/*!
 * SurveyJS Creator v1.12.14
 * (c) 2015-2024 Devsoft Baltic OÜ - http://surveyjs.io/
 * Github: https://github.com/surveyjs/survey-creator
 * License: https://surveyjs.io/Licenses#SurveyCreator
 */
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("survey-core"), require("survey-creator-core/themes"), require("survey-core/themes"));
	else if(typeof define === 'function' && define.amd)
		define("survey-creator-core", ["survey-core", "survey-creator-core/themes", "survey-core/themes"], factory);
	else if(typeof exports === 'object')
		exports["survey-creator-core"] = factory(require("survey-core"), require("survey-creator-core/themes"), require("survey-core/themes"));
	else
		root["SurveyCreatorCore"] = factory(root["Survey"], root["SurveyCreatorTheme"], root["SurveyTheme"]);
})(this, (__WEBPACK_EXTERNAL_MODULE_survey_core__, __WEBPACK_EXTERNAL_MODULE_survey_creator_core_themes__, __WEBPACK_EXTERNAL_MODULE_survey_core_themes__) => {
return /******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./src/components/creator.scss":
/*!*************************************!*\
  !*** ./src/components/creator.scss ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/header/logo-image.scss":
/*!***********************************************!*\
  !*** ./src/components/header/logo-image.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/image-item-value.scss":
/*!**********************************************!*\
  !*** ./src/components/image-item-value.scss ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/item-value.scss":
/*!****************************************!*\
  !*** ./src/components/item-value.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/link-value.scss":
/*!****************************************!*\
  !*** ./src/components/link-value.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/matrix-cell.scss":
/*!*****************************************!*\
  !*** ./src/components/matrix-cell.scss ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/page-navigator/page-navigator-item.scss":
/*!****************************************************************!*\
  !*** ./src/components/page-navigator/page-navigator-item.scss ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/page-navigator/page-navigator.scss":
/*!***********************************************************!*\
  !*** ./src/components/page-navigator/page-navigator.scss ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/page.scss":
/*!**********************************!*\
  !*** ./src/components/page.scss ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/property-panel/property-panel-item.scss":
/*!****************************************************************!*\
  !*** ./src/components/property-panel/property-panel-item.scss ***!
  \****************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/property-panel/property-panel.scss":
/*!***********************************************************!*\
  !*** ./src/components/property-panel/property-panel.scss ***!
  \***********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/question-dropdown.scss":
/*!***********************************************!*\
  !*** ./src/components/question-dropdown.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/question-image.scss":
/*!********************************************!*\
  !*** ./src/components/question-image.scss ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/question-rating.scss":
/*!*********************************************!*\
  !*** ./src/components/question-rating.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/question.scss":
/*!**************************************!*\
  !*** ./src/components/question.scss ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/results.scss":
/*!*************************************!*\
  !*** ./src/components/results.scss ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/row.scss":
/*!*********************************!*\
  !*** ./src/components/row.scss ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/scroll.scss":
/*!************************************!*\
  !*** ./src/components/scroll.scss ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/search.scss":
/*!************************************!*\
  !*** ./src/components/search.scss ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/side-bar/side-bar.scss":
/*!***********************************************!*\
  !*** ./src/components/side-bar/side-bar.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/side-bar/tab-control.scss":
/*!**************************************************!*\
  !*** ./src/components/side-bar/tab-control.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/simulator.scss":
/*!***************************************!*\
  !*** ./src/components/simulator.scss ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/string-editor.scss":
/*!*******************************************!*\
  !*** ./src/components/string-editor.scss ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/switcher/switcher.scss":
/*!***********************************************!*\
  !*** ./src/components/switcher/switcher.scss ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/tabbed-menu/tabbed-menu-item.scss":
/*!**********************************************************!*\
  !*** ./src/components/tabbed-menu/tabbed-menu-item.scss ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/tabbed-menu/tabbed-menu.scss":
/*!*****************************************************!*\
  !*** ./src/components/tabbed-menu/tabbed-menu.scss ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/tabs/designer.scss":
/*!*******************************************!*\
  !*** ./src/components/tabs/designer.scss ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/tabs/json-editor-ace.scss":
/*!**************************************************!*\
  !*** ./src/components/tabs/json-editor-ace.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/tabs/json-editor-textarea.scss":
/*!*******************************************************!*\
  !*** ./src/components/tabs/json-editor-textarea.scss ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/tabs/logic-ui.scss":
/*!*******************************************!*\
  !*** ./src/components/tabs/logic-ui.scss ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/tabs/logic.scss":
/*!****************************************!*\
  !*** ./src/components/tabs/logic.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/tabs/test.scss":
/*!***************************************!*\
  !*** ./src/components/tabs/test.scss ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/tabs/translation.scss":
/*!**********************************************!*\
  !*** ./src/components/tabs/translation.scss ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/toolbox/toolbox-animation.scss":
/*!*******************************************************!*\
  !*** ./src/components/toolbox/toolbox-animation.scss ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/toolbox/toolbox-right.scss":
/*!***************************************************!*\
  !*** ./src/components/toolbox/toolbox-right.scss ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/toolbox/toolbox-search.scss":
/*!****************************************************!*\
  !*** ./src/components/toolbox/toolbox-search.scss ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/toolbox/toolbox-tool.scss":
/*!**************************************************!*\
  !*** ./src/components/toolbox/toolbox-tool.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/components/toolbox/toolbox.scss":
/*!*********************************************!*\
  !*** ./src/components/toolbox/toolbox.scss ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/creator-theme/creator.scss":
/*!****************************************!*\
  !*** ./src/creator-theme/creator.scss ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/custom-questions/boolean-switch.scss":
/*!**************************************************!*\
  !*** ./src/custom-questions/boolean-switch.scss ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/property-grid-theme/property-grid.scss":
/*!****************************************************!*\
  !*** ./src/property-grid-theme/property-grid.scss ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/responsivity.scss":
/*!*******************************!*\
  !*** ./src/responsivity.scss ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/utils/context-button.scss":
/*!***************************************!*\
  !*** ./src/utils/context-button.scss ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/utils/design.scss":
/*!*******************************!*\
  !*** ./src/utils/design.scss ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./src/utils/layout.scss":
/*!*******************************!*\
  !*** ./src/utils/layout.scss ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
// extracted by mini-css-extract-plugin


/***/ }),

/***/ "./node_modules/papaparse/papaparse.min.js":
/*!*************************************************!*\
  !*** ./node_modules/papaparse/papaparse.min.js ***!
  \*************************************************/
/***/ (function(module, exports) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/* @license
Papa Parse
v5.4.1
https://github.com/mholt/PapaParse
License: MIT
*/
!function(e,t){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (t),
		__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
		(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
		__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):0}(this,function s(){"use strict";var f="undefined"!=typeof self?self:"undefined"!=typeof window?window:void 0!==f?f:{};var n=!f.document&&!!f.postMessage,o=f.IS_PAPA_WORKER||!1,a={},u=0,b={parse:function(e,t){var r=(t=t||{}).dynamicTyping||!1;J(r)&&(t.dynamicTypingFunction=r,r={});if(t.dynamicTyping=r,t.transform=!!J(t.transform)&&t.transform,t.worker&&b.WORKERS_SUPPORTED){var i=function(){if(!b.WORKERS_SUPPORTED)return!1;var e=(r=f.URL||f.webkitURL||null,i=s.toString(),b.BLOB_URL||(b.BLOB_URL=r.createObjectURL(new Blob(["var global = (function() { if (typeof self !== 'undefined') { return self; } if (typeof window !== 'undefined') { return window; } if (typeof global !== 'undefined') { return global; } return {}; })(); global.IS_PAPA_WORKER=true; ","(",i,")();"],{type:"text/javascript"})))),t=new f.Worker(e);var r,i;return t.onmessage=_,t.id=u++,a[t.id]=t}();return i.userStep=t.step,i.userChunk=t.chunk,i.userComplete=t.complete,i.userError=t.error,t.step=J(t.step),t.chunk=J(t.chunk),t.complete=J(t.complete),t.error=J(t.error),delete t.worker,void i.postMessage({input:e,config:t,workerId:i.id})}var n=null;b.NODE_STREAM_INPUT,"string"==typeof e?(e=function(e){if(65279===e.charCodeAt(0))return e.slice(1);return e}(e),n=t.download?new l(t):new p(t)):!0===e.readable&&J(e.read)&&J(e.on)?n=new g(t):(f.File&&e instanceof File||e instanceof Object)&&(n=new c(t));return n.stream(e)},unparse:function(e,t){var n=!1,_=!0,m=",",y="\r\n",s='"',a=s+s,r=!1,i=null,o=!1;!function(){if("object"!=typeof t)return;"string"!=typeof t.delimiter||b.BAD_DELIMITERS.filter(function(e){return-1!==t.delimiter.indexOf(e)}).length||(m=t.delimiter);("boolean"==typeof t.quotes||"function"==typeof t.quotes||Array.isArray(t.quotes))&&(n=t.quotes);"boolean"!=typeof t.skipEmptyLines&&"string"!=typeof t.skipEmptyLines||(r=t.skipEmptyLines);"string"==typeof t.newline&&(y=t.newline);"string"==typeof t.quoteChar&&(s=t.quoteChar);"boolean"==typeof t.header&&(_=t.header);if(Array.isArray(t.columns)){if(0===t.columns.length)throw new Error("Option columns is empty");i=t.columns}void 0!==t.escapeChar&&(a=t.escapeChar+s);("boolean"==typeof t.escapeFormulae||t.escapeFormulae instanceof RegExp)&&(o=t.escapeFormulae instanceof RegExp?t.escapeFormulae:/^[=+\-@\t\r].*$/)}();var u=new RegExp(Q(s),"g");"string"==typeof e&&(e=JSON.parse(e));if(Array.isArray(e)){if(!e.length||Array.isArray(e[0]))return h(null,e,r);if("object"==typeof e[0])return h(i||Object.keys(e[0]),e,r)}else if("object"==typeof e)return"string"==typeof e.data&&(e.data=JSON.parse(e.data)),Array.isArray(e.data)&&(e.fields||(e.fields=e.meta&&e.meta.fields||i),e.fields||(e.fields=Array.isArray(e.data[0])?e.fields:"object"==typeof e.data[0]?Object.keys(e.data[0]):[]),Array.isArray(e.data[0])||"object"==typeof e.data[0]||(e.data=[e.data])),h(e.fields||[],e.data||[],r);throw new Error("Unable to serialize unrecognized input");function h(e,t,r){var i="";"string"==typeof e&&(e=JSON.parse(e)),"string"==typeof t&&(t=JSON.parse(t));var n=Array.isArray(e)&&0<e.length,s=!Array.isArray(t[0]);if(n&&_){for(var a=0;a<e.length;a++)0<a&&(i+=m),i+=v(e[a],a);0<t.length&&(i+=y)}for(var o=0;o<t.length;o++){var u=n?e.length:t[o].length,h=!1,f=n?0===Object.keys(t[o]).length:0===t[o].length;if(r&&!n&&(h="greedy"===r?""===t[o].join("").trim():1===t[o].length&&0===t[o][0].length),"greedy"===r&&n){for(var d=[],l=0;l<u;l++){var c=s?e[l]:l;d.push(t[o][c])}h=""===d.join("").trim()}if(!h){for(var p=0;p<u;p++){0<p&&!f&&(i+=m);var g=n&&s?e[p]:p;i+=v(t[o][g],p)}o<t.length-1&&(!r||0<u&&!f)&&(i+=y)}}return i}function v(e,t){if(null==e)return"";if(e.constructor===Date)return JSON.stringify(e).slice(1,25);var r=!1;o&&"string"==typeof e&&o.test(e)&&(e="'"+e,r=!0);var i=e.toString().replace(u,a);return(r=r||!0===n||"function"==typeof n&&n(e,t)||Array.isArray(n)&&n[t]||function(e,t){for(var r=0;r<t.length;r++)if(-1<e.indexOf(t[r]))return!0;return!1}(i,b.BAD_DELIMITERS)||-1<i.indexOf(m)||" "===i.charAt(0)||" "===i.charAt(i.length-1))?s+i+s:i}}};if(b.RECORD_SEP=String.fromCharCode(30),b.UNIT_SEP=String.fromCharCode(31),b.BYTE_ORDER_MARK="\ufeff",b.BAD_DELIMITERS=["\r","\n",'"',b.BYTE_ORDER_MARK],b.WORKERS_SUPPORTED=!n&&!!f.Worker,b.NODE_STREAM_INPUT=1,b.LocalChunkSize=10485760,b.RemoteChunkSize=5242880,b.DefaultDelimiter=",",b.Parser=E,b.ParserHandle=r,b.NetworkStreamer=l,b.FileStreamer=c,b.StringStreamer=p,b.ReadableStreamStreamer=g,f.jQuery){var d=f.jQuery;d.fn.parse=function(o){var r=o.config||{},u=[];return this.each(function(e){if(!("INPUT"===d(this).prop("tagName").toUpperCase()&&"file"===d(this).attr("type").toLowerCase()&&f.FileReader)||!this.files||0===this.files.length)return!0;for(var t=0;t<this.files.length;t++)u.push({file:this.files[t],inputElem:this,instanceConfig:d.extend({},r)})}),e(),this;function e(){if(0!==u.length){var e,t,r,i,n=u[0];if(J(o.before)){var s=o.before(n.file,n.inputElem);if("object"==typeof s){if("abort"===s.action)return e="AbortError",t=n.file,r=n.inputElem,i=s.reason,void(J(o.error)&&o.error({name:e},t,r,i));if("skip"===s.action)return void h();"object"==typeof s.config&&(n.instanceConfig=d.extend(n.instanceConfig,s.config))}else if("skip"===s)return void h()}var a=n.instanceConfig.complete;n.instanceConfig.complete=function(e){J(a)&&a(e,n.file,n.inputElem),h()},b.parse(n.file,n.instanceConfig)}else J(o.complete)&&o.complete()}function h(){u.splice(0,1),e()}}}function h(e){this._handle=null,this._finished=!1,this._completed=!1,this._halted=!1,this._input=null,this._baseIndex=0,this._partialLine="",this._rowCount=0,this._start=0,this._nextChunk=null,this.isFirstChunk=!0,this._completeResults={data:[],errors:[],meta:{}},function(e){var t=w(e);t.chunkSize=parseInt(t.chunkSize),e.step||e.chunk||(t.chunkSize=null);this._handle=new r(t),(this._handle.streamer=this)._config=t}.call(this,e),this.parseChunk=function(e,t){if(this.isFirstChunk&&J(this._config.beforeFirstChunk)){var r=this._config.beforeFirstChunk(e);void 0!==r&&(e=r)}this.isFirstChunk=!1,this._halted=!1;var i=this._partialLine+e;this._partialLine="";var n=this._handle.parse(i,this._baseIndex,!this._finished);if(!this._handle.paused()&&!this._handle.aborted()){var s=n.meta.cursor;this._finished||(this._partialLine=i.substring(s-this._baseIndex),this._baseIndex=s),n&&n.data&&(this._rowCount+=n.data.length);var a=this._finished||this._config.preview&&this._rowCount>=this._config.preview;if(o)f.postMessage({results:n,workerId:b.WORKER_ID,finished:a});else if(J(this._config.chunk)&&!t){if(this._config.chunk(n,this._handle),this._handle.paused()||this._handle.aborted())return void(this._halted=!0);n=void 0,this._completeResults=void 0}return this._config.step||this._config.chunk||(this._completeResults.data=this._completeResults.data.concat(n.data),this._completeResults.errors=this._completeResults.errors.concat(n.errors),this._completeResults.meta=n.meta),this._completed||!a||!J(this._config.complete)||n&&n.meta.aborted||(this._config.complete(this._completeResults,this._input),this._completed=!0),a||n&&n.meta.paused||this._nextChunk(),n}this._halted=!0},this._sendError=function(e){J(this._config.error)?this._config.error(e):o&&this._config.error&&f.postMessage({workerId:b.WORKER_ID,error:e,finished:!1})}}function l(e){var i;(e=e||{}).chunkSize||(e.chunkSize=b.RemoteChunkSize),h.call(this,e),this._nextChunk=n?function(){this._readChunk(),this._chunkLoaded()}:function(){this._readChunk()},this.stream=function(e){this._input=e,this._nextChunk()},this._readChunk=function(){if(this._finished)this._chunkLoaded();else{if(i=new XMLHttpRequest,this._config.withCredentials&&(i.withCredentials=this._config.withCredentials),n||(i.onload=v(this._chunkLoaded,this),i.onerror=v(this._chunkError,this)),i.open(this._config.downloadRequestBody?"POST":"GET",this._input,!n),this._config.downloadRequestHeaders){var e=this._config.downloadRequestHeaders;for(var t in e)i.setRequestHeader(t,e[t])}if(this._config.chunkSize){var r=this._start+this._config.chunkSize-1;i.setRequestHeader("Range","bytes="+this._start+"-"+r)}try{i.send(this._config.downloadRequestBody)}catch(e){this._chunkError(e.message)}n&&0===i.status&&this._chunkError()}},this._chunkLoaded=function(){4===i.readyState&&(i.status<200||400<=i.status?this._chunkError():(this._start+=this._config.chunkSize?this._config.chunkSize:i.responseText.length,this._finished=!this._config.chunkSize||this._start>=function(e){var t=e.getResponseHeader("Content-Range");if(null===t)return-1;return parseInt(t.substring(t.lastIndexOf("/")+1))}(i),this.parseChunk(i.responseText)))},this._chunkError=function(e){var t=i.statusText||e;this._sendError(new Error(t))}}function c(e){var i,n;(e=e||{}).chunkSize||(e.chunkSize=b.LocalChunkSize),h.call(this,e);var s="undefined"!=typeof FileReader;this.stream=function(e){this._input=e,n=e.slice||e.webkitSlice||e.mozSlice,s?((i=new FileReader).onload=v(this._chunkLoaded,this),i.onerror=v(this._chunkError,this)):i=new FileReaderSync,this._nextChunk()},this._nextChunk=function(){this._finished||this._config.preview&&!(this._rowCount<this._config.preview)||this._readChunk()},this._readChunk=function(){var e=this._input;if(this._config.chunkSize){var t=Math.min(this._start+this._config.chunkSize,this._input.size);e=n.call(e,this._start,t)}var r=i.readAsText(e,this._config.encoding);s||this._chunkLoaded({target:{result:r}})},this._chunkLoaded=function(e){this._start+=this._config.chunkSize,this._finished=!this._config.chunkSize||this._start>=this._input.size,this.parseChunk(e.target.result)},this._chunkError=function(){this._sendError(i.error)}}function p(e){var r;h.call(this,e=e||{}),this.stream=function(e){return r=e,this._nextChunk()},this._nextChunk=function(){if(!this._finished){var e,t=this._config.chunkSize;return t?(e=r.substring(0,t),r=r.substring(t)):(e=r,r=""),this._finished=!r,this.parseChunk(e)}}}function g(e){h.call(this,e=e||{});var t=[],r=!0,i=!1;this.pause=function(){h.prototype.pause.apply(this,arguments),this._input.pause()},this.resume=function(){h.prototype.resume.apply(this,arguments),this._input.resume()},this.stream=function(e){this._input=e,this._input.on("data",this._streamData),this._input.on("end",this._streamEnd),this._input.on("error",this._streamError)},this._checkIsFinished=function(){i&&1===t.length&&(this._finished=!0)},this._nextChunk=function(){this._checkIsFinished(),t.length?this.parseChunk(t.shift()):r=!0},this._streamData=v(function(e){try{t.push("string"==typeof e?e:e.toString(this._config.encoding)),r&&(r=!1,this._checkIsFinished(),this.parseChunk(t.shift()))}catch(e){this._streamError(e)}},this),this._streamError=v(function(e){this._streamCleanUp(),this._sendError(e)},this),this._streamEnd=v(function(){this._streamCleanUp(),i=!0,this._streamData("")},this),this._streamCleanUp=v(function(){this._input.removeListener("data",this._streamData),this._input.removeListener("end",this._streamEnd),this._input.removeListener("error",this._streamError)},this)}function r(m){var a,o,u,i=Math.pow(2,53),n=-i,s=/^\s*-?(\d+\.?|\.\d+|\d+\.\d+)([eE][-+]?\d+)?\s*$/,h=/^((\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z))|(\d{4}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d([+-][0-2]\d:[0-5]\d|Z)))$/,t=this,r=0,f=0,d=!1,e=!1,l=[],c={data:[],errors:[],meta:{}};if(J(m.step)){var p=m.step;m.step=function(e){if(c=e,_())g();else{if(g(),0===c.data.length)return;r+=e.data.length,m.preview&&r>m.preview?o.abort():(c.data=c.data[0],p(c,t))}}}function y(e){return"greedy"===m.skipEmptyLines?""===e.join("").trim():1===e.length&&0===e[0].length}function g(){return c&&u&&(k("Delimiter","UndetectableDelimiter","Unable to auto-detect delimiting character; defaulted to '"+b.DefaultDelimiter+"'"),u=!1),m.skipEmptyLines&&(c.data=c.data.filter(function(e){return!y(e)})),_()&&function(){if(!c)return;function e(e,t){J(m.transformHeader)&&(e=m.transformHeader(e,t)),l.push(e)}if(Array.isArray(c.data[0])){for(var t=0;_()&&t<c.data.length;t++)c.data[t].forEach(e);c.data.splice(0,1)}else c.data.forEach(e)}(),function(){if(!c||!m.header&&!m.dynamicTyping&&!m.transform)return c;function e(e,t){var r,i=m.header?{}:[];for(r=0;r<e.length;r++){var n=r,s=e[r];m.header&&(n=r>=l.length?"__parsed_extra":l[r]),m.transform&&(s=m.transform(s,n)),s=v(n,s),"__parsed_extra"===n?(i[n]=i[n]||[],i[n].push(s)):i[n]=s}return m.header&&(r>l.length?k("FieldMismatch","TooManyFields","Too many fields: expected "+l.length+" fields but parsed "+r,f+t):r<l.length&&k("FieldMismatch","TooFewFields","Too few fields: expected "+l.length+" fields but parsed "+r,f+t)),i}var t=1;!c.data.length||Array.isArray(c.data[0])?(c.data=c.data.map(e),t=c.data.length):c.data=e(c.data,0);m.header&&c.meta&&(c.meta.fields=l);return f+=t,c}()}function _(){return m.header&&0===l.length}function v(e,t){return r=e,m.dynamicTypingFunction&&void 0===m.dynamicTyping[r]&&(m.dynamicTyping[r]=m.dynamicTypingFunction(r)),!0===(m.dynamicTyping[r]||m.dynamicTyping)?"true"===t||"TRUE"===t||"false"!==t&&"FALSE"!==t&&(function(e){if(s.test(e)){var t=parseFloat(e);if(n<t&&t<i)return!0}return!1}(t)?parseFloat(t):h.test(t)?new Date(t):""===t?null:t):t;var r}function k(e,t,r,i){var n={type:e,code:t,message:r};void 0!==i&&(n.row=i),c.errors.push(n)}this.parse=function(e,t,r){var i=m.quoteChar||'"';if(m.newline||(m.newline=function(e,t){e=e.substring(0,1048576);var r=new RegExp(Q(t)+"([^]*?)"+Q(t),"gm"),i=(e=e.replace(r,"")).split("\r"),n=e.split("\n"),s=1<n.length&&n[0].length<i[0].length;if(1===i.length||s)return"\n";for(var a=0,o=0;o<i.length;o++)"\n"===i[o][0]&&a++;return a>=i.length/2?"\r\n":"\r"}(e,i)),u=!1,m.delimiter)J(m.delimiter)&&(m.delimiter=m.delimiter(e),c.meta.delimiter=m.delimiter);else{var n=function(e,t,r,i,n){var s,a,o,u;n=n||[",","\t","|",";",b.RECORD_SEP,b.UNIT_SEP];for(var h=0;h<n.length;h++){var f=n[h],d=0,l=0,c=0;o=void 0;for(var p=new E({comments:i,delimiter:f,newline:t,preview:10}).parse(e),g=0;g<p.data.length;g++)if(r&&y(p.data[g]))c++;else{var _=p.data[g].length;l+=_,void 0!==o?0<_&&(d+=Math.abs(_-o),o=_):o=_}0<p.data.length&&(l/=p.data.length-c),(void 0===a||d<=a)&&(void 0===u||u<l)&&1.99<l&&(a=d,s=f,u=l)}return{successful:!!(m.delimiter=s),bestDelimiter:s}}(e,m.newline,m.skipEmptyLines,m.comments,m.delimitersToGuess);n.successful?m.delimiter=n.bestDelimiter:(u=!0,m.delimiter=b.DefaultDelimiter),c.meta.delimiter=m.delimiter}var s=w(m);return m.preview&&m.header&&s.preview++,a=e,o=new E(s),c=o.parse(a,t,r),g(),d?{meta:{paused:!0}}:c||{meta:{paused:!1}}},this.paused=function(){return d},this.pause=function(){d=!0,o.abort(),a=J(m.chunk)?"":a.substring(o.getCharIndex())},this.resume=function(){t.streamer._halted?(d=!1,t.streamer.parseChunk(a,!0)):setTimeout(t.resume,3)},this.aborted=function(){return e},this.abort=function(){e=!0,o.abort(),c.meta.aborted=!0,J(m.complete)&&m.complete(c),a=""}}function Q(e){return e.replace(/[.*+?^${}()|[\]\\]/g,"\\$&")}function E(j){var z,M=(j=j||{}).delimiter,P=j.newline,U=j.comments,q=j.step,N=j.preview,B=j.fastMode,K=z=void 0===j.quoteChar||null===j.quoteChar?'"':j.quoteChar;if(void 0!==j.escapeChar&&(K=j.escapeChar),("string"!=typeof M||-1<b.BAD_DELIMITERS.indexOf(M))&&(M=","),U===M)throw new Error("Comment character same as delimiter");!0===U?U="#":("string"!=typeof U||-1<b.BAD_DELIMITERS.indexOf(U))&&(U=!1),"\n"!==P&&"\r"!==P&&"\r\n"!==P&&(P="\n");var W=0,H=!1;this.parse=function(i,t,r){if("string"!=typeof i)throw new Error("Input must be a string");var n=i.length,e=M.length,s=P.length,a=U.length,o=J(q),u=[],h=[],f=[],d=W=0;if(!i)return L();if(j.header&&!t){var l=i.split(P)[0].split(M),c=[],p={},g=!1;for(var _ in l){var m=l[_];J(j.transformHeader)&&(m=j.transformHeader(m,_));var y=m,v=p[m]||0;for(0<v&&(g=!0,y=m+"_"+v),p[m]=v+1;c.includes(y);)y=y+"_"+v;c.push(y)}if(g){var k=i.split(P);k[0]=c.join(M),i=k.join(P)}}if(B||!1!==B&&-1===i.indexOf(z)){for(var b=i.split(P),E=0;E<b.length;E++){if(f=b[E],W+=f.length,E!==b.length-1)W+=P.length;else if(r)return L();if(!U||f.substring(0,a)!==U){if(o){if(u=[],I(f.split(M)),F(),H)return L()}else I(f.split(M));if(N&&N<=E)return u=u.slice(0,N),L(!0)}}return L()}for(var w=i.indexOf(M,W),R=i.indexOf(P,W),C=new RegExp(Q(K)+Q(z),"g"),S=i.indexOf(z,W);;)if(i[W]!==z)if(U&&0===f.length&&i.substring(W,W+a)===U){if(-1===R)return L();W=R+s,R=i.indexOf(P,W),w=i.indexOf(M,W)}else if(-1!==w&&(w<R||-1===R))f.push(i.substring(W,w)),W=w+e,w=i.indexOf(M,W);else{if(-1===R)break;if(f.push(i.substring(W,R)),D(R+s),o&&(F(),H))return L();if(N&&u.length>=N)return L(!0)}else for(S=W,W++;;){if(-1===(S=i.indexOf(z,S+1)))return r||h.push({type:"Quotes",code:"MissingQuotes",message:"Quoted field unterminated",row:u.length,index:W}),T();if(S===n-1)return T(i.substring(W,S).replace(C,z));if(z!==K||i[S+1]!==K){if(z===K||0===S||i[S-1]!==K){-1!==w&&w<S+1&&(w=i.indexOf(M,S+1)),-1!==R&&R<S+1&&(R=i.indexOf(P,S+1));var O=A(-1===R?w:Math.min(w,R));if(i.substr(S+1+O,e)===M){f.push(i.substring(W,S).replace(C,z)),i[W=S+1+O+e]!==z&&(S=i.indexOf(z,W)),w=i.indexOf(M,W),R=i.indexOf(P,W);break}var x=A(R);if(i.substring(S+1+x,S+1+x+s)===P){if(f.push(i.substring(W,S).replace(C,z)),D(S+1+x+s),w=i.indexOf(M,W),S=i.indexOf(z,W),o&&(F(),H))return L();if(N&&u.length>=N)return L(!0);break}h.push({type:"Quotes",code:"InvalidQuotes",message:"Trailing quote on quoted field is malformed",row:u.length,index:W}),S++}}else S++}return T();function I(e){u.push(e),d=W}function A(e){var t=0;if(-1!==e){var r=i.substring(S+1,e);r&&""===r.trim()&&(t=r.length)}return t}function T(e){return r||(void 0===e&&(e=i.substring(W)),f.push(e),W=n,I(f),o&&F()),L()}function D(e){W=e,I(f),f=[],R=i.indexOf(P,W)}function L(e){return{data:u,errors:h,meta:{delimiter:M,linebreak:P,aborted:H,truncated:!!e,cursor:d+(t||0)}}}function F(){q(L()),u=[],h=[]}},this.abort=function(){H=!0},this.getCharIndex=function(){return W}}function _(e){var t=e.data,r=a[t.workerId],i=!1;if(t.error)r.userError(t.error,t.file);else if(t.results&&t.results.data){var n={abort:function(){i=!0,m(t.workerId,{data:[],errors:[],meta:{aborted:!0}})},pause:y,resume:y};if(J(r.userStep)){for(var s=0;s<t.results.data.length&&(r.userStep({data:t.results.data[s],errors:t.results.errors,meta:t.results.meta},n),!i);s++);delete t.results}else J(r.userChunk)&&(r.userChunk(t.results,n,t.file),delete t.results)}t.finished&&!i&&m(t.workerId,t.results)}function m(e,t){var r=a[e];J(r.userComplete)&&r.userComplete(t),r.terminate(),delete a[e]}function y(){throw new Error("Not implemented.")}function w(e){if("object"!=typeof e||null===e)return e;var t=Array.isArray(e)?[]:{};for(var r in e)t[r]=w(e[r]);return t}function v(e,t){return function(){e.apply(t,arguments)}}function J(e){return"function"==typeof e}return o&&(f.onmessage=function(e){var t=e.data;void 0===b.WORKER_ID&&t&&(b.WORKER_ID=t.workerId);if("string"==typeof t.input)f.postMessage({workerId:b.WORKER_ID,results:b.parse(t.input,t.config),finished:!0});else if(f.File&&t.input instanceof File||t.input instanceof Object){var r=b.parse(t.input,t.config);r&&f.postMessage({workerId:b.WORKER_ID,results:r,finished:!0})}}),(l.prototype=Object.create(h.prototype)).constructor=l,(c.prototype=Object.create(h.prototype)).constructor=c,(p.prototype=Object.create(p.prototype)).constructor=p,(g.prototype=Object.create(h.prototype)).constructor=g,b});

/***/ }),

/***/ "./src/images-v1/add-16x16.svg":
/*!*************************************!*\
  !*** ./src/images-v1/add-16x16.svg ***!
  \*************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_554_309816)\"><path d=\"M9 7H12V9H9V12H7V9H4V7H7V4H9V7ZM16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8ZM14 8C14 4.7 11.3 2 8 2C4.7 2 2 4.7 2 8C2 11.3 4.7 14 8 14C11.3 14 14 11.3 14 8Z\"></path></g><defs><clipPath id=\"clip0_554_309816\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/add-24x24.svg":
/*!*************************************!*\
  !*** ./src/images-v1/add-24x24.svg ***!
  \*************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 11H17V13H13V17H11V13H7V11H11V7H13V11ZM23 12C23 18.1 18.1 23 12 23C5.9 23 1 18.1 1 12C1 5.9 5.9 1 12 1C18.1 1 23 5.9 23 12ZM21 12C21 7 17 3 12 3C7 3 3 7 3 12C3 17 7 21 12 21C17 21 21 17 21 12Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/apply-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v1/apply-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C18.1 23 23 18.1 23 12C23 5.9 18.1 1 12 1ZM12 21C7 21 3 17 3 12C3 7 7 3 12 3C17 3 21 7 21 12C21 17 17 21 12 21ZM16.3 8L17.7 9.4L10 17.1L6.3 13.4L7.7 12L10 14.3L16.3 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/arrowdown-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/arrowdown-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.01 11.59L13.01 15.59V6H11.01V15.59L7.00998 11.59L5.59998 13L12.01 19.41L18.43 13L17.01 11.59Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/arrowleft-16x16.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/arrowleft-16x16.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 8.99999H4.4L8.7 13.3L7.3 14.7L0.599998 7.99999L7.3 1.29999L8.7 2.69999L4.4 6.99999H15V8.99999Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/arrowleft-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/arrowleft-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.4 2.60001L11.8 4.00001L4.8 11H22V13H4.8L11.8 20L10.4 21.4L1 12L10.4 2.60001Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/arrowright-16x16.svg":
/*!********************************************!*\
  !*** ./src/images-v1/arrowright-16x16.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1 6.99999H11.6L7.3 2.69999L8.7 1.29999L15.4 7.99999L8.7 14.7L7.3 13.3L11.6 8.99999H1V6.99999Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/arrowright-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v1/arrowright-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.6 2.60001L12.2 4.00001L19.2 11H2V13H19.2L12.2 20L13.6 21.4L23 12L13.6 2.60001Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/arrowup-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/arrowup-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.43 11.01L12.01 4.59998L5.59998 11.01L7.00998 12.43L11.01 8.42998V18.01H13.01V8.42998L17.01 12.43L18.43 11.01Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/camera-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/camera-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.01 4H18.4C18.2 4 18.01 3.9 17.9 3.73L16.97 2.34C16.41 1.5 15.48 1 14.47 1H9.54C8.53 1 7.6 1.5 7.04 2.34L6.11 3.73C6 3.9 5.81 4 5.61 4H4C2.35 4 1 5.35 1 7V19C1 20.65 2.35 22 4 22H20C21.65 22 23 20.65 23 19V7C23 5.35 21.65 4 20 4H20.01ZM21.01 19C21.01 19.55 20.56 20 20.01 20H4.01C3.46 20 3.01 19.55 3.01 19V7C3.01 6.45 3.46 6 4.01 6H5.62C6.49 6 7.3 5.56 7.79 4.84L8.72 3.45C8.91 3.17 9.22 3 9.55 3H14.48C14.81 3 15.13 3.17 15.31 3.45L16.24 4.84C16.72 5.56 17.54 6 18.41 6H20.02C20.57 6 21.02 6.45 21.02 7V19H21.01ZM12.01 6C8.7 6 6.01 8.69 6.01 12C6.01 15.31 8.7 18 12.01 18C15.32 18 18.01 15.31 18.01 12C18.01 8.69 15.32 6 12.01 6ZM12.01 16C9.8 16 8.01 14.21 8.01 12C8.01 9.79 9.8 8 12.01 8C14.22 8 16.01 9.79 16.01 12C16.01 14.21 14.22 16 12.01 16ZM13.01 10C13.01 10.55 12.56 11 12.01 11C11.46 11 11.01 11.45 11.01 12C11.01 12.55 10.56 13 10.01 13C9.46 13 9.01 12.55 9.01 12C9.01 10.35 10.36 9 12.01 9C12.56 9 13.01 9.45 13.01 10Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/camera-32x32.svg":
/*!****************************************!*\
  !*** ./src/images-v1/camera-32x32.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M27 6H23.8C23.34 6 22.92 5.77 22.66 5.39L22.25 4.78C21.51 3.66 20.26 3 18.92 3H13.06C11.72 3 10.48 3.67 9.73 4.78L9.32 5.39C9.07 5.77 8.64 6 8.18 6H4.98C2.79 6 1 7.79 1 10V24C1 26.21 2.79 28 5 28H27C29.21 28 31 26.21 31 24V10C31 7.79 29.21 6 27 6ZM29 24C29 25.1 28.1 26 27 26H5C3.9 26 3 25.1 3 24V10C3 8.9 3.9 8 5 8H8.2C9.33 8 10.38 7.44 11 6.5L11.41 5.89C11.78 5.33 12.41 5 13.07 5H18.93C19.6 5 20.22 5.33 20.59 5.89L21 6.5C21.62 7.44 22.68 8 23.8 8H27C28.1 8 29 8.9 29 10V24ZM16 9C12.13 9 9 12.13 9 16C9 19.87 12.13 23 16 23C19.87 23 23 19.87 23 16C23 12.13 19.87 9 16 9ZM16 21C13.24 21 11 18.76 11 16C11 13.24 13.24 11 16 11C18.76 11 21 13.24 21 16C21 18.76 18.76 21 16 21ZM17 13C17 13.55 16.55 14 16 14C14.9 14 14 14.9 14 16C14 16.55 13.55 17 13 17C12.45 17 12 16.55 12 16C12 13.79 13.79 12 16 12C16.55 12 17 12.45 17 13Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/cancel-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/cancel-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22.6 8.6L16.4 2.4C16 2 15.5 1.8 15 1.8C14.5 1.8 14 2 13.6 2.4L1.40005 14.6C0.600049 15.4 0.600049 16.6 1.40005 17.4L6.00005 22H12L22.6 11.4C23.3 10.6 23.3 9.3 22.6 8.6ZM11.1 20H6.80005L2.80005 16L6.20005 12.6L12.4 18.8L11.1 20ZM13.8 17.4L7.60005 11.2L15 3.8L21.2 10L13.8 17.4ZM16 20H23V22H14L16 20Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/check-16x16.svg":
/*!***************************************!*\
  !*** ./src/images-v1/check-16x16.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.003 14.413L0.292999 9.70303L1.703 8.29303L5.003 11.583L14.293 2.29303L15.703 3.70303L5.003 14.413Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/check-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v1/check-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 20.1L1 12L3.1 9.9L9 15.9L20.9 4L23 6.1L9 20.1Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/chevrondown-16x16.svg":
/*!*********************************************!*\
  !*** ./src/images-v1/chevrondown-16x16.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 11L13 6H3L8 11Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/chevrondown-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v1/chevrondown-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 15L17 10H7L12 15Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/chevronleft-16x16.svg":
/*!*********************************************!*\
  !*** ./src/images-v1/chevronleft-16x16.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.393 12.6465L5.69297 8.04651L10.393 3.34651L9.69297 2.64651L4.29297 8.04651L9.69297 13.3465L10.393 12.6465Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/clear-16x16.svg":
/*!***************************************!*\
  !*** ./src/images-v1/clear-16x16.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.35 3.34999L12.65 2.64999L8.05002 7.24999L3.35002 2.64999L2.65002 3.34999L7.25002 8.04999L2.65002 12.65L3.35002 13.35L8.05002 8.74999L12.65 13.35L13.35 12.65L8.75002 8.04999L13.35 3.34999Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/clear-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v1/clear-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22.6 8.6L16.4 2.4C16 2 15.5 1.8 15 1.8C14.5 1.8 14 2 13.6 2.4L1.40005 14.6C0.600049 15.4 0.600049 16.6 1.40005 17.4L6.00005 22H12L22.6 11.4C23.3 10.6 23.3 9.3 22.6 8.6ZM11.1 20H6.80005L2.80005 16L6.20005 12.6L12.4 18.8L11.1 20ZM13.8 17.4L7.60005 11.2L15 3.8L21.2 10L13.8 17.4ZM16 20H23V22H14L16 20Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/close-16x16.svg":
/*!***************************************!*\
  !*** ./src/images-v1/close-16x16.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.43 8.0025L13.7 3.7225C14.09 3.3325 14.09 2.6925 13.7 2.2925C13.31 1.9025 12.67 1.9025 12.27 2.2925L7.99 6.5725L3.72 2.3025C3.33 1.9025 2.69 1.9025 2.3 2.3025C1.9 2.6925 1.9 3.3325 2.3 3.7225L6.58 8.0025L2.3 12.2825C1.91 12.6725 1.91 13.3125 2.3 13.7125C2.69 14.1025 3.33 14.1025 3.73 13.7125L8.01 9.4325L12.29 13.7125C12.68 14.1025 13.32 14.1025 13.72 13.7125C14.11 13.3225 14.11 12.6825 13.72 12.2825L9.44 8.0025H9.43Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/close-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v1/close-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.4101 12L20.7001 4.71C21.0901 4.32 21.0901 3.69 20.7001 3.3C20.3101 2.91 19.6801 2.91 19.2901 3.3L12.0001 10.59L4.71006 3.29C4.32006 2.9 3.68006 2.9 3.29006 3.29C2.90006 3.68 2.90006 4.32 3.29006 4.71L10.5801 12L3.29006 19.29C2.90006 19.68 2.90006 20.31 3.29006 20.7C3.49006 20.9 3.74006 20.99 4.00006 20.99C4.26006 20.99 4.51006 20.89 4.71006 20.7L12.0001 13.41L19.2901 20.7C19.4901 20.9 19.7401 20.99 20.0001 20.99C20.2601 20.99 20.5101 20.89 20.7101 20.7C21.1001 20.31 21.1001 19.68 20.7101 19.29L13.4201 12H13.4101Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/codeeditor-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v1/codeeditor-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM4 20V4H20V20H4ZM9 11C9 11.37 8.89 11.7 8.72 12C8.89 12.3 9 12.63 9 13V14.5C9 14.78 9.22 15 9.5 15H10C10.55 15 11 15.45 11 16C11 16.55 10.55 17 10 17H9.5C8.12 17 7 15.88 7 14.5V13C6.45 13 6 12.55 6 12C6 11.45 6.45 11 7 11V9.5C7 8.12 8.12 7 9.5 7H10C10.55 7 11 7.45 11 8C11 8.55 10.55 9 10 9H9.5C9.22 9 9 9.22 9 9.5V11ZM18 12C18 12.55 17.55 13 17 13V14.5C17 15.88 15.88 17 14.5 17H14C13.45 17 13 16.55 13 16C13 15.45 13.45 15 14 15H14.5C14.78 15 15 14.78 15 14.5V13C15 12.63 15.11 12.3 15.28 12C15.11 11.7 15 11.37 15 11V9.5C15 9.22 14.78 9 14.5 9H14C13.45 9 13 8.55 13 8C13 7.45 13.45 7 14 7H14.5C15.88 7 17 8.12 17 9.5V11C17.55 11 18 11.45 18 12Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/collapse-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v1/collapse-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2 6L3 5L8 10L13 5L14 6L8 12L2 6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/collapse-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v1/collapse-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 2V7.6L15.3 5.3L16.7 6.7L12 11.4L7.30005 6.7L8.70005 5.3L11 7.6V2H13Z\"></path><path d=\"M8.70005 18.7001L7.30005 17.3001L12 12.6001L16.7 17.3001L15.3 18.7001L13 16.4001V22.0001H11V16.4001L8.70005 18.7001Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/collapse-pg-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v1/collapse-pg-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 5.6L19.4 12L13 18.4L11.6 17L15.6 13H2V11H15.6L11.6 7L13 5.6ZM20 2V22H22V2H20Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/collapseall-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v1/collapseall-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 14.59L16.41 19L15 20.41L13 18.41V23H11V18.41L9 20.41L7.59 19L12 14.59ZM16.41 5L15 3.59L13 5.59V1H11V5.59L9 3.59L7.59 5L12 9.41L16.41 5ZM2 11V13H22V11H2Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/collapsedetails-16x16.svg":
/*!*************************************************!*\
  !*** ./src/images-v1/collapsedetails-16x16.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 7H3V9H13V7Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/collapsefocused-16x16.svg":
/*!*************************************************!*\
  !*** ./src/images-v1/collapsefocused-16x16.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M1.08278 4.08272C2.14278 3.02272 3.85278 3.02272 4.91278 4.08272L8.00278 7.17272L11.0928 4.08272C12.1528 3.02272 13.8628 3.02272 14.9228 4.08272C15.9828 5.14272 15.9828 6.85272 14.9228 7.91272L9.42278 13.4127C8.64278 14.1927 7.37278 14.1927 6.59278 13.4127L1.08278 7.91272C0.0227808 6.85272 0.0227808 5.14272 1.08278 4.08272Z\"></path><path d=\"M2.00281 6.00269L3.00281 5.00269L8.00281 10.0027L13.0028 5.00269L14.0028 6.00269L8.00281 12.0027L2.00281 6.00269Z\" fill=\"white\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/collapsepage-16x16.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/collapsepage-16x16.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.71 12.29C12.1 12.68 12.1 13.31 11.71 13.7C11.51 13.9 11.26 13.99 11 13.99C10.74 13.99 10.49 13.89 10.29 13.7L9 12.41V15C9 15.55 8.55 16 8 16C7.45 16 7 15.55 7 15V12.41L5.71 13.7C5.32 14.09 4.69 14.09 4.3 13.7C3.91 13.31 3.91 12.68 4.3 12.29L7.3 9.29C7.69 8.9 8.32 8.9 8.71 9.29L11.71 12.29ZM7.29 6.71C7.49 6.91 7.74 7 8 7C8.26 7 8.51 6.9 8.71 6.71L11.71 3.71C12.1 3.32 12.1 2.69 11.71 2.3C11.32 1.91 10.69 1.91 10.3 2.3L9.01 3.59V1C9.01 0.45 8.56 0 8.01 0C7.46 0 7.01 0.45 7.01 1V3.59L5.72 2.3C5.33 1.91 4.7 1.91 4.31 2.3C3.92 2.69 3.9 3.32 4.29 3.71L7.29 6.71Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/collapsepanel-16x16.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/collapsepanel-16x16.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 9H3C2.45 9 2 8.55 2 8C2 7.45 2.45 7 3 7H13C13.55 7 14 7.45 14 8C14 8.55 13.55 9 13 9Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/copy-16x16.svg":
/*!**************************************!*\
  !*** ./src/images-v1/copy-16x16.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_9500_71113)\"><path d=\"M14 0H6C5.46957 0 4.96086 0.210714 4.58579 0.585786C4.21071 0.960859 4 1.46957 4 2V4H2C1.46957 4 0.960859 4.21071 0.585786 4.58579C0.210714 4.96086 0 5.46957 0 6L0 14C0 14.5304 0.210714 15.0391 0.585786 15.4142C0.960859 15.7893 1.46957 16 2 16H10C10.5304 16 11.0391 15.7893 11.4142 15.4142C11.7893 15.0391 12 14.5304 12 14V12H14C14.5304 12 15.0391 11.7893 15.4142 11.4142C15.7893 11.0391 16 10.5304 16 10V2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210714 14.5304 0 14 0V0ZM10 14H2V6H10V14ZM14 10H12V6C12 5.46957 11.7893 4.96086 11.4142 4.58579C11.0391 4.21071 10.5304 4 10 4H6V2H14V10Z\"></path></g><defs><clipPath id=\"clip0_9500_71113\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/copy-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/copy-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21 1H9C7.9 1 7 1.9 7 3V7H3C1.9 7 1 7.9 1 9V21C1 22.1 1.9 23 3 23H15C16.1 23 17 22.1 17 21V17H21C22.1 17 23 16.1 23 15V3C23 1.9 22.1 1 21 1ZM15 21H3V9H15V21ZM21 15H17V9C17 7.9 16.1 7 15 7H9V3H21V15Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/cross-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v1/cross-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.71 7.71L17 7L12.35 11.65L7.71 7L7 7.71L11.65 12.35L7 17L7.71 17.71L12.35 13.06L17 17.71L17.71 17L13.06 12.35L17.71 7.71Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/delete-16x16.svg":
/*!****************************************!*\
  !*** ./src/images-v1/delete-16x16.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 2H14H11V1C11 0.4 10.6 0 10 0H7C6.4 0 6 0.4 6 1V2H3H2V4H3V14C3 15.1 3.9 16 5 16H12C13.1 16 14 15.1 14 14V4H15V2ZM7 1H10V2H7V1ZM12 14H5V4H12V14ZM7 13H6V5H7V13ZM9 13H8V5H9V13ZM11 13H10V5H11V13Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/delete-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/delete-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22 4H20H16V2C16 0.9 15.1 0 14 0H10C8.9 0 8 0.9 8 2V4H4H2V6H4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V6H22V4ZM10 2H14V4H10V2ZM18 20H6V6H8H16H18V20ZM14 8H16V18H14V8ZM11 8H13V18H11V8ZM8 8H10V18H8V8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/desktop-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/desktop-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22 17V2H2V17H10V19C10 19.7956 9.68393 20.5587 9.12132 21.1213C8.55871 21.6839 7.79565 22 7 22H17C16.2044 22 15.4413 21.6839 14.8787 21.1213C14.3161 20.5587 14 19.7956 14 19V17H22ZM4 4H20V15H4V4Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/download-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v1/download-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 18.41L4.59 11L6 9.59L11 14.59V2H13V14.59L18 9.59L19.41 11L12 18.41ZM2 20V22H22V20H2Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/drag-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/drag-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 6C13 4.9 13.9 4 15 4C16.1 4 17 4.9 17 6C17 7.1 16.1 8 15 8C13.9 8 13 7.1 13 6ZM9 4C7.9 4 7 4.9 7 6C7 7.1 7.9 8 9 8C10.1 8 11 7.1 11 6C11 4.9 10.1 4 9 4ZM15 10C13.9 10 13 10.9 13 12C13 13.1 13.9 14 15 14C16.1 14 17 13.1 17 12C17 10.9 16.1 10 15 10ZM9 10C7.9 10 7 10.9 7 12C7 13.1 7.9 14 9 14C10.1 14 11 13.1 11 12C11 10.9 10.1 10 9 10ZM15 16C13.9 16 13 16.9 13 18C13 19.1 13.9 20 15 20C16.1 20 17 19.1 17 18C17 16.9 16.1 16 15 16ZM9 16C7.9 16 7 16.9 7 18C7 19.1 7.9 20 9 20C10.1 20 11 19.1 11 18C11 16.9 10.1 16 9 16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/draghorizontal-24x16.svg":
/*!************************************************!*\
  !*** ./src/images-v1/draghorizontal-24x16.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 9C19.1 9 20 9.9 20 11C20 12.1 19.1 13 18 13C16.9 13 16 12.1 16 11C16 9.9 16.9 9 18 9ZM20 5C20 3.9 19.1 3 18 3C16.9 3 16 3.9 16 5C16 6.1 16.9 7 18 7C19.1 7 20 6.1 20 5ZM14 11C14 9.9 13.1 9 12 9C10.9 9 10 9.9 10 11C10 12.1 10.9 13 12 13C13.1 13 14 12.1 14 11ZM14 5C14 3.9 13.1 3 12 3C10.9 3 10 3.9 10 5C10 6.1 10.9 7 12 7C13.1 7 14 6.1 14 5ZM8 11C8 9.9 7.1 9 6 9C4.9 9 4 9.9 4 11C4 12.1 4.9 13 6 13C7.1 13 8 12.1 8 11ZM8 5C8 3.9 7.1 3 6 3C4.9 3 4 3.9 4 5C4 6.1 4.9 7 6 7C7.1 7 8 6.1 8 5Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/draghorizontalsmall-24x16.svg":
/*!*****************************************************!*\
  !*** ./src/images-v1/draghorizontalsmall-24x16.svg ***!
  \*****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 7C10 7.55 9.55 8 9 8C8.45 8 8 7.55 8 7C8 6.45 8.45 6 9 6C9.55 6 10 6.45 10 7ZM9 9C8.45 9 8 9.45 8 10C8 10.55 8.45 11 9 11C9.55 11 10 10.55 10 10C10 9.45 9.55 9 9 9ZM12 6C11.45 6 11 6.45 11 7C11 7.55 11.45 8 12 8C12.55 8 13 7.55 13 7C13 6.45 12.55 6 12 6ZM12 9C11.45 9 11 9.45 11 10C11 10.55 11.45 11 12 11C12.55 11 13 10.55 13 10C13 9.45 12.55 9 12 9ZM15 8C15.55 8 16 7.55 16 7C16 6.45 15.55 6 15 6C14.45 6 14 6.45 14 7C14 7.55 14.45 8 15 8ZM15 9C14.45 9 14 9.45 14 10C14 10.55 14.45 11 15 11C15.55 11 16 10.55 16 10C16 9.45 15.55 9 15 9Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/dropper-16x16.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/dropper-16x16.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3.31 15C2.69 15 2.11 14.76 1.68 14.32C0.780005 13.42 0.780005 11.95 1.68 11.05L2.45 10.28C2.45 10.18 2.44 10.08 2.44 9.98C2.44 9.02 2.81 8.12 3.49 7.44L5.6 5.33C5.37 5.04 5.25 4.68 5.25 4.31C5.25 3.86 5.42 3.44 5.74 3.12C6.06 2.8 6.48 2.63 6.92 2.63C7.29 2.63 7.65 2.75 7.94 2.98L8.88 2.04C9.56001 1.36 10.46 0.989998 11.41 0.989998C12.36 0.989998 13.27 1.36 13.95 2.04C14.63 2.72 15 3.62 15 4.58C15 5.54 14.63 6.44 13.95 7.12L12.94 8.13C13.04 8.34 13.09 8.58 13.09 8.82C13.09 9.27 12.92 9.69 12.6 10C12.28 10.31 11.86 10.49 11.42 10.49C11.18 10.49 10.94 10.44 10.73 10.34L8.56 12.51C7.88 13.19 6.98 13.56 6.03 13.56C5.93001 13.56 5.83 13.56 5.73 13.54L4.97 14.3C4.53 14.74 3.95 14.98 3.34 14.98L3.31 15Z\" fill=\"black\" fill-opacity=\"0.15\"></path><path d=\"M14 4.58C14 3.89 13.73 3.24 13.24 2.75C12.23 1.74 10.59 1.74 9.58 2.75L7.94 4.39L7.39 3.84C7.13 3.58 6.7 3.58 6.44 3.84C6.18 4.1 6.18 4.53 6.44 4.79L6.99 5.34L4.18 8.15C3.69 8.64 3.42 9.29 3.42 9.98C3.42 10.2 3.46 10.41 3.51 10.62L2.38 11.75C1.87 12.26 1.87 13.09 2.38 13.61C2.64 13.87 2.97 13.99 3.31 13.99C3.65 13.99 3.98 13.86 4.24 13.61L5.37 12.48C5.58 12.53 5.79 12.57 6.01 12.57C6.7 12.57 7.35 12.3 7.84 11.81L10.65 9L10.94 9.29C11.07 9.42 11.24 9.49 11.42 9.49C11.6 9.49 11.77 9.42 11.9 9.29C12.16 9.03 12.16 8.6 11.9 8.34L11.61 8.05L13.25 6.41C13.74 5.92 14.01 5.27 14.01 4.58H14ZM6.89 10.86C6.42 11.33 5.61 11.33 5.14 10.86C4.91 10.63 4.78 10.32 4.78 9.99C4.78 9.66 4.91 9.35 5.14 9.12L7.95 6.31L9.7 8.06L6.89 10.87V10.86Z\" fill=\"white\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/edit-16x16.svg":
/*!**************************************!*\
  !*** ./src/images-v1/edit-16x16.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_2693_58208)\"><path d=\"M15.3 2.8L13.2 0.7C12.7 0.2 12.2 0 11.6 0C11 0 10.4 0.2 10 0.7L2 8.6C0.7 9.9 0 11.7 0 13.5V15.3C0 15.7 0.3 16 0.8 16H2.6C4.4 16 6.2 15.3 7.5 14L15.4 6.1C16.2 5.2 16.2 3.7 15.3 2.8ZM6 12.6C5.1 13.5 3.8 14 2.5 14H2V13.5C2 12.2 2.5 10.9 3.4 10L8 5.4L10.6 8L6 12.6ZM13.9 4.7L12 6.6L9.4 4L11.3 2.1C11.4 2 11.5 2 11.6 2C11.7 2 11.7 2 11.8 2.1L13.9 4.2C14 4.3 14 4.5 13.9 4.7Z\"></path></g><defs><clipPath id=\"clip0_2693_58208\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/edit-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/edit-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.9 4.80001L19.1 2.00001C18.5 1.50001 17.8 1.20001 17 1.20001C16.2 1.20001 15.5 1.50001 14.9 2.10001L4.6 12.3C2.9 14 2 16.3 2 18.7V21C2 21.6 2.4 22 3 22H5.3C7.7 22 10 21.1 11.7 19.4L21.9 9.10001C23.1 7.90001 23.1 6.00001 21.9 4.80001ZM10.2 17.9C8.9 19.2 7.1 20 5.3 20H4V18.7C4 16.8 4.7 15.1 6.1 13.8L12.3 7.60001L16.5 11.8L10.2 17.9ZM20.5 7.70001L17.8 10.4L13.6 6.20001L16.3 3.50001C16.5 3.20001 16.8 3.20001 17 3.20001C17.2 3.20001 17.5 3.20001 17.7 3.50001L20.5 6.30001C20.9 6.60001 20.9 7.30001 20.5 7.70001Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/editsmall-16x16.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/editsmall-16x16.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.59 4.5884L11.42 2.4184C11.03 2.0284 10.52 1.8284 10.01 1.8284C9.5 1.8284 8.99 2.0284 8.6 2.4184L3.76 7.2384C2.63 8.3684 2 9.8884 2 11.4784V12.9884C2 13.5384 2.45 13.9884 3 13.9884H4.51C6.1 13.9884 7.63 13.3584 8.75 12.2284L13.58 7.3984C14.36 6.6184 14.36 5.3484 13.58 4.5684L13.59 4.5884ZM7.35 10.8284C6.59 11.5884 5.59 11.9984 4.52 11.9984H4.01V11.4884C4.01 10.4184 4.43 9.4184 5.18 8.6584L7.72 6.1184L9.89 8.2884L7.35 10.8284ZM11.3 6.8784L9.13 4.7084L10.01 3.8284L12.18 5.9984L11.3 6.8784Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/embedsurvey-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v1/embedsurvey-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 14.41V23H11V14.41L8.71 16.7L7.3 15.29L12.01 10.58L16.72 15.29L15.31 16.7L13.02 14.41H13ZM20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H9V19H4V5H20V19H15V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM5 6V8H8V6H5ZM19 6H9V8H19V6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/error-16x16.svg":
/*!***************************************!*\
  !*** ./src/images-v1/error-16x16.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_19289_560924)\"><path d=\"M8 0C3.58 0 0 3.58 0 8C0 12.42 3.58 16 8 16C12.42 16 16 12.42 16 8C16 3.58 12.42 0 8 0ZM8 14C4.69 14 2 11.31 2 8C2 4.69 4.69 2 8 2C11.31 2 14 4.69 14 8C14 11.31 11.31 14 8 14ZM11.41 6L9.41 8L11.41 10L10 11.41L8 9.41L6 11.41L4.59 10L6.59 8L4.59 6L6 4.59L8 6.59L10 4.59L11.41 6Z\"></path></g><defs><clipPath id=\"clip0_19289_560924\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/error-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v1/error-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 4C7.58 4 4 7.58 4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4ZM12 18C8.69 18 6 15.31 6 12C6 8.69 8.69 6 12 6C15.31 6 18 8.69 18 12C18 15.31 15.31 18 12 18ZM15.41 10L13.41 12L15.41 14L14 15.41L12 13.41L10 15.41L8.59 14L10.59 12L8.59 10L10 8.59L12 10.59L14 8.59L15.41 10Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/expand-16x16.svg":
/*!****************************************!*\
  !*** ./src/images-v1/expand-16x16.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 14L5 13L10 8L5 3L6 2L12 8L6 14Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/expand-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/expand-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.70005 6.69998L7.30005 5.29998L12 0.599976L16.7 5.29998L15.3 6.69998L13 4.39998V9.99998H11V4.39998L8.70005 6.69998Z\"></path><path d=\"M13 13.9999V19.5999L15.3 17.2999L16.7 18.6999L12 23.3999L7.30005 18.6999L8.70005 17.2999L11 19.5999V13.9999H13Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/expand-pg-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/expand-pg-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.9959 2H14.9959V22H21.9959V2H19.9959ZM19.9959 20H16.9959V4H19.9959V20ZM4.40594 11H12.9959V13H4.40594L8.40594 17L6.99594 18.41L0.585938 12L6.99594 5.59L8.40594 7L4.40594 11Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/expandall-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/expandall-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 6.83L7.59 5.42L12 1L16.41 5.41L15 6.82L13 4.82V10.41H11V4.83L9 6.83ZM13 20V14.41H11V20L9 18L7.59 19.41L12 23.82L16.41 19.41L15 18L13 20ZM20 8.41H15V10.41H20V14.41H15V16.41H20C21.1 16.41 22 15.51 22 14.41V10.41C22 9.31 21.1 8.41 20 8.41ZM9 14.41H4V10.41H9V8.41H4C2.9 8.41 2 9.31 2 10.41V14.41C2 15.51 2.9 16.41 4 16.41H9V14.41Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/expanddetails-16x16.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/expanddetails-16x16.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 7H9V3H7V7H3V9H7V13H9V9H13V7Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/expandfocused-16x16.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/expandfocused-16x16.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.08269 11.0827L7.17269 7.99272L4.08269 4.91272C3.02269 3.85272 3.02269 2.14272 4.08269 1.08272C5.14269 0.0227197 6.85269 0.0227197 7.91269 1.08272L13.4127 6.58272C14.1927 7.36272 14.1927 8.63272 13.4127 9.41272L7.91269 14.9127C6.85269 15.9727 5.14269 15.9727 4.08269 14.9127C3.02269 13.8527 3.02269 12.1427 4.08269 11.0827Z\"></path><path d=\"M6.00269 14.0027L5.00269 13.0027L10.0027 8.00269L5.00269 3.00269L6.00269 2.00269L12.0027 8.00269L6.00269 14.0027Z\" fill=\"white\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/expandpage-16x16.svg":
/*!********************************************!*\
  !*** ./src/images-v1/expandpage-16x16.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_21945_90234)\"><path d=\"M4.29 4.71C3.9 4.32 3.9 3.69 4.29 3.3L7.29 0.289998C7.68 -0.100002 8.31 -0.100002 8.7 0.289998L11.7 3.29C12.09 3.68 12.09 4.31 11.7 4.7C11.5 4.9 11.25 4.99 10.99 4.99C10.73 4.99 10.48 4.89 10.28 4.7L8.99 3.41V6C8.99 6.55 8.54 7 7.99 7C7.44 7 6.99 6.55 6.99 6V3.41L5.7 4.7C5.31 5.09 4.68 5.09 4.29 4.7V4.71ZM10.29 11.29L9 12.58V9.99C9 9.44 8.55 8.99 8 8.99C7.45 8.99 7 9.44 7 9.99V12.58L5.71 11.29C5.32 10.9 4.69 10.9 4.3 11.29C3.91 11.68 3.91 12.31 4.3 12.7L7.3 15.7C7.5 15.9 7.75 15.99 8.01 15.99C8.27 15.99 8.52 15.89 8.72 15.7L11.72 12.7C12.11 12.31 12.11 11.68 11.72 11.29C11.33 10.9 10.7 10.9 10.31 11.29H10.29Z\"></path></g><defs><clipPath id=\"clip0_21945_90234\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/expandpanel-16x16.svg":
/*!*********************************************!*\
  !*** ./src/images-v1/expandpanel-16x16.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 13H4C2.9 13 2 12.1 2 11V5C2 3.9 2.9 3 4 3H12C13.1 3 14 3.9 14 5V11C14 12.1 13.1 13 12 13ZM4 5V11H12V5H4Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/file-72x72.svg":
/*!**************************************!*\
  !*** ./src/images-v1/file-72x72.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22 9V7C22 5.9 21.1 5 20 5H12L10 3H4C2.9 3 2 3.9 2 5V9V10V21H22L24 9H22ZM4 5H9.2L10.6 6.4L11.2 7H12H20V9H4V5ZM20.3 19H4V11H21.6L20.3 19Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/finishedit-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v1/finishedit-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.3 3.70001L7.8 9.20001L4.6 12.4C2.9 14.1 2 16.4 2 18.8V21.1C2 21.7 2.4 22.1 3 22.1H5.3C7.7 22.1 10 21.2 11.7 19.5L14.9 16.3L20.4 21.8L21.8 20.4L3.8 2.40001L2.3 3.70001ZM10.2 17.9C8.9 19.2 7.1 20 5.3 20H4V18.7C4 16.8 4.7 15.1 6.1 13.8L9.3 10.6L13.5 14.8L10.2 17.9ZM21.9 9.10001L17.2 13.8L15.8 12.4L20.5 7.70001C20.9 7.30001 20.9 6.70001 20.5 6.30001L17.7 3.50001C17.5 3.20001 17.2 3.20001 17 3.20001C16.8 3.20001 16.5 3.20001 16.3 3.50001L11.6 8.20001L10.2 6.80001L14.9 2.10001C15.5 1.50001 16.2 1.20001 17 1.20001C17.8 1.20001 18.5 1.50001 19.1 2.10001L21.9 4.90001C23.1 6.00001 23.1 7.90001 21.9 9.10001Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/fix-24x24.svg":
/*!*************************************!*\
  !*** ./src/images-v1/fix-24x24.svg ***!
  \*************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_19268_561903)\"><path d=\"M8.71 11.2901L5.71 8.29006C5.32 7.90006 4.69 7.90006 4.3 8.29006C3.91 8.68006 3.91 9.31006 4.3 9.70006L5.59 10.9901H1C0.45 10.9901 0 11.4401 0 11.9901C0 12.5401 0.45 12.9901 1 12.9901H5.59L4.3 14.2801C3.91 14.6701 3.91 15.3001 4.3 15.6901C4.5 15.8901 4.75 15.9801 5.01 15.9801C5.27 15.9801 5.52 15.8801 5.72 15.6901L8.72 12.6901C8.81 12.6001 8.89 12.4901 8.94 12.3601C9.04 12.1201 9.04 11.8401 8.94 11.6001C8.89 11.4801 8.82 11.3701 8.72 11.2701L8.71 11.2901Z\"></path><path d=\"M15.71 10.29C15.32 9.89999 14.69 9.89999 14.3 10.29C13.91 10.68 13.91 11.31 14.3 11.7L16.3 13.7C16.5 13.9 16.75 13.99 17.01 13.99C17.27 13.99 17.52 13.89 17.72 13.7L23.72 7.69999C24.11 7.30999 24.11 6.67999 23.72 6.28999C23.33 5.89999 22.7 5.89999 22.31 6.28999L21.05 7.54999C19.99 6.57999 18.57 5.98999 17.02 5.98999C13.71 5.98999 11.02 8.67999 11.02 11.99C11.02 15.3 13.71 17.99 17.02 17.99C20.33 17.99 23.02 15.3 23.02 11.99C23.02 11.5 22.96 11.03 22.85 10.58L20.98 12.45C20.75 14.44 19.07 15.99 17.03 15.99C14.82 15.99 13.03 14.2 13.03 11.99C13.03 9.77999 14.82 7.98999 17.03 7.98999C18.03 7.98999 18.93 8.36999 19.63 8.97999L17.03 11.58L15.74 10.29H15.71Z\"></path></g><defs><clipPath id=\"clip0_19268_561903\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/flip-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/flip-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23 12.0037C23 14.2445 21.7794 16.3052 19.5684 17.8257C19.3984 17.9458 19.1983 18.0058 19.0082 18.0058C18.688 18.0058 18.3779 17.8557 18.1778 17.5756C17.8677 17.1155 17.9777 16.4953 18.4379 16.1852C20.0887 15.0448 21.0091 13.5643 21.0091 12.0138C21.0091 8.70262 16.9673 6.01171 12.005 6.01171C11.4948 6.01171 10.9945 6.04172 10.5043 6.09173L11.7149 7.30215C12.105 7.69228 12.105 8.32249 11.7149 8.71263C11.5148 8.9127 11.2647 9.00273 11.0045 9.00273C10.7444 9.00273 10.4943 8.90269 10.2942 8.71263L6.58254 5.00136L10.2842 1.2901C10.6744 0.899964 11.3047 0.899964 11.6949 1.2901C12.085 1.68023 12.085 2.31045 11.6949 2.70058L10.3042 4.09105C10.8545 4.03103 11.4147 4.00102 11.985 4.00102C18.0578 4.00102 22.99 7.59225 22.99 12.0037H23ZM12.2851 15.2949C11.895 15.685 11.895 16.3152 12.2851 16.7054L13.4957 17.9158C13.0055 17.9758 12.4952 17.9958 11.995 17.9958C7.03274 17.9958 2.99091 15.3049 2.99091 11.9937C2.99091 10.4332 3.90132 8.95271 5.56207 7.82232C6.02228 7.51222 6.13233 6.89201 5.82219 6.43185C5.51205 5.97169 4.89177 5.86166 4.43156 6.17176C2.22055 7.69228 1 9.76299 1 11.9937C1 16.4052 5.93224 19.9965 12.005 19.9965C12.5753 19.9965 13.1355 19.9665 13.6858 19.9064L12.2951 21.2969C11.905 21.6871 11.905 22.3173 12.2951 22.7074C12.4952 22.9075 12.7453 22.9975 13.0055 22.9975C13.2656 22.9975 13.5157 22.8975 13.7158 22.7074L17.4275 18.9961L13.7158 15.2849C13.3256 14.8947 12.6953 14.8947 12.3051 15.2849L12.2851 15.2949Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/folder-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/folder-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.93 9H21V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H10L8 3H4C3.46957 3 2.96086 3.21071 2.58579 3.58579C2.21071 3.96086 2 4.46957 2 5L2 21H21L23.89 11.63C23.9916 11.3244 24.0179 10.9988 23.9667 10.6809C23.9155 10.363 23.7882 10.0621 23.5958 9.80392C23.4034 9.54571 23.1514 9.33779 22.8614 9.19782C22.5714 9.05786 22.2519 8.99 21.93 9ZM4 5H7.17L8.59 6.41L9.17 7H19V9H6L4 15V5ZM22 11L19.54 19H4.77L7.44 11H22Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/fullsize-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v1/fullsize-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 13H4C2.9 13 2 12.1 2 11V5C2 3.9 2.9 3 4 3H12C13.1 3 14 3.9 14 5V11C14 12.1 13.1 13 12 13ZM4 5V11H12V5H4Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/gear-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/gear-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.5 3C12.78 3 13 3.22 13 3.5V5.08C14.18 5.25 15.27 5.71 16.19 6.4L17.31 5.28C17.41 5.18 17.54 5.13 17.66 5.13C17.78 5.13 17.92 5.18 18.01 5.28L18.72 5.99C18.92 6.19 18.92 6.5 18.72 6.7L17.6 7.82C18.29 8.74 18.75 9.82 18.92 11.01H20.5C20.78 11.01 21 11.23 21 11.51V12.51C21 12.79 20.78 13.01 20.5 13.01H18.92C18.75 14.19 18.29 15.28 17.6 16.2L18.72 17.32C18.92 17.52 18.92 17.83 18.72 18.03L18.01 18.74C17.91 18.84 17.78 18.89 17.66 18.89C17.54 18.89 17.4 18.84 17.31 18.74L16.19 17.62C15.27 18.31 14.19 18.77 13 18.94V20.52C13 20.8 12.78 21.02 12.5 21.02H11.5C11.22 21.02 11 20.8 11 20.52V18.94C9.82 18.77 8.73 18.31 7.81 17.62L6.69 18.74C6.59 18.84 6.46 18.89 6.34 18.89C6.22 18.89 6.08 18.84 5.99 18.74L5.28 18.03C5.08 17.83 5.08 17.52 5.28 17.32L6.4 16.2C5.71 15.28 5.25 14.2 5.08 13.01H3.5C3.22 13.01 3 12.79 3 12.51V11.51C3 11.23 3.22 11.01 3.5 11.01H5.08C5.25 9.83 5.71 8.74 6.4 7.82L5.28 6.7C5.08 6.5 5.08 6.19 5.28 5.99L5.99 5.28C6.09 5.18 6.22 5.13 6.34 5.13C6.46 5.13 6.6 5.18 6.69 5.28L7.81 6.4C8.73 5.71 9.81 5.25 11 5.08V3.5C11 3.22 11.22 3 11.5 3H12.5ZM12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8C9.79 8 8 9.79 8 12C8 14.21 9.79 16 12 16ZM12.5 1H11.5C10.12 1 9 2.12 9 3.5V3.52C8.7 3.63 8.41 3.75 8.13 3.88L8.11 3.86C7.64 3.39 7.01 3.13 6.34 3.13C5.67 3.13 5.04 3.39 4.57 3.86L3.86 4.57C2.89 5.55 2.89 7.13 3.86 8.11L3.88 8.13C3.74 8.41 3.62 8.71 3.52 9H3.5C2.12 9 1 10.12 1 11.5V12.5C1 13.88 2.12 15 3.5 15H3.52C3.63 15.3 3.75 15.59 3.88 15.87L3.86 15.89C2.89 16.87 2.89 18.45 3.86 19.43L4.57 20.14C5.04 20.61 5.67 20.87 6.34 20.87C7.01 20.87 7.64 20.61 8.11 20.14L8.13 20.12C8.41 20.26 8.71 20.38 9 20.48V20.5C9 21.88 10.12 23 11.5 23H12.5C13.88 23 15 21.88 15 20.5V20.48C15.3 20.37 15.59 20.25 15.87 20.12L15.89 20.14C16.36 20.61 16.99 20.87 17.66 20.87C18.33 20.87 18.96 20.61 19.43 20.14L20.14 19.43C21.11 18.46 21.11 16.87 20.14 15.89L20.12 15.87C20.26 15.59 20.38 15.29 20.48 15H20.5C21.88 15 23 13.88 23 12.5V11.5C23 10.12 21.88 9 20.5 9H20.48C20.37 8.7 20.25 8.41 20.12 8.13L20.14 8.11C21.11 7.14 21.11 5.55 20.14 4.57L19.43 3.86C18.96 3.39 18.33 3.13 17.66 3.13C16.99 3.13 16.36 3.39 15.89 3.86L15.87 3.88C15.59 3.74 15.29 3.62 15 3.52V3.5C15 2.12 13.88 1 12.5 1ZM12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/help-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/help-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.88 3.25C15.62 3.25 13.31 3.64 12 4.24C10.7 3.65 8.38 3.25 6.12 3.25C3 3.25 0 4 0 6V22.76C0 20.76 3 20.01 6.12 20.01C7.88 20.01 9.67 20.25 11 20.63C11.38 20.74 11.71 20.86 12 20.99C12.29 20.86 12.62 20.74 13 20.63C14.32 20.25 16.12 20.01 17.88 20.01C21 20.01 24 20.76 24 22.76V6C24 4 21 3.25 17.88 3.25ZM11 18.56C8.97 18.06 6.79 18.02 6.12 18.02C4.54 18.02 3.15 18.19 2 18.52V6.07C2.29 5.79 3.61 5.25 6.12 5.25C8.32 5.25 10.15 5.64 11 5.97V18.56ZM22 18.52C20.84 18.19 19.46 18.02 17.88 18.02C17.21 18.02 15.04 18.06 13 18.56V5.97C13.85 5.64 15.67 5.25 17.88 5.25C20.4 5.25 21.72 5.79 22 6.07V18.51V18.52ZM3.87 7.94C5.48 7.73 7.35 7.76 9.14 8.01C9.69 8.09 10.07 8.59 9.99 9.14C9.92 9.64 9.49 10 9 10C8.95 10 8.91 10 8.86 10C7.27 9.77 5.54 9.75 4.13 9.93C3.58 10 3.08 9.62 3.01 9.07C2.94 8.52 3.32 8.02 3.87 7.95V7.94ZM9.99 13.14C9.92 13.64 9.49 14 9 14C8.95 14 8.91 14 8.86 14C7.27 13.77 5.55 13.75 4.13 13.93C3.58 14 3.08 13.61 3.01 13.07C2.94 12.52 3.32 12.02 3.87 11.95C5.48 11.74 7.35 11.77 9.14 12.02C9.69 12.1 10.07 12.61 9.99 13.15V13.14ZM20.13 7.94C20.68 8.01 21.06 8.51 20.99 9.06C20.92 9.61 20.42 10 19.87 9.92C18.46 9.74 16.74 9.76 15.14 9.99C15.09 9.99 15.04 9.99 15 9.99C14.51 9.99 14.08 9.63 14.01 9.13C13.93 8.58 14.31 8.08 14.86 8C16.65 7.75 18.53 7.72 20.13 7.93V7.94ZM20.99 13.06C20.92 13.61 20.42 13.99 19.87 13.92C18.45 13.74 16.73 13.76 15.14 13.99C15.09 13.99 15.04 13.99 15 13.99C14.51 13.99 14.08 13.63 14.01 13.13C13.93 12.58 14.31 12.08 14.86 12C16.65 11.74 18.52 11.72 20.13 11.93C20.68 12 21.06 12.5 20.99 13.05V13.06Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/hidehint-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v1/hidehint-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_21403_120504)\"><path d=\"M1.53333 2.46669L2.4 3.33335C1.33333 4.60002 0.666664 6.20002 0.666664 8.00002C0.666664 12.0667 3.93333 15.3334 8 15.3334C9.8 15.3334 11.4 14.6667 12.6667 13.6L13.5333 14.4667L14.4667 13.5334L2.46666 1.53335L1.53333 2.46669ZM8 14C4.66666 14 2 11.3334 2 8.00002C2 6.60002 2.46666 5.26669 3.33333 4.26669L7.2 8.13335C7.13333 8.20002 7.06666 8.26669 7.06666 8.33335C7 8.46669 6.93333 8.66669 6.93333 8.86669C6.93333 9.06669 7 9.26669 7.06666 9.40002C7.13333 9.53335 7.2 9.66669 7.26666 9.86669C7.33333 10 7.46666 10.0667 7.6 10.0667C7.66666 10.0667 7.66666 10.0667 7.73333 10.0667H7.8C7.86666 10.0667 7.93333 10.0667 8.06666 10C8.26666 9.93335 8.4 9.80002 8.4 9.66669V9.60002V9.40002L11.6667 12.6667C10.7333 13.5334 9.4 14 8 14ZM5.2 2.73335L4.2 1.73335C5.33333 1.06669 6.6 0.666687 8 0.666687C12.0667 0.666687 15.3333 3.93335 15.3333 8.00002C15.3333 9.40002 14.9333 10.6667 14.2667 11.8L13.2667 10.8C13.7333 10 14 9.00002 14 8.00002C14 4.66669 11.3333 2.00002 8 2.00002C7 2.00002 6 2.26669 5.2 2.73335ZM9 6.53335C9 6.46669 9.06666 6.40002 9.06666 6.26669C9.06666 6.00002 9 5.73335 8.8 5.60002C8.53333 5.33335 8.26666 5.26669 8 5.26669C7.93333 5.26669 7.86666 5.26669 7.73333 5.26669L6.73333 4.26669C6.8 4.26669 6.8 4.20002 6.86666 4.20002C7.66666 3.93335 8.46666 3.93335 9.06666 4.06669C9.4 4.13335 9.66666 4.26669 9.93333 4.40002C10.4 4.86669 10.6667 5.40002 10.6667 6.20002C10.6667 6.73335 10.4667 7.20002 10.1333 7.60002L9 6.53335ZM7.86666 10.6C8.33333 10.6 8.66666 10.8 8.86666 11.2C8.93333 11.3334 8.93333 11.4667 8.93333 11.6C8.93333 11.8667 8.8 12.1334 8.66666 12.3334C8.46666 12.5334 8.2 12.6 7.93333 12.6C7.66666 12.6 7.4 12.4667 7.2 12.3334C7 12.1334 6.93333 11.8667 6.93333 11.6C6.93333 11.3334 7.06666 11.0667 7.2 10.8667C7.33333 10.6667 7.6 10.6 7.86666 10.6Z\"></path></g><defs><clipPath id=\"clip0_21403_120504\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/hidehint-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v1/hidehint-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.3 3.7L3.6 5C2 6.9 1 9.3 1 12C1 18.1 5.9 23 12 23C14.7 23 17.1 22 19 20.4L20.3 21.7L21.7 20.3L3.7 2.3L2.3 3.7ZM12 21C7 21 3 17 3 12C3 9.9 3.7 7.9 5 6.4L10.8 12.2C10.7 12.3 10.6 12.4 10.6 12.5C10.5 12.7 10.4 13 10.4 13.3C10.4 13.6 10.5 13.9 10.6 14.1C10.7 14.3 10.8 14.5 10.9 14.8C11 15 11.2 15.1 11.4 15.1C11.5 15.1 11.5 15.1 11.6 15.1H11.7C11.8 15.1 11.9 15.1 12.1 15C12.4 14.9 12.6 14.7 12.6 14.5V14.4V14.1L17.5 19C16.1 20.3 14.1 21 12 21ZM7.8 4.1L6.3 2.6C8 1.6 9.9 1 12 1C18.1 1 23 5.9 23 12C23 14.1 22.4 16 21.4 17.7L19.9 16.2C20.6 15 21 13.5 21 12C21 7 17 3 12 3C10.5 3 9 3.4 7.8 4.1ZM13.5 9.8C13.5 9.7 13.6 9.6 13.6 9.4C13.6 9 13.5 8.6 13.2 8.4C12.8 8 12.4 7.9 12 7.9C11.9 7.9 11.8 7.9 11.6 7.9L10.1 6.4C10.2 6.4 10.2 6.3 10.3 6.3C11.5 5.9 12.7 5.9 13.6 6.1C14.1 6.2 14.5 6.4 14.9 6.6C15.6 7.3 16 8.1 16 9.3C16 10.1 15.7 10.8 15.2 11.4L13.5 9.8ZM11.8 15.9C12.5 15.9 13 16.2 13.3 16.8C13.4 17 13.4 17.2 13.4 17.4C13.4 17.8 13.2 18.2 13 18.5C12.7 18.8 12.3 18.9 11.9 18.9C11.5 18.9 11.1 18.7 10.8 18.5C10.5 18.2 10.4 17.8 10.4 17.4C10.4 17 10.6 16.6 10.8 16.3C11 16 11.4 15.9 11.8 15.9Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/hint-16x16.svg":
/*!**************************************!*\
  !*** ./src/images-v1/hint-16x16.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_21248_353340)\"><path d=\"M8.00002 0.666687C3.93335 0.666687 0.666687 3.93335 0.666687 8.00002C0.666687 12.0667 3.93335 15.3334 8.00002 15.3334C12.0667 15.3334 15.3334 12.0667 15.3334 8.00002C15.3334 3.93335 12.0667 0.666687 8.00002 0.666687ZM8.00002 14C4.66669 14 2.00002 11.3334 2.00002 8.00002C2.00002 4.66669 4.66669 2.00002 8.00002 2.00002C11.3334 2.00002 14 4.66669 14 8.00002C14 11.3334 11.3334 14 8.00002 14ZM8.86669 11.2C8.93335 11.3334 8.93335 11.4667 8.93335 11.6C8.93335 11.8667 8.80002 12.1334 8.66669 12.3334C8.46669 12.5334 8.20002 12.6 7.93335 12.6C7.66669 12.6 7.40002 12.4667 7.20002 12.3334C7.00002 12.1334 6.93335 11.8667 6.93335 11.6C6.93335 11.3334 7.06669 11.0667 7.20002 10.8667C7.40002 10.6667 7.66669 10.5334 7.93335 10.5334C8.33335 10.6 8.66669 10.8 8.86669 11.2ZM10.6667 6.20002C10.6667 6.93335 10.3334 7.46669 9.73335 7.93335C9.60002 8.06669 9.40002 8.13335 9.26669 8.26669L8.86669 8.53335C8.66669 8.66669 8.60002 8.73335 8.60002 8.73335C8.53335 8.80002 8.53335 8.86669 8.53335 8.93335C8.53335 9.06669 8.46669 9.20002 8.46669 9.40002V9.60002V9.66669C8.40002 9.80002 8.26669 9.93335 8.13335 10C8.00002 10.0667 7.93335 10.0667 7.86669 10.0667H7.80002C7.73335 10.0667 7.73335 10.0667 7.66669 10.0667C7.53335 10 7.40002 9.93335 7.33335 9.86669C7.26669 9.73335 7.13335 9.60002 7.13335 9.40002C7.06669 9.20002 7.00002 9.06669 7.00002 8.86669C7.00002 8.66669 7.06669 8.46669 7.13335 8.33335C7.20002 8.20002 7.33335 8.06669 7.46669 7.93335C7.60002 7.80002 7.73335 7.73335 7.86669 7.66669L8.26669 7.46669C8.66669 7.26669 8.80002 7.13335 8.86669 7.06669C9.06669 6.86669 9.13335 6.60002 9.13335 6.33335C9.13335 6.06669 9.06669 5.80002 8.86669 5.66669C8.53335 5.33335 8.26669 5.26669 8.00002 5.26669C7.26669 5.26669 7.06669 5.60002 7.06669 5.86669C6.93335 6.20002 6.93335 6.26669 6.93335 6.26669V6.40002C6.93335 6.46669 6.93335 6.46669 6.93335 6.53335L7.00002 6.80002L6.80002 6.86669C6.40002 7.06669 6.06669 7.06669 5.80002 6.93335C5.73335 6.86669 5.60002 6.73335 5.53335 6.66669C5.40002 6.46669 5.33335 6.26669 5.33335 6.00002C5.33335 5.73335 5.40002 5.53335 5.46669 5.33335C5.53335 5.13335 5.66669 5.00002 5.80002 4.86669C5.93335 4.73335 6.06669 4.60002 6.26669 4.46669C6.46669 4.40002 6.66669 4.26669 6.86669 4.20002C7.66669 3.93335 8.46669 3.93335 9.06669 4.06669C9.40002 4.13335 9.66669 4.26669 9.93335 4.40002C10.4 4.86669 10.6667 5.40002 10.6667 6.20002Z\"></path></g><defs><clipPath id=\"clip0_21248_353340\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/hint-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/hint-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 1C5.9 1 1 5.9 1 12C1 18.1 5.9 23 12 23C18.1 23 23 18.1 23 12C23 5.9 18.1 1 12 1ZM12 21C7 21 3 17 3 12C3 7 7 3 12 3C17 3 21 7 21 12C21 17 17 21 12 21ZM13.3 16.8C13.4 17 13.4 17.2 13.4 17.4C13.4 17.8 13.2 18.2 13 18.5C12.7 18.8 12.3 18.9 11.9 18.9C11.5 18.9 11.1 18.7 10.8 18.5C10.5 18.2 10.4 17.8 10.4 17.4C10.4 17 10.6 16.6 10.8 16.3C11.1 16 11.5 15.8 11.9 15.8C12.5 15.9 13 16.2 13.3 16.8ZM16 9.3C16 10.4 15.5 11.2 14.6 11.9C14.4 12.1 14.1 12.2 13.9 12.4L13.3 12.8C13 13 12.9 13.1 12.9 13.1C12.8 13.2 12.8 13.3 12.8 13.4C12.8 13.6 12.7 13.8 12.7 14.1V14.4V14.5C12.6 14.7 12.4 14.9 12.2 15C12 15.1 11.9 15.1 11.8 15.1H11.7C11.6 15.1 11.6 15.1 11.5 15.1C11.3 15 11.1 14.9 11 14.8C10.9 14.6 10.7 14.4 10.7 14.1C10.6 13.8 10.5 13.6 10.5 13.3C10.5 13 10.6 12.7 10.7 12.5C10.8 12.3 11 12.1 11.2 11.9C11.4 11.7 11.6 11.6 11.8 11.5L12.4 11.2C13 10.9 13.2 10.7 13.3 10.6C13.6 10.3 13.7 9.9 13.7 9.5C13.7 9.1 13.6 8.7 13.3 8.5C12.8 8 12.4 7.9 12 7.9C10.9 7.9 10.6 8.4 10.6 8.8C10.4 9.3 10.4 9.4 10.4 9.4V9.6C10.4 9.7 10.4 9.7 10.4 9.8L10.5 10.2L10.2 10.3C9.6 10.6 9.1 10.6 8.7 10.4C8.6 10.3 8.4 10.1 8.3 10C8.1 9.7 8 9.4 8 9C8 8.6 8.1 8.3 8.2 8C8.3 7.7 8.5 7.5 8.7 7.3C8.9 7.1 9.1 6.9 9.4 6.7C9.7 6.6 10 6.4 10.3 6.3C11.5 5.9 12.7 5.9 13.6 6.1C14.1 6.2 14.5 6.4 14.9 6.6C15.6 7.3 16 8.1 16 9.3Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/image-48x48.svg":
/*!***************************************!*\
  !*** ./src/images-v1/image-48x48.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M36 8H12C9.79 8 8 9.79 8 12V36C8 38.21 9.79 40 12 40H36C38.21 40 40 38.21 40 36V12C40 9.79 38.21 8 36 8ZM38 36C38 37.1 37.1 38 36 38H12C10.9 38 10 37.1 10 36V12C10 10.9 10.9 10 12 10H36C37.1 10 38 10.9 38 12V36ZM14 17C14 15.34 15.34 14 17 14C18.66 14 20 15.34 20 17C20 18.66 18.66 20 17 20C15.34 20 14 18.66 14 17ZM27 24L36 36H12L19 27L23 29L27 24Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/import-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/import-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.93 9H21V7C21 6.46957 20.7893 5.96086 20.4142 5.58579C20.0391 5.21071 19.5304 5 19 5H10L8 3H4C3.46957 3 2.96086 3.21071 2.58579 3.58579C2.21071 3.96086 2 4.46957 2 5L2 21H21L23.89 11.63C23.9916 11.3244 24.0179 10.9988 23.9667 10.6809C23.9155 10.363 23.7882 10.0621 23.5958 9.80392C23.4034 9.54571 23.1514 9.33779 22.8614 9.19782C22.5714 9.05786 22.2519 8.99 21.93 9ZM4 5H7.17L8.59 6.41L9.17 7H19V9H6L4 15V5ZM22 11L19.54 19H4.77L7.44 11H22Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/invisible-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/invisible-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 7.003C12.4641 7.01107 12.9249 7.08171 13.37 7.213L11.54 9.053C10.9155 9.15262 10.3384 9.44704 9.89125 9.89423C9.44406 10.3414 9.14964 10.9185 9.05002 11.543L7.21002 13.373C7.07873 12.9279 7.00809 12.467 7.00002 12.003C7.00002 10.6769 7.5268 9.40515 8.46449 8.46747C9.40217 7.52978 10.6739 7.003 12 7.003ZM5.40002 15.183C4.39516 14.2466 3.52369 13.1766 2.81002 12.003C5.10002 8.223 8.47002 6.003 12 6.003C12.765 6.0082 13.5255 6.11925 14.26 6.333L15.86 4.733C14.6291 4.25486 13.3206 4.0074 12 4.003C7.24002 4.003 3.05002 7.173 0.52002 12.003C1.41557 13.7255 2.59165 15.2868 4.00002 16.623L5.40002 15.183ZM23.48 12.003C21 16.833 16.76 20.003 12 20.003C10.1707 19.9916 8.37315 19.5242 6.77002 18.643L2.71002 22.713L1.29002 21.293L21.29 1.293L22.71 2.713L18.94 6.473C20.8367 7.96509 22.3858 9.8521 23.48 12.003ZM14.7 10.723L10.7 14.723C11.1058 14.9158 11.5508 15.0116 12 15.003C12.7957 15.003 13.5587 14.6869 14.1213 14.1243C14.6839 13.5617 15 12.7986 15 12.003C14.9993 11.559 14.8967 11.1211 14.7 10.723ZM21.19 12.003C20.243 10.4087 18.9887 9.01851 17.5 7.913L16.16 9.263C16.7052 10.073 16.9975 11.0266 17 12.003C17 13.3291 16.4732 14.6009 15.5356 15.5385C14.5979 16.4762 13.3261 17.003 12 17.003C11.0237 17.0005 10.07 16.7081 9.26002 16.163L8.26002 17.163C9.43056 17.7122 10.707 17.9989 12 18.003C15.53 18.003 18.9 15.783 21.19 12.003Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/language-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v1/language-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.75 8H15.25L13.35 13.08C12.2029 12.2588 11.2439 11.2027 10.537 9.98187C9.83 8.76107 9.39127 7.40364 9.25 6H14V4H9V2H7V4H2V6H6.91C6.73189 7.75797 6.09115 9.43736 5.05302 10.8672C4.01489 12.2971 2.61643 13.4263 1 14.14C1.32315 14.7296 1.69441 15.2915 2.11 15.82C4.82764 14.5445 6.96846 12.2966 8.11 9.52C9.02641 11.7596 10.5985 13.6698 12.62 15L10 22H12.42L13.79 18.13H19.16L20.56 22H23L17.75 8ZM14.46 16.16L15.73 12.53C16.0406 11.7049 16.2945 10.8596 16.49 10C16.55 10.26 16.67 10.66 16.84 11.21C17.01 11.76 17.14 12.15 17.24 12.41L18.55 16.2L14.46 16.16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/loading-48x48.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/loading-48x48.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_19679_369428)\"><path opacity=\"0.25\" d=\"M24 40C15.18 40 8 32.82 8 24C8 15.18 15.18 8 24 8C32.82 8 40 15.18 40 24C40 32.82 32.82 40 24 40ZM24 12C17.38 12 12 17.38 12 24C12 30.62 17.38 36 24 36C30.62 36 36 30.62 36 24C36 17.38 30.62 12 24 12Z\"></path><path d=\"M10 26C8.9 26 8 25.1 8 24C8 15.18 15.18 8 24 8C25.1 8 26 8.9 26 10C26 11.1 25.1 12 24 12C17.38 12 12 17.38 12 24C12 25.1 11.1 26 10 26Z\"></path></g><defs><clipPath id=\"clip0_19679_369428\"><rect width=\"32\" height=\"32\" fill=\"white\" transform=\"translate(8 8)\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/logic-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v1/logic-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 14.59L16.59 16L18.59 18H7.82C7.79 17.9 7.75 17.81 7.7 17.71L17.71 7.7C18.1 7.89 18.53 8 19 8C20.65 8 22 6.65 22 5C22 3.35 20.65 2 19 2C17.7 2 16.6 2.84 16.18 4H7.82C7.41 2.84 6.31 2 5 2C3.35 2 2 3.35 2 5C2 6.65 3.35 8 5 8C6.3 8 7.4 7.16 7.82 6H16.19C16.22 6.1 16.26 6.19 16.31 6.29L6.29 16.3C5.9 16.11 5.47 16 5 16C3.35 16 2 17.35 2 19C2 20.65 3.35 22 5 22C6.3 22 7.4 21.16 7.82 20H18.59L16.59 22L18 23.41L22.41 19L18 14.59ZM19 4C19.55 4 20 4.45 20 5C20 5.55 19.55 6 19 6C18.45 6 18 5.55 18 5C18 4.45 18.45 4 19 4ZM5 6C4.45 6 4 5.55 4 5C4 4.45 4.45 4 5 4C5.55 4 6 4.45 6 5C6 5.55 5.55 6 5 6ZM5 20C4.45 20 4 19.55 4 19C4 18.45 4.45 18 5 18C5.55 18 6 18.45 6 19C6 19.55 5.55 20 5 20Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/logo-angular-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/logo-angular-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_17790_388137)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.17 0L1 3.98L2.71 18.75L12.16 24L21.77 18.68L23.62 3.91L12.17 0ZM16.97 18.27L15.45 14.74H9.23L7.83 18.24L5.23 18.29L12.19 2.81L19.45 18.33L16.97 18.28V18.27ZM10.15 12.69L12.21 7.77L14.56 12.69H10.14H10.15Z\" fill=\"#E23237\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.1899 12.69H12.1699V7.85L12.1999 7.77L14.5499 12.69H12.1799H12.1899ZM12.1699 0V2.84L12.1899 2.8L19.4499 18.32L16.9699 18.27L15.4499 14.74H12.1799V24L21.7899 18.68L23.6399 3.91L12.1699 0Z\" fill=\"#B52E31\"></path></g><defs><clipPath id=\"clip0_17790_388137\"><rect width=\"22.63\" height=\"24\" fill=\"white\" transform=\"translate(1)\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/logo-jquery-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v1/logo-jquery-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.42 17.5751C23.42 17.5751 20.43 25.5875 10.16 23.7169C7.55997 23.0467 5.16997 21.5963 3.35997 19.6157C3.00997 19.2356 2.67997 18.8354 2.37997 18.4153C-0.130033 14.9643 -1.02003 10.0228 1.51997 6.39164L3.17997 4.30101C0.199966 10.1128 4.07997 17.1649 9.63997 19.7657C14.13 22.0064 20.41 21.5263 23.41 17.5751H23.42ZM8.53997 12.4435C9.86997 14.3741 11.96 15.7845 14.23 16.3747C22.16 17.6851 24 11.6032 24 11.6032C18.31 19.1855 4.80997 10.6529 9.36997 2.07033L8.11997 3.83086C6.30997 6.41165 6.75997 9.96273 8.53997 12.4335V12.4435ZM16.9 9.72266C17.08 9.79268 17.27 9.8527 17.46 9.90272C21.84 10.743 23.03 7.66203 23.35 7.21189C21.99 9.39256 18.24 9.07246 16.2 7.47197C14.28 6.02153 13.09 3.26069 14.34 1C11.47 4.08094 13.21 8.36225 16.9 9.72266Z\" fill=\"#0D61A8\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/logo-knockout-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/logo-knockout-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_17790_388139)\"><path d=\"M23.6098 20.0301C23.2398 19.8203 22.8498 19.6805 22.4198 19.6605C20.8398 19.6605 19.6398 19.6605 18.2098 19.6605C16.7898 19.7104 16.6398 18.1121 16.2198 17.0832C15.4698 15.1152 14.8298 13.0973 14.0598 11.1394C15.9698 9.15147 17.8298 7.1136 19.7298 5.12568C20.8498 4.09676 22.2798 2.13881 20.2898 1.17981C18.0898 0.880128 16.8298 3.6772 15.3098 4.90591C13.9298 6.46428 12.4398 7.92276 11.0798 9.48112C13.8898 4.27657 10.8798 -0.208732 5.07985 1.2897C1.39985 2.44849 -1.16015 6.95377 0.529846 10.6399C1.33985 12.2482 3.08985 13.447 4.89985 12.8776C5.75985 12.508 6.36985 11.4291 5.83985 10.55C5.51985 10.1704 5.06985 9.99059 4.61985 9.82077C3.57985 9.38123 3.20985 8.19247 3.47985 7.15356C3.83985 5.06575 7.02985 3.04786 8.43985 5.27553C8.75985 6.34441 8.15985 7.45325 7.80985 8.4522C6.89985 10.7798 5.96985 13.0874 5.04985 15.4049C4.68985 16.5138 3.93985 17.5627 4.09985 18.7714C4.89985 20.4397 6.86985 19.7803 7.55985 18.3518C8.52985 15.9344 9.58985 13.5269 10.4198 11.0795C11.7798 14.5558 12.8498 18.162 14.3298 21.5885C14.8598 22.6074 15.8598 22.957 16.9398 22.997C19.0098 22.997 20.3698 22.997 21.9098 22.997C22.2798 22.997 22.6298 22.8272 22.9898 22.7173C23.9298 22.2378 24.3698 20.8692 23.5998 20.0501L23.6098 20.0301Z\" fill=\"#E42E16\"></path></g><defs><clipPath id=\"clip0_17790_388139\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/logo-react-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v1/logo-react-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.1459 11.9624C14.1459 13.1424 13.1855 14.1024 12.005 14.1024C10.8245 14.1024 9.86411 13.1424 9.86411 11.9624C9.86411 10.7824 10.8245 9.8224 12.005 9.8224C13.1855 9.8224 14.1459 10.7824 14.1459 11.9624ZM24 11.9624C24 13.4324 22.2593 14.9224 19.4581 15.8524C19.308 15.9024 19.168 15.9424 19.0079 15.9924C19.0679 16.2124 19.108 16.4224 19.158 16.6324C19.4181 17.9524 19.4581 19.1824 19.278 20.1824C19.0779 21.2424 18.6378 22.0024 17.9975 22.3724C17.6774 22.5624 17.2972 22.6524 16.877 22.6524C15.7165 22.6524 14.2359 21.9524 12.7053 20.6324C12.4852 20.4424 12.2751 20.2524 12.055 20.0424C11.885 20.2024 11.7249 20.3624 11.5548 20.5024C10.5344 21.3924 9.49396 22.0424 8.53356 22.3824C8.03335 22.5624 7.56315 22.6524 7.14298 22.6524C6.7228 22.6524 6.32263 22.5624 6.0025 22.3724C4.77199 21.6624 4.35181 19.6224 4.86203 16.9124C4.91205 16.6324 4.98208 16.3524 5.0521 16.0624C4.82201 16.0024 4.61192 15.9324 4.40183 15.8524C3.1213 15.4124 2.04085 14.8324 1.26053 14.1724C0.440183 13.4724 0 12.7024 0 11.9724C0 10.5524 1.56065 9.1624 4.17174 8.2624C4.46186 8.1624 4.76198 8.0724 5.06211 7.9824C4.99208 7.7124 4.93205 7.4524 4.88203 7.1924C4.63193 5.9024 4.58191 4.7224 4.74198 3.7624C4.92205 2.7224 5.34223 1.9824 5.97249 1.6224C7.24302 0.882403 9.41392 1.6424 11.6148 3.6024C11.7449 3.7224 11.8749 3.8424 12.015 3.9724C12.2151 3.7824 12.4152 3.5924 12.6153 3.4224C13.6057 2.5624 14.6161 1.9224 15.5165 1.5924C16.5069 1.2324 17.3572 1.2324 17.9775 1.5924C19.258 2.3224 19.6782 4.5824 19.0779 7.4724C19.0479 7.6524 18.9979 7.8224 18.9579 8.0024C19.218 8.0824 19.4781 8.1624 19.7282 8.2424C20.9687 8.6724 22.0192 9.2224 22.7595 9.8424C23.5698 10.5124 23.99 11.2524 23.99 11.9824L24 11.9624ZM13.2855 4.1924C13.1055 4.3524 12.9154 4.5224 12.7353 4.6924C13.4156 5.4224 14.0959 6.2824 14.7561 7.2224C15.8866 7.3324 16.9671 7.5024 17.9675 7.7324C18.0075 7.5724 18.0475 7.4124 18.0775 7.2624C18.6378 4.5424 18.1576 2.8724 17.4673 2.4824C17.1171 2.2824 16.5469 2.3024 15.8666 2.5624C15.0763 2.8524 14.1859 3.4224 13.2855 4.2024V4.1924ZM16.3868 11.9824C16.0767 11.3524 15.7266 10.7124 15.3464 10.0524C14.9762 9.4024 14.5861 8.7924 14.1859 8.2024C13.4756 8.1424 12.7453 8.1224 11.995 8.1224C11.2447 8.1224 10.5244 8.1524 9.81409 8.2024C9.40392 8.7924 9.02376 9.4124 8.6436 10.0624C8.27345 10.7024 7.93331 11.3524 7.62318 11.9924C7.93331 12.6424 8.27345 13.2824 8.65361 13.9324C9.03376 14.5824 9.41392 15.1924 9.82409 15.7924C10.5244 15.8324 11.2447 15.8624 11.995 15.8624C12.7453 15.8624 13.4856 15.8324 14.1959 15.7824C14.5861 15.2024 14.9662 14.5824 15.3464 13.9324C15.7165 13.2824 16.0667 12.6324 16.3768 11.9924L16.3868 11.9824ZM16.2368 14.4324C15.9967 14.8524 15.7466 15.2624 15.5065 15.6524C16.2968 15.5624 17.0471 15.4324 17.7474 15.2724C17.5373 14.6024 17.2672 13.8924 16.9371 13.1624C16.717 13.5824 16.4869 14.0124 16.2368 14.4324ZM13.4456 16.8424C12.9654 16.8624 12.4852 16.8724 11.995 16.8724C11.5048 16.8724 11.0546 16.8724 10.5944 16.8424C11.0646 17.4624 11.5548 18.0424 12.035 18.5724C12.5052 18.0524 12.9754 17.4724 13.4456 16.8324V16.8424ZM7.75323 14.4324C7.51313 14.0224 7.28303 13.6124 7.07295 13.1924C6.77282 13.9124 6.51271 14.6224 6.29262 15.3124C6.97291 15.4624 7.71321 15.5824 8.50354 15.6624C8.24343 15.2624 7.99333 14.8424 7.75323 14.4324ZM8.48353 8.3324C7.72322 8.4224 6.99291 8.5524 6.30263 8.7024C6.51271 9.3724 6.77282 10.0724 7.06294 10.7824C7.27303 10.3724 7.50313 9.9524 7.74323 9.5424C7.98333 9.1324 8.22343 8.7224 8.47353 8.3324H8.48353ZM10.5744 7.1224C11.0346 7.1024 11.5048 7.0924 11.985 7.0924C12.4652 7.0924 12.9454 7.1024 13.4156 7.1224C12.9454 6.5024 12.4752 5.9324 12.005 5.4224C11.5248 5.9424 11.0446 6.5124 10.5844 7.1224H10.5744ZM16.917 10.7924C17.2172 10.0824 17.4773 9.3824 17.6874 8.7224C16.9971 8.5624 16.2568 8.4324 15.4965 8.3424C15.7466 8.7324 15.9867 9.1324 16.2268 9.5424C16.4669 9.9624 16.697 10.3824 16.917 10.8024V10.7924ZM6.03251 7.7224C7.03293 7.4924 8.11338 7.3324 9.24385 7.2224C9.89412 6.2924 10.5844 5.4424 11.2847 4.7024C11.1647 4.5824 11.0446 4.4724 10.9246 4.3724C8.84369 2.5224 7.16298 2.1124 6.4727 2.5124C6.12255 2.7124 5.86244 3.2224 5.74239 3.9424C5.60233 4.7724 5.64235 5.8324 5.87245 6.9924C5.92247 7.2324 5.97249 7.4824 6.04252 7.7324L6.03251 7.7224ZM5.30221 15.0624C5.60233 14.0724 6.0025 13.0424 6.4827 11.9924C6.01251 10.9624 5.61234 9.9424 5.31221 8.9624C5.02209 9.0424 4.75198 9.1324 4.49187 9.2224C2.09087 10.0624 1.01042 11.2024 1.01042 11.9724C1.01042 12.7424 2.1709 14.0224 4.71196 14.8824C4.90204 14.9424 5.10213 15.0124 5.30221 15.0624ZM10.8545 19.7424C11.0046 19.6124 11.1546 19.4724 11.3147 19.3224C10.6144 18.5624 9.91413 17.7124 9.25386 16.7724C8.08337 16.6824 6.99291 16.5224 6.02251 16.3024C5.95248 16.5724 5.90246 16.8424 5.84243 17.0924C5.37224 19.5924 5.82243 21.0924 6.4827 21.4724C6.64277 21.5624 6.86286 21.6224 7.12297 21.6224C7.97332 21.6224 9.31388 21.0824 10.8545 19.7324V19.7424ZM18.0175 16.2524C17.0271 16.4824 15.9366 16.6524 14.7662 16.7524C14.1059 17.7124 13.4256 18.5724 12.7553 19.3024C12.9554 19.5024 13.1655 19.6824 13.3656 19.8524C15.2964 21.5124 16.827 21.8724 17.4873 21.4824C18.1776 21.0824 18.6778 19.4624 18.1576 16.8224C18.1175 16.6324 18.0675 16.4424 18.0275 16.2424L18.0175 16.2524ZM22.9696 11.9624C22.9696 11.5524 22.6594 11.0824 22.0992 10.6124C21.4489 10.0724 20.5185 9.5824 19.3881 9.1924C19.158 9.1124 18.9179 9.0424 18.6778 8.9624C18.3877 9.9124 17.9875 10.9324 17.5073 11.9624C18.0075 13.0224 18.4177 14.0424 18.7178 15.0024C18.8579 14.9624 18.9879 14.9124 19.128 14.8724C21.7691 14.0024 22.9696 12.7524 22.9696 11.9624Z\" fill=\"#00D8FF\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/logo-surveycreator-48x48.svg":
/*!****************************************************!*\
  !*** ./src/images-v1/logo-surveycreator-48x48.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M31.45 3.5H8.55C4.11 3.5 0.5 7.11 0.5 11.55V25.55C0.5 28.73 2.39 31.57 5.19 32.86C4.82 33.58 4.67 34.39 4.8 35.2C4.96 36.21 5.5 37.09 6.32 37.69C6.98 38.17 7.76 38.42 8.56 38.42C8.76 38.42 8.96 38.4 9.16 38.37C10.17 38.21 11.05 37.67 11.65 36.85L17.99 28.14C19.19 28.41 20.43 28.46 21.65 28.26C24.2 27.86 26.45 26.48 27.97 24.39C29.49 22.3 30.11 19.74 29.7 17.19C29.45 15.59 28.8 14.07 27.81 12.8C27.52 12.43 27.05 12.23 26.6 12.22C26.13 12.22 25.69 12.46 25.41 12.84L22.15 17.31C21.89 17.67 21.38 17.75 21.01 17.49C20.83 17.36 20.72 17.17 20.68 16.96C20.65 16.75 20.7 16.53 20.83 16.35L24.09 11.87C24.37 11.49 24.45 11 24.31 10.54C24.17 10.09 23.83 9.73 23.38 9.57C21.86 9.03 20.22 8.87 18.62 9.13C16.07 9.53 13.82 10.91 12.3 13C10.78 15.09 10.16 17.65 10.57 20.2C10.76 21.42 11.19 22.59 11.81 23.64L6.95 30.32C4.92 29.65 3.49 27.73 3.49 25.55V11.55C3.49 8.77 5.75 6.5 8.54 6.5H31.45C34.23 6.5 36.5 8.76 36.5 11.55V25.55C36.5 28.33 34.24 30.59 31.45 30.59H27.5V34L22.95 30.59H18.25C17.42 30.59 16.75 31.26 16.75 32.09C16.75 32.92 17.42 33.59 18.25 33.59H21.95L30.5 40V33.59H31.45C35.89 33.59 39.5 29.98 39.5 25.55V11.55C39.5 7.11 35.89 3.5 31.45 3.5ZM14.87 24.56C15.26 24.02 15.25 23.29 14.85 22.76C14.17 21.88 13.72 20.83 13.55 19.73C13.27 17.97 13.7 16.2 14.75 14.76C15.8 13.32 17.35 12.37 19.11 12.09C19.46 12.04 19.8 12.01 20.15 12.01C20.2 12.01 20.24 12.01 20.29 12.01L18.42 14.58C17.82 15.4 17.58 16.41 17.74 17.42C17.9 18.43 18.44 19.31 19.26 19.91C20.08 20.51 21.09 20.75 22.1 20.59C23.11 20.43 23.99 19.89 24.59 19.07L26.46 16.5C26.59 16.87 26.68 17.26 26.75 17.65C27.03 19.41 26.6 21.18 25.55 22.62C24.5 24.06 22.95 25.01 21.19 25.29C20.09 25.46 18.95 25.36 17.91 24.98C17.28 24.76 16.58 24.98 16.19 25.51L9.23 35.07C9.1 35.25 8.91 35.36 8.7 35.4C8.48 35.43 8.27 35.38 8.09 35.25C7.91 35.12 7.8 34.93 7.76 34.72C7.73 34.51 7.78 34.29 7.91 34.11L14.87 24.55V24.56Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/logo-vue-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v1/logo-vue-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_17790_388140)\"><path d=\"M19.2 2H24L12 22.7L0 2H9.18L12 6.8L14.76 2H19.2Z\" fill=\"#41B883\"></path><path d=\"M4.74023 2L12.0002 14.48L19.2002 2H14.7602L12.0002 6.8L9.18023 2H4.74023Z\" fill=\"#35495E\"></path></g><defs><clipPath id=\"clip0_17790_388140\"><rect width=\"24\" height=\"20.7\" fill=\"white\" transform=\"translate(0 2)\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/maximize-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v1/maximize-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.71 10.71L4.42 13H6.01C6.56 13 7.01 13.45 7.01 14C7.01 14.55 6.56 15 6.01 15H2C1.45 15 1 14.55 1 14V10C1 9.45 1.45 9 2 9C2.55 9 3 9.45 3 10V11.59L5.29 9.3C5.68 8.91 6.31 8.91 6.7 9.3C7.09 9.69 7.09 10.32 6.7 10.71H6.71ZM14 1H10C9.45 1 9 1.45 9 2C9 2.55 9.45 3 10 3H11.59L9.3 5.29C8.91 5.68 8.91 6.31 9.3 6.7C9.5 6.9 9.75 6.99 10.01 6.99C10.27 6.99 10.52 6.89 10.72 6.7L13.01 4.41V6C13.01 6.55 13.46 7 14.01 7C14.56 7 15.01 6.55 15.01 6V2C15.01 1.45 14.56 1 14.01 1H14Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/minimize-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v1/minimize-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 9H3C2.45 9 2 8.55 2 8C2 7.45 2.45 7 3 7H13C13.55 7 14 7.45 14 8C14 8.55 13.55 9 13 9Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/minus-32x32.svg":
/*!***************************************!*\
  !*** ./src/images-v1/minus-32x32.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30 16H3V17H30V16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/minusbox-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v1/minusbox-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_2362_25245)\"><path d=\"M12 9H4V7H12V9ZM16 0V16H0V0H16ZM14 2H2V14H14V2Z\"></path></g><defs><clipPath id=\"clip0_2362_25245\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/more-16x16.svg":
/*!**************************************!*\
  !*** ./src/images-v1/more-16x16.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 8C10 9.1 9.1 10 8 10C6.9 10 6 9.1 6 8C6 6.9 6.9 6 8 6C9.1 6 10 6.9 10 8ZM14 6C12.9 6 12 6.9 12 8C12 9.1 12.9 10 14 10C15.1 10 16 9.1 16 8C16 6.9 15.1 6 14 6ZM2 6C0.9 6 0 6.9 0 8C0 9.1 0.9 10 2 10C3.1 10 4 9.1 4 8C4 6.9 3.1 6 2 6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/more-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/more-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 12C6 13.1 5.1 14 4 14C2.9 14 2 13.1 2 12C2 10.9 2.9 10 4 10C5.1 10 6 10.9 6 12ZM12 10C10.9 10 10 10.9 10 12C10 13.1 10.9 14 12 14C13.1 14 14 13.1 14 12C14 10.9 13.1 10 12 10ZM20 10C18.9 10 18 10.9 18 12C18 13.1 18.9 14 20 14C21.1 14 22 13.1 22 12C22 10.9 21.1 10 20 10Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/navmenu-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/navmenu-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 7H2V5H16V7ZM2 11V13H22V11H2ZM2 19H10V17H2V19Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/noimage-48x48.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/noimage-48x48.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 17.01C14 16.4167 14.1759 15.8366 14.5056 15.3433C14.8352 14.8499 15.3038 14.4654 15.8519 14.2384C16.4001 14.0113 17.0033 13.9519 17.5853 14.0676C18.1672 14.1834 18.7018 14.4691 19.1213 14.8887C19.5409 15.3082 19.8266 15.8428 19.9424 16.4247C20.0581 17.0067 19.9987 17.6099 19.7716 18.1581C19.5446 18.7062 19.1601 19.1748 18.6667 19.5044C18.1734 19.8341 17.5933 20.01 17 20.01C16.2044 20.01 15.4413 19.6939 14.8787 19.1313C14.3161 18.5687 14 17.8056 14 17.01ZM27.09 24.14L20 36.01H36L27.09 24.14ZM36.72 8.14L35.57 10.01H36C36.5304 10.01 37.0391 10.2207 37.4142 10.5958C37.7893 10.9709 38 11.4796 38 12.01V36.01C38 36.5404 37.7893 37.0491 37.4142 37.4242C37.0391 37.7993 36.5304 38.01 36 38.01H18.77L17.57 40.01H36C37.0609 40.01 38.0783 39.5886 38.8284 38.8384C39.5786 38.0883 40 37.0709 40 36.01V12.01C39.9966 11.0765 39.6668 10.1737 39.0678 9.45778C38.4688 8.74188 37.6382 8.25802 36.72 8.09V8.14ZM36.86 4.5L12.86 44.5L11.14 43.5L13.23 40.01H12C10.9391 40.01 9.92172 39.5886 9.17157 38.8384C8.42143 38.0883 8 37.0709 8 36.01V12.01C8 10.9491 8.42143 9.93172 9.17157 9.18157C9.92172 8.43143 10.9391 8.01 12 8.01H32.43L35.14 3.5L36.86 4.5ZM14.43 38.01L15.63 36.01H12L19 27.01L20.56 27.8L31.23 10.01H12C11.4696 10.01 10.9609 10.2207 10.5858 10.5958C10.2107 10.9709 10 11.4796 10 12.01V36.01C10 36.5404 10.2107 37.0491 10.5858 37.4242C10.9609 37.7993 11.4696 38.01 12 38.01H14.43Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-appearance-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/pg-appearance-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 8H19V1H5V8H4V13H5V13.14C5 14.72 6.28 16 7.86 16C8.2 16 8.41 16.19 8.51 16.3C8.61 16.41 8.76 16.65 8.71 16.98L8.44 18.89C8.29 19.92 8.6 20.97 9.28 21.76C9.96 22.55 10.96 23 12 23C13.04 23 14.04 22.55 14.72 21.76C15.4 20.97 15.71 19.93 15.57 18.89L15.3 16.98C15.25 16.64 15.41 16.41 15.5 16.3C15.59 16.19 15.81 16 16.15 16C17.73 16 19.01 14.72 19.01 13.14V13H20.01V8H20ZM18 11H6V10H18V11ZM7 3H11V5H13V3H14V6H16V3H17V8H7V3ZM17 13.14C17 13.61 16.62 14 16.14 14C15.31 14 14.52 14.36 13.98 14.98C13.44 15.61 13.19 16.44 13.31 17.26L13.58 19.17C13.65 19.64 13.51 20.09 13.2 20.45C12.59 21.15 11.39 21.15 10.78 20.45C10.47 20.09 10.34 19.64 10.4 19.17L10.67 17.26C10.79 16.44 10.54 15.61 10 14.98C9.46 14.35 8.67 13.99 7.84 13.99C7.37 13.99 6.98 13.61 6.98 13.13V12.99H16.98V13.13L17 13.14ZM11 19C11 18.45 11.45 18 12 18C12.55 18 13 18.45 13 19C13 19.55 12.55 20 12 20C11.45 20 11 19.55 11 19Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-background-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/pg-background-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 9.41L4.59 8L8 4.59L9.41 6L6 9.41ZM14.41 6L13 4.59L4.59 13L6 14.41L14.41 6ZM4.59 18L6 19.41L19.41 6L18 4.59L4.59 18ZM9.59 18L11 19.41L19.41 11L18 9.59L9.59 18ZM14.59 18L16 19.41L19.41 16L18 14.59L14.59 18ZM22 4V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4ZM20 20V4H4V20H20Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-columns-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v1/pg-columns-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22 3V21H20V3H22ZM14 21H16V3H14V21ZM8 21H10V3H8V21ZM2 21H4V3H2V21Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-conditions-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/pg-conditions-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 14.59L16.59 16L18.59 18H7.82C7.79 17.9 7.75 17.81 7.7 17.71L17.71 7.7C18.1 7.89 18.53 8 19 8C20.65 8 22 6.65 22 5C22 3.35 20.65 2 19 2C17.7 2 16.6 2.84 16.18 4H7.82C7.41 2.84 6.31 2 5 2C3.35 2 2 3.35 2 5C2 6.65 3.35 8 5 8C6.3 8 7.4 7.16 7.82 6H16.19C16.22 6.1 16.26 6.19 16.31 6.29L6.29 16.3C5.9 16.11 5.47 16 5 16C3.35 16 2 17.35 2 19C2 20.65 3.35 22 5 22C6.3 22 7.4 21.16 7.82 20H18.59L16.59 22L18 23.41L22.41 19L18 14.59ZM19 4C19.55 4 20 4.45 20 5C20 5.55 19.55 6 19 6C18.45 6 18 5.55 18 5C18 4.45 18.45 4 19 4ZM5 6C4.45 6 4 5.55 4 5C4 4.45 4.45 4 5 4C5.55 4 6 4.45 6 5C6 5.55 5.55 6 5 6ZM5 20C4.45 20 4 19.55 4 19C4 18.45 4.45 18 5 18C5.55 18 6 18.45 6 19C6 19.55 5.55 20 5 20Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-data-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/pg-data-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2C8.02 2 4 3.37 4 6V18C4 20.63 8.02 22 12 22C15.98 22 20 20.63 20 18V6C20 3.37 15.98 2 12 2ZM12 4C15.72 4 18 5.29 18 6C18 6.71 15.72 8 12 8C8.28 8 6 6.71 6 6C6 5.29 8.28 4 12 4ZM12 20C8.28 20 6 18.71 6 18V16.73C7.54 17.57 9.78 18 12 18C14.22 18 16.46 17.57 18 16.73V18C18 18.71 15.72 20 12 20ZM18 14C18 14.71 15.72 16 12 16C8.28 16 6 14.71 6 14V12.73C7.54 13.57 9.78 14 12 14C14.22 14 16.46 13.57 18 12.73V14ZM18 10C18 10.71 15.72 12 12 12C8.28 12 6 10.71 6 10V8.73C7.54 9.57 9.78 10 12 10C14.22 10 16.46 9.57 18 8.73V10Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-design-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/pg-design-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.59 22H22V2.59L2.59 22ZM20 20H7.41L20 7.41V20ZM13 18L18 13V18H13ZM10 8C11.1 8 12 8.9 12 10C12 11.1 11.1 12 10 12C8.9 12 8 11.1 8 10C8 8.9 8.9 8 10 8ZM2 9.83C2 8.89 2.61 8.09 3.45 7.8C3.56 7.44 3.71 7.09 3.89 6.75C3.75 6.46 3.67 6.13 3.67 5.8C3.67 5.23 3.89 4.69 4.3 4.29C4.94 3.65 5.97 3.5 6.76 3.89C7.1 3.71 7.45 3.57 7.81 3.45C8.1 2.61 8.9 2 9.84 2C10.78 2 11.58 2.61 11.87 3.45C12.23 3.56 12.58 3.71 12.92 3.89C13.71 3.5 14.74 3.65 15.38 4.3C15.78 4.7 16.01 5.24 16.01 5.81C16.01 6.38 15.79 6.92 15.38 7.32L14.67 8.03L13.26 6.61L13.97 5.9C13.97 5.9 14.01 5.83 14.01 5.8C14.01 5.77 14.01 5.74 13.97 5.7C13.9 5.63 13.84 5.63 13.77 5.7L13.1 6.36L12.42 5.91C11.91 5.57 11.36 5.34 10.78 5.22L9.98 5.06V4.13C9.98 3.98 9.7 3.98 9.7 4.13V5.06L8.9 5.22C8.32 5.34 7.76 5.57 7.26 5.91L6.58 6.36L5.92 5.7C5.84 5.63 5.79 5.63 5.72 5.7C5.68 5.74 5.68 5.77 5.68 5.8C5.68 5.83 5.68 5.86 5.72 5.9L6.38 6.57L5.93 7.25C5.59 7.76 5.36 8.31 5.24 8.89L5.08 9.69H4.15C4.07 9.69 4.01 9.75 4.01 9.83C4.01 9.91 4.07 9.97 4.15 9.97H5.08L5.24 10.77C5.36 11.35 5.59 11.91 5.93 12.41L6.38 13.09L5.72 13.75C5.72 13.75 5.68 13.83 5.68 13.85C5.68 13.87 5.68 13.91 5.72 13.95C5.79 14.02 5.85 14.02 5.92 13.95L6.63 13.24L8.05 14.65L7.34 15.36C6.94 15.77 6.4 15.99 5.83 15.99C5.26 15.99 4.72 15.77 4.32 15.36C3.92 14.96 3.69 14.42 3.69 13.85C3.69 13.51 3.77 13.19 3.91 12.9C3.73 12.56 3.59 12.21 3.47 11.85C2.63 11.56 2.02 10.76 2.02 9.82L2 9.83Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-general-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v1/pg-general-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM4 20V4H20V20H4ZM6 7H9V9H6V7ZM12 7H18V9H12V7ZM6 11H9V13H6V11ZM12 11H18V13H12V11ZM6 15H9V17H6V15ZM12 15H18V17H12V15Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-header-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/pg-header-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21 2H3C1.9 2 1 2.9 1 4V15C1 16.1 1.9 17 3 17H21C22.1 17 23 16.1 23 15V4C23 2.9 22.1 2 21 2ZM4.41 15L9 10.41L12 13.41L14 11.41L17.59 15H4.41ZM20.41 15L14 8.59L12 10.59L9 7.59L3 13.59V4H21V15H20.41ZM19 7.5C19 8.33 18.33 9 17.5 9C16.67 9 16 8.33 16 7.5C16 6.67 16.67 6 17.5 6C18.33 6 19 6.67 19 7.5ZM8 21H16V23H8V21ZM6 18H18V20H6V18Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-language-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v1/pg-language-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.75 8H15.25L13.35 13.08C12.2029 12.2588 11.2439 11.2027 10.537 9.98187C9.83 8.76107 9.39127 7.40364 9.25 6H14V4H9V2H7V4H2V6H6.91C6.73189 7.75797 6.09115 9.43736 5.05302 10.8672C4.01489 12.2971 2.61643 13.4263 1 14.14C1.32315 14.7296 1.69441 15.2915 2.11 15.82C4.82764 14.5445 6.96846 12.2966 8.11 9.52C9.02641 11.7596 10.5985 13.6698 12.62 15L10 22H12.42L13.79 18.13H19.16L20.56 22H23L17.75 8ZM14.46 16.16L15.73 12.53C16.0406 11.7049 16.2945 10.8596 16.49 10C16.55 10.26 16.67 10.66 16.84 11.21C17.01 11.76 17.14 12.15 17.24 12.41L18.55 16.2L14.46 16.16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-layout-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/pg-layout-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 2H4C2.9 2 2 2.9 2 4V9C2 10.1 2.9 11 4 11H20C21.1 11 22 10.1 22 9V4C22 2.9 21.1 2 20 2ZM4 9V4H20V9H4ZM11 12H4C2.9 12 2 12.9 2 14V20C2 21.1 2.9 22 4 22H11C12.1 22 13 21.1 13 20V14C13 12.9 12.1 12 11 12ZM4 20V14H11V20H4ZM20 12H16C14.9 12 14 12.9 14 14V20C14 21.1 14.9 22 16 22H20C21.1 22 22 21.1 22 20V14C22 12.9 21.1 12 20 12ZM16 20V14H20V20H16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-logo-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/pg-logo-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM20 4V17.59L15 12.59L13 14.59L10 11.59L4 17.59V4H20ZM19.59 20H4.41L10 14.41L13 17.41L15 15.41L19.59 20ZM14 8C14 6.9 14.9 6 16 6C17.1 6 18 6.9 18 8C18 9.1 17.1 10 16 10C14.9 10 14 9.1 14 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-navigation-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/pg-navigation-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 12L10 8V16L5 12ZM14 8V16L19 12L14 8ZM23 12C23 18.07 18.07 23 12 23C5.93 23 1 18.07 1 12C1 5.93 5.93 1 12 1C18.07 1 23 5.93 23 12ZM21 12C21 7.04 16.96 3 12 3C7.04 3 3 7.04 3 12C3 16.96 7.04 21 12 21C16.96 21 21 16.96 21 12Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-pages-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v1/pg-pages-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 1H5C3.9 1 3 1.9 3 3V21C3 22.1 3.9 23 5 23H19C20.1 23 21 22.1 21 21V3C21 1.9 20.1 1 19 1ZM5 21V3H19V21H5ZM11 7H7V5H11V7ZM7 8H17V10H7V8ZM7 11H17V13H7V11ZM7 14H17V16H7V14ZM12 17H17V19H12V17Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-questiondesign-24x24.svg":
/*!***************************************************!*\
  !*** ./src/images-v1/pg-questiondesign-24x24.svg ***!
  \***************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.01 14.98H22.01V17.98C22.01 19.08 21.11 19.98 20.01 19.98H12.42L8.71 23.69C8.52 23.88 8.26 23.98 8 23.98C7.87 23.98 7.74 23.96 7.62 23.9C7.25 23.75 7 23.38 7 22.98V19.98H4C2.9 19.98 2 19.08 2 17.98V3.98C2 2.88 2.9 1.98 4 1.98H8V3.98H4.01V17.98H8.01C8.56 17.98 9.01 18.43 9.01 18.98V20.57L11.3 18.28C11.49 18.09 11.74 17.99 12.01 17.99H20.01V14.99V14.98ZM23.01 7.48C23.01 8.39 22.43 9.16 21.62 9.44C21.51 9.77 21.38 10.09 21.22 10.4C21.59 11.17 21.46 12.13 20.82 12.78C20.43 13.17 19.9 13.39 19.35 13.39C19.03 13.39 18.73 13.32 18.45 13.18C18.14 13.34 17.82 13.47 17.49 13.58C17.2 14.39 16.43 14.97 15.53 14.97C14.63 14.97 13.85 14.39 13.57 13.58C13.24 13.47 12.92 13.34 12.61 13.18C11.85 13.55 10.85 13.39 10.23 12.77C9.84 12.38 9.62 11.85 9.62 11.3C9.62 10.98 9.69 10.67 9.83 10.4C9.67 10.09 9.54 9.77 9.43 9.44C8.62 9.15 8.04 8.38 8.04 7.48C8.04 6.58 8.62 5.8 9.43 5.52C9.54 5.19 9.67 4.87 9.83 4.56C9.7 4.28 9.62 3.97 9.62 3.66C9.62 3.1 9.84 2.58 10.23 2.19C10.87 1.55 11.83 1.41 12.61 1.79C12.92 1.63 13.24 1.5 13.57 1.39C13.86 0.58 14.63 0 15.53 0C16.43 0 17.21 0.58 17.49 1.39C17.82 1.5 18.14 1.63 18.45 1.79C19.22 1.42 20.18 1.55 20.83 2.19C21.47 2.83 21.61 3.79 21.24 4.57C21.4 4.88 21.53 5.2 21.64 5.53C22.45 5.82 23.03 6.59 23.03 7.49L23.01 7.48ZM21.01 7.48C21.01 7.48 20.97 7.4 20.93 7.4H20L19.84 6.6C19.73 6.05 19.51 5.53 19.19 5.05L18.74 4.37L19.4 3.71C19.4 3.71 19.43 3.62 19.4 3.59C19.37 3.56 19.32 3.56 19.28 3.59L18.62 4.25L17.94 3.8C17.46 3.48 16.94 3.27 16.39 3.15L15.59 2.99V2.06C15.59 1.97 15.42 1.97 15.42 2.06V2.99L14.62 3.15C14.07 3.26 13.55 3.48 13.07 3.8L12.39 4.25L11.73 3.59C11.73 3.59 11.65 3.56 11.61 3.59V3.71L12.26 4.37L11.81 5.05C11.49 5.53 11.28 6.05 11.16 6.6L11 7.4H10.07C10.07 7.4 9.99 7.44 9.99 7.48C9.99 7.52 10.03 7.56 10.07 7.56H11L11.16 8.36C11.27 8.91 11.49 9.43 11.81 9.91L12.26 10.59L11.61 11.25V11.37H11.73L12.39 10.72L13.07 11.17C13.55 11.49 14.07 11.71 14.62 11.82L15.42 11.98V12.91C15.42 13 15.59 13 15.59 12.91V11.98L16.39 11.82C16.94 11.71 17.46 11.49 17.94 11.17L18.62 10.72L19.28 11.38H19.4C19.4 11.38 19.43 11.3 19.4 11.26L18.74 10.6L19.19 9.92C19.51 9.44 19.72 8.92 19.84 8.37L20 7.57H20.93C20.93 7.57 21.01 7.53 21.01 7.49V7.48ZM15.51 4.98C14.13 4.98 13.01 6.1 13.01 7.48C13.01 8.86 14.13 9.98 15.51 9.98C16.89 9.98 18.01 8.86 18.01 7.48C18.01 6.1 16.89 4.98 15.51 4.98Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-quiz-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/pg-quiz-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.26 7.15L20.41 6L19 4.59L17.75 5.84C16.12 4.69 14.14 4.01 12 4.01C9.86 4.01 7.88 4.69 6.25 5.84L5 4.59L3.59 6L4.74 7.15C3.05 8.94 2 11.35 2 14C2 19.51 6.49 24 12 24C17.51 24 22 19.51 22 14C22 11.35 20.96 8.94 19.26 7.15ZM12 22C7.59 22 4 18.41 4 14C4 9.59 7.59 6 12 6C16.41 6 20 9.59 20 14C20 18.41 16.41 22 12 22ZM15 8.58L16.41 9.99L12 14.4L10.59 12.99L15 8.58ZM9.2 3.36L8.83 1.4L9.81 1.21C11.29 0.93 12.7 0.93 14.18 1.21L15.16 1.4L14.79 3.36L13.81 3.17C12.57 2.94 11.42 2.94 10.18 3.17L9.2 3.36Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-rows-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/pg-rows-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21 2V4H3V2H21ZM3 10H21V8H3V10ZM3 16H21V14H3V16ZM3 22H21V20H3V22Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-specific-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v1/pg-specific-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_22397_60021)\"><path d=\"M20 10.005H22V18.005C22 19.105 21.1 20.005 20 20.005H12.41L8.69999 23.715C8.50999 23.905 8.24999 24.005 7.98999 24.005C7.85999 24.005 7.72999 23.985 7.60999 23.925C7.23999 23.775 6.98999 23.405 6.98999 23.005V20.005H4.98999C3.33999 20.005 1.98999 18.655 1.98999 17.005V5.005C1.99999 3.355 3.34999 2.005 4.99999 2.005H14V4.005H4.99999C4.44999 4.005 3.99999 4.455 3.99999 5.005V17.005C3.99999 17.555 4.44999 18.005 4.99999 18.005H7.99999C8.54999 18.005 8.99999 18.455 8.99999 19.005V20.595L11.29 18.305C11.48 18.115 11.73 18.015 12 18.015H20V10.015V10.005ZM10.1 9.49501L16.79 2.795C18.01 1.575 19.99 1.575 21.2 2.795C22.41 4.015 22.42 5.99501 21.2 7.20501L14.5 13.905L8.60999 15.375L10.08 9.485L10.1 9.49501ZM18.21 4.215L17.42 5.005L19.01 6.59501L19.8 5.80501C20.01 5.59501 20.13 5.31501 20.13 5.01501C20.13 4.71501 20.01 4.435 19.8 4.225C19.38 3.805 18.64 3.805 18.21 4.225V4.215ZM11.37 12.635L13.48 12.105L17.58 8.005L15.99 6.41501L11.89 10.515L11.36 12.625L11.37 12.635Z\"></path></g><defs><clipPath id=\"clip0_22397_60021\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/pg-thankyyoupage-24x24.svg":
/*!**************************************************!*\
  !*** ./src/images-v1/pg-thankyyoupage-24x24.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.0001 13.59L19.4101 18L18.0001 19.41L13.5901 15L15.0001 13.59ZM15.0001 10.42L13.4101 12.01L12.0001 13.42L6.00009 19.42L4.59009 18.01L10.5901 12.01L9.00009 10.42L5.00009 14.42L0.590088 10L4.59009 6L3.59009 5L5.00009 3.59L6.00009 4.59L10.4101 9L12.0001 10.59L13.5901 9L18.0001 4.59L19.0001 3.59L20.4101 5L19.4101 6L23.4101 10L19.0001 14.41L15.0001 10.41V10.42ZM7.59009 9L6.00009 7.41L3.41009 10L5.00009 11.59L7.59009 9ZM16.4201 9L19.0101 11.59L20.6001 10L18.0101 7.41L16.4201 9Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-themes-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/pg-themes-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM4 20V4H20V20H4ZM11 5H5V11H11V5ZM9 9H7V7H9V9ZM12 12H19V5H12V12ZM14 7H17V10H14V7ZM13 19H19V13H13V19ZM15 15H17V17H15V15ZM5 19H12V12H5V19ZM7 14H10V17H7V14Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-totals-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/pg-totals-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.0001 5H7.42009L14.4201 12L7.42009 19H20.0101V21H2.59009L11.5901 12L2.59009 3H20.0001V5Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-undefined-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/pg-undefined-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3.34 5.325C3.57 5.785 3.41 6.335 2.99 6.615C2.93 7.115 2.51 7.505 2 7.505C1.45 7.505 1 7.055 1 6.505V6.005C1 5.625 1.21 5.275 1.55 5.115L2 4.895C2.49 4.645 3.09 4.845 3.34 5.345V5.325ZM2 15.415C2.55 15.415 3 14.965 3 14.415V13.535C3 12.985 2.55 12.535 2 12.535C1.45 12.535 1 12.985 1 13.535V14.415C1 14.965 1.45 15.415 2 15.415ZM2 11.455C2.55 11.455 3 11.005 3 10.455V9.575C3 9.025 2.55 8.575 2 8.575C1.45 8.575 1 9.025 1 9.575V10.455C1 11.005 1.45 11.455 2 11.455ZM2.99 17.385C2.93 16.885 2.51 16.495 2 16.495C1.45 16.495 1 16.945 1 17.495V17.995C1 18.375 1.21 18.725 1.55 18.885L2 19.105C2.14 19.175 2.3 19.215 2.45 19.215C2.82 19.215 3.17 19.015 3.35 18.665C3.58 18.205 3.42 17.655 3 17.375L2.99 17.385ZM9.45 20.605L8.72 20.245C8.23 19.995 7.63 20.195 7.38 20.695C7.13 21.185 7.33 21.785 7.83 22.035L8.56 22.395C8.7 22.465 8.86 22.505 9.01 22.505C9.38 22.505 9.73 22.305 9.91 21.955C10.16 21.465 9.96 20.865 9.46 20.615L9.45 20.605ZM6.17 18.965L5.44 18.605C4.95 18.355 4.35 18.555 4.1 19.055C3.85 19.545 4.05 20.145 4.55 20.395L5.28 20.755C5.42 20.825 5.58 20.865 5.73 20.865C6.1 20.865 6.45 20.665 6.63 20.315C6.88 19.825 6.68 19.225 6.18 18.975L6.17 18.965ZM12 21.875C11.51 21.625 10.91 21.825 10.66 22.325C10.41 22.815 10.61 23.415 11.11 23.665L11.56 23.885C11.7 23.955 11.85 23.995 12.01 23.995C12.17 23.995 12.32 23.955 12.46 23.885L12.91 23.665C13.4 23.415 13.6 22.815 13.36 22.325C13.11 21.835 12.51 21.635 12.02 21.875H12ZM18.56 18.595L17.83 18.955C17.34 19.205 17.14 19.805 17.38 20.295C17.56 20.645 17.91 20.845 18.28 20.845C18.43 20.845 18.58 20.815 18.73 20.735L19.46 20.375C19.95 20.125 20.15 19.525 19.91 19.035C19.66 18.545 19.06 18.345 18.57 18.585L18.56 18.595ZM15.28 20.235L14.55 20.595C14.06 20.845 13.86 21.445 14.1 21.935C14.28 22.285 14.63 22.485 15 22.485C15.15 22.485 15.3 22.455 15.45 22.375L16.18 22.015C16.67 21.765 16.87 21.165 16.63 20.675C16.38 20.185 15.78 19.985 15.29 20.225L15.28 20.235ZM22 16.495C21.49 16.495 21.06 16.885 21.01 17.385C20.59 17.655 20.43 18.215 20.66 18.675C20.84 19.025 21.19 19.225 21.56 19.225C21.71 19.225 21.86 19.195 22.01 19.115L22.46 18.895C22.8 18.725 23.01 18.375 23.01 18.005V17.505C23.01 16.955 22.56 16.505 22.01 16.505L22 16.495ZM22 12.535C21.45 12.535 21 12.985 21 13.535V14.415C21 14.965 21.45 15.415 22 15.415C22.55 15.415 23 14.965 23 14.415V13.535C23 12.985 22.55 12.535 22 12.535ZM22 8.575C21.45 8.575 21 9.025 21 9.575V10.455C21 11.005 21.45 11.455 22 11.455C22.55 11.455 23 11.005 23 10.455V9.575C23 9.025 22.55 8.575 22 8.575ZM22.45 5.105L22 4.885C21.51 4.635 20.91 4.835 20.66 5.335C20.43 5.795 20.59 6.345 21.01 6.625C21.07 7.125 21.49 7.515 22 7.515C22.55 7.515 23 7.065 23 6.515V6.015C23 5.635 22.79 5.285 22.45 5.125V5.105ZM14.55 3.385L15.28 3.745C15.42 3.815 15.58 3.855 15.73 3.855C16.1 3.855 16.45 3.655 16.63 3.305C16.88 2.815 16.68 2.215 16.18 1.965L15.45 1.605C14.96 1.355 14.36 1.555 14.11 2.055C13.86 2.555 14.06 3.145 14.56 3.395L14.55 3.385ZM17.83 5.025L18.56 5.385C18.7 5.455 18.86 5.495 19.01 5.495C19.38 5.495 19.73 5.295 19.91 4.945C20.16 4.455 19.96 3.855 19.46 3.605L18.73 3.245C18.24 2.995 17.64 3.195 17.39 3.695C17.14 4.185 17.34 4.785 17.84 5.035L17.83 5.025ZM12.89 0.325L12.44 0.105C12.16 -0.035 11.83 -0.035 11.55 0.105L11.1 0.325C10.61 0.575 10.41 1.175 10.65 1.665C10.9 2.155 11.5 2.355 11.99 2.115C12.13 2.185 12.29 2.225 12.44 2.225C12.81 2.225 13.16 2.025 13.34 1.675C13.59 1.185 13.39 0.585 12.89 0.335V0.325ZM8.28 3.855C8.43 3.855 8.58 3.825 8.73 3.745L9.46 3.385C9.95 3.135 10.15 2.535 9.91 2.045C9.66 1.555 9.06 1.355 8.57 1.595L7.84 1.955C7.35 2.205 7.15 2.805 7.39 3.295C7.57 3.645 7.92 3.845 8.29 3.845L8.28 3.855ZM5 5.495C5.15 5.495 5.3 5.465 5.45 5.385L6.18 5.025C6.67 4.775 6.87 4.175 6.63 3.685C6.38 3.195 5.78 2.995 5.29 3.235L4.56 3.595C4.07 3.845 3.87 4.445 4.11 4.935C4.29 5.285 4.64 5.485 5.01 5.485L5 5.495ZM6 6.655L5.56 6.415C5.07 6.155 4.47 6.335 4.21 6.825C3.95 7.315 4.13 7.915 4.62 8.175L5.06 8.415C5.21 8.495 5.37 8.535 5.53 8.535C5.89 8.535 6.23 8.345 6.41 8.005C6.67 7.515 6.49 6.915 6 6.655ZM7.7 9.835L8.45 10.235C8.6 10.315 8.76 10.355 8.92 10.355C9.28 10.355 9.62 10.165 9.8 9.825C10.06 9.335 9.88 8.735 9.39 8.475L8.64 8.075C8.15 7.815 7.55 7.995 7.29 8.485C7.03 8.975 7.21 9.575 7.7 9.835ZM13.32 10.285C13.06 9.805 12.48 9.625 12 9.855C11.52 9.615 10.93 9.805 10.68 10.285C10.44 10.745 10.6 11.295 11.02 11.585C11.07 12.095 11.48 12.495 12 12.495C12.52 12.495 12.93 12.095 12.98 11.585C13.41 11.305 13.57 10.745 13.32 10.285ZM15.37 8.065L14.61 8.465C14.12 8.725 13.94 9.335 14.2 9.815C14.38 10.155 14.73 10.345 15.08 10.345C15.24 10.345 15.4 10.305 15.55 10.225L16.31 9.825C16.8 9.565 16.98 8.955 16.72 8.475C16.46 7.985 15.85 7.805 15.37 8.065ZM18.46 6.415L18.02 6.655C17.53 6.915 17.35 7.525 17.61 8.005C17.79 8.345 18.14 8.535 18.49 8.535C18.65 8.535 18.81 8.495 18.96 8.415L19.4 8.175C19.89 7.915 20.07 7.305 19.81 6.825C19.55 6.335 18.94 6.155 18.46 6.415ZM12 17.495C11.45 17.495 11 17.945 11 18.495V18.995C11 19.545 11.45 19.995 12 19.995C12.55 19.995 13 19.545 13 18.995V18.495C13 17.945 12.55 17.495 12 17.495ZM13 14.555C13 14.005 12.55 13.555 12 13.555C11.45 13.555 11 14.005 11 14.555V15.435C11 15.985 11.45 16.435 12 16.435C12.55 16.435 13 15.985 13 15.435V14.555Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/pg-validation-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/pg-validation-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 1C5.93 1 1 5.93 1 12C1 18.07 5.93 23 12 23C18.07 23 23 18.07 23 12C23 5.93 18.07 1 12 1ZM12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21ZM17.41 8L13.41 12L17.41 16L16 17.41L12 13.41L8 17.41L6.59 16L10.59 12L6.59 8L8 6.59L12 10.59L16 6.59L17.41 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/phone-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v1/phone-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16 18H8V6H16V18ZM16 2H8C7.46957 2 6.96086 2.21071 6.58579 2.58579C6.21071 2.96086 6 3.46957 6 4V20C6 20.5304 6.21071 21.0391 6.58579 21.4142C6.96086 21.7893 7.46957 22 8 22H16C16.5304 22 17.0391 21.7893 17.4142 21.4142C17.7893 21.0391 18 20.5304 18 20V4C18 3.46957 17.7893 2.96086 17.4142 2.58579C17.0391 2.21071 16.5304 2 16 2Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/plus-32x32.svg":
/*!**************************************!*\
  !*** ./src/images-v1/plus-32x32.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30 16H17V3H16V16H3V17H16V30H17V17H30V16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/plusbox-16x16.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/plusbox-16x16.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_2362_25244)\"><path d=\"M7 9H4V7H7V4H9V7H12V9H9V12H7V9ZM16 0V16H0V0H16ZM14 2H2V14H14V2Z\"></path></g><defs><clipPath id=\"clip0_2362_25244\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/preview-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/preview-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 1C5.92 1 1 5.92 1 12C1 18.08 5.92 23 12 23C18.08 23 23 18.08 23 12C23 5.92 18.08 1 12 1ZM12 21C7.04 21 3 16.96 3 12C3 7.04 7.04 3 12 3C16.96 3 21 7.04 21 12C21 16.96 16.96 21 12 21ZM16.91 10.25L10.97 6.95C10.35 6.6 9.6 6.61 8.99 6.97C8.37 7.33 8 7.98 8 8.69V15.29C8 16.01 8.37 16.65 8.99 17.01C9.31 17.2 9.65 17.29 10 17.29C10.35 17.29 10.67 17.21 10.97 17.04L16.91 13.74C17.54 13.39 17.94 12.72 17.94 11.99C17.94 11.26 17.55 10.59 16.91 10.24V10.25ZM10 15.3V8.7L15.94 12L10 15.3Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/publish-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/publish-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.98 11.0038C21.99 10.8337 22 10.6737 22 10.5036C22 6.3616 18.64 3 14.5 3C11.66 3 9.14 4.58075 7.87 7.00191C4.78 7.07194 2.26 9.48309 2.02 12.5245C0.82 13.2149 0 14.5155 0 15.9962C0 18.2072 1.79 19.9981 4 19.9981H10V17.9971H4C2.9 17.9971 2 17.0967 2 15.9962C2 14.8957 2.9 13.9952 4 13.9952H4.14C4.06 13.6751 4 13.3449 4 12.9948C4 10.7837 5.79 8.99285 8 8.99285C8.41 8.99285 8.79 9.07289 9.16 9.18294C9.75 6.7818 11.91 4.99095 14.5 4.99095C17.54 4.99095 20 7.45212 20 10.4936C20 11.0538 19.92 11.5941 19.76 12.1043C21.05 12.4445 22 13.6051 22 14.9957C22 16.6565 20.66 17.9971 19 17.9971H14V13.405L17 16.4064L18.41 14.9957L13 9.58314L7.59 14.9957L9 16.4064L12 13.405V24H14V19.9981H19C21.76 19.9981 24 17.757 24 14.9957C24 13.3849 23.22 11.9142 21.98 10.9938V11.0038Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/questionlock-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/questionlock-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M9.59 17H11V19H10.41L6 23.41V19H4C2.9 19 2 18.1 2 17V4C2 2.9 2.9 2 4 2H20C21.1 2 22 2.9 22 4V7H20V4H4V17H8V18.59L9.59 17ZM23 13V19C23 20.65 21.65 22 20 22H16C14.35 22 13 20.65 13 19V13H14V12C14 9.79 15.79 8 18 8C20.21 8 22 9.79 22 12V13H23ZM16 13H20V12C20 10.9 19.1 10 18 10C16.9 10 16 10.9 16 12V13ZM21 15H15V19C15 19.55 15.45 20 16 20H20C20.55 20 21 19.55 21 19V15ZM19 16H17V18H19V16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/ranking-arrows.svg":
/*!******************************************!*\
  !*** ./src/images-v1/ranking-arrows.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 10 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 5L5 0L0 5H4V9H6V5H10Z\"></path><path d=\"M6 19V15H4V19H0L5 24L10 19H6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/rankingundefined-16x16.svg":
/*!**************************************************!*\
  !*** ./src/images-v1/rankingundefined-16x16.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 7H3V9H13V7Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/redo-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/redo-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 8H19.6L15.6 4L17 2.6L23.4 9L17 15.4L15.6 14L19.6 10H7C4.8 10 3 11.8 3 14C3 16.2 4.8 18 7 18H8V20H7C3.7 20 1 17.3 1 14C1 10.7 3.7 8 7 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/refresh-16x16.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/refresh-16x16.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 2V7H10L12 5C11.1 3.8 9.6 3 8 3C5.2 3 3 5.2 3 8H1C1 4.1 4.1 1 8 1C10.2 1 12.1 2 13.4 3.6L15 2ZM8 13C6.4 13 4.9 12.2 4 11L6 9H1V14L2.6 12.4C3.9 14 5.8 15 8 15C11.9 15 15 11.9 15 8H13C13 10.8 10.8 13 8 13Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/remove-16x16.svg":
/*!****************************************!*\
  !*** ./src/images-v1/remove-16x16.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_554_309818)\"><path d=\"M12 7V9H4V7H12ZM16 8C16 12.4 12.4 16 8 16C3.6 16 0 12.4 0 8C0 3.6 3.6 0 8 0C12.4 0 16 3.6 16 8ZM14 8C14 4.7 11.3 2 8 2C4.7 2 2 4.7 2 8C2 11.3 4.7 14 8 14C11.3 14 14 11.3 14 8Z\"></path></g><defs><clipPath id=\"clip0_554_309818\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/reorder-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/reorder-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17 5L12 0L7 5H11V9H13V5H17Z\"></path><path d=\"M13 19V15H11V19H7L12 24L17 19H13Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/required-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v1/required-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_19892_573966)\"><path d=\"M2.77 14.1393L6.09 9.0393L0 9.1893L0.06 6.5193L6.15 6.8893L2.96 1.6893L5.29 0.379303L8.02 5.8193L10.96 0.489303L13.23 1.8493L9.91 6.9493L16 6.7993L15.94 9.4693L9.85 9.0993L13.04 14.2993L10.71 15.6093L7.98 10.1693L5.04 15.4993L2.77 14.1393Z\"></path></g><defs><clipPath id=\"clip0_19892_573966\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/restore-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/restore-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.01 2.99297C11.8 2.99297 11.59 3.02297 11.37 3.04297L12.71 1.70297L11.3 0.292969L7.59 4.00297L11.3 7.71297L12.71 6.30297L11.46 5.05297C11.64 5.04297 11.82 5.01297 12 5.01297C15.86 5.01297 19 8.15297 19 12.013C19 15.873 15.86 19.013 12 19.013C8.14 19.013 5 15.873 5 12.013C5 11.463 4.55 11.013 4 11.013C3.45 11.013 3 11.463 3 12.013C3 16.973 7.04 21.013 12 21.013C16.96 21.013 21 16.973 21 12.013C21 7.05297 16.97 2.99297 12.01 2.99297Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/restoredown-16x16.svg":
/*!*********************************************!*\
  !*** ./src/images-v1/restoredown-16x16.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 6C15 6.55 14.55 7 14 7H10C9.45 7 9 6.55 9 6V2C9 1.45 9.45 1 10 1C10.55 1 11 1.45 11 2V3.59L13.29 1.29C13.49 1.09 13.74 1 14 1C14.26 1 14.51 1.1 14.71 1.29C15.1 1.68 15.1 2.31 14.71 2.7L12.42 4.99H14.01C14.56 4.99 15.01 5.44 15.01 5.99L15 6ZM6 9H2C1.45 9 0.999998 9.45 0.999998 10C0.999998 10.55 1.45 11 2 11H3.59L1.29 13.29C0.899998 13.68 0.899998 14.31 1.29 14.7C1.68 15.09 2.31 15.09 2.7 14.7L4.99 12.41V14C4.99 14.55 5.44 15 5.99 15C6.54 15 6.99 14.55 6.99 14V10C6.99 9.45 6.54 9 5.99 9H6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/rotate-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/rotate-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.41 5.99588L18 11.4059L16.59 9.99588L19.59 6.99588H17C13.5522 6.99588 10.2456 8.36551 7.80761 10.8035C5.36964 13.2415 4 16.5481 4 19.9959V21.9959H2V19.9959C2 16.0176 3.58035 12.2023 6.3934 9.38927C9.20644 6.57623 13.0218 4.99588 17 4.99588H19.59L16.59 1.99588L18 0.585876L23.41 5.99588Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/save-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/save-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 2H4L2 4V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H20C20.5304 22 21.0391 21.7893 21.4142 21.4142C21.7893 21.0391 22 20.5304 22 20V4C22 3.46957 21.7893 2.96086 21.4142 2.58579C21.0391 2.21071 20.5304 2 20 2ZM15 4V6H9V4H15ZM8 20V15H16V20H8ZM20 20H18V13H6V20H4V4.83L4.83 4H7V8H17V4H20V20Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/saveas-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/saveas-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M24 11H22V13H20V11H18V9H20V7H22V9H24V11ZM20 14H22V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V4L4 2H20C21.1 2 22 2.9 22 4V6H20V4H17V8H7V4H4.83L4 4.83V20H6V13H18V20H20V14ZM9 6H15V4H9V6ZM16 15H8V20H16V15Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/search-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/search-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 2C9.6 2 6 5.6 6 10C6 11.8 6.6 13.5 7.7 14.9L2.3 20.3C1.9 20.7 1.9 21.3 2.3 21.7C2.5 21.9 2.7 22 3 22C3.3 22 3.5 21.9 3.7 21.7L9.1 16.3C10.5 17.4 12.2 18 14 18C18.4 18 22 14.4 22 10C22 5.6 18.4 2 14 2ZM14 16C10.7 16 8 13.3 8 10C8 6.7 10.7 4 14 4C17.3 4 20 6.7 20 10C20 13.3 17.3 16 14 16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/selectpage-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v1/selectpage-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23 11H19.9C19.4 7.4 16.6 4.5 13 4.1V1H11V4.1C7.4 4.5 4.5 7.4 4.1 11H1V13H4.1C4.6 16.6 7.4 19.5 11 19.9V23H13V19.9C16.6 19.4 19.5 16.6 19.9 13H23V11ZM12 18C8.7 18 6 15.3 6 12C6 8.7 8.7 6 12 6C15.3 6 18 8.7 18 12C18 15.3 15.3 18 12 18Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/settings-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v1/settings-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.8 2C6.4 0.8 5.3 0 4 0C2.3 0 1 1.3 1 3C1 4.7 2.3 6 4 6C5.3 6 6.4 5.2 6.8 4H15V2H6.8ZM4 4C3.4 4 3 3.6 3 3C3 2.4 3.4 2 4 2C4.6 2 5 2.4 5 3C5 3.6 4.6 4 4 4ZM12 5C10.7 5 9.6 5.8 9.2 7H1V9H9.2C9.6 10.2 10.7 11 12 11C13.7 11 15 9.7 15 8C15 6.3 13.7 5 12 5ZM12 9C11.4 9 11 8.6 11 8C11 7.4 11.4 7 12 7C12.6 7 13 7.4 13 8C13 8.6 12.6 9 12 9ZM6 10C4.7 10 3.6 10.8 3.2 12H1V14H3.2C3.6 15.2 4.7 16 6 16C7.3 16 8.4 15.2 8.8 14H15V12H8.8C8.4 10.8 7.3 10 6 10ZM6 14C5.4 14 5 13.6 5 13C5 12.4 5.4 12 6 12C6.6 12 7 12.4 7 13C7 13.6 6.6 14 6 14Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/settings-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v1/settings-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.9 4C9.4 2.3 7.9 1 6 1C3.8 1 2 2.8 2 5C2 7.2 3.8 9 6 9C7.9 9 9.4 7.7 9.9 6H22V4H9.9ZM6 7C4.9 7 4 6.1 4 5C4 3.9 4.9 3 6 3C7.1 3 8 3.9 8 5C8 6.1 7.1 7 6 7ZM9 15C7.1 15 5.6 16.3 5.1 18H2V20H5.1C5.5 21.7 7.1 23 9 23C10.9 23 12.4 21.7 12.9 20H22V18H12.9C12.4 16.3 10.9 15 9 15ZM9 21C7.9 21 7 20.1 7 19C7 17.9 7.9 17 9 17C10.1 17 11 17.9 11 19C11 20.1 10.1 21 9 21ZM18 8C16.1 8 14.6 9.3 14.1 11H2V13H14.1C14.5 14.7 16.1 16 18 16C20.2 16 22 14.2 22 12C22 9.8 20.2 8 18 8ZM18 14C16.9 14 16 13.1 16 12C16 10.9 16.9 10 18 10C19.1 10 20 10.9 20 12C20 13.1 19.1 14 18 14Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/smile-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v1/smile-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_15858_138723)\"><path d=\"M23.9966 14.16C22.8663 20.95 17.1547 24 12.0033 24C6.85193 24 1.15039 20.96 0.0100771 14.16C-0.0799473 13.62 0.290153 13.1 0.830299 13.01C1.37045 12.91 1.89059 13.29 1.98061 13.83C2.92087 19.47 7.69216 21.99 11.9933 21.99C16.2945 21.99 21.0658 19.47 22.006 13.83C22.0961 13.29 22.6162 12.91 23.1564 13.01C23.6965 13.1 24.0666 13.62 23.9766 14.16H23.9966ZM7.00197 7C7.55212 7 8.00224 6.55 8.00224 6V2C8.00224 1.45 7.55212 1 7.00197 1C6.45182 1 6.0017 1.45 6.0017 2V6C6.0017 6.55 6.45182 7 7.00197 7ZM17.0047 7C17.5548 7 18.005 6.55 18.005 6V2C18.005 1.45 17.5548 1 17.0047 1C16.4545 1 16.0044 1.45 16.0044 2V6C16.0044 6.55 16.4545 7 17.0047 7Z\"></path></g><defs><clipPath id=\"clip0_15858_138723\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/smiley-rate0-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/smiley-rate0-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.4101 12L22.7101 2.71C23.1001 2.32 23.1001 1.69 22.7101 1.3C22.3201 0.909998 21.6901 0.909998 21.3001 1.3L12.0101 10.59L2.71006 1.29C2.32006 0.899998 1.68006 0.899998 1.29006 1.29C0.900059 1.68 0.900059 2.32 1.29006 2.71L10.5801 12L1.29006 21.29C0.900059 21.68 0.900059 22.31 1.29006 22.7C1.49006 22.9 1.74006 22.99 2.00006 22.99C2.26006 22.99 2.51006 22.89 2.71006 22.7L12.0001 13.41L21.2901 22.7C21.4901 22.9 21.7401 22.99 22.0001 22.99C22.2601 22.99 22.5101 22.89 22.7101 22.7C23.1001 22.31 23.1001 21.68 22.7101 21.29L13.4201 12H13.4101Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/smiley-rate1-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/smiley-rate1-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 4.9938C4 4.44362 4.45 3.99348 5 3.99348H6.59L5.3 2.70306C4.91 2.31293 4.91 1.68272 5.3 1.2926C5.69 0.902468 6.32 0.902468 6.71 1.2926L9.71 4.29357C9.8 4.3836 9.88 4.49364 9.93 4.62368C10.03 4.86376 10.03 5.14385 9.93 5.38393C9.88 5.50397 9.81 5.614 9.71 5.71404L6.71 8.71501C6.51 8.91508 6.26 9.00511 6 9.00511C5.74 9.00511 5.49 8.90508 5.29 8.71501C4.9 8.32489 4.9 7.69468 5.29 7.30456L6.58 6.01413H4.99C4.44 6.01413 3.99 5.56399 3.99 5.01381L4 4.9938ZM14.08 5.37393C14.13 5.49397 14.2 5.604 14.3 5.70403L17.3 8.70501C17.5 8.90508 17.75 8.99511 18.01 8.99511C18.27 8.99511 18.52 8.89507 18.72 8.70501C19.11 8.31488 19.11 7.68468 18.72 7.29455L17.43 6.00413H19.02C19.57 6.00413 20.02 5.55399 20.02 5.00381C20.02 4.45363 19.57 4.00348 19.02 4.00348H17.43L18.72 2.71306C19.11 2.32293 19.11 1.69273 18.72 1.3026C18.33 0.912471 17.7 0.912471 17.31 1.3026L14.31 4.30358C14.22 4.39361 14.14 4.50364 14.09 4.63368C13.99 4.87376 13.99 5.15385 14.09 5.39393L14.08 5.37393ZM22 14.9971V20.999C22 22.6496 20.65 24 19 24H5C3.35 24 2 22.6496 2 20.999V14.9971C2 13.3465 3.35 11.9961 5 11.9961H19C20.65 11.9961 22 13.3465 22 14.9971ZM19 13.9967H16V16.9977H20V14.9971C20 14.4469 19.55 13.9967 19 13.9967ZM14 16.9977V13.9967H10V16.9977H14ZM10 18.9984V21.9993H14V18.9984H10ZM4 14.9971V16.9977H8V13.9967H5C4.45 13.9967 4 14.4469 4 14.9971ZM5 21.9993H8V18.9984H4V20.999C4 21.5492 4.45 21.9993 5 21.9993ZM20 20.999V18.9984H16V21.9993H19C19.55 21.9993 20 21.5492 20 20.999Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/smiley-rate10-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/smiley-rate10-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.01 23C6.85721 23 1.15412 19.9621 0.0134987 13.1669C-0.0765501 12.6272 0.293651 12.1076 0.833944 12.0177C1.38424 11.9277 1.89452 12.2975 1.98457 12.8371C2.92508 18.4732 7.69767 20.9914 12 20.9914C16.3023 20.9914 21.0749 18.4732 22.0154 12.8371C22.1055 12.2975 22.6158 11.9277 23.1661 12.0177C23.7063 12.1076 24.0765 12.6272 23.9865 13.1669C22.8559 19.9521 17.1428 23 11.99 23H12.01ZM21.165 6.15177C22.3056 5.01257 22.3056 3.16386 21.165 2.02465L21.0049 1.85477C19.9143 0.765533 18.1633 0.725561 17.0227 1.71487C15.8821 0.715568 14.1312 0.765533 13.0406 1.85477L12.8705 2.01466C11.7299 3.15386 11.7299 5.00257 12.8705 6.14178L17.0227 10.2889L21.175 6.14178L21.165 6.15177ZM15.742 3.27378L17.0127 4.54289L18.2834 3.27378C18.6436 2.91403 19.2239 2.91403 19.5841 3.27378L19.7442 3.43367C20.1044 3.79342 20.1044 4.37301 19.7442 4.73276L17.0127 7.46086L14.2812 4.73276C13.921 4.37301 13.921 3.79342 14.2812 3.43367L14.4413 3.27378C14.6214 3.09391 14.8515 3.00397 15.0917 3.00397C15.3318 3.00397 15.5619 3.09391 15.742 3.27378ZM11.1595 6.15177C12.3002 5.01257 12.3002 3.16386 11.1595 2.02465L10.9995 1.85477C9.90886 0.765533 8.15792 0.725561 7.0173 1.71487C5.87668 0.715568 4.12573 0.765533 3.03514 1.85477L2.86505 2.01466C1.72443 3.15386 1.72443 5.00257 2.86505 6.14178L7.0173 10.2889L11.1695 6.14178L11.1595 6.15177ZM5.7366 3.27378L7.00729 4.54289L8.27798 3.27378C8.63818 2.91403 9.21849 2.91403 9.57869 3.27378L9.73877 3.43367C10.099 3.79342 10.099 4.37301 9.73877 4.73276L7.00729 7.46086L4.27581 4.73276C3.91562 4.37301 3.91562 3.79342 4.27581 3.43367L4.4359 3.27378C4.61599 3.09391 4.84612 3.00397 5.08625 3.00397C5.32638 3.00397 5.5565 3.09391 5.7366 3.27378Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/smiley-rate2-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/smiley-rate2-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_15894_140103)\"><path d=\"M4.88291 4.51001C4.47291 4.51001 4.08291 4.25001 3.94291 3.84001C3.76291 3.32001 4.03291 2.75001 4.55291 2.57001L8.32291 1.25001C8.84291 1.06001 9.41291 1.34001 9.59291 1.86001C9.77291 2.38001 9.50291 2.95001 8.98291 3.13001L5.20291 4.45001C5.09291 4.49001 4.98291 4.51001 4.87291 4.51001H4.88291ZM19.8129 3.89001C20.0229 3.38001 19.7729 2.79001 19.2629 2.59001L15.5529 1.07001C15.0429 0.860007 14.4529 1.11001 14.2529 1.62001C14.0429 2.13001 14.2929 2.72001 14.8029 2.92001L18.5029 4.43001C18.6229 4.48001 18.7529 4.50001 18.8829 4.50001C19.2729 4.50001 19.6529 4.27001 19.8129 3.88001V3.89001ZM3.50291 6.00001C2.64291 6.37001 1.79291 6.88001 1.00291 7.48001C0.79291 7.64001 0.64291 7.87001 0.59291 8.14001C0.48291 8.73001 0.87291 9.29001 1.45291 9.40001C2.04291 9.51001 2.60291 9.12001 2.71291 8.54001C2.87291 7.69001 3.12291 6.83001 3.50291 5.99001V6.00001ZM21.0429 8.55001C21.6029 10.48 24.2429 8.84001 22.7529 7.48001C21.9629 6.88001 21.1129 6.37001 20.2529 6.00001C20.6329 6.84001 20.8829 7.70001 21.0429 8.55001ZM21.5729 13.2C21.2529 14.2 22.5429 15.09 23.3629 14.39C23.8529 14 23.9229 13.29 23.5429 12.81C21.7429 10.67 22.1329 10.55 21.5829 13.2H21.5729ZM1.75291 11C1.22291 11.79 -0.14709 12.64 0.0129102 13.75C0.15291 14.36 0.75291 14.74 1.35291 14.6C2.98291 14.1 1.80291 12.22 1.75291 11ZM19.8829 17C19.8829 13.14 16.2929 10 11.8829 10C7.47291 10 3.88291 13.14 3.88291 17C3.88291 20.86 7.47291 24 11.8829 24C16.2929 24 19.8829 20.86 19.8829 17ZM17.8829 17C17.8829 19.76 15.1929 22 11.8829 22C8.57291 22 5.88291 19.76 5.88291 17C5.88291 14.24 8.57291 12 11.8829 12C15.1929 12 17.8829 14.24 17.8829 17Z\"></path></g><defs><clipPath id=\"clip0_15894_140103\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/smiley-rate3-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/smiley-rate3-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.01915 7C6.46961 7 6.01998 6.55 6.01998 6V2C6.01998 1.45 6.46961 1 7.01915 1C7.56869 1 8.01832 1.45 8.01832 2V6C8.01832 6.55 7.56869 7 7.01915 7ZM18.01 6V2C18.01 1.45 17.5604 1 17.0108 1C16.4613 1 16.0117 1.45 16.0117 2V6C16.0117 6.55 16.4613 7 17.0108 7C17.5604 7 18.01 6.55 18.01 6ZM16.4213 21.58L18.01 19.99L19.2989 21.28C19.6886 21.67 20.3181 21.67 20.7077 21.28C21.0974 20.89 21.0974 20.26 20.7077 19.87L19.4188 18.58C18.6395 17.8 17.3705 17.8 16.5912 18.58L15.0025 20.17L13.4138 18.58C12.6345 17.8 11.3655 17.8 10.5862 18.58L8.9975 20.17L7.40883 18.58C6.62948 17.8 5.36053 17.8 4.58118 18.58L3.29226 19.87C2.90258 20.26 2.90258 20.89 3.29226 21.28C3.68193 21.67 4.31141 21.67 4.70108 21.28L5.99001 19.99L7.57868 21.58C8.35803 22.36 9.62698 22.36 10.4063 21.58L11.995 19.99L13.5837 21.58C13.9734 21.97 14.4829 22.16 14.9925 22.16C15.5021 22.16 16.0117 21.97 16.4013 21.58H16.4213Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/smiley-rate4-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/smiley-rate4-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.06927 7C6.51927 7 6.06927 6.55 6.06927 6V2C6.06927 1.45 6.51927 1 7.06927 1C7.61927 1 8.06927 1.45 8.06927 2V6C8.06927 6.55 7.61927 7 7.06927 7ZM18.0693 6V2C18.0693 1.45 17.6193 1 17.0693 1C16.5193 1 16.0693 1.45 16.0693 2V6C16.0693 6.55 16.5193 7 17.0693 7C17.6193 7 18.0693 6.55 18.0693 6ZM22.5693 21.9C23.0693 21.66 23.2793 21.07 23.0393 20.57C21.1093 16.52 16.9093 14 12.0693 14C7.22927 14 3.02927 16.52 1.09927 20.57C0.859273 21.07 1.06927 21.67 1.56927 21.9C2.06927 22.14 2.65927 21.93 2.89927 21.43C4.49927 18.08 8.00927 16 12.0593 16C16.1093 16 19.6293 18.08 21.2193 21.43C21.3893 21.79 21.7493 22 22.1193 22C22.2593 22 22.4093 21.97 22.5493 21.9H22.5693Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/smiley-rate5-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/smiley-rate5-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.00572 7C6.45572 7 6.00572 6.55 6.00572 6V2C6.00572 1.45 6.45572 1 7.00572 1C7.55572 1 8.00572 1.45 8.00572 2V6C8.00572 6.55 7.55572 7 7.00572 7ZM18.0057 6V2C18.0057 1.45 17.5557 1 17.0057 1C16.4557 1 16.0057 1.45 16.0057 2V6C16.0057 6.55 16.4557 7 17.0057 7C17.5557 7 18.0057 6.55 18.0057 6ZM19.9457 21.33C20.1257 20.81 19.8557 20.24 19.3357 20.05C14.5457 18.35 9.45572 18.35 4.66572 20.05C4.14572 20.23 3.87572 20.81 4.05572 21.33C4.23572 21.85 4.80572 22.12 5.33572 21.94C9.69572 20.4 14.3057 20.4 18.6657 21.94C18.7757 21.98 18.8857 22 18.9957 22C19.4057 22 19.7957 21.74 19.9357 21.33H19.9457Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/smiley-rate6-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/smiley-rate6-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 7C6.45 7 6 6.55 6 6V2C6 1.45 6.45 1 7 1C7.55 1 8 1.45 8 2V6C8 6.55 7.55 7 7 7ZM18 6V2C18 1.45 17.55 1 17 1C16.45 1 16 1.45 16 2V6C16 6.55 16.45 7 17 7C17.55 7 18 6.55 18 6ZM21 21C21 20.45 20.55 20 20 20H4C3.45 20 3 20.45 3 21C3 21.55 3.45 22 4 22H20C20.55 22 21 21.55 21 21Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/smiley-rate7-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/smiley-rate7-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.0022 23.99C11.452 23.99 11.0018 23.5402 11.0018 22.9904C11.0018 22.4407 11.452 21.9909 12.0022 21.9909C16.3137 21.9909 21.0755 19.472 22.0158 13.8344C22.1058 13.2947 22.616 12.9248 23.1662 13.0148C23.7064 13.1047 24.0765 13.6245 23.9865 14.1643C22.8561 20.9513 17.144 24 11.9922 24L12.0022 23.99ZM8.00072 5.99783V1.99957C8.00072 1.4498 7.55056 1 7.00036 1C6.45016 1 6 1.4498 6 1.99957V5.99783C6 6.54759 6.45016 6.99739 7.00036 6.99739C7.55056 6.99739 8.00072 6.54759 8.00072 5.99783ZM18.0043 5.99783V1.99957C18.0043 1.4498 17.5542 1 17.004 1C16.4538 1 16.0036 1.4498 16.0036 1.99957V5.99783C16.0036 6.54759 16.4538 6.99739 17.004 6.99739C17.5542 6.99739 18.0043 6.54759 18.0043 5.99783Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/smiley-rate8-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/smiley-rate8-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.01 24C6.85721 24 1.15412 20.96 0.0134987 14.16C-0.0765501 13.62 0.293651 13.1 0.833944 13.01C1.38424 12.92 1.89452 13.29 1.98457 13.83C2.92508 19.47 7.69767 21.99 12 21.99C16.3023 21.99 21.0749 19.47 22.0154 13.83C22.1055 13.29 22.6158 12.92 23.1661 13.01C23.7063 13.1 24.0765 13.62 23.9865 14.16C22.8559 20.95 17.1428 24 11.99 24H12.01ZM8.00783 6V2C8.00783 1.45 7.55759 1 7.00729 1C6.45699 1 6.00675 1.45 6.00675 2V6C6.00675 6.55 6.45699 7 7.00729 7C7.55759 7 8.00783 6.55 8.00783 6ZM18.0133 6V2C18.0133 1.45 17.563 1 17.0127 1C16.4624 1 16.0122 1.45 16.0122 2V6C16.0122 6.55 16.4624 7 17.0127 7C17.563 7 18.0133 6.55 18.0133 6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/smiley-rate9-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/smiley-rate9-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.01 24C6.85767 24 1.15509 20.96 0.0145752 14.16C-0.0354475 13.87 0.0445888 13.57 0.234675 13.35C0.424761 13.13 0.704888 13 0.995019 13H23.005C23.2951 13 23.5752 13.13 23.7653 13.35C23.9554 13.57 24.0354 13.87 23.9854 14.16C22.8549 20.95 17.1423 24 11.99 24H12.01ZM2.25559 15C3.61621 19.82 8.0182 22 12.01 22C16.0018 22 20.4038 19.82 21.7644 15H2.25559ZM8.00819 6V2C8.00819 1.45 7.55799 1 7.00774 1C6.45749 1 6.00729 1.45 6.00729 2V6C6.00729 6.55 6.45749 7 7.00774 7C7.55799 7 8.00819 6.55 8.00819 6ZM18.0127 6V2C18.0127 1.45 17.5625 1 17.0123 1C16.462 1 16.0118 1.45 16.0118 2V6C16.0118 6.55 16.462 7 17.0123 7C17.5625 7 18.0127 6.55 18.0127 6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/speechbubble-16x16.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/speechbubble-16x16.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 11L13 6H3L8 11Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/switchoff-16x16.svg":
/*!*******************************************!*\
  !*** ./src/images-v1/switchoff-16x16.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 5C12.7 5 14 6.3 14 8C14 9.7 12.7 11 11 11H5C3.3 11 2 9.7 2 8C2 6.3 3.3 5 5 5H11ZM11 3H5C2.2 3 0 5.2 0 8C0 10.8 2.2 13 5 13H11C13.8 13 16 10.8 16 8C16 5.2 13.8 3 11 3ZM5 6C3.9 6 3 6.9 3 8C3 9.1 3.9 10 5 10C6.1 10 7 9.1 7 8C7 6.9 6.1 6 5 6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/switchon-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v1/switchon-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 5C12.7 5 14 6.3 14 8C14 9.7 12.7 11 11 11H5C3.3 11 2 9.7 2 8C2 6.3 3.3 5 5 5H11ZM11 3H5C2.2 3 0 5.2 0 8C0 10.8 2.2 13 5 13H11C13.8 13 16 10.8 16 8C16 5.2 13.8 3 11 3ZM11 6C9.9 6 9 6.9 9 8C9 9.1 9.9 10 11 10C12.1 10 13 9.1 13 8C13 6.9 12.1 6 11 6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/tablet-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/tablet-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 18H4V6H20V18ZM21 4H3C2.46957 4 1.96086 4.21071 1.58579 4.58579C1.21071 4.96086 1 5.46957 1 6V18C1 18.5304 1.21071 19.0391 1.58579 19.4142C1.96086 19.7893 2.46957 20 3 20H21C21.5304 20 22.0391 19.7893 22.4142 19.4142C22.7893 19.0391 23 18.5304 23 18V6C23 5.46957 22.7893 4.96086 22.4142 4.58579C22.0391 4.21071 21.5304 4 21 4Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/textedit-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v1/textedit-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 5H2V3H13V5ZM10 7H2V9H10V7ZM2 17H10V15H2V17ZM13 11H2V13H13V11ZM23.4 14.9L17 21.3C16 22.4 14.5 23 13 23H11.6C11.3 23 11 22.7 11 22.4V21C11 19.5 11.6 18.1 12.7 17L19.1 10.6C19.4 10.2 19.9 10 20.4 10C20.9 10 21.4 10.2 21.7 10.6L23.4 12.3C24.2 13 24.2 14.2 23.4 14.9ZM21.9 13.6L20.3 12L14 18.3C13.4 19.1 13 20 13 21C14 21 14.9 20.6 15.6 19.9L21.9 13.6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/theme-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v1/theme-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_9352_93115)\"><path d=\"M24 21.4201C23.9387 22.1566 23.5894 22.8394 23.0278 23.3202C22.4662 23.8011 21.7376 24.0413 21 23.9888C20.2624 24.0413 19.5338 23.8011 18.9722 23.3202C18.4106 22.8394 18.0613 22.1566 18 21.4201C18 18.8513 21 16.2826 21 14.9932C21 16.2826 24 18.8513 24 21.4201ZM22 12.9942L11 1.99951L8.71 4.2884L10.12 5.70771L11 4.82814L18.17 11.9946L5.64 15.8028L2.83 12.9942L7.71 8.11653L9.29 9.70576C9.38296 9.79944 9.49356 9.8738 9.61542 9.92455C9.73728 9.97529 9.86799 10.0014 10 10.0014C10.132 10.0014 10.2627 9.97529 10.3846 9.92455C10.5064 9.8738 10.617 9.79944 10.71 9.70576C10.8037 9.61284 10.8781 9.5023 10.9289 9.3805C10.9797 9.2587 11.0058 9.12805 11.0058 8.99611C11.0058 8.86416 10.9797 8.73352 10.9289 8.61172C10.8781 8.48992 10.8037 8.37937 10.71 8.28645L3.71 1.28986C3.5217 1.10165 3.2663 0.995911 3 0.995911C2.7337 0.995911 2.4783 1.10165 2.29 1.28986C2.1017 1.47807 1.99591 1.73334 1.99591 1.99951C1.99591 2.26569 2.1017 2.52096 2.29 2.70917L6.29 6.70722L0 12.9942L10 22.9893L18 14.9932L22 12.9942Z\"></path></g><defs><clipPath id=\"clip0_9352_93115\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/toolbox-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21 4H16V2C16 1.46957 15.7893 0.960859 15.4142 0.585786C15.0391 0.210714 14.5304 0 14 0L10 0C9.46957 0 8.96086 0.210714 8.58579 0.585786C8.21071 0.960859 8 1.46957 8 2V4H3C2.46957 4 1.96086 4.21071 1.58579 4.58579C1.21071 4.96086 1 5.46957 1 6V12H2V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H20C20.5304 22 21.0391 21.7893 21.4142 21.4142C21.7893 21.0391 22 20.5304 22 20V12H23V6C23 5.46957 22.7893 4.96086 22.4142 4.58579C22.0391 4.21071 21.5304 4 21 4ZM10 2H14V4H10V2ZM20 20H4V12H9V16H15V12H20V20ZM11 14V10H13V14H11ZM21 10H15V8H9V10H3V6H21V10Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-boolean-16x16.svg":
/*!*************************************************!*\
  !*** ./src/images-v1/toolbox-boolean-16x16.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.66658 7.33334H11.3333C13.1999 7.33334 14.6666 5.86667 14.6666 4.00001C14.6666 2.13334 13.1999 0.666672 11.3333 0.666672H4.66658C2.79992 0.666672 1.33325 2.13334 1.33325 4.00001C1.33325 5.86667 2.79992 7.33334 4.66658 7.33334ZM4.66658 2.00001H11.3333C12.4666 2.00001 13.3333 2.86667 13.3333 4.00001C13.3333 5.13334 12.4666 6.00001 11.3333 6.00001H4.66658C3.53325 6.00001 2.66659 5.13334 2.66659 4.00001C2.66659 2.86667 3.53325 2.00001 4.66658 2.00001ZM3.33325 4.00001C3.33325 3.26667 3.93325 2.66667 4.66658 2.66667C5.39992 2.66667 5.99992 3.26667 5.99992 4.00001C5.99992 4.73334 5.39992 5.33334 4.66658 5.33334C3.93325 5.33334 3.33325 4.73334 3.33325 4.00001ZM12.6666 12C12.6666 12.7333 12.0666 13.3333 11.3333 13.3333C10.5999 13.3333 9.99992 12.7333 9.99992 12C9.99992 11.2667 10.5999 10.6667 11.3333 10.6667C12.0666 10.6667 12.6666 11.2667 12.6666 12ZM11.3333 8.66667H4.66658C2.79992 8.66667 1.33325 10.1333 1.33325 12C1.33325 13.8667 2.79992 15.3333 4.66658 15.3333H11.3333C13.1999 15.3333 14.6666 13.8667 14.6666 12C14.6666 10.1333 13.1999 8.66667 11.3333 8.66667ZM11.3333 14H4.66658C3.53325 14 2.66659 13.1333 2.66659 12C2.66659 10.8667 3.53325 10 4.66658 10H11.3333C12.4666 10 13.3333 10.8667 13.3333 12C13.3333 13.1333 12.4666 14 11.3333 14Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-boolean-24x24.svg":
/*!*************************************************!*\
  !*** ./src/images-v1/toolbox-boolean-24x24.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 11H17C19.8 11 22 8.8 22 6C22 3.2 19.8 1 17 1H7C4.2 1 2 3.2 2 6C2 8.8 4.2 11 7 11ZM7 3H17C18.7 3 20 4.3 20 6C20 7.7 18.7 9 17 9H7C5.3 9 4 7.7 4 6C4 4.3 5.3 3 7 3ZM5 6C5 4.9 5.9 4 7 4C8.1 4 9 4.9 9 6C9 7.1 8.1 8 7 8C5.9 8 5 7.1 5 6ZM19 18C19 19.1 18.1 20 17 20C15.9 20 15 19.1 15 18C15 16.9 15.9 16 17 16C18.1 16 19 16.9 19 18ZM17 13H7C4.2 13 2 15.2 2 18C2 20.8 4.2 23 7 23H17C19.8 23 22 20.8 22 18C22 15.2 19.8 13 17 13ZM17 21H7C5.3 21 4 19.7 4 18C4 16.3 5.3 15 7 15H17C18.7 15 20 16.3 20 18C20 19.7 18.7 21 17 21Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-checkbox-16x16.svg":
/*!**************************************************!*\
  !*** ./src/images-v1/toolbox-checkbox-16x16.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.6667 5.93333L14 4.06667V12.6667C14 13.4 13.4 14 12.6667 14H3.33333C2.6 14 2 13.4 2 12.6667V3.33333C2 2.6 2.6 2 3.33333 2H12.6667C12.6667 2 12.6667 2 12.7333 2L13.8667 0.400002L14.9333 1.2L7.4 11.6667L4.4 8.66667L5.33333 7.73333L7.26667 9.66667L11.8 3.33333H3.33333V12.6667H12.6667V5.93333Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-checkbox-24x24.svg":
/*!**************************************************!*\
  !*** ./src/images-v1/toolbox-checkbox-24x24.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 8.9L21 6.1V19C21 20.1 20.1 21 19 21H5C3.9 21 3 20.1 3 19V5C3 3.9 3.9 3 5 3H19C19 3 19 3 19.1 3L20.8 0.599998L22.4 1.8L11.1 17.5L6.6 13L8 11.6L10.9 14.5L17.7 5H5V19H19V8.9Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-customquestion-16x16.svg":
/*!********************************************************!*\
  !*** ./src/images-v1/toolbox-customquestion-16x16.svg ***!
  \********************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.99992 2.66665C10.9399 2.66665 13.3333 4.75998 13.3333 7.33331C13.3267 7.95199 13.1883 8.56216 12.9274 9.12314C12.6664 9.68413 12.2889 10.1831 11.8199 10.5866C11.6735 10.72 11.5586 10.8844 11.4837 11.0678C11.4087 11.2511 11.3755 11.4489 11.3866 11.6466C11.1834 11.5315 10.9535 11.4717 10.7199 11.4733C10.549 11.4746 10.3798 11.5062 10.2199 11.5666C9.51469 11.8526 8.76091 11.9997 7.99992 12C5.05992 12 2.66659 9.90665 2.66659 7.33331C2.66659 4.75998 5.05992 2.66665 7.99992 2.66665ZM7.99992 1.33331C4.31992 1.33331 1.33325 3.99998 1.33325 7.33331C1.33325 10.6666 4.31992 13.3333 7.99992 13.3333C8.93406 13.333 9.85954 13.1543 10.7266 12.8066L13.3333 14.6666L12.7133 11.5733C13.3197 11.0445 13.8072 10.3932 14.1439 9.66246C14.4806 8.93167 14.6587 8.13788 14.6666 7.33331C14.6666 3.99998 11.6799 1.33331 7.99992 1.33331Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-customquestion-24x24.svg":
/*!********************************************************!*\
  !*** ./src/images-v1/toolbox-customquestion-24x24.svg ***!
  \********************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 4C16.41 4 20 7.14 20 11C19.9901 11.928 19.7826 12.8433 19.3911 13.6847C18.9997 14.5262 18.4334 15.2746 17.73 15.88C17.5103 16.0801 17.338 16.3266 17.2256 16.6017C17.1132 16.8767 17.0634 17.1733 17.08 17.47C16.7752 17.2972 16.4304 17.2076 16.08 17.21C15.8237 17.212 15.5698 17.2594 15.33 17.35C14.2722 17.7789 13.1415 17.9996 12 18C7.59 18 4 14.86 4 11C4 7.14 7.59 4 12 4ZM12 2C6.48 2 2 6 2 11C2 16 6.48 20 12 20C13.4012 19.9996 14.7894 19.7314 16.09 19.21L20 22L19.07 17.36C19.9796 16.5667 20.711 15.5899 21.216 14.4937C21.721 13.3975 21.9882 12.2069 22 11C22 6 17.52 2 12 2Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-dropdown-16x16.svg":
/*!**************************************************!*\
  !*** ./src/images-v1/toolbox-dropdown-16x16.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.3333 1.33331H2.66659C1.93325 1.33331 1.33325 1.93331 1.33325 2.66665V3.99998C1.33325 4.73331 1.93325 5.33331 2.66659 5.33331V13.3333C2.66659 14.0666 3.26659 14.6666 3.99992 14.6666H13.3333C14.0666 14.6666 14.6666 14.0666 14.6666 13.3333V5.33331V3.99998V2.66665C14.6666 1.93331 14.0666 1.33331 13.3333 1.33331ZM13.3333 13.3333H3.99992V5.33331H13.3333V13.3333ZM2.66659 3.99998V2.66665H13.3333V3.99998H2.66659ZM11.9999 7.99998H5.33325V6.66665H11.9999V7.99998ZM11.9999 10.6666H5.33325V9.33331H11.9999V10.6666Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-dropdown-24x24.svg":
/*!**************************************************!*\
  !*** ./src/images-v1/toolbox-dropdown-24x24.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 2H4C2.9 2 2 2.9 2 4V6C2 7.1 2.9 8 4 8V20C4 21.1 4.9 22 6 22H20C21.1 22 22 21.1 22 20V8V6V4C22 2.9 21.1 2 20 2ZM20 20H6V8H20V20ZM4 6V4H20V6H4ZM18 12H8V10H18V12ZM18 16H8V14H18V16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-dynamicmatrix-16x16.svg":
/*!*******************************************************!*\
  !*** ./src/images-v1/toolbox-dynamicmatrix-16x16.svg ***!
  \*******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_22761_58174)\"><path d=\"M4.66675 2.66666C4.66675 3.79999 3.80008 4.66666 2.66675 4.66666C1.53341 4.66666 0.666748 3.79999 0.666748 2.66666C0.666748 1.53332 1.53341 0.666656 2.66675 0.666656C3.80008 0.666656 4.66675 1.53332 4.66675 2.66666ZM10.0001 2.66666C10.0001 3.79999 9.13342 4.66666 8.00008 4.66666C6.86675 4.66666 6.00008 3.79999 6.00008 2.66666C6.00008 1.53332 6.86675 0.666656 8.00008 0.666656C9.13342 0.666656 10.0001 1.53332 10.0001 2.66666ZM8.66675 2.66666C8.66675 2.26666 8.40008 1.99999 8.00008 1.99999C7.60008 1.99999 7.33342 2.26666 7.33342 2.66666C7.33342 3.06666 7.60008 3.33332 8.00008 3.33332C8.40008 3.33332 8.66675 3.06666 8.66675 2.66666ZM11.3334 2.66666C11.3334 1.53332 12.2001 0.666656 13.3334 0.666656C14.4667 0.666656 15.3334 1.53332 15.3334 2.66666C15.3334 3.79999 14.4667 4.66666 13.3334 4.66666C12.2001 4.66666 11.3334 3.79999 11.3334 2.66666ZM12.6667 2.66666C12.6667 3.06666 12.9334 3.33332 13.3334 3.33332C13.7334 3.33332 14.0001 3.06666 14.0001 2.66666C14.0001 2.26666 13.7334 1.99999 13.3334 1.99999C12.9334 1.99999 12.6667 2.26666 12.6667 2.66666ZM4.66675 7.99999C4.66675 9.13332 3.80008 9.99999 2.66675 9.99999C1.53341 9.99999 0.666748 9.13332 0.666748 7.99999C0.666748 6.86666 1.53341 5.99999 2.66675 5.99999C3.80008 5.99999 4.66675 6.86666 4.66675 7.99999ZM3.33341 7.99999C3.33341 7.59999 3.06675 7.33332 2.66675 7.33332C2.26675 7.33332 2.00008 7.59999 2.00008 7.99999C2.00008 8.39999 2.26675 8.66666 2.66675 8.66666C3.06675 8.66666 3.33341 8.39999 3.33341 7.99999ZM8.00008 5.99999C6.86675 5.99999 6.00008 6.86666 6.00008 7.99999C6.00008 9.13332 6.86675 9.99999 8.00008 9.99999C9.13342 9.99999 10.0001 9.13332 10.0001 7.99999C10.0001 6.86666 9.13342 5.99999 8.00008 5.99999ZM13.3334 5.99999C12.2001 5.99999 11.3334 6.86666 11.3334 7.99999C11.3334 9.13332 12.2001 9.99999 13.3334 9.99999C14.4667 9.99999 15.3334 9.13332 15.3334 7.99999C15.3334 6.86666 14.4667 5.99999 13.3334 5.99999ZM3.33341 11.3333H2.00008V12.6667H0.666748V14H2.00008V15.3333H3.33341V14H4.66675V12.6667H3.33341V11.3333Z\"></path></g><defs><clipPath id=\"clip0_22761_58174\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-dynamicmatrix-24x24.svg":
/*!*******************************************************!*\
  !*** ./src/images-v1/toolbox-dynamicmatrix-24x24.svg ***!
  \*******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 4C7 5.7 5.7 7 4 7C2.3 7 1 5.7 1 4C1 2.3 2.3 1 4 1C5.7 1 7 2.3 7 4ZM15 4C15 5.7 13.7 7 12 7C10.3 7 9 5.7 9 4C9 2.3 10.3 1 12 1C13.7 1 15 2.3 15 4ZM13 4C13 3.4 12.6 3 12 3C11.4 3 11 3.4 11 4C11 4.6 11.4 5 12 5C12.6 5 13 4.6 13 4ZM17 4C17 2.3 18.3 1 20 1C21.7 1 23 2.3 23 4C23 5.7 21.7 7 20 7C18.3 7 17 5.7 17 4ZM19 4C19 4.6 19.4 5 20 5C20.6 5 21 4.6 21 4C21 3.4 20.6 3 20 3C19.4 3 19 3.4 19 4ZM7 12C7 13.7 5.7 15 4 15C2.3 15 1 13.7 1 12C1 10.3 2.3 9 4 9C5.7 9 7 10.3 7 12ZM5 12C5 11.4 4.6 11 4 11C3.4 11 3 11.4 3 12C3 12.6 3.4 13 4 13C4.6 13 5 12.6 5 12ZM12 9C10.3 9 9 10.3 9 12C9 13.7 10.3 15 12 15C13.7 15 15 13.7 15 12C15 10.3 13.7 9 12 9ZM20 9C18.3 9 17 10.3 17 12C17 13.7 18.3 15 20 15C21.7 15 23 13.7 23 12C23 10.3 21.7 9 20 9ZM5 17H3V19H1V21H3V23H5V21H7V19H5V17Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-dynamicpanel-16x16.svg":
/*!******************************************************!*\
  !*** ./src/images-v1/toolbox-dynamicpanel-16x16.svg ***!
  \******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.99992 1.33334V2.66668H2.66659V6.00001H1.33325V2.66668C1.33325 2.31305 1.47373 1.97392 1.72378 1.72387C1.97382 1.47382 2.31296 1.33334 2.66659 1.33334H5.99992ZM13.3333 1.33334H9.99992V2.66668H13.3333V6.00001H14.6666V2.66668C14.6666 2.31305 14.5261 1.97392 14.2761 1.72387C14.026 1.47382 13.6869 1.33334 13.3333 1.33334ZM2.66659 13.3333V10H1.33325V13.3333C1.33325 13.687 1.47373 14.0261 1.72378 14.2762C1.97382 14.5262 2.31296 14.6667 2.66659 14.6667H5.99992V13.3333H2.66659ZM13.3333 13.3333H9.99992V14.6667H13.3333C13.6869 14.6667 14.026 14.5262 14.2761 14.2762C14.5261 14.0261 14.6666 13.687 14.6666 13.3333V10H13.3333V13.3333ZM11.3333 8.66668H9.99992V7.33334H8.66658V8.66668H7.33325V10H8.66658V11.3333H9.99992V10H11.3333V8.66668Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-dynamicpanel-24x24.svg":
/*!******************************************************!*\
  !*** ./src/images-v1/toolbox-dynamicpanel-24x24.svg ***!
  \******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 2V4H4V9H2V4C2 3.46957 2.21071 2.96086 2.58579 2.58579C2.96086 2.21071 3.46957 2 4 2H9ZM20 2H15V4H20V9H22V4C22 3.46957 21.7893 2.96086 21.4142 2.58579C21.0391 2.21071 20.5304 2 20 2ZM4 20V15H2V20C2 20.5304 2.21071 21.0391 2.58579 21.4142C2.96086 21.7893 3.46957 22 4 22H9V20H4ZM20 20H15V22H20C20.5304 22 21.0391 21.7893 21.4142 21.4142C21.7893 21.0391 22 20.5304 22 20V15H20V20ZM17 13H15V11H13V13H11V15H13V17H15V15H17V13Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-expression-16x16.svg":
/*!****************************************************!*\
  !*** ./src/images-v1/toolbox-expression-16x16.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.3333 0.333333C12.9333 0.133333 12.4667 0 11.8667 0C10.6 0 9.53333 0.533333 8.66667 1.53333C7.66667 2.73333 6.73333 4.73333 6 7.66667H4.13333L3.86667 8.66667H5.66667L5.53333 9.33333C5.46667 9.6 5.4 9.93333 5.26667 10.4667C5.13333 10.9333 5.06667 11.4 5 11.7333C4.53333 13.7333 4.06667 14.6 3.73333 14.9333C3.73333 14.7333 3.66667 14.5333 3.46667 14.4C3.13333 14.2 2.53333 14.1333 2.2 14.5333C2.06667 14.6667 2 14.9333 2 15.1333C2 15.4 2.06667 15.6 2.26667 15.7333C2.46667 15.9333 2.8 16 3.2 16C3.6 16 4 15.9333 4.33333 15.7333C5.26667 15.3333 6 14.4667 6.53333 13.0667C6.8 12.3333 7.2 11.1333 7.6 9.4L7.8 8.6H10.0667L10.3333 7.6H8.06667C8.73333 4.8 9.46667 2.8 10.2 1.8C10.4 1.53333 10.6 1.33333 10.8 1.2C11.0667 1 11.2 1 11.3333 1C11.4667 1 11.6 1 11.8 1.06667C11.6667 1.26667 11.6667 1.46667 11.6667 1.66667C11.6667 1.93333 11.8 2.2 12 2.4C12.4667 2.73333 13.2 2.73333 13.6667 2.4C13.8667 2.13333 14 1.86667 14 1.53333C14 1 13.8 0.6 13.3333 0.333333Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-expression-24x24.svg":
/*!****************************************************!*\
  !*** ./src/images-v1/toolbox-expression-24x24.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 0.5C19.4 0.2 18.7 0 17.8 0C15.9 0 14.3 0.8 13 2.3C11.5 4.1 10.1 7.1 9 11.5H6.2L5.8 13H8.5L8.3 14C8.2 14.4 8.1 14.9 7.9 15.7C7.7 16.4 7.6 17.1 7.5 17.6C6.8 20.6 6.1 21.9 5.6 22.4C5.6 22.1 5.5 21.8 5.2 21.6C4.7 21.3 3.8 21.2 3.3 21.8C3.1 22 3 22.4 3 22.7C3 23.1 3.1 23.4 3.4 23.6C3.7 23.9 4.2 24 4.8 24C5.4 24 6 23.9 6.5 23.6C7.9 23 9 21.7 9.8 19.6C10.2 18.5 10.8 16.7 11.4 14.1L11.7 12.9H15.1L15.5 11.4H12.1C13.1 7.2 14.2 4.2 15.3 2.7C15.6 2.3 15.9 2 16.2 1.8C16.6 1.5 16.8 1.5 17 1.5C17.2 1.5 17.4 1.5 17.7 1.6C17.5 1.9 17.5 2.2 17.5 2.5C17.5 2.9 17.7 3.3 18 3.6C18.7 4.1 19.8 4.1 20.5 3.6C20.8 3.2 21 2.8 21 2.3C21 1.5 20.7 0.9 20 0.5Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-file-16x16.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/toolbox-file-16x16.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_22761_58159)\"><path d=\"M14.6666 6V4.66667C14.6666 3.93333 14.0666 3.33333 13.3333 3.33333H7.99992L6.66659 2H2.66659C1.93325 2 1.33325 2.6 1.33325 3.33333V6V6.66667V14H14.6666L15.9999 6H14.6666ZM2.66659 3.33333H6.13325L7.06659 4.26667L7.46659 4.66667H7.99992H13.3333V6H2.66659V3.33333ZM13.5333 12.6667H2.66659V7.33333H14.3999L13.5333 12.6667Z\"></path></g><defs><clipPath id=\"clip0_22761_58159\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-file-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/toolbox-file-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22 9V7C22 5.9 21.1 5 20 5H12L10 3H4C2.9 3 2 3.9 2 5V9V10V21H22L24 9H22ZM4 5H9.2L10.6 6.4L11.2 7H12H20V9H4V5ZM20.3 19H4V11H21.6L20.3 19Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-html-16x16.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/toolbox-html-16x16.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.23333 4.43333L2.23333 7.96666L5.23333 11.5667L4.16667 12.4333L0.5 7.96666L4.16667 3.56666L5.23333 4.43333ZM11.9 3.56666L10.8333 4.43333L13.8333 7.96666L10.8333 11.5667L11.8333 12.4333L15.5 8.03333L11.9 3.56666ZM5.43333 13.7667L6.7 14.1667L10.7 2.16666L9.43333 1.76666L5.43333 13.7667Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-html-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v1/toolbox-html-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.85 6.65002L3.35 11.95L7.85 17.35L6.25 18.65L0.75 11.95L6.25 5.35002L7.85 6.65002ZM17.85 5.35002L16.25 6.65002L20.75 11.95L16.25 17.35L17.75 18.65L23.25 12.05L17.85 5.35002ZM8.15 20.65L10.05 21.25L16.05 3.25002L14.15 2.65002L8.15 20.65Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-image-16x16.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/toolbox-image-16x16.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.3333 1.33333H2.66659C1.93325 1.33333 1.33325 1.93333 1.33325 2.66666V13.3333C1.33325 14.0667 1.93325 14.6667 2.66659 14.6667H13.3333C14.0666 14.6667 14.6666 14.0667 14.6666 13.3333V2.66666C14.6666 1.93333 14.0666 1.33333 13.3333 1.33333ZM13.3333 13.3333H2.66659V2.66666H13.3333V13.3333ZM4.66658 5.33333C4.66658 4.59999 5.26659 3.99999 5.99992 3.99999C6.73325 3.99999 7.33325 4.59999 7.33325 5.33333C7.33325 6.06666 6.73325 6.66666 5.99992 6.66666C5.26659 6.66666 4.66658 6.06666 4.66658 5.33333ZM12.6666 12.6667H3.33325L5.99992 9.33333L7.33325 9.99999L9.33325 7.99999L12.6666 12.6667Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-image-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/toolbox-image-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 2H4C2.9 2 2 2.9 2 4V20C2 21.1 2.9 22 4 22H20C21.1 22 22 21.1 22 20V4C22 2.9 21.1 2 20 2ZM20 20H4V4H20V20ZM7 8C7 6.9 7.9 6 9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8ZM19 19H5L9 14L11 15L14 12L19 19Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-imagepicker-16x16.svg":
/*!*****************************************************!*\
  !*** ./src/images-v1/toolbox-imagepicker-16x16.svg ***!
  \*****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.3333 3.33331H2.66659C1.93325 3.33331 1.33325 3.93331 1.33325 4.66665V13.3333C1.33325 14.0666 1.93325 14.6666 2.66659 14.6666H11.3333C12.0666 14.6666 12.6666 14.0666 12.6666 13.3333V4.66665C12.6666 3.93331 12.0666 3.33331 11.3333 3.33331ZM11.3333 13.3333H2.66659V4.66665H11.3333V13.3333ZM3.99992 7.33331C3.99992 6.59998 4.59992 5.99998 5.33325 5.99998C6.06659 5.99998 6.66658 6.59998 6.66658 7.33331C6.66658 8.06665 6.06659 8.66665 5.33325 8.66665C4.59992 8.66665 3.99992 8.06665 3.99992 7.33331ZM10.6666 12.6666H3.33325L10.6666 9.33331V12.6666ZM14.6666 2.66665V11.3333C14.6666 12.0666 14.0666 12.6666 13.3333 12.6666V11.3333V2.66665H4.66658H3.33325C3.33325 1.93331 3.93325 1.33331 4.66658 1.33331H13.3333C14.0666 1.33331 14.6666 1.93331 14.6666 2.66665Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-imagepicker-24x24.svg":
/*!*****************************************************!*\
  !*** ./src/images-v1/toolbox-imagepicker-24x24.svg ***!
  \*****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17 5H4C2.9 5 2 5.9 2 7V20C2 21.1 2.9 22 4 22H17C18.1 22 19 21.1 19 20V7C19 5.9 18.1 5 17 5ZM17 20H4V7H17V20ZM6 11C6 9.9 6.9 9 8 9C9.1 9 10 9.9 10 11C10 12.1 9.1 13 8 13C6.9 13 6 12.1 6 11ZM16 19H5L16 14V19ZM22 4V17C22 18.1 21.1 19 20 19V17V4H7H5C5 2.9 5.9 2 7 2H20C21.1 2 22 2.9 22 4Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-longtext-16x16.svg":
/*!**************************************************!*\
  !*** ./src/images-v1/toolbox-longtext-16x16.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.3333 2H2.66659C1.93325 2 1.33325 2.6 1.33325 3.33333V12.6667C1.33325 13.4 1.93325 14 2.66659 14H13.3333C14.0666 14 14.6666 13.4 14.6666 12.6667V3.33333C14.6666 2.6 14.0666 2 13.3333 2ZM13.3333 12.6667H2.66659V3.33333H13.3333V12.6667ZM11.9999 6H3.99992V4.66667H11.9999V6ZM11.9999 8.66667H3.99992V7.33333H11.9999V8.66667ZM7.99992 11.3333H3.99992V10H7.99992V11.3333Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-longtext-24x24.svg":
/*!**************************************************!*\
  !*** ./src/images-v1/toolbox-longtext-24x24.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM20 19H4V5H20V19ZM18 9H6V7H18V9ZM18 13H6V11H18V13ZM12 17H6V15H12V17Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-matrix-16x16.svg":
/*!************************************************!*\
  !*** ./src/images-v1/toolbox-matrix-16x16.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_22761_58164)\"><path d=\"M4.00008 0.666656C2.13341 0.666656 0.666748 2.13332 0.666748 3.99999C0.666748 5.86666 2.13341 7.33332 4.00008 7.33332C5.86675 7.33332 7.33342 5.86666 7.33342 3.99999C7.33342 2.13332 5.86675 0.666656 4.00008 0.666656ZM4.00008 5.99999C2.86675 5.99999 2.00008 5.13332 2.00008 3.99999C2.00008 2.86666 2.86675 1.99999 4.00008 1.99999C5.13341 1.99999 6.00008 2.86666 6.00008 3.99999C6.00008 5.13332 5.13341 5.99999 4.00008 5.99999ZM5.33342 3.99999C5.33342 4.73332 4.73341 5.33332 4.00008 5.33332C3.26675 5.33332 2.66675 4.73332 2.66675 3.99999C2.66675 3.26666 3.26675 2.66666 4.00008 2.66666C4.73341 2.66666 5.33342 3.26666 5.33342 3.99999ZM13.3334 12C13.3334 12.7333 12.7334 13.3333 12.0001 13.3333C11.2667 13.3333 10.6667 12.7333 10.6667 12C10.6667 11.2667 11.2667 10.6667 12.0001 10.6667C12.7334 10.6667 13.3334 11.2667 13.3334 12ZM4.00008 8.66666C2.13341 8.66666 0.666748 10.1333 0.666748 12C0.666748 13.8667 2.13341 15.3333 4.00008 15.3333C5.86675 15.3333 7.33342 13.8667 7.33342 12C7.33342 10.1333 5.86675 8.66666 4.00008 8.66666ZM4.00008 14C2.86675 14 2.00008 13.1333 2.00008 12C2.00008 10.8667 2.86675 9.99999 4.00008 9.99999C5.13341 9.99999 6.00008 10.8667 6.00008 12C6.00008 13.1333 5.13341 14 4.00008 14ZM12.0001 7.33332C13.8667 7.33332 15.3334 5.86666 15.3334 3.99999C15.3334 2.13332 13.8667 0.666656 12.0001 0.666656C10.1334 0.666656 8.66675 2.13332 8.66675 3.99999C8.66675 5.86666 10.1334 7.33332 12.0001 7.33332ZM12.0001 1.99999C13.1334 1.99999 14.0001 2.86666 14.0001 3.99999C14.0001 5.13332 13.1334 5.99999 12.0001 5.99999C10.8667 5.99999 10.0001 5.13332 10.0001 3.99999C10.0001 2.86666 10.8667 1.99999 12.0001 1.99999ZM12.0001 8.66666C10.1334 8.66666 8.66675 10.1333 8.66675 12C8.66675 13.8667 10.1334 15.3333 12.0001 15.3333C13.8667 15.3333 15.3334 13.8667 15.3334 12C15.3334 10.1333 13.8667 8.66666 12.0001 8.66666ZM12.0001 14C10.8667 14 10.0001 13.1333 10.0001 12C10.0001 10.8667 10.8667 9.99999 12.0001 9.99999C13.1334 9.99999 14.0001 10.8667 14.0001 12C14.0001 13.1333 13.1334 14 12.0001 14Z\"></path></g><defs><clipPath id=\"clip0_22761_58164\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-matrix-24x24.svg":
/*!************************************************!*\
  !*** ./src/images-v1/toolbox-matrix-24x24.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 1C3.2 1 1 3.2 1 6C1 8.8 3.2 11 6 11C8.8 11 11 8.8 11 6C11 3.2 8.8 1 6 1ZM6 9C4.3 9 3 7.7 3 6C3 4.3 4.3 3 6 3C7.7 3 9 4.3 9 6C9 7.7 7.7 9 6 9ZM8 6C8 7.1 7.1 8 6 8C4.9 8 4 7.1 4 6C4 4.9 4.9 4 6 4C7.1 4 8 4.9 8 6ZM20 18C20 19.1 19.1 20 18 20C16.9 20 16 19.1 16 18C16 16.9 16.9 16 18 16C19.1 16 20 16.9 20 18ZM6 13C3.2 13 1 15.2 1 18C1 20.8 3.2 23 6 23C8.8 23 11 20.8 11 18C11 15.2 8.8 13 6 13ZM6 21C4.3 21 3 19.7 3 18C3 16.3 4.3 15 6 15C7.7 15 9 16.3 9 18C9 19.7 7.7 21 6 21ZM18 11C20.8 11 23 8.8 23 6C23 3.2 20.8 1 18 1C15.2 1 13 3.2 13 6C13 8.8 15.2 11 18 11ZM18 3C19.7 3 21 4.3 21 6C21 7.7 19.7 9 18 9C16.3 9 15 7.7 15 6C15 4.3 16.3 3 18 3ZM18 13C15.2 13 13 15.2 13 18C13 20.8 15.2 23 18 23C20.8 23 23 20.8 23 18C23 15.2 20.8 13 18 13ZM18 21C16.3 21 15 19.7 15 18C15 16.3 16.3 15 18 15C19.7 15 21 16.3 21 18C21 19.7 19.7 21 18 21Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-multimatrix-16x16.svg":
/*!*****************************************************!*\
  !*** ./src/images-v1/toolbox-multimatrix-16x16.svg ***!
  \*****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_22761_58169)\"><path d=\"M4.66675 2.66666C4.66675 3.79999 3.80008 4.66666 2.66675 4.66666C1.53341 4.66666 0.666748 3.79999 0.666748 2.66666C0.666748 1.53332 1.53341 0.666656 2.66675 0.666656C3.80008 0.666656 4.66675 1.53332 4.66675 2.66666ZM10.0001 2.66666C10.0001 3.79999 9.13342 4.66666 8.00008 4.66666C6.86675 4.66666 6.00008 3.79999 6.00008 2.66666C6.00008 1.53332 6.86675 0.666656 8.00008 0.666656C9.13342 0.666656 10.0001 1.53332 10.0001 2.66666ZM8.66675 2.66666C8.66675 2.26666 8.40008 1.99999 8.00008 1.99999C7.60008 1.99999 7.33342 2.26666 7.33342 2.66666C7.33342 3.06666 7.60008 3.33332 8.00008 3.33332C8.40008 3.33332 8.66675 3.06666 8.66675 2.66666ZM11.3334 2.66666C11.3334 1.53332 12.2001 0.666656 13.3334 0.666656C14.4667 0.666656 15.3334 1.53332 15.3334 2.66666C15.3334 3.79999 14.4667 4.66666 13.3334 4.66666C12.2001 4.66666 11.3334 3.79999 11.3334 2.66666ZM12.6667 2.66666C12.6667 3.06666 12.9334 3.33332 13.3334 3.33332C13.7334 3.33332 14.0001 3.06666 14.0001 2.66666C14.0001 2.26666 13.7334 1.99999 13.3334 1.99999C12.9334 1.99999 12.6667 2.26666 12.6667 2.66666ZM4.66675 7.99999C4.66675 9.13332 3.80008 9.99999 2.66675 9.99999C1.53341 9.99999 0.666748 9.13332 0.666748 7.99999C0.666748 6.86666 1.53341 5.99999 2.66675 5.99999C3.80008 5.99999 4.66675 6.86666 4.66675 7.99999ZM3.33341 7.99999C3.33341 7.59999 3.06675 7.33332 2.66675 7.33332C2.26675 7.33332 2.00008 7.59999 2.00008 7.99999C2.00008 8.39999 2.26675 8.66666 2.66675 8.66666C3.06675 8.66666 3.33341 8.39999 3.33341 7.99999ZM8.00008 5.99999C6.86675 5.99999 6.00008 6.86666 6.00008 7.99999C6.00008 9.13332 6.86675 9.99999 8.00008 9.99999C9.13342 9.99999 10.0001 9.13332 10.0001 7.99999C10.0001 6.86666 9.13342 5.99999 8.00008 5.99999ZM13.3334 5.99999C12.2001 5.99999 11.3334 6.86666 11.3334 7.99999C11.3334 9.13332 12.2001 9.99999 13.3334 9.99999C14.4667 9.99999 15.3334 9.13332 15.3334 7.99999C15.3334 6.86666 14.4667 5.99999 13.3334 5.99999ZM2.66675 11.3333C1.53341 11.3333 0.666748 12.2 0.666748 13.3333C0.666748 14.4667 1.53341 15.3333 2.66675 15.3333C3.80008 15.3333 4.66675 14.4667 4.66675 13.3333C4.66675 12.2 3.80008 11.3333 2.66675 11.3333ZM8.00008 11.3333C6.86675 11.3333 6.00008 12.2 6.00008 13.3333C6.00008 14.4667 6.86675 15.3333 8.00008 15.3333C9.13342 15.3333 10.0001 14.4667 10.0001 13.3333C10.0001 12.2 9.13342 11.3333 8.00008 11.3333ZM15.3334 13.3333C15.3334 14.4667 14.4667 15.3333 13.3334 15.3333C12.2001 15.3333 11.3334 14.4667 11.3334 13.3333C11.3334 12.2 12.2001 11.3333 13.3334 11.3333C14.4667 11.3333 15.3334 12.2 15.3334 13.3333ZM14.0001 13.3333C14.0001 12.9333 13.7334 12.6667 13.3334 12.6667C12.9334 12.6667 12.6667 12.9333 12.6667 13.3333C12.6667 13.7333 12.9334 14 13.3334 14C13.7334 14 14.0001 13.7333 14.0001 13.3333Z\"></path></g><defs><clipPath id=\"clip0_22761_58169\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-multimatrix-24x24.svg":
/*!*****************************************************!*\
  !*** ./src/images-v1/toolbox-multimatrix-24x24.svg ***!
  \*****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 4C7 5.7 5.7 7 4 7C2.3 7 1 5.7 1 4C1 2.3 2.3 1 4 1C5.7 1 7 2.3 7 4ZM15 4C15 5.7 13.7 7 12 7C10.3 7 9 5.7 9 4C9 2.3 10.3 1 12 1C13.7 1 15 2.3 15 4ZM13 4C13 3.4 12.6 3 12 3C11.4 3 11 3.4 11 4C11 4.6 11.4 5 12 5C12.6 5 13 4.6 13 4ZM17 4C17 2.3 18.3 1 20 1C21.7 1 23 2.3 23 4C23 5.7 21.7 7 20 7C18.3 7 17 5.7 17 4ZM19 4C19 4.6 19.4 5 20 5C20.6 5 21 4.6 21 4C21 3.4 20.6 3 20 3C19.4 3 19 3.4 19 4ZM7 12C7 13.7 5.7 15 4 15C2.3 15 1 13.7 1 12C1 10.3 2.3 9 4 9C5.7 9 7 10.3 7 12ZM5 12C5 11.4 4.6 11 4 11C3.4 11 3 11.4 3 12C3 12.6 3.4 13 4 13C4.6 13 5 12.6 5 12ZM12 9C10.3 9 9 10.3 9 12C9 13.7 10.3 15 12 15C13.7 15 15 13.7 15 12C15 10.3 13.7 9 12 9ZM20 9C18.3 9 17 10.3 17 12C17 13.7 18.3 15 20 15C21.7 15 23 13.7 23 12C23 10.3 21.7 9 20 9ZM4 17C2.3 17 1 18.3 1 20C1 21.7 2.3 23 4 23C5.7 23 7 21.7 7 20C7 18.3 5.7 17 4 17ZM12 17C10.3 17 9 18.3 9 20C9 21.7 10.3 23 12 23C13.7 23 15 21.7 15 20C15 18.3 13.7 17 12 17ZM23 20C23 21.7 21.7 23 20 23C18.3 23 17 21.7 17 20C17 18.3 18.3 17 20 17C21.7 17 23 18.3 23 20ZM21 20C21 19.4 20.6 19 20 19C19.4 19 19 19.4 19 20C19 20.6 19.4 21 20 21C20.6 21 21 20.6 21 20Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-multipletext-16x16.svg":
/*!******************************************************!*\
  !*** ./src/images-v1/toolbox-multipletext-16x16.svg ***!
  \******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.3333 0.666656H2.66659C1.93325 0.666656 1.33325 1.26666 1.33325 1.99999V5.99999C1.33325 6.73332 1.93325 7.33332 2.66659 7.33332H13.3333C14.0666 7.33332 14.6666 6.73332 14.6666 5.99999V1.99999C14.6666 1.26666 14.0666 0.666656 13.3333 0.666656ZM13.3333 5.99999H2.66659V1.99999H13.3333V5.99999ZM9.33325 4.66666H3.99992V3.33332H9.33325V4.66666ZM13.3333 8.66666H2.66659C1.93325 8.66666 1.33325 9.26666 1.33325 9.99999V14C1.33325 14.7333 1.93325 15.3333 2.66659 15.3333H13.3333C14.0666 15.3333 14.6666 14.7333 14.6666 14V9.99999C14.6666 9.26666 14.0666 8.66666 13.3333 8.66666ZM13.3333 14H2.66659V9.99999H13.3333V14ZM9.33325 12.6667H3.99992V11.3333H9.33325V12.6667Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-multipletext-24x24.svg":
/*!******************************************************!*\
  !*** ./src/images-v1/toolbox-multipletext-24x24.svg ***!
  \******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 1H4C2.9 1 2 1.9 2 3V9C2 10.1 2.9 11 4 11H20C21.1 11 22 10.1 22 9V3C22 1.9 21.1 1 20 1ZM20 9H4V3H20V9ZM14 7H6V5H14V7ZM20 13H4C2.9 13 2 13.9 2 15V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V15C22 13.9 21.1 13 20 13ZM20 21H4V15H20V21ZM14 19H6V17H14V19Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-panel-16x16.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/toolbox-panel-16x16.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.99992 1.33334V2.66668H2.66659V6.00001H1.33325V2.66668C1.33325 1.93334 1.93325 1.33334 2.66659 1.33334H5.99992ZM13.3333 1.33334H9.99992V2.66668H13.3333V6.00001H14.6666V2.66668C14.6666 1.93334 14.0666 1.33334 13.3333 1.33334ZM2.66659 13.3333V10H1.33325V13.3333C1.33325 14.0667 1.93325 14.6667 2.66659 14.6667H5.99992V13.3333H2.66659ZM13.3333 13.3333H9.99992V14.6667H13.3333C14.0666 14.6667 14.6666 14.0667 14.6666 13.3333V10H13.3333V13.3333Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-panel-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v1/toolbox-panel-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 2V4H4V9H2V4C2 2.9 2.9 2 4 2H9ZM20 2H15V4H20V9H22V4C22 2.9 21.1 2 20 2ZM4 20V15H2V20C2 21.1 2.9 22 4 22H9V20H4ZM20 20H15V22H20C21.1 22 22 21.1 22 20V15H20V20Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-radiogroup-16x16.svg":
/*!****************************************************!*\
  !*** ./src/images-v1/toolbox-radiogroup-16x16.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.99992 2.66665C10.9333 2.66665 13.3333 5.06665 13.3333 7.99998C13.3333 10.9333 10.9333 13.3333 7.99992 13.3333C5.06659 13.3333 2.66659 10.9333 2.66659 7.99998C2.66659 5.06665 5.06659 2.66665 7.99992 2.66665ZM7.99992 1.33331C4.33325 1.33331 1.33325 4.33331 1.33325 7.99998C1.33325 11.6666 4.33325 14.6666 7.99992 14.6666C11.6666 14.6666 14.6666 11.6666 14.6666 7.99998C14.6666 4.33331 11.6666 1.33331 7.99992 1.33331ZM7.99992 6.66665C8.73325 6.66665 9.33325 7.26665 9.33325 7.99998C9.33325 8.73331 8.73325 9.33331 7.99992 9.33331C7.26658 9.33331 6.66658 8.73331 6.66658 7.99998C6.66658 7.26665 7.26658 6.66665 7.99992 6.66665ZM7.99992 5.33331C6.53325 5.33331 5.33325 6.53331 5.33325 7.99998C5.33325 9.46665 6.53325 10.6666 7.99992 10.6666C9.46659 10.6666 10.6666 9.46665 10.6666 7.99998C10.6666 6.53331 9.46659 5.33331 7.99992 5.33331Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-radiogroup-24x24.svg":
/*!****************************************************!*\
  !*** ./src/images-v1/toolbox-radiogroup-24x24.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 4C16.4 4 20 7.6 20 12C20 16.4 16.4 20 12 20C7.6 20 4 16.4 4 12C4 7.6 7.6 4 12 4ZM12 2C6.5 2 2 6.5 2 12C2 17.5 6.5 22 12 22C17.5 22 22 17.5 22 12C22 6.5 17.5 2 12 2ZM12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14C10.9 14 10 13.1 10 12C10 10.9 10.9 10 12 10ZM12 8C9.8 8 8 9.8 8 12C8 14.2 9.8 16 12 16C14.2 16 16 14.2 16 12C16 9.8 14.2 8 12 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-ranking-16x16.svg":
/*!*************************************************!*\
  !*** ./src/images-v1/toolbox-ranking-16x16.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.6666 2.66669H1.33325V14H9.33325V10.6667H11.9999V7.33335H14.6666V2.66669ZM7.99992 12.6667H2.66659V10.6667H7.99992V12.6667ZM10.6666 9.33335H2.66659V7.33335H10.6666V9.33335ZM13.3333 6.00002H2.66659V4.00002H13.3333V6.00002Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-ranking-24x24.svg":
/*!*************************************************!*\
  !*** ./src/images-v1/toolbox-ranking-24x24.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22 4H2V21H14V16H18V11H22V4ZM12 19H4V16H12V19ZM16 14H4V11H16V14ZM20 9H4V6H20V9Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-rating-16x16.svg":
/*!************************************************!*\
  !*** ./src/images-v1/toolbox-rating-16x16.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_22761_58144)\"><path d=\"M8 4.53333L8.6 6.46666L8.86667 7.4H9.86667H11.8667L10.2667 8.6L9.46667 9.2L9.73333 10.1333L10.3333 12.0667L8.73333 10.8667L8 10.2L7.2 10.8L5.6 12L6.2 10.0667L6.46667 9.13333L5.66667 8.53333L4.06667 7.33333H6.06667H7.06667L7.33333 6.4L8 4.53333ZM8 0.199997L6.13333 6H0L4.93333 9.6L3.06667 15.4L8 11.8L12.9333 15.4L11.0667 9.6L16 6H9.86667L8 0.199997Z\"></path></g><defs><clipPath id=\"clip0_22761_58144\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-rating-24x24.svg":
/*!************************************************!*\
  !*** ./src/images-v1/toolbox-rating-24x24.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_554_309749)\"><path d=\"M12 6.8L12.9 9.7L13.3 11.1H14.8H17.8L15.4 12.9L14.2 13.8L14.6 15.2L15.5 18.1L13.1 16.3L12 15.3L10.8 16.2L8.4 18L9.3 15.1L9.7 13.7L8.5 12.8L6.1 11H9.1H10.6L11 9.6L12 6.8ZM12 0.300003L9.2 9H0L7.4 14.4L4.6 23.1L12 17.7L19.4 23.1L16.6 14.4L24 9H14.8L12 0.300003Z\"></path></g><defs><clipPath id=\"clip0_554_309749\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-signature-16x16.svg":
/*!***************************************************!*\
  !*** ./src/images-v1/toolbox-signature-16x16.svg ***!
  \***************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_22761_58139)\"><path d=\"M16 11.3333V12.6667H6.06667C6.33333 12.2667 6.6 11.8 6.8 11.3333H16ZM7.93333 6C7.33333 9.13333 5.73333 13.0667 3.33333 15.0667C2.53333 15.7333 1.33333 15.0667 1.33333 14.0667C1.33333 13.6 1.4 13.1333 1.46667 12.6667H0V11.3333H1.86667C2.86667 8.6 5.06667 6.06667 6.8 5.06667C6.93333 4.06667 6.93333 3.2 6.8 2.6C6.6 2.2 6.46667 2 6.4 2C6.26667 2 5.2 1.93333 2.53333 5.8L1.46667 5.06667C3.66667 1.86667 5.26667 0.466666 6.6 0.666666C8 0.799999 8.33333 3.06667 8.13333 4.6C9.53333 4.66667 9.86667 5.46667 9.93333 6.86667C10.8 6.06667 12.0667 5.26667 12.8 6.13333C13.8667 5.93333 14.7333 6.93333 15.2667 7.66667L14.2 8.46667C13.6 7.6 13.2 7.46667 13.0667 7.46667C13 7.46667 13 7.53333 12.9333 7.6C12.6667 8 12.4 8.53333 12 9.13333C11.8 9.4 11.4667 9.53333 11.1333 9.4C10.3333 9 11 8.06667 11.2 7.46667C10.5333 8 9.6 8.93333 9.26667 9.86667C9.2 10.3333 8.86667 10.8667 8.33333 10.7333C7.73333 10.6 7.8 9.93333 8 9.46667C8.86667 6.53333 8.33333 6 8.33333 6C8.33333 5.93333 8.13333 5.86667 7.93333 6ZM6.33333 6.93333C4.6 8.53333 2.73333 11.4 2.66667 13.8667C4.4 12.3333 5.66667 9.53333 6.33333 6.93333Z\"></path></g><defs><clipPath id=\"clip0_22761_58139\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-signature-24x24.svg":
/*!***************************************************!*\
  !*** ./src/images-v1/toolbox-signature-24x24.svg ***!
  \***************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_554_309751)\"><path d=\"M24 17V19H9.1C9.5 18.4 9.9 17.7 10.2 17H24ZM11.9 9C11 13.7 8.6 19.6 5 22.6C3.8 23.6 2 22.6 2 21.1C2 20.4 2.1 19.7 2.2 19H0V17H2.8C4.3 12.9 7.6 9.1 10.2 7.6C10.4 6.1 10.4 4.8 10.2 3.9C9.9 3.3 9.7 3 9.6 3C9.4 3 7.8 2.9 3.8 8.7L2.2 7.6C5.5 2.8 7.9 0.699999 9.9 0.999999C12 1.2 12.5 4.6 12.2 6.9C14.3 7 14.8 8.2 14.9 10.3C16.2 9.1 18.1 7.9 19.2 9.2C20.8 8.9 22.1 10.4 22.9 11.5L21.3 12.7C20.4 11.4 19.8 11.2 19.6 11.2C19.5 11.2 19.5 11.3 19.4 11.4C19 12 18.6 12.8 18 13.7C17.7 14.1 17.2 14.3 16.7 14.1C15.5 13.5 16.5 12.1 16.8 11.2C15.8 12 14.4 13.4 13.9 14.8C13.8 15.5 13.3 16.3 12.5 16.1C11.6 15.9 11.7 14.9 12 14.2C13.3 9.8 12.5 9 12.5 9C12.5 8.9 12.2 8.8 11.9 9ZM9.5 10.4C6.9 12.8 4.1 17.1 4 20.8C6.6 18.5 8.5 14.3 9.5 10.4Z\"></path></g><defs><clipPath id=\"clip0_554_309751\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-singleline-16x16.svg":
/*!****************************************************!*\
  !*** ./src/images-v1/toolbox-singleline-16x16.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.3333 4H2.66659C1.93325 4 1.33325 4.6 1.33325 5.33333V10.6667C1.33325 11.4 1.93325 12 2.66659 12H13.3333C14.0666 12 14.6666 11.4 14.6666 10.6667V5.33333C14.6666 4.6 14.0666 4 13.3333 4ZM13.3333 10.6667H2.66659V5.33333H13.3333V10.6667ZM9.33325 8.66667H3.99992V7.33333H9.33325V8.66667Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-singleline-24x24.svg":
/*!****************************************************!*\
  !*** ./src/images-v1/toolbox-singleline-24x24.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 6H4C2.9 6 2 6.9 2 8V16C2 17.1 2.9 18 4 18H20C21.1 18 22 17.1 22 16V8C22 6.9 21.1 6 20 6ZM20 16H4V8H20V16ZM14 13H6V11H14V13Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-tagbox-16x16.svg":
/*!************************************************!*\
  !*** ./src/images-v1/toolbox-tagbox-16x16.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.6666 4.66669V4.00002C14.6666 3.26669 14.0666 2.66669 13.3333 2.66669H10.6666C9.93325 2.66669 9.33325 3.26669 9.33325 4.00002V4.66669C9.33325 5.40002 9.93325 6.00002 10.6666 6.00002H13.3333C14.0666 6.00002 14.6666 5.40002 14.6666 4.66669ZM13.3333 4.66669H10.6666V4.00002H13.3333V4.66669ZM1.33325 4.00002V4.66669C1.33325 5.40002 1.93325 6.00002 2.66659 6.00002H7.33325C8.06659 6.00002 8.66658 5.40002 8.66658 4.66669V4.00002C8.66658 3.26669 8.06659 2.66669 7.33325 2.66669H2.66659C1.93325 2.66669 1.33325 3.26669 1.33325 4.00002ZM2.66659 4.00002H7.33325V4.66669H2.66659V4.00002ZM5.99992 8.00002V8.66669C5.99992 9.40002 6.59992 10 7.33325 10H13.3333C14.0666 10 14.6666 9.40002 14.6666 8.66669V8.00002C14.6666 7.26669 14.0666 6.66669 13.3333 6.66669H7.33325C6.59992 6.66669 5.99992 7.26669 5.99992 8.00002ZM7.33325 8.00002H13.3333V8.66669H7.33325V8.00002ZM1.33325 12V12.6667C1.33325 13.4 1.93325 14 2.66659 14H9.99992C10.7333 14 11.3333 13.4 11.3333 12.6667V12C11.3333 11.2667 10.7333 10.6667 9.99992 10.6667H2.66659C1.93325 10.6667 1.33325 11.2667 1.33325 12ZM2.66659 12H9.99992V12.6667H2.66659V12ZM1.33325 8.00002V8.66669C1.33325 9.40002 1.93325 10 2.66659 10H3.99992C4.73325 10 5.33325 9.40002 5.33325 8.66669V8.00002C5.33325 7.26669 4.73325 6.66669 3.99992 6.66669H2.66659C1.93325 6.66669 1.33325 7.26669 1.33325 8.00002ZM2.66659 8.00002H3.99992V8.66669H2.66659V8.00002Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/toolbox-tagbox-24x24.svg":
/*!************************************************!*\
  !*** ./src/images-v1/toolbox-tagbox-24x24.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22 7V6C22 4.9 21.1 4 20 4H16C14.9 4 14 4.9 14 6V7C14 8.1 14.9 9 16 9H20C21.1 9 22 8.1 22 7ZM20 7H16V6H20V7ZM2 6V7C2 8.1 2.9 9 4 9H11C12.1 9 13 8.1 13 7V6C13 4.9 12.1 4 11 4H4C2.9 4 2 4.9 2 6ZM4 6H11V7H4V6ZM9 12V13C9 14.1 9.9 15 11 15H20C21.1 15 22 14.1 22 13V12C22 10.9 21.1 10 20 10H11C9.9 10 9 10.9 9 12ZM11 12H20V13H11V12ZM2 18V19C2 20.1 2.9 21 4 21H15C16.1 21 17 20.1 17 19V18C17 16.9 16.1 16 15 16H4C2.9 16 2 16.9 2 18ZM4 18H15V19H4V18ZM2 12V13C2 14.1 2.9 15 4 15H6C7.1 15 8 14.1 8 13V12C8 10.9 7.1 10 6 10H4C2.9 10 2 10.9 2 12ZM4 12H6V13H4V12Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/undo-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/undo-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17 8H4.39998L8.39998 4L6.99998 2.6L0.599976 9L6.99998 15.4L8.39998 14L4.39998 10H17C19.2 10 21 11.8 21 14C21 16.2 19.2 18 17 18H16V20H17C20.3 20 23 17.3 23 14C23 10.7 20.3 8 17 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/visible-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/visible-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 4C7.2 4 3 7.2 0.5 12C3 16.8 7.2 20 12 20C16.8 20 20.9 16.8 23.5 12C20.9 7.2 16.7 4 12 4ZM12 18C8.5 18 5.1 15.8 2.8 12C5.1 8.2 8.5 6 12 6C15.5 6 18.9 8.2 21.2 12C18.9 15.8 15.5 18 12 18ZM12 7C9.2 7 7 9.2 7 12C7 14.8 9.2 17 12 17C14.8 17 17 14.8 17 12C17 9.2 14.7 7 12 7ZM12 15C10.3 15 9 13.7 9 12C9 11.7 9 11.5 9.1 11.3L12 12L10.3 9.5C10.8 9.2 11.3 9 12 9C13.7 9 15 10.3 15 12C15 13.7 13.6 15 12 15Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/wand-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v1/wand-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.7 16.3C8.1 16.7 8.1 17.3 7.7 17.7L3.7 21.7C3.5 21.9 3.3 22 3 22C2.7 22 2.5 21.9 2.3 21.7C1.9 21.3 1.9 20.7 2.3 20.3L6.3 16.3C6.7 15.9 7.3 15.9 7.7 16.3ZM20.5 10L23 13.7L18.6 14.6L17.7 19L14 16.5L10.3 19L9.4 14.6L5 13.7L7.5 10L5 6.3L9.4 5.4L10.3 1L14 3.5L17.7 1L18.6 5.4L23 6.3L20.5 10ZM18.1 10L18.8 8.9L19.6 7.7L18.1 7.4L16.8 7.1L16.5 5.8L16.2 4.3L15 5.1L14 5.9L12.9 5.2L11.7 4.3L11.4 5.8L11.1 7.1L9.8 7.4L8.3 7.7L9.1 8.9L9.9 10L9.2 11.1L8.4 12.3L9.9 12.6L11.2 12.9L11.5 14.2L11.8 15.7L13 14.9L14.1 14.2L15.2 14.9L16.4 15.7L16.7 14.2L17 12.9L18.3 12.6L19.8 12.3L19 11.1L18.1 10Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/warning-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/warning-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.0336 16.4803L14.5736 2.45346C13.9936 1.4878 12.9936 1 12.0036 1C11.0136 1 10.0136 1.4878 9.43364 2.45346L0.973642 16.4803C-0.226358 18.4714 1.21364 21 3.54364 21H20.4536C22.7836 21 24.2236 18.4714 23.0236 16.4803H23.0336ZM21.3336 18.5112C21.2436 18.6605 20.9936 19.0189 20.4636 19.0189H3.54364C3.01364 19.0189 2.76364 18.6705 2.67364 18.5112C2.58364 18.3519 2.41364 17.9537 2.68364 17.5057L11.1436 3.47885C11.4036 3.04082 11.8336 2.99104 12.0036 2.99104C12.1736 2.99104 12.5936 3.04082 12.8636 3.47885L21.3136 17.5057C21.5836 17.9537 21.4136 18.3519 21.3236 18.5112H21.3336ZM13.0036 8.05824V13.0358C13.0036 13.5834 12.5536 14.0314 12.0036 14.0314C11.4536 14.0314 11.0036 13.5834 11.0036 13.0358V8.05824C11.0036 7.5107 11.4536 7.06272 12.0036 7.06272C12.5536 7.06272 13.0036 7.5107 13.0036 8.05824ZM13.0036 16.0224C13.0036 16.5699 12.5536 17.0179 12.0036 17.0179C11.4536 17.0179 11.0036 16.5699 11.0036 16.0224C11.0036 15.4749 11.4536 15.0269 12.0036 15.0269C12.5536 15.0269 13.0036 15.4749 13.0036 16.0224Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/wrench-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/wrench-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_19764_194726)\"><path d=\"M14.8099 2.19999C15.4199 2.19999 16.0099 2.28999 16.5799 2.42999L13.3099 5.69999C11.9299 7.07999 11.9299 9.31999 13.3099 10.7C13.9999 11.39 14.9099 11.74 15.8099 11.74C16.7099 11.74 17.6199 11.39 18.3099 10.7L21.5799 7.42999C21.7299 7.99999 21.8099 8.58999 21.8099 9.19999C21.8099 13.07 18.6799 16.2 14.8099 16.2C13.6499 16.2 12.5599 15.91 11.5999 15.41L5.80993 21.2C5.39993 21.61 4.84993 21.82 4.30993 21.82C3.76993 21.82 3.21993 21.61 2.80993 21.2C1.97993 20.37 1.97993 19.03 2.80993 18.2L8.59993 12.41C8.09993 11.45 7.80993 10.36 7.80993 9.19999C7.80993 5.32999 10.9399 2.19999 14.8099 2.19999ZM14.8099 0.199993C9.84993 0.199993 5.80993 4.23999 5.80993 9.19999C5.80993 10.13 5.95993 11.06 6.23993 11.94L1.38993 16.79C0.609932 17.57 0.179932 18.6 0.179932 19.7C0.179932 20.8 0.609932 21.84 1.38993 22.61C2.16993 23.39 3.19993 23.82 4.29993 23.82C5.39993 23.82 6.43993 23.39 7.20993 22.61L12.0599 17.76C12.9499 18.04 13.8699 18.19 14.7999 18.19C19.7599 18.19 23.7999 14.15 23.7999 9.18999C23.7999 8.43999 23.6999 7.67999 23.4999 6.91999C23.3199 6.22999 22.7799 5.67999 22.0899 5.48999C21.9199 5.43999 21.7399 5.41999 21.5699 5.41999C21.0499 5.41999 20.5399 5.62999 20.1599 6.00999L16.8899 9.27999C16.5999 9.56999 16.2099 9.72999 15.7999 9.72999C15.3899 9.72999 14.9999 9.56999 14.7099 9.27999C14.4199 8.98999 14.2599 8.59999 14.2599 8.18999C14.2599 7.77999 14.4199 7.38999 14.7099 7.09999L17.9799 3.82999C18.4899 3.31999 18.6799 2.57999 18.4999 1.88999C18.3099 1.19999 17.7699 0.659993 17.0699 0.479993C16.3099 0.279993 15.5499 0.179993 14.7999 0.179993L14.8099 0.199993Z\"></path></g><defs><clipPath id=\"clip0_19764_194726\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v1/zoomin-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v1/zoomin-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M22.71 21.29L17.03 15.61C18.26 14.07 19 12.12 19 10C19 5.04 14.96 1 10 1C5.04 1 1 5.04 1 10C1 14.96 5.04 19 10 19C12.12 19 14.07 18.26 15.61 17.03L21.29 22.71L22.7 21.3L22.71 21.29ZM3 10C3 6.14 6.14 3 10 3C13.86 3 17 6.14 17 10C17 13.86 13.86 17 10 17C6.14 17 3 13.86 3 10ZM11 9H14V11H11V14H9V11H6V9H9V6H11V9Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v1/zoomout-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v1/zoomout-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M22.71 21.29L17.03 15.61C18.26 14.07 19 12.12 19 10C19 5.04 14.96 1 10 1C5.04 1 1 5.04 1 10C1 14.96 5.04 19 10 19C12.12 19 14.07 18.26 15.61 17.03L21.29 22.71L22.7 21.3L22.71 21.29ZM3 10C3 6.14 6.14 3 10 3C13.86 3 17 6.14 17 10C17 13.86 13.86 17 10 17C6.14 17 3 13.86 3 10ZM6 9H14V11H6V9Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/add-16x16.svg":
/*!*************************************!*\
  !*** ./src/images-v2/add-16x16.svg ***!
  \*************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 1.25C4.28 1.25 1.25 4.28 1.25 8C1.25 11.72 4.28 14.75 8 14.75C11.72 14.75 14.75 11.72 14.75 8C14.75 4.28 11.72 1.25 8 1.25ZM8 13.25C5.11 13.25 2.75 10.89 2.75 8C2.75 5.11 5.11 2.75 8 2.75C10.89 2.75 13.25 5.11 13.25 8C13.25 10.89 10.89 13.25 8 13.25ZM10.75 8C10.75 8.41 10.41 8.75 10 8.75H8.75V10C8.75 10.41 8.41 10.75 8 10.75C7.59 10.75 7.25 10.41 7.25 10V8.75H6C5.59 8.75 5.25 8.41 5.25 8C5.25 7.59 5.59 7.25 6 7.25H7.25V6C7.25 5.59 7.59 5.25 8 5.25C8.41 5.25 8.75 5.59 8.75 6V7.25H10C10.41 7.25 10.75 7.59 10.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/add-24x24.svg":
/*!*************************************!*\
  !*** ./src/images-v2/add-24x24.svg ***!
  \*************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.75 12C15.75 12.41 15.41 12.75 15 12.75H12.75V15C12.75 15.41 12.41 15.75 12 15.75C11.59 15.75 11.25 15.41 11.25 15V12.75H9C8.59 12.75 8.25 12.41 8.25 12C8.25 11.59 8.59 11.25 9 11.25H11.25V9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9V11.25H15C15.41 11.25 15.75 11.59 15.75 12ZM21.75 12C21.75 17.38 17.38 21.75 12 21.75C6.62 21.75 2.25 17.38 2.25 12C2.25 6.62 6.62 2.25 12 2.25C17.38 2.25 21.75 6.62 21.75 12ZM20.25 12C20.25 7.45 16.55 3.75 12 3.75C7.45 3.75 3.75 7.45 3.75 12C3.75 16.55 7.45 20.25 12 20.25C16.55 20.25 20.25 16.55 20.25 12Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/apply-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v2/apply-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2.25C6.62 2.25 2.25 6.62 2.25 12C2.25 17.38 6.62 21.75 12 21.75C17.38 21.75 21.75 17.38 21.75 12C21.75 6.62 17.38 2.25 12 2.25ZM12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25ZM16.53 8.47C16.82 8.76 16.82 9.24 16.53 9.53L10.53 15.53C10.38 15.68 10.19 15.75 10 15.75C9.81 15.75 9.62 15.68 9.47 15.53L7.47 13.53C7.18 13.24 7.18 12.76 7.47 12.47C7.76 12.18 8.24 12.18 8.53 12.47L10 13.94L15.47 8.47C15.76 8.18 16.24 8.18 16.53 8.47Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/arrowdown-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/arrowdown-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.5275 12.53L12.5275 16.53C12.4575 16.6 12.3775 16.65 12.2875 16.69C12.1975 16.73 12.0975 16.75 11.9975 16.75C11.8975 16.75 11.7975 16.73 11.7075 16.69C11.6175 16.65 11.5375 16.6 11.4675 16.53L7.4675 12.53C7.1775 12.24 7.1775 11.76 7.4675 11.47C7.7575 11.18 8.2375 11.18 8.5275 11.47L11.2475 14.19V7C11.2475 6.59 11.5875 6.25 11.9975 6.25C12.4075 6.25 12.7475 6.59 12.7475 7V14.19L15.4675 11.47C15.7575 11.18 16.2375 11.18 16.5275 11.47C16.8175 11.76 16.8175 12.24 16.5275 12.53Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/arrowleft-16x16.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/arrowleft-16x16.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.7475 7.9975C14.7475 8.4075 14.4075 8.7475 13.9975 8.7475H3.8075L7.5275 12.4675C7.8175 12.7575 7.8175 13.2375 7.5275 13.5275C7.3775 13.6775 7.1875 13.7475 6.9975 13.7475C6.8075 13.7475 6.6175 13.6775 6.4675 13.5275L1.4675 8.5275C1.1775 8.2375 1.1775 7.7575 1.4675 7.4675L6.4675 2.4675C6.7575 2.1775 7.2375 2.1775 7.5275 2.4675C7.8175 2.7575 7.8175 3.2375 7.5275 3.5275L3.8075 7.2475H13.9975C14.4075 7.2475 14.7475 7.5875 14.7475 7.9975Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/arrowleft-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/arrowleft-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.75 11.9975C21.75 12.4075 21.41 12.7475 21 12.7475H4.81L9.53 17.4675C9.82 17.7575 9.82 18.2375 9.53 18.5275C9.38 18.6775 9.19 18.7475 9 18.7475C8.81 18.7475 8.62 18.6775 8.47 18.5275L2.47 12.5275C2.4 12.4575 2.35 12.3775 2.31 12.2875C2.23 12.1075 2.23 11.8975 2.31 11.7175C2.35 11.6275 2.4 11.5475 2.47 11.4775L8.47 5.4675C8.76 5.1775 9.24 5.1775 9.53 5.4675C9.82 5.7575 9.82 6.2375 9.53 6.5275L4.81 11.2475H21C21.41 11.2475 21.75 11.5875 21.75 11.9975Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/arrowright-16x16.svg":
/*!********************************************!*\
  !*** ./src/images-v2/arrowright-16x16.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.53 8.5275L9.53 13.5275C9.38 13.6775 9.19 13.7475 9 13.7475C8.81 13.7475 8.62 13.6775 8.47 13.5275C8.18 13.2375 8.18 12.7575 8.47 12.4675L12.19 8.7475H2C1.59 8.7475 1.25 8.4075 1.25 7.9975C1.25 7.5875 1.59 7.2475 2 7.2475H12.19L8.47 3.5275C8.18 3.2375 8.18 2.7575 8.47 2.4675C8.76 2.1775 9.24 2.1775 9.53 2.4675L14.53 7.4675C14.82 7.7575 14.82 8.2375 14.53 8.5275Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/arrowright-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v2/arrowright-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.69 12.2875C21.65 12.3775 21.6 12.4575 21.53 12.5275L15.53 18.5275C15.38 18.6775 15.19 18.7475 15 18.7475C14.81 18.7475 14.62 18.6775 14.47 18.5275C14.18 18.2375 14.18 17.7575 14.47 17.4675L19.19 12.7475H3C2.59 12.7475 2.25 12.4075 2.25 11.9975C2.25 11.5875 2.59 11.2475 3 11.2475H19.19L14.47 6.5275C14.18 6.2375 14.18 5.7575 14.47 5.4675C14.76 5.1775 15.24 5.1775 15.53 5.4675L21.53 11.4675C21.6 11.5375 21.65 11.6175 21.69 11.7075C21.77 11.8875 21.77 12.0975 21.69 12.2775V12.2875Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/arrowup-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/arrowup-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.5275 11.53C16.3775 11.68 16.1875 11.75 15.9975 11.75C15.8075 11.75 15.6175 11.68 15.4675 11.53L12.7475 8.81V16C12.7475 16.41 12.4075 16.75 11.9975 16.75C11.5875 16.75 11.2475 16.41 11.2475 16V8.81L8.5275 11.53C8.2375 11.82 7.7575 11.82 7.4675 11.53C7.1775 11.24 7.1775 10.76 7.4675 10.47L11.4675 6.47C11.5375 6.4 11.6175 6.35 11.7075 6.31C11.8875 6.23 12.0975 6.23 12.2775 6.31C12.3675 6.35 12.4475 6.4 12.5175 6.47L16.5175 10.47C16.8075 10.76 16.8075 11.24 16.5175 11.53H16.5275Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/camera-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/camera-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.19 4.25H17.12C16.72 4.25 16.35 4.03 16.17 3.67C15.73 2.8 14.86 2.25 13.88 2.25H10.12C9.14 2.25 8.27 2.79 7.83 3.67C7.65 4.03 7.29 4.25 6.88 4.25H4.81C3.4 4.25 2.25 5.4 2.25 6.81V18.19C2.25 19.6 3.4 20.75 4.81 20.75H19.19C20.6 20.75 21.75 19.6 21.75 18.19V6.81C21.75 5.4 20.6 4.25 19.19 4.25ZM20.25 18.19C20.25 18.77 19.78 19.25 19.19 19.25H4.81C4.23 19.25 3.75 18.78 3.75 18.19V6.81C3.75 6.23 4.22 5.75 4.81 5.75H6.88C7.86 5.75 8.73 5.21 9.17 4.33C9.35 3.97 9.71 3.75 10.12 3.75H13.88C14.28 3.75 14.65 3.97 14.83 4.33C15.27 5.2 16.14 5.75 17.12 5.75H19.19C19.77 5.75 20.25 6.22 20.25 6.81V18.19ZM12 6.25C8.83 6.25 6.25 8.83 6.25 12C6.25 15.17 8.83 17.75 12 17.75C15.17 17.75 17.75 15.17 17.75 12C17.75 8.83 15.17 6.25 12 6.25ZM12 16.25C9.66 16.25 7.75 14.34 7.75 12C7.75 9.66 9.66 7.75 12 7.75C14.34 7.75 16.25 9.66 16.25 12C16.25 14.34 14.34 16.25 12 16.25ZM14.75 12C14.75 13.52 13.52 14.75 12 14.75C11.59 14.75 11.25 14.41 11.25 14C11.25 13.59 11.59 13.25 12 13.25C12.69 13.25 13.25 12.69 13.25 12C13.25 11.59 13.59 11.25 14 11.25C14.41 11.25 14.75 11.59 14.75 12Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/camera-32x32.svg":
/*!****************************************!*\
  !*** ./src/images-v2/camera-32x32.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M25 7.25H22.19C21.73 7.25 21.31 7 21.09 6.59L20.89 6.22C20.23 5.01 18.97 4.25 17.59 4.25H14.41C13.03 4.25 11.77 5 11.11 6.22L10.91 6.6C10.69 7 10.27 7.26 9.81 7.26H7C4.93 7.26 3.25 8.94 3.25 11.01V24.01C3.25 26.08 4.93 27.76 7 27.76H25C27.07 27.76 28.75 26.08 28.75 24.01V11C28.75 8.93 27.07 7.25 25 7.25ZM27.25 24C27.25 25.24 26.24 26.25 25 26.25H7C5.76 26.25 4.75 25.24 4.75 24V11C4.75 9.76 5.76 8.75 7 8.75H9.81C10.82 8.75 11.75 8.2 12.23 7.31L12.43 6.94C12.82 6.21 13.58 5.76 14.41 5.76H17.59C18.42 5.76 19.18 6.21 19.57 6.94L19.77 7.31C20.25 8.2 21.18 8.76 22.19 8.76H25C26.24 8.76 27.25 9.77 27.25 11.01V24.01V24ZM16 10.25C12.28 10.25 9.25 13.28 9.25 17C9.25 20.72 12.28 23.75 16 23.75C19.72 23.75 22.75 20.72 22.75 17C22.75 13.28 19.72 10.25 16 10.25ZM16 22.25C13.11 22.25 10.75 19.89 10.75 17C10.75 14.11 13.11 11.75 16 11.75C18.89 11.75 21.25 14.11 21.25 17C21.25 19.89 18.89 22.25 16 22.25ZM19.75 17C19.75 19.07 18.07 20.75 16 20.75C15.59 20.75 15.25 20.41 15.25 20C15.25 19.59 15.59 19.25 16 19.25C17.24 19.25 18.25 18.24 18.25 17C18.25 16.59 18.59 16.25 19 16.25C19.41 16.25 19.75 16.59 19.75 17Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/cancel-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/cancel-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.8099 11.75L15.2799 9.28C15.5699 8.99 15.5699 8.51 15.2799 8.22C14.9899 7.93 14.5099 7.93 14.2199 8.22L11.7499 10.69L9.27994 8.22C8.98994 7.93 8.50994 7.93 8.21994 8.22C7.92994 8.51 7.92994 8.99 8.21994 9.28L10.6899 11.75L8.21994 14.22C7.92994 14.51 7.92994 14.99 8.21994 15.28C8.36994 15.43 8.55994 15.5 8.74994 15.5C8.93994 15.5 9.12994 15.43 9.27994 15.28L11.7499 12.81L14.2199 15.28C14.3699 15.43 14.5599 15.5 14.7499 15.5C14.9399 15.5 15.1299 15.43 15.2799 15.28C15.5699 14.99 15.5699 14.51 15.2799 14.22L12.8099 11.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/check-16x16.svg":
/*!***************************************!*\
  !*** ./src/images-v2/check-16x16.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.0275 5.0275L6.5275 12.5275C6.3775 12.6775 6.1875 12.7475 5.9975 12.7475C5.8075 12.7475 5.6175 12.6775 5.4675 12.5275L2.4675 9.5275C2.1775 9.2375 2.1775 8.7575 2.4675 8.4675C2.7575 8.1775 3.2375 8.1775 3.5275 8.4675L5.9975 10.9375L12.9675 3.9675C13.2575 3.6775 13.7375 3.6775 14.0275 3.9675C14.3175 4.2575 14.3175 4.7375 14.0275 5.0275Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/check-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v2/check-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.5275 7.5275L9.5275 17.5275C9.3775 17.6775 9.1875 17.7475 8.9975 17.7475C8.8075 17.7475 8.6175 17.6775 8.4675 17.5275L4.4675 13.5275C4.1775 13.2375 4.1775 12.7575 4.4675 12.4675C4.7575 12.1775 5.2375 12.1775 5.5275 12.4675L8.9975 15.9375L18.4675 6.4675C18.7575 6.1775 19.2375 6.1775 19.5275 6.4675C19.8175 6.7575 19.8175 7.2375 19.5275 7.5275Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/chevrondown-16x16.svg":
/*!*********************************************!*\
  !*** ./src/images-v2/chevrondown-16x16.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.5275 7.5275L8.5275 10.5275C8.3775 10.6775 8.1875 10.7475 7.9975 10.7475C7.8075 10.7475 7.6175 10.6775 7.4675 10.5275L4.4675 7.5275C4.1775 7.2375 4.1775 6.7575 4.4675 6.4675C4.7575 6.1775 5.2375 6.1775 5.5275 6.4675L7.9975 8.9375L10.4675 6.4675C10.7575 6.1775 11.2375 6.1775 11.5275 6.4675C11.8175 6.7575 11.8175 7.2375 11.5275 7.5275Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/chevrondown-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v2/chevrondown-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.5275 10.5275L12.5275 14.5275C12.3775 14.6775 12.1875 14.7475 11.9975 14.7475C11.8075 14.7475 11.6175 14.6775 11.4675 14.5275L7.4675 10.5275C7.1775 10.2375 7.1775 9.7575 7.4675 9.4675C7.7575 9.1775 8.2375 9.1775 8.5275 9.4675L11.9975 12.9375L15.4675 9.4675C15.7575 9.1775 16.2375 9.1775 16.5275 9.4675C16.8175 9.7575 16.8175 10.2375 16.5275 10.5275Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/chevronleft-16x16.svg":
/*!*********************************************!*\
  !*** ./src/images-v2/chevronleft-16x16.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9.35 11.65C9.55 11.85 9.55 12.16 9.35 12.36C9.25 12.46 9.12 12.51 9 12.51C8.88 12.51 8.74 12.46 8.65 12.36L4.65 8.35C4.45 8.15 4.45 7.84 4.65 7.64L8.65 3.65C8.85 3.45 9.16 3.45 9.36 3.65C9.56 3.85 9.56 4.16 9.36 4.36L5.71 8.01L9.36 11.66L9.35 11.65Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/chevronright-16x16.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/chevronright-16x16.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.35 8.34627L7.35 12.3463C7.25 12.4463 7.12 12.4963 7 12.4963C6.88 12.4963 6.74 12.4463 6.65 12.3463C6.45 12.1463 6.45 11.8363 6.65 11.6363L10.3 7.98627L6.65 4.34627C6.45 4.15627 6.45 3.83627 6.65 3.64627C6.85 3.45627 7.16 3.44627 7.35 3.64627L11.35 7.64627C11.55 7.84627 11.55 8.15627 11.35 8.35627V8.34627Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/clear-16x16.svg":
/*!***************************************!*\
  !*** ./src/images-v2/clear-16x16.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.35 11.65C12.55 11.85 12.55 12.16 12.35 12.36C12.25 12.46 12.12 12.51 12 12.51C11.88 12.51 11.74 12.46 11.65 12.36L8 8.71L4.35 12.36C4.25 12.46 4.12 12.51 4 12.51C3.88 12.51 3.74 12.46 3.65 12.36C3.45 12.16 3.45 11.85 3.65 11.65L7.3 8L3.65 4.35C3.45 4.16 3.45 3.84 3.65 3.65C3.85 3.46 4.16 3.45 4.35 3.65L8 7.3L11.65 3.65C11.85 3.45 12.16 3.45 12.36 3.65C12.56 3.85 12.56 4.16 12.36 4.36L8.71 8.01L12.36 11.66L12.35 11.65Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/clear-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v2/clear-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.12 10.9325C20.64 10.4125 20.93 9.7225 20.93 8.9925C20.93 8.2625 20.64 7.5725 20.12 7.0525L16.95 3.8825C15.88 2.8125 14.13 2.8125 13.06 3.8825L3.88 13.0525C3.36 13.5725 3.07 14.2625 3.07 14.9925C3.07 15.7225 3.36 16.4125 3.88 16.9325L5.64 18.6925C6.57 19.6225 7.78 20.0825 9 20.0825C10.22 20.0825 11.43 19.6225 12.36 18.6925L20.12 10.9325ZM14.12 4.9325C14.36 4.6925 14.67 4.5625 15 4.5625C15.33 4.5625 15.65 4.6925 15.88 4.9325L19.05 8.1025C19.54 8.5925 19.54 9.3825 19.05 9.8725L12.99 15.9325L8.05 10.9925L14.12 4.9325ZM6.7 17.6325L4.94 15.8725C4.45 15.3825 4.45 14.5925 4.94 14.1025L7 12.0425L11.94 16.9825L11.3 17.6225C10.07 18.8525 7.93 18.8525 6.7 17.6225V17.6325ZM22.75 20.9925C22.75 21.4025 22.41 21.7425 22 21.7425H14C13.59 21.7425 13.25 21.4025 13.25 20.9925C13.25 20.5825 13.59 20.2425 14 20.2425H22C22.41 20.2425 22.75 20.5825 22.75 20.9925ZM4.75 20.9925C4.75 21.4025 4.41 21.7425 4 21.7425H2C1.59 21.7425 1.25 21.4025 1.25 20.9925C1.25 20.5825 1.59 20.2425 2 20.2425H4C4.41 20.2425 4.75 20.5825 4.75 20.9925Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/close-16x16.svg":
/*!***************************************!*\
  !*** ./src/images-v2/close-16x16.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.5275 12.4675C13.8175 12.7575 13.8175 13.2375 13.5275 13.5275C13.3775 13.6775 13.1875 13.7475 12.9975 13.7475C12.8075 13.7475 12.6175 13.6775 12.4675 13.5275L7.9975 9.0575L3.5275 13.5275C3.3775 13.6775 3.1875 13.7475 2.9975 13.7475C2.8075 13.7475 2.6175 13.6775 2.4675 13.5275C2.1775 13.2375 2.1775 12.7575 2.4675 12.4675L6.9375 7.9975L2.4675 3.5275C2.1775 3.2375 2.1775 2.7575 2.4675 2.4675C2.7575 2.1775 3.2375 2.1775 3.5275 2.4675L7.9975 6.9375L12.4675 2.4675C12.7575 2.1775 13.2375 2.1775 13.5275 2.4675C13.8175 2.7575 13.8175 3.2375 13.5275 3.5275L9.0575 7.9975L13.5275 12.4675Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/close-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v2/close-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.5275 18.4675C19.8175 18.7575 19.8175 19.2375 19.5275 19.5275C19.3775 19.6775 19.1875 19.7475 18.9975 19.7475C18.8075 19.7475 18.6175 19.6775 18.4675 19.5275L11.9975 13.0575L5.5275 19.5275C5.3775 19.6775 5.1875 19.7475 4.9975 19.7475C4.8075 19.7475 4.6175 19.6775 4.4675 19.5275C4.1775 19.2375 4.1775 18.7575 4.4675 18.4675L10.9375 11.9975L4.4675 5.5275C4.1775 5.2375 4.1775 4.7575 4.4675 4.4675C4.7575 4.1775 5.2375 4.1775 5.5275 4.4675L11.9975 10.9375L18.4675 4.4675C18.7575 4.1775 19.2375 4.1775 19.5275 4.4675C19.8175 4.7575 19.8175 5.2375 19.5275 5.5275L13.0575 11.9975L19.5275 18.4675Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/codeeditor-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v2/codeeditor-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 3.25H5C3.48 3.25 2.25 4.48 2.25 6V18C2.25 19.52 3.48 20.75 5 20.75H19C20.52 20.75 21.75 19.52 21.75 18V6C21.75 4.48 20.52 3.25 19 3.25ZM20.25 18C20.25 18.69 19.69 19.25 19 19.25H5C4.31 19.25 3.75 18.69 3.75 18V6C3.75 5.31 4.31 4.75 5 4.75H19C19.69 4.75 20.25 5.31 20.25 6V18ZM8.75 11C8.75 11.37 8.63 11.72 8.43 12C8.63 12.28 8.75 12.63 8.75 13V14.5C8.75 14.91 9.09 15.25 9.5 15.25H10C10.41 15.25 10.75 15.59 10.75 16C10.75 16.41 10.41 16.75 10 16.75H9.5C8.26 16.75 7.25 15.74 7.25 14.5V13C7.25 12.86 7.14 12.75 7 12.75C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25C7.14 11.25 7.25 11.14 7.25 11V9.5C7.25 8.26 8.26 7.25 9.5 7.25H10C10.41 7.25 10.75 7.59 10.75 8C10.75 8.41 10.41 8.75 10 8.75H9.5C9.09 8.75 8.75 9.09 8.75 9.5V11ZM17.75 12C17.75 12.41 17.41 12.75 17 12.75C16.86 12.75 16.75 12.86 16.75 13V14.5C16.75 15.74 15.74 16.75 14.5 16.75H14C13.59 16.75 13.25 16.41 13.25 16C13.25 15.59 13.59 15.25 14 15.25H14.5C14.91 15.25 15.25 14.91 15.25 14.5V13C15.25 12.63 15.37 12.28 15.57 12C15.37 11.72 15.25 11.37 15.25 11V9.5C15.25 9.09 14.91 8.75 14.5 8.75H14C13.59 8.75 13.25 8.41 13.25 8C13.25 7.59 13.59 7.25 14 7.25H14.5C15.74 7.25 16.75 8.26 16.75 9.5V11C16.75 11.14 16.86 11.25 17 11.25C17.41 11.25 17.75 11.59 17.75 12Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/collapse-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v2/collapse-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.75 8C11.75 8.41 11.41 8.75 11 8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H11C11.41 7.25 11.75 7.59 11.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/collapse-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v2/collapse-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.5275 17.47C16.8175 17.76 16.8175 18.24 16.5275 18.53C16.3775 18.68 16.1875 18.75 15.9975 18.75C15.8075 18.75 15.6175 18.68 15.4675 18.53L12.7475 15.81V21C12.7475 21.41 12.4075 21.75 11.9975 21.75C11.5875 21.75 11.2475 21.41 11.2475 21V15.81L8.5275 18.53C8.2375 18.82 7.7575 18.82 7.4675 18.53C7.1775 18.24 7.1775 17.76 7.4675 17.47L11.4675 13.47C11.5375 13.4 11.6175 13.35 11.7075 13.31C11.8875 13.23 12.0975 13.23 12.2775 13.31C12.3675 13.35 12.4475 13.4 12.5175 13.47L16.5175 17.47H16.5275ZM11.4675 10.53C11.5375 10.6 11.6175 10.65 11.7075 10.69C11.7975 10.73 11.8975 10.75 11.9975 10.75C12.0975 10.75 12.1975 10.73 12.2875 10.69C12.3775 10.65 12.4575 10.6 12.5275 10.53L16.5275 6.53C16.8175 6.24 16.8175 5.76 16.5275 5.47C16.2375 5.18 15.7575 5.18 15.4675 5.47L12.7475 8.19V3C12.7475 2.59 12.4075 2.25 11.9975 2.25C11.5875 2.25 11.2475 2.59 11.2475 3V8.19L8.5275 5.47C8.2375 5.18 7.7575 5.18 7.4675 5.47C7.1775 5.76 7.1775 6.24 7.4675 6.53L11.4675 10.53Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/collapse-pg-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v2/collapse-pg-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.69 12.29C16.65 12.38 16.6 12.46 16.53 12.53L13.53 15.53C13.38 15.68 13.19 15.75 13 15.75C12.81 15.75 12.62 15.68 12.47 15.53C12.18 15.24 12.18 14.76 12.47 14.47L14.19 12.75H3C2.59 12.75 2.25 12.41 2.25 12C2.25 11.59 2.59 11.25 3 11.25H14.19L12.47 9.53C12.18 9.24 12.18 8.76 12.47 8.47C12.76 8.18 13.24 8.18 13.53 8.47L16.53 11.47C16.6 11.54 16.65 11.62 16.69 11.71C16.77 11.89 16.77 12.1 16.69 12.28V12.29ZM20 3.25C19.59 3.25 19.25 3.59 19.25 4V20C19.25 20.41 19.59 20.75 20 20.75C20.41 20.75 20.75 20.41 20.75 20V4C20.75 3.59 20.41 3.25 20 3.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/collapseall-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v2/collapseall-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15.53 18.47C15.82 18.76 15.82 19.24 15.53 19.53C15.38 19.68 15.19 19.75 15 19.75C14.81 19.75 14.62 19.68 14.47 19.53L12.75 17.81V22C12.75 22.41 12.41 22.75 12 22.75C11.59 22.75 11.25 22.41 11.25 22V17.81L9.53 19.53C9.24 19.82 8.76 19.82 8.47 19.53C8.18 19.24 8.18 18.76 8.47 18.47L11.47 15.47C11.54 15.4 11.62 15.35 11.71 15.31C11.89 15.23 12.1 15.23 12.28 15.31C12.37 15.35 12.45 15.4 12.52 15.47L15.52 18.47H15.53ZM11.47 8.53C11.54 8.6 11.62 8.65 11.71 8.69C11.8 8.73 11.9 8.75 12 8.75C12.1 8.75 12.2 8.73 12.29 8.69C12.38 8.65 12.46 8.6 12.53 8.53L15.53 5.53C15.82 5.24 15.82 4.76 15.53 4.47C15.24 4.18 14.76 4.18 14.47 4.47L12.75 6.19V2C12.75 1.59 12.41 1.25 12 1.25C11.59 1.25 11.25 1.59 11.25 2V6.19L9.53 4.47C9.24 4.18 8.76 4.18 8.47 4.47C8.18 4.76 8.18 5.24 8.47 5.53L11.47 8.53ZM21 11.25H3C2.59 11.25 2.25 11.59 2.25 12C2.25 12.41 2.59 12.75 3 12.75H21C21.41 12.75 21.75 12.41 21.75 12C21.75 11.59 21.41 11.25 21 11.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/collapsedetails-16x16.svg":
/*!*************************************************!*\
  !*** ./src/images-v2/collapsedetails-16x16.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.75 8C11.75 8.41 11.41 8.75 11 8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H11C11.41 7.25 11.75 7.59 11.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/collapsefocused-16x16.svg":
/*!*************************************************!*\
  !*** ./src/images-v2/collapsefocused-16x16.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.75 8C11.75 8.41 11.41 8.75 11 8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H11C11.41 7.25 11.75 7.59 11.75 8Z\"></path><path d=\"M13 3H3C1.35 3 0 4.35 0 6V10C0 11.65 1.35 13 3 13H13C14.65 13 16 11.65 16 10V6C16 4.35 14.65 3 13 3ZM14 10C14 10.55 13.55 11 13 11H3C2.45 11 2 10.55 2 10V6C2 5.45 2.45 5 3 5H13C13.55 5 14 5.45 14 6V10Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/collapsepage-16x16.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/collapsepage-16x16.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.53 11.47C10.82 11.76 10.82 12.24 10.53 12.53C10.38 12.68 10.19 12.75 10 12.75C9.81 12.75 9.62 12.68 9.47 12.53L8.75 11.81V14C8.75 14.41 8.41 14.75 8 14.75C7.59 14.75 7.25 14.41 7.25 14V11.81L6.53 12.53C6.24 12.82 5.76 12.82 5.47 12.53C5.18 12.24 5.18 11.76 5.47 11.47L7.47 9.47C7.54 9.4 7.62 9.35 7.71 9.31C7.89 9.23 8.1 9.23 8.28 9.31C8.37 9.35 8.45 9.4 8.52 9.47L10.52 11.47H10.53ZM9.47 3.47L8.75 4.19V2C8.75 1.59 8.41 1.25 8 1.25C7.59 1.25 7.25 1.59 7.25 2V4.19L6.53 3.47C6.24 3.18 5.76 3.18 5.47 3.47C5.18 3.76 5.18 4.24 5.47 4.53L7.47 6.53C7.54 6.6 7.62 6.65 7.71 6.69C7.8 6.73 7.9 6.75 8 6.75C8.1 6.75 8.2 6.73 8.29 6.69C8.38 6.65 8.46 6.6 8.53 6.53L10.53 4.53C10.82 4.24 10.82 3.76 10.53 3.47C10.24 3.18 9.76 3.18 9.47 3.47ZM3 6.75C3.41 6.75 3.75 6.41 3.75 6C3.75 5.59 3.41 5.25 3 5.25C2.04 5.25 1.25 6.04 1.25 7V9C1.25 9.96 2.04 10.75 3 10.75C3.41 10.75 3.75 10.41 3.75 10C3.75 9.59 3.41 9.25 3 9.25C2.86 9.25 2.75 9.14 2.75 9V7C2.75 6.86 2.86 6.75 3 6.75ZM13 5.25C12.59 5.25 12.25 5.59 12.25 6C12.25 6.41 12.59 6.75 13 6.75C13.14 6.75 13.25 6.86 13.25 7V9C13.25 9.14 13.14 9.25 13 9.25C12.59 9.25 12.25 9.59 12.25 10C12.25 10.41 12.59 10.75 13 10.75C13.96 10.75 14.75 9.96 14.75 9V7C14.75 6.04 13.96 5.25 13 5.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/collapsepanel-16x16.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/collapsepanel-16x16.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.75 8C12.75 8.41 12.41 8.75 12 8.75H4C3.59 8.75 3.25 8.41 3.25 8C3.25 7.59 3.59 7.25 4 7.25H12C12.41 7.25 12.75 7.59 12.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/copy-16x16.svg":
/*!**************************************!*\
  !*** ./src/images-v2/copy-16x16.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M9 5.25H3C2.04 5.25 1.25 6.04 1.25 7V13C1.25 13.96 2.04 14.75 3 14.75H9C9.96 14.75 10.75 13.96 10.75 13V7C10.75 6.04 9.96 5.25 9 5.25ZM9.25 13C9.25 13.14 9.14 13.25 9 13.25H3C2.86 13.25 2.75 13.14 2.75 13V7C2.75 6.86 2.86 6.75 3 6.75H9C9.14 6.75 9.25 6.86 9.25 7V13ZM14.75 3V9C14.75 9.96 13.96 10.75 13 10.75H12C11.59 10.75 11.25 10.41 11.25 10C11.25 9.59 11.59 9.25 12 9.25H13C13.14 9.25 13.25 9.14 13.25 9V3C13.25 2.86 13.14 2.75 13 2.75H7C6.86 2.75 6.75 2.86 6.75 3V4C6.75 4.41 6.41 4.75 6 4.75C5.59 4.75 5.25 4.41 5.25 4V3C5.25 2.04 6.04 1.25 7 1.25H13C13.96 1.25 14.75 2.04 14.75 3Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/copy-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/copy-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 8.25H6C4.48 8.25 3.25 9.48 3.25 11V18C3.25 19.52 4.48 20.75 6 20.75H13C14.52 20.75 15.75 19.52 15.75 18V11C15.75 9.48 14.52 8.25 13 8.25ZM14.25 18C14.25 18.69 13.69 19.25 13 19.25H6C5.31 19.25 4.75 18.69 4.75 18V11C4.75 10.31 5.31 9.75 6 9.75H13C13.69 9.75 14.25 10.31 14.25 11V18ZM20.75 6V13C20.75 14.52 19.52 15.75 18 15.75C17.59 15.75 17.25 15.41 17.25 15C17.25 14.59 17.59 14.25 18 14.25C18.69 14.25 19.25 13.69 19.25 13V6C19.25 5.31 18.69 4.75 18 4.75H11C10.31 4.75 9.75 5.31 9.75 6C9.75 6.41 9.41 6.75 9 6.75C8.59 6.75 8.25 6.41 8.25 6C8.25 4.48 9.48 3.25 11 3.25H18C19.52 3.25 20.75 4.48 20.75 6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/cross-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v2/cross-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.35 15.65C16.55 15.85 16.55 16.16 16.35 16.36C16.25 16.46 16.12 16.51 16 16.51C15.88 16.51 15.74 16.46 15.65 16.36L12 12.71L8.35 16.36C8.25 16.46 8.12 16.51 8 16.51C7.88 16.51 7.74 16.46 7.65 16.36C7.45 16.16 7.45 15.85 7.65 15.65L11.3 12L7.65 8.35C7.45 8.16 7.45 7.84 7.65 7.65C7.85 7.46 8.16 7.45 8.35 7.65L12 11.3L15.65 7.65C15.85 7.45 16.16 7.45 16.36 7.65C16.56 7.85 16.56 8.16 16.36 8.36L12.71 12.01L16.36 15.66L16.35 15.65Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/delete-16x16.svg":
/*!****************************************!*\
  !*** ./src/images-v2/delete-16x16.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 3.25H10.75V3C10.75 2.04 9.96 1.25 9 1.25H7C6.04 1.25 5.25 2.04 5.25 3V3.25H3C2.59 3.25 2.25 3.59 2.25 4C2.25 4.41 2.59 4.75 3 4.75H3.25V13C3.25 13.96 4.04 14.75 5 14.75H11C11.96 14.75 12.75 13.96 12.75 13V4.75H13C13.41 4.75 13.75 4.41 13.75 4C13.75 3.59 13.41 3.25 13 3.25ZM6.75 3C6.75 2.86 6.86 2.75 7 2.75H9C9.14 2.75 9.25 2.86 9.25 3V3.25H6.75V3ZM11.25 13C11.25 13.14 11.14 13.25 11 13.25H5C4.86 13.25 4.75 13.14 4.75 13V4.75H11.25V13ZM9.25 6.25C9.66 6.25 10 6.59 10 7V11C10 11.41 9.66 11.75 9.25 11.75C8.84 11.75 8.5 11.41 8.5 11V7C8.5 6.59 8.84 6.25 9.25 6.25ZM7.5 7V11C7.5 11.41 7.16 11.75 6.75 11.75C6.34 11.75 6 11.41 6 11V7C6 6.59 6.34 6.25 6.75 6.25C7.16 6.25 7.5 6.59 7.5 7Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/delete-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/delete-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.75 9V17C12.75 17.41 12.41 17.75 12 17.75C11.59 17.75 11.25 17.41 11.25 17V9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9ZM14.25 9V17C14.25 17.41 14.59 17.75 15 17.75C15.41 17.75 15.75 17.41 15.75 17V9C15.75 8.59 15.41 8.25 15 8.25C14.59 8.25 14.25 8.59 14.25 9ZM9 8.25C8.59 8.25 8.25 8.59 8.25 9V17C8.25 17.41 8.59 17.75 9 17.75C9.41 17.75 9.75 17.41 9.75 17V9C9.75 8.59 9.41 8.25 9 8.25ZM20.75 6C20.75 6.41 20.41 6.75 20 6.75H18.75V18C18.75 19.52 17.52 20.75 16 20.75H8C6.48 20.75 5.25 19.52 5.25 18V6.75H4C3.59 6.75 3.25 6.41 3.25 6C3.25 5.59 3.59 5.25 4 5.25H8.25V4C8.25 3.04 9.04 2.25 10 2.25H14C14.96 2.25 15.75 3.04 15.75 4V5.25H20C20.41 5.25 20.75 5.59 20.75 6ZM9.75 5.25H14.25V4C14.25 3.86 14.14 3.75 14 3.75H10C9.86 3.75 9.75 3.86 9.75 4V5.25ZM17.25 6.75H6.75V18C6.75 18.69 7.31 19.25 8 19.25H16C16.69 19.25 17.25 18.69 17.25 18V6.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/desktop-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/desktop-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22 14.25H20.75V7C20.75 5.48 19.52 4.25 18 4.25H6C4.48 4.25 3.25 5.48 3.25 7V14.25H2C1.59 14.25 1.25 14.59 1.25 15V17C1.25 18.52 2.58 19.75 4.22 19.75H19.77C21.41 19.75 22.74 18.52 22.74 17V15C22.74 14.59 22.4 14.25 21.99 14.25H22ZM4.75 7C4.75 6.31 5.31 5.75 6 5.75H18C18.69 5.75 19.25 6.31 19.25 7V14.25H4.75V7ZM21.25 17C21.25 17.69 20.59 18.25 19.78 18.25H4.22C3.41 18.25 2.75 17.69 2.75 17V15.75H21.25V17Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/download-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v2/download-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.75 16V18C20.75 19.52 19.52 20.75 18 20.75H6C4.48 20.75 3.25 19.52 3.25 18V16C3.25 15.59 3.59 15.25 4 15.25C4.41 15.25 4.75 15.59 4.75 16V18C4.75 18.69 5.31 19.25 6 19.25H18C18.69 19.25 19.25 18.69 19.25 18V16C19.25 15.59 19.59 15.25 20 15.25C20.41 15.25 20.75 15.59 20.75 16ZM11.47 16.53C11.54 16.6 11.62 16.65 11.71 16.69C11.8 16.73 11.9 16.75 12 16.75C12.1 16.75 12.2 16.73 12.29 16.69C12.38 16.65 12.46 16.6 12.53 16.53L16.53 12.53C16.82 12.24 16.82 11.76 16.53 11.47C16.24 11.18 15.76 11.18 15.47 11.47L12.75 14.19V4C12.75 3.59 12.41 3.25 12 3.25C11.59 3.25 11.25 3.59 11.25 4V14.19L8.53 11.47C8.24 11.18 7.76 11.18 7.47 11.47C7.18 11.76 7.18 12.24 7.47 12.53L11.47 16.53Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/drag-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/drag-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.5 8.75C15.19 8.75 15.75 8.19 15.75 7.5C15.75 6.81 15.19 6.25 14.5 6.25C13.81 6.25 13.25 6.81 13.25 7.5C13.25 8.19 13.81 8.75 14.5 8.75ZM14.5 7.25C14.64 7.25 14.75 7.36 14.75 7.5C14.75 7.78 14.25 7.78 14.25 7.5C14.25 7.36 14.36 7.25 14.5 7.25ZM9.5 6.25C8.81 6.25 8.25 6.81 8.25 7.5C8.25 8.19 8.81 8.75 9.5 8.75C10.19 8.75 10.75 8.19 10.75 7.5C10.75 6.81 10.19 6.25 9.5 6.25ZM9.25 7.5C9.25 7.36 9.36 7.25 9.5 7.25C9.64 7.25 9.75 7.36 9.75 7.5C9.75 7.78 9.25 7.78 9.25 7.5ZM14.5 11.25C13.81 11.25 13.25 11.81 13.25 12.5C13.25 13.19 13.81 13.75 14.5 13.75C15.19 13.75 15.75 13.19 15.75 12.5C15.75 11.81 15.19 11.25 14.5 11.25ZM14.25 12.5C14.25 12.36 14.36 12.25 14.5 12.25C14.64 12.25 14.75 12.36 14.75 12.5C14.75 12.78 14.25 12.78 14.25 12.5ZM9.5 11.25C8.81 11.25 8.25 11.81 8.25 12.5C8.25 13.19 8.81 13.75 9.5 13.75C10.19 13.75 10.75 13.19 10.75 12.5C10.75 11.81 10.19 11.25 9.5 11.25ZM9.25 12.5C9.25 12.36 9.36 12.25 9.5 12.25C9.64 12.25 9.75 12.36 9.75 12.5C9.75 12.78 9.25 12.78 9.25 12.5ZM14.5 16.25C13.81 16.25 13.25 16.81 13.25 17.5C13.25 18.19 13.81 18.75 14.5 18.75C15.19 18.75 15.75 18.19 15.75 17.5C15.75 16.81 15.19 16.25 14.5 16.25ZM14.25 17.5C14.25 17.36 14.36 17.25 14.5 17.25C14.64 17.25 14.75 17.36 14.75 17.5C14.75 17.78 14.25 17.78 14.25 17.5ZM9.5 16.25C8.81 16.25 8.25 16.81 8.25 17.5C8.25 18.19 8.81 18.75 9.5 18.75C10.19 18.75 10.75 18.19 10.75 17.5C10.75 16.81 10.19 16.25 9.5 16.25ZM9.25 17.5C9.25 17.36 9.36 17.25 9.5 17.25C9.64 17.25 9.75 17.36 9.75 17.5C9.75 17.78 9.25 17.78 9.25 17.5Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/draghorizontal-24x16.svg":
/*!************************************************!*\
  !*** ./src/images-v2/draghorizontal-24x16.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.5 9.25C16.81 9.25 16.25 9.81 16.25 10.5C16.25 11.19 16.81 11.75 17.5 11.75C18.19 11.75 18.75 11.19 18.75 10.5C18.75 9.81 18.19 9.25 17.5 9.25ZM17.25 10.5C17.25 10.36 17.36 10.25 17.5 10.25C17.64 10.25 17.75 10.36 17.75 10.5C17.75 10.78 17.25 10.78 17.25 10.5ZM17.5 6.75C18.19 6.75 18.75 6.19 18.75 5.5C18.75 4.81 18.19 4.25 17.5 4.25C16.81 4.25 16.25 4.81 16.25 5.5C16.25 6.19 16.81 6.75 17.5 6.75ZM17.5 5.25C17.64 5.25 17.75 5.36 17.75 5.5C17.75 5.78 17.25 5.78 17.25 5.5C17.25 5.36 17.36 5.25 17.5 5.25ZM12.5 9.25C11.81 9.25 11.25 9.81 11.25 10.5C11.25 11.19 11.81 11.75 12.5 11.75C13.19 11.75 13.75 11.19 13.75 10.5C13.75 9.81 13.19 9.25 12.5 9.25ZM12.25 10.5C12.25 10.36 12.36 10.25 12.5 10.25C12.64 10.25 12.75 10.36 12.75 10.5C12.75 10.78 12.25 10.78 12.25 10.5ZM12.5 4.25C11.81 4.25 11.25 4.81 11.25 5.5C11.25 6.19 11.81 6.75 12.5 6.75C13.19 6.75 13.75 6.19 13.75 5.5C13.75 4.81 13.19 4.25 12.5 4.25ZM12.25 5.5C12.25 5.36 12.36 5.25 12.5 5.25C12.64 5.25 12.75 5.36 12.75 5.5C12.75 5.78 12.25 5.78 12.25 5.5ZM7.5 9.25C6.81 9.25 6.25 9.81 6.25 10.5C6.25 11.19 6.81 11.75 7.5 11.75C8.19 11.75 8.75 11.19 8.75 10.5C8.75 9.81 8.19 9.25 7.5 9.25ZM7.25 10.5C7.25 10.36 7.36 10.25 7.5 10.25C7.64 10.25 7.75 10.36 7.75 10.5C7.75 10.78 7.25 10.78 7.25 10.5ZM7.5 4.25C6.81 4.25 6.25 4.81 6.25 5.5C6.25 6.19 6.81 6.75 7.5 6.75C8.19 6.75 8.75 6.19 8.75 5.5C8.75 4.81 8.19 4.25 7.5 4.25ZM7.25 5.5C7.25 5.36 7.36 5.25 7.5 5.25C7.64 5.25 7.75 5.36 7.75 5.5C7.75 5.78 7.25 5.78 7.25 5.5Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/draghorizontalsmall-24x16.svg":
/*!*****************************************************!*\
  !*** ./src/images-v2/draghorizontalsmall-24x16.svg ***!
  \*****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.5 9.25C15.81 9.25 15.25 9.81 15.25 10.5C15.25 11.19 15.81 11.75 16.5 11.75C17.19 11.75 17.75 11.19 17.75 10.5C17.75 9.81 17.19 9.25 16.5 9.25ZM16.25 10.5C16.25 10.36 16.36 10.25 16.5 10.25C16.64 10.25 16.75 10.36 16.75 10.5C16.75 10.78 16.25 10.78 16.25 10.5ZM16.5 7.75C17.19 7.75 17.75 7.19 17.75 6.5C17.75 5.81 17.19 5.25 16.5 5.25C15.81 5.25 15.25 5.81 15.25 6.5C15.25 7.19 15.81 7.75 16.5 7.75ZM16.5 6.25C16.64 6.25 16.75 6.36 16.75 6.5C16.75 6.78 16.25 6.78 16.25 6.5C16.25 6.36 16.36 6.25 16.5 6.25ZM12.5 9.25C11.81 9.25 11.25 9.81 11.25 10.5C11.25 11.19 11.81 11.75 12.5 11.75C13.19 11.75 13.75 11.19 13.75 10.5C13.75 9.81 13.19 9.25 12.5 9.25ZM12.25 10.5C12.25 10.36 12.36 10.25 12.5 10.25C12.64 10.25 12.75 10.36 12.75 10.5C12.75 10.78 12.25 10.78 12.25 10.5ZM12.5 5.25C11.81 5.25 11.25 5.81 11.25 6.5C11.25 7.19 11.81 7.75 12.5 7.75C13.19 7.75 13.75 7.19 13.75 6.5C13.75 5.81 13.19 5.25 12.5 5.25ZM12.25 6.5C12.25 6.36 12.36 6.25 12.5 6.25C12.64 6.25 12.75 6.36 12.75 6.5C12.75 6.78 12.25 6.78 12.25 6.5ZM8.5 9.25C7.81 9.25 7.25 9.81 7.25 10.5C7.25 11.19 7.81 11.75 8.5 11.75C9.19 11.75 9.75 11.19 9.75 10.5C9.75 9.81 9.19 9.25 8.5 9.25ZM8.25 10.5C8.25 10.36 8.36 10.25 8.5 10.25C8.64 10.25 8.75 10.36 8.75 10.5C8.75 10.78 8.25 10.78 8.25 10.5ZM8.5 5.25C7.81 5.25 7.25 5.81 7.25 6.5C7.25 7.19 7.81 7.75 8.5 7.75C9.19 7.75 9.75 7.19 9.75 6.5C9.75 5.81 9.19 5.25 8.5 5.25ZM8.25 6.5C8.25 6.36 8.36 6.25 8.5 6.25C8.64 6.25 8.75 6.36 8.75 6.5C8.75 6.78 8.25 6.78 8.25 6.5Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/dropper-16x16.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/dropper-16x16.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3.31 15C2.69 15 2.11 14.76 1.68 14.32C0.780005 13.42 0.780005 11.95 1.68 11.05L2.45 10.28C2.45 10.18 2.44 10.08 2.44 9.98C2.44 9.02 2.81 8.12 3.49 7.44L5.6 5.33C5.37 5.04 5.25 4.68 5.25 4.31C5.25 3.86 5.42 3.44 5.74 3.12C6.06 2.8 6.48 2.63 6.92 2.63C7.29 2.63 7.65 2.75 7.94 2.98L8.88 2.04C9.56001 1.36 10.46 0.989998 11.41 0.989998C12.36 0.989998 13.27 1.36 13.95 2.04C14.63 2.72 15 3.62 15 4.58C15 5.54 14.63 6.44 13.95 7.12L12.94 8.13C13.04 8.34 13.09 8.58 13.09 8.82C13.09 9.27 12.92 9.69 12.6 10C12.28 10.31 11.86 10.49 11.42 10.49C11.18 10.49 10.94 10.44 10.73 10.34L8.56 12.51C7.88 13.19 6.98 13.56 6.03 13.56C5.93001 13.56 5.83 13.56 5.73 13.54L4.97 14.3C4.53 14.74 3.95 14.98 3.34 14.98L3.31 15Z\" fill=\"black\" fill-opacity=\"0.15\"></path><path d=\"M14 4.58C14 3.89 13.73 3.24 13.24 2.75C12.23 1.74 10.59 1.74 9.58 2.75L7.94 4.39L7.39 3.84C7.13 3.58 6.7 3.58 6.44 3.84C6.18 4.1 6.18 4.53 6.44 4.79L6.99 5.34L4.18 8.15C3.69 8.64 3.42 9.29 3.42 9.98C3.42 10.2 3.46 10.41 3.51 10.62L2.38 11.75C1.87 12.26 1.87 13.09 2.38 13.61C2.64 13.87 2.97 13.99 3.31 13.99C3.65 13.99 3.98 13.86 4.24 13.61L5.37 12.48C5.58 12.53 5.79 12.57 6.01 12.57C6.7 12.57 7.35 12.3 7.84 11.81L10.65 9L10.94 9.29C11.07 9.42 11.24 9.49 11.42 9.49C11.6 9.49 11.77 9.42 11.9 9.29C12.16 9.03 12.16 8.6 11.9 8.34L11.61 8.05L13.25 6.41C13.74 5.92 14.01 5.27 14.01 4.58H14ZM6.89 10.86C6.42 11.33 5.61 11.33 5.14 10.86C4.91 10.63 4.78 10.32 4.78 9.99C4.78 9.66 4.91 9.35 5.14 9.12L7.95 6.31L9.7 8.06L6.89 10.87V10.86Z\" fill=\"white\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/edit-16x16.svg":
/*!**************************************!*\
  !*** ./src/images-v2/edit-16x16.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.1209 2.0525L13.9509 1.8825C12.8809 0.812502 11.1309 0.812502 10.0609 1.8825L2.47089 9.4625C2.37089 9.5625 2.31089 9.6825 2.27089 9.8125L1.27089 13.8125C1.21089 14.0625 1.28089 14.3425 1.47089 14.5225C1.61089 14.6625 1.80089 14.7425 2.00089 14.7425C2.06089 14.7425 2.12089 14.7425 2.18089 14.7225L6.18089 13.7225C6.31089 13.6925 6.43089 13.6225 6.53089 13.5225L14.1209 5.9325C15.1909 4.8625 15.1909 3.1125 14.1209 2.0425V2.0525ZM5.62089 12.3125L3.04089 12.9625L3.69089 10.3825L9.00089 5.0525L10.9409 6.9925L5.62089 12.3125ZM13.0609 4.8725L12.0009 5.9325L10.0609 3.9925L11.1209 2.9325C11.6109 2.4425 12.4009 2.4425 12.8909 2.9325L13.0609 3.1025C13.5509 3.5925 13.5509 4.3825 13.0609 4.8725Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/edit-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/edit-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.1301 6.05249L17.9601 3.88249C16.8901 2.81249 15.1401 2.81249 14.0701 3.88249L4.48014 13.4625C4.37014 13.5725 4.30014 13.7125 4.27014 13.8725L3.26014 19.8725C3.22014 20.1125 3.30014 20.3525 3.47014 20.5225C3.61014 20.6625 3.80014 20.7425 4.00014 20.7425C4.04014 20.7425 4.08014 20.7425 4.12014 20.7425L10.1201 19.7425C10.2701 19.7125 10.4201 19.6425 10.5301 19.5325L20.1201 9.94249C20.6401 9.42249 20.9301 8.73249 20.9301 8.00249C20.9301 7.27249 20.6401 6.57249 20.1201 6.06249L20.1301 6.05249ZM16.0101 11.9325L12.0701 7.99249L13.0101 7.05249L16.9501 10.9925L16.0101 11.9325ZM9.65014 18.2925L4.92014 19.0825L5.71014 14.3525L11.0101 9.05249L14.9501 12.9925L9.65014 18.2925ZM19.0701 8.87249L18.0101 9.93249L14.0701 5.99249L15.1301 4.93249C15.6201 4.44249 16.4101 4.44249 16.9001 4.93249L19.0701 7.10249C19.3101 7.34249 19.4401 7.65249 19.4401 7.98249C19.4401 8.31249 19.3101 8.63249 19.0701 8.86249V8.87249Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/editsmall-16x16.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/editsmall-16x16.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.1209 3.0525L12.9509 2.8825C11.8809 1.8125 10.1309 1.8125 9.06089 2.8825L3.47089 8.4625C3.37089 8.5625 3.31089 8.6825 3.27089 8.8125L2.27089 12.8125C2.21089 13.0625 2.28089 13.3425 2.47089 13.5225C2.61089 13.6625 2.80089 13.7425 3.00089 13.7425C3.06089 13.7425 3.12089 13.7425 3.18089 13.7225L7.18089 12.7225C7.31089 12.6925 7.43089 12.6225 7.53089 12.5225L13.1209 6.9325C14.1909 5.8625 14.1909 4.1125 13.1209 3.0425V3.0525ZM6.62089 11.3125L4.04089 11.9625L4.69089 9.3825L8.01089 6.0625L9.95089 8.0025L6.63089 11.3225L6.62089 11.3125ZM12.0609 5.8725L11.0009 6.9325L9.06089 4.9925L10.1209 3.9325C10.6109 3.4425 11.4009 3.4425 11.8909 3.9325L12.0609 4.1025C12.5509 4.5925 12.5509 5.3825 12.0609 5.8725Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/embedsurvey-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v2/embedsurvey-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 14.41V23H11V14.41L8.71 16.7L7.3 15.29L12.01 10.58L16.72 15.29L15.31 16.7L13.02 14.41H13ZM20 3H4C2.9 3 2 3.9 2 5V19C2 20.1 2.9 21 4 21H9V19H4V5H20V19H15V21H20C21.1 21 22 20.1 22 19V5C22 3.9 21.1 3 20 3ZM5 6V8H8V6H5ZM19 6H9V8H19V6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/error-16x16.svg":
/*!***************************************!*\
  !*** ./src/images-v2/error-16x16.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 1.25C4.28 1.25 1.25 4.28 1.25 8C1.25 11.72 4.28 14.75 8 14.75C11.72 14.75 14.75 11.72 14.75 8C14.75 4.28 11.72 1.25 8 1.25ZM8 13.25C5.11 13.25 2.75 10.89 2.75 8C2.75 5.11 5.11 2.75 8 2.75C10.89 2.75 13.25 5.11 13.25 8C13.25 10.89 10.89 13.25 8 13.25ZM10.53 6.53L9.06 8L10.53 9.47C10.82 9.76 10.82 10.24 10.53 10.53C10.38 10.68 10.19 10.75 10 10.75C9.81 10.75 9.62 10.68 9.47 10.53L8 9.06L6.53 10.53C6.38 10.68 6.19 10.75 6 10.75C5.81 10.75 5.62 10.68 5.47 10.53C5.18 10.24 5.18 9.76 5.47 9.47L6.94 8L5.47 6.53C5.18 6.24 5.18 5.76 5.47 5.47C5.76 5.18 6.24 5.18 6.53 5.47L8 6.94L9.47 5.47C9.76 5.18 10.24 5.18 10.53 5.47C10.82 5.76 10.82 6.24 10.53 6.53Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/error-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v2/error-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 5.25C8.28 5.25 5.25 8.28 5.25 12C5.25 15.72 8.28 18.75 12 18.75C15.72 18.75 18.75 15.72 18.75 12C18.75 8.28 15.72 5.25 12 5.25ZM12 17.25C9.11 17.25 6.75 14.89 6.75 12C6.75 9.11 9.11 6.75 12 6.75C14.89 6.75 17.25 9.11 17.25 12C17.25 14.89 14.89 17.25 12 17.25ZM14.53 10.53L13.06 12L14.53 13.47C14.82 13.76 14.82 14.24 14.53 14.53C14.38 14.68 14.19 14.75 14 14.75C13.81 14.75 13.62 14.68 13.47 14.53L12 13.06L10.53 14.53C10.38 14.68 10.19 14.75 10 14.75C9.81 14.75 9.62 14.68 9.47 14.53C9.18 14.24 9.18 13.76 9.47 13.47L10.94 12L9.47 10.53C9.18 10.24 9.18 9.76 9.47 9.47C9.76 9.18 10.24 9.18 10.53 9.47L12 10.94L13.47 9.47C13.76 9.18 14.24 9.18 14.53 9.47C14.82 9.76 14.82 10.24 14.53 10.53Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/expand-16x16.svg":
/*!****************************************!*\
  !*** ./src/images-v2/expand-16x16.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.75 8C11.75 8.41 11.41 8.75 11 8.75H8.75V11C8.75 11.41 8.41 11.75 8 11.75C7.59 11.75 7.25 11.41 7.25 11V8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H7.25V5C7.25 4.59 7.59 4.25 8 4.25C8.41 4.25 8.75 4.59 8.75 5V7.25H11C11.41 7.25 11.75 7.59 11.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/expand-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/expand-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.4675 7.53C7.1775 7.24 7.1775 6.76 7.4675 6.47L11.4675 2.47C11.5375 2.4 11.6175 2.35 11.7075 2.31C11.8875 2.23 12.0975 2.23 12.2775 2.31C12.3675 2.35 12.4475 2.4 12.5175 2.47L16.5175 6.47C16.8075 6.76 16.8075 7.24 16.5175 7.53C16.3675 7.68 16.1775 7.75 15.9875 7.75C15.7975 7.75 15.6075 7.68 15.4575 7.53L12.7375 4.81V10C12.7375 10.41 12.3975 10.75 11.9875 10.75C11.5775 10.75 11.2375 10.41 11.2375 10V4.81L8.5175 7.53C8.2275 7.82 7.7475 7.82 7.4575 7.53H7.4675ZM15.4675 16.47L12.7475 19.19V14C12.7475 13.59 12.4075 13.25 11.9975 13.25C11.5875 13.25 11.2475 13.59 11.2475 14V19.19L8.5275 16.47C8.2375 16.18 7.7575 16.18 7.4675 16.47C7.1775 16.76 7.1775 17.24 7.4675 17.53L11.4675 21.53C11.5375 21.6 11.6175 21.65 11.7075 21.69C11.7975 21.73 11.8975 21.75 11.9975 21.75C12.0975 21.75 12.1975 21.73 12.2875 21.69C12.3775 21.65 12.4575 21.6 12.5275 21.53L16.5275 17.53C16.8175 17.24 16.8175 16.76 16.5275 16.47C16.2375 16.18 15.7575 16.18 15.4675 16.47Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/expand-pg-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/expand-pg-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.53 14.47C6.82 14.76 6.82 15.24 6.53 15.53C6.38 15.68 6.19 15.75 6 15.75C5.81 15.75 5.62 15.68 5.47 15.53L2.47 12.53C2.4 12.46 2.35 12.38 2.31 12.29C2.23 12.11 2.23 11.9 2.31 11.72C2.35 11.63 2.4 11.55 2.47 11.48L5.47 8.48C5.76 8.19 6.24 8.19 6.53 8.48C6.82 8.77 6.82 9.25 6.53 9.54L4.81 11.26H13C13.41 11.26 13.75 11.6 13.75 12.01C13.75 12.42 13.41 12.76 13 12.76H4.81L6.53 14.48V14.47ZM18 3.25H12C10.48 3.25 9.25 4.48 9.25 6V9C9.25 9.41 9.59 9.75 10 9.75C10.41 9.75 10.75 9.41 10.75 9V6C10.75 5.31 11.31 4.75 12 4.75H18C18.69 4.75 19.25 5.31 19.25 6V18C19.25 18.69 18.69 19.25 18 19.25H12C11.31 19.25 10.75 18.69 10.75 18V15C10.75 14.59 10.41 14.25 10 14.25C9.59 14.25 9.25 14.59 9.25 15V18C9.25 19.52 10.48 20.75 12 20.75H18C19.52 20.75 20.75 19.52 20.75 18V6C20.75 4.48 19.52 3.25 18 3.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/expandall-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/expandall-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.47 5.53C8.18 5.24 8.18 4.76 8.47 4.47L11.47 1.47C11.54 1.4 11.62 1.35 11.71 1.31C11.89 1.23 12.1 1.23 12.28 1.31C12.37 1.35 12.45 1.4 12.52 1.47L15.52 4.47C15.81 4.76 15.81 5.24 15.52 5.53C15.37 5.68 15.18 5.75 14.99 5.75C14.8 5.75 14.61 5.68 14.46 5.53L12.74 3.81V9C12.74 9.41 12.4 9.75 11.99 9.75C11.58 9.75 11.24 9.41 11.24 9V3.81L9.52 5.53C9.23 5.82 8.75 5.82 8.46 5.53H8.47ZM14.47 18.47L12.75 20.19V15C12.75 14.59 12.41 14.25 12 14.25C11.59 14.25 11.25 14.59 11.25 15V20.19L9.53 18.47C9.24 18.18 8.76 18.18 8.47 18.47C8.18 18.76 8.18 19.24 8.47 19.53L11.47 22.53C11.54 22.6 11.62 22.65 11.71 22.69C11.8 22.73 11.9 22.75 12 22.75C12.1 22.75 12.2 22.73 12.29 22.69C12.38 22.65 12.46 22.6 12.53 22.53L15.53 19.53C15.82 19.24 15.82 18.76 15.53 18.47C15.24 18.18 14.76 18.18 14.47 18.47ZM19 8.25H16C15.59 8.25 15.25 8.59 15.25 9C15.25 9.41 15.59 9.75 16 9.75H19C19.69 9.75 20.25 10.31 20.25 11V13C20.25 13.69 19.69 14.25 19 14.25H16C15.59 14.25 15.25 14.59 15.25 15C15.25 15.41 15.59 15.75 16 15.75H19C20.52 15.75 21.75 14.52 21.75 13V11C21.75 9.48 20.52 8.25 19 8.25ZM8.75 15C8.75 14.59 8.41 14.25 8 14.25H5C4.31 14.25 3.75 13.69 3.75 13V11C3.75 10.31 4.31 9.75 5 9.75H8C8.41 9.75 8.75 9.41 8.75 9C8.75 8.59 8.41 8.25 8 8.25H5C3.48 8.25 2.25 9.48 2.25 11V13C2.25 14.52 3.48 15.75 5 15.75H8C8.41 15.75 8.75 15.41 8.75 15Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/expanddetails-16x16.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/expanddetails-16x16.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.75 8C11.75 8.41 11.41 8.75 11 8.75H8.75V11C8.75 11.41 8.41 11.75 8 11.75C7.59 11.75 7.25 11.41 7.25 11V8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H7.25V5C7.25 4.59 7.59 4.25 8 4.25C8.41 4.25 8.75 4.59 8.75 5V7.25H11C11.41 7.25 11.75 7.59 11.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/expandfocused-16x16.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/expandfocused-16x16.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_22167_104453)\"><path d=\"M11.75 8C11.75 8.41 11.41 8.75 11 8.75H8.75V11C8.75 11.41 8.41 11.75 8 11.75C7.59 11.75 7.25 11.41 7.25 11V8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H7.25V5C7.25 4.59 7.59 4.25 8 4.25C8.41 4.25 8.75 4.59 8.75 5V7.25H11C11.41 7.25 11.75 7.59 11.75 8Z\"></path><path d=\"M13 3C13 1.35 11.65 0 10 0H6C4.35 0 3 1.35 3 3C1.35 3 0 4.35 0 6V10C0 11.65 1.35 13 3 13C3 14.65 4.35 16 6 16H10C11.65 16 13 14.65 13 13C14.65 13 16 11.65 16 10V6C16 4.35 14.65 3 13 3ZM14 10C14 10.55 13.55 11 13 11H12C11.45 11 11 11.45 11 12V13C11 13.55 10.55 14 10 14H6C5.45 14 5 13.55 5 13V12C5 11.45 4.55 11 4 11H3C2.45 11 2 10.55 2 10V6C2 5.45 2.45 5 3 5H4C4.55 5 5 4.55 5 4V3C5 2.45 5.45 2 6 2H10C10.55 2 11 2.45 11 3V4C11 4.55 11.45 5 12 5H13C13.55 5 14 5.45 14 6V10Z\"></path></g><defs><clipPath id=\"clip0_22167_104453\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v2/expandpage-16x16.svg":
/*!********************************************!*\
  !*** ./src/images-v2/expandpage-16x16.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.53 3.47C10.82 3.76 10.82 4.24 10.53 4.53C10.38 4.68 10.19 4.75 10 4.75C9.81 4.75 9.62 4.68 9.47 4.53L8.75 3.81V6C8.75 6.41 8.41 6.75 8 6.75C7.59 6.75 7.25 6.41 7.25 6V3.81L6.53 4.53C6.24 4.82 5.76 4.82 5.47 4.53C5.18 4.24 5.18 3.76 5.47 3.47L7.47 1.47C7.54 1.4 7.62 1.35 7.71 1.31C7.89 1.23 8.1 1.23 8.28 1.31C8.37 1.35 8.45 1.4 8.52 1.47L10.52 3.47H10.53ZM9.47 11.47L8.75 12.19V10C8.75 9.59 8.41 9.25 8 9.25C7.59 9.25 7.25 9.59 7.25 10V12.19L6.53 11.47C6.24 11.18 5.76 11.18 5.47 11.47C5.18 11.76 5.18 12.24 5.47 12.53L7.47 14.53C7.54 14.6 7.62 14.65 7.71 14.69C7.8 14.73 7.9 14.75 8 14.75C8.1 14.75 8.2 14.73 8.29 14.69C8.38 14.65 8.46 14.6 8.53 14.53L10.53 12.53C10.82 12.24 10.82 11.76 10.53 11.47C10.24 11.18 9.76 11.18 9.47 11.47ZM3 3.75C3.41 3.75 3.75 3.41 3.75 3C3.75 2.59 3.41 2.25 3 2.25C2.04 2.25 1.25 3.04 1.25 4V12C1.25 12.96 2.04 13.75 3 13.75C3.41 13.75 3.75 13.41 3.75 13C3.75 12.59 3.41 12.25 3 12.25C2.86 12.25 2.75 12.14 2.75 12V4C2.75 3.86 2.86 3.75 3 3.75ZM13 2.25C12.59 2.25 12.25 2.59 12.25 3C12.25 3.41 12.59 3.75 13 3.75C13.14 3.75 13.25 3.86 13.25 4V12C13.25 12.14 13.14 12.25 13 12.25C12.59 12.25 12.25 12.59 12.25 13C12.25 13.41 12.59 13.75 13 13.75C13.96 13.75 14.75 12.96 14.75 12V4C14.75 3.04 13.96 2.25 13 2.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/expandpanel-16x16.svg":
/*!*********************************************!*\
  !*** ./src/images-v2/expandpanel-16x16.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 3.25H5C4.04 3.25 3.25 4.04 3.25 5V11C3.25 11.96 4.04 12.75 5 12.75H11C11.96 12.75 12.75 11.96 12.75 11V5C12.75 4.04 11.96 3.25 11 3.25ZM11.25 11C11.25 11.14 11.14 11.25 11 11.25H5C4.86 11.25 4.75 11.14 4.75 11V5C4.75 4.86 4.86 4.75 5 4.75H11C11.14 4.75 11.25 4.86 11.25 5V11Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/file-72x72.svg":
/*!**************************************!*\
  !*** ./src/images-v2/file-72x72.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 72 72\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M62.83 12.83L53.17 3.17C52.7982 2.79866 52.357 2.50421 51.8714 2.30346C51.3858 2.1027 50.8654 1.99959 50.34 2H14C12.4087 2 10.8826 2.63214 9.75735 3.75736C8.63214 4.88258 8 6.4087 8 8V64C8 65.5913 8.63214 67.1174 9.75735 68.2426C10.8826 69.3679 12.4087 70 14 70H58C59.5913 70 61.1174 69.3679 62.2426 68.2426C63.3679 67.1174 64 65.5913 64 64V15.66C64.0004 15.1346 63.8973 14.6142 63.6965 14.1286C63.4958 13.643 63.2013 13.2018 62.83 12.83ZM52 4.83L61.17 14H56C54.9391 14 53.9217 13.5786 53.1716 12.8284C52.4214 12.0783 52 11.0609 52 10V4.83ZM62 64C62 65.0609 61.5786 66.0783 60.8284 66.8284C60.0783 67.5786 59.0609 68 58 68H14C12.9391 68 11.9217 67.5786 11.1716 66.8284C10.4214 66.0783 10 65.0609 10 64V8C10 6.93914 10.4214 5.92172 11.1716 5.17157C11.9217 4.42143 12.9391 4 14 4H50V10C50 11.5913 50.6321 13.1174 51.7574 14.2426C52.8826 15.3679 54.4087 16 56 16H62V64ZM22 26H50V28H22V26ZM22 32H50V34H22V32ZM22 38H50V40H22V38ZM22 44H50V46H22V44Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/finishedit-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v2/finishedit-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.5301 8.53249L13.0001 7.06249L16.9401 11.0025L15.4701 12.4725C15.1801 12.7625 15.1801 13.2425 15.4701 13.5325C15.6201 13.6825 15.8101 13.7525 16.0001 13.7525C16.1901 13.7525 16.3801 13.6825 16.5301 13.5325L20.1201 9.94249C21.1901 8.87249 21.1901 7.12249 20.1201 6.05249L17.9501 3.88249C16.8801 2.81249 15.1301 2.81249 14.0601 3.88249L10.4701 7.47249C10.1801 7.76249 10.1801 8.24249 10.4701 8.53249C10.7601 8.82249 11.2401 8.82249 11.5301 8.53249ZM16.8801 4.94249L19.0501 7.11249C19.5401 7.60249 19.5401 8.39249 19.0501 8.88249L17.9901 9.94249L14.0501 6.00249L15.1101 4.94249C15.6001 4.45249 16.3901 4.45249 16.8801 4.94249ZM13.5301 15.4725C13.8201 15.7625 13.8201 16.2425 13.5301 16.5325L10.5301 19.5325C10.4201 19.6425 10.2801 19.7125 10.1201 19.7425L4.12014 20.7425C4.12014 20.7425 4.04014 20.7425 4.00014 20.7425C3.80014 20.7425 3.61014 20.6625 3.47014 20.5225C3.30014 20.3525 3.22014 20.1025 3.26014 19.8725L4.26014 13.8725C4.29014 13.7225 4.36014 13.5725 4.47014 13.4625L7.47014 10.4625C7.76014 10.1725 8.24014 10.1725 8.53014 10.4625C8.82014 10.7525 8.82014 11.2325 8.53014 11.5225L5.70014 14.3525L4.91014 19.0825L9.64014 18.2925L12.4701 15.4625C12.7601 15.1725 13.2401 15.1725 13.5301 15.4625V15.4725ZM20.5301 19.4725C20.8201 19.7625 20.8201 20.2425 20.5301 20.5325C20.3801 20.6825 20.1901 20.7525 20.0001 20.7525C19.8101 20.7525 19.6201 20.6825 19.4701 20.5325L3.47014 4.53249C3.18014 4.24249 3.18014 3.76249 3.47014 3.47249C3.76014 3.18249 4.24014 3.18249 4.53014 3.47249L20.5301 19.4725Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/fix-24x24.svg":
/*!*************************************!*\
  !*** ./src/images-v2/fix-24x24.svg ***!
  \*************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_21942_302540)\"><path d=\"M8.71 11.2901L5.71 8.29006C5.32 7.90006 4.69 7.90006 4.3 8.29006C3.91 8.68006 3.91 9.31006 4.3 9.70006L5.59 10.9901H1C0.45 10.9901 0 11.4401 0 11.9901C0 12.5401 0.45 12.9901 1 12.9901H5.59L4.3 14.2801C3.91 14.6701 3.91 15.3001 4.3 15.6901C4.5 15.8901 4.75 15.9801 5.01 15.9801C5.27 15.9801 5.52 15.8801 5.72 15.6901L8.72 12.6901C8.81 12.6001 8.89 12.4901 8.94 12.3601C9.04 12.1201 9.04 11.8401 8.94 11.6001C8.89 11.4801 8.82 11.3701 8.72 11.2701L8.71 11.2901Z\"></path><path d=\"M15.71 10.29C15.32 9.89999 14.69 9.89999 14.3 10.29C13.91 10.68 13.91 11.31 14.3 11.7L16.3 13.7C16.5 13.9 16.75 13.99 17.01 13.99C17.27 13.99 17.52 13.89 17.72 13.7L23.72 7.69999C24.11 7.30999 24.11 6.67999 23.72 6.28999C23.33 5.89999 22.7 5.89999 22.31 6.28999L21.05 7.54999C19.99 6.57999 18.57 5.98999 17.02 5.98999C13.71 5.98999 11.02 8.67999 11.02 11.99C11.02 15.3 13.71 17.99 17.02 17.99C20.33 17.99 23.02 15.3 23.02 11.99C23.02 11.5 22.96 11.03 22.85 10.58L20.98 12.45C20.75 14.44 19.07 15.99 17.03 15.99C14.82 15.99 13.03 14.2 13.03 11.99C13.03 9.77999 14.82 7.98999 17.03 7.98999C18.03 7.98999 18.93 8.36999 19.63 8.97999L17.03 11.58L15.74 10.29H15.71Z\"></path></g><defs><clipPath id=\"clip0_21942_302540\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v2/flip-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/flip-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.53 17.4775C14.82 17.7675 14.82 18.2475 14.53 18.5375L11.53 21.5375C11.38 21.6875 11.19 21.7575 11 21.7575C10.81 21.7575 10.62 21.6875 10.47 21.5375C10.18 21.2475 10.18 20.7675 10.47 20.4775L12.2 18.7475C12.13 18.7475 12.07 18.7475 12 18.7475C6.62 18.7475 2.25 15.7475 2.25 12.0575C2.25 10.2975 3.22 8.6375 4.99 7.3875C5.33 7.1475 5.8 7.2275 6.03 7.5675C6.27 7.9075 6.19 8.3775 5.85 8.6075C4.49 9.5675 3.74 10.7875 3.74 12.0575C3.74 14.9175 7.44 17.2475 11.99 17.2475C12.05 17.2475 12.11 17.2475 12.17 17.2475L10.46 15.5375C10.17 15.2475 10.17 14.7675 10.46 14.4775C10.75 14.1875 11.23 14.1875 11.52 14.4775L14.52 17.4775H14.53ZM12 5.2575C11.93 5.2575 11.87 5.2575 11.8 5.2575L13.53 3.5275C13.82 3.2375 13.82 2.7575 13.53 2.4675C13.24 2.1775 12.76 2.1775 12.47 2.4675L9.47 5.4675C9.18 5.7575 9.18 6.2375 9.47 6.5275L12.47 9.5275C12.62 9.6775 12.81 9.7475 13 9.7475C13.19 9.7475 13.38 9.6775 13.53 9.5275C13.82 9.2375 13.82 8.7575 13.53 8.4675L11.82 6.7575C11.88 6.7575 11.94 6.7575 12 6.7575C16.55 6.7575 20.25 9.0875 20.25 11.9475C20.25 13.2075 19.5 14.4375 18.14 15.3975C17.8 15.6375 17.72 16.1075 17.96 16.4475C18.11 16.6575 18.34 16.7675 18.57 16.7675C18.72 16.7675 18.87 16.7275 19 16.6275C20.77 15.3775 21.75 13.7175 21.75 11.9575C21.75 8.2675 17.38 5.2675 12 5.2675V5.2575Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/folder-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/folder-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.72 9.24C21.45 8.92 21.12 8.67 20.75 8.5V8C20.75 6.48 19.52 5.25 18 5.25H10.65C10.32 4.1 9.26 3.25 8 3.25H6C4.48 3.25 3.25 4.48 3.25 6V18C3.25 19.52 4.48 20.75 6 20.75H18.33C19.66 20.75 20.8 19.8 21.04 18.49L22.31 11.49C22.46 10.69 22.24 9.86 21.72 9.24ZM4.75 18V6C4.75 5.31 5.31 4.75 6 4.75H8C8.69 4.75 9.25 5.31 9.25 6C9.25 6.41 9.59 6.75 10 6.75H18C18.69 6.75 19.25 7.31 19.25 8V8.25H9.27C7.94 8.25 6.8 9.2 6.56 10.51L5.29 17.51C5.19 18.07 5.27 18.64 5.51 19.15C5.06 18.96 4.75 18.52 4.75 18ZM20.83 11.22L19.56 18.22C19.45 18.81 18.94 19.25 18.33 19.25H8C7.63 19.25 7.28 19.09 7.04 18.8C6.8 18.51 6.7 18.14 6.77 17.78L8.04 10.78C8.15 10.19 8.66 9.75 9.27 9.75H19.6C19.97 9.75 20.32 9.91 20.56 10.2C20.8 10.49 20.9 10.86 20.83 11.22Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/fullsize-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v2/fullsize-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 3.25H4C3.04 3.25 2.25 4.04 2.25 5V11C2.25 11.96 3.04 12.75 4 12.75H12C12.96 12.75 13.75 11.96 13.75 11V5C13.75 4.04 12.96 3.25 12 3.25ZM12.25 11C12.25 11.14 12.14 11.25 12 11.25H4C3.86 11.25 3.75 11.14 3.75 11V5C3.75 4.86 3.86 4.75 4 4.75H12C12.14 4.75 12.25 4.86 12.25 5V11Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/gear-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/gear-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.99 8.25C9.92 8.25 8.24 9.93 8.24 12C8.24 14.07 9.92 15.75 11.99 15.75C14.06 15.75 15.74 14.07 15.74 12C15.74 9.93 14.06 8.25 11.99 8.25ZM11.99 14.25C10.75 14.25 9.74 13.24 9.74 12C9.74 10.76 10.75 9.75 11.99 9.75C13.23 9.75 14.24 10.76 14.24 12C14.24 13.24 13.23 14.25 11.99 14.25ZM20.37 10.09L20.13 10.04C19.72 9.95 19.39 9.65 19.23 9.24C19.18 9.11 19.12 8.98 19.07 8.85C18.89 8.44 18.91 7.99 19.14 7.63L19.27 7.42C19.71 6.72 19.61 5.83 19.03 5.25L18.75 4.97C18.17 4.39 17.27 4.29 16.57 4.73L16.36 4.86C16.01 5.08 15.55 5.11 15.15 4.92C15.02 4.86 14.89 4.81 14.76 4.76C14.34 4.6 14.04 4.26 13.95 3.86L13.9 3.62C13.72 2.81 13.02 2.25 12.19 2.25H11.79C10.96 2.25 10.26 2.81 10.08 3.62L10.03 3.86C9.94 4.27 9.64 4.6 9.23 4.76C9.1 4.81 8.97 4.87 8.84 4.92C8.43 5.1 7.98 5.08 7.63 4.86L7.42 4.73C6.72 4.29 5.83 4.39 5.25 4.97L4.97 5.25C4.39 5.83 4.29 6.73 4.73 7.43L4.86 7.64C5.08 7.99 5.11 8.45 4.92 8.85C4.86 8.98 4.81 9.11 4.76 9.24C4.6 9.66 4.26 9.96 3.86 10.05L3.62 10.1C2.81 10.28 2.25 10.98 2.25 11.81V12.21C2.25 13.04 2.81 13.74 3.62 13.92L3.86 13.97C4.27 14.06 4.6 14.36 4.76 14.77C4.81 14.9 4.87 15.03 4.92 15.16C5.1 15.57 5.08 16.02 4.85 16.38L4.72 16.59C4.28 17.29 4.38 18.18 4.96 18.76L5.24 19.04C5.82 19.62 6.72 19.72 7.42 19.28L7.63 19.15C7.98 18.93 8.44 18.9 8.84 19.09C8.97 19.15 9.1 19.2 9.23 19.25C9.65 19.41 9.95 19.75 10.04 20.15L10.09 20.39C10.27 21.2 10.97 21.76 11.8 21.76H12.2C13.03 21.76 13.73 21.2 13.91 20.39L13.96 20.15C14.05 19.74 14.35 19.41 14.76 19.25C14.89 19.2 15.02 19.14 15.15 19.09C15.56 18.9 16.01 18.93 16.36 19.15L16.57 19.28C17.27 19.72 18.16 19.62 18.74 19.04L19.02 18.76C19.6 18.18 19.7 17.28 19.26 16.58L19.13 16.37C18.91 16.02 18.88 15.56 19.07 15.16C19.13 15.03 19.18 14.9 19.23 14.77C19.39 14.35 19.73 14.05 20.13 13.96L20.37 13.91C21.18 13.73 21.74 13.03 21.74 12.2V11.8C21.74 10.97 21.18 10.27 20.37 10.09ZM20.24 12.2C20.24 12.32 20.16 12.42 20.04 12.44L19.8 12.49C18.9 12.69 18.16 13.34 17.82 14.23C17.78 14.33 17.74 14.44 17.69 14.54C17.3 15.41 17.36 16.39 17.86 17.17L17.99 17.38C18.05 17.48 18.04 17.61 17.96 17.69L17.68 17.97C17.6 18.05 17.47 18.07 17.37 18.01L17.16 17.88C16.38 17.38 15.39 17.32 14.53 17.71C14.43 17.76 14.33 17.8 14.22 17.84C13.33 18.18 12.69 18.92 12.49 19.82L12.44 20.06C12.41 20.18 12.32 20.26 12.2 20.26H11.8C11.68 20.26 11.58 20.18 11.56 20.06L11.51 19.82C11.31 18.92 10.66 18.18 9.77 17.84C9.67 17.8 9.56 17.76 9.46 17.71C9.08 17.54 8.68 17.46 8.29 17.46C7.78 17.46 7.27 17.6 6.83 17.88L6.62 18.01C6.52 18.07 6.39 18.06 6.31 17.98L6.03 17.7C5.95 17.62 5.93 17.49 5.99 17.39L6.12 17.18C6.62 16.4 6.68 15.42 6.29 14.54C6.24 14.44 6.2 14.34 6.16 14.23C5.82 13.34 5.08 12.7 4.18 12.5L3.94 12.45C3.82 12.42 3.74 12.33 3.74 12.21V11.81C3.74 11.69 3.82 11.59 3.94 11.57L4.18 11.52C5.08 11.32 5.82 10.67 6.16 9.78C6.2 9.68 6.24 9.57 6.29 9.47C6.68 8.6 6.62 7.62 6.12 6.84L5.99 6.63C5.93 6.53 5.94 6.4 6.02 6.32L6.3 6.04C6.38 5.96 6.51 5.94 6.61 6.01L6.82 6.14C7.6 6.64 8.58 6.7 9.45 6.31C9.55 6.26 9.65 6.22 9.76 6.18C10.65 5.84 11.29 5.1 11.49 4.2L11.54 3.96C11.57 3.84 11.66 3.76 11.78 3.76H12.18C12.3 3.76 12.4 3.84 12.42 3.96L12.47 4.2C12.67 5.1 13.32 5.84 14.21 6.18C14.31 6.22 14.42 6.26 14.52 6.31C15.39 6.7 16.38 6.64 17.15 6.14L17.36 6.01C17.46 5.95 17.59 5.96 17.67 6.04L17.95 6.32C18.03 6.4 18.05 6.53 17.99 6.63L17.86 6.84C17.36 7.62 17.3 8.6 17.69 9.48C17.74 9.58 17.78 9.68 17.82 9.79C18.16 10.68 18.9 11.32 19.8 11.52L20.04 11.57C20.16 11.6 20.24 11.69 20.24 11.81V12.21V12.2Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/help-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/help-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2.25C6.62 2.25 2.25 6.62 2.25 12C2.25 17.38 6.62 21.75 12 21.75C17.38 21.75 21.75 17.38 21.75 12C21.75 6.62 17.38 2.25 12 2.25ZM12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25ZM12.59 15.38C12.8 15.59 12.9 15.83 12.9 16.12C12.9 16.41 12.8 16.67 12.59 16.88C12.38 17.09 12.13 17.19 11.83 17.19C11.53 17.19 11.28 17.09 11.08 16.88C10.88 16.67 10.78 16.42 10.78 16.12C10.78 15.82 10.88 15.58 11.09 15.38C11.3 15.18 11.54 15.07 11.83 15.07C12.12 15.07 12.38 15.17 12.59 15.38ZM14.76 8.28C14.99 8.62 15.11 8.99 15.11 9.39C15.11 9.75 15.05 10.06 14.92 10.32C14.79 10.58 14.64 10.79 14.46 10.95C14.28 11.11 14.04 11.3 13.75 11.52C13.48 11.72 13.26 11.88 13.11 12.02C12.95 12.16 12.82 12.33 12.71 12.54C12.6 12.75 12.55 12.99 12.55 13.27V13.68H11.05V13.2C11.05 12.8 11.12 12.46 11.25 12.17C11.38 11.88 11.55 11.65 11.74 11.47C11.93 11.29 12.18 11.09 12.48 10.86C12.82 10.6 13.08 10.38 13.24 10.2C13.4 10.02 13.48 9.79 13.48 9.51C13.48 9.17 13.35 8.91 13.07 8.72C12.8 8.53 12.45 8.43 12.02 8.43C11.68 8.43 11.35 8.51 11.02 8.67C10.69 8.83 10.39 9.07 10.13 9.4L9.08 8.59C9.9 7.64 10.93 7.16 12.17 7.16C12.78 7.16 13.3 7.26 13.75 7.47C14.2 7.68 14.53 7.95 14.76 8.3V8.28Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/hidehint-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v2/hidehint-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.13 5.45C10.3 5.69 10.38 5.95 10.38 6.24C10.38 6.5 10.33 6.72 10.24 6.9C10.16 7.06 10.06 7.19 9.95 7.29L7.43 4.77C7.68 4.71 7.94 4.66 8.22 4.66C8.68 4.66 9.07 4.73 9.39 4.87C9.71 5.01 9.96 5.2 10.13 5.44V5.45ZM8.56 11.24L7.37 10.05C7.21 10.21 7.13 10.4 7.13 10.63C7.13 10.87 7.21 11.07 7.38 11.23C7.55 11.4 7.74 11.48 7.98 11.48C8.22 11.48 8.4 11.4 8.57 11.24H8.56ZM5.95 3.18C6.6 2.9 7.29 2.76 8 2.76C10.89 2.76 13.25 5.12 13.25 8.01C13.25 8.72 13.11 9.41 12.83 10.06C12.67 10.44 12.85 10.88 13.23 11.04C13.33 11.08 13.43 11.1 13.52 11.1C13.81 11.1 14.09 10.93 14.21 10.64C14.57 9.8 14.75 8.92 14.75 8C14.75 4.28 11.72 1.25 8 1.25C7.09 1.25 6.2 1.43 5.36 1.79C4.98 1.95 4.8 2.39 4.96 2.77C5.12 3.15 5.56 3.33 5.94 3.17L5.95 3.18ZM10.05 12.84C9.4 13.12 8.71 13.26 8 13.26C5.11 13.26 2.75 10.9 2.75 8.01C2.75 7.3 2.89 6.61 3.17 5.96C3.33 5.58 3.15 5.14 2.77 4.98C2.39 4.82 1.95 5 1.79 5.38C1.43 6.22 1.25 7.1 1.25 8.02C1.25 11.74 4.28 14.77 8 14.77C8.91 14.77 9.8 14.59 10.64 14.23C11.02 14.07 11.2 13.63 11.04 13.25C10.88 12.87 10.44 12.69 10.06 12.85L10.05 12.84ZM2.53 1.48C2.24 1.19 1.76 1.19 1.47 1.48C1.18 1.77 1.18 2.25 1.47 2.54L13.47 14.54C13.62 14.69 13.81 14.76 14 14.76C14.19 14.76 14.38 14.69 14.53 14.54C14.82 14.25 14.82 13.77 14.53 13.48L2.53 1.48Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/hidehint-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v2/hidehint-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.84 17.18C11.54 17.18 11.29 17.08 11.09 16.87C10.89 16.66 10.79 16.41 10.79 16.11C10.79 15.81 10.89 15.57 11.1 15.37C11.31 15.17 11.55 15.06 11.84 15.06C12.13 15.06 12.39 15.16 12.6 15.37C12.81 15.58 12.91 15.82 12.91 16.11C12.91 16.4 12.81 16.66 12.6 16.87C12.39 17.08 12.14 17.18 11.84 17.18ZM14.28 11.1C14.34 11.05 14.41 10.99 14.46 10.94C14.64 10.78 14.79 10.57 14.92 10.31C15.05 10.05 15.11 9.74 15.11 9.38C15.11 8.99 14.99 8.62 14.76 8.27C14.53 7.92 14.19 7.65 13.75 7.44C13.31 7.23 12.78 7.13 12.17 7.13C11.61 7.13 11.1 7.24 10.63 7.43L11.64 8.44C11.76 8.42 11.89 8.4 12.01 8.4C12.44 8.4 12.79 8.5 13.06 8.69C13.33 8.88 13.47 9.15 13.47 9.48C13.47 9.72 13.4 9.92 13.28 10.09L14.28 11.09V11.1ZM16.18 19.1C14.91 19.85 13.46 20.25 12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 10.54 4.15 9.09 4.9 7.82C5.11 7.46 4.99 7 4.64 6.79C4.28 6.58 3.82 6.7 3.61 7.05C2.72 8.55 2.25 10.26 2.25 12C2.25 17.38 6.62 21.75 12 21.75C13.73 21.75 15.44 21.28 16.95 20.39C17.31 20.18 17.43 19.72 17.21 19.36C17 19 16.54 18.88 16.18 19.1ZM7.82 4.9C9.09 4.15 10.54 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 13.46 19.85 14.91 19.1 16.18C18.89 16.54 19.01 17 19.36 17.21C19.48 17.28 19.61 17.31 19.74 17.31C20 17.31 20.25 17.18 20.39 16.94C21.28 15.44 21.75 13.73 21.75 11.99C21.75 6.62 17.38 2.25 12 2.25C10.27 2.25 8.56 2.72 7.05 3.61C6.69 3.82 6.57 4.28 6.79 4.64C7 5 7.46 5.12 7.82 4.9ZM4.53 3.47C4.24 3.18 3.76 3.18 3.47 3.47C3.18 3.76 3.18 4.24 3.47 4.53L19.47 20.53C19.62 20.68 19.81 20.75 20 20.75C20.19 20.75 20.38 20.68 20.53 20.53C20.82 20.24 20.82 19.76 20.53 19.47L4.53 3.47Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/hint-16x16.svg":
/*!**************************************!*\
  !*** ./src/images-v2/hint-16x16.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.13 5.44C10.3 5.68 10.38 5.94 10.38 6.23C10.38 6.49 10.33 6.71 10.24 6.89C10.15 7.07 10.04 7.22 9.91 7.34C9.78 7.46 9.61 7.59 9.39 7.73C9.13 7.9 8.94 8.05 8.82 8.19C8.7 8.33 8.63 8.51 8.63 8.74V8.94H7.28V8.7C7.28 8.41 7.33 8.16 7.42 7.96C7.51 7.76 7.63 7.6 7.76 7.48C7.89 7.36 8.06 7.23 8.26 7.09C8.46 6.95 8.61 6.84 8.7 6.74C8.79 6.64 8.84 6.52 8.84 6.38C8.84 6.21 8.77 6.08 8.63 5.99C8.49 5.9 8.31 5.85 8.09 5.85C7.88 5.85 7.67 5.9 7.47 6C7.27 6.1 7.09 6.24 6.92 6.43L5.98 5.7C6.55 5.03 7.3 4.69 8.23 4.69C8.69 4.69 9.08 4.76 9.4 4.9C9.72 5.04 9.97 5.23 10.14 5.47L10.13 5.44ZM7.98 9.78C7.75 9.78 7.55 9.86 7.38 10.03C7.21 10.2 7.13 10.39 7.13 10.63C7.13 10.87 7.21 11.07 7.38 11.23C7.55 11.4 7.74 11.48 7.98 11.48C8.22 11.48 8.42 11.4 8.58 11.23C8.75 11.06 8.83 10.86 8.83 10.63C8.83 10.4 8.75 10.2 8.58 10.03C8.41 9.86 8.21 9.78 7.98 9.78ZM14.75 8C14.75 11.72 11.72 14.75 8 14.75C4.28 14.75 1.25 11.72 1.25 8C1.25 4.28 4.28 1.25 8 1.25C11.72 1.25 14.75 4.28 14.75 8ZM13.25 8C13.25 5.11 10.89 2.75 8 2.75C5.11 2.75 2.75 5.11 2.75 8C2.75 10.89 5.11 13.25 8 13.25C10.89 13.25 13.25 10.89 13.25 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/hint-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/hint-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2.25C6.62 2.25 2.25 6.62 2.25 12C2.25 17.38 6.62 21.75 12 21.75C17.38 21.75 21.75 17.38 21.75 12C21.75 6.62 17.38 2.25 12 2.25ZM12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25ZM12.59 15.38C12.8 15.59 12.9 15.83 12.9 16.12C12.9 16.41 12.8 16.67 12.59 16.88C12.38 17.09 12.13 17.19 11.83 17.19C11.53 17.19 11.28 17.09 11.08 16.88C10.88 16.67 10.78 16.42 10.78 16.12C10.78 15.82 10.88 15.58 11.09 15.38C11.3 15.18 11.54 15.07 11.83 15.07C12.12 15.07 12.38 15.17 12.59 15.38ZM14.76 8.28C14.99 8.62 15.11 8.99 15.11 9.39C15.11 9.75 15.05 10.06 14.92 10.32C14.79 10.58 14.64 10.79 14.46 10.95C14.28 11.11 14.04 11.3 13.75 11.52C13.48 11.72 13.26 11.88 13.11 12.02C12.95 12.16 12.82 12.33 12.71 12.54C12.6 12.75 12.55 12.99 12.55 13.27V13.68H11.05V13.2C11.05 12.8 11.12 12.46 11.25 12.17C11.38 11.88 11.55 11.65 11.74 11.47C11.93 11.29 12.18 11.09 12.48 10.86C12.82 10.6 13.08 10.38 13.24 10.2C13.4 10.02 13.48 9.79 13.48 9.51C13.48 9.17 13.35 8.91 13.07 8.72C12.8 8.53 12.45 8.43 12.02 8.43C11.68 8.43 11.35 8.51 11.02 8.67C10.69 8.83 10.39 9.07 10.13 9.4L9.08 8.59C9.9 7.64 10.93 7.16 12.17 7.16C12.78 7.16 13.3 7.26 13.75 7.47C14.2 7.68 14.53 7.95 14.76 8.3V8.28Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/image-48x48.svg":
/*!***************************************!*\
  !*** ./src/images-v2/image-48x48.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M33 10.25H15C12.38 10.25 10.25 12.38 10.25 15V33C10.25 35.62 12.38 37.75 15 37.75H33C35.62 37.75 37.75 35.62 37.75 33V15C37.75 12.38 35.62 10.25 33 10.25ZM36.25 33C36.25 34.79 34.79 36.25 33 36.25H15C13.21 36.25 11.75 34.79 11.75 33V15C11.75 13.21 13.21 11.75 15 11.75H33C34.79 11.75 36.25 13.21 36.25 15V33ZM30.5 14.25C28.71 14.25 27.25 15.71 27.25 17.5C27.25 19.29 28.71 20.75 30.5 20.75C32.29 20.75 33.75 19.29 33.75 17.5C33.75 15.71 32.29 14.25 30.5 14.25ZM30.5 19.25C29.54 19.25 28.75 18.46 28.75 17.5C28.75 16.54 29.54 15.75 30.5 15.75C31.46 15.75 32.25 16.54 32.25 17.5C32.25 18.46 31.46 19.25 30.5 19.25ZM29.26 26.28C28.94 25.92 28.49 25.71 28.01 25.7C27.54 25.68 27.07 25.87 26.73 26.2L24.95 27.94L22.28 25.23C21.94 24.89 21.5 24.71 21 24.71C20.52 24.71 20.06 24.93 19.74 25.28L14.74 30.78C14.25 31.3 14.12 32.06 14.41 32.72C14.69 33.36 15.28 33.75 15.95 33.75H32.07C32.74 33.75 33.33 33.35 33.61 32.72C33.89 32.06 33.77 31.31 33.29 30.79L29.27 26.29L29.26 26.28ZM32.22 32.12C32.18 32.2 32.13 32.25 32.06 32.25H15.94C15.87 32.25 15.81 32.21 15.78 32.12C15.77 32.09 15.71 31.93 15.83 31.8L20.84 26.29C20.9 26.22 20.99 26.21 21.02 26.21C21.06 26.21 21.14 26.22 21.2 26.29L24.4 29.54C24.69 29.83 25.16 29.84 25.46 29.54L27.77 27.27C27.83 27.21 27.9 27.2 27.94 27.2C28.01 27.2 28.06 27.21 28.13 27.28L32.16 31.79C32.16 31.79 32.16 31.79 32.17 31.8C32.29 31.93 32.23 32.09 32.22 32.12Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/import-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/import-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.75 8.83V18C19.75 19.52 18.52 20.75 17 20.75H7C5.48 20.75 4.25 19.52 4.25 18V16C4.25 15.59 4.59 15.25 5 15.25C5.41 15.25 5.75 15.59 5.75 16V18C5.75 18.69 6.31 19.25 7 19.25H17C17.69 19.25 18.25 18.69 18.25 18V8.83C18.25 8.5 18.12 8.18 17.88 7.95L15.05 5.12C14.82 4.89 14.5 4.75 14.17 4.75H7C6.31 4.75 5.75 5.31 5.75 6V10C5.75 10.41 5.41 10.75 5 10.75C4.59 10.75 4.25 10.41 4.25 10V6C4.25 4.48 5.48 3.25 7 3.25H14.17C14.9 3.25 15.59 3.54 16.11 4.06L18.94 6.89C19.46 7.41 19.75 8.1 19.75 8.83ZM8.47 15.47C8.18 15.76 8.18 16.24 8.47 16.53C8.62 16.68 8.81 16.75 9 16.75C9.19 16.75 9.38 16.68 9.53 16.53L12.53 13.53C12.6 13.46 12.65 13.38 12.69 13.29C12.77 13.11 12.77 12.9 12.69 12.72C12.65 12.63 12.6 12.55 12.53 12.48L9.53 9.48C9.24 9.19 8.76 9.19 8.47 9.48C8.18 9.77 8.18 10.25 8.47 10.54L10.19 12.26H2C1.59 12.26 1.25 12.6 1.25 13.01C1.25 13.42 1.59 13.76 2 13.76H10.19L8.47 15.48V15.47ZM14 5.25C13.59 5.25 13.25 5.59 13.25 6V7C13.25 8.52 14.48 9.75 16 9.75H17C17.41 9.75 17.75 9.41 17.75 9C17.75 8.59 17.41 8.25 17 8.25H16C15.31 8.25 14.75 7.69 14.75 7V6C14.75 5.59 14.41 5.25 14 5.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/invisible-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/invisible-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.4449 14.3969C20.7749 14.6469 20.8449 15.1169 20.5949 15.4469C18.5349 18.1769 15.4049 19.7469 11.9949 19.7469C11.3849 19.7469 10.7349 19.6769 10.0149 19.5469C9.60488 19.4669 9.33488 19.0769 9.41488 18.6669C9.49488 18.2569 9.88488 17.9869 10.2949 18.0669C10.9249 18.1869 11.4749 18.2369 11.9949 18.2369C14.9249 18.2369 17.6249 16.8869 19.3949 14.5369C19.6449 14.2069 20.1149 14.1369 20.4449 14.3869V14.3969ZM5.97488 17.7169C6.20488 17.7169 6.42488 17.6169 6.57488 17.4169C6.82488 17.0869 6.76488 16.6169 6.42488 16.3669C5.70488 15.8169 5.08488 15.2069 4.58488 14.5469C4.33488 14.2169 3.86488 14.1469 3.53488 14.3969C3.20488 14.6469 3.13488 15.1169 3.38488 15.4469C3.96488 16.2169 4.68488 16.9269 5.51488 17.5569C5.64488 17.6569 5.80488 17.7069 5.96488 17.7069L5.97488 17.7169ZM11.9649 8.74692C12.3749 8.74692 12.7149 8.40692 12.7049 7.98692C12.6949 7.56692 12.3449 7.21692 11.9449 7.24692C9.35488 7.27692 7.24488 9.40692 7.24488 11.9969C7.24488 12.6069 7.36488 13.2069 7.59488 13.7769C7.71488 14.0669 7.99488 14.2469 8.29488 14.2469C8.38488 14.2469 8.48488 14.2269 8.57488 14.1969C8.95488 14.0369 9.14488 13.6069 8.98488 13.2169C8.82488 12.8269 8.74488 12.4169 8.74488 11.9969C8.74488 10.2269 10.1849 8.76692 11.9649 8.74692ZM12.0249 15.2469C11.6149 15.2469 11.2749 15.5869 11.2849 16.0069C11.2849 16.4169 11.6249 16.7469 12.0349 16.7469C14.6249 16.7169 16.7349 14.5869 16.7349 11.9969C16.7349 11.3869 16.6149 10.7869 16.3849 10.2169C16.2249 9.83692 15.7849 9.64692 15.4049 9.80692C15.0249 9.96692 14.8349 10.3969 14.9949 10.7869C15.1549 11.1769 15.2349 11.5869 15.2349 12.0069C15.2349 13.7769 13.7949 15.2369 12.0149 15.2569L12.0249 15.2469ZM23.6549 11.6469C22.4449 9.34692 20.6849 7.44692 18.5649 6.13692C18.2049 5.91692 17.7449 6.02692 17.5349 6.38692C17.3149 6.73692 17.4249 7.19692 17.7849 7.41692C19.6749 8.57692 21.2449 10.2869 22.3249 12.3469C22.4549 12.5969 22.7249 12.7469 22.9949 12.7469C23.1149 12.7469 23.2349 12.7169 23.3449 12.6569C23.7149 12.4669 23.8549 12.0069 23.6549 11.6469ZM11.9949 5.74692C12.5649 5.74692 13.1449 5.79692 13.7349 5.88692C14.1449 5.94692 14.5249 5.67692 14.5949 5.26692C14.6649 4.85692 14.3849 4.47692 13.9749 4.40692C8.38488 3.49692 3.05488 6.46692 0.334879 11.6469C0.144879 12.0169 0.284879 12.4669 0.644879 12.6569C0.754879 12.7169 0.874879 12.7469 0.994879 12.7469C1.26488 12.7469 1.52488 12.5969 1.66488 12.3469C3.79488 8.27692 7.76488 5.74692 11.9949 5.74692ZM18.4149 2.37692C18.0649 2.14692 17.6049 2.23692 17.3749 2.58692L5.37488 20.5769C5.14488 20.9169 5.23488 21.3869 5.58488 21.6169C5.71488 21.6969 5.85488 21.7469 6.00488 21.7469C6.24488 21.7469 6.48488 21.6269 6.62488 21.4169L18.6149 3.41692C18.8449 3.07692 18.7549 2.60692 18.4049 2.37692H18.4149Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/language-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v2/language-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22.67 20.67L16.67 8.67C16.42 8.16 15.58 8.16 15.33 8.67L9.33 20.67C9.14 21.04 9.29 21.49 9.67 21.68C10.04 21.87 10.49 21.72 10.68 21.34L12.98 16.75C12.98 16.75 13 16.75 13.01 16.75H19.01C19.01 16.75 19.03 16.75 19.04 16.75L21.34 21.34C21.47 21.6 21.74 21.76 22.01 21.76C22.12 21.76 22.24 21.73 22.34 21.68C22.71 21.49 22.86 21.04 22.68 20.67H22.67ZM13.71 15.25L16 10.68L18.29 15.25H13.72H13.71ZM10.7 12.23C9.9 11.17 9.36 10.03 8.99 8.88C8.18 11.39 6.56 13.74 3.38 15.65C3.26 15.72 3.13 15.76 3 15.76C2.75 15.76 2.5 15.63 2.36 15.4C2.15 15.04 2.26 14.58 2.62 14.37C6.39 12.11 7.74 9.32 8.12 5.76H3C2.59 5.75 2.25 5.41 2.25 5C2.25 4.59 2.59 4.25 3 4.25H8.22C8.24 3.84 8.25 3.43 8.25 3C8.25 2.57 8.59 2.25 9 2.25C9.41 2.25 9.75 2.59 9.75 3C9.75 3.43 9.76 3.85 9.78 4.25H15C15.41 4.25 15.75 4.59 15.75 5C15.75 5.41 15.41 5.75 15 5.75H9.89C10.15 8.09 10.79 9.84 11.9 11.33C12.15 11.66 12.08 12.13 11.75 12.38C11.42 12.63 10.95 12.56 10.7 12.23Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/loading-48x48.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/loading-48x48.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_19679_369428)\"><path opacity=\"0.25\" d=\"M24 40C15.18 40 8 32.82 8 24C8 15.18 15.18 8 24 8C32.82 8 40 15.18 40 24C40 32.82 32.82 40 24 40ZM24 12C17.38 12 12 17.38 12 24C12 30.62 17.38 36 24 36C30.62 36 36 30.62 36 24C36 17.38 30.62 12 24 12Z\"></path><path d=\"M10 26C8.9 26 8 25.1 8 24C8 15.18 15.18 8 24 8C25.1 8 26 8.9 26 10C26 11.1 25.1 12 24 12C17.38 12 12 17.38 12 24C12 25.1 11.1 26 10 26Z\"></path></g><defs><clipPath id=\"clip0_19679_369428\"><rect width=\"32\" height=\"32\" fill=\"white\" transform=\"translate(8 8)\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v2/logic-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v2/logic-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 14.59L16.59 16L18.59 18H7.82C7.79 17.9 7.75 17.81 7.7 17.71L17.71 7.7C18.1 7.89 18.53 8 19 8C20.65 8 22 6.65 22 5C22 3.35 20.65 2 19 2C17.7 2 16.6 2.84 16.18 4H7.82C7.41 2.84 6.31 2 5 2C3.35 2 2 3.35 2 5C2 6.65 3.35 8 5 8C6.3 8 7.4 7.16 7.82 6H16.19C16.22 6.1 16.26 6.19 16.31 6.29L6.29 16.3C5.9 16.11 5.47 16 5 16C3.35 16 2 17.35 2 19C2 20.65 3.35 22 5 22C6.3 22 7.4 21.16 7.82 20H18.59L16.59 22L18 23.41L22.41 19L18 14.59ZM19 4C19.55 4 20 4.45 20 5C20 5.55 19.55 6 19 6C18.45 6 18 5.55 18 5C18 4.45 18.45 4 19 4ZM5 6C4.45 6 4 5.55 4 5C4 4.45 4.45 4 5 4C5.55 4 6 4.45 6 5C6 5.55 5.55 6 5 6ZM5 20C4.45 20 4 19.55 4 19C4 18.45 4.45 18 5 18C5.55 18 6 18.45 6 19C6 19.55 5.55 20 5 20Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/logo-angular-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/logo-angular-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_17790_388137)\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.17 0L1 3.98L2.71 18.75L12.16 24L21.77 18.68L23.62 3.91L12.17 0ZM16.97 18.27L15.45 14.74H9.23L7.83 18.24L5.23 18.29L12.19 2.81L19.45 18.33L16.97 18.28V18.27ZM10.15 12.69L12.21 7.77L14.56 12.69H10.14H10.15Z\" fill=\"#E23237\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M12.1899 12.69H12.1699V7.85L12.1999 7.77L14.5499 12.69H12.1799H12.1899ZM12.1699 0V2.84L12.1899 2.8L19.4499 18.32L16.9699 18.27L15.4499 14.74H12.1799V24L21.7899 18.68L23.6399 3.91L12.1699 0Z\" fill=\"#B52E31\"></path></g><defs><clipPath id=\"clip0_17790_388137\"><rect width=\"22.63\" height=\"24\" fill=\"white\" transform=\"translate(1)\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v2/logo-jquery-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v2/logo-jquery-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.42 17.5751C23.42 17.5751 20.43 25.5875 10.16 23.7169C7.55997 23.0467 5.16997 21.5963 3.35997 19.6157C3.00997 19.2356 2.67997 18.8354 2.37997 18.4153C-0.130033 14.9643 -1.02003 10.0228 1.51997 6.39164L3.17997 4.30101C0.199966 10.1128 4.07997 17.1649 9.63997 19.7657C14.13 22.0064 20.41 21.5263 23.41 17.5751H23.42ZM8.53997 12.4435C9.86997 14.3741 11.96 15.7845 14.23 16.3747C22.16 17.6851 24 11.6032 24 11.6032C18.31 19.1855 4.80997 10.6529 9.36997 2.07033L8.11997 3.83086C6.30997 6.41165 6.75997 9.96273 8.53997 12.4335V12.4435ZM16.9 9.72266C17.08 9.79268 17.27 9.8527 17.46 9.90272C21.84 10.743 23.03 7.66203 23.35 7.21189C21.99 9.39256 18.24 9.07246 16.2 7.47197C14.28 6.02153 13.09 3.26069 14.34 1C11.47 4.08094 13.21 8.36225 16.9 9.72266Z\" fill=\"#0D61A8\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/logo-knockout-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/logo-knockout-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_17790_388139)\"><path d=\"M23.6098 20.0301C23.2398 19.8203 22.8498 19.6805 22.4198 19.6605C20.8398 19.6605 19.6398 19.6605 18.2098 19.6605C16.7898 19.7104 16.6398 18.1121 16.2198 17.0832C15.4698 15.1152 14.8298 13.0973 14.0598 11.1394C15.9698 9.15147 17.8298 7.1136 19.7298 5.12568C20.8498 4.09676 22.2798 2.13881 20.2898 1.17981C18.0898 0.880128 16.8298 3.6772 15.3098 4.90591C13.9298 6.46428 12.4398 7.92276 11.0798 9.48112C13.8898 4.27657 10.8798 -0.208732 5.07985 1.2897C1.39985 2.44849 -1.16015 6.95377 0.529846 10.6399C1.33985 12.2482 3.08985 13.447 4.89985 12.8776C5.75985 12.508 6.36985 11.4291 5.83985 10.55C5.51985 10.1704 5.06985 9.99059 4.61985 9.82077C3.57985 9.38123 3.20985 8.19247 3.47985 7.15356C3.83985 5.06575 7.02985 3.04786 8.43985 5.27553C8.75985 6.34441 8.15985 7.45325 7.80985 8.4522C6.89985 10.7798 5.96985 13.0874 5.04985 15.4049C4.68985 16.5138 3.93985 17.5627 4.09985 18.7714C4.89985 20.4397 6.86985 19.7803 7.55985 18.3518C8.52985 15.9344 9.58985 13.5269 10.4198 11.0795C11.7798 14.5558 12.8498 18.162 14.3298 21.5885C14.8598 22.6074 15.8598 22.957 16.9398 22.997C19.0098 22.997 20.3698 22.997 21.9098 22.997C22.2798 22.997 22.6298 22.8272 22.9898 22.7173C23.9298 22.2378 24.3698 20.8692 23.5998 20.0501L23.6098 20.0301Z\" fill=\"#E42E16\"></path></g><defs><clipPath id=\"clip0_17790_388139\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v2/logo-react-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v2/logo-react-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.1459 11.9624C14.1459 13.1424 13.1855 14.1024 12.005 14.1024C10.8245 14.1024 9.86411 13.1424 9.86411 11.9624C9.86411 10.7824 10.8245 9.8224 12.005 9.8224C13.1855 9.8224 14.1459 10.7824 14.1459 11.9624ZM24 11.9624C24 13.4324 22.2593 14.9224 19.4581 15.8524C19.308 15.9024 19.168 15.9424 19.0079 15.9924C19.0679 16.2124 19.108 16.4224 19.158 16.6324C19.4181 17.9524 19.4581 19.1824 19.278 20.1824C19.0779 21.2424 18.6378 22.0024 17.9975 22.3724C17.6774 22.5624 17.2972 22.6524 16.877 22.6524C15.7165 22.6524 14.2359 21.9524 12.7053 20.6324C12.4852 20.4424 12.2751 20.2524 12.055 20.0424C11.885 20.2024 11.7249 20.3624 11.5548 20.5024C10.5344 21.3924 9.49396 22.0424 8.53356 22.3824C8.03335 22.5624 7.56315 22.6524 7.14298 22.6524C6.7228 22.6524 6.32263 22.5624 6.0025 22.3724C4.77199 21.6624 4.35181 19.6224 4.86203 16.9124C4.91205 16.6324 4.98208 16.3524 5.0521 16.0624C4.82201 16.0024 4.61192 15.9324 4.40183 15.8524C3.1213 15.4124 2.04085 14.8324 1.26053 14.1724C0.440183 13.4724 0 12.7024 0 11.9724C0 10.5524 1.56065 9.1624 4.17174 8.2624C4.46186 8.1624 4.76198 8.0724 5.06211 7.9824C4.99208 7.7124 4.93205 7.4524 4.88203 7.1924C4.63193 5.9024 4.58191 4.7224 4.74198 3.7624C4.92205 2.7224 5.34223 1.9824 5.97249 1.6224C7.24302 0.882403 9.41392 1.6424 11.6148 3.6024C11.7449 3.7224 11.8749 3.8424 12.015 3.9724C12.2151 3.7824 12.4152 3.5924 12.6153 3.4224C13.6057 2.5624 14.6161 1.9224 15.5165 1.5924C16.5069 1.2324 17.3572 1.2324 17.9775 1.5924C19.258 2.3224 19.6782 4.5824 19.0779 7.4724C19.0479 7.6524 18.9979 7.8224 18.9579 8.0024C19.218 8.0824 19.4781 8.1624 19.7282 8.2424C20.9687 8.6724 22.0192 9.2224 22.7595 9.8424C23.5698 10.5124 23.99 11.2524 23.99 11.9824L24 11.9624ZM13.2855 4.1924C13.1055 4.3524 12.9154 4.5224 12.7353 4.6924C13.4156 5.4224 14.0959 6.2824 14.7561 7.2224C15.8866 7.3324 16.9671 7.5024 17.9675 7.7324C18.0075 7.5724 18.0475 7.4124 18.0775 7.2624C18.6378 4.5424 18.1576 2.8724 17.4673 2.4824C17.1171 2.2824 16.5469 2.3024 15.8666 2.5624C15.0763 2.8524 14.1859 3.4224 13.2855 4.2024V4.1924ZM16.3868 11.9824C16.0767 11.3524 15.7266 10.7124 15.3464 10.0524C14.9762 9.4024 14.5861 8.7924 14.1859 8.2024C13.4756 8.1424 12.7453 8.1224 11.995 8.1224C11.2447 8.1224 10.5244 8.1524 9.81409 8.2024C9.40392 8.7924 9.02376 9.4124 8.6436 10.0624C8.27345 10.7024 7.93331 11.3524 7.62318 11.9924C7.93331 12.6424 8.27345 13.2824 8.65361 13.9324C9.03376 14.5824 9.41392 15.1924 9.82409 15.7924C10.5244 15.8324 11.2447 15.8624 11.995 15.8624C12.7453 15.8624 13.4856 15.8324 14.1959 15.7824C14.5861 15.2024 14.9662 14.5824 15.3464 13.9324C15.7165 13.2824 16.0667 12.6324 16.3768 11.9924L16.3868 11.9824ZM16.2368 14.4324C15.9967 14.8524 15.7466 15.2624 15.5065 15.6524C16.2968 15.5624 17.0471 15.4324 17.7474 15.2724C17.5373 14.6024 17.2672 13.8924 16.9371 13.1624C16.717 13.5824 16.4869 14.0124 16.2368 14.4324ZM13.4456 16.8424C12.9654 16.8624 12.4852 16.8724 11.995 16.8724C11.5048 16.8724 11.0546 16.8724 10.5944 16.8424C11.0646 17.4624 11.5548 18.0424 12.035 18.5724C12.5052 18.0524 12.9754 17.4724 13.4456 16.8324V16.8424ZM7.75323 14.4324C7.51313 14.0224 7.28303 13.6124 7.07295 13.1924C6.77282 13.9124 6.51271 14.6224 6.29262 15.3124C6.97291 15.4624 7.71321 15.5824 8.50354 15.6624C8.24343 15.2624 7.99333 14.8424 7.75323 14.4324ZM8.48353 8.3324C7.72322 8.4224 6.99291 8.5524 6.30263 8.7024C6.51271 9.3724 6.77282 10.0724 7.06294 10.7824C7.27303 10.3724 7.50313 9.9524 7.74323 9.5424C7.98333 9.1324 8.22343 8.7224 8.47353 8.3324H8.48353ZM10.5744 7.1224C11.0346 7.1024 11.5048 7.0924 11.985 7.0924C12.4652 7.0924 12.9454 7.1024 13.4156 7.1224C12.9454 6.5024 12.4752 5.9324 12.005 5.4224C11.5248 5.9424 11.0446 6.5124 10.5844 7.1224H10.5744ZM16.917 10.7924C17.2172 10.0824 17.4773 9.3824 17.6874 8.7224C16.9971 8.5624 16.2568 8.4324 15.4965 8.3424C15.7466 8.7324 15.9867 9.1324 16.2268 9.5424C16.4669 9.9624 16.697 10.3824 16.917 10.8024V10.7924ZM6.03251 7.7224C7.03293 7.4924 8.11338 7.3324 9.24385 7.2224C9.89412 6.2924 10.5844 5.4424 11.2847 4.7024C11.1647 4.5824 11.0446 4.4724 10.9246 4.3724C8.84369 2.5224 7.16298 2.1124 6.4727 2.5124C6.12255 2.7124 5.86244 3.2224 5.74239 3.9424C5.60233 4.7724 5.64235 5.8324 5.87245 6.9924C5.92247 7.2324 5.97249 7.4824 6.04252 7.7324L6.03251 7.7224ZM5.30221 15.0624C5.60233 14.0724 6.0025 13.0424 6.4827 11.9924C6.01251 10.9624 5.61234 9.9424 5.31221 8.9624C5.02209 9.0424 4.75198 9.1324 4.49187 9.2224C2.09087 10.0624 1.01042 11.2024 1.01042 11.9724C1.01042 12.7424 2.1709 14.0224 4.71196 14.8824C4.90204 14.9424 5.10213 15.0124 5.30221 15.0624ZM10.8545 19.7424C11.0046 19.6124 11.1546 19.4724 11.3147 19.3224C10.6144 18.5624 9.91413 17.7124 9.25386 16.7724C8.08337 16.6824 6.99291 16.5224 6.02251 16.3024C5.95248 16.5724 5.90246 16.8424 5.84243 17.0924C5.37224 19.5924 5.82243 21.0924 6.4827 21.4724C6.64277 21.5624 6.86286 21.6224 7.12297 21.6224C7.97332 21.6224 9.31388 21.0824 10.8545 19.7324V19.7424ZM18.0175 16.2524C17.0271 16.4824 15.9366 16.6524 14.7662 16.7524C14.1059 17.7124 13.4256 18.5724 12.7553 19.3024C12.9554 19.5024 13.1655 19.6824 13.3656 19.8524C15.2964 21.5124 16.827 21.8724 17.4873 21.4824C18.1776 21.0824 18.6778 19.4624 18.1576 16.8224C18.1175 16.6324 18.0675 16.4424 18.0275 16.2424L18.0175 16.2524ZM22.9696 11.9624C22.9696 11.5524 22.6594 11.0824 22.0992 10.6124C21.4489 10.0724 20.5185 9.5824 19.3881 9.1924C19.158 9.1124 18.9179 9.0424 18.6778 8.9624C18.3877 9.9124 17.9875 10.9324 17.5073 11.9624C18.0075 13.0224 18.4177 14.0424 18.7178 15.0024C18.8579 14.9624 18.9879 14.9124 19.128 14.8724C21.7691 14.0024 22.9696 12.7524 22.9696 11.9624Z\" fill=\"#00D8FF\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/logo-surveycreator-48x48.svg":
/*!****************************************************!*\
  !*** ./src/images-v2/logo-surveycreator-48x48.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 40 40\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M31.45 3.5H8.55C4.11 3.5 0.5 7.11 0.5 11.55V25.55C0.5 28.73 2.39 31.57 5.19 32.86C4.82 33.58 4.67 34.39 4.8 35.2C4.96 36.21 5.5 37.09 6.32 37.69C6.98 38.17 7.76 38.42 8.56 38.42C8.76 38.42 8.96 38.4 9.16 38.37C10.17 38.21 11.05 37.67 11.65 36.85L17.99 28.14C19.19 28.41 20.43 28.46 21.65 28.26C24.2 27.86 26.45 26.48 27.97 24.39C29.49 22.3 30.11 19.74 29.7 17.19C29.45 15.59 28.8 14.07 27.81 12.8C27.52 12.43 27.05 12.23 26.6 12.22C26.13 12.22 25.69 12.46 25.41 12.84L22.15 17.31C21.89 17.67 21.38 17.75 21.01 17.49C20.83 17.36 20.72 17.17 20.68 16.96C20.65 16.75 20.7 16.53 20.83 16.35L24.09 11.87C24.37 11.49 24.45 11 24.31 10.54C24.17 10.09 23.83 9.73 23.38 9.57C21.86 9.03 20.22 8.87 18.62 9.13C16.07 9.53 13.82 10.91 12.3 13C10.78 15.09 10.16 17.65 10.57 20.2C10.76 21.42 11.19 22.59 11.81 23.64L6.95 30.32C4.92 29.65 3.49 27.73 3.49 25.55V11.55C3.49 8.77 5.75 6.5 8.54 6.5H31.45C34.23 6.5 36.5 8.76 36.5 11.55V25.55C36.5 28.33 34.24 30.59 31.45 30.59H27.5V34L22.95 30.59H18.25C17.42 30.59 16.75 31.26 16.75 32.09C16.75 32.92 17.42 33.59 18.25 33.59H21.95L30.5 40V33.59H31.45C35.89 33.59 39.5 29.98 39.5 25.55V11.55C39.5 7.11 35.89 3.5 31.45 3.5ZM14.87 24.56C15.26 24.02 15.25 23.29 14.85 22.76C14.17 21.88 13.72 20.83 13.55 19.73C13.27 17.97 13.7 16.2 14.75 14.76C15.8 13.32 17.35 12.37 19.11 12.09C19.46 12.04 19.8 12.01 20.15 12.01C20.2 12.01 20.24 12.01 20.29 12.01L18.42 14.58C17.82 15.4 17.58 16.41 17.74 17.42C17.9 18.43 18.44 19.31 19.26 19.91C20.08 20.51 21.09 20.75 22.1 20.59C23.11 20.43 23.99 19.89 24.59 19.07L26.46 16.5C26.59 16.87 26.68 17.26 26.75 17.65C27.03 19.41 26.6 21.18 25.55 22.62C24.5 24.06 22.95 25.01 21.19 25.29C20.09 25.46 18.95 25.36 17.91 24.98C17.28 24.76 16.58 24.98 16.19 25.51L9.23 35.07C9.1 35.25 8.91 35.36 8.7 35.4C8.48 35.43 8.27 35.38 8.09 35.25C7.91 35.12 7.8 34.93 7.76 34.72C7.73 34.51 7.78 34.29 7.91 34.11L14.87 24.55V24.56Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/logo-vue-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v2/logo-vue-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_17790_388140)\"><path d=\"M19.2 2H24L12 22.7L0 2H9.18L12 6.8L14.76 2H19.2Z\" fill=\"#41B883\"></path><path d=\"M4.74023 2L12.0002 14.48L19.2002 2H14.7602L12.0002 6.8L9.18023 2H4.74023Z\" fill=\"#35495E\"></path></g><defs><clipPath id=\"clip0_17790_388140\"><rect width=\"24\" height=\"20.7\" fill=\"white\" transform=\"translate(0 2)\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v2/maximize-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v2/maximize-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.75 3V7C13.75 7.41 13.41 7.75 13 7.75C12.59 7.75 12.25 7.41 12.25 7V4.81L9.53 7.53C9.38 7.68 9.19 7.75 9 7.75C8.81 7.75 8.62 7.68 8.47 7.53C8.18 7.24 8.18 6.76 8.47 6.47L11.19 3.75H9C8.59 3.75 8.25 3.41 8.25 3C8.25 2.59 8.59 2.25 9 2.25H13C13.1 2.25 13.19 2.27 13.29 2.31C13.47 2.39 13.62 2.53 13.7 2.72C13.74 2.81 13.76 2.91 13.76 3.01L13.75 3ZM7.53 8.47C7.24 8.18 6.76 8.18 6.47 8.47L3.75 11.19V9C3.75 8.59 3.41 8.25 3 8.25C2.59 8.25 2.25 8.59 2.25 9V13C2.25 13.1 2.27 13.19 2.31 13.29C2.39 13.47 2.53 13.62 2.72 13.7C2.81 13.74 2.91 13.76 3.01 13.76H7.01C7.42 13.76 7.76 13.42 7.76 13.01C7.76 12.6 7.42 12.26 7.01 12.26H4.82L7.54 9.54C7.83 9.25 7.83 8.77 7.54 8.48L7.53 8.47Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/minimize-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v2/minimize-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.75 8C13.75 8.41 13.41 8.75 13 8.75H3C2.59 8.75 2.25 8.41 2.25 8C2.25 7.59 2.59 7.25 3 7.25H13C13.41 7.25 13.75 7.59 13.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/minus-32x32.svg":
/*!***************************************!*\
  !*** ./src/images-v2/minus-32x32.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30 16H3V17H30V16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/minusbox-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v2/minusbox-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.75 8C10.75 8.41 10.41 8.75 10 8.75H6C5.59 8.75 5.25 8.41 5.25 8C5.25 7.59 5.59 7.25 6 7.25H10C10.41 7.25 10.75 7.59 10.75 8ZM13.75 4V12C13.75 12.96 12.96 13.75 12 13.75H4C3.04 13.75 2.25 12.96 2.25 12V4C2.25 3.04 3.04 2.25 4 2.25H12C12.96 2.25 13.75 3.04 13.75 4ZM12.25 4C12.25 3.86 12.14 3.75 12 3.75H4C3.86 3.75 3.75 3.86 3.75 4V12C3.75 12.14 3.86 12.25 4 12.25H12C12.14 12.25 12.25 12.14 12.25 12V4Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/more-16x16.svg":
/*!**************************************!*\
  !*** ./src/images-v2/more-16x16.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 6.25C7.04 6.25 6.25 7.04 6.25 8C6.25 8.96 7.04 9.75 8 9.75C8.96 9.75 9.75 8.96 9.75 8C9.75 7.04 8.96 6.25 8 6.25ZM7.75 8C7.75 7.86 7.86 7.75 8 7.75C8.14 7.75 8.25 7.86 8.25 8C8.25 8.28 7.75 8.28 7.75 8ZM2 6.25C1.04 6.25 0.25 7.04 0.25 8C0.25 8.96 1.04 9.75 2 9.75C2.96 9.75 3.75 8.96 3.75 8C3.75 7.04 2.96 6.25 2 6.25ZM1.75 8C1.75 7.86 1.86 7.75 2 7.75C2.14 7.75 2.25 7.86 2.25 8C2.25 8.28 1.75 8.28 1.75 8ZM14 6.25C13.04 6.25 12.25 7.04 12.25 8C12.25 8.96 13.04 9.75 14 9.75C14.96 9.75 15.75 8.96 15.75 8C15.75 7.04 14.96 6.25 14 6.25ZM13.75 8C13.75 7.86 13.86 7.75 14 7.75C14.14 7.75 14.25 7.86 14.25 8C14.25 8.28 13.75 8.28 13.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/more-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/more-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 10.25C11.04 10.25 10.25 11.04 10.25 12C10.25 12.96 11.04 13.75 12 13.75C12.96 13.75 13.75 12.96 13.75 12C13.75 11.04 12.96 10.25 12 10.25ZM11.75 12C11.75 11.86 11.86 11.75 12 11.75C12.14 11.75 12.25 11.86 12.25 12C12.25 12.28 11.75 12.28 11.75 12ZM19 10.25C18.04 10.25 17.25 11.04 17.25 12C17.25 12.96 18.04 13.75 19 13.75C19.96 13.75 20.75 12.96 20.75 12C20.75 11.04 19.96 10.25 19 10.25ZM18.75 12C18.75 11.86 18.86 11.75 19 11.75C19.14 11.75 19.25 11.86 19.25 12C19.25 12.28 18.75 12.28 18.75 12ZM5 10.25C4.04 10.25 3.25 11.04 3.25 12C3.25 12.96 4.04 13.75 5 13.75C5.96 13.75 6.75 12.96 6.75 12C6.75 11.04 5.96 10.25 5 10.25ZM4.75 12C4.75 11.86 4.86 11.75 5 11.75C5.14 11.75 5.25 11.86 5.25 12C5.25 12.28 4.75 12.28 4.75 12Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/navmenu-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/navmenu-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3.25 7C3.25 6.59 3.59 6.25 4 6.25H15C15.41 6.25 15.75 6.59 15.75 7C15.75 7.41 15.41 7.75 15 7.75H4C3.59 7.75 3.25 7.41 3.25 7ZM20 11.25H4C3.59 11.25 3.25 11.59 3.25 12C3.25 12.41 3.59 12.75 4 12.75H20C20.41 12.75 20.75 12.41 20.75 12C20.75 11.59 20.41 11.25 20 11.25ZM9 16.25H4C3.59 16.25 3.25 16.59 3.25 17C3.25 17.41 3.59 17.75 4 17.75H9C9.41 17.75 9.75 17.41 9.75 17C9.75 16.59 9.41 16.25 9 16.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/noimage-48x48.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/noimage-48x48.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 48 48\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30.4975 14.2475C28.7075 14.2475 27.2475 15.7075 27.2475 17.4975C27.2475 19.2875 28.7075 20.7475 30.4975 20.7475C32.2875 20.7475 33.7475 19.2875 33.7475 17.4975C33.7475 15.7075 32.2875 14.2475 30.4975 14.2475ZM30.4975 19.2475C29.5375 19.2475 28.7475 18.4575 28.7475 17.4975C28.7475 16.5375 29.5375 15.7475 30.4975 15.7475C31.4575 15.7475 32.2475 16.5375 32.2475 17.4975C32.2475 18.4575 31.4575 19.2475 30.4975 19.2475ZM13.5175 11.2175C13.4375 10.8075 13.7075 10.4175 14.1175 10.3375C14.4275 10.2775 14.7175 10.2475 14.9975 10.2475H32.9975C35.6175 10.2475 37.7475 12.3775 37.7475 14.9975V32.9975C37.7475 33.2775 37.7175 33.5675 37.6575 33.8775C37.5875 34.2375 37.2775 34.4875 36.9175 34.4875C36.8675 34.4875 36.8275 34.4875 36.7775 34.4775C36.3675 34.3975 36.1075 34.0075 36.1775 33.5975C36.2175 33.3775 36.2375 33.1775 36.2375 32.9975V14.9975C36.2375 13.2075 34.7775 11.7475 32.9875 11.7475H14.9975C14.8075 11.7475 14.6175 11.7675 14.3975 11.8075C13.9875 11.8875 13.5975 11.6175 13.5175 11.2075V11.2175ZM34.4775 36.7775C34.5575 37.1875 34.2875 37.5775 33.8775 37.6575C33.5675 37.7175 33.2775 37.7475 32.9975 37.7475H14.9975C12.3775 37.7475 10.2475 35.6175 10.2475 32.9975V14.9975C10.2475 14.7175 10.2775 14.4275 10.3375 14.1175C10.4175 13.7075 10.8075 13.4375 11.2175 13.5175C11.6275 13.5975 11.8875 13.9875 11.8175 14.3975C11.7775 14.6175 11.7575 14.8175 11.7575 14.9975V32.9975C11.7575 34.7875 13.2175 36.2475 15.0075 36.2475H33.0075C33.1975 36.2475 33.3875 36.2275 33.6075 36.1875C34.0075 36.1075 34.4075 36.3775 34.4875 36.7875L34.4775 36.7775ZM15.8275 31.7975C15.6975 31.9375 15.7575 32.0875 15.7775 32.1175C15.8175 32.1975 15.8675 32.2475 15.9375 32.2475H29.8175C30.2275 32.2475 30.5675 32.5875 30.5675 32.9975C30.5675 33.4075 30.2275 33.7475 29.8175 33.7475H15.9375C15.2675 33.7475 14.6775 33.3475 14.3975 32.7175C14.1075 32.0575 14.2375 31.2975 14.7275 30.7775L19.7275 25.2775C20.0475 24.9275 20.5075 24.7175 20.9875 24.7075C21.4875 24.7275 21.9375 24.8875 22.2675 25.2275L25.4675 28.4775C25.7575 28.7675 25.7575 29.2475 25.4675 29.5375C25.1675 29.8275 24.6975 29.8275 24.4075 29.5375L21.2075 26.2875C21.1475 26.2175 21.0675 26.1875 21.0275 26.2075C20.9875 26.2075 20.9075 26.2175 20.8475 26.2875L15.8375 31.7975H15.8275ZM38.5275 38.5275C38.3775 38.6775 38.1875 38.7475 37.9975 38.7475C37.8075 38.7475 37.6175 38.6775 37.4675 38.5275L9.4675 10.5275C9.1775 10.2375 9.1775 9.7575 9.4675 9.4675C9.7575 9.1775 10.2375 9.1775 10.5275 9.4675L38.5275 37.4675C38.8175 37.7575 38.8175 38.2375 38.5275 38.5275Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-appearance-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/pg-appearance-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.75 10.5C19.75 9.72 19.35 9.04 18.75 8.63V3C18.75 2.04 17.96 1.25 17 1.25H7C6.04 1.25 5.25 2.04 5.25 3V8.63C4.65 9.03 4.25 9.72 4.25 10.5C4.25 11.28 4.65 11.96 5.25 12.37V13.14C5.25 14.58 6.42 15.75 7.86 15.75C8.19 15.75 8.48 15.89 8.7 16.13C8.92 16.37 9.01 16.69 8.96 17.01L8.69 18.92C8.55 19.88 8.84 20.86 9.48 21.59C10.12 22.32 11.04 22.75 12.01 22.75C12.98 22.75 13.91 22.33 14.54 21.59C15.18 20.85 15.46 19.88 15.33 18.92L15.06 17.01C15.01 16.69 15.11 16.37 15.32 16.13C15.53 15.89 15.83 15.75 16.16 15.75C17.6 15.75 18.77 14.58 18.77 13.14V12.37C19.37 11.97 19.77 11.28 19.77 10.5H19.75ZM5.75 10.5C5.75 10.09 6.09 9.75 6.5 9.75H17.5C17.91 9.75 18.25 10.09 18.25 10.5C18.25 10.91 17.91 11.25 17.5 11.25H6.5C6.09 11.25 5.75 10.91 5.75 10.5ZM6.75 3C6.75 2.86 6.86 2.75 7 2.75H11.25V4C11.25 4.41 11.59 4.75 12 4.75C12.41 4.75 12.75 4.41 12.75 4V2.75H14.25V5C14.25 5.41 14.59 5.75 15 5.75C15.41 5.75 15.75 5.41 15.75 5V2.75H17C17.14 2.75 17.25 2.86 17.25 3V8.25H6.75V3ZM17.25 13.14C17.25 13.75 16.75 14.25 16.14 14.25C15.38 14.25 14.67 14.58 14.17 15.15C13.67 15.72 13.45 16.48 13.56 17.23L13.83 19.14C13.91 19.67 13.75 20.21 13.4 20.62C12.69 21.43 11.31 21.43 10.6 20.62C10.25 20.21 10.09 19.68 10.17 19.14L10.44 17.23C10.55 16.48 10.32 15.72 9.83 15.15C9.33 14.58 8.62 14.25 7.86 14.25C7.25 14.25 6.75 13.75 6.75 13.14V12.75H17.25V13.14ZM11 19C11 18.45 11.45 18 12 18C12.55 18 13 18.45 13 19C13 19.55 12.55 20 12 20C11.45 20 11 19.55 11 19Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-background-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/pg-background-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.47 8.53C5.18 8.24 5.18 7.76 5.47 7.47L7.47 5.47C7.76 5.18 8.24 5.18 8.53 5.47C8.82 5.76 8.82 6.24 8.53 6.53L6.53 8.53C6.38 8.68 6.19 8.75 6 8.75C5.81 8.75 5.62 8.68 5.47 8.53ZM6 13.75C6.19 13.75 6.38 13.68 6.53 13.53L13.53 6.53C13.82 6.24 13.82 5.76 13.53 5.47C13.24 5.18 12.76 5.18 12.47 5.47L5.47 12.47C5.18 12.76 5.18 13.24 5.47 13.53C5.62 13.68 5.81 13.75 6 13.75ZM17.47 5.47L5.47 17.47C5.18 17.76 5.18 18.24 5.47 18.53C5.62 18.68 5.81 18.75 6 18.75C6.19 18.75 6.38 18.68 6.53 18.53L18.53 6.53C18.82 6.24 18.82 5.76 18.53 5.47C18.24 5.18 17.76 5.18 17.47 5.47ZM17.47 10.47L10.47 17.47C10.18 17.76 10.18 18.24 10.47 18.53C10.62 18.68 10.81 18.75 11 18.75C11.19 18.75 11.38 18.68 11.53 18.53L18.53 11.53C18.82 11.24 18.82 10.76 18.53 10.47C18.24 10.18 17.76 10.18 17.47 10.47ZM17.47 15.47L15.47 17.47C15.18 17.76 15.18 18.24 15.47 18.53C15.62 18.68 15.81 18.75 16 18.75C16.19 18.75 16.38 18.68 16.53 18.53L18.53 16.53C18.82 16.24 18.82 15.76 18.53 15.47C18.24 15.18 17.76 15.18 17.47 15.47ZM21.75 5V19C21.75 20.52 20.52 21.75 19 21.75H5C3.48 21.75 2.25 20.52 2.25 19V5C2.25 3.48 3.48 2.25 5 2.25H19C20.52 2.25 21.75 3.48 21.75 5ZM20.25 5C20.25 4.31 19.69 3.75 19 3.75H5C4.31 3.75 3.75 4.31 3.75 5V19C3.75 19.69 4.31 20.25 5 20.25H19C19.69 20.25 20.25 19.69 20.25 19V5Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-columns-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v2/pg-columns-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.75 4V20C18.75 20.41 18.41 20.75 18 20.75C17.59 20.75 17.25 20.41 17.25 20V4C17.25 3.59 17.59 3.25 18 3.25C18.41 3.25 18.75 3.59 18.75 4ZM14 3.25C13.59 3.25 13.25 3.59 13.25 4V20C13.25 20.41 13.59 20.75 14 20.75C14.41 20.75 14.75 20.41 14.75 20V4C14.75 3.59 14.41 3.25 14 3.25ZM10 3.25C9.59 3.25 9.25 3.59 9.25 4V20C9.25 20.41 9.59 20.75 10 20.75C10.41 20.75 10.75 20.41 10.75 20V4C10.75 3.59 10.41 3.25 10 3.25ZM6 3.25C5.59 3.25 5.25 3.59 5.25 4V20C5.25 20.41 5.59 20.75 6 20.75C6.41 20.75 6.75 20.41 6.75 20V4C6.75 3.59 6.41 3.25 6 3.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-conditions-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/pg-conditions-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.53 14.47C17.24 14.18 16.76 14.18 16.47 14.47C16.18 14.76 16.18 15.24 16.47 15.53L18.19 17.25H8.63C8.57 17.05 8.49 16.85 8.39 16.67L16.67 8.39C17.07 8.61 17.52 8.75 18 8.75C19.52 8.75 20.75 7.52 20.75 6C20.75 4.48 19.52 3.25 18 3.25C16.75 3.25 15.7 4.1 15.37 5.25H8.64C8.31 4.1 7.26 3.25 6.01 3.25C4.48 3.25 3.25 4.48 3.25 6C3.25 7.52 4.48 8.75 6 8.75C7.25 8.75 8.3 7.9 8.63 6.75H15.36C15.42 6.95 15.5 7.15 15.6 7.33L7.33 15.61C6.93 15.39 6.48 15.25 6 15.25C4.48 15.25 3.25 16.48 3.25 18C3.25 19.52 4.48 20.75 6 20.75C7.25 20.75 8.3 19.9 8.63 18.75H18.19L16.47 20.47C16.18 20.76 16.18 21.24 16.47 21.53C16.62 21.68 16.81 21.75 17 21.75C17.19 21.75 17.38 21.68 17.53 21.53L20.53 18.53C20.82 18.24 20.82 17.76 20.53 17.47L17.53 14.47ZM6 7.25C5.31 7.25 4.75 6.69 4.75 6C4.75 5.31 5.31 4.75 6 4.75C6.69 4.75 7.25 5.31 7.25 6C7.25 6.69 6.69 7.25 6 7.25ZM18 4.75C18.69 4.75 19.25 5.31 19.25 6C19.25 6.69 18.69 7.25 18 7.25C17.31 7.25 16.75 6.69 16.75 6C16.75 5.31 17.31 4.75 18 4.75ZM6 19.25C5.31 19.25 4.75 18.69 4.75 18C4.75 17.31 5.31 16.75 6 16.75C6.69 16.75 7.25 17.31 7.25 18C7.25 18.69 6.69 19.25 6 19.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-data-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/pg-data-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2.25C7.58 2.25 4.25 3.86 4.25 6V18C4.25 20.14 7.58 21.75 12 21.75C16.42 21.75 19.75 20.14 19.75 18V6C19.75 3.86 16.42 2.25 12 2.25ZM18.25 14C18.25 14.92 15.82 16.25 12 16.25C8.18 16.25 5.75 14.92 5.75 14V12.27C7.14 13.18 9.37 13.75 12 13.75C14.63 13.75 16.86 13.18 18.25 12.27V14ZM18.25 10C18.25 10.92 15.82 12.25 12 12.25C8.18 12.25 5.75 10.92 5.75 10V8.27C7.14 9.18 9.37 9.75 12 9.75C14.63 9.75 16.86 9.18 18.25 8.27V10ZM12 3.75C15.82 3.75 18.25 5.08 18.25 6C18.25 6.92 15.82 8.25 12 8.25C8.18 8.25 5.75 6.92 5.75 6C5.75 5.08 8.18 3.75 12 3.75ZM12 20.25C8.18 20.25 5.75 18.92 5.75 18V16.27C7.14 17.18 9.37 17.75 12 17.75C14.63 17.75 16.86 17.18 18.25 16.27V18C18.25 18.92 15.82 20.25 12 20.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-design-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/pg-design-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.67 4.8C19.01 4.53 18.27 4.68 17.76 5.18L5.18 17.76C4.68 18.26 4.53 19.01 4.8 19.67C5.07 20.33 5.71 20.75 6.42 20.75H19.01C19.97 20.75 20.76 19.96 20.76 19V6.41C20.76 5.7 20.34 5.07 19.68 4.79L19.67 4.8ZM19.25 19C19.25 19.14 19.14 19.25 19 19.25H6.41C6.26 19.25 6.2 19.15 6.18 19.1C6.16 19.04 6.13 18.93 6.23 18.83L18.82 6.24C18.88 6.18 18.94 6.16 18.99 6.16C19.03 6.16 19.07 6.17 19.09 6.18C19.15 6.2 19.24 6.26 19.24 6.41V19H19.25ZM17.29 10.31C17.01 10.2 16.69 10.26 16.47 10.47L10.47 16.47C10.26 16.68 10.19 17.01 10.31 17.29C10.43 17.57 10.7 17.75 11 17.75H17C17.41 17.75 17.75 17.41 17.75 17V11C17.75 10.7 17.57 10.42 17.29 10.31ZM16.25 16.25H12.81L16.25 12.81V16.25ZM9 6.25C7.48 6.25 6.25 7.48 6.25 9C6.25 10.52 7.48 11.75 9 11.75C10.52 11.75 11.75 10.52 11.75 9C11.75 7.48 10.52 6.25 9 6.25ZM9 10.25C8.31 10.25 7.75 9.69 7.75 9C7.75 8.31 8.31 7.75 9 7.75C9.69 7.75 10.25 8.31 10.25 9C10.25 9.69 9.69 10.25 9 10.25ZM4.23 13.77C3.67 13.21 3.57 12.36 3.93 11.7C3.75 11.37 3.61 11.03 3.5 10.68C2.78 10.47 2.25 9.79 2.25 9C2.25 8.21 2.78 7.54 3.5 7.32C3.61 6.97 3.75 6.62 3.93 6.3C3.57 5.64 3.67 4.79 4.23 4.23C4.79 3.67 5.64 3.57 6.3 3.93C6.63 3.75 6.97 3.61 7.32 3.5C7.53 2.78 8.21 2.25 9 2.25C9.79 2.25 10.46 2.78 10.68 3.5C11.03 3.61 11.38 3.75 11.7 3.93C12.36 3.57 13.21 3.67 13.77 4.23C14.1 4.56 14.28 5 14.28 5.47C14.28 5.77 14.21 6.06 14.07 6.31C14.19 6.54 14.29 6.79 14.39 7.06C14.53 7.45 14.33 7.88 13.94 8.02C13.55 8.16 13.12 7.96 12.98 7.57C12.85 7.2 12.7 6.91 12.54 6.66C12.34 6.36 12.38 5.97 12.63 5.71L12.7 5.64C12.76 5.58 12.77 5.5 12.77 5.46C12.77 5.42 12.77 5.35 12.7 5.29C12.6 5.19 12.44 5.19 12.35 5.29L12.28 5.36C12.03 5.61 11.63 5.65 11.34 5.45C10.88 5.15 10.38 4.94 9.85 4.83C9.5 4.76 9.25 4.45 9.25 4.09V3.99C9.25 3.71 8.75 3.71 8.75 3.99V4.09C8.75 4.45 8.5 4.75 8.15 4.83C7.62 4.94 7.12 5.15 6.66 5.45C6.36 5.65 5.97 5.61 5.72 5.36L5.65 5.29C5.55 5.19 5.39 5.19 5.3 5.29C5.2 5.39 5.2 5.55 5.3 5.64L5.37 5.71C5.62 5.96 5.66 6.36 5.47 6.65C5.17 7.11 4.96 7.61 4.85 8.14C4.78 8.49 4.47 8.74 4.11 8.74H4.01C3.87 8.74 3.76 8.85 3.76 8.99C3.76 9.13 3.87 9.24 4.01 9.24H4.11C4.47 9.24 4.77 9.49 4.85 9.84C4.96 10.37 5.17 10.87 5.47 11.33C5.67 11.63 5.63 12.02 5.37 12.27L5.3 12.34C5.2 12.44 5.2 12.6 5.3 12.69C5.4 12.79 5.56 12.79 5.65 12.69L5.72 12.62C5.97 12.37 6.37 12.33 6.67 12.53C6.92 12.69 7.21 12.84 7.58 12.97C7.97 13.11 8.17 13.54 8.03 13.93C7.92 14.23 7.63 14.42 7.32 14.42C7.24 14.42 7.15 14.41 7.06 14.38C6.79 14.28 6.54 14.17 6.31 14.06C5.65 14.42 4.77 14.3 4.23 13.76V13.77Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-general-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v2/pg-general-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 3.25H6C4.48 3.25 3.25 4.48 3.25 6V18C3.25 19.52 4.48 20.75 6 20.75H18C19.52 20.75 20.75 19.52 20.75 18V6C20.75 4.48 19.52 3.25 18 3.25ZM19.25 18C19.25 18.69 18.69 19.25 18 19.25H6C5.31 19.25 4.75 18.69 4.75 18V6C4.75 5.31 5.31 4.75 6 4.75H18C18.69 4.75 19.25 5.31 19.25 6V18ZM9.75 9C9.75 9.41 9.41 9.75 9 9.75H8C7.59 9.75 7.25 9.41 7.25 9C7.25 8.59 7.59 8.25 8 8.25H9C9.41 8.25 9.75 8.59 9.75 9ZM16.75 9C16.75 9.41 16.41 9.75 16 9.75H12C11.59 9.75 11.25 9.41 11.25 9C11.25 8.59 11.59 8.25 12 8.25H16C16.41 8.25 16.75 8.59 16.75 9ZM9.75 12C9.75 12.41 9.41 12.75 9 12.75H8C7.59 12.75 7.25 12.41 7.25 12C7.25 11.59 7.59 11.25 8 11.25H9C9.41 11.25 9.75 11.59 9.75 12ZM16.75 12C16.75 12.41 16.41 12.75 16 12.75H12C11.59 12.75 11.25 12.41 11.25 12C11.25 11.59 11.59 11.25 12 11.25H16C16.41 11.25 16.75 11.59 16.75 12ZM9.75 15C9.75 15.41 9.41 15.75 9 15.75H8C7.59 15.75 7.25 15.41 7.25 15C7.25 14.59 7.59 14.25 8 14.25H9C9.41 14.25 9.75 14.59 9.75 15ZM16.75 15C16.75 15.41 16.41 15.75 16 15.75H12C11.59 15.75 11.25 15.41 11.25 15C11.25 14.59 11.59 14.25 12 14.25H16C16.41 14.25 16.75 14.59 16.75 15Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-header-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/pg-header-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 3.25H5C3.48 3.25 2.25 4.48 2.25 6V13C2.25 14.52 3.48 15.75 5 15.75H19C20.52 15.75 21.75 14.52 21.75 13V6C21.75 4.48 20.52 3.25 19 3.25ZM6.81 14.25L10 11.06L11.47 12.53C11.76 12.82 12.24 12.82 12.53 12.53L13 12.06L15.19 14.25H6.81ZM20.25 13C20.25 13.69 19.69 14.25 19 14.25H17.31L13.53 10.47C13.24 10.18 12.76 10.18 12.47 10.47L12 10.94L10.53 9.47C10.24 9.18 9.76 9.18 9.47 9.47L4.74 14.2C4.18 14.08 3.75 13.6 3.75 13V6C3.75 5.31 4.31 4.75 5 4.75H19C19.69 4.75 20.25 5.31 20.25 6V13ZM16.5 6.25C15.26 6.25 14.25 7.26 14.25 8.5C14.25 9.74 15.26 10.75 16.5 10.75C17.74 10.75 18.75 9.74 18.75 8.5C18.75 7.26 17.74 6.25 16.5 6.25ZM16.5 9.25C16.09 9.25 15.75 8.91 15.75 8.5C15.75 8.09 16.09 7.75 16.5 7.75C16.91 7.75 17.25 8.09 17.25 8.5C17.25 8.91 16.91 9.25 16.5 9.25ZM15.75 21C15.75 21.41 15.41 21.75 15 21.75H9C8.59 21.75 8.25 21.41 8.25 21C8.25 20.59 8.59 20.25 9 20.25H15C15.41 20.25 15.75 20.59 15.75 21ZM17.75 18C17.75 18.41 17.41 18.75 17 18.75H7C6.59 18.75 6.25 18.41 6.25 18C6.25 17.59 6.59 17.25 7 17.25H17C17.41 17.25 17.75 17.59 17.75 18Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-language-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v2/pg-language-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M22.67 20.67L16.67 8.67C16.42 8.16 15.58 8.16 15.33 8.67L9.33 20.67C9.14 21.04 9.29 21.49 9.67 21.68C10.04 21.87 10.49 21.72 10.68 21.34L12.98 16.75C12.98 16.75 13 16.75 13.01 16.75H19.01C19.01 16.75 19.03 16.75 19.04 16.75L21.34 21.34C21.47 21.6 21.74 21.76 22.01 21.76C22.12 21.76 22.24 21.73 22.34 21.68C22.71 21.49 22.86 21.04 22.68 20.67H22.67ZM13.71 15.25L16 10.68L18.29 15.25H13.72H13.71ZM10.7 12.23C9.9 11.17 9.36 10.03 8.99 8.88C8.18 11.39 6.56 13.74 3.38 15.65C3.26 15.72 3.13 15.76 3 15.76C2.75 15.76 2.5 15.63 2.36 15.4C2.15 15.04 2.26 14.58 2.62 14.37C6.39 12.11 7.74 9.32 8.12 5.76H3C2.59 5.75 2.25 5.41 2.25 5C2.25 4.59 2.59 4.25 3 4.25H8.22C8.24 3.84 8.25 3.43 8.25 3C8.25 2.57 8.59 2.25 9 2.25C9.41 2.25 9.75 2.59 9.75 3C9.75 3.43 9.76 3.85 9.78 4.25H15C15.41 4.25 15.75 4.59 15.75 5C15.75 5.41 15.41 5.75 15 5.75H9.89C10.15 8.09 10.79 9.84 11.9 11.33C12.15 11.66 12.08 12.13 11.75 12.38C11.42 12.63 10.95 12.56 10.7 12.23Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-layout-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/pg-layout-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 3.25H5C4.04 3.25 3.25 4.04 3.25 5V9C3.25 9.96 4.04 10.75 5 10.75H19C19.96 10.75 20.75 9.96 20.75 9V5C20.75 4.04 19.96 3.25 19 3.25ZM19.25 9C19.25 9.14 19.14 9.25 19 9.25H5C4.86 9.25 4.75 9.14 4.75 9V5C4.75 4.86 4.86 4.75 5 4.75H19C19.14 4.75 19.25 4.86 19.25 5V9ZM11 12.25H5C4.04 12.25 3.25 13.04 3.25 14V19C3.25 19.96 4.04 20.75 5 20.75H11C11.96 20.75 12.75 19.96 12.75 19V14C12.75 13.04 11.96 12.25 11 12.25ZM11.25 19C11.25 19.14 11.14 19.25 11 19.25H5C4.86 19.25 4.75 19.14 4.75 19V14C4.75 13.86 4.86 13.75 5 13.75H11C11.14 13.75 11.25 13.86 11.25 14V19ZM19 12.25H16C15.04 12.25 14.25 13.04 14.25 14V19C14.25 19.96 15.04 20.75 16 20.75H19C19.96 20.75 20.75 19.96 20.75 19V14C20.75 13.04 19.96 12.25 19 12.25ZM19.25 19C19.25 19.14 19.14 19.25 19 19.25H16C15.86 19.25 15.75 19.14 15.75 19V14C15.75 13.86 15.86 13.75 16 13.75H19C19.14 13.75 19.25 13.86 19.25 14V19Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-logo-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/pg-logo-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 3.25H6C4.48 3.25 3.25 4.48 3.25 6V18C3.25 19.52 4.48 20.75 6 20.75H18C19.52 20.75 20.75 19.52 20.75 18V6C20.75 4.48 19.52 3.25 18 3.25ZM19.25 18C19.25 18.69 18.69 19.25 18 19.25H6C5.31 19.25 4.75 18.69 4.75 18V6C4.75 5.31 5.31 4.75 6 4.75H18C18.69 4.75 19.25 5.31 19.25 6V18ZM15.5 6.25C14.26 6.25 13.25 7.26 13.25 8.5C13.25 9.74 14.26 10.75 15.5 10.75C16.74 10.75 17.75 9.74 17.75 8.5C17.75 7.26 16.74 6.25 15.5 6.25ZM15.5 9.25C15.09 9.25 14.75 8.91 14.75 8.5C14.75 8.09 15.09 7.75 15.5 7.75C15.91 7.75 16.25 8.09 16.25 8.5C16.25 8.91 15.91 9.25 15.5 9.25ZM14.53 13.47C14.24 13.18 13.76 13.18 13.47 13.47L13 13.94L11.53 12.47C11.24 12.18 10.76 12.18 10.47 12.47L6.47 16.47C6.26 16.68 6.19 17.01 6.31 17.29C6.43 17.57 6.7 17.75 7 17.75H17C17.3 17.75 17.58 17.57 17.69 17.29C17.81 17.01 17.74 16.69 17.53 16.47L14.53 13.47ZM8.81 16.25L11 14.06L12.47 15.53C12.76 15.82 13.24 15.82 13.53 15.53L14 15.06L15.19 16.25H8.81Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-navigation-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/pg-navigation-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.06 8.88C9.63 8.67 9.13 8.71 8.75 9L6.08 11C5.76 11.24 5.58 11.6 5.58 12C5.58 12.4 5.76 12.76 6.08 13L8.75 15C8.97 15.17 9.23 15.25 9.5 15.25C9.69 15.25 9.88 15.21 10.06 15.12C10.49 14.91 10.75 14.48 10.75 14V10C10.75 9.52 10.49 9.09 10.06 8.88ZM9.25 13.5L7.25 12L9.25 10.5V13.5ZM17.92 11L15.25 9C14.87 8.71 14.37 8.67 13.94 8.88C13.51 9.09 13.25 9.52 13.25 10V14C13.25 14.48 13.51 14.91 13.94 15.12C14.12 15.21 14.31 15.25 14.5 15.25C14.76 15.25 15.03 15.17 15.25 15L17.92 13C18.24 12.76 18.42 12.4 18.42 12C18.42 11.6 18.24 11.24 17.92 11ZM14.75 13.5V10.5L16.75 12L14.75 13.5ZM12 2.25C6.62 2.25 2.25 6.62 2.25 12C2.25 17.38 6.62 21.75 12 21.75C17.38 21.75 21.75 17.38 21.75 12C21.75 6.62 17.38 2.25 12 2.25ZM12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-pages-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v2/pg-pages-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17 2.25H7C5.48 2.25 4.25 3.48 4.25 5V19C4.25 20.52 5.48 21.75 7 21.75H17C18.52 21.75 19.75 20.52 19.75 19V5C19.75 3.48 18.52 2.25 17 2.25ZM18.25 19C18.25 19.69 17.69 20.25 17 20.25H7C6.31 20.25 5.75 19.69 5.75 19V5C5.75 4.31 6.31 3.75 7 3.75H17C17.69 3.75 18.25 4.31 18.25 5V19ZM7.25 6C7.25 5.59 7.59 5.25 8 5.25H10C10.41 5.25 10.75 5.59 10.75 6C10.75 6.41 10.41 6.75 10 6.75H8C7.59 6.75 7.25 6.41 7.25 6ZM16.75 9C16.75 9.41 16.41 9.75 16 9.75H8C7.59 9.75 7.25 9.41 7.25 9C7.25 8.59 7.59 8.25 8 8.25H16C16.41 8.25 16.75 8.59 16.75 9ZM16.75 12C16.75 12.41 16.41 12.75 16 12.75H8C7.59 12.75 7.25 12.41 7.25 12C7.25 11.59 7.59 11.25 8 11.25H16C16.41 11.25 16.75 11.59 16.75 12ZM16.75 15C16.75 15.41 16.41 15.75 16 15.75H8C7.59 15.75 7.25 15.41 7.25 15C7.25 14.59 7.59 14.25 8 14.25H16C16.41 14.25 16.75 14.59 16.75 15ZM16.75 18C16.75 18.41 16.41 18.75 16 18.75H13C12.59 18.75 12.25 18.41 12.25 18C12.25 17.59 12.59 17.25 13 17.25H16C16.41 17.25 16.75 17.59 16.75 18Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-questiondesign-24x24.svg":
/*!***************************************************!*\
  !*** ./src/images-v2/pg-questiondesign-24x24.svg ***!
  \***************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.75 15.01V16.01C20.75 17.53 19.52 18.76 18 18.76H12.31L8.53 22.54C8.39 22.68 8.2 22.76 8 22.76C7.9 22.76 7.81 22.74 7.71 22.7C7.43 22.58 7.25 22.31 7.25 22.01V18.76H6C4.48 18.76 3.25 17.53 3.25 16.01V6.01C3.25 4.49 4.48 3.26 6 3.26H9C9.41 3.26 9.75 3.6 9.75 4.01C9.75 4.42 9.41 4.76 9 4.76H6C5.31 4.76 4.75 5.32 4.75 6.01V16.01C4.75 16.7 5.31 17.26 6 17.26H8C8.41 17.26 8.75 17.6 8.75 18.01V20.2L11.47 17.48C11.61 17.34 11.8 17.26 12 17.26H18C18.69 17.26 19.25 16.7 19.25 16.01V15.01C19.25 14.6 19.59 14.26 20 14.26C20.41 14.26 20.75 14.6 20.75 15.01ZM22.75 8.01C22.75 8.8 22.22 9.47 21.5 9.69C21.39 10.04 21.25 10.38 21.07 10.71C21.21 10.96 21.28 11.25 21.28 11.55C21.28 12.02 21.1 12.46 20.77 12.79C20.44 13.12 20 13.3 19.53 13.3C19.23 13.3 18.95 13.23 18.69 13.09C18.36 13.27 18.02 13.41 17.67 13.52C17.46 14.24 16.78 14.77 15.99 14.77C15.2 14.77 14.53 14.24 14.31 13.52C13.96 13.41 13.62 13.27 13.29 13.09C13.04 13.23 12.75 13.3 12.45 13.3C11.98 13.3 11.54 13.12 11.21 12.79C10.88 12.46 10.7 12.02 10.7 11.55C10.7 11.25 10.77 10.97 10.91 10.71C10.73 10.38 10.59 10.04 10.48 9.69C9.76 9.48 9.23 8.8 9.23 8.01C9.23 7.22 9.76 6.55 10.48 6.33C10.59 5.98 10.73 5.64 10.91 5.31C10.77 5.06 10.7 4.77 10.7 4.47C10.7 4 10.88 3.56 11.21 3.23C11.54 2.9 11.98 2.72 12.45 2.72C12.75 2.72 13.03 2.79 13.29 2.93C13.62 2.75 13.96 2.61 14.31 2.5C14.52 1.78 15.2 1.25 15.99 1.25C16.78 1.25 17.45 1.78 17.67 2.5C18.02 2.61 18.36 2.75 18.69 2.93C18.94 2.79 19.23 2.72 19.53 2.72C20 2.72 20.44 2.9 20.77 3.23C21.1 3.56 21.28 4 21.28 4.47C21.28 4.77 21.21 5.05 21.07 5.31C21.25 5.64 21.39 5.98 21.5 6.33C22.22 6.54 22.75 7.22 22.75 8.01ZM21.25 8.01C21.25 7.87 21.14 7.76 21 7.76H20.9C20.54 7.76 20.24 7.51 20.16 7.16C20.05 6.63 19.84 6.13 19.54 5.67C19.34 5.37 19.38 4.98 19.63 4.73L19.7 4.66C19.76 4.6 19.77 4.52 19.77 4.48C19.77 4.44 19.77 4.37 19.7 4.31C19.63 4.25 19.56 4.24 19.52 4.24C19.52 4.24 19.41 4.24 19.34 4.31L19.27 4.38C19.02 4.63 18.62 4.67 18.33 4.47C17.87 4.17 17.37 3.96 16.84 3.85C16.49 3.78 16.24 3.47 16.24 3.11V3.01C16.24 2.73 15.74 2.73 15.74 3.01V3.11C15.74 3.47 15.49 3.77 15.14 3.85C14.61 3.96 14.11 4.17 13.65 4.47C13.36 4.67 12.96 4.63 12.71 4.38L12.64 4.31C12.52 4.19 12.41 4.18 12.29 4.31C12.23 4.37 12.22 4.45 12.22 4.49C12.22 4.53 12.22 4.6 12.29 4.67L12.36 4.74C12.61 4.99 12.65 5.39 12.45 5.68C12.15 6.14 11.94 6.64 11.83 7.17C11.76 7.52 11.45 7.77 11.09 7.77H10.99C10.85 7.77 10.74 7.88 10.74 8.02C10.74 8.16 10.85 8.27 10.99 8.27H11.09C11.45 8.27 11.75 8.52 11.83 8.87C11.94 9.4 12.15 9.9 12.45 10.36C12.65 10.66 12.61 11.05 12.36 11.3L12.29 11.37C12.23 11.43 12.22 11.51 12.22 11.55C12.22 11.59 12.22 11.66 12.29 11.72C12.36 11.79 12.44 11.79 12.47 11.79C12.51 11.79 12.58 11.79 12.65 11.72L12.72 11.65C12.86 11.51 13.06 11.43 13.25 11.43C13.39 11.43 13.54 11.47 13.66 11.55C14.12 11.85 14.62 12.06 15.15 12.17C15.5 12.24 15.75 12.55 15.75 12.91V13.01C15.75 13.29 16.25 13.29 16.25 13.01V12.91C16.25 12.55 16.5 12.25 16.85 12.17C17.38 12.06 17.88 11.85 18.34 11.55C18.64 11.35 19.03 11.39 19.28 11.64L19.35 11.71C19.47 11.83 19.58 11.84 19.7 11.71C19.76 11.65 19.77 11.57 19.77 11.53C19.77 11.49 19.77 11.42 19.7 11.35L19.63 11.28C19.38 11.03 19.34 10.63 19.54 10.34C19.84 9.88 20.05 9.38 20.16 8.85C20.23 8.5 20.54 8.25 20.9 8.25H21C21.14 8.25 21.25 8.14 21.25 8V8.01ZM18.75 8.01C18.75 9.53 17.52 10.76 16 10.76C14.48 10.76 13.25 9.53 13.25 8.01C13.25 6.49 14.48 5.26 16 5.26C17.52 5.26 18.75 6.49 18.75 8.01ZM17.25 8.01C17.25 7.32 16.69 6.76 16 6.76C15.31 6.76 14.75 7.32 14.75 8.01C14.75 8.7 15.31 9.26 16 9.26C16.69 9.26 17.25 8.7 17.25 8.01Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-quiz-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/pg-quiz-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.69 7.38L19.53 6.54C19.82 6.25 19.82 5.77 19.53 5.48C19.24 5.19 18.76 5.19 18.47 5.48L17.63 6.32C16.11 5.04 14.14 4.26 12 4.26C9.86 4.26 7.89 5.04 6.37 6.32L5.53 5.48C5.24 5.19 4.76 5.19 4.47 5.48C4.18 5.77 4.18 6.25 4.47 6.54L5.31 7.38C4.03 8.9 3.25 10.87 3.25 13.01C3.25 17.84 7.17 21.76 12 21.76C16.83 21.76 20.75 17.84 20.75 13.01C20.75 10.87 19.97 8.9 18.69 7.38ZM12 20.26C8 20.26 4.75 17.01 4.75 13.01C4.75 9.01 8 5.76 12 5.76C16 5.76 19.25 9.01 19.25 13.01C19.25 17.01 16 20.26 12 20.26ZM15.53 9.48C15.82 9.77 15.82 10.25 15.53 10.54L12.53 13.54C12.38 13.69 12.19 13.76 12 13.76C11.81 13.76 11.62 13.69 11.47 13.54C11.18 13.25 11.18 12.77 11.47 12.48L14.47 9.48C14.76 9.19 15.24 9.19 15.53 9.48ZM9.26 2.34C9.18 1.93 9.45 1.54 9.86 1.46C11.31 1.18 12.69 1.18 14.14 1.46C14.55 1.54 14.81 1.93 14.74 2.34C14.67 2.7 14.36 2.95 14 2.95C13.95 2.95 13.91 2.95 13.86 2.94C12.59 2.7 11.41 2.7 10.14 2.94C9.74 3.02 9.34 2.75 9.26 2.34Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-rows-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/pg-rows-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3.25 6C3.25 5.59 3.59 5.25 4 5.25H20C20.41 5.25 20.75 5.59 20.75 6C20.75 6.41 20.41 6.75 20 6.75H4C3.59 6.75 3.25 6.41 3.25 6ZM20 9.25H4C3.59 9.25 3.25 9.59 3.25 10C3.25 10.41 3.59 10.75 4 10.75H20C20.41 10.75 20.75 10.41 20.75 10C20.75 9.59 20.41 9.25 20 9.25ZM20 13.25H4C3.59 13.25 3.25 13.59 3.25 14C3.25 14.41 3.59 14.75 4 14.75H20C20.41 14.75 20.75 14.41 20.75 14C20.75 13.59 20.41 13.25 20 13.25ZM20 17.25H4C3.59 17.25 3.25 17.59 3.25 18C3.25 18.41 3.59 18.75 4 18.75H20C20.41 18.75 20.75 18.41 20.75 18C20.75 17.59 20.41 17.25 20 17.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-specific-24x24.svg":
/*!*********************************************!*\
  !*** ./src/images-v2/pg-specific-24x24.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.75 11V16C20.75 17.52 19.52 18.75 18 18.75H12.31L8.53 22.53C8.39 22.67 8.2 22.75 8 22.75C7.9 22.75 7.81 22.73 7.71 22.69C7.43 22.57 7.25 22.3 7.25 22V18.75H6C4.48 18.75 3.25 17.52 3.25 16V6C3.25 4.48 4.48 3.25 6 3.25H13C13.41 3.25 13.75 3.59 13.75 4C13.75 4.41 13.41 4.75 13 4.75H6C5.31 4.75 4.75 5.31 4.75 6V16C4.75 16.69 5.31 17.25 6 17.25H8C8.41 17.25 8.75 17.59 8.75 18V20.19L11.47 17.47C11.61 17.33 11.8 17.25 12 17.25H18C18.69 17.25 19.25 16.69 19.25 16V11C19.25 10.59 19.59 10.25 20 10.25C20.41 10.25 20.75 10.59 20.75 11ZM21.03 7.03L14.53 13.53C14.43 13.63 14.31 13.69 14.18 13.73L10.18 14.73C10.12 14.74 10.06 14.75 10 14.75C9.8 14.75 9.61 14.67 9.47 14.53C9.28 14.34 9.21 14.07 9.27 13.82L10.27 9.82C10.3 9.69 10.37 9.57 10.47 9.47001L16.97 2.97C18.09 1.85 19.91 1.85 21.03 2.97C22.15 4.09 22.15 5.91001 21.03 7.03ZM17.94 8L16 6.06L11.68 10.38L11.03 12.96L13.61 12.31L17.93 7.99001L17.94 8ZM19.97 4.03C19.43 3.49 18.57 3.49 18.03 4.03L17.06 5L19 6.94L19.97 5.97C20.5 5.43 20.5 4.57 19.97 4.03Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-thankyyoupage-24x24.svg":
/*!**************************************************!*\
  !*** ./src/images-v2/pg-thankyyoupage-24x24.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18.5275 17.4675C18.8175 17.7575 18.8175 18.2375 18.5275 18.5275C18.3775 18.6775 18.1875 18.7475 17.9975 18.7475C17.8075 18.7475 17.6175 18.6775 17.4675 18.5275L13.4675 14.5275C13.1775 14.2375 13.1775 13.7575 13.4675 13.4675C13.7575 13.1775 14.2375 13.1775 14.5275 13.4675L18.5275 17.4675ZM22.5275 10.5275L19.5275 13.5275C19.3775 13.6775 19.1875 13.7475 18.9975 13.7475C18.8075 13.7475 18.6175 13.6775 18.4675 13.5275L14.9975 10.0575L6.5275 18.5275C6.3775 18.6775 6.1875 18.7475 5.9975 18.7475C5.8075 18.7475 5.6175 18.6775 5.4675 18.5275C5.1775 18.2375 5.1775 17.7575 5.4675 17.4675L10.9375 11.9975L8.9975 10.0575L5.5275 13.5275C5.3775 13.6775 5.1875 13.7475 4.9975 13.7475C4.8075 13.7475 4.6175 13.6775 4.4675 13.5275L1.4675 10.5275C1.1775 10.2375 1.1775 9.7575 1.4675 9.4675L4.9375 5.9975L4.4675 5.5275C4.1775 5.2375 4.1775 4.7575 4.4675 4.4675C4.7575 4.1775 5.2375 4.1775 5.5275 4.4675L6.5275 5.4675L9.5275 8.4675L11.9975 10.9375L14.4675 8.4675L17.4675 5.4675L18.4675 4.4675C18.7575 4.1775 19.2375 4.1775 19.5275 4.4675C19.8175 4.7575 19.8175 5.2375 19.5275 5.5275L19.0575 5.9975L22.5275 9.4675C22.8175 9.7575 22.8175 10.2375 22.5275 10.5275ZM7.9375 8.9975L5.9975 7.0575L3.0575 9.9975L4.9975 11.9375L7.9375 8.9975ZM20.9375 9.9975L17.9975 7.0575L16.0575 8.9975L18.9975 11.9375L20.9375 9.9975Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-themes-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/pg-themes-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 2.25H5C3.48 2.25 2.25 3.48 2.25 5V19C2.25 20.52 3.48 21.75 5 21.75H19C20.52 21.75 21.75 20.52 21.75 19V5C21.75 3.48 20.52 2.25 19 2.25ZM20.25 19C20.25 19.69 19.69 20.25 19 20.25H5C4.31 20.25 3.75 19.69 3.75 19V5C3.75 4.31 4.31 3.75 5 3.75H19C19.69 3.75 20.25 4.31 20.25 5V19ZM7 10.75H9C9.96 10.75 10.75 9.96 10.75 9V7C10.75 6.04 9.96 5.25 9 5.25H7C6.04 5.25 5.25 6.04 5.25 7V9C5.25 9.96 6.04 10.75 7 10.75ZM6.75 7C6.75 6.86 6.86 6.75 7 6.75H9C9.14 6.75 9.25 6.86 9.25 7V9C9.25 9.14 9.14 9.25 9 9.25H7C6.86 9.25 6.75 9.14 6.75 9V7ZM17 5.25H14C13.04 5.25 12.25 6.04 12.25 7V10C12.25 10.96 13.04 11.75 14 11.75H17C17.96 11.75 18.75 10.96 18.75 10V7C18.75 6.04 17.96 5.25 17 5.25ZM17.25 10C17.25 10.14 17.14 10.25 17 10.25H14C13.86 10.25 13.75 10.14 13.75 10V7C13.75 6.86 13.86 6.75 14 6.75H17C17.14 6.75 17.25 6.86 17.25 7V10ZM17 13.25H15C14.04 13.25 13.25 14.04 13.25 15V17C13.25 17.96 14.04 18.75 15 18.75H17C17.96 18.75 18.75 17.96 18.75 17V15C18.75 14.04 17.96 13.25 17 13.25ZM17.25 17C17.25 17.14 17.14 17.25 17 17.25H15C14.86 17.25 14.75 17.14 14.75 17V15C14.75 14.86 14.86 14.75 15 14.75H17C17.14 14.75 17.25 14.86 17.25 15V17ZM10 12.25H7C6.04 12.25 5.25 13.04 5.25 14V17C5.25 17.96 6.04 18.75 7 18.75H10C10.96 18.75 11.75 17.96 11.75 17V14C11.75 13.04 10.96 12.25 10 12.25ZM10.25 17C10.25 17.14 10.14 17.25 10 17.25H7C6.86 17.25 6.75 17.14 6.75 17V14C6.75 13.86 6.86 13.75 7 13.75H10C10.14 13.75 10.25 13.86 10.25 14V17Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-totals-24x24.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/pg-totals-24x24.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.0008 20.75H5.00076C4.70076 20.75 4.42076 20.57 4.31076 20.29C4.19076 20.01 4.26076 19.69 4.47076 19.47L11.9408 12L4.47076 4.53C4.25076 4.32 4.19076 3.99 4.31076 3.71C4.43076 3.43 4.70076 3.25 5.00076 3.25H19.0008C19.4108 3.25 19.7508 3.59 19.7508 4C19.7508 4.41 19.4108 4.75 19.0008 4.75H6.81076L13.5308 11.47C13.8208 11.76 13.8208 12.24 13.5308 12.53L6.81076 19.25H19.0008C19.4108 19.25 19.7508 19.59 19.7508 20C19.7508 20.41 19.4108 20.75 19.0008 20.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-undefined-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/pg-undefined-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.93 5.2475C7.1 5.6275 6.93 6.0675 6.55 6.2375L6.05 6.4575C5.95 6.4975 5.85 6.5175 5.75 6.5175C5.46 6.5175 5.19 6.3475 5.06 6.0675C4.89 5.6875 5.06 5.2475 5.44 5.0775L5.94 4.8575C6.32 4.6875 6.76 4.8575 6.93 5.2375V5.2475ZM8.76 5.1875C8.86 5.1875 8.97 5.1675 9.06 5.1275L9.56 4.9075C9.94 4.7375 10.11 4.2975 9.94 3.9175C9.77 3.5375 9.33 3.3675 8.95 3.5375L8.45 3.7575C8.07 3.9275 7.9 4.3675 8.07 4.7475C8.19 5.0275 8.47 5.1975 8.76 5.1975V5.1875ZM12.53 2.4175L12.3 2.3175C12.11 2.2275 11.88 2.2275 11.69 2.3175L11.46 2.4175C11.08 2.5875 10.91 3.0275 11.08 3.4075C11.24 3.7575 11.64 3.9275 11.99 3.8175C12.07 3.8375 12.14 3.8575 12.22 3.8575C12.51 3.8575 12.78 3.6875 12.91 3.4075C13.08 3.0275 12.91 2.5875 12.53 2.4175ZM15.55 3.7575L15.05 3.5375C14.67 3.3675 14.23 3.5375 14.06 3.9175C13.89 4.2975 14.06 4.7375 14.44 4.9075L14.94 5.1275C15.04 5.1675 15.14 5.1875 15.24 5.1875C15.53 5.1875 15.8 5.0175 15.93 4.7375C16.1 4.3575 15.93 3.9175 15.55 3.7475V3.7575ZM17.45 6.2375L17.95 6.4575C18.05 6.4975 18.15 6.5175 18.25 6.5175C18.54 6.5175 18.81 6.3475 18.94 6.0675C19.11 5.6875 18.94 5.2475 18.56 5.0775L18.06 4.8575C17.68 4.6875 17.24 4.8575 17.07 5.2375C16.9 5.6175 17.07 6.0575 17.45 6.2275V6.2375ZM21.7 6.7375C21.7 6.7375 21.68 6.6875 21.67 6.6675C21.64 6.6075 21.6 6.5575 21.56 6.5075C21.55 6.4875 21.53 6.4775 21.52 6.4575C21.46 6.3975 21.39 6.3475 21.31 6.3175L21.08 6.2175C20.7 6.0475 20.26 6.2175 20.09 6.5975C20.03 6.7275 20.01 6.8675 20.03 7.0075C20.01 7.1375 20.03 7.2775 20.09 7.4175C20.17 7.5975 20.31 7.7175 20.47 7.7875C20.61 7.9275 20.79 8.0075 21 8.0075C21.41 8.0075 21.75 7.6675 21.75 7.2575V7.0075C21.75 6.9175 21.73 6.8275 21.7 6.7475V6.7375ZM14.94 8.8675L14.44 9.0875C14.06 9.2575 13.89 9.6975 14.06 10.0775C14.18 10.3575 14.46 10.5275 14.75 10.5275C14.85 10.5275 14.96 10.5075 15.05 10.4675L15.55 10.2475C15.93 10.0775 16.1 9.6375 15.93 9.2575C15.76 8.8775 15.32 8.7075 14.94 8.8775V8.8675ZM17.95 7.5275L17.45 7.7475C17.07 7.9175 16.9 8.3575 17.07 8.7375C17.19 9.0175 17.47 9.1875 17.76 9.1875C17.86 9.1875 17.97 9.1675 18.06 9.1275L18.56 8.9075C18.94 8.7375 19.11 8.2975 18.94 7.9175C18.77 7.5375 18.32 7.3675 17.95 7.5375V7.5275ZM12 10.1775C11.64 10.0675 11.24 10.2375 11.09 10.5875C10.95 10.8975 11.05 11.2475 11.3 11.4575C11.39 11.7675 11.67 11.9975 12.01 11.9975C12.35 11.9975 12.63 11.7675 12.72 11.4575C12.97 11.2475 13.06 10.8975 12.93 10.5875C12.77 10.2375 12.37 10.0675 12.02 10.1775H12ZM9.56 9.0975L9.06 8.8775C8.68 8.7075 8.24 8.8775 8.07 9.2575C7.9 9.6375 8.07 10.0775 8.45 10.2475L8.95 10.4675C9.05 10.5075 9.15 10.5275 9.25 10.5275C9.54 10.5275 9.81 10.3575 9.94 10.0775C10.11 9.6975 9.94 9.2575 9.56 9.0875V9.0975ZM6.55 7.7575L6.05 7.5375C5.67 7.3675 5.23 7.5375 5.06 7.9175C4.89 8.2975 5.06 8.7375 5.44 8.9075L5.94 9.1275C6.04 9.1675 6.14 9.1875 6.24 9.1875C6.53 9.1875 6.8 9.0175 6.93 8.7375C7.1 8.3575 6.93 7.9175 6.55 7.7475V7.7575ZM21 12.6475C20.59 12.6475 20.25 12.9875 20.25 13.3975V13.9575C20.25 14.3675 20.59 14.7075 21 14.7075C21.41 14.7075 21.75 14.3675 21.75 13.9575V13.3975C21.75 12.9875 21.41 12.6475 21 12.6475ZM21 9.2875C20.59 9.2875 20.25 9.6275 20.25 10.0375V10.5975C20.25 11.0075 20.59 11.3475 21 11.3475C21.41 11.3475 21.75 11.0075 21.75 10.5975V10.0375C21.75 9.6275 21.41 9.2875 21 9.2875ZM21 15.9975C20.66 15.9975 20.38 16.2175 20.28 16.5275C20.03 16.7375 19.95 17.0875 20.08 17.3975C20.2 17.6775 20.48 17.8475 20.77 17.8475C20.87 17.8475 20.98 17.8275 21.07 17.7875L21.3 17.6875C21.57 17.5675 21.75 17.2975 21.75 16.9975V16.7475C21.75 16.3375 21.41 15.9975 21 15.9975ZM14.94 18.8675L14.44 19.0875C14.06 19.2575 13.89 19.6975 14.06 20.0775C14.18 20.3575 14.46 20.5275 14.75 20.5275C14.85 20.5275 14.96 20.5075 15.05 20.4675L15.55 20.2475C15.93 20.0775 16.1 19.6375 15.93 19.2575C15.76 18.8775 15.32 18.7075 14.94 18.8775V18.8675ZM17.95 17.5275L17.45 17.7475C17.07 17.9175 16.9 18.3575 17.07 18.7375C17.19 19.0175 17.47 19.1875 17.76 19.1875C17.86 19.1875 17.97 19.1675 18.06 19.1275L18.56 18.9075C18.94 18.7375 19.11 18.2975 18.94 17.9175C18.77 17.5375 18.32 17.3675 17.95 17.5375V17.5275ZM12.51 20.2075C12.38 20.0775 12.2 19.9975 12 19.9975C11.8 19.9975 11.62 20.0775 11.49 20.2075C11.32 20.2775 11.17 20.4075 11.09 20.5975C10.92 20.9775 11.09 21.4175 11.47 21.5875L11.7 21.6875C11.79 21.7275 11.89 21.7475 12 21.7475C12.11 21.7475 12.21 21.7275 12.3 21.6875L12.53 21.5875C12.91 21.4175 13.08 20.9775 12.91 20.5975C12.83 20.4175 12.68 20.2875 12.51 20.2175V20.2075ZM9.56 19.0975L9.06 18.8775C8.68 18.7075 8.24 18.8775 8.07 19.2575C7.9 19.6375 8.07 20.0775 8.45 20.2475L8.95 20.4675C9.05 20.5075 9.15 20.5275 9.25 20.5275C9.54 20.5275 9.81 20.3575 9.94 20.0775C10.11 19.6975 9.94 19.2575 9.56 19.0875V19.0975ZM6.55 17.7575L6.05 17.5375C5.67 17.3675 5.23 17.5375 5.06 17.9175C4.89 18.2975 5.06 18.7375 5.44 18.9075L5.94 19.1275C6.04 19.1675 6.14 19.1875 6.24 19.1875C6.53 19.1875 6.8 19.0175 6.93 18.7375C7.1 18.3575 6.93 17.9175 6.55 17.7475V17.7575ZM3 15.9975C2.59 15.9975 2.25 16.3375 2.25 16.7475V16.9975C2.25 17.2975 2.42 17.5675 2.7 17.6875L2.93 17.7875C3.03 17.8275 3.13 17.8475 3.23 17.8475C3.52 17.8475 3.79 17.6775 3.92 17.3975C4.06 17.0875 3.97 16.7375 3.72 16.5275C3.63 16.2175 3.34 15.9975 3 15.9975ZM3 14.7075C3.41 14.7075 3.75 14.3675 3.75 13.9575V13.3975C3.75 12.9875 3.41 12.6475 3 12.6475C2.59 12.6475 2.25 12.9875 2.25 13.3975V13.9575C2.25 14.3675 2.59 14.7075 3 14.7075ZM3 11.3475C3.41 11.3475 3.75 11.0075 3.75 10.5975V10.0375C3.75 9.6275 3.41 9.2875 3 9.2875C2.59 9.2875 2.25 9.6275 2.25 10.0375V10.5975C2.25 11.0075 2.59 11.3475 3 11.3475ZM3 7.9975C3.21 7.9975 3.39 7.9175 3.53 7.7775C3.69 7.7075 3.84 7.5775 3.91 7.4075C3.97 7.2775 3.99 7.1375 3.97 6.9975C3.99 6.8675 3.97 6.7275 3.91 6.5875C3.74 6.2075 3.29 6.0375 2.92 6.2075L2.69 6.3075C2.61 6.3475 2.54 6.3975 2.48 6.4475C2.46 6.4675 2.45 6.4775 2.44 6.4975C2.4 6.5475 2.36 6.5975 2.33 6.6575C2.32 6.6775 2.31 6.6975 2.3 6.7275C2.27 6.8075 2.25 6.8975 2.25 6.9875V7.2375C2.25 7.6475 2.59 7.9875 3 7.9875V7.9975ZM12 15.3475C12.41 15.3475 12.75 15.0075 12.75 14.5975V14.0375C12.75 13.6275 12.41 13.2875 12 13.2875C11.59 13.2875 11.25 13.6275 11.25 14.0375V14.5975C11.25 15.0075 11.59 15.3475 12 15.3475ZM11.25 17.9575C11.25 18.3675 11.59 18.7075 12 18.7075C12.41 18.7075 12.75 18.3675 12.75 17.9575V17.3975C12.75 16.9875 12.41 16.6475 12 16.6475C11.59 16.6475 11.25 16.9875 11.25 17.3975V17.9575Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/pg-validation-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/pg-validation-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2.25C6.62 2.25 2.25 6.62 2.25 12C2.25 17.38 6.62 21.75 12 21.75C17.38 21.75 21.75 17.38 21.75 12C21.75 6.62 17.38 2.25 12 2.25ZM12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25ZM16.53 8.53L13.06 12L16.53 15.47C16.82 15.76 16.82 16.24 16.53 16.53C16.38 16.68 16.19 16.75 16 16.75C15.81 16.75 15.62 16.68 15.47 16.53L12 13.06L8.53 16.53C8.38 16.68 8.19 16.75 8 16.75C7.81 16.75 7.62 16.68 7.47 16.53C7.18 16.24 7.18 15.76 7.47 15.47L10.94 12L7.47 8.53C7.18 8.24 7.18 7.76 7.47 7.47C7.76 7.18 8.24 7.18 8.53 7.47L12 10.94L15.47 7.47C15.76 7.18 16.24 7.18 16.53 7.47C16.82 7.76 16.82 8.24 16.53 8.53Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/phone-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v2/phone-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M15 3.25H9C7.48 3.25 6.25 4.48 6.25 6V18C6.25 19.52 7.48 20.75 9 20.75H15C16.52 20.75 17.75 19.52 17.75 18V6C17.75 4.48 16.52 3.25 15 3.25ZM16.25 18C16.25 18.69 15.69 19.25 15 19.25H9C8.31 19.25 7.75 18.69 7.75 18V6C7.75 5.31 8.31 4.75 9 4.75H15C15.69 4.75 16.25 5.31 16.25 6V18ZM13.75 6C13.75 6.41 13.41 6.75 13 6.75H11C10.59 6.75 10.25 6.41 10.25 6C10.25 5.59 10.59 5.25 11 5.25H13C13.41 5.25 13.75 5.59 13.75 6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/plus-32x32.svg":
/*!**************************************!*\
  !*** ./src/images-v2/plus-32x32.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 32 32\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M30 16H17V3H16V16H3V17H16V30H17V17H30V16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/plusbox-16x16.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/plusbox-16x16.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.75 8C10.75 8.41 10.41 8.75 10 8.75H8.75V10C8.75 10.41 8.41 10.75 8 10.75C7.59 10.75 7.25 10.41 7.25 10V8.75H6C5.59 8.75 5.25 8.41 5.25 8C5.25 7.59 5.59 7.25 6 7.25H7.25V6C7.25 5.59 7.59 5.25 8 5.25C8.41 5.25 8.75 5.59 8.75 6V7.25H10C10.41 7.25 10.75 7.59 10.75 8ZM13.75 4V12C13.75 12.96 12.96 13.75 12 13.75H4C3.04 13.75 2.25 12.96 2.25 12V4C2.25 3.04 3.04 2.25 4 2.25H12C12.96 2.25 13.75 3.04 13.75 4ZM12.25 4C12.25 3.86 12.14 3.75 12 3.75H4C3.86 3.75 3.75 3.86 3.75 4V12C3.75 12.14 3.86 12.25 4 12.25H12C12.14 12.25 12.25 12.14 12.25 12V4Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/preview-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/preview-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2.25C6.62 2.25 2.25 6.62 2.25 12C2.25 17.38 6.62 21.75 12 21.75C17.38 21.75 21.75 17.38 21.75 12C21.75 6.62 17.38 2.25 12 2.25ZM12 20.25C7.45 20.25 3.75 16.55 3.75 12C3.75 7.45 7.45 3.75 12 3.75C16.55 3.75 20.25 7.45 20.25 12C20.25 16.55 16.55 20.25 12 20.25ZM15.17 10.54L11.97 8.41C11.43 8.05 10.74 8.02 10.17 8.32C9.6 8.62 9.25 9.22 9.25 9.86V14.12C9.25 14.77 9.6 15.36 10.17 15.66C10.43 15.8 10.71 15.87 11 15.87C11.34 15.87 11.68 15.77 11.97 15.58L15.17 13.45C15.66 13.12 15.95 12.58 15.95 11.99C15.95 11.4 15.66 10.86 15.17 10.53V10.54ZM14.34 12.21L11.14 14.34C11.03 14.41 10.93 14.38 10.88 14.35C10.83 14.32 10.75 14.26 10.75 14.13V9.87C10.75 9.74 10.83 9.68 10.88 9.65C10.91 9.64 10.95 9.62 11 9.62C11.04 9.62 11.09 9.63 11.14 9.66L14.34 11.79C14.44 11.85 14.45 11.95 14.45 12C14.45 12.05 14.44 12.14 14.34 12.21Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/publish-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/publish-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.74 21.18C16.66 21.52 16.35 21.75 16.01 21.75C15.95 21.75 15.89 21.75 15.83 21.73C11.3 20.6 10.63 16.96 10.98 13.09L9.54 14.53C9.25 14.82 8.77 14.82 8.48 14.53C8.19 14.24 8.19 13.76 8.48 13.47L11.48 10.47C11.48 10.47 11.52 10.45 11.53 10.44C11.57 10.41 11.61 10.38 11.65 10.36C11.69 10.34 11.73 10.32 11.78 10.3C11.83 10.29 11.87 10.28 11.92 10.27C11.97 10.27 12.02 10.27 12.07 10.27C12.09 10.27 12.11 10.27 12.13 10.27C12.16 10.27 12.18 10.29 12.21 10.3C12.26 10.31 12.3 10.33 12.35 10.35C12.4 10.37 12.44 10.4 12.48 10.44C12.5 10.46 12.53 10.46 12.54 10.48L15.54 13.48C15.83 13.77 15.83 14.25 15.54 14.54C15.39 14.69 15.2 14.76 15.01 14.76C14.82 14.76 14.63 14.69 14.48 14.54L12.54 12.6C11.91 18.02 13.48 19.6 16.19 20.28C16.59 20.38 16.84 20.79 16.74 21.19V21.18ZM18.6 7.29C18.05 4.94 15.96 3.25 13.51 3.25C11.06 3.25 8.99 4.92 8.43 7.25C6.2 7.29 4.39 9.05 4.26 11.26C2.68 11.12 1.25 12.4 1.25 14C1.25 15.52 2.48 16.75 4 16.75C4.41 16.75 4.75 16.41 4.75 16C4.75 15.59 4.41 15.25 4 15.25C3.31 15.25 2.75 14.69 2.75 14C2.75 13.31 3.31 12.75 4 12.75C4.25 12.75 4.49 12.82 4.7 12.96C4.96 13.13 5.29 13.13 5.55 12.96C5.8 12.78 5.92 12.47 5.85 12.17C5.79 11.92 5.76 11.71 5.76 11.51C5.76 9.99 6.99 8.76 8.51 8.76C8.66 8.76 8.8 8.78 8.94 8.81C9.14 8.84 9.35 8.79 9.52 8.66C9.68 8.53 9.79 8.35 9.81 8.14C10 6.21 11.6 4.76 13.52 4.76C15.44 4.76 17.01 6.19 17.23 8.1C17.27 8.48 17.64 8.76 18.02 8.76C19.81 8.76 21.27 10.22 21.27 12.01C21.27 13.8 19.81 15.26 18.02 15.26C17.61 15.26 17.27 15.6 17.27 16.01C17.27 16.42 17.61 16.76 18.02 16.76C20.64 16.76 22.77 14.63 22.77 12.01C22.77 9.6 20.97 7.61 18.61 7.3L18.6 7.29Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/questionlock-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/questionlock-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M11.75 18C11.75 18.41 11.41 18.75 11 18.75H10.31L7.53 21.53C7.39 21.67 7.2 21.75 7 21.75C6.9 21.75 6.81 21.73 6.71 21.69C6.43 21.57 6.25 21.3 6.25 21V18.75H5C3.48 18.75 2.25 17.52 2.25 16V5C2.25 3.48 3.48 2.25 5 2.25H18C19.52 2.25 20.75 3.48 20.75 5V6C20.75 6.41 20.41 6.75 20 6.75C19.59 6.75 19.25 6.41 19.25 6V5C19.25 4.31 18.69 3.75 18 3.75H5C4.31 3.75 3.75 4.31 3.75 5V16C3.75 16.69 4.31 17.25 5 17.25H7C7.41 17.25 7.75 17.59 7.75 18V19.19L9.47 17.47C9.61 17.33 9.8 17.25 10 17.25H11C11.41 17.25 11.75 17.59 11.75 18ZM22.75 14V19C22.75 20.52 21.52 21.75 20 21.75H16C14.48 21.75 13.25 20.52 13.25 19V14C13.25 13.59 13.59 13.25 14 13.25H14.25V12C14.25 9.93 15.93 8.25 18 8.25C20.07 8.25 21.75 9.93 21.75 12V13.25H22C22.41 13.25 22.75 13.59 22.75 14ZM15.75 13.25H20.25V12C20.25 10.76 19.24 9.75 18 9.75C16.76 9.75 15.75 10.76 15.75 12V13.25ZM21.25 14.75H14.75V19C14.75 19.69 15.31 20.25 16 20.25H20C20.69 20.25 21.25 19.69 21.25 19V14.75ZM18 16.25C17.59 16.25 17.25 16.59 17.25 17V18C17.25 18.41 17.59 18.75 18 18.75C18.41 18.75 18.75 18.41 18.75 18V17C18.75 16.59 18.41 16.25 18 16.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/ranking-arrows.svg":
/*!******************************************!*\
  !*** ./src/images-v2/ranking-arrows.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 10 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10 5L5 0L0 5H4V9H6V5H10Z\"></path><path d=\"M6 19V15H4V19H0L5 24L10 19H6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/rankingundefined-16x16.svg":
/*!**************************************************!*\
  !*** ./src/images-v2/rankingundefined-16x16.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.75 8C11.75 8.41 11.41 8.75 11 8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H11C11.41 7.25 11.75 7.59 11.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/redo-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/redo-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.7067 11.2425C21.7067 11.2425 21.6867 11.2725 21.6767 11.2925C21.6767 11.3125 21.6767 11.3225 21.6667 11.3425C21.6567 11.3725 21.6267 11.3925 21.6067 11.4125C21.5767 11.4525 21.5467 11.4925 21.5167 11.5325C21.4867 11.5625 21.4467 11.5925 21.4067 11.6225C21.3767 11.6425 21.3567 11.6625 21.3367 11.6825L15.3067 14.6825C15.1967 14.7325 15.0867 14.7625 14.9767 14.7625C14.6967 14.7625 14.4367 14.6125 14.3067 14.3425C14.1267 13.9725 14.2767 13.5225 14.6467 13.3325L19.2767 11.0325C13.7467 8.64247 8.45669 8.45247 6.06669 10.6625C4.07669 12.5025 4.72669 15.5225 5.61669 17.7325C5.76669 18.1125 5.58669 18.5525 5.19669 18.7125C5.10669 18.7525 5.00669 18.7625 4.91669 18.7625C4.61669 18.7625 4.33669 18.5825 4.21669 18.2925C2.27669 13.4825 3.58669 10.8825 5.03669 9.55247C7.81669 6.98247 13.4167 7.00247 19.3767 9.45247L17.3067 5.34247C17.1167 4.97247 17.2667 4.52247 17.6367 4.33247C18.0067 4.14247 18.4567 4.29247 18.6467 4.66247L21.6667 10.6625C21.6667 10.6625 21.6667 10.6925 21.6767 10.7125C21.6967 10.7625 21.7067 10.8125 21.7167 10.8625C21.7167 10.9025 21.7367 10.9525 21.7367 10.9925C21.7367 11.0425 21.7367 11.0925 21.7167 11.1425C21.7167 11.1725 21.7167 11.2125 21.7067 11.2425Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/refresh-16x16.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/refresh-16x16.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2 8.75C1.59 8.75 1.25 8.41 1.25 8C1.25 4.28 4.28 1.25 8 1.25C9.69 1.25 11.3 1.89 12.53 3.01L12.69 1.89C12.75 1.48 13.13 1.2 13.54 1.26C13.95 1.32 14.23 1.7 14.17 2.11L13.73 5.11C13.68 5.48 13.36 5.75 12.99 5.75H9.99C9.58 5.75 9.24 5.41 9.24 5C9.24 4.59 9.58 4.25 9.99 4.25H11.66C10.68 3.29 9.37 2.75 7.99 2.75C5.11 2.75 2.75 5.11 2.75 8C2.75 8.41 2.41 8.75 2 8.75ZM14 7.25C13.59 7.25 13.25 7.59 13.25 8C13.25 10.9 10.89 13.25 8 13.25C6.62 13.25 5.31 12.71 4.33 11.75H6C6.41 11.75 6.75 11.41 6.75 11C6.75 10.59 6.41 10.25 6 10.25H3C2.63 10.25 2.31 10.52 2.26 10.89L1.8 13.89C1.74 14.3 2.02 14.68 2.43 14.74C2.47 14.74 2.51 14.74 2.54 14.74C2.9 14.74 3.22 14.47 3.28 14.1L3.45 12.97C4.69 14.1 6.3 14.74 7.99 14.74C11.71 14.74 14.74 11.71 14.74 7.99C14.74 7.58 14.4 7.24 13.99 7.24L14 7.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/remove-16x16.svg":
/*!****************************************!*\
  !*** ./src/images-v2/remove-16x16.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 1.25C4.28 1.25 1.25 4.28 1.25 8C1.25 11.72 4.28 14.75 8 14.75C11.72 14.75 14.75 11.72 14.75 8C14.75 4.28 11.72 1.25 8 1.25ZM8 13.25C5.11 13.25 2.75 10.89 2.75 8C2.75 5.11 5.11 2.75 8 2.75C10.89 2.75 13.25 5.11 13.25 8C13.25 10.89 10.89 13.25 8 13.25ZM10.75 8C10.75 8.41 10.41 8.75 10 8.75H6C5.59 8.75 5.25 8.41 5.25 8C5.25 7.59 5.59 7.25 6 7.25H10C10.41 7.25 10.75 7.59 10.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/reorder-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/reorder-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.9444 10.75H15.0544C15.7144 10.75 16.3144 10.39 16.6144 9.80002C16.9144 9.22002 16.8644 8.52002 16.4844 7.98002L13.4244 3.71002C12.7644 2.79002 11.2344 2.79002 10.5744 3.71002L7.5244 7.99002C7.1444 8.53002 7.0944 9.22002 7.3944 9.81002C7.6944 10.4 8.2944 10.76 8.9544 10.76L8.9444 10.75ZM8.7444 8.86002L11.7944 4.58002C11.8644 4.49002 11.9544 4.48002 11.9944 4.48002C12.0344 4.48002 12.1344 4.49002 12.1944 4.58002L15.2544 8.86002C15.3344 8.97002 15.3044 9.07002 15.2744 9.12002C15.2444 9.17002 15.1844 9.26002 15.0544 9.26002H8.9444C8.8144 9.26002 8.7444 9.18002 8.7244 9.12002C8.7044 9.06002 8.6644 8.97002 8.7444 8.86002ZM15.0544 13.25H8.9444C8.2844 13.25 7.6844 13.61 7.3844 14.2C7.0844 14.78 7.1344 15.48 7.5144 16.02L10.5744 20.3C10.9044 20.76 11.4344 21.03 11.9944 21.03C12.5544 21.03 13.0944 20.76 13.4144 20.3L16.4744 16.02C16.8544 15.48 16.9044 14.79 16.6044 14.2C16.3044 13.61 15.7044 13.25 15.0444 13.25H15.0544ZM15.2644 15.15L12.2044 19.43C12.0744 19.61 11.9244 19.61 11.7944 19.43L8.7344 15.15C8.6544 15.04 8.6844 14.94 8.7144 14.89C8.7444 14.84 8.8044 14.75 8.9344 14.75H15.0444C15.1744 14.75 15.2444 14.83 15.2644 14.89C15.2844 14.95 15.3244 15.04 15.2444 15.15H15.2644Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/required-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v2/required-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.75 8C14.75 8.41 14.41 8.75 14 8.75H9.81L12.53 11.47C12.82 11.76 12.82 12.24 12.53 12.53C12.38 12.68 12.19 12.75 12 12.75C11.81 12.75 11.62 12.68 11.47 12.53L8.75 9.81V14C8.75 14.41 8.41 14.75 8 14.75C7.59 14.75 7.25 14.41 7.25 14V9.81L4.53 12.53C4.38 12.68 4.19 12.75 4 12.75C3.81 12.75 3.62 12.68 3.47 12.53C3.18 12.24 3.18 11.76 3.47 11.47L6.19 8.75H2C1.59 8.75 1.25 8.41 1.25 8C1.25 7.59 1.59 7.25 2 7.25H6.19L3.47 4.53C3.18 4.24 3.18 3.76 3.47 3.47C3.76 3.18 4.24 3.18 4.53 3.47L7.25 6.19V2C7.25 1.59 7.59 1.25 8 1.25C8.41 1.25 8.75 1.59 8.75 2V6.19L11.47 3.47C11.76 3.18 12.24 3.18 12.53 3.47C12.82 3.76 12.82 4.24 12.53 4.53L9.81 7.25H14C14.41 7.25 14.75 7.59 14.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/restore-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/restore-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.752 12.0003C20.752 16.8303 16.832 20.7503 12.002 20.7503C10.832 20.7503 9.69203 20.5203 8.61203 20.0703C7.35203 19.5403 6.21203 18.7003 5.32203 17.6503C4.73203 16.9603 4.26203 16.1903 3.91203 15.3503C3.75203 14.9703 3.93203 14.5303 4.31203 14.3703C4.70203 14.2103 5.13203 14.3903 5.29203 14.7703C5.58203 15.4603 5.97203 16.1003 6.46203 16.6803C7.20203 17.5503 8.14203 18.2403 9.19203 18.6803C10.082 19.0503 11.022 19.2403 12.002 19.2403C16.002 19.2403 19.252 15.9903 19.252 11.9903C19.252 7.99028 16.002 4.75028 12.002 4.75028C9.67203 4.75028 7.48203 5.88028 6.12203 7.77028L9.35203 7.80028C9.76203 7.80028 10.102 8.14028 10.092 8.56028C10.092 8.97028 9.75203 9.30028 9.34203 9.30028L4.40203 9.25028C4.01203 9.25028 3.69203 8.95028 3.66203 8.56028L3.27203 3.65028C3.24203 3.23028 3.55203 2.87028 3.96203 2.84028C4.37203 2.83028 4.73203 3.12028 4.77203 3.53028L5.02203 6.74028C6.67203 4.55028 9.25203 3.25028 12.002 3.25028C16.832 3.25028 20.752 7.17028 20.752 12.0003Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/restoredown-16x16.svg":
/*!*********************************************!*\
  !*** ./src/images-v2/restoredown-16x16.svg ***!
  \*********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.69 8.71C7.73 8.8 7.75 8.9 7.75 9V13C7.75 13.41 7.41 13.75 7 13.75C6.59 13.75 6.25 13.41 6.25 13V10.81L3.53 13.53C3.38 13.68 3.19 13.75 3 13.75C2.81 13.75 2.62 13.68 2.47 13.53C2.18 13.24 2.18 12.76 2.47 12.47L5.19 9.75H3C2.59 9.75 2.25 9.41 2.25 9C2.25 8.59 2.59 8.25 3 8.25H7C7.1 8.25 7.19 8.27 7.29 8.31C7.47 8.39 7.62 8.53 7.7 8.72L7.69 8.71ZM13 6.25H10.81L13.53 3.53C13.82 3.24 13.82 2.76 13.53 2.47C13.24 2.18 12.76 2.18 12.47 2.47L9.75 5.19V3C9.75 2.59 9.41 2.25 9 2.25C8.59 2.25 8.25 2.59 8.25 3V7C8.25 7.1 8.27 7.19 8.31 7.29C8.39 7.47 8.53 7.62 8.72 7.7C8.81 7.74 8.91 7.76 9.01 7.76H13.01C13.42 7.76 13.76 7.42 13.76 7.01C13.76 6.6 13.42 6.26 13.01 6.26L13 6.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/rotate-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/rotate-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.75 13.9975V9.9975C17.75 8.4775 16.52 7.2475 15 7.2475H9C7.48 7.2475 6.25 8.4775 6.25 9.9975V13.9975C6.25 15.5175 7.48 16.7475 9 16.7475H15C16.52 16.7475 17.75 15.5175 17.75 13.9975ZM7.75 13.9975V9.9975C7.75 9.3075 8.31 8.7475 9 8.7475H15C15.69 8.7475 16.25 9.3075 16.25 9.9975V13.9975C16.25 14.6875 15.69 15.2475 15 15.2475H9C8.31 15.2475 7.75 14.6875 7.75 13.9975ZM8 4.7475C5.66 4.7475 3.75 6.6575 3.75 8.9975C3.75 9.4075 3.41 9.7475 3 9.7475C2.59 9.7475 2.25 9.4075 2.25 8.9975C2.25 5.8275 4.83 3.2475 8 3.2475H8.19L7.47 2.5275C7.18 2.2375 7.18 1.7575 7.47 1.4675C7.76 1.1775 8.24 1.1775 8.53 1.4675L10.53 3.4675C10.6 3.5375 10.65 3.6175 10.69 3.7075C10.77 3.8875 10.77 4.0975 10.69 4.2775C10.61 4.4575 10.47 4.6075 10.28 4.6875C10.19 4.7275 10.09 4.7475 9.99 4.7475H7.99H8ZM16 20.7475H15.81L16.53 21.4675C16.82 21.7575 16.82 22.2375 16.53 22.5275C16.38 22.6775 16.19 22.7475 16 22.7475C15.81 22.7475 15.62 22.6775 15.47 22.5275L13.47 20.5275C13.4 20.4575 13.35 20.3775 13.31 20.2875C13.23 20.1075 13.23 19.8975 13.31 19.7175C13.39 19.5375 13.53 19.3875 13.72 19.3075C13.81 19.2675 13.91 19.2475 14.01 19.2475H16.01C18.35 19.2475 20.26 17.3375 20.26 14.9975C20.26 14.5875 20.6 14.2475 21.01 14.2475C21.42 14.2475 21.76 14.5875 21.76 14.9975C21.76 18.1675 19.18 20.7475 16.01 20.7475H16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/save-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/save-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 3.25H6.83C6.1 3.25 5.41 3.54 4.89 4.06L4.06 4.89C3.54 5.41 3.25 6.1 3.25 6.83V18C3.25 19.52 4.48 20.75 6 20.75H18C19.52 20.75 20.75 19.52 20.75 18V6C20.75 4.48 19.52 3.25 18 3.25ZM9.75 4.75H14.25V7C14.25 7.14 14.14 7.25 14 7.25H10C9.86 7.25 9.75 7.14 9.75 7V4.75ZM19.25 18C19.25 18.69 18.69 19.25 18 19.25H6C5.31 19.25 4.75 18.69 4.75 18V6.83C4.75 6.5 4.88 6.18 5.12 5.95L5.95 5.12C6.18 4.89 6.5 4.75 6.83 4.75H8.25V7C8.25 7.96 9.04 8.75 10 8.75H14C14.96 8.75 15.75 7.96 15.75 7V4.75H18C18.69 4.75 19.25 5.31 19.25 6V18ZM12 10.25C10.48 10.25 9.25 11.48 9.25 13C9.25 14.52 10.48 15.75 12 15.75C13.52 15.75 14.75 14.52 14.75 13C14.75 11.48 13.52 10.25 12 10.25ZM12 14.25C11.31 14.25 10.75 13.69 10.75 13C10.75 12.31 11.31 11.75 12 11.75C12.69 11.75 13.25 12.31 13.25 13C13.25 13.69 12.69 14.25 12 14.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/saveas-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/saveas-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20 17.25C19.59 17.25 19.25 17.59 19.25 18C19.25 18.69 18.69 19.25 18 19.25H6C5.31 19.25 4.75 18.69 4.75 18V6.83C4.75 6.5 4.88 6.18 5.12 5.95L5.95 5.12C6.18 4.89 6.5 4.75 6.83 4.75H8.25V7C8.25 7.96 9.04 8.75 10 8.75H14C14.96 8.75 15.75 7.96 15.75 7V4.75H18C18.69 4.75 19.25 5.31 19.25 6V8C19.25 8.41 19.59 8.75 20 8.75C20.41 8.75 20.75 8.41 20.75 8V6C20.75 4.48 19.52 3.25 18 3.25H6.83C6.1 3.25 5.41 3.54 4.89 4.06L4.06 4.89C3.54 5.41 3.25 6.1 3.25 6.83V18C3.25 19.52 4.48 20.75 6 20.75H18C19.52 20.75 20.75 19.52 20.75 18C20.75 17.59 20.41 17.25 20 17.25ZM14.25 7C14.25 7.14 14.14 7.25 14 7.25H10C9.86 7.25 9.75 7.14 9.75 7V4.75H14.25V7ZM12 10.25C10.48 10.25 9.25 11.48 9.25 13C9.25 14.52 10.48 15.75 12 15.75C13.52 15.75 14.75 14.52 14.75 13C14.75 11.48 13.52 10.25 12 10.25ZM12 14.25C11.31 14.25 10.75 13.69 10.75 13C10.75 12.31 11.31 11.75 12 11.75C12.69 11.75 13.25 12.31 13.25 13C13.25 13.69 12.69 14.25 12 14.25ZM22.75 13C22.75 13.41 22.41 13.75 22 13.75H20.75V15C20.75 15.41 20.41 15.75 20 15.75C19.59 15.75 19.25 15.41 19.25 15V13.75H18C17.59 13.75 17.25 13.41 17.25 13C17.25 12.59 17.59 12.25 18 12.25H19.25V11C19.25 10.59 19.59 10.25 20 10.25C20.41 10.25 20.75 10.59 20.75 11V12.25H22C22.41 12.25 22.75 12.59 22.75 13Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/search-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/search-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.9975 2.25C9.7275 2.25 6.2475 5.73 6.2475 10C6.2475 11.87 6.9075 13.58 8.0175 14.92L2.4675 20.47C2.1775 20.76 2.1775 21.24 2.4675 21.53C2.6175 21.68 2.8075 21.75 2.9975 21.75C3.1875 21.75 3.3775 21.68 3.5275 21.53L9.0775 15.98C10.4175 17.08 12.1275 17.75 13.9975 17.75C18.2675 17.75 21.7475 14.27 21.7475 10C21.7475 5.73 18.2675 2.25 13.9975 2.25ZM13.9975 16.25C10.5475 16.25 7.7475 13.45 7.7475 10C7.7475 6.55 10.5475 3.75 13.9975 3.75C17.4475 3.75 20.2475 6.55 20.2475 10C20.2475 13.45 17.4475 16.25 13.9975 16.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/selectpage-24x24.svg":
/*!********************************************!*\
  !*** ./src/images-v2/selectpage-24x24.svg ***!
  \********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 7.25H6C4.48 7.25 3.25 8.48 3.25 10V19C3.25 20.52 4.48 21.75 6 21.75H13C14.52 21.75 15.75 20.52 15.75 19V10C15.75 8.48 14.52 7.25 13 7.25ZM14.25 19C14.25 19.69 13.69 20.25 13 20.25H6C5.31 20.25 4.75 19.69 4.75 19V10C4.75 9.31 5.31 8.75 6 8.75H13C13.69 8.75 14.25 9.31 14.25 10V19ZM20.75 5V14C20.75 15.52 19.52 16.75 18 16.75C17.59 16.75 17.25 16.41 17.25 16C17.25 15.59 17.59 15.25 18 15.25C18.69 15.25 19.25 14.69 19.25 14V5C19.25 4.31 18.69 3.75 18 3.75H11C10.31 3.75 9.75 4.31 9.75 5C9.75 5.41 9.41 5.75 9 5.75C8.59 5.75 8.25 5.41 8.25 5C8.25 3.48 9.48 2.25 11 2.25H18C19.52 2.25 20.75 3.48 20.75 5ZM9.75 11C9.75 11.41 9.41 11.75 9 11.75H7C6.59 11.75 6.25 11.41 6.25 11C6.25 10.59 6.59 10.25 7 10.25H9C9.41 10.25 9.75 10.59 9.75 11Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/settings-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v2/settings-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14 10.25H12.63C12.3 9.1 11.25 8.25 10 8.25C8.75 8.25 7.7 9.1 7.37 10.25H2C1.59 10.25 1.25 10.59 1.25 11C1.25 11.41 1.59 11.75 2 11.75H7.37C7.7 12.9 8.75 13.75 10 13.75C11.25 13.75 12.3 12.9 12.63 11.75H14C14.41 11.75 14.75 11.41 14.75 11C14.75 10.59 14.41 10.25 14 10.25ZM10 12.25C9.31 12.25 8.75 11.69 8.75 11C8.75 10.31 9.31 9.75 10 9.75C10.69 9.75 11.25 10.31 11.25 11C11.25 11.69 10.69 12.25 10 12.25ZM2 5.75H3.37C3.7 6.9 4.75 7.75 6 7.75C7.25 7.75 8.3 6.9 8.63 5.75H14C14.41 5.75 14.75 5.41 14.75 5C14.75 4.59 14.41 4.25 14 4.25H8.63C8.3 3.1 7.25 2.25 6 2.25C4.75 2.25 3.7 3.1 3.37 4.25H2C1.59 4.25 1.25 4.59 1.25 5C1.25 5.41 1.59 5.75 2 5.75ZM6 3.75C6.69 3.75 7.25 4.31 7.25 5C7.25 5.69 6.69 6.25 6 6.25C5.31 6.25 4.75 5.69 4.75 5C4.75 4.31 5.31 3.75 6 3.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/settings-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v2/settings-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M3 6.75H5.37C5.7 7.9 6.75 8.75 8 8.75C9.25 8.75 10.3 7.9 10.63 6.75H21C21.41 6.75 21.75 6.41 21.75 6C21.75 5.59 21.41 5.25 21 5.25H10.63C10.3 4.1 9.25 3.25 8 3.25C6.75 3.25 5.7 4.1 5.37 5.25H3C2.59 5.25 2.25 5.59 2.25 6C2.25 6.41 2.59 6.75 3 6.75ZM8 4.75C8.69 4.75 9.25 5.31 9.25 6C9.25 6.69 8.69 7.25 8 7.25C7.31 7.25 6.75 6.69 6.75 6C6.75 5.31 7.31 4.75 8 4.75ZM21 11.25H18.63C18.3 10.1 17.25 9.25 16 9.25C14.75 9.25 13.7 10.1 13.37 11.25H3C2.59 11.25 2.25 11.59 2.25 12C2.25 12.41 2.59 12.75 3 12.75H13.37C13.7 13.9 14.75 14.75 16 14.75C17.25 14.75 18.3 13.9 18.63 12.75H21C21.41 12.75 21.75 12.41 21.75 12C21.75 11.59 21.41 11.25 21 11.25ZM16 13.25C15.31 13.25 14.75 12.69 14.75 12C14.75 11.31 15.31 10.75 16 10.75C16.69 10.75 17.25 11.31 17.25 12C17.25 12.69 16.69 13.25 16 13.25ZM21 17.25H10.63C10.3 16.1 9.25 15.25 8 15.25C6.75 15.25 5.7 16.1 5.37 17.25H3C2.59 17.25 2.25 17.59 2.25 18C2.25 18.41 2.59 18.75 3 18.75H5.37C5.7 19.9 6.75 20.75 8 20.75C9.25 20.75 10.3 19.9 10.63 18.75H21C21.41 18.75 21.75 18.41 21.75 18C21.75 17.59 21.41 17.25 21 17.25ZM8 19.25C7.31 19.25 6.75 18.69 6.75 18C6.75 17.31 7.31 16.75 8 16.75C8.69 16.75 9.25 17.31 9.25 18C9.25 18.69 8.69 19.25 8 19.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/smile-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v2/smile-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_22171_138835)\"><path d=\"M23.9966 14.16C22.8663 20.95 17.1547 24 12.0033 24C6.85193 24 1.15039 20.96 0.0100771 14.16C-0.0799473 13.62 0.290153 13.1 0.830299 13.01C1.37045 12.91 1.89059 13.29 1.98061 13.83C2.92087 19.47 7.69216 21.99 11.9933 21.99C16.2945 21.99 21.0658 19.47 22.006 13.83C22.0961 13.29 22.6162 12.91 23.1564 13.01C23.6965 13.1 24.0666 13.62 23.9766 14.16H23.9966ZM7.00197 7C7.55212 7 8.00224 6.55 8.00224 6V2C8.00224 1.45 7.55212 1 7.00197 1C6.45182 1 6.0017 1.45 6.0017 2V6C6.0017 6.55 6.45182 7 7.00197 7ZM17.0047 7C17.5548 7 18.005 6.55 18.005 6V2C18.005 1.45 17.5548 1 17.0047 1C16.4545 1 16.0044 1.45 16.0044 2V6C16.0044 6.55 16.4545 7 17.0047 7Z\"></path></g><defs><clipPath id=\"clip0_22171_138835\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v2/smiley-rate0-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/smiley-rate0-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13.4101 12L22.7101 2.71C23.1001 2.32 23.1001 1.69 22.7101 1.3C22.3201 0.909998 21.6901 0.909998 21.3001 1.3L12.0101 10.59L2.71006 1.29C2.32006 0.899998 1.68006 0.899998 1.29006 1.29C0.900059 1.68 0.900059 2.32 1.29006 2.71L10.5801 12L1.29006 21.29C0.900059 21.68 0.900059 22.31 1.29006 22.7C1.49006 22.9 1.74006 22.99 2.00006 22.99C2.26006 22.99 2.51006 22.89 2.71006 22.7L12.0001 13.41L21.2901 22.7C21.4901 22.9 21.7401 22.99 22.0001 22.99C22.2601 22.99 22.5101 22.89 22.7101 22.7C23.1001 22.31 23.1001 21.68 22.7101 21.29L13.4201 12H13.4101Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/smiley-rate1-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/smiley-rate1-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4 4.9938C4 4.44362 4.45 3.99348 5 3.99348H6.59L5.3 2.70306C4.91 2.31293 4.91 1.68272 5.3 1.2926C5.69 0.902468 6.32 0.902468 6.71 1.2926L9.71 4.29357C9.8 4.3836 9.88 4.49364 9.93 4.62368C10.03 4.86376 10.03 5.14385 9.93 5.38393C9.88 5.50397 9.81 5.614 9.71 5.71404L6.71 8.71501C6.51 8.91508 6.26 9.00511 6 9.00511C5.74 9.00511 5.49 8.90508 5.29 8.71501C4.9 8.32489 4.9 7.69468 5.29 7.30456L6.58 6.01413H4.99C4.44 6.01413 3.99 5.56399 3.99 5.01381L4 4.9938ZM14.08 5.37393C14.13 5.49397 14.2 5.604 14.3 5.70403L17.3 8.70501C17.5 8.90508 17.75 8.99511 18.01 8.99511C18.27 8.99511 18.52 8.89507 18.72 8.70501C19.11 8.31488 19.11 7.68468 18.72 7.29455L17.43 6.00413H19.02C19.57 6.00413 20.02 5.55399 20.02 5.00381C20.02 4.45363 19.57 4.00348 19.02 4.00348H17.43L18.72 2.71306C19.11 2.32293 19.11 1.69273 18.72 1.3026C18.33 0.912471 17.7 0.912471 17.31 1.3026L14.31 4.30358C14.22 4.39361 14.14 4.50364 14.09 4.63368C13.99 4.87376 13.99 5.15385 14.09 5.39393L14.08 5.37393ZM22 14.9971V20.999C22 22.6496 20.65 24 19 24H5C3.35 24 2 22.6496 2 20.999V14.9971C2 13.3465 3.35 11.9961 5 11.9961H19C20.65 11.9961 22 13.3465 22 14.9971ZM19 13.9967H16V16.9977H20V14.9971C20 14.4469 19.55 13.9967 19 13.9967ZM14 16.9977V13.9967H10V16.9977H14ZM10 18.9984V21.9993H14V18.9984H10ZM4 14.9971V16.9977H8V13.9967H5C4.45 13.9967 4 14.4469 4 14.9971ZM5 21.9993H8V18.9984H4V20.999C4 21.5492 4.45 21.9993 5 21.9993ZM20 20.999V18.9984H16V21.9993H19C19.55 21.9993 20 21.5492 20 20.999Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/smiley-rate10-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/smiley-rate10-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.01 23C6.85721 23 1.15412 19.9621 0.0134987 13.1669C-0.0765501 12.6272 0.293651 12.1076 0.833944 12.0177C1.38424 11.9277 1.89452 12.2975 1.98457 12.8371C2.92508 18.4732 7.69767 20.9914 12 20.9914C16.3023 20.9914 21.0749 18.4732 22.0154 12.8371C22.1055 12.2975 22.6158 11.9277 23.1661 12.0177C23.7063 12.1076 24.0765 12.6272 23.9865 13.1669C22.8559 19.9521 17.1428 23 11.99 23H12.01ZM21.165 6.15177C22.3056 5.01257 22.3056 3.16386 21.165 2.02465L21.0049 1.85477C19.9143 0.765533 18.1633 0.725561 17.0227 1.71487C15.8821 0.715568 14.1312 0.765533 13.0406 1.85477L12.8705 2.01466C11.7299 3.15386 11.7299 5.00257 12.8705 6.14178L17.0227 10.2889L21.175 6.14178L21.165 6.15177ZM15.742 3.27378L17.0127 4.54289L18.2834 3.27378C18.6436 2.91403 19.2239 2.91403 19.5841 3.27378L19.7442 3.43367C20.1044 3.79342 20.1044 4.37301 19.7442 4.73276L17.0127 7.46086L14.2812 4.73276C13.921 4.37301 13.921 3.79342 14.2812 3.43367L14.4413 3.27378C14.6214 3.09391 14.8515 3.00397 15.0917 3.00397C15.3318 3.00397 15.5619 3.09391 15.742 3.27378ZM11.1595 6.15177C12.3002 5.01257 12.3002 3.16386 11.1595 2.02465L10.9995 1.85477C9.90886 0.765533 8.15792 0.725561 7.0173 1.71487C5.87668 0.715568 4.12573 0.765533 3.03514 1.85477L2.86505 2.01466C1.72443 3.15386 1.72443 5.00257 2.86505 6.14178L7.0173 10.2889L11.1695 6.14178L11.1595 6.15177ZM5.7366 3.27378L7.00729 4.54289L8.27798 3.27378C8.63818 2.91403 9.21849 2.91403 9.57869 3.27378L9.73877 3.43367C10.099 3.79342 10.099 4.37301 9.73877 4.73276L7.00729 7.46086L4.27581 4.73276C3.91562 4.37301 3.91562 3.79342 4.27581 3.43367L4.4359 3.27378C4.61599 3.09391 4.84612 3.00397 5.08625 3.00397C5.32638 3.00397 5.5565 3.09391 5.7366 3.27378Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/smiley-rate2-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/smiley-rate2-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_15894_140103)\"><path d=\"M4.88291 4.51001C4.47291 4.51001 4.08291 4.25001 3.94291 3.84001C3.76291 3.32001 4.03291 2.75001 4.55291 2.57001L8.32291 1.25001C8.84291 1.06001 9.41291 1.34001 9.59291 1.86001C9.77291 2.38001 9.50291 2.95001 8.98291 3.13001L5.20291 4.45001C5.09291 4.49001 4.98291 4.51001 4.87291 4.51001H4.88291ZM19.8129 3.89001C20.0229 3.38001 19.7729 2.79001 19.2629 2.59001L15.5529 1.07001C15.0429 0.860007 14.4529 1.11001 14.2529 1.62001C14.0429 2.13001 14.2929 2.72001 14.8029 2.92001L18.5029 4.43001C18.6229 4.48001 18.7529 4.50001 18.8829 4.50001C19.2729 4.50001 19.6529 4.27001 19.8129 3.88001V3.89001ZM3.50291 6.00001C2.64291 6.37001 1.79291 6.88001 1.00291 7.48001C0.79291 7.64001 0.64291 7.87001 0.59291 8.14001C0.48291 8.73001 0.87291 9.29001 1.45291 9.40001C2.04291 9.51001 2.60291 9.12001 2.71291 8.54001C2.87291 7.69001 3.12291 6.83001 3.50291 5.99001V6.00001ZM21.0429 8.55001C21.6029 10.48 24.2429 8.84001 22.7529 7.48001C21.9629 6.88001 21.1129 6.37001 20.2529 6.00001C20.6329 6.84001 20.8829 7.70001 21.0429 8.55001ZM21.5729 13.2C21.2529 14.2 22.5429 15.09 23.3629 14.39C23.8529 14 23.9229 13.29 23.5429 12.81C21.7429 10.67 22.1329 10.55 21.5829 13.2H21.5729ZM1.75291 11C1.22291 11.79 -0.14709 12.64 0.0129102 13.75C0.15291 14.36 0.75291 14.74 1.35291 14.6C2.98291 14.1 1.80291 12.22 1.75291 11ZM19.8829 17C19.8829 13.14 16.2929 10 11.8829 10C7.47291 10 3.88291 13.14 3.88291 17C3.88291 20.86 7.47291 24 11.8829 24C16.2929 24 19.8829 20.86 19.8829 17ZM17.8829 17C17.8829 19.76 15.1929 22 11.8829 22C8.57291 22 5.88291 19.76 5.88291 17C5.88291 14.24 8.57291 12 11.8829 12C15.1929 12 17.8829 14.24 17.8829 17Z\"></path></g><defs><clipPath id=\"clip0_15894_140103\"><rect width=\"24\" height=\"24\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v2/smiley-rate3-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/smiley-rate3-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.01915 7C6.46961 7 6.01998 6.55 6.01998 6V2C6.01998 1.45 6.46961 1 7.01915 1C7.56869 1 8.01832 1.45 8.01832 2V6C8.01832 6.55 7.56869 7 7.01915 7ZM18.01 6V2C18.01 1.45 17.5604 1 17.0108 1C16.4613 1 16.0117 1.45 16.0117 2V6C16.0117 6.55 16.4613 7 17.0108 7C17.5604 7 18.01 6.55 18.01 6ZM16.4213 21.58L18.01 19.99L19.2989 21.28C19.6886 21.67 20.3181 21.67 20.7077 21.28C21.0974 20.89 21.0974 20.26 20.7077 19.87L19.4188 18.58C18.6395 17.8 17.3705 17.8 16.5912 18.58L15.0025 20.17L13.4138 18.58C12.6345 17.8 11.3655 17.8 10.5862 18.58L8.9975 20.17L7.40883 18.58C6.62948 17.8 5.36053 17.8 4.58118 18.58L3.29226 19.87C2.90258 20.26 2.90258 20.89 3.29226 21.28C3.68193 21.67 4.31141 21.67 4.70108 21.28L5.99001 19.99L7.57868 21.58C8.35803 22.36 9.62698 22.36 10.4063 21.58L11.995 19.99L13.5837 21.58C13.9734 21.97 14.4829 22.16 14.9925 22.16C15.5021 22.16 16.0117 21.97 16.4013 21.58H16.4213Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/smiley-rate4-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/smiley-rate4-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.06927 7C6.51927 7 6.06927 6.55 6.06927 6V2C6.06927 1.45 6.51927 1 7.06927 1C7.61927 1 8.06927 1.45 8.06927 2V6C8.06927 6.55 7.61927 7 7.06927 7ZM18.0693 6V2C18.0693 1.45 17.6193 1 17.0693 1C16.5193 1 16.0693 1.45 16.0693 2V6C16.0693 6.55 16.5193 7 17.0693 7C17.6193 7 18.0693 6.55 18.0693 6ZM22.5693 21.9C23.0693 21.66 23.2793 21.07 23.0393 20.57C21.1093 16.52 16.9093 14 12.0693 14C7.22927 14 3.02927 16.52 1.09927 20.57C0.859273 21.07 1.06927 21.67 1.56927 21.9C2.06927 22.14 2.65927 21.93 2.89927 21.43C4.49927 18.08 8.00927 16 12.0593 16C16.1093 16 19.6293 18.08 21.2193 21.43C21.3893 21.79 21.7493 22 22.1193 22C22.2593 22 22.4093 21.97 22.5493 21.9H22.5693Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/smiley-rate5-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/smiley-rate5-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7.00572 7C6.45572 7 6.00572 6.55 6.00572 6V2C6.00572 1.45 6.45572 1 7.00572 1C7.55572 1 8.00572 1.45 8.00572 2V6C8.00572 6.55 7.55572 7 7.00572 7ZM18.0057 6V2C18.0057 1.45 17.5557 1 17.0057 1C16.4557 1 16.0057 1.45 16.0057 2V6C16.0057 6.55 16.4557 7 17.0057 7C17.5557 7 18.0057 6.55 18.0057 6ZM19.9457 21.33C20.1257 20.81 19.8557 20.24 19.3357 20.05C14.5457 18.35 9.45572 18.35 4.66572 20.05C4.14572 20.23 3.87572 20.81 4.05572 21.33C4.23572 21.85 4.80572 22.12 5.33572 21.94C9.69572 20.4 14.3057 20.4 18.6657 21.94C18.7757 21.98 18.8857 22 18.9957 22C19.4057 22 19.7957 21.74 19.9357 21.33H19.9457Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/smiley-rate6-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/smiley-rate6-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M7 7C6.45 7 6 6.55 6 6V2C6 1.45 6.45 1 7 1C7.55 1 8 1.45 8 2V6C8 6.55 7.55 7 7 7ZM18 6V2C18 1.45 17.55 1 17 1C16.45 1 16 1.45 16 2V6C16 6.55 16.45 7 17 7C17.55 7 18 6.55 18 6ZM21 21C21 20.45 20.55 20 20 20H4C3.45 20 3 20.45 3 21C3 21.55 3.45 22 4 22H20C20.55 22 21 21.55 21 21Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/smiley-rate7-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/smiley-rate7-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.0022 23.99C11.452 23.99 11.0018 23.5402 11.0018 22.9904C11.0018 22.4407 11.452 21.9909 12.0022 21.9909C16.3137 21.9909 21.0755 19.472 22.0158 13.8344C22.1058 13.2947 22.616 12.9248 23.1662 13.0148C23.7064 13.1047 24.0765 13.6245 23.9865 14.1643C22.8561 20.9513 17.144 24 11.9922 24L12.0022 23.99ZM8.00072 5.99783V1.99957C8.00072 1.4498 7.55056 1 7.00036 1C6.45016 1 6 1.4498 6 1.99957V5.99783C6 6.54759 6.45016 6.99739 7.00036 6.99739C7.55056 6.99739 8.00072 6.54759 8.00072 5.99783ZM18.0043 5.99783V1.99957C18.0043 1.4498 17.5542 1 17.004 1C16.4538 1 16.0036 1.4498 16.0036 1.99957V5.99783C16.0036 6.54759 16.4538 6.99739 17.004 6.99739C17.5542 6.99739 18.0043 6.54759 18.0043 5.99783Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/smiley-rate8-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/smiley-rate8-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.01 24C6.85721 24 1.15412 20.96 0.0134987 14.16C-0.0765501 13.62 0.293651 13.1 0.833944 13.01C1.38424 12.92 1.89452 13.29 1.98457 13.83C2.92508 19.47 7.69767 21.99 12 21.99C16.3023 21.99 21.0749 19.47 22.0154 13.83C22.1055 13.29 22.6158 12.92 23.1661 13.01C23.7063 13.1 24.0765 13.62 23.9865 14.16C22.8559 20.95 17.1428 24 11.99 24H12.01ZM8.00783 6V2C8.00783 1.45 7.55759 1 7.00729 1C6.45699 1 6.00675 1.45 6.00675 2V6C6.00675 6.55 6.45699 7 7.00729 7C7.55759 7 8.00783 6.55 8.00783 6ZM18.0133 6V2C18.0133 1.45 17.563 1 17.0127 1C16.4624 1 16.0122 1.45 16.0122 2V6C16.0122 6.55 16.4624 7 17.0127 7C17.563 7 18.0133 6.55 18.0133 6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/smiley-rate9-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/smiley-rate9-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12.01 24C6.85767 24 1.15509 20.96 0.0145752 14.16C-0.0354475 13.87 0.0445888 13.57 0.234675 13.35C0.424761 13.13 0.704888 13 0.995019 13H23.005C23.2951 13 23.5752 13.13 23.7653 13.35C23.9554 13.57 24.0354 13.87 23.9854 14.16C22.8549 20.95 17.1423 24 11.99 24H12.01ZM2.25559 15C3.61621 19.82 8.0182 22 12.01 22C16.0018 22 20.4038 19.82 21.7644 15H2.25559ZM8.00819 6V2C8.00819 1.45 7.55799 1 7.00774 1C6.45749 1 6.00729 1.45 6.00729 2V6C6.00729 6.55 6.45749 7 7.00774 7C7.55799 7 8.00819 6.55 8.00819 6ZM18.0127 6V2C18.0127 1.45 17.5625 1 17.0123 1C16.462 1 16.0118 1.45 16.0118 2V6C16.0118 6.55 16.462 7 17.0123 7C17.5625 7 18.0127 6.55 18.0127 6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/speechbubble-16x16.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/speechbubble-16x16.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 2.25H3C2.04 2.25 1.25 3.04 1.25 4V11C1.25 11.96 2.04 12.75 3 12.75H4.25V15C4.25 15.3 4.43 15.58 4.71 15.69C4.8 15.73 4.9 15.75 5 15.75C5.2 15.75 5.39 15.67 5.53 15.53L8.31 12.75H13C13.96 12.75 14.75 11.96 14.75 11V4C14.75 3.04 13.96 2.25 13 2.25ZM13.25 11C13.25 11.14 13.14 11.25 13 11.25H8C7.8 11.25 7.61 11.33 7.47 11.47L5.75 13.19V12C5.75 11.59 5.41 11.25 5 11.25H3C2.86 11.25 2.75 11.14 2.75 11V4C2.75 3.86 2.86 3.75 3 3.75H13C13.14 3.75 13.25 3.86 13.25 4V11Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/switchoff-16x16.svg":
/*!*******************************************!*\
  !*** ./src/images-v2/switchoff-16x16.svg ***!
  \*******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 6.25C4.04 6.25 3.25 7.04 3.25 8C3.25 8.96 4.04 9.75 5 9.75C5.96 9.75 6.75 8.96 6.75 8C6.75 7.04 5.96 6.25 5 6.25ZM4.75 8C4.75 7.86 4.86 7.75 5 7.75C5.14 7.75 5.25 7.86 5.25 8C5.25 8.28 4.75 8.28 4.75 8ZM11 3.25H5C2.38 3.25 0.25 5.38 0.25 8C0.25 10.62 2.38 12.75 5 12.75H11C13.62 12.75 15.75 10.62 15.75 8C15.75 5.38 13.62 3.25 11 3.25ZM11 11.25H5C3.21 11.25 1.75 9.79 1.75 8C1.75 6.21 3.21 4.75 5 4.75H11C12.79 4.75 14.25 6.21 14.25 8C14.25 9.79 12.79 11.25 11 11.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/switchon-16x16.svg":
/*!******************************************!*\
  !*** ./src/images-v2/switchon-16x16.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 6.25C10.04 6.25 9.25 7.04 9.25 8C9.25 8.96 10.04 9.75 11 9.75C11.96 9.75 12.75 8.96 12.75 8C12.75 7.04 11.96 6.25 11 6.25ZM10.75 8C10.75 7.86 10.86 7.75 11 7.75C11.14 7.75 11.25 7.86 11.25 8C11.25 8.28 10.75 8.28 10.75 8ZM11 3.25H5C2.38 3.25 0.25 5.38 0.25 8C0.25 10.62 2.38 12.75 5 12.75H11C13.62 12.75 15.75 10.62 15.75 8C15.75 5.38 13.62 3.25 11 3.25ZM11 11.25H5C3.21 11.25 1.75 9.79 1.75 8C1.75 6.21 3.21 4.75 5 4.75H11C12.79 4.75 14.25 6.21 14.25 8C14.25 9.79 12.79 11.25 11 11.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/tablet-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/tablet-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 4.25H5C3.48 4.25 2.25 5.48 2.25 7V17C2.25 18.52 3.48 19.75 5 19.75H19C20.52 19.75 21.75 18.52 21.75 17V7C21.75 5.48 20.52 4.25 19 4.25ZM20.25 17C20.25 17.69 19.69 18.25 19 18.25H5C4.31 18.25 3.75 17.69 3.75 17V7C3.75 6.31 4.31 5.75 5 5.75H19C19.69 5.75 20.25 6.31 20.25 7V17ZM15.75 16C15.75 16.41 15.41 16.75 15 16.75H9C8.59 16.75 8.25 16.41 8.25 16C8.25 15.59 8.59 15.25 9 15.25H15C15.41 15.25 15.75 15.59 15.75 16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/textedit-24x24.svg":
/*!******************************************!*\
  !*** ./src/images-v2/textedit-24x24.svg ***!
  \******************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.12 10.06L19.95 9.89C18.91 8.85 17.1 8.85 16.06 9.89L9.47 16.48C9.37 16.58 9.31 16.7 9.27 16.83L8.27 20.83C8.21 21.08 8.28 21.36 8.47 21.54C8.61 21.68 8.8 21.76 9 21.76C9.06 21.76 9.12 21.76 9.18 21.74L13.18 20.74C13.31 20.71 13.43 20.64 13.53 20.54L20.12 13.95C20.64 13.43 20.93 12.74 20.93 12.01C20.93 11.28 20.64 10.59 20.12 10.07V10.06ZM12.62 19.32L10.04 19.97L10.69 17.39L15.01 13.07L16.95 15.01L12.63 19.33L12.62 19.32ZM19.06 12.88L18 13.94L16.06 12L17.12 10.94C17.61 10.45 18.4 10.45 18.89 10.94L19.06 11.11C19.55 11.6 19.55 12.39 19.06 12.88ZM4.25 4C4.25 3.59 4.59 3.25 5 3.25H18C18.41 3.25 18.75 3.59 18.75 4C18.75 4.41 18.41 4.75 18 4.75H5C4.59 4.75 4.25 4.41 4.25 4ZM4.25 7C4.25 6.59 4.59 6.25 5 6.25H15C15.41 6.25 15.75 6.59 15.75 7C15.75 7.41 15.41 7.75 15 7.75H5C4.59 7.75 4.25 7.41 4.25 7ZM4.25 10C4.25 9.59 4.59 9.25 5 9.25H12C12.41 9.25 12.75 9.59 12.75 10C12.75 10.41 12.41 10.75 12 10.75H5C4.59 10.75 4.25 10.41 4.25 10ZM9 13.75H5C4.59 13.75 4.25 13.41 4.25 13C4.25 12.59 4.59 12.25 5 12.25H9C9.41 12.25 9.75 12.59 9.75 13C9.75 13.41 9.41 13.75 9 13.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/theme-24x24.svg":
/*!***************************************!*\
  !*** ./src/images-v2/theme-24x24.svg ***!
  \***************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 2.25C7.65 2.25 4.25 4.34 4.25 7V17C4.25 19.66 7.65 21.75 12 21.75C16.35 21.75 19.75 19.66 19.75 17V7C19.75 4.34 16.35 2.25 12 2.25ZM12 3.75C15.39 3.75 18.25 5.24 18.25 7C18.25 8.04 17.23 8.79 16.63 9.14C15.77 9.64 15.25 10.51 15.25 11.47V15.5C15.25 15.91 14.91 16.25 14.5 16.25C14.09 16.25 13.75 15.91 13.75 15.5V15C13.75 14.04 13 13.28 12.05 13.25C11.32 13.23 10.75 12.68 10.75 12V11.64C10.75 10.83 10.21 10.14 9.44 9.95C7.23 9.41 5.75 8.23 5.75 7C5.75 5.24 8.61 3.75 12 3.75ZM12 20.25C8.61 20.25 5.75 18.76 5.75 17V9.82C6.58 10.52 7.71 11.08 9.09 11.41C9.18 11.43 9.25 11.53 9.25 11.65V12.01C9.25 13.51 10.46 14.72 12.01 14.76C12.14 14.76 12.25 14.88 12.25 15.01V15.51C12.25 16.75 13.26 17.76 14.5 17.76C15.74 17.76 16.75 16.75 16.75 15.51V11.48C16.75 11.07 16.99 10.68 17.39 10.45C17.71 10.26 17.99 10.06 18.25 9.84V17.01C18.25 18.77 15.39 20.26 12 20.26V20.25ZM12 8.75C14.29 8.75 16.75 8.05 16.75 6.5C16.75 4.95 14.29 4.25 12 4.25C9.71 4.25 7.25 4.95 7.25 6.5C7.25 8.05 9.71 8.75 12 8.75ZM12 5.75C13.88 5.75 14.97 6.24 15.22 6.5C14.97 6.76 13.88 7.25 12 7.25C10.12 7.25 9.03 6.76 8.78 6.5C9.03 6.24 10.12 5.75 12 5.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/toolbox-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.23 6.78L17.76 5.54C17.38 5.35 16.96 5.25 16.53 5.25H15.75V4C15.75 3.04 14.96 2.25 14 2.25H10C9.04 2.25 8.25 3.04 8.25 4V5.25H7.47C7.05 5.25 6.62 5.35 6.24 5.54L3.77 6.78C2.83 7.25 2.25 8.19 2.25 9.24V18C2.25 19.52 3.48 20.75 5 20.75H19C20.52 20.75 21.75 19.52 21.75 18V9.24C21.75 8.19 21.17 7.25 20.23 6.78ZM9.75 4C9.75 3.86 9.86 3.75 10 3.75H14C14.14 3.75 14.25 3.86 14.25 4V5.25H9.75V4ZM4.44 8.12L6.91 6.88C7.08 6.79 7.28 6.75 7.47 6.75H16.53C16.72 6.75 16.92 6.8 17.09 6.88L19.56 8.12C19.99 8.33 20.25 8.76 20.25 9.24V13.25H18.75V13C18.75 12.04 17.96 11.25 17 11.25H16C15.04 11.25 14.25 12.04 14.25 13V13.25H9.75V13C9.75 12.04 8.96 11.25 8 11.25H7C6.04 11.25 5.25 12.04 5.25 13V13.25H3.75V9.24C3.75 8.76 4.01 8.33 4.44 8.12ZM15.75 13C15.75 12.86 15.86 12.75 16 12.75H17C17.14 12.75 17.25 12.86 17.25 13V15C17.25 15.14 17.14 15.25 17 15.25H16C15.86 15.25 15.75 15.14 15.75 15V13ZM6.75 13C6.75 12.86 6.86 12.75 7 12.75H8C8.14 12.75 8.25 12.86 8.25 13V15C8.25 15.14 8.14 15.25 8 15.25H7C6.86 15.25 6.75 15.14 6.75 15V13ZM19 19.25H5C4.31 19.25 3.75 18.69 3.75 18V14.75H5.25V15C5.25 15.96 6.04 16.75 7 16.75H8C8.96 16.75 9.75 15.96 9.75 15V14.75H14.25V15C14.25 15.96 15.04 16.75 16 16.75H17C17.96 16.75 18.75 15.96 18.75 15V14.75H20.25V18C20.25 18.69 19.69 19.25 19 19.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-boolean-16x16.svg":
/*!*************************************************!*\
  !*** ./src/images-v2/toolbox-boolean-16x16.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11 3.25H5C2.38 3.25 0.25 5.38 0.25 8C0.25 10.62 2.38 12.75 5 12.75H11C13.62 12.75 15.75 10.62 15.75 8C15.75 5.38 13.62 3.25 11 3.25ZM11 11.25H5C3.21 11.25 1.75 9.79 1.75 8C1.75 6.21 3.21 4.75 5 4.75H11C12.79 4.75 14.25 6.21 14.25 8C14.25 9.79 12.79 11.25 11 11.25ZM11 5.25C9.48 5.25 8.25 6.48 8.25 8C8.25 9.52 9.48 10.75 11 10.75C12.52 10.75 13.75 9.52 13.75 8C13.75 6.48 12.52 5.25 11 5.25ZM11 9.25C10.31 9.25 9.75 8.69 9.75 8C9.75 7.31 10.31 6.75 11 6.75C11.69 6.75 12.25 7.31 12.25 8C12.25 8.69 11.69 9.25 11 9.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-boolean-24x24.svg":
/*!*************************************************!*\
  !*** ./src/images-v2/toolbox-boolean-24x24.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17 17.75H7C3.83 17.75 1.25 15.17 1.25 12C1.25 8.83 3.83 6.25 7 6.25H17C20.17 6.25 22.75 8.83 22.75 12C22.75 15.17 20.17 17.75 17 17.75ZM7 7.75C4.66 7.75 2.75 9.66 2.75 12C2.75 14.34 4.66 16.25 7 16.25H17C19.34 16.25 21.25 14.34 21.25 12C21.25 9.66 19.34 7.75 17 7.75H7ZM17 14.75C15.48 14.75 14.25 13.52 14.25 12C14.25 10.48 15.48 9.25 17 9.25C18.52 9.25 19.75 10.48 19.75 12C19.75 13.52 18.52 14.75 17 14.75ZM17 10.75C16.31 10.75 15.75 11.31 15.75 12C15.75 12.69 16.31 13.25 17 13.25C17.69 13.25 18.25 12.69 18.25 12C18.25 11.31 17.69 10.75 17 10.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-checkbox-16x16.svg":
/*!**************************************************!*\
  !*** ./src/images-v2/toolbox-checkbox-16x16.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 1.25H3C2.04 1.25 1.25 2.04 1.25 3V13C1.25 13.96 2.04 14.75 3 14.75H13C13.96 14.75 14.75 13.96 14.75 13V3C14.75 2.04 13.96 1.25 13 1.25ZM13.25 13C13.25 13.14 13.14 13.25 13 13.25H3C2.86 13.25 2.75 13.14 2.75 13V3C2.75 2.86 2.86 2.75 3 2.75H13C13.14 2.75 13.25 2.86 13.25 3V13ZM11.53 5.47C11.82 5.76 11.82 6.24 11.53 6.53L7.53 10.53C7.38 10.68 7.19 10.75 7 10.75C6.81 10.75 6.62 10.68 6.47 10.53L4.47 8.53C4.18 8.24 4.18 7.76 4.47 7.47C4.76 7.18 5.24 7.18 5.53 7.47L7 8.94L10.47 5.47C10.76 5.18 11.24 5.18 11.53 5.47Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-checkbox-24x24.svg":
/*!**************************************************!*\
  !*** ./src/images-v2/toolbox-checkbox-24x24.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 20.75H6C4.48 20.75 3.25 19.52 3.25 18V6C3.25 4.48 4.48 3.25 6 3.25H18C19.52 3.25 20.75 4.48 20.75 6V18C20.75 19.52 19.52 20.75 18 20.75ZM6 4.75C5.31 4.75 4.75 5.31 4.75 6V18C4.75 18.69 5.31 19.25 6 19.25H18C18.69 19.25 19.25 18.69 19.25 18V6C19.25 5.31 18.69 4.75 18 4.75H6ZM10.53 15.53L16.53 9.53C16.82 9.24 16.82 8.76 16.53 8.47C16.24 8.18 15.76 8.18 15.47 8.47L10 13.94L8.53 12.47C8.24 12.18 7.76 12.18 7.47 12.47C7.18 12.76 7.18 13.24 7.47 13.53L9.47 15.53C9.62 15.68 9.81 15.75 10 15.75C10.19 15.75 10.38 15.68 10.53 15.53Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-customquestion-16x16.svg":
/*!********************************************************!*\
  !*** ./src/images-v2/toolbox-customquestion-16x16.svg ***!
  \********************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5 15.75C4.9 15.75 4.81 15.73 4.71 15.69C4.43 15.57 4.25 15.3 4.25 15V12.75H3C2.04 12.75 1.25 11.96 1.25 11V3C1.25 2.04 2.04 1.25 3 1.25H13C13.96 1.25 14.75 2.04 14.75 3V11C14.75 11.96 13.96 12.75 13 12.75H8.31L5.53 15.53C5.39 15.67 5.2 15.75 5 15.75ZM3 2.75C2.86 2.75 2.75 2.86 2.75 3V11C2.75 11.14 2.86 11.25 3 11.25H5C5.41 11.25 5.75 11.59 5.75 12V13.19L7.47 11.47C7.61 11.33 7.8 11.25 8 11.25H13C13.14 11.25 13.25 11.14 13.25 11V3C13.25 2.86 13.14 2.75 13 2.75H3Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-customquestion-24x24.svg":
/*!********************************************************!*\
  !*** ./src/images-v2/toolbox-customquestion-24x24.svg ***!
  \********************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 3.25H6C4.48 3.25 3.25 4.48 3.25 6V16C3.25 17.52 4.48 18.75 6 18.75H7.25V22C7.25 22.3 7.43 22.58 7.71 22.69C7.8 22.73 7.9 22.75 8 22.75C8.2 22.75 8.39 22.67 8.53 22.53L12.31 18.75H18C19.52 18.75 20.75 17.52 20.75 16V6C20.75 4.48 19.52 3.25 18 3.25ZM19.25 16C19.25 16.69 18.69 17.25 18 17.25H12C11.8 17.25 11.61 17.33 11.47 17.47L8.75 20.19V18C8.75 17.59 8.41 17.25 8 17.25H6C5.31 17.25 4.75 16.69 4.75 16V6C4.75 5.31 5.31 4.75 6 4.75H18C18.69 4.75 19.25 5.31 19.25 6V16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-dropdown-16x16.svg":
/*!**************************************************!*\
  !*** ./src/images-v2/toolbox-dropdown-16x16.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 1.25H3C2.04 1.25 1.25 2.04 1.25 3V13C1.25 13.96 2.04 14.75 3 14.75H13C13.96 14.75 14.75 13.96 14.75 13V3C14.75 2.04 13.96 1.25 13 1.25ZM2.75 3C2.75 2.86 2.86 2.75 3 2.75H13C13.14 2.75 13.25 2.86 13.25 3V5.25H2.75V3ZM13.25 13C13.25 13.14 13.14 13.25 13 13.25H3C2.86 13.25 2.75 13.14 2.75 13V6.75H13.25V13ZM4.25 9C4.25 8.59 4.59 8.25 5 8.25H11C11.41 8.25 11.75 8.59 11.75 9C11.75 9.41 11.41 9.75 11 9.75H5C4.59 9.75 4.25 9.41 4.25 9ZM4.25 11C4.25 10.59 4.59 10.25 5 10.25H11C11.41 10.25 11.75 10.59 11.75 11C11.75 11.41 11.41 11.75 11 11.75H5C4.59 11.75 4.25 11.41 4.25 11ZM12.75 4C12.75 4.41 12.41 4.75 12 4.75H11C10.59 4.75 10.25 4.41 10.25 4C10.25 3.59 10.59 3.25 11 3.25H12C12.41 3.25 12.75 3.59 12.75 4Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-dropdown-24x24.svg":
/*!**************************************************!*\
  !*** ./src/images-v2/toolbox-dropdown-24x24.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.75 6C17.75 6.41 17.41 6.75 17 6.75H16C15.59 6.75 15.25 6.41 15.25 6C15.25 5.59 15.59 5.25 16 5.25H17C17.41 5.25 17.75 5.59 17.75 6ZM7 12.75H17C17.41 12.75 17.75 12.41 17.75 12C17.75 11.59 17.41 11.25 17 11.25H7C6.59 11.25 6.25 11.59 6.25 12C6.25 12.41 6.59 12.75 7 12.75ZM7 15.75H17C17.41 15.75 17.75 15.41 17.75 15C17.75 14.59 17.41 14.25 17 14.25H7C6.59 14.25 6.25 14.59 6.25 15C6.25 15.41 6.59 15.75 7 15.75ZM20.75 5V19C20.75 20.52 19.52 21.75 18 21.75H6C4.48 21.75 3.25 20.52 3.25 19V5C3.25 3.48 4.48 2.25 6 2.25H18C19.52 2.25 20.75 3.48 20.75 5ZM4.75 8.25H19.25V5C19.25 4.31 18.69 3.75 18 3.75H6C5.31 3.75 4.75 4.31 4.75 5V8.25ZM19.25 9.75H4.75V19C4.75 19.69 5.31 20.25 6 20.25H18C18.69 20.25 19.25 19.69 19.25 19V9.75ZM7 18.75H17C17.41 18.75 17.75 18.41 17.75 18C17.75 17.59 17.41 17.25 17 17.25H7C6.59 17.25 6.25 17.59 6.25 18C6.25 18.41 6.59 18.75 7 18.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-dynamicmatrix-16x16.svg":
/*!*******************************************************!*\
  !*** ./src/images-v2/toolbox-dynamicmatrix-16x16.svg ***!
  \*******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 1.25H3C2.04 1.25 1.25 2.04 1.25 3V5C1.25 5.96 2.04 6.75 3 6.75H13C13.96 6.75 14.75 5.96 14.75 5V3C14.75 2.04 13.96 1.25 13 1.25ZM2.75 5V3C2.75 2.86 2.86 2.75 3 2.75H7.25V5.25H3C2.86 5.25 2.75 5.14 2.75 5ZM13.25 5C13.25 5.14 13.14 5.25 13 5.25H8.75V2.75H13C13.14 2.75 13.25 2.86 13.25 3V5ZM10 11.65H8.75V12.9C8.75 13.31 8.41 13.65 8 13.65C7.59 13.65 7.25 13.31 7.25 12.9V11.65H6C5.59 11.65 5.25 11.31 5.25 10.9C5.25 10.49 5.59 10.15 6 10.15H7.25V9C7.25 8.59 7.59 8.25 8 8.25C8.41 8.25 8.75 8.59 8.75 9V10.15H10C10.41 10.15 10.75 10.49 10.75 10.9C10.75 11.31 10.41 11.65 10 11.65ZM14.75 9V13C14.75 13.96 13.96 14.75 13 14.75H11C10.59 14.75 10.25 14.41 10.25 14C10.25 13.59 10.59 13.25 11 13.25H13C13.14 13.25 13.25 13.14 13.25 13V9C13.25 8.86 13.14 8.75 13 8.75H11C10.59 8.75 10.25 8.41 10.25 8C10.25 7.59 10.59 7.25 11 7.25H13C13.96 7.25 14.75 8.04 14.75 9ZM5.75 14C5.75 14.41 5.41 14.75 5 14.75H3C2.04 14.75 1.25 13.96 1.25 13V9C1.25 8.04 2.04 7.25 3 7.25H5C5.41 7.25 5.75 7.59 5.75 8C5.75 8.41 5.41 8.75 5 8.75H3C2.86 8.75 2.75 8.86 2.75 9V13C2.75 13.14 2.86 13.25 3 13.25H5C5.41 13.25 5.75 13.59 5.75 14Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-dynamicmatrix-24x24.svg":
/*!*******************************************************!*\
  !*** ./src/images-v2/toolbox-dynamicmatrix-24x24.svg ***!
  \*******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 2.25H5C3.48 2.25 2.25 3.48 2.25 5V7C2.25 8.52 3.48 9.75 5 9.75H19C20.52 9.75 21.75 8.52 21.75 7V5C21.75 3.48 20.52 2.25 19 2.25ZM14.25 3.75V8.25H9.75V3.75H14.25ZM3.75 7V5C3.75 4.31 4.31 3.75 5 3.75H8.25V8.25H5C4.31 8.25 3.75 7.69 3.75 7ZM20.25 7C20.25 7.69 19.69 8.25 19 8.25H15.75V3.75H19C19.69 3.75 20.25 4.31 20.25 5V7ZM21.75 15V19C21.75 20.52 20.52 21.75 19 21.75H15C14.59 21.75 14.25 21.41 14.25 21C14.25 20.59 14.59 20.25 15 20.25H19C19.69 20.25 20.25 19.69 20.25 19V15C20.25 14.31 19.69 13.75 19 13.75H15C14.59 13.75 14.25 13.41 14.25 13C14.25 12.59 14.59 12.25 15 12.25H19C20.52 12.25 21.75 13.48 21.75 15ZM9.75 21C9.75 21.41 9.41 21.75 9 21.75H5C3.48 21.75 2.25 20.52 2.25 19V15C2.25 13.48 3.48 12.25 5 12.25H9C9.41 12.25 9.75 12.59 9.75 13C9.75 13.41 9.41 13.75 9 13.75H5C4.31 13.75 3.75 14.31 3.75 15V19C3.75 19.69 4.31 20.25 5 20.25H9C9.41 20.25 9.75 20.59 9.75 21ZM12.75 17.75V20C12.75 20.41 12.41 20.75 12 20.75C11.59 20.75 11.25 20.41 11.25 20V17.75H9C8.59 17.75 8.25 17.41 8.25 17C8.25 16.59 8.59 16.25 9 16.25H11.25V14C11.25 13.59 11.59 13.25 12 13.25C12.41 13.25 12.75 13.59 12.75 14V16.25H15C15.41 16.25 15.75 16.59 15.75 17C15.75 17.41 15.41 17.75 15 17.75H12.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-dynamicpanel-16x16.svg":
/*!******************************************************!*\
  !*** ./src/images-v2/toolbox-dynamicpanel-16x16.svg ***!
  \******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 1.25H3C2.04 1.25 1.25 2.04 1.25 3V13C1.25 13.96 2.04 14.75 3 14.75H13C13.96 14.75 14.75 13.96 14.75 13V3C14.75 2.04 13.96 1.25 13 1.25ZM13.25 13C13.25 13.14 13.14 13.25 13 13.25H3C2.86 13.25 2.75 13.14 2.75 13V3C2.75 2.86 2.86 2.75 3 2.75H13C13.14 2.75 13.25 2.86 13.25 3V13ZM10.75 8C10.75 8.41 10.41 8.75 10 8.75H8.75V10C8.75 10.41 8.41 10.75 8 10.75C7.59 10.75 7.25 10.41 7.25 10V8.75H6C5.59 8.75 5.25 8.41 5.25 8C5.25 7.59 5.59 7.25 6 7.25H7.25V6C7.25 5.59 7.59 5.25 8 5.25C8.41 5.25 8.75 5.59 8.75 6V7.25H10C10.41 7.25 10.75 7.59 10.75 8Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-dynamicpanel-24x24.svg":
/*!******************************************************!*\
  !*** ./src/images-v2/toolbox-dynamicpanel-24x24.svg ***!
  \******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 3.25H6C4.48 3.25 3.25 4.48 3.25 6V18C3.25 19.52 4.48 20.75 6 20.75H18C19.52 20.75 20.75 19.52 20.75 18V6C20.75 4.48 19.52 3.25 18 3.25ZM19.25 18C19.25 18.69 18.69 19.25 18 19.25H6C5.31 19.25 4.75 18.69 4.75 18V6C4.75 5.31 5.31 4.75 6 4.75H18C18.69 4.75 19.25 5.31 19.25 6V18ZM15.75 12C15.75 12.41 15.41 12.75 15 12.75H12.75V15C12.75 15.41 12.41 15.75 12 15.75C11.59 15.75 11.25 15.41 11.25 15V12.75H9C8.59 12.75 8.25 12.41 8.25 12C8.25 11.59 8.59 11.25 9 11.25H11.25V9C11.25 8.59 11.59 8.25 12 8.25C12.41 8.25 12.75 8.59 12.75 9V11.25H15C15.41 11.25 15.75 11.59 15.75 12Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-expression-16x16.svg":
/*!****************************************************!*\
  !*** ./src/images-v2/toolbox-expression-16x16.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.75 4V7.25H8C8.41 7.25 8.75 7.59 8.75 8C8.75 8.41 8.41 8.75 8 8.75H6.75V12C6.75 13.52 5.52 14.75 4 14.75C2.48 14.75 1.25 13.52 1.25 12C1.25 11.59 1.59 11.25 2 11.25C2.41 11.25 2.75 11.59 2.75 12C2.75 12.69 3.31 13.25 4 13.25C4.69 13.25 5.25 12.69 5.25 12V8.75H4C3.59 8.75 3.25 8.41 3.25 8C3.25 7.59 3.59 7.25 4 7.25H5.25V4C5.25 2.48 6.48 1.25 8 1.25C9.52 1.25 10.75 2.48 10.75 4C10.75 4.41 10.41 4.75 10 4.75C9.59 4.75 9.25 4.41 9.25 4C9.25 3.31 8.69 2.75 8 2.75C7.31 2.75 6.75 3.31 6.75 4ZM14.53 13.47L13.03 11.97L14.44 10.53C14.73 10.23 14.72 9.76 14.43 9.47C14.13 9.18 13.66 9.19 13.37 9.48L11.97 10.91L10.53 9.47C10.24 9.18 9.76 9.18 9.47 9.47C9.18 9.76 9.18 10.24 9.47 10.53L10.92 11.98L9.46 13.48C9.17 13.78 9.18 14.25 9.47 14.54C9.62 14.68 9.8 14.75 9.99 14.75C10.18 14.75 10.38 14.67 10.53 14.52L11.97 13.04L13.46 14.53C13.61 14.68 13.8 14.75 13.99 14.75C14.18 14.75 14.37 14.68 14.52 14.53C14.81 14.24 14.81 13.76 14.52 13.47H14.53Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-expression-24x24.svg":
/*!****************************************************!*\
  !*** ./src/images-v2/toolbox-expression-24x24.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8.75 5.5V9.25H10C10.41 9.25 10.75 9.59 10.75 10C10.75 10.41 10.41 10.75 10 10.75H8.75V18.5C8.75 20.29 7.29 21.75 5.5 21.75C3.71 21.75 2.25 20.29 2.25 18.5V18C2.25 17.59 2.59 17.25 3 17.25C3.41 17.25 3.75 17.59 3.75 18V18.5C3.75 19.46 4.54 20.25 5.5 20.25C6.46 20.25 7.25 19.46 7.25 18.5V10.75H6C5.59 10.75 5.25 10.41 5.25 10C5.25 9.59 5.59 9.25 6 9.25H7.25V5.5C7.25 3.71 8.71 2.25 10.5 2.25C12.29 2.25 13.75 3.71 13.75 5.5V6C13.75 6.41 13.41 6.75 13 6.75C12.59 6.75 12.25 6.41 12.25 6V5.5C12.25 4.54 11.46 3.75 10.5 3.75C9.54 3.75 8.75 4.54 8.75 5.5ZM17.06 16L19.53 13.53C19.82 13.24 19.82 12.76 19.53 12.47C19.24 12.18 18.76 12.18 18.47 12.47L16 14.94L13.53 12.47C13.24 12.18 12.76 12.18 12.47 12.47C12.18 12.76 12.18 13.24 12.47 13.53L14.94 16L12.47 18.47C12.18 18.76 12.18 19.24 12.47 19.53C12.62 19.68 12.81 19.75 13 19.75C13.19 19.75 13.38 19.68 13.53 19.53L16 17.06L18.47 19.53C18.62 19.68 18.81 19.75 19 19.75C19.19 19.75 19.38 19.68 19.53 19.53C19.82 19.24 19.82 18.76 19.53 18.47L17.06 16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-file-16x16.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/toolbox-file-16x16.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 2.25H7.75V2C7.75 1.04 6.96 0.25 6 0.25H3C2.04 0.25 1.25 1.04 1.25 2V13C1.25 13.96 2.04 14.75 3 14.75H5C5.41 14.75 5.75 14.41 5.75 14C5.75 13.59 5.41 13.25 5 13.25H3C2.86 13.25 2.75 13.14 2.75 13V6.75H13.25V13C13.25 13.14 13.14 13.25 13 13.25H11C10.59 13.25 10.25 13.59 10.25 14C10.25 14.41 10.59 14.75 11 14.75H13C13.96 14.75 14.75 13.96 14.75 13V4C14.75 3.04 13.96 2.25 13 2.25ZM2.75 5.25V2C2.75 1.86 2.86 1.75 3 1.75H6C6.14 1.75 6.25 1.86 6.25 2V3C6.25 3.41 6.59 3.75 7 3.75H13C13.14 3.75 13.25 3.86 13.25 4V5.25H2.75ZM10.63 11.63C10.48 11.78 10.29 11.85 10.1 11.85C9.91 11.85 9.72 11.78 9.57 11.63L8.75 10.81V15C8.75 15.41 8.41 15.75 8 15.75C7.59 15.75 7.25 15.41 7.25 15V10.81L6.43 11.63C6.14 11.92 5.66 11.92 5.37 11.63C5.08 11.34 5.08 10.86 5.37 10.57L7.47 8.47C7.54 8.4 7.62 8.35 7.71 8.31C7.89 8.23 8.1 8.23 8.28 8.31C8.37 8.35 8.45 8.4 8.52 8.47L10.62 10.57C10.91 10.86 10.91 11.34 10.62 11.63H10.63Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-file-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/toolbox-file-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 4.25H10.65C10.32 3.1 9.26 2.25 8 2.25H6C4.48 2.25 3.25 3.48 3.25 5V18C3.25 19.52 4.48 20.75 6 20.75H9C9.41 20.75 9.75 20.41 9.75 20C9.75 19.59 9.41 19.25 9 19.25H6C5.31 19.25 4.75 18.69 4.75 18V9.75H19.25V18C19.25 18.69 18.69 19.25 18 19.25H15C14.59 19.25 14.25 19.59 14.25 20C14.25 20.41 14.59 20.75 15 20.75H18C19.52 20.75 20.75 19.52 20.75 18V7C20.75 5.48 19.52 4.25 18 4.25ZM4.75 8.25V5C4.75 4.31 5.31 3.75 6 3.75H8C8.69 3.75 9.25 4.31 9.25 5C9.25 5.41 9.59 5.75 10 5.75H18C18.69 5.75 19.25 6.31 19.25 7V8.25H4.75ZM12.75 14.81V23C12.75 23.41 12.41 23.75 12 23.75C11.59 23.75 11.25 23.41 11.25 23V14.81L9.53 16.53C9.24 16.82 8.76 16.82 8.47 16.53C8.18 16.24 8.18 15.76 8.47 15.47L11.47 12.47C11.54 12.4 11.62 12.35 11.71 12.31C11.89 12.23 12.1 12.23 12.28 12.31C12.37 12.35 12.45 12.4 12.52 12.47L15.52 15.47C15.81 15.76 15.81 16.24 15.52 16.53C15.37 16.68 15.18 16.75 14.99 16.75C14.8 16.75 14.61 16.68 14.46 16.53L12.74 14.81H12.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-html-16x16.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/toolbox-html-16x16.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M5.5275 5.53444L3.0575 8.00444L5.5275 10.4744C5.8175 10.7644 5.8175 11.2444 5.5275 11.5344C5.3775 11.6844 5.1875 11.7544 4.9975 11.7544C4.8075 11.7544 4.6175 11.6844 4.4675 11.5344L1.4675 8.53444C1.1775 8.24444 1.1775 7.76444 1.4675 7.47444L4.4675 4.47444C4.7575 4.18444 5.2375 4.18444 5.5275 4.47444C5.8175 4.76444 5.8175 5.24444 5.5275 5.53444ZM14.5275 7.47444L11.5275 4.47444C11.2375 4.18444 10.7575 4.18444 10.4675 4.47444C10.1775 4.76444 10.1775 5.24444 10.4675 5.53444L12.9375 8.00444L10.4675 10.4744C10.1775 10.7644 10.1775 11.2444 10.4675 11.5344C10.6175 11.6844 10.8075 11.7544 10.9975 11.7544C11.1875 11.7544 11.3775 11.6844 11.5275 11.5344L14.5275 8.53444C14.8175 8.24444 14.8175 7.76444 14.5275 7.47444ZM9.1475 2.26444C8.7375 2.18444 8.3475 2.44444 8.2675 2.85444L6.2675 12.8544C6.1875 13.2644 6.4475 13.6544 6.8575 13.7344C6.9075 13.7344 6.9575 13.7444 7.0075 13.7444C7.3575 13.7444 7.6675 13.4944 7.7375 13.1444L9.7375 3.15444C9.8175 2.74444 9.5575 2.35444 9.1475 2.27444V2.26444Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-html-24x24.svg":
/*!**********************************************!*\
  !*** ./src/images-v2/toolbox-html-24x24.svg ***!
  \**********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.5275 8.53263L3.0575 12.0026L6.5275 15.4726C6.8175 15.7626 6.8175 16.2426 6.5275 16.5326C6.3775 16.6826 6.1875 16.7526 5.9975 16.7526C5.8075 16.7526 5.6175 16.6826 5.4675 16.5326L1.4675 12.5326C1.1775 12.2426 1.1775 11.7626 1.4675 11.4726L5.4675 7.47263C5.7575 7.18263 6.2375 7.18263 6.5275 7.47263C6.8175 7.76263 6.8175 8.24263 6.5275 8.53263ZM22.5275 11.4726L18.5275 7.47263C18.2375 7.18263 17.7575 7.18263 17.4675 7.47263C17.1775 7.76263 17.1775 8.24263 17.4675 8.53263L20.9375 12.0026L17.4675 15.4726C17.1775 15.7626 17.1775 16.2426 17.4675 16.5326C17.6175 16.6826 17.8075 16.7526 17.9975 16.7526C18.1875 16.7526 18.3775 16.6826 18.5275 16.5326L22.5275 12.5326C22.8175 12.2426 22.8175 11.7626 22.5275 11.4726ZM14.1775 3.27263C13.7775 3.17263 13.3675 3.41263 13.2675 3.82263L9.2675 19.8226C9.1675 20.2226 9.4075 20.6326 9.8175 20.7326C9.8775 20.7526 9.9375 20.7526 9.9975 20.7526C10.3375 20.7526 10.6375 20.5226 10.7275 20.1826L14.7275 4.18263C14.8275 3.78263 14.5875 3.37263 14.1775 3.27263Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-image-16x16.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/toolbox-image-16x16.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 1.25H3C2.04 1.25 1.25 2.04 1.25 3V13C1.25 13.96 2.04 14.75 3 14.75H13C13.96 14.75 14.75 13.96 14.75 13V3C14.75 2.04 13.96 1.25 13 1.25ZM13.25 13C13.25 13.14 13.14 13.25 13 13.25H3C2.86 13.25 2.75 13.14 2.75 13V3C2.75 2.86 2.86 2.75 3 2.75H13C13.14 2.75 13.25 2.86 13.25 3V13ZM10.5 6.75C11.19 6.75 11.75 6.19 11.75 5.5C11.75 4.81 11.19 4.25 10.5 4.25C9.81 4.25 9.25 4.81 9.25 5.5C9.25 6.19 9.81 6.75 10.5 6.75ZM10.5 5.25C10.64 5.25 10.75 5.36 10.75 5.5C10.75 5.78 10.25 5.78 10.25 5.5C10.25 5.36 10.36 5.25 10.5 5.25ZM12.53 10.47C12.82 10.76 12.82 11.24 12.53 11.53C12.38 11.68 12.19 11.75 12 11.75C11.81 11.75 11.62 11.68 11.47 11.53L10 10.06L9.53 10.53C9.24 10.82 8.76 10.82 8.47 10.53L7 9.06L4.53 11.53C4.24 11.82 3.76 11.82 3.47 11.53C3.18 11.24 3.18 10.76 3.47 10.47L6.47 7.47C6.76 7.18 7.24 7.18 7.53 7.47L9 8.94L9.47 8.47C9.76 8.18 10.24 8.18 10.53 8.47L12.53 10.47Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-image-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/toolbox-image-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 3.25H6C4.48 3.25 3.25 4.48 3.25 6V18C3.25 19.52 4.48 20.75 6 20.75H18C19.52 20.75 20.75 19.52 20.75 18V6C20.75 4.48 19.52 3.25 18 3.25ZM19.25 18C19.25 18.69 18.69 19.25 18 19.25H6C5.31 19.25 4.75 18.69 4.75 18V6C4.75 5.31 5.31 4.75 6 4.75H18C18.69 4.75 19.25 5.31 19.25 6V18ZM15.5 10.75C16.74 10.75 17.75 9.74 17.75 8.5C17.75 7.26 16.74 6.25 15.5 6.25C14.26 6.25 13.25 7.26 13.25 8.5C13.25 9.74 14.26 10.75 15.5 10.75ZM15.5 7.75C15.91 7.75 16.25 8.09 16.25 8.5C16.25 8.91 15.91 9.25 15.5 9.25C15.09 9.25 14.75 8.91 14.75 8.5C14.75 8.09 15.09 7.75 15.5 7.75ZM18.53 16.47C18.82 16.76 18.82 17.24 18.53 17.53C18.38 17.68 18.19 17.75 18 17.75C17.81 17.75 17.62 17.68 17.47 17.53L15 15.06L13.53 16.53C13.24 16.82 12.76 16.82 12.47 16.53L10 14.06L6.53 17.53C6.24 17.82 5.76 17.82 5.47 17.53C5.18 17.24 5.18 16.76 5.47 16.47L9.47 12.47C9.76 12.18 10.24 12.18 10.53 12.47L13 14.94L14.47 13.47C14.76 13.18 15.24 13.18 15.53 13.47L18.53 16.47Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-imagepicker-16x16.svg":
/*!*****************************************************!*\
  !*** ./src/images-v2/toolbox-imagepicker-16x16.svg ***!
  \*****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_22761_58206)\"><path d=\"M2.25 4V12C2.25 12.96 3.04 13.75 4 13.75H12C12.96 13.75 13.75 12.96 13.75 12V4C13.75 3.04 12.96 2.25 12 2.25H4C3.04 2.25 2.25 3.04 2.25 4ZM12.25 4V12C12.25 12.14 12.14 12.25 12 12.25H4C3.86 12.25 3.75 12.14 3.75 12V4C3.75 3.86 3.86 3.75 4 3.75H12C12.14 3.75 12.25 3.86 12.25 4ZM10.5 6.75C11.19 6.75 11.75 6.19 11.75 5.5C11.75 4.81 11.19 4.25 10.5 4.25C9.81 4.25 9.25 4.81 9.25 5.5C9.25 6.19 9.81 6.75 10.5 6.75ZM10.5 5.25C10.64 5.25 10.75 5.36 10.75 5.5C10.75 5.78 10.25 5.78 10.25 5.5C10.25 5.36 10.36 5.25 10.5 5.25ZM4.47 10.53C4.18 10.24 4.18 9.76 4.47 9.47L6.47 7.47C6.76 7.18 7.24 7.18 7.53 7.47L9 8.94L9.47 8.47C9.76 8.18 10.24 8.18 10.53 8.47L11.53 9.47C11.82 9.76 11.82 10.24 11.53 10.53C11.38 10.68 11.19 10.75 11 10.75C10.81 10.75 10.62 10.68 10.47 10.53L10 10.06L9.53 10.53C9.24 10.82 8.76 10.82 8.47 10.53L7 9.06L5.53 10.53C5.24 10.82 4.76 10.82 4.47 10.53ZM0.25 5V4C0.25 1.93 1.93 0.25 4 0.25H5C5.41 0.25 5.75 0.59 5.75 1C5.75 1.41 5.41 1.75 5 1.75H4C2.76 1.75 1.75 2.76 1.75 4V5C1.75 5.41 1.41 5.75 1 5.75C0.59 5.75 0.25 5.41 0.25 5ZM5.75 15C5.75 15.41 5.41 15.75 5 15.75H4C1.93 15.75 0.25 14.07 0.25 12V11C0.25 10.59 0.59 10.25 1 10.25C1.41 10.25 1.75 10.59 1.75 11V12C1.75 13.24 2.76 14.25 4 14.25H5C5.41 14.25 5.75 14.59 5.75 15ZM15.75 11V12C15.75 14.07 14.07 15.75 12 15.75H11C10.59 15.75 10.25 15.41 10.25 15C10.25 14.59 10.59 14.25 11 14.25H12C13.24 14.25 14.25 13.24 14.25 12V11C14.25 10.59 14.59 10.25 15 10.25C15.41 10.25 15.75 10.59 15.75 11ZM15.75 4V5C15.75 5.41 15.41 5.75 15 5.75C14.59 5.75 14.25 5.41 14.25 5V4C14.25 2.76 13.24 1.75 12 1.75H11C10.59 1.75 10.25 1.41 10.25 1C10.25 0.59 10.59 0.25 11 0.25H12C14.07 0.25 15.75 1.93 15.75 4Z\"></path></g><defs><clipPath id=\"clip0_22761_58206\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-imagepicker-24x24.svg":
/*!*****************************************************!*\
  !*** ./src/images-v2/toolbox-imagepicker-24x24.svg ***!
  \*****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.25 7V17C4.25 18.52 5.48 19.75 7 19.75H17C18.52 19.75 19.75 18.52 19.75 17V7C19.75 5.48 18.52 4.25 17 4.25H7C5.48 4.25 4.25 5.48 4.25 7ZM18.25 7V17C18.25 17.69 17.69 18.25 17 18.25H7C6.31 18.25 5.75 17.69 5.75 17V7C5.75 6.31 6.31 5.75 7 5.75H17C17.69 5.75 18.25 6.31 18.25 7ZM8.75 22C8.75 22.41 8.41 22.75 8 22.75H7C3.83 22.75 1.25 20.17 1.25 17V16C1.25 15.59 1.59 15.25 2 15.25C2.41 15.25 2.75 15.59 2.75 16V17C2.75 19.34 4.66 21.25 7 21.25H8C8.41 21.25 8.75 21.59 8.75 22ZM22.75 16V17C22.75 20.17 20.17 22.75 17 22.75H16C15.59 22.75 15.25 22.41 15.25 22C15.25 21.59 15.59 21.25 16 21.25H17C19.34 21.25 21.25 19.34 21.25 17V16C21.25 15.59 21.59 15.25 22 15.25C22.41 15.25 22.75 15.59 22.75 16ZM22.75 7V8C22.75 8.41 22.41 8.75 22 8.75C21.59 8.75 21.25 8.41 21.25 8V7C21.25 4.66 19.34 2.75 17 2.75H16C15.59 2.75 15.25 2.41 15.25 2C15.25 1.59 15.59 1.25 16 1.25H17C20.17 1.25 22.75 3.83 22.75 7ZM1.25 8V7C1.25 3.83 3.83 1.25 7 1.25H8C8.41 1.25 8.75 1.59 8.75 2C8.75 2.41 8.41 2.75 8 2.75H7C4.66 2.75 2.75 4.66 2.75 7V8C2.75 8.41 2.41 8.75 2 8.75C1.59 8.75 1.25 8.41 1.25 8ZM14.5 11.75C15.74 11.75 16.75 10.74 16.75 9.5C16.75 8.26 15.74 7.25 14.5 7.25C13.26 7.25 12.25 8.26 12.25 9.5C12.25 10.74 13.26 11.75 14.5 11.75ZM14.5 8.75C14.91 8.75 15.25 9.09 15.25 9.5C15.25 9.91 14.91 10.25 14.5 10.25C14.09 10.25 13.75 9.91 13.75 9.5C13.75 9.09 14.09 8.75 14.5 8.75ZM6.47 15.47L9.47 12.47C9.76 12.18 10.24 12.18 10.53 12.47L13 14.94L14.47 13.47C14.76 13.18 15.24 13.18 15.53 13.47L17.53 15.47C17.82 15.76 17.82 16.24 17.53 16.53C17.38 16.68 17.19 16.75 17 16.75C16.81 16.75 16.62 16.68 16.47 16.53L15 15.06L13.53 16.53C13.24 16.82 12.76 16.82 12.47 16.53L10 14.06L7.53 16.53C7.24 16.82 6.76 16.82 6.47 16.53C6.18 16.24 6.18 15.76 6.47 15.47Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-longtext-16x16.svg":
/*!**************************************************!*\
  !*** ./src/images-v2/toolbox-longtext-16x16.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 1.25H3C2.04 1.25 1.25 2.04 1.25 3V13C1.25 13.96 2.04 14.75 3 14.75H13C13.96 14.75 14.75 13.96 14.75 13V3C14.75 2.04 13.96 1.25 13 1.25ZM13.25 13C13.25 13.14 13.14 13.25 13 13.25H3C2.86 13.25 2.75 13.14 2.75 13V3C2.75 2.86 2.86 2.75 3 2.75H13C13.14 2.75 13.25 2.86 13.25 3V13ZM11.75 5C11.75 5.41 11.41 5.75 11 5.75H5C4.59 5.75 4.25 5.41 4.25 5C4.25 4.59 4.59 4.25 5 4.25H11C11.41 4.25 11.75 4.59 11.75 5ZM11.75 8C11.75 8.41 11.41 8.75 11 8.75H5C4.59 8.75 4.25 8.41 4.25 8C4.25 7.59 4.59 7.25 5 7.25H11C11.41 7.25 11.75 7.59 11.75 8ZM8.75 11C8.75 11.41 8.41 11.75 8 11.75H5C4.59 11.75 4.25 11.41 4.25 11C4.25 10.59 4.59 10.25 5 10.25H8C8.41 10.25 8.75 10.59 8.75 11Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-longtext-24x24.svg":
/*!**************************************************!*\
  !*** ./src/images-v2/toolbox-longtext-24x24.svg ***!
  \**************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 4.25H5C3.48 4.25 2.25 5.48 2.25 7V17C2.25 18.52 3.48 19.75 5 19.75H19C20.52 19.75 21.75 18.52 21.75 17V7C21.75 5.48 20.52 4.25 19 4.25ZM20.25 17C20.25 17.69 19.69 18.25 19 18.25H5C4.31 18.25 3.75 17.69 3.75 17V7C3.75 6.31 4.31 5.75 5 5.75H19C19.69 5.75 20.25 6.31 20.25 7V17ZM17.75 9C17.75 9.41 17.41 9.75 17 9.75H7C6.59 9.75 6.25 9.41 6.25 9C6.25 8.59 6.59 8.25 7 8.25H17C17.41 8.25 17.75 8.59 17.75 9ZM17.75 12C17.75 12.41 17.41 12.75 17 12.75H7C6.59 12.75 6.25 12.41 6.25 12C6.25 11.59 6.59 11.25 7 11.25H17C17.41 11.25 17.75 11.59 17.75 12ZM12.75 15C12.75 15.41 12.41 15.75 12 15.75H7C6.59 15.75 6.25 15.41 6.25 15C6.25 14.59 6.59 14.25 7 14.25H12C12.41 14.25 12.75 14.59 12.75 15Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-matrix-16x16.svg":
/*!************************************************!*\
  !*** ./src/images-v2/toolbox-matrix-16x16.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M11.5 7.75C13.29 7.75 14.75 6.29 14.75 4.5C14.75 2.71 13.29 1.25 11.5 1.25C9.71 1.25 8.25 2.71 8.25 4.5C8.25 6.29 9.71 7.75 11.5 7.75ZM11.5 2.75C12.46 2.75 13.25 3.54 13.25 4.5C13.25 5.46 12.46 6.25 11.5 6.25C10.54 6.25 9.75 5.46 9.75 4.5C9.75 3.54 10.54 2.75 11.5 2.75ZM11.5 5.75C12.19 5.75 12.75 5.19 12.75 4.5C12.75 3.81 12.19 3.25 11.5 3.25C10.81 3.25 10.25 3.81 10.25 4.5C10.25 5.19 10.81 5.75 11.5 5.75ZM11.5 4.25C11.64 4.25 11.75 4.36 11.75 4.5C11.75 4.78 11.25 4.78 11.25 4.5C11.25 4.36 11.36 4.25 11.5 4.25ZM4.5 1.25C2.71 1.25 1.25 2.71 1.25 4.5C1.25 6.29 2.71 7.75 4.5 7.75C6.29 7.75 7.75 6.29 7.75 4.5C7.75 2.71 6.29 1.25 4.5 1.25ZM4.5 6.25C3.54 6.25 2.75 5.46 2.75 4.5C2.75 3.54 3.54 2.75 4.5 2.75C5.46 2.75 6.25 3.54 6.25 4.5C6.25 5.46 5.46 6.25 4.5 6.25ZM4.5 8.25C2.71 8.25 1.25 9.71 1.25 11.5C1.25 13.29 2.71 14.75 4.5 14.75C6.29 14.75 7.75 13.29 7.75 11.5C7.75 9.71 6.29 8.25 4.5 8.25ZM4.5 13.25C3.54 13.25 2.75 12.46 2.75 11.5C2.75 10.54 3.54 9.75 4.5 9.75C5.46 9.75 6.25 10.54 6.25 11.5C6.25 12.46 5.46 13.25 4.5 13.25ZM4.5 10.25C3.81 10.25 3.25 10.81 3.25 11.5C3.25 12.19 3.81 12.75 4.5 12.75C5.19 12.75 5.75 12.19 5.75 11.5C5.75 10.81 5.19 10.25 4.5 10.25ZM4.25 11.5C4.25 11.36 4.36 11.25 4.5 11.25C4.64 11.25 4.75 11.36 4.75 11.5C4.75 11.78 4.25 11.78 4.25 11.5ZM11.5 8.25C9.71 8.25 8.25 9.71 8.25 11.5C8.25 13.29 9.71 14.75 11.5 14.75C13.29 14.75 14.75 13.29 14.75 11.5C14.75 9.71 13.29 8.25 11.5 8.25ZM11.5 13.25C10.54 13.25 9.75 12.46 9.75 11.5C9.75 10.54 10.54 9.75 11.5 9.75C12.46 9.75 13.25 10.54 13.25 11.5C13.25 12.46 12.46 13.25 11.5 13.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-matrix-24x24.svg":
/*!************************************************!*\
  !*** ./src/images-v2/toolbox-matrix-24x24.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6.5 2.25C4.16 2.25 2.25 4.16 2.25 6.5C2.25 8.84 4.16 10.75 6.5 10.75C8.84 10.75 10.75 8.84 10.75 6.5C10.75 4.16 8.84 2.25 6.5 2.25ZM6.5 9.25C4.98 9.25 3.75 8.02 3.75 6.5C3.75 4.98 4.98 3.75 6.5 3.75C8.02 3.75 9.25 4.98 9.25 6.5C9.25 8.02 8.02 9.25 6.5 9.25ZM17.5 10.75C19.84 10.75 21.75 8.84 21.75 6.5C21.75 4.16 19.84 2.25 17.5 2.25C15.16 2.25 13.25 4.16 13.25 6.5C13.25 8.84 15.16 10.75 17.5 10.75ZM17.5 3.75C19.02 3.75 20.25 4.98 20.25 6.5C20.25 8.02 19.02 9.25 17.5 9.25C15.98 9.25 14.75 8.02 14.75 6.5C14.75 4.98 15.98 3.75 17.5 3.75ZM6.5 13.25C4.16 13.25 2.25 15.16 2.25 17.5C2.25 19.84 4.16 21.75 6.5 21.75C8.84 21.75 10.75 19.84 10.75 17.5C10.75 15.16 8.84 13.25 6.5 13.25ZM6.5 20.25C4.98 20.25 3.75 19.02 3.75 17.5C3.75 15.98 4.98 14.75 6.5 14.75C8.02 14.75 9.25 15.98 9.25 17.5C9.25 19.02 8.02 20.25 6.5 20.25ZM17.5 13.25C15.16 13.25 13.25 15.16 13.25 17.5C13.25 19.84 15.16 21.75 17.5 21.75C19.84 21.75 21.75 19.84 21.75 17.5C21.75 15.16 19.84 13.25 17.5 13.25ZM17.5 20.25C15.98 20.25 14.75 19.02 14.75 17.5C14.75 15.98 15.98 14.75 17.5 14.75C19.02 14.75 20.25 15.98 20.25 17.5C20.25 19.02 19.02 20.25 17.5 20.25ZM16 6.5C16 5.67 16.67 5 17.5 5C18.33 5 19 5.67 19 6.5C19 7.33 18.33 8 17.5 8C16.67 8 16 7.33 16 6.5ZM8 17.5C8 18.33 7.33 19 6.5 19C5.67 19 5 18.33 5 17.5C5 16.67 5.67 16 6.5 16C7.33 16 8 16.67 8 17.5Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-multimatrix-16x16.svg":
/*!*****************************************************!*\
  !*** ./src/images-v2/toolbox-multimatrix-16x16.svg ***!
  \*****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 1.25H3C2.04 1.25 1.25 2.04 1.25 3V13C1.25 13.96 2.04 14.75 3 14.75H13C13.96 14.75 14.75 13.96 14.75 13V3C14.75 2.04 13.96 1.25 13 1.25ZM13.25 3V7.25H8.75V2.75H13C13.14 2.75 13.25 2.86 13.25 3ZM3 2.75H7.25V7.25H2.75V3C2.75 2.86 2.86 2.75 3 2.75ZM2.75 13V8.75H7.25V13.25H3C2.86 13.25 2.75 13.14 2.75 13ZM13 13.25H8.75V8.75H13.25V13C13.25 13.14 13.14 13.25 13 13.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-multimatrix-24x24.svg":
/*!*****************************************************!*\
  !*** ./src/images-v2/toolbox-multimatrix-24x24.svg ***!
  \*****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19 2.25H5C3.48 2.25 2.25 3.48 2.25 5V19C2.25 20.52 3.48 21.75 5 21.75H19C20.52 21.75 21.75 20.52 21.75 19V5C21.75 3.48 20.52 2.25 19 2.25ZM9.75 14.25V9.75H14.25V14.25H9.75ZM14.25 15.75V20.25H9.75V15.75H14.25ZM3.75 9.75H8.25V14.25H3.75V9.75ZM9.75 8.25V3.75H14.25V8.25H9.75ZM15.75 9.75H20.25V14.25H15.75V9.75ZM20.25 5V8.25H15.75V3.75H19C19.69 3.75 20.25 4.31 20.25 5ZM5 3.75H8.25V8.25H3.75V5C3.75 4.31 4.31 3.75 5 3.75ZM3.75 19V15.75H8.25V20.25H5C4.31 20.25 3.75 19.69 3.75 19ZM19 20.25H15.75V15.75H20.25V19C20.25 19.69 19.69 20.25 19 20.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-multipletext-16x16.svg":
/*!******************************************************!*\
  !*** ./src/images-v2/toolbox-multipletext-16x16.svg ***!
  \******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 2.25H3C2.04 2.25 1.25 3.04 1.25 4V6C1.25 6.96 2.04 7.75 3 7.75H13C13.96 7.75 14.75 6.96 14.75 6V4C14.75 3.04 13.96 2.25 13 2.25ZM13.25 6C13.25 6.14 13.14 6.25 13 6.25H3C2.86 6.25 2.75 6.14 2.75 6V4C2.75 3.86 2.86 3.75 3 3.75H13C13.14 3.75 13.25 3.86 13.25 4V6ZM8.75 5C8.75 5.41 8.41 5.75 8 5.75H5C4.59 5.75 4.25 5.41 4.25 5C4.25 4.59 4.59 4.25 5 4.25H8C8.41 4.25 8.75 4.59 8.75 5ZM13 8.25H3C2.04 8.25 1.25 9.04 1.25 10V12C1.25 12.96 2.04 13.75 3 13.75H13C13.96 13.75 14.75 12.96 14.75 12V10C14.75 9.04 13.96 8.25 13 8.25ZM13.25 12C13.25 12.14 13.14 12.25 13 12.25H3C2.86 12.25 2.75 12.14 2.75 12V10C2.75 9.86 2.86 9.75 3 9.75H13C13.14 9.75 13.25 9.86 13.25 10V12ZM10.75 11C10.75 11.41 10.41 11.75 10 11.75H5C4.59 11.75 4.25 11.41 4.25 11C4.25 10.59 4.59 10.25 5 10.25H10C10.41 10.25 10.75 10.59 10.75 11Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-multipletext-24x24.svg":
/*!******************************************************!*\
  !*** ./src/images-v2/toolbox-multipletext-24x24.svg ***!
  \******************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 3.25H6C4.48 3.25 3.25 4.48 3.25 6V8C3.25 9.52 4.48 10.75 6 10.75H18C19.52 10.75 20.75 9.52 20.75 8V6C20.75 4.48 19.52 3.25 18 3.25ZM19.25 8C19.25 8.69 18.69 9.25 18 9.25H6C5.31 9.25 4.75 8.69 4.75 8V6C4.75 5.31 5.31 4.75 6 4.75H18C18.69 4.75 19.25 5.31 19.25 6V8ZM18 13.25H6C4.48 13.25 3.25 14.48 3.25 16V18C3.25 19.52 4.48 20.75 6 20.75H18C19.52 20.75 20.75 19.52 20.75 18V16C20.75 14.48 19.52 13.25 18 13.25ZM19.25 18C19.25 18.69 18.69 19.25 18 19.25H6C5.31 19.25 4.75 18.69 4.75 18V16C4.75 15.31 5.31 14.75 6 14.75H18C18.69 14.75 19.25 15.31 19.25 16V18ZM12.75 7C12.75 7.41 12.41 7.75 12 7.75H7C6.59 7.75 6.25 7.41 6.25 7C6.25 6.59 6.59 6.25 7 6.25H12C12.41 6.25 12.75 6.59 12.75 7ZM15.75 17C15.75 17.41 15.41 17.75 15 17.75H7C6.59 17.75 6.25 17.41 6.25 17C6.25 16.59 6.59 16.25 7 16.25H15C15.41 16.25 15.75 16.59 15.75 17Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-panel-16x16.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/toolbox-panel-16x16.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 14.75H3C2.04 14.75 1.25 13.96 1.25 13V3C1.25 2.04 2.04 1.25 3 1.25H13C13.96 1.25 14.75 2.04 14.75 3V13C14.75 13.96 13.96 14.75 13 14.75ZM3 2.75C2.86 2.75 2.75 2.86 2.75 3V13C2.75 13.14 2.86 13.25 3 13.25H13C13.14 13.25 13.25 13.14 13.25 13V3C13.25 2.86 13.14 2.75 13 2.75H3Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-panel-24x24.svg":
/*!***********************************************!*\
  !*** ./src/images-v2/toolbox-panel-24x24.svg ***!
  \***********************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M18 20.75H6C4.48 20.75 3.25 19.52 3.25 18V6C3.25 4.48 4.48 3.25 6 3.25H18C19.52 3.25 20.75 4.48 20.75 6V18C20.75 19.52 19.52 20.75 18 20.75ZM6 4.75C5.31 4.75 4.75 5.31 4.75 6V18C4.75 18.69 5.31 19.25 6 19.25H18C18.69 19.25 19.25 18.69 19.25 18V6C19.25 5.31 18.69 4.75 18 4.75H6Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-radiogroup-16x16.svg":
/*!****************************************************!*\
  !*** ./src/images-v2/toolbox-radiogroup-16x16.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 1.25C4.28 1.25 1.25 4.28 1.25 8C1.25 11.72 4.28 14.75 8 14.75C11.72 14.75 14.75 11.72 14.75 8C14.75 4.28 11.72 1.25 8 1.25ZM8 13.25C5.11 13.25 2.75 10.89 2.75 8C2.75 5.11 5.11 2.75 8 2.75C10.89 2.75 13.25 5.11 13.25 8C13.25 10.89 10.89 13.25 8 13.25ZM8 5.25C6.48 5.25 5.25 6.48 5.25 8C5.25 9.52 6.48 10.75 8 10.75C9.52 10.75 10.75 9.52 10.75 8C10.75 6.48 9.52 5.25 8 5.25ZM8 9.25C7.31 9.25 6.75 8.69 6.75 8C6.75 7.31 7.31 6.75 8 6.75C8.69 6.75 9.25 7.31 9.25 8C9.25 8.69 8.69 9.25 8 9.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-radiogroup-24x24.svg":
/*!****************************************************!*\
  !*** ./src/images-v2/toolbox-radiogroup-24x24.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M12 21.75C6.62 21.75 2.25 17.38 2.25 12C2.25 6.62 6.62 2.25 12 2.25C17.38 2.25 21.75 6.62 21.75 12C21.75 17.38 17.38 21.75 12 21.75ZM12 3.75C7.45 3.75 3.75 7.45 3.75 12C3.75 16.55 7.45 20.25 12 20.25C16.55 20.25 20.25 16.55 20.25 12C20.25 7.45 16.55 3.75 12 3.75ZM12 14.75C10.48 14.75 9.25 13.52 9.25 12C9.25 10.48 10.48 9.25 12 9.25C13.52 9.25 14.75 10.48 14.75 12C14.75 13.52 13.52 14.75 12 14.75ZM12 10.75C11.31 10.75 10.75 11.31 10.75 12C10.75 12.69 11.31 13.25 12 13.25C12.69 13.25 13.25 12.69 13.25 12C13.25 11.31 12.69 10.75 12 10.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-ranking-16x16.svg":
/*!*************************************************!*\
  !*** ./src/images-v2/toolbox-ranking-16x16.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.75 2C14.75 2.41 14.41 2.75 14 2.75H2C1.59 2.75 1.25 2.41 1.25 2C1.25 1.59 1.59 1.25 2 1.25H14C14.41 1.25 14.75 1.59 14.75 2ZM12 4.25H2C1.59 4.25 1.25 4.59 1.25 5C1.25 5.41 1.59 5.75 2 5.75H12C12.41 5.75 12.75 5.41 12.75 5C12.75 4.59 12.41 4.25 12 4.25ZM10 7.25H2C1.59 7.25 1.25 7.59 1.25 8C1.25 8.41 1.59 8.75 2 8.75H10C10.41 8.75 10.75 8.41 10.75 8C10.75 7.59 10.41 7.25 10 7.25ZM8 10.25H2C1.59 10.25 1.25 10.59 1.25 11C1.25 11.41 1.59 11.75 2 11.75H8C8.41 11.75 8.75 11.41 8.75 11C8.75 10.59 8.41 10.25 8 10.25ZM6 13.25H2C1.59 13.25 1.25 13.59 1.25 14C1.25 14.41 1.59 14.75 2 14.75H6C6.41 14.75 6.75 14.41 6.75 14C6.75 13.59 6.41 13.25 6 13.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-ranking-24x24.svg":
/*!*************************************************!*\
  !*** ./src/images-v2/toolbox-ranking-24x24.svg ***!
  \*************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M8 20.75H4C3.59 20.75 3.25 20.41 3.25 20C3.25 19.59 3.59 19.25 4 19.25H8C8.41 19.25 8.75 19.59 8.75 20C8.75 20.41 8.41 20.75 8 20.75ZM11.75 16C11.75 15.59 11.41 15.25 11 15.25H4C3.59 15.25 3.25 15.59 3.25 16C3.25 16.41 3.59 16.75 4 16.75H11C11.41 16.75 11.75 16.41 11.75 16ZM14.75 12C14.75 11.59 14.41 11.25 14 11.25H4C3.59 11.25 3.25 11.59 3.25 12C3.25 12.41 3.59 12.75 4 12.75H14C14.41 12.75 14.75 12.41 14.75 12ZM17.75 8C17.75 7.59 17.41 7.25 17 7.25H4C3.59 7.25 3.25 7.59 3.25 8C3.25 8.41 3.59 8.75 4 8.75H17C17.41 8.75 17.75 8.41 17.75 8ZM20.75 4C20.75 3.59 20.41 3.25 20 3.25H4C3.59 3.25 3.25 3.59 3.25 4C3.25 4.41 3.59 4.75 4 4.75H20C20.41 4.75 20.75 4.41 20.75 4Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-rating-16x16.svg":
/*!************************************************!*\
  !*** ./src/images-v2/toolbox-rating-16x16.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><g clip-path=\"url(#clip0_22761_58146)\"><path d=\"M11.5406 15.23C11.2506 15.23 10.9506 15.15 10.6806 15L8.00057 13.49L5.32057 15C4.72057 15.34 3.99057 15.3 3.44057 14.89C2.88057 14.48 2.62057 13.81 2.75057 13.13L3.35057 10.08L1.06057 7.97C0.560569 7.5 0.370569 6.8 0.590569 6.15C0.800569 5.49 1.36057 5.04 2.05057 4.96L5.12057 4.59L6.41057 1.78C6.70057 1.15 7.31057 0.760002 8.00057 0.760002C8.69057 0.760002 9.30057 1.15 9.59057 1.78L10.8806 4.59L13.9506 4.96C14.6306 5.04 15.1906 5.5 15.4106 6.15C15.6206 6.81 15.4406 7.5 14.9406 7.97L12.6606 10.09L13.2606 13.14C13.3906 13.82 13.1306 14.49 12.5706 14.9C12.2606 15.12 11.9006 15.23 11.5506 15.23H11.5406ZM7.99057 11.88C8.12057 11.88 8.24057 11.91 8.36057 11.98L11.4106 13.7C11.5306 13.77 11.6306 13.72 11.6806 13.68C11.7306 13.64 11.8006 13.57 11.7806 13.43L11.1006 9.97C11.0506 9.72 11.1306 9.45 11.3206 9.28L13.9006 6.88C14.0006 6.79 13.9806 6.68 13.9706 6.62C13.9606 6.56 13.9006 6.47 13.7606 6.45L10.2806 6.03C10.0206 6 9.80057 5.84 9.69057 5.6L8.23057 2.41C8.17057 2.28 8.06057 2.26 8.00057 2.26C7.94057 2.26 7.83057 2.28 7.77057 2.41L6.31057 5.6C6.20057 5.84 5.98057 6 5.72057 6.03L2.24057 6.45C2.10057 6.47 2.05057 6.56 2.03057 6.62C2.01057 6.68 1.99057 6.79 2.10057 6.88L4.68057 9.28C4.87057 9.46 4.96057 9.72 4.90057 9.97L4.22057 13.43C4.19057 13.57 4.27057 13.64 4.32057 13.68C4.37057 13.72 4.47057 13.76 4.59057 13.7L7.64057 11.98C7.75057 11.92 7.88057 11.88 8.01057 11.88H7.99057Z\"></path></g><defs><clipPath id=\"clip0_22761_58146\"><rect width=\"16\" height=\"16\" fill=\"white\"></rect></clipPath></defs></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-rating-24x24.svg":
/*!************************************************!*\
  !*** ./src/images-v2/toolbox-rating-24x24.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M17.2532 21.7227C16.9432 21.7227 16.6332 21.6427 16.3432 21.4827L12.0032 19.0327L7.66319 21.4827C7.02319 21.8427 6.26319 21.8027 5.66319 21.3727C5.07319 20.9427 4.79319 20.2327 4.93319 19.5127L5.90319 14.5827L2.23319 11.1627C1.70319 10.6627 1.50319 9.9227 1.73319 9.2327C1.96319 8.5427 2.55319 8.0527 3.27319 7.9627L8.23319 7.3727L10.3232 2.8227C10.6332 2.1527 11.2732 1.7427 12.0032 1.7427C12.7332 1.7427 13.3832 2.1527 13.6832 2.8227L15.7732 7.3727L20.7332 7.9627C21.4532 8.0527 22.0532 8.5327 22.2732 9.2327C22.5032 9.9227 22.3132 10.6627 21.7732 11.1627L18.1032 14.5827L19.0732 19.5127C19.2132 20.2327 18.9332 20.9427 18.3432 21.3727C18.0132 21.6127 17.6332 21.7327 17.2632 21.7327L17.2532 21.7227ZM11.9932 17.4227C12.1232 17.4227 12.2432 17.4527 12.3632 17.5227L17.0732 20.1727C17.2532 20.2727 17.4032 20.1927 17.4532 20.1527C17.5032 20.1127 17.6332 20.0027 17.5932 19.8027L16.5432 14.4627C16.4932 14.2127 16.5732 13.9427 16.7632 13.7727L20.7432 10.0727C20.8932 9.9327 20.8632 9.7727 20.8332 9.7027C20.8132 9.6427 20.7432 9.4827 20.5432 9.4627L15.1732 8.8227C14.9132 8.7927 14.6932 8.6327 14.5832 8.3927L12.3232 3.4627C12.2432 3.2727 12.0732 3.2527 12.0032 3.2527C11.9332 3.2527 11.7632 3.2727 11.6832 3.4627L9.42319 8.3927C9.31319 8.6327 9.09319 8.7927 8.83319 8.8227L3.46319 9.4627C3.26319 9.4827 3.19319 9.6427 3.17319 9.7027C3.15319 9.7627 3.12319 9.9327 3.26319 10.0727L7.24319 13.7727C7.43319 13.9527 7.52319 14.2127 7.46319 14.4627L6.41319 19.8027C6.37319 20.0027 6.49319 20.1127 6.55319 20.1527C6.61319 20.1927 6.75319 20.2727 6.93319 20.1727L11.6432 17.5227C11.7532 17.4627 11.8832 17.4227 12.0132 17.4227H11.9932Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-signature-16x16.svg":
/*!***************************************************!*\
  !*** ./src/images-v2/toolbox-signature-16x16.svg ***!
  \***************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M14.52 7.47L8.52 1.47C7.68 0.629996 6.3 0.629996 5.46 1.47C4.8 2.13 4.66 3.1 5.03 3.9L3.4 5.53C2.68 6.25 2.2 7.21 2.06 8.22L1.25 13.9C1.25 13.9 1.25 13.93 1.25 13.95C1.25 14.03 1.25 14.1 1.27 14.18C1.27 14.21 1.27 14.24 1.29 14.27C1.33 14.37 1.38 14.47 1.46 14.55C1.53 14.62 1.61 14.68 1.71 14.71C1.8 14.75 1.9 14.77 1.99 14.77C2.03 14.77 2.06 14.77 2.1 14.77L7.78 13.96C8.79 13.82 9.75 13.34 10.47 12.62L12.1 10.99C12.39 11.12 12.69 11.19 13 11.19C13.55 11.19 14.11 10.98 14.53 10.56C15.37 9.72 15.37 8.34 14.53 7.5L14.52 7.47ZM9.4 11.53C8.91 12.02 8.25 12.35 7.56 12.45L4.11 12.94L5.52 11.53C5.52 11.53 5.52 11.53 5.52 11.52C5.82 11.66 6.14 11.75 6.49 11.75C7.73 11.75 8.74 10.74 8.74 9.5C8.74 8.26 7.73 7.25 6.49 7.25C5.25 7.25 4.24 8.26 4.24 9.5C4.24 9.84 4.32 10.17 4.46 10.46C4.46 10.46 4.46 10.46 4.45 10.46L3.04 11.87L3.53 8.42C3.63 7.73 3.95 7.08 4.45 6.58L5.98 5.05L10.92 9.99L9.39 11.52L9.4 11.53ZM5.75 9.5C5.75 9.09 6.09 8.75 6.5 8.75C6.91 8.75 7.25 9.09 7.25 9.5C7.25 9.91 6.91 10.25 6.5 10.25C6.09 10.25 5.75 9.91 5.75 9.5ZM13.46 9.47C13.21 9.72 12.77 9.72 12.52 9.47L6.52 3.47C6.39 3.34 6.33 3.18 6.33 3C6.33 2.82 6.4 2.66 6.52 2.53C6.64 2.4 6.81 2.34 6.99 2.34C7.17 2.34 7.33 2.41 7.46 2.53L13.46 8.53C13.59 8.66 13.65 8.82 13.65 9C13.65 9.18 13.58 9.34 13.46 9.47Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-signature-24x24.svg":
/*!***************************************************!*\
  !*** ./src/images-v2/toolbox-signature-24x24.svg ***!
  \***************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M16.035 16.03L18.105 13.96C18.395 14.09 18.695 14.16 19.005 14.16C19.555 14.16 20.115 13.95 20.535 13.53C21.375 12.69 21.375 11.31 20.535 10.47L12.535 2.47C11.695 1.63 10.315 1.63 9.47501 2.47C8.81501 3.13 8.67501 4.1 9.04501 4.9L6.97501 6.97C5.89501 8.04 5.12501 9.39 4.72501 10.85L2.27501 19.81C2.27501 19.81 2.27501 19.85 2.27501 19.87C2.25501 19.96 2.25501 20.05 2.27501 20.14C2.27501 20.17 2.27501 20.2 2.29501 20.23C2.33501 20.34 2.38501 20.45 2.47501 20.54C2.54501 20.61 2.63501 20.67 2.72501 20.7C2.81501 20.74 2.91501 20.76 3.00501 20.76C3.07501 20.76 3.13501 20.76 3.20501 20.73L12.155 18.29C13.625 17.89 14.965 17.11 16.035 16.04V16.03ZM10.535 3.53C10.665 3.4 10.825 3.34 11.005 3.34C11.185 3.34 11.345 3.41 11.475 3.53L19.475 11.53C19.605 11.66 19.665 11.82 19.665 12C19.665 12.18 19.595 12.34 19.475 12.47C19.225 12.72 18.785 12.72 18.535 12.47L10.535 4.47C10.405 4.34 10.345 4.18 10.345 4C10.345 3.82 10.415 3.66 10.535 3.53ZM5.52501 18.54L8.52501 15.54C8.52501 15.54 8.59501 15.44 8.62501 15.38C9.02501 15.61 9.49501 15.76 9.99501 15.76C11.515 15.76 12.745 14.53 12.745 13.01C12.745 11.49 11.515 10.26 9.99501 10.26C8.47501 10.26 7.24501 11.49 7.24501 13.01C7.24501 13.51 7.38501 13.97 7.62501 14.38C7.57501 14.41 7.51501 14.44 7.46501 14.48L4.46501 17.48L6.16501 11.25C6.49501 10.04 7.14501 8.92 8.03501 8.03L10.005 6.06L16.945 13L14.975 14.97C14.085 15.86 12.975 16.51 11.755 16.84L5.52501 18.54ZM8.75501 13C8.75501 12.31 9.31501 11.75 10.005 11.75C10.695 11.75 11.255 12.31 11.255 13C11.255 13.69 10.695 14.25 10.005 14.25C9.31501 14.25 8.75501 13.69 8.75501 13ZM21.275 21.83C19.815 22.4 18.835 22.76 18.135 22.76C17.765 22.76 17.485 22.66 17.255 22.44C16.875 22.07 16.815 21.61 16.975 20.88C15.475 22.07 14.735 22.28 14.145 22.17C13.545 22.06 13.275 21.6 13.125 21.31C12.945 21.42 12.625 21.66 12.105 22.14C11.805 22.42 11.325 22.41 11.045 22.1C10.765 21.8 10.775 21.32 11.085 21.04C12.235 19.97 12.885 19.61 13.505 19.73C14.085 19.84 14.315 20.32 14.445 20.58C14.455 20.61 14.475 20.65 14.495 20.68C14.765 20.61 15.615 20.22 17.965 18.04C18.215 17.81 18.595 17.77 18.885 17.96C19.175 18.15 19.295 18.5 19.195 18.83L19.035 19.3C18.785 20.04 18.535 20.8 18.445 21.24C19.025 21.11 20.155 20.68 20.755 20.45C21.145 20.3 21.575 20.49 21.725 20.88C21.875 21.27 21.685 21.7 21.295 21.85L21.275 21.83Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-singleline-16x16.svg":
/*!****************************************************!*\
  !*** ./src/images-v2/toolbox-singleline-16x16.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.75 14C10.75 14.41 10.41 14.75 10 14.75H9C8.21 14.75 7.5 14.41 7 13.88C6.5 14.42 5.79 14.75 5 14.75H4C3.59 14.75 3.25 14.41 3.25 14C3.25 13.59 3.59 13.25 4 13.25H5C5.69 13.25 6.25 12.69 6.25 12V4C6.25 3.31 5.69 2.75 5 2.75H4C3.59 2.75 3.25 2.41 3.25 2C3.25 1.59 3.59 1.25 4 1.25H5C5.79 1.25 6.5 1.59 7 2.12C7.5 1.58 8.21 1.25 9 1.25H10C10.41 1.25 10.75 1.59 10.75 2C10.75 2.41 10.41 2.75 10 2.75H9C8.31 2.75 7.75 3.31 7.75 4V12C7.75 12.69 8.31 13.25 9 13.25H10C10.41 13.25 10.75 13.59 10.75 14ZM4.75 11C4.75 10.59 4.41 10.25 4 10.25H3C2.86 10.25 2.75 10.14 2.75 10V6C2.75 5.86 2.86 5.75 3 5.75H4C4.41 5.75 4.75 5.41 4.75 5C4.75 4.59 4.41 4.25 4 4.25H3C2.04 4.25 1.25 5.04 1.25 6V10C1.25 10.96 2.04 11.75 3 11.75H4C4.41 11.75 4.75 11.41 4.75 11ZM13 4.25H10C9.59 4.25 9.25 4.59 9.25 5C9.25 5.41 9.59 5.75 10 5.75H13C13.14 5.75 13.25 5.86 13.25 6V10C13.25 10.14 13.14 10.25 13 10.25H10C9.59 10.25 9.25 10.59 9.25 11C9.25 11.41 9.59 11.75 10 11.75H13C13.96 11.75 14.75 10.96 14.75 10V6C14.75 5.04 13.96 4.25 13 4.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-singleline-24x24.svg":
/*!****************************************************!*\
  !*** ./src/images-v2/toolbox-singleline-24x24.svg ***!
  \****************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M20.75 10V14C20.75 15.52 19.52 16.75 18 16.75H13C12.59 16.75 12.25 16.41 12.25 16C12.25 15.59 12.59 15.25 13 15.25H18C18.69 15.25 19.25 14.69 19.25 14V10C19.25 9.31 18.69 8.75 18 8.75H13C12.59 8.75 12.25 8.41 12.25 8C12.25 7.59 12.59 7.25 13 7.25H18C19.52 7.25 20.75 8.48 20.75 10ZM7.75 16C7.75 15.59 7.41 15.25 7 15.25H6C5.31 15.25 4.75 14.69 4.75 14V10C4.75 9.31 5.31 8.75 6 8.75H7C7.41 8.75 7.75 8.41 7.75 8C7.75 7.59 7.41 7.25 7 7.25H6C4.48 7.25 3.25 8.48 3.25 10V14C3.25 15.52 4.48 16.75 6 16.75H7C7.41 16.75 7.75 16.41 7.75 16ZM13 19.25H12C11.31 19.25 10.75 18.69 10.75 18V6C10.75 5.31 11.31 4.75 12 4.75H13C13.41 4.75 13.75 4.41 13.75 4C13.75 3.59 13.41 3.25 13 3.25H12C11.21 3.25 10.5 3.59 10 4.12C9.5 3.58 8.79 3.25 8 3.25H7C6.59 3.25 6.25 3.59 6.25 4C6.25 4.41 6.59 4.75 7 4.75H8C8.69 4.75 9.25 5.31 9.25 6V18C9.25 18.69 8.69 19.25 8 19.25H7C6.59 19.25 6.25 19.59 6.25 20C6.25 20.41 6.59 20.75 7 20.75H8C8.79 20.75 9.5 20.41 10 19.88C10.5 20.42 11.21 20.75 12 20.75H13C13.41 20.75 13.75 20.41 13.75 20C13.75 19.59 13.41 19.25 13 19.25Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-tagbox-16x16.svg":
/*!************************************************!*\
  !*** ./src/images-v2/toolbox-tagbox-16x16.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 16 16\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M13 1.25H3C2.04 1.25 1.25 2.04 1.25 3V13C1.25 13.96 2.04 14.75 3 14.75H13C13.96 14.75 14.75 13.96 14.75 13V3C14.75 2.04 13.96 1.25 13 1.25ZM2.75 3C2.75 2.86 2.86 2.75 3 2.75H13C13.14 2.75 13.25 2.86 13.25 3V5.25H2.75V3ZM13.25 13C13.25 13.14 13.14 13.25 13 13.25H3C2.86 13.25 2.75 13.14 2.75 13V6.75H13.25V13ZM7.25 9C7.25 8.59 7.59 8.25 8 8.25H11C11.41 8.25 11.75 8.59 11.75 9C11.75 9.41 11.41 9.75 11 9.75H8C7.59 9.75 7.25 9.41 7.25 9ZM7.25 11C7.25 10.59 7.59 10.25 8 10.25H11C11.41 10.25 11.75 10.59 11.75 11C11.75 11.41 11.41 11.75 11 11.75H8C7.59 11.75 7.25 11.41 7.25 11ZM4.47 9.53C4.33 9.39 4.25 9.2 4.25 9C4.25 8.9 4.27 8.81 4.31 8.71C4.35 8.62 4.4 8.54 4.47 8.47C4.68 8.26 5.01 8.19 5.29 8.31C5.38 8.35 5.46 8.4 5.53 8.47C5.6 8.54 5.66 8.62 5.69 8.71C5.73 8.81 5.75 8.9 5.75 9C5.75 9.2 5.67 9.39 5.53 9.53C5.46 9.6 5.38 9.65 5.29 9.69C5.2 9.73 5.1 9.75 5 9.75C4.8 9.75 4.61 9.67 4.47 9.53ZM4.31 11.29C4.27 11.2 4.25 11.1 4.25 11C4.25 10.9 4.27 10.81 4.31 10.71C4.35 10.62 4.4 10.54 4.47 10.47C4.68 10.26 5.01 10.19 5.29 10.31C5.38 10.35 5.46 10.4 5.53 10.47C5.6 10.54 5.66 10.62 5.69 10.71C5.73 10.81 5.75 10.9 5.75 11C5.75 11.1 5.73 11.2 5.69 11.29C5.66 11.38 5.6 11.46 5.53 11.53C5.46 11.6 5.38 11.65 5.29 11.69C5.2 11.73 5.1 11.75 5 11.75C4.8 11.75 4.61 11.67 4.47 11.53C4.4 11.46 4.35 11.38 4.31 11.29ZM12.75 4C12.75 4.41 12.41 4.75 12 4.75H11C10.59 4.75 10.25 4.41 10.25 4C10.25 3.59 10.59 3.25 11 3.25H12C12.41 3.25 12.75 3.59 12.75 4Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/toolbox-tagbox-24x24.svg":
/*!************************************************!*\
  !*** ./src/images-v2/toolbox-tagbox-24x24.svg ***!
  \************************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M10.25 12C10.25 11.59 10.59 11.25 11 11.25H17C17.41 11.25 17.75 11.59 17.75 12C17.75 12.41 17.41 12.75 17 12.75H11C10.59 12.75 10.25 12.41 10.25 12ZM11 15.75H17C17.41 15.75 17.75 15.41 17.75 15C17.75 14.59 17.41 14.25 17 14.25H11C10.59 14.25 10.25 14.59 10.25 15C10.25 15.41 10.59 15.75 11 15.75ZM17 5.25H16C15.59 5.25 15.25 5.59 15.25 6C15.25 6.41 15.59 6.75 16 6.75H17C17.41 6.75 17.75 6.41 17.75 6C17.75 5.59 17.41 5.25 17 5.25ZM20.75 5V19C20.75 20.52 19.52 21.75 18 21.75H6C4.48 21.75 3.25 20.52 3.25 19V5C3.25 3.48 4.48 2.25 6 2.25H18C19.52 2.25 20.75 3.48 20.75 5ZM4.75 8.25H19.25V5C19.25 4.31 18.69 3.75 18 3.75H6C5.31 3.75 4.75 4.31 4.75 5V8.25ZM19.25 9.75H4.75V19C4.75 19.69 5.31 20.25 6 20.25H18C18.69 20.25 19.25 19.69 19.25 19V9.75ZM11 18.75H17C17.41 18.75 17.75 18.41 17.75 18C17.75 17.59 17.41 17.25 17 17.25H11C10.59 17.25 10.25 17.59 10.25 18C10.25 18.41 10.59 18.75 11 18.75ZM7 18.75H8C8.41 18.75 8.75 18.41 8.75 18C8.75 17.59 8.41 17.25 8 17.25H7C6.59 17.25 6.25 17.59 6.25 18C6.25 18.41 6.59 18.75 7 18.75ZM7 15.75H8C8.41 15.75 8.75 15.41 8.75 15C8.75 14.59 8.41 14.25 8 14.25H7C6.59 14.25 6.25 14.59 6.25 15C6.25 15.41 6.59 15.75 7 15.75ZM7 12.75H8C8.41 12.75 8.75 12.41 8.75 12C8.75 11.59 8.41 11.25 8 11.25H7C6.59 11.25 6.25 11.59 6.25 12C6.25 12.41 6.59 12.75 7 12.75Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/undo-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/undo-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M19.79 18.2825C19.67 18.5725 19.39 18.7525 19.09 18.7525C19 18.7525 18.9 18.7325 18.81 18.7025C18.43 18.5425 18.24 18.1125 18.39 17.7225C19.28 15.5125 19.92 12.4925 17.94 10.6525C15.56 8.45247 10.26 8.64247 4.73001 11.0225L9.36001 13.3225C9.73001 13.5025 9.88001 13.9525 9.70001 14.3325C9.57001 14.5925 9.30001 14.7525 9.03001 14.7525C8.92001 14.7525 8.80001 14.7225 8.70001 14.6725L2.67001 11.6725C2.67001 11.6725 2.63001 11.6325 2.60001 11.6225C2.56001 11.5925 2.51001 11.5625 2.48001 11.5225C2.44001 11.4925 2.42001 11.4525 2.39001 11.4025C2.37001 11.3725 2.35001 11.3525 2.33001 11.3225C2.33001 11.3025 2.33001 11.2925 2.32001 11.2725C2.32001 11.2525 2.30001 11.2425 2.29001 11.2225C2.28001 11.1925 2.29001 11.1525 2.28001 11.1225C2.28001 11.0725 2.26001 11.0225 2.26001 10.9725C2.26001 10.9225 2.26001 10.8825 2.28001 10.8425C2.28001 10.7925 2.30001 10.7425 2.32001 10.6925C2.32001 10.6725 2.32001 10.6625 2.33001 10.6425L5.35001 4.66247C5.54001 4.29247 5.99001 4.14247 6.36001 4.33247C6.73001 4.52247 6.88001 4.97247 6.69001 5.34247L4.62001 9.45247C10.58 6.99247 16.18 6.98247 18.96 9.55247C20.4 10.8825 21.72 13.4825 19.79 18.2825Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/visible-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/visible-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M23.3513 12.66C23.2413 12.72 23.1213 12.75 23.0013 12.75C22.7313 12.75 22.4713 12.6 22.3313 12.35C20.1913 8.28 16.2313 5.75 11.9913 5.75C7.75126 5.75 3.80126 8.28 1.66126 12.35C1.47126 12.72 1.02126 12.86 0.651255 12.66C0.281255 12.47 0.141255 12.01 0.341255 11.65C2.74126 7.09 7.21126 4.25 12.0013 4.25C16.7913 4.25 21.2613 7.09 23.6613 11.65C23.8513 12.02 23.7113 12.47 23.3513 12.66ZM12.0013 16.75C9.38126 16.75 7.25126 14.62 7.25126 12C7.25126 9.38 9.38126 7.25 12.0013 7.25C14.6213 7.25 16.7513 9.38 16.7513 12C16.7513 14.62 14.6213 16.75 12.0013 16.75ZM12.0013 15.25C13.7913 15.25 15.2513 13.79 15.2513 12C15.2513 10.21 13.7913 8.75 12.0013 8.75C10.2113 8.75 8.75126 10.21 8.75126 12C8.75126 13.79 10.2113 15.25 12.0013 15.25ZM13.0013 12C13.0013 11.45 12.5513 11 12.0013 11C11.4513 11 11.0013 11.45 11.0013 12C11.0013 12.55 11.4513 13 12.0013 13C12.5513 13 13.0013 12.55 13.0013 12ZM19.4013 14.55C17.6313 16.9 14.9313 18.25 12.0013 18.25C9.07125 18.25 6.37125 16.9 4.60125 14.55C4.35125 14.22 3.88125 14.15 3.55125 14.4C3.22126 14.65 3.15126 15.12 3.40126 15.45C5.46126 18.18 8.59126 19.75 12.0013 19.75C15.4113 19.75 18.5413 18.18 20.6013 15.45C20.8513 15.12 20.7813 14.65 20.4513 14.4C20.1213 14.15 19.6513 14.21 19.4013 14.55Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/wand-24x24.svg":
/*!**************************************!*\
  !*** ./src/images-v2/wand-24x24.svg ***!
  \**************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M2.9975 21.75C2.8075 21.75 2.6175 21.68 2.4675 21.53C2.1775 21.24 2.1775 20.76 2.4675 20.47L10.4675 12.47C10.7575 12.18 11.2375 12.18 11.5275 12.47C11.8175 12.76 11.8175 13.24 11.5275 13.53L3.5275 21.53C3.3775 21.68 3.1875 21.75 2.9975 21.75ZM14.7475 6V3C14.7475 2.59 14.4075 2.25 13.9975 2.25C13.5875 2.25 13.2475 2.59 13.2475 3V6C13.2475 6.41 13.5875 6.75 13.9975 6.75C14.4075 6.75 14.7475 6.41 14.7475 6ZM14.7475 19V14C14.7475 13.59 14.4075 13.25 13.9975 13.25C13.5875 13.25 13.2475 13.59 13.2475 14V19C13.2475 19.41 13.5875 19.75 13.9975 19.75C14.4075 19.75 14.7475 19.41 14.7475 19ZM10.7475 10C10.7475 9.59 10.4075 9.25 9.9975 9.25H6.9975C6.5875 9.25 6.2475 9.59 6.2475 10C6.2475 10.41 6.5875 10.75 6.9975 10.75H9.9975C10.4075 10.75 10.7475 10.41 10.7475 10ZM22.7475 10C22.7475 9.59 22.4075 9.25 21.9975 9.25H17.9975C17.5875 9.25 17.2475 9.59 17.2475 10C17.2475 10.41 17.5875 10.75 17.9975 10.75H21.9975C22.4075 10.75 22.7475 10.41 22.7475 10ZM17.5275 7.53L19.4775 5.58C19.7675 5.29 19.7675 4.81 19.4775 4.52C19.1875 4.23 18.7075 4.23 18.4175 4.52L16.4675 6.47C16.1775 6.76 16.1775 7.24 16.4675 7.53C16.6175 7.68 16.8075 7.75 16.9975 7.75C17.1875 7.75 17.3775 7.68 17.5275 7.53ZM19.4775 15.48C19.7675 15.19 19.7675 14.71 19.4775 14.42L17.5275 12.47C17.2375 12.18 16.7575 12.18 16.4675 12.47C16.1775 12.76 16.1775 13.24 16.4675 13.53L18.4175 15.48C18.5675 15.63 18.7575 15.7 18.9475 15.7C19.1375 15.7 19.3275 15.63 19.4775 15.48ZM11.5275 7.53C11.8175 7.24 11.8175 6.76 11.5275 6.47L8.5275 3.47C8.2375 3.18 7.7575 3.18 7.4675 3.47C7.1775 3.76 7.1775 4.24 7.4675 4.53L10.4675 7.53C10.6175 7.68 10.8075 7.75 10.9975 7.75C11.1875 7.75 11.3775 7.68 11.5275 7.53Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/warning-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/warning-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M21.7818 16.57L14.3518 4.40997C13.8518 3.58997 12.9718 3.08997 12.0018 3.08997C11.0318 3.08997 10.1618 3.57997 9.65175 4.40997L2.22175 16.57C1.69175 17.43 1.67175 18.47 2.17175 19.35C2.66175 20.23 3.56175 20.75 4.57175 20.75H19.4418C20.4518 20.75 21.3518 20.22 21.8418 19.35C22.3318 18.47 22.3118 17.43 21.7918 16.57H21.7818ZM20.5218 18.62C20.3018 19.02 19.8918 19.26 19.4318 19.26H4.57175C4.11175 19.26 3.70175 19.02 3.48175 18.62C3.26175 18.22 3.27175 17.75 3.50175 17.36L10.9318 5.18997C11.1618 4.80997 11.5518 4.58997 12.0018 4.58997C12.4518 4.58997 12.8318 4.80997 13.0718 5.18997L20.5018 17.35C20.7418 17.74 20.7518 18.21 20.5218 18.61V18.62ZM11.2518 12V8.99997C11.2518 8.58997 11.5918 8.24997 12.0018 8.24997C12.4118 8.24997 12.7518 8.58997 12.7518 8.99997V12C12.7518 12.41 12.4118 12.75 12.0018 12.75C11.5918 12.75 11.2518 12.41 11.2518 12ZM13.0018 16C13.0018 16.55 12.5518 17 12.0018 17C11.4518 17 11.0018 16.55 11.0018 16C11.0018 15.45 11.4518 15 12.0018 15C12.5518 15 13.0018 15.45 13.0018 16Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/wrench-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/wrench-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M4.99752 21.8701C4.99752 21.8701 4.89752 21.8701 4.85752 21.8701C4.04752 21.8301 3.28752 21.4501 2.77752 20.8101C1.85752 19.6901 1.97752 17.9601 3.05752 16.8801L7.76752 12.1701C7.24752 10.8701 7.11752 9.4601 7.38752 8.0701C7.94752 5.2301 10.2375 2.9501 13.0775 2.3901C14.0075 2.2101 14.9475 2.2001 15.8675 2.3801C16.4875 2.5001 16.9875 2.9501 17.1775 3.5601C17.3675 4.1901 17.2075 4.8701 16.7375 5.3301L14.1275 7.9401C13.5875 8.4801 13.5075 9.3201 13.9475 9.8601C14.1975 10.1701 14.5575 10.3501 14.9475 10.3701C15.3475 10.3901 15.7175 10.2401 15.9875 9.9701L18.6875 7.2701C19.1475 6.8101 19.8275 6.6401 20.4575 6.8301C21.0675 7.0201 21.5175 7.5201 21.6375 8.1401C21.8175 9.0601 21.8075 9.9901 21.6275 10.9301C21.0675 13.7701 18.7875 16.0501 15.9475 16.6101C14.5475 16.8901 13.1475 16.7501 11.8475 16.2301L7.04752 21.0301C6.50752 21.5701 5.77752 21.8701 5.01752 21.8701H4.99752ZM14.4975 3.7501C14.1175 3.7501 13.7375 3.7901 13.3575 3.8601C11.1075 4.3001 9.29752 6.1101 8.85752 8.3601C8.60752 9.6101 8.77752 10.8701 9.32752 12.0101C9.46752 12.3001 9.40752 12.6401 9.18752 12.8701L4.11752 17.9401C3.57752 18.4801 3.49752 19.3201 3.93752 19.8601C4.18752 20.1701 4.54752 20.3501 4.93752 20.3701C5.34752 20.3901 5.70752 20.2401 5.97752 19.9701L11.1375 14.8101C11.3675 14.5801 11.7075 14.5201 11.9975 14.6701C13.1375 15.2201 14.3975 15.3901 15.6475 15.1401C17.8975 14.7001 19.7075 12.8901 20.1475 10.6401C20.2975 9.9001 20.2975 9.1501 20.1575 8.4301C20.1375 8.3501 20.0875 8.3001 20.0075 8.2701C19.9675 8.2601 19.8475 8.2301 19.7375 8.3301L17.0375 11.0301C16.4675 11.6001 15.6475 11.9001 14.8675 11.8701C14.0575 11.8301 13.2975 11.4501 12.7875 10.8101C11.8675 9.6901 11.9875 7.9601 13.0675 6.8801L15.6775 4.2701C15.7775 4.1701 15.7475 4.0401 15.7375 4.0001C15.7075 3.9201 15.6575 3.8701 15.5775 3.8501C15.2275 3.7801 14.8675 3.7501 14.5075 3.7501H14.4975Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/zoomin-24x24.svg":
/*!****************************************!*\
  !*** ./src/images-v2/zoomin-24x24.svg ***!
  \****************************************/
/***/ ((module) => {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M21.53 20.47L15.98 14.92C17.08 13.58 17.75 11.87 17.75 10C17.75 5.73 14.27 2.25 10 2.25C5.73 2.25 2.25 5.73 2.25 10C2.25 14.27 5.73 17.75 10 17.75C11.87 17.75 13.58 17.09 14.92 15.98L20.47 21.53C20.62 21.68 20.81 21.75 21 21.75C21.19 21.75 21.38 21.68 21.53 21.53C21.82 21.24 21.82 20.76 21.53 20.47ZM3.75 10C3.75 6.55 6.55 3.75 10 3.75C13.45 3.75 16.25 6.55 16.25 10C16.25 13.45 13.45 16.25 10 16.25C6.55 16.25 3.75 13.45 3.75 10ZM13.75 10C13.75 10.41 13.41 10.75 13 10.75H10.75V13C10.75 13.41 10.41 13.75 10 13.75C9.59 13.75 9.25 13.41 9.25 13V10.75H7C6.59 10.75 6.25 10.41 6.25 10C6.25 9.59 6.59 9.25 7 9.25H9.25V7C9.25 6.59 9.59 6.25 10 6.25C10.41 6.25 10.75 6.59 10.75 7V9.25H13C13.41 9.25 13.75 9.59 13.75 10Z\"></path></svg>"

/***/ }),

/***/ "./src/images-v2/zoomout-24x24.svg":
/*!*****************************************!*\
  !*** ./src/images-v2/zoomout-24x24.svg ***!
  \*****************************************/
/***/ ((module) => {

module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M21.53 20.47L15.98 14.92C17.08 13.58 17.75 11.87 17.75 10C17.75 5.73 14.27 2.25 10 2.25C5.73 2.25 2.25 5.73 2.25 10C2.25 14.27 5.73 17.75 10 17.75C11.87 17.75 13.58 17.09 14.92 15.98L20.47 21.53C20.62 21.68 20.81 21.75 21 21.75C21.19 21.75 21.38 21.68 21.53 21.53C21.82 21.24 21.82 20.76 21.53 20.47ZM10 16.25C6.55 16.25 3.75 13.45 3.75 10C3.75 6.55 6.55 3.75 10 3.75C13.45 3.75 16.25 6.55 16.25 10C16.25 13.45 13.45 16.25 10 16.25ZM13.75 10C13.75 10.41 13.41 10.75 13 10.75H7C6.59 10.75 6.25 10.41 6.25 10C6.25 9.59 6.59 9.25 7 9.25H13C13.41 9.25 13.75 9.59 13.75 10Z\"></path></svg>"

/***/ }),

/***/ "./src/components/action-container-view-model.ts":
/*!*******************************************************!*\
  !*** ./src/components/action-container-view-model.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SurveyElementActionContainer: () => (/* binding */ SurveyElementActionContainer),
/* harmony export */   SurveyElementAdornerBase: () => (/* binding */ SurveyElementAdornerBase)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _survey_elements__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../survey-elements */ "./src/survey-elements.ts");




var SurveyElementActionContainer = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyElementActionContainer, _super);
    function SurveyElementActionContainer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurveyElementActionContainer.prototype.needToShrink = function (item, shrinkTypeConverterAction) {
        return (item.innerItem.location == "start" && shrinkTypeConverterAction || item.innerItem.location != "start");
    };
    SurveyElementActionContainer.prototype.setModeForActions = function (shrinkTypeConverterAction, exclude) {
        var _this = this;
        if (exclude === void 0) { exclude = []; }
        this.visibleActions.forEach(function (item) {
            if (exclude.indexOf(item.id) != -1) {
                item.mode = "removed";
                return;
            }
            if (_this.needToShrink(item, shrinkTypeConverterAction)) {
                item.mode = item.canShrink ? "small" : "removed";
                return;
            }
            item.mode = "large";
        });
    };
    SurveyElementActionContainer.prototype.calcItemSize = function (item, shrinkTypeConverterAction, exclude) {
        if (exclude === void 0) { exclude = []; }
        if (exclude.indexOf(item.id) != -1)
            return 0;
        if (this.needToShrink(item, shrinkTypeConverterAction)) {
            if (!item.canShrink)
                return 0;
            return item.minDimension;
        }
        return item.maxDimension;
    };
    SurveyElementActionContainer.prototype.fit = function (dimension, dotsItemSize) {
        var _this = this;
        if (dimension <= 0)
            return;
        this.dotsItem.visible = false;
        var items = this.visibleActions;
        if (dimension >= items.reduce(function (sum, i) { return sum += i.maxDimension; }, 0)) {
            items.forEach(function (i) { return i.mode = "large"; });
            return;
        }
        if (dimension >= items.reduce(function (sum, i) { return sum += _this.calcItemSize(i, false); }, 0)) {
            this.setModeForActions(false);
            return;
        }
        if (dimension >= items.reduce(function (sum, i) { return sum += _this.calcItemSize(i, false, ["convertInputType"]); }, 0)) {
            this.setModeForActions(false, ["convertInputType"]);
            return;
        }
        if (dimension >= items.reduce(function (sum, i) { return sum += _this.calcItemSize(i, true); }, 0)) {
            this.setModeForActions(true);
            return;
        }
        this.visibleActions.forEach(function (item) {
            if (item.id == "convertTo") {
                item.mode = "small";
                return;
            }
            if (item.id == "convertInputType") {
                item.mode = "removed";
                return;
            }
            item.mode = "popup";
        });
        this.dotsItem.visible = true;
        this.hiddenItemsListModel.setItems(items.filter(function (i) { return i.mode == "popup"; }).map(function (i) { return i.innerItem; }));
    };
    return SurveyElementActionContainer;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.AdaptiveActionContainer));

var SurveyElementAdornerBase = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyElementAdornerBase, _super);
    function SurveyElementAdornerBase(creator, surveyElement) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.animationCollapsed = new survey_core__WEBPACK_IMPORTED_MODULE_1__.AnimationBoolean(_this.getExpandCollapseAnimationOptions(), function (val) {
            _this._renderedCollapsed = !val;
        }, function () { return !_this.renderedCollapsed; });
        _this.draggedIn = false;
        _this.sidebarFlyoutModeChangedFunc = function (_, options) {
            if (options.name === "flyoutMode") {
                _this.updateActionsProperties();
            }
        };
        _this.expandCollapseAction = _this.getExpandCollapseAction();
        _this.createActionContainers();
        _this.attachToUI(surveyElement);
        return _this;
    }
    Object.defineProperty(SurveyElementAdornerBase.prototype, "dragInsideCollapsedContainer", {
        get: function () {
            return this.collapsed && this.creator.dragDropSurveyElements.insideContainer;
        },
        enumerable: false,
        configurable: true
    });
    SurveyElementAdornerBase.prototype.getAnimatedElement = function () {
        return null;
    };
    SurveyElementAdornerBase.prototype.getInnerAnimatedElements = function () {
        return [];
    };
    SurveyElementAdornerBase.prototype.getCollapsingCssClassName = function () {
        return "svc-question--leave";
    };
    SurveyElementAdornerBase.prototype.getExpandingCssClassName = function () {
        return "svc-question--enter";
    };
    Object.defineProperty(SurveyElementAdornerBase.prototype, "hoverDelay", {
        get: function () {
            return this.creator.pageHoverDelay;
        },
        enumerable: false,
        configurable: true
    });
    SurveyElementAdornerBase.prototype.hover = function (e, element) {
        var _this = this;
        var processedFlagName = "__svc_question_processed";
        if (!e[processedFlagName] && e.type === "mouseover") {
            if (!this.hoverTimeout) {
                this.hoverTimeout = setTimeout(function () {
                    _this.isHovered = true;
                    _this.hoverTimeout = undefined;
                }, this.hoverDelay);
            }
            e[processedFlagName] = true;
        }
        else {
            clearTimeout(this.hoverTimeout);
            this.hoverTimeout = undefined;
            this.isHovered = false;
        }
    };
    SurveyElementAdornerBase.prototype.getExpandCollapseAnimationOptions = function () {
        var _this = this;
        var beforeRunAnimation = function (el, animatingClassName) {
            (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.prepareElementForVerticalAnimation)(el);
            var innerAnimatedElements = _this.getInnerAnimatedElements();
            innerAnimatedElements.forEach(function (elem) {
                (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.prepareElementForVerticalAnimation)(elem);
            });
            innerAnimatedElements.forEach(function (elem) {
                elem.classList.add(animatingClassName);
            });
        };
        var afterRunAnimation = function (el, animatingClassName) {
            _this.expandCollapseAnimationRunning = false;
            if (_this.surveyElement) {
                (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.cleanHtmlElementAfterAnimation)(el);
                var innerAnimatedElements = _this.getInnerAnimatedElements();
                innerAnimatedElements.forEach(function (elem) {
                    (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.cleanHtmlElementAfterAnimation)(elem);
                });
                innerAnimatedElements.forEach(function (elem) {
                    elem.classList.remove(animatingClassName);
                });
            }
        };
        return {
            getRerenderEvent: function () { return _this.onElementRerendered; },
            getEnterOptions: function () {
                var className = _this.getExpandingCssClassName();
                return {
                    cssClass: className,
                    onBeforeRunAnimation: function (el) {
                        beforeRunAnimation(el, className);
                    },
                    onAfterRunAnimation: function (el) {
                        afterRunAnimation(el, className);
                    },
                };
            },
            getLeaveOptions: function () {
                var className = _this.getCollapsingCssClassName();
                return {
                    cssClass: className,
                    onBeforeRunAnimation: function (el) {
                        beforeRunAnimation(el, className);
                    },
                    onAfterRunAnimation: function (el) {
                        afterRunAnimation(el, className);
                    },
                };
            },
            getAnimatedElement: function () { return _this.getAnimatedElement(); },
            isAnimationEnabled: function () { return _this.animationAllowed; }
        };
    };
    Object.defineProperty(SurveyElementAdornerBase.prototype, "renderedCollapsed", {
        get: function () {
            return !!this._renderedCollapsed;
        },
        set: function (val) {
            if (this.animationAllowed && val !== this.renderedCollapsed)
                this.expandCollapseAnimationRunning = true;
            this.animationCollapsed.sync(!val);
        },
        enumerable: false,
        configurable: true
    });
    SurveyElementAdornerBase.prototype.createActionContainers = function () {
        this.actionContainer = this.createActionContainer();
    };
    SurveyElementAdornerBase.prototype.createActionContainer = function () {
        var actionContainer = new SurveyElementActionContainer();
        actionContainer.dotsItem.iconSize = "auto";
        actionContainer.dotsItem.popupModel.horizontalPosition = "center";
        actionContainer.dotsItem.popupModel.cssClass += " svc-creator-popup";
        return actionContainer;
    };
    Object.defineProperty(SurveyElementAdornerBase.prototype, "canExpandOnDrag", {
        get: function () {
            return this.surveyElement.isPanel || this.surveyElement.isPage || (0,_survey_elements__WEBPACK_IMPORTED_MODULE_2__.isPanelDynamic)(this.surveyElement);
        },
        enumerable: false,
        configurable: true
    });
    SurveyElementAdornerBase.prototype.dragIn = function () {
        var _this = this;
        if (!this.draggedIn) {
            if (this.canExpandOnDrag && this.collapsed) {
                this.draggedIn = true;
                this.dragCollapsedTimer = setTimeout(function () {
                    _this.expandWithDragIn();
                }, this.creator.expandOnDragTimeOut);
            }
        }
    };
    SurveyElementAdornerBase.prototype.expandWithDragIn = function () {
        this.collapsed = false;
        this.dragCollapsedTimer = undefined;
    };
    SurveyElementAdornerBase.prototype.dragOut = function () {
        if (this.draggedIn) {
            clearTimeout(this.dragCollapsedTimer);
            this.draggedIn = false;
        }
    };
    SurveyElementAdornerBase.prototype.dblclick = function (event) {
        if (this.allowExpandCollapse)
            this.collapsed = !this.collapsed;
        event.stopPropagation();
    };
    Object.defineProperty(SurveyElementAdornerBase.prototype, "element", {
        get: function () {
            return this.surveyElement;
        },
        enumerable: false,
        configurable: true
    });
    SurveyElementAdornerBase.GetAdorner = function (surveyElement) {
        return surveyElement.getPropertyValue(SurveyElementAdornerBase.AdornerValueName);
    };
    SurveyElementAdornerBase.RestoreStateFor = function (surveyElement) {
        var adorner = SurveyElementAdornerBase.GetAdorner(surveyElement);
        if (!!adorner) {
            adorner.restoreState();
        }
    };
    SurveyElementAdornerBase.prototype.restoreState = function () {
        var _a;
        if (!!this.surveyElement) {
            var state = (_a = this.creator.designerStateManager) === null || _a === void 0 ? void 0 : _a.getElementState(this.surveyElement);
            this.collapsed = state.collapsed;
        }
        if (!this.surveyElement || this.surveyElement.isInteractiveDesignElement) {
            this.needToRenderContent = !this.collapsed;
        }
    };
    SurveyElementAdornerBase.prototype.detachElement = function (surveyElement) {
        if (surveyElement) {
            surveyElement.setPropertyValue(SurveyElementAdornerBase.AdornerValueName, null);
            surveyElement.unRegisterFunctionOnPropertyValueChanged("isSelectedInDesigner", "questionSelected");
            this.cleanActionsContainer();
        }
    };
    SurveyElementAdornerBase.prototype.attachElement = function (surveyElement) {
        var _this = this;
        var _a, _b;
        if (surveyElement) {
            (_b = (_a = this.creator) === null || _a === void 0 ? void 0 : _a.designerStateManager) === null || _b === void 0 ? void 0 : _b.initForElement(surveyElement);
            surveyElement.registerFunctionOnPropertyValueChanged("isSelectedInDesigner", function (newValue) {
                _this.onElementSelectedChanged(newValue);
            }, "questionSelected");
            this.restoreState();
            this.updateActionsContainer(surveyElement);
            this.updateActionsProperties();
            surveyElement.setPropertyValue(SurveyElementAdornerBase.AdornerValueName, this);
        }
    };
    SurveyElementAdornerBase.prototype.setSurveyElement = function (surveyElement) {
        this.detachOnlyMyElement();
        this.surveyElement = surveyElement;
        this.attachElement(this.surveyElement);
    };
    SurveyElementAdornerBase.prototype.checkActionProperties = function () {
        if (this.creator.isElementSelected(this.surveyElement)) {
            this.updateActionsProperties();
        }
    };
    SurveyElementAdornerBase.prototype.attachToUI = function (surveyElement, rootElement) {
        if (!!rootElement) {
            this.rootElement = rootElement;
        }
        if (this.surveyElement != surveyElement) {
            this.setSurveyElement(surveyElement);
            this.creator.sidebar.onPropertyChanged.add(this.sidebarFlyoutModeChangedFunc);
            this.creator.expandCollapseManager.add(this);
        }
    };
    SurveyElementAdornerBase.prototype.detachOnlyMyElement = function () {
        if (this.surveyElement && this.surveyElement.getPropertyValue(SurveyElementAdornerBase.AdornerValueName) === this && !this.surveyElement.isDisposed) {
            this.detachElement(this.surveyElement);
        }
    };
    SurveyElementAdornerBase.prototype.detachFromUI = function () {
        this.rootElement = undefined;
        this.detachOnlyMyElement();
        this.surveyElement = undefined;
        this.creator.sidebar.onPropertyChanged.remove(this.sidebarFlyoutModeChangedFunc);
        this.creator.expandCollapseManager.remove(this);
    };
    SurveyElementAdornerBase.prototype.dispose = function () {
        this.detachFromUI();
        if (!this.actionContainer.isDisposed) {
            this.actionContainer.dispose();
        }
        _super.prototype.dispose.call(this);
        this.sidebarFlyoutModeChangedFunc = undefined;
        this.animationCollapsed = undefined;
    };
    SurveyElementAdornerBase.prototype.onElementSelectedChanged = function (isSelected) {
        if (!isSelected)
            return;
        this.updateActionsProperties();
    };
    SurveyElementAdornerBase.prototype.getExpandCollapseAction = function () {
        var _this = this;
        var collapseIcon = "icon-collapsepanel-16x16";
        var expandIcon = "icon-expandpanel-16x16";
        return {
            id: "collapse",
            css: "sv-action-bar-item--collapse",
            iconName: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.collapsed ? expandIcon : collapseIcon; }),
            iconSize: "auto",
            action: function () {
                _this.collapsed = !_this.collapsed;
            }
        };
    };
    SurveyElementAdornerBase.prototype.cleanActionsContainer = function () {
        var actions = this.actionContainer.actions;
        this.actionContainer.setItems([]);
        actions.forEach(function (action) { return action.dispose && action.dispose(); });
    };
    SurveyElementAdornerBase.prototype.updateActionsContainer = function (surveyElement) {
        var actions = [];
        this.buildActions(actions);
        this.creator.onElementMenuItemsChanged(surveyElement, actions);
        this.actionContainer.setItems(actions);
    };
    SurveyElementAdornerBase.prototype.updateActionsProperties = function () {
        if (this.isDisposed)
            return;
        this.updateElementAllowOptions(this.creator.getElementAllowOperations(this.surveyElement), this.isOperationsAllow());
    };
    SurveyElementAdornerBase.prototype.getAllowDragging = function (options) {
        return options.allowDragging;
    };
    SurveyElementAdornerBase.prototype.getAllowExpandCollapse = function (options) {
        return this.creator.expandCollapseButtonVisibility != "never" && (options.allowExpandCollapse == undefined || !!options.allowExpandCollapse);
    };
    SurveyElementAdornerBase.prototype.updateElementAllowOptions = function (options, operationsAllow) {
        this.allowDragging = operationsAllow && this.getAllowDragging(options);
        this.allowExpandCollapse = this.getAllowExpandCollapse(options);
        this.allowEditOption = (options.allowEdit == undefined || !!options.allowEdit);
        this.updateActionVisibility("delete", operationsAllow && options.allowDelete);
        this.updateActionVisibility("duplicate", operationsAllow && options.allowCopy);
        this.updateActionVisibility("collapse", this.allowExpandCollapse);
        if (options.allowShowSettings === undefined) {
            var settingsVisibility = (options.allowEdit !== undefined) ? (operationsAllow && options.allowEdit) : this.creator.sidebar.flyoutMode;
            this.updateActionVisibility("settings", settingsVisibility);
        }
        else {
            this.updateActionVisibility("settings", options.allowShowSettings);
        }
        this.setShowAddQuestionButton(options.allowEdit !== false);
    };
    SurveyElementAdornerBase.prototype.isOperationsAllow = function () {
        return !this.creator.readOnly;
    };
    SurveyElementAdornerBase.prototype.updateActionVisibility = function (id, isVisible) {
        var action = this.getActionById(id);
        if (!action)
            return;
        if (action.visible == isVisible)
            return;
        action.visible = isVisible;
    };
    SurveyElementAdornerBase.prototype.getActionById = function (id) {
        return this.actionContainer.getActionById(id);
    };
    SurveyElementAdornerBase.prototype.buildActions = function (items) {
        var _this = this;
        items.push(new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "duplicate",
            iconName: "icon-duplicate_16x16",
            css: "svc-action-bar-item--right",
            title: this.creator.getLocString("survey.duplicate"),
            visibleIndex: 10,
            iconSize: "auto",
            action: function () { return _this.duplicate(); },
            onFocus: function (isMouse, event) { return _this.disableActionFocusing(isMouse, event); }
        }));
        items.push(new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "settings",
            iconName: "icon-settings_16x16",
            css: "svc-action-bar-item--right",
            title: this.creator.getLocString("ed.settings"),
            locTooltipName: "ed.settingsTooltip",
            visibleIndex: 20,
            iconSize: "auto",
            action: function () {
                _this.creator.setShowSidebar(true, true);
                if (!_this.creator.isMobileView) {
                    _this.creator.sidebar.executeOnExpand(function () {
                        _this.creator.propertyGrid.getAllQuestions()[0].focus();
                    });
                }
            }
        }));
        items.push(new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "delete",
            iconName: "icon-delete_16x16",
            css: "svc-action-bar-item--right",
            //needSeparator: items.length > 0,
            title: this.creator.getLocString("pe.delete"),
            visibleIndex: 30,
            iconSize: "auto",
            action: function () {
                _this.delete();
            },
            onFocus: function (isMouse, event) { return _this.disableActionFocusing(isMouse, event); }
        }));
    };
    SurveyElementAdornerBase.prototype.disableActionFocusing = function (isMouse, event) {
        this.isDisableSelecting = isMouse;
    };
    SurveyElementAdornerBase.prototype.canSelectElement = function () {
        var res = !this.isDisableSelecting;
        this.isDisableSelecting = false;
        return res;
    };
    Object.defineProperty(SurveyElementAdornerBase.prototype, "allowEdit", {
        get: function () {
            return !!this.creator && !this.creator.readOnly && this.allowEditOption;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyElementAdornerBase.prototype, "showAddQuestionButton", {
        get: function () {
            return this.getPropertyValue("showAddQuestionButton");
        },
        enumerable: false,
        configurable: true
    });
    SurveyElementAdornerBase.prototype.setShowAddQuestionButton = function (val) {
        this.setPropertyValue("showAddQuestionButton", val && this.allowEdit && !!this.creator && this.creator.showAddQuestionButton);
    };
    SurveyElementAdornerBase.prototype.duplicate = function () { };
    SurveyElementAdornerBase.prototype.delete = function () {
        this.creator.deleteElement(this.surveyElement);
    };
    SurveyElementAdornerBase.prototype.getCss = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder().append("svc-hovered svc-hovered-ready", this.isHovered).toString();
    };
    SurveyElementAdornerBase.AdornerValueName = "__sjs_creator_adorner";
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyElementAdornerBase.prototype, "allowDragging", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyElementAdornerBase.prototype, "expandCollapseAnimationRunning", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyElementAdornerBase.prototype, "needToRenderContent", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyElementAdornerBase.prototype, "allowExpandCollapse", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (val, target) {
                target.renderedCollapsed = val;
                if (!val)
                    target.needToRenderContent = true;
                if (target.creator.designerStateManager && !target.creator.designerStateManager.isSuspended && target.surveyElement) {
                    target.creator.designerStateManager.getElementState(target.surveyElement).collapsed = val;
                }
                setTimeout(function () {
                    target.creator.survey.pages.forEach(function (p) { return p.ensureRowsVisibility(); });
                    target.creator.survey.getAllPanels().forEach(function (p) { return p.ensureRowsVisibility(); });
                }, 50);
            }
        })
    ], SurveyElementAdornerBase.prototype, "collapsed", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyElementAdornerBase.prototype, "_renderedCollapsed", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyElementAdornerBase.prototype, "isAnimationRunningCollapsed", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyElementAdornerBase.prototype, "isHovered", void 0);
    return SurveyElementAdornerBase;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/embedded-survey.ts":
/*!*******************************************!*\
  !*** ./src/components/embedded-survey.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionEmbeddedSurveyModel: () => (/* binding */ QuestionEmbeddedSurveyModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


var questionType = "embeddedsurvey";
var QuestionEmbeddedSurveyModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionEmbeddedSurveyModel, _super);
    function QuestionEmbeddedSurveyModel(name) {
        var _this = _super.call(this, name) || this;
        _this.onEmbeddedSurveyValueChanged = function () { };
        return _this;
    }
    Object.defineProperty(QuestionEmbeddedSurveyModel.prototype, "embeddedSurvey", {
        get: function () {
            return this.getPropertyValue("embeddedSurvey");
        },
        set: function (val) {
            if (val === this.embeddedSurvey)
                return;
            this.setPropertyValue("embeddedSurvey", val);
            this.onEmbeddedSurveyValueChanged();
        },
        enumerable: false,
        configurable: true
    });
    QuestionEmbeddedSurveyModel.prototype.getType = function () {
        return questionType;
    };
    return QuestionEmbeddedSurveyModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionNonValue));

survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addClass(questionType, [], function () {
    return new QuestionEmbeddedSurveyModel("");
}, "nonvalue");
survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionFactory.Instance.registerQuestion(questionType, function (name) { return new QuestionEmbeddedSurveyModel(name); }, false);


/***/ }),

/***/ "./src/components/header/logo-image.ts":
/*!*********************************************!*\
  !*** ./src/components/header/logo-image.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LogoImageViewModel: () => (/* binding */ LogoImageViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");



__webpack_require__(/*! ./logo-image.scss */ "./src/components/header/logo-image.scss");
var LogoImageViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(LogoImageViewModel, _super);
    function LogoImageViewModel(creator, root) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.root = root;
        return _this;
    }
    Object.defineProperty(LogoImageViewModel.prototype, "allowEdit", {
        get: function () {
            var survey = this.creator.survey;
            var property = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(survey.getType(), "logo");
            return !this.creator.readOnly && (!property.overridingProperty || !survey[property.overridingProperty]);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogoImageViewModel.prototype, "containerCss", {
        get: function () {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("svc-logo-image-container")
                .append("svc-logo-image-container--editable", this.allowEdit).toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogoImageViewModel.prototype, "survey", {
        get: function () {
            return this.creator.survey;
        },
        enumerable: false,
        configurable: true
    });
    LogoImageViewModel.prototype.uploadFile = function (model, fileInput, files) {
        model.isUploading = true;
        model.creator.uploadFiles(files, undefined, function (_, link) {
            model.creator.survey.logo = link;
            fileInput.value = "";
            model.isUploading = false;
        }, { element: model.creator.survey, elementType: "survey", propertyName: "logo" });
    };
    LogoImageViewModel.prototype.chooseFile = function (model) {
        if (this.allowEdit) {
            var fileInput_1 = model.root.getElementsByClassName("svc-choose-file-input")[0];
            if (fileInput_1.files.length === 0) {
                model.creator.chooseFiles(fileInput_1, function (files) {
                    model.uploadFile(model, fileInput_1, files);
                }, { element: this.survey, elementType: this.survey.getType(), propertyName: "logo" });
            }
            else
                model.uploadFile(model, fileInput_1, [fileInput_1.files[0]]);
        }
    };
    LogoImageViewModel.prototype.remove = function (model) {
        model.creator.survey.logo = "";
    };
    Object.defineProperty(LogoImageViewModel.prototype, "chooseLogoPlaceholder", {
        get: function () {
            return this.creator.getLocString("ed.chooseLogoPlaceholder");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogoImageViewModel.prototype, "acceptedTypes", {
        get: function () {
            return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__.getAcceptedTypesByContentMode)("image");
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], LogoImageViewModel.prototype, "isUploading", void 0);
    return LogoImageViewModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/image-item-value.ts":
/*!********************************************!*\
  !*** ./src/components/image-item-value.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ImageItemValueWrapperViewModel: () => (/* binding */ ImageItemValueWrapperViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _item_value__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./item-value */ "./src/components/item-value.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");




__webpack_require__(/*! ./image-item-value.scss */ "./src/components/image-item-value.scss");
var ImageItemValueWrapperViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(ImageItemValueWrapperViewModel, _super);
    function ImageItemValueWrapperViewModel(creator, question, item, templateData, itemsRoot) {
        var _this = _super.call(this, creator, question, item) || this;
        _this.question = question;
        _this.item = item;
        _this.templateData = templateData;
        _this.itemsRoot = itemsRoot;
        _this.isChoosingNewFile = false;
        _this.onDragOver = function (event) {
            _this.isFileDragging = true;
            event.dataTransfer.dropEffect = "copy";
            event.preventDefault();
        };
        _this.onDrop = function (event) {
            _this.isFileDragging = false;
            event.preventDefault();
            var input = event.dataTransfer;
            if (!input || !input.files || input.files.length < 1)
                return;
            var files = [];
            for (var i = 0; i < input.files.length; i++) {
                files.push(input.files[i]);
            }
            _this.uploadFiles(files);
        };
        _this.onDragLeave = function (event) {
            _this.isFileDragging = false;
        };
        return _this;
    }
    ImageItemValueWrapperViewModel.prototype.getRootCss = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append("svc-image-item-value-wrapper")
            .append("svc-image-item-value")
            .append("svc-image-item-value--new", this.isNew || this.isUploading)
            .append("svc-image-item-value-wrapper--ghost", this.isDragDropGhost)
            .append("svc-image-item-value--file-dragging", this.isFileDragging)
            .append("svc-image-item-value--single", this.getIsNewItemSingle()).toString();
    };
    ImageItemValueWrapperViewModel.prototype.getIsNewItemSingle = function () {
        return this.isNew && this.question.choices.length === 0;
    };
    Object.defineProperty(ImageItemValueWrapperViewModel.prototype, "canRenderControls", {
        get: function () {
            return this.getIsNewItemSingle() || !this.question.renderedImageWidth || this.question.renderedImageWidth > 150;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageItemValueWrapperViewModel.prototype, "selectFileTitle", {
        get: function () {
            return this.creator.getLocString("ed.selectFile");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageItemValueWrapperViewModel.prototype, "removeFileTitle", {
        get: function () {
            return this.creator.getLocString("ed.removeFile");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ImageItemValueWrapperViewModel.prototype, "addFileTitle", {
        get: function () {
            return this.creator.getLocString("ed.selectFile");
        },
        enumerable: false,
        configurable: true
    });
    ImageItemValueWrapperViewModel.prototype.chooseFile = function (model) {
        var fileInput = model.itemsRoot.getElementsByClassName("svc-choose-file-input")[0];
        var context = { element: model.question, item: model.item, elementType: model.question.getType(), propertyName: "imageLink" };
        model.creator.chooseFiles(fileInput, function (files) {
            model.isUploading = true;
            model.creator.uploadFiles(files, model.question, function (status, link) {
                if (status === "success") {
                    model.item.imageLink = link;
                }
                model.isUploading = false;
            }, context);
        }, context);
    };
    ImageItemValueWrapperViewModel.prototype.uploadFiles = function (files) {
        var _this = this;
        this.isUploading = true;
        var context = { element: this.question, item: undefined, elementType: this.question.getType(), propertyName: "imageLink" };
        this.creator.uploadFiles(files, this.question, function (status, link) {
            if (status === "success") {
                _this.creator.createNewItemValue(_this.question, _this.isChoosingNewFile, function (res) {
                    res.imageLink = link;
                });
            }
            _this.isChoosingNewFile = false;
            _this.isUploading = false;
        }, context);
    };
    ImageItemValueWrapperViewModel.prototype.chooseNewFile = function (model) {
        var _this = this;
        var fileInput = model.itemsRoot.getElementsByClassName("svc-choose-file-input")[0];
        model.creator.chooseFiles(fileInput, function (files) {
            _this.isChoosingNewFile = true;
            model.uploadFiles(files);
        }, { element: model.question, item: model.item, elementType: model.question.getType(), propertyName: "imageLink" });
    };
    Object.defineProperty(ImageItemValueWrapperViewModel.prototype, "acceptedTypes", {
        get: function () {
            return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.getAcceptedTypesByContentMode)(this.question.contentMode);
        },
        enumerable: false,
        configurable: true
    });
    ImageItemValueWrapperViewModel.prototype.dispose = function () {
        this.itemsRoot = undefined;
        _super.prototype.dispose.call(this);
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], ImageItemValueWrapperViewModel.prototype, "isFileDragging", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], ImageItemValueWrapperViewModel.prototype, "isUploading", void 0);
    return ImageItemValueWrapperViewModel;
}(_item_value__WEBPACK_IMPORTED_MODULE_2__.ItemValueWrapperViewModel));



/***/ }),

/***/ "./src/components/item-value.ts":
/*!**************************************!*\
  !*** ./src/components/item-value.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ItemValueWrapperViewModel: () => (/* binding */ ItemValueWrapperViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _string_editor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./string-editor */ "./src/components/string-editor.ts");


__webpack_require__(/*! ./item-value.scss */ "./src/components/item-value.scss");



var specificChoices = {
    "noneItem": "showNoneItem",
    "otherItem": "showOtherItem",
    "selectAllItem": "showSelectAllItem",
    "refuseItem": "showRefuseItem",
    "dontKnowItem": "showDontKnowItem"
};
var ItemValueWrapperViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(ItemValueWrapperViewModel, _super);
    function ItemValueWrapperViewModel(creator, question, item) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.question = question;
        _this.item = item;
        _this.canTouchItems = true;
        _this.focusCameFromDown = false;
        _this.startDragItemValue = function (pointerDownEvent, currentTarget) {
            _this.dragDropHelper.startDrag(pointerDownEvent, _this.item, _this.question, currentTarget);
        };
        _this.handleDragDropGhostPositionChanged = function () {
            _this.ghostPosition = _this.getGhostPosition(_this.item);
            _this.isDragDropGhost = _this.item === _this.dragDropHelper.draggedElement;
            if (_this.item === _this.dragDropHelper.prevDropTarget) {
                _this.isDragDropMoveDown = _this.item.isDragDropMoveDown;
                _this.isDragDropMoveUp = _this.item.isDragDropMoveUp;
            }
            else {
                _this.isDragDropMoveDown = false;
                _this.isDragDropMoveUp = false;
            }
        };
        _this.updateIsNew(question, item);
        for (var key in specificChoices) {
            _this.registerOnPropertyChanged(key, specificChoices[key]);
        }
        if (_this.isNew) {
            question.renderedChoicesChangedCallback = function () {
                _this.updateNewItemValue();
            };
            _this.updateNewItemValue();
        }
        _this.dragDropHelper.onGhostPositionChanged.add(_this.handleDragDropGhostPositionChanged);
        _this.dragOrClickHelper = new survey_core__WEBPACK_IMPORTED_MODULE_1__.DragOrClickHelper(_this.startDragItemValue);
        _this.allowItemOperations = { allowDelete: undefined, allowEdit: undefined, allowAdd: undefined };
        _this.collectionProperty = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(question.getType(), _this.collectionPropertyName);
        _this.creator.onCollectionItemAllowingCallback(question.ownerObj || question, _this.collectionProperty, question.visibleChoices, _this.item, _this.allowItemOperations);
        if (_this.allowItemOperations.allowDelete === undefined) {
            _this.allowItemOperations.allowDelete = true;
        }
        if (_this.allowItemOperations.allowAdd === undefined) {
            _this.allowItemOperations.allowAdd = true;
        }
        if (!_this.allowItemOperations.allowAdd) {
            _this.updateIsNewVisibility();
        }
        if (!_this.creator.isCanModifyProperty(question, "choices")) {
            _this.canTouchItems = false;
        }
        return _this;
    }
    Object.defineProperty(ItemValueWrapperViewModel.prototype, "canBeDragged", {
        get: function () {
            return !this.isNew && this.question.choices.indexOf(this.item) > -1;
        },
        enumerable: false,
        configurable: true
    });
    ItemValueWrapperViewModel.prototype.isBanStartDrag = function (pointerDownEvent) {
        if (!this.isDraggable)
            return true;
        var isContentEditable = pointerDownEvent.target.getAttribute("contenteditable") === "true";
        return isContentEditable || !this.canBeDragged;
    };
    ItemValueWrapperViewModel.prototype.updateNewItemValue = function () {
        if (!this.creator || !this.question || !this.question.newItem)
            return;
        this.question.newItem.value = this.creator.getNextItemValue(this.question);
        this.question.newItem.text = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.getNextItemText)(this.question.choices);
    };
    ItemValueWrapperViewModel.prototype.registerOnPropertyChanged = function (itemName, propertyName) {
        var _this = this;
        if (this.question[itemName] === this.item) {
            var question_1 = this.question;
            var item_1 = this.item;
            var updateFromProperty = function () {
                _this.updateIsNew(question_1, item_1);
            };
            question_1.registerFunctionOnPropertyValueChanged(propertyName, updateFromProperty);
        }
    };
    Object.defineProperty(ItemValueWrapperViewModel.prototype, "collectionPropertyName", {
        get: function () {
            return !!this.item.ownerPropertyName ? this.item.ownerPropertyName : "choices";
        },
        enumerable: false,
        configurable: true
    });
    ItemValueWrapperViewModel.prototype.onPointerDown = function (pointerDownEvent) {
        if (this.isBanStartDrag(pointerDownEvent))
            return true;
        this.dragOrClickHelper.onPointerDown(pointerDownEvent);
        return false;
    };
    Object.defineProperty(ItemValueWrapperViewModel.prototype, "dragDropHelper", {
        get: function () {
            return this.creator.dragDropChoices;
        },
        enumerable: false,
        configurable: true
    });
    ItemValueWrapperViewModel.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.dragDropHelper.onGhostPositionChanged.remove(this.handleDragDropGhostPositionChanged);
    };
    ItemValueWrapperViewModel.prototype.getGhostPosition = function (item) {
        if (this.dragDropHelper.dropTarget !== item)
            return null;
        return this.dragDropHelper.isBottom ? "bottom" : "top";
    };
    Object.defineProperty(ItemValueWrapperViewModel.prototype, "isDraggable", {
        get: function () {
            return this.isDraggableItem(this.item);
        },
        enumerable: false,
        configurable: true
    });
    ItemValueWrapperViewModel.prototype.isDraggableItem = function (item) {
        if (this.creator.readOnly || !this.canTouchItems)
            return false;
        return this.question.choices.indexOf(item) !== -1;
    };
    ItemValueWrapperViewModel.prototype.getSpecificProp = function (model) {
        for (var key in specificChoices) {
            if (model.question[key] === model.item)
                return specificChoices[key];
        }
        return undefined;
    };
    ItemValueWrapperViewModel.prototype.add = function (model) {
        var propName = this.getSpecificProp(model);
        if (propName) {
            model.question[propName] = true;
            return;
        }
        this.addNewItem(model.item, model.question, model.creator);
        this.updateIsNew(model.question, model.item);
    };
    ItemValueWrapperViewModel.prototype.addNewItem = function (item, question, creator) {
        item.value = "newitem";
        var itemValue = creator.createNewItemValue(question);
        this.updateNewItemValue();
        _string_editor__WEBPACK_IMPORTED_MODULE_4__.StringEditorConnector.get(itemValue.locText).setAutoFocus();
    };
    ItemValueWrapperViewModel.prototype.remove = function (model) {
        var propName = this.getSpecificProp(model);
        if (propName) {
            model.question[propName] = false;
            return;
        }
        var choices = model.question.choices;
        var index = choices.indexOf(model.item);
        if (!this.creator.onCollectionItemDeletingCallback(model.question, this.collectionProperty, choices, model.item))
            return;
        var indexToFocus = this.findNextElementIndexToRemove(index);
        model.question.choices.splice(index, 1);
        this.focusNextElementToRemove(indexToFocus);
        this.updateIsNew(model.question, model.item);
    };
    ItemValueWrapperViewModel.prototype.onFocusOut = function (event) {
        this.question["_lastActiveItemValueIndex"] = this.question.choices.indexOf(this.item);
    };
    ItemValueWrapperViewModel.prototype.findNextElementIndexToRemove = function (index) {
        var indexToFocus = 0;
        if (this.question.choices.length > 0) {
            if (index < this.question["_lastActiveItemValueIndex"]) {
                indexToFocus = index - 1;
            }
            else {
                indexToFocus = index;
            }
            if (indexToFocus < 0)
                indexToFocus = 0;
            if (indexToFocus >= this.question.choices.length - 2)
                indexToFocus = this.question.choices.length - 2;
        }
        return indexToFocus;
    };
    ItemValueWrapperViewModel.prototype.focusNextElementToRemove = function (index) {
        var _this = this;
        setTimeout(function () {
            var _a;
            var el = document.getElementById(_this.question.id);
            var buttons = el.querySelectorAll(".svc-item-value-controls__remove");
            (_a = buttons[index]) === null || _a === void 0 ? void 0 : _a.focus();
        }, 100);
    };
    ItemValueWrapperViewModel.prototype.updateIsNew = function (question, item) {
        this.isNew = !question.isItemInList(item) && !this.isAutoGeneratedItem(item);
        this.updateIsNewVisibility();
    };
    ItemValueWrapperViewModel.prototype.updateIsNewVisibility = function () {
        var _a;
        if (this.isNew) {
            this.item.setIsVisible(!(((_a = this.allowItemOperations) === null || _a === void 0 ? void 0 : _a.allowAdd) === false));
        }
    };
    Object.defineProperty(ItemValueWrapperViewModel.prototype, "allowRemove", {
        get: function () {
            var minChoices = this.creator.minimumChoicesCount;
            if (minChoices > 0 && minChoices >= this.question.choices.length)
                return false;
            var isNew = !this.question.isItemInList(this.item);
            var isAutoGenerated = this.isAutoGeneratedItem(this.item);
            return !this.creator.readOnly && this.canTouchItems && (this.allowItemOperations.allowDelete) && !isNew && !isAutoGenerated;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemValueWrapperViewModel.prototype, "tooltip", {
        get: function () {
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)(this.isNew ? "pe.addItem" : "pe.removeItem");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemValueWrapperViewModel.prototype, "dragTooltip", {
        get: function () {
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("pe.dragItem");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ItemValueWrapperViewModel.prototype, "allowAdd", {
        get: function () {
            var isNew = !this.question.isItemInList(this.item);
            var isAutoGenerated = this.isAutoGeneratedItem(this.item);
            return !this.creator.readOnly && this.canTouchItems && (this.allowItemOperations.allowAdd) && isNew && !isAutoGenerated;
        },
        enumerable: false,
        configurable: true
    });
    ItemValueWrapperViewModel.prototype.select = function (model, event) {
        if (model.question.inMatrixMode)
            return;
        model.creator.selectElement(model.question, "choices", false);
        event && event.stopPropagation();
    };
    ItemValueWrapperViewModel.prototype.isAutoGeneratedItem = function (item) {
        var val = item.value;
        if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isNumber(val))
            return false;
        var min = this.question.choicesMin;
        var max = this.question.choicesMax;
        if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isNumber(min) || !survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isNumber(max) || min === max && min === 0)
            return false;
        return val >= min && val <= max;
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], ItemValueWrapperViewModel.prototype, "isNew", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], ItemValueWrapperViewModel.prototype, "isDragging", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], ItemValueWrapperViewModel.prototype, "isDragDropGhost", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], ItemValueWrapperViewModel.prototype, "isDragDropMoveDown", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], ItemValueWrapperViewModel.prototype, "isDragDropMoveUp", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: null })
    ], ItemValueWrapperViewModel.prototype, "ghostPosition", void 0);
    return ItemValueWrapperViewModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/link-value.ts":
/*!**************************************!*\
  !*** ./src/components/link-value.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionLinkValueModel: () => (/* binding */ QuestionLinkValueModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");



__webpack_require__(/*! ./link-value.scss */ "./src/components/link-value.scss");
var QuestionLinkValueModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionLinkValueModel, _super);
    function QuestionLinkValueModel(name, json) {
        if (json === void 0) { json = null; }
        var _this = _super.call(this, name) || this;
        var linkValueText = json && !json.showValueInLink && (_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.set")) + " " + json.title || null;
        _this.linkValueText = linkValueText || _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.emptyValue");
        return _this;
    }
    QuestionLinkValueModel.prototype.onPropertyValueChanged = function (name, oldValue, newValue) {
        _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
        if (name === "value") {
            this.updateLinkValueText();
            if (this.allowClear) {
                this.showClear = !survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(newValue);
            }
            this.updateIsClickable();
        }
    };
    QuestionLinkValueModel.prototype.onReadOnlyChanged = function () {
        this.updateIsClickable();
        _super.prototype.onReadOnlyChanged.call(this);
    };
    QuestionLinkValueModel.prototype.updateIsClickable = function () {
        this.setPropertyValue("isClickable", !this.isReadOnly || (!!this.isClickableCallback && this.isClickableCallback()));
    };
    Object.defineProperty(QuestionLinkValueModel.prototype, "ariaRole", {
        get: function () {
            return "button";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionLinkValueModel.prototype, "tooltip", {
        get: function () {
            return this.showTooltip ? this.linkValueText : undefined;
        },
        enumerable: false,
        configurable: true
    });
    QuestionLinkValueModel.prototype.getType = function () {
        return "linkvalue";
    };
    QuestionLinkValueModel.prototype.doLinkClick = function () {
        if (!!this.linkClickCallback) {
            this.linkClickCallback();
        }
    };
    QuestionLinkValueModel.prototype.doClearClick = function () {
        if (!!this.clearClickCallback) {
            this.clearClickCallback();
        }
    };
    QuestionLinkValueModel.prototype.updateLinkValueText = function () {
        var displayValue;
        if (this.showValueInLink) {
            displayValue = this.isEmpty() ? _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.emptyValue") : this.getObjDisplayValue();
        }
        else {
            displayValue = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString(this.isEmpty() ? "pe.set" : "pe.change") + " " + this.title;
        }
        this.linkValueText = displayValue;
    };
    QuestionLinkValueModel.prototype.stringifyValue = function (val) {
        if (typeof val !== "string")
            return JSON.stringify(val);
        return val;
    };
    QuestionLinkValueModel.prototype.getObjDisplayValue = function () {
        var obj = this.obj;
        if (!obj || !obj["getDisplayValue"])
            return this.stringifyValue(this.value);
        var res = obj["getDisplayValue"](true, this.value);
        if (typeof res !== "string")
            return JSON.stringify(res);
        return res;
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "svc-link__button svc-link-value-button svc-question-link__set-button" })
    ], QuestionLinkValueModel.prototype, "linkSetButtonCssClasses", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "svc-link__button svc-question-link__clear-button" })
    ], QuestionLinkValueModel.prototype, "linkClearButtonCssClasses", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], QuestionLinkValueModel.prototype, "isSelected", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionLinkValueModel.prototype, "linkValueText", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], QuestionLinkValueModel.prototype, "showClear", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], QuestionLinkValueModel.prototype, "allowClear", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], QuestionLinkValueModel.prototype, "showValueInLink", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], QuestionLinkValueModel.prototype, "showTooltip", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], QuestionLinkValueModel.prototype, "isClickable", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionLinkValueModel.prototype, "iconName", void 0);
    return QuestionLinkValueModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Question));

survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addClass("linkvalue", ["showValueInLink",
    {
        name: "showTooltip: boolean",
        default: false,
        visible: false
    },
    "iconName"
], function (json) {
    var viewModel = new QuestionLinkValueModel("", json);
    return viewModel;
}, "nonvalue");
survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionFactory.Instance.registerQuestion("linkvalue", function (name) {
    return new QuestionLinkValueModel(name);
}, false);


/***/ }),

/***/ "./src/components/matrix-cell.ts":
/*!***************************************!*\
  !*** ./src/components/matrix-cell.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MatrixCellWrapperEditSurvey: () => (/* binding */ MatrixCellWrapperEditSurvey),
/* harmony export */   MatrixCellWrapperViewModel: () => (/* binding */ MatrixCellWrapperViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");






__webpack_require__(/*! ./matrix-cell.scss */ "./src/components/matrix-cell.scss");
var MatrixCellWrapperEditSurvey = /** @class */ (function () {
    function MatrixCellWrapperEditSurvey(creator, cellQuestion, column, model) {
        this.cellQuestion = cellQuestion;
        this.column = column;
        this.creator = creator;
        var questionJSON = cellQuestion.toJSON();
        questionJSON.type = cellQuestion.getType();
        this.surveyValue = creator.createSurvey({ questions: [questionJSON] }, "modal-question-editor", model, function (survey) {
            survey.css = survey_core__WEBPACK_IMPORTED_MODULE_1__.defaultV2Css;
            survey.setDesignMode(true);
            survey.isPopupEditorContent = true;
            survey.showQuestionNumbers = "none";
            survey.questionTitleLocation = "hidden";
        });
        this.question.setSurveyImpl(this.survey);
        this.question.inMatrixMode = true;
        this.question.ownerObj = this.column;
    }
    Object.defineProperty(MatrixCellWrapperEditSurvey.prototype, "survey", {
        get: function () { return this.surveyValue; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MatrixCellWrapperEditSurvey.prototype, "question", {
        get: function () { return this.survey.getAllQuestions()[0]; },
        enumerable: false,
        configurable: true
    });
    MatrixCellWrapperEditSurvey.prototype.apply = function () {
        var matrix = this.cellQuestion.parentQuestion;
        var column = matrix.getColumnByName(this.cellQuestion.name);
        var columnJSON = column.toJSON();
        var prevCellType = columnJSON["cellType"];
        var questionJSON = this.question.toJSON();
        var qType = this.question.getType();
        if (!!prevCellType) {
            questionJSON.cellType = prevCellType;
        }
        if (survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isTwoValueEquals(questionJSON, columnJSON))
            return;
        for (var key in columnJSON) {
            if (!!survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(qType, key) && questionJSON[key] === undefined && (columnJSON[key] === true || columnJSON[key] === false)) {
                questionJSON[key] = !columnJSON[key];
            }
        }
        if (column.cellType === "default") {
            column.cellType = qType;
        }
        for (var key in questionJSON) {
            if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isTwoValueEquals(questionJSON[key], columnJSON[key])) {
                column[key] = questionJSON[key];
            }
        }
        matrix.onColumnCellTypeChanged(column);
        this.creator.setModified({ type: "MATRIX_CELL_EDITOR", column: column });
    };
    return MatrixCellWrapperEditSurvey;
}());

var MatrixCellWrapperViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MatrixCellWrapperViewModel, _super);
    function MatrixCellWrapperViewModel(creator, templateData, question, row, column) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.templateData = templateData;
        _this.question = question;
        _this.row = row;
        _this.column = column;
        _this.onSelectionChanged = function (sender, options) {
            if (_this.context && _this.context.getPropertyValue) {
                _this.isSelected = _this.creator.isElementSelected(_this.context);
            }
            else {
                _this.isSelected = false;
            }
        };
        // if(!question && !!this.templateData.data) {
        //   this.question = this.templateData.data;
        // }
        creator.onSelectedElementChanged.add(_this.onSelectionChanged);
        return _this;
    }
    MatrixCellWrapperViewModel.prototype.editQuestion = function (model, event) {
        var editSurvey = new MatrixCellWrapperEditSurvey(model.creator, model.question, model.column, this);
        editSurvey.question.cellOwner = model;
        var prevCurrentLocale = survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.currentLocale;
        var locale = _editorLocalization__WEBPACK_IMPORTED_MODULE_4__.editorLocalization.currentLocale;
        survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.currentLocale = locale;
        var popupModel = survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.showDialog({
            componentName: "svc-question-editor-content",
            data: {
                survey: editSurvey.survey,
                creator: this.creator
            },
            onApply: function () {
                editSurvey.apply();
                return true;
            },
            cssClass: "svc-matrix-cell__popup svc-creator-popup",
            title: model.question.name,
            displayMode: this.creator.isMobileView ? "overlay" : "popup"
        }, model.creator.rootElement);
        popupModel.locale = locale;
        survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.currentLocale = prevCurrentLocale;
        event.stopPropagation();
        model.creator.selectElement(model.column);
    };
    Object.defineProperty(MatrixCellWrapperViewModel.prototype, "context", {
        get: function () {
            return this.row || this.column || this.templateData;
        },
        enumerable: false,
        configurable: true
    });
    MatrixCellWrapperViewModel.prototype.selectContext = function (model, event) {
        if (!!model.row) {
            model.creator.selectElement(model.row.data, "rows", false);
            event.stopPropagation();
            return;
        }
        if (typeof model.context.getType !== "function") {
            return;
        }
        var contextType = model.context.getType();
        if (contextType === "itemvalue") {
            model.creator.selectElement(model.context.locOwner, model.context.ownerPropertyName, false);
        }
        else {
            model.creator.selectElement(model.context);
        }
        event.stopPropagation();
    };
    Object.defineProperty(MatrixCellWrapperViewModel.prototype, "isSupportCellEditor", {
        get: function () {
            if (!this.question || !this.question.getType)
                return false;
            return _survey_helper__WEBPACK_IMPORTED_MODULE_3__.SurveyHelper.isSupportCellEditor(this.question.getType());
        },
        enumerable: false,
        configurable: true
    });
    MatrixCellWrapperViewModel.prototype.hover = function (event, element) {
        if (!this.row && this.context && this.context.getPropertyValue && this.context.getType && this.context.getType() !== "itemvalue") {
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__.toggleHovered)(event, element);
        }
    };
    MatrixCellWrapperViewModel.prototype.dispose = function () {
        this.creator.onSelectedElementChanged.remove(this.onSelectionChanged);
        _super.prototype.dispose.call(this);
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], MatrixCellWrapperViewModel.prototype, "isSelected", void 0);
    return MatrixCellWrapperViewModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/page-navigator/page-navigator.ts":
/*!*********************************************************!*\
  !*** ./src/components/page-navigator/page-navigator.ts ***!
  \*********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PageNavigatorViewModel: () => (/* binding */ PageNavigatorViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");


__webpack_require__(/*! ./page-navigator.scss */ "./src/components/page-navigator/page-navigator.scss");
__webpack_require__(/*! ./page-navigator-item.scss */ "./src/components/page-navigator/page-navigator-item.scss");

var PageNavigatorViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PageNavigatorViewModel, _super);
    function PageNavigatorViewModel(pagesController, pageEditMode) {
        var _this = _super.call(this) || this;
        _this.pagesController = pagesController;
        _this.pageEditMode = pageEditMode;
        _this.pagesChangedFunc = function (sender, options) {
            _this.buildItems();
        };
        _this.currentPagesChangedFunc = function (sender, options) {
            _this.currentPage = _this.pagesController.currentPage;
        };
        _this.pcPropertyChangedHandler = function (sender, options) {
            if (options.name === "toolboxLocation") {
                if (_this.pagesController.creator["toolboxLocation"] == "sidebar") {
                    _this.popupModel.horizontalPosition = "right";
                }
                else {
                    _this.popupModel.horizontalPosition = _this.pagesController.creator["toolboxLocation"];
                }
            }
        };
        _this.togglePageSelector = function (event) { return _this.popupModel.toggleVisibility(); };
        _this.icon = "icon-select-page";
        _this.pagesController.onPagesChanged.add(_this.pagesChangedFunc);
        _this.pagesController.onCurrentPageChanged.add(_this.currentPagesChangedFunc);
        _this.pageListModel = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ListModel({
            items: [],
            onSelectionChanged: function (item) {
                _this.pagesController.selectPage(item.data);
                _this.popupModel.hide();
            },
            allowSelection: true
        });
        _this.popupModel = new survey_core__WEBPACK_IMPORTED_MODULE_1__.PopupModel("sv-list", { model: _this.pageListModel }, { cssClass: "svc-creator-popup" });
        !!_this.pagesController && (_this.popupModel.horizontalPosition = _this.pagesController.creator["toolboxLocation"]);
        _this.popupModel.onShow = function () {
            _this.pageListModel.selectedItem = _this.getActionBarByPage(_this.pagesController.currentPage);
            _this.isPopupOpened = true;
        };
        _this.popupModel.onHide = function () { _this.isPopupOpened = false; };
        if (!!_this.pagesController.creator["onPropertyChanged"]) {
            _this.pagesController.creator["onPropertyChanged"].add(_this.pcPropertyChangedHandler);
        }
        _this.buildItems();
        return _this;
    }
    PageNavigatorViewModel.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.stopItemsContainerHeightObserver();
        this.pagesController.onPagesChanged.remove(this.pagesChangedFunc);
        this.pagesController.onCurrentPageChanged.remove(this.currentPagesChangedFunc);
        if (!!this.pagesController.creator["onPropertyChanged"]) {
            this.pagesController.creator["onPropertyChanged"].remove(this.pcPropertyChangedHandler);
            this.pcPropertyChangedHandler = undefined;
        }
        if (this.pageListModel) {
            this.pageListModel.dispose();
        }
        if (this.popupModel) {
            this.popupModel.dispose();
        }
        this._scrollableContainer = undefined;
        this._itemsContainer = undefined;
    };
    PageNavigatorViewModel.prototype.getActionBarByPage = function (page) {
        for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].data === page)
                return this.items[i];
        }
        return null;
    };
    PageNavigatorViewModel.prototype.setItems = function (items) {
        this.items = items;
        this.pageListModel.setItems(items);
        this.updateVisibility();
    };
    PageNavigatorViewModel.prototype.buildItems = function () {
        this.currentPage = this.pagesController.currentPage || this.pagesController.pages[0];
        var items = [];
        var pages = this.pagesController.pages;
        for (var i = 0; i < pages.length; i++) {
            items.push(this.createActionBarItem(pages[i]));
        }
        if (this.pagesController.creator["pageEditMode"] === "bypage") {
            var newPage = this.pagesController["creator"].getPlugin("designer").model.newPage;
            if (!!newPage) {
                items.push(this.createActionBarItem(newPage));
            }
        }
        this.setItems(items);
    };
    PageNavigatorViewModel.prototype.patchContainerOffset = function (el) {
        while (!!el) {
            if (el.className.indexOf("svc-tab-designer--with-page-navigator") !== -1) {
                el.offsetParent.scrollTop = 0;
                return;
            }
            el = el.parentElement;
        }
    };
    PageNavigatorViewModel.prototype.createActionBarItem = function (page) {
        var _this = this;
        var item = {
            id: page.id,
            title: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                var pageName = page.name;
                var pageTitle = page.title;
                return _this.pagesController
                    ? _this.pagesController.getDisplayName(page)
                    : (pageTitle || pageName);
            })
        };
        item.active = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return page === _this.currentPage; });
        item.action = function (item) {
            _this.scrollToPage(page);
        };
        item.data = page;
        return this.createActionBarCore(item);
    };
    Object.defineProperty(PageNavigatorViewModel.prototype, "isByPageMode", {
        get: function () {
            return this.pagesController.creator["pageEditMode"] === "bypage";
        },
        enumerable: false,
        configurable: true
    });
    PageNavigatorViewModel.prototype.scrollToPage = function (page) {
        var _this = this;
        if (this.pageEditMode === "bypage") {
            this.pagesController.currentPage = page;
            this.currentPage = page;
            this.pagesController.creator.selectElement(this.pagesController.currentPage);
            return;
        }
        var el = document.getElementById(page.id);
        if (!!el) {
            var isLastPage = this.pagesController.pages.indexOf(page) === (this.pagesController.pages.length - 1);
            if (!!this._scrollableContainer) {
                // const y = el.offsetTop - (this._scrollableContainer.clientHeight / 4);
                this._scrollableContainer.scrollTo(this._scrollableContainer.scrollLeft, el.offsetTop - 20);
                this.patchContainerOffset(el);
                if (isLastPage) {
                    setTimeout(function () {
                        _this._scrollableContainer.scrollTo(_this._scrollableContainer.scrollLeft, el.offsetTop - 20);
                        _this.patchContainerOffset(el);
                    }, 50);
                }
            }
            else {
                el.scrollIntoView({ block: "start" });
                this.patchContainerOffset(el);
                if (isLastPage) {
                    setTimeout(function () {
                        el.scrollIntoView({ block: "start" });
                        _this.patchContainerOffset(el);
                    }, 50);
                }
            }
        }
    };
    PageNavigatorViewModel.prototype.createActionBarCore = function (item) {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action(item);
    };
    Object.defineProperty(PageNavigatorViewModel.prototype, "pageSelectorCaption", {
        get: function () {
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.selectPage");
        },
        enumerable: false,
        configurable: true
    });
    PageNavigatorViewModel.prototype.onContainerScroll = function (viewPort) {
        var viewPortTop = viewPort.scrollTop;
        var viewPortHeight = viewPort.clientHeight;
        var viewPortBottom = viewPortTop + viewPortHeight;
        var visiblePages = [];
        var maxVisiblePage = undefined;
        var maxVisiblePagePart = 0;
        this.pagesController.pages.forEach(function (page) {
            var pageElement = document.getElementById(page.id);
            if (!!pageElement) {
                var pageTop = pageElement.offsetTop;
                var pageBottom = pageTop + pageElement.clientHeight;
                var possiblyVisible = pageTop < viewPortBottom || pageBottom > viewPortTop;
                if (!possiblyVisible)
                    return;
                var deltaTop = pageTop - viewPortTop;
                var deltaBottom = viewPortBottom - pageBottom;
                var visiblePart = pageElement.clientHeight;
                if (deltaTop < 0) {
                    visiblePart += deltaTop;
                }
                if (deltaBottom < 0) {
                    visiblePart += deltaBottom;
                }
                visiblePart = visiblePart / pageElement.clientHeight;
                if (visiblePart > 0) {
                    visiblePages.push({
                        page: page,
                        visiblePart: visiblePart
                    });
                    if (visiblePart > maxVisiblePagePart) {
                        maxVisiblePagePart = visiblePart;
                        maxVisiblePage = page;
                    }
                }
            }
        });
        this.currentPage = maxVisiblePage;
        return visiblePages;
    };
    PageNavigatorViewModel.prototype.stopItemsContainerHeightObserver = function () {
        this._itemsContainer = undefined;
        if (!!this._resizeObserver) {
            this._resizeObserver.disconnect();
            this._resizeObserver = undefined;
        }
        if (!this.isDisposed) {
            this.visibleItemsStartIndex = 0;
            this.visibleItemsCount = Number.MAX_VALUE;
        }
    };
    PageNavigatorViewModel.prototype.setScrollableContainer = function (scrollableContainer) {
        this._scrollableContainer = scrollableContainer;
    };
    PageNavigatorViewModel.prototype.setItemsContainer = function (itemsContainer) {
        var _this = this;
        this.stopItemsContainerHeightObserver();
        this._itemsContainer = itemsContainer;
        this._resizeObserver = new ResizeObserver(function (entries, observer) { return _this.updateVisibleItems(entries[0].contentBoxSize[0].blockSize); });
        this._resizeObserver.observe(itemsContainer);
    };
    PageNavigatorViewModel.prototype.updateVisibleItems = function (allAvailableHeight) {
        this.updateVisibility();
        if (this.isByPageMode) {
            return;
        }
        var itemsAvailableHeight = allAvailableHeight - PageNavigatorViewModel.PAGE_NAVIGATION_MENU_ITEM_HEIGHT;
        this.visibleItemsCount = Math.floor(itemsAvailableHeight / PageNavigatorViewModel.PAGE_NAVIGATION_ITEM_HEIGHT);
        var currantPageIndex = this.pagesController.pages.indexOf(this.currentPage);
        var visibleStart = 0;
        if (currantPageIndex >= this.visibleItemsCount) {
            visibleStart = this.items.length - currantPageIndex - 1 < this.visibleItemsCount / 2 ? this.items.length - this.visibleItemsCount : currantPageIndex - Math.floor(this.visibleItemsCount / 2);
        }
        this.visibleItemsStartIndex = visibleStart;
    };
    PageNavigatorViewModel.prototype._updateVisibility = function () {
        this.hasScrolling = !this._scrollableContainer || (this._scrollableContainer.scrollHeight > this._scrollableContainer.clientHeight);
        this.visible = this.items.length > 1 && (this.hasScrolling || this.isByPageMode);
        if (this.isByPageMode) {
            this.visibleItemsStartIndex = 0;
            this.visibleItemsCount = this.items.length;
        }
    };
    PageNavigatorViewModel.prototype.updateVisibility = function () {
        var _this = this;
        // this._updateVisibility();
        setTimeout(function () {
            _this._updateVisibility();
        }, 10);
    };
    Object.defineProperty(PageNavigatorViewModel.prototype, "visibleItems", {
        get: function () {
            if (this.items.length <= this.visibleItemsCount) {
                return this.items;
            }
            return this.items.slice(this.visibleItemsStartIndex, this.visibleItemsStartIndex + this.visibleItemsCount);
        },
        enumerable: false,
        configurable: true
    });
    PageNavigatorViewModel.PAGE_NAVIGATION_MENU_ITEM_HEIGHT = 44;
    PageNavigatorViewModel.PAGE_NAVIGATION_ITEM_HEIGHT = 36;
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], PageNavigatorViewModel.prototype, "hasScrolling", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.propertyArray)()
    ], PageNavigatorViewModel.prototype, "items", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], PageNavigatorViewModel.prototype, "visible", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], PageNavigatorViewModel.prototype, "isPopupOpened", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (page, navigator) {
                var currantPageIndex = navigator.pagesController.pages.indexOf(page);
                if (currantPageIndex >= navigator.visibleItemsStartIndex && currantPageIndex < navigator.visibleItemsStartIndex + navigator.visibleItemsCount) {
                    return;
                }
                var newVisibleItemsStartIndex = navigator.visibleItemsStartIndex;
                if (currantPageIndex < navigator.visibleItemsStartIndex) {
                    newVisibleItemsStartIndex = currantPageIndex;
                }
                if (currantPageIndex >= navigator.visibleItemsStartIndex + navigator.visibleItemsCount) {
                    newVisibleItemsStartIndex = currantPageIndex - navigator.visibleItemsCount + 1;
                }
                if (navigator.visibleItemsStartIndex !== newVisibleItemsStartIndex) {
                    if (navigator.visible && !!navigator._itemsContainer) {
                        var itemsHolder_1 = navigator._itemsContainer.querySelectorAll(".svc-page-navigator__selector + div")[0];
                        if (!!itemsHolder_1) {
                            var cssClass = "svc-page-navigator__items--" + (navigator.visibleItemsStartIndex < newVisibleItemsStartIndex ? "up" : "down");
                            itemsHolder_1.className = cssClass;
                            setTimeout(function () {
                                itemsHolder_1.className = "";
                                navigator.visibleItemsStartIndex = newVisibleItemsStartIndex;
                            }, 250);
                        }
                    }
                    else {
                        navigator.visibleItemsStartIndex = newVisibleItemsStartIndex;
                    }
                }
            }
        })
    ], PageNavigatorViewModel.prototype, "currentPage", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: 0 })
    ], PageNavigatorViewModel.prototype, "visibleItemsStartIndex", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: Number.MAX_VALUE })
    ], PageNavigatorViewModel.prototype, "visibleItemsCount", void 0);
    return PageNavigatorViewModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/page.ts":
/*!********************************!*\
  !*** ./src/components/page.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PageAdorner: () => (/* binding */ PageAdorner)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _action_container_view_model__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./action-container-view-model */ "./src/components/action-container-view-model.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../creator-settings */ "./src/creator-settings.ts");






__webpack_require__(/*! ./page.scss */ "./src/components/page.scss");
var PageAdorner = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PageAdorner, _super);
    function PageAdorner(creator, page) {
        var _this = _super.call(this, creator, page) || this;
        _this.addGhostPage = function (selectCurrentPage) {
            if (selectCurrentPage === void 0) { selectCurrentPage = true; }
            var currentPage = _this.page;
            if (_this.isGhost) {
                var addedPage = !!_this.creator.addPage(currentPage, selectCurrentPage, function () {
                    currentPage.unRegisterFunctionOnPropertiesValueChanged(["title", "description"], "add_ghost");
                    currentPage.name = _survey_helper__WEBPACK_IMPORTED_MODULE_4__.SurveyHelper.getNewPageName(_this.creator.survey.pages);
                    return true;
                });
                if (addedPage) {
                    _this.creator.survey.currentPage = currentPage;
                }
            }
            if (selectCurrentPage) {
                _this.creator.selectElement(currentPage);
            }
        };
        _this.addNewQuestion = function (model, event, type) {
            var isGhost = _this.isGhost;
            var page = _this.page;
            _this.creator.addNewQuestionInPage(function (type) {
                _this.addGhostPage(false);
                _this.creator.survey.currentPage = _this.page;
            }, null, type || _this.currentAddQuestionType || _creator_settings__WEBPACK_IMPORTED_MODULE_5__.settings.designer.defaultAddQuestionType);
        };
        _this.startDragSurveyElement = function (event) {
            var _a;
            var element = _this.surveyElement;
            var isElementSelected = _this.creator.selectedElement === element;
            _this.dragDropHelper.startDragSurveyElement(event, element, isElementSelected);
            if (_this.creator.collapsePagesOnDrag) {
                (_a = _this.creator.designerStateManager) === null || _a === void 0 ? void 0 : _a.suspend();
                _this.creator.collapseAllPagesOnDragStart();
            }
            return true;
        };
        _this.questionTypeSelectorModel = _this.creator.getQuestionTypeSelectorModel(function (type) {
            _this.currentAddQuestionType = type;
            _this.addGhostPage(false);
            _this.creator.survey.currentPage = _this.page;
        });
        _this.dragOrClickHelper = new survey_core__WEBPACK_IMPORTED_MODULE_1__.DragOrClickHelper(_this.startDragSurveyElement);
        return _this;
    }
    PageAdorner.prototype.updateDragTypeOverMe = function () {
        var _a;
        if (!this.isDisposed) {
            this.dragTypeOverMe = (_a = this.page) === null || _a === void 0 ? void 0 : _a.dragTypeOverMe;
        }
    };
    PageAdorner.prototype.updateIsDragMe = function () {
        var _a;
        if (!this.isDisposed) {
            this.isDragMe = (_a = this.page) === null || _a === void 0 ? void 0 : _a.isDragMe;
        }
    };
    PageAdorner.prototype.updateShowPlaceholder = function (visibleRows) {
        this.showPlaceholder = !this.isGhost && (visibleRows || this.page.visibleRows).length === 0;
    };
    PageAdorner.prototype.updateActionVisibility = function (id, isVisible) {
        _super.prototype.updateActionVisibility.call(this, id, !this.isGhost && isVisible);
    };
    PageAdorner.prototype.updateActionsContainer = function (surveyElement) {
        _super.prototype.updateActionsContainer.call(this, surveyElement);
        if (this.creator.expandCollapseButtonVisibility != "never")
            this.actionContainer.addAction(this.expandCollapseAction);
    };
    Object.defineProperty(PageAdorner.prototype, "dragInsideCollapsedContainer", {
        get: function () {
            return this.collapsed;
        },
        enumerable: false,
        configurable: true
    });
    PageAdorner.prototype.getAllowExpandCollapse = function (options) {
        return !this.isGhost && _super.prototype.getAllowExpandCollapse.call(this, options);
    };
    PageAdorner.prototype.attachElement = function (surveyElement) {
        var _this = this;
        _super.prototype.attachElement.call(this, surveyElement);
        this.dragTypeOverMe = null;
        if (!!surveyElement) {
            surveyElement["surveyChangedCallback"] = function () {
                _this.isPageLive = !!surveyElement.survey;
            };
            if (this.isGhost) {
                this.addGhostPageSubsribes(surveyElement);
            }
            surveyElement.registerFunctionOnPropertiesValueChanged(["dragTypeOverMe"], function () {
                _this.updateDragTypeOverMe();
            }, "dragOver");
            surveyElement.registerFunctionOnPropertiesValueChanged(["isDragMe"], function () {
                _this.updateIsDragMe();
            }, "dragOver");
            surveyElement.registerFunctionOnPropertiesValueChanged(["visibleRows"], function (newValue) {
                _this.updateShowPlaceholder(newValue);
            }, "updatePlaceholder");
            this.updateShowPlaceholder();
            surveyElement.onFirstRendering();
            surveyElement.updateCustomWidgets();
            surveyElement.setWasShown(true);
            this.checkActionProperties();
            this.dragTypeOverMe = surveyElement.dragTypeOverMe;
            this.isDragMe = surveyElement.isDragMe;
        }
    };
    PageAdorner.prototype.detachElement = function (surveyElement) {
        if (!!surveyElement) {
            surveyElement.unRegisterFunctionOnPropertiesValueChanged(["elements"], "updatePlaceholder");
            surveyElement.unRegisterFunctionOnPropertiesValueChanged(["dragTypeOverMe", "isDragMe"], "dragOver");
            surveyElement.unRegisterFunctionOnPropertiesValueChanged(["title", "description"], "add_ghost");
            surveyElement.unRegisterFunctionOnPropertiesValueChanged(["visibleRows"], "updatePlaceholder");
            surveyElement["surveyChangedCallback"] = undefined;
        }
        _super.prototype.detachElement.call(this, surveyElement);
        if (!this.isDisposed) {
            this.dragTypeOverMe = null;
        }
    };
    PageAdorner.prototype.onElementSelectedChanged = function (isSelected) {
        _super.prototype.onElementSelectedChanged.call(this, isSelected);
        this.isSelected = isSelected;
        if (isSelected && this.creator.pageEditMode === "bypage") {
            this.setSurveyElement(this.creator.selectedElement);
        }
        if (isSelected) {
            this.onPageSelected();
        }
    };
    PageAdorner.prototype.patchPageForDragDrop = function (page, addGhostPage) {
        // need for the drag drop see https://github.com/surveyjs/survey-library/blob/871492817561de11f934ebdf50481770300a396a/src/dragdrop/survey-elements.ts#L266
        page["_isGhost"] = true;
        page["_addGhostPageViewModel"] = function () {
            delete page["_isGhost"];
            delete page["_addGhostPageViewModel"];
            addGhostPage();
        };
    };
    PageAdorner.prototype.addGhostPageSubsribes = function (surveyElement) {
        var _this = this;
        surveyElement.registerFunctionOnPropertiesValueChanged(["title", "description"], function () {
            _this.addGhostPage();
            _this.updateShowPlaceholder();
        }, "add_ghost");
        this.patchPageForDragDrop(this.surveyElement, this.addGhostPage);
    };
    Object.defineProperty(PageAdorner.prototype, "placeholderText", {
        get: function () {
            if (this.creator.isMobileView)
                return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ed.pagePlaceHolderMobile");
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ed.pagePlaceHolder");
        },
        enumerable: false,
        configurable: true
    });
    PageAdorner.prototype.isOperationsAllow = function () {
        return _super.prototype.isOperationsAllow.call(this) && !this.isGhost && this.creator.pageEditMode !== "single" && this.creator.allowModifyPages;
    };
    PageAdorner.prototype.getPage = function () {
        return this.surveyElement;
    };
    Object.defineProperty(PageAdorner.prototype, "page", {
        get: function () {
            return this.getPage();
        },
        enumerable: false,
        configurable: true
    });
    PageAdorner.prototype.createActionContainer = function () {
        var container = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ActionContainer();
        container.sizeMode = "small";
        container.cssClasses = {
            root: "svc-page-toolbar sv-action-bar",
            item: "svc-page-toolbar__item",
            itemWithTitle: "svc-page-toolbar__item--with-text",
            itemActive: "svc-page-toolbar__item--active",
            itemPressed: "svc-page-toolbar__item--pressed",
            itemIcon: "svc-page-toolbar-item__icon",
            itemTitle: "svc-page-toolbar-item__title",
            itemTitleWithIcon: "svc-page-toolbar-item__title--with-icon",
        };
        return container;
    };
    PageAdorner.prototype.getExpandCollapseAction = function () {
        var action = _super.prototype.getExpandCollapseAction.call(this);
        action.needSeparator = true;
        return action;
    };
    PageAdorner.prototype.select = function (model, event) {
        if (!model.isGhost) {
            if (model.creator.pageEditMode !== "single") {
                model.creator.selectElement(model.page, undefined, false);
                this.onPageSelected();
            }
            else {
                model.creator.selectElement(model.creator.survey, undefined, false);
            }
        }
        event.stopPropagation();
        event.cancelBubble = true;
    };
    Object.defineProperty(PageAdorner.prototype, "css", {
        get: function () {
            var result = _super.prototype.getCss.call(this);
            if (this.dragDropHelper.draggedElement && this.dragDropHelper.draggedElement.isPage) {
                if (this.dragTypeOverMe === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Top) {
                    result += " svc-question__content--drag-over-top";
                }
                if (this.dragTypeOverMe === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Bottom) {
                    result += " svc-question__content--drag-over-bottom";
                }
            }
            else {
                if (!!this.dragTypeOverMe && this.showPlaceholder) {
                    result = "svc-question__content--drag-over-inside";
                }
                else if (!!this.dragTypeOverMe && this.page.elements.length === 0 && this.creator.survey.pages.length > 0) {
                    result = "svc-page--drag-over-empty";
                    if (!!this.creator && !this.creator.showAddQuestionButton) {
                        result += " svc-page--drag-over-empty-no-add-button";
                    }
                }
                if (!!this.dragTypeOverMe && this.collapsed) {
                    this.dragIn();
                    result += " svc-page__content--collapsed-drag-over-inside";
                }
                else {
                    this.dragOut();
                }
            }
            if (this.allowExpandCollapse || this.page["isGhost"]) {
                result += (" svc-page__content--collapse-" + this.creator.expandCollapseButtonVisibility);
                if (this.renderedCollapsed || this.page["isGhost"])
                    result += (" svc-page__content--collapsed");
                if (this.expandCollapseAnimationRunning)
                    result += (" svc-page__content--animation-running");
            }
            if (this.isDragMe) {
                result += " svc-page__content--dragged";
            }
            if (this.isGhost) {
                return result + " svc-page__content--new";
            }
            if (this.creator.isElementSelected(this.page)) {
                result += " svc-page__content--selected";
            }
            return result.trim();
        },
        enumerable: false,
        configurable: true
    });
    PageAdorner.prototype.hoverStopper = function (event, element) {
        event["__svc_question_processed"] = true;
    };
    PageAdorner.prototype.duplicate = function () {
        var newElement = this.creator.copyPage(this.page);
        this.creator.selectElement(newElement);
    };
    PageAdorner.prototype.delete = function () {
        this.creator.deleteElement(this.page);
    };
    Object.defineProperty(PageAdorner.prototype, "addNewQuestionText", {
        get: function () {
            if (!this.currentAddQuestionType && this.creator)
                return this.creator.getLocString("ed.addNewQuestion");
            return !!this.creator ? this.creator.getAddNewQuestionText(this.currentAddQuestionType) : "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PageAdorner.prototype, "footerActionsBar", {
        get: function () {
            var _this = this;
            if (!this._footerActionsBar) {
                this._footerActionsBar = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ActionContainer();
                this._footerActionsBar.containerCss = "svc-page__footer";
                this._footerActionsBar.cssClasses = {
                    item: "svc-btn",
                    itemTitle: "svc-add-new-item-button__text"
                };
                var footerActions = [{
                        css: "svc-add-new-question-action",
                        visible: (new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.showAddQuestionButton; })),
                        component: "svc-add-new-question-btn",
                        data: this
                    }];
                footerActions = this.creator.getUpdatedPageAdornerFooterActions(this, footerActions);
                this.footerActionsBar.setItems(footerActions);
            }
            return this._footerActionsBar;
        },
        enumerable: false,
        configurable: true
    });
    PageAdorner.prototype.getAnimatedElement = function () {
        var _a;
        var cssClasses = this.surveyElement.cssClasses.page;
        if (cssClasses === null || cssClasses === void 0 ? void 0 : cssClasses.description) {
            return (_a = this.rootElement) === null || _a === void 0 ? void 0 : _a.querySelector(":scope ".concat((0,survey_core__WEBPACK_IMPORTED_MODULE_1__.classesToSelector)(cssClasses.description)));
        }
        return null;
    };
    PageAdorner.prototype.getInnerAnimatedElements = function () {
        var _a;
        var cssClasses = this.surveyElement.cssClasses;
        if (cssClasses.pageRow)
            return [].slice.call((_a = this.rootElement) === null || _a === void 0 ? void 0 : _a.querySelectorAll(":scope .svc-page__footer, :scope ".concat((0,survey_core__WEBPACK_IMPORTED_MODULE_1__.classesToSelector)(this.surveyElement.cssRoot), " > .svc-row")));
        return null;
    };
    PageAdorner.prototype.onPageSelected = function () { };
    PageAdorner.prototype.getAllowDragging = function (options) {
        return this.creator.allowDragPages && _super.prototype.getAllowDragging.call(this, options);
    };
    Object.defineProperty(PageAdorner.prototype, "dragDropHelper", {
        get: function () {
            return this.creator.dragDropSurveyElements;
        },
        enumerable: false,
        configurable: true
    });
    PageAdorner.prototype.onPointerDown = function (pointerDownEvent) {
        this.dragOrClickHelper.onPointerDown(pointerDownEvent);
    };
    Object.defineProperty(PageAdorner.prototype, "dropTargetName", {
        get: function () {
            if (!this.isGhost && !!this.page) {
                return this.page.name;
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], PageAdorner.prototype, "isSelected", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], PageAdorner.prototype, "isPageLive", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], PageAdorner.prototype, "showPlaceholder", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "" })
    ], PageAdorner.prototype, "currentAddQuestionType", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: null })
    ], PageAdorner.prototype, "dragTypeOverMe", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], PageAdorner.prototype, "isDragMe", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (val, target, prevVal) {
                if (val != prevVal) {
                    target.updateShowPlaceholder();
                    target.updateActionsProperties();
                    if (val && target.surveyElement) {
                        target.addGhostPageSubsribes(target.surveyElement);
                    }
                }
            },
        })
    ], PageAdorner.prototype, "isGhost", void 0);
    return PageAdorner;
}(_action_container_view_model__WEBPACK_IMPORTED_MODULE_2__.SurveyElementAdornerBase));



/***/ }),

/***/ "./src/components/question-dropdown.ts":
/*!*********************************************!*\
  !*** ./src/components/question-dropdown.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionDropdownAdornerViewModel: () => (/* binding */ QuestionDropdownAdornerViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question */ "./src/components/question.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");




__webpack_require__(/*! ./question-dropdown.scss */ "./src/components/question-dropdown.scss");
var QuestionDropdownAdornerViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionDropdownAdornerViewModel, _super);
    function QuestionDropdownAdornerViewModel(creator, surveyElement, templateData) {
        var _this = _super.call(this, creator, surveyElement, templateData) || this;
        _this.switchCollapse = function () {
            _this.isCollapsed = !_this.isCollapsed;
        };
        _this.visibleCount = creator.maxVisibleChoices;
        _this.isCollapsed = _this.isCollapsed && _this.needToCollapse;
        return _this;
    }
    Object.defineProperty(QuestionDropdownAdornerViewModel.prototype, "question", {
        get: function () {
            return this.surveyElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionDropdownAdornerViewModel.prototype, "itemComponent", {
        get: function () {
            if (this.surveyElement.isDescendantOf("dropdown")) {
                return "survey-radiogroup-item";
            }
            return "survey-checkbox-item";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionDropdownAdornerViewModel.prototype, "needToCollapse", {
        get: function () {
            return this.visibleCount > 0 && this.question.visibleChoices.length > this.visibleCount;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionDropdownAdornerViewModel.prototype, "isCollapseView", {
        get: function () {
            return this.isCollapsed;
        },
        enumerable: false,
        configurable: true
    });
    QuestionDropdownAdornerViewModel.prototype.leftFocus = function () {
        if (!this.creator.isElementSelected(this.surveyElement) && !this.isCollapsed) {
            this.isCollapsed = this.needToCollapse;
        }
    };
    QuestionDropdownAdornerViewModel.prototype.getChoiceCss = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append("svc-question__dropdown-choice")
            .append("svc-question__dropdown-choice--collapsed", this.isCollapsed && this.needToCollapse)
            .toString();
    };
    QuestionDropdownAdornerViewModel.prototype.getRenderedItems = function () {
        return this.isCollapsed ?
            this.question.renderedChoices.slice(0, this.visibleCount) :
            this.question.renderedChoices;
    };
    QuestionDropdownAdornerViewModel.prototype.getButtonText = function () {
        return !this.isCollapsed ?
            _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.showLessChoices") :
            _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.showMoreChoices");
    };
    QuestionDropdownAdornerViewModel.prototype.attachElement = function (surveyElement) {
        var _this = this;
        _super.prototype.attachElement.call(this, surveyElement);
        if (!!surveyElement) {
            surveyElement.registerFunctionOnPropertyValueChanged("isSelectedInDesigner", function () {
                _this.leftFocus();
            }, "dropdownCollapseChecker");
        }
    };
    QuestionDropdownAdornerViewModel.prototype.detachElement = function (surveyElement) {
        if (!!surveyElement) {
            surveyElement.unRegisterFunctionOnPropertyValueChanged("isSelectedInDesigner", "dropdownCollapseChecker");
        }
        _super.prototype.detachElement.call(this, surveyElement);
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], QuestionDropdownAdornerViewModel.prototype, "isCollapsed", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: -1 })
    ], QuestionDropdownAdornerViewModel.prototype, "visibleCount", void 0);
    return QuestionDropdownAdornerViewModel;
}(_question__WEBPACK_IMPORTED_MODULE_2__.QuestionAdornerViewModel));



/***/ }),

/***/ "./src/components/question-image.ts":
/*!******************************************!*\
  !*** ./src/components/question-image.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionImageAdornerViewModel: () => (/* binding */ QuestionImageAdornerViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _question__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./question */ "./src/components/question.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");





__webpack_require__(/*! ./question-image.scss */ "./src/components/question-image.scss");
var QuestionImageAdornerViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionImageAdornerViewModel, _super);
    function QuestionImageAdornerViewModel(creator, surveyElement, templateData) {
        var _this = _super.call(this, creator, surveyElement, templateData) || this;
        _this.imageLinkValueChangedHandler = function () {
            _this.isEmptyImageLink = !_this.question.imageLink;
            _this.filePresentationModel.value = null;
            _this.filePresentationModel.visible = !_this.question.imageLink;
        };
        _this.isEmptyImageLink = !_this.question.imageLink;
        _this.surveyElement.registerFunctionOnPropertyValueChanged("imageLink", _this.imageLinkValueChangedHandler, "imageLinkValueChanged");
        _this.surveyElement.locImageLink.onStringChanged.add(_this.imageLinkValueChangedHandler);
        _this.initFilePresentationModel();
        return _this;
    }
    QuestionImageAdornerViewModel.prototype.initFilePresentationModel = function () {
        var _this = this;
        this.filePresentationModel = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass("file", { name: this.question.name });
        this.editorSurveyModel = new survey_core__WEBPACK_IMPORTED_MODULE_1__.SurveyModel();
        this.filePresentationModel.setSurveyImpl(this.editorSurveyModel);
        this.filePresentationModel.forceIsInputReadOnly = !this.creator.isCanModifyProperty(this.question, "imageLink");
        this.filePresentationModel.filePlaceholder = this.placeholderText;
        this.filePresentationModel.chooseButtonCaption = this.chooseImageText;
        this.filePresentationModel.acceptedTypes = "image/*";
        this.filePresentationModel.storeDataAsText = false;
        this.filePresentationModel.cssClasses.chooseFileIconId = "icon-choosefile";
        this.editorSurveyModel.onOpenFileChooser.add(function (s, o) {
            _this.creator.chooseFiles(o.input, o.callback, o.context);
        });
        this.editorSurveyModel.onUploadFiles.add(function (s, o) {
            var fileToUpload = o.files[0];
            if (!!fileToUpload) {
                _this.isUploading = true;
                _this.creator.uploadFiles(o.files, _this.question, function (status, link) {
                    _this.question.imageLink = link;
                    o.callback(status, [{ content: link, file: o.files[0] }]);
                    _this.isUploading = false;
                }, { element: _this.question, elementType: _this.question.getType(), propertyName: "imageLink" });
            }
        });
    };
    QuestionImageAdornerViewModel.prototype.chooseFile = function (model) {
        var fileInput = model.rootElement.getElementsByClassName("svc-choose-file-input")[0];
        this.editorSurveyModel.chooseFiles(fileInput, function (files) {
            model.filePresentationModel.loadFiles(files);
        });
    };
    Object.defineProperty(QuestionImageAdornerViewModel.prototype, "acceptedTypes", {
        get: function () {
            return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.getAcceptedTypesByContentMode)(this.surveyElement.contentMode);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionImageAdornerViewModel.prototype, "isEmptyElement", {
        get: function () {
            return this.isEmptyImageLink;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionImageAdornerViewModel.prototype, "question", {
        get: function () {
            return this.surveyElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionImageAdornerViewModel.prototype, "placeholderText", {
        get: function () {
            if (this.creator.isMobileView)
                return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_4__.getLocString)("ed.imagePlaceHolderMobile");
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_4__.getLocString)("ed.imagePlaceHolder");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionImageAdornerViewModel.prototype, "chooseImageText", {
        get: function () {
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_4__.getLocString)("ed.imageChooseImage");
        },
        enumerable: false,
        configurable: true
    });
    QuestionImageAdornerViewModel.prototype.getAnimatedElement = function () {
        if (this.isEmptyImageLink) {
            var cssClasses = this.filePresentationModel.cssClasses;
            if (cssClasses.root) {
                return this.surveyElement.getWrapperElement().querySelector(":scope ".concat((0,survey_core__WEBPACK_IMPORTED_MODULE_1__.classesToSelector)(cssClasses.root)));
            }
        }
        return _super.prototype.getAnimatedElement.call(this);
    };
    QuestionImageAdornerViewModel.prototype.css = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append(_super.prototype.css.call(this))
            .append("svc-question__content--loading", this.isUploading).toString();
    };
    QuestionImageAdornerViewModel.prototype.dispose = function () {
        if (this.surveyElement) {
            this.surveyElement.unRegisterFunctionOnPropertyValueChanged("imageLink", "imageLinkValueChanged");
            this.surveyElement.locImageLink.onStringChanged.remove(this.imageLinkValueChangedHandler);
        }
        _super.prototype.dispose.call(this);
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], QuestionImageAdornerViewModel.prototype, "isUploading", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], QuestionImageAdornerViewModel.prototype, "isEmptyImageLink", void 0);
    return QuestionImageAdornerViewModel;
}(_question__WEBPACK_IMPORTED_MODULE_2__.QuestionAdornerViewModel));



/***/ }),

/***/ "./src/components/question-rating.ts":
/*!*******************************************!*\
  !*** ./src/components/question-rating.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionRatingAdornerViewModel: () => (/* binding */ QuestionRatingAdornerViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");




__webpack_require__(/*! ./question-rating.scss */ "./src/components/question-rating.scss");
var QuestionRatingAdornerViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionRatingAdornerViewModel, _super);
    function QuestionRatingAdornerViewModel(creator, surveyElement, templateData) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.surveyElement = surveyElement;
        _this.templateData = templateData;
        return _this;
    }
    Object.defineProperty(QuestionRatingAdornerViewModel.prototype, "element", {
        get: function () {
            return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.getQuestionFromObj)(this.surveyElement);
        },
        enumerable: false,
        configurable: true
    });
    QuestionRatingAdornerViewModel.useRateValues = function (element) {
        var el = !!element.contentQuestion ? element.contentQuestion : element;
        return !!el.useRateValues && el.useRateValues();
    };
    QuestionRatingAdornerViewModel.prototype.addItem = function (model) {
        if (!model.allowAdd)
            return;
        if (!model.enableAdd)
            return;
        if (!QuestionRatingAdornerViewModel.useRateValues(model.element)) {
            model.element.rateMax += model.element.rateStep;
        }
        else {
            var nextValue = null;
            var values = model.element.rateValues.map(function (item) {
                return item.value;
            });
            var itemText = model.creator.getChoicesItemBaseTitle();
            nextValue = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.getNextValue)(itemText, values);
            var itemValue = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue(nextValue);
            itemValue.locOwner = {
                getLocale: function () {
                    if (!!model.element["getLocale"])
                        return model.element.getLocale();
                    return "";
                },
                getMarkdownHtml: function (text) {
                    return text;
                },
                getProcessedText: function (text) {
                    return text;
                }
            };
            model.element.rateValues = model.element.rateValues.concat([itemValue]);
            var rateValues = model.element.rateValues;
            model.creator.onItemValueAddedCallback(model.element, "rateValues", rateValues[rateValues.length - 1], rateValues);
        }
    };
    QuestionRatingAdornerViewModel.prototype.removeItem = function (model) {
        if (!model.allowRemove)
            return;
        if (!model.enableRemove)
            return;
        var property = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(model.element.getType(), "rateValues");
        var itemIndex = model.element.rateValues && model.element.rateValues.length - 1;
        var item = (model.element.rateValues && model.element.rateValues[itemIndex]) || null;
        var allowDelete = model.creator.onCollectionItemDeletingCallback(model.element, property, model.element.rateValues, item);
        if (allowDelete) {
            var question = model.element;
            if (!QuestionRatingAdornerViewModel.useRateValues(model.element) &&
                itemIndex === question.rateValues.length - 1) {
                question.rateMax -= question.rateStep;
            }
            else {
                if (!QuestionRatingAdornerViewModel.useRateValues(model.element)) {
                    // eslint-disable-next-line no-self-assign
                    question.rateValues = question.rateValues;
                }
                question.rateValues.splice(itemIndex, 1);
            }
        }
    };
    QuestionRatingAdornerViewModel.allowAddForElement = function (element, maximumRateValues) {
        if ((maximumRateValues < 1 || maximumRateValues > survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.ratingMaximumRateValueCount) && !QuestionRatingAdornerViewModel.useRateValues(element))
            maximumRateValues = survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.ratingMaximumRateValueCount;
        if (element.rateDisplayMode == "smileys" && (maximumRateValues < 1 || maximumRateValues > 10))
            maximumRateValues = 10;
        if (maximumRateValues < 1)
            return true;
        return element.rateCount < maximumRateValues;
    };
    Object.defineProperty(QuestionRatingAdornerViewModel.prototype, "allowAdd", {
        get: function () {
            return this.canAddOrRemove();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionRatingAdornerViewModel.prototype, "enableAdd", {
        get: function () {
            return this.allowAdd && QuestionRatingAdornerViewModel.allowAddForElement(this.element, this.creator.maximumRateValues);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionRatingAdornerViewModel.prototype, "addClassNames", {
        get: function () {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("svc-item-value-controls__button")
                .append("svc-item-value-controls__button--disabled", !this.enableAdd)
                .append("svc-item-value-controls__add").toString();
        },
        enumerable: false,
        configurable: true
    });
    QuestionRatingAdornerViewModel.allowRemoveForElement = function (element) {
        return element.rateCount > 2;
    };
    QuestionRatingAdornerViewModel.prototype.canAddOrRemove = function () {
        return this.creator.isCanModifyProperty(this.element, "rateValues") &&
            this.creator.isCanModifyProperty(this.element, "rateCount") &&
            (!this.element.autoGenerate || this.creator.isCanModifyProperty(this.element, "rateMax"));
    };
    Object.defineProperty(QuestionRatingAdornerViewModel.prototype, "allowRemove", {
        get: function () {
            return this.canAddOrRemove();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionRatingAdornerViewModel.prototype, "enableRemove", {
        get: function () {
            return this.allowRemove && QuestionRatingAdornerViewModel.allowRemoveForElement(this.element);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionRatingAdornerViewModel.prototype, "removeClassNames", {
        get: function () {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("svc-item-value-controls__button")
                .append("svc-item-value-controls__button--disabled", !this.enableRemove)
                .append("svc-item-value-controls__remove").toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionRatingAdornerViewModel.prototype, "hasTopLabel", {
        get: function () {
            return (this.element.rateDescriptionLocation == "top" ||
                this.element.rateDescriptionLocation == "topBottom") &&
                !!this.element.minRateDescription;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionRatingAdornerViewModel.prototype, "controlsClassNames", {
        get: function () {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("svc-rating-question-controls")
                .append("svc-item-value-controls")
                .append("svc-rating-question-controls--labels-top", this.hasTopLabel).toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionRatingAdornerViewModel.prototype, "addTooltip", {
        get: function () {
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("pe.addItem");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionRatingAdornerViewModel.prototype, "removeTooltip", {
        get: function () {
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("pe.removeItem");
        },
        enumerable: false,
        configurable: true
    });
    return QuestionRatingAdornerViewModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/question.ts":
/*!************************************!*\
  !*** ./src/components/question.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionAdornerViewModel: () => (/* binding */ QuestionAdornerViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _questionconverter__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../questionconverter */ "./src/questionconverter.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _action_container_view_model__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./action-container-view-model */ "./src/components/action-container-view-model.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _string_editor__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./string-editor */ "./src/components/string-editor.ts");






__webpack_require__(/*! ./question.scss */ "./src/components/question.scss");


var QuestionAdornerViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionAdornerViewModel, _super);
    function QuestionAdornerViewModel(creator, surveyElement, templateData) {
        var _this = _super.call(this, creator, surveyElement) || this;
        _this.templateData = templateData;
        _this.startDragSurveyElement = function (event) {
            var element = _this.surveyElement;
            var isElementSelected = _this.creator.selectedElement === element;
            _this.dragDropHelper.startDragSurveyElement(event, element, isElementSelected);
            return true;
        };
        _this.addNewQuestion = function () {
            _this.creator.addNewQuestionInPage(function (type) { }, _this.surveyElement instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.PanelModelBase ? _this.surveyElement : null, _this.currentAddQuestionType || _creator_settings__WEBPACK_IMPORTED_MODULE_6__.settings.designer.defaultAddQuestionType);
        };
        _this.questionTypeSelectorModel = _this.creator.getQuestionTypeSelectorModel(function (type) { _this.currentAddQuestionType = type; }, _this.surveyElement);
        if (surveyElement.isQuestion &&
            !!surveyElement["setCanShowOptionItemCallback"]) {
            surveyElement.setCanShowOptionItemCallback(function (item) {
                if (creator.readOnly)
                    return false;
                if (item !== _this.surveyElement.newItem)
                    return true;
                return (creator.maximumChoicesCount < 1 ||
                    surveyElement["choices"].length < creator.maximumChoicesCount);
            });
        }
        _this.checkActionProperties();
        _this.dragOrClickHelper = new survey_core__WEBPACK_IMPORTED_MODULE_1__.DragOrClickHelper(_this.startDragSurveyElement);
        _string_editor__WEBPACK_IMPORTED_MODULE_7__.StringItemsNavigatorBase.setQuestion(_this);
        return _this;
    }
    QuestionAdornerViewModel.prototype.canSelectElement = function () {
        return _super.prototype.canSelectElement.call(this) && this.surveyElement.isInteractiveDesignElement;
    };
    QuestionAdornerViewModel.prototype.select = function (model, event) {
        if (!model.canSelectElement())
            return;
        var creator = model.creator;
        var selEl = model.surveyElement;
        var el = document === null || document === void 0 ? void 0 : document.activeElement;
        if (creator.selectedElement !== selEl && !!el && !!el.blur && el.tagName.toLocaleLowerCase() === "input") {
            el.blur();
        }
        event.stopPropagation();
        event.cancelBubble = true;
        creator.selectElement(selEl, undefined, false);
        return true;
    };
    QuestionAdornerViewModel.prototype.rootCss = function () {
        var isStartWithNewLine = this.surveyElement.isQuestion && !this.surveyElement.startWithNewLine;
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append(_super.prototype.getCss.call(this))
            .append("svc-question__adorner")
            .append("svc-question__adorner--selected", !!this.creator.isElementSelected(this.surveyElement))
            .append("svc-question__adorner--collapsed", this.renderedCollapsed)
            .append("svc-question__adorner--start-with-new-line", isStartWithNewLine)
            .append("svc-question__adorner--collapse-" + this.creator.expandCollapseButtonVisibility, true).toString();
    };
    QuestionAdornerViewModel.prototype.css = function () {
        if (!this.surveyElement.isInteractiveDesignElement)
            return "";
        var result = "svc-question__content";
        result += typeof this.surveyElement.getType === "function" ? (" svc-question__content--" + this.surveyElement.getType()) : "";
        if (this.creator.isElementSelected(this.surveyElement)) {
            result += " svc-question__content--selected";
        }
        if (this.isEmptyElement) {
            result += " svc-question__content--empty";
        }
        if (this.isEmptyTemplate) {
            result += " svc-question__content--empty-template";
        }
        if (this.renderedCollapsed) {
            result += " svc-question__content--collapsed";
        }
        if (!this.surveyElement.hasTitle || (!this.surveyElement.isPanel && this.surveyElement.getTitleLocation() === "hidden")) {
            result += " svc-question__content--title-hidden";
        }
        if (this.surveyElement.hasTitleOnBottom) {
            result += " svc-question__content--title-bottom";
        }
        if (this.isDragMe) {
            result += " svc-question__content--dragged";
        }
        if (!!this.dragTypeOverMe && (this.canExpandOnDrag) && this.dragInsideCollapsedContainer) {
            this.dragIn();
            result += " svc-question__content--collapsed-drag-over-inside";
        }
        else {
            this.dragOut();
        }
        if (this.dragTypeOverMe === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.InsideEmptyPanel) {
            result += " svc-question__content--drag-over-inside";
        }
        if (!this.dragInsideCollapsedContainer) {
            if (this.dragTypeOverMe === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Left) {
                result += " svc-question__content--drag-over-left";
            }
            if (this.dragTypeOverMe === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Right) {
                result += " svc-question__content--drag-over-right";
            }
            if (this.dragTypeOverMe === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Top) {
                result += " svc-question__content--drag-over-top";
            }
            if (this.dragTypeOverMe === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Bottom) {
                result += " svc-question__content--drag-over-bottom";
            }
            if (this.creator) {
                result = this.creator.getElementAddornerCssCallback(this.surveyElement, result);
            }
        }
        return result;
    };
    Object.defineProperty(QuestionAdornerViewModel.prototype, "isTitleLeft", {
        get: function () {
            return (!this.surveyElement.isPanel && this.surveyElement.getTitleLocation() === "left");
        },
        enumerable: false,
        configurable: true
    });
    QuestionAdornerViewModel.prototype.getAnimatedElement = function () {
        var _a, _b;
        var cssClasses = this.surveyElement.isPanel ? this.surveyElement.cssClasses.panel : this.surveyElement.cssClasses;
        var cssContent = cssClasses.content;
        if (this.surveyElement.isDescendantOf("rating")) {
            cssContent = "svc-rating-question-content";
        }
        if (this.isTitleLeft) {
            return (_a = this.rootElement) === null || _a === void 0 ? void 0 : _a.querySelector(":scope ".concat((0,survey_core__WEBPACK_IMPORTED_MODULE_1__.classesToSelector)(this.surveyElement.getRootCss())));
        }
        if (cssContent) {
            return (_b = this.rootElement) === null || _b === void 0 ? void 0 : _b.querySelector(":scope ".concat((0,survey_core__WEBPACK_IMPORTED_MODULE_1__.classesToSelector)(cssContent)));
        }
        return null;
    };
    QuestionAdornerViewModel.prototype.getInnerAnimatedElements = function () {
        var _a;
        var cssRoot = this.surveyElement.isPanel ? this.surveyElement.getContainerCss() : this.surveyElement.getRootCss();
        var cssDescription = this.surveyElement.cssDescription;
        var selectorArray = [
            ":scope > .svc-question__content > *:not(.svc-question__drag-area):not(".concat((0,survey_core__WEBPACK_IMPORTED_MODULE_1__.classesToSelector)(cssRoot), ")"),
        ];
        if (!this.isTitleLeft && cssDescription)
            selectorArray.push(":scope ".concat((0,survey_core__WEBPACK_IMPORTED_MODULE_1__.classesToSelector)(cssDescription)));
        var res = [].slice.call((_a = this.rootElement) === null || _a === void 0 ? void 0 : _a.querySelectorAll(selectorArray.join(",")));
        res.push(this.rootElement);
        return res;
    };
    QuestionAdornerViewModel.prototype.expandWithDragIn = function () {
        _super.prototype.expandWithDragIn.call(this);
        this.element.dragTypeOverMe = null;
        this.creator.dragDropSurveyElements.dropTarget = null;
    };
    Object.defineProperty(QuestionAdornerViewModel.prototype, "isDragMe", {
        get: function () {
            return this.surveyElement.isDragMe;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "dragTypeOverMe", {
        get: function () {
            return this.element.dragTypeOverMe;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "isBannerShowing", {
        get: function () {
            return this.isUsingCarryForward || this.isUsingRestfull || this.isMessagePanelVisible;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "isUsingCarryForward", {
        get: function () {
            var _a;
            return (_a = this.element) === null || _a === void 0 ? void 0 : _a.isUsingCarryForward;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "isUsingRestfull", {
        get: function () {
            var _a;
            return (_a = this.element) === null || _a === void 0 ? void 0 : _a.isUsingRestful;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "isMessagePanelVisible", {
        get: function () {
            var _a;
            return (_a = (this.element)) === null || _a === void 0 ? void 0 : _a.getPropertyValue("isMessagePanelVisible");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "cssCollapsedHiddenHeader", {
        get: function () {
            var css = new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append(this.element.cssHeader)
                .append("svc-element__header--hidden")
                .append("svc-element__header--lazy", !this.needToRenderContent)
                .toString();
            return css;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "cssCollapsedHiddenTitle", {
        get: function () {
            return this.element.cssTitle + " svc-element__title--hidden";
        },
        enumerable: false,
        configurable: true
    });
    QuestionAdornerViewModel.prototype.createBannerParams = function () {
        return this.createCarryForwardParams() || this.createUsingRestfulParams() || this.createCustomMessagePanel();
    };
    QuestionAdornerViewModel.prototype.createCarryForwardParams = function () {
        var _this = this;
        var _a;
        if (!this.isUsingCarryForward)
            return null;
        var name = (_a = this.element) === null || _a === void 0 ? void 0 : _a.choicesFromQuestion;
        if (!name)
            return null;
        var question = this.creator.survey.getQuestionByName(name);
        if (!question)
            return null;
        return {
            actionText: question.name,
            text: this.creator.getLocString("ed.carryForwardChoicesCopied"),
            onClick: function () { _this.creator.selectElement(question); }
        };
    };
    QuestionAdornerViewModel.prototype.createUsingRestfulParams = function () {
        var _this = this;
        if (!this.isUsingRestfull)
            return null;
        return {
            actionText: this.creator.getLocString("ed.choicesLoadedFromWebLinkText"),
            text: this.creator.getLocString("ed.choicesLoadedFromWebText"),
            onClick: function () { _this.creator.selectElement(_this.element, "choicesByUrl"); }
        };
    };
    QuestionAdornerViewModel.prototype.createCustomMessagePanel = function () {
        if (!this.isMessagePanelVisible)
            return null;
        var res = {
            question: this.element,
            actionText: "",
            messageText: "",
            onClick: function () { }
        };
        if (this.creator) {
            this.creator.onCreateCustomMessagePanel.fire(this.creator, res);
        }
        res.text = res.messageText;
        return res;
    };
    QuestionAdornerViewModel.prototype.detachElement = function (surveyElement) {
        if (surveyElement) {
            surveyElement.unRegisterFunctionOnPropertyValueChanged("isRequired", "isRequiredAdorner");
            surveyElement.unRegisterFunctionOnPropertiesValueChanged(["inputType", "rateType"], "inputTypeAdorner");
            if (!!surveyElement["setCanShowOptionItemCallback"]) {
                surveyElement.setCanShowOptionItemCallback(undefined);
            }
        }
        _super.prototype.detachElement.call(this, this.element);
    };
    QuestionAdornerViewModel.prototype.attachElement = function (surveyElement) {
        var _this = this;
        _super.prototype.attachElement.call(this, surveyElement);
        if (surveyElement) {
            surveyElement.registerFunctionOnPropertyValueChanged("isRequired", function (newValue) {
                var requiredAction = _this.actionContainer.getActionById("isrequired");
                _this.updateRequiredAction(requiredAction);
            }, "isRequiredAdorner");
        }
    };
    Object.defineProperty(QuestionAdornerViewModel.prototype, "isDraggable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "hoverDelay", {
        get: function () {
            if (this.creator["animationEnabled"]) {
                return this.creator.pageHoverDelay;
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    QuestionAdornerViewModel.prototype.hover = function (event, element) {
        if (!this.surveyElement.isInteractiveDesignElement) {
            return;
        }
        _super.prototype.hover.call(this, event, element);
    };
    QuestionAdornerViewModel.prototype.createActionContainers = function () {
        _super.prototype.createActionContainers.call(this);
        var defaultCssClasses = {
            root: "svc-survey-element-toolbar sv-action-bar",
            item: "svc-survey-element-toolbar__item",
            itemWithTitle: "svc-survey-element-toolbar__item--with-text",
            itemAsIcon: "svc-survey-element-toolbar__item--icon",
            itemActive: "svc-survey-element-toolbar__item--active",
            itemPressed: "svc-survey-element-toolbar__item--pressed",
            itemIcon: "svc-survey-element-toolbar-item__icon",
            itemTitle: "svc-survey-element-toolbar-item__title",
            itemTitleWithIcon: "svc-survey-element-toolbar-item__title--with-icon",
        };
        this.actionContainer.sizeMode = "small";
        this.actionContainer.cssClasses = defaultCssClasses;
        this.actionContainer.dotsItem.css += " svc-survey-element-toolbar__dots-item";
        this.actionContainer.dotsItem.innerCss += " svc-survey-element-toolbar__item";
        this.topActionContainer = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ActionContainer();
        this.topActionContainer.cssClasses = {
            root: "svc-survey-element-top-toolbar sv-action-bar",
            item: "svc-survey-element-top-toolbar__item",
            itemIcon: "svc-survey-element-toolbar-item__icon",
            itemTitle: "svc-survey-element-toolbar-item__title",
            itemTitleWithIcon: "svc-survey-element-toolbar-item__title--with-icon",
        };
        this.topActionContainer.sizeMode = "small";
        this.topActionContainer.setItems([this.expandCollapseAction]);
    };
    QuestionAdornerViewModel.prototype.getActionById = function (id) {
        var res = _super.prototype.getActionById.call(this, id);
        if (!res) {
            res = this.topActionContainer.getActionById(id);
        }
        return res;
    };
    QuestionAdornerViewModel.prototype.updateActionsProperties = function () {
        if (this.isDisposed)
            return;
        _super.prototype.updateActionsProperties.call(this);
        var actions = this.actionContainer.visibleActions;
        var switchToStartLocation = false;
        for (var i = actions.length - 1; i >= 0; i--) {
            if (actions[i].id === "convertTo")
                switchToStartLocation = true;
            if (!actions[i].innerItem.location)
                actions[i].innerItem.location = switchToStartLocation ? "start" : "end";
        }
    };
    QuestionAdornerViewModel.prototype.updateElementAllowOptions = function (options, operationsAllow) {
        _super.prototype.updateElementAllowOptions.call(this, options, operationsAllow);
        this.updateActionVisibility("convertTo", operationsAllow && options.allowChangeType);
        this.updateActionVisibilityByProp("isrequired", "isRequired", operationsAllow && options.allowChangeRequired);
        this.updateActionVisibilityByProp("convertInputType", "inputType", options.allowChangeInputType);
        this.updateActionVisibilityByProp("convertInputType", "rateDisplayMode", options.allowChangeInputType);
    };
    QuestionAdornerViewModel.prototype.updateActionVisibilityByProp = function (actionName, propName, allow) {
        var prop = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(this.surveyElement.getType(), propName);
        if (!prop)
            return;
        var isPropReadOnly = this.creator.onIsPropertyReadOnlyCallback(this.surveyElement, prop, prop.readOnly, null, null);
        this.updateActionVisibility(actionName, allow && !isPropReadOnly);
    };
    Object.defineProperty(QuestionAdornerViewModel.prototype, "isEmptyElement", {
        get: function () {
            if (this.surveyElement instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionHtmlModel) {
                return !this.surveyElement.html;
            }
            if (this.surveyElement instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.PanelModelBase) {
                var panel = this.surveyElement;
                return (!panel.rows || panel.rows.length <= 0 || panel.elements.length === 0);
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "isEmptyTemplate", {
        get: function () {
            if (this.surveyElement instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionPanelDynamicModel) {
                return this.surveyElement.templateElements.length == 0;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "showHiddenTitle", {
        get: function () {
            return (!this.element.hasTitle || this.isTitleLeft || !this.needToRenderContent) && this.element.isInteractiveDesignElement;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "placeholderText", {
        get: function () {
            if (this.surveyElement instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionHtmlModel) {
                return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.htmlPlaceHolder");
            }
            if (this.creator.isMobileView)
                return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.panelPlaceHolderMobile");
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.panelPlaceHolder");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionAdornerViewModel.prototype, "dragDropHelper", {
        get: function () {
            return this.creator.dragDropSurveyElements;
        },
        enumerable: false,
        configurable: true
    });
    QuestionAdornerViewModel.prototype.onPointerDown = function (pointerDownEvent) {
        this.dragOrClickHelper.onPointerDown(pointerDownEvent);
    };
    QuestionAdornerViewModel.prototype.getConvertToTypes = function () {
        var _this = this;
        var availableItems = this.creator.getAvailableToolboxItems(this.element, false);
        var itemNames = [];
        availableItems.forEach(function (item) {
            if (itemNames.indexOf(item.typeName) == -1) {
                itemNames.push(item.typeName);
            }
        });
        var convertClasses = _questionconverter__WEBPACK_IMPORTED_MODULE_3__.QuestionConverter.getConvertToClasses(this.currentType, itemNames, true);
        var res = [];
        convertClasses.forEach(function (className) {
            var items = _this.creator.toolbox.items.filter(function (item) { return item.name == className; });
            if (Array.isArray(items) && items.length > 0) {
                var item = items[0];
                res.push(item);
            }
        });
        return res;
    };
    QuestionAdornerViewModel.prototype.buildDefaultJsonMap = function (availableItems) {
        var defaultJsons = {};
        function addItemJson(toolboxItem) {
            var _a;
            var type = ((_a = toolboxItem.json) === null || _a === void 0 ? void 0 : _a.type) || toolboxItem.id;
            if (toolboxItem.json) {
                var json = toolboxItem.json;
                if (!defaultJsons[type])
                    defaultJsons[type] = [];
                defaultJsons[type].push(json);
            }
        }
        availableItems.forEach(function (toolboxItem) {
            addItemJson(toolboxItem);
            (toolboxItem.items || []).forEach(function (toolboxSubitem) {
                addItemJson(toolboxSubitem);
            });
        });
        return defaultJsons;
    };
    QuestionAdornerViewModel.prototype.convertQuestion = function (questionType, json, defaultJsons) {
        var _this = this;
        var type = (json === null || json === void 0 ? void 0 : json.type) || questionType;
        var newJson = {};
        (defaultJsons[type] || []).forEach(function (djson) {
            if (_this.jsonIsCorresponded(djson)) {
                newJson = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, json);
                var objJson_1 = _this.element.toJSON();
                var cleanJson_1 = _this.cleanDefaultsFromJson(type, djson);
                Object.keys(djson).forEach(function (p) {
                    if (p != "type" && !newJson[p])
                        newJson[p] = undefined;
                });
                Object.keys(json || {}).forEach(function (p) {
                    if (p != "type" && !(!objJson_1[p] || cleanJson_1[p]))
                        newJson[p] = undefined;
                });
            }
        });
        this.creator.convertCurrentQuestion(type, newJson);
    };
    QuestionAdornerViewModel.prototype.getConvertToTypesActions = function () {
        var _this = this;
        var availableItems = this.getConvertToTypes();
        var defaultJsons = this.buildDefaultJsonMap(availableItems);
        var newItems = [];
        var lastItem = null;
        availableItems.forEach(function (item) {
            var needSeparator = lastItem && item.category != lastItem.category;
            var action = _this.creator.createIActionBarItemByClass(item, needSeparator, function (questionType, json) {
                _this.convertQuestion(questionType, json, defaultJsons);
            });
            lastItem = item;
            newItems.push(action);
        });
        return newItems;
    };
    Object.defineProperty(QuestionAdornerViewModel.prototype, "currentType", {
        get: function () {
            return this.surveyElement.getType();
        },
        enumerable: false,
        configurable: true
    });
    QuestionAdornerViewModel.prototype.createConvertToAction = function () {
        var _this = this;
        // const actions = this.getConvertToTypesActions();
        // const allowChangeType: boolean = actions.length > 0;
        // const selItem = this.getSelectedItem(actions, this.currentType);
        // let actionTitle = !!selItem ? selItem.title : editorLocalization.getString("qt." + this.currentType);
        var availableItems = this.creator.getAvailableToolboxItems(this.element, false);
        var currItem = availableItems.filter(function (item) { return item.name === _this.currentType; })[0];
        var actionData = {
            id: "convertTo",
            enabled: true,
            visibleIndex: 0,
            title: !!currItem ? currItem.title : _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("qt." + this.currentType),
            iconName: "icon-chevron_16x16",
            iconSize: "auto"
        };
        var newAction = this.createDropdownModel({
            actionData: actionData,
            items: [],
            updateListModel: function (listModel) {
                _this.updateQuestionTypeOrSubtypeListModel(listModel, false);
            }
        });
        newAction.iconName = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
            var _a;
            if (newAction.mode === "small") {
                return (_a = _this.creator.toolbox.getItemByName(_this.element.getType())) === null || _a === void 0 ? void 0 : _a.iconName;
            }
            return "icon-chevron_16x16";
        });
        newAction.disableHide = true;
        return newAction;
    };
    QuestionAdornerViewModel.prototype.jsonsAreCompatible = function (objJson, json) {
        var _this = this;
        var jsonIsCorresponded = true;
        Object.keys(json).forEach(function (p) {
            var propertyValue = objJson[p] === undefined ? _this.element.getDefaultPropertyValue(p) : objJson[p];
            if (p != "type" && !survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isTwoValueEquals(json[p], propertyValue))
                jsonIsCorresponded = false;
        });
        return jsonIsCorresponded;
    };
    QuestionAdornerViewModel.prototype.jsonIsCorresponded = function (json) {
        return this.jsonsAreCompatible(this.element.toJSON(), json);
    };
    QuestionAdornerViewModel.prototype.toolboxItemIsCorresponded = function (toolboxItem, someItemSelectedAlready) {
        var elementType = this.element.getType();
        var json = toolboxItem.json;
        if (toolboxItem.id == elementType || toolboxItem.json.type == elementType) {
            return !someItemSelectedAlready || this.jsonIsCorresponded(json);
        }
    };
    QuestionAdornerViewModel.prototype.cleanDefaultsFromJson = function (type, toolboxItemJson) {
        var question = survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionFactory.Instance.createQuestion(type, "question");
        if (!question)
            return toolboxItemJson;
        question.fromJSON(toolboxItemJson);
        var json = question.toJSON();
        json["type"] = type;
        delete json.name;
        return json;
    };
    QuestionAdornerViewModel.prototype.updateQuestionTypeOrSubtypeListModel = function (listModel, subtypeOnly) {
        var _this = this;
        var _a;
        var availableItems = this.getConvertToTypes();
        var defaultJsons = this.buildDefaultJsonMap(availableItems);
        var newItems = [];
        var lastItem;
        var selectedAction;
        var selectedSubaction = undefined;
        var selectedSubactions = undefined;
        availableItems.forEach(function (item) {
            var _a;
            var needSeparator = lastItem && item.category != lastItem.category;
            var action = _this.creator.createIActionBarItemByClass(item, needSeparator, function (questionType, json) { _this.convertQuestion(questionType, json, defaultJsons); });
            if (_this.toolboxItemIsCorresponded(item, !!selectedAction)) {
                selectedAction = action;
                selectedSubactions = item.items;
            }
            if (((_a = item.items) === null || _a === void 0 ? void 0 : _a.length) > 0 && _this.creator.toolbox.showSubitems) {
                var subactions_1 = [];
                var selectedSubactionLocal_1 = undefined;
                var allChildsAreCompatibleToParent_1 = false;
                item.items.forEach(function (subitem) {
                    var subaction = _this.creator.createIActionBarItemByClass(subitem, false, function (questionType, json) { _this.convertQuestion(questionType, json, defaultJsons); });
                    if (_this.toolboxItemIsCorresponded(subitem, !!selectedAction))
                        selectedSubactionLocal_1 = subitem;
                    if (_this.jsonsAreCompatible(item.json, subitem.json))
                        allChildsAreCompatibleToParent_1 = true;
                    subactions_1.push(subaction);
                });
                if (!allChildsAreCompatibleToParent_1 && subactions_1.length > 0) {
                    var defaultSubaction = _this.creator.createIActionBarItemByClass(item, false, function (questionType, json) { _this.convertQuestion(questionType, json, defaultJsons); });
                    defaultSubaction.id = action.id + "-default";
                    defaultSubaction.iconName = undefined;
                    defaultSubaction.markerIconName = undefined;
                    defaultSubaction.items = [];
                    defaultSubaction.component = undefined;
                    subactions_1.unshift(defaultSubaction);
                    if (selectedAction == action && !selectedSubactionLocal_1)
                        selectedSubactionLocal_1 = defaultSubaction;
                }
                action.setSubItems({ items: subactions_1 });
                if (selectedSubactionLocal_1) {
                    selectedAction = action;
                    selectedSubaction = selectedSubactionLocal_1;
                    selectedSubactions = subactions_1;
                }
            }
            lastItem = item;
            newItems.push(action);
        });
        if (subtypeOnly) {
            if (selectedSubactions) {
                listModel.setItems(selectedSubactions);
                listModel.selectedItem = selectedSubaction;
                return !!selectedSubactions;
            }
        }
        else {
            var _listModel = (_a = selectedAction === null || selectedAction === void 0 ? void 0 : selectedAction.popupModel) === null || _a === void 0 ? void 0 : _a.contentComponentData.model;
            if (_listModel)
                _listModel.selectedItem = selectedSubaction;
            listModel.setItems(newItems);
            listModel.selectedItem = selectedAction;
        }
    };
    QuestionAdornerViewModel.prototype.createConvertInputType = function () {
        var _this = this;
        var _a;
        if (!this.surveyElement || this.surveyElement.isPanel) {
            return null;
        }
        var listModel = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ListModel([]);
        this.updateQuestionTypeOrSubtypeListModel(listModel, true);
        if (listModel.actions.length == 0)
            return null;
        var actionData = {
            id: "convertInputType",
            visibleIndex: 1,
            title: ((_a = listModel.selectedItem) === null || _a === void 0 ? void 0 : _a.title) || "SUBTYPE",
            disableShrink: true,
            iconName: "icon-chevron_16x16"
        };
        var newAction = this.createDropdownModel({
            actionData: actionData,
            items: [],
            updateListModel: function (listModel) {
                _this.updateQuestionTypeOrSubtypeListModel(listModel, true);
            }
        });
        this.surveyElement.registerFunctionOnPropertiesValueChanged(["inputType", "rateType"], function () {
            var popup = newAction.popupModel;
            var list = popup.contentComponentData.model;
            _this.updateQuestionTypeOrSubtypeListModel(list, true);
            newAction.title = list.selectedItem.title;
        }, "inputTypeAdorner");
        newAction.removePriority = 1;
        return newAction;
    };
    QuestionAdornerViewModel.prototype.getSelectedItem = function (actions, id) {
        var selectedItems = actions.filter(function (item) { return item.id === id; });
        return selectedItems.length > 0 ? selectedItems[0] : undefined;
    };
    QuestionAdornerViewModel.prototype.createDropdownModel = function (options) {
        var newAction = (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.createDropdownActionModel)({
            id: options.actionData.id,
            css: "svc-dropdown-action--convertTo",
            iconName: options.actionData.iconName,
            iconSize: "auto",
            title: options.actionData.title,
            enabled: options.actionData.enabled,
            visibleIndex: options.actionData.visibleIndex,
            disableShrink: options.actionData.disableShrink,
            location: "start",
            action: function (newType) {
            },
        }, {
            items: [],
            allowSelection: true,
            horizontalPosition: "center",
            cssClass: "svc-creator-popup",
        });
        newAction.popupModel.onVisibilityChanged.add(function (_, opt) {
            if (opt.isVisible) {
                var listModel_1 = newAction.popupModel.contentComponentData.model;
                options.updateListModel(listModel_1);
            }
        });
        var listModel = newAction.popupModel.contentComponentData.model;
        // options.updateListModel(listModel);
        if (listModel.selectedItem)
            newAction.title = listModel.selectedItem.title;
        newAction.popupModel.displayMode = this.creator.isTouch ? "overlay" : "popup";
        newAction.data.locOwner = this.creator;
        return newAction;
    };
    QuestionAdornerViewModel.prototype.updateRequiredAction = function (requiredAction) {
        var _a;
        if (!requiredAction)
            return;
        var isRequired = (_a = this.surveyElement) === null || _a === void 0 ? void 0 : _a.isRequired;
        requiredAction.ariaChecked = isRequired;
        requiredAction.active = isRequired;
        requiredAction.innerItem.title = isRequired ? this.creator.getLocString("pe.removeRequiredMark") : this.creator.getLocString("pe.markRequired");
    };
    QuestionAdornerViewModel.prototype.createRequiredAction = function () {
        var _this = this;
        this.surveyElement.isRequired;
        var actionSetup = {
            id: "isrequired",
            ariaRole: "checkbox",
            css: "svc-action-bar-item--right",
            innerCss: "svc-required-action",
            visibleIndex: 20,
            iconName: "icon-required",
            iconSize: "auto",
            action: function () {
                var _a;
                if (_this.creator.isCanModifyProperty(_this.surveyElement, "isRequired")) {
                    _this.surveyElement.isRequired = _this.getUpdatedPropertyValue("isRequired", !((_a = _this.surveyElement) === null || _a === void 0 ? void 0 : _a.isRequired));
                }
            }
        };
        var innerAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action(actionSetup);
        var requiredAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action(actionSetup);
        requiredAction.title = this.creator.getLocString("pe.isRequired");
        requiredAction.innerItem = innerAction;
        this.updateRequiredAction(requiredAction);
        return requiredAction;
    };
    QuestionAdornerViewModel.prototype.getUpdatedPropertyValue = function (propName, newValue) {
        var options = {
            obj: this.element,
            propertyName: propName,
            value: this.element[propName],
            newValue: newValue,
            doValidation: false
        };
        this.creator.onValueChangingCallback(options);
        return options.newValue;
    };
    QuestionAdornerViewModel.prototype.buildActions = function (items) {
        _super.prototype.buildActions.call(this, items);
        var element = this.surveyElement;
        items.push(this.createConvertToAction());
        var inputTypeConverter = this.createConvertInputType();
        if (!!inputTypeConverter) {
            items.push(inputTypeConverter);
        }
        items[items.length - 1].css += " svc-dropdown-action--convertTo-last";
        if (typeof element["isRequired"] !== "undefined" &&
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_4__.propertyExists)(element, "isRequired") &&
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_4__.isPropertyVisible)(element, "isRequired")) {
            items.push(this.createRequiredAction());
        }
    };
    QuestionAdornerViewModel.prototype.duplicate = function () {
        var _this = this;
        setTimeout(function () {
            _this.creator.fastCopyQuestion(_this.surveyElement, true);
        }, 1);
    };
    Object.defineProperty(QuestionAdornerViewModel.prototype, "addNewQuestionText", {
        get: function () {
            if (!this.currentAddQuestionType && this.creator)
                return this.creator.getLocString("ed.addNewQuestion");
            return !!this.creator ? this.creator.getAddNewQuestionText(this.currentAddQuestionType) : "";
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "" })
    ], QuestionAdornerViewModel.prototype, "currentAddQuestionType", void 0);
    return QuestionAdornerViewModel;
}(_action_container_view_model__WEBPACK_IMPORTED_MODULE_5__.SurveyElementAdornerBase));



/***/ }),

/***/ "./src/components/results.ts":
/*!***********************************!*\
  !*** ./src/components/results.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SurveyResultsItemModel: () => (/* binding */ SurveyResultsItemModel),
/* harmony export */   SurveyResultsModel: () => (/* binding */ SurveyResultsModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_2__);



__webpack_require__(/*! ./results.scss */ "./src/components/results.scss");
var SurveyResultsItemModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyResultsItemModel, _super);
    function SurveyResultsItemModel(survey, _data, _lvl) {
        var _this = _super.call(this) || this;
        _this.survey = survey;
        _this._data = _data;
        _this._lvl = _lvl;
        _this.toggle = function () {
            _this.collapsed = !_this.collapsed;
        };
        _this.markerWidth = 16;
        _this.question = survey.getQuestionByName(_this.name);
        _this.items = addCollapsed(survey, _data.data, _lvl + 1);
        _this.lvl = _lvl;
        return _this;
    }
    Object.defineProperty(SurveyResultsItemModel.prototype, "data", {
        get: function () {
            return this.items;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsItemModel.prototype, "isNode", {
        get: function () {
            return this._data.isNode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsItemModel.prototype, "name", {
        get: function () {
            return this._data.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsItemModel.prototype, "title", {
        get: function () {
            return this._data.title;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsItemModel.prototype, "value", {
        get: function () {
            return this._data.value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsItemModel.prototype, "displayValue", {
        get: function () {
            return this._data.displayValue;
        },
        enumerable: false,
        configurable: true
    });
    SurveyResultsItemModel.prototype.getString = function (data) {
        return this._data.getString(data);
    };
    Object.defineProperty(SurveyResultsItemModel.prototype, "markerMargin", {
        get: function () {
            return (1.5 + this.lvl) * this.markerWidth + "px";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsItemModel.prototype, "textMargin", {
        get: function () {
            return (2.75 + this.lvl) * this.markerWidth + "px";
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.property)({ defaultValue: true })
    ], SurveyResultsItemModel.prototype, "collapsed", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.property)({ defaultValue: 0 })
    ], SurveyResultsItemModel.prototype, "lvl", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.property)()
    ], SurveyResultsItemModel.prototype, "items", void 0);
    return SurveyResultsItemModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_2__.Base));

function addCollapsed(survey, items, initLvl) {
    if (items === void 0) { items = []; }
    return items.filter(function (item) { return !!item; }).map(function (item) {
        return new SurveyResultsItemModel(survey, item, initLvl);
    });
}
var SurveyResultsModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyResultsModel, _super);
    function SurveyResultsModel(survey) {
        var _this = _super.call(this) || this;
        _this.survey = survey;
        _this.selectTableClick = function () {
            _this.resultViewType = "table";
        };
        _this.selectJsonClick = function () {
            _this.resultViewType = "text";
        };
        _this.resultText = JSON.stringify(survey.data, null, 4);
        var plainData = survey.getPlainData({ includeEmpty: false, includeValues: true });
        _this.resultData = addCollapsed(survey, plainData, 0);
        return _this;
    }
    SurveyResultsModel.prototype.getLocString = function (name) {
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString(name);
    };
    Object.defineProperty(SurveyResultsModel.prototype, "surveyResultsText", {
        get: function () {
            return this.getLocString("ed.surveyResults");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsModel.prototype, "surveyResultsTableText", {
        get: function () {
            return this.getLocString("ed.surveyResultsTable");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsModel.prototype, "surveyResultsJsonText", {
        get: function () {
            return this.getLocString("ed.surveyResultsJson");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsModel.prototype, "resultsTitle", {
        get: function () {
            return this.getLocString("ed.resultsTitle");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsModel.prototype, "resultsName", {
        get: function () {
            return this.getLocString("ed.resultsName");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsModel.prototype, "resultsValue", {
        get: function () {
            return this.getLocString("ed.resultsValue");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsModel.prototype, "resultsDisplayValue", {
        get: function () {
            return this.getLocString("ed.resultsDisplayValue");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsModel.prototype, "isTableSelected", {
        get: function () {
            return this.resultViewType === "table";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyResultsModel.prototype, "isJsonSelected", {
        get: function () {
            return this.resultViewType === "text";
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.property)({ defaultValue: "table" })
    ], SurveyResultsModel.prototype, "resultViewType", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.property)({ defaultValue: "" })
    ], SurveyResultsModel.prototype, "resultText", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.propertyArray)()
    ], SurveyResultsModel.prototype, "resultData", void 0);
    return SurveyResultsModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_2__.Base));



/***/ }),

/***/ "./src/components/row.ts":
/*!*******************************!*\
  !*** ./src/components/row.ts ***!
  \*******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   RowViewModel: () => (/* binding */ RowViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


__webpack_require__(/*! ./row.scss */ "./src/components/row.scss");
var RowViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(RowViewModel, _super);
    function RowViewModel(creator, row, templateData) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.row = row;
        _this.templateData = templateData;
        _this.rowDragTypeOverMeChanged = function (s, o) {
            if (o.name == "dragTypeOverMe")
                _this.dragTypeOverMe = o.newValue;
        };
        _this.dragTypeOverMe = _this.row.dragTypeOverMe;
        return _this;
    }
    RowViewModel.prototype.subscribeElementChanges = function () {
        this.row.onPropertyChanged.add(this.rowDragTypeOverMeChanged);
    };
    RowViewModel.prototype.unsubscribeElementChanges = function () {
        this.row.onPropertyChanged.remove(this.rowDragTypeOverMeChanged);
    };
    Object.defineProperty(RowViewModel.prototype, "cssClasses", {
        get: function () {
            var result = "svc-row";
            var ghostClass = " svc-row--ghost";
            if (this.row.elements.length === 1 &&
                this.row.elements[0].name === "sv-drag-drop-ghost-survey-element-name") {
                result += ghostClass;
            }
            if (this.dragTypeOverMe === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Top) {
                result += " svc-row--drag-over-top";
            }
            if (this.dragTypeOverMe === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Bottom) {
                result += " svc-row--drag-over-bottom";
            }
            return result;
        },
        enumerable: false,
        configurable: true
    });
    RowViewModel.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.unsubscribeElementChanges();
        this.rowDragTypeOverMeChanged = undefined;
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], RowViewModel.prototype, "dragTypeOverMe", void 0);
    return RowViewModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/scroll.ts":
/*!**********************************!*\
  !*** ./src/components/scroll.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ScrollViewModel: () => (/* binding */ ScrollViewModel)
/* harmony export */ });
__webpack_require__(/*! ./row.scss */ "./src/components/row.scss");
var ScrollViewModel = /** @class */ (function () {
    function ScrollViewModel() {
        //this.dragTypeOverMe = this.row.dragTypeOverMe;
    }
    ScrollViewModel.prototype.setRootElement = function (element) {
        var _this = this;
        this._containerElementValue = element === null || element === void 0 ? void 0 : element.querySelector(".svc-scroll__scroller");
        this._scrollbarElement = element === null || element === void 0 ? void 0 : element.querySelector(".svc-scroll__scrollbar");
        this._scrollbarSizerElement = element === null || element === void 0 ? void 0 : element.querySelector(".svc-scroll__scrollbar-sizer");
        this._containerBodyElement = element === null || element === void 0 ? void 0 : element.querySelector(".svc-scroll__container");
        if (!element)
            return;
        this._containerBodyResizeObserver = new ResizeObserver(function (entries) {
            for (var _i = 0, entries_1 = entries; _i < entries_1.length; _i++) {
                var entry = entries_1[_i];
                var height = entry.contentBoxSize
                    ? entry.contentBoxSize[0].blockSize
                    : entry.contentRect.width;
                _this._scrollbarSizerElement.style.height = height + "px";
                _this._scrollbarElement.style.visibility = _this._scrollbarElement.clientHeight >= height ? "hidden" : "";
            }
        });
        this._containerBodyResizeObserver.observe(this._containerBodyElement);
    };
    ScrollViewModel.prototype.onScrollContainer = function () {
        this._scrollbarElement.scrollTop = this._containerElementValue.scrollTop;
    };
    ScrollViewModel.prototype.onScrollScrollbar = function () {
        this._containerElementValue.scrollTop = this._scrollbarElement.scrollTop;
    };
    ScrollViewModel.prototype.unsubscribeRootElement = function () {
        if (!!this._containerBodyResizeObserver) {
            this._containerBodyResizeObserver.disconnect();
            this._containerBodyResizeObserver = undefined;
        }
    };
    return ScrollViewModel;
}());



/***/ }),

/***/ "./src/components/search-manager.ts":
/*!******************************************!*\
  !*** ./src/components/search-manager.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SearchManager: () => (/* binding */ SearchManager)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");



var SearchManager = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SearchManager, _super);
    function SearchManager() {
        var _this = _super.call(this) || this;
        _this.searchActionBar = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ActionContainer();
        _this.initActionBar();
        return _this;
    }
    Object.defineProperty(SearchManager.prototype, "filterStringPlaceholder", {
        get: function () { return this.getFilterStringPlaceholder(); },
        enumerable: false,
        configurable: true
    });
    SearchManager.prototype.getSearchActions = function () {
        var _this = this;
        return [new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
                id: "svd-grid-search-close",
                iconName: "icon-clear_16x16",
                component: "sv-action-bar-item",
                title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.clear"),
                showTitle: false,
                iconSize: "auto",
                disableTabStop: true,
                innerCss: "svc-search__bar-item",
                visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return !!_this.filterString; }),
                action: function () {
                    _this.clearFilterString();
                }
            })];
    };
    SearchManager.prototype.initActionBar = function () {
        this.searchActionBar.setItems(this.getSearchActions());
    };
    SearchManager.prototype.clearFilterString = function () {
        this.filterString = "";
    };
    SearchManager.prototype.onPropertyValueChanged = function (name, oldValue, newValue) {
        _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
        if (name === "filterString") {
            this.setFiterString(newValue, oldValue);
        }
    };
    SearchManager.prototype.dispose = function () {
        this.searchActionBar.dispose();
        _super.prototype.dispose.call(this);
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SearchManager.prototype, "filterString", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SearchManager.prototype, "isVisible", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SearchManager.prototype, "matchCounterText", void 0);
    return SearchManager;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/side-bar/side-bar-header-model.ts":
/*!**********************************************************!*\
  !*** ./src/components/side-bar/side-bar-header-model.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SidebarHeaderModel: () => (/* binding */ SidebarHeaderModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


var SidebarHeaderModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SidebarHeaderModel, _super);
    function SidebarHeaderModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.toolbar = new survey_core__WEBPACK_IMPORTED_MODULE_1__.AdaptiveActionContainer();
        return _this;
    }
    Object.defineProperty(SidebarHeaderModel.prototype, "component", {
        get: function () {
            return this.componentName || "svc-side-bar-default-header";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarHeaderModel.prototype, "componentModel", {
        get: function () {
            return this.componentData || this;
        },
        enumerable: false,
        configurable: true
    });
    SidebarHeaderModel.prototype.reset = function () {
        this.title = "";
        this.subTitle = "";
        this.componentName = "";
        this.componentData = undefined;
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SidebarHeaderModel.prototype, "title", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SidebarHeaderModel.prototype, "subTitle", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SidebarHeaderModel.prototype, "componentData", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SidebarHeaderModel.prototype, "componentName", void 0);
    return SidebarHeaderModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/side-bar/side-bar-model.ts":
/*!***************************************************!*\
  !*** ./src/components/side-bar/side-bar-model.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SidebarModel: () => (/* binding */ SidebarModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _side_bar_page_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./side-bar-page-model */ "./src/components/side-bar/side-bar-page-model.ts");
/* harmony import */ var _side_bar_header_model__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./side-bar-header-model */ "./src/components/side-bar/side-bar-header-model.ts");
/* harmony import */ var _utils_resizer__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/resizer */ "./src/utils/resizer.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");







var SidebarModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SidebarModel, _super);
    function SidebarModel(creator) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.header = new _side_bar_header_model__WEBPACK_IMPORTED_MODULE_4__.SidebarHeaderModel();
        _this.allowFlyoutMode = true;
        _this.visibilityAnimation = new survey_core__WEBPACK_IMPORTED_MODULE_1__.AnimationBoolean(_this.getAnimationOptions(), function (val) {
            _this.renderedIsVisible = val;
            _this.allowFlyoutMode = true;
        }, function () { return _this.renderedIsVisible; });
        _this.sidebarLocationChangedHandler = function (sender, options) {
            if (options.name === "sidebarLocation" && !!_this.resizeManager) {
                _this.resizeManager.setHandles(_this.getCurrentHandles());
            }
        };
        _this.onSidebarVisibilityChanged = function (sender, options) {
            if (_this.isDisposed)
                return;
            _this.visible = options.show;
        };
        _this.creator.onShowSidebarVisibilityChanged.add(_this.onSidebarVisibilityChanged);
        _this.creator.onPropertyChanged.add(_this.sidebarLocationChangedHandler);
        _this.visible = _this.creator.showSidebar;
        _this.createActions();
        return _this;
    }
    Object.defineProperty(SidebarModel.prototype, "rootCss", {
        get: function () {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("svc-side-bar")
                .append("svc-side-bar--flyout", this.flyoutPanelMode)
                .append("svc-side-bar--mobile", this.creator.isMobileView)
                .append("svc-side-bar--side-area", !!this.sideAreaComponentName)
                .toString();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarModel.prototype, "renderRoot", {
        get: function () {
            return this.hasVisiblePages && (!this.creator.isMobileView || this.renderedIsVisible);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarModel.prototype, "renderContainer", {
        get: function () {
            return this.renderedIsVisible;
        },
        enumerable: false,
        configurable: true
    });
    SidebarModel.prototype.getAnimationOptions = function () {
        var _this = this;
        var onBeforeRunAnimation = function (el) {
            var animatedElements = el.querySelectorAll(".svc-side-bar__container-wrapper,.svc-side-bar__wrapper");
            animatedElements.forEach(function (el) {
                el.style.setProperty("--animation-width", el.offsetWidth + "px");
            });
        };
        return {
            getAnimatedElement: function () {
                return _this.rootElement;
            },
            isAnimationEnabled: function () { return _this.animationAllowed; },
            getRerenderEvent: function () { return _this.onElementRerendered; },
            getLeaveOptions: function () {
                return {
                    onBeforeRunAnimation: onBeforeRunAnimation,
                    cssClass: "svc-side-bar--leave"
                };
            },
            getEnterOptions: function () {
                return {
                    onBeforeRunAnimation: onBeforeRunAnimation,
                    cssClass: "svc-side-bar--enter",
                    onAfterRunAnimation: function () { return _this.afterExpand(); }
                };
            }
        };
    };
    SidebarModel.prototype.afterExpand = function () {
        this.onExpandCallback && this.onExpandCallback();
        this.onExpandCallback = undefined;
    };
    SidebarModel.prototype.executeOnExpand = function (callback) {
        if (this.renderedIsVisible) {
            callback();
        }
        this.onExpandCallback = callback;
    };
    Object.defineProperty(SidebarModel.prototype, "visible", {
        get: function () {
            return this._visible;
        },
        set: function (val) {
            if (this._visible && !val && !this.flyoutMode) {
                this.allowFlyoutMode = false;
            }
            if (this._visible !== val) {
                this._visible = val;
                if (!this.animationAllowed) {
                    this.afterExpand();
                }
                this.visibilityAnimation.sync(val);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarModel.prototype, "flyoutPanelMode", {
        get: function () {
            return this.flyoutMode && this.allowFlyoutMode;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SidebarModel.prototype, "closeText", {
        get: function () {
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("pe.close");
        },
        enumerable: false,
        configurable: true
    });
    SidebarModel.prototype.getPageById = function (id) {
        return this.pages.filter(function (page) { return page.id === id; })[0];
    };
    SidebarModel.prototype.createActions = function () {
        var _this = this;
        this._collapseAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "svd-grid-hide",
            iconName: "icon-collapse-panel",
            iconSize: "auto",
            css: "svd-grid-hide",
            locTitleName: "ed.hidePanel",
            showTitle: false,
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.notShortCircuitAnd)(!(0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.notShortCircuitAnd)(!_this.creator.allowCollapseSidebar, !_this.flyoutMode), _this.visible, !_this.hideSideBarVisibilityControlActions);
            }),
            action: function () {
                _this.collapseSidebar();
                if (!_this.flyoutMode) {
                    _this.collapsedManually = true;
                    _this.expandedManually = false;
                }
                else {
                    _this.creator.focusElement(_this.creator.selectedElement, true);
                }
            }
        });
        this.header.toolbar.actions.push(this._collapseAction);
        if (this.creator.allowCollapseSidebar) {
            this._expandAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
                id: "svd-grid-expand",
                iconName: "icon-expand-panel",
                iconSize: "auto",
                css: "svd-grid-expand",
                needSeparator: true,
                action: function () {
                    _this.expandSidebar();
                    if (!_this.flyoutMode) {
                        _this.collapsedManually = false;
                        _this.expandedManually = _this.flyoutMode;
                    }
                },
                locTitleName: "ed.showPanel",
                visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                    return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.notShortCircuitAnd)(_this.hasVisiblePages, !_this.visible, !_this.hideSideBarVisibilityControlActions);
                }),
                showTitle: false
            });
        }
    };
    SidebarModel.prototype.getCurrentHandles = function () {
        return this.creator.sidebarLocation == "right" ? "w" : "e";
    };
    Object.defineProperty(SidebarModel.prototype, "activePage", {
        get: function () { return this.getPropertyValue("activePage"); },
        set: function (val) {
            this.setPropertyValue("activePage", val);
            this.setActivePage(this.pages.filter(function (page) { return page.id === val; })[0]);
        },
        enumerable: false,
        configurable: true
    });
    SidebarModel.prototype.getActivePage = function () {
        return this._activePage;
    };
    SidebarModel.prototype.setActivePage = function (newPage) {
        if (!!this._activePage && this._activePage.id !== newPage.id && !!this._activePage.deactivateCallback) {
            this._activePage.deactivateCallback();
        }
        this.pages.forEach(function (page) { return page.visible = false; });
        this._activePage = newPage;
        if (this._activePage) {
            this.header.title = this._activePage.caption;
            this._activePage.visible = true;
        }
    };
    SidebarModel.prototype.getExpandAction = function () {
        return this._expandAction;
    };
    SidebarModel.prototype.collapseSidebar = function () {
        this.creator.setShowSidebar(false);
    };
    SidebarModel.prototype.expandSidebar = function () {
        this.creator.setShowSidebar(true);
    };
    SidebarModel.prototype.addPage = function (id, componentName, model, buildActions) {
        var _this = this;
        var page = new _side_bar_page_model__WEBPACK_IMPORTED_MODULE_3__.SidebarPageModel(id, this, componentName, model);
        this.pages.push(page);
        if (!!buildActions) {
            (buildActions() || []).forEach(function (action) { return _this.header.toolbar.actions.push(action); });
        }
        return page;
    };
    SidebarModel.prototype.updateHasVisiblePages = function () {
        this.hasVisiblePages = (this.pages || []).filter(function (page) { return page.visible; }).length > 0;
    };
    SidebarModel.prototype.dispose = function () {
        if (!!this.creator && !this.isDisposed) {
            this.creator.onShowSidebarVisibilityChanged.remove(this.onSidebarVisibilityChanged);
            this.creator.onPropertyChanged.remove(this.sidebarLocationChangedHandler);
            this.sidebarLocationChangedHandler = undefined;
        }
        this.resetResizeManager();
        _super.prototype.dispose.call(this);
    };
    SidebarModel.prototype.initResizeManager = function (container) {
        var _a;
        this.resizeManager = new _utils_resizer__WEBPACK_IMPORTED_MODULE_5__.ResizeManager(container, this.getCurrentHandles());
        this.rootElement = (_a = container === null || container === void 0 ? void 0 : container.parentElement) === null || _a === void 0 ? void 0 : _a.parentElement.parentElement;
    };
    SidebarModel.prototype.resetResizeManager = function () {
        if (!!this.resizeManager) {
            this.resizeManager.dispose();
            this.resizeManager = undefined;
        }
        this.rootElement = undefined;
    };
    Object.defineProperty(SidebarModel.prototype, "toolbar", {
        get: function () {
            var _a;
            return (_a = this.header) === null || _a === void 0 ? void 0 : _a.toolbar;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.propertyArray)()
    ], SidebarModel.prototype, "pages", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SidebarModel.prototype, "_visible", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SidebarModel.prototype, "renderedIsVisible", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SidebarModel.prototype, "collapsedManually", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SidebarModel.prototype, "expandedManually", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SidebarModel.prototype, "hasVisiblePages", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SidebarModel.prototype, "flyoutMode", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SidebarModel.prototype, "hideSideBarVisibilityControlActions", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SidebarModel.prototype, "sideAreaComponentName", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SidebarModel.prototype, "sideAreaComponentData", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({})
    ], SidebarModel.prototype, "allowFlyoutMode", void 0);
    return SidebarModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/side-bar/side-bar-page-model.ts":
/*!********************************************************!*\
  !*** ./src/components/side-bar/side-bar-page-model.ts ***!
  \********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SidebarPageModel: () => (/* binding */ SidebarPageModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


var SidebarPageModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SidebarPageModel, _super);
    function SidebarPageModel(id, sidePanel, componentName, componentData) {
        var _this = _super.call(this) || this;
        _this.id = id;
        _this.sidePanel = sidePanel;
        !!componentName && (_this.componentName = componentName);
        !!componentData && (_this.componentData = componentData);
        return _this;
    }
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SidebarPageModel.prototype, "caption", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (newVal, target) {
                target.sidePanel.updateHasVisiblePages();
            }
        })
    ], SidebarPageModel.prototype, "visible", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SidebarPageModel.prototype, "componentData", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SidebarPageModel.prototype, "componentName", void 0);
    return SidebarPageModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/side-bar/tab-control-model.ts":
/*!******************************************************!*\
  !*** ./src/components/side-bar/tab-control-model.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TabControlModel: () => (/* binding */ TabControlModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_actions__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../utils/actions */ "./src/utils/actions.ts");



var TabControlModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TabControlModel, _super);
    function TabControlModel(sidePanel) {
        var _this = _super.call(this) || this;
        _this.sidePanel = sidePanel;
        _this.topToolbar = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ActionContainer();
        _this.bottomToolbar = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ActionContainer();
        _this.createToggleAction();
        _this.updateExpandCollapseAction();
        _this.sidePanel.registerFunctionOnPropertyValueChanged("_visible", function () {
            _this.updateExpandCollapseAction();
        });
        return _this;
    }
    TabControlModel.prototype.updateExpandCollapseAction = function () {
        this.expandCollapseAction.iconName = this.sidePanel.visible ? "icon-collapse-panel" : "icon-expand-panel";
        this.expandCollapseAction.css = this.sidePanel.visible ? "svd-grid-hide" : "svd-grid-expand";
        this.expandCollapseAction.locTooltipName = this.sidePanel.visible ? "ed.hidePanel" : "ed.showPanel";
    };
    TabControlModel.prototype.createToggleAction = function () {
        var _this = this;
        this.expandCollapseAction = new _utils_actions__WEBPACK_IMPORTED_MODULE_2__.MenuButton({
            id: "svd-grid-hide",
            showTitle: false,
            visible: true,
            pressed: false,
            action: function () {
                if (_this.sidePanel.visible) {
                    _this.sidePanel.collapseSidebar();
                }
                else {
                    _this.sidePanel.expandSidebar();
                }
            }
        });
    };
    Object.defineProperty(TabControlModel.prototype, "sideBarClassName", {
        get: function () {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder().append("svc-sidebar-tabs").append("svc-sidebar-tabs--collapsed", !this.sidePanel.renderedIsVisible).toString();
        },
        enumerable: false,
        configurable: true
    });
    return TabControlModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/simulator.ts":
/*!*************************************!*\
  !*** ./src/components/simulator.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DEFAULT_MONITOR_DPI: () => (/* binding */ DEFAULT_MONITOR_DPI),
/* harmony export */   SurveySimulatorModel: () => (/* binding */ SurveySimulatorModel),
/* harmony export */   simulatorDevices: () => (/* binding */ simulatorDevices)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


__webpack_require__(/*! ./simulator.scss */ "./src/components/simulator.scss");
var SurveySimulatorModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveySimulatorModel, _super);
    function SurveySimulatorModel(surveyProvider) {
        var _this_1 = _super.call(this) || this;
        _this_1.surveyProvider = surveyProvider;
        _this_1.activateZoom = function () {
            document.addEventListener("keydown", _this_1.listenTryToZoom);
            document.addEventListener("wheel", _this_1.listenTryToZoomWithWheel, { passive: false });
        };
        _this_1.deactivateZoom = function () {
            document.removeEventListener("keydown", _this_1.listenTryToZoom);
            document.removeEventListener("wheel", _this_1.listenTryToZoomWithWheel);
        };
        _this_1.listenTryToZoomWithWheel = function (e) { return _this_1.tryToZoomWithWheel(e, e); };
        _this_1.listenTryToZoom = function (e) { return _this_1.tryToZoom(e, e); };
        return _this_1;
        // if (!!_toolbarHolder) {
        //   this.simulatorOptions.survey = this._toolbarHolder.koSurvey;
        //   ko.computed(() => {
        //     this.simulatorEnabled = _toolbarHolder.showSimulator();
        //   });
        //   _toolbarHolder.toolbarItems.push({
        //     id: "svd-test-simulator",
        //     title: getLocString("pe.simulator"),
        //     visible: ko.computed(() => this.simulatorEnabled),
        //     tooltip: getLocString("pe.simulator"),
        //     component: "svd-dropdown",
        //     action: ko.computed({
        //       read: () => this.activeDevice,
        //       write: (val: any) => (this.activeDevice = val),
        //     }),
        //     items: <any>this.koDevices,
        //   });
        //   _toolbarHolder.toolbarItems.push({
        //     id: "svd-test-simulator-orientation",
        //     title: getLocString("pe.landscapeOrientation"),
        //     visible: this.koHasFrame,
        //     tooltip: getLocString("pe.landscapeOrientation"),
        //     component: "svd-boolean",
        //     action: ko.computed({
        //       read: () => this.landscapeOrientation,
        //       write: (val: any) => (this.landscapeOrientation = val),
        //     }),
        //   });
        // }
    }
    SurveySimulatorModel.prototype.surveyChanged = function () {
        var _this_1 = this;
        var _this = this;
        this.survey.onOpenDropdownMenu.add(function (_, options) {
            if (_this_1.surveyProvider.isTouch)
                return;
            var device = simulatorDevices[_this.activeDevice];
            options.menuType = device.deviceType === "desktop" ? "dropdown" : (device.deviceType == "tablet" ? "popup" : "overlay");
        });
    };
    Object.defineProperty(SurveySimulatorModel.prototype, "zoomScale", {
        get: function () {
            return this.currZoomScale;
        },
        enumerable: false,
        configurable: true
    });
    SurveySimulatorModel.prototype.tryToZoomWithWheel = function (data, event) {
        var diff = event.deltaY;
        if (event.ctrlKey || event.metaKey) {
            diff < 0 ? this.zoomSimulator("up", event) : this.zoomSimulator("down", event);
        }
        return true;
    };
    SurveySimulatorModel.prototype.tryToZoom = function (data, event) {
        if (event.ctrlKey || event.metaKey) {
            if (event.keyCode == 107 || event.keyCode == 187) {
                this.zoomSimulator("up", event);
            }
            if (event.keyCode == 109 || event.keyCode == 189) {
                this.zoomSimulator("down", event);
            }
            if (event.keyCode == 48 || event.keyCode == 96) {
                this.zoomSimulator("zero", event);
            }
        }
        return true;
    };
    SurveySimulatorModel.prototype.changeZoomScale = function (type) {
        var coef = 1.01;
        var multiplier = type === "up" ? coef : (type === "down" ? 1 / coef : 1);
        this.currZoomScale = type === "zero" ? 1 : this.currZoomScale * multiplier;
    };
    SurveySimulatorModel.prototype.zoomSimulator = function (type, event) {
        event.preventDefault();
        this.changeZoomScale(type);
        var simulator = document.getElementById("svd-simulator-wrapper");
        if (!!simulator)
            simulator.style.transform = "scale(" + this.currZoomScale + ")";
        event.stopPropagation();
    };
    SurveySimulatorModel.prototype.resetZoomParameters = function () {
        this.currZoomScale = 1;
        var simulator = document.getElementById("svd-simulator-wrapper");
        if (!!simulator)
            simulator.style.transform = "";
    };
    Object.defineProperty(SurveySimulatorModel.prototype, "activeDevice", {
        get: function () {
            return this.device;
        },
        set: function (device) {
            this.device = device;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveySimulatorModel.prototype, "landscapeOrientation", {
        get: function () {
            return this.landscape;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveySimulatorModel.prototype, "hasFrame", {
        // set landscapeOrientation(isLanscape: boolean) {
        //   this.landscape = isLanscape;
        // }
        get: function () {
            var device = simulatorDevices[this.activeDevice];
            return this.simulatorEnabled && device.deviceType !== "desktop";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveySimulatorModel.prototype, "simulatorFrame", {
        get: function () {
            if (!this.hasFrame) {
                return undefined;
            }
            var device = simulatorDevices[this.activeDevice];
            var scale = 1; //DEFAULT_MONITOR_DPI / device.ppi;
            var deviceWidth = (this.landscapeOrientation ? device.height : device.width) / device.cssPixelRatio;
            var deviceHeight = (this.landscapeOrientation ? device.width : device.height) / device.cssPixelRatio;
            var deviceLandscapedFrameWidth = (this.landscapeOrientation ? device.height : device.width) / device.cssPixelRatio;
            var deviceLandscapedFrameHeight = (this.landscapeOrientation ? device.width : device.height) / device.cssPixelRatio;
            var frameWidth = deviceLandscapedFrameWidth * scale + 2 * (this.landscapeOrientation ? 64 : 16);
            var frameHeight = deviceLandscapedFrameHeight * scale + 2 * (this.landscapeOrientation ? 16 : 64);
            return {
                scale: this.simulatorScaleEnabled ? scale /* * device.cssPixelRatio */ : 1,
                frameWidth: frameWidth,
                frameHeight: frameHeight,
                landscapedFrameWidth: this.landscapeOrientation ? frameHeight : frameWidth,
                landscapedFrameHeight: this.landscapeOrientation ? frameWidth : frameHeight,
                deviceWidth: deviceWidth,
                deviceHeight: deviceHeight,
                cssClass: device.cssClass +
                    (this.landscapeOrientation ? " svd-simulator-frame-landscape" : ""),
            };
        },
        enumerable: false,
        configurable: true
    });
    SurveySimulatorModel.prototype.getRootCss = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append("svd-simulator-main")
            .append("svd-simulator-main--frame", this.hasFrame)
            .append("svd-simulator-main--desktop", this.device === "desktop")
            .append("svd-simulator-main--running", this.isRunning)
            .toString();
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveySimulatorModel.prototype, "landscape", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (newVal, target) { target.surveyChanged(); }
        })
    ], SurveySimulatorModel.prototype, "survey", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "desktop" })
    ], SurveySimulatorModel.prototype, "device", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "l" })
    ], SurveySimulatorModel.prototype, "orientation", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveySimulatorModel.prototype, "considerDPI", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveySimulatorModel.prototype, "isRunning", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveySimulatorModel.prototype, "simulatorEnabled", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveySimulatorModel.prototype, "simulatorScaleEnabled", void 0);
    return SurveySimulatorModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));

var DEFAULT_MONITOR_DPI = (typeof window !== "undefined" ? window.devicePixelRatio : 1) * 96;
var simulatorDevices = {
    desktop: {
        deviceType: "desktop",
        title: "Desktop",
    },
    // desktop_1280x720: {
    //   cssPixelRatio: 1,
    //   ppi: DEFAULT_MONITOR_DPI,
    //   width: 720,
    //   height: 1280,
    //   deviceType: "desktop",
    //   title: "Desktop 1280x720"
    // },
    // desktop_1440x900: {
    //   cssPixelRatio: 1,
    //   ppi: DEFAULT_MONITOR_DPI,
    //   width: 900,
    //   height: 1440,
    //   deviceType: "desktop",
    //   title: "Desktop 1440x900"
    // },
    // desktop_1920x1080: {
    //   cssPixelRatio: 1,
    //   ppi: DEFAULT_MONITOR_DPI,
    //   width: 1080,
    //   height: 1920,
    //   deviceType: "desktop",
    //   title: "Desktop 1920x1080"
    // },
    // iPhone: {
    //   cssPixelRatio: 2,
    //   ppi: 326,
    //   width: 640,
    //   height: 960,
    //   deviceType: "phone",
    //   title: "iPhone",
    //   cssClass: "svd-simulator-iphone4"
    // },
    // iPhone5: {
    //   cssPixelRatio: 2,
    //   ppi: 326,
    //   width: 640,
    //   height: 1136,
    //   deviceType: "phone",
    //   title: "iPhone 5",
    //   cssClass: "svd-simulator-iphone5",
    // },
    // iPhone6: {
    //   cssPixelRatio: 2,
    //   ppi: 326,
    //   width: 750,
    //   height: 1334,
    //   deviceType: "phone",
    //   title: "iPhone 6",
    //   cssClass: "svd-simulator-iphone6",
    // },
    // iPhone6plus: {
    //   cssPixelRatio: 2.6,
    //   ppi: 401,
    //   width: 1080,
    //   height: 1920,
    //   deviceType: "phone",
    //   title: "iPhone 6 Plus",
    //   cssClass: "svd-simulator-iphone6plus",
    // },
    // iPhone8: {
    //   cssPixelRatio: 2,
    //   ppi: 326,
    //   width: 750,
    //   height: 1334,
    //   deviceType: "phone",
    //   title: "iPhone 8",
    //   cssClass: "svd-simulator-iphone8",
    // },
    // iPhone8plus: {
    //   cssPixelRatio: 3,
    //   ppi: 401,
    //   width: 1080,
    //   height: 1920,
    //   deviceType: "phone",
    //   title: "iPhone 8 Plus",
    //   cssClass: "svd-simulator-iphone8plus",
    // },
    // iPhoneX: {
    //   cssPixelRatio: 3,
    //   ppi: 458,
    //   width: 1125,
    //   height: 2436,
    //   deviceType: "phone",
    //   title: "iPhone X",
    //   cssClass: "svd-simulator-iphonex",
    // },
    // iPhoneXmax: {
    //   cssPixelRatio: 3,
    //   ppi: 458,
    //   width: 1242,
    //   height: 2688,
    //   deviceType: "phone",
    //   title: "iPhone X Max",
    //   cssClass: "svd-simulator-iphonexmax",
    // },
    iPhoneSE: {
        cssPixelRatio: 2,
        ppi: 326,
        width: 750,
        height: 1334,
        deviceType: "phone",
        title: "iPhone SE",
        cssClass: "svd-simulator-iphonexmax",
    },
    iPhone15: {
        cssPixelRatio: 3,
        ppi: 460,
        width: 1179,
        height: 2556,
        deviceType: "phone",
        title: "iPhone 15",
        cssClass: "svd-simulator-iphonexmax",
    },
    iPhone15Plus: {
        cssPixelRatio: 3,
        ppi: 460,
        width: 1290,
        height: 2796,
        deviceType: "phone",
        title: "iPhone 15 Plus",
        cssClass: "svd-simulator-iphonexmax",
    },
    iPadMini: {
        cssPixelRatio: 2.5,
        ppi: 326,
        width: 1536,
        height: 2048,
        deviceType: "tablet",
        title: "iPad Mini",
        cssClass: "svd-simulator-ipadmini",
    },
    iPad: {
        cssPixelRatio: 2,
        ppi: 264,
        width: 1640,
        height: 2360,
        deviceType: "tablet",
        title: "iPad Air",
        cssClass: "svd-simulator-ipad",
    },
    // iPadPro: {
    //   cssPixelRatio: 2,
    //   ppi: 264,
    //   width: 1688,
    //   height: 2388,
    //   deviceType: "tablet",
    //   title: 'iPad Pro 11"',
    //   cssClass: "svd-simulator-ipadpro",
    // },
    // iPadPro13: {
    //   cssPixelRatio: 2,
    //   ppi: 264,
    //   width: 2048,
    //   height: 2732,
    //   deviceType: "tablet",
    //   title: 'iPad Pro 12,9"',
    //   cssClass: "svd-simulator-ipadpro13",
    // },
    androidPhone: {
        cssPixelRatio: 3,
        ppi: 411,
        width: 1080,
        height: 2048,
        deviceType: "phone",
        title: "Android Phone",
        cssClass: "svd-simulator-androidphone",
    },
    androidTablet: {
        cssPixelRatio: 1.5,
        ppi: 149,
        width: 800,
        height: 1280,
        deviceType: "tablet",
        title: "Android Tablet",
        cssClass: "svd-simulator-androidtablet",
    },
    // win10Phone: {
    //   cssPixelRatio: 2,
    //   ppi: 294,
    //   width: 720,
    //   height: 1280,
    //   deviceType: "phone",
    //   title: "Windows 10 Phone",
    //   cssClass: "svd-simulator-win10phone",
    // },
    microsoftSurface: {
        cssPixelRatio: 1,
        ppi: 148,
        width: 768,
        height: 1366,
        deviceType: "tablet",
        title: "Microsoft Surface",
        cssClass: "svd-simulator-mssurface",
    },
    genericPhone: {
        cssPixelRatio: 1,
        deviceType: "phone",
        title: "",
        cssClass: "svd-simulator-genphone",
    },
};


/***/ }),

/***/ "./src/components/string-editor.ts":
/*!*****************************************!*\
  !*** ./src/components/string-editor.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   StringEditorConnector: () => (/* binding */ StringEditorConnector),
/* harmony export */   StringEditorViewModelBase: () => (/* binding */ StringEditorViewModelBase),
/* harmony export */   StringItemsNavigatorBase: () => (/* binding */ StringItemsNavigatorBase)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");





var StringItemsNavigatorBase = /** @class */ (function () {
    function StringItemsNavigatorBase(question) {
        this.question = question;
    }
    StringItemsNavigatorBase.createItemsNavigator = function (question) {
        if (question instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionImagePickerModel)
            return null;
        if (question instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionMultipleTextModel)
            return new StringItemsNavigatorMultipleText(question);
        if (question instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionMatrixDropdownModel)
            return new StringItemsNavigatorMatrixDropdown(question);
        if (question instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionMatrixDynamicModel)
            return new StringItemsNavigatorMatrixDynamic(question);
        if (question instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionMatrixModel)
            return new StringItemsNavigatorMatrix(question);
        if (question instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionSelectBase)
            return new StringItemsNavigatorSelectBase(question);
        return null;
    };
    StringItemsNavigatorBase.prototype.addNewItems = function (creator, items, startIndex, itemsToAdd) {
        var _this = this;
        var newItems = items.slice();
        var createNewItem = function (text) {
            var val = creator.inplaceEditForValues ? text : (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.getNextItemValue)(creator.getChoicesItemBaseTitle(), newItems);
            if (_this.question.createItemValue)
                return _this.question.createItemValue(val, text);
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue(val, text);
        };
        newItems.splice(startIndex, 1);
        itemsToAdd.forEach(function (item, offset) {
            newItems.splice(startIndex + offset, 0, createNewItem(item));
        });
        this.question[this.getItemsPropertyName(items)] = newItems;
    };
    StringItemsNavigatorBase.prototype.setEventsForItem = function (creator, items, item) {
        var _this = this;
        var connector = StringEditorConnector.get(this.getItemLocString(items, item));
        connector.allowLineBreaksOnEdit = true;
        connector.onEditComplete.clear();
        connector.onEditComplete.add(function () {
            var itemIndex = items.indexOf(item);
            if (itemIndex >= 0 && itemIndex < items.length - 1) {
                StringEditorConnector.get(_this.getItemLocString(items, items[itemIndex + 1])).activateEditor();
            }
            if (itemIndex == items.length - 1) {
                _this.addNewItem(creator, items);
                StringEditorConnector.get(_this.getItemLocString(items, items[items.length - 1])).setAutoFocus();
                StringEditorConnector.get(_this.getItemLocString(items, items[items.length - 1])).activateEditor();
            }
        });
        connector.onBackspaceEmptyString.clear();
        connector.onBackspaceEmptyString.add(function () {
            var itemIndex = items.indexOf(item);
            var itemToFocus = null;
            if (itemIndex !== -1) {
                if (itemIndex == 0 && items.length >= 2)
                    itemToFocus = items[1];
                if (itemIndex > 0)
                    itemToFocus = items[itemIndex - 1];
                if (itemToFocus) {
                    var connector_1 = StringEditorConnector.get(_this.getItemLocString(items, itemToFocus));
                    connector_1.setAutoFocus();
                    connector_1.activateEditor();
                }
                items.splice(itemIndex, 1);
            }
        });
        connector.onTextChanging.clear();
        connector.onTextChanging.add(function (sender, options) {
            var lines = options.value.split(/\r?\n/).map(function (line) { return (line || "").trim(); }).filter(function (line) { return !!line; });
            if (lines.length <= 1)
                return;
            options.cancel = true;
            var itemIndex = items.indexOf(item);
            _this.addNewItems(creator, items, itemIndex, lines);
            var focusedItemIndex = itemIndex + lines.length;
            if (focusedItemIndex >= items.length)
                focusedItemIndex = items.length - 1;
            StringEditorConnector.get(_this.getItemLocString(items, items[focusedItemIndex])).setAutoFocus();
            StringEditorConnector.get(_this.getItemLocString(items, items[focusedItemIndex])).activateEditor();
        });
    };
    StringItemsNavigatorBase.setQuestion = function (questionAdorner) {
        var question = questionAdorner.element;
        var navigator = StringItemsNavigatorBase.createItemsNavigator(question);
        if (navigator) {
            var creator_1 = questionAdorner.creator;
            var titleConnector = StringEditorConnector.get(question.locTitle);
            var allItemSets = navigator.getItemSets();
            var activeChoices_1 = allItemSets[0];
            if (!titleConnector.hasEditCompleteHandler) {
                titleConnector.onEditComplete.add(function () {
                    if (activeChoices_1.length)
                        StringEditorConnector.get(navigator.getItemLocString(activeChoices_1, activeChoices_1[0])).activateEditor();
                });
                titleConnector.hasEditCompleteHandler = true;
            }
            allItemSets.forEach(function (activeChoices) {
                activeChoices.forEach(function (item) {
                    navigator.setEventsForItem(creator_1, activeChoices, item);
                });
                var itemsPropertyName = navigator.getItemsPropertyName(activeChoices);
                question.onPropertyChanged.add(function (sender, options) {
                    if (options.name == itemsPropertyName) {
                        activeChoices.forEach(function (item) {
                            navigator.setEventsForItem(creator_1, activeChoices, item);
                        });
                    }
                });
            });
        }
        return !!navigator;
    };
    return StringItemsNavigatorBase;
}());

var StringItemsNavigatorSelectBase = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(StringItemsNavigatorSelectBase, _super);
    function StringItemsNavigatorSelectBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StringItemsNavigatorSelectBase.prototype.getItemLocString = function (items, item) {
        return item.locText;
    };
    StringItemsNavigatorSelectBase.prototype.getItemSets = function () {
        return [this.question.choices];
    };
    StringItemsNavigatorSelectBase.prototype.addNewItem = function (creator, items, text) {
        if (text === void 0) { text = null; }
        if (creator.maximumChoicesCount && items.length >= creator.maximumChoicesCount)
            return;
        var itemValue = creator.createNewItemValue(this.question);
        if (!!text)
            itemValue.value = text;
    };
    StringItemsNavigatorSelectBase.prototype.getItemsPropertyName = function (items) {
        return "choices";
    };
    return StringItemsNavigatorSelectBase;
}(StringItemsNavigatorBase));
var StringItemsNavigatorMultipleText = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(StringItemsNavigatorMultipleText, _super);
    function StringItemsNavigatorMultipleText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StringItemsNavigatorMultipleText.prototype.getItemLocString = function (items, item) {
        return item.locTitle;
    };
    StringItemsNavigatorMultipleText.prototype.getItemSets = function () {
        return [this.question.items];
    };
    StringItemsNavigatorMultipleText.prototype.addNewItem = function (creator, items, text) {
        if (text === void 0) { text = null; }
        this.question.addItem(text || (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.getNextValue)("text", items.map(function (i) { return i.name; })));
    };
    StringItemsNavigatorMultipleText.prototype.getItemsPropertyName = function (items) {
        return "items";
    };
    StringItemsNavigatorMultipleText.prototype.addNewItems = function (creator, items, startIndex, itemsToAdd) {
        var newItems = items.slice(0, startIndex).concat(itemsToAdd.map(function (text) { return new survey_core__WEBPACK_IMPORTED_MODULE_1__.MultipleTextItemModel(text); })).concat(items.slice(startIndex + 1));
        this.question[this.getItemsPropertyName(items)] = newItems;
    };
    return StringItemsNavigatorMultipleText;
}(StringItemsNavigatorBase));
var StringItemsNavigatorMatrix = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(StringItemsNavigatorMatrix, _super);
    function StringItemsNavigatorMatrix() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StringItemsNavigatorMatrix.prototype.getItemLocString = function (items, item) {
        return item.locText;
    };
    StringItemsNavigatorMatrix.prototype.getItemSets = function () {
        return [this.question.columns, this.question.rows];
    };
    StringItemsNavigatorMatrix.prototype.addNewItem = function (creator, items, text) {
        if (text === void 0) { text = null; }
        var titleBase;
        var propertyName;
        if (items == this.question.columns) {
            if (creator.maximumColumnsCount && items.length >= creator.maximumColumnsCount)
                return;
            titleBase = "Column ";
            propertyName = "columns";
        }
        if (items == this.question.rows) {
            if (creator.maximumRowsCount && items.length >= creator.maximumRowsCount)
                return;
            titleBase = "Row ";
            propertyName = "rows";
        }
        var newItem = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue((0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.getNextValue)(titleBase, items.map(function (i) { return i.value; })));
        items.push(text || newItem);
        creator.onItemValueAddedCallback(this.question, propertyName, newItem, items);
    };
    StringItemsNavigatorMatrix.prototype.getItemsPropertyName = function (items) {
        if (items == this.question.columns)
            return "columns";
        if (items == this.question.rows)
            return "rows";
    };
    return StringItemsNavigatorMatrix;
}(StringItemsNavigatorBase));
var StringItemsNavigatorMatrixDropdown = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(StringItemsNavigatorMatrixDropdown, _super);
    function StringItemsNavigatorMatrixDropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StringItemsNavigatorMatrixDropdown.prototype.getItemLocString = function (items, item) {
        if (items == this.question.columns)
            return item.locTitle;
        return item.locText;
    };
    StringItemsNavigatorMatrixDropdown.prototype.addNewItem = function (creator, items, text) {
        if (text === void 0) { text = null; }
        if (items == this.question.columns) {
            if (creator.maximumColumnsCount && items.length >= creator.maximumColumnsCount)
                return;
            var column = new survey_core__WEBPACK_IMPORTED_MODULE_1__.MatrixDropdownColumn(text || (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.getNextValue)("Column ", items.map(function (i) { return i.value; })));
            this.question.columns.push(column);
            creator.onMatrixDropdownColumnAddedCallback(this.question, column, this.question.columns);
        }
        if (items == this.question.rows)
            _super.prototype.addNewItem.call(this, creator, items, text);
    };
    StringItemsNavigatorMatrixDropdown.prototype.addNewItems = function (creator, items, startIndex, itemsToAdd) {
        if (items == this.question.columns) {
            var newItems = items.slice(0, startIndex).concat(itemsToAdd.map(function (text) { return new survey_core__WEBPACK_IMPORTED_MODULE_1__.MatrixDropdownColumn(text); })).concat(items.slice(startIndex + 1));
            this.question[this.getItemsPropertyName(items)] = newItems;
        }
        else {
            _super.prototype.addNewItems.call(this, creator, items, startIndex, itemsToAdd);
        }
    };
    return StringItemsNavigatorMatrixDropdown;
}(StringItemsNavigatorMatrix));
var StringItemsNavigatorMatrixDynamic = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(StringItemsNavigatorMatrixDynamic, _super);
    function StringItemsNavigatorMatrixDynamic() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StringItemsNavigatorMatrixDynamic.prototype.getItemSets = function () {
        return [this.question.columns];
    };
    return StringItemsNavigatorMatrixDynamic;
}(StringItemsNavigatorMatrixDropdown));
var StringEditorConnector = /** @class */ (function () {
    function StringEditorConnector(locString) {
        this.locString = locString;
        this.hasEditCompleteHandler = false;
        this.allowLineBreaksOnEdit = false;
        this.onDoActivate = new survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase();
        this.onTextChanging = new survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase();
        this.onEditComplete = new survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase();
        this.onBackspaceEmptyString = new survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase();
    }
    StringEditorConnector.get = function (locString) {
        if (!locString["_stringEditorConnector"])
            locString["_stringEditorConnector"] = new StringEditorConnector(locString);
        return locString["_stringEditorConnector"];
    };
    StringEditorConnector.prototype.setAutoFocus = function () { this.focusOnEditor = true; };
    StringEditorConnector.prototype.activateEditor = function () {
        this.onDoActivate.fire(this.locString, {});
    };
    return StringEditorConnector;
}());

var StringEditorViewModelBase = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(StringEditorViewModelBase, _super);
    function StringEditorViewModelBase(locString, creator) {
        var _this = _super.call(this) || this;
        _this.locString = locString;
        _this.creator = creator;
        _this.blurredByEscape = false;
        _this.focusedProgram = false;
        _this.characterCounter = new survey_core__WEBPACK_IMPORTED_MODULE_1__.CharacterCounter();
        _this.activate = function () {
            var element = _this.getEditorElement();
            if (element && element.offsetParent != null) {
                element.focus({ preventScroll: true });
                (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.select)(element);
                return true;
            }
            return false;
        };
        _this.justFocused = false;
        _this.locString = locString;
        _this.checkMarkdownToTextConversion(_this.locString.owner, _this.locString.name);
        return _this;
    }
    StringEditorViewModelBase.prototype.afterRender = function () {
        if (this.connector.focusOnEditor) {
            if (this.activate())
                this.connector.focusOnEditor = false;
        }
    };
    StringEditorViewModelBase.prototype.detachFromUI = function () {
        var _a;
        (_a = this.connector) === null || _a === void 0 ? void 0 : _a.onDoActivate.remove(this.activate);
        this.getEditorElement = undefined;
        this.blurEditor = undefined;
    };
    StringEditorViewModelBase.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.detachFromUI();
    };
    StringEditorViewModelBase.prototype.setLocString = function (locString) {
        var _a;
        (_a = this.connector) === null || _a === void 0 ? void 0 : _a.onDoActivate.remove(this.activate);
        this.locString = locString;
        this.connector = StringEditorConnector.get(locString);
        this.connector.onDoActivate.add(this.activate);
    };
    StringEditorViewModelBase.prototype.checkConstraints = function (event) {
        if (!this.compostionInProgress && this.maxLength > 0 && event.keyCode >= 32) {
            var text = event.target.innerText || "";
            if (text.length >= this.maxLength) {
                event.preventDefault();
            }
        }
        if (event.keyCode == 13 && !this.locString.allowLineBreaks) {
            event.preventDefault();
        }
        if (event.ctrlKey || event.metaKey) {
            if ([89, 90, 66, 73].indexOf(event.keyCode) !== -1) {
                event.stopImmediatePropagation();
                event.preventDefault();
            }
        }
    };
    StringEditorViewModelBase.prototype.onClick = function (event) {
        event.stopPropagation();
    };
    StringEditorViewModelBase.prototype.onFocus = function (event) {
        if (!this.focusedProgram) {
            this.valueBeforeEdit = this.locString.hasHtml ? event.target.innerHTML : event.target.innerText;
            this.focusedProgram = false;
        }
        if (this.maxLength > 0) {
            this.characterCounter.updateRemainingCharacterCounter(this.valueBeforeEdit, this.maxLength);
        }
        if (this.creator) {
            this.creator.selectFromStringEditor = true;
        }
        if (this.locString.hasHtml && this.editAsText) {
            event.target.innerText = event.target.textContent = this.locString.calculatedText;
        }
        event.target.parentElement.click();
        event.target.spellcheck = true;
        event.target.setAttribute("tabindex", -1);
        this.focused = true;
        this.justFocused = true;
    };
    StringEditorViewModelBase.prototype.checkMarkdownToTextConversion = function (element, name) {
        if (!this.creator)
            return;
        var options = {
            element: element,
            text: null,
            name: name,
            html: "",
        };
        this.creator.onHtmlToMarkdown.fire(this.creator, options);
        this.editAsText = (options.text === null);
    };
    StringEditorViewModelBase.prototype.onCompositionStart = function (event) {
        this.compostionInProgress = true;
    };
    StringEditorViewModelBase.prototype.onInput = function (event) {
        var _a;
        if (this.maxLength > 0) {
            var text = event.target.innerText || "";
            this.characterCounter.updateRemainingCharacterCounter(text, this.maxLength);
        }
        if (this.editAsText && !this.compostionInProgress) {
            var options = { value: (_a = event.target) === null || _a === void 0 ? void 0 : _a.innerText, cancel: null };
            if (this.connector)
                this.connector.onTextChanging.fire(this, options);
            if (options.cancel)
                return;
            if (this.maxLength >= 0 && event.target.innerText.length > this.maxLength) {
                event.target.innerText = event.target.innerText.substring(0, this.maxLength);
            }
        }
    };
    StringEditorViewModelBase.prototype.onCompositionEnd = function (event) {
        this.compostionInProgress = false;
        this.onInput(event);
    };
    StringEditorViewModelBase.prototype.onBlur = function (event) {
        var _a;
        event.target.removeAttribute("tabindex");
        if (this.blurredByEscape) {
            this.blurredByEscape = false;
            if (this.locString.hasHtml) {
                event.target.innerHTML = this.valueBeforeEdit;
            }
            else {
                event.target.innerText = this.valueBeforeEdit;
            }
            this.errorText = null;
            this.focused = false;
            window === null || window === void 0 ? void 0 : window.getSelection().removeAllRanges();
            return;
        }
        var clearedText = this.getClearedText(event.target);
        this.errorText = this.getErrorTextOnChanged(clearedText);
        if (this.locString.text != clearedText &&
            !(!this.locString.text && clearedText == this.locString.calculatedText)) {
            if (!this.errorText) {
                this.setValueIntoLocStr(clearedText, event === null || event === void 0 ? void 0 : event.target);
            }
            else {
                (_a = this.creator) === null || _a === void 0 ? void 0 : _a.notify(this.errorText, "error");
                this.focusedProgram = true;
                event.target.innerText = clearedText;
                event.target.focus();
                return;
            }
        }
        else {
            if (this.locString.hasHtml) {
                event.target.innerHTML = this.locString.renderedHtml;
            }
            else {
                event.target.innerText = this.locString.renderedHtml;
            }
            this.locString.strChanged();
        }
        this.focused = false;
        window === null || window === void 0 ? void 0 : window.getSelection().removeAllRanges();
    };
    StringEditorViewModelBase.prototype.getClearedText = function (target) {
        var html = target.innerHTML;
        var text = target.innerText;
        if (!this.creator)
            return this.locString.hasHtml ? html : text;
        var mdText = null;
        if (!this.editAsText) {
            var options = {
                element: this.locString.owner,
                text: null,
                name: this.locString.name,
                html: html
            };
            this.creator.onHtmlToMarkdown.fire(this.creator, options);
            mdText = options.text;
        }
        var clearedText;
        if (mdText) {
            clearedText = mdText;
        }
        else {
            var txt = this.locString.hasHtml && !this.editAsText ? html : text;
            if (!this.locString.allowLineBreaks)
                txt = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.clearNewLines)(txt);
            clearedText = txt;
        }
        var owner = this.locString.owner;
        var changingOptions = {
            obj: owner,
            propertyName: this.locString.name,
            value: this.locString.text,
            newValue: clearedText,
            doValidation: false
        };
        this.creator.onValueChangingCallback(changingOptions);
        return changingOptions.newValue;
    };
    StringEditorViewModelBase.prototype.getErrorTextOnChanged = function (clearedText) {
        if (!this.creator)
            return "";
        var owner = this.locString.owner;
        var res = this.creator.onGetErrorTextOnValidationCallback(this.locString.name, owner, clearedText);
        if (!!res || !!clearedText)
            return res;
        var propJSON = owner.getPropertyByName && owner.getPropertyByName(this.locString.name);
        if (propJSON && propJSON.isRequired)
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.propertyIsEmpty");
        return "";
    };
    Object.defineProperty(StringEditorViewModelBase.prototype, "isInplaceForEditValues", {
        get: function () {
            return !!this.creator && this.creator.inplaceEditForValues &&
                this.locString.owner instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue &&
                this.creator.inplaceEditForValues &&
                ["noneText", "otherText", "selectAllText"].indexOf(this.locString.name) === -1;
        },
        enumerable: false,
        configurable: true
    });
    StringEditorViewModelBase.prototype.setValueIntoLocStr = function (clearedText, target) {
        if (this.isInplaceForEditValues) {
            var itemValue = this.locString.owner;
            if (itemValue.value !== clearedText) {
                if (!!itemValue.locOwner && !!itemValue.ownerPropertyName) {
                    var choices = itemValue.locOwner[itemValue.ownerPropertyName];
                    if (Array.isArray(choices) && !!survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue.getItemByValue(choices, clearedText)) {
                        clearedText = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.getNextItemValue)(clearedText, choices);
                        if (!!target) {
                            target.innerText = clearedText;
                        }
                    }
                }
                itemValue.value = clearedText;
            }
        }
        else {
            var oldStoreDefaultText = this.locString.storeDefaultText;
            this.locString.storeDefaultText = false;
            this.locString.text = clearedText;
            this.locString.storeDefaultText = oldStoreDefaultText;
        }
    };
    StringEditorViewModelBase.prototype.done = function (event) {
        event.stopImmediatePropagation();
        event.preventDefault();
    };
    StringEditorViewModelBase.prototype.onPaste = function (event) {
        var _a;
        if (this.editAsText) {
            event.preventDefault();
            // get text representation of clipboard
            var text = event.clipboardData.getData("text/plain");
            if (!this.locString.allowLineBreaks && !((_a = this.connector) === null || _a === void 0 ? void 0 : _a.allowLineBreaksOnEdit))
                text = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.clearNewLines)(text);
            // insert text manually
            var selection = window.getSelection();
            if (!selection.rangeCount)
                return;
            selection.deleteFromDocument();
            selection.getRangeAt(0).insertNode(document.createTextNode(text));
            selection.collapseToEnd();
            event.target.dispatchEvent(new Event("input", { bubbles: true }));
        }
    };
    StringEditorViewModelBase.prototype.onKeyDown = function (event) {
        if (event.keyCode === 13 && !event.shiftKey) {
            this.blurEditor();
            if (!event.ctrlKey && !event.metaKey) {
                this.connector.onEditComplete.fire(this, {});
            }
            this.done(event);
        }
        if (event.keyCode === 27) {
            this.blurredByEscape = true;
            this.blurEditor();
            this.done(event);
        }
        if (event.keyCode === 8 && !event.target.innerText) {
            this.done(event);
            this.connector.onBackspaceEmptyString.fire(this, {});
        }
        this.checkConstraints(event);
        return true;
    };
    StringEditorViewModelBase.prototype.onKeyUp = function (event) {
        if (event.keyCode === 9 && event.target === document.activeElement) {
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.select)(event.target);
        }
        return true;
    };
    StringEditorViewModelBase.prototype.onMouseUp = function (event) {
        if (this.justFocused) {
            this.justFocused = false;
            if (!window)
                return false;
            if (window.getSelection().focusNode && (window.getSelection().focusNode.parentElement !== event.target) || window.getSelection().toString().length == 0) {
                (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.select)(event.target);
            }
            return false;
        }
        return true;
    };
    StringEditorViewModelBase.prototype.findProperty = function () {
        if (!this.locString.owner.getType)
            return undefined;
        var ownerType = this.locString.owner.getType();
        if (!this.locString.name)
            return undefined;
        var property = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(ownerType, this.locString.name);
        return property;
    };
    Object.defineProperty(StringEditorViewModelBase.prototype, "maxLength", {
        get: function () {
            var property = this.findProperty();
            if (!property || property.maxLength <= 0)
                return -1;
            return property.maxLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StringEditorViewModelBase.prototype, "placeholder", {
        get: function () {
            var _this = this;
            if (!!this.placeholderValue)
                return this.placeholderValue;
            var property = this.findProperty();
            if (!property || !property.placeholder)
                return "";
            var placeholderValue = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString(property.placeholder);
            if (!!placeholderValue) {
                var re = /\{([^}]+)\}/g;
                this.placeholderValue = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                    var result = placeholderValue;
                    var match = re.exec(result);
                    while (match != null) {
                        result = result.replace(re, function (propertyName) {
                            var propertyValue = _this.locString.owner && _this.locString.owner[match[1]];
                            return "" + propertyValue;
                        });
                        match = re.exec(result);
                    }
                    return result;
                });
            }
            return this.placeholderValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StringEditorViewModelBase.prototype, "contentEditable", {
        get: function () {
            if (!this.creator)
                return true;
            return this.creator.isCanModifyProperty(this.locString.owner, this.locString.name);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StringEditorViewModelBase.prototype, "showCharacterCounter", {
        get: function () {
            return this.maxLength !== -1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(StringEditorViewModelBase.prototype, "getCharacterCounterClass", {
        get: function () {
            return "svc-remaining-character-counter";
        },
        enumerable: false,
        configurable: true
    });
    StringEditorViewModelBase.prototype.className = function (text) {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append("svc-string-editor")
            .append("svc-string-editor--hidden", text == "" && this.placeholder == "")
            .append("svc-string-editor--readonly", !this.contentEditable)
            .append("svc-string-editor--error", !!this.errorText)
            .append("svc-string-editor--multiline", !!this.locString.allowLineBreaks)
            .toString();
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], StringEditorViewModelBase.prototype, "errorText", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], StringEditorViewModelBase.prototype, "focused", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], StringEditorViewModelBase.prototype, "editAsText", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], StringEditorViewModelBase.prototype, "placeholderValue", void 0);
    return StringEditorViewModelBase;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/switcher/switcher.ts":
/*!*********************************************!*\
  !*** ./src/components/switcher/switcher.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Switcher: () => (/* binding */ Switcher)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


__webpack_require__(/*! ./switcher.scss */ "./src/components/switcher/switcher.scss");
var Switcher = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(Switcher, _super);
    function Switcher() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Switcher.prototype.getSwitcherIconCss = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append("svc-switcher__icon")
            .append("svc-switcher__icon--checked", this.checked)
            .toString();
    };
    Switcher.prototype.getActionBarItemCss = function () {
        return "svc-switcher " + _super.prototype.getActionBarItemCss.call(this);
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Switcher.prototype, "checked", void 0);
    return Switcher;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Action));



/***/ }),

/***/ "./src/components/tabs/designer-plugin.ts":
/*!************************************************!*\
  !*** ./src/components/tabs/designer-plugin.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TabDesignerPlugin: () => (/* binding */ TabDesignerPlugin)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _property_grid__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../property-grid */ "./src/property-grid/index.ts");
/* harmony import */ var _property_grid_property_grid_view_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../property-grid/property-grid-view-model */ "./src/property-grid/property-grid-view-model.ts");
/* harmony import */ var _designer__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./designer */ "./src/components/tabs/designer.ts");
/* harmony import */ var _designer_state_manager__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./designer-state-manager */ "./src/components/tabs/designer-state-manager.ts");
/* harmony import */ var _side_bar_tab_control_model__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../side-bar/tab-control-model */ "./src/components/side-bar/tab-control-model.ts");
/* harmony import */ var _property_grid_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../property-grid/icons */ "./src/property-grid/icons.ts");
/* harmony import */ var _utils_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/actions */ "./src/utils/actions.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _creator_theme_creator_theme_model_definition__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../creator-theme/creator-theme-model-definition */ "./src/creator-theme/creator-theme-model-definition.ts");
/* harmony import */ var _creator_theme_creator_theme_model__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../creator-theme/creator-theme-model */ "./src/creator-theme/creator-theme-model.ts");
/* harmony import */ var _themes__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./themes */ "./src/components/tabs/themes.ts");













var TabDesignerPlugin = /** @class */ (function () {
    function TabDesignerPlugin(creator) {
        var _this = this;
        this.creator = creator;
        this._showOneCategoryInPropertyGrid = false;
        creator.addPluginTab("designer", this);
        this.tabControlModel = new _side_bar_tab_control_model__WEBPACK_IMPORTED_MODULE_6__.TabControlModel(this.creator.sidebar);
        this.propertyGrid = new _property_grid__WEBPACK_IMPORTED_MODULE_2__.PropertyGridModel(creator.survey, creator, creator.getPropertyGridDefinition());
        this.propertyGridViewModel = new _property_grid_property_grid_view_model__WEBPACK_IMPORTED_MODULE_3__.PropertyGridViewModel(this.propertyGrid, creator);
        this.propertyGridTab = this.creator.sidebar.addPage("propertyGrid", "svc-property-grid", this.propertyGridViewModel, function () {
            var result = [];
            if (!!_this.propertyGridViewModel.prevSelectionAction) {
                _this.propertyGridViewModel.prevSelectionAction.visible = _this.createVisibleUpdater();
                result.push(_this.propertyGridViewModel.prevSelectionAction);
            }
            if (!!_this.propertyGridViewModel.nextSelectionAction) {
                _this.propertyGridViewModel.nextSelectionAction.visible = _this.createVisibleUpdater();
                result.push(_this.propertyGridViewModel.nextSelectionAction);
            }
            if (!!_this.propertyGridViewModel.objectSelectionAction) {
                _this.propertyGridViewModel.objectSelectionAction.visible = _this.createVisibleUpdater();
                result.push(_this.propertyGridViewModel.objectSelectionAction);
            }
            return result;
        });
        creator.onSelectedElementChanged.add(function (sender, options) {
            if (_this.showOneCategoryInPropertyGrid && _this.creator.activeTab === "designer") {
                _this.setPropertyGridIsActivePage();
                _this.updateTabControlActions();
            }
        });
        this.toolboxTab = this.creator.sidebar.addPage("toolbox", "svc-toolbox", creator);
        this.propertyGridPlaceholderPage = this.creator.sidebar.addPage("propertyGridPlaceholder", "svc-property-grid-placeholder", this.propertyGridViewModel);
        this.propertyGridPlaceholderPage.caption = "Survey Settings";
        if (this.creator.showCreatorThemeSettings) {
            this.createCreatorThemeSettingsPage(creator);
        }
        this.designerStateManager = new _designer_state_manager__WEBPACK_IMPORTED_MODULE_5__.DesignerStateManager();
        this.designerStateManager.initForSurvey(this.creator.survey);
        this.creator.onSurveyInstanceCreated.add(function (s, o) {
            if (o.reason == "designer") {
                _this.designerStateManager.initForSurvey(o.survey);
            }
        });
        this.creator.onPropertyChanged.add(function (sender, options) {
            if (options.name === "toolboxLocation") {
                if (_this.toolboxTab.visible && options.newVal !== "sidebar") {
                    _this.propertyGridTab.visible = true;
                }
                _this.toolboxTab.visible = options.newVal === "sidebar";
            }
        });
        this.createActions().forEach(function (action) { return creator.toolbar.actions.push(action); });
        creator.registerShortcut("delete", {
            affectedTab: "designer",
            hotKey: {
                keyCode: 46,
            },
            macOsHotkey: {
                keyCode: 46,
            },
            execute: function () {
                if (!_this.creator.readOnly) {
                    _this.creator.deleteCurrentElement();
                }
            }
        });
    }
    Object.defineProperty(TabDesignerPlugin.prototype, "isSurveySelected", {
        get: function () {
            return this.creator.isElementSelected(this.creator.survey);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabDesignerPlugin.prototype, "isSettingsActive", {
        get: function () {
            return this.creator.showSidebar && this.isSurveySelected;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabDesignerPlugin.prototype, "activePageIsPropertyGrid", {
        get: function () {
            return this.creator.sidebar.activePage === this.propertyGridTab.id;
        },
        enumerable: false,
        configurable: true
    });
    TabDesignerPlugin.prototype.createVisibleUpdater = function () {
        var _this = this;
        return new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () {
            var activePage = _this.creator.sidebar.activePage;
            return _this.creator.activeTab === "designer" && activePage !== _this.propertyGridPlaceholderPage.id;
        });
    };
    TabDesignerPlugin.prototype.updateTabControl = function () {
        if (this.showOneCategoryInPropertyGrid) {
            this.updateTabControlActions();
            this.creator.sidebar.sideAreaComponentName = "svc-tab-control";
            this.creator.sidebar.sideAreaComponentData = this.tabControlModel;
        }
        else {
            this.creator.sidebar.sideAreaComponentName = "";
            this.creator.sidebar.sideAreaComponentData = undefined;
        }
    };
    TabDesignerPlugin.prototype.updateHeaderComponent = function () {
        var activePage = this.creator.sidebar.activePage;
        if (this.showOneCategoryInPropertyGrid && this.activePageIsPropertyGrid) {
            this.creator.sidebar.header.componentName = "svc-side-bar-property-grid-header";
            this.creator.sidebar.header.componentData = this.propertyGridViewModel.objectSelectionAction;
        }
        else if (this.showOneCategoryInPropertyGrid && (activePage === this.propertyGridPlaceholderPage.id
            || activePage === this.themePropertyGridTab.id)) {
            this.creator.sidebar.header.componentName = "svc-side-bar-header";
            this.creator.sidebar.header.componentData = this.creator.sidebar.header;
        }
        else {
            this.creator.sidebar.header.componentName = "";
            this.creator.sidebar.header.componentData = undefined;
        }
    };
    TabDesignerPlugin.prototype.updateActivePage = function () {
        if (this.showOneCategoryInPropertyGrid) {
            this.setActivePage(this.creator.survey.pageCount ? this.propertyGridTab.id : this.propertyGridPlaceholderPage.id);
            this.updateHeaderComponent();
        }
        else {
            this.setPropertyGridIsActivePage();
        }
    };
    TabDesignerPlugin.prototype.setPropertyGridIsActivePage = function () {
        this.setActivePage(this.propertyGridTab.id);
    };
    TabDesignerPlugin.prototype.setActivePage = function (id) {
        this.creator.sidebar.activePage = id;
        this.updateHeaderComponent();
    };
    Object.defineProperty(TabDesignerPlugin.prototype, "showOneCategoryInPropertyGrid", {
        get: function () {
            return this._showOneCategoryInPropertyGrid;
        },
        set: function (newValue) {
            if (this._showOneCategoryInPropertyGrid !== newValue) {
                this._showOneCategoryInPropertyGrid = newValue;
                this.creator.sidebar.hideSideBarVisibilityControlActions = newValue;
                this.propertyGrid.showOneCategoryInPropertyGrid = newValue;
                this.propertyGrid["setObj"](this.creator.selectedElement);
                if (this.creator.activeTab === "designer") {
                    this.updateActivePage();
                    this.updateTabControl();
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    TabDesignerPlugin.prototype.syncTheme = function (theme) {
        var newTheme = theme || this.themeModel.toJSON();
        this.creator.syncTheme(newTheme, this.themeModel.isLight);
    };
    TabDesignerPlugin.prototype.updatePredefinedColorChoices = function () {
        var _this = this;
        this.themePropertyGrid.survey.getAllQuestions().forEach(function (question) {
            if (question.name === "--sjs-special-background") {
                question.choices = _this.themeModel && _this.themeModel.isLight ? (0,_themes__WEBPACK_IMPORTED_MODULE_12__.getPredefinedBackgoundColorsChoices)() : [];
            }
            if (question.name === "--sjs-primary-background-500" || question.name === "--sjs-secondary-background-500") {
                question.choices = (0,_themes__WEBPACK_IMPORTED_MODULE_12__.getPredefinedColorsItemValues)(_this.themeModel.isLight === false ? "dark" : "light");
            }
        });
    };
    TabDesignerPlugin.prototype.updateThemeSettings = function () {
        if (this.creator.showCreatorThemeSettings) {
            this.themeModel.loadTheme(this.creator.creatorTheme);
            this.themePropertyGrid.obj = this.themeModel;
            this.themePropertyGrid.survey.onUpdatePanelCssClasses.add(function (_, options) {
                options.cssClasses.panel.container += " spg-panel--group";
            });
            this.updatePredefinedColorChoices();
        }
    };
    TabDesignerPlugin.prototype.setTheme = function () {
        if (this.creator.showCreatorThemeSettings) {
            this.themeModel.setTheme(this.creator.creatorTheme);
        }
    };
    TabDesignerPlugin.prototype.createCreatorThemeSettingsPage = function (creator) {
        var _this = this;
        this.themeModel = new _creator_theme_creator_theme_model__WEBPACK_IMPORTED_MODULE_11__.CreatorThemeModel();
        this.themePropertyGrid = new _property_grid__WEBPACK_IMPORTED_MODULE_2__.PropertyGridModel(undefined, creator, _creator_theme_creator_theme_model_definition__WEBPACK_IMPORTED_MODULE_10__.creatorThemeModelPropertyGridDefinition);
        this.themePropertyGrid.survey.css.root += "svc-creator-theme-settings";
        this.themePropertyGrid.showOneCategoryInPropertyGrid = true;
        this.themePropertyGrid.surveyInstanceCreatedArea = "designer-tab:creator-settings";
        var themePropertyGridViewModel = new _property_grid_property_grid_view_model__WEBPACK_IMPORTED_MODULE_3__.PropertyGridViewModel(this.themePropertyGrid, creator);
        themePropertyGridViewModel.searchEnabled = false;
        this.themePropertyGridTab = this.creator.sidebar.addPage("creatorTheme", "svc-property-grid", themePropertyGridViewModel);
        this.themePropertyGridTab.caption = _editorLocalization__WEBPACK_IMPORTED_MODULE_9__.editorLocalization.getString("ed.creatorSettingTitle");
        this.themePropertyGridTab.deactivateCallback = function () {
            settingsAction.active = false;
        };
        this.themeModel.onThemeSelected.add(function (sender, options) {
            _this.syncTheme(options.theme);
            _this.themePropertyGrid.survey.editingObj = undefined;
            _this.themePropertyGrid.survey.editingObj = sender;
            _this.updatePredefinedColorChoices();
        });
        this.themeModel.onThemePropertyChanged.add(function (sender, options) {
            _this.syncTheme();
        });
        var settingsAction = new _utils_actions__WEBPACK_IMPORTED_MODULE_8__.MenuButton({
            id: "theme-settings",
            locTooltipName: "ed.creatorSettingTitle",
            iconName: "gear-24x24",
            iconSize: "auto",
            pressed: false,
            action: function () {
                _this.creator.sidebar.expandSidebar();
                _this.setActivePage(_this.themePropertyGridTab.id);
                settingsAction.active = true;
            }
        });
        this.tabControlModel.bottomToolbar.setItems([settingsAction]);
    };
    TabDesignerPlugin.prototype.updateTabControlActions = function () {
        var _this = this;
        var _a;
        if (this.showOneCategoryInPropertyGrid) {
            var pgTabs_1 = [];
            this.propertyGrid.survey.pages.forEach(function (p) {
                if (p.elements.length === 0)
                    return;
                var action = new _utils_actions__WEBPACK_IMPORTED_MODULE_8__.MenuButton({
                    id: p.name,
                    tooltip: p.title,
                    iconName: _property_grid_icons__WEBPACK_IMPORTED_MODULE_7__.pgTabIcons[p.name] || _property_grid_icons__WEBPACK_IMPORTED_MODULE_7__.pgTabIcons["undefined"],
                    iconSize: "auto",
                    active: _this.activePageIsPropertyGrid && p.name === _this.propertyGrid.survey.currentPage.name,
                    pressed: false,
                    action: function () {
                        _this.creator.sidebar.expandSidebar();
                        _this.setPropertyGridIsActivePage();
                        _this.propertyGrid.survey.currentPage = p;
                        _this.propertyGridViewModel.objectSelectionAction.tooltip = p.title;
                        pgTabs_1.forEach(function (i) { return i.active = false; });
                        action.active = true;
                    }
                });
                pgTabs_1.push(action);
            });
            this.tabControlModel.topToolbar.setItems(pgTabs_1);
            this.propertyGridTab.deactivateCallback = function () {
                pgTabs_1.forEach(function (tab) { return tab.active = false; });
            };
            this.propertyGrid.survey.onCurrentPageChanged.add(function (sender, options) {
                pgTabs_1.forEach(function (action) {
                    action.active = action.id === options.newCurrentPage.name;
                });
                _this.propertyGridViewModel.objectSelectionAction.tooltip = options.newCurrentPage.title;
            });
            this.propertyGridViewModel.objectSelectionAction.tooltip = (_a = this.propertyGrid.survey.currentPage) === null || _a === void 0 ? void 0 : _a.title;
        }
    };
    TabDesignerPlugin.prototype.activate = function () {
        this.model = new _designer__WEBPACK_IMPORTED_MODULE_4__.TabDesignerViewModel(this.creator);
        this.creator.sidebar.hideSideBarVisibilityControlActions = this.showOneCategoryInPropertyGrid;
        this.updateActivePage();
        this.updateTabControl();
        this.updateThemeSettings();
        this.creator.focusElement(undefined, true);
    };
    TabDesignerPlugin.prototype.deactivate = function () {
        if (this.model) {
            this.model.dispose();
        }
        this.model = undefined;
        this.propertyGridTab.visible = false;
        this.propertyGridPlaceholderPage.visible = false;
        if (!!this.themePropertyGridTab)
            this.themePropertyGridTab.visible = false;
        this.toolboxTab.visible = false;
        this.creator.sidebar.hideSideBarVisibilityControlActions = false;
        this.creator.sidebar.sideAreaComponentName = undefined;
        this.creator.sidebar.sideAreaComponentData = undefined;
        this.creator.sidebar.onPropertyChanged.clear();
        this.creator.sidebar.header.reset();
        this.creator.expandCollapseManager.clear();
        return true;
    };
    TabDesignerPlugin.prototype.onDesignerSurveyPropertyChanged = function (obj, propName) {
        if (!!this.model) {
            this.model.onDesignerSurveyPropertyChanged(obj, propName);
        }
    };
    TabDesignerPlugin.prototype.update = function () {
        if (!this.model)
            return;
        this.updateActivePage();
        this.model.initSurvey();
    };
    TabDesignerPlugin.prototype.createActions = function () {
        var _this = this;
        var items = [];
        var toolboxAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svd-toolbox",
            iconName: "icon-toolbox",
            iconSize: "auto",
            needSeparator: true,
            action: function () {
                if (!_this.creator.showSidebar) {
                    _this.creator.setShowSidebar(true, true);
                }
                _this.setActivePage("toolbox");
            },
            active: new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () { return _this.creator.sidebar.activePage === "toolbox"; }),
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () {
                return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__.notShortCircuitAnd)(_this.creator.activeTab === "designer", _this.creator.showToolbox, _this.creator.toolboxLocation === "sidebar");
            }),
            title: "Toolbox",
            showTitle: false
        });
        this.surveySettingsAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svd-settings",
            iconName: "icon-settings",
            iconSize: "auto",
            needSeparator: new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () {
                return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__.notShortCircuitAnd)(_this.creator.toolboxLocation !== "sidebar", !_this.creator.isMobileView);
            }),
            action: function () {
                _this.selectSurvey();
                if (!_this.creator.isMobileView) {
                    _this.creator.sidebar.executeOnExpand(function () {
                        _this.creator.propertyGrid.getAllQuestions()[0].focus();
                    });
                }
            },
            active: this.isSettingsActive,
            pressed: this.isSettingsActive,
            visible: this.createVisibleUpdater(),
            locTitleName: "ed.surveySettings",
            locTooltipName: "ed.surveySettingsTooltip",
            showTitle: false
        });
        this.saveSurveyAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svd-save",
            iconName: "icon-save",
            iconSize: "auto",
            action: function () { return _this.creator.saveSurveyActionHandler(); },
            active: false,
            enabled: false,
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () {
                return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__.notShortCircuitAnd)(_this.creator.activeTab === "designer", _this.creator.showSaveButton);
            }),
            locTitleName: "ed.saveSurvey",
            locTooltipName: "ed.saveSurveyTooltip",
            showTitle: false
        });
        this.designerAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svd-designer",
            iconName: "icon-config",
            iconSize: "auto",
            visible: this.createVisibleUpdater(),
            active: true,
            locTitleName: "ed.designer",
            showTitle: false,
            action: function () { }
        });
        this.previewAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svd-preview",
            iconName: "icon-preview",
            iconSize: "auto",
            action: function () {
                _this.creator.makeNewViewActive(_this.creator.showThemeTab ? "theme" : "test");
            },
            visible: this.createVisibleUpdater(),
            locTitleName: "tabs.preview",
            showTitle: false
        });
        items.push(this.saveSurveyAction);
        items.push(toolboxAction);
        items.push(this.surveySettingsAction);
        this.creator.onSelectedElementChanged.add(function (sender, options) {
            _this.surveySettingsAction.active = _this.isSettingsActive;
            _this.surveySettingsAction.pressed = _this.isSettingsActive;
        });
        this.creator.onShowSidebarVisibilityChanged.add(function (sender, options) {
            _this.surveySettingsAction.active = _this.isSettingsActive;
            _this.surveySettingsAction.pressed = _this.isSettingsActive;
        });
        return items;
    };
    TabDesignerPlugin.prototype.selectSurvey = function () {
        if (!this.creator.showSidebar) {
            this.creator.setShowSidebar(true, true);
        }
        this.creator.selectElement(this.creator.survey);
        this.setPropertyGridIsActivePage();
    };
    TabDesignerPlugin.prototype.addFooterActions = function () {
        this.creator.footerToolbar.actions.push(this.designerAction);
        this.creator.footerToolbar.actions.push(this.previewAction);
        this.creator.footerToolbar.actions.push(this.surveySettingsAction);
    };
    return TabDesignerPlugin;
}());



/***/ }),

/***/ "./src/components/tabs/designer-state-manager.ts":
/*!*******************************************************!*\
  !*** ./src/components/tabs/designer-state-manager.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DesignerStateManager: () => (/* binding */ DesignerStateManager)
/* harmony export */ });
var ElementState = /** @class */ (function () {
    function ElementState() {
        this.collapsed = false;
    }
    return ElementState;
}());
var DesignerStateManager = /** @class */ (function () {
    function DesignerStateManager() {
        var _this = this;
        this.elementState = {};
        this.pageState = {};
        this.onQuestionAddedHandler = function (sender, opts) {
            _this.createElementState(opts.question, _this.isSuspended);
        };
        this.onPageAddedHandler = function (sender, opts) {
            _this.createElementState(opts.page, _this.isSuspended);
        };
        this.onPanelAddedHandler = function (sender, opts) {
            _this.createElementState(opts.panel, _this.isSuspended);
        };
        this._suspendCounter = 0;
    }
    DesignerStateManager.prototype.getStateMapForElement = function (element) {
        return (element && element.isPage) ? this.pageState : this.elementState;
    };
    DesignerStateManager.prototype.initForSurvey = function (survey) {
        survey.onQuestionAdded.add(this.onQuestionAddedHandler);
        survey.onPageAdded.add(this.onPageAddedHandler);
        survey.onPanelAdded.add(this.onPanelAddedHandler);
    };
    DesignerStateManager.prototype.initForElement = function (element) {
        if (!element)
            return;
        var stateMap = this.getStateMapForElement(element);
        element.registerFunctionOnPropertyValueChanged("name", function (newName) {
            delete stateMap[element.name];
            stateMap[newName] = new ElementState();
        }, "designerStateManager");
    };
    DesignerStateManager.prototype.getElementState = function (element) {
        return this.createElementState(element, true);
    };
    DesignerStateManager.prototype.createElementState = function (element, checkIfExists) {
        var stateMap = this.getStateMapForElement(element);
        var name = element.name;
        if (checkIfExists) {
            var state = stateMap[name];
            if (state)
                return state;
        }
        var res = new ElementState();
        stateMap[name] = res;
        if (this.onInitElementStateCallback) {
            this.onInitElementStateCallback(element, res);
        }
        return res;
    };
    DesignerStateManager.prototype.suspend = function () {
        this._suspendCounter++;
    };
    DesignerStateManager.prototype.release = function () {
        this._suspendCounter--;
    };
    Object.defineProperty(DesignerStateManager.prototype, "isSuspended", {
        get: function () {
            return this._suspendCounter > 0;
        },
        enumerable: false,
        configurable: true
    });
    return DesignerStateManager;
}());



/***/ }),

/***/ "./src/components/tabs/designer.ts":
/*!*****************************************!*\
  !*** ./src/components/tabs/designer.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TabDesignerViewModel: () => (/* binding */ TabDesignerViewModel),
/* harmony export */   initialSettingsAllowShowEmptyTitleInDesignMode: () => (/* binding */ initialSettingsAllowShowEmptyTitleInDesignMode)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _pages_controller__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../pages-controller */ "./src/pages-controller.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _survey_elements__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../survey-elements */ "./src/survey-elements.ts");
/* harmony import */ var _action_container_view_model__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../action-container-view-model */ "./src/components/action-container-view-model.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _designTabSurveyThemeJSON__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../designTabSurveyThemeJSON */ "./src/designTabSurveyThemeJSON.ts");









__webpack_require__(/*! ./designer.scss */ "./src/components/tabs/designer.scss");
var initialSettingsAllowShowEmptyTitleInDesignMode = survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.allowShowEmptyTitleInDesignMode;
var TabDesignerViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TabDesignerViewModel, _super);
    function TabDesignerViewModel(creator) {
        var _this = _super.call(this) || this;
        _this.minSurfaceScaling = 20;
        _this.maxSurfaceScaling = 200;
        _this.scaleCssVariables = {};
        _this.surfaceScale = 100;
        _this.unitDictionary = {
            "--ctr-surface-base-unit": 8,
            "--lbr-font-unit": 8,
            "--lbr-line-height-unit": 8,
            "--lbr-size-unit": 8,
            "--lbr-spacing-unit": 8,
            "--lbr-corner-radius-unit": 8,
            "--lbr-stroke-unit": 1,
        };
        _this.surveyThemeVariables = {};
        _this._pages = [];
        _this.pagesAnimation = new survey_core__WEBPACK_IMPORTED_MODULE_1__.AnimationGroup(_this.getPagesAnimationOptions(), function (val) {
            _this._pages = val;
            _this._pages.forEach(function (page) { return delete page["draggedFrom"]; });
        }, function () { return _this._pages; });
        _this.creator = creator;
        _this.pagesControllerValue = new _pages_controller__WEBPACK_IMPORTED_MODULE_3__.PagesController(creator);
        _this.creator.dragDropChoices.onShortcutCreated = function (shortcut) {
            Object.keys(_this.surveyThemeVariables).forEach(function (key) {
                shortcut.style.setProperty(key, _this.surveyThemeVariables[key]);
            });
        };
        _this.initSurfaceToolbar();
        _this.initSurvey();
        _this.updateDesignTabSurveyThemeVariables();
        return _this;
    }
    Object.defineProperty(TabDesignerViewModel.prototype, "displayPageDropTarget", {
        get: function () {
            return this.pagesController.page2Display === this.newPage ? "newGhostPage" : this.pagesController.page2Display.name;
        },
        enumerable: false,
        configurable: true
    });
    TabDesignerViewModel.prototype.createNewPage = function () {
        var _this = this;
        if (!this.creator.canAddPage()) {
            return null;
        }
        var newPage = this.survey.createNewPage("");
        newPage["ignoreUndoRedo"] = true;
        this.creator.setNewNames(newPage);
        newPage.onFirstRendering();
        newPage.updateCustomWidgets();
        newPage.setWasShown(true);
        newPage.setSurveyImpl(this.survey);
        newPage.updateElementCss();
        var checkNewElementHandler = function (sender, options) {
            if (options.name === "elements" && newPage.elements.length > 0) {
                // if (this.survey.pages.indexOf(newPage) > -1) return;
                _this.creator.addPage(newPage, true, function () {
                    newPage.onPropertyChanged.remove(checkNewElementHandler);
                    newPage.showTitle = true;
                    newPage.showDescription = true;
                    delete newPage["ignoreUndoRedo"];
                    return !(_this.survey.pages.indexOf(newPage) > -1);
                });
            }
        };
        newPage.num = this.survey.pages.length + 1;
        newPage.onPropertyChanged.add(checkNewElementHandler);
        _survey_elements__WEBPACK_IMPORTED_MODULE_5__.DragDropSurveyElements.newGhostPage = newPage;
        delete newPage["ignoreUndoRedo"];
        return newPage;
    };
    Object.defineProperty(TabDesignerViewModel.prototype, "canShowNewPage", {
        get: function () {
            if (!this.survey || this.creator.pageEditMode === "single" || !this.creator.allowModifyPages)
                return false;
            return true;
            // if (this.creator.pageEditMode === "bypage") return true;
            // const pages: PageModel[] = this.survey.pages;
            // return pages.length === 0 || this.isModifiedPage(pages[pages.length - 1]);
        },
        enumerable: false,
        configurable: true
    });
    TabDesignerViewModel.prototype.isModifiedPage = function (page) {
        return Object.keys(page.toJSON()).filter(function (key) { return key !== "name"; }).length > 0;
    };
    TabDesignerViewModel.prototype.updateDesignTabSurveyThemeVariables = function () {
        var cssVariables = {};
        (0,_utils_utils__WEBPACK_IMPORTED_MODULE_7__.assign)(cssVariables, _designTabSurveyThemeJSON__WEBPACK_IMPORTED_MODULE_8__["default"].cssVariables, this.scaleCssVariables, {
            "--sjs-base-unit": "var(--ctr-surface-base-unit)",
            "--sjs-font-size": "calc(2 * var(--ctr-surface-base-unit))",
        });
        this.surveyThemeVariables = cssVariables;
    };
    TabDesignerViewModel.prototype.initSurfaceToolbar = function () {
        var _this = this;
        this.surfaceToolbar = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ActionContainer();
        var defaultActionBarCss = {
            root: "sv-action-bar svc-tab-designer__surface-toolbar",
            defaultSizeMode: "",
            smallSizeMode: "",
            item: "svc-page-navigator__button",
            itemWithTitle: "",
            itemAsIcon: "",
            itemActive: "svc-page-navigator__button--active",
            itemPressed: "",
            itemIcon: "svc-page-navigator__button-icon",
            itemTitleWithIcon: "",
        };
        this.surfaceToolbar.cssClasses = defaultActionBarCss;
        var surfaceToolbarItems = [];
        if (this.creator.showCreatorThemeSettings) {
            surfaceToolbarItems.push({
                id: "zoomIn",
                locTooltipName: "ed.zoomInTooltip",
                iconName: "icon-zoomin-24x24",
                iconSize: "auto",
                action: function () { _this.scalingSurface(_this.surfaceScale + 10); }
            });
            surfaceToolbarItems.push({
                id: "zoomOut",
                locTooltipName: "ed.zoomOutTooltip",
                iconName: "icon-zoomout-24x24",
                iconSize: "auto",
                action: function () { _this.scalingSurface(_this.surfaceScale - 10); }
            });
        }
        surfaceToolbarItems.push({
            id: "collapseAll",
            locTooltipName: "ed.collapseAllTooltip",
            iconName: "icon-collapseall-24x24",
            iconSize: "auto",
            needSeparator: this.creator.showCreatorThemeSettings,
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.creator.expandCollapseButtonVisibility != "never"; }),
            action: function () { return _this.creator.expandCollapseManager.expandCollapseElements("collapse-all", true); }
        });
        surfaceToolbarItems.push({
            id: "expandAll",
            locTooltipName: "ed.expandAllTooltip",
            iconName: "icon-expandall-24x24",
            iconSize: "auto",
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.creator.expandCollapseButtonVisibility != "never"; }),
            action: function () { return _this.creator.expandCollapseManager.expandCollapseElements("expand-all", false); }
        });
        surfaceToolbarItems.push({
            id: "lockQuestions",
            locTooltipName: "ed.lockQuestionsTooltip",
            iconName: "icon-questionlock-24x24",
            iconSize: "auto",
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.creator.expandCollapseButtonVisibility != "never"; }),
            action: function (action) {
                action.active = !action.active;
                _this.creator.expandCollapseManager.lockQuestions(action.active);
            }
        });
        this.surfaceToolbar.setItems(surfaceToolbarItems);
    };
    TabDesignerViewModel.prototype.scalingSurface = function (scaleFactor) {
        var _this = this;
        if (scaleFactor <= this.minSurfaceScaling || scaleFactor >= this.maxSurfaceScaling)
            return;
        this.surfaceScale = scaleFactor;
        this.creator.setDesignerSurveyScale(scaleFactor);
        Object.keys(this.unitDictionary).forEach(function (key) {
            _this.scaleCssVariables[key] = (_this.unitDictionary[key] * scaleFactor / 100) + "px";
        });
        this.updateDesignTabSurveyThemeVariables();
    };
    Object.defineProperty(TabDesignerViewModel.prototype, "survey", {
        get: function () {
            return this.creator.survey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabDesignerViewModel.prototype, "pagesController", {
        get: function () {
            return this.pagesControllerValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabDesignerViewModel.prototype, "isToolboxVisible", {
        get: function () {
            return this.creator.showToolbox && (this.creator.toolboxLocation === "right" || this.creator.toolboxLocation === "left");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabDesignerViewModel.prototype, "placeholderText", {
        get: function () {
            if (this.creator.isMobileView)
                return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.surveyPlaceHolderMobile");
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.surveyPlaceHolder");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabDesignerViewModel.prototype, "placeholderTitleText", {
        get: function () {
            if (this.creator.isMobileView)
                return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.surveyPlaceholderTitleMobile");
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.surveyPlaceholderTitle");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabDesignerViewModel.prototype, "placeholderDescriptionText", {
        get: function () {
            if (this.creator.isMobileView)
                return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.surveyPlaceholderDescriptionMobile");
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.surveyPlaceholderDescription");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabDesignerViewModel.prototype, "hasToolbar", {
        get: function () {
            return this.creator.expandCollapseButtonVisibility != "never" || this.creator.showCreatorThemeSettings;
        },
        enumerable: false,
        configurable: true
    });
    TabDesignerViewModel.prototype.onDesignerSurveyPropertyChanged = function (obj, propName) {
        if (!obj || this.isUpdatingNewPage)
            return;
        this.isUpdatingNewPage = true;
        if (propName === "elements" && obj.isDescendantOf("page")) {
            var updatePageController = false;
            if (obj.elements.length === 0) {
                updatePageController = this.checkLastPageToDelete();
            }
            this.checkNewPage(updatePageController);
        }
        this.isUpdatingNewPage = false;
    };
    TabDesignerViewModel.prototype.calculateDesignerCss = function () {
        return this.survey.css.container + " " + this.survey.css.container + "--" + this.survey.calculatedWidthMode;
    };
    TabDesignerViewModel.prototype.initSurvey = function () {
        var _this = this;
        if (!this.survey)
            return;
        this.showNewPage = false;
        this.newPage = undefined;
        this.checkNewPage(false);
        this.updatePages();
        this.cssUpdater && this.cssUpdater.dispose();
        this.cssUpdater = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
            return _this.calculateDesignerCss();
        });
        this.survey.registerFunctionOnPropertyValueChanged("pages", function () {
            _this.checkNewPage(true);
            _this.updatePages();
        });
        this.designerCss = this.cssUpdater;
        this.pagesController.onSurveyChanged();
    };
    TabDesignerViewModel.prototype.checkNewPage = function (updatePageController) {
        var showPlaceholder = this.survey.getAllQuestions().length === 0 && this.survey.pageCount === 0;
        this.showPlaceholder = showPlaceholder;
        this.pageCount = this.survey.pageCount;
        if (this.showPlaceholder || this.canShowNewPage) {
            var pages = this.survey.pages;
            if (!this.newPage || (pages.length > 0 && this.newPage === pages[pages.length - 1])) {
                this.newPage = this.createNewPage();
                this.showNewPage = !!this.newPage;
            }
            if (this.newPage) {
                this.newPage.showTitle = !showPlaceholder;
                this.newPage.showDescription = !showPlaceholder;
            }
        }
        else {
            this.showNewPage = false;
            this.newPage = undefined;
        }
        if (updatePageController) {
            if (this.newPage) {
                this.newPage.num = this.survey.pages.length + 1;
                this.newPage.startLoadingFromJson();
                this.newPage.name = _survey_helper__WEBPACK_IMPORTED_MODULE_4__.SurveyHelper.getNewPageName(this.survey.pages);
                this.newPage.endLoadingFromJson();
            }
            this.pagesController.raisePagesChanged();
        }
    };
    TabDesignerViewModel.prototype.updatePages = function () {
        this.pages = this.survey.pages.concat(this.showNewPage ? [this.newPage] : []);
    };
    TabDesignerViewModel.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.cssUpdater && this.cssUpdater.dispose();
    };
    TabDesignerViewModel.prototype.checkLastPageToDelete = function () {
        if (this.survey.pageCount === 0 || this.survey.isQuestionDragging)
            return false;
        var lastPage = this.survey.pages[this.survey.pageCount - 1];
        if (lastPage.elements.length > 0 || lastPage.isConverting)
            return false;
        if (_survey_helper__WEBPACK_IMPORTED_MODULE_4__.SurveyHelper.isPagePropertiesAreModified(lastPage))
            return false;
        lastPage.delete();
        if (this.survey.pageCount === 0) {
            this.creator.selectElement(this.survey);
        }
        return true;
    };
    Object.defineProperty(TabDesignerViewModel.prototype, "pages", {
        get: function () {
            return this._pages;
        },
        set: function (val) {
            this.pagesAnimation.sync(val);
        },
        enumerable: false,
        configurable: true
    });
    TabDesignerViewModel.prototype.getPagesAnimationOptions = function () {
        var _this = this;
        return {
            getEnterOptions: function (item, info) {
                return {
                    onBeforeRunAnimation: survey_core__WEBPACK_IMPORTED_MODULE_1__.prepareElementForVerticalAnimation,
                    cssClass: "svc-page--enter",
                    onAfterRunAnimation: survey_core__WEBPACK_IMPORTED_MODULE_1__.cleanHtmlElementAfterAnimation
                };
            },
            getLeaveOptions: function (item, info) {
                return {
                    onBeforeRunAnimation: survey_core__WEBPACK_IMPORTED_MODULE_1__.prepareElementForVerticalAnimation,
                    cssClass: "svc-page--leave",
                    onAfterRunAnimation: survey_core__WEBPACK_IMPORTED_MODULE_1__.cleanHtmlElementAfterAnimation
                };
            },
            isAnimationEnabled: function () {
                return _this.animationAllowed;
            },
            getKey: function (page) {
                return page.id;
            },
            getAnimatedElement: function (item) { var _a, _b; return (_b = (_a = _action_container_view_model__WEBPACK_IMPORTED_MODULE_6__.SurveyElementAdornerBase.GetAdorner(item)) === null || _a === void 0 ? void 0 : _a.rootElement) === null || _b === void 0 ? void 0 : _b.parentElement; },
            getRerenderEvent: function () { return _this.onElementRerendered; },
            onCompareArrays: function (options) {
                var droppedPage = options.mergedItems.filter(function (page) { return page["draggedFrom"] !== undefined; })[0];
                if (droppedPage) {
                    options.reorderedItems = [];
                    options.addedItems = [droppedPage];
                    var ghostPage = new survey_core__WEBPACK_IMPORTED_MODULE_1__.PageModel();
                    ghostPage.setSurveyImpl(droppedPage.survey);
                    ghostPage.title = droppedPage.title;
                    ghostPage.num = droppedPage.num;
                    ghostPage["isGhost"] = true;
                    options.deletedItems = [ghostPage];
                    options.mergedItems.splice(droppedPage["draggedFrom"], 0, ghostPage);
                }
            },
        };
    };
    TabDesignerViewModel.prototype.clickDesigner = function () {
        this.creator.selectedElement = this.creator.survey;
    };
    TabDesignerViewModel.prototype.getRootCss = function () {
        var rootCss = this.survey.css.root;
        if (this.creator.showPageNavigator && this.survey.pageCount > 1 || this.creator.pageEditMode === "bypage" || this.hasToolbar) {
            rootCss += " svc-tab-designer--with-page-navigator";
        }
        if (this.showPlaceholder) {
            rootCss += " svc-tab-designer--with-place-holder";
        }
        rootCss += " svc-tab-designer--" + this.creator.pageEditMode + "-mode";
        return rootCss;
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], TabDesignerViewModel.prototype, "newPage", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], TabDesignerViewModel.prototype, "showNewPage", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], TabDesignerViewModel.prototype, "pageCount", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], TabDesignerViewModel.prototype, "designerCss", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], TabDesignerViewModel.prototype, "showPlaceholder", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: {} })
    ], TabDesignerViewModel.prototype, "surveyThemeVariables", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.propertyArray)()
    ], TabDesignerViewModel.prototype, "_pages", void 0);
    return TabDesignerViewModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/tabs/header-model.ts":
/*!*********************************************!*\
  !*** ./src/components/tabs/header-model.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HeaderModel: () => (/* binding */ HeaderModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./theme-custom-questions/font-settings */ "./src/components/tabs/theme-custom-questions/font-settings.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");





var HeaderModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(HeaderModel, _super);
    function HeaderModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeaderModel.prototype.getSurvey = function (live) {
        if (live === void 0) { live = false; }
        return this.owner;
    };
    HeaderModel.prototype.fromJSON = function (json, options) {
        _super.prototype.fromJSON.call(this, json, options);
        if (!!json["backgroundImageOpacity"])
            this.backgroundImageOpacity = json["backgroundImageOpacity"] * 100;
    };
    HeaderModel.prototype.setCssVariables = function (cssVariables) {
        if (cssVariables) {
            this["surveyTitle"] = (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_3__.fontsettingsFromCssVariable)(this.getPropertyByName("surveyTitle"), cssVariables);
            this["surveyDescription"] = (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_3__.fontsettingsFromCssVariable)(this.getPropertyByName("surveyDescription"), cssVariables);
            this["headerTitle"] = (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_3__.fontsettingsFromCssVariable)(this.getPropertyByName("headerTitle"), cssVariables);
            this["headerDescription"] = (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_3__.fontsettingsFromCssVariable)(this.getPropertyByName("headerDescription"), cssVariables);
        }
        var backgroundColorValue = cssVariables["--sjs-header-backcolor"];
        if (!!backgroundColorValue) {
            this["backgroundColorSwitch"] = this.getBackgroundColorSwitchByValue(backgroundColorValue);
            this["backgroundColor"] = this["backgroundColorSwitch"] === "custom" ? backgroundColorValue : undefined;
        }
    };
    HeaderModel.prototype.toJSON = function (options) {
        var _this = this;
        var result = _super.prototype.toJSON.call(this, options);
        delete result.type;
        delete result.logoPosition;
        delete result.headerView;
        if (this.backgroundImageOpacity !== 100) {
            result.backgroundImageOpacity = this.backgroundImageOpacity / 100;
        }
        var cssVariables = {};
        Object.keys(result).forEach(function (key) {
            if (typeof result[key] === "object") {
                var property = _this.getPropertyByName(key);
                if (property.type === "font") {
                    (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_3__.fontsettingsToCssVariable)(result[key], property, cssVariables);
                    delete result[key];
                }
            }
        });
        this.setHeaderBackgroundColorCssVariable(cssVariables);
        result.cssVariables = cssVariables;
        delete result.backgroundColorSwitch;
        delete result.backgroundColor;
        return result;
    };
    HeaderModel.prototype.saveToThemeJSON = function (json, options) {
        var result = this.toJSON(options);
        (0,_utils_utils__WEBPACK_IMPORTED_MODULE_4__.assign)(json.cssVariables, result.cssVariables);
        delete result.cssVariables;
        if (Object.keys(result).length > 0) {
            json.header = result;
        }
        json.headerView = this["headerView"];
    };
    HeaderModel.prototype.setHeaderBackgroundColorCssVariable = function (cssVariables) {
        var _a;
        if (this["backgroundColorSwitch"] === "none") {
            cssVariables["--sjs-header-backcolor"] = "transparent";
        }
        else if (this["backgroundColorSwitch"] === "custom") {
            cssVariables["--sjs-header-backcolor"] = (_a = this["backgroundColor"]) !== null && _a !== void 0 ? _a : "transparent";
        }
        else {
            cssVariables["--sjs-header-backcolor"] = undefined;
        }
    };
    HeaderModel.prototype.getBackgroundColorSwitchByValue = function (backgroundColor) {
        if (!backgroundColor)
            return "accentColor";
        if (backgroundColor === "transparent")
            return "none";
        return "custom";
    };
    HeaderModel.prototype.getType = function () {
        return "header";
    };
    return HeaderModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));

function getDefaultTitleSetting() {
    var result = { family: _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.themeEditor.defaultFontFamily, weight: "700", size: 32 };
    return result;
}
function getDefaultDescriptionSetting(isAdvanced) {
    var result = { family: _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.themeEditor.defaultFontFamily, weight: "400", size: 16 };
    if (isAdvanced) {
        result["weight"] = "600";
    }
    return result;
}
function getHorizontalAlignment(questionName, defaultValue) {
    return {
        type: "buttongroup",
        name: questionName,
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        choices: [
            { value: "left" },
            { value: "center" },
            { value: "right", },
        ],
        default: defaultValue,
    };
}
function getVerticalAlignment(questionName, defaultValue) {
    return {
        type: "buttongroup",
        name: questionName,
        displayName: "",
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        choices: [
            { value: "top" },
            { value: "middle" },
            { value: "bottom" },
        ],
        default: defaultValue,
    };
}
survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addClass("header", [
    {
        type: "buttongroup",
        name: "headerView",
        default: "basic",
        choices: [
            { value: "basic" },
            { value: "advanced" }
        ]
    },
    {
        type: "buttongroup",
        name: "logoPosition",
        visibleIf: function (obj) { return obj.headerView === "basic"; },
        default: "left",
        choices: [
            { value: "left" },
            { value: "right" }
        ],
    },
    {
        type: "spinedit",
        name: "height",
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        default: 256,
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "px";
                editor.min = 0;
            }
        }
    },
    {
        type: "spinedit",
        name: "mobileHeight",
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        default: 0,
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "px";
                editor.min = 0;
            }
        }
    },
    {
        type: "buttongroup",
        name: "inheritWidthFrom",
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        default: "container",
        choices: [
            { value: "survey" },
            { value: "container" }
        ],
    },
    {
        type: "spinedit",
        name: "textAreaWidth",
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        default: 512,
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "px";
                editor.min = 0;
            }
        }
    },
    {
        type: "buttongroup",
        name: "backgroundColorSwitch",
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        isSerializable: false,
        default: "accentColor",
        choices: [
            { value: "none" },
            { value: "accentColor" },
            { value: "custom" },
        ],
    },
    {
        type: "color",
        name: "backgroundColor",
        displayName: "",
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        isSerializable: false,
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.allowEmptyValue = true;
                editor.enableIf = "{composite.backgroundColorSwitch} = 'custom'";
            }
        }
    },
    {
        name: "backgroundImage:file",
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.storeDataAsText = false;
                editor.acceptedTypes = "image/*";
            }
        }
    },
    {
        type: "buttongroup",
        name: "backgroundImageFit",
        displayName: "",
        choices: [
            { value: "cover" },
            { value: "fill" },
            { value: "contain" },
            { value: "tile" },
        ],
        default: "cover",
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.enableIf = "{composite.backgroundImage} notempty";
            }
        }
    },
    {
        type: "spinedit",
        name: "backgroundImageOpacity",
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        default: 100,
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "%";
                editor.min = 0;
                editor.max = 100;
                editor.step = 5;
                editor.titleLocation = "left";
                editor.enableIf = "{composite.backgroundImage} notempty";
            }
        }
    },
    {
        type: "boolean",
        name: "overlapEnabled",
        displayName: "",
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.renderAs = "checkbox";
            }
        }
    },
    getHorizontalAlignment("logoPositionX", "right"),
    getVerticalAlignment("logoPositionY", "top"),
    getHorizontalAlignment("titlePositionX", "left"),
    getVerticalAlignment("titlePositionY", "bottom"),
    getHorizontalAlignment("descriptionPositionX", "left"),
    getVerticalAlignment("descriptionPositionY", "bottom"),
]);
survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addProperties("header", [
    {
        type: "font",
        name: "surveyTitle",
        visibleIf: function (obj) { return obj.headerView === "basic"; },
        default: getDefaultTitleSetting(),
    },
    {
        type: "font",
        name: "surveyDescription",
        visibleIf: function (obj) { return obj.headerView === "basic"; },
        default: getDefaultDescriptionSetting(),
    },
    {
        type: "font",
        name: "headerTitle",
        default: getDefaultTitleSetting(),
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.allowEmptyColorValue = true;
            }
        },
    },
    {
        type: "font",
        name: "headerDescription",
        default: getDefaultDescriptionSetting(true),
        visibleIf: function (obj) { return obj.headerView === "advanced"; },
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.allowEmptyColorValue = true;
            }
        },
    },
]);


/***/ }),

/***/ "./src/components/tabs/json-editor-ace.ts":
/*!************************************************!*\
  !*** ./src/components/tabs/json-editor-ace.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AceJsonEditorModel: () => (/* binding */ AceJsonEditorModel),
/* harmony export */   TabJsonEditorAcePlugin: () => (/* binding */ TabJsonEditorAcePlugin)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _textWorker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../textWorker */ "./src/textWorker.ts");
/* harmony import */ var _json_editor_plugin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./json-editor-plugin */ "./src/components/tabs/json-editor-plugin.ts");




__webpack_require__(/*! ./json-editor-ace.scss */ "./src/components/tabs/json-editor-ace.scss");
var AceJsonEditorModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(AceJsonEditorModel, _super);
    function AceJsonEditorModel(creator) {
        var _this = _super.call(this, creator) || this;
        _this.aceCanUndo = false;
        _this.aceCanRedo = false;
        return _this;
    }
    AceJsonEditorModel.prototype.getText = function () {
        return !!this.aceEditor ? this.aceEditor.getValue() : "";
    };
    AceJsonEditorModel.prototype.setText = function (value) {
        this.isProcessingImmediately = true;
        this.aceEditor.setValue(value);
        this.aceEditor.renderer.updateFull(true);
        this.aceEditor.getSession().getUndoManager().reset();
        this.processErrors(value);
        this.isProcessingImmediately = false;
    };
    AceJsonEditorModel.prototype.init = function (aceEditor) {
        var _a, _b;
        this.aceEditor = aceEditor;
        var aceModules = (_b = (_a = window["ace"]) === null || _a === void 0 ? void 0 : _a.define) === null || _b === void 0 ? void 0 : _b.modules;
        if (!(aceModules && aceModules["ace/ext/searchbox"])) {
            this.aceEditor.commands["removeCommand"]("find");
        }
        this.aceEditor.setReadOnly(this.readOnly);
        if (AceJsonEditorModel.aceBasePath) {
            try {
                window["ace"]["config"].set("basePath", AceJsonEditorModel.aceBasePath);
                this.aceEditor.session.setMode("ace/mode/json");
            }
            catch (_c) { }
        }
        var self = this;
        this.aceEditor.setShowPrintMargin(false);
        this.aceEditor.getSession().on("change", function () {
            self.onTextChanged();
        });
        this.aceEditor.getSession().setUseWorker(true);
        _textWorker__WEBPACK_IMPORTED_MODULE_2__.SurveyTextWorker.newLineChar =
            this.aceEditor.session.doc.getNewLineCharacter();
        this.onPluginActivate();
    };
    AceJsonEditorModel.prototype.updateUndoRedoState = function () {
        var undoManager = this.aceEditor
            .getSession()
            .getUndoManager();
        this.aceCanUndo = undoManager.hasUndo();
        this.aceCanRedo = undoManager.hasRedo();
        var isFocused = this.aceEditor.isFocused();
        if (isFocused === true) {
            this.isJSONChanged = !undoManager.isClean();
        }
    };
    AceJsonEditorModel.prototype.onTextChanged = function () {
        this.updateUndoRedoState();
        _super.prototype.onTextChanged.call(this);
    };
    AceJsonEditorModel.prototype.createAnnotations = function (errors) {
        var annotations = [];
        for (var i = 0; i < errors.length; i++) {
            var error = errors[i];
            var annotation = {
                row: error.rowAt,
                column: error.columnAt,
                text: error.text,
                type: "error"
            };
            annotations.push(annotation);
        }
        return annotations;
    };
    AceJsonEditorModel.prototype.setErrors = function (errors) {
        var _this = this;
        _super.prototype.setErrors.call(this, errors);
        this.aceEditor.getSession().setAnnotations(this.createAnnotations(errors));
        setTimeout(function () { return _this.aceEditor.resize(); });
    };
    AceJsonEditorModel.prototype.gotoError = function (at, row, column) {
        this.aceEditor.focus();
        this.aceEditor.renderer.scrollCursorIntoView({ row: row + 1, column: column + 1 }, 0.5);
        this.aceEditor.gotoLine(row + 1, column + 1);
    };
    AceJsonEditorModel.prototype.onEditorActivated = function () {
        this.aceEditor.getSession().getUndoManager().markClean();
        this.updateUndoRedoState();
        this.aceEditor.focus();
    };
    AceJsonEditorModel.aceBasePath = "";
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], AceJsonEditorModel.prototype, "aceCanUndo", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], AceJsonEditorModel.prototype, "aceCanRedo", void 0);
    return AceJsonEditorModel;
}(_json_editor_plugin__WEBPACK_IMPORTED_MODULE_3__.JsonEditorBaseModel));

var TabJsonEditorAcePlugin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TabJsonEditorAcePlugin, _super);
    function TabJsonEditorAcePlugin(creator) {
        var _this = _super.call(this, creator) || this;
        creator.addPluginTab("editor", _this, undefined, "svc-tab-json-editor-ace");
        return _this;
    }
    TabJsonEditorAcePlugin.prototype.createModel = function (creator) {
        return new AceJsonEditorModel(creator);
    };
    TabJsonEditorAcePlugin.hasAceEditor = function () {
        return typeof window !== "undefined" && typeof window["ace"] !== "undefined";
    };
    return TabJsonEditorAcePlugin;
}(_json_editor_plugin__WEBPACK_IMPORTED_MODULE_3__.TabJsonEditorBasePlugin));



/***/ }),

/***/ "./src/components/tabs/json-editor-plugin.ts":
/*!***************************************************!*\
  !*** ./src/components/tabs/json-editor-plugin.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   JsonEditorBaseModel: () => (/* binding */ JsonEditorBaseModel),
/* harmony export */   TabJsonEditorBasePlugin: () => (/* binding */ TabJsonEditorBasePlugin)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _textWorker__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../textWorker */ "./src/textWorker.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../creator-settings */ "./src/creator-settings.ts");





var maxErrorLength = 150;
var JsonEditorBaseModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(JsonEditorBaseModel, _super);
    function JsonEditorBaseModel(creator) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.isJSONChanged = false;
        _this.isProcessingImmediately = false;
        _this.jsonEditorChangedTimeoutId = -1;
        return _this;
    }
    Object.defineProperty(JsonEditorBaseModel.prototype, "text", {
        get: function () {
            return this.getText();
        },
        set: function (val) {
            this.setText(val);
        },
        enumerable: false,
        configurable: true
    });
    JsonEditorBaseModel.prototype.onEditorActivated = function () { };
    JsonEditorBaseModel.prototype.onPluginActivate = function () {
        this.text = this.creator.text;
        this.onEditorActivated();
        this.isJSONChanged = false;
    };
    JsonEditorBaseModel.prototype.onTextChanged = function () {
        if (this.jsonEditorChangedTimeoutId !== -1) {
            clearTimeout(this.jsonEditorChangedTimeoutId);
        }
        if (this.isProcessingImmediately) {
            this.jsonEditorChangedTimeoutId = -1;
        }
        else {
            var self_1 = this;
            if (!!window) {
                this.jsonEditorChangedTimeoutId = window.setTimeout(function () {
                    self_1.jsonEditorChangedTimeoutId = -1;
                    self_1.processErrors(self_1.text);
                }, JsonEditorBaseModel.updateTextTimeout);
            }
        }
    };
    Object.defineProperty(JsonEditorBaseModel.prototype, "errorList", {
        get: function () {
            var _this = this;
            if (!this.errorListValue) {
                this.errorListValue = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ListModel({
                    items: [],
                    onSelectionChanged: function (action) {
                        var error = action.data.error;
                        if (!!error)
                            _this.gotoError(error.at, error.rowAt, error.columnAt);
                    },
                    allowSelection: false,
                    searchEnabled: false
                });
                this.errorListValue.cssClasses = {
                    item: "svc-json-errors__item",
                    itemBody: "svc-json-error",
                    itemsContainer: "svc-json-errors"
                };
                this.errorListValue.hasVerticalScroller = true;
            }
            return this.errorListValue;
        },
        enumerable: false,
        configurable: true
    });
    JsonEditorBaseModel.prototype.setErrors = function (errors) {
        var hasErrors = errors.length > 0;
        if (hasErrors) {
            var actions_1 = [];
            this.createErrorActions(errors).forEach(function (action) { return actions_1.push(action); });
            this.errorList.setItems(actions_1);
        }
        this.hasErrors = hasErrors;
    };
    JsonEditorBaseModel.prototype.gotoError = function (at, row, column) { };
    JsonEditorBaseModel.prototype.createErrorActions = function (errors) {
        var _this = this;
        var res = [];
        var counter = 1;
        errors.forEach(function (error) {
            var line = error.rowAt > -1 ? "Line: " + (error.rowAt + 1) + ". " : "";
            var title = error.text;
            if (title.length > maxErrorLength + 3) {
                title = title.substring(0, maxErrorLength) + "...";
            }
            title = line + title;
            var at = error.at;
            res.push(new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
                id: "error_" + counter++,
                component: "json-error-item",
                title: title,
                tooltip: error.text,
                iconName: "icon-error",
                iconSize: "auto",
                data: {
                    error: error,
                    showFixButton: error.isFixable,
                    fixError: function () {
                        _this.text = error.fixError(_this.text);
                    },
                    fixButtonIcon: "icon-fix",
                    //todo
                    fixButtonTitle: "Fix error"
                }
            }));
        });
        return res;
    };
    JsonEditorBaseModel.prototype.processErrors = function (text) {
        var textWorker = new _textWorker__WEBPACK_IMPORTED_MODULE_2__.SurveyTextWorker(text);
        this.setErrors(textWorker.errors);
    };
    Object.defineProperty(JsonEditorBaseModel.prototype, "readOnly", {
        get: function () {
            return this.creator.readOnly;
        },
        enumerable: false,
        configurable: true
    });
    JsonEditorBaseModel.updateTextTimeout = 1000;
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], JsonEditorBaseModel.prototype, "hasErrors", void 0);
    return JsonEditorBaseModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));

var TabJsonEditorBasePlugin = /** @class */ (function () {
    function TabJsonEditorBasePlugin(creator) {
        this.creator = creator;
        this.saveToFileHandler = _utils_utils__WEBPACK_IMPORTED_MODULE_3__.saveToFileHandler;
        this.createActions().forEach(function (action) { return creator.toolbar.actions.push(action); });
    }
    TabJsonEditorBasePlugin.prototype.exportToFile = function (fileName) {
        if (this.model) {
            var jsonBlob = new Blob([this.model.text], { type: "application/json" });
            this.saveToFileHandler(fileName, jsonBlob);
        }
    };
    TabJsonEditorBasePlugin.prototype.importFromFile = function (file, callback) {
        var _this = this;
        var fileReader = new FileReader();
        fileReader.onload = function (e) {
            var surveyJSONText = fileReader.result;
            if (_this.model) {
                _this.model.text = surveyJSONText;
                _this.model.isJSONChanged = true;
            }
            callback && callback(surveyJSONText);
        };
        fileReader.readAsText(file);
    };
    TabJsonEditorBasePlugin.prototype.copyToClipboard = function () {
        if (this.model) {
            navigator.clipboard.writeText(this.model.text);
        }
    };
    TabJsonEditorBasePlugin.prototype.createActions = function () {
        var _this = this;
        var items = [];
        this.importAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "svc-json-import",
            iconName: "icon-load",
            iconSize: "auto",
            locTitleName: "ed.surveyJsonImportButton",
            locTooltipName: "ed.surveyJsonImportButton",
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.creator.activeTab === "editor"; }),
            mode: "small",
            component: "sv-action-bar-item",
            needSeparator: true,
            action: function () {
                if (!document)
                    return;
                if (!_this.inputFileElement) {
                    _this.inputFileElement = document.createElement("input");
                    _this.inputFileElement.type = "file";
                    _this.inputFileElement.style.display = "none";
                    _this.inputFileElement.onchange = function () {
                        if (_this.inputFileElement.files.length < 1)
                            return;
                        _this.importFromFile(_this.inputFileElement.files[0]);
                        _this.inputFileElement.value = "";
                    };
                }
                _this.inputFileElement.click();
            }
        });
        items.push(this.importAction);
        this.exportAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "svc-json-export",
            iconName: "icon-download",
            iconSize: "auto",
            locTitleName: "ed.surveyJsonExportButton",
            locTooltipName: "ed.surveyJsonExportButton",
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.creator.activeTab === "editor"; }),
            mode: "small",
            component: "sv-action-bar-item",
            action: function () {
                _this.exportToFile(_creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.jsonEditor.exportFileName);
            }
        });
        items.push(this.exportAction);
        this.copyAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "svc-json-copy",
            iconName: "icon-copy",
            iconSize: "auto",
            locTitleName: "ed.surveyJsonCopyButton",
            locTooltipName: "ed.surveyJsonCopyButton",
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.creator.activeTab === "editor"; }),
            mode: "small",
            component: "sv-action-bar-item",
            action: function () {
                _this.copyToClipboard();
            }
        });
        items.push(this.copyAction);
        return items;
    };
    TabJsonEditorBasePlugin.prototype.activate = function () {
        this.model = this.createModel(this.creator);
    };
    TabJsonEditorBasePlugin.prototype.deactivate = function () {
        if (this.model) {
            if (!this.model.readOnly && this.model.isJSONChanged) {
                this.creator.selectedElement = undefined;
                this.creator.changeText(this.model.text, false, true);
                this.creator.selectedElement = this.creator.survey;
                this.creator.setModified({ type: "JSON_EDITOR" });
            }
            this.model.dispose();
            this.model = undefined;
        }
        return true;
    };
    TabJsonEditorBasePlugin.prototype.defaultAllowingDeactivate = function () {
        if (!this.model)
            return true;
        var textWorker = new _textWorker__WEBPACK_IMPORTED_MODULE_2__.SurveyTextWorker(this.model.text);
        if (!textWorker.isJsonCorrect)
            return undefined;
        return !textWorker.isJsonHasErrors;
    };
    return TabJsonEditorBasePlugin;
}());



/***/ }),

/***/ "./src/components/tabs/json-editor-textarea.ts":
/*!*****************************************************!*\
  !*** ./src/components/tabs/json-editor-textarea.ts ***!
  \*****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TabJsonEditorTextareaPlugin: () => (/* binding */ TabJsonEditorTextareaPlugin),
/* harmony export */   TextareaJsonEditorModel: () => (/* binding */ TextareaJsonEditorModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _json_editor_plugin__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./json-editor-plugin */ "./src/components/tabs/json-editor-plugin.ts");




__webpack_require__(/*! ./json-editor-textarea.scss */ "./src/components/tabs/json-editor-textarea.scss");
var TextareaJsonEditorModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TextareaJsonEditorModel, _super);
    function TextareaJsonEditorModel(creator) {
        var _this = _super.call(this, creator) || this;
        _this.ariaLabel = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("tabs.editor");
        _this.onPluginActivate();
        return _this;
    }
    TextareaJsonEditorModel.prototype.checkKey = function (data, e) {
        if (e.key === "Tab") {
            e.preventDefault();
            var textareaElement = e.target;
            var start = textareaElement.selectionStart;
            var end = textareaElement.selectionEnd;
            textareaElement.value = textareaElement.value.substring(0, start) +
                "\t" + textareaElement.value.substring(end);
            textareaElement.selectionStart =
                textareaElement.selectionEnd = start + 1;
            e.stopPropagation();
        }
        return true;
    };
    TextareaJsonEditorModel.prototype.getText = function () {
        return this._text;
    };
    TextareaJsonEditorModel.prototype.setText = function (value) {
        this.isProcessingImmediately = true;
        this._text = value;
        this.processErrors(value);
        this.isProcessingImmediately = false;
    };
    TextareaJsonEditorModel.prototype.gotoError = function (at, row, column) {
        if (!this.textElement)
            return;
        var el = this.textElement;
        el.selectionStart = at;
        el.selectionEnd = at;
        el.focus();
    };
    Object.defineProperty(TextareaJsonEditorModel.prototype, "errorButtonText", {
        get: function () {
            return this.canShowErrors ? (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.jsonHideErrors") : (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.jsonShowErrors");
        },
        enumerable: false,
        configurable: true
    });
    TextareaJsonEditorModel.prototype.toggleErrors = function () {
        this.canShowErrors = !this.canShowErrors;
    };
    Object.defineProperty(TextareaJsonEditorModel.prototype, "userFriendlyErrors", {
        get: function () {
            if (this._errors.length === 0) {
                return [];
            }
            var customErrors = [];
            for (var i = 0; i < this._errors.length - 1; i++) {
                customErrors[i] = this._errors[i].text;
                customErrors[i] += "\n\n";
            }
            customErrors[this._errors.length - 1] = this._errors[this._errors.length - 1].text;
            return customErrors;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextareaJsonEditorModel.prototype, "errors", {
        get: function () {
            return this._errors;
        },
        enumerable: false,
        configurable: true
    });
    TextareaJsonEditorModel.prototype.onTextChanged = function () {
        this.isJSONChanged = true;
        _super.prototype.onTextChanged.call(this);
    };
    TextareaJsonEditorModel.prototype.setErrors = function (errors) {
        //TODO Remove this line and then the function
        this._errors = errors;
        _super.prototype.setErrors.call(this, errors);
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "", onSet: function (_, target) { return target.onTextChanged(); } })
    ], TextareaJsonEditorModel.prototype, "_text", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.propertyArray)()
    ], TextareaJsonEditorModel.prototype, "_errors", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], TextareaJsonEditorModel.prototype, "canShowErrors", void 0);
    return TextareaJsonEditorModel;
}(_json_editor_plugin__WEBPACK_IMPORTED_MODULE_3__.JsonEditorBaseModel));

var TabJsonEditorTextareaPlugin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TabJsonEditorTextareaPlugin, _super);
    function TabJsonEditorTextareaPlugin(creator) {
        var _this = _super.call(this, creator) || this;
        creator.addPluginTab("editor", _this, undefined, "svc-tab-json-editor-textarea");
        return _this;
    }
    TabJsonEditorTextareaPlugin.prototype.createModel = function (creator) {
        return new TextareaJsonEditorModel(creator);
    };
    return TabJsonEditorTextareaPlugin;
}(_json_editor_plugin__WEBPACK_IMPORTED_MODULE_3__.TabJsonEditorBasePlugin));



/***/ }),

/***/ "./src/components/tabs/logic-actions-model.ts":
/*!****************************************************!*\
  !*** ./src/components/tabs/logic-actions-model.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LogicActionModel: () => (/* binding */ LogicActionModel),
/* harmony export */   LogicActionModelBase: () => (/* binding */ LogicActionModelBase),
/* harmony export */   LogicActionSetValueModel: () => (/* binding */ LogicActionSetValueModel),
/* harmony export */   LogicActionTriggerModel: () => (/* binding */ LogicActionTriggerModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _property_grid__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../property-grid/index */ "./src/property-grid/index.ts");
/* harmony import */ var _logic_items__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./logic-items */ "./src/components/tabs/logic-items.ts");






var LogicActionModelBase = /** @class */ (function () {
    function LogicActionModelBase(panel, initialLogicAction, logicType) {
        this.panel = panel;
        this.initialLogicAction = initialLogicAction;
        this.logicType = logicType;
    }
    LogicActionModelBase.createActionModel = function (panel, logicAction, logicType, selectorElementsHash) {
        if (!!logicType && logicType.hasSelectorChoices) {
            if (logicType.name.indexOf("_setValue") > -1)
                return new LogicActionSetValueModel(panel, logicAction, logicType, selectorElementsHash);
            return new LogicActionModel(panel, logicAction, logicType, selectorElementsHash);
        }
        else {
            return new LogicActionTriggerModel(panel, logicAction, logicType);
        }
    };
    LogicActionModelBase.prototype.updateCurrentLogicAction = function (survey) { return false; };
    LogicActionModelBase.prototype.afterUpdateInitialLogicAction = function () { };
    LogicActionModelBase.prototype.resetElements = function () { };
    LogicActionModelBase.prototype.getSelectedElement = function () { return null; };
    LogicActionModelBase.prototype.updateInitialLogicAction = function () {
        this.initialLogicAction = this.currentLogicAction;
        if (this.afterUpdateInitialLogicAction) {
            this.afterUpdateInitialLogicAction();
        }
    };
    LogicActionModelBase.prototype.setInitialElementValue = function (question, action, selectedQuestion) {
        if (!!selectedQuestion && question.choices.filter(function (ch) { return ch.value === selectedQuestion; }).length !== 0) {
            question.value = selectedQuestion;
        }
        else {
            question.value = !!action && action.logicType == this.logicType ? action.elementName : undefined;
        }
    };
    return LogicActionModelBase;
}());

var LogicActionModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(LogicActionModel, _super);
    function LogicActionModel(panel, logicAction, logicType, selectorElementsHash) {
        var _this = _super.call(this, panel, logicAction, logicType) || this;
        _this.selectorElementsHash = selectorElementsHash;
        return _this;
    }
    LogicActionModel.prototype.getSelectorOptionsText = function (logicType) {
        var elementType = logicType.baseClass;
        var optionsCaptionName = elementType == "page" ? "pe.conditionSelectPage" : (elementType == "panel" ? "pe.conditionSelectPanel" : "pe.conditionSelectQuestion");
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString(optionsCaptionName);
    };
    LogicActionModel.prototype.getElementBySelectorName = function (panel) {
        var value = panel.getQuestionByName("elementSelector").value;
        if (!value)
            return null;
        return this.selectorElementsHash[value];
    };
    LogicActionModel.prototype.updateCurrentLogicAction = function (survey) {
        var selectedElement = this.getElementBySelectorName(this.panel);
        var createNewAction = !this.initialLogicAction || this.initialLogicAction.logicType != this.logicType || (!!selectedElement && this.initialLogicAction.element != selectedElement);
        if (!createNewAction) {
            return false;
        }
        this.currentLogicAction = new _logic_items__WEBPACK_IMPORTED_MODULE_4__.SurveyLogicAction(this.logicType, selectedElement, survey);
        return true;
    };
    LogicActionModel.prototype.resetElements = function () {
        var question = this.panel.getQuestionByName("elementSelector");
        question.visible = false;
    };
    LogicActionModel.prototype.updatePanelElements = function (selectedElement, choices) {
        var question = this.panel.getQuestionByName("elementSelector");
        question.visible = true;
        question.choices = choices;
        question.allowClear = false;
        question.optionsCaption = this.getSelectorOptionsText(this.logicType);
        this.setInitialElementValue(question, this.initialLogicAction, selectedElement);
    };
    LogicActionModel.prototype.getSelectedElement = function () {
        var question = this.panel.getQuestionByName("elementSelector");
        return question.value;
    };
    return LogicActionModel;
}(LogicActionModelBase));

var LogicActionSetValueModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(LogicActionSetValueModel, _super);
    function LogicActionSetValueModel() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LogicActionSetValueModel.prototype.updatePanelElements = function (selectedElement, choices) {
        _super.prototype.updatePanelElements.call(this, selectedElement, choices);
        this.getValueIfQuestion().placeholder = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("ed.lg.setValueExpressionPlaceholder");
        this.getValueIfPanel().visible = true;
        this.setValueExpressionValue();
    };
    LogicActionSetValueModel.prototype.afterUpdateInitialLogicAction = function () {
        var selectedElement = this.getElementBySelectorName(this.panel);
        if (!!selectedElement) {
            selectedElement.setValueExpression = this.panel.getQuestionByName("setValueExpression").value;
        }
    };
    LogicActionSetValueModel.prototype.setValueExpressionValue = function () {
        var selectedElement = this.getElementBySelectorName(this.panel);
        if (!!selectedElement) {
            this.getValueIfQuestion().value = selectedElement.setValueExpression;
        }
    };
    LogicActionSetValueModel.prototype.getValueIfPanel = function () { return this.panel.getElementByName("setValueIfPanel"); };
    LogicActionSetValueModel.prototype.getValueIfQuestion = function () { return this.panel.getQuestionByName("setValueExpression"); };
    LogicActionSetValueModel.prototype.resetElements = function () {
        _super.prototype.resetElements.call(this);
        this.getValueIfPanel().visible = false;
        this.getValueIfQuestion().clearValue();
    };
    return LogicActionSetValueModel;
}(LogicActionModel));

var LogicActionTriggerModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(LogicActionTriggerModel, _super);
    function LogicActionTriggerModel(panel, logicAction, logicType) {
        var _this = _super.call(this, panel, logicAction, logicType) || this;
        _this.isTrigger = true;
        return _this;
    }
    LogicActionTriggerModel.prototype.recreateQuestion = function (panel, obj, name, options) {
        var oldQuestion = !!name ? panel.getQuestionByName(name) : null;
        if (!oldQuestion)
            return;
        var triggerEditorPanel = panel.getElementByName("triggerEditorPanel");
        var tempPanel = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass("panel");
        var propGenerator = new _property_grid__WEBPACK_IMPORTED_MODULE_3__.PropertyJSONGenerator(obj, options);
        propGenerator.setupObjPanel(tempPanel, true, "logic");
        var newQuestion = tempPanel.getQuestionByName(name);
        if (!!newQuestion) {
            var index = triggerEditorPanel.elements.indexOf(oldQuestion);
            triggerEditorPanel.blockAnimations();
            triggerEditorPanel.addElement(newQuestion, index);
            oldQuestion.delete();
            triggerEditorPanel.releaseAnimations();
        }
        if (newQuestion.name === "setValue") {
            this.updateSetValueQuestion(newQuestion);
        }
        this.updateVisibilityPanel(triggerEditorPanel);
        tempPanel.dispose();
    };
    LogicActionTriggerModel.prototype.updateSetValueQuestion = function (question) {
        var obj = question.obj;
        var survey = obj.getSurvey();
        if (!survey) {
            survey = obj["owner"];
        }
        if (!obj["setToName"] || !survey)
            return;
        var originalQuestion = survey.getQuestionByValueName(obj["setToName"]);
        question.title = originalQuestion.title;
        question.titleLocation = "top";
    };
    LogicActionTriggerModel.prototype.updateRunExpressionQuestion = function (question) {
        question.titleLocation = "hidden";
        question.placeholder = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.emptyExpressionPlaceHolder");
    };
    LogicActionTriggerModel.prototype.createElementPanelObj = function () {
        var action = this.initialLogicAction;
        var srcElement = !!action && action.logicType == this.logicType ? action.element : null;
        var newObj = this.logicType.createNewObj(srcElement);
        this.setPanelObj(newObj);
        return newObj;
    };
    LogicActionTriggerModel.prototype.getQuestions = function () {
        var _this = this;
        var triggerQuestionsPanel = this.panel.getElementByName("triggerQuestionsPanel");
        if (triggerQuestionsPanel.elements.length === 0 || !this.logicType.questionNames) {
            return null;
        }
        return triggerQuestionsPanel.elements.filter(function (el) { return _this.logicType.questionNames.indexOf(el.name) !== -1; });
    };
    LogicActionTriggerModel.prototype.resetPanel = function (panelName) {
        var panel = this.panel.getElementByName(panelName);
        panel.questions.forEach(function (q) { q.clearValue(); });
        panel.elements.splice(0, panel.elements.length);
        panel.visible = false;
    };
    LogicActionTriggerModel.prototype.updateVisibilityPanel = function (panel) {
        if (panel.elements.length > 0) {
            panel.visible = panel.elements.filter(function (el) { return el.visible; }).length > 0;
        }
        else {
            panel.visible = false;
        }
    };
    LogicActionTriggerModel.prototype.onPanelQuestionValueChanged = function (panel, qName) {
        var _this = this;
        if (this.panelObj) {
            var prop = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(this.panelObj.getType(), qName);
            var depProps = prop === null || prop === void 0 ? void 0 : prop.getDependedProperties();
            if (Array.isArray(depProps) && depProps.length > 0) {
                depProps.forEach(function (dp) {
                    var dQ = panel.getQuestionByName(dp);
                    var dProp = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(_this.panelObj.getType(), dp);
                    if (!!dQ && !!dProp) {
                        _property_grid__WEBPACK_IMPORTED_MODULE_3__.PropertyGridEditorCollection.onMasterValueChanged(_this.panelObj, dProp, dQ);
                    }
                });
            }
        }
    };
    LogicActionTriggerModel.prototype.updatePanelQuestionsValue = function (panel) {
        var _this = this;
        panel.onSurveyLoad();
        panel.questions.forEach(function (q) {
            if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(_this.panelObj[q.getValueName()])) {
                q.value = _this.panelObj[q.getValueName()];
            }
        });
    };
    LogicActionTriggerModel.prototype.afterUpdateInitialLogicAction = function () {
        this.setPanelObj(this.initialLogicAction.element);
        if (!!this.panelObj) {
            this.logicType.saveNewElement(this.panelObj);
        }
    };
    LogicActionTriggerModel.prototype.updateCurrentLogicAction = function (survey) {
        var createNewAction = !this.initialLogicAction || this.initialLogicAction.logicType != this.logicType;
        if (!createNewAction) {
            var el = this.initialLogicAction.element;
            var srcJson = this.panelObj.toJSON();
            var srcKeys = Object.keys(srcJson);
            var destKeys = Object.keys(el.toJSON());
            var propsToDelete = [];
            for (var i = 0; i < destKeys.length; i++) {
                var key = destKeys[i];
                if (srcKeys.indexOf(key) < 0) {
                    propsToDelete.push(key);
                }
            }
            el.fromJSON(srcJson);
            this.currentLogicAction = this.initialLogicAction;
            for (var i = 0; i < propsToDelete.length; i++) {
                el[propsToDelete[i]] = undefined;
            }
            return false;
        }
        this.currentLogicAction = new _logic_items__WEBPACK_IMPORTED_MODULE_4__.SurveyLogicAction(this.logicType, this.panelObj, survey);
        return true;
    };
    LogicActionTriggerModel.prototype.updatePanel = function (propertyName, newValue, options, survey) {
        if (!this.panelObj)
            return;
        this.panelObj[propertyName] = newValue;
        if (!!this.logicType && this.logicType.dependedOnPropertyName === propertyName) {
            this.recreateQuestion(this.panel, this.panelObj, this.logicType.dynamicPropertyName, options);
        }
        this.panel.runCondition(survey.getAllValues(), { survey: survey });
    };
    LogicActionTriggerModel.prototype.setPanelObj = function (obj) {
        var _this = this;
        var oldPanelObj = this.panelObj;
        if (!!oldPanelObj) {
            oldPanelObj.onPropertyValueChangedCallback = undefined;
        }
        this.panelObj = obj;
        if (!!obj) {
            obj.onPropertyValueChangedCallback = function (name, oldValue, newValue, sender, arrayChanges) {
                if (!_this.panel || _this.panel.isDisposed) {
                    oldPanelObj.onPropertyValueChangedCallback = undefined;
                    return;
                }
                var q = _this.panel.getQuestionByName(name);
                if (!!q) {
                    q.value = newValue;
                }
            };
        }
    };
    LogicActionTriggerModel.prototype.resetElements = function () {
        this.setPanelObj(null);
        this.resetPanel("triggerQuestionsPanel");
        this.resetPanel("triggerEditorPanel");
    };
    LogicActionTriggerModel.prototype.updatePanelElements = function (selectedElement, options) {
        var _this = this;
        var triggerEditorPanel = this.panel.getElementByName("triggerEditorPanel");
        var triggerQuestionsPanel = this.panel.getElementByName("triggerQuestionsPanel");
        var obj = this.createElementPanelObj();
        var propGenerator = new _property_grid__WEBPACK_IMPORTED_MODULE_3__.PropertyJSONGenerator(obj, options);
        propGenerator.setupObjPanel(triggerEditorPanel, true, "logic");
        triggerEditorPanel.title = "";
        var runExpressionQuestion = triggerEditorPanel.getQuestionByName("runExpression");
        runExpressionQuestion && this.updateRunExpressionQuestion(runExpressionQuestion);
        if (!!this.logicType.questionNames) {
            var questionsToMove = triggerEditorPanel.elements.filter(function (el) { return _this.logicType.questionNames.indexOf(el.name) !== -1; });
            questionsToMove.forEach(function (q) {
                var question = q;
                if (question.getType() === "dropdown") {
                    question.allowClear = false;
                    question.renderAs = "logicoperator";
                }
                triggerQuestionsPanel.addQuestion(question);
            });
        }
        triggerEditorPanel.getElementByName(this.logicType.propertyName).visible = false;
        this.updateVisibilityPanel(triggerQuestionsPanel);
        this.updatePanelQuestionsValue(triggerQuestionsPanel);
        this.updateVisibilityPanel(triggerEditorPanel);
        this.updatePanelQuestionsValue(triggerEditorPanel);
        var questions = this.getQuestions();
        if (!!questions && !!selectedElement) {
            questions.forEach(function (question) {
                _this.setInitialElementValue(question, _this.initialLogicAction, selectedElement);
                selectedElement = null;
            });
        }
    };
    LogicActionTriggerModel.prototype.getSelectedElement = function () {
        var questions = this.getQuestions();
        if (!questions)
            return;
        var question = questions[0];
        return (!!question && question.value);
    };
    return LogicActionTriggerModel;
}(LogicActionModelBase));



/***/ }),

/***/ "./src/components/tabs/logic-expression.ts":
/*!*************************************************!*\
  !*** ./src/components/tabs/logic-expression.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SurveyLogicExpressionUpdater: () => (/* binding */ SurveyLogicExpressionUpdater),
/* harmony export */   updateLogicExpression: () => (/* binding */ updateLogicExpression)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);

var SurveyLogicExpressionUpdater = /** @class */ (function () {
    function SurveyLogicExpressionUpdater(expresion) {
        this.constChanges = [];
        this.operand = new survey_core__WEBPACK_IMPORTED_MODULE_0__.ConditionsParser().parseExpression(expresion);
    }
    SurveyLogicExpressionUpdater.prototype.update = function (varName, oldValue, newValue) {
        this.updateOperand(this.operand, varName.toLocaleLowerCase(), oldValue, newValue);
    };
    Object.defineProperty(SurveyLogicExpressionUpdater.prototype, "isModified", {
        get: function () { return this.constChanges.length > 0; },
        enumerable: false,
        configurable: true
    });
    SurveyLogicExpressionUpdater.prototype.toString = function () {
        var self = this;
        var isRoot = true;
        var strFunc = function (op) {
            var locIsRoot = isRoot;
            isRoot = false;
            if (op.getType() === "const") {
                return self.constToString(op);
            }
            if (op.getType() === "binary") {
                return self.binaryToString(op, locIsRoot, strFunc);
            }
            return undefined;
        };
        return this.operand.toString(strFunc);
    };
    SurveyLogicExpressionUpdater.prototype.constToString = function (op) {
        for (var i = 0; i < this.constChanges.length; i++) {
            if (this.constChanges[i].op === op)
                return this.constChanges[i].val;
        }
        return op.toString();
    };
    SurveyLogicExpressionUpdater.prototype.binaryToString = function (op, isRoot, func) {
        return ((isRoot ? "" : "(") +
            this.operandToString(op.leftOperand, func) +
            " " +
            this.operatorToString(op.operator) +
            " " +
            this.operandToString(op.rightOperand, func) +
            (isRoot ? "" : ")"));
    };
    SurveyLogicExpressionUpdater.prototype.operandToString = function (op, func) {
        return !!op ? op.toString(func) : "";
    };
    SurveyLogicExpressionUpdater.prototype.operatorToString = function (operator) {
        var res = SurveyLogicExpressionUpdater.operatorText[operator];
        return !!res ? res : operator;
    };
    SurveyLogicExpressionUpdater.prototype.updateOperand = function (op, varName, oldValue, newValue) {
        if (op.getType() == "binary") {
            var bOP = op;
            if (bOP.isConjunction) {
                this.updateOperand(bOP.leftOperand, varName, oldValue, newValue);
                this.updateOperand(bOP.rightOperand, varName, oldValue, newValue);
            }
            else {
                if (this.hasVarName(bOP.leftOperand, varName)) {
                    this.updateOperandConst(bOP.rightOperand, oldValue, newValue);
                }
                else {
                    if (this.hasVarName(bOP.rightOperand, varName)) {
                        this.updateOperandConst(bOP.leftOperand, oldValue, newValue);
                    }
                }
            }
        }
    };
    SurveyLogicExpressionUpdater.prototype.hasVarName = function (op, varName) {
        if (!op || op.getType() !== "variable")
            return;
        return op.variable.toLowerCase() === varName;
    };
    SurveyLogicExpressionUpdater.prototype.updateOperandConst = function (op, oldValue, newValue) {
        var _this = this;
        if (op.getType() === "array") {
            var aOp = op;
            if (Array.isArray(aOp.values)) {
                aOp.values.forEach(function (item) { return _this.updateOperandConst(item, oldValue, newValue); });
            }
        }
        if (op.getType() !== "const")
            return;
        var cOp = op;
        if (survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.isTwoValueEquals(cOp.correctValue, oldValue)) {
            newValue = this.getCorrectNewValue(cOp, newValue);
            this.constChanges.push({ op: op, val: newValue });
        }
    };
    SurveyLogicExpressionUpdater.prototype.getCorrectNewValue = function (op, newValue) {
        var str = op.toString();
        if (!!str && !survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.isTwoValueEquals(op.correctValue, str)) {
            if (str[0] === "\"" || str[0] === "'") {
                return str[0] + newValue + str[0];
            }
        }
        return newValue;
    };
    SurveyLogicExpressionUpdater.operatorText = {
        less: "<",
        lessorequal: "<=",
        greater: ">",
        greaterorequal: ">=",
        equal: "=",
        notequal: "!=",
        plus: "+",
        minus: "-",
        mul: "*",
        div: "/",
        power: "^",
        mod: "%",
        negate: "!",
    };
    return SurveyLogicExpressionUpdater;
}());

function updateLogicExpression(expression, varName, oldValue, newValue) {
    var updater = new SurveyLogicExpressionUpdater(expression);
    updater.update(varName, oldValue, newValue);
    return updater.isModified ? updater.toString() : expression;
}


/***/ }),

/***/ "./src/components/tabs/logic-item-editor.ts":
/*!**************************************************!*\
  !*** ./src/components/tabs/logic-item-editor.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LogicItemEditor: () => (/* binding */ LogicItemEditor)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _property_grid_index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../property-grid/index */ "./src/property-grid/index.ts");
/* harmony import */ var _logic_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./logic-types */ "./src/components/tabs/logic-types.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _logic_theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./logic-theme */ "./src/components/tabs/logic-theme.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _logic_actions_model__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./logic-actions-model */ "./src/components/tabs/logic-actions-model.ts");
/* harmony import */ var _property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../property-grid-theme/property-grid */ "./src/property-grid-theme/property-grid.ts");











function logicTypeVisibleIf(params) {
    if (!this.question || !this.question.parentQuestion || params.length != 1)
        return true;
    var panels = this.question.parentQuestion.panels;
    if (panels.length < 2)
        return true;
    for (var i = 0; i < panels.length; i++) {
        var q = panels[i].getQuestionByName("logicTypeName");
        if (q == this.question)
            continue;
        if (q.value == params[0])
            return false;
    }
    return true;
}
survey_core__WEBPACK_IMPORTED_MODULE_1__.FunctionFactory.Instance.register("logicTypeVisibleIf", logicTypeVisibleIf);
var LogicItemEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(LogicItemEditor, _super);
    function LogicItemEditor(editableItem, options) {
        if (options === void 0) { options = null; }
        var _this = _super.call(this, options) || this;
        _this.options = options;
        _this.initialSelectedElements = {};
        _this.isModifiedValue = false;
        _this.selectorElementsHash = {};
        if (!_this.options) {
            _this.options = new _creator_settings__WEBPACK_IMPORTED_MODULE_2__.EmptySurveyCreatorOptions();
        }
        _this.editSurvey.onDynamicPanelItemValueChanged.add(function (sender, options) {
            if (options.name == "logicTypeName") {
                _this.onLogicTypeChanged(options.panel);
            }
            var actionModel = _this.getActionModelByPanel(options.panel);
            if (actionModel.isTrigger) {
                actionModel.updatePanel(options.name, options.value, _this.options, _this.editSurvey);
            }
        });
        _this.editSurvey.onDynamicPanelRemoved.add(function (sender, options) {
            if (_this.isBuildingPanels)
                return;
            var actionModel = _this.getActionModelByPanel(options.panel);
            if (!!actionModel && !!actionModel.initialLogicAction) {
                _this.editableItem.removeAction(actionModel.initialLogicAction);
            }
            if (_this.panel.panelCount == 0) {
                _this.panel.addPanel();
            }
            if (_this.panel.panelCount > 0)
                _this.panels[0].getQuestionByName("logicTypeName").title = _editorLocalization__WEBPACK_IMPORTED_MODULE_5__.editorLocalization.getString("pe.then");
        });
        _this.editSurvey.onDynamicPanelAdded.add(function (sender, options) {
            if (_this.isBuildingPanels)
                return;
            var panel = _this.panels[_this.panel.panelCount - 1];
            _this.onPanelAdded(panel, null);
        });
        _this.editSurvey.css = _logic_theme__WEBPACK_IMPORTED_MODULE_7__.logicCss;
        _this.editSurvey.onUpdateQuestionCssClasses.add(function (sender, options) {
            _this.onUpdateQuestionCssClasses(options);
        });
        _this.editSurvey.onUpdatePanelCssClasses.add(function (sender, options) {
            _this.onUpdatePanelCssClasses(options);
        });
        _this.editSurvey.onQuestionAdded.add(function (sender, options) {
            _this.onQuestionAdded(options);
        });
        _this.editSurvey.onGetQuestionTitleActions.add(function (sender, options) {
            _this.onGetQuestionTitleActions(options);
        });
        _this.editSurvey.onValueChanged.add(function (sender, options) {
            _this.onValueChanged(options);
        });
        _this.editSurvey.onDynamicPanelItemValueChanged.add(function (sender, options) {
            var _a;
            var q = options.panel.getQuestionByName(options.name);
            if (!!q && ((_a = q.parent) === null || _a === void 0 ? void 0 : _a.name) === "triggerEditorPanel") {
                var action = _this.getActionModelByPanel(options.panel);
                if (action) {
                    action.onPanelQuestionValueChanged(q.parent, options.name);
                }
            }
        });
        _this.setEditableItem(editableItem);
        return _this;
    }
    Object.defineProperty(LogicItemEditor.prototype, "editableItem", {
        get: function () {
            return this.editableItemValue;
        },
        enumerable: false,
        configurable: true
    });
    LogicItemEditor.prototype.setEditableItem = function (val) {
        this.editableItemValue = val;
        this.buildInitialSelectedElements();
        this.buildPanels();
        this.resetModified();
    };
    Object.defineProperty(LogicItemEditor.prototype, "survey", {
        get: function () {
            return this.editableItem.survey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogicItemEditor.prototype, "isModified", {
        get: function () {
            return this.isModifiedValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogicItemEditor.prototype, "panel", {
        get: function () {
            return (this.editSurvey.getQuestionByName("panel"));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(LogicItemEditor.prototype, "panels", {
        get: function () {
            return this.panel.panels;
        },
        enumerable: false,
        configurable: true
    });
    LogicItemEditor.prototype.getActionModelByPanel = function (panel) {
        return panel["actionModel"];
    };
    LogicItemEditor.prototype.setActionModelByPanel = function (panel, actionModel) {
        panel["actionModel"] = actionModel;
    };
    Object.defineProperty(LogicItemEditor.prototype, "context", {
        get: function () { return this.contextValue; },
        set: function (val) {
            if (val === this.context)
                return;
            this.contextValue = val;
            this.updatePanelsOnContextChanged();
        },
        enumerable: false,
        configurable: true
    });
    LogicItemEditor.prototype.getLogicTypeByPanel = function (panel) {
        return this.getLogicTypeByName(panel.getQuestionByName("logicTypeName").value);
    };
    LogicItemEditor.prototype.getSurveyJSON = function () {
        return {
            clearInvisibleValues: "onHidden",
            elements: [
                {
                    type: "paneldynamic",
                    name: "panel",
                    title: (0,_logic_types__WEBPACK_IMPORTED_MODULE_4__.getLogicString)("actionsEditorTitle"),
                    titleLocation: "hidden",
                    panelAddText: (0,_logic_types__WEBPACK_IMPORTED_MODULE_4__.getLogicString)("addNewAction"),
                    panelRemoveButtonLocation: "right",
                    panelCount: 0,
                    minPanelCount: 1,
                    maxPanelCount: 1,
                    templateElements: [
                        {
                            name: "logicTypeName",
                            type: "dropdown",
                            renderAs: "logicoperator",
                            searchEnabled: false,
                            allowClear: false,
                            title: _editorLocalization__WEBPACK_IMPORTED_MODULE_5__.editorLocalization.getString("pe.then"),
                            titleLocation: "left",
                            isRequired: true,
                            optionsCaption: (0,_logic_types__WEBPACK_IMPORTED_MODULE_4__.getLogicString)("selectedActionCaption"),
                            requiredErrorText: this.getLocString("pe.conditionActionEmpty")
                        },
                        {
                            name: "logicTypeDescription",
                            type: "html",
                            startWithNewLine: false,
                            visible: false // TODO we do not show description by the new design
                        },
                        {
                            name: "elementSelector",
                            type: "dropdown",
                            renderAs: "logicoperator",
                            allowClear: false,
                            titleLocation: "hidden",
                            isRequired: true,
                            startWithNewLine: false,
                            visible: false
                        },
                        {
                            name: "triggerQuestionsPanel",
                            type: "panel",
                            startWithNewLine: false,
                            visible: false
                        },
                        {
                            name: "removeAction",
                            type: "linkvalue",
                            titleLocation: "hidden",
                            showOptionsCaption: false,
                            visible: false,
                            startWithNewLine: false,
                            showValueInLink: false,
                            allowClear: false,
                            showClear: false,
                            iconName: "icon-delete_24x24"
                        },
                        {
                            name: "triggerEditorPanel",
                            type: "panel",
                            visible: false
                        },
                        {
                            name: "setValueIfPanel",
                            visible: false,
                            type: "panel",
                            elements: [{
                                    name: "setValueExpression",
                                    type: "comment",
                                    titleLocation: "hidden"
                                }]
                        }
                    ]
                }
            ]
        };
    };
    LogicItemEditor.prototype.getSurveyCreationReason = function () {
        return "logic-item-editor";
    };
    LogicItemEditor.prototype.resetModified = function () {
        this.isModifiedValue = false;
    };
    LogicItemEditor.prototype.isEmpty = function () {
        if (this.panels.length === 0)
            return true;
        if (this.panels.length > 1)
            return false;
        var modelAction = this.getActionModelByPanel(this.panels[0]);
        return !modelAction;
    };
    LogicItemEditor.prototype.apply = function () {
        if (this.editSurvey.hasErrors())
            return false;
        for (var i = 0; i < this.panels.length; i++) {
            this.applyPanel(this.panels[i]);
        }
        this.resetModified();
        return true;
    };
    LogicItemEditor.prototype.getEditingActions = function () {
        var _this = this;
        return this.panels.map(function (panel) {
            var modelAction = _this.getActionModelByPanel(panel);
            modelAction.updateCurrentLogicAction(_this.survey);
            return modelAction.currentLogicAction || modelAction.initialLogicAction;
        }).filter(function (action) { return !!action; });
    };
    LogicItemEditor.prototype.onUpdateQuestionCssClasses = function (options) {
        var _a;
        var cssClasses = options.cssClasses;
        var question = options.question;
        if (question.getType() !== "paneldynamic") {
            cssClasses.answered = "svc-logic-question--answered";
        }
        if (question.name === "logicTypeName") {
            question.allowRootStyle = false;
            cssClasses.control += " svc-logic-operator svc-logic-operator--action";
            cssClasses.error.root = "svc-logic-operator__error";
            cssClasses.onError = "svc-logic-operator--error";
        }
        var selectorsNames = ["elementSelector", "setToName", "fromName", "gotoName"];
        if (selectorsNames.indexOf(question.name) > -1) {
            question.allowRootStyle = false;
            if (question.name === "setToName" || question.name === "fromName") {
                question.titleLocation = "left";
                question.startWithNewLine = false;
            }
            cssClasses.control += " svc-logic-operator svc-logic-operator--question";
            cssClasses.error.root = "svc-logic-operator__error";
            cssClasses.onError = "svc-logic-operator--error";
        }
        if (question.isContentElement || this.isSetValueInternalQuestion(question)) {
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_8__.assignDefaultV2Classes)(cssClasses, question.getType());
            cssClasses.mainRoot += " svc-logic-question-value sd-element--with-frame";
        }
        var parentName = (_a = question.parent) === null || _a === void 0 ? void 0 : _a.name;
        if (selectorsNames.indexOf(question.name) < 0 && (parentName === "triggerEditorPanel" || parentName === "setValueIfPanel")) {
            var qType = question.getType();
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_8__.assignDefaultV2Classes)(cssClasses, qType);
            if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.defaultV2Css[qType] && _property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_10__.propertyGridCss[qType]) {
                (0,_utils_utils__WEBPACK_IMPORTED_MODULE_8__.copyCssClasses)(cssClasses, _property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_10__.propertyGridCss.question);
                (0,_utils_utils__WEBPACK_IMPORTED_MODULE_8__.copyCssClasses)(cssClasses, _property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_10__.propertyGridCss[qType]);
            }
            var els = question.parent.elements.filter(function (el) { return selectorsNames.indexOf(el.name) < 0 && el.name !== "expression"; });
            if ((question.name !== "runExpression" && qType !== "comment") || (Array.isArray(els) && els.length > 1)) {
                cssClasses.mainRoot += " svc-logic-question-value sd-element--with-frame";
            }
        }
        if (question.name === "removeAction") {
            question.allowRootStyle = false;
            cssClasses.mainRoot += " svc-logic-condition-remove-question";
        }
        if (question.name === "panel") {
            cssClasses.root += " svc-logic-paneldynamic";
            cssClasses.buttonAdd += " svc-logic-operator--action ";
            cssClasses.iconRemove = "svc-icon-remove";
            cssClasses.buttonRemove = "svc-logic-paneldynamic__button svc-logic-paneldynamic__remove-btn";
            cssClasses.buttonRemoveRight = "svc-logic-paneldynamic__remove-btn--right";
            cssClasses.buttonRemoveText = "svc-logic-paneldynamic__button-remove-text";
        }
    };
    LogicItemEditor.prototype.isSetValueInternalQuestion = function (question) {
        if (this.isSetValueInternalQuestionCore(question))
            return true;
        if (this.isSetValueInternalQuestionCore(question.parentQuestion))
            return true;
        var parent = question.parent;
        return parent && this.isSetValueInternalQuestionCore(parent.parentQuestion);
    };
    LogicItemEditor.prototype.isSetValueInternalQuestionCore = function (question) {
        var setValueName = "setValue";
        return (question === null || question === void 0 ? void 0 : question.name) === setValueName;
    };
    LogicItemEditor.prototype.onUpdatePanelCssClasses = function (options) {
        var panel = options.panel;
        var cssClasses = options.cssClasses;
        var name = panel.name;
        if (name === "triggerEditorPanel" || name === "setValueIfPanel") {
            cssClasses.panel.container += " svc-logic_trigger-editor";
        }
        if (name === "triggerQuestionsPanel") {
            panel.allowRootStyle = false;
            cssClasses.panel.container += " svc-logic_trigger-questions";
        }
        if (this.isSetValueInternalQuestionCore(panel.parentQuestion)) {
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_8__.assignDefaultV2Classes)(cssClasses, panel.getType());
        }
    };
    LogicItemEditor.prototype.onValueChanged = function (options) {
        this.isModifiedValue = true;
        options.question.maxPanelCount = (options.value.length === 1 && !options.value[0].logicTypeName) ? 1 : 100;
        this.panels.forEach(function (panel) {
            panel.getQuestionByName("removeAction").visible = options.value.length !== 1;
        });
    };
    LogicItemEditor.prototype.onQuestionAdded = function (options) {
        if (options.question.name === "setToName" || options.question.name === "fromName") {
            options.question.titleLocation = "left";
            options.question.startWithNewLine = false;
        }
    };
    LogicItemEditor.prototype.onGetQuestionTitleActions = function (options) {
        if (options.question.name === "setValue") {
            options.titleActions = [];
        }
    };
    LogicItemEditor.prototype.applyPanel = function (panel) {
        var actionModel = this.getActionModelByPanel(panel);
        if (!actionModel.updateCurrentLogicAction(this.survey)) {
            return;
        }
        this.editableItem.replaceAction(actionModel.currentLogicAction, actionModel.initialLogicAction);
        actionModel.updateInitialLogicAction();
    };
    LogicItemEditor.prototype.buildInitialSelectedElements = function () {
        this.initialSelectedElements = {};
        if (!this.editableItem)
            return;
        for (var i = 0; i < this.editableItem.actions.length; i++) {
            var action = this.editableItem.actions[i];
            if (this.isElementSelectorVisible(action.logicType)) {
                var lgName = action.logicTypeName;
                if (!this.initialSelectedElements[lgName]) {
                    this.initialSelectedElements[lgName] = [];
                }
                this.initialSelectedElements[lgName].push(action.element);
            }
        }
    };
    LogicItemEditor.prototype.buildPanels = function () {
        this.panel.panelCount = 0;
        if (!this.editableItem)
            return;
        this.logicTypeChoices = this.getLogicTypeChoices();
        for (var i = 0; i < this.editableItem.actions.length; i++) {
            this.onPanelAdded(this.panel.addPanel(), this.editableItem.actions[i]);
        }
        if (this.panel.panelCount == 0) {
            this.onPanelAdded(this.panel.addPanel(), null);
        }
    };
    LogicItemEditor.prototype.onPanelAdded = function (panel, action) {
        var ltQuestion = panel.getQuestionByName("logicTypeName");
        ltQuestion.title = this.panel.panelCount > 1 ? _editorLocalization__WEBPACK_IMPORTED_MODULE_5__.editorLocalization.getString("pe.and") : _editorLocalization__WEBPACK_IMPORTED_MODULE_5__.editorLocalization.getString("pe.then");
        ltQuestion.choices = this.logicTypeChoices;
        ltQuestion.allowClear = false;
        if (!!action) {
            var newActionModel = _logic_actions_model__WEBPACK_IMPORTED_MODULE_9__.LogicActionModelBase.createActionModel(panel, action, this.getLogicTypeByName(action.logicTypeName), this.selectorElementsHash);
            this.setActionModelByPanel(panel, newActionModel);
            ltQuestion.value = action.logicTypeName;
        }
        var removeActionLinkQuestion = (panel.getQuestionByName("removeAction"));
        var dynamicPanel = (removeActionLinkQuestion.parentQuestion);
        removeActionLinkQuestion.linkClickCallback = function () {
            if (!!dynamicPanel) {
                dynamicPanel.removePanelUI(panel);
            }
        };
        removeActionLinkQuestion.linkSetButtonCssClasses = "svc-logic-condition-remove svc-icon-remove";
        removeActionLinkQuestion.linkValueText = "";
        return panel;
    };
    LogicItemEditor.prototype.updatePanelsOnContextChanged = function () {
        this.logicTypeChoices = this.getLogicTypeChoices();
        if (!!this.context) {
            for (var i = this.panels.length - 1; i >= 0; i--) {
                var panel = this.panels[i];
                if (this.isPanelSupportContext(panel))
                    continue;
                if (i === 0 && this.panels.length === 1) {
                    panel.getQuestionByName("logicTypeName").clearValue();
                }
                else {
                    this.panel.removePanel(i);
                }
            }
        }
        for (var i = 0; i < this.panels.length; i++) {
            this.updateSelectorOnContextChanged(this.panels[i]);
        }
    };
    LogicItemEditor.prototype.isPanelSupportContext = function (panel) {
        var logicType = this.getLogicTypeByPanel(panel);
        return !!logicType ? logicType.supportContext(this.context) : false;
    };
    LogicItemEditor.prototype.updateSelectorOnContextChanged = function (panel) {
        var logicTypeQuestion = panel.getQuestionByName("logicTypeName");
        logicTypeQuestion.choices = this.logicTypeChoices;
        logicTypeQuestion.allowClear = false;
        var logicType = this.getLogicTypeByPanel(panel);
        if (!this.isElementSelectorVisible(logicType))
            return;
        var selectorQuestion = panel.getQuestionByName("elementSelector");
        selectorQuestion.choices = this.getSelectorChoices(logicType);
        selectorQuestion.allowClear = false;
    };
    LogicItemEditor.prototype.getLogicTypeChoices = function () {
        var res = [];
        var logicTypes = this.editableItem.getVisibleLogicTypes();
        for (var i = 0; i < logicTypes.length; i++) {
            var lt = logicTypes[i];
            if (!!this.context && !lt.supportContext(this.context))
                continue;
            var item = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue(lt.name, lt.displayName);
            if (lt.isUniqueItem) {
                item.visibleIf = "logicTypeVisibleIf({item})";
            }
            res.push(item);
        }
        return res;
    };
    LogicItemEditor.prototype.onLogicTypeChanged = function (panel) {
        var logicType = this.getLogicTypeByPanel(panel);
        var qTypeDescription = panel.getQuestionByName("logicTypeDescription");
        qTypeDescription.html = !!logicType ? logicType.description : "";
        var oldActionModel = this.getActionModelByPanel(panel);
        var prevSelectedQuestion;
        if (!!oldActionModel) {
            prevSelectedQuestion = oldActionModel.getSelectedElement();
            oldActionModel.resetElements();
        }
        if (!logicType)
            return;
        var newActionModel = _logic_actions_model__WEBPACK_IMPORTED_MODULE_9__.LogicActionModelBase.createActionModel(panel, (oldActionModel ? oldActionModel.initialLogicAction : null), logicType, this.selectorElementsHash);
        this.setActionModelByPanel(panel, newActionModel);
        if (newActionModel.isTrigger) {
            newActionModel.updatePanelElements(prevSelectedQuestion, this.options);
        }
        else {
            newActionModel.updatePanelElements(prevSelectedQuestion, this.getSelectorChoices(newActionModel.logicType));
        }
    };
    LogicItemEditor.prototype.getLogicTypeByName = function (ltName) {
        if (!ltName)
            return null;
        var logicTypes = this.editableItem.getVisibleLogicTypes();
        for (var i = 0; i < logicTypes.length; i++) {
            if (logicTypes[i].name == ltName)
                return logicTypes[i];
        }
        return null;
    };
    LogicItemEditor.prototype.isElementSelectorVisible = function (logicType) {
        return !!logicType && logicType.hasSelectorChoices;
    };
    LogicItemEditor.prototype.getLocString = function (name) {
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_5__.editorLocalization.getString(name);
    };
    LogicItemEditor.prototype.getElementText = function (el, showTitles) {
        var text = "";
        if (showTitles) {
            text = el.locTitle.renderedHtml;
        }
        if (!text)
            text = el.name;
        if (el.isQuestion) {
            text = this.options.getObjectDisplayName(el, "logic-tab:question-selector", "condition", text);
        }
        return text;
    };
    LogicItemEditor.prototype.getSelectorChoices = function (logicType) {
        if (!logicType.hasSelectorChoices)
            return [];
        var elements = logicType.getSelectorChoices(this.survey, this.context);
        var res = [];
        var showTitles = this.options.showTitlesInExpressions;
        for (var i = 0; i < elements.length; i++) {
            var namePrefix = "";
            var textPrefix = "";
            var el = elements[i];
            var owner = logicType.getParentElement(el);
            if (owner) {
                namePrefix = owner.name + ".";
                textPrefix = this.getElementText(owner, showTitles) + ".";
            }
            var text = this.getElementText(el, showTitles);
            var value = namePrefix + el.name;
            var itemValue = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue(value, textPrefix + text);
            this.selectorElementsHash[value] = el;
            if (!!el[logicType.propertyName] && !this.isElementInInitialSelection(logicType.name, el)) {
                itemValue.enableIf = "1=2";
                itemValue.visibleIf = "1=2";
            }
            res.push(itemValue);
        }
        if (_creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.questionSortOrder === "asc") {
            _survey_helper__WEBPACK_IMPORTED_MODULE_6__.SurveyHelper.sortItems(res);
        }
        return res;
    };
    LogicItemEditor.prototype.isElementInInitialSelection = function (logicTypeName, el) {
        if (!this.initialSelectedElements[logicTypeName])
            return false;
        return this.initialSelectedElements[logicTypeName].indexOf(el) > -1;
    };
    return LogicItemEditor;
}(_property_grid_index__WEBPACK_IMPORTED_MODULE_3__.PropertyEditorSetupValue));



/***/ }),

/***/ "./src/components/tabs/logic-items.ts":
/*!********************************************!*\
  !*** ./src/components/tabs/logic-items.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SurveyLogicAction: () => (/* binding */ SurveyLogicAction),
/* harmony export */   SurveyLogicItem: () => (/* binding */ SurveyLogicItem)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _expressionToDisplayText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../expressionToDisplayText */ "./src/expressionToDisplayText.ts");
/* harmony import */ var _logic_expression__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./logic-expression */ "./src/components/tabs/logic-expression.ts");
/* harmony import */ var _logic_types__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./logic-types */ "./src/components/tabs/logic-types.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../survey-helper */ "./src/survey-helper.ts");








var SurveyLogicAction = /** @class */ (function () {
    function SurveyLogicAction(logicType, element, survey) {
        this.surveyValue = survey;
        this.logicTypeValue = logicType;
        this.elementValue = element;
    }
    Object.defineProperty(SurveyLogicAction.prototype, "logicType", {
        get: function () {
            return this.logicTypeValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicAction.prototype, "element", {
        get: function () {
            return this.elementValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicAction.prototype, "parentElement", {
        get: function () {
            if (!this.element || !this.logicType)
                return null;
            return this.logicType.getParentElement(this.element);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicAction.prototype, "survey", {
        get: function () {
            return this.surveyValue;
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicAction.prototype.apply = function (expression, isRenaming) {
        if (isRenaming === void 0) { isRenaming = false; }
        if (!!this.element && !!this.logicType) {
            this.element[this.logicType.propertyName] = expression;
            if (!expression &&
                survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.isDescendantOf(this.element.getType(), "surveytrigger")) {
                var index = this.survey.triggers.indexOf(this.element);
                if (index > -1) {
                    this.survey.triggers.splice(index, 1);
                }
            }
        }
    };
    SurveyLogicAction.prototype.renameQuestion = function (oldName, newName) {
        if (!this.element)
            return;
        var names = this.questionNames;
        for (var i = 0; i < names.length; i++) {
            var str = this.element[names[i]];
            if (!!str && str.toLowerCase() == oldName.toLowerCase()) {
                this.element[names[i]] = newName;
            }
        }
    };
    SurveyLogicAction.prototype.clone = function () {
        var el = this.logicType.cloneElement(this.element);
        return new SurveyLogicAction(this.logicType, el, this.survey);
    };
    SurveyLogicAction.prototype.equals = function (action) {
        if (this.logicType !== action.logicType)
            return false;
        return this.logicType.areElementsEqual(this.element, action.element);
    };
    Object.defineProperty(SurveyLogicAction.prototype, "name", {
        get: function () {
            return !!this.logicType ? this.logicType.displayName : "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicAction.prototype, "logicTypeName", {
        get: function () {
            return !!this.logicType ? this.logicType.name : undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicAction.prototype, "logicTypeDescription", {
        get: function () {
            return !!this.logicType ? this.logicType.description : "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicAction.prototype, "text", {
        get: function () {
            return !!this.logicType ? this.logicType.getDisplayText(this.element) : "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicAction.prototype, "deleteActionText", {
        get: function () {
            return (0,_logic_types__WEBPACK_IMPORTED_MODULE_4__.getLogicString)("deleteAction");
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicAction.prototype.getLocString = function (name) {
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString(name);
    };
    SurveyLogicAction.prototype.isSuitableByQuestionName = function (questionName) {
        var res = this.elementName === questionName || this.elementName.indexOf(questionName + ".") === 0;
        if (!res) {
            res = this.questionNamesValues.filter(function (question) { return question === questionName || question.indexOf(questionName + ".") === 0; }).length > 0;
        }
        return res;
    };
    SurveyLogicAction.prototype.isSuitableByLogicType = function (logicTypeName) {
        if (!this.logicTypeName)
            return true;
        return logicTypeName === this.logicTypeName;
    };
    SurveyLogicAction.prototype.addQuestionNames = function (names) {
        var name = this.elementOwnerName;
        if (!!this.elementName && names.indexOf(name) === -1) {
            names.push(name);
        }
        this.questionNamesValues.forEach(function (name) {
            if (!!name && names.indexOf(name) === -1) {
                names.push(name);
            }
        });
    };
    Object.defineProperty(SurveyLogicAction.prototype, "questionNames", {
        get: function () {
            if (!this.logicType || !this.logicType.questionNames)
                return [];
            return this.logicType.questionNames;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicAction.prototype, "elementName", {
        get: function () {
            if (!this.element)
                return "";
            var prefix = "";
            var owner = this.getOwnerElement();
            if (!!owner && owner !== this.element) {
                prefix = owner.name + ".";
            }
            return (prefix + this.element.name) || "";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicAction.prototype, "elementOwnerName", {
        get: function () {
            var owner = this.getOwnerElement();
            return !!owner ? owner.name || "" : "";
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicAction.prototype.getOwnerElement = function () {
        if (!this.element)
            return null;
        var parentElement = this.parentElement;
        return !!parentElement ? parentElement : this.element;
    };
    Object.defineProperty(SurveyLogicAction.prototype, "questionNamesValues", {
        get: function () {
            var _this = this;
            return this.questionNames.map(function (name) { return _this.element[name]; });
        },
        enumerable: false,
        configurable: true
    });
    return SurveyLogicAction;
}());

var SurveyLogicItem = /** @class */ (function () {
    function SurveyLogicItem(owner, expression) {
        if (expression === void 0) { expression = ""; }
        this.owner = owner;
        this.expression = expression;
        this.idValue = ++SurveyLogicItem.counter;
        this.isNew = false;
        this.isModified = false;
        this.actionsValue = [];
        this.removedActions = [];
    }
    Object.defineProperty(SurveyLogicItem.prototype, "actions", {
        get: function () {
            return this.actionsValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicItem.prototype, "id", {
        get: function () { return this.idValue; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicItem.prototype, "name", {
        get: function () {
            return "logicItem" + this.id;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicItem.prototype, "survey", {
        get: function () {
            return this.owner.survey;
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicItem.prototype.getVisibleLogicTypes = function () {
        return this.owner.getVisibleLogicTypes();
    };
    Object.defineProperty(SurveyLogicItem.prototype, "expressionText", {
        get: function () {
            var text = this.getExpressionAsDisplayText();
            if (!text)
                return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.lg.itemEmptyExpressionText");
            return text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicItem.prototype, "actionsText", {
        get: function () {
            return this.actions.map(function (action) { return action.text; }).join(", ");
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicItem.prototype.getDisplayText = function () {
        var conditionText = this.getExpressionAsDisplayText();
        var actionsText = "";
        this.actions.forEach(function (action) {
            actionsText += (", " + action.text);
        });
        if (!!conditionText && !!actionsText) {
            var text = this.ifText + " " + conditionText + actionsText;
            return text.replace(new RegExp("({|})", "gm"), "'");
        }
        else {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.lg.itemEmptyExpressionText");
        }
    };
    SurveyLogicItem.prototype.edit = function () {
        if (!!this.owner) {
            this.owner.editItem(this);
        }
    };
    SurveyLogicItem.prototype.remove = function () {
        if (!!this.owner) {
            this.owner.removeItem(this);
        }
    };
    Object.defineProperty(SurveyLogicItem.prototype, "isReadOnly", {
        get: function () {
            return !!this.owner && this.owner.readOnly;
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicItem.prototype.addNewAction = function (action) {
        this.actions.push(action);
    };
    SurveyLogicItem.prototype.removeAction = function (action) {
        this.replaceActionCore(null, action);
    };
    SurveyLogicItem.prototype.replaceAction = function (newAction, oldAction) {
        if (!!oldAction) {
            this.replaceActionCore(newAction, oldAction);
        }
        else {
            this.addNewAction(newAction);
        }
    };
    SurveyLogicItem.prototype.clone = function () {
        var res = new SurveyLogicItem(this.owner, this.expression);
        for (var i = 0; i < this.actions.length; i++) {
            res.addNewAction(this.actions[i].clone());
        }
        return res;
    };
    SurveyLogicItem.prototype.equals = function (item) {
        if (this.expression !== item.expression)
            return false;
        if (this.actions.length !== item.actions.length)
            return false;
        for (var i = 0; i < this.actions.length; i++) {
            if (!this.actions[i].equals(item.actions[i]))
                return false;
        }
        return true;
    };
    SurveyLogicItem.prototype.replaceActionCore = function (newAction, oldAction) {
        this.removedActions.push(oldAction);
        var index = this.actions.indexOf(oldAction);
        if (index > -1) {
            if (!!newAction) {
                this.actions.splice(index, 1, newAction);
            }
            else {
                this.actions.splice(index, 1);
            }
        }
    };
    SurveyLogicItem.prototype.apply = function (expression) {
        if (!expression) {
            this.removeActions();
        }
        else {
            this.removeSameActions();
        }
        for (var i = 0; i < this.removedActions.length; i++) {
            this.removedActions[i].apply("");
        }
        this.removedActions = [];
        this.applyExpression(expression, false);
    };
    SurveyLogicItem.prototype.renameQuestion = function (oldName, newName) {
        var _this = this;
        if (!oldName || !newName || oldName === newName)
            return;
        ["", "panel.", "row."].forEach(function (prefix) {
            return _this.renameQuestionInExpression(prefix + oldName, prefix + newName, [_creator_settings__WEBPACK_IMPORTED_MODULE_5__.settings.logic.closeBracket, ".", "["]);
        });
        var ops = this.actions;
        for (var i = 0; i < ops.length; i++) {
            ops[i].renameQuestion(oldName, newName);
        }
    };
    SurveyLogicItem.prototype.renameColumn = function (question, column, oldName) {
        if (!this.canUpdateExpressionByQuestion(question))
            return;
        if (this.actions[0].parentElement === question) {
            this.renameQuestionInExpression("row." + oldName, "row." + column.name, [_creator_settings__WEBPACK_IMPORTED_MODULE_5__.settings.logic.closeBracket]);
        }
        var rows = question["rows"];
        if (!Array.isArray(rows) || !this.isQuestionInExpression(question))
            return;
        var questionPrefix = this.getItemValueQuestionName(question) + ".";
        for (var i = 0; i < rows.length; i++) {
            if (survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.isValueEmpty(rows[i].value))
                continue;
            var rowName = rows[i].value.toString() + ".";
            this.renameQuestionInExpression(questionPrefix + rowName + oldName, questionPrefix + rowName + column.name, [_creator_settings__WEBPACK_IMPORTED_MODULE_5__.settings.logic.closeBracket]);
        }
    };
    SurveyLogicItem.prototype.renameItemValue = function (question, item, oldValue) {
        if (!this.canUpdateExpressionByQuestion(question))
            return;
        if (!!question.parentQuestion) {
            if (Array.isArray(question.parentQuestion["rows"])) {
                this.renameDropdownColumnItemValue(question, item, oldValue);
            }
            if (this.actions[0].parentElement !== question.parentQuestion)
                return;
        }
        if (!this.isQuestionInExpression(question))
            return;
        var questionName = this.getItemValueQuestionName(question).toLocaleLowerCase();
        var rows = question["rows"];
        var newExpression = this.expression;
        if (!Array.isArray(rows)) {
            newExpression = (0,_logic_expression__WEBPACK_IMPORTED_MODULE_3__.updateLogicExpression)(newExpression, questionName, oldValue, item.value);
        }
        else {
            for (var i = 0; i < rows.length; i++) {
                if (survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.isValueEmpty(rows[i].value))
                    continue;
                var rowName = "." + rows[i].value.toString();
                newExpression = (0,_logic_expression__WEBPACK_IMPORTED_MODULE_3__.updateLogicExpression)(newExpression, questionName + rowName, oldValue, item.value);
            }
        }
        if (newExpression != this.expression) {
            this.applyExpression(newExpression, true);
        }
    };
    SurveyLogicItem.prototype.renameDropdownColumnItemValue = function (question, item, oldValue) {
        var matrix = question.parentQuestion;
        if (!this.isQuestionInExpression(matrix))
            return;
        var columnPostFix = "." + question.getValueName();
        if (!this.isStrContainsInExpression(columnPostFix + _creator_settings__WEBPACK_IMPORTED_MODULE_5__.settings.logic.closeBracket))
            return;
        var questionPrefix = matrix.getValueName() + ".";
        var rows = matrix["rows"];
        var newExpression = this.expression;
        for (var i = 0; i < rows.length; i++) {
            if (survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.isValueEmpty(rows[i].value))
                continue;
            var rowName = rows[i].value.toString();
            newExpression = (0,_logic_expression__WEBPACK_IMPORTED_MODULE_3__.updateLogicExpression)(newExpression, questionPrefix + rowName + columnPostFix, oldValue, item.value);
        }
        if (newExpression != this.expression) {
            this.applyExpression(newExpression, true);
        }
    };
    SurveyLogicItem.prototype.renameRowValue = function (question, item, oldValue) {
        if (!this.canUpdateExpressionByQuestion(question) || !this.isQuestionInExpression(question))
            return;
        var questionName = this.getItemValueQuestionName(question);
        this.renameQuestionInExpression(questionName + "." + oldValue.toString(), questionName + "." + item.value.toString(), [_creator_settings__WEBPACK_IMPORTED_MODULE_5__.settings.logic.closeBracket, "."]);
    };
    SurveyLogicItem.prototype.canUpdateExpressionByQuestion = function (question) {
        return !!this.expression && !!question.name && this.actions.length > 0;
    };
    SurveyLogicItem.prototype.isQuestionInExpression = function (question) {
        return this.isStrContainsInExpression(this.getItemValueQuestionName(question).toLocaleLowerCase());
    };
    SurveyLogicItem.prototype.isStrContainsInExpression = function (str) {
        if (!str)
            return false;
        return this.expression.toLocaleLowerCase().indexOf(str.toLocaleLowerCase()) > -1;
    };
    SurveyLogicItem.prototype.getItemValueQuestionName = function (question) {
        var valName = question.getValueName();
        if (!!question.parentQuestion) {
            if (question.parentQuestion.isDescendantOf("paneldynamic"))
                return "panel." + valName;
            if (question.parentQuestion.isDescendantOf("matrixdropdownbase"))
                return "row." + valName;
        }
        return valName;
    };
    SurveyLogicItem.prototype.removeQuestion = function (name) {
        this.removeQuestionInExpression(name);
    };
    SurveyLogicItem.prototype.getQuestionNames = function () {
        var res = [];
        this.getQuestionNamesFromExpression(res);
        this.getQuestionNamesFromActions(res);
        return res;
    };
    SurveyLogicItem.prototype.getActionTypes = function () {
        return this.actions.map(function (action) { return action.logicTypeName; });
    };
    SurveyLogicItem.prototype.getContext = function () {
        var exp = this.expression;
        if (!exp)
            return null;
        if (!_survey_helper__WEBPACK_IMPORTED_MODULE_7__.SurveyHelper.getQuestionContextIndexInfo(exp, "{"))
            return null;
        for (var i = 0; i < this.actions.length; i++) {
            var parentEl = this.actions[i].parentElement;
            if (!!parentEl) {
                return parentEl;
            }
        }
        return null;
    };
    SurveyLogicItem.prototype.getQuestionNamesFromExpression = function (names) {
        var conditionRunner = new survey_core__WEBPACK_IMPORTED_MODULE_0__.ConditionRunner(this.expression);
        conditionRunner.getVariables().forEach(function (item) {
            if (names.indexOf(item) === -1)
                names.push(item);
        });
    };
    SurveyLogicItem.prototype.getQuestionNamesFromActions = function (names) {
        this.actions.forEach(function (action) { return action.addQuestionNames(names); });
    };
    SurveyLogicItem.prototype.getExpressionAsDisplayText = function () {
        return !!this.owner
            ? this.owner.getExpressionAsDisplayText(this.expression)
            : this.expression;
    };
    Object.defineProperty(SurveyLogicItem.prototype, "editText", {
        get: function () {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("pe.edit");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicItem.prototype, "deleteText", {
        get: function () {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("pe.delete");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicItem.prototype, "ifText", {
        get: function () {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("pe.if");
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicItem.prototype.isSuitable = function (filteredName, logicTypeName) {
        if (logicTypeName === void 0) { logicTypeName = ""; }
        if (!filteredName && !logicTypeName)
            return true;
        if (!filteredName) {
            return this.isSuitableByLogicTypeInActions(logicTypeName);
        }
        if (!logicTypeName) {
            return this.isSuitableInExpression(filteredName) || this.isSuitableByNameInActions(filteredName);
        }
        return (this.isSuitableInExpression(filteredName) || this.isSuitableByNameInActions(filteredName)) && this.isSuitableByLogicTypeInActions(logicTypeName);
    };
    SurveyLogicItem.prototype.isSuitableInExpression = function (filteredName) {
        return this.expression.indexOf((0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.wrapTextByCurlyBraces)(filteredName)) !== -1 || this.expression.indexOf("'" + filteredName + ".") !== -1;
    };
    SurveyLogicItem.prototype.isSuitableByNameInActions = function (filteredName) {
        return this.actions.some(function (action) { return action.isSuitableByQuestionName(filteredName); });
    };
    SurveyLogicItem.prototype.isSuitableByLogicTypeInActions = function (logicTypeName) {
        return this.actions.some(function (action) { return action.isSuitableByLogicType(logicTypeName); });
    };
    SurveyLogicItem.prototype.renameQuestionInExpression = function (oldName, newName, postFixes) {
        var _this = this;
        if (!this.expression)
            return;
        oldName = oldName.toLowerCase();
        if (!this.isStrContainsInExpression(oldName))
            return;
        var ob = _creator_settings__WEBPACK_IMPORTED_MODULE_5__.settings.logic.openBracket;
        oldName = ob + oldName;
        newName = ob + newName;
        var newExpression = this.expression;
        postFixes.forEach(function (ch) {
            newExpression = _this.renameQuestionInExpressionCore(newExpression, newExpression.toLocaleLowerCase(), oldName + ch, newName + ch);
        });
        if (newExpression != this.expression) {
            this.applyExpression(newExpression, true);
        }
    };
    SurveyLogicItem.prototype.renameQuestionInExpressionCore = function (expression, lowCaseExpression, oldSubStr, newSubStr) {
        var index = lowCaseExpression.lastIndexOf(oldSubStr, lowCaseExpression.length);
        while (index > -1) {
            expression = expression.substring(0, index) + newSubStr + expression.substring(index + oldSubStr.length);
            lowCaseExpression = lowCaseExpression.substring(0, index);
            index = lowCaseExpression.lastIndexOf(oldSubStr, index);
        }
        return expression;
    };
    SurveyLogicItem.prototype.removeQuestionInExpression = function (name) {
        if (!this.expression)
            return;
        var expR = new _expressionToDisplayText__WEBPACK_IMPORTED_MODULE_2__.ExpressionRemoveVariable();
        var newExpression = expR.remove(this.expression, name);
        if (newExpression != this.expression) {
            this.applyExpression(newExpression, true);
        }
    };
    SurveyLogicItem.prototype.applyExpression = function (expression, isRenaming) {
        this.expression = expression;
        var ops = this.actions;
        for (var i = 0; i < ops.length; i++) {
            ops[i].apply(expression, isRenaming);
        }
    };
    SurveyLogicItem.prototype.removeActions = function () {
        var ops = this.actions;
        for (var i = ops.length - 1; i >= 0; i--) {
            this.removeAction(ops[i]);
        }
    };
    SurveyLogicItem.prototype.removeSameActions = function () {
        var ops = this.actions;
        for (var i = ops.length - 1; i >= 0; i--) {
            for (var j = i - 1; j >= 0; j--) {
                if (ops[i].equals(ops[j])) {
                    this.removeAction(ops[i]);
                    break;
                }
            }
        }
    };
    SurveyLogicItem.counter = 0;
    return SurveyLogicItem;
}());



/***/ }),

/***/ "./src/components/tabs/logic-plugin.ts":
/*!*********************************************!*\
  !*** ./src/components/tabs/logic-plugin.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TabLogicPlugin: () => (/* binding */ TabLogicPlugin)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _logic_types__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./logic-types */ "./src/components/tabs/logic-types.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _logic_ui__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./logic-ui */ "./src/components/tabs/logic-ui.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../survey-helper */ "./src/survey-helper.ts");





var TabLogicPlugin = /** @class */ (function () {
    function TabLogicPlugin(creator) {
        this.creator = creator;
        creator.addPluginTab("logic", this);
        this.createActions().forEach(function (action) { return creator.toolbar.actions.push(action); });
    }
    TabLogicPlugin.prototype.activate = function () {
        var _this = this;
        this.model = new _logic_ui__WEBPACK_IMPORTED_MODULE_3__.SurveyLogicUI(this.creator.survey, this.creator);
        this.filterQuestionAction.title = this.createFilterQuestionTitleUpdater();
        this.filterQuestionAction.visible = true;
        this.filterActionTypeAction.title = this.createFilterTypeTitleUpdater();
        this.filterActionTypeAction.visible = true;
        if (this.fastEntryAction) {
            this.fastEntryAction.visible = true;
            this.fastEntryAction.active = this.model.expressionEditorIsFastEntry;
            this.fastEntryAction.enabled = false;
        }
        this.model.onPropertyChanged.add(function (sender, options) {
            if (!!_this.fastEntryAction && options.name === "expressionEditorIsFastEntry") {
                _this.fastEntryAction.active = _this.model.expressionEditorIsFastEntry;
            }
            if (!!_this.fastEntryAction && options.name === "expressionEditorCanShowBuilder") {
                _this.fastEntryAction.enabled = _this.model.expressionEditorCanShowBuilder;
            }
        });
    };
    TabLogicPlugin.prototype.createFilterTypeTitleUpdater = function () {
        var _this = this;
        return new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () {
            var loc = _this.creator.locale;
            if (!loc)
                loc = "en";
            var type = _this.model.actionTypeFilter;
            var allType = _this.showAllActionTypesText;
            return !!type ? _this.model.getTypeByName(type).displayName : allType;
        });
    };
    TabLogicPlugin.prototype.createFilterQuestionTitleUpdater = function () {
        var _this = this;
        return new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () {
            var loc = _this.creator.locale;
            if (!loc)
                loc = "en";
            var questionFilter = _this.model.questionFilter;
            var allQuestions = _this.showAllQuestionsText;
            return !!questionFilter ? questionFilter : allQuestions;
        });
    };
    TabLogicPlugin.prototype.update = function () {
        if (!this.model)
            return;
        this.model.update(this.creator.survey);
    };
    TabLogicPlugin.prototype.canDeactivateAsync = function (onSuccess) {
        var _this = this;
        if (!!this.model) {
            this.model.tryLeaveUI(function (res) {
                if (!res) {
                    _this.creator.notify(_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("ed.lg.expressionInvalid"), "error");
                }
                else {
                    onSuccess();
                }
            });
            return;
        }
        onSuccess();
    };
    TabLogicPlugin.prototype.deactivate = function () {
        this.disposeObjs();
        return true;
    };
    TabLogicPlugin.prototype.dispose = function () {
        this.disposeObjs();
    };
    TabLogicPlugin.prototype.disposeObjs = function () {
        this.filterActionTypeAction.title = undefined;
        this.filterQuestionAction.title = undefined;
        if (this.model) {
            this.model.dispose();
            this.model = undefined;
        }
        this.filterQuestionAction.visible = false;
        this.filterActionTypeAction.visible = false;
        this.fastEntryAction && (this.fastEntryAction.visible = false);
    };
    TabLogicPlugin.prototype.createActions = function () {
        var _this = this;
        var items = [];
        var onQuestionPopupShow = function () {
            var items = _this.model.getUsedQuestions().map(function (question) { return { id: question.name, title: _this.creator.getObjectDisplayName(question, "logic-tab:question-filter", "condition", question.name) }; });
            _survey_helper__WEBPACK_IMPORTED_MODULE_4__.SurveyHelper.sortItems(items, "title");
            var listModel = _this.filterQuestionAction.popupModel.contentComponentData.model;
            listModel.setItems([{ id: null, title: _this.showAllQuestionsText }].concat(items));
        };
        this.filterQuestionAction = (0,survey_core__WEBPACK_IMPORTED_MODULE_0__.createDropdownActionModelAdvanced)({
            id: "svc-logic-filter-question",
            visible: false,
        }, {
            items: [{ id: null, title: this.showAllQuestionsText }],
            onSelectionChanged: function (item) {
                _this.model.questionFilter = !!item.id ? item.id : "";
            },
            allowSelection: true,
            locOwner: this.creator
        }, {
            verticalPosition: "bottom",
            horizontalPosition: "center",
            cssClass: "svc-creator-popup",
            onShow: onQuestionPopupShow
        });
        items.push(this.filterQuestionAction);
        var onActionTypesPopupShow = function () {
            var items = _this.model.getUsedActionTypes().map(function (type) { return { id: type.name, title: type.displayName }; });
            _survey_helper__WEBPACK_IMPORTED_MODULE_4__.SurveyHelper.sortItems(items, "title");
            var listModel = _this.filterActionTypeAction.popupModel.contentComponentData.model;
            listModel.setItems([{ id: null, title: _this.showAllActionTypesText }].concat(items));
        };
        this.filterActionTypeAction = (0,survey_core__WEBPACK_IMPORTED_MODULE_0__.createDropdownActionModelAdvanced)({
            id: "svc-logic-filter-actiontype",
            visible: false,
        }, {
            items: [{ id: null, title: this.showAllActionTypesText }],
            onSelectionChanged: function (item) {
                _this.model.actionTypeFilter = !!item.id ? item.id : "";
            },
            allowSelection: true,
            locOwner: this.creator
        }, {
            verticalPosition: "bottom",
            horizontalPosition: "center",
            cssClass: "svc-creator-popup",
            onShow: onActionTypesPopupShow
        });
        items.push(this.filterActionTypeAction);
        if (this.creator.allowEditExpressionsInTextEditor) {
            this.fastEntryAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
                id: "svc-logic-fast-entry",
                iconName: "icon-fast-entry",
                iconSize: "auto",
                locTitleName: "pe.fastEntry",
                visible: false,
                component: "sv-action-bar-item",
                action: function () {
                    _this.model.toggleExpressionEditorIsFastEntry();
                }
            });
            items.push(this.fastEntryAction);
        }
        return items;
    };
    Object.defineProperty(TabLogicPlugin.prototype, "showAllQuestionsText", {
        get: function () { return (0,_logic_types__WEBPACK_IMPORTED_MODULE_1__.getLogicString)("showAllQuestions"); },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabLogicPlugin.prototype, "showAllActionTypesText", {
        get: function () { return (0,_logic_types__WEBPACK_IMPORTED_MODULE_1__.getLogicString)("showAllActionTypes"); },
        enumerable: false,
        configurable: true
    });
    return TabLogicPlugin;
}());



/***/ }),

/***/ "./src/components/tabs/logic-theme.ts":
/*!********************************************!*\
  !*** ./src/components/tabs/logic-theme.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   logicCss: () => (/* binding */ logicCss)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);

var logicCss = {
    root: "",
    container: "",
    header: "",
    body: "sl-body",
    bodyEmpty: "",
    footer: "",
    title: "",
    description: "",
    logo: "",
    logoImage: "",
    headerText: "",
    navigationButton: "",
    completedPage: "",
    navigation: {
        complete: "",
        prev: "",
        next: "",
        start: "",
        preview: "",
        edit: ""
    },
    panel: {
        enter: "sl-element-wrapper--enter",
        leave: "sl-element-wrapper--leave",
        title: "",
        titleExpandable: "",
        titleOnExpand: "",
        titleOnError: "",
        description: "",
        container: "sl-panel",
        content: "",
        icon: "",
        iconExpanded: "",
        footer: "sl-panel__footer",
        requiredText: "sl-panel__required-text"
    },
    paneldynamic: {
        mainRoot: "",
        root: "",
        navigation: "",
        title: "",
        button: "",
        buttonRemove: "",
        buttonAdd: "svc-logic-operator sl-paneldynamic__add-btn",
        progressTop: "",
        progressBottom: "",
        buttonPrev: "",
        buttonNext: "",
        progressContainer: "",
        progress: "",
        progressBar: "",
        progressText: "",
        separator: "sv-hidden",
        panelWrapper: "sl-panel-wrapper",
        content: "sl-paneldynamic__content",
        panelsContainer: "",
        panelWrapperList: "sl-panel-wrapper--list",
        panelWrapperInRow: "sl-panel-wrapper--in-row",
        panelWrapperEnter: "sl-panel-wrapper--enter",
        panelWrapperLeave: "sl-panel-wrapper--leave"
    },
    progress: "",
    progressBar: "",
    progressText: "",
    progressTextInBar: "",
    page: {
        root: "",
        title: "",
        description: ""
    },
    pageTitle: "",
    pageDescription: "",
    row: "sl-row",
    rowEnter: "sl-row--enter",
    rowLeave: "sl-row--leave",
    rowDelayedEnter: "sl-row--delayed-enter",
    rowMultiple: "sl-row--multiple",
    question: {
        mainRoot: "sl-question",
        flowRoot: "",
        asCell: "",
        header: "sl-question__header",
        headerLeft: "sl-question__header--left",
        headerTop: "",
        headerBottom: "",
        content: "",
        contentLeft: "",
        titleLeftRoot: "",
        titleOnAnswer: "",
        titleOnError: "",
        enter: "sl-element-wrapper--enter",
        leave: "sl-element-wrapper--leave",
        title: "sl-question__title",
        requiredText: "sl-question__required-text",
        number: "",
        description: "",
        descriptionUnderInput: "",
        comment: "",
        required: "",
        titleRequired: "",
        indent: 0,
        footer: "",
        formGroup: "",
        hasError: "",
        disabled: ""
    },
    image: { root: "" },
    error: {
        root: "",
        icon: "",
        item: "",
        locationTop: "",
        locationBottom: ""
    },
    checkbox: {
        root: "",
        item: "",
        itemSelectAll: "",
        itemNone: "",
        itemDisabled: "",
        itemChecked: "",
        itemHover: "",
        itemInline: "",
        label: "",
        labelChecked: "",
        itemControl: "",
        itemDecorator: "",
        controlLabel: "",
        materialDecorator: "",
        other: "",
        column: ""
    },
    radiogroup: {
        root: "",
        item: "",
        itemInline: "",
        label: "",
        labelChecked: "",
        itemDisabled: "",
        itemChecked: "",
        itemHover: "",
        itemControl: "",
        itemDecorator: "",
        controlLabel: "",
        materialDecorator: "",
        other: "",
        clearButton: "",
        column: ""
    },
    boolean: {
        mainRoot: "",
        root: "",
        item: "",
        control: "",
        itemChecked: "",
        itemIndeterminate: "",
        itemDisabled: "",
        label: "",
        switch: "",
        disabledLabel: "",
        itemDecorator: "",
        materialDecorator: "",
        sliderText: "",
        slider: ""
    },
    text: {
        root: "",
        small: "",
        controlDisabled: "",
        onError: ""
    },
    multipletext: {
        root: "",
        item: "",
        itemTitle: "",
        row: "",
        cell: ""
    },
    dropdown: {
        root: "",
        popup: "svc-creator-popup",
        small: "",
        control: "sl-dropdown",
        selectWrapper: "",
        other: "",
        onError: "",
        label: "",
        item: "",
        itemDisabled: "",
        itemChecked: "",
        itemHover: "",
        itemControl: "",
        itemDecorator: "",
        controlDisabled: "",
        controlLabel: "",
        materialDecorator: "",
        controlValue: "sl-dropdown__value",
        chevronButton: "",
        chevronButtonSvg: "",
        chevronButtonIconId: "",
    },
    imagepicker: {
        root: "",
        item: "",
        itemInline: "",
        itemChecked: "",
        itemDisabled: "",
        itemHover: "",
        label: "",
        itemControl: "",
        image: "",
        itemText: "",
        clearButton: "",
        other: ""
    },
    matrix: {
        mainRoot: "",
        tableWrapper: "",
        root: "",
        row: "",
        rowAdditional: "",
        rowError: "",
        cell: "",
        headerCell: "",
        label: "",
        itemValue: "",
        itemChecked: "",
        itemDisabled: "",
        itemHover: "",
        materialDecorator: "",
        itemDecorator: "",
        cellText: "",
        cellTextSelected: "",
        cellTextDisabled: ""
    },
    matrixdropdown: {
        tableWrapper: "",
        mainRoot: "",
        root: "",
        row: "",
        rowAdditional: "",
        cell: "",
        headerCell: ""
    },
    matrixdynamic: {
        tableWrapper: "",
        mainRoot: "sl-question st-row__question st-scrollable",
        root: "sl-table st-matrixdynamic",
        noHeader: "",
        row: "sl-table__row",
        rowAdditional: "sl-table__row--additional",
        cell: "sl-table__cell",
        headerCell: "sl-table__cell st-table__cell--header",
        button: "sl-btn",
        detailRow: "sl-table__row sl-table__row--detail st-table__row--detail",
        rowEnter: "sl-table__row--enter",
        rowLeave: "sl-table__row--leave",
        detailButton: "sl-table__cell--detail-button",
        detailButtonExpanded: "sl-table__cell--detail-button--expanded",
        detailIcon: "sl-detail-panel__icon",
        detailIconExpanded: "sl-detail-panel__icon--expanded",
        detailPanelCell: "sl-table__cell--detail-panel",
        actionsCell: "sl-table__cell sl-table__cell--actions st-table__cell--actions",
        buttonAdd: "sl-matrixdynamic__add-btn",
        buttonRemove: "sl-matrixdynamic__remove-btn",
        iconAdd: "",
        iconRemove: ""
    },
    rating: {
        root: "",
        item: "",
        itemHover: "",
        selected: "",
        minText: "",
        itemText: "",
        maxText: "",
        itemDisabled: ""
    },
    comment: {
        mainRoot: "",
        root: "spg-input spg-comment sl-comment",
        small: ""
    },
    expression: "",
    file: {
        root: "",
        other: "",
        placeholderInput: "",
        preview: "",
        fileSign: "",
        fileSignBottom: "",
        fileDecorator: "",
        fileInput: "",
        noFileChosen: "",
        chooseFile: "",
        disabled: "",
        removeButton: "",
        removeButtonBottom: "",
        removeFile: "",
        removeFileSvg: "",
        wrapper: ""
    },
    signaturepad: {
        root: "",
        small: "",
        controls: "",
        placeholder: "",
        clearButton: ""
    },
    saveData: {
        root: "",
        saving: "",
        error: "",
        success: "",
        saveAgainButton: ""
    },
    window: {
        root: "",
        body: "",
        header: {
            root: "",
            title: "",
            button: "",
            buttonExpanded: "",
            buttonCollapsed: ""
        }
    },
    list: {
        root: "sv-list__container sl-list",
        itemBody: "sv-list__item-body sd-list__item-body sl-list__item-body"
    },
    embeddedsurvey: {
        mainRoot: "sl-embedded-survey"
    },
    actionBar: survey_core__WEBPACK_IMPORTED_MODULE_0__.defaultActionBarCss
};


/***/ }),

/***/ "./src/components/tabs/logic-types.ts":
/*!********************************************!*\
  !*** ./src/components/tabs/logic-types.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SurveyLogicType: () => (/* binding */ SurveyLogicType),
/* harmony export */   SurveyLogicTypes: () => (/* binding */ SurveyLogicTypes),
/* harmony export */   getLogicString: () => (/* binding */ getLogicString)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _expressionToDisplayText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../expressionToDisplayText */ "./src/expressionToDisplayText.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");




function getLogicString(name) {
    return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.lg." + name);
}
var SurveyLogicType = /** @class */ (function () {
    function SurveyLogicType(logicType, survey, options) {
        if (options === void 0) { options = null; }
        this.logicType = logicType;
        this.survey = survey;
        this.options = options;
        this.mergeWithBaseClass();
    }
    SurveyLogicType.expressionToDisplayText = function (survey, options, expression) {
        return new _expressionToDisplayText__WEBPACK_IMPORTED_MODULE_2__.ExpressionToDisplayText(survey, options).toDisplayText(expression);
    };
    SurveyLogicType.prototype.mergeWithBaseClass = function () {
        if (!this.logicType.baseClass)
            return;
        var baseClass = SurveyLogicTypes.baseTypes[this.logicType.baseClass];
        if (!baseClass)
            return;
        for (var key in baseClass) {
            if (!this.logicType[key]) {
                this.logicType[key] = baseClass[key];
            }
        }
    };
    Object.defineProperty(SurveyLogicType.prototype, "name", {
        get: function () {
            return this.logicType.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicType.prototype, "baseClass", {
        get: function () {
            return this.logicType.baseClass;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicType.prototype, "propertyName", {
        get: function () {
            return this.logicType.propertyName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicType.prototype, "hasVisibleElements", {
        get: function () {
            return this.logicType.isInvisible !== true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicType.prototype, "dynamicPropertyName", {
        get: function () {
            return this.logicType.dynamicPropertyName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicType.prototype, "dependedOnPropertyName", {
        get: function () {
            return this.logicType.dependedOnPropertyName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicType.prototype, "visible", {
        get: function () {
            if (!this.showInUI)
                return false;
            if (!!this.logicType.showIf)
                return this.logicType.showIf(this.survey);
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicType.prototype, "showTitlesInExpression", {
        get: function () {
            return !!this.options && this.options.showTitlesInExpressions;
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicType.prototype.createNewObj = function (srcObj) {
        var obj = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.createClass(this.baseClass);
        if (!!srcObj) {
            obj.fromJSON(srcObj.toJSON());
        }
        //TODO
        obj["survey"] = this.survey;
        if (obj.setOwner) {
            obj.setOwner(this.survey);
        }
        //Do not fire notification about changes to our creator.survey model
        if (obj instanceof survey_core__WEBPACK_IMPORTED_MODULE_0__.ItemValue || obj instanceof survey_core__WEBPACK_IMPORTED_MODULE_0__.SurveyTrigger) {
            obj["isGhost"] = true;
        }
        return obj;
    };
    SurveyLogicType.prototype.cloneElement = function (el) {
        if (this.isTrigger)
            return this.createNewObj(el);
        return el;
    };
    SurveyLogicType.prototype.areElementsEqual = function (el1, el2) {
        if (el1 === el2)
            return true;
        if (!this.isTrigger || el1.getType() !== el2.getType())
            return false;
        return survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.isTwoValueEquals(el1.toJSON(), el2.toJSON());
    };
    SurveyLogicType.prototype.saveNewElement = function (el) {
        var collection = !!this.logicType.getCollection
            ? this.logicType.getCollection(this.survey)
            : null;
        if (!collection && this.isTrigger) {
            collection = this.survey.triggers;
        }
        if (!!collection && collection.indexOf(el) < 0) {
            collection.push(el);
        }
    };
    Object.defineProperty(SurveyLogicType.prototype, "showInUI", {
        get: function () {
            return this.logicType.showInUI !== false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicType.prototype, "isUniqueItem", {
        get: function () {
            return this.logicType.isUniqueItem === true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicType.prototype, "questionNames", {
        get: function () {
            return this.logicType.questionNames;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicType.prototype, "displayName", {
        get: function () {
            return getLogicString(this.name + "Name");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicType.prototype, "description", {
        get: function () {
            return getLogicString(this.name + "Description");
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicType.prototype.getParentElement = function (element) {
        return !!this.logicType.getParentElement ? this.logicType.getParentElement(element) : null;
    };
    Object.defineProperty(SurveyLogicType.prototype, "hasSelectorChoices", {
        get: function () {
            return !!this.logicType.getSelectorChoices;
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicType.prototype.getSelectorChoices = function (survey, context) {
        if (!this.hasSelectorChoices)
            return null;
        return this.logicType.getSelectorChoices(survey, context);
    };
    SurveyLogicType.prototype.getDisplayText = function (element) {
        var str = getLogicString(this.name + "Text");
        if (!!this.logicType.getDisplayText)
            return this.logicType.getDisplayText(element, str, this);
        if (!!this.logicType.getElementName) {
            element = this.getElementByName(this.logicType.getElementName(element));
        }
        var name = this.getElementDisplayName(element);
        if (!!name) {
            var parentElement = this.getParentElement(element);
            var parentName = this.getElementDisplayName(parentElement);
            return str["format"](name, parentName);
        }
        return str;
    };
    SurveyLogicType.prototype.getElementDisplayName = function (element) {
        if (!element)
            return "";
        var res = "";
        if (this.showTitlesInExpression) {
            res = element["title"];
        }
        if (!res) {
            res = element["name"] || "";
        }
        return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.wrapTextByCurlyBraces)(res);
    };
    SurveyLogicType.prototype.getElementByName = function (name) {
        if (!this.survey)
            return null;
        var question = this.survey.getQuestionByName(name);
        if (!!question)
            return question;
        return this.survey.getPageByName(name);
    };
    SurveyLogicType.prototype.formatElName = function (name) {
        var el = this.getElementByName(name);
        return this.getElementDisplayName(el);
    };
    SurveyLogicType.prototype.formatExpression = function (expression) {
        return SurveyLogicType.expressionToDisplayText(this.survey, this.options, expression);
    };
    SurveyLogicType.prototype.supportContext = function (context) {
        if (!this.logicType.supportContext)
            return false;
        return this.logicType.supportContext(context);
    };
    Object.defineProperty(SurveyLogicType.prototype, "isTrigger", {
        get: function () {
            return !!this.baseClass && this.baseClass.indexOf("trigger") > -1;
        },
        enumerable: false,
        configurable: true
    });
    return SurveyLogicType;
}());

function hasMatrixColumns(survey) {
    var questions = survey.getAllQuestions();
    for (var i = 0; i < questions.length; i++) {
        var q = questions[i];
        if (q instanceof survey_core__WEBPACK_IMPORTED_MODULE_0__.QuestionMatrixDropdownModelBase) {
            if (q.columns.length > 0)
                return true;
        }
    }
    return false;
}
var SurveyLogicTypes = /** @class */ (function () {
    function SurveyLogicTypes() {
    }
    SurveyLogicTypes.baseTypes = {
        panel: {
            showIf: function (survey) {
                return survey.getAllPanels().length > 0;
            },
            getSelectorChoices: function (survey, context) {
                return survey.getAllPanels();
            }
        },
        question: {
            showIf: function (survey) {
                return survey.getAllQuestions().length > 0;
            },
            supportContext: function (context) {
                return Array.isArray(context["templateElements"]) ||
                    (Array.isArray(context["detailElements"]) && context["detailElements"].length > 0);
            },
            getParentElement: function (element) {
                return !!element ? element.parentQuestion : null;
            },
            getSelectorChoices: function (survey, context) {
                var res = new Array();
                var questions = survey.getAllQuestions();
                var addElement = function (el) {
                    res.push(el);
                    if (el.isPanel) {
                        el.elements.forEach(function (child) { return addElement(child); });
                    }
                };
                for (var i = 0; i < questions.length; i++) {
                    var q = questions[i];
                    if (!context) {
                        res.push(q);
                    }
                    if (q instanceof survey_core__WEBPACK_IMPORTED_MODULE_0__.QuestionPanelDynamicModel && (!context || context === q)) {
                        q.templateElements.forEach(function (el) { return addElement(el); });
                    }
                    if (q instanceof survey_core__WEBPACK_IMPORTED_MODULE_0__.QuestionMatrixDropdownModelBase && (!context || context === q)) {
                        q.detailElements.forEach(function (el) { return addElement(el); });
                    }
                }
                return res;
            }
        },
        matrixdropdowncolumn: {
            showIf: function (survey) {
                return hasMatrixColumns(survey);
            },
            supportContext: function (context) {
                return Array.isArray(context["columns"]);
            },
            getParentElement: function (element) {
                return !!element ? element.colOwner : null;
            },
            getSelectorChoices: function (survey, context) {
                var res = [];
                var questions = survey.getAllQuestions();
                for (var i = 0; i < questions.length; i++) {
                    var question = questions[i];
                    if (question instanceof survey_core__WEBPACK_IMPORTED_MODULE_0__.QuestionMatrixDropdownModelBase &&
                        (!context || context === question)) {
                        var columns = question.columns;
                        for (var j = 0; j < columns.length; j++) {
                            res.push(columns[j]);
                        }
                    }
                }
                return res;
            }
        }
    };
    SurveyLogicTypes.types = [
        {
            name: "page_visibility",
            baseClass: "page",
            propertyName: "visibleIf",
            showIf: function (survey) {
                return survey.pages.length > 1;
            },
            getSelectorChoices: function (survey, context) {
                return survey.pages;
            }
        },
        {
            name: "page_enable",
            baseClass: "page",
            propertyName: "enableIf",
            showIf: function (survey) {
                return survey.pages.length > 1;
            },
            getSelectorChoices: function (survey, context) {
                return survey.pages;
            }
        },
        {
            name: "page_require",
            baseClass: "page",
            propertyName: "requiredIf",
            showIf: function (survey) {
                return survey.pages.length > 1;
            },
            getSelectorChoices: function (survey, context) {
                return survey.pages;
            }
        },
        {
            name: "panel_visibility",
            baseClass: "panel",
            propertyName: "visibleIf",
        },
        {
            name: "panel_enable",
            baseClass: "panel",
            propertyName: "enableIf",
        },
        {
            name: "panel_require",
            baseClass: "panel",
            propertyName: "requiredIf",
        },
        {
            name: "question_visibility",
            baseClass: "question",
            propertyName: "visibleIf",
        },
        {
            name: "question_enable",
            baseClass: "question",
            propertyName: "enableIf",
        },
        {
            name: "question_require",
            baseClass: "question",
            propertyName: "requiredIf",
        },
        {
            name: "question_resetValue",
            baseClass: "question",
            propertyName: "resetValueIf",
        },
        {
            name: "question_setValue",
            baseClass: "question",
            propertyName: "setValueIf",
            getDisplayText: function (element, formatStr, lt) {
                return getDisplayTextForSetValueIf(element, formatStr, lt);
            }
        },
        {
            name: "question_setValueExpression",
            baseClass: "question",
            propertyName: "setValueExpression",
            showInUI: false,
        },
        {
            name: "column_visibility",
            baseClass: "matrixdropdowncolumn",
            propertyName: "visibleIf",
        },
        {
            name: "column_enable",
            baseClass: "matrixdropdowncolumn",
            propertyName: "enableIf",
        },
        {
            name: "column_require",
            baseClass: "matrixdropdowncolumn",
            propertyName: "requiredIf",
        },
        {
            name: "column_resetValue",
            baseClass: "matrixdropdowncolumn",
            propertyName: "resetValueIf",
        },
        {
            name: "column_setValue",
            baseClass: "matrixdropdowncolumn",
            propertyName: "setValueIf",
            getDisplayText: function (element, formatStr, lt) {
                return getDisplayTextForSetValueIf(element, formatStr, lt);
            }
        },
        {
            name: "column_setValueExpression",
            baseClass: "matrixdropdowncolumn",
            propertyName: "setValueExpression",
            showInUI: false,
        },
        {
            name: "expression_expression",
            baseClass: "expression",
            propertyName: "expression",
            showInUI: false,
        },
        {
            name: "matrixdropdowncolumn_totalExpression",
            baseClass: "matrixdropdowncolumn",
            propertyName: "totalExpression",
            showInUI: false,
        },
        {
            name: "trigger_complete",
            baseClass: "completetrigger",
            propertyName: "expression",
            isUniqueItem: true,
            isInvisible: true
        },
        {
            name: "trigger_setvalue",
            baseClass: "setvaluetrigger",
            propertyName: "expression",
            dynamicPropertyName: "setValue",
            dependedOnPropertyName: "setToName",
            questionNames: ["setToName"],
            getDisplayText: function (element, formatStr, lt) {
                if (survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.isValueEmpty(element["setValue"])) {
                    formatStr = getLogicString("trigger_setvalueEmptyText");
                }
                return formatStr["format"](lt.formatElName(element["setToName"]), element["setValue"]);
            },
        },
        {
            name: "trigger_copyvalue",
            baseClass: "copyvaluetrigger",
            propertyName: "expression",
            questionNames: ["setToName", "fromName"],
            getDisplayText: function (element, formatStr, lt) {
                return formatStr["format"](lt.formatElName(element["setToName"]), lt.formatElName(element["fromName"]));
            },
        },
        {
            name: "trigger_skip",
            baseClass: "skiptrigger",
            propertyName: "expression",
            questionNames: ["gotoName"],
            isUniqueItem: true,
            getElementName: function (element) {
                return element["gotoName"];
            },
        },
        {
            name: "trigger_runExpression",
            baseClass: "runexpressiontrigger",
            propertyName: "expression",
            questionNames: ["setToName"],
            getDisplayText: function (element, formatStr, lt) {
                var res = getLogicString("trigger_runExpressionText1");
                res = res["format"](lt.formatExpression(element["runExpression"]));
                var setToName = element["setToName"];
                if (!!setToName) {
                    var str = getLogicString("trigger_runExpressionText2");
                    res += str["format"](lt.formatElName(element["setToName"]));
                }
                return res;
            },
        },
        {
            name: "completedHtmlOnCondition",
            baseClass: "htmlconditionitem",
            propertyName: "expression",
            isUniqueItem: true,
            getCollection: function (survey) {
                return survey.completedHtmlOnCondition;
            },
        },
        {
            name: "trigger_runExpression_Expression",
            baseClass: "runexpressiontrigger",
            propertyName: "runExpression",
            showInUI: false,
        },
        {
            name: "question_expressionValidator",
            baseClass: "expressionvalidator",
            propertyName: "expression",
            showInUI: false,
        },
        {
            name: "matrix_rowsVisibleIf",
            baseClass: "matrix",
            propertyName: "rowsVisibleIf",
            showInUI: false,
        },
        {
            name: "matrix_columnsVisibleIf",
            baseClass: "matrix",
            propertyName: "columnsVisibleIf",
            showInUI: false,
        },
        {
            name: "matrixdropdown_rowsVisibleIf",
            baseClass: "matrixdropdown",
            propertyName: "rowsVisibleIf",
            showInUI: false,
        },
        {
            name: "select_choicesVisibleIf",
            baseClass: "selectbase",
            propertyName: "choicesVisibleIf",
            showInUI: false,
        },
        {
            name: "select_choicesEnableIf",
            baseClass: "selectbase",
            propertyName: "choicesEnableIf",
            showInUI: false,
        },
        {
            name: "itemvalue_visibleIf",
            baseClass: "itemvalue",
            propertyName: "visibleIf",
            showInUI: false,
        },
        {
            name: "itemvalue_enableIf",
            baseClass: "itemvalue",
            propertyName: "enableIf",
            showInUI: false,
        },
        {
            name: "calculatedValue",
            baseClass: "calculatedvalue",
            propertyName: "expression",
            showInUI: false,
        },
    ];
    return SurveyLogicTypes;
}());

function getDisplayTextForSetValueIf(element, formatStr, lt) {
    var name = lt.formatElName(element["name"]);
    var exp = element["setValueExpression"];
    if (!exp) {
        return getLogicString("trigger_setvalueEmptyText")["format"](name);
    }
    return formatStr["format"](name, exp);
}


/***/ }),

/***/ "./src/components/tabs/logic-ui.ts":
/*!*****************************************!*\
  !*** ./src/components/tabs/logic-ui.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SurveyLogicUI: () => (/* binding */ SurveyLogicUI)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _property_grid_condition_survey__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../property-grid/condition-survey */ "./src/property-grid/condition-survey.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _logic_item_editor__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./logic-item-editor */ "./src/components/tabs/logic-item-editor.ts");
/* harmony import */ var _logic_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./logic-types */ "./src/components/tabs/logic-types.ts");
/* harmony import */ var _logic__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./logic */ "./src/components/tabs/logic.ts");
/* harmony import */ var _property_grid_index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../property-grid/index */ "./src/property-grid/index.ts");
/* harmony import */ var _utils_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../../utils/actions */ "./src/utils/actions.ts");
/* harmony import */ var _logic_theme__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./logic-theme */ "./src/components/tabs/logic-theme.ts");










__webpack_require__(/*! ./logic-ui.scss */ "./src/components/tabs/logic-ui.scss");

var SurveyLogicUI = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyLogicUI, _super);
    function SurveyLogicUI(survey, options) {
        if (options === void 0) { options = null; }
        var _this = _super.call(this, survey, options) || this;
        _this.survey = survey;
        _this.options = options;
        _this.itemUIHash = {};
        if (!_this.options)
            _this.options = new _creator_settings__WEBPACK_IMPORTED_MODULE_3__.EmptySurveyCreatorOptions();
        _this.setupToolbarItems();
        _this.update();
        return _this;
    }
    SurveyLogicUI.prototype.update = function (survey, options) {
        var _this = this;
        if (survey === void 0) { survey = null; }
        if (options === void 0) { options = null; }
        _super.prototype.update.call(this, survey, options);
        var newItemsSurveyValue = this.options.createSurvey(this.getLogicItemSurveyJSON(), "logic-items", this, function (survey) {
            survey.css = _logic_theme__WEBPACK_IMPORTED_MODULE_9__.logicCss;
        });
        this.itemsSurveyValue = newItemsSurveyValue;
        this.itemsSurvey.onMatrixRowRemoving.add(function (sender, options) {
            var item = _this.visibleItems[options.rowIndex];
            options.allow = _this.canRemoveItem(item);
        });
        this.itemsSurvey.onMatrixRowRemoved.add(function (sender, options) {
            var item = _this.visibleItems[options.rowIndex];
            var isDeleteEditable = item === _this.editableItem;
            _this.removeItem(item, false);
            if (isDeleteEditable) {
                _this.mode = "view";
                _this.updateNewActionState();
            }
            _this.expressionEditorCanShowBuilder = !!_this.editableItem;
        });
        this.itemsSurvey.onGetMatrixRowActions.add(function (sender, options) {
            (0,_utils_actions__WEBPACK_IMPORTED_MODULE_8__.updateMatrixLogicExpandAction)(options.question, options.actions, options.row);
            (0,_utils_actions__WEBPACK_IMPORTED_MODULE_8__.updateMatrixLogicRemoveAction)(options.question, options.actions, options.row);
        });
        this.updateItemsSurveyData();
        this.onReadOnlyChanged();
    };
    SurveyLogicUI.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        for (var key in this.itemUIHash) {
            var itemUI = this.itemUIHash[key];
            itemUI.expressionEditor.dispose();
            itemUI.itemEditor.dispose();
        }
        this.itemUIHash = {};
    };
    SurveyLogicUI.prototype.addNewUI = function () {
        if (this.items.length == 0 || !this.items[this.items.length - 1].isNew) {
            this.matrixItems["lockResetRenderedTable"] = true;
            this.addNew();
            this.matrixItems["lockResetRenderedTable"] = false;
        }
        var rows = this.matrixItems.visibleRows;
        rows[rows.length - 1].showDetailPanel();
    };
    SurveyLogicUI.prototype.toggleExpressionEditorIsFastEntry = function () {
        this.expressionEditorIsFastEntry = !this.expressionEditorIsFastEntry;
        if (!!this.expressionEditor) {
            this.expressionEditor.setIsFastEntry(this.expressionEditorIsFastEntry);
        }
    };
    SurveyLogicUI.prototype.updateEditableItemIsModifiedState = function () {
        if (!!this.editableItem) {
            this.editableItem.isModified = !!this.itemEditor && !!this.expressionEditor && (this.itemEditor.isModified || this.expressionEditor.isModified(this.editableItem.expression));
        }
    };
    SurveyLogicUI.prototype.getUnsavedItems = function () {
        var res = [];
        for (var i = 0; i < this.visibleItems.length; i++) {
            var item = this.visibleItems[i];
            var itemUI = this.findLogicItemUI(item);
            if (!itemUI)
                continue;
            if (item.isNew) {
                if (!itemUI.expressionEditor.isEmpty() || !itemUI.itemEditor.isEmpty()) {
                    res.push(item);
                }
            }
            else {
                if (item.isModified) {
                    res.push(item);
                }
            }
        }
        return res;
    };
    SurveyLogicUI.prototype.getErroredItem = function (items) {
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            if (this.isErroredItem(item))
                return item;
        }
        return null;
    };
    SurveyLogicUI.prototype.isErroredItem = function (item) {
        var itemUI = this.findLogicItemUI(item);
        if (!itemUI)
            return false;
        return itemUI.expressionEditor.hasErrors() || itemUI.itemEditor.hasErrors();
    };
    SurveyLogicUI.prototype.showErroredItem = function (item) {
        var index = this.visibleItems.indexOf(item);
        var rows = this.matrixItems.visibleRows;
        var row = index > -1 && index < rows.length ? rows[index] : null;
        if (!!row) {
            rows.forEach(function (r) { return r.hideDetailPanel(); });
            this.mode = "view";
            row.showDetailPanel();
            this.hasErrorInUI();
        }
    };
    SurveyLogicUI.prototype.saveItem = function (item) {
        if (this.isErroredItem(item))
            return;
        !!this.options && this.options.startUndoRedoTransaction();
        this.doItemApply(item);
        !!this.options && this.options.stopUndoRedoTransaction();
    };
    SurveyLogicUI.prototype.tryLeaveUI = function (resultFunc) {
        var _this = this;
        this.updateEditableItemIsModifiedState();
        var unsavedItems = this.getUnsavedItems();
        if (unsavedItems.length === 0) {
            !!resultFunc && resultFunc(true);
            return true;
        }
        var erroredItem = this.getErroredItem(unsavedItems);
        var onLeavingFunc = function () {
            unsavedItems.forEach(function (item) { return _this.saveItem(item); });
            !!resultFunc && resultFunc(true);
        };
        if (!erroredItem) {
            onLeavingFunc();
            return true;
        }
        var onStayingFunc = function () {
            _this.showErroredItem(erroredItem);
            !!resultFunc && resultFunc(false);
        };
        if (this.confirmLeavingOnError(onLeavingFunc, onStayingFunc)) {
            return undefined;
        }
        onStayingFunc();
        return false;
    };
    SurveyLogicUI.prototype.confirmLeavingOnError = function (onLeaving, onStaying) {
        if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.showDialog)
            return false;
        var locStr = new survey_core__WEBPACK_IMPORTED_MODULE_1__.LocalizableString(undefined);
        locStr.text = this.getLocString("ed.lg.uncompletedRule_text");
        var popupModel = survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.showDialog({
            componentName: "sv-string-viewer",
            data: { locStr: locStr, locString: locStr, model: locStr },
            onApply: function () {
                onLeaving();
                return true;
            },
            onCancel: function () {
                onStaying();
                return true;
            },
            cssClass: "svc-creator-popup",
            title: this.getLocString("ed.lg.uncompletedRule_title"),
            displayMode: "popup"
        }, this.options.rootElement);
        var toolbar = popupModel.footerToolbar;
        var applyBtn = toolbar.getActionById("apply");
        var cancelBtn = toolbar.getActionById("cancel");
        cancelBtn.title = this.getLocString("ed.lg.uncompletedRule_cancel");
        applyBtn.title = this.getLocString("ed.lg.uncompletedRule_apply");
        applyBtn.innerCss += " svc-logic-tab__leave-apply-button";
        popupModel.width = "800px";
        return true;
    };
    SurveyLogicUI.prototype.onPropertyValueChanged = function (name, oldValue, newValue) {
        _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
        if (name === "items") {
            this.updateItemsSurveyData();
        }
    };
    SurveyLogicUI.prototype.onReadOnlyChanged = function () {
        var _this = this;
        if (!this.itemsSurvey)
            return;
        this.itemsSurvey.mode = this.readOnly ? "display" : "edit";
        Object.keys(this.itemUIHash || {}).forEach(function (id) {
            _this.updateEditModeLogicItem(_this.itemUIHash[id]);
        });
    };
    Object.defineProperty(SurveyLogicUI.prototype, "expressionEditor", {
        get: function () {
            return this.expressionEditorValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicUI.prototype, "itemEditor", {
        get: function () {
            return this.itemEditorValue;
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicUI.prototype.getExpressionEditor = function (item) {
        return this.getLogicItemUI(item).expressionEditor;
    };
    SurveyLogicUI.prototype.getLogicItemEditor = function (item) {
        return this.getLogicItemUI(item).itemEditor;
    };
    SurveyLogicUI.prototype.updateEditModeLogicItem = function (item) {
        if (!item)
            return;
        item.expressionEditor.editSurvey.mode = this.readOnly ? "display" : "edit";
        item.itemEditor.editSurvey.mode = this.readOnly ? "display" : "edit";
    };
    SurveyLogicUI.prototype.getLogicItemUI = function (item) {
        var res = this.findLogicItemUI(item);
        if (!res) {
            var context = item.getContext();
            res = { expressionEditor: this.createExpressionPropertyEditor(), itemEditor: new _logic_item_editor__WEBPACK_IMPORTED_MODULE_4__.LogicItemEditor(item, this.options) };
            this.updateEditModeLogicItem(res);
            res.expressionEditor.context = context;
            res.itemEditor.context = context;
            res.expressionEditor.text = item.expression;
            res.expressionEditor.onContextChanged = function (context) {
                res.itemEditor.context = context;
            };
            this.itemUIHash[item.id] = res;
        }
        return res;
    };
    SurveyLogicUI.prototype.findLogicItemUI = function (item) {
        return this.itemUIHash[item.id];
    };
    Object.defineProperty(SurveyLogicUI.prototype, "expressionSurvey", {
        get: function () {
            return this.expressionEditor.editSurvey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicUI.prototype, "itemEditorSurvey", {
        get: function () {
            return this.itemEditor.editSurvey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicUI.prototype, "itemsSurvey", {
        get: function () {
            return this.itemsSurveyValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicUI.prototype, "hasItems", {
        get: function () {
            return this.items.length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicUI.prototype, "matrixItems", {
        get: function () {
            return this.itemsSurvey.getQuestionByName("items");
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogicUI.prototype.onStartEditing = function () {
        _super.prototype.onStartEditing.call(this);
        this.expressionEditorValue = this.getExpressionEditor(this.editableItem);
        this.itemEditorValue = this.getLogicItemEditor(this.editableItem);
        this.expressionEditorIsFastEntry = false;
        this.expressionEditor.setIsFastEntry(this.expressionEditorIsFastEntry);
        this.expressionEditorCanShowBuilder = _property_grid_condition_survey__WEBPACK_IMPORTED_MODULE_2__.ConditionEditor.canBuildExpression(this.expressionEditor.text);
    };
    SurveyLogicUI.prototype.onEndEditing = function () {
        this.updateEditableItemIsModifiedState();
        _super.prototype.onEndEditing.call(this);
        this.expressionEditorValue = null;
        this.itemEditorValue = null;
    };
    SurveyLogicUI.prototype.onEditableItemApply = function () {
        this.doItemApply(this.editableItem);
        if (!this.editableItem.isSuitable(this.questionFilter, this.actionTypeFilter)) {
            this.questionFilter = "";
            this.actionTypeFilter = "";
        }
        else {
            this.updateItemsSurveyData();
        }
    };
    SurveyLogicUI.prototype.doItemApply = function (item) {
        var itemUI = this.findLogicItemUI(item);
        if (!itemUI)
            return;
        itemUI.expressionEditor.apply();
        itemUI.itemEditor.apply();
        item.apply(itemUI.expressionEditor.text);
        if (item.actions.length != itemUI.itemEditor.panels.length) {
            itemUI.itemEditor.setEditableItem(item);
        }
        itemUI.itemEditor.resetModified();
        item.isNew = false;
    };
    SurveyLogicUI.prototype.hasErrorInUI = function () {
        var creator = this.survey.creator;
        if (this.expressionEditor.hasErrorInUI()) {
            this.errorText = this.expressionEditor.errorText;
            return true;
        }
        if (this.itemEditor.hasErrors()) {
            this.errorText = (0,_logic_types__WEBPACK_IMPORTED_MODULE_5__.getLogicString)("actionInvalid");
            !!creator &&
                creator.notify(this.errorText, "error");
            return true;
        }
        return false;
    };
    SurveyLogicUI.prototype.getExpressionText = function () {
        return this.expressionEditor.text;
    };
    SurveyLogicUI.prototype.getEditingActions = function () {
        return this.itemEditor.getEditingActions();
    };
    SurveyLogicUI.prototype.getLogicItemSurveyJSON = function () {
        var creator = this.survey.creator;
        var json = (creator && creator.useTableViewInLogicTab) ? this.getTwoColumnsLayout() : this.getOneColumnLayout();
        (0,_property_grid_index__WEBPACK_IMPORTED_MODULE_7__.setSurveyJSONForPropertyGrid)(json);
        return json;
    };
    SurveyLogicUI.prototype.getTwoColumnsLayout = function () {
        return {
            elements: [
                {
                    type: "matrixdynamic",
                    name: "items",
                    titleLocation: "hidden",
                    detailPanelMode: "underRowSingle",
                    allowAddRows: false,
                    allowAdaptiveActions: false,
                    rowCount: 0,
                    columns: [
                        {
                            cellType: "linkvalue",
                            name: "conditions",
                            title: this.getLocString("ed.lg.conditions")
                        },
                        {
                            cellType: "linkvalue",
                            name: "actions",
                            title: this.getLocString("ed.lg.actions")
                        }
                    ]
                }
            ]
        };
    };
    SurveyLogicUI.prototype.getOneColumnLayout = function () {
        return {
            elements: [
                {
                    type: "matrixdynamic",
                    name: "items",
                    titleLocation: "hidden",
                    showColumnHeader: false,
                    detailPanelMode: "underRowSingle",
                    allowAddRows: false,
                    allowAdaptiveActions: false,
                    rowCount: 0,
                    showHeader: false,
                    columns: [
                        {
                            cellType: "linkvalue",
                            name: "rules",
                            showTooltip: true,
                            width: "100%"
                        }
                    ]
                }
            ]
        };
    };
    SurveyLogicUI.prototype.createExpressionPropertyEditor = function () {
        var _this = this;
        var res = new _property_grid_condition_survey__WEBPACK_IMPORTED_MODULE_2__.ConditionEditor(this.survey, null, this.options);
        res.isModal = false;
        res.editSurvey.onValueChanged.add(function (sender, options) {
            if (options.name === "textEditor") {
                _this.expressionEditorCanShowBuilder = _property_grid_condition_survey__WEBPACK_IMPORTED_MODULE_2__.ConditionEditor.canBuildExpression(options.value);
            }
        });
        return res;
    };
    SurveyLogicUI.prototype.getVisibleItems = function () {
        var _this = this;
        return this.items.filter(function (item) { return item.isNew || item.isSuitable(_this.questionFilter, _this.actionTypeFilter); });
    };
    SurveyLogicUI.prototype.getDataFromItem = function (item) {
        var creator = this.survey.creator;
        if (creator && creator.useTableViewInLogicTab) {
            return {
                conditions: item.expressionText,
                actions: item.actionsText
            };
        }
        else {
            return { rules: this.getLogicItemDisplayText(item) };
        }
    };
    SurveyLogicUI.prototype.getLogicItemDisplayText = function (item) {
        var text = item.getDisplayText();
        if (!this.options)
            return text;
        return this.options.onLogicGetTitleCallback(item.expression, item.expressionText, text, item);
    };
    SurveyLogicUI.prototype.updateItemsSurveyData = function () {
        var _this = this;
        if (!this.itemsSurvey)
            return;
        var data = [];
        this.visibleItems = this.getVisibleItems();
        this.visibleItems.forEach(function (item) {
            data.push(_this.getDataFromItem(item));
        });
        this.matrixItems.onHasDetailPanelCallback = function (row) { return true; };
        this.matrixItems.onCreateDetailPanelCallback = function (row, panel) {
            row.onDetailPanelShowingChanged = function () {
                _this.expressionEditorCanShowBuilder = row.isDetailPanelShowing;
                if (row.isDetailPanelShowing) {
                    if (_this.mode === "view") {
                        var logicItem = _this.visibleItems[row.rowIndex - 1];
                        _this.editItem(logicItem);
                    }
                    var condQuestion = panel.getQuestionByName("conditions");
                    var actionsQuestion = panel.getQuestionByName("actions");
                    condQuestion.embeddedSurvey = _this.expressionEditor.editSurvey;
                    actionsQuestion.embeddedSurvey = _this.itemEditorValue.editSurvey;
                    _this.updateRowIsAdditionalClasses(row.rowIndex - 1, false);
                }
                else {
                    _this.mode = "view";
                    _this.updateRenderedRows();
                }
                _this.updateNewActionState();
            };
            panel.addNewQuestion("embeddedsurvey", "conditions");
            panel.addNewQuestion("embeddedsurvey", "actions");
            panel.footerActions.push({
                id: "saveDetailPanel",
                innerCss: "sl-panel__done-button",
                title: _this.getLocString("pe.doneEditing"),
                action: function () {
                    if (_this.saveEditableItem()) {
                        row.hideDetailPanel(true);
                    }
                }
            });
        };
        this.matrixItems.onCellCreatedCallback = function (options) {
            options.cell.question.linkClickCallback = function () {
                if (options.row.isDetailPanelShowing) {
                    options.row.hideDetailPanel();
                }
                else {
                    options.row.showDetailPanel();
                }
            };
            options.cell.question.showClear = false;
            options.cell.question.allowClear = false;
        };
        this.matrixItems.value = data;
        this.updateRenderedRows();
    };
    SurveyLogicUI.prototype.updateRenderedRows = function () {
        var _this = this;
        this.visibleItems.forEach(function (_, index) {
            _this.updateRowIsAdditionalClasses(index, _this.visibleItems[index].isModified || _this.visibleItems[index].isNew);
        });
    };
    SurveyLogicUI.prototype.updateRowIsAdditionalClasses = function (index, isAdditionalClasses) {
        if (!!this.matrixItems.renderedTable) {
            var visibleRows = this.matrixItems.renderedTable.rows.filter(function (row) { return row.visible; });
            visibleRows[index].isAdditionalClasses = isAdditionalClasses;
        }
    };
    SurveyLogicUI.prototype.updateNewActionState = function () {
        this.addNewButton.enabled = this.mode !== "new";
    };
    SurveyLogicUI.prototype.setupToolbarItems = function () {
        var _this = this;
        this.addNewButton = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "svd-logic-addNew",
            title: this.addNewText,
            tooltip: this.addNewText,
            component: "sv-action-bar-item",
            enabled: true,
            action: function () {
                _this.addNewUI();
            }
        });
    };
    Object.defineProperty(SurveyLogicUI.prototype, "addNewText", {
        get: function () {
            return (0,_logic_types__WEBPACK_IMPORTED_MODULE_5__.getLogicString)("addNewItem");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicUI.prototype, "emptyTabPlaceholder", {
        get: function () {
            return (0,_logic_types__WEBPACK_IMPORTED_MODULE_5__.getLogicString)("empty_tab");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicUI.prototype, "placeholderTitleText", {
        get: function () {
            if (this.options.isMobileView)
                return (0,_logic_types__WEBPACK_IMPORTED_MODULE_5__.getLogicString)("logicPlaceholderTitleMobile");
            return (0,_logic_types__WEBPACK_IMPORTED_MODULE_5__.getLogicString)("logicPlaceholderTitle");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogicUI.prototype, "placeholderDescriptionText", {
        get: function () {
            if (this.options.isMobileView)
                return (0,_logic_types__WEBPACK_IMPORTED_MODULE_5__.getLogicString)("logicPlaceholderDescriptionMobile");
            return (0,_logic_types__WEBPACK_IMPORTED_MODULE_5__.getLogicString)("logicPlaceholderDescription");
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyLogicUI.prototype, "itemsSurveyValue", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyLogicUI.prototype, "expressionEditorIsFastEntry", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyLogicUI.prototype, "expressionEditorCanShowBuilder", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (value, target) {
                target.updateItemsSurveyData();
            }
        })
    ], SurveyLogicUI.prototype, "questionFilter", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (value, target) {
                target.updateItemsSurveyData();
            }
        })
    ], SurveyLogicUI.prototype, "actionTypeFilter", void 0);
    return SurveyLogicUI;
}(_logic__WEBPACK_IMPORTED_MODULE_6__.SurveyLogic));



/***/ }),

/***/ "./src/components/tabs/logic.ts":
/*!**************************************!*\
  !*** ./src/components/tabs/logic.ts ***!
  \**************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   LogicEvent: () => (/* binding */ LogicEvent),
/* harmony export */   SurveyLogic: () => (/* binding */ SurveyLogic),
/* harmony export */   initLogicOperator: () => (/* binding */ initLogicOperator)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _logic_items__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./logic-items */ "./src/components/tabs/logic-items.ts");
/* harmony import */ var _logic_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./logic-types */ "./src/components/tabs/logic-types.ts");






__webpack_require__(/*! ./logic.scss */ "./src/components/tabs/logic.scss");
function initLogicOperator(question) {
    question.popupModel.isFocusedContent = true;
    question.popupModel.setWidthByTarget = false;
    question.popupModel.positionMode = "flex";
    question.popupModel.showPointer = true;
    question.dropdownListModel["listModel"].searchEnabled = question.searchEnabled;
}
var LogicEvent = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(LogicEvent, _super);
    function LogicEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return LogicEvent;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase));

var SurveyLogic = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyLogic, _super);
    function SurveyLogic(survey, options) {
        if (options === void 0) { options = null; }
        var _this = _super.call(this) || this;
        _this.survey = survey;
        _this.options = options;
        _this.invisibleItems = [];
        /**
         * The event is called when logic item is saved.
         * options.item is the saved logic item.
         */
        _this.onLogicItemSaved = new LogicEvent();
        /**
         * The event is called before logic item is saved. You can set options.error to non empty string to show error instead of saving the item.
         * You can use options.item.actions to access actions and optionally set errorText to a particular action.
         * options.item is the editing logic item. options.item.actions contains the old actions.
         * options.actions is the array of  logic actions that user edit and create.
         * usedNamesInExpression - the string list of all variables (questions, calculatedValues, and so on) that are used in expression
         * error - the error string. It is empty by default. You have to set it to non-empty string to show the error on saving.
         */
        _this.onLogicItemValidation = new LogicEvent();
        /**
         * The event is called before logic item is being removed.
         * options.allowRemove is the option you can set to false and prevent removing.
         * options.item is the logic item to remove.
         */
        _this.onLogicItemRemoving = new LogicEvent();
        /**
         * The event is called when logic item is removed.
         * options.item is the removed logic item.
         */
        _this.onLogicItemRemoved = new LogicEvent();
        if (!_this.options)
            _this.options = new _creator_settings__WEBPACK_IMPORTED_MODULE_3__.EmptySurveyCreatorOptions();
        _this.readOnly = _this.optionsReadOnly;
        _this.update();
        return _this;
    }
    Object.defineProperty(SurveyLogic, "visibleActions", {
        get: function () {
            return _creator_settings__WEBPACK_IMPORTED_MODULE_3__.settings.logic.visibleActions;
        },
        set: function (val) {
            _creator_settings__WEBPACK_IMPORTED_MODULE_3__.settings.logic.visibleActions = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogic, "types", {
        get: function () {
            return _logic_types__WEBPACK_IMPORTED_MODULE_5__.SurveyLogicTypes.types;
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogic.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.onEndEditing();
        this.survey = undefined;
    };
    Object.defineProperty(SurveyLogic.prototype, "editableItem", {
        get: function () {
            return this.editableItemValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyLogic.prototype, "mode", {
        /**
         * There are 3 modes: view, new, edit
         */
        get: function () { return this.modeValue; },
        set: function (val) {
            if (this.modeValue === val)
                return;
            var oldValue = this.mode;
            this.modeValue = val;
            this.errorText = "";
            if (val == "view" && (oldValue == "edit" || oldValue == "new")) {
                this.onEndEditing();
            }
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogic.prototype.getLocString = function (name) {
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString(name);
    };
    SurveyLogic.prototype.getTypeByName = function (name) {
        for (var i = 0; i < this.logicTypes.length; i++) {
            if (this.logicTypes[i].name == name)
                return this.logicTypes[i];
        }
        return null;
    };
    SurveyLogic.prototype.update = function (survey, options) {
        if (survey === void 0) { survey = null; }
        if (options === void 0) { options = null; }
        if (!!survey) {
            this.survey = survey;
        }
        if (!!options) {
            this.options = options;
        }
        this.logicTypes = this.createLogicTypes();
        this.updateVisibleItems();
        this.invisibleItems = this.buildItems(false);
        this.readOnly = this.optionsReadOnly;
        this.mode = "view";
    };
    SurveyLogic.prototype.updateVisibleItems = function () {
        this.items = this.buildItems(true);
        this.editableItemValue = null;
    };
    Object.defineProperty(SurveyLogic.prototype, "optionsReadOnly", {
        get: function () {
            return !!this.options && this.options.readOnly;
        },
        enumerable: false,
        configurable: true
    });
    SurveyLogic.prototype.saveEditableItem = function () {
        if (!this.editableItem || this.hasError())
            return false;
        !!this.options && this.options.startUndoRedoTransaction();
        this.onEditableItemApply();
        var hasInList = this.items.indexOf(this.editableItem) < 0;
        if (hasInList) {
            this.items.push(this.editableItem);
        }
        var isNew = !hasInList || this.editableItem.isNew;
        this.editableItem.isNew = false;
        this.onItemChanged(this.editableItem, isNew ? "new" : "modify");
        !!this.options && this.options.stopUndoRedoTransaction();
        this.onLogicItemSaved.fire(this, { item: this.editableItem });
        return true;
    };
    SurveyLogic.prototype.saveEditableItemAndBack = function () {
        var res = this.saveEditableItem();
        if (res) {
            this.mode = "view";
        }
        return res;
    };
    SurveyLogic.prototype.onEditableItemApply = function () { };
    SurveyLogic.prototype.onItemChanged = function (item, changeType) {
        if (!!this.onChangedCallback) {
            this.onChangedCallback(item, changeType);
        }
    };
    SurveyLogic.prototype.renameQuestion = function (oldName, newName) {
        this.items.forEach(function (item) { return item.renameQuestion(oldName, newName); });
        this.invisibleItems.forEach(function (item) { return item.renameQuestion(oldName, newName); });
    };
    SurveyLogic.prototype.renameItemValue = function (item, oldValue) {
        var question = this.getItemValueQuestion(item, oldValue);
        if (!question)
            return;
        this.items.forEach(function (lItem) { return lItem.renameItemValue(question, item, oldValue); });
        this.invisibleItems.forEach(function (lItem) { return lItem.renameItemValue(question, item, oldValue); });
    };
    SurveyLogic.prototype.renameRowValue = function (item, oldValue) {
        var question = this.getItemValueQuestion(item, oldValue);
        if (!question)
            return;
        this.items.forEach(function (lItem) { return lItem.renameRowValue(question, item, oldValue); });
        this.invisibleItems.forEach(function (lItem) { return lItem.renameRowValue(question, item, oldValue); });
    };
    SurveyLogic.prototype.renameColumn = function (column, oldName) {
        var question = column.colOwner;
        if (!question || !question.isQuestion)
            return;
        this.items.forEach(function (lItem) { return lItem.renameColumn(question, column, oldName); });
        this.invisibleItems.forEach(function (lItem) { return lItem.renameColumn(question, column, oldName); });
    };
    SurveyLogic.prototype.getItemValueQuestion = function (item, oldValue) {
        if (!item.locOwner || survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(oldValue) || survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(item.value))
            return null;
        var owner = item.locOwner;
        return owner.isQuestion ? owner : null;
    };
    SurveyLogic.prototype.removeQuestion = function (name) {
        this.removeQuestionCore(name, this.items);
        this.removeQuestionCore(name, this.invisibleItems);
    };
    SurveyLogic.prototype.hasError = function () {
        if (!this.editableItem)
            return false;
        if (this.hasErrorInUI())
            return true;
        var exp = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ExpressionRunner(this.getExpressionText());
        var options = {
            item: this.editableItem,
            error: "",
            usedNamesInExpression: exp.getVariables(),
            actions: this.getEditingActions(),
        };
        this.onLogicItemValidation.fire(this, options);
        this.errorText = options.error;
        var creator = this.survey.creator;
        if (!!this.errorText && !!creator)
            creator.notify(this.errorText, "error");
        return !!this.errorText;
    };
    SurveyLogic.prototype.getUsedQuestions = function () {
        var _this = this;
        var names = {};
        this.items.forEach(function (item) {
            item.getQuestionNames().forEach(function (name) {
                var question = _this.survey.getQuestionByName(name);
                if (!!question && !names[name]) {
                    names[name] = question;
                }
            });
        });
        var res = [];
        Object.keys(names).forEach(function (item) {
            if (!!names[item]) {
                res.push(names[item]);
            }
        });
        return res;
    };
    SurveyLogic.prototype.getUsedActionTypes = function () {
        var _this = this;
        var types = {};
        this.items.forEach(function (item) {
            item.getActionTypes().forEach(function (name) {
                if (!types[name]) {
                    types[name] = _this.logicTypes.filter(function (logicType) { return logicType.name == name; })[0];
                }
            });
        });
        var res = [];
        Object.keys(types).forEach(function (item) {
            if (!!types[item]) {
                res.push(types[item]);
            }
        });
        return res;
    };
    SurveyLogic.prototype.hasErrorInUI = function () {
        return false;
    };
    SurveyLogic.prototype.getExpressionText = function () {
        return "";
    };
    SurveyLogic.prototype.getEditingActions = function () {
        return [];
    };
    SurveyLogic.prototype.onReadOnlyChanged = function () { };
    SurveyLogic.prototype.removeQuestionCore = function (name, items) {
        for (var i = 0; i < items.length; i++) {
            items[i].removeQuestion(name);
        }
    };
    SurveyLogic.prototype.addNew = function () {
        !!this.options && this.options.startUndoRedoTransaction();
        var logicItem = new _logic_items__WEBPACK_IMPORTED_MODULE_4__.SurveyLogicItem(this);
        logicItem.isNew = true;
        this.items.push(logicItem);
        this.editItemCore(logicItem);
        !!this.options && this.options.stopUndoRedoTransaction();
    };
    SurveyLogic.prototype.editItem = function (item) {
        !!this.options && this.options.startUndoRedoTransaction();
        this.editItemCore(item);
        !!this.options && this.options.stopUndoRedoTransaction();
    };
    SurveyLogic.prototype.editItemCore = function (item) {
        this.editableItemValue = item;
        this.onStartEditing();
        this.mode = item.isNew ? "new" : "edit";
    };
    SurveyLogic.prototype.onStartEditing = function () { };
    SurveyLogic.prototype.onEndEditing = function () {
        this.editableItemValue = null;
    };
    SurveyLogic.prototype.canRemoveItem = function (item) {
        var eventOptions = { item: item, allowRemove: true };
        this.onLogicItemRemoving.fire(this, eventOptions);
        return eventOptions.allowRemove;
    };
    SurveyLogic.prototype.removeItem = function (item, checkCanRemove) {
        if (checkCanRemove === void 0) { checkCanRemove = true; }
        if (checkCanRemove && !this.canRemoveItem(item))
            return;
        !!this.options && this.options.startUndoRedoTransaction();
        item.apply("");
        var index = this.items.indexOf(item);
        if (index > -1) {
            this.items.splice(index, 1);
        }
        this.onItemChanged(item, "delete");
        !!this.options && this.options.stopUndoRedoTransaction();
        this.onLogicItemRemoved.fire(this, { item: item });
    };
    SurveyLogic.prototype.addAction = function (lt, element) {
        if (element === void 0) { element = null; }
        var action = this.createNewAction(lt, element);
        this.editableItem.addNewAction(action);
        return action;
    };
    SurveyLogic.prototype.addNewAction = function () {
        return this.addAction(null, null);
    };
    SurveyLogic.prototype.createNewAction = function (lt, element) {
        var action = new _logic_items__WEBPACK_IMPORTED_MODULE_4__.SurveyLogicAction(lt, element, this.survey);
        return action;
    };
    SurveyLogic.prototype.getVisibleLogicTypes = function () {
        var res = [];
        var logicTypes = this.logicTypes;
        for (var i = 0; i < logicTypes.length; i++) {
            if (logicTypes[i].visible) {
                res.push(logicTypes[i]);
            }
        }
        return res;
    };
    SurveyLogic.prototype.removeAction = function (action) {
        if (!this.editableItem)
            return;
        this.editableItem.removeAction(action);
        if (this.editableItem.actions.length == 0) {
            this.addNewAction();
        }
    };
    SurveyLogic.prototype.getExpressionAsDisplayText = function (expression) {
        return _logic_types__WEBPACK_IMPORTED_MODULE_5__.SurveyLogicType.expressionToDisplayText(this.survey, this.options, expression);
    };
    SurveyLogic.prototype.buildItems = function (showInUI) {
        var res = [];
        var hash = {};
        var elements = this.getAllElements();
        for (var i = 0; i < elements.length; i++) {
            this.buildItemsByElement(elements[i], res, hash, showInUI);
        }
        return res;
    };
    SurveyLogic.prototype.getAllElements = function () {
        var res = [];
        this.AddElements(this.survey.pages, res);
        this.AddElements(_logic_types__WEBPACK_IMPORTED_MODULE_5__.SurveyLogicTypes.baseTypes.question.getSelectorChoices(this.survey, null), res);
        this.AddElements(this.survey.getAllPanels(), res);
        this.AddElements(this.survey.triggers, res);
        this.AddElements(this.survey.completedHtmlOnCondition, res);
        this.AddElements(this.survey.calculatedValues, res);
        this.AddElements(_logic_types__WEBPACK_IMPORTED_MODULE_5__.SurveyLogicTypes.baseTypes.matrixdropdowncolumn.getSelectorChoices(this.survey, null), res);
        this.AddElements(this.getValidators(), res);
        this.AddElements(this.getItemValues(), res);
        return res;
    };
    SurveyLogic.prototype.getValidators = function () {
        var res = [];
        var questions = this.survey.getAllQuestions();
        for (var i = 0; i < questions.length; i++) {
            this.AddElements(questions[i].validators, res);
        }
        return res;
    };
    SurveyLogic.prototype.getItemValues = function () {
        var res = [];
        var questions = this.survey.getAllQuestions();
        for (var i = 0; i < questions.length; i++) {
            var q = questions[i];
            var choices = q["choices"];
            if (!choices)
                continue;
            var prop = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(q.getType(), "choices");
            if (!prop || prop.type !== "itemvalue[]")
                continue;
            this.AddElements(choices, res);
        }
        return res;
    };
    SurveyLogic.prototype.AddElements = function (src, dest) {
        for (var i = 0; i < src.length; i++) {
            dest.push(src[i]);
        }
    };
    SurveyLogic.prototype.buildItemsByElement = function (element, dest, hash, showInUI) {
        var types = this.getElementAllTypes(element);
        for (var i = 0; i < this.logicTypes.length; i++) {
            var lt = this.logicTypes[i];
            if (lt.showInUI !== showInUI)
                continue;
            var expression = element[lt.propertyName];
            if (types.indexOf(lt.baseClass) > -1 &&
                !survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(expression)) {
                var key = this.getLogicItemHashKey(expression, element);
                var item = hash[key];
                if (!item) {
                    item = new _logic_items__WEBPACK_IMPORTED_MODULE_4__.SurveyLogicItem(this, expression);
                    hash[key] = item;
                    dest.push(item);
                }
                var action = this.createNewAction(lt, element);
                item.addNewAction(action);
            }
        }
    };
    SurveyLogic.prototype.getLogicItemHashKey = function (expression, element) {
        var parentQuestion = this.getParentQuestion(element);
        var parentName = !!parentQuestion ? "@" + parentQuestion.name : "";
        return parentName + expression.replace(" ", "").toLowerCase();
    };
    SurveyLogic.prototype.getParentQuestion = function (element) {
        var parentQuestion = element.parentQuestion;
        if (!!parentQuestion)
            return parentQuestion;
        if (element.isDescendantOf("matrixdropdowncolumn"))
            return element.colOwner;
        return null;
    };
    SurveyLogic.prototype.getElementAllTypes = function (element) {
        var types = [];
        var type = element.getType();
        types.push(type);
        while (!!type && type != "base") {
            var cl = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findClass(type);
            if (!cl)
                break;
            type = cl.parentName;
            if (!!type) {
                types.push(type);
            }
        }
        return types;
    };
    SurveyLogic.prototype.createLogicTypes = function () {
        var _this = this;
        var res = [];
        SurveyLogic.types.forEach(function (logicType) {
            if (_this.isLogicTypeVisible(logicType)) {
                res.push(new _logic_types__WEBPACK_IMPORTED_MODULE_5__.SurveyLogicType(logicType, _this.survey, _this.options));
            }
        });
        return res;
    };
    SurveyLogic.prototype.isLogicTypeVisible = function (logicType) {
        var visActions = SurveyLogic.visibleActions;
        if (visActions.length > 0 && visActions.indexOf(logicType.name) < 0)
            return false;
        var prefix = "trigger_";
        if (logicType.name.indexOf(prefix) === 0) {
            return _creator_settings__WEBPACK_IMPORTED_MODULE_3__.settings.logic.invisibleTriggers.indexOf(logicType.name.substring(prefix.length)) < 0;
        }
        return true;
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.propertyArray)()
    ], SurveyLogic.prototype, "items", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.propertyArray)()
    ], SurveyLogic.prototype, "logicTypes", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyLogic.prototype, "errorText", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (value, target) {
                target.onReadOnlyChanged();
            }
        })
    ], SurveyLogic.prototype, "readOnly", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyLogic.prototype, "placeholderHtml", void 0);
    return SurveyLogic;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/components/tabs/preview.ts":
/*!****************************************!*\
  !*** ./src/components/tabs/preview.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PreviewViewModel: () => (/* binding */ PreviewViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var _simulator__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../simulator */ "./src/components/simulator.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _theme_model__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./theme-model */ "./src/components/tabs/theme-model.ts");






var PreviewViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PreviewViewModel, _super);
    function PreviewViewModel(surveyProvider, startThemeClasses) {
        if (startThemeClasses === void 0) { startThemeClasses = survey_core__WEBPACK_IMPORTED_MODULE_2__.defaultV2Css; }
        var _this = _super.call(this) || this;
        _this.surveyProvider = surveyProvider;
        _this.startThemeClasses = startThemeClasses;
        _this.enableInvisiblePages = true;
        _this.pages = new survey_core__WEBPACK_IMPORTED_MODULE_2__.ActionContainer();
        _this.simulator = new _simulator__WEBPACK_IMPORTED_MODULE_1__.SurveySimulatorModel(surveyProvider);
        _this.pages.cssClasses = {
            root: "sv-action-bar svc-pages-toolbar",
            item: "svc-preview-pager__item",
            itemActive: "svc-preview-pager__item--active",
            itemPressed: "svc-preview-pager__item--pressed",
            itemAsIcon: "svc-preview-pager__item--icon",
            itemIcon: "svc-preview-pager-item__icon",
            itemTitle: "svc-preview-pager-item__title",
        };
        return _this;
    }
    Object.defineProperty(PreviewViewModel.prototype, "activeLanguage", {
        get: function () {
            return this.getPropertyValue("activeLanguage", this.survey.locale || survey_core__WEBPACK_IMPORTED_MODULE_2__.surveyLocalization.defaultLocale);
        },
        set: function (val) {
            if (val === this.activeLanguage)
                return;
            this.setPropertyValue("activeLanguage", val);
            this.survey.locale = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewViewModel.prototype, "survey", {
        get: function () {
            return this.simulator.survey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewViewModel.prototype, "pageActions", {
        get: function () {
            return this.pages.actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewViewModel.prototype, "isPageToolbarVisible", {
        get: function () {
            return this.pages.visibleActions.length > 0 && !this.surveyProvider.isMobileView;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewViewModel.prototype, "isMobileView", {
        get: function () {
            return this.surveyProvider.isMobileView;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewViewModel.prototype, "showResults", {
        get: function () {
            return this.getShowResults();
        },
        enumerable: false,
        configurable: true
    });
    PreviewViewModel.prototype.updateSimulatorSurvey = function (json, theme) {
        var _this = this;
        var newSurvey = this.surveyProvider.createSurvey(json || {}, this.getTabName(), this, function (survey) {
            var preferredTheme = undefined;
            if ((0,_theme_model__WEBPACK_IMPORTED_MODULE_5__.isThemeEmpty)(_this.surveyProvider.theme)) {
                preferredTheme = (0,_theme_model__WEBPACK_IMPORTED_MODULE_5__.findSuitableTheme)(undefined, _this.surveyProvider.preferredColorPalette, undefined, undefined);
            }
            survey.applyTheme(preferredTheme || _this.surveyProvider.theme);
            survey.setCss(theme, false);
            survey.fitToContainer = true;
            survey.addLayoutElement({
                id: "complete-customization",
                container: "completePage",
                component: "svc-complete-page",
                data: _this
            });
        });
        var hasSurveyBefore = !!this.simulator.survey;
        this.simulator.survey = newSurvey;
        if (this.onSurveyCreatedCallback)
            this.onSurveyCreatedCallback(this.survey);
        this.survey.onComplete.add(function (sender) {
            _this.isRunning = false;
        });
        if (!!this.survey["onNavigateToUrl"]) {
            this.survey["onNavigateToUrl"].add(function (sender, options) {
                var url = options.url;
                options.url = "";
                if (!!url && options.allow) {
                    var message = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ed.navigateToMsg") + " '" + url + "'.";
                    if (!!_this.surveyProvider) {
                        _this.surveyProvider.notify(message);
                    }
                    else {
                        alert(message);
                    }
                }
            });
        }
        this.survey.onStarted.add(function (sender) {
            _this.setActivePageItem(_this.simulator.survey.activePage, true);
        });
        this.survey.onCurrentPageChanged.add(function (sender, options) {
            _this.activePage = options.newCurrentPage;
            _this.setActivePageItem(options.oldCurrentPage, false);
            _this.setActivePageItem(options.newCurrentPage, true);
        });
        this.survey.onPageVisibleChanged.add(function (sender, options) {
            _this.updatePageItem(options.page);
            _this.updatePrevNextPageActionState();
        });
        if (hasSurveyBefore) {
            this.show();
        }
    };
    PreviewViewModel.prototype.setJSON = function (json, currTheme) {
        this.json = json;
        if (json != null) {
            if (json.cookieName) {
                delete json.cookieName;
            }
        }
        this.updateSimulatorSurvey(json, currTheme);
    };
    PreviewViewModel.prototype.initialize = function (json, options) {
        this.setJSON(json, this.startThemeClasses);
        this.updatePageList();
        if (options.showPagesInTestSurveyTab !== undefined) {
            this.showPagesInTestSurveyTab = options.showPagesInTestSurveyTab;
        }
        this.buildActions();
    };
    PreviewViewModel.prototype.updatePageItem = function (page) {
        var item = this.getPageItemByPage(page);
        if (item) {
            item.enabled = (this.enableInvisiblePages && this.showInvisibleElements) || page.isVisible;
        }
    };
    PreviewViewModel.prototype.getCurrentPageItem = function () {
        return this.pageListItems[this.survey.pages.indexOf(this.survey.activePage)];
    };
    PreviewViewModel.prototype.getSelectPageTitle = function () {
        return (this.activePage && this.getPageTitle(this.activePage, "preview-tab:selected-page", "survey-tester-selected")) || (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ts.selectPage");
    };
    PreviewViewModel.prototype.getPageTitle = function (page, area, reason) {
        if (area === void 0) { area = "preview-tab:page-list"; }
        if (reason === void 0) { reason = "survey-tester"; }
        var pageTitle = page.title.replace(PreviewViewModel.tagRegex, "");
        var title = this.surveyProvider.getObjectDisplayName(page, area, reason, pageTitle);
        if (title === page.name && title.indexOf("page") === 0) {
            var index = this.survey.pages.indexOf(page);
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.pageTypeName") + " " + (index + 1);
        }
        return title;
    };
    PreviewViewModel.prototype.updatePageList = function () {
        var pages = [];
        for (var i = 0; i < this.survey.pages.length; i++) {
            var page = this.survey.pages[i];
            var pageItem = {
                id: page.name,
                data: page,
                title: this.getPageTitle(page),
                enabled: (this.enableInvisiblePages && this.showInvisibleElements) || page.isVisible,
                visible: true
            };
            if (!page.isVisible) {
                pageItem.css = "svc-page-invisible";
                pageItem.markerIconName = "icon-invisible-items";
            }
            pages.push(pageItem);
        }
        this.pageListItems = pages;
    };
    PreviewViewModel.prototype.getTabName = function () { return ""; };
    PreviewViewModel.prototype.getShowResults = function () { return false; };
    PreviewViewModel.prototype.show = function () {
        this.showInvisibleElements = false;
        this.activePage = this.survey.activePage;
        this.survey.locale = this.activeLanguage;
        this.isRunning = true;
    };
    PreviewViewModel.prototype.testAgain = function () {
        this.setJSON(this.json, this.simulator.survey.css);
        this.updatePageList();
        this.show();
    };
    PreviewViewModel.prototype.buildActions = function () {
        var _this = this;
        var pageActions = [];
        var setNearPage = function (isNext) {
            var currentIndex = _this.survey.currentPageNo;
            var shift = isNext ? 1 : -1;
            var newIndex = currentIndex + shift;
            if (_this.survey.state === "starting" && isNext) {
                newIndex = 0;
            }
            var nearPage = _this.showInvisibleElements ? _this.survey.pages[newIndex] : _this.survey.visiblePages[newIndex];
            if (!isNext && currentIndex === 0 && _this.survey.firstPageIsStarted
                && _this.survey.pages.length > 0) {
                nearPage = _this.survey.pages[0];
            }
            var pageIndex = _this.survey.pages.indexOf(nearPage);
            _this.activePage = _this.survey.pages[pageIndex];
            _this.selectPageAction.data.selectedItem = _this.pageListItems[pageIndex];
        };
        if (this.prevPageAction) {
            this.prevPageAction.visible = new survey_core__WEBPACK_IMPORTED_MODULE_2__.ComputedUpdater(function () {
                var isRunning = _this.survey.state === "running";
                var isActiveTab = _this.getTabName() === _this.surveyProvider.activeTab;
                return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_4__.notShortCircuitAnd)(_this.isRunning, isActiveTab, _this.pageListItems.length > 1) && isRunning;
            });
            this.prevPageAction.iconName = new survey_core__WEBPACK_IMPORTED_MODULE_2__.ComputedUpdater(function () {
                return _this.surveyProvider.isMobileView ? "icon-arrow-left" : "icon-arrow-left_16x16";
            });
            this.prevPageAction.action = function () { return setNearPage(false); };
            pageActions.push(this.prevPageAction);
        }
        this.selectPageAction = (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.createDropdownActionModel)({
            id: "pageSelector",
            css: "svc-page-selector",
            title: this.getSelectPageTitle(),
            visible: this.isRunning && this.pageListItems.length > 1 && this.showPagesInTestSurveyTab
        }, {
            items: this.pageListItems,
            allowSelection: true,
            selectedItem: this.getCurrentPageItem(),
            onSelectionChanged: function (item) {
                _this.activePage = item.data;
                for (var i = 0; i < _this.survey.pages.length && _this.survey.pages[i] !== _this.activePage; i++) {
                    _this.survey.pages[i].passed = true;
                }
            },
            cssClass: "svc-creator-popup",
            verticalPosition: "top",
            horizontalPosition: "center"
        });
        pageActions.push(this.selectPageAction);
        this.selectPageAction.visible = new survey_core__WEBPACK_IMPORTED_MODULE_2__.ComputedUpdater(function () {
            return _this.survey.state === "running";
        });
        if (this.nextPageAction) {
            this.nextPageAction.visible = new survey_core__WEBPACK_IMPORTED_MODULE_2__.ComputedUpdater(function () {
                var isRunning = _this.survey.state === "running";
                var isActiveTab = _this.getTabName() === _this.surveyProvider.activeTab;
                return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_4__.notShortCircuitAnd)(_this.isRunning, isActiveTab, _this.pageListItems.length > 1) && isRunning;
            });
            this.nextPageAction.iconName = new survey_core__WEBPACK_IMPORTED_MODULE_2__.ComputedUpdater(function () {
                return _this.surveyProvider.isMobileView ? "icon-arrow-right" : "icon-arrow-right_16x16";
            });
            this.nextPageAction.action = function () { return setNearPage(true); };
            pageActions.push(this.nextPageAction);
        }
        this.pages.actions = pageActions;
        this.pages.containerCss = "sv-action-bar--pages";
        this.updatePrevNextPageActionState();
    };
    PreviewViewModel.prototype.setActivePageItem = function (page, val) {
        var item = this.getPageItemByPage(page);
        if (item) {
            item.active = val;
        }
    };
    PreviewViewModel.prototype.getPageItemByPage = function (page) {
        var model = this.selectPageAction.popupModel.contentComponentData.model;
        if (!model || !Array.isArray(model.actions))
            return undefined;
        var items = model.actions;
        for (var i = 0; i < items.length; i++) {
            if (items[i].data === page)
                return items[i];
        }
        return null;
    };
    PreviewViewModel.prototype.updateResultsTemplate = function (theme) {
        this.simulator.survey.setCss(theme, false);
        this.simulator.survey.render();
    };
    PreviewViewModel.prototype.setTheme = function (themeName, themeMapper) {
        var availableThemes = themeMapper.filter(function (item) { return item.name === themeName; });
        var theme = survey_core__WEBPACK_IMPORTED_MODULE_2__.defaultV2Css;
        if (availableThemes.length > 0) {
            theme = availableThemes[0].theme;
        }
        this.isRunning ? this.updateSimulatorSurvey(this.json, theme) : this.updateResultsTemplate(theme);
    };
    PreviewViewModel.prototype.onPropertyValueChanged = function (name, oldValue, newValue) {
        _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
        if (!this.pages.hasActions)
            return;
        if (name === "activePage") {
            this.updatePrevNextPageActionState();
            this.selectPageAction.title = this.getSelectPageTitle();
        }
        if (name === "isRunning" || name === "pageListItems" || name === "showPagesInTestSurveyTab") {
            this.selectPageAction.popupModel.contentComponentData.model.items = this.pageListItems;
            this.selectPageAction.popupModel.contentComponentData.model.selectedItem = this.getCurrentPageItem();
            this.selectPageAction.visible = this.isRunning && this.pageListItems.length > 1 && this.showPagesInTestSurveyTab;
        }
    };
    PreviewViewModel.prototype.updatePrevNextPageActionState = function () {
        if (!this.prevPageAction || !this.survey)
            return;
        var isPrevEnabled = this.survey.firstPageIsStarted && this.survey.state !== "starting"
            || (!this.survey.firstPageIsStarted && !this.survey.isFirstPage);
        this.prevPageAction.enabled = isPrevEnabled;
        var isNextEnabled = this.survey && this.survey.visiblePages.indexOf(this.activePage) !== this.survey.visiblePages.length - 1;
        this.nextPageAction.enabled = isNextEnabled;
    };
    Object.defineProperty(PreviewViewModel.prototype, "placeholderTitleText", {
        get: function () {
            if (this.isMobileView)
                return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ed.previewPlaceholderTitleMobile");
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ed.previewPlaceholderTitle");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PreviewViewModel.prototype, "placeholderDescriptionText", {
        get: function () {
            if (this.isMobileView)
                return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ed.previewPlaceholderDescriptionMobile");
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ed.previewPlaceholderDescription");
        },
        enumerable: false,
        configurable: true
    });
    PreviewViewModel.prototype.onScroll = function () {
        this.survey.onScroll();
        return true;
    };
    PreviewViewModel.prototype.dispose = function () {
        if (this.selectPageAction) {
            this.selectPageAction.dispose();
        }
        this.simulator.dispose();
        _super.prototype.dispose.call(this);
    };
    PreviewViewModel.tagRegex = /(<([^>]+)>)/ig;
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.property)({
            defaultValue: false,
            onSet: function (val, target) {
                target.simulator.survey.showInvisibleElements = val;
            }
        })
    ], PreviewViewModel.prototype, "showInvisibleElements", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.property)({ defaultValue: true })
    ], PreviewViewModel.prototype, "showPagesInTestSurveyTab", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.property)({
            defaultValue: true, onSet: function (value, target) {
                if (!!target.simulator)
                    target.simulator.isRunning = value;
            }
        })
    ], PreviewViewModel.prototype, "isRunning", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.propertyArray)()
    ], PreviewViewModel.prototype, "pageListItems", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_2__.property)({
            onSet: function (val, target) {
                if (!!val) {
                    var survey = target.simulator.survey;
                    if (survey.firstPageIsStarted) {
                        if (val === survey.pages[0]) {
                            survey.clear(false, true);
                        }
                        else {
                            if (survey.state == "starting") {
                                survey.setPropertyValue("isStartedState", false);
                            }
                        }
                    }
                    if (survey.state !== "starting") {
                        survey.currentPage = val;
                    }
                }
                target.updatePrevNextPageActionState();
            }
        })
    ], PreviewViewModel.prototype, "activePage", void 0);
    return PreviewViewModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_2__.Base));



/***/ }),

/***/ "./src/components/tabs/test-plugin.ts":
/*!********************************************!*\
  !*** ./src/components/tabs/test-plugin.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TabTestPlugin: () => (/* binding */ TabTestPlugin)
/* harmony export */ });
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _simulator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../simulator */ "./src/components/simulator.ts");
/* harmony import */ var _test__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./test */ "./src/components/tabs/test.ts");





var TabTestPlugin = /** @class */ (function () {
    function TabTestPlugin(creator) {
        this.creator = creator;
        this.simulatorTheme = survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyCss[survey_core__WEBPACK_IMPORTED_MODULE_1__.defaultV2ThemeName];
        this._previewDevice = "";
        creator.addPluginTab("test", this);
        this.setPreviewTheme(this.creator.themeForPreview);
        this.createActions().forEach(function (action) { return creator.toolbar.actions.push(action); });
    }
    Object.defineProperty(TabTestPlugin.prototype, "previewDevice", {
        get: function () {
            if (!!this.model) {
                this._previewDevice = this.model.simulator.device;
            }
            return this._previewDevice;
        },
        set: function (newValue) {
            this.setDevice(newValue);
        },
        enumerable: false,
        configurable: true
    });
    TabTestPlugin.prototype.setDevice = function (newValue) {
        this._previewDevice = newValue || "desktop";
        if (!!this.model) {
            this.model.simulator.device = newValue;
            this.model.simulator.resetZoomParameters();
        }
        var currentType = _simulator__WEBPACK_IMPORTED_MODULE_3__.simulatorDevices[this._previewDevice].deviceType;
        this.orientationSelectorAction.enabled = currentType != "desktop";
        this.deviceSelectorAction.iconName = "icon-device-" + currentType;
        this.deviceSelectorAction.title = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("pe.simulator");
        this.deviceSelectorAction.data.selectedItem = { id: this._previewDevice };
    };
    TabTestPlugin.prototype.setDefaultLanguageOption = function (opt) {
        var _this = this;
        var vis = opt === true || opt === "all" || (opt === "auto" && this.model.survey.getUsedLocales().length > 1);
        this.languageSelectorAction.visible = vis;
        var languages = [];
        if (vis) {
            languages = this.getLanguages(opt !== "all" ? this.model.survey.getUsedLocales() : null);
        }
        this.languageSelectorAction.popupModel.contentComponentData.model.setItems(languages);
        this.languageSelectorAction.data.selectedItem = languages.filter(function (lang) { return lang.id === _this.model.activeLanguage; })[0];
    };
    TabTestPlugin.prototype.getLanguages = function (usedLanguages) {
        if (usedLanguages === void 0) { usedLanguages = null; }
        var res = [];
        var locales = !!usedLanguages && usedLanguages.length > 1 ? usedLanguages : survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.getLocales();
        for (var i = 0; i < locales.length; i++) {
            var loc = locales[i];
            res.push({ id: loc, title: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getLocaleName(loc) });
        }
        return res;
    };
    TabTestPlugin.prototype.updateActions = function () {
        this.languageSelectorAction.title = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getLocaleName(this.model.activeLanguage);
        this.languageSelectorAction.visible = true;
        if (this.creator.showSimulatorInTestSurveyTab) {
            this.setDevice(this.model.simulator.device);
            this.deviceSelectorAction.data.selectedItem = { id: this.model.simulator.device };
            this.orientationSelectorAction.title = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("pe.portraitOrientation");
        }
        if (this.creator.showInvisibleElementsInTestSurveyTab) {
            this.invisibleToggleAction.css = this.model.showInvisibleElements ? "sv-action-bar-item--active" : "";
            this.invisibleToggleAction.visible = this.model.isRunning;
        }
        if (this.creator.showDefaultLanguageInTestSurveyTab != undefined) {
            this.setDefaultLanguageOption(this.creator.showDefaultLanguageInTestSurveyTab);
        }
    };
    TabTestPlugin.prototype.setPreviewTheme = function (themeName) {
        this.simulatorTheme = survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyCss[themeName] || survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyCss[survey_core__WEBPACK_IMPORTED_MODULE_1__.defaultV2ThemeName];
    };
    TabTestPlugin.prototype.createVisibleUpdater = function () {
        var _this = this;
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.creator.activeTab === "test"; });
    };
    TabTestPlugin.prototype.activate = function () {
        var tabModel = new _test__WEBPACK_IMPORTED_MODULE_4__.TestSurveyTabViewModel(this.creator, this.simulatorTheme);
        tabModel.simulator.device = this.previewDevice || this.creator.previewDevice || "desktop";
        tabModel.simulator.landscape = this.creator.previewOrientation != "portrait";
        this.model = tabModel;
        this.update();
    };
    TabTestPlugin.prototype.update = function () {
        var _this = this;
        if (!this.model)
            return;
        var options = {
            showPagesInTestSurveyTab: this.creator.showPagesInTestSurveyTab,
        };
        this.testAgainAction.locStrsChanged();
        this.model.testAgainAction = this.testAgainAction;
        this.model.prevPageAction = this.prevPageAction;
        this.model.nextPageAction = this.nextPageAction;
        this.model.initialize(this.creator.JSON, options);
        this.updateActions();
        this.model.show();
        this.model.onPropertyChanged.add(function (sender, options) {
            if (options.name === "isRunning") {
                _this.invisibleToggleAction && (_this.invisibleToggleAction.visible = _this.model.isRunning);
                _this.testAgainAction.visible = !_this.model.isRunning;
            }
        });
    };
    TabTestPlugin.prototype.deactivate = function () {
        if (this.model) {
            this._previewDevice = this.model.simulator.device;
            this.simulatorTheme = this.model.simulator.survey.css;
            this.model.onSurveyCreatedCallback = undefined;
            this.model.dispose();
            this.model = undefined;
        }
        this.languageSelectorAction.visible = false;
        this.testAgainAction.visible = false;
        this.invisibleToggleAction && (this.invisibleToggleAction.visible = false);
        return true;
    };
    TabTestPlugin.prototype.getAvailableThemes = function (themeMapper) {
        var availableThemesToItems = [];
        for (var i = 0; i < themeMapper.length; i++) {
            var item = themeMapper[i];
            var action = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({ id: item.name + "_themeSwitcher", locTitleName: this.getThemeLocName(item.name) });
            action.value = item.name;
            availableThemesToItems.push(action);
        }
        return availableThemesToItems;
    };
    TabTestPlugin.prototype.getThemeLocName = function (name) {
        return "ed." + name + "Theme";
    };
    TabTestPlugin.prototype.createActions = function () {
        var _this = this;
        var items = [];
        this.testAgainAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "testSurveyAgain",
            visible: false,
            locTitleName: "ed.testSurveyAgain",
            action: function () {
                _this.model.testAgain();
            }
        });
        if (this.creator.showSimulatorInTestSurveyTab) {
            var deviceSelectorItems = Object.keys(_simulator__WEBPACK_IMPORTED_MODULE_3__.simulatorDevices)
                .filter(function (key) { return !!_simulator__WEBPACK_IMPORTED_MODULE_3__.simulatorDevices[key].title; })
                .map(function (key) { var _a; return ({ id: key, title: _simulator__WEBPACK_IMPORTED_MODULE_3__.simulatorDevices[key].title, visibleIndex: (_a = _simulator__WEBPACK_IMPORTED_MODULE_3__.simulatorDevices[key].visibleIndex) !== null && _a !== void 0 ? _a : Number.MAX_VALUE }); });
            this.deviceSelectorAction = (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.createDropdownActionModel)({
                id: "deviceSelector",
                iconName: "icon-device-desktop",
                iconSize: "auto",
                mode: "small",
                visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                    return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__.notShortCircuitAnd)(_this.creator.activeTab === "test", _this.creator.showSimulatorInTestSurveyTab, !_this.creator.isTouch);
                }),
            }, {
                items: deviceSelectorItems,
                allowSelection: true,
                onSelectionChanged: function (item) { _this.setDevice(item.id); },
                horizontalPosition: "center",
                cssClass: "svc-creator-popup",
                onHide: function () { _this.deviceSelectorAction.enabled = true; },
                onShow: function () { _this.deviceSelectorAction.enabled = false; }
            });
            items.push(this.deviceSelectorAction);
            this.orientationSelectorAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
                id: "orientationSelector",
                iconName: "icon-device-rotate",
                iconSize: "auto",
                mode: "small",
                visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                    return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__.notShortCircuitAnd)(_this.creator.activeTab === "test", _this.creator.showSimulatorInTestSurveyTab, !_this.creator.isTouch);
                }),
                action: function () {
                    _this.model.simulator.landscape = !_this.model.simulator.landscape;
                    _this.orientationSelectorAction.title = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)(!_this.model.simulator.landscape ? "pe.landscapeOrientation" : "pe.portraitOrientation");
                }
            });
            items.push(this.orientationSelectorAction);
        }
        if (this.creator.showInvisibleElementsInTestSurveyTab) {
            this.invisibleToggleAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
                id: "showInvisible",
                iconName: "icon-invisible-items",
                iconSize: "auto",
                mode: "small",
                needSeparator: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                    return !_this.creator.isMobileView;
                }),
                locTitleName: "ts.showInvisibleElements",
                visible: false,
                action: function () {
                    _this.model.showInvisibleElements = !_this.model.showInvisibleElements;
                    _this.invisibleToggleAction.css = _this.model.showInvisibleElements ? "sv-action-bar-item--active" : "";
                    _this.invisibleToggleAction.title = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)(!_this.model.showInvisibleElements ? "ts.showInvisibleElements" : "ts.hideInvisibleElements");
                }
            });
            items.push(this.invisibleToggleAction);
        }
        var themeMapper = survey_core__WEBPACK_IMPORTED_MODULE_1__.StylesManager.getIncludedThemeCss();
        var sequence = ["defaultV2", "modern", "default"];
        themeMapper = themeMapper.sort(function (theme1, theme2) {
            return sequence.indexOf(theme1.name) > sequence.indexOf(theme2.name) ? 1 : -1;
        });
        var availableThemesToItems = this.getAvailableThemes(themeMapper);
        if (this.creator.allowChangeThemeInPreview && availableThemesToItems.length > 1 && !this.creator.showThemeTab) {
            this.changeThemeModel = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ListModel(availableThemesToItems, function (item) {
                if (!!_this.model) {
                    _this.model.setTheme(item.value, themeMapper);
                }
                _this.changeThemeAction.locTitleName = _this.getThemeLocName(item.value);
                _this.changeThemeAction.locStrsChanged();
                _this.changeThemePopupModel.toggleVisibility();
            }, true);
            this.changeThemeModel.locOwner = this.creator;
            this.changeThemePopupModel = new survey_core__WEBPACK_IMPORTED_MODULE_1__.PopupModel("sv-list", { model: this.changeThemeModel }, {
                verticalPosition: "bottom",
                horizontalPosition: "center",
                cssClass: "svc-creator-popup",
            });
            var getStartThemeName = function () {
                var availableThemes = themeMapper.filter(function (item) { return item.theme.root === _this.simulatorTheme.root; });
                return availableThemes.length > 0 ? availableThemes[0].name : "defaultV2";
            };
            this.changeThemeAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
                id: "themeSwitcher",
                iconName: "icon-theme",
                iconSize: "auto",
                component: "sv-action-bar-item-dropdown",
                mode: "large",
                locTitleName: this.getThemeLocName(getStartThemeName()),
                needSeparator: true,
                visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                    return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__.notShortCircuitAnd)(_this.creator.showSimulatorInTestSurveyTab, _this.creator.activeTab === "test");
                }),
                action: function () {
                    _this.changeThemePopupModel.toggleVisibility();
                },
                popupModel: this.changeThemePopupModel
            });
            items.push(this.changeThemeAction);
        }
        this.languageSelectorAction = (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.createDropdownActionModel)({
            id: "languageSelector",
            iconName: "icon-language",
            visible: false,
            mode: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                return _this.creator.isMobileView ? "small" : "large";
            }),
        }, {
            items: [],
            allowSelection: true,
            onSelectionChanged: function (item) {
                _this.model.activeLanguage = item.id;
                _this.languageSelectorAction.title = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getLocaleName(item.id);
            },
            horizontalPosition: "center",
            cssClass: "svc-creator-popup",
            onHide: function () { _this.languageSelectorAction.enabled = true; },
            onShow: function () { _this.languageSelectorAction.enabled = false; }
        });
        items.push(this.languageSelectorAction);
        this.designerAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "svd-designer",
            iconName: "icon-config",
            iconSize: "auto",
            action: function () { _this.creator.makeNewViewActive("designer"); },
            visible: this.createVisibleUpdater(),
            locTitleName: "ed.designer",
            showTitle: false
        });
        this.previewAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "svd-preview",
            iconName: "icon-preview",
            iconSize: "auto",
            active: true,
            visible: this.createVisibleUpdater(),
            locTitleName: "tabs.preview",
            showTitle: false,
            action: function () { }
        });
        this.prevPageAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "prevPage",
            iconName: "icon-arrow-left_16x16",
            iconSize: "auto",
            needSeparator: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                return _this.creator.isMobileView;
            }),
            visible: false
        });
        this.nextPageAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "nextPage",
            iconName: "icon-arrow-right_16x16",
            iconSize: "auto",
            visible: false
        });
        return items;
    };
    TabTestPlugin.prototype.addFooterActions = function () {
        this.creator.footerToolbar.actions.push(this.designerAction);
        this.creator.footerToolbar.actions.push(this.previewAction);
        this.creator.footerToolbar.actions.push(this.prevPageAction);
        this.creator.footerToolbar.actions.push(this.nextPageAction);
        this.invisibleToggleAction && (this.creator.footerToolbar.actions.push(this.invisibleToggleAction));
        // this.languageSelectorAction && (this.creator.footerToolbar.actions.push(this.languageSelectorAction));
    };
    return TabTestPlugin;
}());



/***/ }),

/***/ "./src/components/tabs/test.ts":
/*!*************************************!*\
  !*** ./src/components/tabs/test.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TestSurveyTabViewModel: () => (/* binding */ TestSurveyTabViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var _preview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./preview */ "./src/components/tabs/preview.ts");


__webpack_require__(/*! ./test.scss */ "./src/components/tabs/test.scss");
var TestSurveyTabViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TestSurveyTabViewModel, _super);
    function TestSurveyTabViewModel(surveyProvider, startThemeClasses) {
        return _super.call(this, surveyProvider, startThemeClasses) || this;
    }
    TestSurveyTabViewModel.prototype.getTabName = function () {
        return "test";
    };
    TestSurveyTabViewModel.prototype.getShowResults = function () {
        return this.surveyProvider.previewShowResults && !this.isRunning && !this.isMobileView;
    };
    return TestSurveyTabViewModel;
}(_preview__WEBPACK_IMPORTED_MODULE_1__.PreviewViewModel));



/***/ }),

/***/ "./src/components/tabs/theme-builder.ts":
/*!**********************************************!*\
  !*** ./src/components/tabs/theme-builder.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ThemeTabViewModel: () => (/* binding */ ThemeTabViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var _preview__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./preview */ "./src/components/tabs/preview.ts");


var ThemeTabViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(ThemeTabViewModel, _super);
    function ThemeTabViewModel(surveyProvider, startThemeClasses) {
        return _super.call(this, surveyProvider, startThemeClasses) || this;
    }
    Object.defineProperty(ThemeTabViewModel.prototype, "currentTheme", {
        get: function () {
            return this.surveyProvider.theme;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeTabViewModel.prototype, "currentThemeCssVariables", {
        get: function () {
            return this.currentTheme.cssVariables || {};
        },
        enumerable: false,
        configurable: true
    });
    ThemeTabViewModel.prototype.getTabName = function () { return "theme"; };
    return ThemeTabViewModel;
}(_preview__WEBPACK_IMPORTED_MODULE_1__.PreviewViewModel));



/***/ }),

/***/ "./src/components/tabs/theme-custom-questions/background-corner-radius.ts":
/*!********************************************************************************!*\
  !*** ./src/components/tabs/theme-custom-questions/background-corner-radius.ts ***!
  \********************************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   backgroundCornerRadiusFromCssVariable: () => (/* binding */ backgroundCornerRadiusFromCssVariable),
/* harmony export */   backgroundCornerRadiusToCssVariable: () => (/* binding */ backgroundCornerRadiusToCssVariable),
/* harmony export */   updateBackgroundCornerRadiusJSON: () => (/* binding */ updateBackgroundCornerRadiusJSON)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/utils */ "./src/utils/utils.ts");




function getElementsJSON() {
    return [
        {
            type: "coloralpha",
            name: "backcolor",
            colorTitle: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.backcolor"),
            colorTitleLocation: "left",
            titleLocation: "hidden",
            descriptionLocation: "hidden"
        },
        {
            type: "coloralpha",
            name: "hovercolor",
            colorTitle: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.hovercolor"),
            colorTitleLocation: "left",
            titleLocation: "hidden",
            descriptionLocation: "hidden"
        },
        {
            type: "spinedit",
            name: "cornerRadius",
            title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.cornerRadius"),
            titleLocation: "left",
            descriptionLocation: "hidden",
            unit: "px",
            min: 0
        }
    ];
}
if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.getCustomQuestionByName("backgroundcornerradius")) {
    survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.add({
        name: "backgroundcornerradius",
        showInToolbox: false,
        internal: true,
        elementsJSON: getElementsJSON(),
        onInit: function () {
        },
        onCreated: function (question) {
        },
        valueToQuestion: function (value) {
            return JSON.parse(JSON.stringify(value));
        },
        onValueChanged: function (question, name, newValue) {
        },
    });
}
function updateBackgroundCornerRadiusJSON() {
    var config = survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.getCustomQuestionByName("backgroundcornerradius");
    config.json.elementsJSON = getElementsJSON();
}
function backgroundCornerRadiusToCssVariable(value, property, themeCssVariables) {
    if (value === void 0) { value = {}; }
    Object.keys(value).forEach(function (key) {
        var propertyName = "--sjs-".concat(property.name.toLocaleLowerCase(), "-").concat(key);
        if (!property.defaultValue || value[key] !== property.defaultValue[key]) {
            themeCssVariables[propertyName] = value[key] + (key === "cornerRadius" ? "px" : "");
        }
        else {
            themeCssVariables[propertyName] = undefined;
        }
    });
}
function backgroundCornerRadiusFromCssVariable(property, themeCssVariables, defaultBackcolorVariableName, defaultHovercolorVariableName, defaultCornerRadius) {
    if (defaultCornerRadius === void 0) { defaultCornerRadius = 4; }
    if (!property)
        return;
    if (!property.defaultValue)
        property.defaultValue = {};
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.assign)(property.defaultValue, {
        backcolor: themeCssVariables[defaultBackcolorVariableName],
        hovercolor: themeCssVariables[defaultHovercolorVariableName],
        cornerRadius: defaultCornerRadius
    });
    var result = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, property.defaultValue);
    var objFromTheme = Object.keys(themeCssVariables).filter(function (key) { return key.indexOf(property.name.toLocaleLowerCase()) !== -1; });
    objFromTheme.forEach(function (key) {
        var propertyName = key.split("-").pop();
        if (propertyName === "cornerRadius" && themeCssVariables[key] !== undefined) {
            result[propertyName] = parseFloat(themeCssVariables[key].toString());
        }
        else {
            result[propertyName] = themeCssVariables[key];
        }
    });
    return result;
}


/***/ }),

/***/ "./src/components/tabs/theme-custom-questions/color-alpha.ts":
/*!*******************************************************************!*\
  !*** ./src/components/tabs/theme-custom-questions/color-alpha.ts ***!
  \*******************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createColor: () => (/* binding */ createColor),
/* harmony export */   updatecoloralphaJSON: () => (/* binding */ updatecoloralphaJSON)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../utils/utils */ "./src/utils/utils.ts");



function getElementsJSON() {
    return [
        {
            name: "color",
            type: "color",
            titleLocation: "hidden",
        },
        {
            name: "opacity",
            startWithNewLine: false,
            type: "spinedit",
            title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_1__.getLocString)("theme.opacity"),
            min: 0,
            max: 100,
            defaultValue: 100,
            unit: "%",
            titleLocation: "left"
        }
    ];
}
if (!survey_core__WEBPACK_IMPORTED_MODULE_0__.ComponentCollection.Instance.getCustomQuestionByName("coloralpha")) {
    survey_core__WEBPACK_IMPORTED_MODULE_0__.ComponentCollection.Instance.add({
        name: "coloralpha",
        showInToolbox: false,
        internal: true,
        elementsJSON: getElementsJSON(),
        onInit: function () {
            survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.addProperties("coloralpha", [{
                    name: "choices:itemvalue[]",
                    visible: false
                },
                {
                    name: "colorTitleLocation:string",
                    default: "hidden",
                    visible: false
                },
                {
                    name: "allowEmptyValue:boolean",
                    default: false,
                    visible: false
                },
                {
                    name: "colorTitle:string",
                    visible: false
                }
            ]);
        },
        onLoaded: function (question) {
            syncPropertiesFromCompositeToColor(question, "colorTitle", question.colorTitle);
            syncPropertiesFromCompositeToColor(question, "colorTitleLocation", question.colorTitleLocation);
            syncPropertiesFromCompositeToColor(question, "choices", question.choices);
            syncPropertiesFromCompositeToColor(question, "allowEmptyValue", question.allowEmptyValue);
        },
        onPropertyChanged: function (question, propertyName, newValue) {
            syncPropertiesFromCompositeToColor(question, propertyName, newValue);
        },
        valueToQuestion: function (value) {
            return !!value ? createColor(value) : "";
        },
        valueFromQuestion: function (value) {
            return typeof value == "string" || typeof value == "undefined" ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__.parseColor)(value) : value;
        },
        onCreated: function (question) {
            question.contentPanel.questions.forEach(function (q) { return q.allowRootStyle = false; });
        }
    });
}
function updatecoloralphaJSON() {
    var config = survey_core__WEBPACK_IMPORTED_MODULE_0__.ComponentCollection.Instance.getCustomQuestionByName("coloralpha");
    config.json.elementsJSON = getElementsJSON();
}
function syncPropertiesFromCompositeToColor(question, propertyName, newValue) {
    var colorQuestion = question.contentPanel.questions[0];
    if (!colorQuestion) {
        return;
    }
    if (propertyName == "colorTitleLocation") {
        colorQuestion.titleLocation = newValue;
    }
    if (propertyName == "colorTitle") {
        colorQuestion.title = newValue;
    }
    if (propertyName == "choices") {
        colorQuestion.choices = newValue;
    }
    if (propertyName == "allowEmptyValue") {
        colorQuestion.allowEmptyValue = newValue;
    }
}
function createColor(value) {
    return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__.ingectAlpha)(value.color, value.opacity / 100);
}


/***/ }),

/***/ "./src/components/tabs/theme-custom-questions/font-settings.ts":
/*!*********************************************************************!*\
  !*** ./src/components/tabs/theme-custom-questions/font-settings.ts ***!
  \*********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DefaultFonts: () => (/* binding */ DefaultFonts),
/* harmony export */   fontsettingsFromCssVariable: () => (/* binding */ fontsettingsFromCssVariable),
/* harmony export */   fontsettingsToCssVariable: () => (/* binding */ fontsettingsToCssVariable),
/* harmony export */   updateFontSettingsJSON: () => (/* binding */ updateFontSettingsJSON)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../../utils/utils */ "./src/utils/utils.ts");




var DefaultFonts = [
    "Open Sans",
    "Arial, sans-serif",
    "Brush Script MT, cursive",
    "Courier New, monospace",
    "Garamond, serif",
    "Georgia, serif",
    "Tahoma, sans-serif",
    "Times New Roman, serif",
    "Trebuchet MS, sans-serif",
    "Verdana, sans-serif",
];
function getElementsJSON() {
    return [
        {
            type: "dropdown",
            name: "family",
            title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.fontFamily"),
            titleLocation: "left",
            descriptionLocation: "hidden",
            choices: [].concat(DefaultFonts),
            allowClear: false
        },
        {
            type: "buttongroup",
            name: "weight",
            titleLocation: "hidden",
            descriptionLocation: "hidden",
            choices: [
                { value: "400", text: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.fontWeightRegular") },
                { value: "600", text: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.fontWeightSemiBold") },
                { value: "700", text: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.fontWeightBold") },
                { value: "800", text: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.fontWeightHeavy") },
            ],
        },
        {
            type: "coloralpha",
            name: "color",
            colorTitle: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.color"),
            colorTitleLocation: "left",
            titleLocation: "hidden",
            descriptionLocation: "hidden"
        },
        {
            type: "coloralpha",
            name: "placeholdercolor",
            colorTitle: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.placeholderColor"),
            colorTitleLocation: "left",
            titleLocation: "hidden",
            descriptionLocation: "hidden"
        },
        {
            type: "spinedit",
            name: "size",
            title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.size"),
            titleLocation: "left",
            descriptionLocation: "hidden",
            unit: "px",
            min: 0,
        }
    ];
}
if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.getCustomQuestionByName("font")) {
    survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.add({
        name: "font",
        showInToolbox: false,
        internal: true,
        elementsJSON: getElementsJSON(),
        onInit: function () {
            survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addProperties("font", [
                {
                    name: "allowEmptyColorValue:boolean",
                    default: false,
                    visible: false
                },
            ]);
        },
        onLoaded: function (question) {
            syncPropertiesFromComposite(question, "allowEmptyColorValue", question.allowEmptyColorValue);
        },
        onPropertyChanged: function (question, propertyName, newValue) {
            syncPropertiesFromComposite(question, propertyName, newValue);
        },
        onCreated: function (question) {
            var color = question.contentPanel.getQuestionByName("color");
            color.visible = question.name !== "surveyTitle" && question.name !== "surveyDescription";
            var placeholderColor = question.contentPanel.getQuestionByName("placeholdercolor");
            placeholderColor.visible = question.name === "editorFont";
            var family = question.contentPanel.getQuestionByName("family");
            family.choices = [].concat(DefaultFonts);
        },
        valueToQuestion: function (value) {
            return JSON.parse(JSON.stringify(value));
        },
        onValueChanged: function (question, name, newValue) {
        },
    });
}
function syncPropertiesFromComposite(question, propertyName, newValue) {
    var colorQuestion = question.contentPanel.questions[2];
    if (propertyName == "allowEmptyColorValue") {
        colorQuestion.allowEmptyValue = newValue;
    }
}
function updateFontSettingsJSON() {
    var config = survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.getCustomQuestionByName("font");
    config.json.elementsJSON = getElementsJSON();
}
function fontsettingsToCssVariable(value, property, themeCssVariables) {
    if (value === void 0) { value = {}; }
    Object.keys(value).forEach(function (key) {
        var propertyName = "--sjs-font-".concat(property.name.toLocaleLowerCase(), "-").concat(key);
        if (!property.defaultValue || value[key] !== property.defaultValue[key]) {
            themeCssVariables[propertyName] = value[key] + (key === "size" ? "px" : "");
        }
        else {
            themeCssVariables[propertyName] = undefined;
        }
    });
}
function fontsettingsFromCssVariable(property, themeCssVariables, defaultColorVariableName, defaultPlaceholderColorVariableName) {
    if (!property)
        return;
    if (!property.defaultValue)
        property.defaultValue = {};
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.assign)(property.defaultValue, {
        color: themeCssVariables[defaultColorVariableName],
        placeholdercolor: !!defaultPlaceholderColorVariableName ? themeCssVariables[defaultPlaceholderColorVariableName] : undefined,
    });
    if (!property.defaultValue["size"]) {
        property.defaultValue["size"] = parseFloat(themeCssVariables["--sjs-font-size"]);
    }
    var result = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, property.defaultValue);
    var fontSettingsFromTheme = Object.keys(themeCssVariables).filter(function (key) { return key.indexOf(property.name.toLocaleLowerCase()) !== -1; });
    fontSettingsFromTheme.forEach(function (key) {
        var propertyName = key.split("-").pop();
        if (propertyName === "size" && themeCssVariables[key] !== undefined) {
            result[propertyName] = parseFloat(themeCssVariables[key].toString());
        }
        else {
            result[propertyName] = themeCssVariables[key];
        }
    });
    return result;
}


/***/ }),

/***/ "./src/components/tabs/theme-custom-questions/index.ts":
/*!*************************************************************!*\
  !*** ./src/components/tabs/theme-custom-questions/index.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   updateCustomQuestionJSONs: () => (/* binding */ updateCustomQuestionJSONs)
/* harmony export */ });
/* harmony import */ var _shadow_effects__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./shadow-effects */ "./src/components/tabs/theme-custom-questions/shadow-effects.ts");
/* harmony import */ var _color_alpha__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./color-alpha */ "./src/components/tabs/theme-custom-questions/color-alpha.ts");
/* harmony import */ var _background_corner_radius__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./background-corner-radius */ "./src/components/tabs/theme-custom-questions/background-corner-radius.ts");
/* harmony import */ var _font_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./font-settings */ "./src/components/tabs/theme-custom-questions/font-settings.ts");




function updateCustomQuestionJSONs() {
    (0,_shadow_effects__WEBPACK_IMPORTED_MODULE_0__.updateShadowEffectsJSON)();
    (0,_font_settings__WEBPACK_IMPORTED_MODULE_3__.updateFontSettingsJSON)();
    (0,_color_alpha__WEBPACK_IMPORTED_MODULE_1__.updatecoloralphaJSON)();
    (0,_background_corner_radius__WEBPACK_IMPORTED_MODULE_2__.updateBackgroundCornerRadiusJSON)();
}


/***/ }),

/***/ "./src/components/tabs/theme-custom-questions/shadow-effects.ts":
/*!**********************************************************************!*\
  !*** ./src/components/tabs/theme-custom-questions/shadow-effects.ts ***!
  \**********************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   createBoxShadow: () => (/* binding */ createBoxShadow),
/* harmony export */   createBoxShadowReset: () => (/* binding */ createBoxShadowReset),
/* harmony export */   parseBoxShadow: () => (/* binding */ parseBoxShadow),
/* harmony export */   trimBoxShadowValue: () => (/* binding */ trimBoxShadowValue),
/* harmony export */   updateShadowEffectsJSON: () => (/* binding */ updateShadowEffectsJSON)
/* harmony export */ });
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


function getQuestionJSON() {
    return {
        "type": "paneldynamic",
        "minPanelCount": 1,
        "panelAddText": (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_0__.getLocString)("theme.boxShadowAddRule"),
        "templateElements": [
            {
                "type": "spinedit",
                "name": "x",
                "unit": "px",
                "title": (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_0__.getLocString)("theme.boxShadowX"),
                "titleLocation": "left",
            },
            {
                "type": "spinedit",
                "name": "y",
                "unit": "px",
                "startWithNewLine": false,
                "title": (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_0__.getLocString)("theme.boxShadowY"),
                "titleLocation": "left"
            },
            {
                "type": "spinedit",
                "name": "blur",
                "unit": "px",
                "title": (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_0__.getLocString)("theme.boxShadowBlur"),
                "min": 0,
                "titleLocation": "left"
            },
            {
                "type": "spinedit",
                "name": "spread",
                "unit": "px",
                "min": 0,
                "startWithNewLine": false,
                "title": (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_0__.getLocString)("theme.boxShadowSpread"),
                "titleLocation": "left"
            },
            {
                "type": "coloralpha",
                "name": "color",
                "titleLocation": "hidden"
            },
            {
                "type": "buttongroup",
                "name": "isInset",
                "titleLocation": "hidden",
                "choices": [
                    { text: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_0__.getLocString)("theme.boxShadowDrop"), value: false },
                    { text: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_0__.getLocString)("theme.boxShadowInner"), value: true }
                ]
            }
        ]
    };
}
if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.getCustomQuestionByName("shadoweffects")) {
    survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.add({
        name: "shadoweffects",
        showInToolbox: false,
        internal: true,
        questionJSON: getQuestionJSON(),
        onCreated: function (question) {
            question.valueFromDataCallback = function (value) {
                if (typeof value == "undefined")
                    return [{}];
                return typeof value == "string" ? parseBoxShadow(value) : value;
            };
            question.valueToDataCallback = function (value) {
                if (!value)
                    return "";
                if (typeof value == "string") {
                    return value;
                }
                else {
                    return createBoxShadow(Array.isArray(value) ? value : [value]);
                }
            };
            question.contentQuestion.panels.forEach(function (p) { return p.questions.forEach(function (q) { return q.allowRootStyle = false; }); });
        },
    });
}
function updateShadowEffectsJSON() {
    var config = survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.getCustomQuestionByName("shadoweffects");
    config.json.questionJSON = getQuestionJSON();
}
function createBoxShadow(value) {
    if (!Array.isArray(value))
        return undefined;
    var hasValue = false;
    value.forEach(function (val) { for (var key in val) {
        hasValue = true;
    } });
    if (!hasValue)
        return undefined;
    return value.map((function (val) { var _a, _b, _c, _d, _e; return "".concat(val.isInset == true ? "inset " : "").concat((_a = val.x) !== null && _a !== void 0 ? _a : 0, "px ").concat((_b = val.y) !== null && _b !== void 0 ? _b : 0, "px ").concat((_c = val.blur) !== null && _c !== void 0 ? _c : 0, "px ").concat((_d = val.spread) !== null && _d !== void 0 ? _d : 0, "px ").concat((_e = val.color) !== null && _e !== void 0 ? _e : "#000000"); })).join(",");
}
function createBoxShadowReset(value) {
    var resetValue = parseBoxShadow(value);
    resetValue.forEach(function (valueItem) {
        valueItem.x = 0;
        valueItem.y = 0;
        valueItem.blur = 0;
        valueItem.spread = 0;
    });
    return createBoxShadow(resetValue);
}
function parseBoxShadow(value) {
    if (value === void 0) { value = ""; }
    return value.split(/,(?![^(]*\))/).map(function (value) {
        var color = value.match(/#[a-zA-Z0-9]+|rgba?\(.*?\)/);
        var isInset = value.indexOf("inset") > -1;
        var res = {};
        if (isInset) {
            value = value.replace("inset", "");
        }
        if (!!color) {
            res["color"] = color[0];
        }
        var values = value.replace(/\s+/g, " ").replace(/^\s|\s$/g, "").split(" ");
        res["x"] = parseInt(values[0]) || 0;
        res["y"] = parseInt(values[1]) || 0;
        res["blur"] = parseInt(values[2]) || 0;
        res["spread"] = parseInt(values[3]) || 0;
        res["isInset"] = isInset;
        return res;
    });
}
function trimBoxShadowValue(value) {
    if (!value)
        return value;
    return value.replace(/\)\,\s/g, "),");
}


/***/ }),

/***/ "./src/components/tabs/theme-model-definition.ts":
/*!*******************************************************!*\
  !*** ./src/components/tabs/theme-model-definition.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ThemeModelEditorDefinition: () => (/* binding */ ThemeModelEditorDefinition),
/* harmony export */   themeModelPropertyGridDefinition: () => (/* binding */ themeModelPropertyGridDefinition)
/* harmony export */ });
var themeModelProperties = {
    "theme": {
        properties: [
            { name: "header", tab: "header" },
            { name: "--sjs-general-backcolor-dim", tab: "background" },
            { name: "backgroundImage", tab: "background" },
            { name: "backgroundImageFit", tab: "background" },
            { name: "backgroundImageAttachment", tab: "background" },
            { name: "backgroundOpacity", tab: "background" },
            { name: "primaryColor", tab: "appearancecolor" },
            { name: "panelBackgroundTransparency", tab: "appearancecolor" },
            { name: "questionBackgroundTransparency", tab: "appearancecolor" },
            { name: "--sjs-primary-backcolor", tab: "appearanceprimarycolor" },
            { name: "--sjs-primary-backcolor-dark", tab: "appearanceprimarycolor" },
            { name: "--sjs-primary-backcolor-light", tab: "appearanceprimarycolor" },
            { name: "--sjs-primary-forecolor", tab: "appearanceprimarycolor" },
            { name: "--sjs-primary-forecolor-light", tab: "appearanceprimarycolor" },
            { name: "--sjs-special-red", tab: "appearanceprimarycolor" },
            { name: "--sjs-special-red-light", tab: "appearanceprimarycolor" },
            { name: "--sjs-font-family", tab: "appearancefont" },
            { name: "fontSize", tab: "appearancefont" },
            { name: "scale", tab: "appearanceother" },
            { name: "cornerRadius", tab: "appearanceother" },
            { name: "advancedMode", tab: "appearanceadvancedmode" },
            { name: "pageTitle", tab: "appearancepage" },
            { name: "pageDescription", tab: "appearancepage" },
            { name: "questionPanel", tab: "appearancequestion" },
            { name: "--sjs-shadow-small", tab: "appearancequestion" },
            { name: "questionTitle", tab: "appearancequestion" },
            { name: "questionDescription", tab: "appearancequestion" },
            { name: "editorPanel", tab: "appearanceinput" },
            { name: "--sjs-shadow-inner", tab: "appearanceinput" },
            { name: "editorFont", tab: "appearanceinput" },
            { name: "--sjs-border-default", tab: "appearancelines" },
            { name: "--sjs-border-light", tab: "appearancelines" },
        ],
        tabs: [
            { name: "header", index: 100 },
            { name: "background", index: 200 },
            { name: "appearance", index: 300 },
            { name: "appearancecolor", parent: "appearance", index: 100 },
            { name: "appearancefont", parent: "appearance", index: 200 },
            { name: "appearanceother", parent: "appearance", index: 300 },
            { name: "appearanceadvancedmode", parent: "appearance", index: 350 },
            { name: "appearanceprimarycolor", parent: "appearance", index: 400 },
            { name: "appearancepage", parent: "appearance", index: 500 },
            { name: "appearancequestion", parent: "appearance", index: 600 },
            { name: "appearanceinput", parent: "appearance", index: 700 },
            { name: "appearancelines", parent: "appearance", index: 800 },
        ]
    },
    "header@header": {
        properties: [
            { name: "headerView" },
            { name: "logoPosition" },
            { name: "surveyTitle" },
            { name: "surveyDescription" },
            { name: "height", tab: "layout" },
            { name: "mobileHeight", tab: "layout" },
            { name: "inheritWidthFrom", tab: "layout" },
            { name: "textAreaWidth", tab: "layout" },
            { name: "backgroundColorSwitch", tab: "background" },
            { name: "backgroundColor", tab: "background" },
            { name: "backgroundImage", tab: "background" },
            { name: "backgroundImageFit", tab: "background" },
            { name: "backgroundImageOpacity", tab: "background" },
            { name: "overlapEnabled", tab: "background" },
            { name: "headerTitle", tab: "header" },
            { name: "headerDescription", tab: "header" },
            { name: "logoPositionX", tab: "positions" },
            { name: "logoPositionY", tab: "positions" },
            { name: "titlePositionX", tab: "positions" },
            { name: "titlePositionY", tab: "positions" },
            { name: "descriptionPositionX", tab: "positions" },
            { name: "descriptionPositionY", tab: "positions" },
        ],
        tabs: [
            { name: "settings" },
            { name: "layout", parent: "settings", index: 100 },
            { name: "background", parent: "settings", index: 200 },
            { name: "header", parent: "settings", index: 300 },
            { name: "positions", parent: "settings", index: 400 },
        ]
    },
};
var themeModelPropertyGridDefinition = {
    autoGenerateProperties: true,
    classes: themeModelProperties
};
var ThemeModelEditorDefinition = /** @class */ (function () {
    function ThemeModelEditorDefinition() {
    }
    ThemeModelEditorDefinition.definition = themeModelProperties;
    return ThemeModelEditorDefinition;
}());



/***/ }),

/***/ "./src/components/tabs/theme-model.ts":
/*!********************************************!*\
  !*** ./src/components/tabs/theme-model.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   HeaderModel: () => (/* reexport safe */ _header_model__WEBPACK_IMPORTED_MODULE_8__.HeaderModel),
/* harmony export */   ThemeModel: () => (/* binding */ ThemeModel),
/* harmony export */   findSuitableTheme: () => (/* binding */ findSuitableTheme),
/* harmony export */   getObjectDiffs: () => (/* binding */ getObjectDiffs),
/* harmony export */   getThemeChanges: () => (/* binding */ getThemeChanges),
/* harmony export */   getThemeFullName: () => (/* binding */ getThemeFullName),
/* harmony export */   isThemeEmpty: () => (/* binding */ isThemeEmpty)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _themes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./themes */ "./src/components/tabs/themes.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./theme-custom-questions/font-settings */ "./src/components/tabs/theme-custom-questions/font-settings.ts");
/* harmony import */ var _theme_custom_questions_background_corner_radius__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./theme-custom-questions/background-corner-radius */ "./src/components/tabs/theme-custom-questions/background-corner-radius.ts");
/* harmony import */ var _theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./theme-custom-questions/shadow-effects */ "./src/components/tabs/theme-custom-questions/shadow-effects.ts");
/* harmony import */ var _header_model__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./header-model */ "./src/components/tabs/header-model.ts");
/* harmony import */ var survey_core_themes__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! survey-core/themes */ "survey-core/themes");
/* harmony import */ var survey_core_themes__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(survey_core_themes__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _plugins_undo_redo_undo_redo_manager__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../plugins/undo-redo/undo-redo-manager */ "./src/plugins/undo-redo/undo-redo-manager.ts");
/* harmony import */ var _theme_custom_questions__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./theme-custom-questions */ "./src/components/tabs/theme-custom-questions/index.ts");














Object.keys(survey_core_themes__WEBPACK_IMPORTED_MODULE_9__ || {}).forEach(function (libraryThemeName) {
    var libraryTheme = survey_core_themes__WEBPACK_IMPORTED_MODULE_9__[libraryThemeName];
    var creatorThemeVariables = {};
    var creatorTheme = {};
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.assign)(creatorThemeVariables, libraryTheme.cssVariables);
    (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.assign)(creatorTheme, libraryTheme, { cssVariables: creatorThemeVariables });
    var creatorThemeName = getThemeFullName(libraryTheme);
    _themes__WEBPACK_IMPORTED_MODULE_3__.Themes[creatorThemeName] = creatorTheme;
});
function getThemeFullName(theme) {
    var themeName = theme.themeName || ThemeModel.DefaultTheme.themeName || "default";
    var fullThemeName = themeName + "-" + (theme.colorPalette || "light");
    if (theme.isPanelless === true) {
        fullThemeName += "-panelless";
    }
    return fullThemeName;
}
function isThemeEmpty(theme) {
    if (!theme) {
        return true;
    }
    var themeProperties = Object.keys(theme);
    return themeProperties.length == 0 || themeProperties.length == 1 && themeProperties[0] == "cssVariables" && Object.keys(theme.cssVariables).length == 0;
}
function findSuitableTheme(themeName, colorPalette, isPanelless, probeThemeFullName) {
    var suitableTheme = _themes__WEBPACK_IMPORTED_MODULE_3__.Themes[probeThemeFullName];
    if (!!suitableTheme) {
        return suitableTheme;
    }
    var appropriateThemeNames = Object.keys(_themes__WEBPACK_IMPORTED_MODULE_3__.Themes).filter(function (fullName) { return fullName.indexOf(themeName + "-") === 0; });
    for (var _i = 0, appropriateThemeNames_1 = appropriateThemeNames; _i < appropriateThemeNames_1.length; _i++) {
        var fullThemeName = appropriateThemeNames_1[_i];
        if (fullThemeName.indexOf(themeName + "-" + colorPalette) === 0) {
            probeThemeFullName = themeName + "-" + colorPalette;
        }
        if (fullThemeName.indexOf(themeName + "-" + colorPalette + (isPanelless ? "-panelless" : "")) === 0) {
            probeThemeFullName = themeName + "-" + colorPalette + (isPanelless ? "-panelless" : "");
        }
    }
    suitableTheme = _themes__WEBPACK_IMPORTED_MODULE_3__.Themes[appropriateThemeNames[0]];
    if (!!suitableTheme) {
        return suitableTheme;
    }
    var defaultNearestThemeFullName = getThemeFullName({ themeName: ThemeModel.DefaultTheme.themeName, colorPalette: colorPalette || "light", isPanelless: isPanelless });
    return _themes__WEBPACK_IMPORTED_MODULE_3__.Themes[defaultNearestThemeFullName] || ThemeModel.DefaultTheme;
}
function getObjectDiffs(obj1, obj2) {
    if (obj2 === void 0) { obj2 = {}; }
    var result = {};
    Object.keys(obj1).forEach(function (key) {
        if (typeof obj1[key] === "object") {
            result[key] = getObjectDiffs(obj1[key], obj2[key]);
        }
        else {
            if (obj1[key] !== undefined && obj1[key] != obj2[key]) {
                result[key] = obj1[key];
            }
        }
    });
    return result;
}
function getThemeChanges(fullTheme, baseTheme) {
    if (!baseTheme) {
        var probeThemeFullName = getThemeFullName(fullTheme);
        baseTheme = findSuitableTheme(fullTheme.themeName, fullTheme.colorPalette, fullTheme.isPanelless, probeThemeFullName);
    }
    var themeChanges = getObjectDiffs(fullTheme, baseTheme);
    Object.keys(themeChanges).forEach(function (propertyName) {
        if (propertyName.toLowerCase().indexOf("background") !== -1) {
            if (themeChanges[propertyName] === "" || themeChanges[propertyName] === survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty("survey", propertyName).defaultValue) {
                delete themeChanges[propertyName];
            }
        }
    });
    themeChanges.themeName = baseTheme.themeName || ThemeModel.DefaultTheme.themeName || "default";
    themeChanges.colorPalette = baseTheme.colorPalette || "light";
    themeChanges.isPanelless = !!baseTheme.isPanelless;
    return themeChanges;
}
var ThemeModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(ThemeModel, _super);
    function ThemeModel() {
        var _this = _super.call(this) || this;
        _this.themeCssVariablesChanges = {};
        _this.colorCalculator = new _utils_utils__WEBPACK_IMPORTED_MODULE_10__.ColorCalculator();
        _this._defaultSessionTheme = ThemeModel.DefaultTheme;
        _this.onThemeSelected = new survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase();
        _this.onThemePropertyChanged = new survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase();
        _this.onAllowModifyTheme = new survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase();
        _this.blockThemeChangedNotifications = 0;
        (0,_theme_custom_questions__WEBPACK_IMPORTED_MODULE_12__.updateCustomQuestionJSONs)();
        _this.setNewHeaderProperty();
        _this.onPropertyValueChangedCallback = function (name, oldValue, newValue, sender, arrayChanges) {
            _this.onThemePropertyValueChangedCallback(name, oldValue, newValue, sender, arrayChanges);
        };
        return _this;
    }
    ThemeModel.prototype.getFullThemeName = function (_themeName) {
        if (this.colorPalette === "light") {
            return _themeName || this.themeName;
        }
        return (_themeName || this.themeName) + "-" + this.colorPalette;
    };
    Object.defineProperty(ThemeModel.prototype, "defaultSessionTheme", {
        get: function () {
            return this._defaultSessionTheme;
        },
        set: function (theme) {
            this._defaultSessionTheme = theme;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeModel.prototype, "cssVariables", {
        get: function () {
            return this.toJSON()["cssVariables"] || {};
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ThemeModel.prototype, "themeCssCustomizations", {
        get: function () {
            var customizations = {};
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.assign)(customizations, this.themeCssVariablesChanges);
            return customizations;
        },
        enumerable: false,
        configurable: true
    });
    ThemeModel.prototype.getType = function () {
        return "theme";
    };
    ThemeModel.prototype.setNewHeaderProperty = function () {
        var header = new _header_model__WEBPACK_IMPORTED_MODULE_8__.HeaderModel();
        header.owner = this;
        this.setPropertyValue("header", header);
    };
    ThemeModel.prototype.hasVariations = function (palette) {
        var themeHasModeVariations = false;
        var themeHasPaletteVariations = false;
        var registeredThemes = Object.keys(_themes__WEBPACK_IMPORTED_MODULE_3__.Themes);
        var themeLight = this.themeName + "-light";
        var themeDark = this.themeName + "-dark";
        if (this.isPanelless) {
            themeLight += "-panelless";
            themeDark += "-panelless";
        }
        themeHasPaletteVariations = registeredThemes.indexOf(themeLight) !== -1 && registeredThemes.indexOf(themeDark) !== -1;
        var themePanels = this.themeName + "-" + this.colorPalette;
        var themePanelless = themePanels + "-panelless";
        themeHasModeVariations = registeredThemes.indexOf(themePanels) !== -1 && registeredThemes.indexOf(themePanelless) !== -1;
        if (palette) {
            return themeHasPaletteVariations;
        }
        else {
            return themeHasModeVariations;
        }
    };
    ThemeModel.prototype.initializeColorCalculator = function (cssVariables) {
        if (!cssVariables["--sjs-primary-backcolor"] ||
            !cssVariables["--sjs-primary-backcolor-light"] ||
            !cssVariables["--sjs-primary-backcolor-dark"]) {
            return;
        }
        this.colorCalculator.initialize(cssVariables["--sjs-primary-backcolor"], cssVariables["--sjs-primary-backcolor-light"], cssVariables["--sjs-primary-backcolor-dark"]);
    };
    ThemeModel.prototype.updatePropertiesDependentOnPrimaryColor = function (value) {
        this.colorCalculator.calculateColors(value);
        this.setPropertyValue("--sjs-primary-backcolor-light", this.colorCalculator.colorSettings.newColorLight);
        this.setPropertyValue("--sjs-primary-backcolor-dark", this.colorCalculator.colorSettings.newColorDark);
        this.setThemeCssVariablesChanges("--sjs-primary-backcolor-light", this.colorCalculator.colorSettings.newColorLight);
        this.setThemeCssVariablesChanges("--sjs-primary-backcolor-dark", this.colorCalculator.colorSettings.newColorDark);
    };
    ThemeModel.prototype.cssVariablePropertiesChanged = function (name, value, property) {
        var nameProcessed = true;
        if (name === "primaryColor") {
            this.setPropertyValue("--sjs-primary-backcolor", value);
            this.setThemeCssVariablesChanges("--sjs-primary-backcolor", value);
            this.updatePropertiesDependentOnPrimaryColor(value);
        }
        else if (name === "--sjs-primary-backcolor") {
            this["primaryColor"] = value;
            this.updatePropertiesDependentOnPrimaryColor(value);
        }
        else if (name === "--sjs-shadow-inner" || name === "--sjs-shadow-small") {
            var newBoxShadowReset = (0,_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_7__.createBoxShadowReset)(value);
            this.setPropertyValue(name + "-reset", newBoxShadowReset);
            this.setThemeCssVariablesChanges(name + "-reset", newBoxShadowReset);
        }
        else if (name == "scale") {
            this.setThemeCssVariablesChanges("--sjs-base-unit", (value * 8 / 100) + "px");
        }
        else if (name == "fontSize") {
            this.setThemeCssVariablesChanges("--sjs-font-size", (value * 16 / 100) + "px");
        }
        else if (name == "cornerRadius") {
            this.setThemeCssVariablesChanges("--sjs-corner-radius", value + "px");
        }
        else if (name === "questionBackgroundTransparency" || name === "editorPanel") {
            var baseColor = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.parseColor)(this.getPropertyValue("--sjs-general-backcolor-dim-light")).color;
            var questionBackgroundTransparencyValue = this.getPropertyValue("questionBackgroundTransparency");
            this.setThemeCssVariablesChanges("--sjs-editor-background", (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.ingectAlpha)(baseColor, questionBackgroundTransparencyValue / 100));
        }
        else if (name === "panelBackgroundTransparency" || name === "questionPanel") {
            var baseColor = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.parseColor)(this.getPropertyValue("--sjs-general-backcolor")).color;
            var panelBackgroundTransparencyValue = this.getPropertyValue("panelBackgroundTransparency");
            this.setThemeCssVariablesChanges("--sjs-question-background", (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.ingectAlpha)(baseColor, panelBackgroundTransparencyValue / 100));
        }
        else {
            nameProcessed = false;
        }
        var typeProcessed = true;
        if (property.type === "font") {
            (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_5__.fontsettingsToCssVariable)(value, property, this.themeCssVariablesChanges);
            this.onThemePropertyChanged.fire(this, { name: name, value: value });
        }
        else if (property.type === "backgroundcornerradius") {
            (0,_theme_custom_questions_background_corner_radius__WEBPACK_IMPORTED_MODULE_6__.backgroundCornerRadiusToCssVariable)(value, property, this.themeCssVariablesChanges);
            this.onThemePropertyChanged.fire(this, { name: name, value: value });
        }
        else {
            typeProcessed = false;
        }
        return nameProcessed || typeProcessed;
    };
    ThemeModel.prototype.setThemeCssVariablesChanges = function (name, value) {
        if (this.themeCssVariablesChanges[name] !== value) {
            this.themeCssVariablesChanges[name] = value;
            this.onThemePropertyChanged.fire(this, { name: name, value: value });
        }
    };
    ThemeModel.prototype.initialize = function (surveyTheme, survey, creator) {
        if (surveyTheme === void 0) { surveyTheme = {}; }
        this._defaultSessionTheme = ThemeModel.DefaultTheme;
        this.backgroundImage = "backgroundImage" in surveyTheme ? surveyTheme.backgroundImage : survey === null || survey === void 0 ? void 0 : survey.backgroundImage;
        this.backgroundImageFit = surveyTheme.backgroundImageFit !== undefined ? surveyTheme.backgroundImageFit : survey === null || survey === void 0 ? void 0 : survey.backgroundImageFit;
        this.backgroundImageAttachment = surveyTheme.backgroundImageAttachment !== undefined ? surveyTheme.backgroundImageAttachment : survey === null || survey === void 0 ? void 0 : survey.backgroundImageAttachment;
        this.backgroundOpacity = ((surveyTheme.backgroundOpacity !== undefined ? surveyTheme.backgroundOpacity : survey === null || survey === void 0 ? void 0 : survey.backgroundOpacity) || 1) * 100;
        this.loadTheme(surveyTheme, creator && creator.preferredColorPalette);
        this.header["logoPosition"] = survey === null || survey === void 0 ? void 0 : survey.logoPosition;
        this.undoRedoManager = new _plugins_undo_redo_undo_redo_manager__WEBPACK_IMPORTED_MODULE_11__.UndoRedoManager();
    };
    Object.defineProperty(ThemeModel.prototype, "header", {
        get: function () {
            return this.getPropertyValue("header");
        },
        set: function (val) {
            if (!val)
                return;
            this.setNewHeaderProperty();
            this.header.fromJSON(val.toJSON());
        },
        enumerable: false,
        configurable: true
    });
    ThemeModel.prototype.loadTheme = function (theme, preferredColorPalette) {
        this.blockThemeChangedNotifications += 1;
        try {
            var probeThemeFullName = getThemeFullName({ themeName: theme.themeName, colorPalette: theme.colorPalette || preferredColorPalette, isPanelless: theme.isPanelless });
            var baseTheme = findSuitableTheme(theme.themeName, theme.colorPalette || preferredColorPalette, theme.isPanelless, probeThemeFullName);
            var themeChanges = getThemeChanges(theme, baseTheme);
            this.themeName = themeChanges.themeName;
            this.colorPalette = themeChanges.colorPalette;
            this.isPanelless = themeChanges.isPanelless;
            this.backgroundImage = theme.backgroundImage || this.backgroundImage;
            this.backgroundImageFit = theme.backgroundImageFit || this.backgroundImageFit;
            this.backgroundImageAttachment = theme.backgroundImageAttachment || this.backgroundImageAttachment;
            var effectiveThemeCssVariables = {};
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.assign)(effectiveThemeCssVariables, ThemeModel.DefaultTheme.cssVariables || {}, baseTheme.cssVariables || {});
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.assign)(effectiveThemeCssVariables, theme.cssVariables || {}, this.themeCssVariablesChanges);
            var effectiveTheme = {
                backgroundImage: this.backgroundImage || baseTheme.backgroundImage || "",
                backgroundImageFit: this.backgroundImageFit || baseTheme.backgroundImageFit,
                backgroundImageAttachment: this.backgroundImageAttachment || baseTheme.backgroundImageAttachment,
                backgroundOpacity: (this.backgroundOpacity / 100) || baseTheme.backgroundOpacity,
            };
            var effectiveHeader = {};
            if (Object.keys(effectiveHeader).length > 0) {
                effectiveTheme.header = effectiveHeader;
            }
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.assign)(effectiveTheme, theme, { cssVariables: effectiveThemeCssVariables, themeName: this.themeName, colorPalette: this.colorPalette, isPanelless: this.isPanelless });
            this.initializeColorCalculator(effectiveTheme.cssVariables);
            this.fromJSON(effectiveTheme);
        }
        finally {
            this.blockThemeChangedNotifications -= 1;
        }
    };
    ThemeModel.prototype.resetTheme = function () {
        this.setTheme({
            themeName: this.defaultSessionTheme.themeName,
            isPanelless: this.defaultSessionTheme.isPanelless,
            colorPalette: this.defaultSessionTheme.colorPalette
        });
    };
    ThemeModel.prototype.setTheme = function (theme) {
        var _this = this;
        var headerBackgroundColorValue = this.themeCssVariablesChanges["--sjs-header-backcolor"];
        this.themeCssVariablesChanges = {};
        if (headerBackgroundColorValue !== undefined) {
            this.themeCssVariablesChanges["--sjs-header-backcolor"] = headerBackgroundColorValue;
        }
        try {
            this.blockThemeChangedNotifications += 1;
            this.iteratePropertiesHash(function (hash, key) {
                _this.setPropertyValue(key, undefined);
            });
            this.setNewHeaderProperty();
        }
        finally {
            this.blockThemeChangedNotifications -= 1;
        }
        this.loadTheme(theme);
        this.onThemeSelected.fire(this, { theme: this.toJSON() });
    };
    ThemeModel.prototype.selectTheme = function (themeName, colorPalette, themeMode) {
        if (colorPalette === void 0) { colorPalette = "light"; }
        if (themeMode === void 0) { themeMode = "panels"; }
        this.themeName = themeName;
        this.colorPalette = colorPalette;
        this.isPanelless = themeMode === "lightweight";
        var theme = this.findSuitableTheme(themeName);
        this.setTheme(theme);
    };
    ThemeModel.prototype.generalPropertiesChanged = function (name, value) {
        var _a;
        if (["themeName", "isPanelless", "colorPalette"].indexOf(name) !== -1) {
            if (name === "themeName") {
                this.loadTheme(this.findSuitableTheme(value) || (_a = {}, _a[name] = value, _a.isPanelless = this.isPanelless, _a.colorPalette = this.colorPalette, _a));
            }
            if (name === "isPanelless") {
                this.loadTheme({ themeName: this.themeName, isPanelless: value, colorPalette: this.colorPalette });
            }
            if (name === "colorPalette") {
                this.loadTheme({ themeName: this.themeName, isPanelless: this.isPanelless, colorPalette: value });
            }
            this.onThemeSelected.fire(this, { theme: this.toJSON() });
            return true;
        }
        return false;
    };
    ThemeModel.prototype.onThemePropertyValueChangedCallback = function (name, oldValue, newValue, sender, arrayChanges) {
        var _this = this;
        if (!!this.undoRedoManager) {
            if (this.blockThemeChangedNotifications == 0) {
                this.undoRedoManager.startTransaction(name + " changed");
            }
            this.undoRedoManager.onPropertyValueChanged(name, oldValue, newValue, sender, arrayChanges);
        }
        if (this.blockThemeChangedNotifications > 0)
            return;
        var processedInternally = false;
        if (this !== sender) {
            var senderJSON_1 = sender.toJSON();
            if (!!senderJSON_1.cssVariables) {
                Object.keys(senderJSON_1.cssVariables).forEach(function (key) { return _this.setThemeCssVariablesChanges(key, senderJSON_1.cssVariables[key]); });
            }
            this.onThemePropertyChanged.fire(this, { name: name, value: newValue });
            processedInternally = true;
        }
        if (name.indexOf("--") === 0) {
            this.setThemeCssVariablesChanges(name, newValue);
            processedInternally = true;
        }
        if (this.generalPropertiesChanged(name, newValue)) {
            if (!!this.undoRedoManager && this.blockThemeChangedNotifications == 0) {
                this.undoRedoManager.stopTransaction();
            }
            return;
        }
        this.blockThemeChangedNotifications += 1;
        if (this === sender && ["backgroundImage", "backgroundImageFit", "backgroundImageAttachment", "backgroundOpacity"].indexOf(name) !== -1) {
            this[name] = newValue;
            this.onThemePropertyChanged.fire(this, { name: name, value: newValue });
            this.blockThemeChangedNotifications -= 1;
            if (!!this.undoRedoManager && this.blockThemeChangedNotifications == 0) {
                this.undoRedoManager.stopTransaction();
            }
            return;
        }
        if (this.cssVariablePropertiesChanged(name, newValue, sender.getPropertyByName(name))) {
            processedInternally = true;
        }
        if (!processedInternally) {
            this.onThemePropertyChanged.fire(this, { name: name, value: newValue });
        }
        this.blockThemeChangedNotifications -= 1;
        if (!!this.undoRedoManager && this.blockThemeChangedNotifications == 0) {
            this.undoRedoManager.stopTransaction();
        }
    };
    ThemeModel.prototype.findSuitableTheme = function (themeName) {
        var probeThemeFullName = getThemeFullName({ themeName: themeName, colorPalette: this.colorPalette, isPanelless: this.isPanelless });
        return findSuitableTheme(themeName, this.colorPalette, this.isPanelless, probeThemeFullName);
    };
    ThemeModel.prototype.fromJSON = function (json, options) {
        var _this = this;
        if (!json)
            return;
        var _json = {};
        (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.assign)(_json, json);
        delete _json["header"];
        delete _json["cssVariables"];
        _super.prototype.fromJSON.call(this, _json, options);
        var _headerJson = {};
        (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.assign)(_headerJson, json.header);
        if (!!json["headerView"])
            _headerJson["headerView"] = json["headerView"];
        this.header.fromJSON(_headerJson || {});
        if (json.cssVariables) {
            this["primaryColor"] = json.cssVariables["--sjs-primary-backcolor"];
            _super.prototype.fromJSON.call(this, json.cssVariables, options);
            this.header.setCssVariables(json.cssVariables);
            this.scale = !!this["--sjs-base-unit"] ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.roundTo2Decimals)(parseFloat(this["--sjs-base-unit"]) * 100 / 8) : undefined;
            this.fontSize = !!this["--sjs-font-size"] ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.roundTo2Decimals)(parseFloat(this["--sjs-font-size"]) * 100 / 16) : undefined;
            this.cornerRadius = this["--sjs-corner-radius"] ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.roundTo2Decimals)(parseFloat(this["--sjs-corner-radius"])) : undefined;
            if (!!json["backgroundOpacity"])
                this.backgroundOpacity = json["backgroundOpacity"] * 100;
            this["questionPanel"] = (0,_theme_custom_questions_background_corner_radius__WEBPACK_IMPORTED_MODULE_6__.backgroundCornerRadiusFromCssVariable)(this.getPropertyByName("questionPanel"), json.cssVariables, "--sjs-general-backcolor", "--sjs-general-backcolor-dark", this.cornerRadius);
            this["editorPanel"] = (0,_theme_custom_questions_background_corner_radius__WEBPACK_IMPORTED_MODULE_6__.backgroundCornerRadiusFromCssVariable)(this.getPropertyByName("editorPanel"), json.cssVariables, "--sjs-general-backcolor-dim-light", "--sjs-general-backcolor-dim-dark", this.cornerRadius);
            survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.getProperties("theme").forEach(function (property) {
                if (property.type === "font") {
                    _this[property.name] = (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_5__.fontsettingsFromCssVariable)(property, json.cssVariables);
                }
            });
            this["pageTitle"] = (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_5__.fontsettingsFromCssVariable)(this.getPropertyByName("pageTitle"), json.cssVariables, "--sjs-general-dim-forecolor");
            this["pageDescription"] = (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_5__.fontsettingsFromCssVariable)(this.getPropertyByName("pageDescription"), json.cssVariables, "--sjs-general-dim-forecolor-light");
            this["questionTitle"] = (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_5__.fontsettingsFromCssVariable)(this.getPropertyByName("questionTitle"), json.cssVariables, "--sjs-general-forecolor");
            this["questionDescription"] = (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_5__.fontsettingsFromCssVariable)(this.getPropertyByName("questionDescription"), json.cssVariables, "--sjs-general-forecolor-light");
            this["editorFont"] = (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_5__.fontsettingsFromCssVariable)(this.getPropertyByName("editorFont"), json.cssVariables, "--sjs-general-forecolor", "--sjs-general-forecolor-light");
        }
    };
    ThemeModel.prototype.toJSON = function (options) {
        var _this = this;
        if (this.scale !== undefined) {
            this["--sjs-base-unit"] = (this.scale * 8 / 100) + "px";
        }
        if (this.fontSize !== undefined) {
            this["--sjs-font-size"] = (this.fontSize * 16 / 100) + "px";
        }
        if (this.cornerRadius !== undefined) {
            this["--sjs-corner-radius"] = this.cornerRadius + "px";
        }
        var result = _super.prototype.toJSON.call(this, options);
        result["backgroundImage"] = this.backgroundImage || "";
        result["backgroundOpacity"] = this.backgroundOpacity / 100;
        result["backgroundImageAttachment"] = this.backgroundImageAttachment;
        result["backgroundImageFit"] = this.backgroundImageFit;
        var cssVariables = {};
        Object.keys(result).forEach(function (key) {
            if (key.indexOf("--") == 0) {
                cssVariables[key] = result[key];
                delete result[key];
            }
            else if (typeof result[key] === "object") {
                var property_1 = _this.getPropertyByName(key);
                if (property_1.type === "font") {
                    (0,_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_5__.fontsettingsToCssVariable)(result[key], property_1, cssVariables);
                    delete result[key];
                }
                if (property_1.type === "backgroundcornerradius") {
                    (0,_theme_custom_questions_background_corner_radius__WEBPACK_IMPORTED_MODULE_6__.backgroundCornerRadiusToCssVariable)(result[key], property_1, cssVariables);
                    delete result[key];
                }
            }
        });
        result.cssVariables = cssVariables;
        this.header.saveToThemeJSON(result, options);
        return result;
    };
    ThemeModel.DefaultTheme = _themes__WEBPACK_IMPORTED_MODULE_3__.Themes["default-light"] || {};
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ThemeModel.prototype, "backgroundImage", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ThemeModel.prototype, "backgroundImageFit", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ThemeModel.prototype, "backgroundImageAttachment", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ThemeModel.prototype, "backgroundOpacity", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ThemeModel.prototype, "themeName", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ThemeModel.prototype, "colorPalette", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ThemeModel.prototype, "isPanelless", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ThemeModel.prototype, "groupAppearanceAdvancedMode", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (newValue, target) {
                var basecolor = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.parseColor)(target.questionPanel.backcolor).color;
                var newColor = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.ingectAlpha)(basecolor, newValue / 100);
                if (target.questionPanel.backcolor !== newColor) {
                    var newQuestionPanel = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, target.questionPanel);
                    newQuestionPanel.backcolor = newColor;
                    target.questionPanel = newQuestionPanel;
                }
            }
        })
    ], ThemeModel.prototype, "panelBackgroundTransparency", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (newValue, target) {
                var basecolor = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.parseColor)(target.editorPanel.backcolor).color;
                var newColor = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.ingectAlpha)(basecolor, newValue / 100);
                if (target.editorPanel.backcolor !== newColor) {
                    var newEditorPanel = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, target.editorPanel);
                    newEditorPanel.backcolor = newColor;
                    target.editorPanel = newEditorPanel;
                }
            }
        })
    ], ThemeModel.prototype, "questionBackgroundTransparency", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ThemeModel.prototype, "scale", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ThemeModel.prototype, "cornerRadius", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ThemeModel.prototype, "fontSize", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (newValue, target) {
                var opacity = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.parseColor)(newValue.backcolor).opacity;
                if (target.panelBackgroundTransparency !== opacity) {
                    target.panelBackgroundTransparency = opacity;
                }
            }
        })
    ], ThemeModel.prototype, "questionPanel", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (newValue, target) {
                var opacity = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_10__.parseColor)(newValue.backcolor).opacity;
                if (target.questionBackgroundTransparency !== opacity) {
                    target.questionBackgroundTransparency = opacity;
                }
            }
        })
    ], ThemeModel.prototype, "editorPanel", void 0);
    return ThemeModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));

survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addClass("theme", [
    {
        type: "dropdown",
        name: "themeName",
        choices: _themes__WEBPACK_IMPORTED_MODULE_3__.PredefinedThemes.map(function (theme) { return ({ value: theme, text: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.names." + theme) }); }),
        category: "general",
    }, {
        type: "buttongroup",
        name: "colorPalette",
        displayName: "",
        choices: [
            { value: "light" },
            { value: "dark" }
        ],
        category: "general",
        enableIf: function (obj) {
            return !obj || obj.hasVariations(true);
        },
    }, {
        type: "buttongroup",
        name: "isPanelless",
        choices: [
            { value: false },
            { value: true }
        ],
        category: "general",
        enableIf: function (obj) {
            return !obj || obj.hasVariations(false);
        },
    },
    {
        type: "spinedit",
        isSerializable: false,
        name: "scale",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "%";
                editor.min = 0;
                editor.step = 5;
            }
        }
    }, {
        type: "spinedit",
        isSerializable: false,
        name: "cornerRadius",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "px";
                editor.min = 0;
            }
        }
    }, {
        name: "advancedMode",
        type: "switchToggle",
        isSerializable: false,
        default: false,
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.titleLocation = "hidden";
                editor.renderAs = "switch";
            }
        }
    }, {
        type: "spinedit",
        isSerializable: false,
        name: "fontSize",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "%";
                editor.min = 0;
                editor.step = 5;
            }
        }
    },
    {
        type: "spinedit",
        isSerializable: false,
        name: "panelBackgroundTransparency",
        default: 100,
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "%";
                editor.min = 0;
                editor.max = 100;
                editor.step = 5;
            }
        }
    }, {
        type: "spinedit",
        isSerializable: false,
        name: "questionBackgroundTransparency",
        default: 100,
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "%";
                editor.min = 0;
                editor.max = 100;
                editor.step = 5;
            }
        }
    },
    {
        type: "backgroundcornerradius",
        name: "editorPanel",
    }, {
        type: "backgroundcornerradius",
        name: "questionPanel",
    },
], function (json) { return new ThemeModel(); });
survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addProperties("theme", [{
        name: "backgroundImage:file",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.storeDataAsText = false;
                editor.acceptedTypes = "image/*";
            }
        }
    }, {
        name: "backgroundImageFit",
        displayName: "",
        enableIf: function (obj) {
            return !!obj.backgroundImage;
        },
        choices: [
            { value: "auto" },
            { value: "contain" },
            { value: "cover" }
        ],
        default: "cover",
    }, {
        name: "backgroundImageAttachment",
        displayName: "",
        enableIf: function (obj) {
            return !!obj.backgroundImage;
        },
        choices: [
            { value: "fixed" },
            { value: "scroll" }
        ],
        default: "scroll",
    }, {
        type: "spinedit",
        isSerializable: false,
        name: "backgroundOpacity",
        enableIf: function (obj) {
            return !!obj.backgroundImage;
        },
        default: 100,
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "%";
                editor.min = 0;
                editor.max = 100;
                editor.step = 5;
                editor.titleLocation = "left";
            }
        }
    }, {
        type: "header",
        name: "header",
        isSerializable: false,
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                var questions = editor.contentPanel.elements;
                var callback_1 = function (editor) {
                    if (editor.getType() === "panel") {
                        editor["elements"].forEach(function (el) {
                            callback_1(el);
                        });
                    }
                    var obj = editor.obj;
                    if (!obj)
                        return;
                    var property = editor.property;
                    if (!!property && property.onPropertyEditorUpdate) {
                        property.onPropertyEditorUpdate(obj, editor);
                    }
                };
                questions.forEach(function (question) {
                    callback_1(question);
                });
            }
        }
    }, {
        type: "color",
        isSerializable: false,
        name: "primaryColor",
    }, {
        type: "dropdown",
        name: "--sjs-font-family",
        default: _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.themeEditor.defaultFontFamily,
        choices: [].concat(_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_5__.DefaultFonts),
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.allowClear = false;
                editor.choices = [].concat(_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_5__.DefaultFonts);
            }
        }
    },
    {
        name: "--sjs-font-size", visible: false,
        default: "16px",
    },
    { name: "--sjs-corner-radius", visible: false },
    { name: "--sjs-base-unit", visible: false },
    { name: "--sjs-corner-radius", visible: false },
    {
        type: "font",
        name: "pageTitle",
        default: {
            family: _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.themeEditor.defaultFontFamily,
            weight: "700",
            size: 24
        },
    }, {
        type: "font",
        name: "pageDescription",
        default: {
            family: _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.themeEditor.defaultFontFamily,
            weight: "700",
            size: 24
        },
    }, {
        type: "shadoweffects",
        name: "--sjs-shadow-small",
        onSetValue: function (obj, value) {
            obj.setPropertyValue("--sjs-shadow-small", (0,_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_7__.trimBoxShadowValue)(value));
        },
    }, {
        type: "font",
        name: "questionTitle",
        default: {
            family: _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.themeEditor.defaultFontFamily,
            weight: "600",
            size: 16,
        },
    }, {
        type: "font",
        name: "questionDescription",
        default: {
            family: _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.themeEditor.defaultFontFamily,
            weight: "400",
            size: 16
        },
    },
    {
        type: "shadoweffects",
        name: "--sjs-shadow-inner",
        onSetValue: function (obj, value) {
            obj.setPropertyValue("--sjs-shadow-inner", (0,_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_7__.trimBoxShadowValue)(value));
        },
    }, {
        type: "font",
        name: "editorFont",
        default: {
            family: _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.themeEditor.defaultFontFamily,
            weight: "400",
            size: 16
        },
    }, {
        type: "coloralpha",
        name: "--sjs-border-default",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.colorTitle = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.borderDefault");
                editor.colorTitleLocation = "left";
            }
        }
    },
    {
        type: "coloralpha",
        name: "--sjs-border-light",
        displayName: "",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.colorTitle = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.borderLight");
                editor.colorTitleLocation = "left";
            }
        }
    },
    { name: "--sjs-general-backcolor", visible: false },
    { name: "--sjs-general-backcolor-dark", visible: false },
    { name: "--sjs-general-backcolor-dim-light", visible: false },
    { name: "--sjs-general-backcolor-dim-dark", visible: false },
    { name: "--sjs-general-forecolor", visible: false },
    { name: "--sjs-general-forecolor-light", visible: false },
    { name: "--sjs-general-dim-forecolor", visible: false },
    { name: "--sjs-general-dim-forecolor-light", visible: false },
    { name: "--sjs-secondary-backcolor", visible: false },
    { name: "--sjs-secondary-backcolor-light", visible: false },
    { name: "--sjs-secondary-backcolor-semi-light", visible: false },
    { name: "--sjs-secondary-forecolor", visible: false },
    { name: "--sjs-secondary-forecolor-light", visible: false },
    {
        name: "--sjs-shadow-small-reset",
        visible: false,
        onSetValue: function (obj, value) {
            obj.setPropertyValue("--sjs-shadow-small-reset", (0,_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_7__.trimBoxShadowValue)(value));
        },
    },
    {
        name: "--sjs-shadow-medium",
        visible: false,
        onSetValue: function (obj, value) {
            obj.setPropertyValue("--sjs-shadow-medium", (0,_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_7__.trimBoxShadowValue)(value));
        },
    },
    {
        name: "--sjs-shadow-large",
        visible: false,
        onSetValue: function (obj, value) {
            obj.setPropertyValue("--sjs-shadow-large", (0,_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_7__.trimBoxShadowValue)(value));
        },
    },
    {
        name: "--sjs-shadow-inner-reset",
        visible: false,
        onSetValue: function (obj, value) {
            obj.setPropertyValue("--sjs-shadow-inner-reset", (0,_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_7__.trimBoxShadowValue)(value));
        },
    },
    { name: "--sjs-border-light", visible: false },
    { name: "--sjs-border-default", visible: false },
    { name: "--sjs-border-inside", visible: false },
    { name: "--sjs-special-red-forecolor", visible: false },
    { name: "--sjs-special-green", visible: false },
    { name: "--sjs-special-green-light", visible: false },
    { name: "--sjs-special-green-forecolor", visible: false },
    { name: "--sjs-special-blue", visible: false },
    { name: "--sjs-special-blue-light", visible: false },
    { name: "--sjs-special-blue-forecolor", visible: false },
    { name: "--sjs-special-yellow", visible: false },
    { name: "--sjs-special-yellow-light", visible: false },
    { name: "--sjs-special-yellow-forecolor", visible: false },
    { name: "--sjs-article-font-xx-large-textDecoration", visible: false },
    { name: "--sjs-article-font-xx-large-fontWeight", visible: false },
    { name: "--sjs-article-font-xx-large-fontStyle", visible: false },
    { name: "--sjs-article-font-xx-large-fontStretch", visible: false },
    { name: "--sjs-article-font-xx-large-letterSpacing", visible: false },
    { name: "--sjs-article-font-xx-large-lineHeight", visible: false },
    { name: "--sjs-article-font-xx-large-paragraphIndent", visible: false },
    { name: "--sjs-article-font-xx-large-textCase", visible: false },
    { name: "--sjs-article-font-x-large-textDecoration", visible: false },
    { name: "--sjs-article-font-x-large-fontWeight", visible: false },
    { name: "--sjs-article-font-x-large-fontStyle", visible: false },
    { name: "--sjs-article-font-x-large-fontStretch", visible: false },
    { name: "--sjs-article-font-x-large-letterSpacing", visible: false },
    { name: "--sjs-article-font-x-large-lineHeight", visible: false },
    { name: "--sjs-article-font-x-large-paragraphIndent", visible: false },
    { name: "--sjs-article-font-x-large-textCase", visible: false },
    { name: "--sjs-article-font-large-textDecoration", visible: false },
    { name: "--sjs-article-font-large-fontWeight", visible: false },
    { name: "--sjs-article-font-large-fontStyle", visible: false },
    { name: "--sjs-article-font-large-fontStretch", visible: false },
    { name: "--sjs-article-font-large-letterSpacing", visible: false },
    { name: "--sjs-article-font-large-lineHeight", visible: false },
    { name: "--sjs-article-font-large-paragraphIndent", visible: false },
    { name: "--sjs-article-font-large-textCase", visible: false },
    { name: "--sjs-article-font-medium-textDecoration", visible: false },
    { name: "--sjs-article-font-medium-fontWeight", visible: false },
    { name: "--sjs-article-font-medium-fontStyle", visible: false },
    { name: "--sjs-article-font-medium-fontStretch", visible: false },
    { name: "--sjs-article-font-medium-letterSpacing", visible: false },
    { name: "--sjs-article-font-medium-lineHeight", visible: false },
    { name: "--sjs-article-font-medium-paragraphIndent", visible: false },
    { name: "--sjs-article-font-medium-textCase", visible: false },
    { name: "--sjs-article-font-default-textDecoration", visible: false },
    { name: "--sjs-article-font-default-fontWeight", visible: false },
    { name: "--sjs-article-font-default-fontStyle", visible: false },
    { name: "--sjs-article-font-default-fontStretch", visible: false },
    { name: "--sjs-article-font-default-letterSpacing", visible: false },
    { name: "--sjs-article-font-default-lineHeight", visible: false },
    { name: "--sjs-article-font-default-paragraphIndent", visible: false },
    { name: "--sjs-article-font-default-textCase", visible: false },
    {
        type: "color",
        name: "--sjs-general-backcolor-dim",
    },
    {
        type: "coloralpha",
        name: "--sjs-primary-backcolor",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.colorTitle = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.primaryDefaultColor");
                editor.colorTitleLocation = "left";
            }
        }
    }, {
        type: "coloralpha",
        name: "--sjs-primary-backcolor-dark",
        displayName: "",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.colorTitle = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.primaryDarkColor");
                editor.colorTitleLocation = "left";
            }
        }
    }, {
        type: "coloralpha",
        name: "--sjs-primary-backcolor-light",
        displayName: "",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.colorTitle = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.primaryLightColor");
                editor.colorTitleLocation = "left";
            }
        }
    }, {
        type: "coloralpha",
        name: "--sjs-primary-forecolor",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.colorTitle = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.primaryForecolor");
                editor.colorTitleLocation = "left";
            }
        }
    }, {
        type: "coloralpha",
        name: "--sjs-primary-forecolor-light",
        displayName: "",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.colorTitle = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.primaryForecolorLight");
                editor.colorTitleLocation = "left";
            }
        }
    }, {
        type: "coloralpha",
        name: "--sjs-special-red",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.colorTitle = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.fontColor");
                editor.colorTitleLocation = "left";
            }
        }
    }, {
        type: "coloralpha",
        name: "--sjs-special-red-light",
        displayName: "",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.colorTitle = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.backgroundColor");
                editor.colorTitleLocation = "left";
            }
        }
    },
]);


/***/ }),

/***/ "./src/components/tabs/theme-plugin.ts":
/*!*********************************************!*\
  !*** ./src/components/tabs/theme-plugin.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ThemeTabPlugin: () => (/* binding */ ThemeTabPlugin)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _theme_builder__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./theme-builder */ "./src/components/tabs/theme-builder.ts");
/* harmony import */ var _themes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./themes */ "./src/components/tabs/themes.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _property_grid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../property-grid */ "./src/property-grid/index.ts");
/* harmony import */ var _property_grid_property_grid_view_model__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../property-grid/property-grid-view-model */ "./src/property-grid/property-grid-view-model.ts");
/* harmony import */ var _theme_model__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./theme-model */ "./src/components/tabs/theme-model.ts");
/* harmony import */ var _switcher_switcher__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../switcher/switcher */ "./src/components/switcher/switcher.ts");
/* harmony import */ var _theme_model_definition__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./theme-model-definition */ "./src/components/tabs/theme-model-definition.ts");
/* harmony import */ var _property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../../property-grid-theme/property-grid */ "./src/property-grid-theme/property-grid.ts");
/* harmony import */ var _side_bar_tab_control_model__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../side-bar/tab-control-model */ "./src/components/side-bar/tab-control-model.ts");
/* harmony import */ var _property_grid_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../../property-grid/icons */ "./src/property-grid/icons.ts");
/* harmony import */ var _utils_actions__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../../utils/actions */ "./src/utils/actions.ts");















/**
 * An object that enables you to modify, add, and remove UI themes and handle theme-related events. To access this object, use the [`themeEditor`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#themeEditor) property on a Survey Creator instance:
 *
 * ```js
 * const creatorOptions = { ... };
 * const creator = new SurveyCreator.SurveyCreator(creatorOptions);
 * creator.themeEditor.settingName = "value";
 *
 * // In modular applications:
 * import { SurveyCreatorModel } from "survey-creator-core";
 *
 * const creatorOptions = { ... };
 * const creator = new SurveyCreatorModel(creatorOptions);
 * creator.themeEditor.settingName = "value";
 * ```
 *
 * [Theme Editor Documentation](https://surveyjs.io/survey-creator/documentation/theme-editor (linkStyle))
 */
var ThemeTabPlugin = /** @class */ (function () {
    function ThemeTabPlugin(creator) {
        var _this = this;
        this.creator = creator;
        this.allowModifyTheme = true;
        this.simulatorCssClasses = survey_core__WEBPACK_IMPORTED_MODULE_0__.surveyCss[survey_core__WEBPACK_IMPORTED_MODULE_0__.defaultV2ThemeName];
        this._availableThemes = [].concat(_themes__WEBPACK_IMPORTED_MODULE_4__.PredefinedThemes);
        this._showOneCategoryInPropertyGrid = false;
        this._advancedModeValue = false;
        this.creatorPropertyChanged = function (sender, options) {
            if (options.name === "isMobileView") {
                _this.updateVisibilityOfPropertyGridGroups();
            }
        };
        this.previewDevice = "desktop";
        this.saveToFileHandler = _utils_utils__WEBPACK_IMPORTED_MODULE_5__.saveToFileHandler;
        this.autoSaveTimerId = null;
        /**
         * An event that is raised when users select a UI theme from a drop-down list, choose a dark or light color palette, and switch between regular and panelless theme modifications.
         *
         * Parameters:
         *
         * - `sender`: `ThemeTabPlugin`\
         * A `ThemeTabPlugin` instance that raised the event.
         * - `options.theme`: [`ITheme`](https://surveyjs.io/form-library/documentation/api-reference/itheme)\
         * A selected theme.
         * @see availableThemes
         * @see addTheme
         * @see removeTheme
         */
        this.onThemeSelected = new survey_core__WEBPACK_IMPORTED_MODULE_0__.EventBase();
        /**
         * An event that is raised when the value of a property or CSS variable in a theme JSON schema has changed.
         *
         * Parameters:
         *
         * - `sender`: `ThemeTabPlugin`\
         * A `ThemeTabPlugin` instance that raised the event.
         * - `options.name`: `string`\
         * The name of the changed property or CSS variable.
         * - `options.value`: `any`\
         * A new value of the property or CSS variable.
         */
        this.onThemePropertyChanged = new survey_core__WEBPACK_IMPORTED_MODULE_0__.EventBase();
        /**
         * An event that you can use to switch the current theme to read-only mode.
         *
         * Parameters:
         *
         * - `sender`: `ThemeTabPlugin`\
         * A `ThemeTabPlugin` instance that raised the event.
         * - `options.theme`: [`ITheme`](https://surveyjs.io/form-library/documentation/api-reference/itheme)\
         * The current theme.
         * - `options.allow`: `boolean`\
         * A Boolean property that you can set to `false` if you want to disallow theme modifications.
         */
        this.onAllowModifyTheme = new survey_core__WEBPACK_IMPORTED_MODULE_0__.EventBase();
        creator.addPluginTab("theme", this);
        this.simulatorCssClasses = survey_core__WEBPACK_IMPORTED_MODULE_0__.surveyCss[survey_core__WEBPACK_IMPORTED_MODULE_0__.defaultV2ThemeName];
        this.tabControlModel = new _side_bar_tab_control_model__WEBPACK_IMPORTED_MODULE_12__.TabControlModel(this.creator.sidebar);
        this.createActions().forEach(function (action) { return creator.toolbar.actions.push(action); });
        this.propertyGrid = new _property_grid__WEBPACK_IMPORTED_MODULE_6__.PropertyGridModel(undefined, creator, _theme_model_definition__WEBPACK_IMPORTED_MODULE_10__.themeModelPropertyGridDefinition);
        this.propertyGrid.surveyInstanceCreatedArea = "theme-tab:property-grid";
        var propertyGridViewModel = new _property_grid_property_grid_view_model__WEBPACK_IMPORTED_MODULE_7__.PropertyGridViewModel(this.propertyGrid, creator);
        this.propertyGridTab = this.creator.sidebar.addPage("theme", "svc-property-grid", propertyGridViewModel);
        this.propertyGridTab.caption = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("ed.themePropertyGridTitle");
        this.themeModel = new _theme_model__WEBPACK_IMPORTED_MODULE_8__.ThemeModel();
        creator.registerShortcut("undo_theme", {
            name: "undo",
            affectedTab: "theme",
            hotKey: {
                ctrlKey: true,
                keyCode: 90,
            },
            macOsHotkey: {
                keyCode: 90,
            },
            execute: function () { return _this.undo(); }
        });
        creator.registerShortcut("redo_theme", {
            name: "redo",
            affectedTab: "theme",
            hotKey: {
                ctrlKey: true,
                keyCode: 89,
            },
            macOsHotkey: {
                keyCode: 89,
            },
            execute: function () { return _this.redo(); }
        });
        creator.onPropertyChanged.add(this.creatorPropertyChanged);
    }
    Object.defineProperty(ThemeTabPlugin.prototype, "showOneCategoryInPropertyGrid", {
        get: function () {
            return this._showOneCategoryInPropertyGrid;
        },
        set: function (newValue) {
            if (this._showOneCategoryInPropertyGrid !== newValue) {
                this._showOneCategoryInPropertyGrid = newValue;
                this.creator.sidebar.hideSideBarVisibilityControlActions = newValue;
                this.updateAdvancedModeQuestion();
                this.propertyGrid.showOneCategoryInPropertyGrid = newValue;
                this.propertyGrid["setObj"](this.creator.selectedElement);
                if (this.creator.activeTab === "theme") {
                    this.updateTabControl();
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    ThemeTabPlugin.prototype.updateAdvancedModeQuestion = function () {
        var advancedModeQuestion = this.propertyGrid.survey.getQuestionByName("advancedMode");
        if (advancedModeQuestion) {
            advancedModeQuestion.visible = this.showOneCategoryInPropertyGrid;
            advancedModeQuestion.value = this._advancedModeValue;
        }
    };
    ThemeTabPlugin.prototype.createVisibleUpdater = function () {
        var _this = this;
        return new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () { return _this.creator.activeTab === "theme"; });
    };
    ThemeTabPlugin.prototype.createAppearanceAdvancedModeAction = function () {
        var _this = this;
        var advancedMode = new _switcher_switcher__WEBPACK_IMPORTED_MODULE_9__.Switcher({
            id: "advancedMode",
            component: "svc-switcher",
            ariaRole: "checkbox",
            css: "sv-theme-group_title-action",
            title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.advancedMode"),
            visible: !this.creator.isMobileView,
            action: function () {
                advancedMode.checked = !advancedMode.checked;
                if (!!_this.propertyGrid.survey.getQuestionByName("advancedMode")) {
                    _this.propertyGrid.survey.getQuestionByName("advancedMode").value = advancedMode.checked;
                }
            }
        });
        advancedMode.checked = this._advancedModeValue;
        this.advancedModeSwitcher = advancedMode;
    };
    ThemeTabPlugin.prototype.addSubGroupTitle = function (panel, titleId) {
        if (!!panel.getQuestionByName(titleId))
            return;
        var question = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.createClass("html");
        question.fromJSON({
            name: titleId,
            visibleIf: "{advancedMode} = true",
            html: "<div class='spg-theme-group-caption'>".concat((0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)(titleId), "</div>")
        });
        panel.addElement(question);
    };
    ThemeTabPlugin.prototype.updateSubGroups = function (survey) {
        var _this = this;
        ["appearancelines", "appearanceinput", "appearancequestion", "appearancepage", "appearanceprimarycolor"].forEach(function (panelName) { return _this.setVisibleIf(panelName, true); });
        ["appearancecolor", "appearancefont", "appearanceother"].forEach(function (panelName) { return _this.setVisibleIf(panelName, false); });
        this.addSubGroupTitle(survey.getPanelByName("appearanceprimarycolor"), "theme.pageTitle");
        this.addSubGroupTitle(survey.getPanelByName("appearancepage"), "theme.questionTitle");
        this.addSubGroupTitle(survey.getPanelByName("appearancequestion"), "theme.editorPanel");
        this.addSubGroupTitle(survey.getPanelByName("appearanceinput"), "theme.lines");
    };
    ThemeTabPlugin.prototype.updatePropertyGridEditorsAvailability = function () {
        var simulatorSurvey = this.model.survey;
        var page = this.propertyGrid.survey.pages[0];
        var header = page === null || page === void 0 ? void 0 : page.getElementByName("header");
        if (header && header.elements.length > 0) {
            var headerViewContainer = header.elements[0].contentPanel;
            this.setCoverPropertiesFromSurvey(headerViewContainer, simulatorSurvey);
        }
        var pageTitleQuestion = this.propertyGrid.survey.getQuestionByName("pageTitle");
        var pageElements = simulatorSurvey.isSinglePage ? simulatorSurvey.pages[0].elements : simulatorSurvey.pages;
        if (!!pageTitleQuestion) {
            pageTitleQuestion.readOnly = !pageElements.some(function (p) { return !!p.title; });
        }
        var pageDescriptionQuestion = this.propertyGrid.survey.getQuestionByName("pageDescription");
        if (pageDescriptionQuestion) {
            pageDescriptionQuestion.readOnly = !pageElements.some(function (p) { return !!p.description; });
        }
    };
    ThemeTabPlugin.prototype.updatePropertyGridColorEditorWithPredefinedColors = function () {
        var _this = this;
        var page = this.propertyGrid.survey.pages[0];
        var header = page === null || page === void 0 ? void 0 : page.getElementByName("header");
        if (header && header.elements.length > 0) {
            var headerViewContainer = header.elements[0].contentPanel;
            var headerBackgroundQuestion = headerViewContainer.getQuestionByName("backgroundColor");
            if (!!headerBackgroundQuestion) {
                headerBackgroundQuestion.choices = (0,_themes__WEBPACK_IMPORTED_MODULE_4__.getPredefinedColorsItemValues)(this.themeModel.colorPalette);
            }
        }
        this.propertyGrid.survey.getAllQuestions().forEach(function (question) {
            if (["color", "coloralpha"].indexOf(question.getType()) !== -1) {
                question.choices = (0,_themes__WEBPACK_IMPORTED_MODULE_4__.getPredefinedColorsItemValues)(_this.themeModel.colorPalette);
            }
        });
    };
    ThemeTabPlugin.prototype._setPGEditorPropertyValue = function (editor, propertyName, value) {
        if (!!editor) {
            editor[propertyName] = value;
        }
    };
    ThemeTabPlugin.prototype.setCoverPropertiesFromSurvey = function (panel, survey) {
        this._setPGEditorPropertyValue(panel.getQuestionByName("headerView"), "value", survey.headerView);
        this._setPGEditorPropertyValue(panel.getQuestionByName("logoPosition"), "value", survey.logoPosition);
        this._setPGEditorPropertyValue(panel.getQuestionByName("surveyTitle"), "readOnly", !survey.hasTitle);
        this._setPGEditorPropertyValue(panel.getQuestionByName("surveyDescription"), "readOnly", !survey.hasDescription);
        this._setPGEditorPropertyValue(panel.getQuestionByName("headerTitle"), "readOnly", !survey.hasTitle);
        this._setPGEditorPropertyValue(panel.getQuestionByName("headerDescription"), "readOnly", !survey.hasDescription);
        this._setPGEditorPropertyValue(panel.getQuestionByName("logoPositionX"), "readOnly", !survey.logo);
        this._setPGEditorPropertyValue(panel.getQuestionByName("logoPositionY"), "readOnly", !survey.logo);
        this._setPGEditorPropertyValue(panel.getQuestionByName("logoPosition"), "readOnly", !survey.logo);
        this._setPGEditorPropertyValue(panel.getQuestionByName("titlePositionX"), "readOnly", !survey.title);
        this._setPGEditorPropertyValue(panel.getQuestionByName("titlePositionY"), "readOnly", !survey.title);
        this._setPGEditorPropertyValue(panel.getQuestionByName("descriptionPositionX"), "readOnly", !survey.description);
        this._setPGEditorPropertyValue(panel.getQuestionByName("descriptionPositionY"), "readOnly", !survey.description);
        if (survey.showTOC) {
            var inheritWidthFrom = panel.getQuestionByName("inheritWidthFrom");
            this._setPGEditorPropertyValue(inheritWidthFrom, "value", "container");
            this._setPGEditorPropertyValue(inheritWidthFrom, "visible", false);
        }
    };
    ThemeTabPlugin.prototype.updateVisibilityOfPropertyGridGroups = function () {
        var page = this.propertyGrid.survey.pages[0];
        var header = page === null || page === void 0 ? void 0 : page.getElementByName("header");
        if (header) {
            header.visible = !this.creator.isMobileView;
        }
        if (this.advancedModeSwitcher) {
            this.advancedModeSwitcher.visible = !this.creator.isMobileView;
        }
    };
    ThemeTabPlugin.prototype.setVisibleIf = function (panelName, visibilityValue) {
        var panel = this.propertyGrid.survey.getPanelByName(panelName);
        if (!!panel) {
            panel.visibleIf = "{advancedMode} = ".concat(visibilityValue);
        }
    };
    ThemeTabPlugin.prototype.updateTabControl = function () {
        if (this.showOneCategoryInPropertyGrid) {
            this.updateTabControlActions();
            this.creator.sidebar.sideAreaComponentName = "svc-tab-control";
            this.creator.sidebar.sideAreaComponentData = this.tabControlModel;
            this.creator.sidebar.header.componentName = "svc-side-bar-header";
            this.creator.sidebar.header.componentData = this.creator.sidebar.header;
        }
        else {
            this.creator.sidebar.sideAreaComponentName = "";
            this.creator.sidebar.sideAreaComponentData = undefined;
            this.creator.sidebar.header.componentName = "";
            this.creator.sidebar.header.componentData = undefined;
        }
    };
    ThemeTabPlugin.prototype.activate = function () {
        var _this = this;
        this.model = new _theme_builder__WEBPACK_IMPORTED_MODULE_3__.ThemeTabViewModel(this.creator, this.simulatorCssClasses);
        this.model.simulator.device = this.previewDevice;
        this.themeModel.initialize(this.creator.theme, this.creator.survey, this.creator);
        this.creator.sidebar.hideSideBarVisibilityControlActions = this.showOneCategoryInPropertyGrid;
        this.update();
        this.propertyGrid.survey.onOpenFileChooser.clear();
        this.propertyGrid.obj = this.themeModel;
        this.propertyGrid.survey.mode = "edit";
        this.propertyGrid.survey.getAllQuestions().forEach(function (q) { return q.readOnly = false; });
        this.onAvailableThemesChanged(this.availableThemes);
        this.updateAllowModifyTheme();
        this.updateAdvancedModeQuestion();
        var themeBuilderCss = JSON.parse(JSON.stringify(_property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_11__.propertyGridCss));
        themeBuilderCss.root += " spg-theme-builder-root";
        if (this.showOneCategoryInPropertyGrid) {
            themeBuilderCss.root += " spg-root--one-category";
            themeBuilderCss.page.root += " spg-panel__content";
        }
        this.propertyGrid.survey.css = themeBuilderCss;
        this.updateSubGroups(this.propertyGrid.survey);
        this.propertyGrid.survey.onGetPanelTitleActions.add(function (sender, opt) {
            if (opt.panel && opt.panel.name == "appearance") {
                _this.createAppearanceAdvancedModeAction();
                opt.titleActions.push(_this.advancedModeSwitcher);
            }
        });
        this.propertyGrid.survey.onOpenFileChooser.add(function (_, options) {
            var _a, _b;
            var context = {};
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_5__.assign)(context, options.context, { element: _this.themeModel, elementType: "theme" });
            if (options.element) {
                var question = options.element;
                context.propertyName = question.name;
                if (((_b = (_a = question === null || question === void 0 ? void 0 : question.parent) === null || _a === void 0 ? void 0 : _a.parent) === null || _b === void 0 ? void 0 : _b.name) === "settings") {
                    context.elementType = "header";
                    context.element = context.element.header;
                }
            }
            _this.creator.chooseFiles(options.input, options.callback, context);
        });
        this.propertyGrid.survey.onUpdatePanelCssClasses.add(function (sender, options) {
            var _a, _b, _c;
            if (options.panel.hasParent) {
                var parent_1 = ((_a = options.panel.parent) !== null && _a !== void 0 ? _a : options.panel.parentQuestion);
                if (!parent_1 || parent_1.hasParent && !(parent_1.name === "settings" || ((_b = parent_1.parentQuestion) === null || _b === void 0 ? void 0 : _b.name) === "settings")) {
                    options.cssClasses.panel.container = "spg-panel-group";
                    options.cssClasses.panel.content = "spg-panel-group__content";
                }
                else {
                    options.cssClasses.panel.container = "spg-nested-panel";
                    options.cssClasses.panel.content = "spg-nested-panel__content";
                }
            }
            else if (_this.showOneCategoryInPropertyGrid && ((_c = options.panel.parent) === null || _c === void 0 ? void 0 : _c.isPage)) {
                options.cssClasses.panel.container = "spg-panel-by-page";
                options.cssClasses.panel.content = "spg-panel-by-page__content";
                if (options.panel.name === "appearanceother") {
                    options.cssClasses.panel.container += " spg-panel--hidden-border";
                }
                if (options.panel.name === "appearanceadvancedmode") {
                    options.cssClasses.panel.container += " spg-panel--hidden-border spg-panel--padding";
                }
            }
        });
        this.updatePropertyGridEditorsAvailability();
        this.updateVisibilityOfPropertyGridGroups();
        this.updatePropertyGridColorEditorWithPredefinedColors();
        this.creator.sidebar.activePage = this.propertyGridTab.id;
        this.propertyGridTab.visible = true;
        this.updateTabControl();
        this.expandCategoryIfNeeded();
    };
    ThemeTabPlugin.prototype.expandCategoryIfNeeded = function () {
        if (!this.model.survey.isEmpty) {
            this.propertyGrid.expandCategoryIfNeeded();
        }
    };
    ThemeTabPlugin.prototype.updateTabControlActions = function () {
        var _this = this;
        if (this.showOneCategoryInPropertyGrid) {
            var pgTabs_1 = this.propertyGrid.survey.pages.map(function (p) {
                var action = new _utils_actions__WEBPACK_IMPORTED_MODULE_14__.MenuButton({
                    id: p.name,
                    tooltip: p.title,
                    iconName: _property_grid_icons__WEBPACK_IMPORTED_MODULE_13__.pgTabIcons[p.name] || _property_grid_icons__WEBPACK_IMPORTED_MODULE_13__.pgTabIcons["undefined"],
                    active: p.name === _this.propertyGrid.survey.currentPage.name,
                    pressed: false,
                    action: function () {
                        _this.creator.sidebar.expandSidebar();
                        _this.propertyGrid.survey.currentPage = p;
                        _this.creator.sidebar.header.subTitle = p.title;
                        pgTabs_1.forEach(function (i) { return i.active = false; });
                        action.active = true;
                    }
                });
                return action;
            });
            this.tabControlModel.topToolbar.setItems(pgTabs_1);
            this.creator.sidebar.header.subTitle = this.propertyGrid.survey.currentPage.title;
        }
    };
    ThemeTabPlugin.prototype.update = function () {
        var _this = this;
        if (!this.model)
            return;
        this.model.simulator.landscape = this.creator.previewOrientation != "portrait";
        this.model.testAgainAction = this.testAgainAction;
        this.model.prevPageAction = this.prevPageAction;
        this.model.nextPageAction = this.nextPageAction;
        var options = {
            showPagesInTestSurveyTab: this.creator.showPagesInTestSurveyTab,
        };
        this.model.initialize(this.creator.JSON, options);
        this.updateSimulatorTheme(this.creator.theme);
        if (this.creator.showInvisibleElementsInTestSurveyTab) {
            this.invisibleToggleAction.css = this.model.showInvisibleElements ? "sv-action-bar-item--active" : "";
            this.invisibleToggleAction.visible = this.model.isRunning;
        }
        this.updateUndeRedoActions();
        this.themeModel.undoRedoManager.canUndoRedoCallback = function () {
            _this.updateUndeRedoActions();
        };
        this.model.show();
        this.model.onPropertyChanged.add(function (sender, options) {
            if (options.name === "isRunning") {
                _this.invisibleToggleAction && (_this.invisibleToggleAction.visible = _this.model.isRunning);
                _this.testAgainAction.visible = !_this.model.isRunning;
            }
        });
        this.themeModel.onThemeSelected.add(function (sender, options) {
            _this.syncTheme(options.theme);
            _this.resetTheme.enabled = (0,_theme_model__WEBPACK_IMPORTED_MODULE_8__.getThemeFullName)(sender.defaultSessionTheme) !== (0,_theme_model__WEBPACK_IMPORTED_MODULE_8__.getThemeFullName)(options.theme);
            _this.saveThemeAction.enabled = true;
            _this.onThemeSelected.fire(_this, options);
            if (_this.creator.isAutoSave) {
                _this.processAutoSave();
            }
            _this.propertyGrid.survey.editingObj = undefined;
            _this.propertyGrid.survey.editingObj = sender;
            _this.updateAllowModifyTheme();
            _this.updatePropertyGridColorEditorWithPredefinedColors();
        });
        this.themeModel.onThemePropertyChanged.add(function (sender, options) {
            _this.syncTheme(_this.themeModel.toJSON());
            if (options.name == "--sjs-base-unit") {
                _this.model.survey.triggerResponsiveness(true);
            }
            if (options.name == "logoPosition") {
                _this.creator.survey.logoPosition = options.value;
                _this.model.survey.logoPosition = options.value;
            }
            _this.resetTheme.enabled = true;
            _this.saveThemeAction.enabled = true;
            _this.onThemePropertyChanged.fire(_this, options);
            if (_this.creator.isAutoSave) {
                _this.processAutoSave();
            }
        });
        this.themeModel.onAllowModifyTheme.add(function (sender, options) {
            _this.onAllowModifyTheme.fire(_this, options);
        });
        this.resetTheme.enabled = (0,_theme_model__WEBPACK_IMPORTED_MODULE_8__.getThemeFullName)(this.themeModel.defaultSessionTheme) !== (0,_theme_model__WEBPACK_IMPORTED_MODULE_8__.getThemeFullName)(this.creator.theme) || this.isModified;
        this.updateTabControl();
    };
    ThemeTabPlugin.prototype.updateAllowModifyTheme = function () {
        var _this = this;
        var opt = { theme: this.themeModel, allow: !this.creator.readOnly };
        this.onAllowModifyTheme.fire(this, opt);
        this.propertyGrid.survey.getAllQuestions().forEach(function (q) {
            if (["themeName", "colorPalette", "isPanelless"].indexOf(q.name) === -1) {
                q.readOnly = _this.creator.onIsPropertyReadOnlyCallback(_this.themeModel, _this.themeModel.getPropertyByName(q.name), !opt.allow, undefined, undefined, false);
            }
        });
    };
    ThemeTabPlugin.prototype.deactivate = function () {
        var _a;
        if (this.model) {
            this.previewDevice = this.model.simulator.device;
            this.simulatorCssClasses = this.model.survey.css;
            this.model.onPropertyChanged.clear();
            this.themeModel.onThemeSelected.clear();
            this.themeModel.onThemePropertyChanged.clear();
            this.themeModel.onAllowModifyTheme.clear();
            this.model.onSurveyCreatedCallback = undefined;
            this.model.dispose();
            this.model = undefined;
            this.creator.sidebar.hideSideBarVisibilityControlActions = false;
        }
        this._advancedModeValue = !!((_a = this.propertyGrid.survey.getQuestionByName("advancedMode")) === null || _a === void 0 ? void 0 : _a.value);
        this.creator.sidebar.sideAreaComponentName = undefined;
        this.creator.sidebar.sideAreaComponentData = undefined;
        this.creator.sidebar.header.reset();
        this.propertyGridTab.visible = false;
        this.testAgainAction.visible = false;
        this.invisibleToggleAction && (this.invisibleToggleAction.visible = false);
        return true;
    };
    ThemeTabPlugin.prototype.exportToFile = function (fileName) {
        var themeCopy = JSON.parse(JSON.stringify(this.themeModel.toJSON()));
        var themeData = JSON.stringify(themeCopy, null, 4);
        var themeBlob = new Blob([themeData], { type: "application/json" });
        this.saveToFileHandler(fileName, themeBlob);
    };
    ThemeTabPlugin.prototype.importFromFile = function (file, callback) {
        var _this = this;
        var fileReader = new FileReader();
        fileReader.onload = function (e) {
            var theme = JSON.parse(fileReader.result);
            if (!!_this.themeModel) {
                _this.themeModel.setTheme(theme);
            }
            callback && callback(theme);
        };
        fileReader.readAsText(file);
    };
    ThemeTabPlugin.prototype.createActions = function () {
        var _this = this;
        var items = [];
        this.designerAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svd-designer",
            iconName: "icon-config",
            iconSize: "auto",
            action: function () { _this.creator.makeNewViewActive("designer"); },
            visible: this.createVisibleUpdater(),
            locTitleName: "ed.designer",
            showTitle: false
        });
        this.prevPageAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "prevPage",
            iconName: "icon-arrow-left_16x16",
            iconSize: "auto",
            needSeparator: new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () {
                return _this.creator.isMobileView;
            }),
            visible: false
        });
        this.nextPageAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "nextPage",
            iconName: "icon-arrow-right_16x16",
            iconSize: "auto",
            visible: false
        });
        this.previewAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svd-preview",
            iconName: "icon-preview",
            iconSize: "auto",
            active: true,
            visible: this.createVisibleUpdater(),
            locTitleName: "tabs.preview",
            showTitle: false,
            action: function () { }
        });
        this.testAgainAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "testSurveyAgain",
            visible: false,
            iconSize: "auto",
            locTitleName: "ed.testSurveyAgain",
            action: function () {
                _this.model.testAgain();
            }
        });
        this.undoAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "action-undo-theme",
            iconName: "icon-undo",
            iconSize: "auto",
            locTitleName: "ed.undo",
            showTitle: false,
            visible: this.createVisibleUpdater(),
            action: function () { return _this.undo(); }
        });
        this.redoAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "action-redo-theme",
            iconName: "icon-redo",
            iconSize: "auto",
            locTitleName: "ed.redo",
            showTitle: false,
            visible: this.createVisibleUpdater(),
            action: function () { return _this.redo(); }
        });
        items.push(this.undoAction);
        items.push(this.redoAction);
        this.saveThemeAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svd-save-theme",
            iconName: "icon-save",
            iconSize: "auto",
            action: function () {
                _this.creator.saveThemeActionHandler();
                _this.saveThemeAction.enabled = false;
            },
            active: false,
            enabled: false,
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () {
                return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_5__.notShortCircuitAnd)(_this.creator.activeTab === "theme", _this.creator.showSaveButton);
            }),
            locTitleName: "ed.saveTheme",
            locTooltipName: "ed.saveThemeTooltip",
            showTitle: false
        });
        items.push(this.saveThemeAction);
        this.resetTheme = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svc-reset-theme",
            iconName: "icon-reset",
            iconSize: "auto",
            locTitleName: "ed.themeResetButton",
            locTooltipName: "ed.themeResetButton",
            mode: "small",
            visible: this.createVisibleUpdater(),
            action: function () {
                survey_core__WEBPACK_IMPORTED_MODULE_0__.settings.confirmActionAsync((0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.themeResetConfirmation"), function (confirm) {
                    if (confirm) {
                        _this.themeModel.resetTheme();
                    }
                }, (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.themeResetConfirmationOk"), _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.currentLocale);
            }
        });
        items.push(this.resetTheme);
        this.themeSettingsAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svc-theme-settings",
            iconName: "icon-theme",
            iconSize: "auto",
            action: function () {
                if (!_this.creator.showSidebar) {
                    _this.creator.setShowSidebar(true, true);
                }
            },
            visible: this.createVisibleUpdater(),
            active: new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () { return _this.creator.showSidebar; }),
            pressed: new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () { return _this.creator.showSidebar; }),
            locTitleName: "ed.themeSettings",
            locTooltipName: "ed.themeSettingsTooltip",
            showTitle: false
        });
        items.push(this.themeSettingsAction);
        this.importAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svc-theme-import",
            iconName: "icon-load",
            iconSize: "auto",
            locTitleName: "ed.themeImportButton",
            locTooltipName: "ed.themeImportButton",
            visible: this.createVisibleUpdater(),
            mode: "small",
            component: "sv-action-bar-item",
            needSeparator: true,
            action: function () {
                if (!document)
                    return;
                if (!_this.inputFileElement) {
                    _this.inputFileElement = document.createElement("input");
                    _this.inputFileElement.type = "file";
                    _this.inputFileElement.style.display = "none";
                    _this.inputFileElement.onchange = function () {
                        if (_this.inputFileElement.files.length < 1)
                            return;
                        _this.importFromFile(_this.inputFileElement.files[0]);
                        _this.inputFileElement.value = "";
                    };
                }
                _this.inputFileElement.click();
            }
        });
        items.push(this.importAction);
        this.exportAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svc-theme-export",
            iconName: "icon-download",
            iconSize: "auto",
            locTitleName: "ed.themeExportButton",
            locTooltipName: "ed.themeExportButton",
            visible: this.createVisibleUpdater(),
            mode: "small",
            component: "sv-action-bar-item",
            action: function () {
                _this.exportToFile(_creator_settings__WEBPACK_IMPORTED_MODULE_1__.settings.themeEditor.exportFileName);
            }
        });
        items.push(this.exportAction);
        if (this.creator.showInvisibleElementsInTestSurveyTab) {
            this.invisibleToggleAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
                id: "showInvisible",
                iconName: "icon-invisible-items",
                iconSize: "auto",
                mode: "small",
                locTitleName: "ts.showInvisibleElements",
                visible: false,
                action: function () {
                    _this.model.showInvisibleElements = !_this.model.showInvisibleElements;
                    _this.invisibleToggleAction.css = _this.model.showInvisibleElements ? "sv-action-bar-item--active" : "";
                    _this.invisibleToggleAction.title = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)(!_this.model.showInvisibleElements ? "ts.showInvisibleElements" : "ts.hideInvisibleElements");
                }
            });
        }
        return items;
    };
    ThemeTabPlugin.prototype.undo = function () {
        var _undoRedoManager = this.model && this.themeModel.undoRedoManager;
        if (!_undoRedoManager)
            return;
        _undoRedoManager.suspend();
        if (_undoRedoManager.canUndo()) {
            _undoRedoManager.undo();
        }
        _undoRedoManager.resume();
    };
    ThemeTabPlugin.prototype.redo = function () {
        var _undoRedoManager = this.model && this.themeModel.undoRedoManager;
        if (!_undoRedoManager)
            return;
        _undoRedoManager.suspend();
        if (_undoRedoManager.canRedo()) {
            _undoRedoManager.redo();
        }
        _undoRedoManager.resume();
    };
    ThemeTabPlugin.prototype.updateUndeRedoActions = function () {
        var _undoRedoManager = this.themeModel.undoRedoManager;
        this.undoAction.enabled = _undoRedoManager.canUndo();
        this.redoAction.enabled = _undoRedoManager.canRedo();
    };
    ThemeTabPlugin.prototype.addFooterActions = function () {
        this.creator.footerToolbar.actions.push(this.designerAction);
        this.creator.footerToolbar.actions.push(this.previewAction);
        this.creator.footerToolbar.actions.push(this.prevPageAction);
        this.creator.footerToolbar.actions.push(this.nextPageAction);
        this.invisibleToggleAction && (this.creator.footerToolbar.actions.push(this.invisibleToggleAction));
        this.creator.footerToolbar.actions.push(this.themeSettingsAction);
    };
    ThemeTabPlugin.prototype.syncTheme = function (theme) {
        var newTheme = theme || this.themeModel.toJSON();
        this.creator.theme = newTheme;
        this.updateSimulatorTheme(newTheme);
    };
    ThemeTabPlugin.prototype.updateSimulatorTheme = function (theme) {
        if (!!this.model.survey) {
            if ((0,_theme_model__WEBPACK_IMPORTED_MODULE_8__.isThemeEmpty)(theme)) {
                var preferredTheme = (0,_theme_model__WEBPACK_IMPORTED_MODULE_8__.findSuitableTheme)(undefined, this.creator.preferredColorPalette, undefined, undefined);
                this.model.survey.applyTheme(preferredTheme || this.themeModel.toJSON());
            }
            else {
                this.model.survey.applyTheme(theme);
            }
        }
    };
    Object.defineProperty(ThemeTabPlugin.prototype, "saveThemeFunc", {
        /**
         * A function that is called [auto-save](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#isAutoSave) is triggered to save a theme JSON object.
         *
         * For more information, refer to the [Save and Load Custom Themes](https://surveyjs.io/survey-creator/documentation/theme-editor#save-and-load-custom-themes) help topic.
         */
        get: function () {
            return this._saveThemeFuncValue;
        },
        set: function (value) {
            this._saveThemeFuncValue = value;
        },
        enumerable: false,
        configurable: true
    });
    ThemeTabPlugin.prototype.processAutoSave = function () {
        var _this = this;
        var saveThemeFunc = this.saveThemeFunc;
        if (!saveThemeFunc && this.creator.saveThemeFunc) {
            saveThemeFunc = function () { return _this.creator.saveTheme(); };
        }
        if (!saveThemeFunc) {
            return;
        }
        if (this.creator.autoSaveDelay <= 0) {
            saveThemeFunc();
            return;
        }
        if (!!this.autoSaveTimerId) {
            clearTimeout(this.autoSaveTimerId);
        }
        this.autoSaveTimerId = setTimeout(function () {
            clearTimeout(_this.autoSaveTimerId);
            _this.autoSaveTimerId = null;
            saveThemeFunc && saveThemeFunc();
        }, this.creator.autoSaveDelay);
    };
    Object.defineProperty(ThemeTabPlugin.prototype, "availableThemes", {
        /**
         * A list of UI themes from which users can select. You can sort this list if you want to reorder themes in Theme Editor.
         * @see addTheme
         * @see removeTheme
         */
        get: function () {
            return [].concat(this._availableThemes);
        },
        set: function (availableThemes) {
            this._availableThemes = availableThemes || [];
            this.onAvailableThemesChanged(availableThemes);
            this.updateAllowModifyTheme();
        },
        enumerable: false,
        configurable: true
    });
    ThemeTabPlugin.prototype.onAvailableThemesChanged = function (availableThemes) {
        var themeChooser = this.propertyGrid.survey.getQuestionByName("themeName");
        if (!!themeChooser) {
            themeChooser.choices = availableThemes.map(function (theme) { return ({ value: theme, text: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("theme.names." + theme) }); });
            if (availableThemes.indexOf(themeChooser.value) === -1) {
                this.themeModel.setTheme(this.themeModel.defaultSessionTheme);
            }
        }
        this.propertyGrid.survey.runExpressions();
    };
    /**
     * Adds a new UI theme to Theme Editor.
     * @param theme A [UI theme](https://surveyjs.io/form-library/documentation/api-reference/itheme) to add.
     * @param setAsDefault For internal use.
     * @returns An identifier of the added theme, which is a concatenation of the [`themeName`](https://surveyjs.io/form-library/documentation/api-reference/itheme#themeName), [`colorPalette`](https://surveyjs.io/form-library/documentation/api-reference/itheme#colorPalette), and [`isPanelless`](https://surveyjs.io/form-library/documentation/api-reference/itheme#isPanelless) settings (for example, `"default-dark-panelless"`).
     * @see removeTheme
     * @see getCurrentTheme
     */
    ThemeTabPlugin.prototype.addTheme = function (theme, setAsDefault) {
        if (setAsDefault === void 0) { setAsDefault = false; }
        var fullThemeName = (0,_theme_model__WEBPACK_IMPORTED_MODULE_8__.getThemeFullName)(theme);
        _themes__WEBPACK_IMPORTED_MODULE_4__.Themes[fullThemeName] = theme;
        if (this._availableThemes.indexOf(theme.themeName) === -1) {
            if (setAsDefault) {
                this.availableThemes = [theme.themeName].concat(this.availableThemes);
                _theme_model__WEBPACK_IMPORTED_MODULE_8__.ThemeModel.DefaultTheme = theme;
            }
            else {
                this.availableThemes = this.availableThemes.concat([theme.themeName]);
            }
        }
        else {
            // eslint-disable-next-line no-self-assign
            this.availableThemes = this.availableThemes;
        }
        return fullThemeName;
    };
    /**
     * Removes a UI theme from Theme Editor.
     * @param themeAccessor A [UI theme](https://surveyjs.io/form-library/documentation/api-reference/itheme) to delete or a theme identifier, which is a concatenation of the [`themeName`](https://surveyjs.io/form-library/documentation/api-reference/itheme#themeName), [`colorPalette`](https://surveyjs.io/form-library/documentation/api-reference/itheme#colorPalette), and [`isPanelless`](https://surveyjs.io/form-library/documentation/api-reference/itheme#isPanelless) settings (for example, `"default-dark-panelless"`).
     * @param includeModifications Pass `true` to delete not only the specified UI theme, but also all other themes with the same `themeName` value (dark/light and panelless modifications).
     * @see addTheme
     * @see getCurrentTheme
     */
    ThemeTabPlugin.prototype.removeTheme = function (themeAccessor, includeModifications) {
        if (includeModifications === void 0) { includeModifications = false; }
        var themeToDelete = typeof themeAccessor === "string" ? _themes__WEBPACK_IMPORTED_MODULE_4__.Themes[themeAccessor] : themeAccessor;
        var fullThemeName = typeof themeAccessor === "string" ? themeAccessor : (0,_theme_model__WEBPACK_IMPORTED_MODULE_8__.getThemeFullName)(themeToDelete);
        if (!!themeToDelete) {
            delete _themes__WEBPACK_IMPORTED_MODULE_4__.Themes[fullThemeName];
            if (_theme_model__WEBPACK_IMPORTED_MODULE_8__.ThemeModel.DefaultTheme === themeToDelete) {
                _theme_model__WEBPACK_IMPORTED_MODULE_8__.ThemeModel.DefaultTheme = _themes__WEBPACK_IMPORTED_MODULE_4__.Themes["default-light"] || _themes__WEBPACK_IMPORTED_MODULE_4__.Themes[Object.keys(_themes__WEBPACK_IMPORTED_MODULE_4__.Themes)[0]];
                this.themeModel.defaultSessionTheme = _theme_model__WEBPACK_IMPORTED_MODULE_8__.ThemeModel.DefaultTheme;
            }
            var registeredThemeNames = Object.keys(_themes__WEBPACK_IMPORTED_MODULE_4__.Themes);
            var themeModifications = registeredThemeNames.filter(function (themeName) { return themeName.indexOf(themeToDelete.themeName + "-") === 0; });
            if (includeModifications && themeModifications.length > 0) {
                themeModifications.forEach(function (themeModificationFullName) { return delete _themes__WEBPACK_IMPORTED_MODULE_4__.Themes[themeModificationFullName]; });
            }
            if (includeModifications || themeModifications.length === 0) {
                var themeIndex = this._availableThemes.indexOf(themeToDelete.themeName);
                if (themeIndex !== -1) {
                    var availableThemes = this.availableThemes;
                    availableThemes.splice(themeIndex, 1);
                    this.availableThemes = availableThemes;
                }
            }
        }
    };
    /**
     * Returns a JSON object that describes the currently applied UI theme.
     * @param changesOnly Pass `true` to get a JSON object that contains only changed theme settings instead of a full theme JSON schema.
     * @returns A currently applied [theme JSON schema](https://surveyjs.io/form-library/documentation/api-reference/itheme).
     * @see availableThemes
     * @see addTheme
     * @see removeTheme
     */
    ThemeTabPlugin.prototype.getCurrentTheme = function (changesOnly) {
        if (changesOnly === void 0) { changesOnly = false; }
        if (!changesOnly) {
            return this.creator.theme;
        }
        return this.getThemeChanges();
    };
    ThemeTabPlugin.prototype.getThemeChanges = function () {
        return (0,_theme_model__WEBPACK_IMPORTED_MODULE_8__.getThemeChanges)(this.creator.theme);
    };
    Object.defineProperty(ThemeTabPlugin.prototype, "isModified", {
        /**
         * Indicates whether the selected theme has been modified.
         * @see [`creator.saveTheme()`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#saveTheme)
         * @see [`creator.saveThemeFunc`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#saveThemeFunc)
         */
        get: function () {
            var currentThemeChanges = this.getThemeChanges();
            var hasCssModifications = Object.keys(currentThemeChanges.cssVariables).length > 0;
            var hasBackgroundModifications = Object.keys(currentThemeChanges).some(function (propertyName) { return propertyName.toLowerCase().indexOf("background") !== -1; });
            var hasHeaderModifications = !!currentThemeChanges.header && Object.keys(currentThemeChanges.header).length === 0;
            return hasCssModifications || hasBackgroundModifications || hasHeaderModifications;
        },
        enumerable: false,
        configurable: true
    });
    ThemeTabPlugin.DefaultTheme = _themes__WEBPACK_IMPORTED_MODULE_4__.Themes["default-light"];
    return ThemeTabPlugin;
}());



/***/ }),

/***/ "./src/components/tabs/themes.ts":
/*!***************************************!*\
  !*** ./src/components/tabs/themes.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PredefinedBackgroundColors: () => (/* binding */ PredefinedBackgroundColors),
/* harmony export */   PredefinedColors: () => (/* binding */ PredefinedColors),
/* harmony export */   PredefinedThemes: () => (/* binding */ PredefinedThemes),
/* harmony export */   Themes: () => (/* binding */ Themes),
/* harmony export */   getPredefinedBackgoundColorsChoices: () => (/* binding */ getPredefinedBackgoundColorsChoices),
/* harmony export */   getPredefinedColorsItemValues: () => (/* binding */ getPredefinedColorsItemValues)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");


var Themes = {};
var PredefinedThemes = ["default", "sharp", "borderless", "flat", "plain", "doubleborder", "layered", "solid", "threedimensional", "contrast"];
var PredefinedColors = {
    light: {
        teal: "rgba(11, 128, 128, 1)",
        blue: "rgba(39, 114, 203, 1)",
        purple: "rgba(122, 70, 187, 1)",
        orchid: "rgba(178, 61, 153, 1)",
        tulip: "rgba(191, 76, 97, 1)",
        brown: "rgba(177, 94, 47, 1)",
        green: "rgba(11, 134, 75, 1)"
    },
    dark: {
        teal: "rgba(22, 198, 187, 1)",
        blue: "rgba(109, 183, 252, 1)",
        purple: "rgba(173, 144, 255, 1)",
        orchid: "rgba(232, 113, 220, 1)",
        tulip: "rgba(245, 131, 151, 1)",
        brown: "rgba(252, 187, 89, 1)",
        green: "rgba(140, 204, 90, 1)"
    }
};
var PredefinedBackgroundColors = {
    light: {
        teal: "rgba(239, 249, 249, 1)",
        blue: "rgba(243, 247, 253, 1)",
        purple: "rgba(248, 244, 254, 1)",
        orchid: "rgba(252, 242, 250, 1)",
        tulip: "rgba(253, 243, 245, 1)",
        brown: "rgba(251, 245, 241, 1)",
        green: "rgba(240, 250, 243, 1)",
        gray: "rgba(246, 246, 246, 1)"
    },
    dark: {}
};
function getPredefinedColorsItemValues(colorPalette) {
    if (colorPalette === void 0) { colorPalette = "light"; }
    return Object.keys(PredefinedColors[colorPalette]).map(function (colorName) {
        return new survey_core__WEBPACK_IMPORTED_MODULE_0__.ItemValue(PredefinedColors[colorPalette][colorName], (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_1__.getLocString)("theme.colors." + colorName));
    });
}
function getPredefinedBackgoundColorsChoices(colorPalette) {
    if (colorPalette === void 0) { colorPalette = "light"; }
    return Object.keys(PredefinedBackgroundColors[colorPalette]).map(function (colorName) {
        return ({ value: PredefinedBackgroundColors[colorPalette][colorName], text: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_1__.getLocString)("theme.colors." + colorName) });
    });
}


/***/ }),

/***/ "./src/components/tabs/translation-plugin.ts":
/*!***************************************************!*\
  !*** ./src/components/tabs/translation-plugin.ts ***!
  \***************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TabTranslationPlugin: () => (/* binding */ TabTranslationPlugin)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _translation__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./translation */ "./src/components/tabs/translation.ts");
/* harmony import */ var _side_bar_tab_control_model__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../side-bar/tab-control-model */ "./src/components/side-bar/tab-control-model.ts");
/* harmony import */ var _utils_actions__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../utils/actions */ "./src/utils/actions.ts");





var TabTranslationPlugin = /** @class */ (function () {
    function TabTranslationPlugin(creator) {
        this.creator = creator;
        this._showOneCategoryInPropertyGrid = false;
        creator.addPluginTab("translation", this);
        this.tabControlModel = new _side_bar_tab_control_model__WEBPACK_IMPORTED_MODULE_3__.TabControlModel(this.creator.sidebar);
        this.sidebarTab = this.creator.sidebar.addPage("translation");
        this.sidebarTab.caption = _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.translationPropertyGridTitle");
        this.createActions().forEach(function (action) { return creator.toolbar.actions.push(action); });
    }
    Object.defineProperty(TabTranslationPlugin.prototype, "showOneCategoryInPropertyGrid", {
        get: function () {
            return this._showOneCategoryInPropertyGrid;
        },
        set: function (newValue) {
            if (this._showOneCategoryInPropertyGrid !== newValue) {
                this._showOneCategoryInPropertyGrid = newValue;
                this.creator.sidebar.hideSideBarVisibilityControlActions = newValue;
                if (this.creator.activeTab === "translation") {
                    this.updateTabControl();
                }
            }
        },
        enumerable: false,
        configurable: true
    });
    TabTranslationPlugin.prototype.updateSettingsSurvey = function () {
        this.model.settingsSurvey.locale = this.creator.locale;
        this.model.settingsSurvey.css.root += (this.showOneCategoryInPropertyGrid ? " spg-root--one-category" : "");
        this.model.settingsSurvey.rootCss += (this.showOneCategoryInPropertyGrid ? " spg-root--one-category" : "");
    };
    TabTranslationPlugin.prototype.activate = function () {
        var _this = this;
        this.model = new _translation__WEBPACK_IMPORTED_MODULE_2__.Translation(this.creator.survey, this.creator);
        this.updateSettingsSurvey();
        this.model.readOnly = this.creator.readOnly;
        this.model.translationStringVisibilityCallback = function (obj, propertyName, visible) {
            var options = { obj: obj, propertyName: propertyName, visible: visible };
            !_this.creator.onTranslationStringVisibility.isEmpty && _this.creator.onTranslationStringVisibility.fire(_this.creator, options);
            return options.visible;
        };
        this.model.localeInitialVisibleCallback = function (locale) {
            var options = { locale: locale, isSelected: true };
            _this.creator.onTranslationLocaleInitiallySelected.fire(_this.creator, options);
            return options.isSelected;
        };
        this.model.importItemCallback = function (name, locale, text) {
            var options = { locale: locale, name: name, text: text };
            _this.creator.onTranslationImportItem.fire(_this.creator, options);
            return options.text;
        };
        this.model.importFinishedCallback = function () {
            _this.creator.onTranslationImported.fire(_this.creator, {});
        };
        this.sidebarTab.componentData = this.model.settingsSurvey;
        this.sidebarTab.componentName = "survey-widget";
        this.creator.sidebar.activePage = this.sidebarTab.id;
        this.mergeLocaleWithDefaultAction.title = this.createMergeLocaleWithDefaultActionTitleUpdater();
        this.mergeLocaleWithDefaultAction.tooltip = this.createMergeLocaleWithDefaultActionTitleUpdater();
        this.mergeLocaleWithDefaultAction.visible = this.model.canMergeLocaleWithDefault;
        this.filterPageAction.visible = this.creator.survey.pageCount > 1;
        this.updateFilterPageAction(true);
        this.filterStringsAction.visible = true;
        this.updateFilterStrigsAction(true);
        this.importCsvAction.visible = true;
        this.exportCsvAction.visible = true;
        this.filterPageAction.data.setItems([{ id: null, title: this.showAllPagesText }].concat(this.creator.survey.pages.map(function (page) { return ({
            id: page.name,
            title: _this.getPageDisplayText(page)
        }); })), false);
        this.model.onPropertyChanged.add(function (sender, options) {
            if (options.name === "filteredPage") {
                _this.updateFilterPageAction();
            }
            if (options.name === "showAllStrings") {
                _this.updateFilterStrigsAction();
            }
            if (options.name === "canMergeLocaleWithDefault") {
                _this.mergeLocaleWithDefaultAction.visible = _this.model.canMergeLocaleWithDefault;
            }
            if (options.name === "mergeLocaleWithDefaultText") {
                _this.mergeLocaleWithDefaultAction.title = _this.model.mergeLocaleWithDefaultText;
                _this.mergeLocaleWithDefaultAction.tooltip = _this.model.mergeLocaleWithDefaultText;
            }
        });
        this.model.reset();
        this.creator.sidebar.hideSideBarVisibilityControlActions = this.showOneCategoryInPropertyGrid;
        this.updateTabControl();
    };
    TabTranslationPlugin.prototype.update = function () {
        if (!this.model)
            return;
        this.model.survey = this.creator.survey;
        this.model.filteredPage = null;
        this.updateFilterPageAction(true);
        this.updateTabControl();
    };
    TabTranslationPlugin.prototype.deactivate = function () {
        if (!!this.model) {
            this.model.dispose();
        }
        this.model = undefined;
        this.sidebarTab.visible = false;
        this.filterStringsAction.visible = false;
        this.filterPageAction.visible = false;
        this.mergeLocaleWithDefaultAction.title = undefined;
        this.mergeLocaleWithDefaultAction.tooltip = undefined;
        this.mergeLocaleWithDefaultAction.visible = false;
        this.importCsvAction.visible = false;
        this.exportCsvAction.visible = false;
        this.creator.sidebar.hideSideBarVisibilityControlActions = false;
        return true;
    };
    TabTranslationPlugin.prototype.updateTabControl = function () {
        if (this.showOneCategoryInPropertyGrid) {
            this.updateTabControlActions();
            this.creator.sidebar.sideAreaComponentName = "svc-tab-control";
            this.creator.sidebar.sideAreaComponentData = this.tabControlModel;
            this.creator.sidebar.header.componentName = "svc-side-bar-header";
            this.creator.sidebar.header.componentData = this.creator.sidebar.header;
        }
        else {
            this.creator.sidebar.sideAreaComponentName = "";
            this.creator.sidebar.sideAreaComponentData = undefined;
            this.creator.sidebar.header.componentName = "";
            this.creator.sidebar.header.componentData = undefined;
        }
    };
    TabTranslationPlugin.prototype.updateTabControlActions = function () {
        var _this = this;
        if (this.showOneCategoryInPropertyGrid) {
            var languagesString_1 = _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.translationLanguages");
            var action_1 = new _utils_actions__WEBPACK_IMPORTED_MODULE_4__.MenuButton({
                id: "pg-languages",
                tooltip: languagesString_1,
                iconName: "pg-general-24x24",
                active: true,
                pressed: false,
                action: function () {
                    _this.creator.sidebar.expandSidebar();
                    _this.creator.sidebar.header.subTitle = languagesString_1;
                    action_1.active = true;
                }
            });
            this.tabControlModel.topToolbar.setItems([action_1]);
            this.creator.sidebar.header.subTitle = languagesString_1;
        }
    };
    TabTranslationPlugin.prototype.createMergeLocaleWithDefaultActionTitleUpdater = function () {
        var _this = this;
        return new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () {
            var loc = _this.creator.locale;
            if (!loc)
                loc = "en";
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.translationMergeLocaleWithDefault")["format"](survey_core__WEBPACK_IMPORTED_MODULE_0__.surveyLocalization.defaultLocale);
        });
    };
    Object.defineProperty(TabTranslationPlugin.prototype, "selectLanguageOptionsCaption", {
        get: function () {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.translationAddLanguage");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabTranslationPlugin.prototype, "showAllStringsText", {
        get: function () {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.translationShowAllStrings");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabTranslationPlugin.prototype, "showUsedStringsOnlyText", {
        get: function () {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.translationShowUsedStringsOnly");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabTranslationPlugin.prototype, "showAllPagesText", {
        get: function () {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.translationShowAllPages");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabTranslationPlugin.prototype, "exportToCSVText", {
        get: function () {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.translationExportToSCVButton");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabTranslationPlugin.prototype, "importFromCSVText", {
        get: function () {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.translationImportFromSCVButton");
        },
        enumerable: false,
        configurable: true
    });
    TabTranslationPlugin.prototype.createActions = function () {
        var _this = this;
        var items = [];
        this.createFilterPageAction();
        items.push(this.filterPageAction);
        this.createFilterStringsAction();
        items.push(this.filterStringsAction);
        this.mergeLocaleWithDefaultAction = new survey_core__WEBPACK_IMPORTED_MODULE_0__.Action({
            id: "svd-translation-merge_locale_withdefault",
            visible: false,
            component: "sv-action-bar-item",
            mode: "small",
            needSeparator: true,
            action: function () {
                _this.model.mergeLocaleWithDefault();
            }
        });
        items.push(this.mergeLocaleWithDefaultAction);
        this.importCsvAction = (0,_translation__WEBPACK_IMPORTED_MODULE_2__.createImportCSVAction)(function () { _this.model.importFromCSVFileDOM(); }, true);
        this.importCsvAction.enabled = (new survey_core__WEBPACK_IMPORTED_MODULE_0__.ComputedUpdater(function () { return !_this.creator.readOnly; }));
        this.importCsvAction.visible = false;
        items.push(this.importCsvAction);
        this.exportCsvAction = (0,_translation__WEBPACK_IMPORTED_MODULE_2__.createExportCSVAction)(function () { _this.model.exportToCSVFileUI(); });
        this.exportCsvAction.visible = false;
        items.push(this.exportCsvAction);
        return items;
    };
    TabTranslationPlugin.prototype.createFilterPageAction = function () {
        var _this = this;
        this.filterPageAction = (0,survey_core__WEBPACK_IMPORTED_MODULE_0__.createDropdownActionModel)({
            id: "svc-translation-filter-page",
            title: this.getFilterPageActionTitle(),
            visible: false,
            mode: "small",
        }, {
            items: [{ id: null, title: this.showAllPagesText }],
            allowSelection: true,
            onSelectionChanged: function (item) {
                _this.model.filteredPage = !!item.id ? _this.creator.survey.getPageByName(item.id) : null;
            },
            horizontalPosition: "center",
            cssClass: "svc-creator-popup",
        });
    };
    TabTranslationPlugin.prototype.createFilterStringsAction = function () {
        var _this = this;
        this.filterStringsAction = (0,survey_core__WEBPACK_IMPORTED_MODULE_0__.createDropdownActionModel)({
            id: "svc-translation-show-all-strings",
            title: this.getFilterStringsActionTitle(),
            visible: false,
            mode: "small",
        }, {
            items: [{ id: "show-all-strings", locTitleName: "ed.translationShowAllStrings" }, { id: "show-used-strings-only", locTitleName: "ed.translationShowUsedStringsOnly" }],
            allowSelection: true,
            onSelectionChanged: function (item) {
                _this.model.showAllStrings = item.id === "show-all-strings";
            },
            horizontalPosition: "center",
            cssClass: "svc-creator-popup",
        });
    };
    TabTranslationPlugin.prototype.updateFilterStrigsAction = function (updateSelectedItem) {
        if (updateSelectedItem === void 0) { updateSelectedItem = false; }
        var title = this.getFilterStringsActionTitle();
        this.filterStringsAction.title = title;
        if (updateSelectedItem) {
            this.filterStringsAction.needSeparator = this.filterPageAction.visible;
            var list = this.filterStringsAction.data;
            list.selectedItem = list.actions.filter(function (el) { return el.title === title; })[0];
        }
    };
    TabTranslationPlugin.prototype.updateFilterPageAction = function (updateSelectedItem) {
        if (updateSelectedItem === void 0) { updateSelectedItem = false; }
        this.filterPageAction.title = this.getFilterPageActionTitle();
        if (updateSelectedItem) {
            var list = this.filterPageAction.data;
            var id_1 = this.model.filteredPage ? this.model.filteredPage.name : null;
            list.selectedItem = list.actions.filter(function (el) { return el.id === id_1; })[0];
        }
    };
    TabTranslationPlugin.prototype.getFilterPageActionTitle = function () {
        var pageDisplayName = this.model && this.model.filteredPage && this.getPageDisplayText(this.model.filteredPage);
        return pageDisplayName || this.showAllPagesText;
    };
    TabTranslationPlugin.prototype.getFilterStringsActionTitle = function () {
        return (this.model && !this.model.showAllStrings) ? this.showUsedStringsOnlyText : this.showAllStringsText;
    };
    TabTranslationPlugin.prototype.getPageDisplayText = function (page) {
        return this.creator.getObjectDisplayName(page, "translation-tab", "survey-translation", page.title);
    };
    return TabTranslationPlugin;
}());



/***/ }),

/***/ "./src/components/tabs/translation-theme.ts":
/*!**************************************************!*\
  !*** ./src/components/tabs/translation-theme.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   translationCss: () => (/* binding */ translationCss)
/* harmony export */ });
var translationCss = {
    root: "st-root-modern",
    container: "st-container-modern",
    header: "st-title st-container-modern__title",
    body: "st-body",
    bodyEmpty: "st-body st-body--empty",
    footer: "st-footer st-body__footer st-clearfix",
    title: "",
    description: "",
    logo: "st-logo",
    logoImage: "st-logo__image",
    headerText: "st-header__text",
    navigationButton: "",
    bodyNavigationButton: "st-navigation-btn",
    completedPage: "st-completedpage",
    navigation: {
        complete: "st-btn st-footer__complete-btn",
        prev: "st-btn st-footer__prev-btn",
        next: "st-btn st-footer__next-btn",
        start: "st-btn st-footer__start-btn",
        preview: "st-btn st-footer__preview-btn",
        edit: "st-btn st-footer__edit-btn"
    },
    panel: {
        title: "st-title st-panel__title",
        titleExpandable: "st-panel__title--expandable",
        titleOnExpand: "st-panel__title--expanded",
        titleOnError: "st-panel__title--error",
        description: "st-description st-panel__description",
        container: "st-element st-panel st-row__panel",
        content: "st-panel__content",
        icon: "st-panel__icon",
        iconExpanded: "st-panel__icon--expanded",
        footer: "st-panel__footer",
        requiredText: "st-panel__required-text"
    },
    paneldynamic: {
        root: "st-paneldynamic",
        navigation: "st-paneldynamic__navigation",
        title: "st-title st-question__title",
        button: "st-btn",
        buttonRemove: "st-paneldynamic__remove-btn",
        buttonAdd: "st-paneldynamic__add-btn",
        progressTop: "st-paneldynamic__progress st-paneldynamic__progress--top",
        progressBottom: "st-paneldynamic__progress st-paneldynamic__progress--bottom",
        buttonPrev: "st-paneldynamic__prev-btn",
        buttonNext: "st-paneldynamic__next-btn",
        progressContainer: "st-paneldynamic__progress-container",
        progress: "st-progress",
        progressBar: "st-progress__bar",
        progressText: "st-paneldynamic__progress-text",
        separator: "st-paneldynamic__separator",
        panelWrapper: "st-paneldynamic__panel-wrapper",
        panelWrapperInRow: "st-paneldynamic__panel-wrapper--in-row"
    },
    progress: "st-progress st-body__progress",
    progressBar: "st-progress__bar",
    progressText: "st-progress__text",
    progressTextInBar: "st-hidden",
    page: {
        root: "st-page st-body__page",
        title: "st-title st-page__title",
        description: "st-description st-page__description"
    },
    pageTitle: "st-title st-page__title",
    pageDescription: "st-description st-page__description",
    row: "st-row st-clearfix",
    question: {
        mainRoot: "st-element st-question st-row__question",
        flowRoot: "st-element st-question st-row__question st-row__question--flow",
        asCell: "st-table__cell",
        header: "st-question__header",
        headerLeft: "st-question__header--location--left",
        headerTop: "st-question__header--location--top",
        headerBottom: "st-question__header--location--bottom",
        content: "st-question__content",
        contentLeft: "st-question__content--left",
        titleLeftRoot: "",
        titleOnAnswer: "st-question__title--answer",
        titleOnError: "st-question__title--error",
        title: "st-title st-question__title",
        requiredText: "st-question__required-text",
        number: "st-question__num",
        description: "st-description st-question__description",
        descriptionUnderInput: "st-description st-question__description",
        comment: "st-comment",
        required: "st-question--required",
        titleRequired: "st-question__title--required",
        indent: 20,
        footer: "st-question__footer",
        formGroup: "st-question__form-group",
        hasError: "",
        disabled: "st-question--disabled"
    },
    image: { root: "st-image", image: "sv_image_image" },
    error: {
        root: "st-question__erbox",
        icon: "",
        item: "",
        locationTop: "st-question__erbox--location--top",
        locationBottom: "st-question__erbox--location--bottom"
    },
    checkbox: {
        root: "st-selectbase",
        item: "st-item st-checkbox st-selectbase__item",
        itemSelectAll: "st-checkbox--selectall",
        itemNone: "st-checkbox--none",
        itemDisabled: "st-item--disabled st-checkbox--disabled",
        itemChecked: "st-item--checked st-checkbox--checked",
        itemHover: "st-item--allowhover st-checkbox--allowhover",
        itemInline: "st-selectbase__item--inline",
        label: "st-selectbase__label",
        labelChecked: "",
        itemControl: "st-visuallyhidden st-item__control st-checkbox__control",
        itemDecorator: "st-item__svg st-checkbox__svg",
        controlLabel: "st-item__control-label",
        materialDecorator: "st-item__decorator st-checkbox__decorator",
        other: "st-comment st-question__other",
        column: "st-selectbase__column"
    },
    radiogroup: {
        root: "st-selectbase",
        item: "st-item st-radio st-selectbase__item",
        itemInline: "st-selectbase__item--inline",
        label: "st-selectbase__label",
        labelChecked: "",
        itemDisabled: "st-item--disabled st-radio--disabled",
        itemChecked: "st-item--checked st-radio--checked",
        itemHover: "st-item--allowhover st-radio--allowhover",
        itemControl: "st-visuallyhidden st-item__control st-radio__control",
        itemDecorator: "st-item__svg st-radio__svg",
        controlLabel: "st-item__control-label",
        materialDecorator: "st-item__decorator st-radio__decorator",
        other: "st-comment st-question__other",
        clearButton: "st-btn st-selectbase__clear-btn",
        column: "st-selectbase__column"
    },
    boolean: {
        mainRoot: "st-question st-row__question st-question--boolean",
        root: "",
        item: "st-boolean",
        control: "st-boolean__control st-visuallyhidden",
        itemChecked: "st-boolean--checked",
        itemIndeterminate: "st-boolean--indeterminate",
        itemDisabled: "st-boolean--disabled",
        label: "st-boolean__label",
        switch: "st-boolean__switch",
        disabledLabel: "st-checkbox__label--disabled",
        itemDecorator: "st-checkbox__hidden",
        materialDecorator: "st-checkbox__rectangle",
        sliderText: "",
        slider: "st-boolean__thumb"
    },
    text: {
        root: "st-input st-text",
        small: "st-row__question--small",
        controlDisabled: "st-input--disabled",
        onError: "st-input--error"
    },
    multipletext: {
        root: "st-multipletext",
        item: "st-multipletext__item",
        itemTitle: "st-multipletext__item-title",
        row: "st-multipletext__row",
        cell: "st-multipletext__cell"
    },
    dropdown: {
        root: "st-selectbase",
        popup: "st-dropdown-popup svc-creator-popup",
        small: "st-row__question--small",
        control: "st-input st-dropdown",
        other: "st-comment st-question__other",
        onError: "st-input--error",
        label: "st-selectbase__label",
        item: "st-item st-radio st-selectbase__item",
        itemDisabled: "st-item--disabled st-radio--disabled",
        itemChecked: "st-item--checked st-radio--checked",
        itemHover: "st-item--allowhover st-radio--allowhover",
        itemControl: "st-visuallyhidden st-item__control st-radio__control",
        itemDecorator: "st-item__svg st-radio__svg",
        controlDisabled: "st-input--disabled",
        controlLabel: "st-item__control-label",
        materialDecorator: "st-item__decorator st-radio__decorator"
    },
    imagepicker: {
        root: "st-imagepicker",
        item: "st-imagepicker__item",
        itemInline: "st-imagepicker__item--inline",
        itemChecked: "st-imagepicker__item--checked",
        itemDisabled: "st-imagepicker__item--disabled",
        itemHover: "st-imagepicker__item--allowhover",
        label: "st-imagepicker__label",
        itemControl: "st-imagepicker__control",
        image: "st-imagepicker__image",
        itemText: "st-imagepicker__text",
        clearButton: "st-btn",
        other: "st-comment st-question__other"
    },
    matrix: {
        mainRoot: "st-question st-row__question st-scrollable",
        tableWrapper: "st-matrix",
        root: "st-table",
        noHeader: "st-table--no-header",
        rowError: "st-matrix__row--error",
        cell: "st-table__cell st-matrix__cell",
        headerCell: "st-table__cell st-table__cell--header",
        rowTextCell: "st-table__cell st-table__cell--row-text",
        label: "st-item st-radio st-matrix__label",
        itemValue: "st-visuallyhidden st-item__control st-radio__control",
        itemChecked: "st-radio--checked",
        itemDisabled: "st-item--disabled st-radio--disabled",
        itemHover: "st-radio--allowhover",
        materialDecorator: "st-item__decorator st-radio__decorator",
        itemDecorator: "st-item__svg st-radio__svg",
        cellText: "st-matrix__text",
        cellTextSelected: "st-matrix__text--checked",
        cellTextDisabled: "st-matrix__text--disabled"
    },
    matrixdropdown: {
        mainRoot: "st-question st-row__question st-scrollable",
        root: "st-table",
        noHeader: "st-table--no-header",
        cell: "st-table__cell",
        headerCell: "st-table__cell st-table__cell--header",
        rowTextCell: "st-table__cell st-table__cell--row-text"
    },
    matrixdynamic: {
        mainRoot: "st-question st-row__question st-scrollable",
        root: "st-table st-matrixdynamic",
        noHeader: "st-table--no-header",
        cell: "st-table__cell",
        headerCell: "st-table__cell st-table__cell--header",
        rowTextCell: "st-table__cell st-table__cell--row-text",
        button: "st-btn",
        detailRow: "st-table__row st-table__row--detail",
        detailButton: "st-table__cell--detail-button",
        detailButtonExpanded: "st-table__cell--detail-button--expanded",
        detailIcon: "st-detail-panel__icon",
        detailIconExpanded: "st-detail-panel__icon--expanded",
        detailPanelCell: "st-table__cell--detail-panel",
        actionsCell: "st-table__cell st-table__cell--actions",
        buttonAdd: "st-matrixdynamic__add-btn",
        buttonRemove: "st-matrixdynamic__remove-btn",
        iconAdd: "",
        iconRemove: ""
    },
    rating: {
        root: "st-rating",
        item: "st-rating__item",
        itemHover: "st-rating__item--allowhover",
        selected: "st-rating__item--selected",
        minText: "st-rating__item-text st-rating__min-text",
        itemText: "st-rating__item-text",
        maxText: "st-rating__item-text st-rating__max-text",
        itemDisabled: "st-rating__item--disabled"
    },
    comment: {
        root: "st-comment",
        small: "st-row__question--small"
    },
    expression: "",
    file: {
        root: "st-file",
        other: "st-comment st-question__other",
        placeholderInput: "st-visuallyhidden",
        preview: "st-file__preview",
        fileSign: "st-hidden",
        fileSignBottom: "st-file__sign",
        fileDecorator: "st-file__decorator",
        fileInput: "st-visuallyhidden",
        noFileChosen: "st-description st-file__no-file-chosen",
        chooseFile: "st-btn st-file__choose-btn",
        disabled: "st-file__choose-btn--disabled",
        removeButton: "st-hidden",
        removeButtonBottom: "st-btn st-file__clean-btn",
        removeFile: "st-hidden",
        removeFileSvg: "st-file__remove-svg",
        wrapper: "st-file__wrapper"
    },
    signaturepad: {
        root: "st-signaturepad sjs_sp_container",
        small: "st-row__question--small",
        controls: "sjs_sp_controls",
        placeholder: "sjs_sp_placeholder",
        clearButton: "sjs_sp_clear"
    },
    saveData: {
        root: "",
        saving: "",
        error: "",
        success: "",
        saveAgainButton: ""
    },
    window: {
        root: "sv_window",
        body: "sv_window_content",
        header: {
            root: "sv_window_title",
            title: "",
            button: "",
            buttonExpanded: "",
            buttonCollapsed: ""
        }
    }
};


/***/ }),

/***/ "./src/components/tabs/translation.ts":
/*!********************************************!*\
  !*** ./src/components/tabs/translation.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Translation: () => (/* binding */ Translation),
/* harmony export */   TranslationEditor: () => (/* binding */ TranslationEditor),
/* harmony export */   TranslationForEditor: () => (/* binding */ TranslationForEditor),
/* harmony export */   TranslationGroup: () => (/* binding */ TranslationGroup),
/* harmony export */   TranslationItem: () => (/* binding */ TranslationItem),
/* harmony export */   TranslationItemBase: () => (/* binding */ TranslationItemBase),
/* harmony export */   TranslationItemString: () => (/* binding */ TranslationItemString),
/* harmony export */   createExportCSVAction: () => (/* binding */ createExportCSVAction),
/* harmony export */   createImportCSVAction: () => (/* binding */ createImportCSVAction)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var papaparse__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! papaparse */ "./node_modules/papaparse/papaparse.min.js");
/* harmony import */ var papaparse__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(papaparse__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _property_grid_index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../../property-grid/index */ "./src/property-grid/index.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../../survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../../property-grid-theme/property-grid */ "./src/property-grid-theme/property-grid.ts");
/* harmony import */ var _translation_theme__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./translation-theme */ "./src/components/tabs/translation-theme.ts");
/* harmony import */ var _utils_actions__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../../utils/actions */ "./src/utils/actions.ts");
/* harmony import */ var _action_container_view_model__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../action-container-view-model */ "./src/components/action-container-view-model.ts");






__webpack_require__(/*! ./translation.scss */ "./src/components/tabs/translation.scss");





var isLocaleEnableIfExecuting;
function localeEnableIf(params) {
    if (isLocaleEnableIfExecuting || !this.question || !this.row)
        return false;
    var matrix = this.question.parentQuestion;
    if (!matrix)
        return false;
    isLocaleEnableIfExecuting = true;
    var index = matrix.visibleRows.indexOf(this.row);
    isLocaleEnableIfExecuting = false;
    if (index <= 0)
        return false;
    var val = matrix.value;
    if (!Array.isArray(val))
        return true;
    var rowVal = val[index];
    if (!rowVal || rowVal.isSelected)
        return true;
    var selectedCounter = 0;
    for (var i = 1; i < val.length; i++) {
        if (val[i].isSelected)
            selectedCounter++;
    }
    return selectedCounter < _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.translation.maximumSelectedLocales;
}
survey_core__WEBPACK_IMPORTED_MODULE_1__.FunctionFactory.Instance.register("localeEnableIf", localeEnableIf);
var TranslationItemBase = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TranslationItemBase, _super);
    function TranslationItemBase(name, translation) {
        var _this = _super.call(this) || this;
        _this.name = name;
        _this.translation = translation;
        return _this;
    }
    Object.defineProperty(TranslationItemBase.prototype, "isGroup", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    TranslationItemBase.prototype.fillLocales = function (locales) { };
    TranslationItemBase.prototype.mergeLocaleWithDefault = function (loc) { };
    TranslationItemBase.prototype.makeObservable = function () {
        this.fireOnObjCreating();
    };
    TranslationItemBase.prototype.deleteLocaleStrings = function (locale) { };
    TranslationItemBase.prototype.applyEditLocale = function (locale) { };
    TranslationItemBase.prototype.fireOnObjCreating = function (obj) {
        if (obj === void 0) { obj = null; }
        if (this.translation) {
            if (!obj)
                obj = this;
            this.translation.fireOnObjCreating(obj);
        }
    };
    return TranslationItemBase;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));

var TranslationItemString = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TranslationItemString, _super);
    function TranslationItemString(locString, locale) {
        var _this = _super.call(this) || this;
        _this.locString = locString;
        _this.locale = locale;
        _this.text = _this.locString.getLocaleText(_this.locale);
        return _this;
    }
    TranslationItemString.prototype.onPropertyValueChanged = function (name, oldValue, newValue) {
        _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
        if (!this.isReadOnly && name === "text") {
            this.locString.setLocaleText(this.locale, newValue);
        }
    };
    TranslationItemString.prototype.getType = function () {
        return "translationitemstring";
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], TranslationItemString.prototype, "text", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], TranslationItemString.prototype, "placeholder", void 0);
    return TranslationItemString;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));

var TranslationItem = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TranslationItem, _super);
    function TranslationItem(name, locString, defaultValue, translation, context, property) {
        if (defaultValue === void 0) { defaultValue = ""; }
        if (property === void 0) { property = null; }
        var _this = _super.call(this, name, translation) || this;
        _this.name = name;
        _this.locString = locString;
        _this.defaultValue = defaultValue;
        _this.context = context;
        _this.property = property;
        if (!!_this.translation) {
            _this.readOnly = _this.translation.readOnly;
        }
        _this.hashValues = {};
        var self = _this;
        _this.afterRender = function (el, data) {
            if (!!self.translation) {
                self.translation.translateItemAfterRender(self, el, data.locale);
            }
        };
        _this.fireOnObjCreating();
        return _this;
    }
    Object.defineProperty(TranslationItem.prototype, "maxLength", {
        get: function () {
            return !!this.property ? this.property.maxLength : -1;
        },
        enumerable: false,
        configurable: true
    });
    TranslationItem.prototype.makeObservable = function () {
        _super.prototype.makeObservable.call(this);
        for (var loc in this.hashValues) {
            this.fireOnObjCreating(this.hashValues[loc]);
        }
    };
    TranslationItem.prototype.getType = function () {
        return "translationitem";
    };
    Object.defineProperty(TranslationItem.prototype, "text", {
        get: function () {
            return !!this.customText ? this.customText : this.localizableName;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationItem.prototype, "localizableName", {
        get: function () {
            var type = this.context && this.context.getType && this.context.getType();
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getPropertyNameInEditor(type, this.name);
        },
        enumerable: false,
        configurable: true
    });
    TranslationItem.prototype.getLocText = function (loc) {
        return this.locString.getLocaleText(loc);
    };
    TranslationItem.prototype.setLocText = function (loc, newValue) {
        this.locString.setLocaleText(loc, newValue);
        !!this.translation.tranlationChangedCallback &&
            this.translation.tranlationChangedCallback(loc, this.name, newValue, this.context);
    };
    TranslationItem.prototype.applyEditLocale = function (locale) {
        var itemStr = this.values(locale);
        if (!!itemStr && !!itemStr.text) {
            this.setLocText(locale, itemStr.text);
        }
    };
    TranslationItem.prototype.values = function (loc) {
        var _a;
        if (!this.hashValues[loc]) {
            var val = new TranslationItemString(this.locString, loc);
            val.isReadOnly = !!((_a = this.translation) === null || _a === void 0 ? void 0 : _a.getEditLocale());
            if (!loc) {
                val.placeholder = this.defaultValue;
            }
            this.hashValues[loc] = val;
            this.fireOnObjCreating(val);
        }
        return this.hashValues[loc];
    };
    TranslationItem.prototype.fillLocales = function (locales) {
        var keys = this.getKeys();
        for (var i = 0; i < keys.length; i++) {
            var key = keys[i];
            if (!!key &&
                locales.indexOf(key) < 0 &&
                key !== survey_core__WEBPACK_IMPORTED_MODULE_1__.LocalizableString.defaultLocale) {
                locales.push(key);
            }
        }
    };
    TranslationItem.prototype.toJSON = function () {
        var _this = this;
        var json = this.locString.getJson();
        var keys = Object.keys(this.hashValues);
        if (keys.length > 0) {
            keys.forEach(function (loc) {
                var text = _this.hashValues[loc].text;
                if (!!text) {
                    if (!json)
                        json = {};
                    if (typeof json === "string") {
                        json = { default: json };
                    }
                    json[loc] = text;
                }
            });
        }
        json = this.correctJSON(json);
        if (!json || typeof json === "string")
            return { default: json };
        return json;
    };
    TranslationItem.prototype.correctJSON = function (json) {
        if (!json || typeof json === "string")
            return json;
        if (Array.isArray(json))
            return json.join("\n");
        for (var key in json) {
            if (Array.isArray(json[key])) {
                json[key] = json[key].join("\n");
            }
        }
        return json;
    };
    TranslationItem.prototype.getKeys = function () {
        return this.locString.getLocales();
    };
    TranslationItem.prototype.mergeLocaleWithDefault = function (loc) {
        var locText = this.locString.getLocaleText(loc);
        if (!locText)
            return;
        this.locString.setLocaleText("", locText);
        this.locString.setLocaleText(loc, null);
    };
    TranslationItem.prototype.deleteLocaleStrings = function (locale) {
        this.setLocText(locale, undefined);
    };
    TranslationItem.prototype.getDefaultLocaleText = function (ignorePlaceHolder) {
        if (ignorePlaceHolder === void 0) { ignorePlaceHolder = false; }
        var res = this.locString.getLocaleText("");
        if (!res) {
            res = this.getPlaceholder("", ignorePlaceHolder);
        }
        return res;
    };
    TranslationItem.prototype.getPlaceholder = function (locale, ignorePlaceHolder) {
        if (ignorePlaceHolder === void 0) { ignorePlaceHolder = false; }
        var textLocale = !!locale && locale !== "default" ? locale : survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.defaultLocale;
        var placeholderText = !ignorePlaceHolder ? _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.translationPlaceHolder", textLocale) : "";
        if (this.context instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.SurveyModel) {
            return survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.getString(this.name, locale) || placeholderText;
        }
        if (!(this.context instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.PageModel) && this.name === "title") {
            return this.getPlaceholderText(locale) || this.context.name;
        }
        if (this.context.ownerPropertyName === "choices" && this.context.getType() === "itemvalue") {
            return this.getPlaceholderText(locale) || this.getItemValuePlaceholderText() || placeholderText;
        }
        return placeholderText;
    };
    TranslationItem.prototype.getTextForExport = function (loc) {
        var res = this.locString.getLocaleText(loc);
        if (!!res)
            return res;
        var index = loc.indexOf("-");
        if (index < 0)
            return "";
        return this.getPlaceholderText(loc);
    };
    TranslationItem.prototype.getPlaceholderText = function (loc) {
        if (!loc || loc === "default")
            return "";
        var root = this.getRootDialect(loc);
        return this.locString.getLocaleText(root);
    };
    TranslationItem.prototype.getRootDialect = function (loc) {
        var index = loc.indexOf("-");
        if (index < 0)
            return "";
        loc = loc.substring(0, index);
        return loc === survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.defaultLocale ? "" : loc;
    };
    TranslationItem.prototype.getItemValuePlaceholderText = function () {
        var val = this.context.value;
        return !survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(val) ? val.toString() : "";
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], TranslationItem.prototype, "readOnly", void 0);
    return TranslationItem;
}(TranslationItemBase));

var TranslationGroup = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TranslationGroup, _super);
    function TranslationGroup(name, obj, translation, text, hasIndent) {
        if (translation === void 0) { translation = null; }
        if (text === void 0) { text = ""; }
        if (hasIndent === void 0) { hasIndent = false; }
        var _this = _super.call(this, name, translation) || this;
        _this.name = name;
        _this.obj = obj;
        _this.text = text;
        _this.hasIndent = hasIndent;
        _this.isRootValue = false;
        _this.removeLocale = function (loc) {
            _this.translation && _this.translation.removeLocale(loc);
        };
        if (!_this.text) {
            _this.text = name;
        }
        _this.reset();
        _this.fireOnObjCreating();
        return _this;
    }
    TranslationGroup.prototype.getType = function () {
        return "translationgroup";
    };
    Object.defineProperty(TranslationGroup.prototype, "items", {
        get: function () {
            return this.itemValues;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "locItems", {
        get: function () {
            return this.itemValues.filter(function (item) { return item instanceof TranslationItem; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "allLocItems", {
        get: function () {
            var res = new Array();
            this.fillLocItems(res);
            return res;
        },
        enumerable: false,
        configurable: true
    });
    TranslationGroup.prototype.fillLocItems = function (items) {
        this.itemValues.forEach(function (item) {
            if (item.isGroup) {
                item.fillLocItems(items);
            }
            else {
                items.push(item);
            }
        });
    };
    Object.defineProperty(TranslationGroup.prototype, "isRoot", {
        get: function () {
            return this.isRootValue;
        },
        enumerable: false,
        configurable: true
    });
    TranslationGroup.prototype.setAsRoot = function () {
        this.isRootValue = true;
    };
    TranslationGroup.prototype.setParent = function (parent) {
        this.parentValue = parent;
    };
    Object.defineProperty(TranslationGroup.prototype, "parent", {
        get: function () { return this.parentValue; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "fullName", {
        get: function () {
            var propsName = this.obj.name === this.name || this.isRoot ? "_props" : "";
            var name = this.name + propsName;
            if (this.isRoot || !this.parent)
                return name;
            var parentName = this.parent.getNameForChild();
            return (!!parentName ? parentName + "_" : "") + name;
        },
        enumerable: false,
        configurable: true
    });
    TranslationGroup.prototype.getNameForChild = function () {
        if (this.isRoot)
            return "";
        return this.isFinalNameObj ? this.name : this.fullName;
    };
    Object.defineProperty(TranslationGroup.prototype, "isFinalNameObj", {
        get: function () {
            return this.obj.isQuestion || this.obj.isPage || this.obj.isPanel;
        },
        enumerable: false,
        configurable: true
    });
    TranslationGroup.prototype.getItemByName = function (name) {
        for (var i = 0; i < this.itemValues.length; i++) {
            if (this.itemValues[i].name == name)
                return this.itemValues[i];
        }
        return null;
    };
    Object.defineProperty(TranslationGroup.prototype, "groups", {
        get: function () {
            return this.itemValues.filter(function (item) { return item instanceof TranslationGroup; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "isGroup", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "locales", {
        get: function () {
            return !!this.translation ? this.translation.locales : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "removeLocaleText", {
        get: function () {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("pe.remove");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "localeCount", {
        get: function () {
            return !!Array.isArray(this.locales) ? this.locales.length : 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "locWidth", {
        get: function () {
            var count = this.localeCount;
            if (count < 2)
                return "100%";
            return Math.floor(100 / count).toString() + "%";
        },
        enumerable: false,
        configurable: true
    });
    TranslationGroup.prototype.getLocaleName = function (loc) {
        return this.translation
            ? this.translation.getLocaleName(loc)
            : _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getLocaleName(loc);
    };
    TranslationGroup.prototype.reset = function () {
        this.itemValues = [];
        this.fillItems();
    };
    TranslationGroup.prototype.fillLocales = function (locales) {
        for (var i = 0; i < this.items.length; i++) {
            this.items[i].fillLocales(locales);
        }
    };
    TranslationGroup.prototype.makeObservable = function () {
        _super.prototype.makeObservable.call(this);
        for (var i = 0; i < this.items.length; i++) {
            this.items[i].makeObservable();
        }
    };
    Object.defineProperty(TranslationGroup.prototype, "showAllStrings", {
        get: function () {
            return !!this.translation ? this.translation.showAllStrings : true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TranslationGroup.prototype, "hasItems", {
        get: function () {
            if (this.locItems.length > 0)
                return true;
            var groups = this.groups;
            for (var i = 0; i < groups.length; i++) {
                if (groups[i].hasItems)
                    return true;
            }
            return false;
        },
        enumerable: false,
        configurable: true
    });
    TranslationGroup.prototype.mergeLocaleWithDefault = function (loc) {
        this.itemValues.forEach(function (item) { return item.mergeLocaleWithDefault(loc); });
    };
    TranslationGroup.prototype.deleteLocaleStrings = function (locale) {
        this.items.forEach(function (item) { return item.deleteLocaleStrings(locale); });
    };
    TranslationGroup.prototype.applyEditLocale = function (locale) {
        this.items.forEach(function (item) { return item.applyEditLocale(locale); });
    };
    TranslationGroup.prototype.fillItems = function () {
        if (this.isItemValueArray(this.obj)) {
            this.createItemValuesLocale();
            return;
        }
        if (!this.obj || !this.obj.getType)
            return;
        var properties = this.getLocalizedProperties(this.obj);
        for (var i = 0; i < properties.length; i++) {
            var property = properties[i];
            var item = this.createTranslationItem(this.obj, properties[i]);
            if (!!item) {
                this.itemValues.push(item);
            }
        }
        properties = this.getArrayProperties(this.obj);
        for (var i = 0; i < properties.length; i++) {
            var property = properties[i];
            var value = this.obj[property.name];
            //If ItemValue array?
            if (this.isItemValueArray(value)) {
                if (this.canShowProperty(property, Array.isArray(value) && value.length > 0)) {
                    this.addNewGroup(new TranslationGroup(property.name, value, this.translation, _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getPropertyName(property.name), true));
                }
            }
            else {
                this.createGroups(value, property);
            }
        }
        this.createMatrixCellsGroup();
        this.sortItems();
    };
    TranslationGroup.prototype.createMatrixCellsGroup = function () {
        var _this = this;
        survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.getPropertiesByObj(this.obj).forEach(function (prop) {
            if (prop.type === "cells" && _this.canShowProperty(prop, true)) {
                _this.createMatrixCellsGroupCore(prop);
            }
        });
    };
    TranslationGroup.prototype.createMatrixCellsGroupCore = function (prop) {
        var _this = this;
        var cells = this.obj[prop.name];
        if (cells.isEmpty)
            return;
        var matrix = this.obj;
        var root = new TranslationGroup(prop.name, cells, this.translation, _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getPropertyName(prop.name));
        var defaultName = survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.matrix.defaultRowName;
        var rows = [{ value: defaultName, text: _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("qt.default") }];
        matrix.rows.forEach(function (row) { return rows.push({ value: row.value, text: row.text }); });
        rows.forEach(function (row) {
            matrix.columns.forEach(function (col) {
                var locStr = cells.getCellDisplayLocText(row.value, col);
                if (!!locStr) {
                    var name_1 = _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getPropertyName(row.text, "") + ", " + _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getPropertyName(col.title);
                    var item = new TranslationItem(name_1, locStr, "", _this.translation, locStr);
                    root.items.push(item);
                }
            });
        });
        this.addNewGroup(root);
    };
    TranslationGroup.prototype.sortItems = function () {
        if (!_creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.translation.sortByName)
            return;
        this.itemValues.sort(function (a, b) {
            if (!a.name)
                return -1;
            if (!b.name)
                return 1;
            return a.name.localeCompare(b.name);
        });
    };
    TranslationGroup.prototype.getLocalizedProperties = function (obj) {
        var res = [];
        var properties = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.getPropertiesByObj(obj);
        for (var i = 0; i < properties.length; i++) {
            var property_1 = properties[i];
            if (property_1.readOnly || !property_1.visible || !property_1.isSerializable || !property_1.isLocalizable)
                continue;
            var isShowing = ["url", "file"].indexOf(property_1.type) < 0;
            if (this.canShowProperty(property_1, !!obj[property_1.name], isShowing)) {
                res.push(property_1);
            }
        }
        return res;
    };
    TranslationGroup.prototype.getArrayProperties = function (obj) {
        var res = [];
        var properties = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.getPropertiesByObj(obj);
        for (var i = 0; i < properties.length; i++) {
            var property = properties[i];
            if (property.isSerializable === false)
                continue;
            var value = obj[property.name];
            if (!!value && Array.isArray(value) && value.length > 0) {
                res.push(property);
            }
        }
        return res;
    };
    TranslationGroup.prototype.canShowProperty = function (property, isEmpty, isShowing) {
        if (isShowing === void 0) { isShowing = true; }
        var obj = Array.isArray(this.obj) ? (this.obj.length > 0 ? this.obj[0] : undefined) : this.obj;
        if (!obj)
            return false;
        if (!!this.translation)
            return this.translation.canShowProperty(obj, property, isEmpty, isShowing);
        return isShowing;
    };
    TranslationGroup.prototype.createTranslationItem = function (obj, property) {
        var _a;
        var defaultValue = this.getDefaultValue(obj, property);
        var locStr = obj[property.serializationProperty];
        if (!locStr)
            return null;
        if (!this.showAllStrings && !defaultValue && locStr.isEmpty)
            return null;
        var editLocale = (_a = this.translation) === null || _a === void 0 ? void 0 : _a.getEditLocale();
        if (!!editLocale && !!locStr.getLocaleText(editLocale))
            return null;
        if (!this.canShowProperty(property, locStr.isEmpty))
            return null;
        return new TranslationItem(property.name, locStr, defaultValue, this.translation, obj, property);
    };
    TranslationGroup.prototype.getDefaultValue = function (obj, property) {
        if (property.name == "title" &&
            property.isLocalizable &&
            !!property.serializationProperty) {
            var locStr = obj[property.serializationProperty];
            if (!!locStr &&
                !obj.isPage && !obj.isPanel &&
                (!!locStr.onGetTextCallback || locStr["onRenderedHtmlCallback"]))
                return obj["name"];
        }
        return "";
    };
    TranslationGroup.prototype.isItemValueArray = function (val) {
        return (!!val &&
            Array.isArray(val) &&
            val.length > 0 &&
            !!val[0] &&
            !!val[0]["getType"] &&
            !!val[0]["setData"] &&
            !!val[0]["setLocText"]);
    };
    TranslationGroup.prototype.createGroups = function (value, property) {
        for (var i = 0; i < value.length; i++) {
            var obj = value[i];
            if (!!obj && obj.getType) {
                var name_2 = obj["name"];
                var text = name_2;
                if (!name_2) {
                    var index = "[" + i.toString() + "]";
                    name_2 = property.name + index;
                    text = _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getPropertyName(property.name) + index;
                }
                this.addNewGroup(new TranslationGroup(name_2, obj, this.translation, text));
            }
        }
    };
    TranslationGroup.prototype.addNewGroup = function (group) {
        group.setParent(this);
        if (group.hasItems) {
            this.itemValues.push(group);
        }
    };
    TranslationGroup.prototype.createItemValuesLocale = function () {
        var _a;
        var editMode = (_a = this.translation) === null || _a === void 0 ? void 0 : _a.getEditLocale();
        for (var i = 0; i < this.obj.length; i++) {
            var val = this.obj[i];
            var canAdd = this.showAllStrings || !val.locText.isEmpty || isNaN(val.value);
            if (!!editMode && val.locText.getLocaleText(editMode)) {
                canAdd = false;
            }
            if (!canAdd)
                continue;
            var item = new TranslationItem(val.value, val.locText, val.value, this.translation, val);
            this.itemValues.push(item);
            this.addCustomPropertiesForItemValue(this.obj[i], item);
        }
    };
    TranslationGroup.prototype.addCustomPropertiesForItemValue = function (itemValue, textItem) {
        var locProperties = this.getLocalizedProperties(itemValue);
        for (var i = 0; i < locProperties.length; i++) {
            if (locProperties[i].name == "text")
                continue;
            var item = this.createTranslationItem(itemValue, locProperties[i]);
            if (!!item) {
                item.customText = textItem.text + " (" + item.localizableName + ")";
                item.name = itemValue.value + "." + item.name;
                this.itemValues.push(item);
            }
        }
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], TranslationGroup.prototype, "showHeader", void 0);
    return TranslationGroup;
}(TranslationItemBase));

var Translation = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(Translation, _super);
    function Translation(survey, options, hasUI) {
        if (options === void 0) { options = null; }
        if (hasUI === void 0) { hasUI = true; }
        var _this = _super.call(this) || this;
        _this.options = options;
        _this.hasUI = hasUI;
        _this.chooseLanguageActions = [];
        if (!_this.options)
            _this.options = new _creator_settings__WEBPACK_IMPORTED_MODULE_4__.EmptySurveyCreatorOptions();
        var self = _this;
        _this.exportToCSVFileUI = function () {
            self.exportToSCVFile(_creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.translation.exportFileName);
        };
        _this.importFromCSVFileUI = function (el) {
            if (el.files.length < 1)
                return;
            self.importFromCSVFile(el.files[0]);
            el.value = "";
        };
        _this.settingsSurveyValue = _this.createSettingsSurvey();
        _this.surveyValue = survey;
        _this.setupToolbarItems();
        _this.updateChooseLanguageActions();
        return _this;
    }
    Translation.prototype.getProcessedTranslationItemText = function (locale, locString, newText, context) {
        return this.options.getProcessedTranslationItemText(locale, locString, newText, context);
    };
    Translation.prototype.getType = function () {
        return "translation";
    };
    Translation.prototype.getEditLocale = function () { return this.editLocale; };
    Translation.prototype.setEditMode = function (locale) {
        this.editLocale = locale;
        this.addLocale(locale);
    };
    Object.defineProperty(Translation.prototype, "isEditMode", {
        get: function () { return !!this.editLocale; },
        enumerable: false,
        configurable: true
    });
    Translation.prototype.applyEditLocale = function () {
        if (!this.isEditMode || !this.root)
            return;
        this.root.applyEditLocale(this.editLocale);
    };
    Translation.prototype.makeObservable = function (onBaseObjCreating) {
        this.onBaseObjCreatingCallback = onBaseObjCreating;
        this.fireOnObjCreating(this);
        this.root.makeObservable();
    };
    Translation.prototype.fireOnObjCreating = function (obj) {
        if (!this.onBaseObjCreatingCallback)
            return;
        this.onBaseObjCreatingCallback(obj);
    };
    Object.defineProperty(Translation.prototype, "settingsSurvey", {
        get: function () {
            return this.settingsSurveyValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "localesQuestion", {
        get: function () {
            return (this.settingsSurvey.getQuestionByName("locales"));
        },
        enumerable: false,
        configurable: true
    });
    Translation.prototype.deleteLocaleStrings = function (locale) {
        if (!this.root) {
            this.reset();
        }
        if (!this.root)
            return;
        this.options.startUndoRedoTransaction("Delete strings for locale: " + locale);
        this.root.deleteLocaleStrings(locale);
        this.removeLocale(locale);
        this.reset();
        this.options.stopUndoRedoTransaction();
    };
    Translation.prototype.createSettingsSurvey = function () {
        var _this = this;
        var json = this.getSettingsSurveyJSON();
        (0,_property_grid_index__WEBPACK_IMPORTED_MODULE_5__.setSurveyJSONForPropertyGrid)(json);
        var res = this.options.createSurvey(json, "translation_settings", this, function (survey) {
            survey.css = _property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_7__.propertyGridCss;
            survey.css.root += " st-properties";
            survey.rootCss += " st-properties";
        });
        res.onValueChanged.add(function (sender, options) {
            if (options.name == "locales") {
                _this.updateLocales();
            }
        });
        res.getQuestionByName("locales").lockedRowCount = 1;
        res.onMatrixRowRemoving.add(function (sender, options) {
            _this.removingLocale = options.question.value[options.rowIndex].name;
        });
        res.onMatrixRowRemoved.add(function (sender, options) {
            if (!!_this.removingLocale) {
                _this.deleteLocaleStrings(_this.removingLocale);
            }
        });
        res.onGetQuestionTitleActions.add(function (sender, options) {
            options.titleActions = [_this.addLanguageAction];
        });
        res.onGetMatrixRowActions.add(function (sender, options) {
            (0,_utils_actions__WEBPACK_IMPORTED_MODULE_9__.updateMatrixRemoveAction)(options.question, options.actions, options.row);
            if (_this.options.getHasMachineTranslation() && (0,_utils_actions__WEBPACK_IMPORTED_MODULE_9__.findAction)(options.actions, "remove-row") &&
                Array.isArray(options.question.value)) {
                var q = options.question;
                var rowIndex = q.visibleRows.indexOf(options.row);
                if (rowIndex >= 0 && rowIndex < q.value.length) {
                    var locale_1 = q.value[rowIndex].name;
                    options.actions.splice(0, 0, new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
                        iconName: "icon-language",
                        iconSize: "auto",
                        locTooltipName: "ed.translateUsigAI",
                        visibleIndex: 5,
                        location: "end",
                        action: function () { return _this.showTranslationEditor(locale_1); }
                    }));
                }
            }
            (0,_utils_actions__WEBPACK_IMPORTED_MODULE_9__.updateMatixActionsClasses)(options.actions);
        });
        return res;
    };
    Translation.prototype.calcIsChooseLanguageEnabled = function () {
        this.isChooseLanguageEnabled = this.chooseLanguageActions.filter(function (item) { return item.visible; }).length > 0;
    };
    Translation.prototype.refreshAddLanguageActionListModel = function () {
        var listModel = this.addLanguageAction.data;
        if (listModel) {
            listModel.refresh();
        }
    };
    Translation.prototype.updateLocales = function () {
        var res = [""];
        var val = this.getSelectedLocales();
        if (!Array.isArray(val))
            val = [];
        this.options.translationLocalesOrder = val;
        val.forEach(function (lc) { return res.push(lc); });
        this.locales = res;
        this.canMergeLocaleWithDefault = this.hasLocale(this.defaultLocale);
        this.localesQuestion.allowRowsDragAndDrop = res.length > 2;
    };
    Translation.prototype.getSettingsSurveyJSON = function () {
        return {
            elements: [
                {
                    type: "matrixdynamic",
                    name: "locales",
                    title: _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.translationLanguages"),
                    confirmDelete: true,
                    titleLocation: "top",
                    confirmDeleteText: _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.translationDeleteLanguage"),
                    columns: [
                        { name: "isSelected", cellType: "boolean", renderAs: "checkbox", enableIf: "localeEnableIf()" },
                        { name: "displayName", cellType: "expression", expression: "{row.displayName}" }
                    ],
                    showHeader: false,
                    allowAddRows: false,
                    rowCount: 0
                }
            ]
        };
    };
    Translation.prototype.getSurveyLocales = function () {
        var usedLocales = new Array();
        var sLocales = survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.supportedLocales;
        var locales = Array.isArray(sLocales) && sLocales.length > 0
            ? sLocales
            : survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.getLocales();
        var addedLocales = {};
        for (var i = 0; i < locales.length; i++) {
            this.addLocaleIntoChoices(locales[i], usedLocales, addedLocales);
        }
        locales = this.getVisibleLocales();
        for (var i = 0; i < locales.length; i++) {
            this.addLocaleIntoChoices(locales[i], usedLocales, addedLocales);
        }
        return [usedLocales, locales];
    };
    Translation.prototype.importFromCSVFileDOM = function () {
        var _this = this;
        if (!document)
            return;
        if (!this.inputFileElement) {
            this.inputFileElement = document.createElement("input");
            this.inputFileElement.type = "file";
            this.inputFileElement.style.display = "none";
            this.inputFileElement.onchange = function () {
                _this.importFromCSVFileUI(_this.inputFileElement);
            };
        }
        this.inputFileElement.click();
    };
    Translation.prototype.updateSettingsSurveyLocales = function () {
        var _a = this.getSurveyLocales(), choices = _a[0], locales = _a[1];
        var selectedLocales = [];
        if (!locales)
            locales = [];
        for (var i = 0; i < locales.length; i++) {
            if (!!this.localeInitialVisibleCallback && !this.localeInitialVisibleCallback(locales[i]))
                continue;
            selectedLocales.push(locales[i]);
        }
        var maxLocales = _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.translation.maximumSelectedLocales;
        if (maxLocales > 0 && selectedLocales.length > maxLocales) {
            selectedLocales.splice(maxLocales);
        }
        this.setSelectedLocales(selectedLocales);
    };
    Translation.prototype.resetStringsSurvey = function () {
        if (!this.hasUI)
            return;
        this.stringsSurvey = this.createStringsSurvey();
        this.stringsHeaderSurvey = this.createStringsHeaderSurvey();
        this.updateReadOnly();
    };
    Translation.prototype.getSurveyStringsArea = function () { return undefined; };
    Translation.prototype.getSurveyStringsHeaderArea = function () { return undefined; };
    Translation.prototype.onSurveyStringsCreated = function (survey) { };
    Translation.prototype.onSurveyStringsHeaderCreated = function (survey) { };
    Translation.prototype.createStringsSurvey = function () {
        var _this = this;
        var json = { autoGrowComment: true, allowResizeComment: false };
        (0,_property_grid_index__WEBPACK_IMPORTED_MODULE_5__.setSurveyJSONForPropertyGrid)(json, false);
        var survey = this.options.createSurvey(json, "translation_strings", this, function (survey) {
            survey.lazyRendering = true;
            survey.skeletonComponentName = "sd-translation-line-skeleton";
            survey.startLoadingFromJson();
            survey.css = _translation_theme__WEBPACK_IMPORTED_MODULE_8__.translationCss;
            survey.addNewPage("page");
            _this.addTranslationGroupIntoStringsSurvey(survey.pages[0], _this.root);
            survey.data = _this.getStringsSurveyData(survey);
            survey.endLoadingFromJson();
            _this.onSurveyStringsCreated(survey);
        }, this.getSurveyStringsArea());
        var getTransationItem = function (question, rowName) {
            var itemValue = survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue.getItemByValue(question.rows, rowName);
            return !!itemValue ? itemValue["translationData"] : null;
        };
        survey.onMatrixCellCreated.add(function (sender, options) {
            if (options.cell.question instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionCommentModel) {
                var cellQuestion = options.cell.question;
                var item = getTransationItem(options.question, options.row.name);
                _this.setPlaceHolder(cellQuestion, item, options.columnName);
                var isMultiLine = false;
                if (!!item) {
                    cellQuestion.maxLength = item.maxLength;
                    var loc = item.locString;
                    isMultiLine = loc.getIsMultiple();
                    cellQuestion.acceptCarriageReturn = isMultiLine || loc.allowLineBreaks;
                }
                if (!isMultiLine) {
                    cellQuestion.rows = 1;
                }
            }
        });
        survey.onMatrixCellValueChanging.add(function (_, options) {
            var item = getTransationItem(options.question, options.row.name);
            if (!!item) {
                options.value = _this.getProcessedTranslationItemText(options.columnName, item.locString, options.value, item.context);
            }
        });
        survey.onMatrixCellValueChanged.add(function (sender, options) {
            var item = getTransationItem(options.question, options.row.name);
            if (!!item) {
                item.setLocText(options.columnName, options.value);
                var colName_1 = options.columnName;
                options.row.cells.forEach(function (cell) {
                    if (colName_1 === "default" || cell.column.name.indexOf(colName_1 + "-") === 0)
                        _this.setPlaceHolder(cell.question, item, cell.column.name);
                });
            }
        });
        survey.onUpdatePanelCssClasses.add(function (sender, options) {
            if (options.panel["__translationHasIndent"]) {
                options.cssClasses.panel.content += " st-panel-indent";
            }
        });
        survey.currentPage = survey.pages[0];
        return survey;
    };
    Translation.prototype.setPlaceHolder = function (cellQuestion, item, locale) {
        cellQuestion.placeholder = item.getPlaceholder(locale);
    };
    Translation.prototype.createStringsHeaderSurvey = function () {
        var _this = this;
        var json = {};
        (0,_property_grid_index__WEBPACK_IMPORTED_MODULE_5__.setSurveyJSONForPropertyGrid)(json, false);
        var survey = this.options.createSurvey(json, "translation_strings_header", this, function (survey) {
            survey.css = _translation_theme__WEBPACK_IMPORTED_MODULE_8__.translationCss;
            var newPage = survey.addNewPage("page");
            var matrix = (survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass("matrixdropdown"));
            matrix.name = "stringsHeader";
            matrix.titleLocation = "hidden";
            _this.addLocaleColumns(matrix);
            newPage.addQuestion(matrix, 0);
            survey.currentPage = survey.pages[0];
            _this.onSurveyStringsHeaderCreated(survey);
        }, this.getSurveyStringsHeaderArea());
        return survey;
    };
    Translation.prototype.addTranslationGroupIntoStringsSurvey = function (panel, group) {
        for (var i = 0; i < group.items.length; i++) {
            if (group.items[i].isGroup)
                continue;
            var item = group.items[i];
            var matrix = (survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass("matrixdropdown"));
            matrix.cellType = "comment";
            matrix.titleLocation = "hidden";
            matrix.name = group.fullName + i;
            matrix.showHeader = false;
            panel.addQuestion(matrix);
            this.addLocaleColumns(matrix);
            // let matrix = <QuestionMatrixDropdownModel>panel.questions[0];
            var itemValue = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue(item.name, item.text);
            itemValue["translationData"] = item;
            matrix.rows.push(itemValue);
        }
        for (var i = 0; i < group.items.length; i++) {
            if (!group.items[i].isGroup)
                continue;
            var item = group.items[i];
            var pnl = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass("panel");
            pnl.name = item.name;
            panel.addElement(pnl);
            pnl.title = item.text;
            if (item.hasIndent) {
                pnl["__translationHasIndent"] = true;
            }
            this.addTranslationGroupIntoStringsSurvey(pnl, item);
        }
    };
    Translation.prototype.addLocaleColumns = function (matrix) {
        var locs = this.getSelectedLocales();
        matrix.addColumn("default", this.getLocaleName("")).readOnly = this.isEditMode;
        for (var i = 0; i < locs.length; i++) {
            matrix.addColumn(locs[i], this.getLocaleName(locs[i]));
        }
    };
    Translation.prototype.getStringsSurveyData = function (survey) {
        var res = {};
        var questions = survey.getAllQuestions();
        for (var i = 0; i < questions.length; i++) {
            res[questions[i].name] = this.getStringsQuestionData(questions[i]);
        }
        return res;
    };
    Translation.prototype.updateStringsSurveyData = function () {
        var survey = this.stringsSurvey;
        if (survey) {
            survey.data = this.getStringsSurveyData(survey);
        }
    };
    Translation.prototype.getStringsQuestionData = function (matrix) {
        var res = {};
        for (var i = 0; i < matrix.rows.length; i++) {
            var itemValue = matrix.rows[i];
            var item = itemValue["translationData"];
            var value = item.toJSON();
            if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(value)) {
                res[itemValue.value] = value;
            }
        }
        return res;
    };
    Translation.prototype.updateHeaderStringsSurveyColumns = function () {
        if (!this.stringsHeaderSurvey)
            return;
        var matrix = (this.stringsHeaderSurvey.getQuestionByName("stringsHeader"));
        matrix.columns = [];
        this.addLocaleColumns(matrix);
    };
    Translation.prototype.updateStringsSurveyColumns = function () {
        if (!this.stringsSurvey)
            return;
        var questions = this.stringsSurvey.getAllQuestions();
        for (var i = 0; i < questions.length; i++) {
            var matrix = questions[i];
            matrix.beginUpdate();
            matrix.columns = [];
            this.addLocaleColumns(matrix);
            matrix.endUpdate();
        }
    };
    Translation.prototype.addLocaleIntoChoices = function (loc, choices, addedLocales) {
        if (!loc || addedLocales[loc])
            return;
        addedLocales[loc] = true;
        choices.push(new survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue(loc, this.getLocaleName(loc)));
    };
    Translation.prototype.addLocaleIntoValue = function (loc, updateValue) {
        var visLocs = this.getVisibleLocales();
        if (visLocs.indexOf(loc) < 0) {
            visLocs.push(loc);
            this.setVisibleLocales(visLocs);
        }
        if (updateValue) {
            var selLocs = this.getSelectedLocales();
            if (selLocs.indexOf(loc) < 0 && selLocs.length < _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.translation.maximumSelectedLocales) {
                selLocs.push(loc);
                this.setSelectedLocales(selLocs);
            }
        }
    };
    Translation.prototype.isLocaleVisible = function (locales, locale) {
        return locale !== survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.defaultLocale && locales.indexOf(locale) < 0;
    };
    Translation.prototype.setupToolbarItems = function () {
        var _this = this;
        this.chooseLanguageActions = this.getSurveyLocales()[0].map(function (locale) { return (new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: locale.value,
            title: _this.getLocaleName(locale.value),
            data: locale
        })); });
        this.addLanguageAction = (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.createDropdownActionModel)({
            id: "svc-translation-choose-language",
            iconName: "icon-add",
            iconSize: "auto",
            enabled: (new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.isChooseLanguageEnabled && !_this.readOnly; })),
        }, {
            items: this.chooseLanguageActions,
            allowSelection: false,
            cssClass: "svc-creator-popup",
            onSelectionChanged: function (item) {
                _this.addLocale(item.id);
            }
        });
    };
    Translation.prototype.onPropertyValueChanged = function (name, oldValue, newValue) {
        _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
        if (name === "canMergeLocaleWithDefault") {
            this.mergeLocaleWithDefaultText = this.getMergeLocaleWithDefaultText();
        }
        if (name === "locales") {
            this.updateHeaderStringsSurveyColumns();
            this.updateStringsSurveyColumns();
        }
    };
    Translation.prototype.getMergeLocaleWithDefaultText = function () {
        if (!this.canMergeLocaleWithDefault)
            return "";
        var locText = this.getLocaleName(this.defaultLocale);
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.translationMergeLocaleWithDefault")["format"](locText);
    };
    Object.defineProperty(Translation.prototype, "survey", {
        get: function () {
            return this.surveyValue;
        },
        set: function (val) {
            this.surveyValue = val;
            this.setVisibleLocales([]);
            this.reset();
        },
        enumerable: false,
        configurable: true
    });
    Translation.prototype.reset = function (alwaysReset) {
        if (alwaysReset === void 0) { alwaysReset = true; }
        if (!alwaysReset && !!this.root)
            return;
        var rootObj = !!this.filteredPage ? this.filteredPage : this.survey;
        var rootName = !!this.filteredPage ? rootObj["name"] : "survey";
        this.root = new TranslationGroup(rootName, rootObj, this);
        this.root.setAsRoot();
        this.root.reset();
        this.resetLocales();
        this.isEmpty = !this.root.hasItems;
        this.updateSettingsSurveyLocales();
        this.updateLocales();
        this.resetStringsSurvey();
        this.updateChooseLanguageActions();
    };
    Translation.prototype.updateReadOnly = function () {
        if (this.stringsSurvey) {
            var mode = this.readOnly ? "display" : "edit";
            this.stringsSurvey.mode = mode;
            this.settingsSurvey.mode = mode;
        }
    };
    Translation.prototype.canShowProperty = function (obj, prop, isEmpty, isShowing) {
        if (isShowing === void 0) { isShowing = true; }
        var result = isShowing && (!isEmpty || _survey_helper__WEBPACK_IMPORTED_MODULE_6__.SurveyHelper.isPropertyVisible(obj, prop, this.options));
        return this.translationStringVisibilityCallback ? this.translationStringVisibilityCallback(obj, prop.name, result) : result;
    };
    Object.defineProperty(Translation.prototype, "defaultLocale", {
        get: function () {
            return survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.defaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    Translation.prototype.getLocaleName = function (loc, inEnglish) {
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getLocaleName(loc, this.defaultLocale, inEnglish);
    };
    Translation.prototype.removeLocale = function (locale) {
        if (this.hasLocale(locale)) {
            var index = this.locales.indexOf(locale);
            var locales = this.locales;
            locales.splice(index, 1);
            this.locales = locales;
            this.canMergeLocaleWithDefault = this.hasLocale(this.defaultLocale);
        }
    };
    Translation.prototype.hasLocale = function (locale) {
        return this.locales.indexOf(locale) > -1;
    };
    Translation.prototype.addLocale = function (locale) {
        if (!this.hasLocale(locale)) {
            this.addLocaleIntoValue(locale, true);
        }
        this.updateChooseLanguageActions();
    };
    Translation.prototype.updateChooseLanguageActions = function () {
        var _this = this;
        var actions = this.chooseLanguageActions;
        var locales = this.getVisibleLocales();
        if (Array.isArray(actions)) {
            actions.forEach(function (item) { return item.visible = _this.isLocaleVisible(locales, item.data.value); });
        }
        this.refreshAddLanguageActionListModel();
        this.calcIsChooseLanguageEnabled();
    };
    Translation.prototype.resetLocales = function () {
        var locales = [""];
        this.root.fillLocales(locales);
        var sortedLocales = this.options.translationLocalesOrder;
        if (Array.isArray(sortedLocales) && sortedLocales.length > 0) {
            var sortFunc_1 = function (a, b, arr) {
                var i1 = arr.indexOf(a);
                var i2 = arr.indexOf(b);
                if (i1 < 0)
                    i1 = 100;
                if (i2 < 0)
                    i2 = 100;
                return i1 < i2 ? -1 : (i1 > i2 ? 1 : 0);
            };
            locales.sort(function (a, b) {
                var res = sortFunc_1(a, b, sortedLocales);
                return res === 0 ? sortFunc_1(a, b, locales) : res;
            });
        }
        this.setSelectedAndVisibleLocales(locales, this.getSelectedLocales(), true);
    };
    Translation.prototype.getSelectedLocales = function () {
        return this.getSelectedLocalesCore(true);
    };
    Translation.prototype.setSelectedLocales = function (selectedLocales) {
        this.setSelectedAndVisibleLocales(this.getVisibleLocales(), selectedLocales, true);
    };
    Translation.prototype.getVisibleLocales = function () {
        return this.getSelectedLocalesCore(false);
    };
    Translation.prototype.setVisibleLocales = function (locales) {
        this.setSelectedAndVisibleLocales(locales, this.getSelectedLocales(), false);
    };
    Translation.prototype.getSelectedLocalesCore = function (isSelected) {
        if (!this.localesQuestion)
            return [];
        var val = this.localesQuestion.value;
        if (!Array.isArray(val) || val.length === 0)
            return [];
        var res = [];
        val.forEach(function (item) { if (!!item.name && (!isSelected || item.isSelected))
            res.push(item.name); });
        return res;
    };
    Translation.prototype.setSelectedAndVisibleLocales = function (locales, selectedLocales, includeSelected) {
        var _this = this;
        if (!this.localesQuestion)
            return;
        if (!Array.isArray(selectedLocales))
            selectedLocales = [];
        var val = [];
        if (includeSelected) {
            selectedLocales.forEach(function (sl) { if (locales.indexOf(sl) < 0)
                locales.push(sl); });
        }
        var locDefault = this.defaultLocale;
        val.push({ isSelected: true, name: "", displayName: this.getLocaleName("") });
        if (this.getEditLocale()) {
            val.push({ isSelected: true, name: this.getEditLocale() });
        }
        else {
            locales.forEach(function (loc) {
                if (!!loc) {
                    val.push({ isSelected: loc === locDefault || selectedLocales.indexOf(loc) > -1, name: loc, displayName: _this.getLocaleName(loc) });
                }
            });
        }
        this.localesQuestion.value = val;
    };
    Object.defineProperty(Translation.prototype, "noStringsText", {
        get: function () {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.translationNoStrings");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "placeholderTitleText", {
        get: function () {
            if (this.options.isMobileView)
                return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ed.translationsPlaceholderTitleMobile");
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ed.translationsPlaceholderTitle");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Translation.prototype, "placeholderDescriptionText", {
        get: function () {
            if (this.options.isMobileView)
                return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ed.translationsPlaceholderDescriptionMobile");
            return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.getLocString)("ed.translationsPlaceholderDescription");
        },
        enumerable: false,
        configurable: true
    });
    Translation.prototype.exportToCSV = function () {
        if (!this.root) {
            this.reset();
        }
        var res = [];
        var headerRow = [];
        var visibleLocales = this.locales;
        headerRow.push("description ↓ - language →");
        for (var i = 0; i < visibleLocales.length; i++) {
            headerRow.push(!!visibleLocales[i] ? visibleLocales[i] : "default");
        }
        res.push(headerRow);
        var itemsHash = {};
        this.fillItemsHash("", this.root, itemsHash);
        for (var key in itemsHash) {
            var row = [key];
            var item = itemsHash[key];
            for (var i = 0; i < visibleLocales.length; i++) {
                var loc = visibleLocales[i];
                var val = item.getTextForExport(loc);
                val = !val && i == 0 ? item.defaultValue : val;
                val = this.options.getTranslationExportedText(item.context, item.name, item.locString, loc, val);
                row.push(!val && i == 0 ? item.defaultValue : val);
            }
            res.push(row);
        }
        var prefix = _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.translation.exportPrefix;
        if (!prefix)
            prefix = "";
        return (prefix +
            (0,papaparse__WEBPACK_IMPORTED_MODULE_2__.unparse)(res, {
                quoteChar: '"',
                escapeChar: '"',
                delimiter: Translation.csvDelimiter,
                header: true,
                newline: Translation.newLineDelimiter,
                skipEmptyLines: false,
                columns: null //or array of strings
            }));
    };
    Translation.prototype.importFromNestedArray = function (rows) {
        var _this = this;
        var locales = rows.shift().slice(1);
        if (locales[0] === "default") {
            locales[0] = "";
        }
        var translation = new Translation(this.survey, this.options, false);
        translation.showAllStrings = true;
        var itemsHash = {};
        this.fillItemsHash("", translation.root, itemsHash);
        rows.forEach(function (row) {
            var name = row.shift().trim();
            if (!name)
                return;
            var item = itemsHash[name];
            if (!item)
                return;
            _this.updateItemWithStrings(name, item, row, locales);
        });
        this.reset();
        if (this.importFinishedCallback)
            this.importFinishedCallback();
    };
    Translation.prototype.exportToSCVFile = function (fileName) {
        if (!window)
            return;
        var data = this.exportToCSV();
        var blob = new Blob([data], { type: "text/csv" });
        if (window.navigator["msSaveOrOpenBlob"]) {
            window.navigator["msSaveBlob"](blob, fileName);
        }
        else {
            var elem = window.document.createElement("a");
            elem.href = window.URL.createObjectURL(blob);
            elem.download = fileName;
            document.body.appendChild(elem);
            elem.click();
            document.body.removeChild(elem);
        }
    };
    Translation.prototype.importFromCSVFile = function (file) {
        var self = this;
        (0,papaparse__WEBPACK_IMPORTED_MODULE_2__.parse)(file, {
            complete: function (results, file) {
                self.importFromNestedArray(results.data);
            }
        });
    };
    Translation.prototype.mergeLocaleWithDefault = function () {
        this.reset(false);
        if (!this.hasLocale(this.defaultLocale))
            return;
        this.root.mergeLocaleWithDefault(this.defaultLocale);
        this.setVisibleLocales([]);
        this.setSelectedLocales([]);
        this.reset();
    };
    Translation.prototype.createTranslationEditor = function (locale) {
        var _this = this;
        var res = new TranslationEditor(this.survey, locale, this.options);
        res.onApply = function () {
            _this.reset();
        };
        return res;
    };
    Translation.prototype.showTranslationEditor = function (locale) {
        this.createTranslationEditor(locale).showDialog();
    };
    Translation.prototype.translateItemAfterRender = function (item, el, locale) {
        if (!this.translateItemAfterRenderCallback)
            return;
        if (Array.isArray(el)) {
            for (var i = 0; i < el.length; i++) {
                if (el[i].tagName == "TEXTAREA") {
                    el = el[i];
                    break;
                }
            }
        }
        this.translateItemAfterRenderCallback(item, el, locale);
    };
    /**
     * Update a translation item with given values
     */
    Translation.prototype.updateItemWithStrings = function (name, item, values, locales) {
        for (var i = 0; i < values.length && i < locales.length; i++) {
            var val = values[i].trim();
            if (!val)
                continue;
            if (this.importItemCallback) {
                val = this.importItemCallback(name, locales[i], val);
            }
            if (!!val) {
                item.values(locales[i]).text = val;
            }
        }
    };
    Translation.prototype.fillItemsHash = function (parentName, group, itemsHash) {
        var _this = this;
        var name = parentName ? parentName + "." + group.name : group.name;
        group.locItems.forEach(function (item) {
            itemsHash[name + "." + item.name] = item;
        });
        group.groups.forEach(function (group) { return _this.fillItemsHash(name, group, itemsHash); });
    };
    Translation.prototype.dispose = function () {
        this.isEmpty = true;
        if (!!this.stringsSurvey) {
            this.stringsSurvey.dispose();
            this.stringsSurvey = undefined;
        }
        if (!!this.stringsHeaderSurvey) {
            this.stringsHeaderSurvey.dispose();
            this.stringsHeaderSurvey = undefined;
        }
        if (!!this.settingsSurveyValue) {
            this.settingsSurveyValue.dispose();
            this.settingsSurveyValue = undefined;
        }
        this.importFinishedCallback = undefined;
        this.availableTranlationsChangedCallback = undefined;
        this.tranlationChangedCallback = undefined;
        _super.prototype.dispose.call(this);
    };
    Translation.csvDelimiter = ",";
    Translation.newLineDelimiter = "\n";
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.propertyArray)()
    ], Translation.prototype, "locales", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Translation.prototype, "canMergeLocaleWithDefault", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Translation.prototype, "mergeLocaleWithDefaultText", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            defaultValue: false, onSet: function (_, target) {
                target.updateReadOnly();
            }
        })
    ], Translation.prototype, "readOnly", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Translation.prototype, "root", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            defaultValue: false, onSet: function (_, target) {
                target.reset();
            }
        })
    ], Translation.prototype, "showAllStrings", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (_, target) {
                target.reset();
            }
        })
    ], Translation.prototype, "filteredPage", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Translation.prototype, "stringsSurvey", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], Translation.prototype, "stringsHeaderSurvey", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], Translation.prototype, "isEmpty", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], Translation.prototype, "isChooseLanguageEnabled", void 0);
    return Translation;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));

var TranslationForEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TranslationForEditor, _super);
    function TranslationForEditor(survey, options, surveyStringsHeaderCreatedCallback) {
        var _this = _super.call(this, survey, options, true) || this;
        _this.surveyStringsHeaderCreatedCallback = surveyStringsHeaderCreatedCallback;
        return _this;
    }
    TranslationForEditor.prototype.getSurveyStringsArea = function () { return "translation-tab:table-popup-editor"; };
    TranslationForEditor.prototype.getSurveyStringsHeaderArea = function () { return "translation-tab:table-header-popup-editor"; };
    TranslationForEditor.prototype.onSurveyStringsHeaderCreated = function (survey) {
        this.surveyStringsHeaderCreatedCallback(survey);
    };
    return TranslationForEditor;
}(Translation));

var TranslationEditor = /** @class */ (function () {
    function TranslationEditor(survey, locale, options) {
        var _this = this;
        this.fromLocales = [];
        this.survey = survey;
        this.options = options;
        this.locale = locale;
        this.translationValue = new TranslationForEditor(this.survey, this.options, function (survey) {
            _this.setupNavigationButtons(survey);
        });
        this.translation.setEditMode(this.locale);
        this.translation.reset();
        this.fillFromLocales();
        this.updateFromLocaleAction();
        this.updateMatricesColumns();
    }
    Object.defineProperty(TranslationEditor.prototype, "translation", {
        get: function () { return this.translationValue; },
        enumerable: false,
        configurable: true
    });
    TranslationEditor.prototype.showDialog = function () {
        var _this = this;
        var dialogTitle = _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.translationDialogTitle") + " (" + this.translation.getLocaleName(this.locale) + ")";
        if (this.translation.stringsSurvey.getAllQuestions(true).length === 0) {
            var locStr = new survey_core__WEBPACK_IMPORTED_MODULE_1__.LocalizableString(this.translation.stringsSurvey);
            locStr.text = _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.translationNoStrings");
            var popup = survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.showDialog({
                componentName: "sv-string-viewer",
                data: { locStr: locStr, locString: locStr, model: locStr },
                onApply: function () { return true; },
                cssClass: "svc-creator-popup",
                title: dialogTitle,
                displayMode: "popup"
            }, this.options.rootElement);
            var actions = popup.footerToolbar.actions;
            actions.splice(1, actions.length - 1);
            actions[0].title = "OK";
            return;
        }
        var popupModel = survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.showDialog({
            componentName: "svc-tab-translation",
            data: {
                model: this.translation
            },
            onApply: function () {
                _this.apply();
                return true;
            },
            onHide: function () {
                _this.dispose();
            },
            cssClass: "svc-property-editor st-translation-dialog svc-creator-popup",
            title: dialogTitle,
            displayMode: this.options.isMobileView ? "overlay" : "popup"
        }, this.options.rootElement);
        popupModel.locale = _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.currentLocale;
    };
    TranslationEditor.prototype.doMachineTranslation = function () {
        var _this = this;
        var fromLocale = this.fromLocale || this.translation.defaultLocale;
        if (!fromLocale)
            fromLocale = "en";
        var items = this.createStringsToTranslate();
        var strings = [];
        items.forEach(function (item) {
            strings.push(_this.getTextToTranslate(item));
        });
        var callback = function (translatedStrings) {
            if (!Array.isArray(translatedStrings))
                return;
            for (var i = 0; i < Math.min(items.length, translatedStrings.length); i++) {
                items[i].values(_this.locale).text = translatedStrings[i];
            }
            _this.translation.updateStringsSurveyData();
        };
        this.options.doMachineTranslation(fromLocale, this.locale, strings, callback);
    };
    TranslationEditor.prototype.apply = function () {
        this.translation.applyEditLocale();
        if (this.onApply) {
            this.onApply();
        }
    };
    TranslationEditor.prototype.cancel = function () {
        this.dispose();
    };
    TranslationEditor.prototype.dispose = function () {
        this.translationValue.dispose();
    };
    TranslationEditor.prototype.setFromLocale = function (locale) {
        if (this.fromLocale === locale)
            return;
        this.fromLocale = locale;
        this.updateMatricesColumns();
    };
    TranslationEditor.prototype.updateMatricesColumns = function () {
        var _this = this;
        this.translation.stringsHeaderSurvey.getAllQuestions().forEach(function (q) {
            _this.updateMatrixColumns(q);
            _this.updateHeaderMatrixColumns(q);
        });
        var questions = this.translation.stringsSurvey.getAllQuestions();
        for (var i = 0; i < questions.length; i++) {
            this.updateMatrixColumns(questions[i]);
        }
    };
    TranslationEditor.prototype.updateHeaderMatrixColumns = function (matrix) {
        var cols = matrix.columns;
        cols[0].title = this.translation.getLocaleName("");
        if (cols.length > 2) {
            cols[1].title = this.getHeaderTitle("translationSource", cols[1].name);
            cols[2].title = this.getHeaderTitle("translationTarget", cols[2].name);
        }
        else {
            cols[1].title = this.getHeaderTitle("translationTarget", cols[1].name);
        }
    };
    TranslationEditor.prototype.updateMatrixColumns = function (matrix) {
        var colIndex = 1;
        if (matrix.columns.length === 3) {
            matrix.columns.splice(colIndex, 1);
        }
        var loc = this.fromLocale;
        if (loc) {
            var column = new survey_core__WEBPACK_IMPORTED_MODULE_1__.MatrixDropdownColumn(loc, this.translation.getLocaleName(loc));
            column.readOnly = true;
            matrix.columns.splice(colIndex, 0, column);
        }
    };
    TranslationEditor.prototype.getHeaderTitle = function (strName, locale) {
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed." + strName) + this.translation.getLocaleName(locale);
    };
    TranslationEditor.prototype.fillFromLocales = function () {
        var _this = this;
        this.fromLocales = [];
        var items = this.createStringsToTranslate();
        items.forEach(function (item) {
            item.fillLocales(_this.fromLocales);
        });
    };
    TranslationEditor.prototype.setupNavigationButtons = function (survey) {
        var _this = this;
        var navigationBar = new _action_container_view_model__WEBPACK_IMPORTED_MODULE_10__.SurveyElementActionContainer();
        survey["navigationBarValue"] = navigationBar;
        survey.findLayoutElement("buttons-navigation").data = navigationBar;
        navigationBar.locOwner = survey;
        navigationBar.cssClasses = survey.css.actionBar;
        navigationBar.containerCss = survey.css.footer;
        survey.addNavigationItem(this.createLocaleFromAction());
        var actionCss = "svc-action-bar-item--right";
        if (this.options.getHasMachineTranslation()) {
            survey.addNavigationItem(new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
                id: "svc-translation-machine",
                iconName: "icon-language",
                iconSize: "auto",
                css: actionCss,
                locTitleName: "ed.translateUsigAI",
                component: "sv-action-bar-item",
                action: function () { _this.doMachineTranslation(); }
            }));
        }
        var importAction = createImportCSVAction(function () { _this.translation.importFromCSVFileDOM(); }, false, true);
        importAction.css = actionCss;
        var exportAction = createExportCSVAction(function () { _this.translation.exportToCSVFileUI(); }, true);
        exportAction.css = actionCss;
        survey.addNavigationItem(importAction);
        survey.addNavigationItem(exportAction);
        survey.showNavigationButtons = "top";
    };
    TranslationEditor.prototype.createStringsToTranslate = function () {
        var _this = this;
        var res = new Array();
        var loc = this.fromLocale || "";
        this.translation.root.allLocItems.forEach(function (item) {
            if (_this.getTextToTranslate(item)) {
                res.push(item);
            }
        });
        return res;
    };
    TranslationEditor.prototype.getTextToTranslate = function (item) {
        var loc = this.fromLocale || "";
        var res = item.getLocText(loc);
        if (!res && !loc) {
            res = item.getDefaultLocaleText(true);
        }
        return res;
    };
    TranslationEditor.prototype.createLocaleFromAction = function () {
        var _this = this;
        var defaultLocaleTitle = this.getActionTranslateFromText("");
        var onActionTypesPopupShow = function () {
            var items = [{ id: null, title: defaultLocaleTitle }];
            _this.fromLocales.forEach(function (locale) {
                items.push({ id: locale, title: _this.getActionTranslateFromText(locale) });
            });
            var listModel = action.popupModel.contentComponentData.model;
            listModel.setItems(items);
        };
        var actionTypesPopupModel = (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.createPopupModelWithListModel)({
            items: [{ id: null, title: defaultLocaleTitle }],
            onSelectionChanged: function (item) {
                var id = item.id || "";
                _this.setFromLocale(id);
                action.title = _this.getActionTranslateFromText(id);
            },
            allowSelection: true
        }, {
            verticalPosition: "bottom",
            horizontalPosition: "center",
            cssClass: "svc-creator-popup",
            onShow: onActionTypesPopupShow
        });
        var action = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "svc-translation-fromlocale",
            component: "svc-translate-from-action",
            css: "st-translation-machine-from",
            location: "start",
            title: defaultLocaleTitle,
            innerCss: "st-translation-machine-from__btn",
            data: {
                additionalTitleCss: "st-translation-machine-from__title",
                additionalTitle: _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.translateUsigAIFrom")
            },
            popupModel: actionTypesPopupModel,
            action: function () {
                actionTypesPopupModel.toggleVisibility();
            }
        });
        return action;
    };
    TranslationEditor.prototype.updateFromLocaleAction = function () {
        var action = this.translation.stringsHeaderSurvey.findLayoutElement("buttons-navigation").data.getActionById("svc-translation-fromlocale");
        if (!!action) {
            action.enabled = this.fromLocales.length > 0;
            action.iconName = action.enabled ? "icon-chevron_16x16" : undefined;
            action.iconSize = "auto";
            action.data.containerCss = new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("st-translation-machine-from__container")
                .append("st-translation-machine-from__container--disabled", !action.enabled)
                .toString();
        }
    };
    TranslationEditor.prototype.getActionTranslateFromText = function (loc) {
        loc = loc || "";
        return this.translation.getLocaleName(loc);
    };
    return TranslationEditor;
}());

function createImportCSVAction(action, needSeparator, isInEditor) {
    if (isInEditor === void 0) { isInEditor = false; }
    return new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
        id: "svc-translation-import",
        iconName: "icon-load",
        iconSize: "auto",
        locTitleName: "ed.translationImportFromSCVButton",
        locTooltipName: "ed.translationImportFromSCVButton",
        mode: isInEditor ? "large" : "small",
        component: "sv-action-bar-item",
        needSeparator: needSeparator,
        action: action
    });
}
function createExportCSVAction(action, isInEditor) {
    if (isInEditor === void 0) { isInEditor = false; }
    return new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
        id: "svc-translation-export",
        iconName: "icon-download",
        iconSize: "auto",
        locTitleName: "ed.translationExportToSCVButton",
        locTooltipName: "ed.translationExportToSCVButton",
        mode: isInEditor ? "large" : "small",
        component: "sv-action-bar-item",
        action: action
    });
}


/***/ }),

/***/ "./src/components/toolbox/toolbox-search-manager.ts":
/*!**********************************************************!*\
  !*** ./src/components/toolbox/toolbox-search-manager.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SearchManagerToolbox: () => (/* binding */ SearchManagerToolbox)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _search_manager__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../search-manager */ "./src/components/search-manager.ts");




var SearchManagerToolbox = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SearchManagerToolbox, _super);
    function SearchManagerToolbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchManagerToolbox.prototype.getFilterStringPlaceholder = function () { return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.toolboxFilteredTextPlaceholder"); };
    SearchManagerToolbox.prototype.setFiterString = function (newValue, oldValue) {
        this.toolbox.showSeparators = !newValue;
        this.toolbox.items.forEach(function (item) { return item.visible = item.hasText(newValue); });
        this.toolbox.showPlaceholder = !this.toolbox.items.filter(function (i) { return i.visible; }).length;
        this.toolbox.categories.forEach(function (category) {
            category.forceExpand = !!newValue;
            category.empty = category.items.filter(function (item) { return item.visible; }).length == 0;
        });
    };
    SearchManagerToolbox.prototype.clearFilterString = function () {
        this.filterString = "";
        this.toolbox.rootElement.querySelector("input").focus();
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SearchManagerToolbox.prototype, "toolbox", void 0);
    return SearchManagerToolbox;
}(_search_manager__WEBPACK_IMPORTED_MODULE_3__.SearchManager));



/***/ }),

/***/ "./src/components/toolbox/toolbox-tool.ts":
/*!************************************************!*\
  !*** ./src/components/toolbox/toolbox-tool.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ToolboxToolViewModel: () => (/* binding */ ToolboxToolViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _toolbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../../toolbox */ "./src/toolbox.ts");



var ToolboxToolViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(ToolboxToolViewModel, _super);
    function ToolboxToolViewModel(item, creator, model) {
        var _this = _super.call(this) || this;
        _this.item = item;
        _this.creator = creator;
        _this.model = model;
        _this.click = function (event) {
            if (!_this.allowAdd)
                return;
            _this.creator.clickToolboxItem(_this.item.json);
            _this.hidePopup();
        };
        _this.onPointerUp = function (pointerUpEvent) {
            _this.hidePopup();
            _this.toolboxItem.isPressed = false;
            document.removeEventListener("pointerup", _this.onPointerUp);
        };
        _this.startDragToolboxItem = function (pointerDownEvent, currentTarget) {
            var json = _this.creator.getJSONForNewElement(_this.item.json);
            _this.dragDropHelper.startDragToolboxItem(pointerDownEvent, json, _this.item);
            return true;
        };
        _this.dragOrClickHelper = new survey_core__WEBPACK_IMPORTED_MODULE_1__.DragOrClickHelper(_this.startDragToolboxItem);
        if (!_this.isDotsItem()) {
            var popup = item.popupModel;
            if (!!popup) {
                var className = new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                    .append(popup.cssClass)
                    .append("svc-toolbox-subtypes")
                    .toString();
                popup.cssClass = className;
                popup.isFocusedContainer = false;
                popup.contentComponentName = "svc-toolbox-list";
                popup.contentComponentData["creator"] = creator;
                popup.isFocusedContent = false;
            }
        }
        return _this;
    }
    Object.defineProperty(ToolboxToolViewModel.prototype, "toolboxItem", {
        get: function () {
            return this.item;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ToolboxToolViewModel.prototype, "itemComponent", {
        get: function () {
            if (!!this.creator && !this.creator.toolbox.showSubitems && this.toolboxItem.hasSubItems) {
                return _toolbox__WEBPACK_IMPORTED_MODULE_2__.QuestionToolbox.defaultItemComponent;
            }
            return this.item.component || _toolbox__WEBPACK_IMPORTED_MODULE_2__.QuestionToolbox.defaultItemComponent;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ToolboxToolViewModel.prototype, "allowAdd", {
        get: function () {
            return !this.creator.readOnly;
        },
        enumerable: false,
        configurable: true
    });
    ToolboxToolViewModel.prototype.onMouseOver = function (itemValue, mouseoverEvent) {
        this.model.mouseOverHandler(itemValue);
    };
    ToolboxToolViewModel.prototype.onMouseLeave = function (itemValue, mouseoverEvent) {
        itemValue.hidePopupDelayed(this.creator.toolbox.subItemsHideDelay);
    };
    ToolboxToolViewModel.prototype.onPointerDown = function (pointerDownEvent) {
        var _a;
        pointerDownEvent.stopPropagation();
        if (!this.allowAdd)
            return;
        if (this.isDotsItem())
            return true; //toolbox responsive popup
        this.dragOrClickHelper.onPointerDown(pointerDownEvent);
        this.toolboxItem.isPressed = true;
        document.addEventListener("pointerup", this.onPointerUp);
        (_a = this.creator) === null || _a === void 0 ? void 0 : _a.onDragDropItemStart();
    };
    ToolboxToolViewModel.prototype.isDotsItem = function () {
        return this.item.id.indexOf("dotsItem-id") === 0;
    };
    ToolboxToolViewModel.prototype.hidePopup = function () {
        this.toolboxItem.hidePopup();
        this.toolboxItem.isHovered = false;
    };
    Object.defineProperty(ToolboxToolViewModel.prototype, "dragDropHelper", {
        get: function () {
            return this.creator.dragDropSurveyElements;
        },
        enumerable: false,
        configurable: true
    });
    return ToolboxToolViewModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/creator-base.ts":
/*!*****************************!*\
  !*** ./src/creator-base.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CreatorAction: () => (/* binding */ CreatorAction),
/* harmony export */   CreatorBase: () => (/* binding */ CreatorBase),
/* harmony export */   CreatorEvent: () => (/* binding */ CreatorEvent),
/* harmony export */   StylesManager: () => (/* binding */ StylesManager),
/* harmony export */   SurveyCreatorModel: () => (/* binding */ SurveyCreatorModel),
/* harmony export */   ToolbarActionContainer: () => (/* binding */ ToolbarActionContainer),
/* harmony export */   editableStringRendererName: () => (/* binding */ editableStringRendererName),
/* harmony export */   getElementWrapperComponentData: () => (/* binding */ getElementWrapperComponentData),
/* harmony export */   getElementWrapperComponentName: () => (/* binding */ getElementWrapperComponentName),
/* harmony export */   getItemValueWrapperComponentData: () => (/* binding */ getItemValueWrapperComponentData),
/* harmony export */   getItemValueWrapperComponentName: () => (/* binding */ getItemValueWrapperComponentName),
/* harmony export */   getQuestionContentWrapperComponentName: () => (/* binding */ getQuestionContentWrapperComponentName),
/* harmony export */   initializeDesignTimeSurveyModel: () => (/* binding */ initializeDesignTimeSurveyModel),
/* harmony export */   isStringEditable: () => (/* binding */ isStringEditable),
/* harmony export */   isTextInput: () => (/* binding */ isTextInput),
/* harmony export */   registerAdorner: () => (/* binding */ registerAdorner),
/* harmony export */   removeAdorners: () => (/* binding */ removeAdorners)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _json5__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./json5 */ "./src/json5.ts");
/* harmony import */ var _questionconverter__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./questionconverter */ "./src/questionconverter.ts");
/* harmony import */ var _textWorker__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./textWorker */ "./src/textWorker.ts");
/* harmony import */ var _toolbox__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./toolbox */ "./src/toolbox.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ./survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _selection_history__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ./selection-history */ "./src/selection-history.ts");
/* harmony import */ var _components_tabs_json_editor_ace__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ./components/tabs/json-editor-ace */ "./src/components/tabs/json-editor-ace.ts");
/* harmony import */ var _components_tabs_json_editor_textarea__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ./components/tabs/json-editor-textarea */ "./src/components/tabs/json-editor-textarea.ts");
/* harmony import */ var _components_tabs_test_plugin__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ./components/tabs/test-plugin */ "./src/components/tabs/test-plugin.ts");
/* harmony import */ var _components_tabs_logic__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ./components/tabs/logic */ "./src/components/tabs/logic.ts");
/* harmony import */ var _components_tabs_translation_plugin__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ./components/tabs/translation-plugin */ "./src/components/tabs/translation-plugin.ts");
/* harmony import */ var _components_tabs_logic_plugin__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ./components/tabs/logic-plugin */ "./src/components/tabs/logic-plugin.ts");
/* harmony import */ var _plugins_undo_redo__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ./plugins/undo-redo */ "./src/plugins/undo-redo/index.ts");
/* harmony import */ var _components_tabs_designer_plugin__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ./components/tabs/designer-plugin */ "./src/components/tabs/designer-plugin.ts");
/* harmony import */ var _creator_responsivity_manager__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ./creator-responsivity-manager */ "./src/creator-responsivity-manager.ts");
/* harmony import */ var _components_side_bar_side_bar_model__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ./components/side-bar/side-bar-model */ "./src/components/side-bar/side-bar-model.ts");
/* harmony import */ var _src_components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../src/components/tabs/translation */ "./src/components/tabs/translation.ts");
/* harmony import */ var _components_string_editor__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ./components/string-editor */ "./src/components/string-editor.ts");
/* harmony import */ var _components_tabs_theme_plugin__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ./components/tabs/theme-plugin */ "./src/components/tabs/theme-plugin.ts");
/* harmony import */ var _survey_elements__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ./survey-elements */ "./src/survey-elements.ts");
/* harmony import */ var _expand_collapse_manager__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ./expand-collapse-manager */ "./src/expand-collapse-manager.ts");
/* harmony import */ var _designTabSurveyThemeJSON__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ./designTabSurveyThemeJSON */ "./src/designTabSurveyThemeJSON.ts");
/* harmony import */ var _components_action_container_view_model__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ./components/action-container-view-model */ "./src/components/action-container-view-model.ts");
/* harmony import */ var _tabbed_menu__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ./tabbed-menu */ "./src/tabbed-menu.ts");
/* harmony import */ var _svgbundle__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ./svgbundle */ "./src/svgbundle.ts");

































__webpack_require__(/*! ./components/creator.scss */ "./src/components/creator.scss");
__webpack_require__(/*! ./components/string-editor.scss */ "./src/components/string-editor.scss");
__webpack_require__(/*! ./creator-theme/creator.scss */ "./src/creator-theme/creator.scss");
(0,survey_core__WEBPACK_IMPORTED_MODULE_1__.addIconsToThemeSet)("v1", _svgbundle__WEBPACK_IMPORTED_MODULE_29__.iconsV1);
(0,survey_core__WEBPACK_IMPORTED_MODULE_1__.addIconsToThemeSet)("v2", _svgbundle__WEBPACK_IMPORTED_MODULE_29__.iconsV2);
survey_core__WEBPACK_IMPORTED_MODULE_1__.SvgRegistry.registerIcons(_creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.useLegacyIcons ? _svgbundle__WEBPACK_IMPORTED_MODULE_29__.iconsV1 : _svgbundle__WEBPACK_IMPORTED_MODULE_29__.iconsV2);
//Obsolete
var CreatorAction = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorAction, _super);
    function CreatorAction() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CreatorAction;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Action));

var ToolbarActionContainer = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(ToolbarActionContainer, _super);
    function ToolbarActionContainer(creator) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        return _this;
    }
    ToolbarActionContainer.prototype.getRenderedActions = function () {
        var actions = this.actions;
        var expandAction = this.creator.sidebar.getExpandAction();
        var index = actions.indexOf(expandAction);
        if (index !== -1) {
            actions.splice(index, 1);
            actions.push(expandAction);
        }
        return actions;
    };
    return ToolbarActionContainer;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.ActionContainer));

var CreatorEvent = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorEvent, _super);
    function CreatorEvent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CreatorEvent;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase));

/**
 * A class with properties, methods, and events that allow you to configure Survey Creator and manage its elements.
 *
 * [View Demo](https://surveyjs.io/survey-creator/examples/free-nps-survey-template/ (linkStyle))
 */
var SurveyCreatorModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyCreatorModel, _super);
    function SurveyCreatorModel(options, options2) {
        var _this = this;
        var _a;
        _this = _super.call(this) || this;
        _this.options = options;
        _this.startEditTitleOnQuestionAddedValue = true;
        _this.isRTLValue = false;
        _this.alwaySaveTextInPropertyEditorsValue = false;
        _this.pageEditModeValue = "standard";
        _this.newQuestions = [];
        _this.newPanels = [];
        _this.plugins = {};
        /**
         * An event that is raised before a survey element (a question, panel, or page) is deleted.
         * @see deleteElement
         */
        _this.onElementDeleting = _this.addCreatorEvent();
        /**
         * An event that is raised when Survey Creator sets the read-only status for a survey element property. Use this event to change the read-only status for individual properties.
         */
        _this.onGetPropertyReadOnly = _this.addCreatorEvent();
        /**
         * An event that is raised when Survey Creator [instantiates a survey to display a UI element](https://surveyjs.io/survey-creator/documentation/creator-v2-whats-new#survey-creator-ui-elements-are-surveys). Handle this event to customize the UI element by modifying the survey.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [Design Mode Survey Instance](https://surveyjs.io/survey-creator/documentation/customize-survey-creation-process#design-mode-survey-instance (linkStyle))
         *
         * [Preview Mode Survey Instance](https://surveyjs.io/survey-creator/documentation/customize-survey-creation-process#preview-mode-survey-instance (linkStyle))
         *
         * > If you want this event raised at startup, assign a survey JSON schema to the [`JSON`](#JSON) property *after* you add a handler to the event. If the JSON schema should be empty, specify the `JSON` property with an empty object.
         */
        _this.onSurveyInstanceCreated = _this.addCreatorEvent();
        /**
         * An event that is raised when Survey Creator obtains a survey element name to display it in the UI.
         *
         * Handle this event to replace survey element names in the UI with custom display texts. If you only want to replace the names with survey element titles, enable the [`showObjectTitles`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#showObjectTitles) property instead of handling this event.
         */
        _this.onGetObjectDisplayName = _this.addCreatorEvent();
        _this.onHtmlToMarkdown = _this.addCreatorEvent();
        /*
         * An event that is raised when Survey Creator obtains the expand/collapse state of a survey element on the design surface. Handle this event to set a required state.
         */
        _this.onElementGetExpandCollapseState = _this.addCreatorEvent();
        /**
         * An event that is raised when Survey Creator obtains permitted operations for a survey element. Use this event to disable user interactions with a question, panel, or page on the design surface.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * To disable a user interaction, set the correponding `allow...` property to `false`.
         *
         * [Specify Adorner Visibility](https://surveyjs.io/survey-creator/documentation/customize-survey-creation-process#specify-adorner-availability (linkStyle))
         * @see onCollectionItemAllowOperations
         */
        _this.onElementAllowOperations = _this.addCreatorEvent();
        /**
         * An event that is raised when Survey Creator obtains [adorners](https://surveyjs.io/survey-creator/documentation/customize-survey-creation-process#specify-adorner-availability) for a survey element. Use this event to hide and modify predefined adorners or add a custom adorner.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/survey-creator/examples/create-custom-adorners/ (linkStyle))
         * @see onElementAllowOperations
         * @see onGetPageActions
         */
        _this.onDefineElementMenuItems = _this.addCreatorEvent();
        /**
         * An event that is raised when Survey Creator adds properties to a survey element selected on the design surface. Handle this event if you cancel the addition of certain properties and thus [hide them from the Property Grid](https://surveyjs.io/survey-creator/documentation/property-grid-customization#hide-properties-from-the-property-grid).
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/survey-creator/examples/hide-category-from-property-grid/ (linkStyle))
         */
        _this.onShowingProperty = _this.addCreatorEvent();
        _this.onCanShowProperty = _this.onShowingProperty;
        /**
         * This event is obsolete. Use the [`onSurveyInstanceCreated`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#onSurveyInstanceCreated) event instead.
         * @deprecated
         */
        _this.onPropertyGridSurveyCreated = _this.addCreatorEvent();
        /**
         * An event that is raised when a property editor is created in the Property Grid. Use this event to modify the property editor or add event handlers to it.
         * @see onConfigureTablePropertyEditor
         * @see onSurveyInstanceCreated
         */
        _this.onPropertyEditorCreated = _this.addCreatorEvent();
        /**
         * An event that is raised when title actions are added to a property editor. Title actions are most often used to reveal hints for properties configured by users. Handle this event you want to add, remove, or modify the title actions.
         */
        _this.onPropertyEditorUpdateTitleActions = _this.addCreatorEvent();
        /**
         * An event that is raised before Survey Creator displays a pop-up window called from the Property Grid. This window allows users to edit choices, conditions, etc. Use this event to customize the pop-up window, for example, add custom action buttons.
         */
        _this.onPropertyGridShowModal = _this.addCreatorEvent();
        _this.onCanDeleteItem = _this.addCreatorEvent();
        _this.onCollectionItemDeleting = _this.addCreatorEvent();
        /**
         * An event that is raised when Survey Creator obtains permitted operations for a collection item (a choice option in Choices, a column or row in Columns, etc.). Use this event to prevent users from adding, deleting, or editing a particular collection item.
         * @see onElementAllowOperations
         */
        _this.onCollectionItemAllowOperations = _this.addCreatorEvent();
        /**
         * An event that is raised when users add a new collection item (a choice option to Choices, a column or row to Columns, etc.). Use this event to modify this item.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * > This event is not raised when users add a new column to a [Multi-Select Matrix](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-with-dropdown-list) or [Dynamic Matrix](https://surveyjs.io/form-library/documentation/api-reference/dynamic-matrix-table-question-model). For these cases, handle the [`onMatrixColumnAdded`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#onMatrixColumnAdded) event instead.
         * @see onFastEntryFinished
         * @see onCollectionItemAllowOperations
         */
        _this.onItemValueAdded = _this.addCreatorEvent();
        /**
         * An event that is raised when users finish editing collection items (choices, rows, columns) in a pop-up window.
         *
         * Survey authors can specify collection items using a table UI in Property Grid (see the [`onItemValueAdded`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#onItemValueAdded) event) or a multi-line text editor in a pop-up window. Each line in the editor specifies the value and display text of one collection item in the following format: `value|text`. Use the `onFastEntryFinished` event to process the entered text lines as required.
         */
        _this.onFastEntryFinished = _this.addCreatorEvent();
        /**
         * An event that is raised when users add a new column to a [Multi-Select Matrix](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-with-dropdown-list) or [Dynamic Matrix](https://surveyjs.io/form-library/documentation/api-reference/dynamic-matrix-table-question-model). Use this event to modify this column.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * > This event is not raised when users add a new column to a [Single-Select Matrix](https://surveyjs.io/form-library/documentation/api-reference/matrix-table-question-model). For this case, handle the [`onItemValueAdded`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#onItemValueAdded) event instead.
         * @see onCollectionItemAllowOperations
         */
        _this.onMatrixColumnAdded = _this.addCreatorEvent();
        /**
         * This event is obsolete. Use the [`onConfigureTablePropertyEditor`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#onConfigureTablePropertyEditor) event instead.
         * @deprecated
         */
        _this.onSetPropertyEditorOptions = _this.addCreatorEvent();
        /**
         * An event that is raised when a table property editor is created in the Property Grid. Use this event to configure the table property editor.
         * @see onPropertyEditorCreated
         */
        _this.onConfigureTablePropertyEditor = _this.addCreatorEvent();
        _this.onGenerateNewName = _this.addCreatorEvent();
        /**
         * An event that is raised when Survey Creator validates a modified value of a survey element property. Use this event to display a custom error message when the value is incorrect.
         * @see onPropertyValueChanging
         * @see onSurveyPropertyValueChanged
         */
        _this.onPropertyValidationCustomError = _this.addCreatorEvent();
        /**
         * An event that is raised each time a user modifies a survey element property. Use this event to validate or correct a property value while the user changes it.
         * @see onPropertyValidationCustomError
         * @see onSurveyPropertyValueChanged
         */
        _this.onPropertyValueChanging = _this.addCreatorEvent();
        /**
         * An event that is raised after a survey element property has changed.
         * @see onPropertyValidationCustomError
         * @see onPropertyValueChanging
         */
        _this.onSurveyPropertyValueChanged = _this.addCreatorEvent();
        /**
         * An event that is raised when a condition editor renders a list of questions and variables available for selection. Use this event to modify this list.
         */
        _this.onConditionQuestionsGetList = _this.addCreatorEvent();
        _this.onConditionGetTitle = _this.addCreatorEvent();
        /**
         * An event that is raised when Survey Creator populates a condition editor with operators. Use this event to hide individual condition operators.
         */
        _this.onGetConditionOperator = _this.addCreatorEvent();
        /**
         * An event that is raised when the Logic tab constructs a user-friendly display text for a logic rule. Use this event to modify this display text.
         */
        _this.onLogicItemDisplayText = _this.addCreatorEvent();
        /**
          * An event that is raised when users modify survey or theme settings.
          * @see state
          */
        _this.onModified = _this.addCreatorEvent();
        /**
         * An event that is raised when users add a question to the survey. Use this event to customize the question.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [Customize Survey Elements on Creation](https://surveyjs.io/survey-creator/documentation/customize-survey-creation-process#customize-survey-elements-on-creation (linkStyle))
         */
        _this.onQuestionAdded = _this.addCreatorEvent();
        /**
         * An event that is raised when users add a [Panel](https://surveyjs.io/form-library/documentation/api-reference/panel-model) element to the survey. Use this event to customize the panel.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [Customize Survey Elements on Creation](https://surveyjs.io/survey-creator/documentation/customize-survey-creation-process#customize-survey-elements-on-creation (linkStyle))
         */
        _this.onPanelAdded = _this.addCreatorEvent();
        /**
         * An event that is raised when a new page is added to the survey. Use this event to customize the page.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [Customize Survey Elements on Creation](https://surveyjs.io/survey-creator/documentation/customize-survey-creation-process#customize-survey-elements-on-creation (linkStyle))
         */
        _this.onPageAdded = _this.addCreatorEvent();
        /**
         * An event that is raised when a [question's type is being changed](https://surveyjs.io/survey-creator/documentation/end-user-guide/user-interface#how-to-change-the-question-type).
         */
        _this.onQuestionConverting = _this.addCreatorEvent();
        /**
         * An event that is raised when Survey Creator renders action buttons under each page on the design surface. Use this event to add, remove, or modify the buttons.
         * @see onDefineElementMenuItems
         */
        _this.onGetPageActions = _this.addCreatorEvent();
        /**
         * This event is obsolete. Use the [`onSurveyInstanceCreated`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#onSurveyInstanceCreated) event instead.
         * @deprecated
         */
        _this.onDesignerSurveyCreated = _this.addCreatorEvent();
        /**
         * This event is obsolete. Use the [`onSurveyInstanceCreated`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#onSurveyInstanceCreated) event instead.
         * @deprecated
         */
        _this.onPreviewSurveyCreated = _this.addCreatorEvent();
        _this.onTestSurveyCreated = _this.onPreviewSurveyCreated;
        /**
         * An event that is raised when Survey Creator [displays a toast notification](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#notify). Use this event to implement custom toast notification.
         * @see notify
         */
        _this.onNotify = _this.addCreatorEvent();
        /**
         * An event that is raised before a survey element (question, panel, page, or the survey itself) is focused. Use this event to move focus to a different survey element.
         * @see onSelectedElementChanged
         * @see selectedElement
         */
        _this.onSelectedElementChanging = _this.addCreatorEvent();
        /**
         * An event that is raised after a survey element (a question, panel, page, or the survey itself) is focused.
         * @see onSelectedElementChanging
         */
        _this.onSelectedElementChanged = _this.addCreatorEvent();
        /**
         * An event that is raised when Survey Creator opens a dialog window for users to select files.
         * @see onUploadFile
         * @see uploadFiles
         */
        _this.onOpenFileChooser = _this.addCreatorEvent();
        /**
         * An event that is raised when a user selects a file to upload. Use this event to upload the file to your server.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * [View Demo](https://surveyjs.io/survey-creator/examples/file-upload/ (linkStyle))
         * @see uploadFiles
         */
        _this.onUploadFile = _this.addCreatorEvent();
        /**
         * An event that is raised when the Translation tab displays a property for translation. Use this event to control the property visibility.
         */
        _this.onTranslationStringVisibility = _this.addCreatorEvent();
        _this.onTranslationLocaleInitiallySelected = _this.addCreatorEvent();
        /**
         * An event that is raised before a translated string is imported from a CSV file. Use this event to modify the string to be imported or cancel the import.
         * @see onTranslationExportItem
         * @see onTranslationImported
         */
        _this.onTranslationImportItem = _this.addCreatorEvent();
        /**
         * An event that is raised after all translated strings are imported from a CSV file.
         * @see onTranslationImportItem
         * @see onTranslationExportItem
         */
        _this.onTranslationImported = _this.addCreatorEvent();
        /**
         * An event that is raised before a translated string is exported to a CSV file. Use this event to modify the string to be exported.
         * @see onTranslationImportItem
         */
        _this.onTranslationExportItem = _this.addCreatorEvent();
        /**
         * An event that allows you to integrate a machine translation service, such as Google Translate or Microsoft Translator, into Survey Creator.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         *
         * Within the event handler, you need to pass translation strings and locale information to the translation service API. The service should return an array of translated strings that you need to pass to the `options.callback` function. The following code shows how to integrate the Microsoft Translator service into Survey Creator:
         *
         * ```js
         * import { SurveyCreatorModel } from "survey-creator-core";
         * const creatorOptions = { ... };
         * const creator = new SurveyCreatorModel(creatorOptions);
         *
         * const apiKey = "<your-microsoft-translator-api-key>";
         * const resourceRegion = "<your-azure-region>";
         * const endpoint = "https://api.cognitive.microsofttranslator.com/";
         * creator.onMachineTranslate.add((_, options) => {
         *   // Prepare strings for Microsoft Translator as an array of objects: [{ Text: "text to translate" }]
         *   const data = [];
         *   options.strings.forEach(str => { data.push({ Text: str }); });
         *   // Include required locales in the URL
         *   const params = "api-version=3.0&from=" + options.fromLocale + "&to=" + options.toLocale;
         *   const url = endpoint + "/translate?" + params;
         *   fetch(url, {
         *     method: "POST",
         *     headers: {
         *       "Content-Type": "application/json",
         *       "Ocp-Apim-Subscription-Key": apiKey,
         *       "Ocp-Apim-Subscription-Region": resourceRegion,
         *       "X-ClientTraceId": crypto.randomUUID()
         *     },
         *     body: JSON.stringify(data)
         *   }).then(response => response.json())
         *     .then(data => {
         *       // Convert data received from Microsoft Translator to a flat array
         *       const translatedStrings = [];
         *       for (let i = 0; i < data.length; i++) {
         *         translatedStrings.push(data[i].translations[0].text);
         *       }
         *       // Pass translated strings to Survey Creator
         *       options.callback(translatedStrings);
         *
         *     }).catch(error => {
         *       // If translation was unsuccessful:
         *       options.callback();
         *       alert("Could not translate strings to the " + options.toLocale + " locale");
         *     });
         * });
         * ```
         *
         * > Survey Creator does not include a machine translation service out of the box. Our component only provides a UI for calling the service API.
         */
        _this.onMachineTranslate = _this.addCreatorEvent();
        /**
         * An event that is raised before a string translation is changed. Use this event to override a new translation value.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * Refer to the following help topics for more information on localization:
         *
         * - [Localization & Globalization in SurveyJS Form Library](https://surveyjs.io/form-library/documentation/survey-localization)
         * - [Localization & Globalization in Survey Creator](https://surveyjs.io/survey-creator/documentation/localization)
         */
        _this.onTranslationItemChanging = _this.addCreatorEvent();
        /**
         * An event that is raised when users drag and drop survey elements within the design surface. Use this event to control drag and drop operations.
         * @see onDragStart
         * @see onDragEnd
         */
        _this.onDragDropAllow = _this.addCreatorEvent();
        _this.onDragOverLocationCalculating = _this.addCreatorEvent();
        /**
         * An event that allows you to create a custom message panel.
         *
         * For information on event handler parameters, refer to descriptions within the interface.
         *
         * A message panel is displayed within a question box on the design surface. It contains a text message and an optional action link. The following image illustrates a built-in message panel that appears when a question sources its choice options from another question or from a web service:
         *
         * <img src="https://surveyjs.io/stay-updated/release-notes/articles/v1.9.126/creator-message-panel.png" alt="Survey Creator: A message panel" width="75%">
         *
         * To create a custom message panel, handle the `onCreateCustomMessagePanel` event. This event is raised for questions whose `isMessagePanelVisible` property set to `true`. The following code shows how to enable this property based on a condition. This code implements a custom data source selector for select-based questions (Dropdown, Checkboxes, Radio Button Group). When a survey author selects any data source other than "Custom", the `isMessagePanelVisible` property becomes enabled, indicating that the `onCreateCustomMessagePanel` event must be raised. A function that handles this event specifies custom message and action link texts and `onClick` event handler:
         *
         * ```js
         * import { Serializer } from "survey-core";
         * import { SurveyCreatorModel } from "survey-creator-core";
         *
         * Serializer.addProperty("selectbase", {
         *   name: "choicesDataSource",
         *   displayName: "Data source",
         *   category: "choices",
         *   choices: [
         *     { text: "Country", value: "country" },
         *     { text: "Region", value: "region" },
         *     { text: "City", value: "city" },
         *     { text: "Custom", value: "custom" }
         *   ],
         *   onSetValue: function (obj: any, value: any) {
         *     // Set the custom property value
         *     obj.setPropertyValue("choicesDataSource", value);
         *     // Display the message panel based on a condition
         *     obj.setPropertyValue("isMessagePanelVisible", value !== "custom");
         *   }
         * });
         *
         * const creator = new SurveyCreatorModel({});
         *
         * creator.onCreateCustomMessagePanel.add((_, options) => {
         *   options.messageText = "Choices for this question are loaded from a predefined data source. ";
         *   options.actionText = "Go to settings";
         *   // Focus the "Data source" editor within the Property Grid
         *   options.onClick = () => {
         *     creator.selectElement(options.question, "choicesDataSource");
         *   };
         * });
         * ```
         */
        _this.onCreateCustomMessagePanel = _this.addCreatorEvent();
        // /**
        //  * You need to set this property to true if you want to use tabs instead of accordion in the popup element's editor.
        //  */
        // public useTabsInElementEditor = false;
        /**
         * Limits the number of items in a logical condition.
         *
         * Default value: -1 (unlimited)
         */
        _this.maxLogicItemsInCondition = -1;
        /**
         * Specifies whether drop-down menus and other UI elements display survey, page, and question titles instead of their names.
         *
         * Default value: `false`
         * @see onGetObjectDisplayName
         */
        _this.showObjectTitles = false;
        /**
         * Limits the number of visible choices. Users can click "Show more" to view hidden choices.
         *
         * Set this property to -1 if you do not want to hide any choices.
         *
         * Default value: 10
         */
        _this.maxVisibleChoices = 10;
        /**
         * Specifies whether to display question titles instead of names when users edit logical expressions.
         *
         * Default value: `false`
         * @see showObjectTitles
         * @see onGetObjectDisplayName
         */
        _this.showTitlesInExpressions = false;
        /**
         * Specifies whether users can edit expressions in the Logic tab as plain text.
         *
         * If you set this property to `false`, users can only use UI elements to edit logical expressions.
         *
         * Default value: `true`
         * @see showLogicTab
         */
        _this.allowEditExpressionsInTextEditor = true;
        /**
         * Limits the number of columns that users can add to [Matrix](https://surveyjs.io/Documentation/Library?id=questionmatrixmodel), [Matrix Dynamic](https://surveyjs.io/Documentation/Library?id=questionmatrixdynamicmodel), and [Matrix Dropdown](https://surveyjs.io/Documentation/Library?id=questionmatrixdropdownmodel) questions.
         *
         * Default value: 0 (unlimited, taken from `settings.propertyGrid.maximumColumnsCount`)
         */
        _this.maximumColumnsCount = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.propertyGrid.maximumColumnsCount;
        /**
         * Limits the number of choices that users can add to [Checkbox](https://surveyjs.io/Documentation/Library?id=questioncheckboxmodel), [Dropdown](https://surveyjs.io/Documentation/Library?id=questiondropdownmodel), and [Radiogroup](https://surveyjs.io/Documentation/Library?id=questionradiogroupmodel) questions.
         *
         * Default value: 0 (unlimited, taken from `settings.propertyGrid.maximumChoicesCount`)
         */
        _this.maximumChoicesCount = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.propertyGrid.maximumChoicesCount;
        /**
         * Limits the minimum number of choices in [Checkbox](https://surveyjs.io/Documentation/Library?id=questioncheckboxmodel), [Dropdown](https://surveyjs.io/Documentation/Library?id=questiondropdownmodel), and [Radiogroup](https://surveyjs.io/Documentation/Library?id=questionradiogroupmodel) questions. Set this property if users should not delete choices below the specified limit.
         *
         * Default value: 0 (unlimited, taken from `settings.propertyGrid.minimumChoicesCount`)
         */
        _this.minimumChoicesCount = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.propertyGrid.minimumChoicesCount;
        /**
         * Limits the number of rows that users can add to [Matrix](https://surveyjs.io/Documentation/Library?id=questionmatrixmodel) and [Matrix Dropdown](https://surveyjs.io/Documentation/Library?id=questionmatrixdropdownmodel) questions.
         *
         * Default value: 0 (unlimited, taken from `settings.propertyGrid.maximumRowsCount`)
         */
        _this.maximumRowsCount = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.propertyGrid.maximumRowsCount;
        /**
         * Limits the number of rate values that users can add to [Rating](https://surveyjs.io/Documentation/Library?id=questionratingmodel) questions.
         *
         * Default value: 0 (unlimited, taken from `settings.propertyGrid.maximumRateValues`)
         */
        _this.maximumRateValues = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.propertyGrid.maximumRateValues;
        /**
         * Limits the number of nested panels within a [Panel](https://surveyjs.io/form-library/documentation/api-reference/panel-model) element.
         *
         * Default value: -1 (unlimited)
         */
        _this.maxNestedPanels = -1;
        _this.showPagesInTestSurveyTab = true;
        _this.showSimulatorInTestSurveyTab = true;
        /**
         * A [UI theme](https://surveyjs.io/Documentation/Library?id=get-started-react#configure-styles) used to display the survey in the Preview tab.
         *
         * Accepted values: `"modern"`, `"default"`, `"defaultV2"`
         *
         * Default value: `"defaultV2"`
         * @see allowChangeThemeInPreview
         */
        _this.themeForPreview = "defaultV2";
        _this.hasPendingThemeChanges = false;
        _this._theme = { cssVariables: {} };
        //#endregion Theme
        _this._allowModifyPages = true;
        _this.showDefaultLanguageInTestSurveyTab = "auto";
        _this.showInvisibleElementsInTestSurveyTab = true;
        /**
         * Specifies whether users can switch between UI themes in the Preview tab.
         *
         * Default value: `true`
         *
         * [View Demo](https://surveyjs.io/Examples/Creator?id=theme-switcher (linkStyle))
         * @see themeForPreview
         */
        _this.allowChangeThemeInPreview = true;
        _this._tabResponsivenessMode = "menu";
        /**
         * Specifies whether to show an error message if a survey is not saved in a database.
         *
         * Default value: `true`
         */
        _this.showErrorOnFailedSave = true;
        /**
         * An event that is raised before the [active tab](#activeTab) is switched. Use this event to allow or cancel the switch.
         * @see makeNewViewActive
         */
        _this.onActiveTabChanging = _this.addCreatorEvent();
        /**
         * An event that is raised after the [active tab](#activeTab) is switched.
         * @see makeNewViewActive
         */
        _this.onActiveTabChanged = _this.addCreatorEvent();
        _this.showSidebarValue = true;
        _this.onShowSidebarVisibilityChanged = _this.addCreatorEvent();
        //#region Obsolete properties and functins
        _this.onShowPropertyGridVisiblityChanged = _this.addCreatorEvent();
        //#endregion Obsolete properties and functions
        //#region Undo/Redo
        /**
         * An event that is raised before an undo operation.
         * @see undo
         * @see redo
         * @see onBeforeRedo
         */
        _this.onBeforeUndo = _this.addCreatorEvent();
        /**
         * An event that is raised before an redo operation.
         * @see redo
         * @see undo
         * @see onBeforeUndo
         */
        _this.onBeforeRedo = _this.addCreatorEvent();
        /**
         * An event that is raised before a new page is added to the survey. Handle this event if you do not want to add the page.
         */
        _this.onPageAdding = _this.addCreatorEvent();
        /**
         * An event that is raised when users start to drag a survey element within the design surface.
         * @see onDragEnd
         * @see onDragDropAllow
         */
        _this.onDragStart = _this.addCreatorEvent();
        _this.onBeforeDrop = _this.onDragStart;
        /**
         * An event that is raised when users finish dragging a survey element within the design surface.
         * @see onDragStart
         * @see onDragDropAllow
         */
        _this.onDragEnd = _this.addCreatorEvent();
        _this.onAfterDrop = _this.onDragEnd;
        _this.animationEnabled = false;
        _this.onStateChanged = _this.addCreatorEvent();
        _this.expandCollapseManager = new _expand_collapse_manager__WEBPACK_IMPORTED_MODULE_25__.ExpandCollapseManager(_this);
        _this.notifier = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Notifier({
            root: "svc-notifier",
            rootWithButtons: "",
            info: "svc-notifier--info",
            error: "svc-notifier--error",
            success: "svc-notifier--success",
            button: "",
            shown: "svc-notifier--shown"
        });
        /**
         * Specifies where to add new questions when users click the "Add Question" button.
         *
         * Accepted values:
         *
         * - `true` (default)
         * New questions are added to the end of a survey page.
         *
         * - `false`
         * New questions are added after the currently selected question on the design surface.
         */
        _this.addNewQuestionLast = true;
        _this.onKeyDownHandler = function (event) {
            _this.findSuitableShortcuts(event).forEach(function (shortcut) {
                if ((event.keyCode < 48 || event.keyCode == 89 || event.keyCode == 90) && isTextInput(event.target))
                    return;
                shortcut.execute(_this.selectedElement);
            });
        };
        _this.shortcuts = {};
        _this.hiddenProperties = {};
        _this.translationLocalesOrder = [];
        /**
         * A delay between changing survey settings and saving the survey JSON schema, measured in milliseconds. Applies only when the [`isAutoSave`](#isAutoSave) property is `true`.
         *
         * Default value: 500 (inherited from `settings.autoSave.delay`)
         *
         * If a user changes the settings once again during the delay, only the latest version will be saved.
         */
        _this.autoSaveDelay = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.autoSave.delay;
        _this.autoSaveTimerId = null;
        _this.saveNo = 0;
        _this._syncSaveActions = function (sender, options) {
            var saveAction = _this._findAction("svd-save");
            var saveThemeAction = _this._findAction("svd-save-theme");
            if (!saveAction || !saveThemeAction) {
                return;
            }
            if (sender === _this) {
                saveThemeAction.enabled = saveAction.enabled;
            }
            else {
                saveAction.enabled = saveThemeAction.enabled;
            }
        };
        _this.showTabsDefault = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.layout.showTabs;
        _this.showToolbarDefault = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.layout.showToolbar;
        _this.expandOnDragTimeOut = 1000;
        _this.themeVariables = {};
        _this.preferredColorPalette = "light";
        _this.allowDragPages = false;
        _this.collapsePagesOnDrag = false;
        if (!!options2 ||
            typeof _this.options === "string" ||
            _this.options instanceof String) {
            _this.options = !!options2 ? options2 : {};
            _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnText("Creator constructor has one parameter, as creator options, in V2.");
        }
        _this.previewDevice = (_a = options.previewDevice) !== null && _a !== void 0 ? _a : "desktop";
        _this.previewOrientation = options.previewOrientation;
        _this.toolbarValue = new ToolbarActionContainer(_this);
        _this.toolbarValue.locOwner = _this;
        _this.tabbedMenu = new _tabbed_menu__WEBPACK_IMPORTED_MODULE_28__.TabbedMenuContainer(_this);
        _this.tabbedMenu.locOwner = _this;
        _this.selectionHistoryControllerValue = new _selection_history__WEBPACK_IMPORTED_MODULE_10__.SelectionHistory(_this);
        _this.sidebar = new _components_side_bar_side_bar_model__WEBPACK_IMPORTED_MODULE_20__.SidebarModel(_this);
        _this.setOptions(_this.options);
        _this.patchMetadata();
        _this.initSurveyWithJSON(undefined, false);
        _this.toolbox = new _toolbox__WEBPACK_IMPORTED_MODULE_7__.QuestionToolbox(_this.options && _this.options.questionTypes ? _this.options.questionTypes : null, _this, true);
        _this.updateToolboxIsCompact();
        _this.initDragDrop();
        _this.initTabs();
        _this.syncSaveButtons = _this.options.saveSurveyAndTheme !== undefined ? _this.options.saveSurveyAndTheme : _this.options.syncSaveButtons;
        _this.isTouch = survey_core__WEBPACK_IMPORTED_MODULE_1__.IsTouch;
        var expandAction = _this.sidebar.getExpandAction();
        !!expandAction && _this.toolbar.actions.push(expandAction);
        return _this;
    }
    //ILocalizableOwner
    SurveyCreatorModel.prototype.getMarkdownHtml = function (text, name) { return null; };
    SurveyCreatorModel.prototype.getRenderer = function (name) { return null; };
    SurveyCreatorModel.prototype.getRendererContext = function (locStr) { return locStr; };
    SurveyCreatorModel.prototype.getProcessedText = function (text) { return text; };
    SurveyCreatorModel.prototype.getLocale = function () { return this.locale; };
    Object.defineProperty(SurveyCreatorModel.prototype, "showPreviewTab", {
        /**
         * Specifies whether to display the Preview tab.
         *
         * Default value: `true`
         * @see activeTab
         * @see onSurveyInstanceCreated
         */
        get: function () { return this.showTestSurveyTab; },
        set: function (val) { this.showTestSurveyTab = val; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "showOneCategoryInPropertyGrid", {
        get: function () {
            return this._showOneCategoryInPropertyGrid;
        },
        set: function (newValue) {
            var _this = this;
            this._showOneCategoryInPropertyGrid = newValue;
            Object.keys(this.plugins).forEach(function (name) {
                var plugin = _this.plugins[name];
                if (!!plugin && "showOneCategoryInPropertyGrid" in plugin) {
                    plugin.showOneCategoryInPropertyGrid = newValue;
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "allowEditSurveyTitle", {
        get: function () {
            return this.getPropertyValue("allowEditSurveyTitle", true);
        },
        set: function (val) {
            this.setPropertyVisibility("survey", val, "title", "description", "logo", "logoFit", "showTitle", "logoWidth", "logoHeight");
            this.setPropertyValue("allowEditSurveyTitle", val);
            this.designerPropertyGrid && this.designerPropertyGrid.refresh();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "showSurveyTitle", {
        /**
         * Specifies whether users can see and edit the survey header and related survey properties.
         *
         * Default value: `true`
         */
        get: function () {
            return this.allowEditSurveyTitle;
        },
        set: function (val) {
            this.allowEditSurveyTitle = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "haveCommercialLicense", {
        get: function () {
            return !!survey_core__WEBPACK_IMPORTED_MODULE_1__.hasLicense && (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.hasLicense)(1);
        },
        set: function (val) {
            // eslint-disable-next-line no-console
            console.warn("As of v1.9.101, the haveCommercialLicense property is not supported. To activate your license, use the setLicenseKey(key) method as shown on the following page: https://surveyjs.io/remove-alert-banner");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "licenseText", {
        get: function () {
            return this.getLocString("survey.license");
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.slk = function (val) {
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.slk)(val);
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "startEditTitleOnQuestionAdded", {
        get: function () {
            return !this.isMobileView && !this.toolbox.searchManager.filterString && this.startEditTitleOnQuestionAddedValue;
        },
        set: function (value) {
            this.startEditTitleOnQuestionAddedValue = value;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.changePageModifications = function (allow) {
        if (allow === void 0) { allow = false; }
        this.setPropertyVisibility("survey", allow, "pages");
        this.setPropertyVisibility("question", allow, "page");
        this.setPropertyVisibility("panel", allow, "page");
        this.showJSONEditorTab = (this.options.showJSONEditorTab === true);
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "pageEditMode", {
        /**
         * Specifies how Survey Creator users edit survey pages.
         *
         * Accepted values:
         *
         * - `"standard"` (default)
         * Questions and panels are divided between pages. Users can scroll the design surface to reach a required page.
         *
         * - `"single"`
         * All questions and panels belong to a single page. Users cannot add or remove pages.
         *
         * - `"bypage"`
         * Questions and panels are divided between pages. Users can use the page navigator to switch to a required page.
         * @see allowModifyPages
         */
        get: function () {
            return this.pageEditModeValue;
        },
        set: function (val) {
            this.pageEditModeValue = val;
            var allowModifyPages = this.pageEditModeValue !== "single";
            this.changePageModifications(allowModifyPages);
            survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.allowShowEmptyTitleInDesignMode = allowModifyPages;
            survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.allowShowEmptyDescriptionInDesignMode = allowModifyPages;
            if (this.pageEditModeValue === "bypage") {
                this.showPageNavigator = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "toolbarItems", {
        get: function () {
            return this.toolbarValue.actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "toolbar", {
        get: function () {
            return this.toolbarValue;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype._findAction = function (id) {
        return this.toolbarItems.filter(function (a) { return a.id === id; })[0];
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "showingViewName", {
        get: function () {
            return this.activeTab;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "isDesignerShowing", {
        get: function () {
            return this.activeTab === "designer";
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.showDesigner = function () {
        this.activeTab = "designer";
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "isTestSurveyShowing", {
        get: function () {
            return this.isPreviewShowing;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "isPreviewShowing", {
        get: function () {
            return this.activeTab === "test";
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.showTestSurvey = function () {
        this.showPreview();
    };
    SurveyCreatorModel.prototype.showPreview = function () {
        this.activeTab = "test";
    };
    /**
     * Adds a custom tab to Survey Creator.
     *
     * [View Demo](https://surveyjs.io/survey-creator/examples/modify-tab-bar/ (linkStyle))
     * @param name A unique tab ID.
     * @param plugin An object that allows you to handle user interactions with the tab.
     * @param title A tab caption. If `title` is undefined, the `name` argument value is displayed instead. To localize the caption, add its translations to the `ed` object within [localization dictionaries](https://github.com/surveyjs/survey-creator/tree/90de47d2c9da49b06a7f97414026d70f7acf05c6/packages/survey-creator-core/src/localization) and pass `ed.propertyName` as the `title` argument.
     * @param componentName The name of the component that renders tab markup. Default value: `"svc-tab-" + name`.
     * @param index A zero-based index that specifies the tab's position relative to other tabs.
     */
    SurveyCreatorModel.prototype.addPluginTab = function (name, plugin, title, componentName, index) {
        this.tabbedMenu.addTab(name, plugin, title, componentName, index);
        this.addPlugin(name, plugin);
    };
    SurveyCreatorModel.prototype.addPlugin = function (name, plugin) {
        this.plugins[name] = plugin;
    };
    SurveyCreatorModel.prototype.removePlugin = function (name) {
        var plugin = this.getPlugin(name);
        if (!plugin)
            return;
        var index = this.getTabIndex(name);
        if (index > -1) {
            this.tabs.splice(index, 1);
        }
        delete this.plugins[name];
        if (plugin.dispose) {
            plugin.dispose();
        }
    };
    SurveyCreatorModel.prototype.getTabIndex = function (id) {
        for (var i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].id === id)
                return i;
        }
        return -1;
    };
    SurveyCreatorModel.prototype.getPlugin = function (name) {
        return this.plugins[name];
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "showPagesInPreviewTab", {
        /**
         * Specifies whether to show a page selector at the bottom of the Preview tab.
         *
         * Default value: `true`
         */
        get: function () { return this.showPagesInTestSurveyTab; },
        set: function (val) { this.showPagesInTestSurveyTab = val; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "showSimulatorInPreviewTab", {
        /**
         * Specifies whether the Preview tab displays a Device button that allows users to preview the survey on different device types.
         *
         * Default value: `true`
         */
        get: function () { return this.showSimulatorInTestSurveyTab; },
        set: function (val) { this.showSimulatorInTestSurveyTab = val; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "themeEditor", {
        //#region Theme
        /**
         * An object that enables you to manage UI themes. Refer to the following API section for information on available properties, methods, and events: [`ThemeTabPlugin`](https://surveyjs.io/survey-creator/documentation/api-reference/themetabplugin).
         * @see showThemeTab
         * @see saveThemeFunc
         */
        get: function () {
            return this.getPlugin("theme");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "saveThemeFunc", {
        /**
         * A function that is called each time users click the [Save button](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#showSaveButton) or [auto-save](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#isAutoSave) is triggered to save a theme JSON object.
         *
         * For more information, refer to the [Save and Load Custom Themes](https://surveyjs.io/survey-creator/documentation/theme-editor#save-and-load-custom-themes) help topic.
         * @see showThemeTab
         * @see themeEditor
         * @see saveSurveyFunc
         */
        get: function () {
            return this.saveThemeFuncValue;
        },
        set: function (value) {
            this.saveThemeFuncValue = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "theme", {
        /**
         * Gets or sets a [theme](https://surveyjs.io/form-library/documentation/api-reference/itheme) for the survey being configured.
         *
         * [Theme Editor](https://surveyjs.io/survey-creator/documentation/theme-editor (linkStyle))
         * @see showThemeTab
         * @see themeEditor
         * @see saveThemeFunc
         */
        get: function () {
            return this._theme;
        },
        set: function (newTheme) {
            this._theme = newTheme;
            this.hasPendingThemeChanges = true;
            if (this.activeTab !== "theme") {
                this.updatePlugin(this.activeTab);
            }
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype._doSaveThemeCore = function (onSaveComplete) {
        var _this = this;
        this.setState("saving");
        if (this.saveThemeFunc) {
            this.saveNo++;
            this.saveThemeFunc(this.saveNo, function (no, isSuccess) {
                if (_this.saveNo !== no)
                    return;
                if (isSuccess) {
                    _this.setState("saved");
                    _this.hasPendingThemeChanges = false;
                }
                else {
                    _this.setState("modified");
                    if (_this.showErrorOnFailedSave) {
                        _this.notify(_this.getLocString("ed.saveError"), "error");
                    }
                }
                onSaveComplete && onSaveComplete();
            });
        }
    };
    /**
     * Calls the [`saveThemeFunc`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#saveThemeFunc) function to save the theme JSON schema.
     * @see saveSurvey
     * @see save
     */
    SurveyCreatorModel.prototype.saveTheme = function () {
        this._doSaveThemeCore();
    };
    SurveyCreatorModel.prototype.saveThemeActionHandler = function () {
        if (this.syncSaveButtons) {
            this.save();
        }
        else {
            this.saveTheme();
        }
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "allowModifyPages", {
        /**
         * Specifies whether users can add, edit, and delete survey pages.
         *
         * Default value: `true`
         * @see pageEditMode
         */
        get: function () {
            return this._allowModifyPages;
        },
        set: function (val) {
            this._allowModifyPages = val;
            this.changePageModifications(val);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "showDefaultLanguageInPreviewTab", {
        /**
         * Specifies whether the Preview tab displays a language selector.
         *
         * Accepted values:
         *
         * - `"auto"` (default)
         * Display the language selector only if the survey is translated into more than one language.
         *
         * - `true`
         * Always display the language selector regardless of how many languages the survey uses.
         *
         * - `false`
         * Never display the language selector.
         *
         * - `"all"`
         * Always display the language selector with [all supported languages](https://github.com/surveyjs/survey-creator/tree/90de47d2c9da49b06a7f97414026d70f7acf05c6/packages/survey-creator-core/src/localization).
         *
         * [Localization & Globalization](https://surveyjs.io/survey-creator/documentation/survey-localization-translate-surveys-to-different-languages (linkStyle))
         */
        get: function () { return this.showDefaultLanguageInTestSurveyTab; },
        set: function (val) { this.showDefaultLanguageInTestSurveyTab = val; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "showInvisibleElementsInPreviewTab", {
        /**
         * Specifies whether the Preview tab displays a toggle that allows users to show or hide invisible survey elements.
         *
         * Default value: `true`
         */
        get: function () { return this.showInvisibleElementsInTestSurveyTab; },
        set: function (val) { this.showInvisibleElementsInTestSurveyTab = val; },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "tabResponsivenessMode", {
        get: function () {
            return this._tabResponsivenessMode;
        },
        set: function (val) {
            this._tabResponsivenessMode = val;
            this.tabbedMenu.updateResponsivenessMode();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "tabs", {
        get: function () {
            return this.tabbedMenu.actions;
        },
        set: function (val) {
            this.tabbedMenu.actions = val;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.getLocString = function (str) {
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString(str);
    };
    SurveyCreatorModel.prototype.onSetReadOnly = function (newVal) { };
    Object.defineProperty(SurveyCreatorModel.prototype, "locale", {
        /**
         * Specifies the locale of the Survey Creator UI.
         *
         * Default value: `""` (inherited from `editorLocalization.currentLocale`)
         *
         * [Localization & Globalization](https://surveyjs.io/survey-creator/documentation/survey-localization-translate-surveys-to-different-languages (linkStyle))
         */
        get: function () {
            return this.getPropertyValue("locale", _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.currentLocale);
        },
        set: function (value) {
            if (_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.currentLocale === value)
                return;
            _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.currentLocale = value;
            this.setPropertyValue("locale", value);
            this.updateLocalizedStrings();
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.updateLocalizedStrings = function () {
        this.toolbox.updateTitles();
        this.refreshPlugin();
        var selEl = this.selectedElement;
        if (!!selEl) {
            this.selectElement(null);
            this.selectElement(selEl);
        }
        this.locStrsChanged();
    };
    SurveyCreatorModel.prototype.locStrsChanged = function () {
        _super.prototype.locStrsChanged.call(this);
        this.tabbedMenu.locStrsChanged();
        this.toolbar.locStrsChanged();
    };
    SurveyCreatorModel.prototype.refreshPlugin = function () {
        var plugin = this.currentPlugin;
        if (!!plugin) {
            if (plugin.deactivate) {
                plugin.deactivate();
            }
            var viewType = this.viewType;
            this.viewType = "";
            plugin.activate();
            this.viewType = viewType;
        }
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "readOnly", {
        /**
         * Enables the read-only mode. If you set this property to `true`, users cannot change the initial survey configuration.
         *
         * Default value: `false`
         */
        get: function () {
            return this.getPropertyValue("readOnly", false);
            //return this.koReadOnly();
        },
        set: function (newVal) {
            var text = this.text;
            this.setPropertyValue("readOnly", newVal);
            this.onSetReadOnly(newVal);
            this.text = text;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "isRTL", {
        /**
         * Specifies whether to enable support for right-to-left languages.
         *
         * Default value: `false`
         */
        get: function () {
            return this.isRTLValue;
        },
        set: function (value) {
            this.isRTLValue = value;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "activeTab", {
        /**
         * Gets or sets the currently displayed tab.
         *
         * Possible values:
         *
         * - [`"designer"`](#showDesignerTab)
         * - [`"test"`](#showPreviewTab)
         * - [`"theme"`](#showThemeTab)
         * - [`"editor"`](#showJSONEditorTab)
         * - [`"logic"`](#showLogicTab)
         * - [`"translation"`](#showLogicTab)
         * @see makeNewViewActive
         */
        get: function () {
            return this.viewType;
        },
        set: function (val) {
            this.makeNewViewActive(val);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Switches the [active tab](#activeTab). Returns `false` if the tab cannot be switched.
     * @param tabName A tab that you want to make active: `"designer"`, `"test"`, `"theme"`, `"editor"`, `"logic"`, or `"translation"`.
     * @returns `false` if the active tab cannot be switched, `true` otherwise.
     */
    SurveyCreatorModel.prototype.makeNewViewActive = function (tabName) {
        var _this = this;
        if (tabName == this.viewType)
            return false;
        var plugin = this.currentPlugin;
        if (!!plugin && !!plugin.canDeactivateAsync) {
            plugin.canDeactivateAsync(function () {
                _this.switchViewType(tabName);
            });
            return undefined;
        }
        return this.switchViewType(tabName);
    };
    SurveyCreatorModel.prototype.switchViewType = function (viewName) {
        var _a, _b, _c;
        var allow = true;
        if (!!((_a = this.currentPlugin) === null || _a === void 0 ? void 0 : _a.defaultAllowingDeactivate)) {
            allow = this.currentPlugin.defaultAllowingDeactivate();
            if (allow === undefined)
                return false;
        }
        var chaningOptions = { tabName: viewName, allow: allow, model: (_b = this.currentPlugin) === null || _b === void 0 ? void 0 : _b.model };
        this.onActiveTabChanging.fire(this, chaningOptions);
        if (!chaningOptions.allow)
            return;
        if (!!((_c = this.currentPlugin) === null || _c === void 0 ? void 0 : _c.deactivate) && !this.currentPlugin.deactivate())
            return;
        var plugin = this.activatePlugin(viewName);
        this.viewType = viewName;
        this.onActiveTabChanged.fire(this, { tabName: viewName, plugin: plugin, model: !!plugin ? plugin.model : undefined });
        return true;
    };
    SurveyCreatorModel.prototype.activatePlugin = function (newType) {
        var plugin = this.getPlugin(newType);
        if (!!plugin) {
            plugin.activate();
        }
        return plugin;
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "currentPlugin", {
        get: function () {
            return this.getPlugin(this.activeTab);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "toolboxCategories", {
        get: function () {
            return this.toolbox.categories;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.addCreatorEvent = function () {
        return this.addEvent();
    };
    SurveyCreatorModel.prototype.updateToolboxIsCompact = function (newVal) {
        if (!this.toolbox)
            return;
        var hasValue = newVal != undefined && newVal != null;
        if (this.toolbox.forceCompact !== undefined) {
            this.toolbox.isCompact = this.toolbox.forceCompact;
        }
        else if (this.toolboxLocation == "right") {
            this.toolbox.isCompact = this.showSidebar || (hasValue && newVal);
        }
        else if (hasValue && this.toolbox.isCompact !== newVal) {
            this.toolbox.isCompact = newVal;
        }
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "showToolbox", {
        get: function () {
            return this.showToolboxValue && this.allowShowToolbox;
        },
        /**
         * Specifies whether to show the Toolbox.
         *
         * Default value: `true`
         *
         * [Toolbox Customization](https://surveyjs.io/survey-creator/documentation/toolbox-customization (linkStyle))
         * @see toolbox
         * @see toolboxLocation
         */
        set: function (val) {
            if (val !== true && val !== false) {
                _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnText("showToolbox is a boolean property now.");
            }
            if (val === "none" || val === false || val === "top") {
                this.showToolboxValue = false;
            }
            else if (val === true) {
                this.showToolboxValue = true;
            }
            else {
                this.toolboxLocation = val;
                this.showToolboxValue = true;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "showSidebar", {
        /**
         * Specifies whether to show the sidebar that displays the Property Grid.
         *
         * Default value: `true`
         * @see sidebarLocation
         */
        get: function () {
            return this.showSidebarValue;
        },
        set: function (val) {
            if (val !== true && val !== false) {
                _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnText("showSidebar is a boolean property now.");
                return;
            }
            if (this.showSidebar === val)
                return;
            this.setShowSidebar(val, true);
            if (!this.onShowPropertyGridVisiblityChanged.isEmpty) {
                _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnNonSupported("onShowPropertyGridVisiblityChanged", "onShowSidebarVisibilityChanged");
                this.onShowPropertyGridVisiblityChanged.fire(this, { show: val });
            }
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.setShowSidebar = function (value, isManualMode) {
        if (isManualMode === void 0) { isManualMode = false; }
        this.showSidebarValue = value;
        if (isManualMode) {
            if (value) {
                this.sidebar.expandedManually = true;
            }
            else {
                this.sidebar.collapsedManually = true;
            }
        }
        this.updateToolboxIsCompact();
        this.onShowSidebarVisibilityChanged.fire(this, { show: value });
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "showPropertyGrid", {
        get: function () {
            _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnNonSupported("showPropertyGrid", "showSidebar");
            return this.showSidebar;
        },
        set: function (val) {
            _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnNonSupported("showPropertyGrid", "showSidebar");
            if (val !== true && val !== false) {
                _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnText("showSidebar is a boolean property.");
                return;
            }
            this.showSidebar = val;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.rightContainerActiveItem = function (name) {
        _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnNonSupported("rightContainerActiveItem");
    };
    SurveyCreatorModel.prototype.leftContainerActiveItem = function (name) {
        _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnNonSupported("leftContainerActiveItem");
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "undoRedoManager", {
        get: function () {
            var plugin = this.getPlugin("undoredo");
            return plugin && plugin.model.undoRedoManager;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "undoRedoController", {
        get: function () {
            var plugin = this.getPlugin("undoredo");
            return plugin && plugin.model;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.startUndoRedoTransaction = function (name) {
        this.undoRedoController && this.undoRedoController.startTransaction(name);
    };
    SurveyCreatorModel.prototype.stopUndoRedoTransaction = function () {
        this.undoRedoController && this.undoRedoController.stopTransaction();
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "isProcessingUndoRedo", {
        /**
         * Returns `true` if an undo or redo operation is in progress.
         * @see undo
         * @see redo
         */
        get: function () {
            return this.undoRedoManager && this.undoRedoManager.isProcessingUndoRedo;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Cancels the last change if possible.
     * @see redo
     * @see onBeforeUndo
     */
    SurveyCreatorModel.prototype.undo = function () {
        this.undoRedoController && this.undoRedoController.undo();
    };
    /**
     * Repeats the last undone action if possible.
     * @see undo
     * @see onBeforeRedo
     */
    SurveyCreatorModel.prototype.redo = function () {
        this.undoRedoController && this.undoRedoController.redo();
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "selectionHistoryController", {
        //#endregion Undo/Redo
        get: function () {
            return this.selectionHistoryControllerValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "currentPage", {
        get: function () {
            return this.survey.currentPage;
        },
        set: function (value) {
            this.survey.currentPage = value;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.canAddPage = function (pageToAdd) {
        var options = {
            page: pageToAdd,
            allow: true
        };
        this.onPageAdding.fire(this, options);
        return options.allow;
    };
    SurveyCreatorModel.prototype.addPage = function (pageToAdd, changeSelection, beforeAdd) {
        if (changeSelection === void 0) { changeSelection = true; }
        if (!this.canAddPage(pageToAdd)) {
            return null;
        }
        if (beforeAdd !== undefined) {
            if (!beforeAdd()) {
                return;
            }
        }
        var page = pageToAdd;
        if (!page) {
            page = this.addNewPageIntoSurvey();
        }
        else {
            this.survey.addPage(page);
        }
        if (changeSelection) {
            this.selectElement(page);
        }
        return page;
    };
    SurveyCreatorModel.prototype.addNewPageIntoSurvey = function () {
        var name = _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getNewPageName(this.survey.pages);
        return this.survey.addNewPage(name);
    };
    SurveyCreatorModel.prototype.initTabs = function () {
        this.initPlugins();
        this.initFooterToolbar();
    };
    SurveyCreatorModel.prototype.getTabsInfo = function () {
        var _this = this;
        return {
            designer: function () { return new _components_tabs_designer_plugin__WEBPACK_IMPORTED_MODULE_18__.TabDesignerPlugin(_this); },
            preview: function () { return new _components_tabs_test_plugin__WEBPACK_IMPORTED_MODULE_13__.TabTestPlugin(_this); },
            theme: function () { return new _components_tabs_theme_plugin__WEBPACK_IMPORTED_MODULE_23__.ThemeTabPlugin(_this); },
            logic: function () { return new _components_tabs_logic_plugin__WEBPACK_IMPORTED_MODULE_16__.TabLogicPlugin(_this); },
            editor: function () { return _components_tabs_json_editor_ace__WEBPACK_IMPORTED_MODULE_11__.TabJsonEditorAcePlugin.hasAceEditor() ? new _components_tabs_json_editor_ace__WEBPACK_IMPORTED_MODULE_11__.TabJsonEditorAcePlugin(_this) : new _components_tabs_json_editor_textarea__WEBPACK_IMPORTED_MODULE_12__.TabJsonEditorTextareaPlugin(_this); },
            translation: function () { return new _components_tabs_translation_plugin__WEBPACK_IMPORTED_MODULE_15__.TabTranslationPlugin(_this); }
        };
    };
    SurveyCreatorModel.prototype.getAvailableTabNames = function () {
        var res = [];
        var tabInfo = this.getTabsInfo();
        for (var key in tabInfo) {
            res.push(key);
        }
        return res;
    };
    SurveyCreatorModel.prototype.getTabNames = function () {
        var tabNames = this.getAvailableTabNames();
        var res = [];
        this.tabs.forEach(function (tab) {
            var name = tab.id === "test" ? "preview" : tab.id;
            if (tabNames.indexOf(name) > -1) {
                res.push(name);
            }
        });
        return res;
    };
    //TODO-presets
    SurveyCreatorModel.prototype.setTabs = function (tabNames) {
        var _this = this;
        if (!Array.isArray(tabNames))
            return;
        var tabInfo = this.getTabsInfo();
        for (var i = tabNames.length - 1; i >= 0; i--) {
            if (!tabInfo[tabNames[i]])
                tabNames.splice(i, 1);
        }
        if (tabNames.length === 0)
            return;
        for (var i = this.tabs.length - 1; i >= 0; i--) {
            var tabId = this.tabs[i].id;
            var id = tabId === "test" ? "preview" : tabId;
            if (tabNames.indexOf(id) < 0) {
                this.removePlugin(tabId);
            }
        }
        tabNames.forEach(function (id) {
            var tabId = id === "preview" ? "test" : id;
            if (tabInfo[id] && _this.getTabIndex(tabId) < 0) {
                tabInfo[id]();
            }
        });
        for (var i = 0; i < tabNames.length; i++) {
            var index = this.getTabIndex(tabNames[i]);
            if (index > -1 && index !== i) {
                var item = this.tabs[index];
                this.tabs.splice(index, 1);
                this.tabs.splice(i, 0, item);
            }
        }
        if (this.tabs.length > 0) {
            this.makeNewViewActive(this.tabs[0].id);
        }
    };
    SurveyCreatorModel.prototype.initPlugins = function () {
        this.addPlugin("undoredo", new _plugins_undo_redo__WEBPACK_IMPORTED_MODULE_17__.UndoRedoPlugin(this));
        var tabs = [];
        if (this.showDesignerTab) {
            tabs.push("designer");
        }
        if (this.showPreviewTab) {
            tabs.push("preview");
        }
        if (this.showThemeTab) {
            tabs.push("theme");
        }
        if (this.showLogicTab) {
            tabs.push("logic");
        }
        if (this.showJSONEditorTab) {
            tabs.push("editor");
        }
        if (this.showTranslationTab) {
            tabs.push("translation");
        }
        this.setTabs(tabs);
    };
    SurveyCreatorModel.prototype.initFooterToolbar = function () {
        var _this = this;
        if (!this.footerToolbar) {
            this.footerToolbar = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ActionContainer();
            ["designer", "undoredo", "test", "theme"].forEach(function (pluginKey) {
                var plugin = _this.getPlugin(pluginKey);
                if (!!plugin && !!plugin["addFooterActions"]) {
                    plugin["addFooterActions"]();
                }
            });
        }
    };
    SurveyCreatorModel.prototype.getOptions = function () {
        return this.options || {};
    };
    SurveyCreatorModel.prototype.setOptions = function (options) {
        if (!options)
            options = {};
        var obsoleteOptions = {};
        obsoleteOptions["showTestSurveyTab"] = "showPreviewTab";
        obsoleteOptions["showDefaultLanguageInTestSurveyTab"] = "showDefaultLanguageInPreviewTab";
        obsoleteOptions["showInvisibleElementsInPreviewTab"] = "showInvisibleElementsInTestSurveyTab";
        for (var key in obsoleteOptions) {
            if (options[key] === undefined)
                continue;
            var newKey = obsoleteOptions[key];
            if (options[newKey] === undefined) {
                options[newKey] = options[key];
                delete options[key];
            }
        }
        this.options = options;
        for (var key in options) {
            this[key] = options[key];
        }
    };
    SurveyCreatorModel.prototype.setPropertyPlaceHolder = function (className, propertyName, value) {
        var prop = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(className, propertyName);
        if (!!prop) {
            prop.placeholder = value;
        }
    };
    SurveyCreatorModel.prototype.setPropertyVisibility = function (className, visible) {
        var properties = [];
        for (var _i = 2; _i < arguments.length; _i++) {
            properties[_i - 2] = arguments[_i];
        }
        if (!Array.isArray(properties))
            return;
        for (var i = 0; i < properties.length; i++) {
            var prop = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(className, properties[i]);
            if (!!prop) {
                if (!visible) {
                    this.hiddenProperties[prop.id] = true;
                }
                else {
                    delete this.hiddenProperties[prop.id];
                }
            }
        }
    };
    SurveyCreatorModel.prototype.patchMetadata = function () {
        this.setPropertyPlaceHolder("survey", "title", "pe.surveyTitlePlaceholder");
        this.setPropertyPlaceHolder("survey", "description", "pe.surveyDescriptionPlaceholder");
        this.setPropertyVisibility("survey", false, "logoPosition");
        if (this.pageEditMode !== "single") {
            this.setPropertyPlaceHolder("page", "title", "pe.pageTitlePlaceholder");
            this.setPropertyPlaceHolder("page", "description", "pe.pageDescriptionPlaceholder");
        }
    };
    SurveyCreatorModel.prototype.isCanModifyProperty = function (obj, propertyName) {
        var property = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(obj.getType(), propertyName);
        var parentObj, parentProperty;
        if (obj instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue) {
            parentObj = obj.locOwner;
            parentProperty = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(parentObj.getType(), obj.ownerPropertyName || propertyName);
            var allowEdit = true;
            if (parentObj instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionSelectBase)
                allowEdit = parentObj.isItemInList(obj);
            var allowQuestionOperations = this.getElementAllowOperations(parentObj);
            if (allowQuestionOperations.allowEdit === false)
                return false;
            var options = { allowDelete: true, allowEdit: allowEdit, allowAdd: true };
            this.onCollectionItemAllowingCallback(parentObj, property, parentObj.getPropertyValue(parentProperty === null || parentProperty === void 0 ? void 0 : parentProperty.name), obj, options);
            if (options.allowEdit === false) {
                return false;
            }
            if (this.onIsPropertyReadOnlyCallback(parentObj, parentProperty, parentProperty === null || parentProperty === void 0 ? void 0 : parentProperty.readOnly, null, null)) {
                return false;
            }
        }
        if (obj instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.SurveyElement) {
            var allowElementOperations = this.getElementAllowOperations(obj);
            if (allowElementOperations.allowEdit === false)
                return false;
        }
        return (!property ||
            !this.onIsPropertyReadOnlyCallback(obj, property, property.readOnly, parentObj, parentProperty));
    };
    SurveyCreatorModel.prototype.onIsPropertyReadOnlyCallback = function (obj, property, readOnly, parentObj, parentProperty, creatorReadOnly) {
        if (!property)
            return false;
        if (creatorReadOnly === undefined) {
            creatorReadOnly = this.readOnly;
        }
        var proposedValue = creatorReadOnly || readOnly;
        if (this.onGetPropertyReadOnly.isEmpty)
            return proposedValue;
        var options = {
            obj: obj,
            property: property,
            readOnly: proposedValue,
            propertyName: property.name,
            parentObj: parentObj,
            parentProperty: parentProperty
        };
        this.onGetPropertyReadOnly.fire(this, options);
        return options.readOnly;
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "survey", {
        /**
         * A [survey](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model) being configured in the Designer tab.
         * @see onSurveyInstanceCreated
         */
        get: function () {
            return this.surveyValue;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds new items to the [`pages`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#pages), [`triggers`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#triggers), [`calculatedValues`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#calculatedValues), and [`completedHtmlOnCondition`](https://surveyjs.io/form-library/documentation/api-reference/survey-data-model#completedHtmlOnCondition) arrays in the existing survey JSON schema.
     *
     * Use this method to merge the collection properties of two survey JSON schemas:
     *
     * ```js
     * import { SurveyCreatorModel } from "survey-creator-core";
     * const creatorOptions = { ... };
     * const creator = new SurveyCreatorModel(creatorOptions);
     *
     * const surveyJson1 = { ... };
     * const surveyJson2 = { ... };
     *
     * creator.JSON = surveyJson1;
     * creator.addCollectionItemsJson(surveyJson2);
     * // `creator.JSON` contains the merged survey JSON schema
     * ```
     * @param json A JSON object that contains the `pages`, `triggers`, `calculatedValues`, and/or `completedHtmlOnCondition` array(s).
     * @param insertPageIndex A zero-based index at which to insert new pages.
     */
    SurveyCreatorModel.prototype.addCollectionItemsJson = function (json, insertPageIndex) {
        var survey = new survey_core__WEBPACK_IMPORTED_MODULE_1__.SurveyModel(json);
        this.updateAddingSurvey(survey);
        this.addSurveyPages(survey, insertPageIndex);
    };
    SurveyCreatorModel.prototype.updateAddingSurvey = function (survey) {
        this.updateAddingPages(survey);
        this.updateAddingPanels(survey);
        this.updateAddingQuestions(survey);
        this.updateAddingCalculatedValules(survey);
        this.updateAddingArrays(survey);
    };
    SurveyCreatorModel.prototype.updateAddingPages = function (survey) {
        this.updateAddingElements(survey, survey.pages, this.survey.pages, function (el, allElements) {
            el.name = _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getNewPageName(allElements);
        });
    };
    SurveyCreatorModel.prototype.updateAddingExistingElements = function () {
        return [].concat(this.survey.getAllQuestions(false, true)).concat(this.survey.getAllPanels());
    };
    SurveyCreatorModel.prototype.updateAddingPanels = function (survey) {
        this.updateAddingElements(survey, survey.getAllPanels(), this.updateAddingExistingElements(), function (el, allElements) {
            el.name = _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getNewPanelName(allElements);
        });
    };
    SurveyCreatorModel.prototype.updateAddingQuestions = function (survey) {
        var logic = new _components_tabs_logic__WEBPACK_IMPORTED_MODULE_14__.SurveyLogic(survey, this);
        this.updateAddingElements(survey, survey.getAllQuestions(false, true), this.updateAddingExistingElements(), function (el, allElements) {
            var oldName = el.name;
            el.name = _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getNewQuestionName(allElements);
            logic.renameQuestion(oldName, el.name);
        });
    };
    SurveyCreatorModel.prototype.updateAddingCalculatedValules = function (survey) {
        var logic = new _components_tabs_logic__WEBPACK_IMPORTED_MODULE_14__.SurveyLogic(survey, this);
        this.updateAddingElements(survey, survey.calculatedValues, this.survey.calculatedValues, function (el, allElements) {
            var oldName = el.name;
            el.name = _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getNewName(allElements, "var");
            logic.renameQuestion(oldName, el.name);
        });
    };
    SurveyCreatorModel.prototype.updateAddingArrays = function (survey) {
        var _this = this;
        survey.triggers.forEach(function (item) { return _this.survey.triggers.push(item); });
        survey.completedHtmlOnCondition.forEach(function (item) { return _this.survey.completedHtmlOnCondition.push(item); });
        survey.calculatedValues.forEach(function (item) { return _this.survey.calculatedValues.push(item); });
    };
    SurveyCreatorModel.prototype.updateAddingElements = function (survey, changingElements, existingElements, onChange) {
        var elementsToChange = [];
        var hash = {};
        existingElements.forEach(function (el) {
            if (!!el.name) {
                hash[el.name] = el;
            }
        });
        changingElements.forEach(function (el) {
            if (!!el.name && !!hash[el.name]) {
                elementsToChange.push(el);
            }
        });
        var allElements = existingElements.concat(changingElements);
        elementsToChange.forEach(function (el) {
            onChange(el, allElements);
        });
    };
    SurveyCreatorModel.prototype.addSurveyPages = function (survey, indexPage) {
        if (indexPage === undefined || indexPage >= this.survey.pages.length) {
            indexPage = -1;
        }
        for (var i = 0; i < survey.pages.length; i++) {
            if (indexPage < 0) {
                this.survey.pages.push(survey.pages[i]);
            }
            else {
                this.survey.pages.splice(indexPage + i, 0, survey.pages[i]);
            }
        }
    };
    SurveyCreatorModel.prototype.getSurfaceCss = function () {
        var result = JSON.parse(JSON.stringify(survey_core__WEBPACK_IMPORTED_MODULE_1__.defaultV2Css));
        result.header += " svc-surface-header";
        return result;
    };
    /**
     * Returns true if initial survey was empty. It was not set via JSON property and default new survey is empty as well.
     * @returns true if initial survey doesn't have any elements or properties
     */
    SurveyCreatorModel.prototype.initSurveyWithJSON = function (json, clearState) {
        var _this = this;
        if (!json) {
            json = { "logoPosition": "right" };
        }
        this.existingPages = {};
        var survey = this.createSurvey({}, "designer", undefined, function (survey) {
            survey.skeletonHeight = 188;
            survey.css = _this.getSurfaceCss();
            survey.setIsMobile(!!_this.isMobileView);
            survey.setDesignMode(true);
            survey.lazyRendering = true;
            survey.setJsonObject(json);
            if (survey.isEmpty) {
                survey.setJsonObject(_this.getDefaultSurveyJson());
            }
        });
        survey.pages.forEach(function (page) {
            _this.existingPages[page.id] = true;
        });
        survey.onQuestionAdded.add(function (sender, options) {
            _this.doOnQuestionAdded(options.question, options.parentPanel);
        });
        survey.onPanelAdded.add(function (sender, options) {
            _this.doOnPanelAdded(options.panel, options.parentPanel);
        });
        survey.onPageAdded.add(function (sender, options) {
            if (!!_this.existingPages[options.page.id])
                return;
            _this.existingPages[options.page.id] = true;
            _this.doOnPageAdded(options.page);
        });
        survey.onDragDropAllow.add(function (sender, options) {
            options.survey = sender;
            _this.onDragDropAllow.fire(_this, options);
        });
        this.setSurvey(survey);
        this.expandCollapseManager.expandCollapseElements("loading", false);
        this.updatePlugin(this.activeTab);
        if (this.activeTab !== "designer") {
            this.updatePlugin("designer");
        }
        if (!!this.undoRedoController) {
            this.undoRedoController.updateSurvey();
        }
    };
    SurveyCreatorModel.prototype.updatePlugin = function (name) {
        var plugin = this.getPlugin(this.activeTab);
        if (!!plugin && !!plugin.update) {
            plugin.update();
        }
    };
    SurveyCreatorModel.prototype.initDragDrop = function () {
        this.initDragDropSurveyElements();
        this.initDragDropChoices();
    };
    SurveyCreatorModel.prototype.initDragDropSurveyElements = function () {
        var _this = this;
        _survey_elements__WEBPACK_IMPORTED_MODULE_24__.DragDropSurveyElements.restrictDragQuestionBetweenPages =
            _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.dragDrop.restrictDragQuestionBetweenPages;
        this.dragDropSurveyElements = new _survey_elements__WEBPACK_IMPORTED_MODULE_24__.DragDropSurveyElements(null, this);
        this.dragDropSurveyElements.onGetMaxNestedPanels = function () { return _this.maxNestedPanels; };
        this.dragDropSurveyElements.onDragOverLocationCalculating = function (options) { _this.onDragOverLocationCalculating.fire(_this, options); };
        var isDraggedFromToolbox = false;
        this.dragDropSurveyElements.onDragStart.add(function (sender, options) {
            isDraggedFromToolbox = !sender.draggedElement.parent && !sender.draggedElement.isPage;
            _this.onDragStart.fire(_this, options);
            _this.startUndoRedoTransaction("drag drop");
        });
        this.dragDropSurveyElements.onDragEnd.add(function (sender, options) {
            _this.stopUndoRedoTransaction();
            var editTitle = isDraggedFromToolbox && _this.startEditTitleOnQuestionAdded;
            if (!options.draggedElement)
                return;
            _this.selectElement(options.draggedElement, undefined, true, editTitle);
            _this.onDragEnd.fire(_this, options);
            if (!options.fromElement && !options.draggedElement.isPage) {
                _this.setModified({ type: "ADDED_FROM_TOOLBOX", question: options.draggedElement });
            }
        });
        this.dragDropSurveyElements.onDragClear.add(function (sender, options) {
            var _a;
            isDraggedFromToolbox = false;
            _this.stopUndoRedoTransaction();
            if (_this.collapsePagesOnDrag) {
                (_a = _this.designerStateManager) === null || _a === void 0 ? void 0 : _a.release();
                _this.restoreElementsState();
            }
        });
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "designerStateManager", {
        get: function () {
            var _a;
            return (_a = this.getPlugin("designer")) === null || _a === void 0 ? void 0 : _a.designerStateManager;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.collapseAllPagesOnDragStart = function () {
        this.expandCollapseManager.expandCollapseElements("drag-start", true, this.survey.pages);
    };
    SurveyCreatorModel.prototype.getElementExpandCollapseState = function (element, reason, defaultValue) {
        var options = {
            element: element,
            reason: reason,
            collapsed: defaultValue
        };
        this.onElementGetExpandCollapseState.fire(this, options);
        return options.collapsed;
    };
    SurveyCreatorModel.prototype.restoreState = function (element) {
        var state = this.getElementExpandCollapseState(element, "drag-end", undefined);
        if (state !== undefined) {
            _components_action_container_view_model__WEBPACK_IMPORTED_MODULE_27__.SurveyElementAdornerBase.GetAdorner(element).collapsed = state;
        }
        _components_action_container_view_model__WEBPACK_IMPORTED_MODULE_27__.SurveyElementAdornerBase.RestoreStateFor(element);
    };
    SurveyCreatorModel.prototype.restoreElementsState = function () {
        var _this = this;
        this.survey.pages.forEach(function (element) {
            if (element["draggedFrom"] !== undefined) {
                var adorner = _components_action_container_view_model__WEBPACK_IMPORTED_MODULE_27__.SurveyElementAdornerBase.GetAdorner(element);
                adorner === null || adorner === void 0 ? void 0 : adorner.blockAnimations();
                _this.restoreState(element);
                adorner === null || adorner === void 0 ? void 0 : adorner.releaseAnimations();
            }
            else {
                _this.restoreState(element);
            }
        });
    };
    SurveyCreatorModel.prototype.initDragDropChoices = function () {
        var _this = this;
        this.dragDropChoices = new survey_core__WEBPACK_IMPORTED_MODULE_1__.DragDropChoices(null, this);
        this.dragDropChoices.onDragStart.add(function (sender, options) {
            _this.startUndoRedoTransaction("drag drop");
        });
        this.dragDropChoices.onDragEnd.add(function (sender, options) {
            _this.stopUndoRedoTransaction();
            _this.selectElement(options.draggedElement, undefined, false);
        });
    };
    SurveyCreatorModel.prototype.updateElementsOnLocaleChanged = function (obj, propertyName) {
        if (obj.getType() !== "survey" || propertyName !== "locale")
            return;
        var pages = this.survey.pages;
        for (var i = 0; i < pages.length; i++) {
            pages[i].locStrsChanged();
        }
    };
    SurveyCreatorModel.prototype.updateConditionsOnNameChanged = function (obj, propertyName, oldValue) {
        if (this.isObjQuestion(obj)) {
            if (propertyName === "name" && !obj["valueName"]) {
                this.updateLogicOnQuestionNameChanged(oldValue, obj["name"]);
            }
            if (propertyName === "valueName") {
                var oldName = !!oldValue ? oldValue : obj["name"];
                var newName = !!obj["valueName"] ? obj["valueName"] : obj["name"];
                this.updateLogicOnQuestionNameChanged(oldName, newName);
            }
            if (propertyName === "name" && obj.isDescendantOf("selectbase")) {
                this.updateChoicesFromQuestionOnColumnNameChanged(oldValue, obj["name"]);
            }
        }
        if (propertyName === "name" && obj.isDescendantOf("matrixdropdowncolumn")) {
            this.updateLogicOnColumnNameChanged(obj, oldValue, obj["name"]);
        }
    };
    SurveyCreatorModel.prototype.getSurveyLogicForUpdate = function () {
        if (!!this.surveyLogicForUpdate && this.surveyLogicForUpdate.survey !== this.survey) {
            this.surveyLogicForUpdate = undefined;
        }
        if (!this.surveyLogicForUpdate) {
            this.surveyLogicForUpdate = this.createSurveyLogicForUpdate();
        }
        return this.surveyLogicForUpdate;
    };
    SurveyCreatorModel.prototype.clearSurveyLogicForUpdate = function (obj, propertyName, value) {
        if (this.surveyLogicRenaming || !this.surveyLogicForUpdate || !obj || !propertyName)
            return;
        if (this.needClearSurveyLogicForUpdate(obj, propertyName, value)) {
            this.surveyLogicForUpdate = undefined;
        }
    };
    SurveyCreatorModel.prototype.needClearSurveyLogicForUpdate = function (obj, propertyName, value) {
        if (Array.isArray(value)) {
            return true;
        }
        var prop = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(obj.getType(), propertyName);
        return !!prop && ["expression", "condition", "questionvalue", "question"].indexOf(prop.type) > -1;
    };
    SurveyCreatorModel.prototype.updateSurveyLogicValues = function (obj, propertyName, oldValue) {
        if (!obj || !propertyName || survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(oldValue))
            return;
        if (propertyName === "value" && obj.isDescendantOf("itemvalue")) {
            this.updateSurveyLogicItemValue(obj, oldValue);
        }
    };
    SurveyCreatorModel.prototype.updateSurveyLogicItemValue = function (item, oldValue) {
        if (!item.locOwner || !_creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.updateExpressionsOnChanging.choiceValue)
            return;
        if (["choices", "rateValues", "columns", "rows"].indexOf(item.ownerPropertyName) < 0)
            return;
        this.surveyLogicRenaming = true;
        var logicUpdater = this.getSurveyLogicForUpdate();
        if (item.ownerPropertyName === "rows") {
            logicUpdater.renameRowValue(item, oldValue);
        }
        else {
            logicUpdater.renameItemValue(item, oldValue);
        }
        this.surveyLogicRenaming = false;
    };
    SurveyCreatorModel.prototype.createSurveyLogicForUpdate = function () {
        return new _components_tabs_logic__WEBPACK_IMPORTED_MODULE_14__.SurveyLogic(this.survey, this);
    };
    SurveyCreatorModel.prototype.updateLogicOnQuestionNameChanged = function (oldName, newName) {
        if (oldName === newName || !_creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.updateExpressionsOnChanging.questionName)
            return;
        this.surveyLogicRenaming = true;
        this.getSurveyLogicForUpdate().renameQuestion(oldName, newName);
        this.surveyLogicRenaming = false;
    };
    SurveyCreatorModel.prototype.updateLogicOnColumnNameChanged = function (column, oldName, newName) {
        if (!oldName || oldName === newName || !_creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.updateExpressionsOnChanging.columnName)
            return;
        this.surveyLogicRenaming = true;
        this.getSurveyLogicForUpdate().renameColumn(column, oldName);
        this.surveyLogicRenaming = false;
    };
    SurveyCreatorModel.prototype.updateChoicesFromQuestionOnColumnNameChanged = function (oldName, newName) {
        var questions = this.getAllQuestions();
        questions.forEach(function (q) {
            if (q.choicesFromQuestion === oldName) {
                q.choicesFromQuestion = newName;
            }
        });
    };
    SurveyCreatorModel.prototype.isObjQuestion = function (obj) {
        return this.isObjThisType(obj, "question");
    };
    SurveyCreatorModel.prototype.isObjPage = function (obj) {
        return this.isObjThisType(obj, "page");
    };
    SurveyCreatorModel.prototype.isObjThisType = function (obj, typeName) {
        var classInfo = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findClass(obj.getType());
        while (!!classInfo && !!classInfo.parentName) {
            if (classInfo.name === typeName)
                return true;
            classInfo = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findClass(classInfo.parentName);
        }
        return !!classInfo && classInfo.name === typeName;
    };
    SurveyCreatorModel.prototype.onDragDropItemStart = function () {
        this.addNewElementReason = "DROPPED_FROM_TOOLBOX";
    };
    SurveyCreatorModel.prototype.doOnQuestionAdded = function (question, parentPanel) {
        question.name = this.generateUniqueName(question, question.name);
        var page = this.getPageByElement(question);
        var options = { question: question, page: page, reason: this.addNewElementReason };
        this.addNewElementReason = undefined;
        this.onQuestionAdded.fire(this, options);
    };
    SurveyCreatorModel.prototype.doOnPanelAdded = function (panel, parentPanel) {
        var page = this.getPageByElement(panel);
        var options = { panel: panel, page: page, reason: this.addNewElementReason };
        this.onPanelAdded.fire(this, options);
        this.addNewElementReason = undefined;
    };
    SurveyCreatorModel.prototype.doOnPageAdded = function (page) {
        var options = { page: page };
        this.onPageAdded.fire(this, options);
        var pType = this.isCopyingPage ? "ELEMENT_COPIED" : "PAGE_ADDED";
        this.setModified({ type: pType, newValue: options.page });
    };
    SurveyCreatorModel.prototype.getPageByElement = function (obj) {
        return this.survey.getPageByElement(obj);
    };
    SurveyCreatorModel.prototype.getDefaultSurveyJson = function () {
        var json = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.defaultNewSurveyJSON;
        if (json["pages"] &&
            json["pages"]["length"] > 0 &&
            json["pages"][0]["name"]) {
            json["pages"][0]["name"] =
                _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.newPageName") + "1";
        }
        return json;
    };
    SurveyCreatorModel.prototype.setSurvey = function (survey) {
        if (!!this.surveyValue) {
            this.surveyValue.dispose();
        }
        this.surveyValue = survey;
        this.selectElement(survey);
        this.selectionHistoryController.reset();
    };
    SurveyCreatorModel.prototype.getSurveyTextFromDesigner = function () {
        if (!this.survey)
            return "";
        var json = this.survey.toJSON();
        json = this.singlePageJSON(json);
        this.moveElementsToTheEnd(json);
        var indent = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.jsonEditor.indentation;
        if (this.generateValidJSON) {
            return JSON.stringify(json, null, indent);
        }
        return new _json5__WEBPACK_IMPORTED_MODULE_4__.SurveyJSON5().stringify(json, null, indent);
    };
    SurveyCreatorModel.prototype.moveElementsToTheEnd = function (json) {
        var _this = this;
        if (!json)
            return;
        if (Array.isArray(json)) {
            json.forEach(function (el) { return _this.moveElementsToTheEnd(el); });
        }
        else {
            if (typeof json === "object") {
                if (!!json["elements"]) {
                    var els = json["elements"];
                    delete json["elements"];
                    json["elements"] = els;
                }
                Object.keys(json).forEach(function (key) { return _this.moveElementsToTheEnd(json[key]); });
            }
        }
    };
    SurveyCreatorModel.prototype.setTextValue = function (value) {
        if (!!this.setSurveyJSONTextCallback) {
            this.setSurveyJSONTextCallback(value);
        }
    };
    SurveyCreatorModel.prototype.changeText = function (value, clearState, trustJSON) {
        if (clearState === void 0) { clearState = false; }
        this.setTextValue(value);
        if (!value) {
            this.initSurveyWithJSON(undefined, clearState);
        }
        else {
            var jsonValue = trustJSON ? this.parseJSON(value) : undefined;
            if (!trustJSON) {
                var textWorker = new _textWorker__WEBPACK_IMPORTED_MODULE_6__.SurveyTextWorker(value);
                if (textWorker.isJsonCorrect) {
                    jsonValue = this.parseJSON(value);
                }
                else if (!!textWorker.survey) {
                    jsonValue = textWorker.survey.toJSON();
                }
            }
            if (!!jsonValue) {
                this.initSurveyWithJSON(jsonValue, clearState);
            }
            else {
                this.viewType = "editor";
            }
        }
    };
    SurveyCreatorModel.prototype.parseJSON = function (val) {
        return new _json5__WEBPACK_IMPORTED_MODULE_4__.SurveyJSON5().parse(val);
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "text", {
        /**
         * A survey JSON schema as a string.
         *
         * This property allows you to get or set the JSON schema of a survey being configured. Alternatively, you can use the [`JSON`](#JSON) property.
         */
        get: function () {
            if (!!this.getSurveyJSONTextCallback) {
                return this.getSurveyJSONTextCallback().text;
            }
            return this.getSurveyTextFromDesigner();
        },
        set: function (value) {
            this.changeText(value, true);
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.getSurveyJSON = function () {
        if (this.viewType != "editor") {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.JsonObject().toJsonObject(this.survey);
        }
        var surveyJsonText = this.text;
        var textWorker = new _textWorker__WEBPACK_IMPORTED_MODULE_6__.SurveyTextWorker(surveyJsonText);
        if (textWorker.isJsonCorrect) {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.JsonObject().toJsonObject(textWorker.survey);
        }
        return null;
    };
    SurveyCreatorModel.prototype.getObjectDisplayName = function (obj, area, reason, displayName) {
        if (reason === void 0) { reason = undefined; }
        if (displayName === void 0) { displayName = undefined; }
        if (!displayName) {
            displayName = _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getObjectName(obj, this.showObjectTitles);
        }
        var options = { obj: obj, displayName: displayName, area: area, reason: reason };
        this.onGetObjectDisplayName.fire(this, options);
        return options.displayName;
    };
    SurveyCreatorModel.prototype.createSurvey = function (json, reason, model, callback, area) {
        var _this = this;
        var _a;
        var survey = this.createSurveyCore(json, reason);
        if (reason !== "designer" && reason !== "test" && reason !== "theme") {
            survey.fitToContainer = false;
            survey.applyTheme(_designTabSurveyThemeJSON__WEBPACK_IMPORTED_MODULE_26__["default"]);
            survey.gridLayoutEnabled = false;
        }
        if (reason === "designer" || reason === "modal-question-editor") {
            initializeDesignTimeSurveyModel(survey, this);
        }
        survey["needRenderIcons"] = false;
        if (reason != "designer" && reason != "test" && reason !== "theme") {
            survey.locale = _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.currentLocale;
            if (!json["clearInvisibleValues"]) {
                survey.clearInvisibleValues = "onComplete";
            }
        }
        if (callback) {
            callback(survey);
        }
        area = area || this.getSurveyInstanceCreatedArea(reason);
        this.onSurveyInstanceCreated.fire(this, {
            survey: survey,
            reason: reason,
            area: area,
            model: !!model ? model : (_a = this.currentPlugin) === null || _a === void 0 ? void 0 : _a.model,
            obj: area === "property-grid" && model ? model.obj : undefined
        });
        if (reason === "designer") {
            this.onDesignerSurveyCreated.fire(this, { survey: survey });
        }
        if (reason === "test" || reason === "theme") {
            this.onPreviewSurveyCreated.fire(this, { survey: survey });
        }
        survey.onPopupVisibleChanged.add(function (_, options) {
            if (!options.popup.getAreaCallback)
                options.popup.getAreaCallback = function () { return _this.rootElement; };
        });
        return survey;
    };
    SurveyCreatorModel.prototype.getSurveyInstanceCreatedArea = function (reason) {
        var hash = {};
        hash["designer"] = "designer-tab";
        hash["test"] = "preview-tab";
        hash["default-value"] = "default-value-popup-editor";
        hash["condition-builder"] = "logic-rule:condition-editor";
        hash["logic-item-editor"] = "logic-rule:action-editor";
        hash["logic-items"] = "logic-tab:condition-list";
        hash["theme"] = "theme-tab";
        hash["translation_settings"] = "translation-tab:language-list";
        hash["translation_strings"] = "translation-tab:table";
        hash["translation_strings_header"] = "translation-tab:table-header";
        hash["cells-editor"] = "matrix-cell-values-popup-editor";
        hash["fast-entry"] = "table-values-popup-editor";
        hash["modal-question-editor"] = "matrix-cell-question-popup-editor";
        var res = hash[reason];
        return !!res ? res : reason;
    };
    SurveyCreatorModel.prototype.createSurveyCore = function (json, reason) {
        if (json === void 0) { json = {}; }
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.SurveyModel(json);
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "state", {
        /**
         * Indicates the state of Survey Creator.
         *
         * Possible values:
         *
         * - `""` - Survey Creator doesn't have unsaved changes.
         * - `"modified"` - Survey Creator has unsaved changes.
         * - `"saving"` - Changes are being saved.
         * - `"saved"` - Changes are successfully saved.
         * @see onModified
         */
        get: function () {
            return !!this._stateValue ? this._stateValue : "";
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.setState = function (value) {
        this._stateValue = value;
        this.onStateChanged.fire(this, { val: value });
        if (!!value) {
            this.notify(this.getLocString("ed." + value));
            this._updateSaveActions();
        }
    };
    SurveyCreatorModel.prototype.setModified = function (options) {
        if (options === void 0) { options = null; }
        this.setState("modified");
        this.onModified.fire(this, options);
        this.isAutoSave && this.doAutoSave();
    };
    SurveyCreatorModel.prototype.notifySurveyPropertyChanged = function (options) {
        this.clearSurveyLogicForUpdate(options.target, options.name, options.newValue);
        this.updateSurveyLogicValues(options.target, options.name, options.oldValue);
        var plugin = this.currentPlugin;
        if (!!plugin && !!plugin.onDesignerSurveyPropertyChanged) {
            plugin.onDesignerSurveyPropertyChanged(options.target, options.name);
        }
        if (!this.onSurveyPropertyValueChanged.isEmpty) {
            options.propertyName = options.name;
            options.obj = options.target;
            options.value = options.newValue;
            this.onSurveyPropertyValueChanged.fire(this, options);
        }
        options.type = "PROPERTY_CHANGED";
        this.setModified(options);
    };
    SurveyCreatorModel.prototype.notifySurveyItemMoved = function (options) {
        options.type = "ELEMENT_REORDERED";
        this.setModified(options);
    };
    SurveyCreatorModel.prototype.notifySurveyItemConverted = function (newElement, oldElement) {
        var options = { oldValue: oldElement, newValue: newElement };
        options.type = "QUESTION_CONVERTED";
        options.className = newElement.getType();
        this.setModified(options);
    };
    /**
     * Displays a toast notification with a specified message.
     *
     * If you want to implement custom toast notification from scratch, handle the [`onNotify`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#onNotify) event.
     * @param message A message to display.
     * @param type A notification type: `"info"` (default) or `"error"`.
     */
    SurveyCreatorModel.prototype.notify = function (message, type) {
        if (type === void 0) { type = "info"; }
        if (this.onNotify.isEmpty) {
            this.notifier.notify(message, type);
            // alert(message);
        }
        else {
            this.onNotify.fire(this, { message: message, type: type });
        }
    };
    SurveyCreatorModel.prototype.convertQuestion = function (obj, className, defaultJSON) {
        if (defaultJSON === void 0) { defaultJSON = null; }
        var objJSON = _questionconverter__WEBPACK_IMPORTED_MODULE_5__.QuestionConverter.getObjJSON(obj, this.getDefaultElementJSON(obj.getType()));
        var options = {
            sourceQuestion: obj,
            targetType: className,
            json: objJSON
        };
        this.onQuestionConverting.fire(this, options);
        var newQuestion = _questionconverter__WEBPACK_IMPORTED_MODULE_5__.QuestionConverter.convertObject(obj, className, options.json, this.getDefaultElementJSON(className), defaultJSON);
        return newQuestion;
    };
    SurveyCreatorModel.prototype.getDefaultElementJSON = function (elType) {
        var _a;
        if (!this.toolbox)
            return null;
        var json = (_a = this.toolbox.getItemByName(elType)) === null || _a === void 0 ? void 0 : _a.json;
        return !!json ? survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.createCopy(json) : null;
    };
    SurveyCreatorModel.prototype.singlePageJSON = function (json) {
        if (this.pageEditMode === "single") {
            var pages = json.pages;
            if (Array.isArray(pages) && pages.length > 0) {
                if (pages[0].elements !== undefined) {
                    json.elements = pages[0].elements;
                }
                delete json.pages;
            }
        }
        return json;
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "JSON", {
        /**
         * A survey JSON schema.
         *
         * This property allows you to get or set the JSON schema of a survey being configured. Alternatively, you can use the [`text`](#text) property.
         */
        get: function () {
            var json = this.survey.toJSON();
            return this.singlePageJSON(json);
        },
        set: function (val) {
            if (this.viewType == "editor") {
                this.setTextValue(JSON.stringify(val));
            }
            else {
                this.initSurveyWithJSON(val, true);
            }
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.loadSurvey = function (surveyId) {
        var _this = this;
        new survey_core__WEBPACK_IMPORTED_MODULE_1__.dxSurveyService().loadSurvey(surveyId, function (success, result, response) {
            if (success && result) {
                _this.JSON = result;
            }
        });
    };
    SurveyCreatorModel.prototype.doClickQuestionCore = function (element, modifiedType, index, panel) {
        if (modifiedType === void 0) { modifiedType = "ADDED_FROM_TOOLBOX"; }
        if (index === void 0) { index = -1; }
        if (panel === void 0) { panel = null; }
        if (this.survey.pageCount == 0) {
            this.addNewPageIntoSurvey();
        }
        var parent = this.currentPage;
        if (this.pageEditMode === "bypage") {
            var desigerTab = this.getPlugin("designer").model;
            var pagesController = desigerTab.pagesController;
            parent = pagesController.page2Display;
        }
        var selectedElement = this.getSelectedSurveyElement();
        if (selectedElement && selectedElement.parent && selectedElement["page"] == parent &&
            (selectedElement !== panel)) {
            if (!panel) {
                while (!!selectedElement.parent && selectedElement.parent.isPanel) {
                    if (!!selectedElement.parentQuestion) {
                        selectedElement = selectedElement.parentQuestion;
                    }
                    else {
                        selectedElement = selectedElement.parent;
                    }
                }
            }
            parent = selectedElement.parent;
            if (index < 0) {
                if (this.addNewQuestionLast && modifiedType === "ADDED_FROM_PAGEBUTTON") {
                    index = parent.elements.length;
                }
                else {
                    index = parent.elements.indexOf(selectedElement);
                    if (index > -1)
                        index++;
                }
            }
        }
        if (panel) {
            parent = panel;
        }
        this.addNewElementReason = modifiedType;
        var currentRow = this.findRowByElement(selectedElement, parent);
        element.setVisibleIndex(-1);
        if (currentRow && this.isRowMultiline(currentRow)) {
            this.addElemenMultiline(parent, element, index, currentRow);
        }
        else {
            parent.addElement(element, index);
        }
        this.addNewElementReason = "";
        this.setModified({ type: modifiedType, question: element });
    };
    SurveyCreatorModel.prototype.isRowMultiline = function (row) {
        return row.elements.length > 1;
    };
    SurveyCreatorModel.prototype.findRowByElement = function (element, parent) {
        if (!element)
            return null;
        if (element.isPage)
            return element.rows[element.rows.length - 1];
        return parent.rows.find(function (row) { return row.elements.indexOf(element) !== -1; });
    };
    SurveyCreatorModel.prototype.addElemenMultiline = function (parent, element, index, currentRow) {
        var elsCount = currentRow.elements.length;
        var prevElement = currentRow.elements[elsCount - 1];
        prevElement.startWithNewLine = true;
        parent.addElement(element, index);
        prevElement.startWithNewLine = false;
    };
    SurveyCreatorModel.prototype.setNewNames = function (element) {
        this.newQuestions = [];
        this.newPanels = [];
        this.newQuestionChangedNames = {};
        this.setNewNamesCore(element);
        this.updateNewElementExpressions(element);
    };
    SurveyCreatorModel.prototype.updateNewElementExpressions = function (element) {
        var survey = this.createSurvey({}, "updateNewElementExpressions", undefined, function (survey) {
            survey.setDesignMode(true);
            if (element.isPage) {
                survey.addPage(element);
            }
            else {
                survey.addNewPage("p1");
                survey.pages[0].addElement(element);
            }
        });
        var logic = new _components_tabs_logic__WEBPACK_IMPORTED_MODULE_14__.SurveyLogic(survey);
        for (var key in this.newQuestionChangedNames) {
            logic.renameQuestion(key, this.newQuestionChangedNames[key]);
        }
    };
    SurveyCreatorModel.prototype.getAllQuestions = function (includeNewItems) {
        if (includeNewItems === void 0) { includeNewItems = true; }
        return this.getAllElements(false, includeNewItems);
    };
    SurveyCreatorModel.prototype.getAllPanels = function (includeNewItems) {
        if (includeNewItems === void 0) { includeNewItems = true; }
        return this.getAllElements(true, includeNewItems);
    };
    SurveyCreatorModel.prototype.getAllElements = function (isPanel, includeNewItems) {
        var result = _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getAllElements(this.survey, isPanel);
        if (includeNewItems) {
            _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.addElements(this.newPanels, isPanel, result);
            _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.addElements(this.newQuestions, isPanel, result);
        }
        return result;
    };
    SurveyCreatorModel.prototype.getNewName = function (type, isPanel) {
        if (type == "page")
            return _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getNewPageName(this.survey.pages);
        if (isPanel)
            return this.getNewPanelName();
        return this.getNewQuestionName();
    };
    SurveyCreatorModel.prototype.getNewQuestionName = function () {
        return _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getNewQuestionName(this.getAllQuestions());
    };
    SurveyCreatorModel.prototype.getNewPanelName = function () {
        return _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getNewPanelName(this.getAllPanels());
    };
    SurveyCreatorModel.prototype.setNewNamesCore = function (element) {
        var _this = this;
        var elType = element["getType"]();
        var newName = this.getNewName(elType, element.isPanel);
        if (newName != element.name) {
            this.newQuestionChangedNames[element.name] = newName;
            element.name = newName;
        }
        if (element.isPanel || element.isPage) {
            if (element.isPanel) {
                this.newPanels.push(element);
            }
            var panel = element;
            panel.elements.forEach(function (el) { return _this.setNewNamesCore(el); });
        }
        else {
            this.newQuestions.push(element);
            var els = Array.isArray(element["templateElements"]) ? element["templateElements"] :
                (Array.isArray(element["detailElements"]) ? element["detailElements"] : undefined);
            if (els) {
                els.forEach(function (el) { return _this.setNewNamesCore(el); });
            }
        }
    };
    SurveyCreatorModel.prototype.createNewElement = function (json) {
        var newElement = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass(json["type"]);
        new survey_core__WEBPACK_IMPORTED_MODULE_1__.JsonObject().toObject(json, newElement);
        var needNewName = true;
        if (!!json.name) {
            if (newElement.isPage) {
                needNewName = !!this.survey.getPageByName(newElement.name);
            }
            else {
                if (newElement.isPanel) {
                    needNewName = !!this.survey.getPanelByName(newElement.name);
                }
                else {
                    needNewName = !!this.survey.getQuestionByName(newElement.name);
                }
            }
        }
        if (needNewName) {
            this.setNewNames(newElement);
        }
        return newElement;
    };
    SurveyCreatorModel.prototype.copyElement = function (element) {
        var json = new survey_core__WEBPACK_IMPORTED_MODULE_1__.JsonObject().toJsonObject(element);
        json.type = element.getType();
        return this.createNewElement(json);
    };
    /**
     * Creates a copy of a specified question, inserts the copy next to this question, and (optionally) selects it on the design surface.
     * @param question A question to copy.
     * @param selectCopy *(Optional)* Pass `true` if you want to select the copy on the design surface. Default value: `false`.
     * @returns The instance of a new question.
     */
    SurveyCreatorModel.prototype.fastCopyQuestion = function (question, selectCopy) {
        var newElement = this.copyElement(question);
        var index = !!question["parent"]
            ? question["parent"].elements.indexOf(question) + 1
            : -1;
        if (index > -1) {
            var elements = question.parent.elements;
            if (index < elements.length && elements[index].startWithNewLine === false) {
                newElement.startWithNewLine = false;
            }
        }
        this.doClickQuestionCore(newElement, "ELEMENT_COPIED", index, question["parent"]);
        if (selectCopy) {
            this.selectElement(newElement);
        }
        return newElement;
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "selectedElement", {
        /**
         * Gets or sets the focused survey element: a question, panel, page, or the survey itself.
         * @see onSelectedElementChanging
         * @see onSelectedElementChanged
         */
        get: function () {
            return this.selectedElementValue;
        },
        set: function (val) {
            this.selectElement(val);
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Refreshes the Designer tab.
     *
     * `refreshDesigner()` is useful if the Designer tab UI depends on an external variable. Call this method each time this variable changes to update the UI.
     */
    SurveyCreatorModel.prototype.refreshDesigner = function () {
        if (this.activeTab !== "designer")
            return;
        this.changeText(this.text);
    };
    SurveyCreatorModel.prototype.deleteCurrentObject = function () {
        this.deleteCurrentElement();
    };
    SurveyCreatorModel.prototype.deleteCurrentElement = function () {
        this.deleteObject(this.selectedElement);
    };
    /**
     * Deletes a survey element: a question, panel, or page.
     *
     * If you want to delete the focused element, pass the [`selectedElement`](#selectedElement) property value to this method.
     * @param element A survey element to delete.
     * @see onElementDeleting
     */
    SurveyCreatorModel.prototype.deleteElement = function (element) {
        this.deleteObject(element);
    };
    /**
     * Creates a copy of a specified page and inserts the copy next to this page.
     * @param page A [page](https://surveyjs.io/form-library/documentation/api-reference/page-model) to copy.
     * @returns The [instance of a new page](https://surveyjs.io/form-library/documentation/api-reference/page-model).
     * @see onPageAdding
     * @see onPageAdded
     */
    SurveyCreatorModel.prototype.copyPage = function (page) {
        var _this = this;
        this.isCopyingPage = true;
        var newPage = this.copyElement(page);
        var index = this.survey.pages.indexOf(page);
        if (index > -1) {
            this.survey.pages.splice(index + 1, 0, newPage);
        }
        else {
            this.survey.pages.push(newPage);
        }
        this.isCopyingPage = false;
        newPage.questions.forEach(function (q) {
            _this.addNewElementReason = "ELEMENT_COPIED";
            _this.doOnQuestionAdded(q, q.parent);
        });
        var panels = newPage.getPanels();
        if (Array.isArray(panels))
            panels.forEach(function (p) { return _this.doOnPanelAdded(p, p.parent); });
        this.addNewElementReason = "";
        return newPage;
    };
    SurveyCreatorModel.prototype.deleteObjectCore = function (obj) {
        if (obj.isPage) {
            var newPage = this.getNextPage(obj);
            this.survey.removePage(obj);
            this.selectElement(!!newPage ? newPage : this.survey);
        }
        else {
            if (this.survey.pageCount === 1) {
                var page = this.survey.pages[0];
                if (page.elements.length === 1 && obj === page.elements[0] && !_survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.isPagePropertiesAreModified(page)) {
                    this.deleteObjectCore(page);
                    return;
                }
            }
            this.deletePanelOrQuestion(obj);
        }
        this.setModified({
            type: "OBJECT_DELETED",
            target: obj
        });
        this.updateConditionsOnRemove(obj);
    };
    SurveyCreatorModel.prototype.getNextPage = function (page) {
        var index = this.survey.pages.indexOf(page);
        if (index < 0 || this.survey.pages.length == 1)
            return null;
        if (index == this.survey.pages.length - 1)
            index--;
        else
            index++;
        if (index < 0 || index > this.survey.pages.length - 1)
            return null;
        return this.survey.pages[index];
    };
    SurveyCreatorModel.prototype.deleteObject = function (obj) {
        if (!this.checkOnElementDeleting(obj))
            return;
        this.deleteObjectCore(obj);
    };
    SurveyCreatorModel.prototype.updateConditionsOnRemove = function (obj) {
        if (!_creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.updateExpressionsOnDeleting.question)
            return;
        var objType = _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getObjectType(obj);
        var questions;
        if (objType == _survey_helper__WEBPACK_IMPORTED_MODULE_9__.ObjType.Question) {
            questions = [obj];
        }
        else {
            var questions = obj.questions;
        }
        if (!questions)
            return;
        var logic = new _components_tabs_logic__WEBPACK_IMPORTED_MODULE_14__.SurveyLogic(this.survey, this);
        for (var i = 0; i < questions.length; i++) {
            logic.removeQuestion(questions[i].getValueName());
        }
    };
    SurveyCreatorModel.prototype.checkOnElementDeleting = function (obj) {
        var options = {
            element: obj,
            elementType: _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getObjectType(obj),
            allowing: true
        };
        this.onElementDeleting.fire(this, options);
        return options.allowing;
    };
    SurveyCreatorModel.prototype.isElementSelected = function (element) {
        if (!element || element.isDisposed)
            return false;
        return element.getPropertyValue("isSelectedInDesigner");
    };
    SurveyCreatorModel.prototype.selectElement = function (element, propertyName, focus, startEdit) {
        if (focus === void 0) { focus = true; }
        if (startEdit === void 0) { startEdit = false; }
        if (!!element && (element.isDisposed || !element.getSurvey() || ((element.isQuestion || element.isPanel) && !element.parent)))
            return;
        var oldValue = this.selectedElement;
        if (oldValue !== element) {
            this.selectedElementValue = this.onSelectingElement(element);
            if (oldValue !== this.selectedElementValue) {
                if (!!oldValue && !oldValue.isDisposed) {
                    oldValue.setPropertyValue("isSelectedInDesigner", false);
                }
                if (!!this.selectedElementValue) {
                    this.selectedElementValue.setPropertyValue("isSelectedInDesigner", true);
                }
            }
        }
        if (oldValue !== element || !!propertyName) {
            this.selectionChanged(this.selectedElement, propertyName, !!focus);
        }
        var selEl = this.getSelectedSurveyElement();
        if (oldValue !== element && !!document && !!selEl) {
            this.focusElement(element, focus, selEl, propertyName, startEdit);
        }
    };
    SurveyCreatorModel.prototype.focusElement = function (element, focus, selEl, propertyName, startEdit) {
        var _this = this;
        if (selEl === void 0) { selEl = null; }
        if (propertyName === void 0) { propertyName = null; }
        if (startEdit === void 0) { startEdit = null; }
        if (!selEl)
            selEl = this.getSelectedSurveyElement();
        if (!selEl)
            return;
        clearInterval(this.currentFocusInterval);
        clearTimeout(this.currentFocusTimeout);
        this.currentFocusTimeout = setTimeout(function () {
            _this.currentFocusInterval = setInterval(function () {
                var _a, _b;
                var el = document.getElementById(selEl.id);
                if (!!selEl && (focus || startEdit && (!selEl.hasTitle || selEl.isPanel))) {
                    if (!el || _this.rootElement.getAnimations({ subtree: true }).filter((function (animation) { return animation.effect.getComputedTiming().activeDuration !== Infinity && (animation.pending || animation.playState !== "finished"); }))[0])
                        return;
                    clearInterval(_this.currentFocusInterval);
                    if (!!el) {
                        var isNeedScroll = _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.isNeedScrollIntoView((_a = el.parentElement) !== null && _a !== void 0 ? _a : el, true);
                        if (!!isNeedScroll) {
                            var elementPage = _this.getPageByElement(selEl);
                            var scrollIntoViewOptions_1 = { block: "start", behavior: _this.animationEnabled ? "smooth" : undefined };
                            if (!!elementPage) {
                                _this.survey.scrollElementToTop(selEl, undefined, elementPage, selEl.id, true, scrollIntoViewOptions_1, _this.rootElement);
                            }
                            else {
                                _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.scrollIntoViewIfNeeded((_b = el.parentElement) !== null && _b !== void 0 ? _b : el, function () { return scrollIntoViewOptions_1; }, true);
                            }
                        }
                        if (!propertyName && el.parentElement) {
                            var elToFocus = (typeof (focus) === "string") ? el.parentElement.querySelector(focus) : el.parentElement;
                            elToFocus && elToFocus.focus({ preventScroll: true });
                        }
                    }
                }
                else {
                    clearInterval(_this.currentFocusInterval);
                }
                if (startEdit && !!element) {
                    _components_string_editor__WEBPACK_IMPORTED_MODULE_22__.StringEditorConnector.get(element.locTitle).activateEditor();
                }
            }, 1);
        }, 100);
    };
    SurveyCreatorModel.prototype.getSelectedSurveyElement = function () {
        var sel = this.selectedElement;
        if (!sel || sel.getType() == "survey")
            return null;
        return sel.isInteractiveDesignElement && sel.id ? sel : null;
    };
    SurveyCreatorModel.prototype.onSelectingElement = function (val) {
        var options = { newSelectedElement: val };
        this.onSelectedElementChanging.fire(this, options);
        return options.newSelectedElement;
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "designerPropertyGrid", {
        //#region Obsolete designerPropertyGrid
        get: function () {
            var propertyGridTab = this.sidebar.getPageById("propertyGrid");
            if (!propertyGridTab)
                return null;
            return propertyGridTab.componentData ? propertyGridTab.componentData.propertyGridModel : null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyCreatorModel.prototype, "propertyGrid", {
        get: function () {
            return this.designerPropertyGrid.survey;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Collapses a specified category in Property Grid.
     * @param name A [category name](https://surveyjs.io/form-library/documentation/customize-question-types/add-custom-properties-to-a-form#category).
     * @see expandPropertyGridCategory
     */
    SurveyCreatorModel.prototype.collapsePropertyGridCategory = function (name) {
        if (!!this.designerPropertyGrid) {
            this.designerPropertyGrid.collapseCategory(name);
        }
    };
    /**
     * Expands a specified category in Property Grid.
     * @param name A [category name](https://surveyjs.io/form-library/documentation/customize-question-types/add-custom-properties-to-a-form#category).
     * @see collapsePropertyGridCategory
     */
    SurveyCreatorModel.prototype.expandPropertyGridCategory = function (name) {
        if (!!this.designerPropertyGrid) {
            this.designerPropertyGrid.expandCategory(name);
        }
    };
    /**
     * Collapses all categories in Property Grid.
     * @see expandAllPropertyGridCategories
     */
    SurveyCreatorModel.prototype.collapseAllPropertyGridCategories = function () {
        if (!!this.designerPropertyGrid) {
            this.designerPropertyGrid.collapseAllCategories();
        }
    };
    /**
     * Expands all categories in Property Grid.
     * @see collapseAllPropertyGridCategories
     */
    SurveyCreatorModel.prototype.expandAllPropertyGridCategories = function () {
        if (!!this.designerPropertyGrid) {
            this.designerPropertyGrid.expandAllCategories();
        }
    };
    SurveyCreatorModel.prototype.collapseAllPropertyTabs = function () {
        this.collapseAllPropertyGridCategories();
    };
    SurveyCreatorModel.prototype.expandAllPropertyTabs = function () {
        this.expandAllPropertyGridCategories();
    };
    SurveyCreatorModel.prototype.expandPropertyTab = function (name) {
        this.expandPropertyGridCategory(name);
    };
    SurveyCreatorModel.prototype.collapsePropertyTab = function (name) {
        this.collapsePropertyGridCategory(name);
    };
    //#endregion Obsolete designerPropertyGrid
    /**
     * Validates the property values of the [focused element](#selectedElement).
     * @returns `true` if all property values of the focused element are valid or if no element is focused, `false` otherwise.
     * @see onSelectedElementChanging
     * @see onSelectedElementChanged
     */
    SurveyCreatorModel.prototype.validateSelectedElement = function () {
        var isValid = true;
        if (!this.selectedElement)
            return isValid;
        if (!!this.designerPropertyGrid) {
            isValid = this.designerPropertyGrid.validate();
        }
        /*
        var options = { errors: [] };
        this.onValidateSelectedElement.fire(this, options);
        return isValid && options.errors.length == 0;
        */
        return isValid;
    };
    /**
     * Deletes all custom translation strings for a specified locale from Survey Creator and from the generated survey JSON schema.
     * @param locale A locale code (for example, "en").
     * @see locale
     */
    SurveyCreatorModel.prototype.deleteLocaleStrings = function (locale) {
        var translation = new _src_components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__.Translation(this.survey);
        translation.deleteLocaleStrings(locale);
    };
    SurveyCreatorModel.prototype.getPropertyGridDefinition = function () {
        return this.propertyGridDefinition;
    };
    SurveyCreatorModel.prototype.setPropertyGridDefinition = function (val) {
        this.propertyGridDefinition = val;
        if (this.designerPropertyGrid) {
            this.designerPropertyGrid.setPropertyGridDefinition(val);
        }
    };
    SurveyCreatorModel.prototype.expandCategoryIfNeeded = function () {
        if (!this.survey.isEmpty) {
            this.designerPropertyGrid.expandCategoryIfNeeded();
        }
    };
    SurveyCreatorModel.prototype.selectionChanged = function (element, propertyName, focus) {
        var _this = this;
        if (focus === void 0) { focus = true; }
        this.survey.currentPage = this.getCurrentPageByElement(element);
        this.selectionHistoryController.onObjSelected(element);
        if (this.designerPropertyGrid) {
            this.designerPropertyGrid.obj = element;
            if (!propertyName) {
                propertyName = this.designerPropertyGrid.currentlySelectedProperty;
            }
            if (!!propertyName) {
                this.sidebar.executeOnExpand(function () {
                    _this.designerPropertyGrid.selectProperty(propertyName, focus || !_this.selectFromStringEditor);
                });
            }
            this.expandCategoryIfNeeded();
            this.selectFromStringEditor = false;
        }
        var options = { newSelectedElement: element };
        this.onSelectedElementChanged.fire(this, options);
    };
    SurveyCreatorModel.prototype.getCurrentPageByElement = function (element) {
        if (!element)
            return undefined;
        if (element["isPage"])
            return element;
        if (!!element["page"])
            return element["page"];
        if (!!element["parentQuestion"])
            return this.getCurrentPageByElement(element["parentQuestion"]);
        return undefined;
    };
    SurveyCreatorModel.prototype.clickToolboxItem = function (newElement, panel, modifiedType) {
        if (panel === void 0) { panel = null; }
        if (modifiedType === void 0) { modifiedType = "ADDED_FROM_TOOLBOX"; }
        if (!this.readOnly) {
            if (newElement["getType"] === undefined) {
                newElement = this.createNewElement(newElement);
            }
            this.survey.lazyRendering = false;
            this.doClickQuestionCore(newElement, modifiedType, -1, panel);
            this.selectElement(newElement, null, !this.toolbox.searchManager.filterString, this.startEditTitleOnQuestionAdded);
        }
    };
    SurveyCreatorModel.prototype.getJSONForNewElement = function (json) {
        var newElement = this.createNewElement(json);
        json = newElement.toJSON();
        json["type"] = newElement.getType();
        return json;
    };
    /**
     * Opens a dialog window for users to select files.
     * @param input A [file input HTML element](https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement).
     * @param callback A callback function that you can use to process selected files. Accepts an array of JavaScript <a href="https://developer.mozilla.org/en-US/docs/Web/API/File" target="_blank">File</a> objects.
     * @see onOpenFileChooser
     * @see onUploadFile
     */
    SurveyCreatorModel.prototype.chooseFiles = function (input, callback, context) {
        if (this.onOpenFileChooser.isEmpty) {
            (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.chooseFiles)(input, callback);
        }
        else {
            this.onOpenFileChooser.fire(this, {
                input: input,
                element: context && context.element || this.survey,
                elementType: context && context.elementType,
                item: context && context.item,
                propertyName: context && context.propertyName,
                callback: callback,
                context: context
            });
        }
    };
    /**
     * Uploads files to a server.
     * @param files An array of JavaScript <a href="https://developer.mozilla.org/en-US/docs/Web/API/File" target="_blank">File</a> objects that represent files to upload.
     * @param question A [question instance](https://surveyjs.io/form-library/documentation/api-reference/question) for which files are uploaded.
     * @param callback A callback function that indicates the upload status&mdash;"success" or "error"&mdash;as the first argument. If a file is uploaded successfully, the second argument contains the file's URL.
     * @see onUploadFile
     */
    SurveyCreatorModel.prototype.uploadFiles = function (files, question, callback, context) {
        if (this.onUploadFile.isEmpty) {
            var fileReader_1 = new FileReader();
            fileReader_1.onload = function (e) {
                callback("success", fileReader_1.result);
            };
            fileReader_1.readAsDataURL(files[0]);
        }
        else {
            this.onUploadFile.fire(this, {
                question: question,
                files: files || [],
                callback: callback,
                element: context && context.element || this.survey,
                elementType: context && context.elementType,
                propertyName: context && context.propertyName,
                context: context
            });
        }
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "rootElement", {
        get: function () {
            return this._rootElementValue;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.setRootElement = function (element) {
        this._rootElementValue = element;
        this.initKeyboardShortcuts(element);
        this.initResponsivityManager(element);
    };
    SurveyCreatorModel.prototype.unsubscribeRootElement = function () {
        this.removeKeyboardShortcuts(this._rootElementValue);
        this.resetResponsivityManager();
    };
    SurveyCreatorModel.prototype.initKeyboardShortcuts = function (rootNode) {
        if (!!rootNode) {
            rootNode.addEventListener("keydown", this.onKeyDownHandler);
        }
    };
    SurveyCreatorModel.prototype.removeKeyboardShortcuts = function (rootNode) {
        if (!!rootNode) {
            rootNode.removeEventListener("keydown", this.onKeyDownHandler);
        }
    };
    SurveyCreatorModel.prototype.findSuitableShortcuts = function (event) {
        var _this = this;
        var shortcuts = [];
        var availableShortcuts = Object.keys(this.shortcuts || {})
            .map(function (key) { return _this.shortcuts[key]; })
            .filter(function (shortcut) { return !shortcut.affectedTab || shortcut.affectedTab === _this.activeTab; });
        availableShortcuts.forEach(function (shortcut) {
            var hotKey = event.metaKey ? shortcut.macOsHotkey : shortcut.hotKey;
            if (!hotKey)
                return;
            if (!!hotKey.ctrlKey !== !!event.ctrlKey)
                return;
            if (!!hotKey.shiftKey !== !!event.shiftKey)
                return;
            if (hotKey.keyCode !== event.keyCode)
                return;
            shortcuts.push(shortcut);
        });
        return shortcuts;
    };
    SurveyCreatorModel.prototype.registerShortcut = function (name, shortcut) {
        this.shortcuts[name] = shortcut;
    };
    SurveyCreatorModel.prototype.unRegisterShortcut = function (name) {
        delete this.shortcuts[name];
    };
    SurveyCreatorModel.prototype.deletePanelOrQuestion = function (obj) {
        var _this = this;
        var changeSelection = obj === this.selectedElement;
        var parent = obj["parent"];
        var elements = parent.elements;
        var objIndex = elements.indexOf(obj);
        if (objIndex == elements.length - 1) {
            objIndex--;
        }
        if (obj["questions"]) {
            obj["questions"].forEach(function (q) { return _this.updateConditionsOnRemove(q); });
        }
        obj["delete"](false);
        if (parent.isPage && (this.pageEditMode === "single" || elements.length === 0)) {
            parent = this.survey;
        }
        if (changeSelection) {
            this.selectElement(objIndex > -1 ? elements[objIndex] : parent);
        }
    };
    SurveyCreatorModel.prototype.onCanShowObjectProperty = function (object, property, showMode, parentObj, parentProperty) {
        if (this.hiddenProperties[property.id])
            return false;
        var options = {
            obj: object,
            property: property,
            canShow: true,
            showMode: showMode,
            parentObj: parentObj,
            parentProperty: parentProperty
        };
        this.onCanShowProperty.fire(this, options);
        return options.canShow;
    };
    SurveyCreatorModel.prototype.canDeleteItem = function (object, item, allowDelete) {
        var options = { obj: object, item: item, canDelete: allowDelete };
        this.onCanDeleteItem.fire(this, options);
        return options.canDelete;
    };
    SurveyCreatorModel.prototype.getErrorOnPropertyChanging = function (obj, propertyName, value) {
        if (propertyName !== "name")
            return null;
        if (_survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getObjectType(obj) === _survey_helper__WEBPACK_IMPORTED_MODULE_9__.ObjType.Unknown)
            return null;
        var hasError = false;
        if (_survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getObjectType(obj) === _survey_helper__WEBPACK_IMPORTED_MODULE_9__.ObjType.Column) {
            hasError = !!obj.colOwner
                ? !this.isNameUniqueInArray(obj.colOwner.columns, obj, value)
                : false;
        }
        else {
            hasError = this.generateUniqueName(obj, value) !== value;
        }
        return hasError ? this.getLocString("pe.propertyNameIsNotUnique") : null;
    };
    SurveyCreatorModel.prototype.generateUniqueName = function (el, newName) {
        var options = { element: el, name: newName, isDone: true };
        var list = [];
        do {
            this.generateUniqueNameCore(options);
            if (!options.isDone && list.indexOf(options.name) > -1) {
                options.name = this.checkForUniqueName(el, options.name);
                break;
            }
            list.push(options.name);
        } while (!options.isDone);
        return options.name;
    };
    SurveyCreatorModel.prototype.generateUniqueNameCore = function (options) {
        options.name = this.checkForUniqueName(options.element, options.name);
        var evnOptions = { element: options.element, name: options.name };
        this.onGenerateNewName.fire(this, evnOptions);
        if (options.name !== evnOptions.name) {
            options.name = evnOptions.name;
            options.name = this.checkForUniqueName(options.element, options.name);
            options.isDone = options.name === evnOptions.name;
        }
    };
    SurveyCreatorModel.prototype.checkForUniqueName = function (el, newName) {
        while (!this.isNameUnique(el, newName, false)) {
            newName = _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.generateNewName(newName);
        }
        return newName;
    };
    SurveyCreatorModel.prototype.isNameUnique = function (el, newName, includeNewItems) {
        if (includeNewItems === void 0) { includeNewItems = true; }
        if (!this.isNameUniqueInArray(this.survey.pages, el, newName))
            return false;
        if (!this.isNameUniqueInArray(this.getAllPanels(includeNewItems), el, newName))
            return false;
        return this.isNameUniqueInArray(this.getAllQuestions(includeNewItems), el, newName);
    };
    SurveyCreatorModel.prototype.isNameUniqueInArray = function (elements, el, newName) {
        if (!Array.isArray(elements))
            return true;
        newName = newName.toLowerCase();
        for (var i = 0; i < elements.length; i++) {
            if (elements[i] != el && elements[i].name.toLowerCase() == newName)
                return false;
        }
        return true;
    };
    SurveyCreatorModel.prototype.doPropertyGridChanged = function () { };
    Object.defineProperty(SurveyCreatorModel.prototype, "alwaySaveTextInPropertyEditors", {
        //implements ISurveyCreatorOptions
        get: function () {
            return this.alwaySaveTextInPropertyEditorsValue;
        },
        set: function (value) {
            this.alwaySaveTextInPropertyEditorsValue = value;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.getElementAddornerCssCallback = function (obj, className) { return className; };
    SurveyCreatorModel.prototype.onCanShowPropertyCallback = function (object, property, showMode, parentObj, parentProperty) {
        if (showMode === void 0) { showMode = null; }
        return this.onCanShowObjectProperty(object, property, showMode, parentObj, parentProperty);
    };
    SurveyCreatorModel.prototype.onPropertyGridSurveyCreatedCallback = function (object, survey) {
        var options = { obj: object, survey: survey };
        this.onPropertyGridSurveyCreated.fire(this, options);
    };
    SurveyCreatorModel.prototype.onPropertyEditorCreatedCallback = function (object, property, editor) {
        var options = { obj: object, property: property, editor: editor };
        this.onPropertyEditorCreated.fire(this, options);
    };
    SurveyCreatorModel.prototype.onPropertyEditorUpdateTitleActionsCallback = function (object, property, editor, titleActions) {
        var options = { obj: object, property: property, editor: editor, titleActions: titleActions };
        this.onPropertyEditorUpdateTitleActions.fire(this, options);
    };
    SurveyCreatorModel.prototype.onPropertyGridShowModalCallback = function (object, property, editor, popupEditor, popupModel) {
        var options = { obj: object, property: property, editor: editor, popupEditor: popupEditor, popupModel: popupModel };
        this.onPropertyGridShowModal.fire(this, options);
    };
    SurveyCreatorModel.prototype.onCanDeleteItemCallback = function (object, item, allowDelete) {
        if (!!item && item["isPage"]) {
            if (this.pageEditMode === "bypage")
                return item !== this.survey.currentPage;
            if (this.pageEditMode === "single")
                return false;
        }
        return this.canDeleteItem(object, item, allowDelete);
    };
    SurveyCreatorModel.prototype.onCollectionItemDeletingCallback = function (obj, property, collection, item) {
        if ((item === null || item === void 0 ? void 0 : item.isPage) && !this.checkOnElementDeleting(item))
            return false;
        if (this.onCollectionItemDeleting.isEmpty)
            return true;
        var options = {
            obj: obj,
            property: property,
            propertyName: property.name,
            collection: collection,
            item: item,
            allowDelete: true
        };
        this.onCollectionItemDeleting.fire(this, options);
        return options.allowDelete;
    };
    SurveyCreatorModel.prototype.onCollectionItemAllowingCallback = function (obj, property, collection, item, itemOptions) {
        if (this.onCollectionItemAllowOperations.isEmpty)
            return;
        var options = {
            obj: obj,
            property: property,
            propertyName: property && property.name,
            collection: collection,
            item: item,
            allowEdit: itemOptions.allowEdit,
            allowDelete: itemOptions.allowDelete,
            allowAdd: itemOptions.allowAdd
        };
        this.onCollectionItemAllowOperations.fire(this, options);
        itemOptions.allowEdit = options.allowEdit;
        itemOptions.allowDelete = options.allowDelete;
        itemOptions.allowAdd = options.allowAdd;
    };
    SurveyCreatorModel.prototype.onItemValueAddedCallback = function (obj, propertyName, itemValue, itemValues) {
        var options = {
            obj: obj,
            propertyName: propertyName,
            newItem: itemValue,
            itemValues: itemValues
        };
        this.onItemValueAdded.fire(this, options);
    };
    SurveyCreatorModel.prototype.onFastEntryCallback = function (items, lines) {
        var options = {
            items: items,
            lines: lines
        };
        this.onFastEntryFinished.fire(this, options);
        return options.items;
    };
    SurveyCreatorModel.prototype.onMatrixDropdownColumnAddedCallback = function (matrix, column, columns) {
        var options = { newColumn: column, matrix: matrix, columns: columns };
        this.onMatrixColumnAdded.fire(this, options);
    };
    SurveyCreatorModel.prototype.onSetPropertyEditorOptionsCallback = function (propertyName, obj, editorOptions) {
        var options = {
            propertyName: propertyName,
            obj: obj,
            editorOptions: editorOptions,
            allowAddRemoveItems: editorOptions.allowAddRemoveItems,
            allowRemoveAllItems: editorOptions.allowRemoveAllItems,
            allowBatchEdit: editorOptions.allowBatchEdit
        };
        var keys = ["allowAddRemoveItems", "allowRemoveAllItems", "allowBatchEdit"];
        keys.forEach(function (key) { return options[key] = editorOptions[key]; });
        this.onSetPropertyEditorOptions.fire(this, options);
        this.onConfigureTablePropertyEditor.fire(this, options);
        keys.forEach(function (key) { return editorOptions[key] = editorOptions[key] && options[key]; });
    };
    SurveyCreatorModel.prototype.onGetErrorTextOnValidationCallback = function (propertyName, obj, value) {
        var error = this.getErrorOnPropertyChanging(obj, propertyName, value);
        if (!!error)
            return error;
        var options = {
            propertyName: propertyName,
            obj: obj,
            value: value,
            error: ""
        };
        this.onPropertyValidationCustomError.fire(this, options);
        return options.error;
    };
    SurveyCreatorModel.prototype.onValueChangingCallback = function (options) {
        this.onPropertyValueChanging.fire(this, options);
    };
    SurveyCreatorModel.prototype.onGetElementEditorTitleCallback = function (obj, title) {
        return title;
    };
    SurveyCreatorModel.prototype.onConditionQuestionsGetListCallback = function (propertyName, obj, editor, list, variables) {
        if (this.onConditionQuestionsGetList.isEmpty)
            return _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.questionSortOrder;
        var options = {
            propertyName: propertyName,
            obj: obj,
            editor: editor,
            sortOrder: "asc",
            list: list,
            variables: variables
        };
        this.onConditionQuestionsGetList.fire(this, options);
        if (options.list !== list) {
            list.splice(0, list.length);
            for (var i = 0; i < options.list.length; i++) {
                list.push(options.list[i]);
            }
        }
        return options.sortOrder;
    };
    SurveyCreatorModel.prototype.onConditionGetTitleCallback = function (expression, title) {
        var options = {
            expression: expression,
            title: title,
        };
        this.onConditionGetTitle.fire(this, options);
        return options.title;
    };
    SurveyCreatorModel.prototype.isConditionOperatorEnabled = function (questionName, question, operator, isEnabled) {
        if (this.onGetConditionOperator.isEmpty)
            return isEnabled;
        var options = {
            questionName: questionName,
            question: question,
            questionType: !!question ? question.getType() : "",
            operator: operator,
            show: isEnabled
        };
        this.onGetConditionOperator.fire(this, options);
        return options.show;
    };
    SurveyCreatorModel.prototype.onLogicGetTitleCallback = function (expression, expressionText, text, logicItem) {
        if (this.onLogicItemDisplayText.isEmpty)
            return text;
        var options = {
            expression: expression,
            expressionText: expressionText,
            text: text,
            logicItem: logicItem
        };
        this.onLogicItemDisplayText.fire(this, options);
        return options.text;
    };
    SurveyCreatorModel.prototype.getProcessedTranslationItemText = function (locale, locString, newText, obj) {
        if (this.onTranslationItemChanging.isEmpty)
            return newText;
        var options = {
            locale: locale,
            obj: obj,
            locString: locString,
            newText: newText
        };
        this.onTranslationItemChanging.fire(this, options);
        return options.newText;
    };
    SurveyCreatorModel.prototype.getTranslationExportedText = function (obj, name, locString, locale, text) {
        if (this.onTranslationExportItem.isEmpty)
            return text;
        var options = {
            obj: obj,
            name: name,
            locString: locString,
            locale: locale,
            text: text
        };
        this.onTranslationExportItem.fire(this, options);
        return options.text;
    };
    SurveyCreatorModel.prototype.getHasMachineTranslation = function () {
        return !this.onMachineTranslate.isEmpty;
    };
    SurveyCreatorModel.prototype.doMachineTranslation = function (fromLocale, toLocale, strings, callback) {
        if (!this.getHasMachineTranslation()) {
            callback(undefined);
        }
        else {
            this.onMachineTranslate.fire(this, { fromLocale: fromLocale, toLocale: toLocale, strings: strings, callback: callback });
        }
    };
    SurveyCreatorModel.prototype.doAutoSave = function () {
        var _this = this;
        var saveFunc = function () { return _this.doSave(); };
        if (this.autoSaveDelay <= 0) {
            saveFunc();
            return;
        }
        if (!!this.autoSaveTimerId) {
            clearTimeout(this.autoSaveTimerId);
        }
        var self = this;
        this.autoSaveTimerId = setTimeout(function () {
            clearTimeout(self.autoSaveTimerId);
            self.autoSaveTimerId = null;
            saveFunc();
        }, this.autoSaveDelay);
    };
    SurveyCreatorModel.prototype._doSaveCore = function (onSaveComplete) {
        var _this = this;
        this.setState("saving");
        if (this.saveSurveyFunc) {
            this.saveNo++;
            this.saveSurveyFunc(this.saveNo, function (no, isSuccess) {
                if (_this.saveNo !== no)
                    return;
                if (isSuccess) {
                    _this.setState("saved");
                }
                else {
                    _this.setState("modified");
                    if (_this.showErrorOnFailedSave) {
                        _this.notify(_this.getLocString("ed.saveError"), "error");
                    }
                }
                onSaveComplete && onSaveComplete();
            });
        }
    };
    /**
     * Calls the [`saveSurveyFunc`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#saveSurveyFunc) function to save the survey JSON schema.
     * @see saveTheme
     * @see save
     */
    SurveyCreatorModel.prototype.saveSurvey = function () {
        this._doSaveCore();
    };
    SurveyCreatorModel.prototype.doSave = function () {
        this._doSaveCore();
    };
    SurveyCreatorModel.prototype.saveSurveyActionHandler = function () {
        if (this.syncSaveButtons) {
            this.save();
        }
        else {
            this.saveSurvey();
        }
    };
    SurveyCreatorModel.prototype._updateSaveActions = function () {
        var action = this._findAction("svd-save");
        if (action) {
            action.enabled = this.state === "modified";
            action.active = this.state === "modified";
        }
        if (this.syncSaveButtons) {
            var action_1 = this._findAction("svd-save-theme");
            if (action_1) {
                action_1.enabled = this.hasPendingThemeChanges;
                action_1.active = this.hasPendingThemeChanges;
            }
        }
    };
    /**
     * Calls the [`saveSurveyFunc`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#saveSurveyFunc) and [`saveThemeFunc`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#saveThemeFunc) functions to save the survey and theme JSON schemas.
     * @see saveSurvey
     * @see saveTheme
     */
    SurveyCreatorModel.prototype.save = function () {
        var _this = this;
        var themeSaveHandler = function () {
            if (_this.hasPendingThemeChanges) {
                _this._doSaveThemeCore(function () {
                    _this._updateSaveActions();
                });
            }
        };
        if (this.state === "modified") {
            this._doSaveCore(function () {
                themeSaveHandler();
            });
        }
        else
            themeSaveHandler();
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "saveSurveyFunc", {
        /**
         * A function that is called each time users click the [Save button](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#showSaveButton) or [auto-save](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#isAutoSave) is triggered to save a survey JSON schema.
         *
         * For more information, refer to the Save and Load Survey Model Schemas help topic for your framework: [Angular](https://surveyjs.io/survey-creator/documentation/get-started-angular#save-and-load-survey-model-schemas) | [Vue](https://surveyjs.io/survey-creator/documentation/get-started-vue#save-and-load-survey-model-schemas) | [React](https://surveyjs.io/survey-creator/documentation/get-started-react#save-and-load-survey-model-schemas) | [HTML/CSS/JavaScript](https://surveyjs.io/survey-creator/documentation/get-started-html-css-javascript#save-and-load-survey-model-schemas).
         * @see saveThemeFunc
         */
        get: function () {
            return this.saveSurveyFuncValue;
        },
        set: function (value) {
            this.saveSurveyFuncValue = value;
            this.showSaveButton = value != null && !this.isAutoSave;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.convertCurrentQuestion = function (newType, defaultJSON) {
        if (defaultJSON === void 0) { defaultJSON = null; }
        var el = this.selectedElement;
        if (!el || el.getType() === newType && !defaultJSON)
            return;
        var objType = _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getObjectType(el);
        if (objType !== _survey_helper__WEBPACK_IMPORTED_MODULE_9__.ObjType.Question && objType !== _survey_helper__WEBPACK_IMPORTED_MODULE_9__.ObjType.Panel)
            return;
        this.addNewElementReason = "ELEMENT_CONVERTED";
        el = this.convertQuestion(el, newType, defaultJSON);
        this.selectElement(el, null, "#convertTo button");
    };
    SurveyCreatorModel.prototype.getAddNewQuestionText = function (currentAddQuestionType) {
        if (currentAddQuestionType === void 0) { currentAddQuestionType = null; }
        if (!currentAddQuestionType)
            currentAddQuestionType = this.currentAddQuestionType;
        if (!!currentAddQuestionType) {
            var str = this.getLocString("ed.addNewTypeQuestion");
            var items = this.toolbox.items.filter(function (item) { return item.name == currentAddQuestionType; });
            if (Array.isArray(items) && items.length > 0 && !!str && !!str["format"]) {
                return str["format"](items[0].title);
            }
        }
        return this.getLocString("ed.addNewQuestion");
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "addNewQuestionText", {
        get: function () {
            return this.getAddNewQuestionText();
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.getAvailableToolboxItems = function (element, isAddNew) {
        if (isAddNew === void 0) { isAddNew = true; }
        var res = [].concat(this.toolbox.items);
        if (!element || this.maxNestedPanels < 0)
            return res;
        if (!isAddNew && element.isPanel)
            return res;
        if (this.maxNestedPanels < _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.getElementDeepLength(element)) {
            for (var i = res.length - 1; i >= 0; i--) {
                if (res[i].isPanel) {
                    res.splice(i, 1);
                }
            }
        }
        return res;
    };
    SurveyCreatorModel.prototype.getQuestionTypeSelectorModel = function (beforeAdd, element) {
        var _this = this;
        var panel = !!element && element.isPanel ? element : null;
        var onSelectQuestionType = function (questionType, json) {
            _this.currentAddQuestionType = questionType;
            _this.addNewQuestionInPage(beforeAdd, panel, questionType, json);
            newAction.popupModel.hide();
        };
        var getActions = function () {
            var availableTypes = _this.getAvailableToolboxItems(element).map(function (item) {
                return _this.createIActionBarItemByClass(item, item.needSeparator, onSelectQuestionType);
            });
            return availableTypes;
        };
        var newAction = (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.createDropdownActionModel)({
            iconName: "icon-more",
            title: this.getLocString("ed.addNewQuestion"),
        }, {
            items: [],
            allowSelection: false,
            cssClass: "svc-creator-popup",
            verticalPosition: "bottom",
            horizontalPosition: "center",
            displayMode: this.isTouch ? "overlay" : "popup"
        });
        newAction.popupModel.getTargetCallback = undefined;
        newAction.popupModel.onVisibilityChanged.add(function (_, opt) {
            if (opt.isVisible) {
                var listModel = newAction.popupModel.contentComponentData.model;
                listModel.setItems(getActions());
            }
        });
        return newAction;
    };
    SurveyCreatorModel.prototype.getUpdatedPageAdornerFooterActions = function (pageAdorner, actions) {
        var options = {
            page: pageAdorner.page,
            addNewQuestion: function (type) { pageAdorner.addNewQuestion(pageAdorner, undefined, type); },
            actions: actions
        };
        this.onGetPageActions.fire(this, options);
        return options.actions;
    };
    SurveyCreatorModel.prototype.addNewQuestionInPage = function (beforeAdd, panel, type, initJson) {
        if (panel === void 0) { panel = null; }
        if (type === void 0) { type = null; }
        if (initJson === void 0) { initJson = null; }
        if (!type)
            type = this.currentAddQuestionType;
        if (!type)
            type = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.designer.defaultAddQuestionType;
        beforeAdd(type);
        var json = initJson;
        if (!json) {
            var toolboxItem = this.toolbox.getItemByName(type);
            if (!!toolboxItem && !!toolboxItem.json) {
                json = toolboxItem.json;
            }
            else {
                json = { type: type };
            }
        }
        var newElement = this.createNewElement(json);
        this.clickToolboxItem(newElement, panel, "ADDED_FROM_PAGEBUTTON");
    };
    SurveyCreatorModel.prototype.createIActionBarItemByClass = function (item, needSeparator, onSelectQuestionType) {
        var action = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            title: item.title,
            id: item.name,
            iconName: item.iconName,
            iconSize: "auto",
            visible: item.visible,
            enabled: item.enabled,
            needSeparator: needSeparator
        });
        action.action = function () {
            onSelectQuestionType(item.typeName, item.json);
        };
        if (!!item.items && item.items.length > 0 && this.toolbox.showSubitems) {
            var innerItems = item.items.map(function (i) { return new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
                id: i.id,
                title: i.title,
                action: function () {
                    action.hidePopup();
                    onSelectQuestionType(item.typeName, i.json);
                }
            }); });
            action.setSubItems({ items: innerItems });
        }
        return action;
    };
    SurveyCreatorModel.prototype.onElementMenuItemsChanged = function (element, items) {
        this.onDefineElementMenuItems.fire(this, {
            obj: element,
            items: items
        });
    };
    SurveyCreatorModel.prototype.getElementAllowOperations = function (element) {
        var options = {
            obj: element,
            element: element,
            allowDelete: true,
            allowCopy: true,
            allowDragging: true,
            allowChangeType: true,
            allowChangeInputType: true,
            allowChangeRequired: true,
            allowShowSettings: undefined,
            allowEdit: undefined,
            allowExpandCollapse: undefined
        };
        this.onElementAllowOperations.fire(this, options);
        return options;
    };
    SurveyCreatorModel.prototype.getChoicesItemBaseTitle = function () {
        return this.getLocString("ed.choices_Item") || survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.getString("choices_Item");
    };
    SurveyCreatorModel.prototype.getNextItemValue = function (question) {
        var itemText = this.getChoicesItemBaseTitle();
        return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_8__.getNextItemValue)(itemText, question.choices);
    };
    SurveyCreatorModel.prototype.createNewItemValue = function (question, callEvent, callback) {
        if (callEvent === void 0) { callEvent = true; }
        var nextValue = this.getNextItemValue(question);
        var res = question.createItemValue(nextValue);
        res.text = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_8__.getNextItemText)(question.choices);
        question.choices.push(res);
        if (callback) {
            callback(res);
        }
        if (callEvent) {
            var propName = !!res.ownerPropertyName ? res.ownerPropertyName : "choices";
            this.onItemValueAddedCallback(question, propName, res, question.choices);
        }
        return res;
    };
    SurveyCreatorModel.prototype.onPropertyValueChanged = function (name, oldValue, newValue) {
        var _this = this;
        _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
        if (name === "viewType") {
            this.tabs.forEach(function (tab) {
                var isActive = _this.viewType === tab.id;
                tab.active = isActive;
                tab.disableHide = isActive;
            });
        }
    };
    SurveyCreatorModel.prototype.initResponsivityManager = function (container) {
        this.responsivityManager = new _creator_responsivity_manager__WEBPACK_IMPORTED_MODULE_19__.CreatorResponsivityManager(container, this);
    };
    SurveyCreatorModel.prototype.resetResponsivityManager = function () {
        if (!!this.responsivityManager) {
            this.responsivityManager.dispose();
            this.responsivityManager = undefined;
        }
    };
    SurveyCreatorModel.prototype.setDesignerSurveyScale = function (scale) {
        var _a;
        if (scale <= 0)
            return;
        (_a = this.responsivityManager) === null || _a === void 0 ? void 0 : _a.updateSurveyActualWidth();
        this.survey.widthScale = scale;
    };
    Object.defineProperty(SurveyCreatorModel.prototype, "showPageNavigator", {
        get: function () {
            return this.showPageNavigatorValue && this.allowShowPageNavigator;
        },
        set: function (val) {
            this.showPageNavigatorValue = val;
        },
        enumerable: false,
        configurable: true
    });
    SurveyCreatorModel.prototype.dispose = function () {
        var _this = this;
        this.isCreatorDisposed = true;
        this.tabs = [];
        Object.keys(this.plugins).forEach(function (pluginName) {
            var plugin = _this.plugins[pluginName];
            if (typeof plugin.deactivate === "function") {
                plugin.deactivate();
            }
            if (typeof plugin.dispose === "function") {
                plugin.dispose();
            }
        });
        _super.prototype.dispose.call(this);
    };
    SurveyCreatorModel.prototype.getRootCss = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append("svc-creator")
            .append("svc-creator--mobile", this.isMobileView)
            .append("svc-creator--touch", this.isTouch)
            .append("svc-creator--disable-animations", !this.animationEnabled)
            .toString();
    };
    SurveyCreatorModel.prototype.applyTheme = function (theme) {
        this.syncTheme(theme);
        var designerPlugin = this.getPlugin("designer");
        if (designerPlugin) {
            designerPlugin.setTheme();
        }
    };
    SurveyCreatorModel.prototype.syncTheme = function (theme, isLight) {
        if (!theme)
            return;
        this.creatorTheme = theme;
        var newCssVariable = {};
        (0,_utils_utils__WEBPACK_IMPORTED_MODULE_8__.assign)(newCssVariable, theme === null || theme === void 0 ? void 0 : theme.cssVariables);
        this.themeVariables = newCssVariable;
        var iconsSetName = this.creatorTheme && this.creatorTheme["iconsSet"] ? this.creatorTheme["iconsSet"] : "v1";
        survey_core__WEBPACK_IMPORTED_MODULE_1__.SvgRegistry.registerIcons(survey_core__WEBPACK_IMPORTED_MODULE_1__.SvgThemeSets[iconsSetName]);
        if (isLight !== undefined) {
            this.preferredColorPalette = isLight ? "light" : "dark";
        }
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyCreatorModel.prototype, "showDesignerTab", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyCreatorModel.prototype, "showJSONEditorTab", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyCreatorModel.prototype, "showTestSurveyTab", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyCreatorModel.prototype, "showThemeTab", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyCreatorModel.prototype, "showCreatorThemeSettings", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyCreatorModel.prototype, "showTranslationTab", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyCreatorModel.prototype, "showLogicTab", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyCreatorModel.prototype, "useTableViewInLogicTab", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: 200 })
    ], SurveyCreatorModel.prototype, "pageHoverDelay", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyCreatorModel.prototype, "inplaceEditForValues", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyCreatorModel.prototype, "previewShowResults", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyCreatorModel.prototype, "isAutoSave", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyCreatorModel.prototype, "showOptions", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyCreatorModel.prototype, "showSearch", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyCreatorModel.prototype, "generateValidJSON", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "" })
    ], SurveyCreatorModel.prototype, "currentAddQuestionType", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "landscape" })
    ], SurveyCreatorModel.prototype, "previewOrientation", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyCreatorModel.prototype, "surveyValue", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyCreatorModel.prototype, "viewType", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyCreatorModel.prototype, "allowShowToolbox", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyCreatorModel.prototype, "showToolboxValue", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyCreatorModel.prototype, "showSidebarValue", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,_plugins_undo_redo__WEBPACK_IMPORTED_MODULE_17__.undoRedoTransaction)()
    ], SurveyCreatorModel.prototype, "addPage", null);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,_plugins_undo_redo__WEBPACK_IMPORTED_MODULE_17__.ignoreUndoRedo)()
    ], SurveyCreatorModel.prototype, "doOnQuestionAdded", null);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,_plugins_undo_redo__WEBPACK_IMPORTED_MODULE_17__.ignoreUndoRedo)()
    ], SurveyCreatorModel.prototype, "doOnPanelAdded", null);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,_plugins_undo_redo__WEBPACK_IMPORTED_MODULE_17__.ignoreUndoRedo)()
    ], SurveyCreatorModel.prototype, "doOnPageAdded", null);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,_plugins_undo_redo__WEBPACK_IMPORTED_MODULE_17__.undoRedoTransaction)()
    ], SurveyCreatorModel.prototype, "deleteObject", null);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            defaultValue: false,
            onSet: function (val, target) {
                var themeTabPlugin = target.getPlugin("theme");
                if (!themeTabPlugin) {
                    return;
                }
                if (val) {
                    target.onModified.add(target._syncSaveActions);
                    themeTabPlugin.onThemePropertyChanged.add(target._syncSaveActions);
                    themeTabPlugin.onThemeSelected.add(target._syncSaveActions);
                }
                else {
                    target.onModified.remove(target._syncSaveActions);
                    themeTabPlugin.onThemePropertyChanged.remove(target._syncSaveActions);
                    themeTabPlugin.onThemeSelected.remove(target._syncSaveActions);
                }
            },
        })
    ], SurveyCreatorModel.prototype, "syncSaveButtons", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyCreatorModel.prototype, "showSaveButton", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,_plugins_undo_redo__WEBPACK_IMPORTED_MODULE_17__.undoRedoTransaction)()
    ], SurveyCreatorModel.prototype, "convertCurrentQuestion", null);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,_plugins_undo_redo__WEBPACK_IMPORTED_MODULE_17__.undoRedoTransaction)()
    ], SurveyCreatorModel.prototype, "addNewQuestionInPage", null);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyCreatorModel.prototype, "showHeaderInEmptySurvey", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyCreatorModel.prototype, "allowShowPageNavigator", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyCreatorModel.prototype, "showPageNavigatorValue", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ getDefaultValue: function (obj) { return obj.showTabsDefault; } })
    ], SurveyCreatorModel.prototype, "showTabs", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ getDefaultValue: function (obj) { return obj.showToolbarDefault; } })
    ], SurveyCreatorModel.prototype, "showToolbar", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ getDefaultValue: function () { return _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.layout.allowCollapseSidebar; } })
    ], SurveyCreatorModel.prototype, "allowCollapseSidebar", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ getDefaultValue: function () { return _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.designer.showAddQuestionButton; } })
    ], SurveyCreatorModel.prototype, "showAddQuestionButton", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            defaultValue: false, onSet: function (val, creator) {
                creator.survey.setIsMobile(!!val);
            }
        })
    ], SurveyCreatorModel.prototype, "isMobileView", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], SurveyCreatorModel.prototype, "isTouch", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            defaultValue: "left", onSet: function (newValue, target) {
                if (!target.toolbox)
                    return;
                target.toolbox.setLocation(newValue);
                target.updateToolboxIsCompact();
            }
        })
    ], SurveyCreatorModel.prototype, "toolboxLocation", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "right" })
    ], SurveyCreatorModel.prototype, "sidebarLocation", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "never" })
    ], SurveyCreatorModel.prototype, "expandCollapseButtonVisibility", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            defaultValue: false, onSet: function (newValue, target) {
                if (!newValue) {
                    throw new Error("Creator is disposed");
                }
            }
        })
    ], SurveyCreatorModel.prototype, "isCreatorDisposed", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], SurveyCreatorModel.prototype, "enableLinkFileEditor", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: {} })
    ], SurveyCreatorModel.prototype, "themeVariables", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SurveyCreatorModel.prototype, "creatorTheme", void 0);
    return SurveyCreatorModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));

var CreatorBase = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorBase, _super);
    function CreatorBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return CreatorBase;
}(SurveyCreatorModel));

var StylesManager = /** @class */ (function () {
    function StylesManager() {
    }
    Object.defineProperty(StylesManager, "currentTheme", {
        get: function () {
            _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnNonSupported("StylesManager");
            return undefined;
        },
        set: function (val) {
            _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnNonSupported("StylesManager");
        },
        enumerable: false,
        configurable: true
    });
    StylesManager.applyTheme = function (name) {
        _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnNonSupported("StylesManager");
    };
    return StylesManager;
}());

function initializeDesignTimeSurveyModel(model, creator) {
    model.creator = creator;
    model.isPopupEditorContent = false;
    model.onElementWrapperComponentName.add(function (_, opt) {
        var compName = opt.componentName;
        if (opt.wrapperName === "component") {
            opt.componentName = getElementWrapperComponentName(opt.element, opt.reason, model.isPopupEditorContent);
        }
        if (opt.wrapperName === "content-component") {
            opt.componentName = getQuestionContentWrapperComponentName(opt.element);
        }
        if (opt.wrapperName === "row") {
            opt.componentName = "svc-row";
        }
        if (opt.wrapperName === "itemvalue") {
            opt.componentName = getItemValueWrapperComponentName(opt.item, opt.element);
        }
        opt.componentName = opt.componentName || compName;
    });
    model.onElementWrapperComponentData.add(function (_, opt) {
        var data = opt.data;
        if (opt.wrapperName === "component") {
            opt.data = getElementWrapperComponentData(opt.element, opt.reason, creator);
        }
        if (opt.wrapperName === "row") {
            opt.data = { creator: creator, row: opt.element };
        }
        if (opt.wrapperName === "itemvalue") {
            opt.data = getItemValueWrapperComponentData(opt.item, opt.element, creator);
        }
        opt.data = opt.data || data;
    });
    model.getRendererForString = function (element, name) {
        if (!creator.readOnly && isStringEditable(element, name)) {
            return editableStringRendererName;
        }
        return undefined;
    };
    model.getRendererContextForString = function (element, locStr) {
        if (!creator.readOnly && isStringEditable(element, locStr.name)) {
            return {
                creator: creator,
                element: element,
                locStr: locStr
            };
        }
        return locStr;
    };
}
function isContentElement(element) {
    var current = element;
    while (!!current) {
        if (current.isContentElement) {
            return true;
        }
        current = current.parentQuestion;
    }
    return false;
}
function getQuestionFromElement(element) {
    if (!element)
        return null;
    if (!!element.row)
        return element.row.data;
    if (!!element.column)
        return element.column.colOwner;
    return null;
}
var editableStringRendererName = "svc-string-editor";
function getElementWrapperComponentName(element, reason, isPopupEditorContent) {
    if (reason === "logo-image") {
        return "svc-logo-image";
    }
    if (reason === "cell" || reason === "column-header" || reason === "row-header") {
        if (isContentElement(getQuestionFromElement(element)))
            return undefined;
        return "svc-matrix-cell";
    }
    if (!isContentElement(element)) {
        if (element instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.Question) {
            var isDropdown = element.isDescendantOf("dropdown") || element.isDescendantOf("tagbox");
            if (isPopupEditorContent) {
                return isDropdown ? "svc-cell-dropdown-question" : "svc-cell-question";
            }
            if (element.customWidget) {
                return "svc-widget-question";
            }
            if (isDropdown) {
                return "svc-dropdown-question";
            }
            if (element.isDescendantOf("image")) {
                return "svc-image-question";
            }
            return "svc-question";
        }
        if (element instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.PanelModel) {
            return "svc-panel";
        }
    }
    return undefined;
}
function getQuestionContentWrapperComponentName(element) {
    if (element.isDescendantOf("rating") && !isContentElement(element)) {
        return "svc-rating-question-content";
    }
    return undefined;
}
function getElementWrapperComponentData(element, reason, creator) {
    if (reason === "logo-image")
        return creator;
    if (reason === "cell" ||
        reason === "column-header" ||
        reason === "row-header") {
        return {
            creator: creator,
            element: element,
            question: element.question,
            row: element.row,
            column: element.column
        };
    }
    var hasWrapper = getElementWrapperComponentName(element, reason, false);
    if (!hasWrapper)
        return undefined;
    if (element instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.Question)
        return creator;
    if (element instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.PanelModel)
        return creator;
    return null;
}
function getItemValueWrapperComponentName(item, question) {
    if (isContentElement(question)) {
        return survey_core__WEBPACK_IMPORTED_MODULE_1__.SurveyModel.TemplateRendererComponentName;
    }
    if (question.isDescendantOf("imagepicker")) {
        return "svc-image-item-value";
    }
    return "svc-item-value";
}
function getItemValueWrapperComponentData(item, question, creator) {
    if (question.isContentElement) {
        return item;
    }
    return {
        creator: creator,
        question: question,
        item: item
    };
}
function isStringEditable(element, name) {
    if (element.parentQuestion instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionMatrixDropdownModelBase) {
        if (!!element.data || isContentElement(element.parentQuestion))
            return false;
    }
    return !isContentElement(element) || element.isEditableTemplateElement;
}
function isTextInput(target) {
    if (!target.tagName)
        return false;
    var tagName = target.tagName.toLowerCase();
    if (["input", "textarea"].indexOf(tagName) !== -1)
        return true;
    if (["span", "div"].indexOf(tagName) !== -1) {
        return target.isContentEditable;
    }
    return false;
}
function registerAdorner(name, adorner) {
    _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnNonSupported("registerAdorner", "This functionality is no longer supported.");
}
function removeAdorners(names) {
    if (names === void 0) { names = undefined; }
    _survey_helper__WEBPACK_IMPORTED_MODULE_9__.SurveyHelper.warnNonSupported("removeAdorners", "This functionality is no longer supported.");
}


/***/ }),

/***/ "./src/creator-events-api.ts":
/*!***********************************!*\
  !*** ./src/creator-events-api.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/creator-responsivity-manager.ts":
/*!*********************************************!*\
  !*** ./src/creator-responsivity-manager.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CreatorResponsivityManager: () => (/* binding */ CreatorResponsivityManager)
/* harmony export */ });
__webpack_require__(/*! ./responsivity.scss */ "./src/responsivity.scss");
var CreatorResponsivityManager = /** @class */ (function () {
    function CreatorResponsivityManager(container, creator) {
        var _this = this;
        this.container = container;
        this.creator = creator;
        this.resizeObserver = undefined;
        if (typeof ResizeObserver !== "undefined") {
            this.resizeObserver = new ResizeObserver(function (_) { return _this.process(); });
            this.resizeObserver.observe(this.findCorrectParent(this.container));
            this.process(true);
            if (this.currentWidth == "xs" || this.currentWidth == "s" || this.currentWidth === "m") {
                this.creator.setShowSidebar(false);
            }
        }
    }
    CreatorResponsivityManager.prototype.getScreenWidth = function () {
        var _this = this;
        var res;
        Object.keys(CreatorResponsivityManager.screenSizeBreakpoints).forEach(function (mode) {
            var breakpoint = CreatorResponsivityManager.screenSizeBreakpoints[mode];
            if (!res && _this.container && !!breakpoint && _this.container.offsetWidth >= breakpoint) {
                res = mode;
            }
        });
        return res || "xs";
    };
    CreatorResponsivityManager.prototype.initMobileView = function () {
        this.creator.showTabs = false;
        this.creator.showToolbar = false;
        this.creator.isMobileView = true;
    };
    CreatorResponsivityManager.prototype.resetMobileView = function () {
        this.creator.showTabs = undefined;
        this.creator.showToolbar = undefined;
        this.creator.isMobileView = undefined;
    };
    CreatorResponsivityManager.prototype.procesShowToolbox = function (toolboxVisible) {
        this.creator.allowShowToolbox = toolboxVisible;
    };
    CreatorResponsivityManager.prototype.procesShowPageNavigator = function (pageNavigatorVisibility) {
        this.creator.allowShowPageNavigator = this.creator.pageEditMode === "bypage" || pageNavigatorVisibility;
    };
    CreatorResponsivityManager.prototype.findCorrectParent = function (container) {
        if (!!(window === null || window === void 0 ? void 0 : window.getComputedStyle)) {
            if (window.getComputedStyle(container.parentElement).display === "inline") {
                return this.findCorrectParent(container.parentElement);
            }
        }
        return container.parentElement;
    };
    CreatorResponsivityManager.prototype._process = function (toolboxIsCompact, toolboxVisible, flyoutSidebar) {
        this.creator.updateToolboxIsCompact(toolboxIsCompact);
        this.procesShowToolbox(toolboxVisible);
        this.procesShowPageNavigator(toolboxVisible);
        if (this.creator.sidebar.visible && !flyoutSidebar) {
            this.creator.sidebar.collapsedManually = false;
        }
        if (this.creator.sidebar.visible && !this.creator.sidebar.expandedManually && flyoutSidebar && this.creator.toolboxLocation != "right") {
            this.creator.sidebar.collapseSidebar();
        }
        if (!this.creator.sidebar.visible && !this.creator.sidebar.collapsedManually && !flyoutSidebar && this.creator.toolboxLocation != "right") {
            this.creator.sidebar.expandSidebar();
        }
        this.creator.sidebar.flyoutMode = flyoutSidebar;
    };
    CreatorResponsivityManager.prototype.process = function (isFirst) {
        if (isFirst === void 0) { isFirst = false; }
        if (isFirst) {
            this.creator.sidebar.blockAnimations();
            this.creator.toolbox.blockAnimations();
        }
        this.updateSurveyActualWidth();
        this.currentWidth = this.getScreenWidth();
        if (this.currentWidth === "xl" || this.currentWidth === "xxl") {
            this._process(false, true, false);
        }
        else if (this.currentWidth === "l") {
            this._process(true, true, false);
        }
        else if (this.currentWidth === "m") {
            this._process(true, true, true);
        }
        else {
            this._process(true, false, true);
        }
        if (this.currentWidth == "xs") {
            this.initMobileView();
        }
        else {
            this.resetMobileView();
        }
        if (isFirst) {
            this.creator.sidebar.releaseAnimations();
            this.creator.toolbox.releaseAnimations();
        }
    };
    CreatorResponsivityManager.prototype.updateSurveyActualWidth = function () {
        var _a;
        if (!!this.container && !!this.container.querySelector) {
            var surveyContainer = (_a = this.container) === null || _a === void 0 ? void 0 : _a.querySelector(".svc-tab-designer_content > div");
            if (!!surveyContainer) {
                this.creator.survey.setResponsiveStartWidth(surveyContainer.offsetWidth);
            }
        }
    };
    CreatorResponsivityManager.prototype.dispose = function () {
        this.creator.allowShowToolbox = true;
        this.creator.allowShowPageNavigator = true;
        if (!!this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
    };
    CreatorResponsivityManager.screenSizeBreakpoints = {
        "xxl": 1800,
        "xl": 1500,
        "l": 1200,
        "m": 900,
        "s": 600,
    };
    return CreatorResponsivityManager;
}());



/***/ }),

/***/ "./src/creator-settings.ts":
/*!*********************************!*\
  !*** ./src/creator-settings.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EmptySurveyCreatorOptions: () => (/* binding */ EmptySurveyCreatorOptions),
/* harmony export */   QuestionConvertMode: () => (/* binding */ QuestionConvertMode),
/* harmony export */   settings: () => (/* binding */ settings)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);

/**
 * List available question convert modes
 */
var QuestionConvertMode;
(function (QuestionConvertMode) {
    QuestionConvertMode[QuestionConvertMode["AllTypes"] = 0] = "AllTypes";
    QuestionConvertMode[QuestionConvertMode["CompatibleTypes"] = 1] = "CompatibleTypes";
})(QuestionConvertMode || (QuestionConvertMode = {}));
var settings = {
    translation: {
        sortByName: false,
        //Set it to \xef\xbb\xbf; to tell system that it is UTF8 file. You can use other prefix as well
        exportPrefix: "",
        /**
         * The maximum number of locales that user can select at once for translation
         */
        maximumSelectedLocales: 7,
        /**
         * The name of the translation export file in csv format
         */
        exportFileName: "survey_translation.csv"
    },
    themeEditor: {
        exportFileName: "survey_theme.json",
        defaultFontFamily: "Open Sans",
    },
    operators: {
        empty: [],
        notempty: [],
        equal: ["!file"],
        notequal: ["!file"],
        contains: ["checkbox", "text", "comment"],
        notcontains: ["checkbox", "text", "comment"],
        anyof: ["selectbase"],
        allof: ["checkbox"],
        greater: ["!checkbox", "!imagepicker", "!boolean", "!file"],
        less: ["!checkbox", "!imagepicker", "!boolean", "!file"],
        greaterorequal: ["!checkbox", "!imagepicker", "!boolean", "!file"],
        lessorequal: ["!checkbox", "!imagepicker", "!boolean", "!file"]
    },
    defaultNewSurveyJSON: {},
    designer: {
        /**
         * The default question type on clicking Add Question button.
         */
        defaultAddQuestionType: "text",
        /**
         * Set this property to false, to hide "Add Question" button on designer surface
         */
        showAddQuestionButton: true
    },
    logic: {
        questionSortOrder: "asc",
        get defaultOperator() { return settings.logic.defaultOperators.default; },
        set defaultOperator(val) { settings.logic.defaultOperators.default = val; },
        defaultOperators: {
            default: "equal",
            checkbox: "allof",
            tagbox: "allof"
        },
        includeComplexQuestions: false,
        visibleActions: new Array(),
        invisibleTriggers: new Array(),
        logicItemTitleMaxChars: 50,
        openBracket: "{",
        closeBracket: "}",
        /**
         * Set these properties to false if you don't want to update expressions on changing question and column names and on changing choices values
         */
        updateExpressionsOnChanging: {
            questionName: true,
            columnName: true,
            choiceValue: true
        },
        /**
         * Set these properties to false if you don't want to update expressions on deleting question
         */
        updateExpressionsOnDeleting: {
            question: true
        }
    },
    /**
     * Determines which types of questions the conversion will be available for.
     */
    questionConvertMode: QuestionConvertMode.AllTypes,
    propertyGrid: {
        useButtonGroup: true,
        maxCharsInButtonGroup: 25,
        showNavigationButtons: false,
        enableSearch: true,
        maximumColumnsCount: 0,
        minimumChoicesCount: 0,
        maximumChoicesCount: 0,
        maximumRowsCount: 0,
        maximumRateValues: 0,
        generalTabName: "general",
        defaultExpandedTabName: "general",
        allowExpandMultipleCategories: false
    },
    toolbox: {
        /**
         * Use it to change the default question JSON on dropping it into designer or converting questions
         */
        defaultJSON: {
            dropdown: {
                choices: ["Item 1", "Item 2", "Item 3"]
            },
            tagbox: {
                choices: ["Item 1", "Item 2", "Item 3"]
            },
            checkbox: {
                choices: ["Item 1", "Item 2", "Item 3"]
            },
            radiogroup: {
                choices: ["Item 1", "Item 2", "Item 3"]
            },
            ranking: {
                choices: ["Item 1", "Item 2", "Item 3"]
            },
            imagepicker: {
                imageFit: "cover",
                choices: [
                    {
                        value: "Image 1",
                        imageLink: "https://surveyjs.io/Content/Images/examples/image-picker/lion.jpg"
                    },
                    {
                        value: "Image 2",
                        imageLink: "https://surveyjs.io/Content/Images/examples/image-picker/giraffe.jpg"
                    },
                    {
                        value: "Image 3",
                        imageLink: "https://surveyjs.io/Content/Images/examples/image-picker/panda.jpg"
                    },
                    {
                        value: "Image 4",
                        imageLink: "https://surveyjs.io/Content/Images/examples/image-picker/camel.jpg"
                    }
                ]
            },
            image: {
                imageFit: "cover",
                imageHeight: "auto",
                imageWidth: "100%"
            }
        }
    },
    /**
     * Notification settings
     */
    notifications: {
        lifetime: 2000
    },
    /**
     * Auto save parameters
     */
    autoSave: {
        delay: 500
    },
    /**
     * Drag Drop Settings
     */
    dragDrop: {
        restrictDragQuestionBetweenPages: false,
        allowDragToTheSameLine: true
    },
    /**
     * Creator layout settings
     */
    layout: {
        showTabs: true,
        showToolbar: true,
        allowCollapseSidebar: true
    },
    jsonEditor: {
        indentation: 2,
        exportFileName: "survey.json"
    },
    useLegacyIcons: true
};
var EmptySurveyCreatorOptions = /** @class */ (function () {
    function EmptySurveyCreatorOptions() {
        this.isMobileView = false;
        this.allowEditExpressionsInTextEditor = true;
        this.maximumColumnsCount = settings.propertyGrid.maximumColumnsCount;
        this.minimumChoicesCount = settings.propertyGrid.minimumChoicesCount;
        this.maximumChoicesCount = settings.propertyGrid.maximumChoicesCount;
        this.maximumRowsCount = settings.propertyGrid.maximumRowsCount;
        this.maximumRateValues = settings.propertyGrid.maximumRateValues;
        this.machineTranslationValue = false;
        this.inplaceEditForValues = false;
        this.maxNestedPanels = -1;
        this.translationLocalesOrder = [];
    }
    EmptySurveyCreatorOptions.prototype.getProcessedTranslationItemText = function (locale, locString, newText, obj) {
        return newText;
    };
    EmptySurveyCreatorOptions.prototype.getObjectDisplayName = function (obj, area, reason, displayName) {
        return displayName;
    };
    EmptySurveyCreatorOptions.prototype.onCanShowPropertyCallback = function (object, property, showMode, parentObj, parentProperty) {
        return true;
    };
    EmptySurveyCreatorOptions.prototype.getElementAddornerCssCallback = function (obj, className) { return className; };
    EmptySurveyCreatorOptions.prototype.onPropertyGridSurveyCreatedCallback = function (object, survey) { };
    EmptySurveyCreatorOptions.prototype.onPropertyEditorCreatedCallback = function (object, property, editor) { };
    EmptySurveyCreatorOptions.prototype.onPropertyEditorUpdateTitleActionsCallback = function (object, property, editor, titleActions) { };
    EmptySurveyCreatorOptions.prototype.onPropertyGridShowModalCallback = function (object, property, editor, popupEditor, popupModel) { };
    EmptySurveyCreatorOptions.prototype.onIsPropertyReadOnlyCallback = function (obj, property, readOnly, parentObj, parentProperty) {
        return readOnly;
    };
    EmptySurveyCreatorOptions.prototype.onCanDeleteItemCallback = function (object, item, allowDelete) {
        return allowDelete;
    };
    EmptySurveyCreatorOptions.prototype.onCollectionItemDeletingCallback = function (obj, property, collection, item) {
        return true;
    };
    EmptySurveyCreatorOptions.prototype.onCollectionItemAllowingCallback = function (obj, property, collection, item, options) { };
    EmptySurveyCreatorOptions.prototype.onItemValueAddedCallback = function (obj, propertyName, itemValue, itemValues) { };
    EmptySurveyCreatorOptions.prototype.onFastEntryCallback = function (items, lines) {
        return items;
    };
    EmptySurveyCreatorOptions.prototype.onMatrixDropdownColumnAddedCallback = function (matrix, column, columns) { };
    EmptySurveyCreatorOptions.prototype.onSetPropertyEditorOptionsCallback = function (propertyName, obj, editorOptions) { };
    EmptySurveyCreatorOptions.prototype.onGetErrorTextOnValidationCallback = function (propertyName, obj, value) {
        return null;
    };
    EmptySurveyCreatorOptions.prototype.onValueChangingCallback = function (options) { };
    EmptySurveyCreatorOptions.prototype.onGetElementEditorTitleCallback = function (obj, title) {
        return title;
    };
    EmptySurveyCreatorOptions.prototype.startUndoRedoTransaction = function (name) { };
    EmptySurveyCreatorOptions.prototype.stopUndoRedoTransaction = function () { };
    EmptySurveyCreatorOptions.prototype.createSurvey = function (json, reason, model, callback, area) {
        var survey = new survey_core__WEBPACK_IMPORTED_MODULE_0__.SurveyModel(json);
        if (!!callback) {
            callback(survey);
        }
        return survey;
    };
    EmptySurveyCreatorOptions.prototype.onConditionQuestionsGetListCallback = function (propertyName, obj, editor, list, variables) { return "asc"; };
    EmptySurveyCreatorOptions.prototype.onConditionGetTitleCallback = function (expression, title) {
        return title;
    };
    EmptySurveyCreatorOptions.prototype.isConditionOperatorEnabled = function (questionName, question, operator, isEnabled) { return isEnabled; };
    EmptySurveyCreatorOptions.prototype.onLogicGetTitleCallback = function (expression, displayExpression, text, logicItem) { return text; };
    EmptySurveyCreatorOptions.prototype.getTranslationExportedText = function (obj, name, locString, locale, text) { return text; };
    EmptySurveyCreatorOptions.prototype.uploadFiles = function (files, question, callback) { };
    EmptySurveyCreatorOptions.prototype.getHasMachineTranslation = function () { return this.machineTranslationValue; };
    EmptySurveyCreatorOptions.prototype.doMachineTranslation = function (fromLocale, toLocale, strings, callback) { };
    EmptySurveyCreatorOptions.prototype.chooseFiles = function (input, callback, context) { };
    return EmptySurveyCreatorOptions;
}());

survey_core__WEBPACK_IMPORTED_MODULE_0__.StylesManager.applyTheme("defaultV2");


/***/ }),

/***/ "./src/creator-theme/creator-theme-model-definition.ts":
/*!*************************************************************!*\
  !*** ./src/creator-theme/creator-theme-model-definition.ts ***!
  \*************************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   creatorThemeModelEditorDefinition: () => (/* binding */ creatorThemeModelEditorDefinition),
/* harmony export */   creatorThemeModelPropertyGridDefinition: () => (/* binding */ creatorThemeModelPropertyGridDefinition)
/* harmony export */ });
var creatorThemeModelProperties = {
    "creatortheme": {
        properties: [
            { name: "themeName", index: 1 },
            { name: "--sjs-special-background", index: 10 },
            { name: "--sjs-primary-background-500", index: 10, tab: "accentColors" },
            { name: "--sjs-secondary-background-500", index: 20, tab: "accentColors" },
            { name: "fontScale", index: 40, tab: "scaling" },
            { name: "scale", index: 50, tab: "scaling" },
        ],
        tabs: [
            { name: "accentColors", "parent": "general", index: 20 },
            { name: "scaling", "parent": "general", index: 30 }
        ]
    },
};
var creatorThemeModelPropertyGridDefinition = {
    autoGenerateProperties: true,
    classes: creatorThemeModelProperties
};
var creatorThemeModelEditorDefinition = /** @class */ (function () {
    function creatorThemeModelEditorDefinition() {
    }
    creatorThemeModelEditorDefinition.definition = creatorThemeModelProperties;
    return creatorThemeModelEditorDefinition;
}());



/***/ }),

/***/ "./src/creator-theme/creator-theme-model.ts":
/*!**************************************************!*\
  !*** ./src/creator-theme/creator-theme-model.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CreatorThemeModel: () => (/* binding */ CreatorThemeModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _creator_themes__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./creator-themes */ "./src/creator-theme/creator-themes.ts");
/* harmony import */ var survey_creator_core_themes__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! survey-creator-core/themes */ "survey-creator-core/themes");
/* harmony import */ var survey_creator_core_themes__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(survey_creator_core_themes__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_tabs_themes__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../components/tabs/themes */ "./src/components/tabs/themes.ts");







Object.keys(survey_creator_core_themes__WEBPACK_IMPORTED_MODULE_5__ || {}).forEach(function (themeName) {
    var theme = survey_creator_core_themes__WEBPACK_IMPORTED_MODULE_5__[themeName];
    if (_creator_themes__WEBPACK_IMPORTED_MODULE_4__.PredefinedCreatorThemes.indexOf(theme.themeName) === -1) {
        _creator_themes__WEBPACK_IMPORTED_MODULE_4__.PredefinedCreatorThemes.push(theme.themeName);
    }
    _creator_themes__WEBPACK_IMPORTED_MODULE_4__.CreatorThemes[theme.themeName] = theme;
});
var CreatorThemeModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorThemeModel, _super);
    function CreatorThemeModel() {
        var _this = _super.call(this) || this;
        _this.initialCssVariables = {};
        _this.themeCssVariablesChanges = {};
        _this.primaryColorCalculator = new _utils_utils__WEBPACK_IMPORTED_MODULE_3__.ColorCalculator();
        _this.secondaryColorCalculator = new _utils_utils__WEBPACK_IMPORTED_MODULE_3__.ColorCalculator();
        _this.backgroundColorCalculator = new _utils_utils__WEBPACK_IMPORTED_MODULE_3__.ColorCalculator();
        _this.unitDictionary = {
            "--ctr-font-unit": 8,
            "--ctr-line-height-unit": 8,
            "--ctr-size-unit": 8,
            "--ctr-spacing-unit": 8,
            "--ctr-corner-radius-unit": 8,
            "--ctr-stroke-unit": 1,
        };
        _this.themeName = CreatorThemeModel.defautlThemeName;
        _this.isLight = true;
        _this.onThemeSelected = new survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase();
        _this.onThemePropertyChanged = new survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase();
        _this.blockThemeChangedNotifications = 0;
        _this.onPropertyValueChangedCallback = function (name, oldValue, newValue, sender, arrayChanges) {
            _this.onThemePropertyValueChangedCallback(name, oldValue, newValue, sender, arrayChanges);
        };
        return _this;
    }
    CreatorThemeModel.prototype.initializeColorCalculators = function (cssVariables) {
        this.initializeColorCalculator(this.primaryColorCalculator, cssVariables, "--sjs-primary-background-500", "--sjs-primary-background-10", "--sjs-primary-background-400");
        this.initializeColorCalculator(this.secondaryColorCalculator, cssVariables, "--sjs-secondary-background-500", "--sjs-secondary-background-10", "--sjs-secondary-background-25");
        this.initializeColorCalculator(this.backgroundColorCalculator, cssVariables, "--sjs-special-background", "--sjs-special-haze", "--sjs-special-glow");
    };
    CreatorThemeModel.prototype.initializeColorCalculator = function (calculator, cssVariables, baseColorName, lightColorName, darkColorName) {
        if (!cssVariables[baseColorName] ||
            !cssVariables[lightColorName] ||
            !cssVariables[darkColorName]) {
            return;
        }
        calculator.initialize(cssVariables[baseColorName], cssVariables[lightColorName], cssVariables[darkColorName]);
    };
    CreatorThemeModel.prototype.updateColorPropertiesDependentOnBaseColor = function (calculator, value, baseColorName, lightColorName, darkColorName) {
        this.setPropertyValue(baseColorName, value);
        this.setThemeCssVariablesChanges(baseColorName, value);
        calculator.calculateColors(value);
        this.setPropertyValue(lightColorName, calculator.colorSettings.newColorLight);
        this.setPropertyValue(darkColorName, calculator.colorSettings.newColorDark);
        this.setThemeCssVariablesChanges(lightColorName, calculator.colorSettings.newColorLight);
        this.setThemeCssVariablesChanges(darkColorName, calculator.colorSettings.newColorDark);
    };
    CreatorThemeModel.prototype.isSpecialBackgroundFromCurrentTheme = function () {
        var currentTheme = _creator_themes__WEBPACK_IMPORTED_MODULE_4__.CreatorThemes[this.themeName];
        return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.colorsAreEqual)(currentTheme && currentTheme.cssVariables && currentTheme.cssVariables["--sjs-special-background"], this["--sjs-special-background"]);
    };
    CreatorThemeModel.prototype.findAppropriateSpecialBackground = function (primaryColorValue) {
        var primaryColorName;
        var colorsDict = _components_tabs_themes__WEBPACK_IMPORTED_MODULE_6__.PredefinedColors["light"];
        Object.keys(colorsDict).forEach(function (colorName) {
            if ((0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.colorsAreEqual)(colorsDict[colorName], primaryColorValue)) {
                primaryColorName = colorName;
            }
        });
        return _components_tabs_themes__WEBPACK_IMPORTED_MODULE_6__.PredefinedBackgroundColors["light"][primaryColorName];
    };
    CreatorThemeModel.prototype.updateBackgroundColor = function (primaryColorNewValue, primaryColorOldValue) {
        if (!this.isLight) {
            return;
        }
        var canCalculateSpecialBackgroundColor = this.isSpecialBackgroundFromCurrentTheme() || (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.colorsAreEqual)(this.findAppropriateSpecialBackground(primaryColorOldValue), this["--sjs-special-background"]);
        if (canCalculateSpecialBackgroundColor) {
            var newSpecialBackgroundColor = this.findAppropriateSpecialBackground(primaryColorNewValue);
            this["--sjs-special-background"] = newSpecialBackgroundColor || _components_tabs_themes__WEBPACK_IMPORTED_MODULE_6__.PredefinedBackgroundColors["light"]["gray"];
        }
    };
    CreatorThemeModel.prototype.getType = function () {
        return "creatortheme";
    };
    Object.defineProperty(CreatorThemeModel.prototype, "cssVariables", {
        get: function () {
            return this.toJSON()["cssVariables"] || {};
        },
        enumerable: false,
        configurable: true
    });
    CreatorThemeModel.prototype.cssVariableChangedHandler = function () {
        if (this.themeName === CreatorThemeModel.defautlThemeName && Object.keys(this.cssVariables).length === 0) {
            this.loadTheme({ themeName: CreatorThemeModel.defautlThemeName });
        }
    };
    CreatorThemeModel.prototype.setThemeCssVariablesChanges = function (name, value) {
        if (this.themeCssVariablesChanges[name] !== value) {
            this.cssVariableChangedHandler();
            this.themeCssVariablesChanges[name] = value;
            this.onThemePropertyChanged.fire(this, { name: name, value: value });
        }
    };
    CreatorThemeModel.prototype.resetColorThemeCssVariablesChanges = function () {
        var _this = this;
        Object.keys(this.themeCssVariablesChanges).forEach(function (key) {
            if (key.indexOf("--sjs-") === 0) {
                delete _this.themeCssVariablesChanges[key];
            }
        });
    };
    CreatorThemeModel.prototype.onThemePropertyValueChangedCallback = function (name, oldValue, newValue, sender, arrayChanges) {
        if (this.blockThemeChangedNotifications > 0)
            return;
        if (name === "themeName") {
            this.resetColorThemeCssVariablesChanges();
            this.loadTheme({ themeName: newValue });
            this.onThemeSelected.fire(this, { theme: this.toJSON() });
        }
        else if (name === "--sjs-primary-background-500") {
            this.updateColorPropertiesDependentOnBaseColor(this.primaryColorCalculator, newValue, "--sjs-primary-background-500", "--sjs-primary-background-10", "--sjs-primary-background-400");
            this.updateBackgroundColor(newValue, oldValue);
        }
        else if (name === "--sjs-secondary-background-500") {
            this.updateColorPropertiesDependentOnBaseColor(this.secondaryColorCalculator, newValue, "--sjs-secondary-background-500", "--sjs-secondary-background-10", "--sjs-secondary-background-25");
        }
        else if (name === "--sjs-special-background") {
            this.updateColorPropertiesDependentOnBaseColor(this.backgroundColorCalculator, newValue, "--sjs-special-background", "--sjs-special-haze", "--sjs-special-glow");
        }
        else if (name.indexOf("--") === 0) {
            this.setThemeCssVariablesChanges(name, newValue);
        }
        else if (name == "fontScale" || name == "scale") {
            this.scalePropertiesChanged(name, newValue);
        }
    };
    CreatorThemeModel.prototype.scalePropertiesChanged = function (propertyName, newValue) {
        if (propertyName == "fontScale") {
            this.scalingProperties("--ctr-font-unit", newValue);
            this.scalingProperties("--ctr-line-height-unit", newValue);
        }
        else if (propertyName == "scale") {
            this.scalingProperties("--ctr-size-unit", newValue);
            this.scalingProperties("--ctr-spacing-unit", newValue);
            this.scalingProperties("--ctr-corner-radius-unit", newValue);
        }
    };
    CreatorThemeModel.prototype.scalingProperties = function (cssName, newValue) {
        var baseUnit = this.unitDictionary[cssName];
        this.setThemeCssVariablesChanges(cssName, (newValue * baseUnit / 100) + "px");
    };
    CreatorThemeModel.prototype.scaleValue = function (cssName, scale) {
        var baseUnit = this.unitDictionary[cssName];
        this[cssName] = (scale * baseUnit / 100) + "px";
    };
    CreatorThemeModel.prototype.scaleCssVariables = function () {
        if (this.fontScale !== undefined) {
            this.scaleValue("--ctr-font-unit", this.fontScale);
            this.scaleValue("--ctr-line-height-unit", this.fontScale);
        }
        if (this.scale !== undefined) {
            this.scaleValue("--ctr-size-unit", this.scale);
            this.scaleValue("--ctr-spacing-unit", this.scale);
            this.scaleValue("--ctr-corner-radius-unit", this.scale);
        }
    };
    CreatorThemeModel.prototype.getScaleFactor = function (cssName) {
        return !!this[cssName] ? (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.roundTo2Decimals)(parseFloat(this[cssName]) * 100 / this.unitDictionary[cssName]) : undefined;
    };
    CreatorThemeModel.prototype.updateScaleProperties = function () {
        this.blockThemeChangedNotifications += 1;
        try {
            this.fontScale = this.getScaleFactor("--ctr-font-unit");
            this.scale = this.getScaleFactor("--ctr-size-unit");
        }
        finally {
            this.blockThemeChangedNotifications -= 1;
        }
    };
    CreatorThemeModel.prototype.loadTheme = function (theme) {
        if (theme === void 0) { theme = {}; }
        this.blockThemeChangedNotifications += 1;
        try {
            var baseTheme = _creator_themes__WEBPACK_IMPORTED_MODULE_4__.CreatorThemes[theme.themeName] || {};
            this.themeName = theme.themeName || baseTheme.themeName || CreatorThemeModel.defautlThemeName;
            var effectiveThemeCssVariables = {};
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.assign)(effectiveThemeCssVariables, baseTheme.cssVariables || {});
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.assign)(effectiveThemeCssVariables, theme.cssVariables || {}, this.themeCssVariablesChanges);
            var effectiveTheme = {};
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.assign)(effectiveTheme, baseTheme, theme, { cssVariables: effectiveThemeCssVariables, themeName: this.themeName });
            this.initializeColorCalculators(effectiveTheme.cssVariables);
            this.fromJSON(effectiveTheme);
        }
        finally {
            this.blockThemeChangedNotifications -= 1;
        }
    };
    CreatorThemeModel.prototype.setTheme = function (theme) {
        var _this = this;
        this.themeCssVariablesChanges = {};
        try {
            this.blockThemeChangedNotifications += 1;
            this.iteratePropertiesHash(function (hash, key) {
                _this.setPropertyValue(key, undefined);
            });
        }
        finally {
            this.blockThemeChangedNotifications -= 1;
        }
        this.loadTheme(theme);
        this.onThemeSelected.fire(this, { theme: this.toJSON() });
    };
    CreatorThemeModel.prototype.fromJSON = function (json, options) {
        if (!json)
            return;
        var _json = {};
        (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.assign)(_json, json);
        delete _json["cssVariables"];
        _super.prototype.fromJSON.call(this, _json, options);
        if (json.cssVariables) {
            _super.prototype.fromJSON.call(this, json.cssVariables, options);
            this.initialCssVariables = {};
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.assign)(this.initialCssVariables, json.cssVariables);
            this.updateScaleProperties();
        }
    };
    CreatorThemeModel.prototype.toJSON = function (options) {
        this.scaleCssVariables();
        var result = _super.prototype.toJSON.call(this, options);
        var cssVariables = {};
        (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.assign)(cssVariables, this.initialCssVariables, this.themeCssVariablesChanges);
        result.cssVariables = cssVariables;
        Object.keys(result).forEach(function (key) {
            if (key.indexOf("--") == 0) {
                delete result[key];
            }
        });
        if (Object.keys(result.cssVariables).length === 0) {
            delete result.cssVariables;
        }
        return result;
    };
    CreatorThemeModel.defautlThemeName = "sc2020";
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], CreatorThemeModel.prototype, "themeName", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], CreatorThemeModel.prototype, "scale", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], CreatorThemeModel.prototype, "fontScale", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], CreatorThemeModel.prototype, "isLight", void 0);
    return CreatorThemeModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));

survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addClass("creatortheme", [
    {
        type: "dropdown",
        name: "themeName",
        choices: _creator_themes__WEBPACK_IMPORTED_MODULE_4__.PredefinedCreatorThemes.map(function (theme) { return ({ value: theme, text: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("creatortheme.names." + theme) }); }),
    },
    {
        type: "string",
        visible: false,
        name: "iconsSet",
        default: "v1"
    }
], function (json) { return new CreatorThemeModel(); });
survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addProperties("creatortheme", [
    {
        type: "color",
        name: "--sjs-special-background",
        default: "#F3F3F3FF",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.title = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("creatortheme.--sjs-special-background");
            }
        }
    }, {
        type: "color",
        name: "--sjs-primary-background-500",
        default: "#19B394FF",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.titleLocation = "left";
                editor.title = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("creatortheme.--sjs-primary-background-500");
            }
        },
    }, {
        type: "color",
        name: "--sjs-secondary-background-500",
        default: "#FF9814FF",
        displayName: "",
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.titleLocation = "left";
                editor.title = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("creatortheme.--sjs-secondary-background-500");
            }
        },
    }, {
        name: "--ctr-font-unit",
        default: "8px",
        visible: false,
    }, {
        name: "--ctr-line-height-unit",
        default: "8px",
        visible: false,
    }, {
        type: "spinedit",
        name: "fontScale",
        isSerializable: false,
        default: 100,
        enableIf: function (obj) {
            return !obj || obj.themeName !== CreatorThemeModel.defautlThemeName;
        },
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "%";
                editor.min = 0;
                editor.step = 5;
                editor.title = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("creatortheme.fontScale");
                editor.titleLocation = "left";
                editor.descriptionLocation = "hidden";
            }
        }
    }, {
        name: "--ctr-spacing-unit",
        default: "8px",
        visible: false,
    }, {
        name: "--ctr-size-unit",
        default: "8px",
        visible: false,
    }, {
        name: "--ctr-corner-radius-unit",
        default: "8px",
        visible: false,
    }, {
        name: "--lbr-font-unit",
        default: "8px",
        visible: false,
    }, {
        name: "--lbr-line-height-unit",
        default: "8px",
        visible: false,
    }, {
        name: "--lbr-size-unit",
        default: "8px",
        visible: false,
    }, {
        name: "--lbr-spacing-unit",
        default: "8px",
        visible: false,
    }, {
        name: "--lbr-corner-radius-unit",
        default: "8px",
        visible: false,
    }, {
        name: "--lbr-size-unit",
        default: "8px",
        visible: false,
    }, {
        type: "spinedit",
        name: "scale",
        isSerializable: false,
        default: 100,
        enableIf: function (obj) {
            return !obj || obj.themeName !== CreatorThemeModel.defautlThemeName;
        },
        onPropertyEditorUpdate: function (obj, editor) {
            if (!!editor) {
                editor.unit = "%";
                editor.min = 0;
                editor.step = 5;
                editor.title = (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("creatortheme.userInterfaceBaseUnit");
                editor.titleLocation = "left";
                editor.descriptionLocation = "hidden";
            }
        }
    }, {
        name: "isLight:boolean",
        visible: false,
        isSerializable: false,
    },
    { name: "--sjs-primary-background-400", visible: false },
    { name: "--sjs-primary-background-10", visible: false },
    { name: "--sjs-secondary-background-25", visible: false },
    { name: "--sjs-secondary-background-10", visible: false },
    { name: "--sjs-special-haze", visible: false },
    { name: "--sjs-special-glow", visible: false },
]);


/***/ }),

/***/ "./src/creator-theme/creator-themes.ts":
/*!*********************************************!*\
  !*** ./src/creator-theme/creator-themes.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CreatorThemes: () => (/* binding */ CreatorThemes),
/* harmony export */   PredefinedCreatorThemes: () => (/* binding */ PredefinedCreatorThemes)
/* harmony export */ });
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _designTabSurveyThemeJSON__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../designTabSurveyThemeJSON */ "./src/designTabSurveyThemeJSON.ts");


var PredefinedCreatorThemes = ["sc2020"];
var sc2020CssVariables = {};
(0,_utils_utils__WEBPACK_IMPORTED_MODULE_0__.assign)(sc2020CssVariables, _designTabSurveyThemeJSON__WEBPACK_IMPORTED_MODULE_1__["default"].cssVariables, {
    "--sjs-special-background": "#F3F3F3FF",
    "--sjs-primary-background-500": "#19B394FF",
    "--sjs-primary-background-10": "#19B3941A",
    "--sjs-primary-background-400": "#14A48BFF",
    "--sjs-secondary-background-500": "#FF9814FF",
    "--sjs-secondary-background-25": "#FF981440",
    "--sjs-secondary-background-10": "#FF98141A",
    "--ctr-surface-background-color": "var(--sjs-special-background)",
    "--ctr-toolbox-background-color": "var(--sjs-special-background)",
});
var CreatorThemes = {
    "sc2020": {
        themeName: "sc2020",
        cssVariables: sc2020CssVariables,
        iconsSet: "v1"
    }
};


/***/ }),

/***/ "./src/custom-questions/question-color.ts":
/*!************************************************!*\
  !*** ./src/custom-questions/question-color.ts ***!
  \************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionColorModel: () => (/* binding */ QuestionColorModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");



var DEFAULT_COLOR = "#000000";
var DEFAULT_SWATCH_COLOR = "#FFFFFF";
var QuestionColorModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionColorModel, _super);
    function QuestionColorModel(name) {
        var _this = _super.call(this, name) || this;
        _this.allowEmptyValue = false;
        _this.createItemValues("choices");
        _this.registerFunctionOnPropertyValueChanged("choices", function () {
            _this.updateChoices();
        });
        return _this;
    }
    QuestionColorModel.prototype.getCorrectedValue = function (newValue) {
        if (newValue == undefined || newValue == null || (this.allowEmptyValue && !newValue))
            return newValue;
        newValue = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__.parseColor)(newValue !== null && newValue !== void 0 ? newValue : "").color;
        if (newValue.indexOf("#") < 0) {
            newValue = "#" + newValue;
        }
        newValue = (newValue.match(/#([0-9a-fA-F]){1,6}/) || [DEFAULT_COLOR])[0];
        if (newValue.length === 4) {
            var value = newValue.slice(0, 1);
            for (var i = 1; i < 4; i++) {
                value += newValue[i] + newValue[i];
            }
            newValue = value;
        }
        if (newValue.length < 7) {
            var length_1 = newValue.length;
            for (var i = 0; i < 7 - length_1; i++) {
                newValue += "0";
            }
        }
        return newValue;
    };
    QuestionColorModel.prototype.isNewValueEqualsToValue = function (newValue) {
        if (_super.prototype.isNewValueEqualsToValue.call(this, newValue) || this.isTwoValueEquals(newValue, this.value, true, true))
            return true;
        else
            return false;
    };
    QuestionColorModel.prototype.setNewValue = function (newValue) {
        this.resetRenderedValue();
        _super.prototype.setNewValue.call(this, this.getCorrectedValue(newValue));
        this.updateRenderedValue();
    };
    QuestionColorModel.prototype.onBeforeInput = function (event) {
        if (!!event.data && !/[\d\w(),#]/.test(event.data)) {
            event.preventDefault();
        }
    };
    QuestionColorModel.prototype.onColorInputChange = function (event) {
        this.value = event.target.value;
    };
    QuestionColorModel.prototype.getType = function () {
        return "color";
    };
    QuestionColorModel.prototype.resetRenderedValue = function () {
        this._renderedValue = undefined;
    };
    QuestionColorModel.prototype.updateRenderedValue = function () {
        if (this.value) {
            var color = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__.parseColor)(this.value || "");
            this._renderedValue = color.color;
        }
        else if (this.allowEmptyValue) {
            this._renderedValue = "";
        }
        else {
            this._renderedValue = DEFAULT_COLOR;
        }
    };
    Object.defineProperty(QuestionColorModel.prototype, "renderedValue", {
        get: function () {
            if (!this._renderedValue && this._renderedValue !== "") {
                this.updateRenderedValue();
            }
            return this._renderedValue.toUpperCase();
        },
        enumerable: false,
        configurable: true
    });
    QuestionColorModel.prototype.getSwatchCss = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append(this.cssClasses.swatch)
            .append(this.cssClasses.swatchDefault, !this.renderedValue)
            .append(this.cssClasses.swatchDisabled, this.isInputReadOnly)
            .toString();
    };
    QuestionColorModel.prototype.getSwatchStyle = function () {
        return { backgroundColor: this.renderedValue || DEFAULT_SWATCH_COLOR };
    };
    Object.defineProperty(QuestionColorModel.prototype, "renderedColorValue", {
        get: function () {
            return this.renderedValue || DEFAULT_SWATCH_COLOR;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionColorModel.prototype, "isInputTextUpdate", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    QuestionColorModel.prototype.onSurveyValueChanged = function (newValue) {
        _super.prototype.onSurveyValueChanged.call(this, newValue);
        this.updateRenderedValue();
    };
    Object.defineProperty(QuestionColorModel.prototype, "dropdownAction", {
        get: function () {
            if (!this._dropdownAction) {
                this._dropdownAction = this.createDropdownAction();
            }
            return this._dropdownAction;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionColorModel.prototype, "choices", {
        get: function () {
            return this.getPropertyValue("choices");
        },
        set: function (newValue) {
            this.setPropertyValue("choices", newValue);
        },
        enumerable: false,
        configurable: true
    });
    QuestionColorModel.prototype.onTextKeyDownHandler = function (event) {
        var popupModel = this.dropdownAction.popupModel;
        if (event.key === "ArrowDown") {
            this.dropdownAction.action();
        }
        if (!popupModel.isVisible) {
            _super.prototype.onTextKeyDownHandler.call(this, event);
        }
    };
    Object.defineProperty(QuestionColorModel.prototype, "showDropdownAction", {
        get: function () {
            return !this.isValueEmpty(this.choices);
        },
        enumerable: false,
        configurable: true
    });
    QuestionColorModel.prototype.createDropdownAction = function () {
        var _this = this;
        var action = (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.createDropdownActionModelAdvanced)({ enabled: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return !_this.isInputReadOnly; }) }, {
            onSelectionChanged: function (item) {
                _this.value = item.value;
            },
            items: this.choices
        }, {
            showPointer: false,
            verticalPosition: "bottom",
            horizontalPosition: "center",
            cssClass: "svc-creator-popup",
        });
        action.disableTabStop = true;
        var popupModel = action.popupModel;
        var listModel = popupModel.contentComponentData.model;
        popupModel.displayMode = survey_core__WEBPACK_IMPORTED_MODULE_1__.IsTouch ? "overlay" : "popup";
        popupModel.setWidthByTarget = true;
        popupModel.positionMode = "fixed";
        popupModel.getTargetCallback = undefined;
        listModel.isItemSelected = function (itemValue) { return itemValue.value == _this.value; };
        return action;
    };
    QuestionColorModel.prototype.calcCssClasses = function (css) {
        var classes = _super.prototype.calcCssClasses.call(this, css);
        var dropdownAction = this.dropdownAction;
        dropdownAction.cssClasses = { item: classes.colorDropdown };
        dropdownAction.iconName = classes.colorDropdownIcon;
        dropdownAction.iconSize = "auto";
        var listModel = dropdownAction.popupModel.contentComponentData.model;
        listModel.cssClasses = {};
        listModel.cssClasses = {
            itemBody: listModel.cssClasses.itemBody + " " + classes.colorItem
        };
        return classes;
    };
    QuestionColorModel.prototype.updateChoices = function () {
        this.dropdownAction.popupModel.contentComponentData.model.setItems(this.choices);
    };
    Object.defineProperty(QuestionColorModel.prototype, "itemComponent", {
        get: function () {
            return "color-item";
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionColorModel.prototype, "allowEmptyValue", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionColorModel.prototype, "_renderedValue", void 0);
    return QuestionColorModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionTextModel));

survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addClass("color", [
    {
        name: "allowEmptyValue:boolean",
        default: false
    },
    "choices:itemvalue[]"
], function () { return new QuestionColorModel(""); }, "text");
survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionFactory.Instance.registerQuestion("color", function (name) {
    return new QuestionColorModel(name);
}, false);


/***/ }),

/***/ "./src/custom-questions/question-file.ts":
/*!***********************************************!*\
  !*** ./src/custom-questions/question-file.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionFileEditorModel: () => (/* binding */ QuestionFileEditorModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


var QuestionFileEditorModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionFileEditorModel, _super);
    function QuestionFileEditorModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._renderedValue = "";
        _this.notEmptyValuePlaceholder = "";
        _this.onKeyDown = function (event) {
            if (event.target.tagName === "INPUT") {
                _this.onTextKeyDownHandler(event);
            }
        };
        _this.onFileInputChange = function (event) {
            if (!_this.onChooseFilesCallback) {
                _this.doChange(event);
                return true;
            }
        };
        return _this;
    }
    QuestionFileEditorModel.prototype.onChangeQuestionValue = function (newValue) { };
    QuestionFileEditorModel.prototype.setNewValue = function (newValue) {
        if (typeof newValue === "object") {
            this.stateChanged(this.isEmpty() ? "empty" : "loaded");
            if (!this.isLoadingFromJson) {
                this.loadPreview(newValue);
            }
            this.loadedFilesValue = newValue;
            newValue = this.previewValue[0].content;
        }
        this.updateRenderedValue(newValue);
        _super.prototype.setNewValue.call(this, newValue);
    };
    QuestionFileEditorModel.prototype.loadPreview = function (newValue) {
        if (typeof newValue !== "string") {
            _super.prototype.loadPreview.call(this, newValue);
        }
    };
    Object.defineProperty(QuestionFileEditorModel.prototype, "allowMultiple", {
        get: function () {
            return false;
        },
        set: function (val) { },
        enumerable: false,
        configurable: true
    });
    QuestionFileEditorModel.prototype.clear = function (doneCallback, shouldClearValue) {
        var _this = this;
        if (shouldClearValue === void 0) { shouldClearValue = true; }
        if (!this.survey)
            return;
        var callback = function () {
            if (shouldClearValue) {
                _this.value = undefined;
            }
            _this.errors = [];
            !!doneCallback && doneCallback();
        };
        if (!!this.loadedFilesValue) {
            this.containsMultiplyFiles = false;
            this.survey.clearFiles(this.loadedFilesValue, this.name, this.previewValue, null, function (status, data) {
                if (status === "success") {
                    callback();
                }
            });
        }
        else {
            callback();
        }
    };
    Object.defineProperty(QuestionFileEditorModel.prototype, "renderedPlaceholder", {
        get: function () {
            return this.notEmptyValuePlaceholder || this.placeholder;
        },
        enumerable: false,
        configurable: true
    });
    QuestionFileEditorModel.prototype.updateRenderedValue = function (value) {
        var matchBase64 = !!value ? value.match(/^data:((?:\w+\/(?:(?!;).)+)?)((?:;[\w\W]*?[^;])*),/) : null;
        if (matchBase64) {
            this.notEmptyValuePlaceholder = matchBase64[0] + "...";
            this._renderedValue = "";
        }
        else {
            this.notEmptyValuePlaceholder = "";
            this._renderedValue = value;
        }
    };
    Object.defineProperty(QuestionFileEditorModel.prototype, "renderedValue", {
        get: function () {
            return this._renderedValue;
        },
        enumerable: false,
        configurable: true
    });
    QuestionFileEditorModel.prototype.updateValueFromInputEvent = function (event) {
        var value = event.target.value;
        if (!!this.notEmptyValuePlaceholder && !value)
            return;
        if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isTwoValueEquals(value, this.value)) {
            this.clear(undefined, false);
            this.loadedFilesValue = undefined;
            this.value = event.target.value;
        }
    };
    QuestionFileEditorModel.prototype.onSurveyValueChanged = function (newValue) {
        _super.prototype.onSurveyValueChanged.call(this, newValue);
        this.updateRenderedValue(newValue);
    };
    QuestionFileEditorModel.prototype.onInputChange = function (event) {
        if (event.target !== document.activeElement) {
            this.updateValueFromInputEvent(event);
        }
    };
    QuestionFileEditorModel.prototype.onInputBlur = function (event) {
        this.updateValueFromInputEvent(event);
    };
    QuestionFileEditorModel.prototype.getType = function () {
        return "fileedit";
    };
    QuestionFileEditorModel.prototype.getIsClearButtonDisabled = function () {
        return !this.value || this.isInputReadOnly;
    };
    QuestionFileEditorModel.prototype.getChooseButtonCss = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder().append(this.cssClasses.chooseButton).append(this.cssClasses.chooseButtonDisabled, this.isInputReadOnly).toString();
    };
    QuestionFileEditorModel.prototype.chooseFiles = function (event) {
        var _this = this;
        if (this.isInputReadOnly || !this.onChooseFilesCallback) {
            return true;
        }
        else {
            event.preventDefault();
            event.stopPropagation();
            var input = this["rootElement"].querySelectorAll("input[type='file']")[0];
            this.onChooseFilesCallback(input, function (files) {
                _this.loadFiles(files);
            });
        }
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionFileEditorModel.prototype, "_renderedValue", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionFileEditorModel.prototype, "notEmptyValuePlaceholder", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionFileEditorModel.prototype, "placeholder", void 0);
    return QuestionFileEditorModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionFileModel));

survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addClass("fileedit", ["placeholder:string"], function () { return new QuestionFileEditorModel(""); }, "file");
survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionFactory.Instance.registerQuestion("fileedit", function (name) {
    return new QuestionFileEditorModel(name);
}, false);


/***/ }),

/***/ "./src/custom-questions/question-spin-editor.ts":
/*!******************************************************!*\
  !*** ./src/custom-questions/question-spin-editor.ts ***!
  \******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionSpinEditorModel: () => (/* binding */ QuestionSpinEditorModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


var QuestionSpinEditorModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionSpinEditorModel, _super);
    function QuestionSpinEditorModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._showUnitsInEditor = true;
        _this.onUpButtonMouseDown = function () {
            _this.increase();
            _this.increaseTimer = setTimeout(_this.onUpButtonMouseDown, 200);
        };
        _this.onDownButtonMouseDown = function () {
            _this.decrease();
            _this.decreaseTimer = setTimeout(_this.onDownButtonMouseDown, 200);
        };
        _this.onButtonMouseLeave = function () {
            _this.onButtonMouseUp();
        };
        _this.onButtonMouseUp = function () {
            clearTimeout(_this.decreaseTimer);
            clearTimeout(_this.increaseTimer);
        };
        _this.onKeyDown = function (event) {
            switch (event.key) {
                case "ArrowUp":
                    _this.increase();
                    event.stopPropagation();
                    event.preventDefault();
                    break;
                case "ArrowDown":
                    _this.decrease();
                    event.stopPropagation();
                    event.preventDefault();
                    break;
            }
            _this.onTextKeyDownHandler(event);
        };
        _this.onInputKeyDown = function (event) {
            if (event.key == "ArrowUp" || event.key == "ArrowDown")
                _this["updateValueOnEvent"](event);
        };
        _this.onFocus = function (event) {
            if (event.target.tagName == "INPUT") {
                queueMicrotask(function () {
                    var inputElement = event.target;
                    var selectStart = inputElement.selectionStart;
                    var selectEnd = inputElement.selectionEnd;
                    var selectDirection = inputElement.selectionDirection;
                    _this._showUnitsInEditor = false;
                    queueMicrotask(function () {
                        if (Math.abs(selectEnd - selectStart) > 0) {
                            inputElement.setSelectionRange(0, _this.renderedValue.length, selectDirection);
                        }
                        else {
                            inputElement.setSelectionRange(_this.renderedValue.length, _this.renderedValue.length);
                        }
                    });
                });
            }
        };
        _this.onBlur = function (event) {
            _this._showUnitsInEditor = true;
            if (event.target.tagName == "INPUT") {
                _this["updateValueOnEvent"](event);
            }
        };
        return _this;
    }
    QuestionSpinEditorModel.prototype.parseValue = function (val) {
        var value = parseFloat(val.toString());
        var unit = val.toString().replace(/[^A-Za-z]/g, "");
        return { value: value, unit: unit };
    };
    QuestionSpinEditorModel.prototype.changeValue = function (increase) {
        var parsedValue = this.parseValue(this.renderedValue);
        var step = Number(this.renderedStep || 1);
        var result = parsedValue.value;
        if (increase) {
            result += step;
        }
        else {
            result -= step;
        }
        this.value = result;
    };
    Object.defineProperty(QuestionSpinEditorModel.prototype, "showUnitsInEditor", {
        get: function () {
            return !!this.unit && this._showUnitsInEditor;
        },
        enumerable: false,
        configurable: true
    });
    QuestionSpinEditorModel.prototype.correctValue = function (newValue) {
        if (newValue == undefined || newValue == null)
            return newValue;
        var renderedMax = Number(this.renderedMax);
        var renderedMin = Number(this.renderedMin);
        newValue = typeof newValue === "string" ? parseFloat(newValue) : newValue;
        if (isNaN(newValue)) {
            newValue = isNaN(renderedMin) ? 0 : renderedMin;
        }
        else if (newValue > renderedMax) {
            newValue = renderedMax;
        }
        else if (newValue < renderedMin) {
            newValue = renderedMin;
        }
        newValue = Math.round(newValue * 1000) / 1000;
        return newValue;
    };
    QuestionSpinEditorModel.prototype.setNewValue = function (newValue) {
        _super.prototype.setNewValue.call(this, this.correctValue(newValue));
    };
    Object.defineProperty(QuestionSpinEditorModel.prototype, "renderedValue", {
        get: function () {
            var _a, _b;
            var renderedValue = ((_b = (_a = this.value) !== null && _a !== void 0 ? _a : this.renderedMin) !== null && _b !== void 0 ? _b : 0).toString();
            if (this.showUnitsInEditor) {
                renderedValue += this.unit;
            }
            return renderedValue;
        },
        enumerable: false,
        configurable: true
    });
    QuestionSpinEditorModel.prototype.increase = function () {
        this.changeValue(true);
    };
    QuestionSpinEditorModel.prototype.decrease = function () {
        this.changeValue(false);
    };
    QuestionSpinEditorModel.prototype.onBeforeInput = function (event) {
        var target = event.target;
        var regex = target.selectionStart == 0 ? /[\d.-]/ : /[\d.]/;
        if (!!event.data && !regex.test(event.data)) {
            event.preventDefault();
        }
    };
    QuestionSpinEditorModel.prototype.getType = function () {
        return "spinedit";
    };
    Object.defineProperty(QuestionSpinEditorModel.prototype, "isInputTextUpdate", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionSpinEditorModel.prototype, "unit", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionSpinEditorModel.prototype, "_showUnitsInEditor", void 0);
    return QuestionSpinEditorModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionTextModel));

survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addClass("spinedit", [
    "unit"
], function () { return new QuestionSpinEditorModel(""); }, "text");
survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionFactory.Instance.registerQuestion("spinedit", function (name) {
    return new QuestionSpinEditorModel(name);
}, false);


/***/ }),

/***/ "./src/custom-questions/question-text-with-reset.ts":
/*!**********************************************************!*\
  !*** ./src/custom-questions/question-text-with-reset.ts ***!
  \**********************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionCommentWithResetModel: () => (/* binding */ QuestionCommentWithResetModel),
/* harmony export */   QuestionTextWithResetModel: () => (/* binding */ QuestionTextWithResetModel),
/* harmony export */   ResetValueAdorner: () => (/* binding */ ResetValueAdorner)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


var ResetValueAdorner = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(ResetValueAdorner, _super);
    function ResetValueAdorner(question) {
        var _this = _super.call(this) || this;
        _this.question = question;
        return _this;
    }
    ResetValueAdorner.prototype.resetValue = function () {
        if (this.resetValueCallback) {
            this.resetValueCallback();
        }
    };
    Object.defineProperty(ResetValueAdorner.prototype, "isDisabled", {
        get: function () {
            return this.question.isInputReadOnly || !this.allowResetValue;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ResetValueAdorner.prototype, "allowResetValue", void 0);
    return ResetValueAdorner;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));

var QuestionTextWithResetModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionTextWithResetModel, _super);
    function QuestionTextWithResetModel(name) {
        var _this = _super.call(this, name) || this;
        _this.resetValueAdorner = _this.createResetValueAdorner();
        return _this;
    }
    QuestionTextWithResetModel.prototype.createResetValueAdorner = function () {
        return new ResetValueAdorner(this);
    };
    QuestionTextWithResetModel.prototype.getType = function () {
        return "textwithreset";
    };
    QuestionTextWithResetModel.prototype.getRootClass = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append(this.cssClasses.root)
            .append(this.cssClasses.onError, this.errors.length > 0)
            .toString();
    };
    QuestionTextWithResetModel.prototype.getControlClass = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append(this.cssClasses.control)
            .toString();
    };
    Object.defineProperty(QuestionTextWithResetModel.prototype, "wrappedQuestionTemplate", {
        get: function () {
            return "text";
        },
        enumerable: false,
        configurable: true
    });
    return QuestionTextWithResetModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionTextModel));

survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addClass("textwithreset", [], function () { return new QuestionTextWithResetModel(""); }, "text");
survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionFactory.Instance.registerQuestion("textwithreset", function (name) {
    return new QuestionTextWithResetModel(name);
}, false);
var QuestionCommentWithResetModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionCommentWithResetModel, _super);
    function QuestionCommentWithResetModel(name) {
        var _this = _super.call(this, name) || this;
        _this.resetValueAdorner = _this.createResetValueAdorner();
        return _this;
    }
    QuestionCommentWithResetModel.prototype.createResetValueAdorner = function () {
        return new ResetValueAdorner(this);
    };
    QuestionCommentWithResetModel.prototype.getType = function () {
        return "commentwithreset";
    };
    QuestionCommentWithResetModel.prototype.getCssType = function () {
        return "textwithreset";
    };
    QuestionCommentWithResetModel.prototype.getRootClass = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append(this.cssClasses.root)
            .append(this.cssClasses.rootMultiline)
            .append(this.cssClasses.onError, this.errors.length > 0)
            .toString();
    };
    QuestionCommentWithResetModel.prototype.getControlClass = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append(this.cssClasses.control)
            .append(this.cssClasses.controlMultiline)
            .toString();
    };
    Object.defineProperty(QuestionCommentWithResetModel.prototype, "wrappedQuestionTemplate", {
        get: function () {
            return "comment";
        },
        enumerable: false,
        configurable: true
    });
    return QuestionCommentWithResetModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionCommentModel));

survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addClass("commentwithreset", [{ name: "allowResize:boolean", default: false }], function () { return new QuestionCommentWithResetModel(""); }, "comment");
survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionFactory.Instance.registerQuestion("commentwithreset", function (name) {
    return new QuestionCommentWithResetModel(name);
}, false);


/***/ }),

/***/ "./src/designTabSurveyThemeJSON.ts":
/*!*****************************************!*\
  !*** ./src/designTabSurveyThemeJSON.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
var designTabSurveyThemeJSON = {
    "cssVariables": {
        "--sjs-primary-backcolor": "var(--sjs-primary-background-500)",
        "--sjs-primary-backcolor-light": "var(--sjs-primary-background-10)",
        "--sjs-primary-backcolor-dark": "var(--sjs-primary-background-400)",
        "--sjs-primary-forecolor": "var(--sjs-primary-foreground-100)",
        "--sjs-primary-forecolor-light": "var(--sjs-primary-foreground-25)",
        "--sjs-secondary-backcolor": "var(--sjs-secondary-background-500)",
        "--sjs-secondary-backcolor-light": "var(--sjs-secondary-background-10)",
        "--sjs-secondary-backcolor-semi-light": "var(--sjs-secondary-background-25)",
        "--sjs-secondary-forecolor": "var(--sjs-secondary-foreground-100)",
        "--sjs-secondary-forecolor-light": "var(--sjs-secondary-forecolor-25)",
        "--sjs-general-backcolor": "var(--sjs-layer-1-background-500)",
        "--sjs-general-backcolor-dark": "var(--sjs-layer-1-background-400)",
        "--sjs-general-forecolor": "var(--sjs-layer-1-foreground-100)",
        "--sjs-general-forecolor-light": "var(--sjs-layer-1-foreground-50)",
        "--sjs-general-backcolor-dim": "var(--sjs-layer-3-background-500)",
        "--sjs-general-dim-forecolor": "var(--sjs-layer-3-foreground-100)",
        "--sjs-general-dim-forecolor-light": "var(--sjs-layer-3-foreground-50)",
        "--sjs-general-backcolor-dim-light": "var(--sjs-layer-2-background-500)",
        "--sjs-general-backcolor-dim-dark": "var(--sjs-layer-2-background-400)",
        "--sjs-border-default": "var(--sjs-border-25)",
        "--sjs-border-light": "var(--sjs-border-10)",
        "--sjs-border-inside": "var(--sjs-border-25)",
        "--sjs-special-red": "var(--sjs-semantic-red-background-500)",
        "--sjs-special-red-light": "var(--sjs-semantic-red-background-10)",
        "--sjs-special-red-forecolor": "var(--sjs-semantic-red-foreground-100)",
        "--sjs-special-green": "var(--sjs-semantic-green-background-500)",
        "--sjs-special-green-light": "var(--sjs-semantic-green-background-10)",
        "--sjs-special-green-forecolor": "var(--sjs-semantic-green-foreground-100)",
        "--sjs-special-blue": "var(--sjs-semantic-blue-background-500)",
        "--sjs-special-blue-light": "var(--sjs-semantic-blue-background-10)",
        "--sjs-special-blue-forecolor": "var(--sjs-semantic-blue-foreground-100)",
        "--sjs-special-yellow": "var(--sjs-semantic-yellow-background-500)",
        "--sjs-special-yellow-light": "var(--sjs-semantic-yellow-background-10)",
        "--sjs-special-yellow-forecolor": "var(--sjs-semantic-yellow-foreground-100)",
        "--sjs-special-white": "var(--sjs-semantic-white-background-500)",
        "--sjs-general-haze-background": "var(--sjs-special-haze)",
        "--sjs-shadow-large-offset-x": "var(--lbr-shadow-large-offset-x)",
        "--sjs-shadow-large-offset-y": "var(--lbr-shadow-large-offset-y)",
        "--sjs-shadow-large-blur": "var(--lbr-shadow-large-blur)",
        "--sjs-shadow-large-spread": "var(--lbr-shadow-large-spread)",
        "--sjs-shadow-large-color": "var(--lbr-shadow-large-color)",
        "--sjs-shadow-medium-offset-x": "var(--lbr-shadow-medium-offset-x)",
        "--sjs-shadow-medium-offset-y": "var(--lbr-shadow-medium-offset-y)",
        "--sjs-shadow-medium-blur": "var(--lbr-shadow-medium-blur)",
        "--sjs-shadow-medium-spread": "var(--lbr-shadow-medium-spread)",
        "--sjs-shadow-medium-color": "var(--lbr-shadow-medium-color)",
        "--sjs-shadow-small-offset-x": "var(--lbr-shadow-small-offset-x)",
        "--sjs-shadow-small-offset-y": "var(--lbr-shadow-small-offset-y)",
        "--sjs-shadow-small-blur": "var(--lbr-shadow-small-blur)",
        "--sjs-shadow-small-spread": "var(--lbr-shadow-small-spread)",
        "--sjs-shadow-small-color": "var(--lbr-shadow-small-color)",
        "--sjs-shadow-inner-offset-x": "var(--lbr-shadow-inner-offset-x)",
        "--sjs-shadow-inner-offset-y": "var(--lbr-shadow-inner-offset-y)",
        "--sjs-shadow-inner-blur": "var(--lbr-shadow-inner-blur)",
        "--sjs-shadow-inner-spread": "var(--lbr-shadow-inner-spread)",
        "--sjs-shadow-inner-color": "var(--lbr-shadow-inner-color)",
    }
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (designTabSurveyThemeJSON);


/***/ }),

/***/ "./src/editable-object.ts":
/*!********************************!*\
  !*** ./src/editable-object.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EditableObject: () => (/* binding */ EditableObject)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);

var EditableObject = /** @class */ (function () {
    function EditableObject(obj) {
        this.objValue = obj;
        this.editableObjValue = this.createEditableObj();
    }
    EditableObject.isCopyObject = function (obj) {
        return !!obj && obj["isCopy"];
    };
    EditableObject.getSurvey = function (object) {
        if (object instanceof survey_core__WEBPACK_IMPORTED_MODULE_0__.SurveyModel ||
            (!!object && !!object.getType && object.getType() == "survey")) {
            return EditableObject.getOriginalSurvey(object);
        }
        if (object instanceof survey_core__WEBPACK_IMPORTED_MODULE_0__.MatrixDropdownColumn && !!object.colOwner)
            return object.colOwner["survey"];
        if (!!object) {
            if (!!object.survey)
                return EditableObject.getOriginalSurvey(object.survey);
            if (!!object.owner)
                return EditableObject.getSurvey(object.owner);
            if (!!object.errorOwner)
                return EditableObject.getSurvey(object.errorOwner);
            if (!!object.locOwner)
                return EditableObject.getSurvey(object.locOwner);
        }
        var original = EditableObject.getOriginalObject(object);
        if (!!original && original !== object)
            return EditableObject.getSurvey(original);
        return null;
    };
    EditableObject.getOriginalObject = function (object) {
        return !!object && !!object["originalObj"] ? object["originalObj"] : object;
    };
    EditableObject.getOriginalSurvey = function (survey) {
        return EditableObject.getOriginalObject(survey);
    };
    Object.defineProperty(EditableObject.prototype, "obj", {
        get: function () {
            return this.objValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EditableObject.prototype, "editableObj", {
        get: function () {
            return this.editableObjValue;
        },
        enumerable: false,
        configurable: true
    });
    EditableObject.prototype.isPropertyChanged = function (propertyName) {
        if (propertyName == "pages")
            return false; //TODO could not find a better way yet
        return !survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.isTwoValueEquals(this.obj[propertyName], this.editableObj[propertyName]);
    };
    EditableObject.prototype.apply = function (propertyName) {
        if (!this.isPropertyChanged(propertyName))
            return;
        this.obj[propertyName] = this.editableObj[propertyName];
    };
    EditableObject.prototype.reset = function () {
        this.assignProperties(this.editableObj);
    };
    EditableObject.prototype.applyAll = function (excludedProps) {
        if (excludedProps === void 0) { excludedProps = []; }
        var props = this.getProperties(excludedProps);
        for (var i = 0; i < props.length; i++) {
            this.apply(props[i]);
        }
    };
    EditableObject.prototype.getProperties = function (excludedProps) {
        var props = [];
        var newJSON = this.getObjJson(this.editableObj);
        var oldJSON = this.getObjJson(this.obj);
        for (var key in newJSON) {
            if (excludedProps.indexOf(key) > -1)
                continue;
            props.push(key);
        }
        for (var key in oldJSON) {
            if (excludedProps.indexOf(key) > -1 || props.indexOf(key) > -1)
                continue;
            props.push(key);
        }
        return props;
    };
    EditableObject.prototype.createEditableObj = function () {
        var type = this.obj.getType();
        var res = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.createClass(type);
        if (res == null && type == "survey") {
            res = new survey_core__WEBPACK_IMPORTED_MODULE_0__.SurveyModel(); // TODO: Create Survey via platform Provider/Factory
        }
        this.assignProperties(res);
        if (type == "matrixdropdowncolumn") {
            res["colOwner"] = this.obj["colOwner"];
        }
        if (type != "survey") {
            if (!!res["setSurveyImpl"]) {
                res["setSurveyImpl"](this.obj["survey"]);
            }
            else {
                if (!!this.obj["survey"] && !res["survey"]) {
                    res["survey"] = this.obj["survey"];
                }
            }
        }
        if (!!this.obj["parent"]) {
            res["parent"] = this.obj["parent"];
        }
        res["isCopy"] = true;
        res["originalObj"] = this.obj;
        return res;
    };
    EditableObject.prototype.assignProperties = function (obj) {
        new survey_core__WEBPACK_IMPORTED_MODULE_0__.JsonObject().toObject(this.getObjJson(), obj);
    };
    EditableObject.prototype.getObjJson = function (obj) {
        if (obj === void 0) { obj = null; }
        if (!obj)
            obj = this.obj;
        var jsonObj = new survey_core__WEBPACK_IMPORTED_MODULE_0__.JsonObject();
        jsonObj.lightSerializing = true;
        return jsonObj.toJsonObject(obj);
    };
    return EditableObject;
}());



/***/ }),

/***/ "./src/editorLocalization.ts":
/*!***********************************!*\
  !*** ./src/editorLocalization.ts ***!
  \***********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   EditorLocalization: () => (/* binding */ EditorLocalization),
/* harmony export */   defaultStrings: () => (/* binding */ defaultStrings),
/* harmony export */   editorLocalization: () => (/* binding */ editorLocalization),
/* harmony export */   getLocString: () => (/* binding */ getLocString),
/* harmony export */   setupLocale: () => (/* binding */ setupLocale)
/* harmony export */ });
/* harmony import */ var _localization_english__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./localization/english */ "./src/localization/english.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_2__);



var renamedKeys = {};
renamedKeys["tabs.preview"] = "ed.testSurvey";
renamedKeys["tabs.theme"] = "ed.themeSurvey";
renamedKeys["tabs.translation"] = "ed.translation";
renamedKeys["tabs.designer"] = "ed.designer";
renamedKeys["tabs.editor"] = "ed.jsonEditor";
renamedKeys["tabs.logic"] = "ed.logic";
var EditorLocalization = /** @class */ (function () {
    function EditorLocalization() {
        this.defaultLocaleValue = "en";
        this.currentLocaleValue = "";
        this.camelCaseBreaking = true;
        this.locales = {};
        this.peByClass = {};
        this.peHelpByClass = {};
        this.pePlaceholderByClass = {};
    }
    EditorLocalization.prototype.reset = function () {
        this.peByClass = {};
        this.peHelpByClass = {};
        this.pePlaceholderByClass = {};
    };
    Object.defineProperty(EditorLocalization.prototype, "defaultLocale", {
        get: function () { return this.defaultLocaleValue; },
        set: function (val) {
            if (!val)
                val = "en";
            if (val !== this.defaultLocale) {
                this.defaultLocaleValue = val;
                this.reset();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EditorLocalization.prototype, "currentLocale", {
        get: function () { return this.currentLocaleValue; },
        set: function (val) {
            if (!val)
                val = "";
            if (val !== this.currentLocale) {
                this.currentLocaleValue = val;
                this.reset();
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(EditorLocalization.prototype, "presetStrings", {
        get: function () { return this.presetStringsValues; },
        set: function (val) {
            this.presetStringsValues = val;
            this.reset();
        },
        enumerable: false,
        configurable: true
    });
    EditorLocalization.prototype.getString = function (strName, locale) {
        if (locale === void 0) { locale = null; }
        var oldVal = this.getOldKeysString(strName, locale);
        if (!!oldVal)
            return oldVal;
        var path = strName.split(".");
        return this.getStringByPath(path, locale);
    };
    EditorLocalization.prototype.getStringByPath = function (path, locale) {
        if (locale === void 0) { locale = null; }
        if (!locale)
            locale = this.currentLocale;
        var loc = this.getLocale(locale);
        var defaultLocale = this.getDefaultStrings();
        var locs = [];
        if (!!loc)
            locs.push(loc);
        if (!!locale && locale.indexOf("-") > -1) {
            var baseLocale = this.getLocale(locale.substring(0, locale.indexOf("-")));
            if (!!baseLocale)
                locs.push(baseLocale);
        }
        if (locs.length === 0 || locs[locs.length - 1] !== defaultLocale) {
            locs.push(defaultLocale);
        }
        var presetLoc = this.getPresetLocale(locale);
        if (!!presetLoc) {
            locs.unshift(presetLoc);
        }
        for (var i = 0; i < locs.length; i++) {
            var res = this.getStringByLocale(path, locs[i]);
            if (!!res || res === "")
                return res;
        }
        return path[path.length - 1];
    };
    EditorLocalization.prototype.hasString = function (strName, locale) {
        if (locale === void 0) { locale = null; }
        return this.getStringByLocale(strName.split("."), this.getLocale(locale)) !== undefined;
    };
    EditorLocalization.prototype.getStringByLocale = function (path, loc) {
        var obj = loc;
        for (var i = 0; i < path.length; i++) {
            if (typeof obj === "string")
                return undefined;
            obj = obj[path[i]];
            if (!obj && obj !== "")
                return undefined;
        }
        return obj;
    };
    EditorLocalization.prototype.getLocaleName = function (loc, defaultLocale, inEnglish) {
        if (defaultLocale === void 0) { defaultLocale = null; }
        if (!defaultLocale) {
            defaultLocale = survey_core__WEBPACK_IMPORTED_MODULE_2__.surveyLocalization.defaultLocale;
        }
        var name = survey_core__WEBPACK_IMPORTED_MODULE_2__.surveyLocalization.getLocaleName(loc || defaultLocale, inEnglish);
        if (name === loc)
            return name;
        name = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__.capitalize)(name);
        if (!loc) {
            name = editorLocalization.getString("ed.defaultLocale")["format"](name);
        }
        return name || loc;
    };
    EditorLocalization.prototype.getPropertyName = function (strName, defaultName) {
        if (defaultName === void 0) { defaultName = null; }
        var obj = this.getProperty(strName, defaultName);
        var name = obj["name"];
        if (!!name) {
            if (this.stringsDiff(name, strName))
                return name;
            return this.getAutoPropertyName(name, defaultName);
        }
        return obj;
    };
    EditorLocalization.prototype.getPropertyTitle = function (strName) {
        var obj = this.getProperty(strName);
        if (obj["title"])
            return obj["title"];
        return "";
    };
    EditorLocalization.prototype.getPropertyNameInEditor = function (typeName, propName, defaultName) {
        if (defaultName === void 0) { defaultName = null; }
        var obj = this.getPropertyInfoInEditorByType(typeName, propName, this.peByClass, "pe");
        if (!obj) {
            obj = this.getStringByPath(["pe", propName]);
        }
        if (this.stringsDiff(obj, propName))
            return obj;
        return this.getPropertyName(propName, defaultName);
    };
    EditorLocalization.prototype.getPropertyHelpInEditor = function (typeName, propName, propType) {
        if (propType === void 0) { propType = undefined; }
        var res = this.getPropertyHelpInEditorCore(typeName, propName, this.peHelpByClass, "pehelp");
        if (!!res)
            return res;
        var loc = this.getLocale();
        return !!propType && !!loc && !!loc.pe ? loc.pe[propType + "Help"] : undefined;
    };
    EditorLocalization.prototype.getPropertyPlaceholder = function (typeName, propName) {
        var str = this.getPropertyHelpInEditorCore(typeName, propName, this.pePlaceholderByClass, "peplaceholder");
        if (!!str)
            return (str === " ") ? null : str;
        var loc = this.getLocale();
        if (!!loc && !!loc.peplaceholder) {
            str = loc.peplaceholder[propName];
        }
        if (!!str)
            return str;
        return !!loc && !!loc.pe ? loc.pe[propName + "_placeholder"] : undefined;
    };
    EditorLocalization.prototype.getPropertyHelpInEditorCore = function (typeName, propName, data, suffix) {
        var str = this.getPropertyInfoInEditorByType(typeName, propName, data, suffix);
        if (!!str)
            return (str === " ") ? null : str;
        var locs = this.getLocalesWithPreset();
        for (var i = 0; i < locs.length; i++) {
            var loc = locs[i];
            if (!!loc[suffix] && loc[suffix][propName])
                return loc[suffix][propName];
        }
        return undefined;
    };
    EditorLocalization.prototype.getPropertyInfoInEditorByType = function (typeName, propName, peInfoByClass, postFix) {
        if (!typeName)
            return undefined;
        var locs = this.getLocalesWithPreset();
        for (var i = 0; i < locs.length; i++) {
            var res = this.getPropertyInfoInEditorByTypeCore(typeName, propName, peInfoByClass, postFix, locs[i]);
            if (!!res)
                return res;
        }
        return undefined;
    };
    EditorLocalization.prototype.getPropertyInfoInEditorByTypeCore = function (typeName, propName, peInfoByClass, postFix, loc) {
        var peClass = peInfoByClass[typeName];
        if (peClass === undefined) {
            peClass = this.getObjInEditorByTypeCore(typeName, peInfoByClass, postFix, loc);
        }
        while (!!peClass) {
            var res = peClass.props[propName];
            if (!!res && typeof res !== "function")
                return peClass.props[propName];
            peClass = peClass.parent;
        }
        return undefined;
    };
    EditorLocalization.prototype.getObjInEditorByTypeCore = function (typeName, peInfoByClass, postFix, loc) {
        if (!typeName)
            return undefined;
        var peClass = peInfoByClass[typeName];
        if (peClass !== undefined)
            peClass;
        var pe = !!loc ? loc[postFix] : undefined;
        if (!pe)
            return undefined;
        var propIndex = typeName.indexOf("@");
        if (propIndex > -1) {
            var parentRes = this.getObjInEditorByTypeCore(typeName.substring(0, propIndex), peInfoByClass, postFix, loc);
            if (!pe[typeName]) {
                peInfoByClass[typeName] = parentRes;
                return parentRes;
            }
            var res_1 = { props: pe[typeName], parent: parentRes };
            peInfoByClass[typeName] = res_1;
            return res_1;
        }
        var classNames = [];
        var classInfo = survey_core__WEBPACK_IMPORTED_MODULE_2__.Serializer.findClass(typeName);
        var res = undefined;
        while (!!classInfo) {
            var tName = classInfo.name;
            res = peInfoByClass[typeName];
            if (!!res)
                break;
            classNames.push(tName);
            if (pe[tName]) {
                res = { props: pe[tName], parent: this.getObjInEditorByTypeCore(classInfo.parentName, peInfoByClass, postFix, loc) };
                break;
            }
            if (!classInfo.parentName)
                break;
            classInfo = survey_core__WEBPACK_IMPORTED_MODULE_2__.Serializer.findClass(classInfo.parentName);
        }
        for (var i = 0; i < classNames.length; i++) {
            peInfoByClass[classNames[i]] = res;
        }
        return res;
    };
    EditorLocalization.prototype.getProperty = function (strName, defaultName) {
        if (defaultName === void 0) { defaultName = null; }
        var obj = this.getStringByPath(["p", strName]);
        if (this.stringsDiff(obj, strName))
            return obj;
        var pos = (strName + "").indexOf("_");
        if (pos < -1)
            return this.getAutoPropertyName(obj, defaultName);
        strName = (strName + "").substring(pos + 1);
        obj = this.getStringByPath(["p", strName]);
        if (this.stringsDiff(obj, strName))
            return obj;
        return this.getAutoPropertyName(obj, defaultName);
    };
    EditorLocalization.prototype.convertToCamelCase = function (value, toLowCase) {
        if (toLowCase === void 0) { toLowCase = false; }
        if (!value)
            return value;
        value = value.trim();
        if (value.indexOf(" ") > -1)
            return value;
        var hasLowCase = false;
        for (var i = 0; i < value.length; i++) {
            if (value[i] !== value[i].toUpperCase()) {
                hasLowCase = true;
                break;
            }
        }
        if (!hasLowCase)
            return value;
        var res = value[0].toUpperCase();
        var isPrevUpperCase = false;
        var isUpperCase = function (index) {
            if (index >= value.length)
                return false;
            return value[index].toUpperCase() === value[index];
        };
        for (var i = 1; i < value.length; i++) {
            if (!isPrevUpperCase && isUpperCase(i)) {
                res += " ";
            }
            var requireConvert = !isPrevUpperCase && !isUpperCase(i + 1);
            res += requireConvert ? value[i].toLowerCase() : value[i];
            isPrevUpperCase = isUpperCase(i);
        }
        if (toLowCase) {
            res = res.toLowerCase();
        }
        return res;
    };
    EditorLocalization.prototype.getAutoPropertyName = function (propName, defaultName) {
        if (defaultName === void 0) { defaultName = null; }
        if (!!defaultName)
            return defaultName;
        if (!propName || !this.camelCaseBreaking)
            return propName;
        return this.convertToCamelCase(propName);
    };
    EditorLocalization.prototype.getPropertyValueInEditor = function (propName, value) {
        var loc = this.getLocale();
        if (!!loc && !!loc.pv && !!loc.pv[propName]) {
            var res = loc.pv[propName][value];
            if (!!res)
                return res;
        }
        return this.getPropertyValue(value);
    };
    EditorLocalization.prototype.getPropertyValue = function (value, locale) {
        if (locale === void 0) { locale = null; }
        return this.getValueInternal(value, "pv", locale);
    };
    EditorLocalization.prototype.getValidatorName = function (name, locale) {
        if (locale === void 0) { locale = null; }
        return this.getValueInternal(name, "validators", locale);
    };
    EditorLocalization.prototype.getTriggerName = function (name, locale) {
        if (locale === void 0) { locale = null; }
        return this.getValueInternal(name, "triggers", locale);
    };
    EditorLocalization.prototype.getLocale = function (locale) {
        if (!locale)
            locale = this.currentLocale;
        return (locale ? this.getLocaleStrings(locale) : this.getDefaultStrings()) || this.getDefaultStrings();
    };
    EditorLocalization.prototype.getLocaleStrings = function (loc) {
        return this.locales[loc];
    };
    EditorLocalization.prototype.setupLocale = function (loc, strings) {
        this.locales[loc] = strings;
    };
    EditorLocalization.prototype.getPresetLocale = function (locale) {
        if (!this.presetStrings)
            return undefined;
        var presetLoc = locale || this.currentLocale || this.defaultLocale;
        return this.presetStrings[presetLoc];
    };
    EditorLocalization.prototype.getLocalesWithPreset = function (locale) {
        var res = [];
        var presetLoc = this.getPresetLocale(locale);
        if (presetLoc) {
            res.push(presetLoc);
        }
        var loc = this.getLocale(locale);
        if (loc) {
            res.push(loc);
        }
        return res;
    };
    EditorLocalization.prototype.getValueInternal = function (value, prefix, locale) {
        if (locale === void 0) { locale = null; }
        if (!value || (value.indexOf && value.indexOf(".") > -1))
            return "";
        value = value.toString();
        var res = this.getString(prefix + "." + value, locale);
        if (!!res)
            return res;
        return this.camelCaseBreaking
            ? this.convertToCamelCase(value, false)
            : value;
    };
    EditorLocalization.prototype.getLocales = function () {
        var res = [];
        res.push("");
        for (var key in this.locales) {
            res.push(key);
        }
        return res;
    };
    EditorLocalization.prototype.getDefaultStrings = function () {
        var loc = this.defaultLocale;
        if (!!loc && loc !== "en") {
            var strs = this.getLocale(loc);
            if (!!strs)
                return strs;
        }
        return defaultStrings;
    };
    EditorLocalization.prototype.stringsDiff = function (str1, str2) {
        if (typeof str1 === "function" || typeof str2 === "function")
            return false;
        return str1 !== str2;
    };
    EditorLocalization.prototype.getOldKeysString = function (str, locale) {
        if (locale === void 0) { locale = null; }
        var reNamedVal = renamedKeys[str];
        if (!reNamedVal)
            return undefined;
        var path = reNamedVal.split(".");
        var res = this.getStringByPath(path, locale);
        return res !== path[path.length - 1] ? res : undefined;
    };
    return EditorLocalization;
}());

var editorLocalization = new EditorLocalization();
survey_core__WEBPACK_IMPORTED_MODULE_2__.surveyLocalization.onGetExternalString = function (name, locale) {
    var res = editorLocalization.getString(name, locale);
    return res !== name ? res : "";
};
function getLocString(strName, locale) {
    if (locale === void 0) { locale = null; }
    return editorLocalization.getString(strName, locale);
}
var defaultStrings = _localization_english__WEBPACK_IMPORTED_MODULE_0__.enStrings;
function setupLocale(localeConfig) {
    editorLocalization.setupLocale(localeConfig.localeCode, localeConfig.strings);
}


/***/ }),

/***/ "./src/entries/helpers.ts":
/*!********************************!*\
  !*** ./src/entries/helpers.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   __assign: () => (/* binding */ __assign),
/* harmony export */   __decorate: () => (/* binding */ __decorate),
/* harmony export */   __extends: () => (/* binding */ __extends),
/* harmony export */   __spreadArray: () => (/* binding */ __spreadArray),
/* harmony export */   __spreadArrays: () => (/* binding */ __spreadArrays)
/* harmony export */ });
var __decorate = function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3
        ? target
        : desc === null
            ? (desc = Object.getOwnPropertyDescriptor(target, key))
            : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function")
        r = Reflect.decorate(decorators, target, key, desc);
    else
        for (var i = decorators.length - 1; i >= 0; i--)
            if ((d = decorators[i]))
                r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __assign = Object["assign"] ||
    function (target) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s)
                if (Object.prototype.hasOwnProperty.call(s, p))
                    target[p] = s[p];
        }
        return target;
    };
function __extends(thisClass, baseClass) {
    for (var p in baseClass)
        if (baseClass.hasOwnProperty(p))
            thisClass[p] = baseClass[p];
    function __() {
        this.constructor = thisClass;
    }
    thisClass.prototype =
        baseClass === null
            ? Object.create(baseClass)
            : ((__.prototype = baseClass.prototype), new __());
}
var __spreadArrays = function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++)
        s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __spreadArray = function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};


/***/ }),

/***/ "./src/expand-collapse-manager.ts":
/*!****************************************!*\
  !*** ./src/expand-collapse-manager.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ExpandCollapseManager: () => (/* binding */ ExpandCollapseManager)
/* harmony export */ });
var ExpandCollapseManager = /** @class */ (function () {
    function ExpandCollapseManager(creator) {
        this.creator = creator;
        this._lockQuestions = false;
        this.adorners = [];
    }
    ExpandCollapseManager.prototype.expandCollapseElements = function (reason, isCollapsed, elements) {
        if (elements === void 0) { elements = null; }
        this.updateCollapsed(elements || this.getCollapsableElements(), isCollapsed, reason);
    };
    ExpandCollapseManager.prototype.lockQuestions = function (locked) {
        this._lockQuestions = locked;
    };
    ExpandCollapseManager.prototype.getCollapsableElements = function () {
        return this.creator.survey.pages
            .concat(this.creator.survey.getAllPanels())
            .concat(this.creator.survey.getAllQuestions());
    };
    ExpandCollapseManager.prototype.updateCollapsed = function (elements, value, reason) {
        var _this = this;
        var canToSaveToStateManager = this.creator.designerStateManager && !this.creator.designerStateManager.isSuspended;
        elements.forEach(function (element) {
            if (element.isQuestion && _this._lockQuestions)
                return;
            if (canToSaveToStateManager) {
                _this.creator.designerStateManager.getElementState(element).collapsed =
                    _this.creator.getElementExpandCollapseState(element, reason, value);
            }
        });
        for (var i = this.adorners.length - 1; i >= 0; i--) {
            var element = this.adorners[i].element;
            if (element.isQuestion && this._lockQuestions)
                continue;
            if (elements.indexOf(element) == -1)
                continue;
            if (this.adorners[i].allowExpandCollapse) {
                var newState = canToSaveToStateManager ?
                    this.creator.designerStateManager.getElementState(element).collapsed :
                    this.creator.getElementExpandCollapseState(element, reason, value);
                this.adorners[i].collapsed = newState;
            }
        }
    };
    ExpandCollapseManager.prototype.add = function (adorner) {
        this.adorners.push(adorner);
    };
    ExpandCollapseManager.prototype.remove = function (adorner) {
        this.adorners.splice(this.adorners.indexOf(adorner), 1);
    };
    ExpandCollapseManager.prototype.clear = function () {
        this.adorners.length = 0;
    };
    return ExpandCollapseManager;
}());



/***/ }),

/***/ "./src/expressionToDisplayText.ts":
/*!****************************************!*\
  !*** ./src/expressionToDisplayText.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ExpressionRemoveVariable: () => (/* binding */ ExpressionRemoveVariable),
/* harmony export */   ExpressionToDisplayText: () => (/* binding */ ExpressionToDisplayText)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");



var ExpressionToDisplayText = /** @class */ (function () {
    function ExpressionToDisplayText(survey, options) {
        if (options === void 0) { options = null; }
        this.survey = survey;
        this.options = options;
    }
    ExpressionToDisplayText.prototype.toDisplayText = function (expression) {
        if (!this.survey)
            return expression;
        this.showTitles =
            !!this.options && this.options.showTitlesInExpressions == true;
        var parser = new survey_core__WEBPACK_IMPORTED_MODULE_0__.ConditionsParser();
        var node = parser.parseExpression(expression);
        if (!node)
            return expression;
        if (!!node["getType"])
            return this.toDisplayTextCore(node);
        if (!this.showTitles)
            return expression;
        var variables = [];
        node.setVariables(variables);
        return this.replaceVariables(expression, variables);
    };
    ExpressionToDisplayText.prototype.toExpression = function (node) {
        return this.toDisplayTextCore(node);
    };
    ExpressionToDisplayText.prototype.toDisplayTextCore = function (node) {
        this.currentQuestion = null;
        var self = this;
        var isRoot = true;
        var strFunc = function (op) {
            var locIsRoot = isRoot;
            isRoot = false;
            if (self.showTitles && op.getType() == "variable") {
                return self.getQuestionText(op);
            }
            if (self.showTitles && op.getType() == "const") {
                return self.getDisplayText(op);
            }
            if (op.getType() == "binary") {
                self.proceedBinary(op);
                return self.getDisplayBinary(op, locIsRoot, strFunc);
            }
            if (op.getType() == "unary") {
                return self.getDisplayUnary(op, strFunc);
            }
            return undefined;
        };
        return node.toString(strFunc);
    };
    ExpressionToDisplayText.prototype.getQuestionText = function (op) {
        var question = this.getQuestionByName(op.variable);
        if (!question || !question.title)
            return op.variable;
        return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__.wrapTextByCurlyBraces)(question.title);
    };
    ExpressionToDisplayText.prototype.getDisplayText = function (op) {
        if (!this.currentQuestion)
            return undefined;
        var res = this.currentQuestion.getDisplayValue(true, op.correctValue);
        return !!res ? new survey_core__WEBPACK_IMPORTED_MODULE_0__.Const(res).toString() : undefined;
    };
    ExpressionToDisplayText.prototype.getDisplayOperand = function (op, func) {
        return !!op ? op.toString(func) : "";
    };
    ExpressionToDisplayText.prototype.getDisplayOperator = function (operator) {
        var res = ExpressionToDisplayText.operatorText[operator];
        if (!!res)
            return res;
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("op." + operator);
    };
    ExpressionToDisplayText.prototype.getDisplayBinary = function (op, isRoot, func) {
        return ((isRoot ? "" : "(") +
            this.getDisplayOperand(op.leftOperand, func) +
            " " +
            this.getDisplayOperator(op.operator) +
            " " +
            this.getDisplayOperand(op.rightOperand, func) +
            (isRoot ? "" : ")"));
    };
    ExpressionToDisplayText.prototype.getDisplayUnary = function (op, func) {
        var exp = op.expression.toString(func);
        var operator = this.getDisplayOperator(op.operator);
        if (op.operator == "empty" || op.operator == "notempty")
            return exp + " " + operator;
        return operator + " " + exp;
    };
    ExpressionToDisplayText.prototype.proceedBinary = function (op) {
        if (op.isArithmetic || op.isConjunction) {
            this.currentQuestion = null;
            return;
        }
        this.currentQuestion = this.getQuestionFromOperands(op.leftOperand, op.rightOperand);
        if (!this.currentQuestion) {
            this.currentQuestion = this.getQuestionFromOperands(op.rightOperand, op.leftOperand);
        }
    };
    ExpressionToDisplayText.prototype.getQuestionFromOperands = function (op1, op2) {
        if (!op1 || !op2)
            return null;
        if (op1.getType() != "variable")
            return null;
        var op2Type = op2.getType();
        if (op2Type != "const" && op2Type != "function" && op2Type != "array")
            return null;
        return this.getQuestionByName(op1.variable);
    };
    ExpressionToDisplayText.prototype.replaceVariables = function (expression, variables) {
        for (var i = 0; i < variables.length; i++) {
            expression = this.replaceVariable(expression, variables[i]);
        }
        return expression;
    };
    ExpressionToDisplayText.prototype.replaceVariable = function (expression, variable) {
        var question = this.getQuestionByName(variable);
        if (!question || !question.title)
            return expression;
        return expression.replace((0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__.wrapTextByCurlyBraces)(variable), (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__.wrapTextByCurlyBraces)(question.title));
    };
    ExpressionToDisplayText.prototype.getQuestionByName = function (name) {
        if (!this.survey)
            return null;
        return this.survey.getQuestionByValueName(name);
    };
    ExpressionToDisplayText.operatorText = {
        less: "<",
        lessorequal: "<=",
        greater: ">",
        greaterorequal: ">=",
        equal: "==",
        notequal: "!=",
        plus: "+",
        minus: "-",
        mul: "*",
        div: "/",
        power: "^",
        mod: "%",
        negate: "!",
    };
    return ExpressionToDisplayText;
}());

var ExpressionRemoveVariable = /** @class */ (function () {
    function ExpressionRemoveVariable() {
    }
    ExpressionRemoveVariable.prototype.remove = function (expression, variable) {
        var parser = new survey_core__WEBPACK_IMPORTED_MODULE_0__.ConditionsParser();
        var node = parser.parseExpression(expression);
        if (!node)
            return expression;
        this.wasRemoved = false;
        if (!!node["getType"]) {
            var op = this.processOperand(node, variable);
            if (!this.wasRemoved)
                return expression;
            return !!op ? op.toString() : "";
        }
        return expression;
    };
    ExpressionRemoveVariable.prototype.processOperand = function (op, variable) {
        if (!op)
            return null;
        if (op.getType() == "variable") {
            return this.processVariable(op, variable);
        }
        if (op.getType() == "unary") {
            return this.processUnary(op, variable);
        }
        if (op.getType() == "binary") {
            return this.proceedBinary(op, variable);
        }
        return op;
    };
    ExpressionRemoveVariable.prototype.processVariable = function (op, variable) {
        if (op.variable !== variable)
            return op;
        this.wasRemoved = true;
        return null;
    };
    ExpressionRemoveVariable.prototype.processUnary = function (op, variable) {
        var expression = this.processOperand(op.expression, variable);
        if (!!expression)
            return op;
        this.wasRemoved = true;
        return null;
    };
    ExpressionRemoveVariable.prototype.proceedBinary = function (op, variable) {
        var left = this.processOperand(op.leftOperand, variable);
        var right = this.processOperand(op.rightOperand, variable);
        if (!!left && !!right) {
            if (left !== op.leftOperand || right !== op.rightOperand)
                return new survey_core__WEBPACK_IMPORTED_MODULE_0__.BinaryOperand(op.operator, left, right, op.isArithmetic);
            return op;
        }
        if (!left && !right)
            return null;
        var res = !!left ? left : right;
        return res.getType() == "binary" ? res : null;
    };
    return ExpressionRemoveVariable;
}());



/***/ }),

/***/ "./src/json5.ts":
/*!**********************!*\
  !*** ./src/json5.ts ***!
  \**********************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SurveyJSON5: () => (/* binding */ SurveyJSON5)
/* harmony export */ });
// This file is based on JSON5, http://json5.org/
// The modification for getting object and properties location 'at' were maden.
var SurveyJSON5 = /** @class */ (function () {
    function SurveyJSON5(parseType) {
        if (parseType === void 0) { parseType = 0; }
        this.parseType = parseType;
    }
    SurveyJSON5.prototype.parse = function (source, reviver, startFrom, endAt) {
        if (reviver === void 0) { reviver = null; }
        if (startFrom === void 0) { startFrom = 0; }
        if (endAt === void 0) { endAt = -1; }
        var result;
        this.text = String(source);
        this.at = startFrom;
        this.endAt = endAt;
        this.ch = " ";
        result = this.value();
        this.white();
        if (this.ch) {
            this.error("Syntax error");
        }
        // If there is a reviver function, we recursively walk the new structure,
        // passing each name/value pair to the reviver function for possible
        // transformation, starting with a temporary root object that holds the result
        // in an empty key. If there is not a reviver function, we simply return the
        // result.
        return typeof reviver === "function"
            ? (function walk(holder, key) {
                var k, v, value = holder[key];
                if (value && typeof value === "object") {
                    for (k in value) {
                        if (Object.prototype.hasOwnProperty.call(value, k)) {
                            v = walk(value, k);
                            if (v !== undefined) {
                                value[k] = v;
                            }
                            else {
                                delete value[k];
                            }
                        }
                    }
                }
                return reviver.call(holder, key, value);
            })({ "": result }, "")
            : result;
    };
    SurveyJSON5.prototype.error = function (m) {
        // Call error when something is wrong.
        var error = new SyntaxError();
        error.message = m;
        error["at"] = this.at;
        throw error;
    };
    SurveyJSON5.prototype.next = function (c) {
        if (c === void 0) { c = null; }
        // If a c parameter is provided, verify that it matches the current character.
        if (c && c !== this.ch) {
            this.error("Expected '" + c + "' instead of '" + this.ch + "'");
        }
        // Get the this.next character. When there are no more characters,
        // return the empty string.
        this.ch = this.chartAt();
        this.at += 1;
        return this.ch;
    };
    SurveyJSON5.prototype.peek = function () {
        // Get the this.next character without consuming it or
        // assigning it to the this.ch varaible.
        return this.chartAt();
    };
    SurveyJSON5.prototype.chartAt = function () {
        if (this.endAt > -1 && this.at >= this.endAt)
            return "";
        return this.text.charAt(this.at);
    };
    SurveyJSON5.prototype.identifier = function () {
        // Parse an identifier. Normally, reserved words are disallowed here, but we
        // only use this for unquoted object keys, where reserved words are allowed,
        // so we don't check for those here. References:
        // - http://es5.github.com/#x7.6
        // - https://developer.mozilla.org/en/Core_JavaScript_1.5_Guide/Core_Language_Features#Variables
        // - http://docstore.mik.ua/orelly/webprog/jscript/ch02_07.htm
        // TODO Identifiers can have Unicode "letters" in them; add support for those.
        var key = this.ch;
        // Identifiers must start with a letter, _ or $.
        if (this.ch !== "_" &&
            this.ch !== "$" &&
            (this.ch < "a" || this.ch > "z") &&
            (this.ch < "A" || this.ch > "Z")) {
            this.error("Bad identifier");
        }
        // Subsequent characters can contain digits.
        while (this.next() &&
            (this.ch === "_" ||
                this.ch === "$" ||
                (this.ch >= "a" && this.ch <= "z") ||
                (this.ch >= "A" && this.ch <= "Z") ||
                (this.ch >= "0" && this.ch <= "9"))) {
            key += this.ch;
        }
        return key;
    };
    SurveyJSON5.prototype.number = function () {
        // Parse a number value.
        var number, sign = "", string = "", base = 10;
        if (this.ch === "-" || this.ch === "+") {
            sign = this.ch;
            this.next(this.ch);
        }
        // support for Infinity (could tweak to allow other words):
        if (this.ch === "I") {
            number = this.word();
            if (typeof number !== "number" || isNaN(number)) {
                this.error("Unexpected word for number");
            }
            return sign === "-" ? -number : number;
        }
        // support for NaN
        if (this.ch === "N") {
            number = this.word();
            if (!isNaN(number)) {
                this.error("expected word to be NaN");
            }
            // ignore sign as -NaN also is NaN
            return number;
        }
        if (this.ch === "0") {
            string += this.ch;
            this.next();
            if (this.ch === "x" || this.ch === "X") {
                string += this.ch;
                this.next();
                base = 16;
            }
            else if (this.ch >= "0" && this.ch <= "9") {
                this.error("Octal literal");
            }
        }
        switch (base) {
            case 10:
                while (this.ch >= "0" && this.ch <= "9") {
                    string += this.ch;
                    this.next();
                }
                if (this.ch === ".") {
                    string += ".";
                    while (this.next() && this.ch >= "0" && this.ch <= "9") {
                        string += this.ch;
                    }
                }
                if (this.ch === "e" || this.ch === "E") {
                    string += this.ch;
                    this.next();
                    if (this.ch === "-" || this.ch === "+") {
                        string += this.ch;
                        this.next();
                    }
                    while (this.ch >= "0" && this.ch <= "9") {
                        string += this.ch;
                        this.next();
                    }
                }
                break;
            case 16:
                while ((this.ch >= "0" && this.ch <= "9") ||
                    (this.ch >= "A" && this.ch <= "F") ||
                    (this.ch >= "a" && this.ch <= "f")) {
                    string += this.ch;
                    this.next();
                }
                break;
        }
        if (sign === "-") {
            number = -string;
        }
        else {
            number = +string;
        }
        if (!isFinite(number)) {
            this.error("Bad number");
        }
        else {
            return number;
        }
    };
    SurveyJSON5.prototype.string = function () {
        // Parse a string value.
        var hex, i, string = "", delim, // double quote or single quote
        uffff;
        // When parsing for string values, we must look for ' or " and \ characters.
        if (this.ch === '"' || this.ch === "'") {
            delim = this.ch;
            while (this.next()) {
                if (this.ch === delim) {
                    this.next();
                    return string;
                }
                else if (this.ch === "\\") {
                    this.next();
                    if (this.ch === "u") {
                        uffff = 0;
                        for (i = 0; i < 4; i += 1) {
                            hex = parseInt(this.next(), 16);
                            if (!isFinite(hex)) {
                                break;
                            }
                            uffff = uffff * 16 + hex;
                        }
                        string += String.fromCharCode(uffff);
                    }
                    else if (this.ch === "\r") {
                        if (this.peek() === "\n") {
                            this.next();
                        }
                    }
                    else if (typeof SurveyJSON5.escapee[this.ch] === "string") {
                        string += SurveyJSON5.escapee[this.ch];
                    }
                    else {
                        break;
                    }
                }
                else if (this.ch === "\n") {
                    // unescaped newlines are invalid; see:
                    // https://github.com/aseemk/json5/issues/24
                    // TODO this feels special-cased; are there other
                    // invalid unescaped chars?
                    break;
                }
                else {
                    string += this.ch;
                }
            }
        }
        this.error("Bad string");
    };
    SurveyJSON5.prototype.inlineComment = function () {
        // Skip an inline comment, assuming this is one. The current character should
        // be the second / character in the // pair that begins this inline comment.
        // To finish the inline comment, we look for a newline or the end of the text.
        if (this.ch !== "/") {
            this.error("Not an inline comment");
        }
        do {
            this.next();
            if (this.ch === "\n" || this.ch === "\r") {
                this.next();
                return;
            }
        } while (this.ch);
    };
    SurveyJSON5.prototype.blockComment = function () {
        // Skip a block comment, assuming this is one. The current character should be
        // the * character in the /* pair that begins this block comment.
        // To finish the block comment, we look for an ending */ pair of characters,
        // but we also watch for the end of text before the comment is terminated.
        if (this.ch !== "*") {
            this.error("Not a block comment");
        }
        do {
            this.next();
            while (this.ch === "*") {
                this.next("*");
                if (this.ch === "/") {
                    this.next("/");
                    return;
                }
            }
        } while (this.ch);
        this.error("Unterminated block comment");
    };
    SurveyJSON5.prototype.comment = function () {
        // Skip a comment, whether inline or block-level, assuming this is one.
        // Comments always begin with a / character.
        if (this.ch !== "/") {
            this.error("Not a comment");
        }
        this.next("/");
        if (this.ch === "/") {
            this.inlineComment();
        }
        else if (this.ch === "*") {
            this.blockComment();
        }
        else {
            this.error("Unrecognized comment");
        }
    };
    SurveyJSON5.prototype.white = function () {
        // Skip whitespace and comments.
        // Note that we're detecting comments by only a single / character.
        // This works since regular expressions are not valid JSON(5), but this will
        // break if there are other valid values that begin with a / character!
        while (this.ch) {
            if (this.ch === "/") {
                this.comment();
            }
            else if (SurveyJSON5.ws.indexOf(this.ch) >= 0) {
                this.next();
            }
            else {
                return;
            }
        }
    };
    SurveyJSON5.prototype.word = function () {
        // true, false, or null.
        switch (this.ch) {
            case "t":
                this.next("t");
                this.next("r");
                this.next("u");
                this.next("e");
                return true;
            case "f":
                this.next("f");
                this.next("a");
                this.next("l");
                this.next("s");
                this.next("e");
                return false;
            case "n":
                this.next("n");
                this.next("u");
                this.next("l");
                this.next("l");
                return null;
            case "I":
                this.next("I");
                this.next("n");
                this.next("f");
                this.next("i");
                this.next("n");
                this.next("i");
                this.next("t");
                this.next("y");
                return Infinity;
            case "N":
                this.next("N");
                this.next("a");
                this.next("N");
                return NaN;
        }
        this.error("Unexpected '" + this.ch + "'");
    };
    SurveyJSON5.prototype.array = function () {
        // Parse an array value.
        var array = [];
        if (this.ch === "[") {
            this.next("[");
            this.white();
            while (this.ch) {
                if (this.ch === "]") {
                    this.next("]");
                    return array; // Potentially empty array
                }
                // ES5 allows omitting elements in arrays, e.g. [,] and
                // [,null]. We don't allow this in JSON5.
                if (this.ch === ",") {
                    this.error("Missing array element");
                }
                else {
                    array.push(this.value());
                }
                this.white();
                // If there's no comma after this value, this needs to
                // be the end of the array.
                if (this.ch !== ",") {
                    this.next("]");
                    return array;
                }
                this.next(",");
                this.white();
            }
        }
        this.error("Bad array");
    };
    SurveyJSON5.prototype.object = function () {
        // Parse an object value.
        var key, start, isFirstProperty = true, object = {};
        if (this.parseType > 0) {
            object[SurveyJSON5.positionName] = { start: this.at - 1 };
        }
        if (this.ch === "{") {
            this.next("{");
            this.white();
            start = this.at - 1;
            while (this.ch) {
                if (this.ch === "}") {
                    if (this.parseType > 0) {
                        object[SurveyJSON5.positionName].end = start;
                    }
                    this.next("}");
                    return object; // Potentially empty object
                }
                // Keys can be unquoted. If they are, they need to be
                // valid JS identifiers.
                if (this.ch === '"' || this.ch === "'") {
                    key = this.string();
                }
                else {
                    key = this.identifier();
                }
                this.white();
                if (this.parseType > 1) {
                    object[SurveyJSON5.positionName][key] = {
                        start: start,
                        valueStart: this.at
                    };
                }
                this.next(":");
                object[key] = this.value();
                if (this.parseType > 1) {
                    start = this.at - 1;
                    object[SurveyJSON5.positionName][key].valueEnd = start;
                    object[SurveyJSON5.positionName][key].end = start;
                }
                this.white();
                // If there's no comma after this pair, this needs to be
                // the end of the object.
                if (this.ch !== ",") {
                    if (this.parseType > 1) {
                        object[SurveyJSON5.positionName][key].valueEnd--;
                        object[SurveyJSON5.positionName][key].end--;
                    }
                    if (this.parseType > 0) {
                        object[SurveyJSON5.positionName].end = this.at - 1;
                    }
                    this.next("}");
                    return object;
                }
                if (this.parseType > 1) {
                    object[SurveyJSON5.positionName][key].valueEnd--;
                    if (!isFirstProperty) {
                        object[SurveyJSON5.positionName][key].end--;
                    }
                }
                this.next(",");
                this.white();
                isFirstProperty = false;
            }
        }
        this.error("Bad object");
    };
    SurveyJSON5.prototype.value = function () {
        // Parse a JSON value. It could be an object, an array, a string, a number,
        // or a word.
        this.white();
        switch (this.ch) {
            case "{":
                return this.object();
            case "[":
                return this.array();
            case '"':
            case "'":
                return this.string();
            case "-":
            case "+":
            case ".":
                return this.number();
            default:
                return this.ch >= "0" && this.ch <= "9" ? this.number() : this.word();
        }
    };
    SurveyJSON5.prototype.stringify = function (obj, replacer, space) {
        if (replacer === void 0) { replacer = null; }
        if (space === void 0) { space = null; }
        if (replacer &&
            (typeof replacer !== "function" && !this.isArray(replacer))) {
            throw new Error("Replacer must be a function or an array");
        }
        this.replacer = replacer;
        this.indentStr = this.getIndent(space);
        this.objStack = [];
        // special case...when undefined is used inside of
        // a compound object/array, return null.
        // but when top-level, return undefined
        var topLevelHolder = { "": obj };
        if (obj === undefined) {
            return this.getReplacedValueOrUndefined(topLevelHolder, "", true);
        }
        return this.internalStringify(topLevelHolder, "", true);
    };
    SurveyJSON5.prototype.getIndent = function (space) {
        if (space) {
            if (typeof space === "string") {
                return space;
            }
            else if (typeof space === "number" && space >= 0) {
                return this.makeIndent(" ", space, true);
            }
        }
        return "";
    };
    SurveyJSON5.prototype.getReplacedValueOrUndefined = function (holder, key, isTopLevel) {
        var value = holder[key];
        // Replace the value with its toJSON value first, if possible
        if (value && value.toJSON && typeof value.toJSON === "function") {
            value = value.toJSON();
        }
        // If the user-supplied replacer if a function, call it. If its an array, check objects' string keys for
        // presence in the array (removing the key/value pair from the resulting JSON if the key is missing).
        if (typeof this.replacer === "function") {
            return this.replacer.call(holder, key, value);
        }
        else if (this.replacer) {
            if (isTopLevel ||
                this.isArray(holder) ||
                this.replacer.indexOf(key) >= 0) {
                return value;
            }
            else {
                return undefined;
            }
        }
        else {
            return value;
        }
    };
    SurveyJSON5.prototype.isWordChar = function (char) {
        return ((char >= "a" && char <= "z") ||
            (char >= "A" && char <= "Z") ||
            (char >= "0" && char <= "9") ||
            char === "_" ||
            char === "$");
    };
    SurveyJSON5.prototype.isWordStart = function (char) {
        return ((char >= "a" && char <= "z") ||
            (char >= "A" && char <= "Z") ||
            char === "_" ||
            char === "$");
    };
    SurveyJSON5.prototype.isWord = function (key) {
        if (typeof key !== "string") {
            return false;
        }
        if (!this.isWordStart(key[0])) {
            return false;
        }
        var i = 1, length = key.length;
        while (i < length) {
            if (!this.isWordChar(key[i])) {
                return false;
            }
            i++;
        }
        return true;
    };
    // polyfills
    SurveyJSON5.prototype.isArray = function (obj) {
        if (Array.isArray) {
            return Array.isArray(obj);
        }
        else {
            return Object.prototype.toString.call(obj) === "[object Array]";
        }
    };
    SurveyJSON5.prototype.isDate = function (obj) {
        return Object.prototype.toString.call(obj) === "[object Date]";
    };
    SurveyJSON5.prototype.isNaN = function (val) {
        return typeof val === "number" && val !== val;
    };
    SurveyJSON5.prototype.checkForCircular = function (obj) {
        for (var i = 0; i < this.objStack.length; i++) {
            if (this.objStack[i] === obj) {
                throw new TypeError("Converting circular structure to JSON");
            }
        }
    };
    SurveyJSON5.prototype.makeIndent = function (str, num, noNewLine) {
        if (noNewLine === void 0) { noNewLine = false; }
        if (!str) {
            return "";
        }
        // indentation no more than 10 chars
        if (str.length > 10) {
            str = str.substring(0, 10);
        }
        var indent = noNewLine ? "" : "\n";
        for (var i = 0; i < num; i++) {
            indent += str;
        }
        return indent;
    };
    SurveyJSON5.prototype.escapeString = function (str) {
        // If the string contains no control characters, no quote characters, and no
        // backslash characters, then we can safely slap some quotes around it.
        // Otherwise we must also replace the offending characters with safe escape
        // sequences.
        SurveyJSON5.escapable.lastIndex = 0;
        return SurveyJSON5.escapable.test(str)
            ? '"' +
                str.replace(SurveyJSON5.escapable, function (a) {
                    var c = SurveyJSON5.meta[a];
                    return typeof c === "string"
                        ? c
                        : "\\u" + ("0000" + a.charCodeAt(0).toString(16)).slice(-4);
                }) +
                '"'
            : '"' + str + '"';
    };
    // End
    SurveyJSON5.prototype.internalStringify = function (holder, key, isTopLevel) {
        var buffer, res;
        // Replace the value, if necessary
        var obj_part = this.getReplacedValueOrUndefined(holder, key, isTopLevel);
        if (obj_part && !this.isDate(obj_part)) {
            // unbox objects
            // don't unbox dates, since will turn it into number
            obj_part = obj_part.valueOf();
        }
        switch (typeof obj_part) {
            case "boolean":
                return obj_part.toString();
            case "number":
                if (isNaN(obj_part) || !isFinite(obj_part)) {
                    return "null";
                }
                return obj_part.toString();
            case "string":
                return this.escapeString(obj_part.toString());
            case "object":
                if (obj_part === null) {
                    return "null";
                }
                else if (this.isArray(obj_part)) {
                    this.checkForCircular(obj_part);
                    buffer = "[";
                    this.objStack.push(obj_part);
                    for (var i = 0; i < obj_part.length; i++) {
                        res = this.internalStringify(obj_part, i, false);
                        buffer += this.makeIndent(this.indentStr, this.objStack.length);
                        if (res === null || typeof res === "undefined") {
                            buffer += "null";
                        }
                        else {
                            buffer += res;
                        }
                        if (i < obj_part.length - 1) {
                            buffer += ",";
                        }
                        else if (this.indentStr) {
                            buffer += "\n";
                        }
                    }
                    this.objStack.pop();
                    buffer +=
                        this.makeIndent(this.indentStr, this.objStack.length, true) + "]";
                }
                else {
                    this.checkForCircular(obj_part);
                    buffer = "{";
                    var nonEmpty = false;
                    this.objStack.push(obj_part);
                    for (var prop in obj_part) {
                        if (obj_part.hasOwnProperty(prop)) {
                            var value = this.internalStringify(obj_part, prop, false);
                            isTopLevel = false;
                            if (typeof value !== "undefined" && value !== null) {
                                buffer += this.makeIndent(this.indentStr, this.objStack.length);
                                nonEmpty = true;
                                var propKey = this.isWord(prop)
                                    ? prop
                                    : this.escapeString(prop);
                                buffer +=
                                    propKey + ":" + (this.indentStr ? " " : "") + value + ",";
                            }
                        }
                    }
                    this.objStack.pop();
                    if (nonEmpty) {
                        buffer =
                            buffer.substring(0, buffer.length - 1) +
                                this.makeIndent(this.indentStr, this.objStack.length) +
                                "}";
                    }
                    else {
                        buffer = "{}";
                    }
                }
                return buffer;
            default:
                // functions and undefined should be ignored
                return undefined;
        }
    };
    SurveyJSON5.positionName = "pos";
    SurveyJSON5.escapee = {
        "'": "'",
        '"': '"',
        "\\": "\\",
        "/": "/",
        "\n": "",
        b: "\b",
        f: "\f",
        n: "\n",
        r: "\r",
        t: "\t"
    };
    SurveyJSON5.ws = [" ", "\t", "\r", "\n", "\v", "\f", "\xA0", "\uFEFF"];
    // Copied from Crokford's implementation of JSON
    // See https://github.com/douglascrockford/JSON-js/blob/e39db4b7e6249f04a195e7dd0840e610cc9e941e/json2.js#L195
    // Begin
    // eslint-disable-next-line
    SurveyJSON5.cx = /[\u0000\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    // eslint-disable-next-line
    SurveyJSON5.escapable = /[\\\"\x00-\x1f\x7f-\x9f\u00ad\u0600-\u0604\u070f\u17b4\u17b5\u200c-\u200f\u2028-\u202f\u2060-\u206f\ufeff\ufff0-\uffff]/g;
    SurveyJSON5.meta = {
        // table of character substitutions
        "\b": "\\b",
        "\t": "\\t",
        "\n": "\\n",
        "\f": "\\f",
        "\r": "\\r",
        '"': '\\"',
        "\\": "\\\\"
    };
    return SurveyJSON5;
}());



/***/ }),

/***/ "./src/localization/english.ts":
/*!*************************************!*\
  !*** ./src/localization/english.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   enStrings: () => (/* binding */ enStrings)
/* harmony export */ });
// Uncomment the line below if you create a custom dictionary
// import { editorLocalization } from "survey-creator-core";
var enStrings = {
    // survey templates
    survey: {
        edit: "Edit",
        externalHelpLink: "Watch and learn how to create surveys",
        externalHelpLinkUrl: "https://www.youtube.com/channel/UCH2ru9okIcooNZfpIbyq4qQ?view_as=subscriber",
        dropQuestion: "Please drop a question here from the Toolbox.",
        addLogicItem: "Create a rule to customize the flow of the survey.",
        copy: "Copy",
        duplicate: "Duplicate",
        addToToolbox: "Add to toolbox",
        deletePanel: "Delete Panel",
        deleteQuestion: "Delete Question",
        convertTo: "Convert to",
        drag: "Drag element",
        license: "To use our library, a <a href='https://surveyjs.io/licensing'>developer license</a> is required. If you have an active license, <a href='https://surveyjs.io/remove-alert-banner'>set up your license key</a> and ensure you're using the latest version."
    },
    // Creator tabs
    tabs: {
        preview: "Preview",
        theme: "Themes",
        translation: "Translations",
        designer: "Designer",
        editor: "JSON Editor",
        logic: "Logic"
    },
    // Question types
    qt: {
        default: "Default",
        checkbox: "Checkboxes",
        comment: "Long Text",
        imagepicker: "Image Picker",
        ranking: "Ranking",
        image: "Image",
        dropdown: "Dropdown",
        tagbox: "Multi-Select Dropdown",
        file: "File Upload",
        html: "HTML",
        matrix: "Single-Select Matrix",
        matrixdropdown: "Multi-Select Matrix",
        matrixdynamic: "Dynamic Matrix",
        multipletext: "Multiple Textboxes",
        panel: "Panel",
        paneldynamic: "Dynamic Panel",
        radiogroup: "Radio Button Group",
        rating: "Rating Scale",
        text: "Single-Line Input",
        boolean: "Yes/No (Boolean)",
        expression: "Expression (read-only)",
        signaturepad: "Signature",
        buttongroup: "Button Group"
    },
    toolboxCategories: {
        general: "General",
        choice: "Choice Questions",
        text: "Text Input Questions",
        containers: "Containers",
        matrix: "Matrix Questions",
        misc: "Misc"
    },
    // Strings in SurveyJS Creator
    ed: {
        defaultLocale: "Default ({0})",
        survey: "Survey",
        settings: "Settings",
        settingsTooltip: "Open settings",
        surveySettings: "Survey Settings",
        surveySettingsTooltip: "Survey settings",
        themeSettings: "Theme Settings",
        themeSettingsTooltip: "Theme settings",
        creatorSettingTitle: "Creator Settings",
        showPanel: "Show Panel",
        hidePanel: "Hide Panel",
        prevSelected: "Select previous",
        nextSelected: "Select next",
        prevFocus: "Focus previous",
        nextFocus: "Focus next",
        surveyTypeName: "Survey",
        pageTypeName: "Page",
        panelTypeName: "Panel",
        questionTypeName: "Question",
        columnTypeName: "Column",
        addNewPage: "Add New Page",
        moveRight: "Scroll to the Right",
        moveLeft: "Scroll to the Left",
        deletePage: "Delete Page",
        editPage: "Edit Page",
        edit: "Edit",
        newPageName: "page",
        newQuestionName: "question",
        newPanelName: "panel",
        newTextItemName: "text",
        defaultV2Theme: "Default",
        modernTheme: "Modern",
        defaultTheme: "Default (legacy)",
        testSurveyAgain: "Preview Survey Again",
        testSurveyWidth: "Survey width: ",
        navigateToMsg: "You had to navigate to",
        saveSurvey: "Save Survey",
        saveSurveyTooltip: "Save Survey",
        saveTheme: "Save Theme",
        saveThemeTooltip: "Save Theme",
        jsonHideErrors: "Hide errors",
        jsonShowErrors: "Show errors",
        undo: "Undo",
        redo: "Redo",
        undoTooltip: "Undo last change",
        redoTooltip: "Redo the change",
        expandAllTooltip: "Expand All",
        collapseAllTooltip: "Collapse All",
        zoomInTooltip: "Zoom In",
        zoomOutTooltip: "Zoom Out",
        lockQuestionsTooltip: "Lock expand/collapse state for questions",
        showMoreChoices: "Show more",
        showLessChoices: "Show less",
        copy: "Copy",
        cut: "Cut",
        paste: "Paste",
        copyTooltip: "Copy selection to clipboard",
        cutTooltip: "Cut selection to clipboard",
        pasteTooltip: "Paste from clipboard",
        options: "Options",
        generateValidJSON: "Generate Valid JSON",
        generateReadableJSON: "Generate Readable JSON",
        toolbox: "Toolbox",
        "property-grid": "Properties",
        toolboxFilteredTextPlaceholder: "Type to search...",
        toolboxNoResultsFound: "No results found",
        propertyGridFilteredTextPlaceholder: "Type to search...",
        propertyGridNoResultsFound: "No results found",
        propertyGridPlaceholderTitle: "Start configuring your form",
        propertyGridPlaceholderDescription: "Click any category icon to explore survey settings. Additional settings will become available once you add a survey element to the design surface.",
        correctJSON: "Please correct JSON.",
        surveyResults: "Survey Results ",
        surveyResultsTable: "As Table",
        surveyResultsJson: "As JSON",
        resultsTitle: "Question Title",
        resultsName: "Question Name",
        resultsValue: "Answer Value",
        resultsDisplayValue: "Display Value",
        modified: "Modified",
        saving: "Saving",
        saved: "Saved",
        propertyEditorError: "Error",
        saveError: "Error! Editor content is not saved.",
        translationPropertyGridTitle: "Language Settings",
        themePropertyGridTitle: "Theme Settings",
        translationLanguages: "Languages",
        translationDeleteLanguage: "Are you certain you wish to delete all strings for this language?",
        translationAddLanguage: "Select language to translate",
        translationShowAllStrings: "All Strings",
        translationShowUsedStringsOnly: "Used Strings Only",
        translationShowAllPages: "All Pages",
        translationNoStrings: "No strings to translate. Please change the filter.",
        translationExportToSCVButton: "Export to CSV",
        translationImportFromSCVButton: "Import from CSV",
        translateUsigAI: "Auto-translate All",
        translateUsigAIFrom: "Translate from: ",
        translationDialogTitle: "Untranslated strings",
        translationMergeLocaleWithDefault: "Merge {0} with default locale",
        translationPlaceHolder: "Translation...",
        translationSource: "Source: ",
        translationTarget: "Target: ",
        translationYouTubeNotSupported: "YouTube links are not supported.",
        themeExportButton: "Export",
        themeImportButton: "Import",
        surveyJsonExportButton: "Export",
        surveyJsonImportButton: "Import",
        surveyJsonCopyButton: "Copy to clipboard",
        themeResetButton: "Reset theme settings to default",
        themeResetConfirmation: "Do you really want to reset the theme? All your customizations will be lost.",
        themeResetConfirmationOk: "Yes, reset the theme",
        bold: "Bold",
        italic: "Italic",
        underline: "Underline",
        addNewQuestion: "Add Question",
        selectPage: "Select page...",
        carryForwardChoicesCopied: "Choices are copied from",
        choicesLoadedFromWebText: "Choices are loaded from a web service.",
        choicesLoadedFromWebLinkText: "Go to settings",
        choicesLoadedFromWebPreviewTitle: "Preview of loaded choice options",
        htmlPlaceHolder: "HTML content will be here.",
        panelPlaceHolder: "Drop a question from the toolbox here.",
        surveyPlaceHolder: "The survey is empty. Drag an element from the toolbox or click the button below.",
        pagePlaceHolder: "The page is empty. Drag an element from the toolbox or click the button below.",
        imagePlaceHolder: "Drag and drop an image here or click the button below and choose an image to upload",
        surveyPlaceHolderMobile: "Click the \"Add Question\" button below to start creating your form.",
        surveyPlaceholderTitle: "Your form is empty",
        surveyPlaceholderTitleMobile: "Your form is empty",
        surveyPlaceholderDescription: "Drag an element from the toolbox or click the button below.",
        surveyPlaceholderDescriptionMobile: "Drag an element from the toolbox or click the button below.",
        previewPlaceholderTitle: "No preview",
        previewPlaceholderTitleMobile: "No preview",
        previewPlaceholderDescription: "The survey doesn't contain any visible elements.",
        previewPlaceholderDescriptionMobile: "The survey doesn't contain any visible elements.",
        translationsPlaceholderTitle: "No strings to translate",
        translationsPlaceholderTitleMobile: "No strings to translate",
        translationsPlaceholderDescription: "Add elements to your form or change the strings filter in the toolbar.",
        translationsPlaceholderDescriptionMobile: "Add elements to your form or change the strings filter in the toolbar.",
        pagePlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the page.",
        panelPlaceHolderMobile: "Click the \"Add Question\" button below to add a new element to the panel.",
        imagePlaceHolderMobile: "Click the button below and choose an image to upload",
        imageChooseImage: "Choose Image",
        addNewTypeQuestion: "Add {0}",
        chooseLogoPlaceholder: "[LOGO]",
        choices_Item: "Item ",
        selectFile: "Select a file",
        removeFile: "Remove the file",
        lg: {
            addNewItem: "Add New Rule",
            empty_tab: "Create a rule to customize the flow of the survey.",
            logicPlaceholderTitle: "No logical rules",
            logicPlaceholderTitleMobile: "No logical rules",
            logicPlaceholderDescription: "Create a rule to customize the flow of the survey.",
            logicPlaceholderDescriptionMobile: "Create a rule to customize the flow of the survey.",
            page_visibilityName: "Show/hide page",
            page_enableName: "Enable/disable page",
            page_requireName: "Make page required",
            panel_visibilityName: "Show/hide panel",
            panel_enableName: "Enable/disable panel",
            panel_requireName: "Make panel required",
            question_visibilityName: "Show/hide question",
            question_enableName: "Enable/disable question",
            question_requireName: "Make question required",
            question_resetValueName: "Reset question value",
            question_setValueName: "Set question value",
            column_visibilityName: "Show/hide column",
            column_enableName: "Enable/disable column",
            column_requireName: "Make column required",
            column_resetValueName: "Reset column value",
            column_setValueName: "Set column value",
            trigger_completeName: "Complete survey",
            trigger_setvalueName: "Set answer",
            trigger_copyvalueName: "Copy answer",
            trigger_skipName: "Skip to question",
            trigger_runExpressionName: "Run expression",
            completedHtmlOnConditionName: "Set \"Thank You\" page markup",
            page_visibilityDescription: "Make the page visible when the logical expression evaluates to true. Otherwise, keep the page invisible.",
            panel_visibilityDescription: "Make the page visible when the logical expression evaluates to true. Otherwise, keep the panel invisible.",
            panel_enableDescription: "Make the panel and all elements inside it enabled when the logical expression evaluates to true. Otherwise, keep them disabled.",
            question_visibilityDescription: "Make the question visible when the logical expression evaluates to true. Otherwise, keep the question invisible.",
            question_enableDescription: "Make the question enabled when the logical expression evaluates to true. Otherwise, keep the question disabled.",
            question_requireDescription: "Question becomes required when the logical expression evaluates to true.",
            trigger_completeDescription: "When the logical expression evaluates to true, the survey ends, and the respondent sees the \"Thank you\" page.",
            trigger_setvalueDescription: "When question values used in the logical expression are changed, and the expression evaluates to true, the specified value is assigned to the selected question.",
            trigger_copyvalueDescription: "When question values used in the logical expression are changed, and the expression evaluates to true, the value of the selected question is copied to another question.",
            trigger_skipDescription: "When the logical expression evaluates to true, the survey focuses/jumps to the selected question.",
            trigger_runExpressionDescription: "When the logical expression evaluates to true, the survey evaluates another expression. Optionally, the result of the latter expression can be assigned as a value to the selected question",
            completedHtmlOnConditionDescription: "If the logical expression evaluates to true, the \"Thank You\" page displays the specified content.",
            itemExpressionText: "When expression: '{0}' returns true",
            itemEmptyExpressionText: "New rule",
            page_visibilityText: "make page {0} visible",
            panel_visibilityText: "make panel {0} visible",
            panel_enableText: "make panel {0} enable",
            question_visibilityText: "make question {0} visible",
            question_enableText: "make question {0} enable",
            question_requireText: "make question {0} required",
            question_resetValueText: "reset value for question: {0}",
            question_setValueText: "assign value: {1} to question: {0}",
            column_visibilityText: "make column {0} of question {1} visible",
            column_enableText: "make column {0} of question {1} enable",
            column_requireText: "make column {0} of question {1} required",
            column_resetValueText: "reset cell value for column: {0}",
            column_setValueText: "assign cell value: {1} to column: {0}",
            setValueExpressionPlaceholder: "An expression whose result will be assigned to the target question.",
            trigger_completeText: "survey becomes completed",
            trigger_setvalueText: "set into question: {0} value {1}",
            trigger_setvalueEmptyText: "clear question value: {0}",
            trigger_copyvalueText: "copy into question: {0} value from question {1}",
            trigger_skipText: "survey skip to the question {0}",
            trigger_runExpressionText1: "run expression: '{0}'",
            trigger_runExpressionText2: " and set its result into question: {0}",
            completedHtmlOnConditionText: "show custom text for the \"Thank You\" page.",
            showAllQuestions: "All Questions",
            showAllActionTypes: "All Action Types",
            conditions: "Condition(s)",
            actions: "Action(s)",
            expressionEditorTitle: "Define condition(s)",
            actionsEditorTitle: "Define action(s)",
            deleteAction: "Delete Action",
            addNewAction: "Add Action",
            selectedActionCaption: "Select action...",
            expressionInvalid: "The logic expression is empty or invalid. Please correct it.",
            noActionError: "Please add at least one action.",
            actionInvalid: "Please fix issues in your action(s).",
            uncompletedRule_title: "Logical rules are incomplete",
            uncompletedRule_text: "You have not completed some of the logical rules. If you leave the tab now, the changes will be lost. Do you still want to leave the tab without completing the changes?",
            uncompletedRule_apply: "Yes",
            uncompletedRule_cancel: "No, I want to complete the rules"
        }
    },
    // Property Editors
    pe: {
        panel: {
            name: "Panel name",
            title: "Panel title",
            description: "Panel description",
            visibleIf: "Make the panel visible if",
            requiredIf: "Make the panel required if",
            questionsOrder: "Question order within the panel",
            page: "Move the panel to page",
            startWithNewLine: "Display the panel on a new line",
            state: "Panel collapse state",
            width: "Inline panel width",
            minWidth: "Minimum panel width",
            maxWidth: "Maximum panel width",
            showNumber: "Number this panel"
        },
        paneldynamic: {
            name: "Panel name",
            title: "Panel title",
            description: "Panel description",
            visibleIf: "Make the panel visible if",
            requiredIf: "Make the panel required if",
            page: "Move the panel to page",
            startWithNewLine: "Display the panel on a new line",
            state: "Panel collapse state",
            width: "Inline panel width",
            minWidth: "Minimum panel width",
            maxWidth: "Maximum panel width",
            confirmDelete: "Confirm panel deletion",
            templateDescription: "Panel description pattern",
            templateTitle: "Panel title pattern",
            noEntriesText: "Empty panel text",
            templateTabTitle: "Tab title pattern",
            tabTitlePlaceholder: "Tab title placeholder",
            templateVisibleIf: "Make an individual panel visible if",
            hideNumber: "Hide the panel number",
            titleLocation: "Panel title alignment",
            descriptionLocation: "Panel description alignment",
            templateTitleLocation: "Question title alignment",
            templateErrorLocation: "Error message alignment",
            newPanelPosition: "New panel location",
            showRangeInProgress: "Show the progress bar",
            showProgressBar: "Show the progress bar",
            progressBarLocation: "Progress bar alignment",
            keyName: "Prevent duplicate responses in the following question"
        },
        question: {
            name: "Question name",
            title: "Question title",
            description: "Question description",
            visibleIf: "Make the question visible if",
            requiredIf: "Make the question required if",
            page: "Move the question to page",
            state: "Question box collapse state",
            hideNumber: "Hide the question number",
            titleLocation: "Question title alignment",
            descriptionLocation: "Question description alignment",
            errorLocation: "Error message alignment",
            indent: "Increase the inner indent",
            width: "Inline question width",
            minWidth: "Minimum question width",
            maxWidth: "Maximum question width",
            textUpdateMode: "Update input field value"
        },
        signaturepad: {
            signatureWidth: "Signature area width",
            signatureHeight: "Signature area height",
            signatureAutoScaleEnabled: "Auto-scale the signature area",
            showPlaceholder: "Show a placeholder within signature area",
            placeholder: "Placeholder text",
            placeholderReadOnly: "Placeholder text in read-only or preview mode",
            allowClear: "Show the Clear button within signature area",
            penMinWidth: "Minimum stroke width",
            penMaxWidth: "Maximum stroke width",
            penColor: "Stroke color"
        },
        comment: {
            rows: "Input field height (in lines)"
        },
        showQuestionNumbers: "Question numbering",
        questionStartIndex: "Question indexing type",
        expression: {
            name: "Expression name",
            title: "Expression title",
            description: "Expression description",
            expression: "Expression"
        },
        trigger: {
            expression: "Expression"
        },
        calculatedvalue: {
            expression: "Expression"
        },
        // survey templates
        survey: {
            title: "Survey title",
            description: "Survey description"
        },
        page: {
            name: "Page name",
            title: "Page title",
            description: "Page description",
            visibleIf: "Make the page visible if",
            requiredIf: "Make the page required if",
            timeLimit: "Time limit to complete the page",
            questionsOrder: "Question order on the page"
        },
        matrixdropdowncolumn: {
            name: "Column name",
            title: "Column title",
            isUnique: "Prevent duplicate responses",
            width: "Column width",
            minWidth: "Minimum column width",
            rows: "Input field height (in lines)",
            visibleIf: "Make the column visible if",
            requiredIf: "Make the column required if",
            showInMultipleColumns: "Each option in a separate column"
        },
        multipletextitem: {
            name: "Name",
            title: "Title"
        },
        masksettings: {
            saveMaskedValue: "Save masked value in survey results"
        },
        patternmask: {
            pattern: "Value pattern"
        },
        datetimemask: {
            min: "Minimum value",
            max: "Maximum value"
        },
        numericmask: {
            allowNegativeValues: "Allow negative values",
            thousandsSeparator: "Thousands separator",
            decimalSeparator: "Decimal separator",
            precision: "Value precision",
            min: "Minimum value",
            max: "Maximum value"
        },
        currencymask: {
            prefix: "Currency prefix",
            suffix: "Currency suffix"
        },
        imageHeight: "Display area height",
        imageWidth: "Display area width",
        valueName: "Join identifier",
        rateDescriptionLocation: "Label alignment",
        size: "Input field width (in characters)",
        cellErrorLocation: "Cell error message alignment",
        enabled: "Enabled",
        disabled: "Disabled",
        inherit: "Inherit",
        apply: "Apply",
        ok: "OK",
        save: "Save",
        clear: "Clear",
        saveTooltip: "Save",
        cancel: "Cancel",
        set: "Set",
        reset: "Reset",
        change: "Change",
        refresh: "Refresh",
        close: "Close",
        delete: "Delete",
        add: "Add",
        addNew: "Add New",
        addItem: "Click to add an item...",
        removeItem: "Click to remove the item...",
        dragItem: "Drag the item",
        addOther: "Other",
        addSelectAll: "Select All",
        addNone: "None",
        removeAll: "Remove All",
        edit: "Edit",
        back: "Return without saving",
        backTooltip: "Return without saving",
        saveAndBack: "Save and return",
        saveAndBackTooltip: "Save and return",
        doneEditing: "Done",
        editChoices: "Edit Choices",
        showChoices: "Show Choices",
        move: "Move",
        empty: "<empty>",
        emptyValue: "Value is empty",
        fastEntry: "Manual Entry",
        fastEntryNonUniqueError: "Value '{0}' is not unique",
        fastEntryChoicesCountError: "Please limit the number of items from {0} to {1}",
        fastEntryChoicesMinCountError: "Please enter at least {0} items",
        fastEntryPlaceholder: "Enter the list of choice options and their IDs in the following format:\n\nid|option\n\nA choice option ID is not visible to respondents and can be used in conditional rules.",
        formEntry: "Form Entry",
        testService: "Test the service",
        itemSelectorEmpty: "Please select the element",
        conditionActionEmpty: "Please select the action",
        conditionSelectQuestion: "Select a question...",
        conditionSelectPage: "Select a page...",
        conditionSelectPanel: "Select a panel...",
        conditionValueQuestionTitle: "Please enter/select the value",
        aceEditorHelp: "Press ctrl+space to get expression completion hint",
        aceEditorRowTitle: "Current row",
        aceEditorPanelTitle: "Current panel",
        showMore: "For more details please check the documentation",
        assistantTitle: "Available questions",
        cellsEmptyRowsColumns: "There is should be at least one column or row",
        showPreviewBeforeComplete: "Review before submit",
        overridingPropertyPrefix: "Enabled by a condition",
        resetToDefaultCaption: "Reset",
        propertyIsEmpty: "Please enter a value",
        propertyIsNoUnique: "Please enter a unique value",
        propertyNameIsNotUnique: "Please enter a unique name",
        propertyNameIsIncorrect: "Do not use reserved words: \"item\", \"choice\", \"panel\", \"row\".",
        listIsEmpty: "You don't have any items yet",
        "listIsEmpty@choices": "You don't have any choices yet",
        "listIsEmpty@columns": "You don't have any columns yet",
        "listIsEmpty@rows": "You don't have any rows yet",
        "listIsEmpty@validators": "You don't have any validation rules yet",
        "listIsEmpty@calculatedValues": "You don't have any custom variables yet",
        "listIsEmpty@triggers": "You don't have any triggers yet",
        "listIsEmpty@navigateToUrlOnCondition": "You don't have any links yet",
        "listIsEmpty@pages": "You don't have any pages yet",
        "addNew@choices": "Add new choice",
        "addNew@columns": "Add new column",
        "addNew@rows": "Add new row",
        "addNew@validators": "Add new rule",
        "addNew@calculatedValues": "Add new variable",
        "addNew@triggers": "Add new trigger",
        "addNew@navigateToUrlOnCondition": "Add new URL",
        "addNew@pages": "Add new page",
        expressionIsEmpty: "Expression is empty",
        value: "Value",
        text: "Text",
        rowid: "Row ID",
        imageLink: "Image or video file URL",
        columnEdit: "Edit column: {0}",
        itemEdit: "Edit item: {0}",
        url: "URL",
        path: "Path to data",
        choicesbyurl: {
            url: "Web service URL",
            valueName: "Get value to store from the following property"
        },
        titleName: "Get value to display from the following property",
        imageLinkName: "Get file URLs from the following property",
        allowEmptyResponse: "Accept empty response",
        titlePlaceholder: "Title",
        surveyTitlePlaceholder: "Survey Title",
        pageTitlePlaceholder: "Page {num}",
        descriptionPlaceholder: "Description",
        surveyDescriptionPlaceholder: "Description",
        pageDescriptionPlaceholder: "Description",
        textWrapEnabled: "Wrap choices",
        showOtherItem: "Enable the \"Other\" option",
        otherText: "Rename the \"Other\" option",
        showNoneItem: "Enable the \"None\" option",
        showRefuseItem: "Enable the \"Refuse to Answer\" option",
        showDontKnowItem: "Enable the \"Don't Know\" option",
        noneText: "Rename the \"None\" option",
        showSelectAllItem: "Enable the \"Select All\" option",
        selectAllText: "Rename the \"Select All\" option",
        choicesMin: "Minimum value for auto-generated items",
        choicesMax: "Maximum value for auto-generated items",
        choicesStep: "Step value for auto-generated items",
        name: "Name",
        title: "Title",
        cellType: "Cell input type",
        colCount: "Column count",
        choicesOrder: "Choice order",
        visible: "Visible",
        isRequired: "Required",
        markRequired: "Mark as required",
        removeRequiredMark: "Remove the required mark",
        isAllRowRequired: "Require an answer in each row",
        eachRowUnique: "Prevent duplicate responses in rows",
        requiredErrorText: "Error message for required questions",
        startWithNewLine: "Display the question on a new line",
        rows: "Rows",
        cols: "Columns",
        placeholder: "Placeholder text within input field",
        showPreview: "Show preview area",
        storeDataAsText: "Store file content in JSON result as text",
        maxSize: "Maximum file size (in bytes)",
        rowCount: "Row count",
        columnLayout: "Columns layout",
        addRowLocation: "\"Add Row\" button alignment",
        transposeData: "Transpose rows to columns",
        addRowText: "\"Add Row\" button text",
        removeRowText: "\"Remove Row\" button text",
        rateMin: "Minimum rating value",
        rateMax: "Maximum rating value",
        rateStep: "Step value",
        minRateDescription: "Minimum value label",
        maxRateDescription: "Maximum value label",
        inputType: "Input type",
        optionsCaption: "Option placeholder",
        defaultValue: "Default Answer",
        cellsDefaultRow: "Default texts",
        surveyEditorTitle: "Edit survey settings",
        qEditorTitle: "Edit: {0}",
        maxLength: "Maximum character limit",
        buildExpression: "Build",
        editExpression: "Edit",
        and: "and",
        or: "or",
        remove: "Remove",
        addCondition: "Add Condition",
        emptyLogicPopupMessage: "Select a question to start configuring conditions.",
        if: "If",
        then: "then",
        setToName: "Target question",
        fromName: "Question to copy answer from",
        gotoName: "Question to skip to",
        ruleIsNotSet: "Rule is incorrect",
        includeIntoResult: "Add to the survey results",
        showTitle: "Make the title and description visible",
        expandCollapseTitle: "Expand/collapse title",
        locale: "Select a survey language",
        simulator: "Select device type",
        landscapeOrientation: "Switch to landscape orientation",
        portraitOrientation: "Switch to portrait orientation",
        mode: "Survey display mode",
        clearInvisibleValues: "Clear hidden question values",
        cookieName: "Limit to one response",
        sendResultOnPageNext: "Auto-save survey progress on page change",
        storeOthersAsComment: "Save the \"Other\" option value as a separate property",
        showPageTitles: "Show page titles",
        showPageNumbers: "Show page numbers",
        pagePrevText: "\"Previous Page\" button text",
        pageNextText: "\"Next Page\" button text",
        completeText: "\"Complete Survey\" button text",
        previewText: "\"Review Answers\" button text",
        editText: "\"Edit Answer\" button text",
        startSurveyText: "\"Start Survey\" button text",
        showNavigationButtons: "Show/hide navigation buttons",
        showPrevButton: "Show the \"Previous Page\" button",
        firstPageIsStarted: "First page is a start page",
        showCompletedPage: "Show the \"Thank You\" page",
        goNextPageAutomatic: "Auto-advance to the next page",
        allowCompleteSurveyAutomatic: "Complete the survey automatically",
        showProgressBar: "Progress bar alignment",
        questionTitleLocation: "Question title alignment",
        questionTitleWidth: "Question title width",
        requiredText: "Required symbol(s)",
        questionTitleTemplate: "Question title template, default is: '{no}. {require} {title}'",
        questionErrorLocation: "Error message alignment",
        focusFirstQuestionAutomatic: "Focus first question on a new page",
        questionsOrder: "Question order",
        timeLimit: "Time limit to complete the survey",
        timeLimitPerPage: "Time limit to complete one page",
        showTimer: "Use a timer",
        timerLocation: "Timer alignment",
        timerInfoMode: "Timer mode",
        renderMode: "Panel display mode",
        allowAddPanel: "Enable panel addition",
        allowRemovePanel: "Enable panel removal",
        panelAddText: "\"Add Panel\" button text",
        panelRemoveText: "\"Remove Panel\" button text",
        isSinglePage: "Show all elements on one page",
        html: "HTML markup",
        setValue: "Answer",
        dataFormat: "Storage format",
        allowAddRows: "Enable row addition",
        allowRemoveRows: "Enable row removal",
        allowRowsDragAndDrop: "Enable row reordering",
        responsiveImageSizeHelp: "Does not apply if you specify the exact display area width or height.",
        minImageWidth: "Minimum display area width",
        maxImageWidth: "Maximum display area width",
        minImageHeight: "Minimum display area height",
        maxImageHeight: "Maximum display area height",
        minValue: "Minimum value",
        maxValue: "Maximum value",
        caseInsensitive: "Case insensitive",
        minLength: "Minimum length (in characters)",
        allowDigits: "Allow digits",
        minCount: "Minimum count",
        maxCount: "Maximum count",
        regex: "Regular expression",
        surveyvalidator: {
            text: "Error message",
            expression: "Validation expression"
        },
        totalText: "Total row header",
        totalType: "Aggregation method",
        totalExpression: "Total value expression",
        totalDisplayStyle: "Total value display format",
        totalCurrency: "Currency",
        totalFormat: "Formatted string",
        logo: "Survey logo",
        questionsOnPageMode: "Survey layout",
        maxTextLength: "Restrict answer length",
        maxOthersLength: "Restrict comment length",
        commentAreaRows: "Comment area height (in lines)",
        autoGrowComment: "Auto-expand text areas",
        allowResizeComment: "Allow users to resize text areas",
        textUpdateMode: "Update input field values",
        maskType: "Input mask type",
        focusOnFirstError: "Set focus on the first invalid answer",
        checkErrorsMode: "Run validation",
        validateVisitedEmptyFields: "Validate empty fields on lost focus",
        navigateToUrl: "Redirect to an external link after submission",
        navigateToUrlOnCondition: "Dynamic external link",
        completedBeforeHtml: "Markup to show if the user already filled out this survey",
        completedHtml: "\"Thank You\" page markup",
        completedHtmlOnCondition: "Dynamic \"Thank You\" page markup",
        loadingHtml: "Markup to show while survey model is loading",
        commentText: "Comment area text",
        autocomplete: "Autocomplete type",
        labelTrue: "Label for \"True\"",
        labelFalse: "Label for \"False\"",
        allowClear: "Show the Clear button",
        searchMode: "Search Mode",
        displayStyle: "Display format",
        format: "Formatted string",
        maximumFractionDigits: "Maximum fractional digits",
        minimumFractionDigits: "Minimum fractional digits",
        useGrouping: "Display grouping separators",
        allowMultiple: "Enable multiple file upload",
        allowImagesPreview: "Preview uploaded images",
        acceptedTypes: "Accepted file types",
        waitForUpload: "Wait for upload to complete",
        needConfirmRemoveFile: "Confirm file deletion",
        detailPanelMode: "Row expansion alignment",
        minRowCount: "Minimum row count",
        maxRowCount: "Maximum row count",
        confirmDelete: "Confirm row deletion",
        confirmDeleteText: "Confirmation message",
        panelCount: "Initial panel count",
        minPanelCount: "Minimum panel count",
        maxPanelCount: "Maximum panel count",
        panelsState: "Inner panel collapse state",
        panelPrevText: "\"Previous Panel\" button text",
        panelNextText: "\"Next Panel\" button text",
        panelRemoveButtonLocation: "\"Remove Panel\" button alignment",
        hideIfRowsEmpty: "Hide the question if it has no rows",
        hideColumnsIfEmpty: "Hide columns if there are no rows",
        rateValues: "Custom rating values",
        rateCount: "Rating count",
        autoGenerate: "Rating configuration",
        hideIfChoicesEmpty: "Hide the question if it has no choices",
        minWidth: "Minimum width",
        maxWidth: "Maximum width",
        width: "Width",
        showHeader: "Show column headers",
        horizontalScroll: "Show horizontal scrollbar",
        columnMinWidth: "Minimum column width",
        rowTitleWidth: "Row header width",
        valueTrue: "Value to store when \"True\" is selected",
        valueFalse: "Value to store when \"False\" is selected",
        minErrorText: "\"Value is below minimum\" error message",
        maxErrorText: "\"Value exceeds maximum\" error message",
        otherErrorText: "\"Empty comment\" error message",
        keyDuplicationError: "Error message for duplicate responses",
        minSelectedChoices: "Minimum choices to select",
        maxSelectedChoices: "Maximum choices to select",
        showClearButton: "Show the Clear button",
        logoWidth: "Logo width",
        logoHeight: "Logo height",
        readOnly: "Read-only",
        enableIf: "Disable the read-only mode if",
        emptyRowsText: "\"No rows\" message",
        separateSpecialChoices: "Separate special choices",
        choicesFromQuestion: "Copy choices from the following question",
        choicesFromQuestionMode: "Which choice options to copy",
        progressBarShowPageTitles: "Display page titles in progress bar",
        progressBarShowPageNumbers: "Display page numbers in progress bar",
        showCommentArea: "Add a comment box",
        commentPlaceholder: "Placeholder text for the comment box",
        displayRateDescriptionsAsExtremeItems: "Show the labels as extreme values",
        rowsOrder: "Row order",
        columnsLayout: "Column layout",
        columnColCount: "Nested column count",
        correctAnswer: "Correct Answer",
        defaultPanelValue: "Default Values",
        cells: "Cell Texts",
        fileInputPlaceholder: "Select a file or paste a file link...",
        keyName: "Prevent duplicate responses in the following column",
        itemvalue: {
            visibleIf: "Make the option visible if",
            enableIf: "Make the option selectable if"
        },
        "itemvalue@rows": {
            visibleIf: "Make the row visible if",
            enableIf: "Make the row editable if"
        },
        imageitemvalue: {
            text: "Alt text"
        },
        logoPosition: "Logo alignment",
        addLogo: "Add logo...",
        changeLogo: "Change logo...",
        logoPositions: {
            none: "Remove logo",
            left: "Left",
            right: "Right",
            top: "On the top",
            bottom: "In the bottom"
        },
        // Creator tabs
        tabs: {
            panel: {
                layout: "Panel Layout"
            },
            general: "General",
            fileOptions: "Options",
            html: "HTML Editor",
            columns: "Columns",
            rows: "Rows",
            choices: "Choice Options",
            items: "Items",
            visibleIf: "Visible If",
            enableIf: "Editable If",
            requiredIf: "Required If",
            rateValues: "Rating Values",
            choicesByUrl: "Choices from a Web Service",
            matrixChoices: "Default Choices",
            multipleTextItems: "Text Inputs",
            numbering: "Numbering",
            validators: "Validators",
            navigation: "Navigation",
            question: "Question Settings",
            pages: "Pages",
            timer: "Quiz Mode",
            calculatedValues: "Calculated Values",
            triggers: "Triggers",
            templateTitle: "Title template",
            totals: "Totals",
            logic: "Conditions",
            mask: "Input Mask Settings",
            layout: {
                panel: "Panel Layout",
                question: "Layout",
                base: "Layout"
            },
            data: "Data",
            validation: "Validation",
            cells: "Individual Cell Texts",
            showOnCompleted: "\"Thank You\" Page",
            logo: "Logo in the Survey Header",
            slider: "Slider",
            expression: "Expression",
            questionSettings: "Question Settings",
            header: "Header",
            background: "Background",
            appearance: "Appearance",
            accentColors: "Accent colors",
            scaling: "Scaling",
            others: "Others"
        },
        editProperty: "Edit property '{0}'",
        items: "Items",
        choicesVisibleIf: "Make choices visible if",
        choicesEnableIf: "Make choices selectable if",
        columnsEnableIf: "Make columns visible if",
        rowsEnableIf: "Make rows visible if",
        innerIndent: "Increase the inner indent",
        defaultValueFromLastRow: "Use answers from the last row as default",
        defaultValueFromLastPanel: "Use answers from the last panel as default",
        enterNewValue: "Please enter a value.",
        noquestions: "There are no questions in the survey.",
        createtrigger: "Please create a trigger",
        titleKeyboardAdornerTip: "Press enter button to edit",
        keyboardAdornerTip: "Press enter button to edit item, press delete button to delete item, press alt plus arrow up or arrow down to move item",
        triggerOn: "On ",
        triggerMakePagesVisible: "Make pages visible",
        triggerMakeQuestionsVisible: "Make elements visible",
        triggerCompleteText: "Complete the survey if successful.",
        triggerNotSet: "The trigger is not set",
        triggerRunIf: "Run if",
        triggerSetToName: "Change value of: ",
        triggerFromName: "Copy value from: ",
        triggerRunExpression: "Run this Expression",
        triggerSetValue: "to: ",
        triggerGotoName: "Go to the question",
        triggerIsVariable: "Do not put the variable into the survey result.",
        triggerRunExpressionEmpty: "Please enter a valid expression",
        emptyExpressionPlaceHolder: "Type expression here...",
        noFile: "No file chosen",
        clearIfInvisible: "Clear hidden question values",
        valuePropertyName: "Store values in the following property",
        searchEnabled: "Enable search-as-you-type",
        hideSelectedItems: "Hide selected items",
        closeOnSelect: "Collapse the dropdown upon selection",
        verticalAlign: "Vertical alignment within cells",
        alternateRows: "Alternate row colors",
        columnsVisibleIf: "Make columns visible if",
        rowsVisibleIf: "Make rows visible if",
        otherPlaceholder: "Placeholder text for the comment box",
        filePlaceholder: "Placeholder text for Local file",
        photoPlaceholder: "Placeholder text for Camera",
        fileOrPhotoPlaceholder: "Placeholder text for Local file or Camera",
        rateType: "Rating icon",
        url_placeholder: "Ex.: https://api.example.com/books",
        path_placeholder: "Ex.: categories.fiction",
        questionStartIndex_placeholder: "Ex.: a)",
        width_placeholder: "Ex.: 6in",
        minWidth_placeholder: "Ex.: 600px",
        maxWidth_placeholder: "Ex.: 50%",
        imageHeight_placeholder: "auto",
        imageWidth_placeholder: "auto",
        theme: {
            themeName: "Theme",
            isPanelless: "Question appearance",
            editorPanel: "Background and corner radius",
            questionPanel: "Background and corner radius",
            primaryColor: "Accent color",
            panelBackgroundTransparency: "Panel and question box opacity",
            questionBackgroundTransparency: "Input element opacity",
            fontSize: "Survey font size",
            scale: "Survey scale factor",
            cornerRadius: "Corner radius",
            advancedMode: "Advanced mode",
            pageTitle: "Title font",
            pageDescription: "Description font",
            questionTitle: "Title font",
            questionDescription: "Description font",
            editorFont: "Font",
            backgroundOpacity: "Opacity",
            "--sjs-font-family": "Survey font family",
            "--sjs-general-backcolor-dim": "Background color",
            "--sjs-primary-backcolor": "Accent background colors",
            "--sjs-primary-forecolor": "Accent foreground colors",
            "--sjs-special-red": "Error message colors",
            "--sjs-shadow-small": "Shadow effects",
            "--sjs-shadow-inner": "Shadow effects",
            "--sjs-border-default": "Colors",
        },
        "header@header": {
            headerView: "View",
            logoPosition: "Logo alignment",
            surveyTitle: "Survey title font",
            surveyDescription: "Survey description font",
            headerTitle: "Survey title font",
            headerDescription: "Survey description font",
            inheritWidthFrom: "Content area width",
            textAreaWidth: "Text width",
            backgroundColorSwitch: "Background color",
            backgroundImage: "Background image",
            backgroundImageOpacity: "Opacity",
            overlapEnabled: "Overlap",
            logoPositionX: "Logo alignment",
            titlePositionX: "Survey title alignment",
            descriptionPositionX: "Survey description alignment",
        }
    },
    // Property values
    pv: {
        "true": "true",
        "false": "false",
        file: "Local file",
        camera: "Camera",
        "file-camera": "Local file or Camera",
        inherit: "Inherit",
        show: "Visible",
        hide: "Hidden",
        default: "Inherit",
        initial: "Initial",
        random: "Random",
        collapsed: "Collapsed",
        expanded: "Expanded",
        none: "None",
        asc: "Ascending",
        desc: "Descending",
        indeterminate: "Indeterminate",
        selected: "Selected",
        unselected: "Unselected",
        decimal: "decimal",
        currency: "currency",
        percent: "percent",
        firstExpanded: "First panel is expanded",
        off: "Hide question numbers",
        list: "List",
        carousel: "Carousel",
        tab: "Tabs",
        progressTop: "Panel navigator + Progress bar at the top",
        progressBottom: "Panel navigator + Progress bar at the bottom",
        progressTopBottom: "Panel navigator + Progress bar at the top and bottom",
        horizontal: "Horizontal",
        vertical: "Vertical",
        top: "Top",
        bottom: "Bottom",
        topBottom: "Top and bottom",
        both: "Both",
        left: "Left",
        right: "Right",
        center: "Center",
        leftRight: "Left and right",
        middle: "Middle",
        color: "color",
        date: "date",
        datetime: "datetime",
        "datetime-local": "datetime-local",
        email: "email",
        month: "month",
        number: "number",
        password: "password",
        range: "range",
        tel: "tel",
        text: "text",
        time: "time",
        url: "url",
        week: "week",
        hidden: "Hidden",
        edit: "Editable",
        display: "Read-only",
        contain: "Contain",
        cover: "Cover",
        fill: "Fill",
        next: "Next",
        last: "Last",
        onComplete: "Upon survey completion",
        onHidden: "When question gets hidden",
        onHiddenContainer: "When question or its panel/page gets hidden",
        clearInvisibleValues: {
            none: "Never"
        },
        clearIfInvisible: {
            none: "Never"
        },
        inputType: {
            color: "Color",
            date: "Date",
            "datetime-local": "Date and Time",
            email: "Email",
            month: "Month",
            number: "Number",
            password: "Password",
            range: "Range",
            tel: "Phone Number",
            text: "Text",
            time: "Time",
            url: "URL",
            week: "Week"
        },
        autocomplete: {
            "name": "Full Name",
            "honorific-prefix": "Prefix",
            "given-name": "First Name",
            "additional-name": "Middle Name",
            "family-name": "Last Name",
            "honorific-suffix": "Suffix",
            "nickname": "Nickname",
            "organization-title": "Job Title",
            "username": "User Name",
            "new-password": "New Password",
            "current-password": "Current Password",
            "organization": "Organization Name",
            "street-address": "Full Street Address",
            "address-line1": "Address Line 1",
            "address-line2": "Address Line 2",
            "address-line3": "Address Line 3",
            "address-level4": "Level 4 Address",
            "address-level3": "Level 3 Address",
            "address-level2": "Level 2 Address",
            "address-level1": "Level 1 Address",
            "country": "Country Code",
            "country-name": "Country Name",
            "postal-code": "Postal Code",
            "cc-name": "Cardholder Name",
            "cc-given-name": "Cardholder First Name",
            "cc-additional-name": "Cardholder Middle Name",
            "cc-family-name": "Cardholder Last Name",
            "cc-number": "Credit Card Number",
            "cc-exp": "Expiration Date",
            "cc-exp-month": "Expiration Month",
            "cc-exp-year": "Expiration Year",
            "cc-csc": "Card Security Code",
            "cc-type": "Credit Card Type",
            "transaction-currency": "Transaction Currency",
            "transaction-amount": "Transaction Amount",
            "language": "Preferred Language",
            "bday": "Birthday",
            "bday-day": "Birthday Day",
            "bday-month": "Birthday Month",
            "bday-year": "Birthday Year",
            "sex": "Gender",
            "url": "Website URL",
            "photo": "Profile Photo",
            "tel": "Telephone Number",
            "tel-country-code": "Country Code for Phone",
            "tel-national": "National Telephone Number",
            "tel-area-code": "Area Code",
            "tel-local": "Local Phone Number",
            "tel-local-prefix": "Local Phone Prefix",
            "tel-local-suffix": "Local Phone Suffix",
            "tel-extension": "Phone Extension",
            "email": "Email Address",
            "impp": "Instant Messaging Protocol"
        },
        maskType: {
            none: "None",
            pattern: "Pattern",
            numeric: "Numeric",
            datetime: "Date and Time",
            currency: "Currency"
        },
        inputTextAlignment: {
            auto: "Auto",
            left: "Left",
            right: "Right"
        },
        all: "All",
        page: "Page",
        survey: "Survey",
        onNextPage: "When switching to the next page",
        onValueChanged: "After an answer is changed",
        onValueChanging: "Before an answer is changed",
        questionsOnPageMode: {
            standard: "Original structure",
            singlePage: "Show all questions on one page",
            questionPerPage: "Show single question per page"
        },
        noPreview: "No preview",
        showAllQuestions: "Show all questions",
        showAnsweredQuestions: "Show answered questions only",
        pages: "Completed pages",
        questions: "Answered questions",
        requiredQuestions: "Answered required questions",
        correctQuestions: "Valid answers",
        buttons: "Completed pages (button UI)",
        underInput: "Under the input field",
        underTitle: "Under the question title",
        onBlur: "On lost focus",
        onTyping: "While typing",
        underRow: "Under the row",
        underRowSingle: "Under the row, display one row expansion only",
        auto: "Auto",
        showNavigationButtons: {
            none: "Hidden"
        },
        timerInfoMode: {
            combined: "Both"
        },
        addRowLocation: {
            default: "Based on matrix layout"
        },
        panelsState: {
            default: "Locked",
            collapsed: "Collapse all",
            expanded: "Expand all",
            firstExpanded: "First expanded"
        },
        widthMode: {
            static: "Static",
            responsive: "Responsive"
        },
        contentMode: {
            image: "Image",
            video: "Video",
            youtube: "YouTube"
        },
        displayMode: {
            buttons: "Buttons",
            dropdown: "Dropdown"
        },
        rateColorMode: {
            default: "Default",
            scale: "Scale"
        },
        scaleColorMode: {
            monochrome: "Monochrome",
            colored: "Colored"
        },
        autoGenerate: {
            "true": "Auto-generate",
            "false": "Manual"
        },
        rateType: {
            labels: "Labels",
            stars: "Stars",
            smileys: "Smileys"
        },
        state: {
            default: "Locked"
        },
        showQuestionNumbers: {
            default: "Auto-numbering",
            on: "Auto-numbering",
            onPage: "Reset on each page",
            onpanel: "Reset on each panel",
            onPanel: "Reset on each panel",
            onSurvey: "Continue across the survey",
            off: "No numbering"
        },
        descriptionLocation: {
            underTitle: "Under the question title",
            underInput: "Under the input field"
        },
        selectToRankAreasLayout: {
            horizontal: "Next to choices",
            vertical: "Above choices"
        },
        displayStyle: {
            decimal: "Decimal",
            currency: "Currency",
            percent: "Percentage",
            date: "Date"
        },
        totalDisplayStyle: {
            decimal: "Decimal",
            currency: "Currency",
            percent: "Percentage",
            date: "Date"
        },
        rowsOrder: {
            initial: "Original"
        },
        questionsOrder: {
            initial: "Original"
        },
        showProgressBar: {
            off: "Hidden",
            topbottom: "Top and bottom",
            aboveheader: "Above the header",
            belowheader: "Below the header"
        },
        progressBarLocation: {
            "top": "Top",
            "bottom": "Bottom",
            "topBottom": "Top and bottom"
        },
        sum: "Sum",
        count: "Count",
        min: "Min",
        max: "Max",
        avg: "Avg",
        searchMode: {
            contains: "Contains",
            startsWith: "Starts with"
        },
        backgroundImageFit: {
            auto: "Auto",
            cover: "Cover",
            contain: "Contain",
            fill: "Stretch",
            tile: "Tile",
        },
        backgroundImageAttachment: {
            fixed: "Fixed",
            scroll: "Scroll",
        },
        headerView: {
            basic: "Basic",
            advanced: "Advanced",
        },
        inheritWidthFrom: {
            survey: "Same as survey",
            container: "Same as container",
        },
        backgroundColorSwitch: {
            none: "None",
            accentColor: "Accent color",
            custom: "Custom",
        },
        colorPalette: {
            light: "Light",
            dark: "Dark",
        },
        isPanelless: {
            false: "Default",
            true: "Without Panels",
        },
        progressBarInheritWidthFrom: {
            survey: "Same as survey",
            container: "Same as container"
        }
    },
    // Operators
    op: {
        empty: "Empty",
        notempty: "Not empty",
        equal: "Equals",
        notequal: "Does not equal",
        contains: "Contains",
        notcontains: "Does not contain",
        anyof: "Any of",
        allof: "All of",
        greater: "Greater than",
        less: "Less than",
        greaterorequal: "Greater than or equal to",
        lessorequal: "Less than or equal to",
        and: "and",
        or: "or"
    },
    // Embed window
    ew: {
        angular: "Use Angular version",
        jquery: "Use jQuery version",
        knockout: "Use Knockout version",
        react: "Use React version",
        vue: "Use Vue version",
        bootstrap: "For bootstrap framework",
        modern: "Modern theme",
        default: "Default theme",
        orange: "Orange theme",
        darkblue: "Darkblue theme",
        darkrose: "Darkrose theme",
        stone: "Stone theme",
        winter: "Winter theme",
        winterstone: "Winter-Stone theme",
        showOnPage: "Show survey on a page",
        showInWindow: "Show survey in a window",
        loadFromServer: "Load Survey JSON from server",
        titleScript: "Scripts and styles",
        titleHtml: "HTML",
        titleJavaScript: "JavaScript"
    },
    // Preview (Survey)
    ts: {
        selectPage: "Select the page to test it",
        showInvisibleElements: "Show invisible elements",
        hideInvisibleElements: "Hide invisible elements"
    },
    validators: {
        answercountvalidator: "Answer count",
        emailvalidator: "Email",
        expressionvalidator: "Expression",
        numericvalidator: "Number",
        regexvalidator: "Regex",
        textvalidator: "Text"
    },
    triggers: {
        completetrigger: "Complete survey",
        setvaluetrigger: "Set answer",
        copyvaluetrigger: "Copy answer",
        skiptrigger: "Skip to question",
        runexpressiontrigger: "Run expression",
        visibletrigger: "change visibility (deprecated)"
    },
    peplaceholder: {
        patternmask: {
            pattern: "Ex.: +1(999)-999-99-99"
        },
        datetimemask: {
            pattern: "Ex.: mm/dd/yyyy HH:MM:ss"
        },
        currencymask: {
            prefix: "Ex.: $",
            suffix: "Ex.: USD"
        },
        panelbase: {
            questionTitleWidth: "Ex.: 200px"
        },
        panellayoutcolumn: {
            effectiveWidth: "Ex.: 30%",
            questionTitleWidth: "Ex.: 200px",
        },
    },
    pehelp: {
        panel: {
            name: "A panel ID that is not visible to respondents.",
            description: "Type a panel subtitle.",
            // isRequired: "Prevents survey submission unless at least one nested question has an answer.",
            visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility.",
            enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel.",
            requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer.",
            questionTitleLocation: "Applies to all questions within this panel. When set to \"Hidden\", it also hides question descriptions. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default). ",
            questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.).",
            questionErrorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting.",
            questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting.",
            page: "Repositions the panel to the end of a selected page.",
            innerIndent: "Adds space or margin between the panel content and the left border of the panel box.",
            startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form.",
            state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed.",
            width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.).",
            showQuestionNumbers: "Assigns numbers to questions nested within this panel."
        },
        paneldynamic: {
            name: "A panel ID that is not visible to respondents.",
            description: "Type a panel subtitle.",
            // isRequired: "Prevents survey submission unless at least one nested question has an answer.",
            visibleIf: "Use the magic wand icon to set a conditional rule that determines panel visibility.",
            enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the panel.",
            requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer.",
            templateTitleLocation: "Applies to all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default).",
            templateErrorLocation: "Sets the location of an error message in relation to a question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default).",
            errorLocation: "Sets the location of an error message in relation to all questions within the panel. The \"Inherit\" option applies the page-level (if set) or survey-level setting.",
            // questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the page-level (if set) or survey-level setting.",
            page: "Repositions the panel to the end of a selected page.",
            innerIndent: "Adds space or margin between the panel content and the left border of the panel box.",
            startWithNewLine: "Unselect to display the panel in one line with the previous question or panel. The setting doesn't apply if the panel is the first element in your form.",
            state: "Choose from: \"Expanded\" - the panel is displayed in full and can be collapsed; \"Collapsed\" - the panel displays only the title and description and can be expanded; \"Locked\" - the panel is displayed in full and cannot be collapsed.",
            width: "Sets the width of the panel in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.).",
            templateTitle: "Type in a template for dynamic panel titles. Use \{panelIndex}\ for the panel's general position and \{visiblePanelIndex}\ for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering.",
            templateTabTitle: "Type in a template for tab titles. Use \{panelIndex}\ for a panel's general position and \{visiblePanelIndex}\ for its order among visible panels. Insert these placeholders into the pattern to add automatic numbering.",
            tabTitlePlaceholder: "A fallback text for tab titles that applies when the tab title pattern doesn't produce a meaningful value.",
            templateVisibleIf: "This setting allows you to control the visibility of individual panels within the dynamic panel. Use the `{panel}` placeholder to reference the current panel in your expression.",
            titleLocation: "This setting is automatically inherited by all questions within this panel. If you want to override this setting, define title alignment rules for individual questions. The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Top\" by default).",
            descriptionLocation: "The \"Inherit\" option applies the page-level (if set) or survey-level setting (\"Under the panel title\" by default).",
            newPanelPosition: "Defines the position of a newly added panel. By default, new panels are added to the end. Select \"Next\" to insert a new panel after the current one.",
            defaultValueFromLastPanel: "Duplicates answers from the last panel and assigns them to the next added dynamic panel.",
            keyName: "Reference a question name to require a user to provide a unique response for this question in each panel."
        },
        defaultValueExpression: "This setting allows you to assign a default answer value based on an expression. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression serves as the initial default value that can be overridden by a respondent's manual input.",
        resetValueIf: "Use the magic wand icon to set a conditional rule that determines when a respondent's input is reset to the value based on the \"Default value expression\" or \"Set value expression\" or to the \"Default answer\" value (if either is set).",
        setValueIf: "Use the magic wand icon to set a conditional rule that determines when to run the \"Set value expression\" and dynamically assign the resulting value as a response.",
        setValueExpression: "Specify an expression that defines the value to be set when the conditions in the \"Set value if\" rule are met. The expression can include basic calculations - `{q1_id} + {q2_id}`, Boolean expressions, such as `{age} > 60`, and functions: `iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc. The value determined by this expression can be overridden by a respondent's manual input.",
        question: {
            name: "A question ID that is not visible to respondents.",
            description: "Type a question subtitle.",
            visibleIf: "Use the magic wand icon to set a conditional rule that determines question visibility.",
            enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the question.",
            requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey advancing or submission unless the question received an answer.",
            startWithNewLine: "Unselect to display the question in one line with the previous question or panel. The setting doesn't apply if the question is the first element in your form.",
            page: "Repositions the question to the end of a selected page.",
            state: "Choose from: \"Expanded\" - the question box is displayed in full and can be collapsed; \"Collapsed\" - the question box displays only the title and description and can be expanded; \"Locked\" - the question box is displayed in full and cannot be collapsed.",
            titleLocation: "Overrides title alignment rules defined on a panel, page, or survey level. When set to \"Hidden\", it also hides question descriptions. The \"Inherit\" option applies any higher-level settings (if set) or survey-level setting (\"Top\" by default).",
            descriptionLocation: "The \"Inherit\" option applies the survey-level setting (\"Under the question title\" by default).",
            errorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default).",
            indent: "Adds space or margin between the question content and the left border of the question box.",
            width: "Sets the width of the question in proportion to other survey elements in the same line. Accepts CSS values (px, %, in, pt, etc.).",
            surveyvalidator: {
                expression: "Use the magic wand icon to set a validation rule for the question."
            },
            textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing. The \"Inherit\" option applies the survey-level setting (\"On lost focus\" by default).",
            url: "You can use any web service as a data source for multiple-choice questions. To populate choice values, enter the URL of the service providing the data.",
            searchMode: "A comparison operation used to filter the drop-down list.",
            textWrapEnabled: "Long texts in choice options will automatically generate line breaks to fit within the drop-down menu. Unselect if you want the texts to clip."
        },
        signaturepad: {
            signatureWidth: "Sets the width of the displayed signature area and the resulting image.",
            signatureHeight: "Sets the height of the displayed signature area and the resulting image.",
            signatureAutoScaleEnabled: "Select if you want the signature area to fill all available space within the question box while maintaining the default 3:2 aspect ratio. When custom width and height values are set, the setting will keep the aspect ratio of these dimensions."
        },
        file: {
            imageHeight: "Adjusts the height of the image in the survey results.",
            imageWidth: "Adjusts the width of the image in the survey results.",
            allowImagesPreview: "Displays thumbnail previews for uploaded files when possible. Unselect if you want to show file icons instead.",
        },
        image: {
            contentMode: "The \"Auto\" option automatically determines the suitable mode for display - Image, Video, or YouTube - based on the source URL provided."
        },
        imagepicker: {
            imageHeight: "Overrides the minimum and maximum height values.",
            imageWidth: "Overrides the minimum and maximum width values.",
            choices: "\"Value\" serves as an item ID used in conditional rules; \"Text\" is displayed to respondents.",
            contentMode: "Choose between \"Image\" and \"Video\" to set the content mode of the media selector. If \"Image\" is selected, ensure that all options provided are image files in the following formats: JPEG, GIF, PNG, APNG, SVG, BMP, ICO. Similarly, if \"Video\" is selected, ensure that all options are direct links to video files in the following formats: MP4, MOV, WMV, FLV, AVI, MKV. Please note that YouTube links are not supported for video options."
        },
        text: {
            size: "This setting only resizes the input field and doesn't affect the width of the question box. To limit the accepted input length, go to \"Validation\" → \"Maximum character limit\"."
        },
        comment: {
            rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear."
        },
        // survey templates
        survey: {
            mode: "Choose between: \"Editable\" - enables respondents to fill out your survey; \"Read-only\" - disables form editing."
        },
        matrixdropdowncolumn: {
            name: "A column ID that is not visible to respondents.",
            isUnique: "When enabled for a column, a respondent is required to provide a unique response for each question within this column.",
            rows: "Sets the number of displayed lines in the input field. If the input takes up more lines, the scroll bar will appear.",
            visibleIf: "Use the magic wand icon to set a conditional rule that determines column visibility.",
            enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the column.",
            requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer.",
            showInMultipleColumns: "When selected, creates an individual column for each choice option.",
            colCount: "Arranges choice options in a multi-column layout. When set to 0, the options are displayed in a single line. When set to -1, the actual value is inherited from the \"Nested column count\" property of the parent matrix.",
        },
        caseInsensitive: "Select if uppercase and lowercase letters in the regular expression must be treated as equivalent.",
        widthMode: "Choose from: \"Static\" - sets a fixed width; \"Responsive\" - makes the survey occupy the full width of the screen; \"Auto\" - applies either of the two depending on the question types used.",
        cookieName: "Assign a unique cookie value for your survey. The cookie will be set in a respondent's browser upon survey completion to prevent repetitive survey submissions.",
        logo: "Paste an image link (no size limits) or click the folder icon to browse a file from your computer (up to 64KB).",
        logoWidth: "Sets a logo width in CSS units (px, %, in, pt, etc.).",
        logoHeight: "Sets a logo height in CSS units (px, %, in, pt, etc.).",
        logoFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio.",
        goNextPageAutomatic: "Select if you want the survey to auto-advance to the next page once a respondent has answered all questions on the current page. This feature won't apply if the last question on the page is open-ended or allows multiple answers.",
        allowCompleteSurveyAutomatic: "Select if you want the survey to complete automatically after a respondent answers all questions.",
        showNavigationButtons: "Sets the visibility and location of navigation buttons on a page.",
        showProgressBar: "Sets the visibility and location of a progress bar. The \"Auto\" value displays the progress bar above or below the survey header.",
        showPreviewBeforeComplete: "Enable the preview page with all or answered questions only.",
        questionTitleLocation: "Applies to all questions within the survey. This setting can be overridden by title alignment rules at lower levels: panel, page, or question. A lower-level setting will override those on a higher level.",
        requiredText: "A symbol or a sequence of symbols indicating that an answer is required.",
        questionStartIndex: "Enter a number or letter with which you want to start numbering.",
        questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box.",
        focusFirstQuestionAutomatic: "Select if you want the first input field on each page ready for text entry.",
        questionsOrder: "Keeps the original order of questions or randomizes them. The effect of this setting is only visible in the Preview tab.",
        maxTextLength: "For text entry questions only.",
        maxOthersLength: "For question comments only.",
        commentAreaRows: "Sets the number of displayed lines in text areas for question comments. In the input takes up more lines, the scroll bar appears.",
        autoGrowComment: "Select if you want question comments and Long Text questions to auto-grow in height based on the entered text length.",
        allowResizeComment: "For question comments and Long Text questions only.",
        calculatedValues: "Custom variables serve as intermediate or auxiliary variables used in form calculations. They take respondent inputs as source values. Each custom variable has a unique name and an expression it's based on.",
        includeIntoResult: "Select if you wish the calculated value of the expression to be saved along with survey results.",
        triggers: "A trigger is an event or condition that is based on an expression. Once the expression is evaluated to \"true\", a trigger sets off an action. Such an action can optionally have a target question it affects.",
        clearInvisibleValues: "Choose whether or not to clear values for questions hidden by conditional logic and when to do it.",
        textUpdateMode: "Choose from: \"On lost focus\" - the value is updated when the input field loses focus; \"While typing\" - the value is updated in real-time, as users are typing.",
        columns: "The left value serves as a column ID used in conditional rules, the right value is displayed to respondents.",
        rows: "The left value serves as a row ID used in conditional rules, the right value is displayed to respondents.",
        columnMinWidth: "Accepts CSS values (px, %, in, pt, etc.).",
        rowTitleWidth: "Accepts CSS values (px, %, in, pt, etc.).",
        totalText: "Visible only if at least one column displays total values set with \"Aggregation method\" or \"Total value expression\".",
        cellErrorLocation: "Sets the location of an error message in relation to a cell with invalid input. The \"Inherit\" option applies the setting from the \"Error message alignment\" property.",
        keyDuplicationError: "When the \"Prevent duplicate responses\" property is enabled, a respondent attempting to submit a duplicate entry will receive the following error message.",
        totalExpression: "Allows you to calculate total values based on an expression. The expression can include basic calculations (`{q1_id} + {q2_id}`), Boolean expressions (`{age} > 60`) and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.).",
        confirmDelete: "Triggers a prompt asking to confirm the row deletion.",
        defaultValueFromLastRow: "Duplicates answers from the last row and assigns them to the next added dynamic row.",
        keyName: "Reference a column ID to require a user to provide a unique response for each question within the specified column.",
        description: "Type a subtitle.",
        locale: "Choose a language to begin creating your survey. To add a translation, switch to a new language and translate the original text here or in the Translations tab.",
        detailPanelMode: "Sets the location of a details section in relation to a row. Choose from: \"None\" - no expansion is added; \"Under the row\" - a row expansion is placed under each row of the matrix; \"Under the row, display one row expansion only\" - an expansion is displayed under a single row only, the remaining row expansions are collapsed.",
        imageFit: "Choose from: \"None\" - image maintains its original size; \"Contain\" - image is resized to fit while maintaining its aspect ratio; \"Cover\" - image fills the entire box while maintaining its aspect ratio; \"Fill\" - image is stretched to fill the box without maintaining its aspect ratio.",
        autoGrow: "The \"Inherit\" option applies a survey-level setting (\"Disabled\" by default).",
        allowResize: "The \"Inherit\" option applies a survey-level setting (\"Enabled\" by default).",
        timeLimit: "A time interval in seconds after which the survey auto-advances to the \"Thank You\" page. When set to 0, counts the time spent on the survey.",
        timeLimitPerPage: "A time interval in seconds after which the survey auto-advances to the next page. Hides the \"Previous\" navigation button. When set to 0, counts the time spent on the current page.",
        validateVisitedEmptyFields: "Enable this option to trigger validation when a user focuses on an empty input field and then leaves it without making any changes.",
        page: {
            timeLimit: "A time interval in seconds after which the survey auto-advances to the next page. Hides the \"Previous\" navigation button. When set to 0, counts the time spent on the current page.",
            // isRequired: "Prevents survey submission unless at least one nested question has an answer.",
            visibleIf: "Use the magic wand icon to set a conditional rule that determines page visibility.",
            enableIf: "Use the magic wand icon to set a conditional rule that disables the read-only mode for the page.",
            requiredIf: "Use the magic wand icon to set a conditional rule that prevents survey submission unless at least one nested question has an answer.",
            questionTitleLocation: "Applies to all questions within this page. When set to \"Hidden\", it also hides question descriptions. If you want to override this setting, define title alignment rules for individual questions or panels. The \"Inherit\" option applies the survey-level setting (\"Top\" by default).",
            questionTitleWidth: "Sets consistent width for question titles when they are aligned to the left of their question boxes. Accepts CSS values (px, %, in, pt, etc.).",
            questionErrorLocation: "Sets the location of an error message in relation to the question with invalid input. Choose between: \"Top\" - an error text is placed at the top of the question box; \"Bottom\" - an error text is placed at the bottom of the question box. The \"Inherit\" option applies the survey-level setting (\"Top\" by default).",
            questionsOrder: "Keeps the original order of questions or randomizes them. The \"Inherit\" option applies the survey-level setting (\"Original\" by default). The effect of this setting is only visible in the Preview tab.",
            navigationButtonsVisibility: "Sets the visibility of navigation buttons on the page. The \"Inherit\" option applies the survey-level setting, which defaults to \"Visible\"."
        },
        timerLocation: "Sets the location of a timer on a page.",
        panelsState: "Choose from: \"Locked\" - users cannot expand or collapse panels; \"Collapse all\" - all panels start in a collapsed state; \"Expand all\" - all panels start in an expanded state; \"First expanded\" - only the first panel is initially expanded. Applies if \"Panel display mode\" is set to \"List\" and the \"Panel title pattern\" property is specified.",
        imageLinkName: "Enter a shared property name within the array of objects that contains the image or video file URLs you want to display in the choice list.",
        choices: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents.",
        title: "Type a user-friendly title to display.",
        waitForUpload: "Ensures that users won't complete the survey until files are uploaded.",
        minWidth: "Accepts CSS values (px, %, in, pt, etc.).",
        maxWidth: "Accepts CSS values (px, %, in, pt, etc.).",
        width: "Accepts CSS values (px, %, in, pt, etc.).",
        valueName: "A join identifier is a custom key that you can assign to several questions to link them together and sync their values. These values will be merged into a single array or object and stored in survey results using the key as the property name.",
        useDisplayValuesInDynamicTexts: "In single- and multiple-selection question types, each choice option has an ID and display value. When selected, this setting shows a display value instead of an ID value in HTML questions and dynamic titles and descriptions of survey elements.",
        clearIfInvisible: "Choose whether or not to clear question values hidden by conditional logic and when to do it. The \"Inherit\" option applies the survey-level setting (\"Upon survey completion\" by default).",
        choicesFromQuestionMode: "Choose from: \"All\" - copies all choice options from the selected question; \"Selected\" - dynamically copies only selected choice options; \"Unselected\" - dynamically copies only unselected choice options. The \"None\" and \"Other\" options are copied by default if enabled in the source question.",
        showOtherItem: "When selected, users can include additional input in a separate comment box.",
        separateSpecialChoices: "Displays each special choice option (\"None\", \"Other\", \"Select All\") on a new line, even when using a multiple-column layout.",
        path: "Specify the location within the service dataset where the target array of objects is located. Leave empty if the URL already points to the array.",
        choicesbyurl: {
            valueName: "Enter a uniform property name within the array of objects whose value will be stored as a response in survey results."
        },
        titleName: "Enter a uniform property name within the array of objects that contains the values you want to display in the choice list.",
        allowEmptyResponse: "Select to allow the service to return an empty response or array.",
        choicesVisibleIf: "Use the magic wand icon to set a conditional rule that determines the visibility of all choice options.",
        rateValues: "The left value serves as an item ID used in conditional rules, the right value is displayed to respondents.",
        rating: {
            displayMode: "\"Auto\" selects between the \"Buttons\" and \"Dropdown\" modes based on the available width. When the width is insufficient to display buttons, the question displays a dropdown."
        },
        valuePropertyName: "Allows you to connect questions that produce results in different formats. When such questions are linked together using a join identifier, this shared property stores selected question values.",
        searchEnabled: "Select if you want to update the drop-down menu contents to match the search query that a user is typing in the input field.",
        valueTrue: "A value to save in survey results when respondents give a positive answer.",
        valueFalse: "A value to save in survey results when respondents give a negative answer.",
        showPreview: "It's not recommended that you disable this option as it overrides the Preview image and makes it hard for a user to understand whether the files have been uploaded.",
        needConfirmRemoveFile: "Triggers a prompt asking to confirm the file deletion.",
        selectToRankEnabled: "Enable to rank only selected choices. Users will drag selected items from the choice list to order them within the ranking area.",
        dataList: "Enter a list of choices that will be suggested to the respondent during input.",
        itemSize: "The setting only resizes the input fields and doesn't affect the width of the question box.",
        itemTitleWidth: "Sets consistent width for all item labels in pixels",
        inputTextAlignment: "Select how to align input value within the field. The default setting \"Auto\" aligns the input value to the right if currency or numeric masking is applied and to the left if not.",
        altText: "Serves as a substitute when the image cannot be displayed on a user's device and for accessibility purposes.",
        rateColorMode: "Defines the color of the selected emoji when the Rating icon type is set to \"Smileys\". Choose between: \"Default\" - the selected emoji appears in default survey color; \"Scale\" - the selected emoji inherits color from the rating scale.",
        expression: {
            name: "An expression ID that is not visible to respondents.",
            description: "Type an expression subtitle.",
            expression: "An expression can include basic calculations (`{q1_id} + {q2_id}`), conditions (`{age} > 60`), and functions ('iif()`, `today()`, `age()`, `min()`, `max()`, `avg()`, etc.)."
        },
        storeOthersAsComment: "Select to store the \"Other\" option value as a separate property in survey results.",
        format: "Use {0} as a placeholder for the actual value.",
        acceptedTypes: "Refer to the [accept](https://www.w3schools.com/tags/att_input_accept.asp) attribute description for more information.",
        columnColCount: "Arranges choice options in a multi-column layout. When set to 0, the options are displayed in a single line. Applies only to columns with \"Cell input type\" set to Radio Button Group or Checkboxes.",
        autocomplete: "Select the data type that the user's browser can retrieve. This data is sourced either from past values entered by the user or from pre-configured values if any have been saved by the user for autocompletion.",
        filePlaceholder: "Applies when \"File source type\" is \"Local file\" or when camera is unavailable",
        photoPlaceholder: "Applies when \"File source type\" is \"Camera\".",
        fileOrPhotoPlaceholder: "Applies when \"File source type\" is \"Local file or camera\".",
        colCount: "Arranges choice options in a multi-column layout. When set to 0, the options are displayed in a single line.",
        masksettings: {
            saveMaskedValue: "Select if you want to store the question value with an applied mask in survey results."
        },
        patternmask: {
            pattern: "The pattern can contain string literals and the following placeholders: `9` - for a digit; `a` - for an upper- or lower-case letter; `#` - for a digit or an upper- or lower-case letter. Use backslash `\\` to escape a character."
        },
        datetimemask: {
            pattern: "The pattern can contain separator characters and the following placeholders:<br>`m` - Month number.<br>`mm` - Month number, with leading zero for single-digit values.<br>`d` - Day of the month.<br>`dd` - Day of the month, with leading zero for single-digit values.<br>`yy` - The last two digits of the year.<br>`yyyy` - Four-digit year.<br>`H` - Hours in 24-hour format.<br>`HH` - Hours in 24-hour format, with leading zero for single-digit values.<br>`h` - Hours in 12-hour format.<br>`hh` - Hours in 12-hour format, with leading zero for single-digit values.<br>`MM` - Minutes.<br>`ss` - Seconds.<br>`TT` - 12-hour clock period in upper case (AM/PM).<br>`tt` - 12-hour clock period in lower case (am/pm)."
        },
        numericmask: {
            decimalSeparator: "A symbol used to separate the fractional part from the integer part of a displayed number.",
            thousandsSeparator: "A symbol used to separate the digits of a large number into groups of three.",
            precision: "Limits how many digits to retain after the decimal point for a displayed number."
        },
        currencymask: {
            prefix: "One or several symbols to be displayed before the value.",
            suffix: "One or several symbols to be displayed after the value."
        },
        theme: {
            isPanelless: "This setting applies only to questions outside of a panel.",
            primaryColor: "Sets a supplementary color that highlights key survey elements.",
            panelBackgroundTransparency: "Adjusts the transparency of panels and question boxes relative to the survey background.",
            questionBackgroundTransparency: "Adjusts the transparency of input elements relative to the survey background.",
            cornerRadius: "Sets the corner radius for all rectangular elements. Enable the Advanced Mode if you want to set individual corner radius values for input elements or panels and question boxes.",
            "--sjs-general-backcolor-dim": "Sets the main background color of the survey.",
        },
        header: {
            inheritWidthFrom: "The \"Same as container\" option auto-adjusts the header content area width to fit into the HTML element the survey is placed in.",
            textAreaWidth: "The width of the header area that contains the survey title and description, measured in pixels.",
            overlapEnabled: "When enabled, the top of the survey overlays the bottom of the header.",
            mobileHeight: "When set to 0, the height is calculated automatically to accommodate the header's content.",
        },
        panellayoutcolumn: {
            effectiveWidth: "Accepts values %.",
            questionTitleWidth: "Accepts values px."
        },
        progressBarInheritWidthFrom: "The \"Same as container\" option auto-adjusts the progress bar area width to fit into the HTML element the survey is placed in."
    },
    // Properties
    p: {
        title: {
            name: "title",
            title: "Leave it empty, if it is the same as 'Name'"
        },
        multiSelect: "Allow multiple selection",
        showLabel: "Show image and video captions",
        swapOrder: "Swap the order of Yes and No",
        value: "Value",
        tabAlign: "Tab alignment",
        sourceType: "File source type",
        fitToContainer: "Fit to container",
        setValueExpression: "Set value expression",
        description: "Description",
        logoFit: "Logo fit",
        pages: "Pages",
        questions: "Questions",
        triggers: "Triggers",
        calculatedValues: "Custom variables",
        surveyId: "Survey id",
        surveyPostId: "Survey post id",
        surveyShowDataSaving: "Survey show data saving",
        questionDescriptionLocation: "Question description alignment",
        progressBarType: "Progress bar type",
        showTOC: "Show table of contents (TOC)",
        tocLocation: "TOC alignment",
        questionTitlePattern: "Question title pattern",
        widthMode: "Survey width mode",
        showBrandInfo: "Show brand info",
        useDisplayValuesInDynamicTexts: "Use display values in dynamic texts",
        visibleIf: "Visible if",
        defaultValueExpression: "Default value expression",
        requiredIf: "Required if",
        resetValueIf: "Reset value if",
        setValueIf: "Set value if",
        validators: "Validation rules",
        bindings: "Bindings",
        renderAs: "Render as",
        attachOriginalItems: "Attach original items",
        choices: "Choices",
        choicesByUrl: "Choices by url",
        currency: "Currency",
        cellHint: "Cell hint",
        totalMaximumFractionDigits: "Total maximum fraction digits",
        totalMinimumFractionDigits: "Total minimum fraction digits",
        columns: "Columns",
        detailElements: "Detail elements",
        allowAdaptiveActions: "Allow adaptive actions",
        defaultRowValue: "Default row value",
        detailPanelShowOnAdding: "Detail panel show on adding",
        choicesLazyLoadEnabled: "Choices lazy load enabled",
        choicesLazyLoadPageSize: "Choices lazy load page size",
        inputFieldComponent: "Input field component",
        itemComponent: "Item component",
        min: "Min",
        max: "Max",
        minValueExpression: "Min value expression",
        maxValueExpression: "Max value expression",
        step: "Step",
        dataList: "Items for auto-suggest",
        itemSize: "Input field width (in characters)",
        itemTitleWidth: "Item label width (in px)",
        inputTextAlignment: "Input value alignment",
        elements: "Elements",
        content: "Content",
        navigationButtonsVisibility: "Show/hide navigation buttons",
        navigationTitle: "Navigation title",
        navigationDescription: "Navigation description",
        longTap: "Long tap",
        autoGrow: "Expand input field dynamically",
        allowResize: "Enable resize handle",
        acceptCarriageReturn: "Accept carriage return",
        displayMode: "Display mode",
        rateType: "Rate type",
        label: "Label",
        contentMode: "Content mode",
        imageFit: "Image and thumbnail fit",
        altText: "Alt text",
        height: "Height",
        mobileHeight: "Height on smartphones",
        penColor: "Pen color",
        backgroundColor: "Background color",
        templateElements: "Template elements",
        operator: "Operator",
        isVariable: "Is variable",
        runExpression: "Run expression",
        showCaption: "Show caption",
        iconName: "Icon name",
        iconSize: "Icon size",
        precision: "Precision",
        matrixDragHandleArea: "Matrix drag handle area",
        backgroundImage: "Background image",
        backgroundImageFit: "Background image fit",
        backgroundImageAttachment: "Background image attachment",
        backgroundOpacity: "Background opacity",
        selectToRankEnabled: "Allow selective ranking",
        selectToRankAreasLayout: "Ranking area alignment",
        selectToRankEmptyRankedAreaText: "Text to show if all options are selected",
        selectToRankEmptyUnrankedAreaText: "Placeholder text for the ranking area",
        allowCameraAccess: "Allow camera access",
        scaleColorMode: "Rating icon color mode",
        rateColorMode: "Smileys color scheme",
        copyDisplayValue: "Copy display value",
        effectiveColSpan: "Column span",
        progressBarInheritWidthFrom: "Progress bar area width",
    },
    theme: {
        advancedMode: "Advanced mode",
        pageTitle: "Page",
        questionTitle: "Question box",
        editorPanel: "Input element",
        lines: "Lines",
        primaryDefaultColor: "Default",
        primaryDarkColor: "Hover",
        primaryLightColor: "Selected",
        backgroundDimColor: "Background color",
        cornerRadius: "Corner radius",
        backcolor: "Default background",
        hovercolor: "Hover background",
        borderDecoration: "Border decoration",
        fontColor: "Font color",
        backgroundColor: "Background color",
        primaryForecolor: "Default color",
        primaryForecolorLight: "Disabled color",
        font: "Font",
        borderDefault: "Darker",
        borderLight: "Lighter",
        fontFamily: "Font family",
        fontWeightRegular: "Regular",
        fontWeightHeavy: "Heavy",
        fontWeightSemiBold: "Semi-bold",
        fontWeightBold: "Bold",
        color: "Color",
        placeholderColor: "Placeholder color",
        size: "Size",
        opacity: "Opacity",
        boxShadowX: "X",
        boxShadowY: "Y",
        boxShadowAddRule: "Add Shadow Effect",
        boxShadowBlur: "Blur",
        boxShadowSpread: "Spread",
        boxShadowDrop: "Drop",
        boxShadowInner: "Inner",
        names: {
            default: "Default",
            sharp: "Sharp",
            borderless: "Borderless",
            flat: "Flat",
            plain: "Plain",
            doubleborder: "Double Border",
            layered: "Layered",
            solid: "Solid",
            threedimensional: "3D",
            contrast: "Contrast"
        },
        colors: {
            teal: "Teal",
            blue: "Blue",
            purple: "Purple",
            orchid: "Orchid",
            tulip: "Tulip",
            brown: "Brown",
            green: "Green",
            gray: "Gray"
        },
    },
    creatortheme: {
        "--sjs-special-background": "Surface background",
        "--sjs-primary-background-500": "Primary",
        "--sjs-secondary-background-500": "Secondary",
        "surfaceScale": "Surface",
        "userInterfaceBaseUnit": "UI elements",
        "fontScale": "Font",
        names: {
            "sc2020": "Survey Creator 2020",
            "default-light": "Light",
            "default-dark": "Dark",
            "default-contrast": "Contrast"
        },
    }
};
// Uncomment the line below if you create a custom dictionary.
// Replace "en" with a custom locale code (for example, "fr" or "de"),
// Replace `enStrings` with the name of the variable that contains the custom dictionary.
// setupLocale({ localeCode: "en", strings: enStrings });


/***/ }),

/***/ "./src/pages-controller.ts":
/*!*********************************!*\
  !*** ./src/pages-controller.ts ***!
  \*********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PagesController: () => (/* binding */ PagesController)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


var PagesController = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PagesController, _super);
    function PagesController(creator) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.onPagesChanged = _this.addEvent();
        _this.onCurrentPageChanged = _this.addEvent();
        _this.currentPageChangedFunc = function (sender, options) {
            _this.page2Display = _this.survey.currentPage;
            _this.onCurrentPageChanged.fire(_this, {});
        };
        _this.onSurveyChanged();
        return _this;
    }
    Object.defineProperty(PagesController.prototype, "survey", {
        get: function () {
            return this.creator.survey;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PagesController.prototype, "pages", {
        get: function () {
            return this.survey.pages;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PagesController.prototype, "currentPage", {
        get: function () {
            return this.survey.currentPage;
        },
        set: function (value) {
            this.survey.currentPage = value;
            this.page2Display = value;
        },
        enumerable: false,
        configurable: true
    });
    PagesController.prototype.selectPage = function (value) {
        this.currentPage = value;
        this.creator.selectElement(value);
    };
    PagesController.prototype.getDisplayName = function (page) {
        if (!page)
            return "";
        return this.creator.getObjectDisplayName(page, "page-selector");
    };
    PagesController.prototype.raisePagesChanged = function () {
        this.page2Display = this.survey.currentPage;
        this.onPagesChanged.fire(this, {});
    };
    PagesController.prototype.onSurveyChanged = function () {
        this.removeFunctions();
        this.surveyValue = this.creator.survey;
        if (!this.surveyValue)
            return;
        this.raisePagesChanged();
        this.page2Display = this.survey.currentPage;
        this.surveyValue.onCurrentPageChanged.add(this.currentPageChangedFunc);
    };
    PagesController.prototype.dispose = function () {
        _super.prototype.dispose.call(this);
        this.removeFunctions();
    };
    PagesController.prototype.removeFunctions = function () {
        if (!!this.surveyValue && !this.surveyValue.isDisposed) {
            this.surveyValue.onCurrentPageChanged.remove(this.currentPageChangedFunc);
        }
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], PagesController.prototype, "page2Display", void 0);
    return PagesController;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/plugins/undo-redo/index.ts":
/*!****************************************!*\
  !*** ./src/plugins/undo-redo/index.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UndoRedoPlugin: () => (/* binding */ UndoRedoPlugin),
/* harmony export */   ignoreUndoRedo: () => (/* binding */ ignoreUndoRedo),
/* harmony export */   undoRedoTransaction: () => (/* binding */ undoRedoTransaction)
/* harmony export */ });
/* harmony import */ var _undo_redo_controller__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./undo-redo-controller */ "./src/plugins/undo-redo/undo-redo-controller.ts");

var UndoRedoPlugin = /** @class */ (function () {
    function UndoRedoPlugin(creator) {
        var _this = this;
        this.creator = creator;
        this.model = undefined;
        this.model = new _undo_redo_controller__WEBPACK_IMPORTED_MODULE_0__.UndoRedoController(creator);
        this.model.createActions().forEach(function (action) { return creator.toolbar.actions.push(action); });
        creator.registerShortcut("undo", {
            affectedTab: "designer",
            hotKey: {
                ctrlKey: true,
                keyCode: 90,
            },
            macOsHotkey: {
                keyCode: 90,
            },
            execute: function () { return _this.model.undo(); }
        });
        creator.registerShortcut("redo", {
            affectedTab: "designer",
            hotKey: {
                ctrlKey: true,
                keyCode: 89,
            },
            macOsHotkey: {
                keyCode: 89,
            },
            execute: function () { return _this.model.redo(); }
        });
    }
    UndoRedoPlugin.prototype.activate = function () { };
    UndoRedoPlugin.prototype.deactivate = function () { return true; };
    UndoRedoPlugin.prototype.update = function () { };
    UndoRedoPlugin.prototype.addFooterActions = function () {
        this.model.undoAction && (this.creator.footerToolbar.actions.splice(2, 0, this.model.undoAction));
        this.model.redoAction && (this.creator.footerToolbar.actions.splice(3, 0, this.model.redoAction));
    };
    return UndoRedoPlugin;
}());

function undoRedoTransaction(transactionName, undoRedoManagerProperty) {
    if (undoRedoManagerProperty === void 0) { undoRedoManagerProperty = "undoRedoManager"; }
    return function (target, propertyKey, descriptor) {
        var wrappedFunction = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var undoRedoManager = this[undoRedoManagerProperty];
            try {
                undoRedoManager && undoRedoManager.startTransaction(transactionName || propertyKey);
                var result = wrappedFunction.apply(this, args);
                return result;
            }
            finally {
                undoRedoManager && undoRedoManager.stopTransaction();
            }
        };
        return descriptor;
    };
}
function ignoreUndoRedo(undoRedoManagerProperty) {
    if (undoRedoManagerProperty === void 0) { undoRedoManagerProperty = "undoRedoManager"; }
    return function (target, propertyKey, descriptor) {
        var wrappedFunction = descriptor.value;
        descriptor.value = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var undoRedoManager = this[undoRedoManagerProperty];
            try {
                undoRedoManager && undoRedoManager.suspend();
                var result = wrappedFunction.apply(this, args);
                return result;
            }
            finally {
                undoRedoManager && undoRedoManager.resume();
            }
        };
        return descriptor;
    };
}


/***/ }),

/***/ "./src/plugins/undo-redo/undo-redo-controller.ts":
/*!*******************************************************!*\
  !*** ./src/plugins/undo-redo/undo-redo-controller.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   UndoRedoController: () => (/* binding */ UndoRedoController)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _undo_redo_manager__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./undo-redo-manager */ "./src/plugins/undo-redo/undo-redo-manager.ts");



var UndoRedoController = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(UndoRedoController, _super);
    function UndoRedoController(creator) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.undoRedoManager = undefined;
        /**
         * The event is called before undo happens.
         * options.canUndo a boolean value. It is true by default. Set it false to hide prevent undo operation.
         */
        _this.onBeforeUndo = new survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase();
        /**
          * The event is called before redo happens.
          * options.canRedo a boolean value. It is true by default. Set it false to hide prevent redo operation.
          */
        _this.onBeforeRedo = new survey_core__WEBPACK_IMPORTED_MODULE_1__.EventBase();
        _this.updateSurvey();
        return _this;
    }
    UndoRedoController.prototype.onSurveyPropertyValueChangedCallback = function (name, oldValue, newValue, sender, arrayChanges) {
        if (!this.undoRedoManager || !this.undoRedoManager.isCorrectProperty(sender, name)) {
            return;
        }
        var canUndoRedoMerge = this.undoRedoManager.tryMergeTransaction(sender, name, newValue);
        if (!canUndoRedoMerge) {
            this.undoRedoManager.startTransaction(name + " changed");
            this.undoRedoManager.onPropertyValueChanged(name, oldValue, newValue, sender, arrayChanges);
            this.creator.updateElementsOnLocaleChanged(sender, name);
            this.creator.updateConditionsOnNameChanged(sender, name, oldValue);
            this.undoRedoManager.stopTransaction();
        }
        else {
            this.creator.notifySurveyPropertyChanged({
                name: name,
                target: sender,
                oldValue: oldValue,
                newValue: newValue
            });
        }
    };
    UndoRedoController.prototype.updateSurvey = function () {
        var _this = this;
        var surveyModel = this.creator.survey;
        if (!!surveyModel) {
            surveyModel.onPropertyValueChangedCallback = function (name, oldValue, newValue, sender, arrayChanges) {
                _this.onSurveyPropertyValueChangedCallback(name, oldValue, newValue, sender, arrayChanges);
            };
        }
        this.undoRedoManager = new _undo_redo_manager__WEBPACK_IMPORTED_MODULE_2__.UndoRedoManager();
        this.undoRedoManager.changesFinishedCallback = function (actions, isUndo) {
            if (_this.notifySurveyMoveItem(actions, isUndo))
                return;
            for (var i = actions.length - 1; i >= 0; i--) {
                var action = actions[i];
                if (!!action) {
                    var changes = action.getChanges(isUndo);
                    _this.creator.notifySurveyPropertyChanged({
                        name: changes.propertyName,
                        target: changes.object,
                        oldValue: changes.oldValue,
                        newValue: changes.newValue
                    });
                }
            }
        };
        this.undoRedoManager.canUndoRedoCallback = function () {
            _this.updateUndeRedoActions();
        };
    };
    UndoRedoController.prototype.notifySurveyMoveItem = function (actions, isUndo) {
        if (actions.length !== 2)
            false;
        var act1 = actions[0];
        var act2 = actions[1];
        if (!act1 || !act2)
            return false;
        var changes1 = act1.getChanges(isUndo);
        var changes2 = act2.getChanges(isUndo);
        if (changes1.object !== changes2.object || changes1.propertyName !== changes2.propertyName)
            return false;
        var act1Del = act1.getDeletedElement(isUndo);
        var act1Ins = act1.getInsertedElement(isUndo);
        var act2Del = act2.getDeletedElement(isUndo);
        var act2Ins = act2.getInsertedElement(isUndo);
        if (act1Del === act1Ins || (act1Del !== act2Ins && act1Ins !== act2Del))
            return false;
        var indexFrom = act1Del ? act1.getIndex() : act2.getIndex();
        var indexTo = act1Ins ? act1.getIndex() : act2.getIndex();
        if (indexFrom === indexTo && !!act1Del && !!act2Ins && !act1Ins && !act2Del) {
            this.creator.notifySurveyItemConverted(!isUndo ? act2Ins : act1Del, !isUndo ? act1Del : act2Ins);
        }
        else {
            this.creator.notifySurveyItemMoved({
                arrayName: changes1.propertyName,
                parent: changes1.object,
                element: act1Del ? act1Del : act1Ins,
                indexFrom: !isUndo ? indexFrom : indexTo,
                indexTo: !isUndo ? indexTo : indexFrom
            });
        }
        return true;
    };
    UndoRedoController.prototype.selectElementAfterUndo = function () {
        this.selectElementAfterUndoCore(this.creator.selectedElement);
    };
    UndoRedoController.prototype.selectElementAfterUndoCore = function (obj) {
        if (!!obj &&
            !obj.isDisposed &&
            !!obj.getSurvey() &&
            (!this.creator.isObjQuestion(obj) || !!obj["parent"])) {
            this.creator.selectElement(obj);
            return;
        }
        this.creator.selectElement(this.creator.survey);
    };
    UndoRedoController.prototype.undo = function () {
        if (!this.undoRedoManager)
            return;
        this.undoRedoManager.suspend();
        var options = { canUndo: this.undoRedoManager.canUndo() };
        this.onBeforeUndo.fire(this.creator, options);
        this.creator.onBeforeUndo.fire(this.creator, options);
        if (options.canUndo) {
            this.undoRedoManager.undo();
            this.selectElementAfterUndo();
        }
        this.undoRedoManager.resume();
    };
    UndoRedoController.prototype.redo = function () {
        if (!this.undoRedoManager)
            return;
        var options = { canRedo: this.undoRedoManager.canRedo() };
        this.onBeforeRedo.fire(this.creator, options);
        this.creator.onBeforeRedo.fire(this.creator, options);
        if (options.canRedo) {
            var item = this.undoRedoManager.redo();
            this.selectElementAfterUndo();
        }
    };
    UndoRedoController.prototype.startTransaction = function (name) {
        if (name === void 0) { name = ""; }
        this.undoRedoManager && this.undoRedoManager.startTransaction(name);
    };
    UndoRedoController.prototype.stopTransaction = function () {
        this.undoRedoManager && this.undoRedoManager.stopTransaction();
    };
    UndoRedoController.prototype.createActions = function () {
        var _this = this;
        var items = [];
        this.undoAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "action-undo",
            iconName: "icon-undo",
            iconSize: "auto",
            locTitleName: "ed.undo",
            showTitle: false,
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.creator.activeTab === "designer"; }),
            needSeparator: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                return _this.creator.isMobileView;
            }),
            action: function () { return _this.undo(); }
        });
        this.redoAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "action-redo",
            iconName: "icon-redo",
            iconSize: "auto",
            locTitleName: "ed.redo",
            showTitle: false,
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.creator.activeTab === "designer"; }),
            action: function () { return _this.redo(); }
        });
        items.push(this.undoAction);
        items.push(this.redoAction);
        this.updateUndeRedoActions();
        return items;
    };
    UndoRedoController.prototype.updateUndeRedoActions = function () {
        this.undoAction.enabled = this.undoRedoManager.canUndo();
        this.redoAction.enabled = this.undoRedoManager.canRedo();
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], UndoRedoController.prototype, "undoRedoManager", void 0);
    return UndoRedoController;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/plugins/undo-redo/undo-redo-manager.ts":
/*!****************************************************!*\
  !*** ./src/plugins/undo-redo/undo-redo-manager.ts ***!
  \****************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Transaction: () => (/* binding */ Transaction),
/* harmony export */   UndoRedoAction: () => (/* binding */ UndoRedoAction),
/* harmony export */   UndoRedoArrayAction: () => (/* binding */ UndoRedoArrayAction),
/* harmony export */   UndoRedoManager: () => (/* binding */ UndoRedoManager)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _editable_object__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../../editable-object */ "./src/editable-object.ts");


var UndoRedoManager = /** @class */ (function () {
    function UndoRedoManager() {
        this._ignoreChanges = false;
        this._isExecuting = false;
        this._preparingTransaction = null;
        this._transactions = [];
        this._currentTransactionIndex = -1;
        this.transactionCounter = 0;
    }
    UndoRedoManager.prototype.onPropertyValueChanged = function (name, oldValue, newValue, sender, arrayChanges) {
        if (_editable_object__WEBPACK_IMPORTED_MODULE_1__.EditableObject.isCopyObject(sender))
            return;
        if (this.isIgnoring)
            return;
        if (sender["ignoreUndoRedo"] === true)
            return;
        var transaction = this._preparingTransaction;
        var action = arrayChanges
            ? new UndoRedoArrayAction(name, sender, arrayChanges)
            : new UndoRedoAction(name, oldValue, newValue, sender);
        if (!transaction) {
            transaction = new Transaction(name);
            transaction.addAction(action);
            this._addTransaction(transaction);
            return;
        }
        transaction.addAction(action);
    };
    UndoRedoManager.prototype.isCorrectProperty = function (sender, propertyName) {
        var prop = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.getOriginalProperty(sender, propertyName);
        return !!prop && prop.isSerializable;
    };
    UndoRedoManager.prototype.tryMergeTransaction = function (sender, propertyName, newValue) {
        if (propertyName === "name")
            return false; //TODO check on
        var lastTransaction = this._getCurrentTransaction();
        if (!lastTransaction || lastTransaction.actions.length == 0)
            return false;
        var lastAction = lastTransaction.actions[lastTransaction.actions.length - 1];
        return lastAction.tryMerge(sender, propertyName, newValue);
    };
    UndoRedoManager.prototype.isCopyObject = function (sender) { };
    UndoRedoManager.prototype._cutOffTail = function () {
        if (this._currentTransactionIndex + 1 !== this._transactions.length) {
            this._transactions.length = this._currentTransactionIndex + 1;
        }
    };
    Object.defineProperty(UndoRedoManager.prototype, "isIgnoring", {
        get: function () {
            return this._ignoreChanges || this._isExecuting;
        },
        enumerable: false,
        configurable: true
    });
    UndoRedoManager.prototype._addTransaction = function (transaction) {
        if (transaction.isEmpty())
            return;
        this._cutOffTail();
        if (this._transactions[this._currentTransactionIndex] !== transaction) {
            this._transactions.push(transaction);
            this._currentTransactionIndex++;
        }
        this.canUndoRedoCallback();
    };
    UndoRedoManager.prototype._getCurrentTransaction = function () {
        var index = this._currentTransactionIndex;
        var currentTransaction = this._transactions[index];
        return currentTransaction;
    };
    UndoRedoManager.prototype._getNextTransaction = function () {
        var index = this._currentTransactionIndex;
        var nextTransaction = this._transactions[index + 1];
        return nextTransaction;
    };
    UndoRedoManager.prototype.notifyChangesFinished = function (transaction, isUndo) {
        if (isUndo === void 0) { isUndo = false; }
        if (transaction.actions.length > 0) {
            !!this.changesFinishedCallback &&
                this.changesFinishedCallback(transaction.actions, isUndo);
            // this.changesFinishedCallback(transaction.actions[0].getChanges(isUndo));
        }
    };
    UndoRedoManager.prototype.canUndoRedoCallback = function () { };
    UndoRedoManager.prototype.startTransaction = function (name) {
        if (this.isIgnoring)
            return;
        this.transactionCounter++;
        if (this._preparingTransaction)
            return;
        this._preparingTransaction = new Transaction(name);
    };
    UndoRedoManager.prototype.stopTransaction = function () {
        if (this.isIgnoring)
            return;
        if (this.transactionCounter > 0) {
            this.transactionCounter--;
        }
        if (!this._preparingTransaction || this.transactionCounter > 0)
            return;
        this._addTransaction(this._preparingTransaction);
        if (this.transactionCounter === 0) {
            this.notifyChangesFinished(this._preparingTransaction);
        }
        this._preparingTransaction = null;
    };
    UndoRedoManager.prototype.setUndoCallbackForTransaction = function (callback) {
        if (!this._preparingTransaction)
            return;
        this._preparingTransaction.undoCallback = callback;
    };
    Object.defineProperty(UndoRedoManager.prototype, "isProcessingUndoRedo", {
        get: function () {
            return this._isExecuting === true;
        },
        enumerable: false,
        configurable: true
    });
    UndoRedoManager.prototype.canUndo = function () {
        return !!this._getCurrentTransaction();
    };
    UndoRedoManager.prototype.undo = function () {
        var currentTransaction = this._getCurrentTransaction();
        if (!this.canUndo())
            return;
        this._isExecuting = true;
        currentTransaction.rollback();
        this._isExecuting = false;
        this._currentTransactionIndex--;
        this.canUndoRedoCallback();
        this.notifyChangesFinished(currentTransaction, true);
    };
    UndoRedoManager.prototype.canRedo = function () {
        return !!this._getNextTransaction();
    };
    UndoRedoManager.prototype.redo = function () {
        var nextTransaction = this._getNextTransaction();
        if (!this.canRedo())
            return;
        this._isExecuting = true;
        nextTransaction.apply();
        this._isExecuting = false;
        this._currentTransactionIndex++;
        this.canUndoRedoCallback();
        this.notifyChangesFinished(nextTransaction);
    };
    UndoRedoManager.prototype.suspend = function () {
        this._ignoreChanges = true;
    };
    UndoRedoManager.prototype.resume = function () {
        this._ignoreChanges = false;
    };
    return UndoRedoManager;
}());

var Transaction = /** @class */ (function () {
    function Transaction(_name) {
        this._name = _name;
        this._actions = [];
        this.undoCallback = function () { };
    }
    Transaction.prototype.apply = function () {
        var actions = this._actions;
        for (var index = 0; index < actions.length; index++) {
            var action = actions[index];
            action.apply();
        }
    };
    Transaction.prototype.rollback = function () {
        var actions = this._actions;
        for (var index = actions.length - 1; index >= 0; index--) {
            var action = actions[index];
            action.rollback();
        }
        this.undoCallback();
    };
    Transaction.prototype.addAction = function (action) {
        this._actions.push(action);
    };
    Transaction.prototype.isEmpty = function () {
        return this._actions.length === 0;
    };
    Object.defineProperty(Transaction.prototype, "actions", {
        get: function () {
            return this._actions;
        },
        enumerable: false,
        configurable: true
    });
    return Transaction;
}());

var UndoRedoAction = /** @class */ (function () {
    function UndoRedoAction(_propertyName, _oldValue, _newValue, _sender) {
        this._propertyName = _propertyName;
        this._oldValue = _oldValue;
        this._newValue = _newValue;
        this._sender = _sender;
        this.tickCount = new Date().getTime();
    }
    UndoRedoAction.prototype.apply = function () {
        this._sender[this._propertyName] = this._newValue;
    };
    UndoRedoAction.prototype.rollback = function () {
        this._sender[this._propertyName] = this._oldValue;
    };
    UndoRedoAction.prototype.getChanges = function (isUndo) {
        if (isUndo === void 0) { isUndo = false; }
        return {
            object: this._sender,
            propertyName: this._propertyName,
            oldValue: isUndo ? this._newValue : this._oldValue,
            newValue: isUndo ? this._oldValue : this._newValue
        };
    };
    UndoRedoAction.prototype.getDeletedElement = function (isUndo) { return undefined; };
    UndoRedoAction.prototype.getInsertedElement = function (isUndo) { return undefined; };
    UndoRedoAction.prototype.getIndex = function () { return -1; };
    UndoRedoAction.prototype.tryMerge = function (sender, propertyName, newValue) {
        if (sender !== this._sender || propertyName !== this._propertyName || newValue == this._oldValue)
            return false;
        var prop = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.getOriginalProperty(sender, propertyName);
        if (!prop || (prop.type !== "string" && prop.type !== "text"))
            return false;
        if (new Date().getTime() - this.tickCount > UndoRedoAction.maximumMergeTime)
            return false;
        this._newValue = newValue;
        return true;
    };
    UndoRedoAction.maximumMergeTime = 1000;
    return UndoRedoAction;
}());

var UndoRedoArrayAction = /** @class */ (function () {
    function UndoRedoArrayAction(_propertyName, _sender, arrayChanges) {
        this._propertyName = _propertyName;
        this._sender = _sender;
        this._index = 0;
        this._itemsToAdd = [];
        this._deletedItems = [];
        this.survey = _sender.getSurvey();
        this._index = arrayChanges.index;
        this._itemsToAdd = arrayChanges.itemsToAdd;
        this._deletedItems = arrayChanges.deletedItems;
    }
    UndoRedoArrayAction.prototype.apply = function () {
        this.rollback();
    };
    UndoRedoArrayAction.prototype.rollback = function () {
        this._sender = this.getSenderElement();
        if (!this._sender)
            return;
        var array = this._sender[this._propertyName];
        var index = this._index;
        var deleteCount = this._itemsToAdd.length;
        var itemsToAdd = this.getItemsToAdd();
        this._deletedItems = array.splice.apply(array, [index, deleteCount].concat(itemsToAdd));
        this._itemsToAdd = [].concat(itemsToAdd);
    };
    UndoRedoArrayAction.prototype.getChanges = function () {
        return {
            object: this._sender,
            propertyName: this._propertyName,
            oldValue: this._deletedItems,
            newValue: this._itemsToAdd
        };
    };
    UndoRedoArrayAction.prototype.getDeletedElement = function (isUndo) { return this.getMovedElement(this._deletedItems, this._itemsToAdd, isUndo); };
    UndoRedoArrayAction.prototype.getInsertedElement = function (isUndo) { return this.getMovedElement(this._itemsToAdd, this._deletedItems, isUndo); };
    UndoRedoArrayAction.prototype.getIndex = function () { return this._index; };
    UndoRedoArrayAction.prototype.getMovedElement = function (items1, items2, isUndo) {
        var items = isUndo ? items2 : items1;
        if (Array.isArray(items) && items.length === 1)
            return items[0];
        return undefined;
    };
    UndoRedoArrayAction.prototype.tryMerge = function (sender, propertyName, newValue) {
        return false;
    };
    UndoRedoArrayAction.prototype.getSenderElement = function () {
        if (!this._sender.isDisposed || !this.survey)
            return this._sender;
        var name = this._sender["name"];
        if (this._sender["isPage"] === true) {
            if (this.survey.pages.length === 0)
                return this.survey.addNewPage();
            return this.survey.getPageByName(name);
        }
        if (this._sender["isPanel"] === true)
            return this.survey.getPanelByName(name);
        if (this._sender["isQuestion"] === true)
            return this.survey.getQuestionByName(name);
        return this._sender;
    };
    UndoRedoArrayAction.prototype.getItemsToAdd = function () {
        var res = [];
        for (var i = 0; i < this._deletedItems.length; i++) {
            var obj = this._deletedItems[i];
            if (obj.isDisposed && obj.getType) {
                var json = obj.toJSON();
                obj = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.createClass(obj.getType());
                obj.fromJSON(json);
            }
            res.push(obj);
        }
        return res;
    };
    return UndoRedoArrayAction;
}());



/***/ }),

/***/ "./src/presets/presets-base.ts":
/*!*************************************!*\
  !*** ./src/presets/presets-base.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CreatorPresetBase: () => (/* binding */ CreatorPresetBase)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);

var CreatorPresetBase = /** @class */ (function () {
    function CreatorPresetBase() {
        this.onApplied = new survey_core__WEBPACK_IMPORTED_MODULE_0__.EventBase();
        this.children = [];
        this.setupPresets();
    }
    CreatorPresetBase.prototype.setJson = function (json) {
        var _this = this;
        if (!json && this.applyEmptyJson())
            json = {};
        this.json = json;
        this.children.forEach(function (item) { return item.setJson(_this.json && item.getPath() ? _this.json[item.getPath()] : _this.json); });
    };
    CreatorPresetBase.prototype.apply = function (creator) {
        if (!this.json)
            return;
        if (!!creator) {
            this.applyCore(creator);
            this.children.forEach(function (item) { return item.apply(creator); });
        }
        this.onApplied.fire(this, {});
    };
    CreatorPresetBase.prototype.applyEmptyJson = function () { return false; };
    CreatorPresetBase.prototype.applyCore = function (creator) { };
    CreatorPresetBase.prototype.createPresets = function () {
        return [];
    };
    CreatorPresetBase.prototype.setupPresets = function () {
        this.addPresets(this.createPresets());
    };
    CreatorPresetBase.prototype.addPreset = function (preset) {
        this.children.push(preset);
    };
    CreatorPresetBase.prototype.addPresets = function (presets) {
        var _this = this;
        presets.forEach(function (preset) { return _this.addPreset(preset); });
    };
    return CreatorPresetBase;
}());



/***/ }),

/***/ "./src/presets/presets-languages.ts":
/*!******************************************!*\
  !*** ./src/presets/presets-languages.ts ***!
  \******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CreatorPresetLanguages: () => (/* binding */ CreatorPresetLanguages)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var _presets_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./presets-base */ "./src/presets/presets-base.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_2__);



var CreatorPresetLanguages = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorPresetLanguages, _super);
    function CreatorPresetLanguages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreatorPresetLanguages.prototype.getPath = function () { return "languages"; };
    CreatorPresetLanguages.prototype.applyEmptyJson = function () { return true; };
    CreatorPresetLanguages.prototype.applyCore = function (creator) {
        var _a, _b, _c;
        _super.prototype.applyCore.call(this, creator);
        var locale = ((_a = this.json) === null || _a === void 0 ? void 0 : _a.creator) || "";
        var supportedLocales = ((_b = this.json) === null || _b === void 0 ? void 0 : _b.surveyLocales) || [];
        var useEnglishNames = (_c = this.json) === null || _c === void 0 ? void 0 : _c.useEnglishNames;
        creator.locale = locale;
        survey_core__WEBPACK_IMPORTED_MODULE_2__.surveyLocalization.supportedLocales = supportedLocales;
        survey_core__WEBPACK_IMPORTED_MODULE_2__.surveyLocalization.showNamesInEnglish = useEnglishNames === true;
    };
    return CreatorPresetLanguages;
}(_presets_base__WEBPACK_IMPORTED_MODULE_1__.CreatorPresetBase));



/***/ }),

/***/ "./src/presets/presets-properties.ts":
/*!*******************************************!*\
  !*** ./src/presets/presets-properties.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CreatorPresetPropertyGrid: () => (/* binding */ CreatorPresetPropertyGrid),
/* harmony export */   CreatorPresetPropertyGridDefinition: () => (/* binding */ CreatorPresetPropertyGridDefinition)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var _presets_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./presets-base */ "./src/presets/presets-base.ts");


var CreatorPresetPropertyGridDefinition = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorPresetPropertyGridDefinition, _super);
    function CreatorPresetPropertyGridDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreatorPresetPropertyGridDefinition.prototype.getPath = function () { return "definition"; };
    CreatorPresetPropertyGridDefinition.prototype.applyCore = function (creator) {
        creator.setPropertyGridDefinition(this.json);
    };
    return CreatorPresetPropertyGridDefinition;
}(_presets_base__WEBPACK_IMPORTED_MODULE_1__.CreatorPresetBase));

var CreatorPresetPropertyGrid = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorPresetPropertyGrid, _super);
    function CreatorPresetPropertyGrid() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreatorPresetPropertyGrid.prototype.getPath = function () { return "propertyGrid"; };
    CreatorPresetPropertyGrid.prototype.createPresets = function () {
        return [new CreatorPresetPropertyGridDefinition()];
    };
    return CreatorPresetPropertyGrid;
}(_presets_base__WEBPACK_IMPORTED_MODULE_1__.CreatorPresetBase));



/***/ }),

/***/ "./src/presets/presets-tabs.ts":
/*!*************************************!*\
  !*** ./src/presets/presets-tabs.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CreatorPresetTabs: () => (/* binding */ CreatorPresetTabs)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var _presets_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./presets-base */ "./src/presets/presets-base.ts");


var CreatorPresetTabs = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorPresetTabs, _super);
    function CreatorPresetTabs() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreatorPresetTabs.prototype.getPath = function () { return "tabs"; };
    CreatorPresetTabs.prototype.applyCore = function (creator) {
        _super.prototype.applyCore.call(this, creator);
        var items = this.json["items"] || [];
        var tab = this.json.activeTab || (items.length > 0 ? items[0] : "");
        if (items.length > 0 && items.indexOf(tab) < 0) {
            tab = items[0];
        }
        if (!!tab && creator.activeTab !== tab) {
            var activePlugin = creator.getPlugin(creator.activeTab);
            if (!!(activePlugin === null || activePlugin === void 0 ? void 0 : activePlugin.deactivate)) {
                activePlugin.deactivate();
            }
        }
        this.applyTabs(creator, items);
        if (tab) {
            creator.activeTab = tab === "preview" ? "test" : tab;
        }
    };
    CreatorPresetTabs.prototype.applyTabs = function (creator, items) {
        if (!Array.isArray(items))
            return;
        creator.setTabs(items);
    };
    return CreatorPresetTabs;
}(_presets_base__WEBPACK_IMPORTED_MODULE_1__.CreatorPresetBase));



/***/ }),

/***/ "./src/presets/presets-toolbox.ts":
/*!****************************************!*\
  !*** ./src/presets/presets-toolbox.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CreatorPresetToolbox: () => (/* binding */ CreatorPresetToolbox),
/* harmony export */   CreatorPresetToolboxConfigurator: () => (/* binding */ CreatorPresetToolboxConfigurator),
/* harmony export */   CreatorPresetToolboxDefinition: () => (/* binding */ CreatorPresetToolboxDefinition)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var _presets_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./presets-base */ "./src/presets/presets-base.ts");


var CreatorPresetToolboxDefinition = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorPresetToolboxDefinition, _super);
    function CreatorPresetToolboxDefinition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreatorPresetToolboxDefinition.prototype.getPath = function () { return "definition"; };
    CreatorPresetToolboxDefinition.prototype.applyCore = function (creator) {
        _super.prototype.applyCore.call(this, creator);
        this.applyDefinition(creator, this.json);
    };
    CreatorPresetToolboxDefinition.prototype.applyDefinition = function (creator, definition) {
        var toolbox = creator.toolbox;
        toolbox.presetDefaultItems = this.getPresetDefaultItems(definition);
        if (Array.isArray(definition)) {
            definition.forEach(function (item) {
                var tItem = toolbox.getActionById(item.name);
                if (tItem) {
                    ["iconName", "title", "tooltip", "json"].forEach(function (propName) {
                        if (item[propName]) {
                            tItem[propName] = item[propName];
                        }
                    });
                }
            });
        }
    };
    CreatorPresetToolboxDefinition.prototype.getPresetDefaultItems = function (defintion) {
        if (!Array.isArray(defintion))
            return undefined;
        var def = JSON.parse(JSON.stringify(defintion));
        var res = new Array();
        def.forEach(function (item) {
            if (typeof item === "object" && !!item.name) {
                res.push(item);
            }
        });
        return res;
    };
    return CreatorPresetToolboxDefinition;
}(_presets_base__WEBPACK_IMPORTED_MODULE_1__.CreatorPresetBase));

var CreatorPresetToolboxConfigurator = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorPresetToolboxConfigurator, _super);
    function CreatorPresetToolboxConfigurator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreatorPresetToolboxConfigurator.prototype.getPath = function () { return ""; };
    CreatorPresetToolboxConfigurator.prototype.applyCore = function (creator) {
        if (!this.json)
            return;
        _super.prototype.applyCore.call(this, creator);
        creator.toolbox.showCategoryTitles = this.json.showCategoryTitles;
        this.applyItems(creator, this.json["items"]);
        this.applyCategories(creator, this.json["categories"]);
    };
    CreatorPresetToolboxConfigurator.prototype.applyItems = function (creator, items) {
        if (!Array.isArray(items))
            return;
        creator.toolbox.hasCategories = false;
        creator.toolbox.defineCategories([{ category: "general", items: items }]);
    };
    CreatorPresetToolboxConfigurator.prototype.applyCategories = function (creator, categories) {
        if (!Array.isArray(categories))
            return;
        creator.toolbox.hasCategories = true;
        creator.toolbox.defineCategories(categories);
    };
    return CreatorPresetToolboxConfigurator;
}(_presets_base__WEBPACK_IMPORTED_MODULE_1__.CreatorPresetBase));

var CreatorPresetToolbox = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorPresetToolbox, _super);
    function CreatorPresetToolbox() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CreatorPresetToolbox.prototype.getPath = function () { return "toolbox"; };
    CreatorPresetToolbox.prototype.createPresets = function () {
        return [new CreatorPresetToolboxDefinition(), new CreatorPresetToolboxConfigurator()];
    };
    return CreatorPresetToolbox;
}(_presets_base__WEBPACK_IMPORTED_MODULE_1__.CreatorPresetBase));



/***/ }),

/***/ "./src/presets/presets.ts":
/*!********************************!*\
  !*** ./src/presets/presets.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CreatorPreset: () => (/* binding */ CreatorPreset)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var _presets_base__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./presets-base */ "./src/presets/presets-base.ts");
/* harmony import */ var _presets_toolbox__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./presets-toolbox */ "./src/presets/presets-toolbox.ts");
/* harmony import */ var _presets_languages__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./presets-languages */ "./src/presets/presets-languages.ts");
/* harmony import */ var _presets_tabs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./presets-tabs */ "./src/presets/presets-tabs.ts");
/* harmony import */ var _presets_properties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./presets-properties */ "./src/presets/presets-properties.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");







var CreatorPreset = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CreatorPreset, _super);
    function CreatorPreset(json) {
        var _this = _super.call(this) || this;
        _this.setJson(json);
        return _this;
    }
    CreatorPreset.prototype.getPath = function () { return ""; };
    CreatorPreset.prototype.getJson = function () {
        return this.json;
    };
    CreatorPreset.prototype.apply = function (creator) {
        _super.prototype.apply.call(this, creator);
        this.applyLocalization();
        if (!!creator) {
            creator.updateLocalizedStrings();
        }
    };
    CreatorPreset.prototype.applyLocalization = function () {
        var _a;
        var strs = (_a = this.json) === null || _a === void 0 ? void 0 : _a.localization;
        if (!!strs) {
            _editorLocalization__WEBPACK_IMPORTED_MODULE_6__.editorLocalization.presetStrings = JSON.parse(JSON.stringify(strs));
        }
        else {
            _editorLocalization__WEBPACK_IMPORTED_MODULE_6__.editorLocalization.presetStrings = undefined;
        }
    };
    CreatorPreset.prototype.createPresets = function () {
        return [new _presets_languages__WEBPACK_IMPORTED_MODULE_3__.CreatorPresetLanguages(), new _presets_tabs__WEBPACK_IMPORTED_MODULE_4__.CreatorPresetTabs(), new _presets_toolbox__WEBPACK_IMPORTED_MODULE_2__.CreatorPresetToolbox(),
            new _presets_properties__WEBPACK_IMPORTED_MODULE_5__.CreatorPresetPropertyGrid()];
    };
    return CreatorPreset;
}(_presets_base__WEBPACK_IMPORTED_MODULE_1__.CreatorPresetBase));



/***/ }),

/***/ "./src/property-grid-theme/property-grid.ts":
/*!**************************************************!*\
  !*** ./src/property-grid-theme/property-grid.ts ***!
  \**************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   propertyGridCss: () => (/* binding */ propertyGridCss)
/* harmony export */ });
var propertyGridCss = {
    root: "spg-root-modern",
    container: "spg-container-modern",
    header: "spg-title spg-container-modern__title",
    body: "spg-body",
    bodyEmpty: "spg-body spg-body--empty",
    footer: "spg-footer spg-body__footer spg-clearfix",
    title: "",
    description: "",
    logo: "spg-logo",
    logoImage: "spg-logo__image",
    headerText: "spg-header__text",
    navigationButton: "",
    completedPage: "spg-completedpage",
    navigation: {
        complete: "spg-btn spg-footer__complete-btn",
        prev: "spg-btn spg-footer__prev-btn",
        next: "spg-btn spg-footer__next-btn",
        start: "spg-btn spg-footer__start-btn",
        preview: "spg-btn spg-footer__preview-btn",
        edit: "spg-btn spg-footer__edit-btn"
    },
    panel: {
        expandableAnimating: "",
        title: "spg-title spg-panel__title",
        titleBar: "sd-action-title-bar spg-action-title-bar",
        contentEnter: "spg-panel__content--enter",
        contentLeave: "spg-panel__content--leave",
        titleExpandable: "spg-panel__title--expandable",
        titleExpanded: "spg-panel__title--expanded",
        titleCollapsed: "spg-panel__title--collapsed",
        titleOnError: "spg-panel__title--error",
        description: "spg-description spg-panel__description",
        container: "spg-panel spg-row__panel",
        content: "spg-panel__content",
        icon: "spg-panel__icon",
        iconExpanded: "spg-panel__icon--expanded",
        footer: "spg-panel__footer",
        requiredText: "spg-panel__required-text"
    },
    paneldynamic: {
        mainRoot: "spg-question spg-row__question",
        root: "spg-paneldynamic",
        navigation: "spg-paneldynamic__navigation",
        title: "spg-title spg-question__title",
        button: "spg-action-button spg-action-button--text",
        buttonRemove: "spg-action-button--danger",
        buttonAdd: "spg-paneldynamic__add-btn",
        panelsContainer: "",
        panelWrapper: "spg-paneldynamic__panel-wrapper",
        panelWrapperList: "",
        progressTop: "spg-paneldynamic__progress spg-paneldynamic__progress--top",
        progressBottom: "spg-paneldynamic__progress spg-paneldynamic__progress--bottom",
        buttonPrev: "spg-paneldynamic__prev-btn",
        buttonNext: "spg-paneldynamic__next-btn",
        progressContainer: "spg-paneldynamic__progress-container",
        progress: "spg-progress",
        progressBar: "spg-progress__bar",
        progressText: "spg-paneldynamic__progress-text",
        panelFooter: "spg-panel__footer",
        separator: "spg-paneldynamic__separator"
    },
    progress: "spg-progress spg-body__progress",
    progressBar: "spg-progress__bar",
    progressText: "spg-progress__text",
    progressTextInBar: "spg-hidden",
    page: {
        root: "spg-page spg-body__page",
        title: "spg-title spg-page__title",
        description: "spg-description spg-page__description"
    },
    pageTitle: "spg-title spg-page__title",
    pageDescription: "spg-description spg-page__description",
    row: "spg-row spg-clearfix",
    rowEnter: "spg-row--enter",
    rowLeave: "spg-row--leave",
    rowDelayedEnter: "spg-row--delayed-fade-in",
    rowMultiple: "spg-row--multiple",
    question: {
        mainRoot: "spg-question spg-row__question",
        flowRoot: "spg-question spg-row__question spg-row__question--flow",
        asCell: "spg-table__cell",
        header: "spg-question__header",
        headerLeft: "spg-question__header--location--left",
        headerTop: "spg-question__header--location--top",
        headerBottom: "spg-question__header--location--bottom",
        content: "spg-question__content",
        contentLeft: "spg-question__content--left",
        titleLeftRoot: "spg-question--location--left",
        titleOnAnswer: "spg-question__title--answer",
        titleOnError: "spg-question__title--error",
        title: "spg-title spg-question__title",
        titleBar: "sd-action-title-bar spg-action-title-bar",
        requiredText: "spg-question__required-text",
        number: "spg-question__num",
        description: "spg-description spg-question__description",
        descriptionUnderInput: "spg-description spg-question__description",
        comment: "spg-comment",
        required: "spg-question--required",
        titleRequired: "spg-question__title--required",
        indent: 0,
        footer: "spg-question__footer",
        formGroup: "spg-question__form-group",
        hasError: "",
        disabled: "spg-question--disabled"
    },
    image: { root: "spg-image", image: "sv_image_image" },
    error: {
        root: "spg-question__erbox",
        icon: "spg-question__erbox-icon",
        item: "",
        locationTop: "spg-question__erbox--location--top",
        locationBottom: "spg-question__erbox--location--bottom"
    },
    checkbox: {
        root: "spg-selectbase",
        item: "spg-item spg-checkbox spg-selectbase__item",
        itemSelectAll: "spg-checkbox--selectall",
        itemNone: "spg-checkbox--none",
        itemDisabled: "spg-item--disabled spg-checkbox--disabled",
        itemChecked: "spg-checkbox--checked",
        itemHover: "spg-checkbox--allowhover",
        itemInline: "spg-selectbase__item--inline",
        label: "spg-selectbase__label",
        // label: "spg-checkbox",
        itemSvgIconId: "#icon-v2check",
        labelChecked: "",
        //itemControl: "spg-visuallyhidden spg-item__control",
        itemControl: "spg-checkbox__control",
        itemDecorator: "spg-checkbox__svg",
        //itemDecorator: "spg-checkbox__hidden",
        //controlLabel: "spg-item__control-label",
        controlLabel: "spg-checkbox__caption",
        materialDecorator: "spg-checkbox__rectangle",
        //materialDecorator: "spg-item__decorator spg-checkbox__decorator",
        other: "spg-comment spg-question__other",
        column: "spg-selectbase__column"
    },
    radiogroup: {
        root: "spg-selectbase",
        item: "spg-item spg-radio spg-selectbase__item",
        itemInline: "spg-selectbase__item--inline",
        label: "spg-selectbase__label",
        labelChecked: "",
        itemDisabled: "spg-item--disabled spg-radio--disabled",
        itemChecked: "spg-radio--checked",
        itemHover: "spg-radio--allowhover",
        itemControl: "spg-visuallyhidden spg-item__control",
        itemDecorator: "spg-item__svg spg-radio__svg",
        controlLabel: "spg-item__control-label",
        materialDecorator: "spg-item__decorator spg-radio__decorator",
        other: "spg-comment spg-question__other",
        clearButton: "spg-btn spg-selectbase__clear-btn",
        column: "spg-selectbase__column"
    },
    boolean: {
        mainRoot: "spg-question spg-row__question spg-question--boolean",
        rootCheckbox: "spg-selectbase",
        checkboxItem: "spg-checkbox",
        checkboxItemChecked: "spg-checkbox--checked",
        checkboxitemIndeterminate: "spg-checkbox--indeterminate",
        checkboxItemDisabled: "spg-checkbox--disabled",
        svgIconId: "#icon-v2check",
        checkboxLabel: "spg-selectbase__label",
        controlCheckbox: "spg-checkbox__control",
        checkboxControlLabel: "spg-checkbox__caption",
        checkboxItemDecorator: "spg-checkbox__svg",
        checkboxMaterialDecorator: "spg-checkbox__rectangle"
    },
    text: {
        root: "spg-input spg-text",
        small: "spg-row__question--small",
        content: "spg-question__content spg-text__content",
        remainingCharacterCounter: "spg-remaining-character-counter",
        onError: "spg-input--error"
    },
    multipletext: {
        root: "spg-multipletext",
        item: "spg-multipletext__item",
        itemTitle: "spg-multipletext__item-title",
        content: "spg-multipletext__content spg-text__content",
        row: "spg-multipletext__row",
        cell: "spg-multipletext__cell"
    },
    dropdown: {
        root: "",
        popup: "spg-dropdown-popup svc-creator-popup",
        small: "spg-row__question--small sd-row__question--small",
        control: "spg-input spg-dropdown sd-input sd-dropdown",
        controlEmpty: "spg-dropdown--empty sd-dropdown--empty",
        controlValue: "sd-dropdown__value spg-dropdown__value",
        filterStringInput: "sd-dropdown__filter-string-input spg-dropdown__filter-string-input",
        other: "spg-comment spg-question__other",
        onError: "spg-input--error",
        selectWrapper: "sv-dropdown_select-wrapper spg-dropdown_select-wrapper",
        chevronButton: "sd-dropdown_chevron-button spg-dropdown_chevron-button",
        chevronButtonSvg: "sd-dropdown_chevron-button-svg spg-dropdown_chevron-button-svg",
        chevronButtonIconId: "icon-chevron",
    },
    buttongroup: {
        root: "spg-button-group",
        item: "spg-button-group__item",
        itemIcon: "spg-button-group__item-icon",
        itemDecorator: "spg-button-group__item-decorator",
        itemCaption: "spg-button-group__item-caption",
        itemHover: "spg-button-group__item--hover",
        itemSelected: "spg-button-group__item--selected",
        itemDisabled: "spg-button-group__item--disabled",
        itemControl: "sv-visuallyhidden",
        disabled: "spg-question--disabled"
    },
    imagepicker: {
        root: "spg-imagepicker",
        item: "spg-imagepicker__item",
        itemInline: "spg-imagepicker__item--inline",
        itemChecked: "spg-imagepicker__item--checked",
        itemDisabled: "spg-imagepicker__item--disabled",
        itemHover: "spg-imagepicker__item--allowhover",
        label: "spg-imagepicker__label",
        itemControl: "spg-imagepicker__control",
        image: "spg-imagepicker__image",
        itemText: "spg-imagepicker__text",
        clearButton: "spg-btn",
        other: "spg-comment spg-question__other"
    },
    matrix: {
        tableWrapper: "spg-matrix spg-table-wrapper",
        root: "spg-table",
        rowError: "spg-matrix__row--error",
        cell: "spg-table__cell spg-matrix__cell",
        headerCell: "spg-table__cell spg-table__cell--header",
        label: "spg-item spg-radio spg-matrix__label",
        itemValue: "spg-visuallyhidden spg-item__control spg-radio__control",
        itemChecked: "spg-radio--checked",
        itemDisabled: "spg-item--disabled spg-radio--disabled",
        itemHover: "spg-radio--allowhover",
        materialDecorator: "spg-item__decorator spg-radio__decorator",
        itemDecorator: "spg-item__svg spg-radio__svg",
        cellText: "spg-matrix__text",
        cellTextSelected: "spg-matrix__text--checked",
        cellTextDisabled: "spg-matrix__text--disabled",
    },
    matrixdropdown: {
        tableWrapper: "spg-table-wrapper",
        root: "spg-table",
        cell: "spg-table__cell",
        headerCell: "spg-table__cell spg-table__cell--header",
        emptyCell: "spg-table__cell--empty",
        rowEnter: "spg-table__row--enter",
        rowLeave: "spg-table__row--leave",
    },
    matrixdynamic: {
        tableWrapper: "spg-table-wrapper",
        root: "spg-table spg-matrixdynamic",
        content: "spg-matrixdynamic__content spg-text__content",
        cell: "spg-table__cell",
        row: "spg-table__row",
        rowDisabled: "spg-table__row-disabled",
        rowReadOnly: "spg-table__row-readonly",
        headerCell: "spg-table__cell spg-table__cell--header",
        button: "spg-btn",
        detailRow: "spg-table__row spg-table__row--detail",
        detailButton: "spg-table__cell--detail-button",
        detailButtonExpanded: "spg-table__cell--detail-button--expanded",
        detailIcon: "spg-detail-panel__icon",
        detailIconExpanded: "spg-detail-panel__icon--expanded",
        detailPanelCell: "spg-table__cell spg-table__cell--detail-panel",
        actionsCell: "spg-table__cell spg-table__cell--actions",
        buttonAdd: "spg-matrixdynamic__add-btn spg-action-button spg-action-button--large",
        buttonRemove: "spg-matrixdynamic__remove-btn",
        iconAdd: "",
        iconRemove: "",
        dragElementDecorator: "spg-drag-element__svg",
        iconDragElement: "#icon-drag-24x24",
        iconDrag: "spg-matrixdynamic__drag-element",
        footer: "",
        dragDropGhostPositionTop: "spg-matrixdynamic__drag-drop-ghost-position-top",
        dragDropGhostPositionBottom: "spg-matrixdynamic__drag-drop-ghost-position-bottom",
        emptyRowsSection: "spg-matrixdynamic__placeholder",
        emptyRowsText: "spg-matrixdynamic__placeholder-text",
        cellQuestionWrapper: "spg-table__question-wrapper",
        draggedRow: "spg-matrixdynamic__dragged-row",
        emptyCell: "spg-table__cell--empty",
        rowEnter: "spg-table__row--enter",
        rowLeave: "spg-table__row--leave",
    },
    rating: {
        root: "spg-rating",
        item: "spg-rating__item",
        selected: "spg-rating__item--selected",
        minText: "spg-rating__min-text",
        itemText: "spg-rating__item-text",
        maxText: "spg-rating__max-text",
        disabled: "spg-rating--disabled"
    },
    comment: {
        root: "spg-input spg-comment",
        content: "spg-question__content spg-comment__content",
        remainingCharacterCounter: "spg-remaining-character-counter",
        small: "spg-row__question--small",
        onError: "spg-input--error"
    },
    expression: "",
    file: {
        root: "spg-file",
        other: "spg-comment spg-question__other",
        placeholderInput: "spg-visuallyhidden",
        preview: "spg-file__preview",
        fileSign: "spg-hidden",
        fileSignBottom: "spg-file__sign",
        fileDecorator: "spg-file__decorator",
        fileInput: "spg-visuallyhidden",
        noFileChosen: "spg-description spg-file__no-file-chosen",
        chooseFile: "spg-btn spg-file__choose-btn",
        disabled: "spg-file__choose-btn--disabled",
        removeButton: "spg-hidden",
        removeButtonBottom: "spg-btn spg-file__clean-btn",
        removeFile: "spg-hidden",
        removeFileSvg: "spg-file__remove-svg",
        wrapper: "spg-file__wrapper"
    },
    signaturepad: {
        root: "spg-signaturepad sjs_sp_container",
        small: "spg-row__question--small",
        controls: "sjs_sp_controls",
        clearButton: "sjs_sp_clear"
    },
    propertygrid_bindings: {
        content: "spg-question__content spg-question__nopadding spg-question-group"
    },
    propertygrid_restfull: {
        content: "spg-question__content spg-question__nopadding spg-restfull"
    },
    propertygrid_masksettings: {
        content: "spg-question__content spg-question__nopadding spg-masksettings"
    },
    propertygrid_header: {
        mainRoot: "spg-header",
        content: "spg-question__content spg-question__nopadding"
    },
    coloralpha: {
        content: "spg-question__content spg-question__nopadding spg-question__content-coloralpha"
    },
    font: {
        content: "spg-question__content spg-question__nopadding spg-question-composite__content"
    },
    backgroundcornerradius: {
        content: "spg-question__content spg-question__nopadding spg-question-composite__content"
    },
    saveData: {
        root: "",
        saving: "",
        error: "",
        success: "",
        saveAgainButton: ""
    },
    window: {
        root: "sv_window",
        body: "sv_window_content",
        header: {
            root: "sv_window_title",
            title: "",
            button: "",
            buttonExpanded: "",
            buttonCollapsed: ""
        }
    },
    actionBar: {
        root: "spg-action-bar",
        item: "spg-action-button",
        itemPressed: "spg-action-button--pressed",
        itemAsIcon: "spg-action-button--icon",
        itemIcon: "spg-action-button__icon",
        itemTitle: "spg-action-button__title",
    },
    spinedit: {
        root: "spg-input spg-spin-editor spg-input-container",
        control: "spg-spin-editor__input spg-input-container__input",
        buttonsContainer: "spg-input-container__buttons-container",
        arrowButton: "spg-input__edit-button",
        increaseButtonIcon: "icon-arrow-up",
        decreaseButtonIcon: "icon-arrow-down"
    },
    color: {
        root: "spg-input spg-color-editor spg-input-container",
        swatch: "spg-color-editor__color-swatch",
        swatchDefault: "spg-color-editor__color-swatch--default",
        swatchDisabled: "spg-color-editor__color-swatch--disabled",
        colorInput: "spg-color-editor__color-input",
        control: "spg-color-editor__input spg-input-container__input",
        colorDropdown: "spg-input__edit-button",
        colorDropdownIcon: "icon-drop-down-arrow",
        colorItem: "spg-color-editor__color-item",
        swatchIcon: "icon-color-picker"
    },
    textwithreset: {
        root: "spg-input spg-input-container",
        rootMultiline: "spg-input-container--multiline",
        control: "spg-input-container__input",
        controlMultiline: "spg-input-container__input spg-comment",
        resetButton: "spg-input__edit-button",
        resetButtonIcon: "icon-reset",
        content: "spg-question__content spg-text__content",
        remainingCharacterCounter: "spg-remaining-character-counter",
        onError: "spg-input--error"
    },
    fileedit: {
        root: "spg-input spg-input-container spg-file-edit",
        control: "spg-input-container__input",
        buttonsContainer: "spg-input-container__buttons-container",
        chooseButtonIcon: "icon-choosefile",
        clearButtonIcon: "icon-cancel-24x24",
        fileInput: "sd-visuallyhidden",
        clearButton: "spg-input__edit-button",
        chooseButton: "spg-input__edit-button spg-file-edit__choose-button",
        chooseButtonDisabled: "spg-input__edit-button--disabled"
    },
    linkvalue: {
        content: "spg-link"
    }
};


/***/ }),

/***/ "./src/property-grid/bindings.ts":
/*!***************************************!*\
  !*** ./src/property-grid/bindings.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PropertyGridEditorBindings: () => (/* binding */ PropertyGridEditorBindings)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! . */ "./src/property-grid/index.ts");




var json = {
    name: "propertygrid_bindings",
    showInToolbox: false,
    internal: true,
    createElements: function () {
        //tell ComponentCollection that it is composite question
    }
};
if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.getCustomQuestionByName(json.name)) {
    survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.add(json);
}
var PropertyGridEditorBindings = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorBindings, _super);
    function PropertyGridEditorBindings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorBindings.prototype.fit = function (prop) {
        return prop.type == "bindings";
    };
    PropertyGridEditorBindings.prototype.getJSON = function () {
        var res = {
            type: "propertygrid_bindings",
        };
        return res;
    };
    PropertyGridEditorBindings.prototype.onCreated = function (obj, question, prop, options) {
        question.contentPanel.fromJSON({ elements: this.getQuestions(obj, options) });
        question.valueFromDataCallback = function (value) {
            if (!value && obj.bindings.getNames().length > 0) {
                var result = {};
                for (var _i = 0, _a = obj.bindings.getNames(); _i < _a.length; _i++) {
                    var bindingName = _a[_i];
                    result[bindingName] = obj.bindings.getValueNameByPropertyName(bindingName);
                }
                return result;
            }
            return value;
        };
    };
    PropertyGridEditorBindings.prototype.getQuestions = function (obj, options) {
        var res = [];
        for (var _i = 0, _a = obj.bindings.getNames(); _i < _a.length; _i++) {
            var bindingName = _a[_i];
            res.push(this.getBindingJSON(bindingName, obj, options));
        }
        return res;
    };
    PropertyGridEditorBindings.prototype.getBindingJSON = function (bindingName, obj, options) {
        var prop = new survey_core__WEBPACK_IMPORTED_MODULE_1__.JsonObjectProperty(null, "value");
        prop.type = "questionvalue";
        var json = ___WEBPACK_IMPORTED_MODULE_3__.PropertyGridEditorCollection.getJSON(obj, prop, options);
        json.titleLocation = "left";
        json.descriptionLocation = "hidden";
        json.minWidth = "0px";
        json.name = bindingName;
        json.title = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getPropertyName(bindingName);
        return json;
    };
    return PropertyGridEditorBindings;
}(___WEBPACK_IMPORTED_MODULE_3__.PropertyGridEditor));

___WEBPACK_IMPORTED_MODULE_3__.PropertyGridEditorCollection.register(new PropertyGridEditorBindings());


/***/ }),

/***/ "./src/property-grid/cells-survey.ts":
/*!*******************************************!*\
  !*** ./src/property-grid/cells-survey.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   CellsEditor: () => (/* binding */ CellsEditor)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./index */ "./src/property-grid/index.ts");




var CellsEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(CellsEditor, _super);
    function CellsEditor(matrix, options) {
        if (options === void 0) { options = null; }
        var _this = _super.call(this, options) || this;
        _this.matrix = matrix;
        _this.editMatrixValue = (_this.editSurvey.getQuestionByName("question"));
        _this.buildColumns();
        _this.buildRows();
        _this.editMatrix.value = _this.matrix.cells.getJson();
        return _this;
    }
    CellsEditor.prototype.getSurveyJSON = function () {
        return {
            elements: [
                {
                    type: "matrixdropdown",
                    name: "question",
                    cellType: "comment",
                },
            ],
        };
    };
    CellsEditor.prototype.getSurveyCreationReason = function () {
        return "cells-editor";
    };
    Object.defineProperty(CellsEditor.prototype, "editMatrix", {
        get: function () {
            return this.editMatrixValue;
        },
        enumerable: false,
        configurable: true
    });
    CellsEditor.prototype.apply = function () {
        this.matrix.cells.setJson(this.editMatrix.value);
        return true;
    };
    CellsEditor.prototype.buildColumns = function () {
        var columns = this.matrix.columns;
        for (var i = 0; i < columns.length; i++) {
            this.editMatrix.addColumn("" + columns[i].value, columns[i].text);
        }
    };
    CellsEditor.prototype.buildRows = function () {
        this.editMatrix.rows.push(new survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue("default", _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.cellsDefaultRow")));
        var rows = this.matrix.rows;
        for (var i = 0; i < rows.length; i++) {
            this.editMatrix.rows.push(new survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue(rows[i].value, rows[i].text));
        }
    };
    return CellsEditor;
}(_index__WEBPACK_IMPORTED_MODULE_3__.PropertyEditorSetupValue));



/***/ }),

/***/ "./src/property-grid/condition-survey.ts":
/*!***********************************************!*\
  !*** ./src/property-grid/condition-survey.ts ***!
  \***********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ConditionEditor: () => (/* binding */ ConditionEditor),
/* harmony export */   ConditionEditorItem: () => (/* binding */ ConditionEditorItem),
/* harmony export */   ConditionEditorItemsBuilder: () => (/* binding */ ConditionEditorItemsBuilder),
/* harmony export */   SurveyConditionEditorItem: () => (/* binding */ SurveyConditionEditorItem)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ./index */ "./src/property-grid/index.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _components_tabs_logic_theme__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../components/tabs/logic-theme */ "./src/components/tabs/logic-theme.ts");
/* harmony import */ var _components_tabs_logic_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../components/tabs/logic-types */ "./src/components/tabs/logic-types.ts");









var ConditionEditorItem = /** @class */ (function () {
    function ConditionEditorItem() {
        this.conjunction = "and";
        this.operator = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.defaultOperators.default;
    }
    return ConditionEditorItem;
}());

var SurveyConditionEditorItem = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyConditionEditorItem, _super);
    function SurveyConditionEditorItem(survey) {
        var _this = _super.call(this) || this;
        _this.survey = survey;
        return _this;
    }
    SurveyConditionEditorItem.prototype.getOperatorText = function () {
        var op = this.operator;
        if (op == "equal")
            return "=";
        if (op == "notequal")
            return "<>";
        if (op == "greater")
            return ">";
        if (op == "less")
            return "<";
        if (op == "greaterorequal")
            return ">=";
        if (op == "lessorequal")
            return "<=";
        return op;
    };
    SurveyConditionEditorItem.prototype.getValueText = function () {
        var val = this.value;
        if (!val)
            return val;
        if (!Array.isArray(val))
            return this.valToText(val);
        var res = "[";
        for (var i = 0; i < val.length; i++) {
            res += this.valToText(val[i]);
            if (i < val.length - 1)
                res += ", ";
        }
        res += "]";
        return res;
    };
    Object.defineProperty(SurveyConditionEditorItem.prototype, "isValueRequired", {
        get: function () {
            return this.operator !== "empty" && this.operator !== "notempty";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyConditionEditorItem.prototype, "isReady", {
        get: function () {
            return (!!this.questionName &&
                (!this.isValueRequired || !survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(this.value)));
        },
        enumerable: false,
        configurable: true
    });
    SurveyConditionEditorItem.prototype.toExpression = function () {
        var text = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.wrapTextByCurlyBraces)(this.getQuestionValueByName()) + " " + this.getOperatorText();
        if (this.isValueRequired) {
            text += " " + this.getValueText();
        }
        return text;
    };
    SurveyConditionEditorItem.prototype.getQuestionValueByName = function () {
        var question = this.survey.getQuestionByName(this.questionName);
        if (question &&
            question.name != question.getValueName() &&
            this.questionName != question.getValueName()) {
            return this.questionName.replace(question.name, question.getValueName());
        }
        return this.questionName;
    };
    SurveyConditionEditorItem.prototype.valToText = function (val) {
        if (val == "true" || val == "false")
            return val;
        if (this.isNumeric(val))
            return val;
        if (val[0] == "[")
            return val.replace(/(?!^)(['])(?!$)/g, "\\$1");
        if (!this.isQuote(val[0]))
            val = "'" + val;
        if (!this.isQuote(val[val.length - 1]))
            val = val + "'";
        return val.replace(/(?!^)(['"])(?!$)/g, "\\$1");
    };
    SurveyConditionEditorItem.prototype.isNumeric = function (val) {
        if (typeof val === "string" &&
            val.length > 1 &&
            val[0] === "0" &&
            val[1] !== "x")
            return false;
        return !isNaN(val);
    };
    SurveyConditionEditorItem.prototype.isQuote = function (ch) {
        return ch == "'" || ch == '"';
    };
    return SurveyConditionEditorItem;
}(ConditionEditorItem));

var ConditionEditorItemsBuilder = /** @class */ (function () {
    function ConditionEditorItemsBuilder(hasValue) {
        if (hasValue === void 0) { hasValue = null; }
        this.hasValue = hasValue;
    }
    ConditionEditorItemsBuilder.prototype.build = function (text) {
        if (!text)
            return [];
        var operand = null;
        operand = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ConditionsParser().parseExpression(text);
        if (!operand)
            return [];
        return this.buildEditorItems(operand);
    };
    ConditionEditorItemsBuilder.prototype.buildEditorItems = function (operand) {
        var res = [];
        if (!this.buildEditorItemsCore(operand, res, "")) {
            res = [];
        }
        return res;
    };
    ConditionEditorItemsBuilder.prototype.buildEditorItemsCore = function (operand, res, parentConjunction) {
        if (operand.getType() == "unary")
            return this.buildEditorItemsAddUnaryOperand(operand, res);
        if (operand.getType() !== "binary")
            return false;
        var op = operand;
        if (op.isArithmetic && !op.isConjunction)
            return false;
        if (op.isConjunction)
            return this.buildEditorItemsAddConjunction(op, res, parentConjunction);
        return this.buildEditorItemsAddBinaryOperand(op, res);
    };
    ConditionEditorItemsBuilder.prototype.buildEditorItemsAddConjunction = function (op, res, parentConjunction) {
        var conjunction = op.conjunction;
        if (conjunction == "or" && !!parentConjunction && parentConjunction != conjunction)
            return false;
        if (!this.buildEditorItemsCore(op.leftOperand, res, conjunction))
            return false;
        var conjunctionIndex = res.length;
        if (!this.buildEditorItemsCore(op.rightOperand, res, conjunction))
            return false;
        res[conjunctionIndex].conjunction = op.conjunction;
        return true;
    };
    ConditionEditorItemsBuilder.prototype.buildEditorItemsAddBinaryOperand = function (op, res) {
        var variableOperand = this.getOperandByType(op, "variable");
        var arrayValue = this.getArrayValueFromOperand(op);
        var constOperand = !arrayValue ? this.getOperandByType(op, "const") : null;
        if (!variableOperand ||
            (!constOperand && !arrayValue && this.canShowValueByOperator(op.operator)))
            return false;
        if (!this.isVariableInSurvey(variableOperand.variable))
            return false;
        var item = new ConditionEditorItem();
        item.questionName = variableOperand.variable;
        item.operator = op.leftOperand !== variableOperand ? this.getOppositeOperator(op.operator) : op.operator;
        if (!!arrayValue) {
            item.value = arrayValue;
        }
        if (!!constOperand) {
            item.value = constOperand.correctValue;
        }
        res.push(item);
        return true;
    };
    ConditionEditorItemsBuilder.prototype.isVariableInSurvey = function (variable) {
        return !!this.hasValue ? this.hasValue(variable) : true;
    };
    ConditionEditorItemsBuilder.prototype.getArrayValueFromOperand = function (op) {
        var arrayOperand = this.getOperandByType(op, "array");
        if (!arrayOperand || !arrayOperand.values)
            return null;
        var valuesOperand = arrayOperand.values;
        if (!Array.isArray(valuesOperand) || valuesOperand.length == 0)
            return null;
        var res = [];
        for (var i = 0; i < valuesOperand.length; i++) {
            var opConst = valuesOperand[i];
            if (!opConst)
                continue;
            if (opConst.getType() != "const")
                return null;
            res.push(opConst.correctValue);
        }
        if (res.length == 0)
            return null;
        return res;
    };
    ConditionEditorItemsBuilder.prototype.buildEditorItemsAddUnaryOperand = function (op, res) {
        var operator = op.operator;
        if (operator !== "empty" && operator != "notempty")
            return false;
        var operand = op.expression;
        if (operand == null || operand.getType() != "variable")
            return false;
        var questionName = operand.variable;
        if (!this.isVariableInSurvey(questionName))
            return false;
        var item = new ConditionEditorItem();
        item.questionName = questionName;
        item.operator = operator;
        res.push(item);
        return true;
    };
    ConditionEditorItemsBuilder.prototype.getOppositeOperator = function (operator) {
        if (operator == "less")
            return "greater";
        if (operator == "greater")
            return "less";
        if (operator == "lessorequal")
            return "greaterorequal";
        if (operator == "greaterorequal")
            return "lessorequal";
        return operator;
    };
    ConditionEditorItemsBuilder.prototype.getOperandByType = function (op, opType) {
        if (!op.rightOperand)
            return null;
        if (op.leftOperand.getType() !== opType &&
            op.rightOperand.getType() !== opType)
            return null;
        if (op.leftOperand.getType() == opType &&
            op.rightOperand.getType() == opType)
            return null;
        return op.leftOperand.getType() == opType
            ? op.leftOperand
            : op.rightOperand;
    };
    ConditionEditorItemsBuilder.prototype.canShowValueByOperator = function (operator) {
        return operator != "empty" && operator != "notempty";
    };
    return ConditionEditorItemsBuilder;
}());

function questionValueVisibleIf(params) {
    if (params.length !== 2)
        return false;
    if (!params[0] || !params[1])
        return false;
    return params[1] !== "empty" && params[1] !== "notempty";
}
survey_core__WEBPACK_IMPORTED_MODULE_1__.FunctionFactory.Instance.register("questionValueVisibleIf", questionValueVisibleIf);
var ConditionEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(ConditionEditor, _super);
    function ConditionEditor(survey, object, options, propertyName) {
        if (object === void 0) { object = null; }
        if (options === void 0) { options = null; }
        if (propertyName === void 0) { propertyName = ""; }
        var _this = _super.call(this, options) || this;
        _this.propertyName = propertyName;
        _this.addConditionQuestionsHash = {};
        _this.isModalValue = true;
        _this.isSettingPanelValues = false;
        _this.calculatedValueQuestion = null;
        _this.surveyValue = survey;
        _this.objectValue = object;
        _this.panelValue = (_this.editSurvey.getQuestionByName("panel"));
        _this.textEditorValue = (_this.editSurvey.getQuestionByName("textEditor"));
        if (!!_this.options.maxLogicItemsInCondition) {
            _this.panel.maxPanelCount = _this.options.maxLogicItemsInCondition;
        }
        _this.allConditionQuestions = _this.createAllConditionQuestions();
        _this.editSurvey.onValueChanged.add(function (sender, options) {
            _this.onValueChanged(options);
        });
        _this.editSurvey.onDynamicPanelAdded.add(function (sender, options) {
            _this.onPanelAdded();
        });
        _this.editSurvey.onDynamicPanelRemoved.add(function (sender, options) {
            if (options.question.panelCount == 0) {
                options.question.addPanel();
            }
            if (_this.panel.panelCount > 0)
                _this.panel.panels[0].getQuestionByName("questionName").titleLocation = "left";
        });
        _this.editSurvey.onDynamicPanelItemValueChanged.add(function (sender, options) {
            _this.onPanelValueChanged(options.panel, options.name);
        });
        _this.editSurvey.css = _components_tabs_logic_theme__WEBPACK_IMPORTED_MODULE_7__.logicCss;
        _this.editSurvey.onUpdateQuestionCssClasses.add(function (sender, options) {
            _this.onUpdateQuestionCssClasses(options);
        });
        _this.text = !!_this.object && _this.propertyName ? _this.object[_this.propertyName] : "";
        _this.updatePlaceholderVisibileIf();
        return _this;
    }
    ConditionEditor.canParseExpression = function (text) {
        if (!text)
            return true;
        return !!new survey_core__WEBPACK_IMPORTED_MODULE_1__.ConditionsParser().parseExpression(text);
    };
    ConditionEditor.canBuildExpression = function (text) {
        if (!text)
            return true;
        if (!ConditionEditor.canParseExpression(text))
            return false;
        return new ConditionEditorItemsBuilder().build(text).length > 0;
    };
    ConditionEditor.isOperatorEnabled = function (qType, operatorTypes) {
        if (!qType)
            return true;
        if (!operatorTypes || operatorTypes.length == 0)
            return true;
        var contains = [];
        var notContains = [];
        for (var i = 0; i < operatorTypes.length; i++) {
            var name_1 = operatorTypes[i];
            if (name_1[0] == "!") {
                notContains.push(name_1.substring(1));
            }
            else {
                contains.push(name_1);
            }
        }
        return ConditionEditor.isClassContains(qType, contains, notContains);
    };
    ConditionEditor.isClassContains = function (qType, contains, notContains) {
        var classInfo = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findClass(qType);
        while (!!classInfo) {
            if (contains.indexOf(classInfo.name) > -1)
                return true;
            if (notContains.indexOf(classInfo.name) > -1)
                return false;
            classInfo = !!classInfo.parentName ? survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findClass(classInfo.parentName) : null;
        }
        return contains.length == 0;
    };
    Object.defineProperty(ConditionEditor.prototype, "title", {
        get: function () {
            return this.panel.title;
        },
        set: function (val) {
            this.panel.title = val;
            this.textEditor.title = val;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConditionEditor.prototype, "isModal", {
        get: function () {
            return this.isModalValue;
        },
        set: function (val) {
            if (val === this.isModalValue)
                return;
            this.isModalValue = val;
            this.updatePlaceholderVisibileIf();
        },
        enumerable: false,
        configurable: true
    });
    ConditionEditor.prototype.updatePlaceholderVisibileIf = function () {
        if (!!this.panel) {
            var expression = "";
            //todo remove placeholder to V2 version
            if (this.isModal && !this.options["animationEnabled"]) {
                expression = "{panel.questionName} empty and {panelIndex} == 0";
            }
            this.panel.template.getQuestionByName("placeholder").visibleIf = expression;
        }
    };
    ConditionEditor.prototype.getSurveyJSON = function () {
        return {
            elements: [
                {
                    type: "paneldynamic",
                    titleLocation: "hidden",
                    name: "panel",
                    panelRemoveButtonLocation: "right",
                    panelAddText: _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("pe.addCondition"),
                    minPanelCount: 1,
                    maxPanelCount: 1,
                    startWithNewLine: false,
                    templateElements: [
                        {
                            name: "conjunction",
                            type: "dropdown",
                            renderAs: "logicoperator",
                            searchEnabled: false,
                            titleLocation: "hidden",
                            showOptionsCaption: false,
                            visibleIf: "{panelIndex} > 0",
                            choices: [
                                { value: "and", text: _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("pe.and") },
                                { value: "or", text: _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("pe.or") }
                            ]
                        },
                        {
                            name: "questionName",
                            type: "dropdown",
                            renderAs: "logicoperator",
                            title: _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("pe.if"),
                            titleLocation: "left",
                            showOptionsCaption: false,
                            startWithNewLine: false,
                            isRequired: true
                        },
                        {
                            name: "operator",
                            type: "dropdown",
                            renderAs: "logicoperator",
                            searchEnabled: false,
                            titleLocation: "hidden",
                            startWithNewLine: false,
                            showOptionsCaption: false,
                            isRequired: true,
                            enableIf: "{panel.questionName} notempty"
                        },
                        {
                            name: "removeAction",
                            type: "linkvalue",
                            titleLocation: "hidden",
                            showOptionsCaption: false,
                            visible: false,
                            startWithNewLine: false,
                            showValueInLink: false,
                            allowClear: false,
                            showClear: false,
                            iconName: "icon-delete_24x24"
                        },
                        {
                            name: "questionValue",
                            type: "text",
                            visible: false
                        },
                        {
                            name: "placeholder",
                            type: "html",
                            visible: false,
                            html: "<div class='svc-logic-placeholder'><span class=\"svc-logic-placeholder__text\">".concat(_editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("pe.emptyLogicPopupMessage"), "<span></div>")
                        }
                    ]
                },
                {
                    type: "comment",
                    titleLocation: "hidden",
                    name: "textEditor",
                    textUpdateMode: "onTyping",
                    placeholder: _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("pe.emptyExpressionPlaceHolder"),
                    visible: false
                }
            ]
        };
    };
    ConditionEditor.prototype.getSurveyCreationReason = function () {
        return "condition-builder";
    };
    Object.defineProperty(ConditionEditor.prototype, "text", {
        get: function () {
            return this.getText();
        },
        set: function (val) {
            if (!this.isModal && !ConditionEditor.canBuildExpression(val)) {
                this.panel.panelCount = 0;
                this.showTextEditor(val);
            }
            else {
                this.textEditor.value = val;
                this.showBuilder(val);
            }
        },
        enumerable: false,
        configurable: true
    });
    ConditionEditor.prototype.isModified = function (prevText) {
        if (this.textEditor.visible)
            return prevText != this.text;
        var items = this.getEditorItems();
        var prevOp = !!prevText ? new survey_core__WEBPACK_IMPORTED_MODULE_1__.ConditionsParser().parseExpression(prevText) : null;
        if (!prevOp)
            return !(items.length == 1 && !items[0].questionName);
        if (!this.isReady)
            return true;
        var curOp = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ConditionsParser().parseExpression(this.text);
        return !prevOp.isEqual(curOp);
    };
    Object.defineProperty(ConditionEditor.prototype, "context", {
        get: function () {
            return this.contextValue;
        },
        set: function (val) {
            if (val === this.context)
                return;
            this.contextValue = val;
            this.updateNamesOnContextChanged();
            if (this.onContextChanged) {
                this.onContextChanged(val);
            }
        },
        enumerable: false,
        configurable: true
    });
    ConditionEditor.prototype.processText = function (val) {
        this.panel.panelCount = 0;
        var items = new ConditionEditorItemsBuilder().build(val);
        this.buildPanels(items);
    };
    Object.defineProperty(ConditionEditor.prototype, "survey", {
        get: function () {
            return this.surveyValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConditionEditor.prototype, "object", {
        get: function () {
            return this.objectValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConditionEditor.prototype, "panel", {
        get: function () {
            return this.panelValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConditionEditor.prototype, "textEditor", {
        get: function () {
            return this.textEditorValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ConditionEditor.prototype, "isReady", {
        get: function () {
            if (this.textEditor.visible) {
                return ConditionEditor.canParseExpression(this.textEditor.value);
            }
            for (var i = 0; i < this.panel.panels.length; i++) {
                if (!this.createEditorItemFromPanel(this.panel.panels[i]).isReady)
                    return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    ConditionEditor.prototype.isEmpty = function () {
        if (this.panel.panels.length === 0)
            return true;
        if (this.panel.panels.length > 1)
            return false;
        var item = this.createEditorItemFromPanel(this.panel.panels[0]);
        return !item.questionName;
    };
    ConditionEditor.prototype.hasErrorInUI = function () {
        var creator = this.survey.creator;
        if (!this.isReady) {
            this.hasErrors();
            this.errorText = (0,_components_tabs_logic_types__WEBPACK_IMPORTED_MODULE_8__.getLogicString)("expressionInvalid");
            !!creator &&
                creator.notify(this.errorText, "error");
            return true;
        }
        return false;
    };
    ConditionEditor.prototype.apply = function () {
        if (this.hasErrorInUI()) {
            return false;
        }
        if (!this.object || !this.propertyName)
            return;
        this.object[this.propertyName] = this.text;
        return true;
    };
    ConditionEditor.prototype.setIsFastEntry = function (showTextEdit) {
        if (showTextEdit) {
            this.showTextEditor(this.text);
        }
        else {
            if (!this.panel.visible) {
                this.showBuilder(this.text);
            }
        }
    };
    ConditionEditor.prototype.buildPanels = function (items) {
        this.panel.panelCount = items.length;
        for (var i = 0; i < items.length; i++) {
            this.setItemToPanel(items[i], this.panel.panels[i]);
        }
        if (this.panel.panelCount == 0) {
            this.panel.addPanel();
        }
    };
    ConditionEditor.prototype.getIsOperatorEnabled = function (qName, qType, op, condQuestion, isContainer) {
        if (isContainer)
            return op === "empty" || op === "notempty";
        var isOperatorEnabled = ConditionEditor.isOperatorEnabled(qType, _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.operators[op]);
        return !!condQuestion ? this.options.isConditionOperatorEnabled(qName, condQuestion, op, isOperatorEnabled) : isOperatorEnabled;
    };
    ConditionEditor.prototype.isContainerQuestion = function (questionName) {
        if (!_creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.includeComplexQuestions || !questionName)
            return false;
        for (var key in this.addConditionQuestionsHash) {
            if (key.indexOf(questionName + ".") === 0 || key.indexOf(questionName + "[") === 0)
                return true;
        }
        return false;
    };
    ConditionEditor.prototype.setupConditionOperator = function (item, panel) {
        var _this = this;
        var questionOperator = panel.getQuestionByName("operator");
        questionOperator.choices = this.getOperators();
        questionOperator.value = item.operator;
        questionOperator.onOpened.add(function (_, opt) {
            _this.updateConditionChoices(panel, opt.choices);
        });
    };
    ConditionEditor.prototype.updateConditionChoices = function (panel, choices, questionOperator) {
        var _this = this;
        var isCurrentOperatorEnabled = true;
        var op = questionOperator === null || questionOperator === void 0 ? void 0 : questionOperator.value;
        var questionName = panel.getQuestionByName("questionName").value;
        var json = this.getQuestionConditionJson(questionName);
        var qType = !!json ? json.type : null;
        var isContainer = this.isContainerQuestion(questionName);
        var condQuestion = this.getConditionQuestion(questionName);
        choices.forEach(function (choice) {
            var isOperatorEnabled = _this.getIsOperatorEnabled(questionName, qType, choice.value, condQuestion, isContainer);
            choice.setIsEnabled(isOperatorEnabled);
            choice.setIsVisible(isOperatorEnabled);
            if (!!questionOperator && choice.value == op) {
                isCurrentOperatorEnabled = isOperatorEnabled;
            }
        });
        if (!isCurrentOperatorEnabled) {
            questionOperator.value = this.getFirstEnabledOperator(choices);
        }
    };
    ConditionEditor.prototype.setupConditionQuestionName = function (item, panel) {
        var panelQuestionName = panel.getQuestionByName("questionName");
        panelQuestionName.choices = this.getConditionQuestions();
        panelQuestionName.titleLocation = this.panel.panels.indexOf(panel) == 0 ? "left" : "hidden";
        var questionName = this.getQuestionNameToPanel(item.questionName);
        if (!!this.getConditionQuestion(questionName)) {
            panelQuestionName.value = questionName;
        }
    };
    ConditionEditor.prototype.setupRemoveQuestion = function (panel) {
        var dynamicPanel = (panel.getQuestionByName("removeAction").parentQuestion);
        var removeQuestionQuestion = panel.getQuestionByName("removeAction");
        removeQuestionQuestion.linkClickCallback = function () {
            if (!!dynamicPanel) {
                dynamicPanel.removePanelUI(panel);
            }
        };
        removeQuestionQuestion.linkSetButtonCssClasses = "svc-logic-condition-remove svc-icon-remove";
        removeQuestionQuestion.linkValueText = "";
    };
    ConditionEditor.prototype.setItemToPanel = function (item, panel) {
        this.isSettingPanelValues = true;
        panel.getQuestionByName("conjunction").value = item.conjunction;
        this.setupConditionOperator(item, panel);
        this.setupConditionQuestionName(item, panel);
        if (!!panel.getQuestionByName("questionValue")) {
            panel.getQuestionByName("questionValue").value = item.value;
            this.updateSurveyVariable(item);
        }
        this.setupRemoveQuestion(panel);
        this.isSettingPanelValues = false;
    };
    ConditionEditor.prototype.updateSurveyVariable = function (item) {
        this.editSurvey.setVariable(item.questionName, item.value);
    };
    ConditionEditor.prototype.getConditionQuestions = function () {
        if (!this.context)
            return this.allConditionQuestions;
        var res = [];
        for (var i = 0; i < this.allConditionQuestions.length; i++) {
            var item = this.allConditionQuestions[i];
            if (!item.context || item.context === this.context) {
                res.push(item);
            }
        }
        return res;
    };
    ConditionEditor.prototype.getText = function () {
        if (this.textEditor.visible)
            return this.textEditor.value;
        var res = "";
        var items = this.getEditorItems();
        for (var i = 0; i < items.length; i++) {
            if (!items[i].isReady)
                break;
            if (!!res) {
                res += " " + items[i].conjunction + " ";
            }
            res += items[i].toExpression();
        }
        return res;
    };
    ConditionEditor.prototype.getEditorItems = function () {
        var res = [];
        for (var i = 0; i < this.panel.panels.length; i++) {
            res.push(this.createEditorItemFromPanel(this.panel.panels[i]));
        }
        return res;
    };
    ConditionEditor.prototype.createEditorItemFromPanel = function (panel) {
        var item = new SurveyConditionEditorItem(this.survey);
        item.conjunction = panel.getQuestionByName("conjunction").value;
        item.questionName = this.getQuestionNameFromPanel(panel.getQuestionByName("questionName").value);
        item.operator = panel.getQuestionByName("operator").value;
        if (!!panel.getQuestionByName("questionValue")) {
            item.value = panel.getQuestionByName("questionValue").value;
            this.updateSurveyVariable(item);
        }
        return item;
    };
    ConditionEditor.prototype.getQuestionNameFromPanel = function (name) {
        if (!this.context || !name)
            return name;
        var prefix = this.context.getValueName() + ".";
        return name.replace(prefix, "");
    };
    ConditionEditor.prototype.getContextIndexInfo = function (name, prefix) {
        if (prefix === void 0) { prefix = ""; }
        return _survey_helper__WEBPACK_IMPORTED_MODULE_4__.SurveyHelper.getQuestionContextIndexInfo(name, prefix);
    };
    ConditionEditor.prototype.getQuestionNameToPanel = function (name) {
        if (!this.context || !name)
            return name;
        var indexInfo = this.getContextIndexInfo(name);
        if (!indexInfo || indexInfo.index !== 0)
            return name;
        return this.context.getValueName() + "." + name;
    };
    ConditionEditor.prototype.getContextFromPanels = function () {
        if (!!this.object)
            return null;
        for (var i = 0; i < this.panel.panels.length; i++) {
            var questionName = this.panel.panels[i].getQuestionByName("questionName").value;
            var context = this.getContextByQuestionName(questionName);
            if (!!context)
                return context;
        }
        return null;
    };
    ConditionEditor.prototype.updateNamesOnContextChanged = function () {
        for (var i = 0; i < this.panel.panels.length; i++) {
            this.panel.panels[i].getQuestionByName("questionName").choices = this.getConditionQuestions();
        }
    };
    ConditionEditor.prototype.getContextByQuestionName = function (name) {
        if (!name)
            return null;
        var indexInfo = this.getContextIndexInfo(name, ".");
        if (!indexInfo)
            return null;
        name = name.substring(0, indexInfo.index);
        return this.survey.getQuestionByValueName(name);
    };
    ConditionEditor.prototype.getConditionQuestionText = function (question, name) {
        return this.options.getObjectDisplayName(question, "condition-editor", "condition", name);
    };
    ConditionEditor.prototype.createAllConditionQuestions = function () {
        if (!this.survey)
            return [];
        var res = [];
        var questions = this.survey.getAllQuestions();
        var contextObject = this.getContextObject();
        var sortOrder = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.questionSortOrder;
        if (questions.length > 0) {
            for (var i = 0; i < questions.length; i++) {
                var question = questions[i];
                if (contextObject == question)
                    continue;
                var context = contextObject ? contextObject : (!this.context || this.context === question);
                if (_creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.includeComplexQuestions && question.isContainer) {
                    res.push({ question: question, name: question.name, text: question.title });
                }
                question.addConditionObjectsByContext(res, context);
            }
        }
        var variableNames = this.survey.getVariableNames();
        this.addSurveyCalculatedValues(variableNames);
        sortOrder = this.options.onConditionQuestionsGetListCallback(this.propertyName, this.object, this, res, variableNames);
        for (var i = 0; i < res.length; i++) {
            res[i].value = res[i].name;
            var question = !!res[i].question ? res[i].question : res[i];
            if (!this.options.showTitlesInExpressions) {
                var name_2 = res[i].name;
                var valueName = question.valueName;
                if (!!valueName && name_2.indexOf(valueName) == 0) {
                    name_2 = name_2.replace(valueName, question.name);
                }
                var unwrappedValueText = "-unwrapped";
                name_2 = name_2.replace(unwrappedValueText, "");
                res[i].text = this.getConditionQuestionText(question, name_2);
            }
            this.addConditionQuestionsHash[res[i].name] = question;
        }
        this.addValuesIntoConditionQuestions(variableNames, res);
        if (sortOrder === "asc") {
            _survey_helper__WEBPACK_IMPORTED_MODULE_4__.SurveyHelper.sortItems(res);
        }
        return res;
    };
    ConditionEditor.prototype.getContextObject = function () {
        if (this.object && this.object.isDescendantOf("itemvalue")) {
            var res = this.object.locOwner;
            if (!!res && res.getType) {
                if (!!res.locOwner && res.locOwner.isDescendantOf("matrixdropdowncolumn"))
                    return res.locOwner;
                return res;
            }
        }
        return this.object;
    };
    ConditionEditor.prototype.addValuesIntoConditionQuestions = function (values, res) {
        for (var i = 0; i < values.length; i++) {
            var name_3 = !!values[i].name ? values[i].name : values[i];
            this.addConditionQuestionsHash[name_3] = this.getCalculatedValueQuestion();
            res.push({
                value: name_3,
                text: name_3,
                question: this.getCalculatedValueQuestion()
            });
        }
    };
    ConditionEditor.prototype.addSurveyCalculatedValues = function (names) {
        this.survey.calculatedValues.forEach(function (item) {
            var index = names.indexOf(item.name.toLowerCase());
            if (index > -1) {
                names.splice(index, 1);
            }
            names.push(item.name);
        });
    };
    ConditionEditor.prototype.getCalculatedValueQuestion = function () {
        if (!this.calculatedValueQuestion) {
            this.calculatedValueQuestion = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass("text");
            this.calculatedValueQuestion.name = "question";
        }
        return this.calculatedValueQuestion;
    };
    ConditionEditor.prototype.getOperators = function () {
        var res = [];
        var ops = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.operators;
        for (var name_4 in ops) {
            res.push(new survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue(name_4, _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("op." + name_4)));
        }
        return res;
    };
    ConditionEditor.prototype.rebuildQuestionValue = function (panel) {
        if (!!panel.getQuestionByName("questionValue")) {
            panel.getQuestionByName("questionValue").clearValue();
        }
        var qName = panel.getQuestionByName("questionName").value;
        var json = this.getQuestionConditionJson(qName, panel.getQuestionByName("operator").value);
        if (!json) {
            json = {
                type: "text"
            };
        }
        json.isRequired = true;
        _survey_helper__WEBPACK_IMPORTED_MODULE_4__.SurveyHelper.updateQuestionJson(json);
        json.enableIf = "{panel.questionName} notempty and {panel.operator} != 'empty' and {panel.operator} != 'notempty'";
        var newQuestion = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass(json.type);
        delete json.type;
        new survey_core__WEBPACK_IMPORTED_MODULE_1__.JsonObject().toObject(json, newQuestion);
        if (!newQuestion) {
            newQuestion = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass("text", json);
        }
        var oldQuestion = panel.getQuestionByName("questionValue");
        if (!!oldQuestion) {
            panel.removeElement(oldQuestion);
        }
        if (this.canShowQuestionValue(panel)) {
            var title = newQuestion.title;
            newQuestion.name = "questionValue";
            newQuestion.visibleIf = "questionValueVisibleIf({panel.questionName}, {panel.operator})";
            newQuestion.title = title;
            newQuestion.description = "";
            newQuestion.titleLocation = "top";
            newQuestion.hasComment = false;
            if (newQuestion.showOtherItem) {
                var question = this.getConditionQuestion(qName);
                if (question && question.getStoreOthersAsComment && question.getStoreOthersAsComment()) {
                    var other = newQuestion.otherItem;
                    newQuestion.choices.push(new survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue(other.value, other.title));
                    other.value = "#" + other.value + "#";
                    newQuestion.showOtherItem = false;
                }
            }
            panel.addElement(newQuestion);
        }
    };
    ConditionEditor.prototype.rebuildQuestionValueOnOperandChanging = function (panel) {
        var json = this.getQuestionConditionJson(panel.getQuestionByName("questionName").value, panel.getQuestionByName("operator").value);
        var question = panel.getQuestionByName("questionValue");
        if (!!question && (question.isReadOnly || !question.isVisible)) {
            question.clearValue();
        }
        if (!question || (!!json && json.type == question.getType()))
            return;
        this.rebuildQuestionValue(panel);
    };
    ConditionEditor.prototype.canShowQuestionValue = function (panel) {
        var questionOperator = panel.getQuestionByName("operator");
        if (!questionOperator)
            return false;
        this.updateOperatorEnables(panel);
        var choices = questionOperator.choices;
        for (var i = 0; i < choices.length; i++) {
            if (!choices[i].isEnabled)
                continue;
            var val = choices[i].value;
            if (val !== "empty" && val != "notempty")
                return true;
        }
        return false;
    };
    ConditionEditor.prototype.getConditionQuestion = function (name) {
        return this.addConditionQuestionsHash[name];
    };
    ConditionEditor.prototype.getQuestionConditionJson = function (questionName, operator) {
        var path = "";
        var question = this.getConditionQuestion(questionName);
        if (!question)
            return null;
        if (!operator) {
            operator = this.getDefaultOperatorByQuestion(question);
        }
        if (questionName.indexOf(question.getValueName()) == 0) {
            path = questionName.substring(question.getValueName().length);
        }
        var indexInfo = this.getContextIndexInfo(questionName);
        if (!!indexInfo && indexInfo.index == 0) {
            path = questionName.substring(indexInfo.name.length);
        }
        if (!path) {
            path = questionName;
        }
        if (!!path && path[0] == ".") {
            path = path.substring(1);
        }
        var json = question && question.getConditionJson ? question.getConditionJson(operator, path) : null;
        if (!json)
            return null;
        if (!!json.choicesFromQuestion) {
            this.updateChoicesFromQuestion(json);
        }
        if (json.type == "expression") {
            json.type = "text";
        }
        if (operator == "anyof") {
            if (!ConditionEditor.isClassContains(json.type, ["checkbox"], [])) {
                json.type = "checkbox";
            }
        }
        return json;
    };
    ConditionEditor.prototype.updateChoicesFromQuestion = function (json) {
        var question = this.getConditionQuestion(json.choicesFromQuestion);
        if (!question)
            return;
        delete json.choicesFromQuestion;
        var questionJSON = question.toJSON();
        if (!!questionJSON.choices) {
            json.choices = questionJSON.choices;
        }
        if (!!questionJSON.choicesByUrl) {
            json.choicesByUrl = questionJSON.choicesByUrl;
        }
    };
    ConditionEditor.prototype.updateOperatorEnables = function (panel) {
        var questionOperator = panel.getQuestionByName("operator");
        if (!questionOperator)
            return;
        this.updateConditionChoices(panel, questionOperator.choices, questionOperator);
    };
    ConditionEditor.prototype.updateQuestionsWidth = function (panel) {
        var valueQuestion = panel.getQuestionByName("questionValue");
        var conjunctionQuestion = panel.getQuestionByName("conjunction");
        var nameQuestion = panel.getQuestionByName("questionName");
        var operatorQuestion = panel.getQuestionByName("operator");
        var isValueSameLine = !!valueQuestion && !valueQuestion.startWithNewLine;
        var isFirst = !conjunctionQuestion || !conjunctionQuestion.isVisible;
        if (!isFirst) {
            conjunctionQuestion.minWidth = "50px";
            conjunctionQuestion.width = "15%";
        }
        nameQuestion.minWidth = "50px";
        nameQuestion.width = isFirst ? "40%" : "25%";
        operatorQuestion.minWidth = "50px";
        operatorQuestion.width = isValueSameLine ? "25%" : "60%";
        if (!!valueQuestion) {
            valueQuestion.minWidth = "50px";
            valueQuestion.width = isValueSameLine ? "35%" : "";
        }
    };
    Object.defineProperty(ConditionEditor.prototype, "defaultOperator", {
        get: function () { return _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.defaultOperators.default; },
        enumerable: false,
        configurable: true
    });
    ConditionEditor.prototype.getDefaultOperatorByQuestionName = function (questionName) {
        return this.getDefaultOperatorByQuestion(this.getConditionQuestion(questionName));
    };
    ConditionEditor.prototype.getDefaultOperatorByQuestion = function (question) {
        if (!!question) {
            var defOps = _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.logic.defaultOperators;
            if (!!defOps[question.getType()])
                return defOps[question.getType()];
        }
        return this.defaultOperator;
    };
    ConditionEditor.prototype.getFirstEnabledOperator = function (choices) {
        for (var i = 0; i < choices.length; i++) {
            if (choices[i].isEnabled) {
                return choices[i].value;
            }
        }
        return this.defaultOperator;
    };
    ConditionEditor.prototype.onPanelAdded = function () {
        this.setItemToPanel(new ConditionEditorItem(), this.panel.panels[this.panel.panels.length - 1]);
    };
    ConditionEditor.prototype.onPanelValueChanged = function (panel, name) {
        if (name == "questionName") {
            this.context = this.getContextFromPanels();
            this.rebuildQuestionValue(panel);
            if (!this.isSettingPanelValues) {
                panel.getQuestionByName("operator").value = this.getDefaultOperatorByQuestionName(panel.getQuestionByName("questionName").value);
            }
        }
        if (name == "operator") {
            this.rebuildQuestionValueOnOperandChanging(panel);
        }
        this.updateOperatorEnables(panel);
        this.updateQuestionsWidth(panel);
    };
    ConditionEditor.prototype.onUpdateQuestionCssClasses = function (options) {
        var cssClasses = options.cssClasses;
        var question = options.question;
        if (question.getType() !== "paneldynamic") {
            cssClasses.answered = "svc-logic-question--answered";
        }
        if (question.name === "textEditor") {
            cssClasses.root += " svc-logic-question-text-editor";
        }
        if (question.name === "conjunction") {
            question.allowRootStyle = false;
            cssClasses.control += " svc-logic-operator svc-logic-operator--conjunction ";
        }
        if (question.name === "questionName") {
            question.allowRootStyle = false;
            cssClasses.control += " svc-logic-operator svc-logic-operator--question";
            cssClasses.error.root = "svc-logic-operator__error";
            cssClasses.onError = "svc-logic-operator--error";
        }
        if (question.name === "operator") {
            question.allowRootStyle = false;
            cssClasses.control += " svc-logic-operator svc-logic-operator--operator";
        }
        if (question.name === "removeAction") {
            question.allowRootStyle = false;
            cssClasses.mainRoot += " svc-logic-condition-remove-question";
        }
        if (question.name === "questionValue" || question.isContentElement) {
            (0,_utils_utils__WEBPACK_IMPORTED_MODULE_6__.assignDefaultV2Classes)(cssClasses, question.getType());
            cssClasses.mainRoot += " svc-logic-question-value sd-element--with-frame";
            cssClasses.error.root = "svc-logic-operator__error";
        }
        if (question.name === "panel") {
            cssClasses.root += " svc-logic-paneldynamic";
            cssClasses.buttonAdd += " svc-logic-operator--operator";
            cssClasses.iconRemove = "svc-icon-remove";
            cssClasses.buttonRemove = "svc-logic-paneldynamic__button svc-logic-paneldynamic__remove-btn";
            cssClasses.buttonRemoveRight = "svc-logic-paneldynamic__remove-btn--right";
            cssClasses.buttonRemoveText = "svc-logic-paneldynamic__button-remove-text";
        }
    };
    ConditionEditor.prototype.onValueChanged = function (options) {
        if (options.question.name === "panel" && options.value.length > 0) {
            var maxLogicItems = this.options.maxLogicItemsInCondition > 0 ? this.options.maxLogicItemsInCondition : 100;
            options.question.maxPanelCount = options.value.length === 1 && !options.value[0].questionName ? 1 : maxLogicItems;
            this.panel.panels.forEach(function (panel) {
                panel.getQuestionByName("removeAction").visible = options.value.length !== 1;
            });
        }
        this.setTitle();
    };
    ConditionEditor.prototype.setTitle = function () {
        var text = this.isReady ? this.text : "";
        this.title = this.options.onConditionGetTitleCallback(text, text || _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("pe.ruleIsNotSet"));
    };
    ConditionEditor.prototype.showTextEditor = function (expression) {
        this.panel.visible = false;
        this.textEditor.value = expression;
        this.textEditor.visible = true;
    };
    ConditionEditor.prototype.showBuilder = function (expression) {
        if (!this.isModal && !this.getCanShowBuilder(expression))
            return;
        this.textEditor.visible = false;
        this.processText(expression);
        this.panel.visible = true;
    };
    ConditionEditor.prototype.getCanShowBuilder = function (expression) {
        return ConditionEditor.canBuildExpression(expression);
    };
    return ConditionEditor;
}(_index__WEBPACK_IMPORTED_MODULE_5__.PropertyEditorSetupValue));



/***/ }),

/***/ "./src/property-grid/condition.ts":
/*!****************************************!*\
  !*** ./src/property-grid/condition.ts ***!
  \****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PropertyGridEditorCondition: () => (/* binding */ PropertyGridEditorCondition),
/* harmony export */   PropertyGridEditorExpression: () => (/* binding */ PropertyGridEditorExpression)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./index */ "./src/property-grid/index.ts");
/* harmony import */ var _condition_survey__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./condition-survey */ "./src/property-grid/condition-survey.ts");



var PropertyGridEditorExpression = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorExpression, _super);
    function PropertyGridEditorExpression() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorExpression.prototype.fit = function (prop) {
        return prop.type == "expression";
    };
    PropertyGridEditorExpression.prototype.getJSON = function (obj, prop, options) {
        return {
            type: "comment",
            showOptionsCaption: false,
            rows: 2
        };
    };
    PropertyGridEditorExpression.prototype.clearPropertyValue = function (obj, prop, question, options) {
        question.clearValue();
    };
    return PropertyGridEditorExpression;
}(_index__WEBPACK_IMPORTED_MODULE_1__.PropertyGridEditor));

var PropertyGridEditorCondition = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorCondition, _super);
    function PropertyGridEditorCondition() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorCondition.prototype.fit = function (prop) {
        return prop.type == "condition";
    };
    PropertyGridEditorCondition.prototype.getJSON = function (obj, prop, options) {
        return {
            type: "comment",
            showOptionsCaption: false,
            rows: 2,
        };
    };
    PropertyGridEditorCondition.prototype.canClearPropertyValue = function (obj, prop, question, options) {
        return options.allowEditExpressionsInTextEditor !== false;
    };
    PropertyGridEditorCondition.prototype.onSetup = function (obj, question, prop, options) {
        if (options.allowEditExpressionsInTextEditor === false) {
            question.onKeyDownPreprocess = function (event) {
                var allowed = ["Tab", "ArrowUp", "ArrowDown", "ArrowLeft", "ArrowRight", "Home", "End"];
                if (!event.ctrlKey && allowed.indexOf(event.key) < 0) {
                    event.preventDefault();
                }
            };
        }
    };
    PropertyGridEditorCondition.prototype.createPropertyEditorSetup = function (obj, prop, question, options) {
        return new _condition_survey__WEBPACK_IMPORTED_MODULE_2__.ConditionEditor(obj.getSurvey(), obj, options, prop.name);
    };
    return PropertyGridEditorCondition;
}(PropertyGridEditorExpression));

_index__WEBPACK_IMPORTED_MODULE_1__.PropertyGridEditorCollection.register(new PropertyGridEditorExpression());
_index__WEBPACK_IMPORTED_MODULE_1__.PropertyGridEditorCollection.register(new PropertyGridEditorCondition());


/***/ }),

/***/ "./src/property-grid/description-parser.ts":
/*!*************************************************!*\
  !*** ./src/property-grid/description-parser.ts ***!
  \*************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DescriptionMardownParser: () => (/* binding */ DescriptionMardownParser),
/* harmony export */   parsePropertyDescription: () => (/* binding */ parsePropertyDescription)
/* harmony export */ });
var DescriptionMardownParser = /** @class */ (function () {
    function DescriptionMardownParser() {
    }
    DescriptionMardownParser.prototype.parse = function (text) {
        if (!DescriptionMardownParser.boldRegEx) {
            DescriptionMardownParser.boldRegEx = /\*{2}(.*?)\*{2}/gm;
            DescriptionMardownParser.italicRegEx = /\_(.*?)\_/gm;
            DescriptionMardownParser.codeRegEx = /\`(.*?)\`/gm;
            DescriptionMardownParser.linkRegEx = /\[(.+)\]\(([^ ]+?)( "(.+)")?\)/;
        }
        var createSpan = function (text, str, className, chars) {
            if (!str)
                return text;
            var index = text.indexOf(str);
            if (checkIfLink(text, index))
                return text;
            var innerStr = str.substring(chars.length, str.length);
            innerStr = innerStr.substring(0, innerStr.length - chars.length);
            var newStr = "<span class='" + className + "'>" + innerStr + "</span>";
            return text.replace(str, newStr);
        };
        var checkIfLink = function (text, index) {
            var isBracket = false;
            for (var i = index - 1; i > 0; i--) {
                if (text[i] === " " || text[i] === "\n")
                    return false;
                if (text[i] === "]" && isBracket)
                    return true;
                isBracket = text[i] === "(";
            }
            return false;
        };
        var createLink = function (text, str, className, chars) {
            if (!str)
                return text;
            var index = str.indexOf("](");
            if (index < 0)
                return text;
            var contentStr = str.substring(1, index);
            var linkStr = str.substring(index + 2, str.length - 1);
            var newStr = "<a class='" + className + "' target='_blank' href='" + linkStr + "'>" + contentStr + "</a>";
            return text.replace(str, newStr);
        };
        text = this.replace(DescriptionMardownParser.boldRegEx, text, "spg-bold", "**", createSpan);
        text = this.replace(DescriptionMardownParser.italicRegEx, text, "spg-italic", "_", createSpan);
        text = this.replace(DescriptionMardownParser.codeRegEx, text, "spg-code", "`", createSpan);
        text = this.replace(DescriptionMardownParser.linkRegEx, text, "spg-link", "", createLink);
        text = this.addLineBreaks(text);
        return text;
    };
    DescriptionMardownParser.prototype.replace = function (re, text, className, chars, replaceFunc) {
        var rArray = text.match(re);
        if (!Array.isArray(rArray) || rArray.length == 0)
            return text;
        for (var i = 0; i < rArray.length; i++) {
            text = replaceFunc(text, rArray[i], className, chars);
        }
        return text;
    };
    DescriptionMardownParser.prototype.addLineBreaks = function (text) {
        var br = "\n";
        if (text.indexOf(br) < 0)
            return text;
        var strs = text.split(br);
        return strs.join("<br/>");
    };
    return DescriptionMardownParser;
}());

function parsePropertyDescription(text) {
    return new DescriptionMardownParser().parse(text);
}


/***/ }),

/***/ "./src/property-grid/fast-entry.ts":
/*!*****************************************!*\
  !*** ./src/property-grid/fast-entry.ts ***!
  \*****************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   FastEntryEditor: () => (/* binding */ FastEntryEditor),
/* harmony export */   FastEntryEditorBase: () => (/* binding */ FastEntryEditorBase)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./index */ "./src/property-grid/index.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");




var FastEntryEditorBase = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(FastEntryEditorBase, _super);
    function FastEntryEditorBase(choices, options, className, names) {
        if (options === void 0) { options = null; }
        if (className === void 0) { className = "item"; }
        if (names === void 0) { names = []; }
        var _this = _super.call(this, options) || this;
        _this.choices = choices;
        _this.className = className;
        _this.names = names;
        _this.commentValue = (_this.editSurvey.getQuestionByName("question"));
        _this.setComment();
        _this.editSurvey.getQuestionByName("question").placeholder =
            _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("pe.fastEntryPlaceholder");
        _this.editSurvey.onValidateQuestion.add(function (sender, options) {
            var minChoiceCount = _this.options.minimumChoicesCount;
            if (minChoiceCount > 0) {
                var choicesCount = _this.getChoicesCount();
                if (minChoiceCount > choicesCount) {
                    options.error = _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization
                        .getString("pe.fastEntryChoicesMinCountError")["format"](minChoiceCount);
                }
                return;
            }
            var maxChoicesCount = _this.options.maximumChoicesCount;
            if (maxChoicesCount > 0) {
                var choicesCount = _this.getChoicesCount();
                if (maxChoicesCount < choicesCount) {
                    options.error = _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization
                        .getString("pe.fastEntryChoicesCountError")["format"](choicesCount, maxChoicesCount);
                }
                return;
            }
            if (!_this.isValueUnique)
                return;
            var uniqueValue = _this.getFirstUniqueValue();
            if (!!uniqueValue) {
                options.error = _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization
                    .getString("pe.fastEntryNonUniqueError")["format"](uniqueValue);
            }
        });
        return _this;
    }
    FastEntryEditorBase.prototype.calcBeforeApplyItemsArray = function (dest, src, names) {
        if (!src || src.length == 0) {
            dest.splice(0, dest.length);
            return;
        }
        if (dest.length > src.length) {
            dest.splice(src.length, dest.length - src.length);
        }
        if (dest.length < src.length) {
            var insertedArray = [];
            for (var i = dest.length; i < src.length; i++) {
                insertedArray.push(src[i]);
            }
            dest.splice.apply(dest, [dest.length, 0].concat(insertedArray));
        }
    };
    FastEntryEditorBase.prototype.applyItemValueArray = function (dest, src, names) {
        if (names === void 0) { names = []; }
        this.calcBeforeApplyItemsArray(dest, src, names);
        for (var i = 0; i < dest.length; i++) {
            names.forEach(function (name) {
                dest[i][name] = src[i][name];
            });
        }
    };
    FastEntryEditorBase.prototype.getSurveyJSON = function () {
        return {
            elements: [
                {
                    type: "comment",
                    name: "question",
                    titleLocation: "hidden",
                    rows: 12
                }
            ]
        };
    };
    FastEntryEditorBase.prototype.getSurveyCreationReason = function () {
        return "fast-entry";
    };
    FastEntryEditorBase.prototype.apply = function () {
        if (this.comment.isEmpty())
            return false;
        return this.applyCore();
    };
    FastEntryEditorBase.prototype.applyCore = function () {
        if (this.editSurvey.hasErrors(true))
            return false;
        var text = this.comment.value || "";
        var texts = text.split("\n") || [];
        var items = this.convertTextToItemValues(texts);
        items = this.options.onFastEntryCallback(items, texts);
        this.applyItemValueArray(this.choices, items, this.names);
        return true;
    };
    FastEntryEditorBase.prototype.convertTextToItemValues = function (texts) {
        var items = [];
        for (var i = 0; i < texts.length; i++) {
            if (!texts[i])
                continue;
            var elements = texts[i].split(survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue.Separator);
            var valueItem = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass(this.className);
            this.names.forEach(function (name, i) {
                valueItem[name] = elements[i];
            });
            items.push(valueItem);
        }
        return items;
    };
    Object.defineProperty(FastEntryEditorBase.prototype, "comment", {
        get: function () {
            return this.commentValue;
        },
        enumerable: false,
        configurable: true
    });
    FastEntryEditorBase.prototype.getChoicesCount = function () {
        var texts = this.comment.value.split("\n");
        var res = 0;
        for (var i = 0; i < texts.length; i++) {
            var str = texts[i];
            if (!!str)
                res++;
        }
        return res;
    };
    Object.defineProperty(FastEntryEditorBase.prototype, "isValueUnique", {
        get: function () {
            return survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty("itemvalue", "value").isUnique === true;
        },
        enumerable: false,
        configurable: true
    });
    FastEntryEditorBase.prototype.getFirstUniqueValue = function () {
        var texts = this.comment.value.split("\n");
        var values = {};
        for (var i = 0; i < texts.length; i++) {
            var str = texts[i];
            if (!str)
                continue;
            var value = str.split(survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue.Separator)[0];
            if (values[value])
                return value;
            values[value] = true;
        }
        return undefined;
    };
    FastEntryEditorBase.prototype.setComment = function () {
        var text = this.convertItemValuesToText();
        this.comment.value = text;
    };
    FastEntryEditorBase.prototype.collectNames = function (item, type, separatorCounter) {
        var text = "";
        this.names.forEach(function (name) {
            if (type === "itemvalues") {
                if (name == "value")
                    return;
                var str = name == "text" ? item.pureText : item[name];
            }
            else {
                var str = item[name];
            }
            if (!!str) {
                for (var i = 0; i < separatorCounter; i++) {
                    text += survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue.Separator;
                }
                text += str;
                separatorCounter = 1;
            }
            else {
                separatorCounter++;
            }
        });
        return text;
    };
    FastEntryEditorBase.prototype.convertItemValuesToText = function () {
        var _this = this;
        var text = "";
        this.choices.forEach(function (item) {
            if (text)
                text += "\n";
            text += _this.collectNames(item, "", 0);
        });
        return text;
    };
    return FastEntryEditorBase;
}(_index__WEBPACK_IMPORTED_MODULE_2__.PropertyEditorSetupValue));

var FastEntryEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(FastEntryEditor, _super);
    function FastEntryEditor(choices, options, className, names) {
        if (options === void 0) { options = null; }
        if (className === void 0) { className = "itemvalue"; }
        if (names === void 0) { names = ["value", "text"]; }
        var _this = _super.call(this, choices, options, className, names) || this;
        _this.choices = choices;
        _this.className = className;
        _this.names = names;
        return _this;
    }
    FastEntryEditor.prototype.apply = function () {
        return this.applyCore();
    };
    FastEntryEditor.prototype.applyItemValueArray = function (dest, src, names) {
        if (names === void 0) { names = []; }
        this.calcBeforeApplyItemsArray(dest, src, names);
        for (var i = 0; i < dest.length; i++) {
            if (dest[i].value != src[i].value) {
                dest[i].value = src[i].value;
            }
            dest[i].text = src[i].hasText ? src[i].text : "";
            names.forEach(function (name) {
                if (name == "value" || name == "text")
                    return;
                dest[i][name] = src[i][name];
            });
        }
    };
    FastEntryEditor.prototype.convertItemValuesToText = function () {
        var _this = this;
        var text = "";
        this.choices.forEach(function (item) {
            if (text)
                text += "\n";
            text += item.value;
            text += _this.collectNames(item, "itemvalues", 1);
        });
        return text;
    };
    return FastEntryEditor;
}(FastEntryEditorBase));



/***/ }),

/***/ "./src/property-grid/header-settings.ts":
/*!**********************************************!*\
  !*** ./src/property-grid/header-settings.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PropertyGridEditorQuestionHeader: () => (/* binding */ PropertyGridEditorQuestionHeader)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./index */ "./src/property-grid/index.ts");
/* harmony import */ var _components_tabs_theme_model_definition__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../components/tabs/theme-model-definition */ "./src/components/tabs/theme-model-definition.ts");




var json = {
    name: "propertygrid_header",
    showInToolbox: false,
    internal: true,
    createElements: function (panel) {
        //tell ComponentCollection that it is composite question
    }
};
if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.getCustomQuestionByName(json.name)) {
    survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.add(json);
}
var PropertyGridEditorQuestionHeader = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorQuestionHeader, _super);
    function PropertyGridEditorQuestionHeader() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorQuestionHeader.prototype.fit = function (prop) {
        return prop.type == "header";
    };
    PropertyGridEditorQuestionHeader.prototype.getJSON = function (obj, prop, options) {
        return {
            type: "propertygrid_header",
            titleLocation: "hidden"
        };
    };
    PropertyGridEditorQuestionHeader.prototype.onCreated = function (obj, question, prop, options, propGridDefinition) {
        var panel = question["contentPanel"];
        var header = obj[prop.name];
        var propertyGenerator = new _index__WEBPACK_IMPORTED_MODULE_2__.PropertyJSONGenerator(header, options, obj, prop, _components_tabs_theme_model_definition__WEBPACK_IMPORTED_MODULE_3__.themeModelPropertyGridDefinition);
        propertyGenerator.setupObjPanel(panel, true);
        var settingsPanel;
        var questions = panel.elements;
        for (var i = 0; i < questions.length; i++) {
            if (questions[i].name == "settings") {
                settingsPanel = questions[i];
            }
        }
        settingsPanel.state = undefined;
        settingsPanel.title = "";
        settingsPanel.elements.forEach(function (el) {
            el.title = "";
            el.state = undefined;
        });
    };
    return PropertyGridEditorQuestionHeader;
}(_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditor));

_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditorCollection.register(new PropertyGridEditorQuestionHeader());


/***/ }),

/***/ "./src/property-grid/icons.ts":
/*!************************************!*\
  !*** ./src/property-grid/icons.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   pgTabIcons: () => (/* binding */ pgTabIcons)
/* harmony export */ });
var pgTabIcons = {
    "appearance": "icon-pg-appearance-24x24",
    "background": "icon-pg-background-24x24",
    "columns": "icon-pg-columns-24x24",
    "logic": "icon-pg-conditions-24x24",
    "data": "icon-pg-data-24x24",
    "design": "icon-pg-design-24x24",
    "general": "icon-pg-general-24x24",
    "header": "icon-pg-header-24x24",
    "language": "icon-pg-language-24x24",
    "layout": "icon-pg-layout-24x24",
    "logo": "icon-pg-logo-24x24",
    "navigation": "icon-pg-navigation-24x24",
    "pages": "icon-pg-pages-24x24",
    "question": "icon-pg-questiondesign-24x24",
    "timer": "icon-pg-quiz-24x24",
    "rows": "icon-pg-rows-24x24",
    "specific": "icon-pg-specific-24x24",
    "showOnCompleted": "icon-pg-thankyyoupage-24x24",
    "themes": "icon-pg-themes-24x24",
    "totals": "icon-pg-totals-24x24",
    "validation": "icon-pg-validation-24x24",
    "undefined": "icon-pg-undefined-24x24",
};


/***/ }),

/***/ "./src/property-grid/index.ts":
/*!************************************!*\
  !*** ./src/property-grid/index.ts ***!
  \************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PropertyEditorSetupValue: () => (/* binding */ PropertyEditorSetupValue),
/* harmony export */   PropertyGridEditor: () => (/* binding */ PropertyGridEditor),
/* harmony export */   PropertyGridEditorBoolean: () => (/* binding */ PropertyGridEditorBoolean),
/* harmony export */   PropertyGridEditorCollection: () => (/* binding */ PropertyGridEditorCollection),
/* harmony export */   PropertyGridEditorColor: () => (/* binding */ PropertyGridEditorColor),
/* harmony export */   PropertyGridEditorColorWithAlpha: () => (/* binding */ PropertyGridEditorColorWithAlpha),
/* harmony export */   PropertyGridEditorDateTime: () => (/* binding */ PropertyGridEditorDateTime),
/* harmony export */   PropertyGridEditorDropdown: () => (/* binding */ PropertyGridEditorDropdown),
/* harmony export */   PropertyGridEditorHtml: () => (/* binding */ PropertyGridEditorHtml),
/* harmony export */   PropertyGridEditorImageSize: () => (/* binding */ PropertyGridEditorImageSize),
/* harmony export */   PropertyGridEditorNumber: () => (/* binding */ PropertyGridEditorNumber),
/* harmony export */   PropertyGridEditorPage: () => (/* binding */ PropertyGridEditorPage),
/* harmony export */   PropertyGridEditorQuestion: () => (/* binding */ PropertyGridEditorQuestion),
/* harmony export */   PropertyGridEditorQuestionCarryForward: () => (/* binding */ PropertyGridEditorQuestionCarryForward),
/* harmony export */   PropertyGridEditorQuestionSelectBase: () => (/* binding */ PropertyGridEditorQuestionSelectBase),
/* harmony export */   PropertyGridEditorQuestionValue: () => (/* binding */ PropertyGridEditorQuestionValue),
/* harmony export */   PropertyGridEditorSet: () => (/* binding */ PropertyGridEditorSet),
/* harmony export */   PropertyGridEditorSpinEdit: () => (/* binding */ PropertyGridEditorSpinEdit),
/* harmony export */   PropertyGridEditorString: () => (/* binding */ PropertyGridEditorString),
/* harmony export */   PropertyGridEditorStringArray: () => (/* binding */ PropertyGridEditorStringArray),
/* harmony export */   PropertyGridEditorStringBase: () => (/* binding */ PropertyGridEditorStringBase),
/* harmony export */   PropertyGridEditorSwitchToggle: () => (/* binding */ PropertyGridEditorSwitchToggle),
/* harmony export */   PropertyGridEditorText: () => (/* binding */ PropertyGridEditorText),
/* harmony export */   PropertyGridEditorUndefinedBoolean: () => (/* binding */ PropertyGridEditorUndefinedBoolean),
/* harmony export */   PropertyGridLinkEditor: () => (/* binding */ PropertyGridLinkEditor),
/* harmony export */   PropertyGridModel: () => (/* binding */ PropertyGridModel),
/* harmony export */   PropertyGridTitleActionsCreator: () => (/* binding */ PropertyGridTitleActionsCreator),
/* harmony export */   PropertyJSONGenerator: () => (/* binding */ PropertyJSONGenerator),
/* harmony export */   setSurveyJSONForPropertyGrid: () => (/* binding */ setSurveyJSONForPropertyGrid)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _editable_object__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../editable-object */ "./src/editable-object.ts");
/* harmony import */ var _property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../property-grid-theme/property-grid */ "./src/property-grid-theme/property-grid.ts");
/* harmony import */ var _question_editor_properties__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../question-editor/properties */ "./src/question-editor/properties.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _description_parser__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ./description-parser */ "./src/property-grid/description-parser.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");












function propertyVisibleIf(params) {
    if (!this.question)
        return false;
    var obj = this.question.obj;
    var prop = this.question.property;
    if (!obj || !prop)
        return false;
    if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.hasOriginalProperty(obj, prop.name))
        return false;
    return prop.isVisible("", obj);
}
function propertyEnableIf(params) {
    var prop = this.question.property;
    var obj = this.question.obj;
    if (!this.question || !obj || !prop)
        return false;
    if (this.question.obj[prop.overridingProperty])
        return false;
    return prop.isEnable(obj);
}
survey_core__WEBPACK_IMPORTED_MODULE_1__.FunctionFactory.Instance.register("propertyVisibleIf", propertyVisibleIf);
survey_core__WEBPACK_IMPORTED_MODULE_1__.FunctionFactory.Instance.register("propertyEnableIf", propertyEnableIf);
function setSurveyJSONForPropertyGrid(json, updateOnTyping, titleLocationLeft) {
    if (updateOnTyping === void 0) { updateOnTyping = true; }
    if (titleLocationLeft === void 0) { titleLocationLeft = true; }
    json.showNavigationButtons = "none";
    json.showPageTitles = false;
    json.focusFirstQuestionAutomatic = false;
    json.showQuestionNumbers = "off";
    if (titleLocationLeft) {
        json.questionTitleLocation = "left";
    }
    json.showProgressBar = "off";
    if (updateOnTyping) {
        json.textUpdateMode = "onTyping";
    }
    json.requiredText = "";
}
var PropertyEditorSetupValue = /** @class */ (function () {
    function PropertyEditorSetupValue(options, doSetup) {
        if (options === void 0) { options = null; }
        if (doSetup === void 0) { doSetup = true; }
        this.options = options;
        if (!this.options) {
            this.options = new _creator_settings__WEBPACK_IMPORTED_MODULE_6__.EmptySurveyCreatorOptions();
        }
        if (doSetup) {
            this.setupSurvey();
        }
    }
    PropertyEditorSetupValue.prototype.setupSurvey = function () {
        this.editSurveyValue = this.createSurvey();
    };
    Object.defineProperty(PropertyEditorSetupValue.prototype, "editSurvey", {
        get: function () {
            return this.editSurveyValue;
        },
        enumerable: false,
        configurable: true
    });
    PropertyEditorSetupValue.prototype.hasErrors = function () {
        return this.editSurvey.hasErrors(true, true);
    };
    PropertyEditorSetupValue.prototype.createSurvey = function () {
        var json = this.getSurveyJSON();
        setSurveyJSONForPropertyGrid(json, false, false);
        return this.options.createSurvey(json, this.getSurveyCreationReason(), this);
    };
    PropertyEditorSetupValue.prototype.dispose = function () {
        if (!!this.editSurvey) {
            this.editSurvey.dispose();
        }
    };
    return PropertyEditorSetupValue;
}());

var PropertyGridEditorCollection = {
    editors: new Array(),
    fitHash: {},
    clearHash: function () {
        this.fitHash = {};
    },
    register: function (editor) {
        this.editors.push(editor);
    },
    getEditor: function (prop, context) {
        if (!prop)
            return null;
        if (!!context) {
            for (var i = this.editors.length - 1; i >= 0; i--) {
                var ed_1 = this.editors[i];
                if (ed_1.fit(prop, context))
                    return ed_1;
            }
        }
        var fitEd = this.fitHash[prop.id];
        if (!!fitEd)
            return fitEd;
        var ed = this.isEditorFit(prop);
        return !!ed ? ed : this.isEditorFit(prop, true);
    },
    isEditorFit: function (prop, asDefault) {
        if (asDefault === void 0) { asDefault = false; }
        for (var i = this.editors.length - 1; i >= 0; i--) {
            var ed = this.editors[i];
            if ((!asDefault && ed.fit(prop)) ||
                (asDefault && ed.isDefault && ed.isDefault())) {
                this.fitHash[prop.id] = ed;
                return ed;
            }
        }
        return null;
    },
    getJSON: function (obj, prop, options, context, propGridDefinition) {
        var res = this.getEditor(prop, context);
        return !!res ? res.getJSON(obj, prop, options, propGridDefinition) : null;
    },
    onCreated: function (obj, question, prop, options, propGridDefinition) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onCreated) {
            res.onCreated(obj, question, prop, options, propGridDefinition);
        }
    },
    onSetup: function (obj, question, prop, options) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onSetup) {
            res.onSetup(obj, question, prop, options);
        }
    },
    validateValue: function (obj, question, prop, value) {
        var res = this.getEditor(prop);
        if (!!res && !!res.validateValue) {
            return res.validateValue(obj, question, prop, value);
        }
        return "";
    },
    onAfterRenderQuestion: function (obj, prop, evtOptions) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onAfterRenderQuestion) {
            res.onAfterRenderQuestion(obj, prop, evtOptions);
        }
    },
    onMatrixCellCreated: function (obj, prop, options) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onMatrixCellCreated) {
            res.onMatrixCellCreated(options.question.obj, options);
        }
    },
    onMatrixCellValueChanged: function (obj, prop, options) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onMatrixCellValueChanged) {
            res.onMatrixCellValueChanged(obj, options);
        }
        var row = options.row;
        if (!!row) {
            var questions = row.questions;
            for (var i = 0; i < questions.length; i++) {
                if (questions[i].errors.length > 0)
                    return;
            }
            var cellQuestion = row.getQuestionByName(options.columnName);
            if (!!cellQuestion) {
                row.runCondition({}, { question: cellQuestion });
            }
        }
    },
    onMatrixAllowRemoveRow: function (obj, prop, row) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onMatrixAllowRemoveRow) {
            return res.onMatrixAllowRemoveRow(obj, row);
        }
        return true;
    },
    onGetMatrixRowAction: function (obj, prop, options, setObjFunc) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onGetMatrixRowAction) {
            res.onGetMatrixRowAction(obj, options, setObjFunc);
        }
    },
    onUpdateQuestionCssClasses: function (obj, prop, options) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onUpdateQuestionCssClasses) {
            res.onUpdateQuestionCssClasses(obj, options);
        }
    },
    onGetQuestionTitleActions: function (obj, prop, options, creator) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onGetQuestionTitleActions) {
            res.onGetQuestionTitleActions(obj, options, creator);
        }
    },
    onValueChanged: function (obj, prop, question) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onValueChanged) {
            res.onValueChanged(obj, prop, question);
        }
    },
    onValueChanging: function (obj, prop, question, options) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onValueChanging) {
            res.onValueChanging(obj, prop, question, options);
        }
    },
    onMasterValueChanged: function (obj, prop, question) {
        var res = this.getEditor(prop);
        if (!!res && !!res.onMasterValueChanged) {
            res.onMasterValueChanged(obj, prop, question);
        }
    },
};
var PropertyGridTitleActionsCreator = /** @class */ (function () {
    function PropertyGridTitleActionsCreator(obj, options) {
        this.obj = obj;
        this.options = options;
    }
    PropertyGridTitleActionsCreator.prototype.onGetQuestionTitleActions = function (options) {
        var question = options.question;
        var property = question.property;
        var editor = PropertyGridEditorCollection.getEditor(property);
        if (!editor)
            return;
        var actions = [];
        var enabled = !question.isReadOnly;
        var hasClear = !!editor.clearPropertyValue && (!editor.canClearPropertyValue || editor.canClearPropertyValue(this.obj, property, question, this.options));
        if (hasClear) {
            actions.push(this.createClearValueAction(editor, property, question, enabled));
        }
        if (question.allowBatchEdit !== false) {
            if (!!editor.createPropertyEditorSetup) {
                if (!!editor.isPropertyEditorSetupEnabled) {
                    enabled = editor.isPropertyEditorSetupEnabled(this.obj, property, options.question, this.options);
                }
                actions.push(this.createEditorSetupAction(editor, property, question, enabled));
            }
        }
        var helpAction = this.createPropertyHelpAction(question);
        if (!!helpAction) {
            actions.unshift(helpAction);
            question.getTitleToolbar().containerCss += " spg-title-toolbar--single-help-action";
        }
        if (actions.length > 0) {
            options.titleActions = actions;
        }
    };
    PropertyGridTitleActionsCreator.prototype.createClearValueAction = function (editor, property, question, enabled) {
        var _this = this;
        return {
            id: "property-grid-clear",
            title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("pe.clear"),
            showTitle: false,
            iconName: "icon-clear",
            iconSize: "auto",
            innerCss: "spg-action-button--danger",
            enabled: enabled,
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                var propertyValue = question.obj[property.name];
                return Array.isArray(propertyValue) ? propertyValue.length > 0 : !!propertyValue;
            }),
            action: function () {
                editor.clearPropertyValue(question.obj, property, question, _this.options);
            }
        };
    };
    PropertyGridTitleActionsCreator.prototype.showModalPropertyEditor = function (editor, property, question) {
        return editor.showModalPropertyEditor(editor, property, question, this.options);
    };
    PropertyGridTitleActionsCreator.prototype.createEditorSetupAction = function (editor, property, question, enabled) {
        var _this = this;
        var setupAction = {
            id: "property-grid-setup",
            iconName: property.isArray ? "icon-fast-entry" : "icon-wizard",
            iconSize: "auto",
            enabled: enabled,
            title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("pe.edit"),
            showTitle: false,
            action: function () {
                return _this.showModalPropertyEditor(editor, property, question);
            }
        };
        return setupAction;
    };
    PropertyGridTitleActionsCreator.prototype.createPropertyHelpAction = function (question) {
        var _this = this;
        if (!question.description)
            return null;
        var action = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            title: "",
            tooltip: question.description,
            id: "property-grid-help",
            iconName: this.getHelpActionIconName(question),
            iconSize: "auto",
            css: "spg-help-action",
            showTitle: false,
            action: function () {
                question.descriptionLocation =
                    question.descriptionLocation != "hidden" ? "hidden" : "underTitle";
                action.iconName = _this.getHelpActionIconName(question);
            }
        });
        var baseOnMouseDown = action.doMouseDown;
        action.doMouseDown = function (args) {
            baseOnMouseDown.call(action);
            var evt = !!args.originalEvent ? args.originalEvent : args;
            evt.preventDefault();
            evt.stopPropagation();
        };
        return action;
    };
    PropertyGridTitleActionsCreator.prototype.getHelpActionIconName = function (question) {
        return question.descriptionLocation != "hidden" ? "icon-description-hide" : "icon-description";
    };
    return PropertyGridTitleActionsCreator;
}());

var PropertyJSONGenerator = /** @class */ (function () {
    function PropertyJSONGenerator(obj, options, parentObj, parentProperty, propertyGridDefinition) {
        if (options === void 0) { options = null; }
        if (parentObj === void 0) { parentObj = null; }
        if (parentProperty === void 0) { parentProperty = null; }
        if (propertyGridDefinition === void 0) { propertyGridDefinition = null; }
        this.obj = obj;
        this.options = options;
        this.parentObj = parentObj;
        this.parentProperty = parentProperty;
        this.propertyGridDefinition = propertyGridDefinition;
    }
    PropertyJSONGenerator.isPropertyReadOnly = function (prop, options, obj, parentObj, parentProperty) {
        var res = prop.readOnly;
        if (!!options && !!obj) {
            res = options.onIsPropertyReadOnlyCallback(obj, prop, res, parentObj, parentProperty);
        }
        return res;
    };
    PropertyJSONGenerator.getClassNameProperty = function (obj) {
        if (!!obj && !!obj["getClassNameProperty"])
            return obj["getClassNameProperty"]();
        return undefined;
    };
    PropertyJSONGenerator.prototype.toJSON = function (isNested, context) {
        if (isNested === void 0) { isNested = false; }
        if (context === void 0) { context = undefined; }
        return this.createJSON(isNested, context);
    };
    PropertyJSONGenerator.prototype.createColumnsJSON = function (className, names) {
        var res = [];
        var obj = (className ? survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass(className) : this.obj) || this.obj;
        for (var i = 0; i < names.length; i++) {
            var columnJSON = this.getColumnPropertyJSON(obj, names[i]);
            if (!!columnJSON) {
                res.push(columnJSON);
            }
        }
        return res;
    };
    PropertyJSONGenerator.prototype.setupObjPanel = function (panel, isNestedObj, context) {
        if (isNestedObj === void 0) { isNestedObj = false; }
        if (context === void 0) { context = undefined; }
        panel.fromJSON(this.toJSON(isNestedObj, context));
        this.onQuestionsCreated(panel);
    };
    PropertyJSONGenerator.prototype.setupPages = function (survey) {
        var _this = this;
        var json = this.convertPanelsToPages(this.toJSON(false));
        var surveyJSON = survey.toJSON();
        Object.keys(json).forEach(function (key) { return surveyJSON[key] = json[key]; });
        survey.fromJSON(surveyJSON);
        survey.pages.forEach(function (page) { return _this.onQuestionsCreated(page); });
    };
    PropertyJSONGenerator.prototype.convertPanelsToPages = function (json) {
        var elements = json.elements;
        if (!Array.isArray(elements))
            return;
        elements.forEach(function (el) {
            delete el.type;
        });
        json["pages"] = elements;
        delete json.elements;
        return json;
    };
    PropertyJSONGenerator.prototype.onQuestionsCreated = function (panel) {
        var properties = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.getPropertiesByObj(this.obj);
        var props = {};
        for (var i = 0; i < properties.length; i++) {
            props[properties[i].name] = properties[i];
        }
        var questions = panel.questions;
        for (var i = 0; i < questions.length; i++) {
            var q = questions[i];
            var prop = props[q.name];
            q.property = prop;
            q.obj = this.obj;
            q.creatorOptions = this.options;
            var eventVisibility = this.getVisibilityOnEvent(prop);
            q.readOnly = q.readOnly || this.isPropertyReadOnly(prop);
            q.visible = q.visible && eventVisibility;
            if (!!prop.visibleIf && eventVisibility) {
                q.visibleIf = "propertyVisibleIf() = true";
            }
            if (q.visible && (!!prop.overridingProperty || prop.enableIf)) {
                if (!q.readOnly) {
                    q.enableIf = "propertyEnableIf() = true";
                }
                if (prop.overridingProperty) {
                    q.onUpdateCssClassesCallback = function (css) {
                        css.questionWrapper = "spg-boolean-wrapper--overriding";
                    };
                    var overridingQuestion = this.createOverridingQuestion(panel, q, prop.overridingProperty);
                    if (!!overridingQuestion) {
                        q.parent.addElement(overridingQuestion, q.parent.elements.indexOf(q) + 1);
                    }
                }
            }
            q.descriptionLocation = "hidden";
            var helpText = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getPropertyHelpInEditor(this.obj.getType(), prop.name, prop.type);
            if (!!helpText) {
                q.description = helpText;
            }
            PropertyGridEditorCollection.onCreated(this.obj, q, prop, this.options, this.propertyGridDefinition);
            this.options.onPropertyEditorCreatedCallback(this.obj, prop, q);
        }
    };
    PropertyJSONGenerator.prototype.getVisibilityOnEvent = function (prop, showMode) {
        if (showMode === void 0) { showMode = ""; }
        return this.options.onCanShowPropertyCallback(this.obj, prop, showMode, this.parentObj, this.parentProperty);
    };
    PropertyJSONGenerator.prototype.isPropertyReadOnly = function (prop) {
        return PropertyJSONGenerator.isPropertyReadOnly(prop, this.options, this.obj, this.parentObj, this.parentProperty);
    };
    PropertyJSONGenerator.prototype.createOverridingQuestion = function (panel, question, overridingProp) {
        var linkValue = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass("linkvalue");
        if (!linkValue)
            return null;
        linkValue.name = question.name + "_" + "overridingProperty";
        linkValue.startWithNewLine = false;
        linkValue.property = question.property;
        linkValue.obj = question.obj;
        linkValue.visibleIf = "propertyEnableIf() = false";
        var overridingQuestion = panel.getQuestionByName(overridingProp);
        if (!overridingQuestion && !!panel.survey) {
            overridingQuestion = panel.survey.getQuestionByName(overridingProp);
        }
        linkValue.linkValueText = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.overridingPropertyPrefix");
        linkValue.titleLocation = "hidden";
        linkValue.onUpdateCssClassesCallback = function (css) {
            css.questionWrapper = "spg-link-wrapper--overriding";
        };
        if (!!overridingQuestion) {
            linkValue.linkClickCallback = function () {
                //Focus and aways scroll into view
                overridingQuestion.focus(false, true);
            };
        }
        return linkValue;
    };
    PropertyJSONGenerator.prototype.getClasPropName = function () {
        if (!!this.parentObj && !!this.parentProperty)
            return this.parentProperty.name;
        var propName = PropertyJSONGenerator.getClassNameProperty(this.obj);
        if (!!propName && this.obj[propName])
            return this.obj[propName];
        return undefined;
    };
    PropertyJSONGenerator.prototype.createJSON = function (isNestedObj, context) {
        if (context === void 0) { context = undefined; }
        var className = undefined;
        var propName = this.getClasPropName();
        if (!!propName) {
            className = this.obj.getType();
            if (className === "itemvalue")
                className += "[]";
            className += "@" + propName;
        }
        var properties = new _question_editor_properties__WEBPACK_IMPORTED_MODULE_5__.SurveyQuestionProperties(this.obj, null, className, undefined, this.parentObj, this.parentProperty, this.propertyGridDefinition);
        var tabs = properties.getTabs();
        var panels = {};
        for (var i = 0; i < tabs.length; i++) {
            if (tabs[i].visible === false)
                continue;
            panels[tabs[i].name] = this.createPanelProps(tabs[i], context);
        }
        var json = {
            elements: []
        };
        for (var key in panels) {
            if (key == _creator_settings__WEBPACK_IMPORTED_MODULE_6__.settings.propertyGrid.generalTabName && isNestedObj) {
                var els = panels[key].elements;
                for (var i = 0; i < els.length; i++) {
                    json.elements.push(els[i]);
                }
            }
            else {
                json.elements.push(panels[key]);
            }
        }
        return json;
    };
    PropertyJSONGenerator.prototype.createPanelProps = function (tab, context, isChild) {
        var _this = this;
        if (isChild === void 0) { isChild = false; }
        var panel = this.createPanelJSON(tab.name, tab.title, isChild);
        for (var i = 0; i < tab.properties.length; i++) {
            var propDef = tab.properties[i];
            var propJSON = this.createQuestionJSON(this.obj, propDef.property, propDef.title, false, context);
            if (propDef.onSameLine) {
                propJSON.startWithNewLine = false;
                this.updateQuestionJSONOnSameLine(propJSON);
                if (panel.elements.length > 0) {
                    this.updateQuestionJSONOnSameLine(panel.elements[panel.elements.length - 1]);
                }
            }
            if (!propJSON)
                continue;
            panel.elements.push(propJSON);
        }
        if (Array.isArray(tab.tabs)) {
            tab.tabs.forEach(function (child) {
                var panelJSON = _this.createPanelProps(child, context, true);
                if (panelJSON.title === child.name) {
                    delete panelJSON.title;
                }
                if (panelJSON) {
                    panel.elements.push(panelJSON);
                }
            });
        }
        return panel;
    };
    PropertyJSONGenerator.prototype.updateQuestionJSONOnSameLine = function (json) {
        json.titleLocation = "left";
        json.minWidth = "50px";
    };
    PropertyJSONGenerator.prototype.createPanelJSON = function (category, title, isChild) {
        var res = {
            type: "panel",
            name: category,
            title: this.getPanelTitle(category, title),
            elements: []
        };
        if (!isChild) {
            res.state = "collapsed";
        }
        return res;
    };
    PropertyJSONGenerator.prototype.createQuestionJSON = function (obj, prop, title, isColumn, context) {
        if (isColumn === void 0) { isColumn = false; }
        var isVisible = this.isPropertyVisible(prop, isColumn ? "list" : "");
        if (!isVisible && isColumn)
            return null;
        var json = PropertyGridEditorCollection.getJSON(obj, prop, this.options, context, this.propertyGridDefinition);
        if (!json)
            return null;
        json.name = prop.name;
        json.title = this.getQuestionTitle(prop, obj.getType(), title);
        if (this.isQuestionTitleHidden(prop)) {
            json.titleLocation = "hidden";
        }
        json.visible = prop.visible;
        json.isReadOnly = prop.readOnly;
        json.isRequired = prop.isRequired;
        json.requiredErrorText = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.propertyIsEmpty");
        if (["page", "panelbase"].indexOf(prop.className) && json.name === "name") {
            json.isRequired = true;
            json.requiredErrorText = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.propertyIsEmpty");
        }
        var placeholder = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getPropertyPlaceholder(obj.getType(), prop.name);
        if (!!placeholder) {
            json.placeholder = placeholder;
        }
        return json;
    };
    PropertyJSONGenerator.prototype.getColumnPropertyJSON = function (obj, propName) {
        if (!obj)
            return null;
        var prop = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(obj.getType(), propName);
        if (!prop)
            return null;
        var json = this.createQuestionJSON(obj, prop, "", true, undefined);
        if (!json)
            return null;
        if (prop.isUnique) {
            json.isUnique = prop.isUnique;
        }
        if (!!json.type) {
            json.cellType = json.type;
            delete json.type;
        }
        if (json.cellType === "buttongroup") {
            json.cellType = "dropdown";
        }
        if (json.cellType === "fileedit") {
            json.cellType = "text";
        }
        if (!!prop.visibleIf) {
            json.visibleIf = "propertyVisibleIf() = true";
        }
        if (!!json.isReadOnly) {
            json.readOnly = json.isReadOnly;
            delete json.isReadOnly;
        }
        return json;
    };
    PropertyJSONGenerator.prototype.isPropertyVisible = function (prop, showMode) {
        if (!prop.visible)
            return false;
        return !showMode || !prop.showMode || showMode == prop.showMode;
    };
    PropertyJSONGenerator.prototype.getPanelTitle = function (name, title) {
        if (!!title)
            return title;
        var res = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.tabs." + name);
        if (typeof res === "object") {
            for (var key in res) {
                if (survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.isDescendantOf(this.obj.getType(), key))
                    return res[key];
            }
        }
        return res;
    };
    PropertyJSONGenerator.prototype.getQuestionTitle = function (prop, className, title) {
        if (!!prop.displayName)
            return prop.displayName;
        if (!!title && title !== prop.name)
            return title;
        var titleClass = className;
        if (!!this.parentProperty) {
            titleClass += "@" + this.parentProperty.name;
        }
        if (this.obj.getType() === "matrixdropdowncolumn" && this.obj.getDynamicType() !== "question") {
            if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(this.obj.getType(), prop.name)) {
                titleClass = this.obj.getDynamicType();
            }
        }
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getPropertyNameInEditor(titleClass, prop.name);
    };
    PropertyJSONGenerator.prototype.isQuestionTitleHidden = function (prop) {
        return prop.displayName === "";
    };
    return PropertyJSONGenerator;
}());

var PropertyGridModel = /** @class */ (function () {
    function PropertyGridModel(obj, options, propertyGridDefinition) {
        if (obj === void 0) { obj = null; }
        if (options === void 0) { options = new _creator_settings__WEBPACK_IMPORTED_MODULE_6__.EmptySurveyCreatorOptions(); }
        if (propertyGridDefinition === void 0) { propertyGridDefinition = null; }
        this.showOneCategoryInPropertyGrid = false;
        this.surveyInstanceCreatedArea = "property-grid";
        this.isCellCreating = false;
        this.options = options;
        this.propertyGridDefinition = propertyGridDefinition;
        if (this.options.enableLinkFileEditor) {
            PropertyGridEditorCollection.register(new PropertyGridLinkEditor());
        }
        this.obj = obj;
    }
    PropertyGridModel.prototype.refresh = function () {
        this.setObj(this.objValue);
    };
    Object.defineProperty(PropertyGridModel.prototype, "obj", {
        get: function () {
            return this.objValue;
        },
        set: function (value) {
            if (this.objValue === value)
                return;
            this.setObj(value);
        },
        enumerable: false,
        configurable: true
    });
    PropertyGridModel.prototype.setPropertyGridDefinition = function (val) {
        if (this.propertyGridDefinition === val)
            return;
        this.propertyGridDefinition = val;
        if (!!this.obj) {
            this.updateCurrentSurveyWithNewDefinition();
        }
    };
    PropertyGridModel.prototype.selectProperty = function (propertyName, focus) {
        if (focus === void 0) { focus = true; }
        if (!this.survey)
            return;
        var question = this.survey.getQuestionByName(propertyName);
        if (!question)
            return;
        var panels = this.survey.getAllPanels();
        for (var i = 0; i < panels.length; i++) {
            var panel = panels[i];
            if (panel === question.parent) {
                panel.blockAnimations();
                panel.expand();
                panel.releaseAnimations();
            }
            else {
                panel.collapse();
            }
        }
        if (focus) {
            question.focus();
        }
        else {
            if (this.showOneCategoryInPropertyGrid) {
                this.survey.currentPage = question.page;
            }
        }
    };
    PropertyGridModel.prototype.setObjFromAction = function (value, propertyName) {
        if (this.changedFromActionCallback) {
            this.changedFromActionCallback(value, propertyName);
        }
        else {
            this.setObj(value);
        }
    };
    PropertyGridModel.prototype.setObj = function (value) {
        var _this = this;
        this.objValue = value;
        this.classNameProperty = !!this.obj
            ? PropertyJSONGenerator.getClassNameProperty(this.obj)
            : "";
        this.classNameValue = !!this.classNameProperty
            ? this.obj[this.classNameProperty]
            : undefined;
        this.titleActionsCreator = !!this.obj
            ? new PropertyGridTitleActionsCreator(this.obj, this.options)
            : undefined;
        var json = this.getSurveyJSON();
        if (this.options.readOnly) {
            json.mode = "display";
        }
        if (!!this.surveyValue) {
            this.surveyValue.onValidateQuestion.clear();
            this.surveyValue.onValueChanging.clear();
            this.surveyValue.onValueChanged.clear();
            this.surveyValue.onMatrixCellValueChanging.clear();
            this.surveyValue.onMatrixCellValidate.clear();
            this.surveyValue.onMatrixCellValueChanged.clear();
            this.surveyValue.editingObj = undefined;
            this.surveyValue.data = {};
            this.surveyValue.dispose();
        }
        this.surveyValue = this.createSurvey(json, function (survey) {
            _this.onCreateSurvey(survey);
        });
        if (!this.obj)
            return;
        this.survey.onValueChanged.add(function (sender, options) {
            _this.onValueChanged(options);
        });
        this.survey.onValueChanging.add(function (sender, options) {
            _this.onValueChanging(options);
        });
        this.survey.onValidateQuestion.add(function (sender, options) {
            _this.onValidateQuestion(options);
        });
        this.survey.onGetQuestionTitleActions.add(function (sender, options) {
            _this.titleActionsCreator.onGetQuestionTitleActions(options);
            _this.onGetQuestionTitleActions(options, _this.options);
            var q = options.question;
            _this.options.onPropertyEditorUpdateTitleActionsCallback(_this.obj, q.property, q, options.titleActions);
        });
        this.survey.onGetPanelTitleActions.add(function (sender, options) {
            options.titleActions.splice(0, options.titleActions.length);
        });
        this.survey.onMatrixCellCreated.add(function (sender, options) {
            _this.onMatrixCellCreated(options);
        });
        this.survey.onMatrixCellValueChanging.add(function (sender, options) {
            _this.onMatrixCellValueChanging(options);
        });
        this.survey.onMatrixCellValidate.add(function (sender, options) {
            _this.onMatrixCellValidate(options);
        });
        this.survey.onMatrixCellValueChanged.add(function (sender, options) {
            _this.onMatrixCellValueChanged(options);
        });
        this.survey.onMatrixAllowRemoveRow.add(function (sender, options) {
            options.allow = _this.getMatrixAllowRemoveRow(options.question, options.row);
        });
        this.survey.onMatrixRowRemoving.add(function (sender, options) {
            options.allow = _this.getMatrixOnRowRemoving(options.question, options.row);
        });
        this.survey.onMatrixRowAdded.add(function (sender, options) {
            _this.onMatrixRowAdded(options);
        });
        this.survey.onGetMatrixRowActions.add(function (sender, options) {
            _this.onGetMatrixRowAction(options);
        });
        this.survey.onUpdateQuestionCssClasses.add(function (sender, options) {
            _this.onUpdateQuestionCssClasses(options);
        });
        this.survey.onElementContentVisibilityChanged.add(function (sender, options) {
            if (_creator_settings__WEBPACK_IMPORTED_MODULE_6__.settings.propertyGrid.allowExpandMultipleCategories)
                return;
            var el = options.element;
            if (el && el.isPanel && el.isExpanded) {
                _this.collapseOtherPanels(el);
            }
        });
        this.survey.onAfterRenderQuestion.add(function (sender, options) {
            _this.onAfterRenderQuestion(options);
        });
        this.survey.onTextMarkdown.add(function (sender, options) {
            if (options.name === "description") {
                options.html = (0,_description_parser__WEBPACK_IMPORTED_MODULE_8__.parsePropertyDescription)(options.text);
            }
        });
        this.survey.editingObj = this.obj;
        if (this.objValueChangedCallback) {
            this.objValueChangedCallback();
        }
        this.updateDependedPropertiesEditors();
        if (this.showOneCategoryInPropertyGrid) {
            this.survey.onCurrentPageChanged.add(function (sender, options) {
                if (_this.currentlySelectedPage !== options.newCurrentPage) {
                    var questionToFocus = options.newCurrentPage.getFirstQuestionToFocus(false, true);
                    _this.currentlySelectedPage = options.newCurrentPage;
                    _this.currentlySelectedProperty = !!questionToFocus ? questionToFocus.name : "";
                }
            });
        }
        else {
            this.survey.onFocusInPanel.add(function (sender, options) {
                if (_this.currentlySelectedPanel !== options.panel) {
                    var questionToFocus = options.panel.getFirstQuestionToFocus(false, true);
                    _this.currentlySelectedProperty = !!questionToFocus ? questionToFocus.name : "";
                    _this.currentlySelectedPanel = options.panel;
                }
            });
        }
        this.survey.onFocusInQuestion.add(function (sender, options) {
            _this.currentlySelectedProperty = options.question.name;
            _this.currentlySelectedPanel = options.question.parent;
        });
        this.survey.onUploadFiles.add(function (_, options) {
            var callback = function (status, data) { return options.callback(status, [{ content: data, file: options.files[0] }]); };
            var question = options.question.obj.getType() == "survey" ? undefined : (options.question.obj.getType() == "imageitemvalue" ? options.question.obj.locOwner : options.question.obj);
            var item = options.question.obj.getType() == "imageitemvalue" ? options.question.obj : undefined;
            _this.options.uploadFiles(options.files, question, callback, { element: options.question.obj, item: item, elementType: options.question.obj.getType(), propertyName: options.name });
        });
        this.survey.getAllQuestions().map(function (q) { return q.allowRootStyle = false; });
        this.survey.onQuestionCreated.add(function (_, opt) {
            opt.question.allowRootStyle = false;
        });
        this.options.onPropertyGridSurveyCreatedCallback(this.obj, this.survey);
    };
    PropertyGridModel.prototype.onCreateSurvey = function (survey) {
        var _this = this;
        survey.questionErrorLocation = "bottom";
        survey.getCss().list = {};
        var surveyCss = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, _property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_4__.propertyGridCss);
        surveyCss.root += (this.showOneCategoryInPropertyGrid ? " spg-root--one-category" : "");
        survey.css = surveyCss;
        if (!!this.obj) {
            var jsonGenerator = new PropertyJSONGenerator(this.obj, this.options, null, null, this.propertyGridDefinition);
            if (this.showOneCategoryInPropertyGrid) {
                survey.css.page.root += " spg-panel__content";
                jsonGenerator.setupPages(survey);
            }
            else {
                var page = survey.createNewPage("p1");
                jsonGenerator.setupObjPanel(page, false);
                survey.addPage(page);
            }
            survey.getAllQuestions().forEach(function (q) {
                PropertyGridEditorCollection.onSetup(_this.obj, q, q.property, _this.options);
            });
            survey.enterKeyAction = "loseFocus";
            survey.checkErrorsMode = "onValueChanging";
            survey.questionErrorComponent = "svc-question-error";
            if (survey.pages.length === 0) {
                survey.addNewPage("p1");
            }
        }
    };
    PropertyGridModel.prototype.updateCurrentSurveyWithNewDefinition = function () {
        var newSurvey = new survey_core__WEBPACK_IMPORTED_MODULE_1__.SurveyModel(this.getSurveyJSON());
        this.onCreateSurvey(newSurvey);
        this.updateElementsInPanel(this.survey.pages[0], newSurvey.pages[0]);
    };
    PropertyGridModel.prototype.updateElementsInPanel = function (curPanel, newPanel) {
        for (var i = curPanel.elements.length - 1; i >= 0; i--) {
            var el = curPanel.elements[i];
            var newEl = newPanel.getElementByName(el.name);
            if (!!newEl && el.isPanel === newEl.isPanel) {
                if (el.isPanel && newEl.isPanel) {
                    this.updateElementsInPanel(el, newEl);
                }
            }
            else {
                curPanel.removeElement(el);
            }
        }
        var elsToAdd = new Array();
        for (var i = 0; i < newPanel.elements.length; i++) {
            var newEl = newPanel.elements[i];
            var curIndex = i + elsToAdd.length;
            if (curIndex < curPanel.elements.length && curPanel.elements[curIndex].name === newEl.name)
                continue;
            var curEl = curPanel.getElementByName(newEl.name);
            if (!!curEl) {
                curPanel.removeElement(curEl);
                curPanel.addElement(curEl, curIndex);
            }
            else {
                elsToAdd.push({ element: newEl, index: i });
            }
        }
        for (var i = 0; i < elsToAdd.length; i++) {
            curPanel.addElement(elsToAdd[i].element, elsToAdd[i].index);
        }
    };
    Object.defineProperty(PropertyGridModel.prototype, "options", {
        get: function () {
            return this.optionsValue;
        },
        set: function (val) {
            this.optionsValue = !!val ? val : new _creator_settings__WEBPACK_IMPORTED_MODULE_6__.EmptySurveyCreatorOptions();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PropertyGridModel.prototype, "survey", {
        get: function () {
            return this.surveyValue;
        },
        enumerable: false,
        configurable: true
    });
    PropertyGridModel.prototype.validate = function () {
        if (!this.survey)
            return;
        return !this.survey.hasErrors(true, true);
    };
    PropertyGridModel.prototype.collapseCategory = function (name) {
        var panel = this.survey.getPanelByName(name);
        if (!!panel) {
            panel.collapse();
        }
    };
    PropertyGridModel.prototype.expandCategory = function (name) {
        var panel = this.survey.getPanelByName(name);
        if (!!panel) {
            panel.expand();
        }
    };
    PropertyGridModel.prototype.collapseAllCategories = function () {
        this.collapseAllCategoriesExcept(null);
    };
    PropertyGridModel.prototype.expandAllCategories = function () {
        this.survey.getAllPanels().forEach(function (pnl) {
            if (!pnl.parent.isPanel) {
                pnl.expand();
            }
        });
    };
    PropertyGridModel.prototype.expandCategoryIfNeeded = function () {
        var expandedTabName = _creator_settings__WEBPACK_IMPORTED_MODULE_6__.settings.propertyGrid.defaultExpandedTabName;
        if (!!expandedTabName && !this.getPropertyGridExpandedCategory()) {
            var panel = this.survey.getPanelByName(expandedTabName);
            if (!!panel) {
                panel.blockAnimations();
                panel.expand();
                panel.releaseAnimations();
            }
        }
    };
    PropertyGridModel.prototype.getPropertyGridExpandedCategory = function () {
        var panels = this.survey.getAllPanels();
        for (var i = 0; i < panels.length; i++) {
            if (panels[i].isExpanded)
                return panels[i].name;
        }
        return "";
    };
    PropertyGridModel.prototype.collapseOtherPanels = function (panel) {
        this.collapseAllCategoriesExcept(panel);
    };
    PropertyGridModel.prototype.collapseAllCategoriesExcept = function (panel) {
        this.survey.getAllPanels().forEach(function (pnl) {
            if (pnl !== panel && !pnl.parent.isPanel)
                pnl.collapse();
        });
    };
    PropertyGridModel.prototype.createSurvey = function (json, callback) {
        return this.options.createSurvey(json, this.surveyInstanceCreatedArea, this, callback);
    };
    PropertyGridModel.prototype.getSurveyJSON = function () {
        var res = { autoGrowComment: true, allowResizeComment: false };
        setSurveyJSONForPropertyGrid(res, true, false);
        return res;
    };
    PropertyGridModel.prototype.validateQuestionValue = function (obj, question, prop, val) {
        if (question.isRequired && (survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(val) || question["valueChangingEmpty"]))
            return this.getErrorTextOnValidate(_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.propertyIsEmpty"), prop.name, obj, val);
        if (this.isPropNameInValid(obj, prop, val) || question["nameHasError"])
            return this.getErrorTextOnValidate(_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.propertyNameIsIncorrect"), prop.name, obj, val);
        var editorError = PropertyGridEditorCollection.validateValue(obj, question, prop, val);
        return this.getErrorTextOnValidate(editorError, prop.name, obj, val);
    };
    PropertyGridModel.prototype.getErrorTextOnValidate = function (defaultError, propName, obj, val) {
        var customError = this.options.onGetErrorTextOnValidationCallback(propName, obj, val);
        return !!customError ? customError : defaultError;
    };
    PropertyGridModel.prototype.onValidateQuestion = function (options) {
        var q = options.question;
        if (!q || !q.property)
            return;
        options.error = this.validateQuestionValue(this.obj, q, q.property, options.value);
    };
    PropertyGridModel.prototype.onValueChanging = function (options) {
        var q = options.question;
        if (!q || !q.property || !Array.isArray(options.value) && survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isTwoValueEquals(options.value, options.oldValue, false, false, false))
            return;
        PropertyGridEditorCollection.onValueChanging(this.obj, q.property, q, options);
        var changingOptions = {
            obj: this.obj,
            propertyName: q.property.name,
            value: options.oldValue,
            newValue: options.value,
            doValidation: false
        };
        this.options.onValueChangingCallback(changingOptions);
        options.value = changingOptions.newValue;
        if (q.property.isRequired) {
            var isEmpty = survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(options.value);
            q["valueChangingEmpty"] = isEmpty;
        }
        var isPropertyNameInValid = this.isPropNameInValid(this.obj, q.property, options.value);
        q["nameHasError"] = isPropertyNameInValid;
    };
    PropertyGridModel.prototype.isPropNameInValid = function (obj, prop, val) {
        if (obj["isQuestion"] && prop.name === "name" && !!val) {
            val = val.toLowerCase();
            return ["item", "choice", "row", "panel"].indexOf(val) > -1;
        }
        return false;
    };
    PropertyGridModel.prototype.onValueChanged = function (options) {
        var _this = this;
        var q = options.question;
        if (!q || !q.property)
            return;
        q["valueChangingEmpty"] = false;
        q["nameHasError"] = false;
        this.changeDependedProperties(q, function (name) { return _this.survey.getQuestionByName(name); }, function (name) { return _this.survey.getValue(name); });
        PropertyGridEditorCollection.onValueChanged(this.obj, q.property, q);
        if (!!this.classNameProperty &&
            options.name === this.classNameProperty &&
            this.classNameValue !== options.value) {
            this.setObj(this.obj);
            if (!!this.survey) {
                var question = this.survey.getQuestionByName(options.name);
                if (!!question) {
                    question.focus();
                }
            }
        }
    };
    PropertyGridModel.prototype.changeDependedProperties = function (question, dependedsQuetion, dependedsValue) {
        var prop = question.property;
        if (!prop)
            return;
        var properties = prop.getDependedProperties();
        if (!properties)
            return;
        for (var i = 0; i < properties.length; i++) {
            var name = properties[i];
            var q = dependedsQuetion(name);
            if (!q)
                continue;
            this.updateDependedPropertiesEditor(q);
            var objValue = dependedsValue(name);
            if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isTwoValueEquals(q.value, objValue, false, false, false)) {
                q.value = objValue;
            }
            PropertyGridEditorCollection.onMasterValueChanged(question.obj, q.property, q);
        }
    };
    PropertyGridModel.prototype.updateDependedPropertiesEditor = function (editor) {
        var obj = editor.obj;
        if (!obj)
            return;
        var property = editor.property;
        if (!!property && property.onPropertyEditorUpdate) {
            property.onPropertyEditorUpdate(obj, editor);
        }
    };
    PropertyGridModel.prototype.updateDependedPropertiesEditors = function () {
        var questions = this.survey.getAllQuestions();
        for (var i = 0; i < questions.length; i++) {
            this.updateDependedPropertiesEditor(questions[i]);
        }
    };
    PropertyGridModel.prototype.onAfterRenderQuestion = function (options) {
        PropertyGridEditorCollection.onAfterRenderQuestion(this.obj, options.question.property, options);
    };
    PropertyGridModel.prototype.onMatrixCellCreated = function (options) {
        this.isCellCreating = true;
        PropertyGridEditorCollection.onMatrixCellCreated(this.obj, options.question.property, options);
        this.isCellCreating = false;
        var obj = options.row.editingObj;
        if (!obj)
            return;
        var prop = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(obj.getType(), options.columnName);
        if (!prop)
            return;
        var allowEditRow = this.getMatrixAllowEditRow(options.question, options.row);
        options.cellQuestion.readOnly = !allowEditRow || PropertyJSONGenerator.isPropertyReadOnly(prop, this.options, obj, this.obj, options.question.property);
    };
    PropertyGridModel.prototype.onMatrixCellValueChanging = function (options) {
        if (this.isCellCreating)
            return;
        var changingOptions = {
            obj: options.row.editingObj,
            propertyName: options.columnName,
            value: options.oldValue,
            newValue: options.value,
            doValidation: false
        };
        this.options.onValueChangingCallback(changingOptions);
        options.value = changingOptions.newValue;
    };
    PropertyGridModel.prototype.onMatrixCellValidate = function (options) {
        if (this.isCellCreating)
            return;
        var q = options.row.getQuestionByColumnName(options.columnName);
        if (!q || !q.property)
            return;
        options.error = this.validateQuestionValue(options.row.editingObj, q, q.property, options.value);
    };
    PropertyGridModel.prototype.onGetMatrixRowAction = function (options) {
        var _this = this;
        PropertyGridEditorCollection.onGetMatrixRowAction(this.obj, options.question.property, options, function (obj) {
            _this.setObjFromAction(obj, options.question.name);
        });
    };
    PropertyGridModel.prototype.onUpdateQuestionCssClasses = function (options) {
        PropertyGridEditorCollection.onUpdateQuestionCssClasses(this.obj, options.question.property, options);
    };
    PropertyGridModel.prototype.onGetQuestionTitleActions = function (options, creator) {
        PropertyGridEditorCollection.onGetQuestionTitleActions(this.obj, options.question.property, options, creator);
    };
    PropertyGridModel.prototype.onMatrixCellValueChanged = function (options) {
        if (this.isCellCreating)
            return;
        var cellQuestion = options.row.getQuestionByName(options.columnName);
        if (!!cellQuestion) {
            this.changeDependedProperties(cellQuestion, function (name) { return options.row.getQuestionByName(name); }, function (name) { return options.row.getValue(name); });
        }
        PropertyGridEditorCollection.onMatrixCellValueChanged(this.obj, options.question.property, options);
    };
    PropertyGridModel.prototype.getMatrixAllowRemoveRow = function (question, row) {
        if (row.allowDeleteRow === undefined) {
            this.calculateMatrixAllowOperations(question, row);
        }
        return row.allowDeleteRow;
    };
    PropertyGridModel.prototype.getMatrixOnRowRemoving = function (question, row) {
        return this.options.onCollectionItemDeletingCallback(this.obj, question.property, question.value, row.editingObj);
    };
    PropertyGridModel.prototype.getMatrixAllowEditRow = function (question, row) {
        if (question.readOnly)
            return false;
        if (row.allowEditRow === undefined) {
            this.calculateMatrixAllowOperations(question, row);
        }
        return row.allowEditRow;
    };
    PropertyGridModel.prototype.calculateMatrixAllowOperations = function (question, row) {
        var rowOptions = { allowDelete: this.onMatrixAllowRemoveRow(question, row), allowEdit: true, allowAdd: undefined };
        this.options.onCollectionItemAllowingCallback(this.obj, question.property, question.value, row.editingObj, rowOptions);
        row.allowDeleteRow = rowOptions.allowDelete;
        row.allowEditRow = rowOptions.allowEdit;
    };
    PropertyGridModel.prototype.onMatrixAllowRemoveRow = function (question, row) {
        var res = PropertyGridEditorCollection.onMatrixAllowRemoveRow(this.obj, question.property, row);
        return this.options.onCanDeleteItemCallback(this.obj, row.editingObj, res);
    };
    PropertyGridModel.prototype.onMatrixRowAdded = function (options) {
        var item = options.row.editingObj;
        if (survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.isDescendantOf(item.getType(), "itemvalue")) {
            this.options.onItemValueAddedCallback(this.obj, options.question.property.name, options.row.editingObj, options.question.value);
        }
        if (survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.isDescendantOf(item.getType(), "matrixdropdowncolumn")) {
            this.options.onMatrixDropdownColumnAddedCallback(this.obj, options.row.editingObj, options.question.value);
        }
    };
    return PropertyGridModel;
}());

var PropertyGridEditor = /** @class */ (function () {
    function PropertyGridEditor() {
    }
    PropertyGridEditor.prototype.showModalPropertyEditor = function (editor, property, question, options, onClose) {
        var _this = this;
        var obj = question.obj;
        var surveyPropertyEditor = editor.createPropertyEditorSetup(obj, property, question, options);
        if (!surveyPropertyEditor)
            return null;
        if (property.type !== "condition") {
            surveyPropertyEditor.editSurvey.css = survey_core__WEBPACK_IMPORTED_MODULE_1__.defaultV2Css;
        }
        if (question.isReadOnly) {
            surveyPropertyEditor.editSurvey.mode = "display";
        }
        if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.showDialog)
            return surveyPropertyEditor;
        var prevCurrentLocale = survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.currentLocale;
        var locale = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.currentLocale;
        survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.currentLocale = locale;
        var popupModel = survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.showDialog({
            componentName: "survey",
            data: {
                survey: surveyPropertyEditor.editSurvey,
                model: surveyPropertyEditor.editSurvey
            },
            onApply: function () {
                _this.onModalPropertyEditorClosed(editor, property, question, options, "apply");
                onClose && onClose("apply");
                return surveyPropertyEditor.apply();
            },
            onCancel: function () {
                _this.onModalPropertyEditorClosed(editor, property, question, options, "cancel");
                onClose && onClose("cancel");
            },
            cssClass: "svc-property-editor svc-creator-popup",
            title: question.title,
            displayMode: options.isMobileView ? "overlay" : "popup"
        }, options.rootElement);
        if (question.isReadOnly) {
            var applyBtn = popupModel.footerToolbar.getActionById("apply");
            if (!!applyBtn) {
                applyBtn.visible = false;
            }
        }
        popupModel.locale = locale;
        survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.currentLocale = prevCurrentLocale;
        this.onModalPropertyEditorShown(editor, property, question, options);
        options.onPropertyGridShowModalCallback(obj, property, question, surveyPropertyEditor, popupModel);
        return surveyPropertyEditor;
    };
    PropertyGridEditor.prototype.onModalPropertyEditorShown = function (editor, property, question, options) {
    };
    PropertyGridEditor.prototype.onModalPropertyEditorClosed = function (editor, property, question, options, reason) {
    };
    PropertyGridEditor.prototype.isSupportGrouping = function () {
        return false;
    };
    PropertyGridEditor.prototype.hasPreviousElementForGrouping = function (question) {
        if (!question || !question.parent)
            return false;
        var index = question.parent.elements.indexOf(question);
        if (index < 1)
            return;
        var prevElement = question.parent.elements[index - 1];
        var prevPrevElement = question.parent.elements[index - 2];
        if (prevElement.getType() === question.getType())
            return true;
        //in case of overriding property
        if (index > 1 && !prevElement.startWithNewLine && prevPrevElement["property"] === prevElement["property"] && prevPrevElement.getType() === question.getType())
            return true;
        return false;
    };
    PropertyGridEditor.prototype.onUpdateQuestionCssClasses = function (obj, options) {
        if (!this.isSupportGrouping())
            return;
        if (this.hasPreviousElementForGrouping(options.question)) {
            options.cssClasses.mainRoot += " spg-row-narrow__question";
        }
    };
    return PropertyGridEditor;
}());

var PropertyGridEditorBoolean = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorBoolean, _super);
    function PropertyGridEditorBoolean() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorBoolean.prototype.fit = function (prop, context) {
        return prop.type == "boolean" || prop.type == "switch";
    };
    PropertyGridEditorBoolean.prototype.getJSON = function (obj, prop, options) {
        var res = {
            type: "boolean",
            default: false,
            renderAs: "checkbox",
            titleLocation: "hidden"
        };
        var choices = prop.getChoices(obj, function (choices) { });
        if (Array.isArray(choices) && choices.length >= 2) {
            var jsonChoices = [];
            for (var i = 0; i < 2; i++) {
                var val = choices[i].value || choices[i];
                jsonChoices.push({ value: val, text: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getPropertyValueInEditor(prop.name, val) });
            }
            var defaultValue = prop.getDefaultValue(obj) || jsonChoices[0].value;
            var indexTrue = defaultValue === choices[1].value ? 1 : 0;
            var indexFalse = indexTrue === 0 ? 1 : 0;
            res.valueTrue = jsonChoices[indexTrue].value;
            res.valueFalse = jsonChoices[indexFalse].value;
            res.labelTrue = jsonChoices[indexTrue].text;
            res.labelFalse = jsonChoices[indexFalse].text;
        }
        return res;
    };
    PropertyGridEditorBoolean.prototype.isSupportGrouping = function () {
        return true;
    };
    return PropertyGridEditorBoolean;
}(PropertyGridEditor));

var PropertyGridEditorSwitchToggle = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorSwitchToggle, _super);
    function PropertyGridEditorSwitchToggle() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorSwitchToggle.prototype.fit = function (prop, context) {
        return prop.type == "switchToggle";
    };
    PropertyGridEditorSwitchToggle.prototype.getJSON = function (obj, prop, options) {
        var res = {
            type: "boolean",
            default: false,
        };
        var choices = prop.getChoices(obj, function (choices) { });
        if (Array.isArray(choices) && choices.length >= 2) {
            var jsonChoices = [];
            for (var i = 0; i < 2; i++) {
                var val = choices[i].value || choices[i];
                jsonChoices.push({ value: val, text: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getPropertyValueInEditor(prop.name, val) });
            }
            var defaultValue = prop.getDefaultValue(obj) || jsonChoices[0].value;
            var indexTrue = defaultValue === choices[1].value ? 1 : 0;
            var indexFalse = indexTrue === 0 ? 1 : 0;
            res.valueTrue = jsonChoices[indexTrue].value;
            res.valueFalse = jsonChoices[indexFalse].value;
            res.labelTrue = jsonChoices[indexTrue].text;
            res.labelFalse = jsonChoices[indexFalse].text;
        }
        return res;
    };
    return PropertyGridEditorSwitchToggle;
}(PropertyGridEditor));

var PropertyGridEditorUndefinedBoolean = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorUndefinedBoolean, _super);
    function PropertyGridEditorUndefinedBoolean() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorUndefinedBoolean.prototype.fit = function (prop, context) {
        return prop.type == "boolean" && !!prop.defaultValueFunc && prop.defaultValueFunc(null) === undefined;
    };
    PropertyGridEditorUndefinedBoolean.prototype.getJSON = function (obj, prop, options) {
        var choices = [
            { value: "auto", text: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.inherit") },
            { value: "false", text: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.disabled") },
            { value: "true", text: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.enabled") },
        ];
        var res = {
            type: "buttongroup",
            choices: choices,
            showOptionsCaption: false
        };
        return res;
    };
    PropertyGridEditorUndefinedBoolean.prototype.onCreated = function (obj, question, prop, options, propGridDefinition) {
        question.valueFromDataCallback = function (val) { return val === undefined || val === null ? "auto" : val.toString(); };
        question.valueToDataCallback = function (val) { return val === "auto" ? undefined : val === "true"; };
    };
    PropertyGridEditorUndefinedBoolean.prototype.onSetup = function (obj, question, prop, options) {
        var objValue = obj.getPropertyValue(prop.name);
        if (objValue === undefined) {
            question.value = "auto";
        }
        else {
            question.value = objValue === "true";
        }
    };
    return PropertyGridEditorUndefinedBoolean;
}(PropertyGridEditor));

var PropertyGridEditorStringBase = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorStringBase, _super);
    function PropertyGridEditorStringBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorStringBase.prototype.updateMaxLength = function (prop, json) {
        if (prop.maxLength > 0) {
            json.maxLength = prop.maxLength;
        }
        return json;
    };
    PropertyGridEditorStringBase.prototype.updateType = function (prop, obj, json) {
        if (!json.maxLength && obj.hasDefaultPropertyValue(prop.name)) {
            json.type = "".concat(json.type, "withreset");
            json.renderAs = json.type;
        }
        return json;
    };
    PropertyGridEditorStringBase.prototype.onCreated = function (obj, question, prop, options) {
        if (question instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionTextBase) {
            question.onKeyDownPreprocess = function (event) {
                if ((event.ctrlKey || event.metaKey) && [89, 90].indexOf(event.keyCode) !== -1) {
                    if (question.isInputTextUpdate) {
                        options.findSuitableShortcuts(event).forEach(function (shortcut) {
                            shortcut.execute(options.selectedElement);
                        });
                        event.preventDefault();
                    }
                    else if (event.target.value == question.value) {
                        options.findSuitableShortcuts(event).forEach(function (shortcut) {
                            shortcut.execute(options.selectedElement);
                        });
                    }
                }
            };
        }
        if (prop.name === "title") {
            question.allowSpaceAsAnswer = true;
        }
        if (question.getType() == "textwithreset" || question.getType() == "commentwithreset") {
            question.resetValueAdorner.resetValueCallback = function () {
                obj.resetPropertyValue(prop.name);
            };
            question.resetValueAdorner.caption = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.resetToDefaultCaption");
            var isDefaultValue_1 = function () { return !prop.isDefaultValueByObj(obj, prop.getValue(obj)); };
            question.resetValueAdorner.allowResetValue = isDefaultValue_1();
            obj.registerFunctionOnPropertyValueChanged(prop.name, function () {
                question.resetValueAdorner.allowResetValue = isDefaultValue_1();
            });
        }
    };
    return PropertyGridEditorStringBase;
}(PropertyGridEditor));

var PropertyGridEditorString = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorString, _super);
    function PropertyGridEditorString() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorString.prototype.fit = function (prop) {
        return prop.type == "string";
    };
    PropertyGridEditorString.prototype.isDefault = function () {
        return true;
    };
    PropertyGridEditorString.prototype.getJSON = function (obj, prop, options) {
        var json = this.updateType(prop, obj, this.updateMaxLength(prop, { type: "text" }));
        if (prop.isRequired) {
            json.textUpdateMode = "onBlur";
        }
        if (!!prop.dataList) {
            json.dataList = prop.dataList;
        }
        return json;
    };
    PropertyGridEditorString.prototype.validateValue = function (obj, question, prop, val) {
        return validateImageItemValueProperty(obj, prop, val);
    };
    return PropertyGridEditorString;
}(PropertyGridEditorStringBase));

var PropertyGridEditorDateTime = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorDateTime, _super);
    function PropertyGridEditorDateTime() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorDateTime.prototype.fit = function (prop) {
        return prop.type == "datetime";
    };
    PropertyGridEditorDateTime.prototype.getJSON = function (obj, prop, options) {
        var res = {
            type: "text",
            inputType: "date"
        };
        return res;
    };
    return PropertyGridEditorDateTime;
}(PropertyGridEditor));

function validateImageItemValueProperty(obj, prop, val) {
    if (obj.getType() !== "imageitemvalue" || prop.name !== "imageLink" || !survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isUrlYoutubeVideo(val))
        return undefined;
    return _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("ed.translationYouTubeNotSupported");
}
var PropertyGridLinkEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridLinkEditor, _super);
    function PropertyGridLinkEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridLinkEditor.prototype.fit = function (prop) {
        return prop.type === "url" || prop.type === "file";
    };
    PropertyGridLinkEditor.prototype.getJSON = function (obj, prop, options) {
        var res = { type: "fileedit", storeDataAsText: false, placeholder: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.fileInputPlaceholder") };
        return res;
    };
    PropertyGridLinkEditor.prototype.onCreated = function (obj, question, prop, options) {
        if (["image", "imageitemvalue"].indexOf(obj.getType()) > -1) {
            var questionObj = obj.getType() == "imageitemvalue" ? obj.locOwner : obj;
            if (questionObj) {
                questionObj.registerFunctionOnPropertyValueChanged("contentMode", function (newValue) {
                    question.acceptedTypes = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_9__.getAcceptedTypesByContentMode)(newValue);
                });
                question.acceptedTypes = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_9__.getAcceptedTypesByContentMode)(questionObj.contentMode);
            }
        }
        else {
            question.acceptedTypes = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_9__.getAcceptedTypesByContentMode)("image");
        }
        question.onChooseFilesCallback = (function (input, callback) {
            options.chooseFiles(input, callback, { element: obj, elementType: obj.getType(), propertyName: question.name });
        });
    };
    PropertyGridLinkEditor.prototype.validateValue = function (obj, question, prop, val) {
        return validateImageItemValueProperty(obj, prop, val);
    };
    return PropertyGridLinkEditor;
}(PropertyGridEditor));

var PropertyGridEditorColor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorColor, _super);
    function PropertyGridEditorColor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorColor.prototype.fit = function (prop) {
        return prop.type == "color";
    };
    PropertyGridEditorColor.prototype.getJSON = function (obj, prop, options) {
        var res = { type: "color", allowEmptyValue: true };
        return res;
    };
    PropertyGridEditorColor.prototype.onCreated = function (obj, question, prop) {
        question.valueFromDataCallback = function (val) {
            return val;
        };
        question.valueToDataCallback = function (val) {
            return val;
        };
    };
    return PropertyGridEditorColor;
}(PropertyGridEditor));

var PropertyGridEditorColorWithAlpha = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorColorWithAlpha, _super);
    function PropertyGridEditorColorWithAlpha() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorColorWithAlpha.prototype.fit = function (prop) {
        return prop.type == "coloralpha";
    };
    PropertyGridEditorColorWithAlpha.prototype.getJSON = function (obj, prop, options) {
        return { type: "coloralpha", descriptionLocation: "hidden" };
    };
    PropertyGridEditorColorWithAlpha.prototype.onCreated = function (obj, question, prop) {
        question.valueFromDataCallback = function (val) {
            return val;
        };
        question.valueToDataCallback = function (val) {
            return val;
        };
    };
    return PropertyGridEditorColorWithAlpha;
}(PropertyGridEditor));

var PropertyGridEditorNumber = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorNumber, _super);
    function PropertyGridEditorNumber() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorNumber.prototype.fit = function (prop) {
        return prop.type == "number" || prop.type == "responsiveImageSize";
    };
    PropertyGridEditorNumber.prototype.getJSON = function (obj, prop, options) {
        var res = { type: "text", inputType: "number", textUpdateMode: "onBlur" };
        if (prop.minValue !== undefined) {
            res.min = prop.minValue;
        }
        if (prop.maxValue !== undefined) {
            res.max = prop.maxValue;
        }
        return res;
    };
    PropertyGridEditorNumber.prototype.onValueChanging = function (obj, prop, question, options) {
        if (!options.value && options.value !== 0) {
            if (prop.defaultValue !== undefined) {
                options.value = prop.defaultValue;
            }
            else {
                if (!prop.isRequired && options.value === "") {
                    options.value = undefined;
                }
                else {
                    options.value = prop.minValue !== undefined && prop.minValue > 0 ? prop.minValue : 0;
                }
            }
        }
    };
    return PropertyGridEditorNumber;
}(PropertyGridEditor));

var PropertyGridEditorSpinEdit = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorSpinEdit, _super);
    function PropertyGridEditorSpinEdit() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorSpinEdit.prototype.fit = function (prop) {
        return prop.type == "spinedit";
    };
    PropertyGridEditorSpinEdit.prototype.getJSON = function (obj, prop, options) {
        var res = { type: "spinedit", descriptionLocation: "hidden" };
        return res;
    };
    return PropertyGridEditorSpinEdit;
}(PropertyGridEditor));

var PropertyGridEditorImageSize = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorImageSize, _super);
    function PropertyGridEditorImageSize() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorImageSize.prototype.fit = function (prop) {
        return prop.type == "string" && (prop.name == "imageHeight" || prop.name == "imageWidth");
    };
    PropertyGridEditorImageSize.prototype.isDefault = function () {
        return false;
    };
    PropertyGridEditorImageSize.prototype.onCreated = function (obj, question, prop, options) {
        _super.prototype.onCreated.call(this, obj, question, prop, options);
        var isDefaultValue = function (imageHeight, imageWidth) {
            var imageHeightProperty = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(obj.getType(), "imageHeight");
            var imageWidthProperty = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(obj.getType(), "imageWidth");
            if (!imageHeightProperty && !imageWidthProperty)
                return false;
            return imageHeightProperty.isDefaultValue(imageHeight) && imageWidthProperty.isDefaultValue(imageWidth);
        };
        question.valueFromDataCallback = function (value) {
            var isDefaultSize = isDefaultValue(obj["imageHeight"], obj["imageWidth"]);
            return isDefaultSize ? undefined : value;
        };
    };
    return PropertyGridEditorImageSize;
}(PropertyGridEditorString));

var PropertyGridEditorText = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorText, _super);
    function PropertyGridEditorText() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorText.prototype.fit = function (prop) {
        return prop.type === "text";
    };
    PropertyGridEditorText.prototype.getJSON = function (obj, prop, options) {
        return this.updateType(prop, obj, this.updateMaxLength(prop, {
            type: "comment",
            rows: 2
        }));
    };
    return PropertyGridEditorText;
}(PropertyGridEditorStringBase));

var PropertyGridEditorHtml = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorHtml, _super);
    function PropertyGridEditorHtml() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorHtml.prototype.fit = function (prop) {
        return prop.type === "html";
    };
    PropertyGridEditorHtml.prototype.getJSON = function (obj, prop, options) {
        return this.updateMaxLength(prop, {
            type: "comment",
            "allowResize": true,
            "autoGrow": false,
        });
    };
    return PropertyGridEditorHtml;
}(PropertyGridEditorStringBase));

var PropertyGridEditorStringArray = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorStringArray, _super);
    function PropertyGridEditorStringArray() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorStringArray.prototype.fit = function (prop) {
        return prop.type == "string[]";
    };
    PropertyGridEditorStringArray.prototype.getJSON = function (obj, prop, options) {
        return {
            type: "comment",
            rows: 2
        };
    };
    PropertyGridEditorStringArray.prototype.onCreated = function (obj, question, prop) {
        question.valueFromDataCallback = function (val) {
            if (!Array.isArray(val))
                return "";
            return val.join("\n");
        };
        question.valueToDataCallback = function (val) {
            if (!val)
                return [];
            if (Array.isArray(val) && !val["split"])
                return val;
            return val.split("\n");
        };
    };
    return PropertyGridEditorStringArray;
}(PropertyGridEditor));

var PropertyGridEditorDropdown = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorDropdown, _super);
    function PropertyGridEditorDropdown() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorDropdown.prototype.fit = function (prop) {
        return prop.type !== "boolean" && (this.isLocaleProp(prop) || prop.hasChoices);
    };
    PropertyGridEditorDropdown.prototype.getJSON = function (obj, prop, options) {
        var choices = this.getChoices(obj, prop);
        var json = {
            type: this.renderAsButtonGroup(prop, choices)
                ? "buttongroup"
                : "dropdown",
            choices: choices,
            showOptionsCaption: false
        };
        this.updateObjBasedOnEmptyValueItem(prop, choices, json);
        return json;
    };
    PropertyGridEditorDropdown.prototype.getChoices = function (obj, prop) {
        return prop.getChoices(obj, function (choices) { });
    };
    PropertyGridEditorDropdown.prototype.updateObjBasedOnEmptyValueItem = function (prop, choices, objOrJson) {
        var emptyValueItem = this.getEmptyJsonItemValue(prop, choices);
        if (!!emptyValueItem) {
            objOrJson.showOptionsCaption = true;
            objOrJson.allowClear = true;
            if (emptyValueItem.text) {
                objOrJson.optionsCaption = emptyValueItem.text;
            }
        }
    };
    Object.defineProperty(PropertyGridEditorDropdown.prototype, "canRenderAsButtonGroup", {
        get: function () {
            return _creator_settings__WEBPACK_IMPORTED_MODULE_6__.settings.propertyGrid.useButtonGroup;
        },
        enumerable: false,
        configurable: true
    });
    PropertyGridEditorDropdown.prototype.renderAsButtonGroup = function (prop, choices) {
        if (prop.type === "dropdown")
            return false;
        if (prop.type === "buttongroup")
            return true;
        if (this.isLocaleProp(prop))
            return false;
        if (!this.canRenderAsButtonGroup ||
            !choices ||
            choices.length == 0 ||
            choices.length > 4)
            return false;
        var charCount = 0;
        for (var i = 0; i < choices.length; i++) {
            var text = this.getLocalizedText(prop, !!choices[i].value ? choices[i].value : choices[i]);
            charCount += !!text ? text.length : 0;
        }
        return charCount < _creator_settings__WEBPACK_IMPORTED_MODULE_6__.settings.propertyGrid.maxCharsInButtonGroup;
    };
    PropertyGridEditorDropdown.prototype.onCreated = function (obj, question, prop) {
        this.setChoices(obj, question, prop);
        question.displayValueCallback = function (text) {
            return !text ? question.optionsCaption : text;
        };
    };
    PropertyGridEditorDropdown.prototype.onMasterValueChanged = function (obj, prop, question) {
        this.setChoices(obj, question, prop);
        if (!question.isEmpty()) {
            if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.ItemValue.getItemByValue(question.choices, question.value)) {
                question.clearValue();
            }
        }
    };
    PropertyGridEditorDropdown.prototype.setChoicesCore = function (question, prop, propChoices) {
        if (!propChoices || !Array.isArray(propChoices) || propChoices.length == 0)
            return;
        this.updateObjBasedOnEmptyValueItem(prop, propChoices, question);
        question.choices = this.choicesFromPropChoices(prop, propChoices);
    };
    PropertyGridEditorDropdown.prototype.isLocaleProp = function (prop) {
        return prop.name === "locale";
    };
    PropertyGridEditorDropdown.prototype.getLocalizedText = function (prop, value) {
        if (this.isLocaleProp(prop)) {
            var text = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getLocaleName(value);
            if (text)
                return text;
        }
        if (prop.name === "cellType") {
            var text = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("qt." + value);
            if (text)
                return text;
        }
        if (value === null)
            return null;
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getPropertyValueInEditor(prop.name, value);
    };
    PropertyGridEditorDropdown.prototype.choicesFromPropChoices = function (prop, propChoices) {
        var choices = [];
        for (var i = 0; i < propChoices.length; i++) {
            var jsonItem = this.getJsonItem(prop, propChoices[i]);
            if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(jsonItem.value)) {
                choices.push(jsonItem);
            }
        }
        return choices;
    };
    PropertyGridEditorDropdown.prototype.getJsonItem = function (prop, item) {
        var jsonItem = { value: item.value !== undefined ? item.value : item };
        var text = !!item.text ? item.text : "";
        if (!text) {
            text = this.getLocalizedText(prop, jsonItem.value);
        }
        if (!!text && text != jsonItem.value) {
            jsonItem.text = text;
        }
        return jsonItem;
    };
    PropertyGridEditorDropdown.prototype.setChoices = function (obj, question, prop) {
        var _this = this;
        var propChoices = prop.getChoices(obj, function (choices) {
            _this.setChoicesCore(question, prop, choices);
        });
        this.setChoicesCore(question, prop, propChoices);
    };
    PropertyGridEditorDropdown.prototype.getEmptyJsonItemValue = function (prop, choices) {
        if (!choices)
            return null;
        for (var i = 0; i < choices.length; i++) {
            var item = choices[i];
            var value = item.value !== undefined ? item.value : item;
            if (survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(value))
                return this.getJsonItem(prop, item);
        }
        return null;
    };
    return PropertyGridEditorDropdown;
}(PropertyGridEditor));

var PropertyGridEditorSet = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorSet, _super);
    function PropertyGridEditorSet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorSet.prototype.fit = function (prop) {
        return prop.type == "set" || prop.type == "multiplevalues";
    };
    PropertyGridEditorSet.prototype.getJSON = function (obj, prop, options) {
        var json = _super.prototype.getJSON.call(this, obj, prop, options);
        var hasTagbox = !!survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findClass("tagbox");
        json.type = hasTagbox ? "tagbox" : "checkbox";
        json.hasSelectAll = !hasTagbox;
        return json;
    };
    return PropertyGridEditorSet;
}(PropertyGridEditorDropdown));

var PropertyGridEditorPage = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorPage, _super);
    function PropertyGridEditorPage() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorPage.prototype.fit = function (prop) {
        return prop.hasChoices && prop.name == "page";
    };
    Object.defineProperty(PropertyGridEditorPage.prototype, "canRenderAsButtonGroup", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    PropertyGridEditorPage.prototype.onCreated = function (obj, question, prop) {
        _super.prototype.onCreated.call(this, obj, question, prop);
        question.valueFromDataCallback = function (val) {
            return !!val ? val.name : "";
        };
        question.valueToDataCallback = function (val) {
            if (!val || !obj || !obj.getSurvey())
                return undefined;
            return obj.getSurvey().getPageByName(val);
        };
    };
    return PropertyGridEditorPage;
}(PropertyGridEditorDropdown));

var PropertyGridEditorQuestion = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorQuestion, _super);
    function PropertyGridEditorQuestion() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorQuestion.prototype.fit = function (prop) {
        return prop.type == "question" || prop.type === "questionlist";
    };
    PropertyGridEditorQuestion.prototype.getJSON = function (obj, prop, options) {
        var result = {
            type: "dropdown",
            optionsCaption: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.conditionSelectQuestion"),
            choices: this.getChoices(obj, prop, options)
        };
        if (prop.type == "question") {
            result["allowClear"] = false;
        }
        return result;
    };
    PropertyGridEditorQuestion.prototype.getChoices = function (obj, prop, options) {
        var _this = this;
        var survey = _editable_object__WEBPACK_IMPORTED_MODULE_3__.EditableObject.getSurvey(obj);
        if (!survey)
            return [];
        var questions = this.getQuestions(survey, obj);
        if (!questions)
            questions = [];
        var showTitles = !!options && options.showTitlesInExpressions;
        var qItems = questions.map(function (q) {
            var text = showTitles ? q.locTitle.renderedHtml : q.name;
            if (!!options)
                text = options.getObjectDisplayName(q, "property-grid:property-editor", "property-editor", text);
            var value = _this.getItemValue(q);
            return { value: value, text: text };
        });
        if (_creator_settings__WEBPACK_IMPORTED_MODULE_6__.settings.logic.questionSortOrder === "asc") {
            _survey_helper__WEBPACK_IMPORTED_MODULE_7__.SurveyHelper.sortItems(qItems);
        }
        return qItems;
    };
    PropertyGridEditorQuestion.prototype.getQuestions = function (survey, obj) {
        return survey.getAllQuestions();
    };
    PropertyGridEditorQuestion.prototype.getItemValue = function (question) {
        return question.name;
    };
    return PropertyGridEditorQuestion;
}(PropertyGridEditor));

var PropertyGridEditorQuestionSelectBase = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorQuestionSelectBase, _super);
    function PropertyGridEditorQuestionSelectBase() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorQuestionSelectBase.prototype.fit = function (prop) {
        return prop.type == "question_selectbase";
    };
    PropertyGridEditorQuestionSelectBase.prototype.isQuestionFit = function (question) {
        return survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.isDescendantOf(question.getType(), "selectbase");
    };
    PropertyGridEditorQuestionSelectBase.prototype.getQuestions = function (survey, obj) {
        var questions = _super.prototype.getQuestions.call(this, survey, obj);
        var res = [];
        for (var i = 0; i < questions.length; i++) {
            var q = questions[i];
            if (q !== obj && this.isQuestionFit(q)) {
                res.push(q);
            }
        }
        return res;
    };
    return PropertyGridEditorQuestionSelectBase;
}(PropertyGridEditorQuestion));

var PropertyGridEditorQuestionCarryForward = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorQuestionCarryForward, _super);
    function PropertyGridEditorQuestionCarryForward() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorQuestionCarryForward.prototype.fit = function (prop) {
        return prop.type == "question_carryforward";
    };
    PropertyGridEditorQuestionCarryForward.prototype.isQuestionFit = function (question) {
        return question.isValueArray || _super.prototype.isQuestionFit.call(this, question);
    };
    return PropertyGridEditorQuestionCarryForward;
}(PropertyGridEditorQuestionSelectBase));

var PropertyGridEditorQuestionValue = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorQuestionValue, _super);
    function PropertyGridEditorQuestionValue() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorQuestionValue.prototype.fit = function (prop) {
        return prop.type === "questionvalue" || prop.type === "questionlist-savevaluename";
    };
    PropertyGridEditorQuestionValue.prototype.getItemValue = function (question) {
        return question.getValueName();
    };
    PropertyGridEditorQuestionValue.prototype.getQuestions = function (survey, obj) {
        var questions = _super.prototype.getQuestions.call(this, survey, obj);
        return questions.filter(function (q) { return !survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.isDescendantOf(q.getType(), "nonvalue"); });
    };
    return PropertyGridEditorQuestionValue;
}(PropertyGridEditorQuestion));

PropertyGridEditorCollection.register(new PropertyGridEditorBoolean());
PropertyGridEditorCollection.register(new PropertyGridEditorString());
PropertyGridEditorCollection.register(new PropertyGridEditorNumber());
PropertyGridEditorCollection.register(new PropertyGridEditorSpinEdit());
PropertyGridEditorCollection.register(new PropertyGridEditorText());
PropertyGridEditorCollection.register(new PropertyGridEditorHtml());
PropertyGridEditorCollection.register(new PropertyGridEditorDropdown());
PropertyGridEditorCollection.register(new PropertyGridEditorSet());
PropertyGridEditorCollection.register(new PropertyGridEditorPage());
PropertyGridEditorCollection.register(new PropertyGridEditorStringArray());
PropertyGridEditorCollection.register(new PropertyGridEditorQuestion());
PropertyGridEditorCollection.register(new PropertyGridEditorQuestionValue());
PropertyGridEditorCollection.register(new PropertyGridEditorQuestionSelectBase());
PropertyGridEditorCollection.register(new PropertyGridEditorQuestionCarryForward());
PropertyGridEditorCollection.register(new PropertyGridEditorImageSize());
PropertyGridEditorCollection.register(new PropertyGridEditorColor());
PropertyGridEditorCollection.register(new PropertyGridEditorColorWithAlpha());
PropertyGridEditorCollection.register(new PropertyGridEditorDateTime());
PropertyGridEditorCollection.register(new PropertyGridEditorUndefinedBoolean());
PropertyGridEditorCollection.register(new PropertyGridEditorSwitchToggle());
survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionFactory.Instance.registerQuestion("buttongroup", function (name) {
    return new survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionButtonGroupModel(name);
}, false);


/***/ }),

/***/ "./src/property-grid/maskSettings.ts":
/*!*******************************************!*\
  !*** ./src/property-grid/maskSettings.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PropertyGridEditorQuestionMaskSettings: () => (/* binding */ PropertyGridEditorQuestionMaskSettings)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./index */ "./src/property-grid/index.ts");



var json = {
    name: "propertygrid_masksettings",
    showInToolbox: false,
    internal: true,
    createElements: function (panel) {
        //tell ComponentCollection that it is composite question
    }
};
if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.getCustomQuestionByName(json.name)) {
    survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.add(json);
}
var PropertyGridEditorQuestionMaskSettings = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorQuestionMaskSettings, _super);
    function PropertyGridEditorQuestionMaskSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorQuestionMaskSettings.prototype.fit = function (prop) {
        return prop.type == "masksettings";
    };
    PropertyGridEditorQuestionMaskSettings.prototype.getJSON = function (obj, prop, options) {
        return {
            type: "propertygrid_masksettings",
            titleLocation: "hidden"
        };
    };
    PropertyGridEditorQuestionMaskSettings.prototype.onCreated = function (obj, question, prop, options) {
        var masksettings = obj[prop.name];
        this._propertyGrid = new _index__WEBPACK_IMPORTED_MODULE_2__.PropertyJSONGenerator(masksettings, options, obj, prop);
        this._prevMaskType = "";
        var panel = question["contentPanel"];
        this._previewQuestion = panel.addNewQuestion("html", "preview");
        this.updatePanel(obj, question, prop);
    };
    PropertyGridEditorQuestionMaskSettings.prototype.onValueChanged = function (obj, prop, question) {
        if (prop.name === "maskSettings") {
            this.updatePanel(obj, question, prop);
        }
    };
    PropertyGridEditorQuestionMaskSettings.prototype.updatePanel = function (obj, question, prop) {
        var panel = question["contentPanel"];
        var masksettings = obj[prop.name];
        if (this._prevMaskType !== obj["maskType"]) {
            this._propertyGrid.obj = masksettings;
            this._propertyGrid.setupObjPanel(panel, true);
            this._prevMaskType = obj["maskType"];
        }
        if (masksettings.getType() == "datetimemask") {
            this.updateDateTimeMinMaxInputType(masksettings, panel);
        }
        this.updatePreviewQuestion(masksettings, panel);
    };
    PropertyGridEditorQuestionMaskSettings.prototype.updateDateTimeMinMaxInputType = function (masksettings, panel) {
        var inputType = "datetime-local";
        if (!masksettings.hasDatePart)
            inputType = "time";
        if (!masksettings.hasTimePart)
            inputType = "date";
        panel.getQuestionByName("min").inputType = inputType;
        panel.getQuestionByName("max").inputType = inputType;
    };
    PropertyGridEditorQuestionMaskSettings.prototype.updatePreviewQuestion = function (masksettings, panel) {
        this._previewQuestion.visible = masksettings.getType() === "masksettings";
        if (!panel.getElementByName(this._previewQuestion.name)) {
            panel.addElement(this._previewQuestion);
        }
    };
    return PropertyGridEditorQuestionMaskSettings;
}(_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditor));

_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditorCollection.register(new PropertyGridEditorQuestionMaskSettings());


/***/ }),

/***/ "./src/property-grid/matrices.ts":
/*!***************************************!*\
  !*** ./src/property-grid/matrices.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PropertyGridEditorMatrix: () => (/* binding */ PropertyGridEditorMatrix),
/* harmony export */   PropertyGridEditorMatrixCalculatedValues: () => (/* binding */ PropertyGridEditorMatrixCalculatedValues),
/* harmony export */   PropertyGridEditorMatrixColumns: () => (/* binding */ PropertyGridEditorMatrixColumns),
/* harmony export */   PropertyGridEditorMatrixHtmlConditions: () => (/* binding */ PropertyGridEditorMatrixHtmlConditions),
/* harmony export */   PropertyGridEditorMatrixItemValues: () => (/* binding */ PropertyGridEditorMatrixItemValues),
/* harmony export */   PropertyGridEditorMatrixLayoutColumns: () => (/* binding */ PropertyGridEditorMatrixLayoutColumns),
/* harmony export */   PropertyGridEditorMatrixMultipleTypes: () => (/* binding */ PropertyGridEditorMatrixMultipleTypes),
/* harmony export */   PropertyGridEditorMatrixMutlipleTextItems: () => (/* binding */ PropertyGridEditorMatrixMutlipleTextItems),
/* harmony export */   PropertyGridEditorMatrixPages: () => (/* binding */ PropertyGridEditorMatrixPages),
/* harmony export */   PropertyGridEditorMatrixRateValues: () => (/* binding */ PropertyGridEditorMatrixRateValues),
/* harmony export */   PropertyGridEditorMatrixTriggers: () => (/* binding */ PropertyGridEditorMatrixTriggers),
/* harmony export */   PropertyGridEditorMatrixUrlConditions: () => (/* binding */ PropertyGridEditorMatrixUrlConditions),
/* harmony export */   PropertyGridEditorMatrixValidators: () => (/* binding */ PropertyGridEditorMatrixValidators)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _question_editor_properties__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../question-editor/properties */ "./src/question-editor/properties.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _fast_entry__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./fast-entry */ "./src/property-grid/fast-entry.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ./index */ "./src/property-grid/index.ts");
/* harmony import */ var _utils_actions__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../utils/actions */ "./src/utils/actions.ts");
/* harmony import */ var _components_question_rating__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../components/question-rating */ "./src/components/question-rating.ts");










survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.addProperty("itemvalue", {
    name: "icon", isSerializable: false, readOnly: true, visibleIndex: 0, visibleIf: function (obj) {
        return obj &&
            obj.ownerPropertyName === "rateValues" &&
            obj.locOwner instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionRatingModel &&
            obj.locOwner.rateType == "smileys";
    },
});
var PropertyGridEditorMatrix = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrix, _super);
    function PropertyGridEditorMatrix() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrix.getNewColumnName = function (objs, keyPropName, baseName) {
        var arr = [];
        if (Array.isArray(objs)) {
            for (var i = 0; i < objs.length; i++) {
                arr.push(objs[i][keyPropName]);
            }
        }
        return (0,_utils_utils__WEBPACK_IMPORTED_MODULE_5__.getNextValue)(baseName, arr);
    };
    PropertyGridEditorMatrix.prototype.onCreated = function (obj, question, prop, options, propGridDefinition) {
        var _this = this;
        question.onGetValueForNewRowCallBack = function (sender) {
            return _this.createNewItem(sender, prop);
        };
        this.setupMatrixQuestion(obj, question, prop, propGridDefinition);
    };
    PropertyGridEditorMatrix.prototype.onSetup = function (obj, question, prop, options) {
        var matrix = question;
        if (matrix.allowRowsDragAndDrop && matrix.dragDropMatrixRows) {
            matrix.dragDropMatrixRows.onDragStart.add(function () { options.startUndoRedoTransaction(); });
            matrix.dragDropMatrixRows.onDragEnd.add(function () { options.stopUndoRedoTransaction(); });
        }
    };
    PropertyGridEditorMatrix.prototype.initializePlaceholder = function (rowObj, cellQuestion, propertyName) {
        var objType = typeof rowObj.getType === "function" && rowObj.getType();
        if (cellQuestion.getType() === "text" && !!objType) {
            if (propertyName === "text" && objType === "itemvalue") {
                cellQuestion.placeholder = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                    if (!!rowObj.value)
                        return rowObj.value.toString();
                    return rowObj.text;
                });
            }
            if (propertyName === "title" && (objType === "matrixdropdowncolumn" || objType === "multipletextitem")) {
                cellQuestion.placeholder = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
                    if (!!rowObj.name)
                        return rowObj.name;
                    return rowObj.title;
                });
            }
        }
    };
    PropertyGridEditorMatrix.prototype.onMatrixCellCreated = function (obj, options) {
        var rowObj = options.row.editingObj;
        if (!rowObj)
            return;
        var q = options.cellQuestion;
        q.obj = rowObj;
        this.initializePlaceholder(rowObj, q, options.columnName);
        q.property = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(rowObj.getType(), options.columnName);
        if (q.getType() === "boolean" && q.renderAs === "checkbox") {
            q.titleLocation = "default";
        }
    };
    PropertyGridEditorMatrix.prototype.onGetMatrixRowAction = function (obj, options, setObjFunc) {
        var _this = this;
        var question = options.question;
        var row = options.row;
        var actions = options.actions;
        if (this.getEditItemAsStandAlone()) {
            actions.push({
                id: "svd-grid-edit-column",
                iconName: "icon-edit",
                title: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.edit"),
                visibleIndex: 0,
                showTitle: false,
                location: "end",
                action: function () {
                    var column = options.row.editingObj;
                    setObjFunc(column);
                }
            });
        }
        var showDetailAction = actions.filter(function (item) { return item.id === "show-detail"; })[0];
        (0,_utils_actions__WEBPACK_IMPORTED_MODULE_8__.updateMatrixRemoveAction)(question, actions, row);
        if (!!showDetailAction) {
            showDetailAction.component = "sv-action-bar-item";
            showDetailAction.iconName = this.getShowDetailActionIconName(row);
            showDetailAction.iconSize = "auto";
            showDetailAction.showTitle = false;
            showDetailAction.location = "end";
            showDetailAction.ariaExpanded = row.isDetailPanelShowing;
            showDetailAction.action = function () {
                row.showHideDetailPanelClick();
                showDetailAction.iconName = row.isDetailPanelShowing ? "icon-editing-finish" : "icon-edit";
            };
            showDetailAction.visibleIndex = 0;
            showDetailAction.visible = this.hasPropertiesInDetail;
            row.onDetailPanelShowingChanged = function () {
                showDetailAction.iconName = _this.getShowDetailActionIconName(row);
                showDetailAction.ariaExpanded = row.isDetailPanelShowing;
            };
        }
        (0,_utils_actions__WEBPACK_IMPORTED_MODULE_8__.updateMatixActionsClasses)(actions);
    };
    PropertyGridEditorMatrix.prototype.getShowDetailActionIconName = function (row) {
        return row.isDetailPanelShowing ? "icon-editing-finish" : "icon-edit";
    };
    PropertyGridEditorMatrix.prototype.addItem = function (creator, obj, question) {
        question.addRow();
    };
    PropertyGridEditorMatrix.prototype.onGetQuestionTitleActions = function (obj, options, creator) {
        var _this = this;
        var question = options.question;
        options.titleActions.push({
            id: "add-item",
            iconName: "icon-add",
            iconSize: "auto",
            title: question.addRowText,
            showTitle: false,
            action: function () { return _this.addItem(creator, obj, question); },
            enabled: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return question.canAddRow; })
        });
    };
    PropertyGridEditorMatrix.prototype.createNewItem = function (matrix, prop) {
        matrix.visibleRows.forEach(function (row) { return row.hideDetailPanel(); });
        var json = {};
        var baseValue = this.getBaseValue(prop);
        var keyPropName = this.getKeyValue();
        if (!baseValue) {
            baseValue = "item";
        }
        var keyValue = null;
        if (!!baseValue && !!keyPropName) {
            var newName = PropertyGridEditorMatrix.getNewColumnName(matrix.value, keyPropName, baseValue);
            keyValue = newName;
        }
        var obj = matrix.obj;
        var item = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass(this.getDefaultClassName(obj, prop), json);
        if (!!keyValue) {
            item[keyPropName] = keyValue;
        }
        if (!!this.getObjTypeName()) {
            item[this.getObjTypeName()] = item.getType();
        }
        var arr = obj[prop.name];
        if (survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.isDescendantOf(item.getType(), "itemvalue")) {
            item.text = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_5__.getNextItemText)(arr);
        }
        arr.push(item);
        if (arr != matrix.value) {
            matrix.value = arr;
        }
        return item;
    };
    PropertyGridEditorMatrix.prototype.getDefaultClassName = function (obj, prop) {
        return prop.className;
    };
    PropertyGridEditorMatrix.prototype.getBaseValue = function (prop) {
        return prop.getBaseValue();
    };
    PropertyGridEditorMatrix.prototype.getKeyValue = function () {
        return "";
    };
    PropertyGridEditorMatrix.prototype.getColumnNames = function (obj, prop, options, propGridDefinition) {
        var names = this.getPropertiesNames(obj, prop, options, propGridDefinition);
        if (!!names && names.length > 0) {
            return names;
        }
        return this.getDefaultListProperties(prop);
    };
    PropertyGridEditorMatrix.prototype.getColumnClassName = function (obj, prop) {
        return prop.className;
    };
    PropertyGridEditorMatrix.prototype.getPropertiesNames = function (obj, prop, options, propGridDefinition) {
        var res = [];
        var properties = this.getDefinedListProperties(obj, prop, options, propGridDefinition);
        for (var i = 0; i < properties.length; i++) {
            res.push(properties[i].name);
        }
        if (res.length == 0) {
            res = this.getDefaulColumnNames();
        }
        return res;
    };
    PropertyGridEditorMatrix.prototype.getDefinedListProperties = function (obj, prop, options, propGridDefinition) {
        if (!prop.className) {
            return [];
        }
        var newObj = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass(prop.className);
        if (!newObj) {
            return [];
        }
        var props = new _question_editor_properties__WEBPACK_IMPORTED_MODULE_3__.SurveyQuestionProperties(newObj, options, this.getColumnClassName(obj, prop), "list", obj, prop, propGridDefinition);
        if (props.getTabs().length == 0) {
            return [];
        }
        return props.getTabs()[0].properties;
    };
    PropertyGridEditorMatrix.prototype.getDefaultListProperties = function (prop) {
        var res = [];
        if (!!prop && !!prop.className) {
            var properties = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.getProperties(prop.className);
            for (var i = 0; i < properties.length; i++) {
                if (!this.isPropertyShownInList(properties[i])) {
                    continue;
                }
                res.push(properties[i].name);
            }
        }
        return res.length > 0 ? res : this.getDefaulColumnNames();
    };
    PropertyGridEditorMatrix.prototype.getDefaulColumnNames = function () {
        return [];
    };
    PropertyGridEditorMatrix.prototype.isPropertyShownInList = function (prop) {
        return prop.visible && prop.showMode !== "form";
    };
    PropertyGridEditorMatrix.prototype.getObjTypeName = function () {
        return "";
    };
    PropertyGridEditorMatrix.prototype.hasDetailPanel = function () {
        return !this.getEditItemAsStandAlone();
    };
    PropertyGridEditorMatrix.prototype.setupMatrixQuestion = function (obj, matrix, prop, propGridDefinition) {
        var _this = this;
        this.hasPropertiesInDetail =
            this.hasDetailPanel() && this.calcHasPropertiesInDetail(matrix, prop, propGridDefinition);
        matrix.onHasDetailPanelCallback = function (row) {
            return row.allowEditRow !== false && _this.hasPropertiesInDetail;
        };
        matrix.onCreateDetailPanelRenderedRowCallback = function (renderedRow) {
            renderedRow.cells = [renderedRow.cells[1]];
            renderedRow.cells[0].colSpans += 2;
        };
        var q = matrix;
        matrix.onCreateDetailPanelCallback = function (row, panel) {
            new _index__WEBPACK_IMPORTED_MODULE_7__.PropertyJSONGenerator(row.editingObj, q.creatorOptions, q.obj, q.property, propGridDefinition).setupObjPanel(panel, true);
        };
        matrix.allowRowsDragAndDrop = this.getAllowRowDragDrop(prop) && !matrix.isReadOnly;
        if (!!q.creatorOptions) {
            this.setupUsingOptions(obj, matrix, q.creatorOptions, prop);
        }
        if (!!prop.uniquePropertyName) {
            var column = matrix.getColumnByName(prop.uniquePropertyName);
            if (!!column) {
                column.isUnique = true;
            }
        }
    };
    PropertyGridEditorMatrix.prototype.getAllowRowDragDrop = function (prop) { return false; };
    PropertyGridEditorMatrix.prototype.calcHasPropertiesInDetail = function (matrix, prop, propGridDefinition) {
        if (!prop.className)
            return true;
        var newObj = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass(prop.className);
        if (!newObj)
            return true;
        var panel = new survey_core__WEBPACK_IMPORTED_MODULE_1__.PanelModel("");
        new _index__WEBPACK_IMPORTED_MODULE_7__.PropertyJSONGenerator(newObj, matrix.creatorOptions, matrix.obj, prop, propGridDefinition).setupObjPanel(panel, true);
        return panel.elements.length > 0;
    };
    PropertyGridEditorMatrix.prototype.getJSON = function (obj, prop, options, propGridDefinition) {
        return this.getMatrixJSON(obj, prop, this.getColumnNames(obj, prop, options, propGridDefinition), options, propGridDefinition);
    };
    PropertyGridEditorMatrix.prototype.getMatrixJSON = function (obj, prop, propNames, options, propGridDefinition) {
        var className = prop.className;
        if (!className) {
            className = prop.baseClassName;
        }
        var columns = this.getColumnsJSON(obj, prop, propNames, options, propGridDefinition);
        var res = {
            type: "matrixdynamic",
            detailPanelMode: "underRow",
            cellType: "text",
            rowCount: 0,
            keyName: this.getKeyName(prop),
            columns: columns,
            showHeader: columns.length > 1,
            hideColumnsIfEmpty: true,
            addRowText: this.getAddRowText(prop),
            keyDuplicationError: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.propertyIsNoUnique"),
            emptyRowsText: this.getEmptyRowsText(prop)
        };
        if (this.getShowDetailPanelOnAdding()) {
            res.detailPanelShowOnAdding = true;
        }
        var minRowCount = this.getMinimumRowCount(obj, prop, options);
        var maxRowCount = this.getMaximumRowCount(obj, prop, options);
        if (minRowCount > 0) {
            res.minRowCount = minRowCount;
        }
        if (maxRowCount > 0) {
            res.maxRowCount = maxRowCount;
        }
        return res;
    };
    PropertyGridEditorMatrix.prototype.getEmptyRowsText = function (prop) {
        var locName = "pe.listIsEmpty";
        var propLocName = locName + "@" + prop.name;
        if (!!_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.hasString(propLocName)) {
            locName = propLocName;
        }
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString(locName);
    };
    PropertyGridEditorMatrix.prototype.getMinimumRowCount = function (obj, prop, options) {
        return -1;
    };
    PropertyGridEditorMatrix.prototype.getMaximumRowCount = function (obj, prop, options) {
        return -1;
    };
    PropertyGridEditorMatrix.prototype.filterPropertyNames = function (propNames, options) {
        return propNames;
    };
    PropertyGridEditorMatrix.prototype.getClassNameByProp = function (prop) {
        return !!prop.className ? prop.className : prop.baseClassName;
    };
    PropertyGridEditorMatrix.prototype.getKeyName = function (prop) {
        var className = this.getClassNameByProp(prop);
        if (!className)
            return "";
        var props = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.getProperties(className);
        for (var i = 0; i < props.length; i++) {
            if (props[i].isUnique)
                return props[i].name;
        }
        return "";
    };
    PropertyGridEditorMatrix.prototype.getColumnsJSON = function (obj, prop, propNames, options, propGridDefinition) {
        var res = new _index__WEBPACK_IMPORTED_MODULE_7__.PropertyJSONGenerator(obj, options, undefined, undefined, propGridDefinition).createColumnsJSON(this.getClassNameByProp(prop), this.filterPropertyNames(propNames, options));
        for (var i = 0; i < res.length; i++) {
            if (res[i].cellType == "comment") {
                res[i].cellType = "text";
            }
        }
        return res;
    };
    PropertyGridEditorMatrix.prototype.getEditItemAsStandAlone = function () {
        return false;
    };
    PropertyGridEditorMatrix.prototype.getShowDetailPanelOnAdding = function () {
        return false;
    };
    PropertyGridEditorMatrix.prototype.getAddRowText = function (prop) {
        var customLocStrName = "pe.addNew@" + prop.name;
        if (_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.hasString(customLocStrName)) {
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString(customLocStrName);
        }
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("pe.addNew");
    };
    PropertyGridEditorMatrix.prototype.setupUsingOptions = function (obj, matrix, options, prop) {
        var evtOptions = {
            allowAddRemoveItems: true,
            allowRemoveAllItems: true,
            showTextView: true,
            allowBatchEdit: true
            // options.itemsEntryType
        };
        options.onSetPropertyEditorOptionsCallback(prop.name, obj, evtOptions);
        if (!evtOptions.allowAddRemoveItems) {
            matrix.allowAddRows = false;
            matrix.allowRemoveRows = false;
        }
        matrix.allowRemoveAllItems = evtOptions.allowRemoveAllItems;
        matrix.showTextView = evtOptions.showTextView;
        matrix.allowBatchEdit = evtOptions.allowBatchEdit;
    };
    return PropertyGridEditorMatrix;
}(_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditor));

var PropertyGridEditorMatrixItemValues = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixItemValues, _super);
    function PropertyGridEditorMatrixItemValues() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixItemValues.prototype.fit = function (prop) {
        return (prop.isArray && survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.isDescendantOf(prop.className, "itemvalue") && prop.name != "rateValues");
    };
    PropertyGridEditorMatrixItemValues.prototype.excludeTextPropertyName = function (propNames, options) {
        var hideText = options === null || options === void 0 ? void 0 : options.inplaceEditForValues;
        return !!hideText ? propNames.filter(function (p) { return p !== "text"; }) : propNames;
    };
    PropertyGridEditorMatrixItemValues.prototype.filterPropertyNames = function (propNames, options) {
        return this.excludeTextPropertyName(propNames, options).filter(function (p) { return p != "icon"; });
    };
    PropertyGridEditorMatrixItemValues.prototype.isPropertyEditorSetupEnabled = function (obj, prop, question, options) {
        if (question.showTextView === false)
            return false;
        var matrix = question;
        var column = matrix.getColumnByName("value");
        var items = question.value;
        return (!!column &&
            column.isVisible &&
            !column.readOnly &&
            !this.hasMultipleLanguage(items) &&
            !this.hasVisibleIfOrEnableIf(items));
    };
    PropertyGridEditorMatrixItemValues.prototype.getAllowRowDragDrop = function (prop) { return true; };
    PropertyGridEditorMatrixItemValues.prototype.createPropertyEditorSetup = function (obj, prop, question, options) {
        var names = question.columns.filter(function (c) { return !c.readOnly; }).map(function (c) { return c.name; });
        return new _fast_entry__WEBPACK_IMPORTED_MODULE_6__.FastEntryEditor(obj[prop.name], options, prop.className, names);
    };
    PropertyGridEditorMatrixItemValues.prototype.canClearPropertyValue = function (obj, prop, question, options) {
        return question.allowRemoveAllItems !== false;
    };
    PropertyGridEditorMatrixItemValues.prototype.clearPropertyValue = function (obj, prop, question, options) {
        var arr = obj[prop.name];
        if (!Array.isArray(arr)) {
            return;
        }
        arr.splice(0, arr.length);
    };
    PropertyGridEditorMatrixItemValues.prototype.getColumnClassName = function (obj, prop) {
        return obj.getType() + "@" + prop.name;
    };
    PropertyGridEditorMatrixItemValues.prototype.getDefaulColumnNames = function () {
        return ["value", "text"];
    };
    PropertyGridEditorMatrixItemValues.prototype.getKeyValue = function () {
        return "value";
    };
    PropertyGridEditorMatrixItemValues.prototype.getMatrixJSON = function (obj, prop, propNames, options, propGridDefinition) {
        var res = _super.prototype.getMatrixJSON.call(this, obj, prop, propNames, options, propGridDefinition);
        if (prop.name === "rateValues" && res.columns[0].name == "icon")
            res.showHeader = res.columns > 3;
        return res;
    };
    PropertyGridEditorMatrixItemValues.prototype.getMinimumRowCount = function (obj, prop, options) {
        if (prop.name === "choices")
            return options.minimumChoicesCount;
        return _super.prototype.getMaximumRowCount.call(this, obj, prop, options);
    };
    PropertyGridEditorMatrixItemValues.prototype.getMaximumRowCount = function (obj, prop, options) {
        if (prop.name === "choices")
            return options.maximumChoicesCount;
        if (prop.name === "rows")
            return options.maximumRowsCount;
        if (prop.name === "columns")
            return options.maximumColumnsCount;
        if (prop.name === "rateValues")
            return options.maximumRateValues;
        return _super.prototype.getMaximumRowCount.call(this, obj, prop, options);
    };
    PropertyGridEditorMatrixItemValues.prototype.hasMultipleLanguage = function (items) {
        if (!items || !Array.isArray(items)) {
            return false;
        }
        for (var i = 0; i < items.length; i++) {
            if (items[i].locText.hasNonDefaultText()) {
                return true;
            }
        }
        return false;
    };
    PropertyGridEditorMatrixItemValues.prototype.hasVisibleIfOrEnableIf = function (items) {
        if (!items || !Array.isArray(items)) {
            return false;
        }
        for (var i = 0; i < items.length; i++) {
            if (!!items[i].visibleIf || items[i].enableIf) {
                return true;
            }
        }
        return false;
    };
    PropertyGridEditorMatrixItemValues.prototype.onMatrixCellCreated = function (obj, options) {
        _super.prototype.onMatrixCellCreated.call(this, obj, options);
        function updateHtml(question, value) {
            var newValue = survey_core__WEBPACK_IMPORTED_MODULE_1__.renamedIcons[value] || value;
            question.html = "<div class=\"spg-smiley-icon\"><svg><use xlink:href=\"#icon-" + newValue + "\"></use></svg></div>";
        }
        function changeValueCallback(sender, options) {
            if (options.name != "value")
                return;
            updateHtml(sender, options.newValue);
        }
        if (obj instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionRatingModel && options.columnName == "icon") {
            updateHtml(options.cellQuestion, options.cellQuestion.value);
            options.cellQuestion.onPropertyChanged.add(changeValueCallback);
        }
    };
    PropertyGridEditorMatrixItemValues.prototype.onMatrixCellValueChanged = function (obj, options) {
        if (obj instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionRatingModel && options.columnName == "icon") {
            //options.cellQuestion.html = "<svg style='fill: red'><use xlink:href=\"#" + options.cellQuestion.value + "\"></use></svg>";
            options.cellQuestion.html = options.cellQuestion.value;
        }
    };
    return PropertyGridEditorMatrixItemValues;
}(PropertyGridEditorMatrix));

var PropertyGridEditorMatrixRateValues = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixRateValues, _super);
    function PropertyGridEditorMatrixRateValues() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixRateValues.prototype.fit = function (prop) {
        return (prop.isArray && survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.isDescendantOf(prop.className, "itemvalue") && prop.name == "rateValues");
    };
    PropertyGridEditorMatrixRateValues.prototype.updateAllowAddRemove = function (matrixQuestion, obj) {
        matrixQuestion.allowRemoveRows = _components_question_rating__WEBPACK_IMPORTED_MODULE_9__.QuestionRatingAdornerViewModel.allowRemoveForElement(obj);
        matrixQuestion.allowAddRows = _components_question_rating__WEBPACK_IMPORTED_MODULE_9__.QuestionRatingAdornerViewModel.allowAddForElement(obj, matrixQuestion.maxRowCount);
    };
    PropertyGridEditorMatrixRateValues.prototype.onCreated = function (obj, question, prop, options, propGridDefinition) {
        var _this = this;
        _super.prototype.onCreated.call(this, obj, question, prop, options, propGridDefinition);
        var matrixQuestion = question;
        var ratingQuestion = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_5__.getQuestionFromObj)(obj);
        this.updateAllowAddRemove(matrixQuestion, ratingQuestion);
        obj.onPropertyChanged.add(function (sender, options) {
            if (options.name == "rateCount" || options.name == "rateDisplayMode") {
                _this.updateAllowAddRemove(matrixQuestion, ratingQuestion);
            }
        });
    };
    PropertyGridEditorMatrixRateValues.prototype.onGetQuestionTitleActions = function (obj, options, creator) {
        var clearAction = options.titleActions.filter(function (a) { return a.id == "property-grid-clear"; })[0];
        if (clearAction)
            clearAction.visible = false;
        _super.prototype.onGetQuestionTitleActions.call(this, obj, options, creator);
    };
    PropertyGridEditorMatrixRateValues.prototype.filterPropertyNames = function (propNames, options) {
        return this.excludeTextPropertyName(propNames, options);
    };
    return PropertyGridEditorMatrixRateValues;
}(PropertyGridEditorMatrixItemValues));

var PropertyGridEditorMatrixColumns = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixColumns, _super);
    function PropertyGridEditorMatrixColumns() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixColumns.prototype.fit = function (prop) {
        return prop.type == "matrixdropdowncolumns";
    };
    PropertyGridEditorMatrixColumns.prototype.getEditItemAsStandAlone = function () {
        return true;
    };
    PropertyGridEditorMatrixColumns.prototype.getDefaulColumnNames = function () {
        return ["name", "title"];
    };
    PropertyGridEditorMatrixColumns.prototype.getKeyValue = function () {
        return "name";
    };
    PropertyGridEditorMatrixColumns.prototype.getBaseValue = function (prop) {
        return "column";
    };
    PropertyGridEditorMatrixColumns.prototype.getMaximumRowCount = function (obj, prop, options) {
        return options.maximumColumnsCount;
    };
    PropertyGridEditorMatrixColumns.prototype.getAllowRowDragDrop = function (prop) { return true; };
    return PropertyGridEditorMatrixColumns;
}(PropertyGridEditorMatrix));

var PropertyGridEditorMatrixLayoutColumns = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixLayoutColumns, _super);
    function PropertyGridEditorMatrixLayoutColumns() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixLayoutColumns.prototype.fit = function (prop) {
        return prop.type == "panellayoutcolumns";
    };
    PropertyGridEditorMatrixLayoutColumns.prototype.getDefaulColumnNames = function () {
        return ["width", "questionTitleWidth"];
    };
    PropertyGridEditorMatrixLayoutColumns.prototype.onMatrixCellCreated = function (obj, options) {
        _super.prototype.onMatrixCellCreated.call(this, obj, options);
        var q = options.cellQuestion;
        q.textUpdateMode = "onTyping";
    };
    PropertyGridEditorMatrixLayoutColumns.prototype.onCreated = function (obj, question, prop, options, propGridDefinition) {
        _super.prototype.onCreated.call(this, obj, question, prop, options, propGridDefinition);
        var matrixQuestion = question;
        matrixQuestion.allowRemoveRows = false;
        matrixQuestion.allowAddRows = false;
    };
    return PropertyGridEditorMatrixLayoutColumns;
}(PropertyGridEditorMatrix));

var PropertyGridEditorMatrixPages = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixPages, _super);
    function PropertyGridEditorMatrixPages() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixPages.prototype.fit = function (prop) {
        return prop.type == "surveypages";
    };
    PropertyGridEditorMatrixPages.prototype.addItem = function (creator, obj, question) {
        creator.addPage(undefined, false);
    };
    PropertyGridEditorMatrixPages.prototype.getColumnClassName = function (obj, prop) {
        return "page@" + obj.getType();
    };
    PropertyGridEditorMatrixPages.prototype.getDefaulColumnNames = function () {
        return ["name", "title"];
    };
    PropertyGridEditorMatrixPages.prototype.hasDetailPanel = function () {
        return false;
    };
    PropertyGridEditorMatrixPages.prototype.getKeyValue = function () {
        return "name";
    };
    PropertyGridEditorMatrixPages.prototype.getBaseValue = function (prop) {
        return "page";
    };
    PropertyGridEditorMatrixPages.prototype.getAllowRowDragDrop = function (prop) { return true; };
    return PropertyGridEditorMatrixPages;
}(PropertyGridEditorMatrix));

var PropertyGridEditorMatrixCalculatedValues = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixCalculatedValues, _super);
    function PropertyGridEditorMatrixCalculatedValues() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixCalculatedValues.prototype.fit = function (prop) {
        return prop.type == "calculatedvalues";
    };
    PropertyGridEditorMatrixCalculatedValues.prototype.getColumnClassName = function (obj, prop) {
        return "calculatedvalue@items";
    };
    PropertyGridEditorMatrixCalculatedValues.prototype.getDefaulColumnNames = function () {
        return ["name"];
    };
    PropertyGridEditorMatrixCalculatedValues.prototype.getKeyValue = function () {
        return "name";
    };
    PropertyGridEditorMatrixCalculatedValues.prototype.getBaseValue = function (prop) {
        return "var";
    };
    PropertyGridEditorMatrixCalculatedValues.prototype.getShowDetailPanelOnAdding = function () {
        return true;
    };
    PropertyGridEditorMatrixCalculatedValues.prototype.setupMatrixQuestion = function (obj, matrix, prop, propGridDefinition) {
        _super.prototype.setupMatrixQuestion.call(this, obj, matrix, prop, propGridDefinition);
        matrix.isUniqueCaseSensitive = false;
    };
    return PropertyGridEditorMatrixCalculatedValues;
}(PropertyGridEditorMatrix));

var PropertyGridEditorMatrixHtmlConditions = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixHtmlConditions, _super);
    function PropertyGridEditorMatrixHtmlConditions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixHtmlConditions.prototype.fit = function (prop) {
        return prop.type == "htmlconditions";
    };
    PropertyGridEditorMatrixHtmlConditions.prototype.getDefaulColumnNames = function () {
        return ["html"];
    };
    PropertyGridEditorMatrixHtmlConditions.prototype.getShowDetailPanelOnAdding = function () {
        return true;
    };
    return PropertyGridEditorMatrixHtmlConditions;
}(PropertyGridEditorMatrix));

var PropertyGridEditorMatrixUrlConditions = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixUrlConditions, _super);
    function PropertyGridEditorMatrixUrlConditions() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixUrlConditions.prototype.fit = function (prop) {
        return prop.type == "urlconditions";
    };
    PropertyGridEditorMatrixUrlConditions.prototype.getDefaulColumnNames = function () {
        return ["url"];
    };
    PropertyGridEditorMatrixUrlConditions.prototype.getShowDetailPanelOnAdding = function () {
        return true;
    };
    return PropertyGridEditorMatrixUrlConditions;
}(PropertyGridEditorMatrix));

var PropertyGridEditorMatrixMutlipleTextItems = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixMutlipleTextItems, _super);
    function PropertyGridEditorMatrixMutlipleTextItems() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixMutlipleTextItems.prototype.fit = function (prop) {
        return prop.type == "textitem[]";
    };
    PropertyGridEditorMatrixMutlipleTextItems.prototype.getEditItemAsStandAlone = function () {
        return true;
    };
    PropertyGridEditorMatrixMutlipleTextItems.prototype.getColumnClassName = function (obj, prop) {
        return "multipletext@items";
    };
    PropertyGridEditorMatrixMutlipleTextItems.prototype.getDefaulColumnNames = function () {
        return ["name"];
    };
    PropertyGridEditorMatrixMutlipleTextItems.prototype.getKeyValue = function () {
        return "name";
    };
    PropertyGridEditorMatrixMutlipleTextItems.prototype.getBaseValue = function (prop) {
        return "item";
    };
    PropertyGridEditorMatrixMutlipleTextItems.prototype.getAllowRowDragDrop = function () {
        return true;
    };
    PropertyGridEditorMatrixMutlipleTextItems.prototype.createPropertyEditorSetup = function (obj, prop, question, options) {
        var names = [];
        question.columns.forEach(function (col) {
            names.push(col.name);
        });
        return new _fast_entry__WEBPACK_IMPORTED_MODULE_6__.FastEntryEditorBase(obj[prop.name], options, prop.className, names);
    };
    PropertyGridEditorMatrixMutlipleTextItems.prototype.onMatrixCellCreated = function (obj, options) {
        _super.prototype.onMatrixCellCreated.call(this, obj, options);
        var q = options.cellQuestion;
        if (!options.row.editingObj)
            return;
        var editor = options.row.editingObj.editor;
        if (!!editor && !!q.property) {
            editor.registerFunctionOnPropertyValueChanged(q.property.name, function () {
                q.value = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.getObjPropertyValue(editor, q.property.name);
            });
        }
    };
    return PropertyGridEditorMatrixMutlipleTextItems;
}(PropertyGridEditorMatrix));

var PropertyGridEditorMatrixMultipleTypes = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixMultipleTypes, _super);
    function PropertyGridEditorMatrixMultipleTypes() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixMultipleTypes.prototype.getColumnsJSON = function (obj, prop, propNames, options, propGridDefinition) {
        var res = _super.prototype.getColumnsJSON.call(this, obj, prop, propNames, options, propGridDefinition);
        if (!!this.getObjTypeName()) {
            res.unshift({
                name: this.getObjTypeName(),
                cellType: "dropdown"
            });
        }
        return res;
    };
    PropertyGridEditorMatrixMultipleTypes.prototype.onMatrixCellCreated = function (obj, options) {
        _super.prototype.onMatrixCellCreated.call(this, obj, options);
        if (!options.row.editingObj)
            return;
        var q = options.cellQuestion;
        if (options.columnName === this.getObjTypeName()) {
            q.showOptionsCaption = false;
            q.choices = this.getChoices(obj);
            q.value = options.row.editingObj.getType();
        }
    };
    PropertyGridEditorMatrixMultipleTypes.prototype.onMatrixCellValueChanged = function (obj, options) {
        if (options.columnName !== this.getObjTypeName())
            return;
        var index = options.question.visibleRows.indexOf(options.row);
        if (index < 0)
            return;
        var isDetailPanelShowing = options.row.isDetailPanelShowing;
        var objJSON = options.row.editingObj.toJSON();
        delete objJSON.type;
        var newItem = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass(options.value);
        newItem.fromJSON(objJSON);
        newItem[this.getObjTypeName()] = newItem.getType();
        options.row.hideDetailPanel(true);
        options.question.value.splice(index, 1, newItem);
        options.row.value = newItem;
        if (isDetailPanelShowing) {
            options.row.showDetailPanel();
        }
    };
    PropertyGridEditorMatrixMultipleTypes.prototype.getShowDetailPanelOnAdding = function () {
        return true;
    };
    return PropertyGridEditorMatrixMultipleTypes;
}(PropertyGridEditorMatrix));

var PropertyGridEditorMatrixValidators = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixValidators, _super);
    function PropertyGridEditorMatrixValidators() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixValidators.prototype.fit = function (prop) {
        return prop.type == "validators";
    };
    PropertyGridEditorMatrixValidators.prototype.getObjTypeName = function () {
        return "validatorType";
    };
    PropertyGridEditorMatrixValidators.prototype.getDefaultClassName = function (obj, prop) {
        var res = "expression";
        var question = obj;
        if (!!question.getSupportedValidators) {
            var validators = question.getSupportedValidators();
            if (validators.length > 0 && validators.indexOf(res) < 0) {
                res = validators[0];
            }
        }
        return res + "validator";
    };
    PropertyGridEditorMatrixValidators.prototype.getChoices = function (obj) {
        var names = this.getSupportedValidators(obj);
        var res = [];
        for (var i = 0; i < names.length; i++) {
            var name = names[i] + "validator";
            res.push({
                value: name,
                text: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getValidatorName(name)
            });
        }
        return res;
    };
    PropertyGridEditorMatrixValidators.prototype.getSupportedValidators = function (obj) {
        if (!obj)
            return [];
        if (obj.getSupportedValidators)
            return obj.getSupportedValidators();
        if (obj.getOriginalObj)
            return this.getSupportedValidators(obj.getOriginalObj());
        return [];
    };
    return PropertyGridEditorMatrixValidators;
}(PropertyGridEditorMatrixMultipleTypes));

var PropertyGridEditorMatrixTriggers = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorMatrixTriggers, _super);
    function PropertyGridEditorMatrixTriggers() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorMatrixTriggers.prototype.getAvailableTriggers = function () {
        var _this = this;
        return survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.getChildrenClasses("surveytrigger", true).filter(function (classObj) { return _this.isTriggerVisible(classObj.name); });
    };
    PropertyGridEditorMatrixTriggers.prototype.isTriggerVisible = function (name) {
        var postfix = "trigger";
        var pureName = name.substring(0, name.length - postfix.length);
        return name !== "visibletrigger" && _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.logic.invisibleTriggers.indexOf(pureName) < 0;
    };
    PropertyGridEditorMatrixTriggers.prototype.fit = function (prop) {
        return prop.type == "triggers";
    };
    PropertyGridEditorMatrixTriggers.prototype.getObjTypeName = function () {
        return "triggerType";
    };
    PropertyGridEditorMatrixTriggers.prototype.getDefaultClassName = function (obj, prop) {
        var classes = this.getAvailableTriggers().map(function (tr) { return tr.name; });
        if (!classes.length)
            return prop.name;
        if (classes.indexOf("runexpressiontrigger") !== -1) {
            return "runexpressiontrigger";
        }
        else {
            return classes[0];
        }
    };
    PropertyGridEditorMatrixTriggers.prototype.getAllowRowDragDrop = function (prop) { return true; };
    PropertyGridEditorMatrixTriggers.prototype.getChoices = function (obj) {
        return this.getAvailableTriggers().map(function (tr) { return { value: tr.name, text: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getTriggerName(tr.name) }; });
    };
    return PropertyGridEditorMatrixTriggers;
}(PropertyGridEditorMatrixMultipleTypes));

_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register(new PropertyGridEditorMatrixItemValues());
_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register(new PropertyGridEditorMatrixRateValues());
_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register(new PropertyGridEditorMatrixColumns());
_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register(new PropertyGridEditorMatrixPages());
_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register(new PropertyGridEditorMatrixCalculatedValues());
_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register(new PropertyGridEditorMatrixHtmlConditions());
_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register(new PropertyGridEditorMatrixUrlConditions());
_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register(new PropertyGridEditorMatrixMutlipleTextItems());
_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register(new PropertyGridEditorMatrixValidators());
_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register(new PropertyGridEditorMatrixTriggers());
_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register({
    fit: function (prop) {
        if (prop.name === "icon") {
            return prop.classInfo.name === "itemvalue";
        }
        return false;
    },
    getJSON: function (obj) {
        return {
            "type": "html"
        };
    }
});
_index__WEBPACK_IMPORTED_MODULE_7__.PropertyGridEditorCollection.register(new PropertyGridEditorMatrixLayoutColumns());


/***/ }),

/***/ "./src/property-grid/object-selector.ts":
/*!**********************************************!*\
  !*** ./src/property-grid/object-selector.ts ***!
  \**********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ObjectSelector: () => (/* binding */ ObjectSelector),
/* harmony export */   ObjectSelectorItem: () => (/* binding */ ObjectSelectorItem),
/* harmony export */   ObjectSelectorModel: () => (/* binding */ ObjectSelectorModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../survey-helper */ "./src/survey-helper.ts");



var ObjectSelectorItem = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(ObjectSelectorItem, _super);
    function ObjectSelectorItem(id, data, title, level) {
        var _this = _super.call(this, { id: "sv_item_selector_" + id.toString(), title: title }) || this;
        _this.data = data;
        _this.level = level;
        return _this;
    }
    ObjectSelectorItem.prototype.hasText = function (filteredTextInLow) {
        if (!filteredTextInLow)
            return true;
        if (!this.textInLow) {
            this.textInLow = this.title.toLocaleLowerCase();
        }
        return this.textInLow.indexOf(filteredTextInLow) > -1;
    };
    return ObjectSelectorItem;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Action));

var ObjectSelector = /** @class */ (function () {
    function ObjectSelector(creator, survey, getObjectDisplayName) {
        if (getObjectDisplayName === void 0) { getObjectDisplayName = undefined; }
        this.creator = creator;
        this.getObjectDisplayName = getObjectDisplayName;
        this.surveyValue = survey;
        this.rebuild();
    }
    Object.defineProperty(ObjectSelector.prototype, "survey", {
        get: function () {
            return this.surveyValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ObjectSelector.prototype, "items", {
        get: function () {
            return this.itemsValue;
        },
        enumerable: false,
        configurable: true
    });
    ObjectSelector.prototype.getItemByObj = function (obj) {
        var items = this.items;
        for (var i = 0; i < items.length; i++) {
            if (items[i].data === obj)
                return items[i];
        }
        return null;
    };
    ObjectSelector.prototype.filterByText = function (filteredText) {
        this.filteredTextInLow = !!filteredText ? filteredText.toLocaleLowerCase() : "";
        this.updateItemsVisibility();
    };
    ObjectSelector.prototype.rebuild = function () {
        var objs = [];
        this.deepestLevel = 0;
        var root = this.createItem(this.survey, null);
        objs.push(root);
        for (var i = 0; i < this.survey.pages.length; i++) {
            var page = this.survey.pages[i];
            var itemsParent = root;
            if (!this.creator || this.creator.pageEditMode !== "single") {
                var pageItem = this.createItem(page, root);
                objs.push(pageItem);
                itemsParent = pageItem;
            }
            this.buildElements(objs, this.getElements(page), itemsParent);
        }
        this.itemsValue = objs;
    };
    ObjectSelector.prototype.updateItemsVisibility = function () {
        for (var i = this.deepestLevel; i >= 0; i--) {
            this.updateItemsLevelVisibility(i);
        }
    };
    ObjectSelector.prototype.updateItemsLevelVisibility = function (level) {
        for (var i = 0; i < this.items.length; i++) {
            var item = this.items[i];
            if (item.level !== level)
                continue;
            item.visible = this.hasVisibleChildren(i) || item.hasText(this.filteredTextInLow);
        }
    };
    ObjectSelector.prototype.hasVisibleChildren = function (index) {
        var level = this.items[index].level;
        for (var i = index + 1; i < this.items.length; i++) {
            if (this.items[i].level <= level)
                return false;
            if (this.items[i].visible)
                return true;
        }
        return false;
    };
    ObjectSelector.prototype.getElements = function (element) {
        return _survey_helper__WEBPACK_IMPORTED_MODULE_2__.SurveyHelper.getElements(element);
    };
    ObjectSelector.prototype.buildElements = function (objs, elements, parentItem) {
        for (var i = 0; i < elements.length; i++) {
            var el = elements[i];
            var item = this.createItem(el, parentItem);
            objs.push(item);
            this.buildElements(objs, this.getElements(el), item);
        }
    };
    ObjectSelector.prototype.createItem = function (obj, parent) {
        var item = new ObjectSelectorItem(ObjectSelector.uniqueId++, obj, this.getText(obj), parent != null ? parent.level + 1 : 0);
        if (item.level > this.deepestLevel) {
            this.deepestLevel = item.level;
        }
        return item;
    };
    ObjectSelector.prototype.getText = function (obj) {
        var text = !!this.getObjectDisplayName
            ? this.getObjectDisplayName(obj, "property-grid-header:element-list", "property-grid", undefined)
            : _survey_helper__WEBPACK_IMPORTED_MODULE_2__.SurveyHelper.getObjectName(obj, false);
        return text;
    };
    ObjectSelector.uniqueId = 0;
    return ObjectSelector;
}());

var ObjectSelectorModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(ObjectSelectorModel, _super);
    function ObjectSelectorModel(creator, getObjectDisplayName) {
        if (getObjectDisplayName === void 0) { getObjectDisplayName = undefined; }
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.getObjectDisplayName = getObjectDisplayName;
        return _this;
    }
    Object.defineProperty(ObjectSelectorModel.prototype, "list", {
        get: function () {
            return this.listModelValue;
        },
        enumerable: false,
        configurable: true
    });
    ObjectSelectorModel.prototype.show = function (survey, selectedObj, onClose) {
        var _this = this;
        this.selector = new ObjectSelector(this.creator, survey, this.getObjectDisplayName);
        var selectedItem = this.selector.getItemByObj(selectedObj);
        if (!this.listModelValue) {
            this.listModelValue = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ListModel({
                items: this.selector.items,
                onSelectionChanged: function (item) { onClose(item.data); },
                allowSelection: true,
                selectedItem: selectedItem
            });
            this.listModelValue.setOnFilterStringChangedCallback(function (text) { _this.selector.filterByText(text); });
        }
        else {
            this.listModelValue.setItems(this.selector.items);
            this.listModelValue.selectedItem = selectedItem;
        }
        this.isVisible = true;
    };
    ObjectSelectorModel.prototype.refresh = function () {
        this.listModelValue.refresh();
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], ObjectSelectorModel.prototype, "isVisible", void 0);
    return ObjectSelectorModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/property-grid/property-grid-view-model.ts":
/*!*******************************************************!*\
  !*** ./src/property-grid/property-grid-view-model.ts ***!
  \*******************************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PropertyGridViewModel: () => (/* binding */ PropertyGridViewModel)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _object_selector__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./object-selector */ "./src/property-grid/object-selector.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _search_manager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ./search-manager */ "./src/property-grid/search-manager.ts");
/* harmony import */ var _utils_actions__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../utils/actions */ "./src/utils/actions.ts");








var PropertyGridViewModel = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridViewModel, _super);
    function PropertyGridViewModel(propertyGridModel, creator) {
        var _this = _super.call(this) || this;
        _this.propertyGridModel = propertyGridModel;
        _this.creator = creator;
        _this.searchManager = new _search_manager__WEBPACK_IMPORTED_MODULE_6__.SearchManagerPropertyGrid();
        _this.searchEnabled = _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.propertyGrid.enableSearch;
        _this.selectedElementName = _this.getTitle();
        _this.propertyGridModel.objValueChangedCallback = function () {
            _this.onSurveyChanged();
        };
        _this.propertyGridModel.changedFromActionCallback = function (obj, propertyName) {
            if (!!_this.selectionController) {
                _this.selectionController.selectFromAction(obj, propertyName);
            }
        };
        _this.initActions();
        _this.creator.onPropertyChanged.add(function (sender, options) {
            if (options.name === "sidebarLocation") {
                _this.selectorPopupModel.horizontalPosition = _this.creator.sidebarLocation == "right" ? "left" : "right";
            }
        });
        _this.onSurveyChanged();
        return _this;
    }
    Object.defineProperty(PropertyGridViewModel.prototype, "rootCss", {
        get: function () {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("spg-container")
                .append("spg-container_search", this.searchEnabled)
                .toString();
        },
        enumerable: false,
        configurable: true
    });
    PropertyGridViewModel.prototype.onPropertyValueChanged = function (name, oldValue, newValue) {
        _super.prototype.onPropertyValueChanged.call(this, name, oldValue, newValue);
        if (!!this.nextSelectionAction && name === "hasNext") {
            this.nextSelectionAction.enabled = this.hasNext;
        }
        if (!!this.prevSelectionAction && name === "hasPrev") {
            this.prevSelectionAction.enabled = this.hasPrev;
        }
    };
    Object.defineProperty(PropertyGridViewModel.prototype, "selectionController", {
        get: function () {
            return this.creator.selectionHistoryController;
        },
        enumerable: false,
        configurable: true
    });
    PropertyGridViewModel.prototype.onSurveyChanged = function () {
        var _this = this;
        this.survey = this.propertyGridModel.survey;
        this.searchManager.setSurvey(this.survey);
        if (!!this.survey) {
            this.survey.onValueChanged.add(function (sender, options) {
                if (options.name == "name" || options.name == "title") {
                    _this.updateTitle();
                }
            });
        }
        this.updateTitle();
        if (this.selectionController) {
            this.hasPrev = this.selectionController.hasPrev;
            this.hasNext = this.selectionController.hasNext;
        }
    };
    PropertyGridViewModel.prototype.updateTitle = function () {
        var titleName = this.getTitle();
        this.selectedElementName = titleName;
        this.objectSelectionAction.title = this.selectedElementName;
    };
    PropertyGridViewModel.prototype.getTitle = function () {
        var obj = this.getSelectedObj();
        if (!obj)
            return "";
        var displayName = _survey_helper__WEBPACK_IMPORTED_MODULE_2__.SurveyHelper.getObjectName(obj, this.propertyGridModel.options.showObjectTitles);
        return this.propertyGridModel.options.getObjectDisplayName(obj, "property-grid-header:selected-element", "property-grid-title", displayName);
    };
    PropertyGridViewModel.prototype.getSelectedObj = function () {
        return this.propertyGridModel.obj;
    };
    PropertyGridViewModel.prototype.initActions = function () {
        var _this = this;
        if (_creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.propertyGrid.showNavigationButtons) {
            this.prevSelectionAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
                id: "svd-grid-history-prev",
                iconName: "icon-arrow-left",
                component: "sv-action-bar-item",
                title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_5__.getLocString)("ed.prevSelected"),
                showTitle: false,
                enabled: this.hasPrev,
                action: function () {
                    _this.selectionController.prev();
                }
            });
            this.nextSelectionAction = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
                id: "svd-grid-history-next",
                iconName: "icon-arrow-right",
                component: "sv-action-bar-item",
                title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_5__.getLocString)("ed.nextSelected"),
                showTitle: false,
                enabled: this.hasNext,
                action: function () {
                    _this.selectionController.next();
                }
            });
        }
        this.createObjectSwitcherAction();
    };
    PropertyGridViewModel.prototype.createObjectSwitcherAction = function () {
        var _this = this;
        var selectorModel = new _object_selector__WEBPACK_IMPORTED_MODULE_3__.ObjectSelectorModel(this.creator, function (obj, area, reason, displayName) {
            return _this.propertyGridModel.options.getObjectDisplayName(obj, area, reason, displayName);
        });
        this.selectorPopupModel = new survey_core__WEBPACK_IMPORTED_MODULE_1__.PopupModel("svc-object-selector", { model: selectorModel }, {
            verticalPosition: "bottom",
            horizontalPosition: "center",
            cssClass: "svc-creator-popup",
        });
        this.selectorPopupModel.cssClass += " svc-object-selector";
        this.selectorPopupModel.displayMode = this.creator.isTouch ? "overlay" : "popup";
        this.selectorPopupModel.getTargetCallback = survey_core__WEBPACK_IMPORTED_MODULE_1__.getActionDropdownButtonTarget;
        this.selectorPopupModel.registerPropertyChangedHandlers(["isVisible"], function () {
            if (!_this.selectorPopupModel.isVisible) {
                _this.objectSelectionAction.pressed = false;
            }
            else {
                _this.objectSelectionAction.pressed = true;
            }
        });
        this.objectSelectionAction = new _utils_actions__WEBPACK_IMPORTED_MODULE_7__.MenuButton({
            id: "svd-grid-object-selector",
            title: this.selectedElementName,
            css: "sv-action--object-selector",
            component: "sv-action-bar-item-dropdown",
            disableHide: true,
            pressed: false,
            action: function () {
                selectorModel.show(_this.selectionController.creator.survey, _this.propertyGridModel.obj, function (obj) {
                    _this.selectionController.selectFromAction(obj, "name");
                    _this.selectorPopupModel.hide();
                });
                _this.selectorPopupModel.show();
                selectorModel.list.scrollToSelectedItem();
            },
            popupModel: this.selectorPopupModel
        });
        this.objectSelectionAction.contentType = "text-description-vertical";
    };
    PropertyGridViewModel.prototype.dispose = function () {
        this.searchManager.dispose();
        this.nextSelectionAction.dispose();
        this.prevSelectionAction.dispose();
        this.objectSelectionAction.dispose();
        this.selectorPopupModel.dispose();
        _super.prototype.dispose.call(this);
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], PropertyGridViewModel.prototype, "hasPrev", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], PropertyGridViewModel.prototype, "hasNext", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], PropertyGridViewModel.prototype, "survey", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], PropertyGridViewModel.prototype, "selectedElementName", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            onSet: function (newValue, target) {
                target.searchManager.isVisible = newValue;
            }
        })
    ], PropertyGridViewModel.prototype, "searchEnabled", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], PropertyGridViewModel.prototype, "showPlaceholder", void 0);
    return PropertyGridViewModel;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/property-grid/restfull.ts":
/*!***************************************!*\
  !*** ./src/property-grid/restfull.ts ***!
  \***************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PropertyGridEditorQuestionRestfull: () => (/* binding */ PropertyGridEditorQuestionRestfull)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./index */ "./src/property-grid/index.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");




var json = {
    name: "propertygrid_restfull",
    showInToolbox: false,
    internal: true,
    createElements: function (panel) {
        //tell ComponentCollection that it is composite question
    }
};
if (!survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.getCustomQuestionByName(json.name)) {
    survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.add(json);
}
var PropertyGridEditorQuestionRestfull = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorQuestionRestfull, _super);
    function PropertyGridEditorQuestionRestfull() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorQuestionRestfull.prototype.fit = function (prop) {
        return prop.type == "restfull";
    };
    PropertyGridEditorQuestionRestfull.prototype.getJSON = function (obj, prop, options) {
        return {
            type: "propertygrid_restfull",
            titleLocation: "hidden"
        };
    };
    PropertyGridEditorQuestionRestfull.prototype.onCreated = function (obj, question, prop, options, propGridDefinition) {
        var panel = question["contentPanel"];
        var choicesByUrl = obj[prop.name];
        new _index__WEBPACK_IMPORTED_MODULE_2__.PropertyJSONGenerator(choicesByUrl, options, obj, prop, propGridDefinition).setupObjPanel(panel, true);
        var test = panel.addNewQuestion("dropdown", "test");
        test.title = _editorLocalization__WEBPACK_IMPORTED_MODULE_3__.editorLocalization.getString("ed.choicesLoadedFromWebPreviewTitle");
        test.choices = [];
        this.updateTestQuestion(test, choicesByUrl);
    };
    PropertyGridEditorQuestionRestfull.prototype.onValueChanged = function (obj, prop, question) {
        if (prop.name !== "choicesByUrl")
            return;
        var panel = question["contentPanel"];
        var test = panel.getQuestionByName("test");
        this.updateTestQuestion(test, obj[prop.name]);
    };
    PropertyGridEditorQuestionRestfull.prototype.updateTestQuestion = function (test, choicesByUrl) {
        if (!choicesByUrl)
            return;
        test.visible = !!choicesByUrl.url;
        test.choicesByUrl.setData(choicesByUrl);
    };
    return PropertyGridEditorQuestionRestfull;
}(_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditorQuestion));

_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditorCollection.register(new PropertyGridEditorQuestionRestfull());


/***/ }),

/***/ "./src/property-grid/search-manager.ts":
/*!*********************************************!*\
  !*** ./src/property-grid/search-manager.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SearchManagerPropertyGrid: () => (/* binding */ SearchManagerPropertyGrid)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _components_search_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../components/search-manager */ "./src/components/search-manager.ts");





var SearchManagerPropertyGrid = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SearchManagerPropertyGrid, _super);
    function SearchManagerPropertyGrid() {
        var _this = _super.call(this) || this;
        _this.highlightedEditorClass = " spg-question--highlighted";
        _this.initActionBar();
        return _this;
    }
    SearchManagerPropertyGrid.prototype.getFilterStringPlaceholder = function () { return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.propertyGridFilteredTextPlaceholder"); };
    Object.defineProperty(SearchManagerPropertyGrid.prototype, "propertyGridNoResultsFound", {
        get: function () { return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.propertyGridNoResultsFound"); },
        enumerable: false,
        configurable: true
    });
    SearchManagerPropertyGrid.prototype.expandAllParents = function (element) {
        if (!element)
            return;
        if (element.page && element.survey) {
            element.survey.currentPage = element.page;
        }
        if (element.isCollapsed) {
            element.expand(false);
        }
        this.expandAllParents(element.parent);
        this.expandAllParents(element.parentQuestion);
    };
    SearchManagerPropertyGrid.prototype.switchHighlightedEditor = function (index) {
        var _this = this;
        this.currentMatchIndex = index;
        var prevMatch = this.currentMatch;
        this.currentMatch = this.allMatches[index];
        prevMatch === null || prevMatch === void 0 ? void 0 : prevMatch.updateElementCss();
        if (!!this.currentMatch && prevMatch !== this.currentMatch) {
            this.currentMatch.updateElementCss();
            this.expandAllParents(this.currentMatch);
            setTimeout(function () {
                var _a;
                var elementId = (_a = _this.currentMatch) === null || _a === void 0 ? void 0 : _a.id;
                (0,_utils_utils__WEBPACK_IMPORTED_MODULE_3__.scrollElementIntoView)(elementId);
            }, 10);
        }
        this.updatedMatchCounterText(index);
    };
    SearchManagerPropertyGrid.prototype.updatedMatchCounterText = function (index) {
        var count = this.allMatches.length;
        if (count === 1) {
            this.matchCounterText = "";
        }
        else if (this.currentMatch) {
            var value = index + 1;
            this.matchCounterText = [value, count].join("/");
        }
        else {
            this.matchCounterText = !!this.filterString ? this.propertyGridNoResultsFound : "";
        }
    };
    SearchManagerPropertyGrid.prototype.navigateToEditor = function (index) {
        if (index < 0) {
            index = this.allMatches.length - 1;
        }
        if (index >= this.allMatches.length) {
            index = 0;
        }
        this.switchHighlightedEditor(index);
    };
    SearchManagerPropertyGrid.prototype.getAllMatches = function (newFilter) {
        var normalize = survey_core__WEBPACK_IMPORTED_MODULE_1__.settings.comparator.normalizeTextCallback;
        var newValueInLow = normalize(newFilter, "search");
        newValueInLow = newValueInLow.toLocaleLowerCase().trim();
        var visibleQuestions = this.survey.getAllQuestions().filter(function (q) { return q.isVisible; });
        return visibleQuestions.filter(function (q) {
            var srcString = q.name + "|" + q.title + "|" + q.description;
            if (!!srcString) {
                srcString = normalize(srcString, "search");
                srcString = srcString.toLocaleLowerCase().trim();
            }
            return srcString.indexOf(newValueInLow) !== -1;
        });
    };
    SearchManagerPropertyGrid.prototype.setFiterString = function (newValue, oldValue) {
        if (!newValue) {
            this.reset();
            return;
        }
        this.allMatches = this.getAllMatches(newValue);
        if (this.allMatches.length === 0) {
            this.reset();
            return;
        }
        var newCurrentIndex = this.allMatches.indexOf(this.currentMatch);
        this.switchHighlightedEditor(newCurrentIndex === -1 ? 0 : newCurrentIndex);
    };
    SearchManagerPropertyGrid.prototype.reset = function () {
        this.allMatches = [];
        this.currentMatchIndex = -1;
        var prevMatch = this.currentMatch;
        this.currentMatch = undefined;
        prevMatch === null || prevMatch === void 0 ? void 0 : prevMatch.updateElementCss();
        this.updatedMatchCounterText(-1);
    };
    SearchManagerPropertyGrid.prototype.getSearchActions = function () {
        var _this = this;
        var searchActions = _super.prototype.getSearchActions.call(this);
        searchActions.unshift(new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "svd-grid-search-next",
            iconName: "icon-next_16x16",
            component: "sv-action-bar-item",
            title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.nextFocus"),
            showTitle: false,
            iconSize: "auto",
            innerCss: "svc-search__bar-item",
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.allMatches.length > 1; }),
            action: function () {
                if (_this.allMatches.length > 0) {
                    _this.navigateToEditor(_this.currentMatchIndex + 1);
                }
            }
        }));
        searchActions.unshift(new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "svd-grid-search-prev",
            iconName: "icon-previous_16x16",
            component: "sv-action-bar-item",
            title: (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.prevFocus"),
            showTitle: false,
            iconSize: "auto",
            innerCss: "svc-search__bar-item",
            visible: new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () { return _this.allMatches.length > 1; }),
            action: function () {
                if (_this.allMatches.length > 0) {
                    _this.navigateToEditor(_this.currentMatchIndex - 1);
                }
            }
        }));
        return searchActions;
    };
    SearchManagerPropertyGrid.prototype.setSurvey = function (newSurvey) {
        this.clearFilterString();
        this.survey = newSurvey;
        if (!!this.survey) {
            var _self_1 = this;
            this.survey.onUpdateQuestionCssClasses.add(function (_, options) {
                var classes = options.cssClasses;
                if (options.question === _self_1.currentMatch) {
                    classes.mainRoot += _self_1.highlightedEditorClass;
                }
            });
        }
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SearchManagerPropertyGrid.prototype, "survey", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], SearchManagerPropertyGrid.prototype, "isVisible", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: [] })
    ], SearchManagerPropertyGrid.prototype, "allMatches", void 0);
    return SearchManagerPropertyGrid;
}(_components_search_manager__WEBPACK_IMPORTED_MODULE_4__.SearchManager));



/***/ }),

/***/ "./src/property-grid/theme-settings.ts":
/*!*********************************************!*\
  !*** ./src/property-grid/theme-settings.ts ***!
  \*********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PropertyGridEditorBackgroundCornerRadius: () => (/* binding */ PropertyGridEditorBackgroundCornerRadius),
/* harmony export */   PropertyGridEditorFontSettings: () => (/* binding */ PropertyGridEditorFontSettings),
/* harmony export */   PropertyGridEditorShadowEffects: () => (/* binding */ PropertyGridEditorShadowEffects)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! . */ "./src/property-grid/index.ts");


var PropertyGridEditorFontSettings = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorFontSettings, _super);
    function PropertyGridEditorFontSettings() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorFontSettings.prototype.fit = function (prop) {
        return prop.type == "font";
    };
    PropertyGridEditorFontSettings.prototype.getJSON = function (obj, prop, options) {
        return { type: "font", descriptionLocation: "hidden" };
    };
    PropertyGridEditorFontSettings.prototype.onCreated = function (obj, question, prop) {
        question.valueFromDataCallback = function (val) {
            return val;
        };
        question.valueToDataCallback = function (val) {
            return val;
        };
    };
    return PropertyGridEditorFontSettings;
}(___WEBPACK_IMPORTED_MODULE_1__.PropertyGridEditor));

___WEBPACK_IMPORTED_MODULE_1__.PropertyGridEditorCollection.register(new PropertyGridEditorFontSettings());
var PropertyGridEditorBackgroundCornerRadius = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorBackgroundCornerRadius, _super);
    function PropertyGridEditorBackgroundCornerRadius() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorBackgroundCornerRadius.prototype.fit = function (prop) {
        return prop.type == "backgroundcornerradius";
    };
    PropertyGridEditorBackgroundCornerRadius.prototype.getJSON = function (obj, prop, options) {
        return { type: "backgroundcornerradius", descriptionLocation: "hidden" };
    };
    PropertyGridEditorBackgroundCornerRadius.prototype.onCreated = function (obj, question, prop) {
        question.valueFromDataCallback = function (val) {
            return val;
        };
        question.valueToDataCallback = function (val) {
            return val;
        };
    };
    return PropertyGridEditorBackgroundCornerRadius;
}(___WEBPACK_IMPORTED_MODULE_1__.PropertyGridEditor));

___WEBPACK_IMPORTED_MODULE_1__.PropertyGridEditorCollection.register(new PropertyGridEditorBackgroundCornerRadius());
var PropertyGridEditorShadowEffects = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridEditorShadowEffects, _super);
    function PropertyGridEditorShadowEffects() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridEditorShadowEffects.prototype.fit = function (prop) {
        return prop.type == "shadoweffects";
    };
    PropertyGridEditorShadowEffects.prototype.getJSON = function (obj, prop, options) {
        return { type: "shadoweffects", descriptionLocation: "hidden" };
    };
    return PropertyGridEditorShadowEffects;
}(___WEBPACK_IMPORTED_MODULE_1__.PropertyGridEditor));

___WEBPACK_IMPORTED_MODULE_1__.PropertyGridEditorCollection.register(new PropertyGridEditorShadowEffects());


/***/ }),

/***/ "./src/property-grid/values-survey.ts":
/*!********************************************!*\
  !*** ./src/property-grid/values-survey.ts ***!
  \********************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DefaultArrayValueEditor: () => (/* binding */ DefaultArrayValueEditor),
/* harmony export */   DefaultMatrixRowValueEditor: () => (/* binding */ DefaultMatrixRowValueEditor),
/* harmony export */   DefaultPanelDynamicPanelValueEditor: () => (/* binding */ DefaultPanelDynamicPanelValueEditor),
/* harmony export */   DefaultValueEditor: () => (/* binding */ DefaultValueEditor),
/* harmony export */   TriggerValueEditor: () => (/* binding */ TriggerValueEditor)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./index */ "./src/property-grid/index.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../survey-helper */ "./src/survey-helper.ts");



var DefaultValueEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(DefaultValueEditor, _super);
    function DefaultValueEditor(editQuestion, propertyName, options) {
        if (options === void 0) { options = null; }
        var _this = _super.call(this, options, false) || this;
        _this.editQuestion = editQuestion;
        _this.propertyName = propertyName;
        _this.setupSurvey();
        var oldValue = _this.getQuestionValue();
        if (oldValue !== undefined) {
            _this.question.value = oldValue;
        }
        return _this;
    }
    Object.defineProperty(DefaultValueEditor.prototype, "question", {
        get: function () {
            return this.editSurvey.getQuestionByName("question");
        },
        enumerable: false,
        configurable: true
    });
    DefaultValueEditor.prototype.getSurveyJSON = function () {
        return {
            elements: [this.getQuestionJSON()]
        };
    };
    DefaultValueEditor.prototype.getQuestionJSON = function () {
        var json = this.editQuestion.toJSON();
        json.name = "question";
        json.title = json.title || this.editQuestion.name;
        json.type = this.editQuestion.getType();
        if (json.type == "expression") {
            json.type = "text";
        }
        if (!!json.cellType && json.type == "matrixdropdowncolumn") {
            json.type = json.cellType;
            delete json["cellType"];
        }
        _survey_helper__WEBPACK_IMPORTED_MODULE_2__.SurveyHelper.updateQuestionJson(json);
        return json;
    };
    DefaultValueEditor.prototype.getQuestionValue = function () {
        return this.editQuestion[this.propertyName];
    };
    DefaultValueEditor.prototype.getEditValue = function () {
        return this.question.value;
    };
    DefaultValueEditor.prototype.getSurveyCreationReason = function () {
        return "default-value";
    };
    DefaultValueEditor.prototype.apply = function () {
        this.editQuestion[this.propertyName] = this.getEditValue();
        return true;
    };
    return DefaultValueEditor;
}(_index__WEBPACK_IMPORTED_MODULE_1__.PropertyEditorSetupValue));

var DefaultArrayValueEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(DefaultArrayValueEditor, _super);
    function DefaultArrayValueEditor(editQuestion, propertyName, options) {
        if (options === void 0) { options = null; }
        var _this = _super.call(this, editQuestion, propertyName, options) || this;
        _this.editQuestion = editQuestion;
        _this.propertyName = propertyName;
        return _this;
    }
    DefaultArrayValueEditor.prototype.getQuestionValue = function () {
        var res = _super.prototype.getQuestionValue.call(this);
        if (!res)
            return res;
        if (!Array.isArray(res)) {
            res = [res];
        }
        return res;
    };
    DefaultArrayValueEditor.prototype.getEditValue = function () {
        var res = _super.prototype.getEditValue.call(this);
        if (res && Array.isArray(res)) {
            if (res.length == 0)
                return null;
            return res[0];
        }
        return res;
    };
    return DefaultArrayValueEditor;
}(DefaultValueEditor));

var DefaultMatrixRowValueEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(DefaultMatrixRowValueEditor, _super);
    function DefaultMatrixRowValueEditor(editQuestion, propertyName, options) {
        if (options === void 0) { options = null; }
        var _this = _super.call(this, editQuestion, propertyName, options) || this;
        _this.editQuestion = editQuestion;
        _this.propertyName = propertyName;
        return _this;
    }
    DefaultMatrixRowValueEditor.prototype.getQuestionJSON = function () {
        var json = _super.prototype.getQuestionJSON.call(this);
        json.type = "matrixdynamic";
        json.rowCount = 1;
        json.minRowCount = 1;
        json.maxRowCount = 1;
        json.columnsLocation = "vertical";
        delete json.defaultValue;
        return json;
    };
    return DefaultMatrixRowValueEditor;
}(DefaultArrayValueEditor));

var DefaultPanelDynamicPanelValueEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(DefaultPanelDynamicPanelValueEditor, _super);
    function DefaultPanelDynamicPanelValueEditor(editQuestion, propertyName, options) {
        if (options === void 0) { options = null; }
        var _this = _super.call(this, editQuestion, propertyName, options) || this;
        _this.editQuestion = editQuestion;
        _this.propertyName = propertyName;
        return _this;
    }
    DefaultPanelDynamicPanelValueEditor.prototype.getQuestionJSON = function () {
        var json = _super.prototype.getQuestionJSON.call(this);
        json.panelCount = 1;
        json.minPanelCount = 1;
        json.maxPanelCount = 1;
        return json;
    };
    return DefaultPanelDynamicPanelValueEditor;
}(DefaultArrayValueEditor));

var TriggerValueEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TriggerValueEditor, _super);
    function TriggerValueEditor(editQuestion, editObj, propertyName, options) {
        if (options === void 0) { options = null; }
        var _this = _super.call(this, editQuestion, propertyName, options) || this;
        _this.editQuestion = editQuestion;
        _this.editObj = editObj;
        _this.propertyName = propertyName;
        _this.question.value = _this.getQuestionValue();
        return _this;
    }
    TriggerValueEditor.prototype.getQuestionValue = function () {
        return !!this.editObj ? this.editObj[this.propertyName] : null;
    };
    TriggerValueEditor.prototype.apply = function () {
        this.editObj[this.propertyName] = this.question.value;
        return true;
    };
    return TriggerValueEditor;
}(DefaultValueEditor));



/***/ }),

/***/ "./src/property-grid/values.ts":
/*!*************************************!*\
  !*** ./src/property-grid/values.ts ***!
  \*************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   PropertyGridCellsEditor: () => (/* binding */ PropertyGridCellsEditor),
/* harmony export */   PropertyGridPanelValueEditor: () => (/* binding */ PropertyGridPanelValueEditor),
/* harmony export */   PropertyGridRowValueEditor: () => (/* binding */ PropertyGridRowValueEditor),
/* harmony export */   PropertyGridTriggerValueEditor: () => (/* binding */ PropertyGridTriggerValueEditor),
/* harmony export */   PropertyGridTriggerValueInLogicEditor: () => (/* binding */ PropertyGridTriggerValueInLogicEditor),
/* harmony export */   PropertyGridValueEditor: () => (/* binding */ PropertyGridValueEditor),
/* harmony export */   PropertyGridValueEditorBase: () => (/* binding */ PropertyGridValueEditorBase)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./index */ "./src/property-grid/index.ts");
/* harmony import */ var _cells_survey__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./cells-survey */ "./src/property-grid/cells-survey.ts");
/* harmony import */ var _values_survey__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./values-survey */ "./src/property-grid/values-survey.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../survey-helper */ "./src/survey-helper.ts");






var PropertyGridValueEditorBase = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridValueEditorBase, _super);
    function PropertyGridValueEditorBase() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.onCreated = function (obj, question, prop, options) {
            var linkQuestion = question;
            linkQuestion.isClickableCallback = function () {
                return !linkQuestion.isReadOnly || !_this.isValueEmpty(linkQuestion.value);
            };
            linkQuestion.linkClickCallback = function () {
                _this.showModalPropertyEditor(_this, prop, question, options, function () { return linkQuestion.isSelected = false; });
                linkQuestion.isSelected = true;
            };
            linkQuestion.clearClickCallback = function () {
                _this.clearPropertyValue(question.obj, prop, question, null /*this.options*/);
            };
        };
        return _this;
    }
    PropertyGridValueEditorBase.prototype.getJSON = function (obj, prop, options) {
        return {
            type: "linkvalue",
            showValueInLink: false,
            titleLocation: "hidden"
        };
    };
    PropertyGridValueEditorBase.prototype.clearPropertyValue = function (obj, prop, question, options) {
        obj[prop.name] = undefined;
    };
    PropertyGridValueEditorBase.prototype.isValueEmpty = function (val) {
        return survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(val);
    };
    PropertyGridValueEditorBase.prototype.isSupportGrouping = function () {
        return true;
    };
    return PropertyGridValueEditorBase;
}(_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditor));

var PropertyGridCellsEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridCellsEditor, _super);
    function PropertyGridCellsEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridCellsEditor.prototype.fit = function (prop) {
        return prop.type == "cells";
    };
    PropertyGridCellsEditor.prototype.createPropertyEditorSetup = function (obj, prop, question, options) {
        return new _cells_survey__WEBPACK_IMPORTED_MODULE_3__.CellsEditor(obj, options);
    };
    PropertyGridCellsEditor.prototype.clearPropertyValue = function (obj, prop, question, options) {
        obj.cells.setJson(null);
    };
    PropertyGridCellsEditor.prototype.isValueEmpty = function (val) {
        if (!val)
            return true;
        return survey_core__WEBPACK_IMPORTED_MODULE_1__.Helpers.isValueEmpty(val.values);
    };
    return PropertyGridCellsEditor;
}(PropertyGridValueEditorBase));

var PropertyGridValueEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridValueEditor, _super);
    function PropertyGridValueEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridValueEditor.prototype.fit = function (prop) {
        return prop.type == "value";
    };
    PropertyGridValueEditor.prototype.createPropertyEditorSetup = function (obj, prop, question, options) {
        return new _values_survey__WEBPACK_IMPORTED_MODULE_4__.DefaultValueEditor(obj, prop.name, options);
    };
    return PropertyGridValueEditor;
}(PropertyGridValueEditorBase));

var PropertyGridRowValueEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridRowValueEditor, _super);
    function PropertyGridRowValueEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridRowValueEditor.prototype.fit = function (prop) {
        return prop.type == "rowvalue";
    };
    PropertyGridRowValueEditor.prototype.createPropertyEditorSetup = function (obj, prop, question, options) {
        return new _values_survey__WEBPACK_IMPORTED_MODULE_4__.DefaultMatrixRowValueEditor(obj, prop.name, options);
    };
    return PropertyGridRowValueEditor;
}(PropertyGridValueEditorBase));

var PropertyGridPanelValueEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridPanelValueEditor, _super);
    function PropertyGridPanelValueEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridPanelValueEditor.prototype.fit = function (prop) {
        return prop.type == "panelvalue";
    };
    PropertyGridPanelValueEditor.prototype.createPropertyEditorSetup = function (obj, prop, question, options) {
        return new _values_survey__WEBPACK_IMPORTED_MODULE_4__.DefaultPanelDynamicPanelValueEditor(obj, prop.name, options);
    };
    return PropertyGridPanelValueEditor;
}(PropertyGridValueEditorBase));

var PropertyGridTriggerValueEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridTriggerValueEditor, _super);
    function PropertyGridTriggerValueEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridTriggerValueEditor.prototype.fit = function (prop) {
        return prop.type == "triggervalue";
    };
    PropertyGridTriggerValueEditor.prototype.createPropertyEditorSetup = function (obj, prop, question, options) {
        var trigger = question.obj;
        var setQuestion = this.getSetToNameQuestion(trigger);
        return new _values_survey__WEBPACK_IMPORTED_MODULE_4__.TriggerValueEditor(setQuestion, trigger, prop.name, options);
    };
    PropertyGridTriggerValueEditor.prototype.getSetToNameQuestion = function (obj) {
        var survey = obj.getSurvey();
        if (!survey) {
            survey = obj["owner"];
        }
        if (!obj["setToName"] || !survey)
            return null;
        return survey.getQuestionByValueName(obj["setToName"]);
    };
    return PropertyGridTriggerValueEditor;
}(PropertyGridValueEditorBase));

var PropertyGridTriggerValueInLogicEditor = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(PropertyGridTriggerValueInLogicEditor, _super);
    function PropertyGridTriggerValueInLogicEditor() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PropertyGridTriggerValueInLogicEditor.prototype.fit = function (prop, context) {
        return context === "logic" && prop.type == "triggervalue";
    };
    PropertyGridTriggerValueInLogicEditor.prototype.getJSON = function (obj, prop, options) {
        var setQuestion = this.getSetToNameQuestion(obj);
        if (!setQuestion)
            return {
                type: "linkvalue"
            };
        var json = setQuestion.toJSON();
        json.type = setQuestion.getType();
        _survey_helper__WEBPACK_IMPORTED_MODULE_5__.SurveyHelper.updateQuestionJson(json);
        return json;
    };
    return PropertyGridTriggerValueInLogicEditor;
}(PropertyGridTriggerValueEditor));

_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditorCollection.register(new PropertyGridCellsEditor());
_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditorCollection.register(new PropertyGridValueEditor());
_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditorCollection.register(new PropertyGridRowValueEditor());
_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditorCollection.register(new PropertyGridPanelValueEditor());
_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditorCollection.register(new PropertyGridTriggerValueEditor());
_index__WEBPACK_IMPORTED_MODULE_2__.PropertyGridEditorCollection.register(new PropertyGridTriggerValueInLogicEditor());


/***/ }),

/***/ "./src/question-editor/definition.ts":
/*!*******************************************!*\
  !*** ./src/question-editor/definition.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SurveyQuestionEditorDefinition: () => (/* binding */ SurveyQuestionEditorDefinition),
/* harmony export */   defaultPropertyGridDefinition: () => (/* binding */ defaultPropertyGridDefinition)
/* harmony export */ });
var defaultProperties = {
    question: {
        properties: [
            "name",
            "title",
            "description",
            "visible",
            "readOnly",
            "isRequired",
            "showCommentArea",
            "commentText",
            "commentPlaceholder",
            { name: "visibleIf", tab: "logic" },
            { name: "enableIf", tab: "logic" },
            { name: "requiredIf", tab: "logic" },
            { name: "bindings", tab: "logic" },
            { name: "defaultValueExpression", tab: "logic" },
            { name: "resetValueIf", tab: "logic" },
            { name: "setValueIf", tab: "logic" },
            { name: "setValueExpression", tab: "logic" },
            { name: "page", tab: "layout" },
            { name: "startWithNewLine", tab: "layout" },
            { name: "hideNumber", tab: "layout" },
            { name: "state", tab: "layout" },
            { name: "titleLocation", tab: "layout" },
            { name: "descriptionLocation", tab: "layout" },
            { name: "errorLocation", tab: "layout" },
            { name: "indent", tab: "layout" },
            {
                name: "width",
                tab: "layout",
            },
            {
                name: "minWidth",
                tab: "layout",
            },
            {
                name: "maxWidth",
                tab: "layout",
            },
            { name: "effectiveColSpan", tab: "layout" },
            { name: "valueName", tab: "data" },
            { name: "defaultValue", tab: "data" },
            { name: "correctAnswer", tab: "data" },
            { name: "useDisplayValuesInDynamicTexts", tab: "data" },
            { name: "clearIfInvisible", tab: "data" },
            { name: "validators", tab: "validation" },
            { name: "requiredErrorText", tab: "validation" }
        ],
        tabs: [
            { name: "layout", index: 100 },
            { name: "logic", index: 200 },
            { name: "data", index: 300 },
            { name: "validation", index: 400 }
        ]
    },
    comment: {
        properties: [
            { name: "rows", tab: "layout" },
            { name: "cols", tab: "layout" },
            "placeholder",
            { name: "maxLength", tab: "validation" },
            { name: "textUpdateMode", tab: "data" },
            { name: "autoGrow", tab: "layout" },
            { name: "allowResize", tab: "layout" },
        ]
    },
    file: {
        properties: [
            "sourceType",
            "visible",
            "readOnly",
            "isRequired",
            "showCommentArea",
            "allowMultiple",
            { name: "showPreview" },
            "allowImagesPreview",
            "waitForUpload",
            "needConfirmRemoveFile",
            { name: "storeDataAsText" },
            "allowCameraAccess",
            "acceptedTypes",
            "maxSize",
            "imageHeight",
            "imageWidth",
            "filePlaceholder",
            "photoPlaceholder",
            "fileOrPhotoPlaceholder"
        ]
    },
    signaturepad: {
        properties: [
            "dataFormat",
            "signatureWidth",
            "signatureHeight",
            "signatureAutoScaleEnabled",
            "showPlaceholder",
            "placeholder",
            "placeholderReadOnly",
            "allowClear",
            "backgroundImage",
            "backgroundColor",
            "penMinWidth",
            "penMaxWidth",
            "penColor",
            "waitForUpload",
            { name: "storeDataAsText" },
        ]
    },
    html: {
        properties: ["html"]
    },
    matrixdropdownbase: {
        properties: [
            "cellType",
            "optionsCaption",
            "detailPanelMode",
            "detailPanelShowOnAdding",
            { name: "showHeader", tab: "layout" },
            { name: "showColumnHeader", tab: "layout" },
            { name: "verticalAlign", tab: "layout" },
            { name: "alternateRows", tab: "layout" },
            { name: "columnsVisibleIf", tab: "logic" },
            { name: "rowsVisibleIf", tab: "logic" },
            { name: "columnLayout", tab: "layout" },
            { name: "transposeData", tab: "layout" },
            { name: "horizontalScroll", tab: "layout" },
            { name: "columnColCount", tab: "layout" },
            { name: "columnMinWidth", tab: "layout" },
            { name: "cellErrorLocation", tab: "layout" },
            { name: "detailErrorLocation", tab: "layout" }
        ],
        tabs: [
            { name: "columns", index: 10 },
            { name: "rows", index: 11 },
            { name: "choices", index: 12 }
        ]
    },
    matrixdynamic: {
        properties: [
            "allowAddRows",
            "allowRemoveRows",
            "allowRowsDragAndDrop",
            "rowCount",
            "minRowCount",
            "maxRowCount",
            "addRowLocation",
            "addRowText",
            "removeRowText",
            "confirmDelete",
            "confirmDeleteText",
            "placeholder",
            { name: "hideColumnsIfEmpty", tab: "columns" },
            { name: "emptyRowsText", tab: "columns" },
            { name: "defaultRowValue", tab: "data" },
            { name: "defaultValueFromLastRow", tab: "data" },
            { name: "keyName", tab: "validation" },
            { name: "keyDuplicationError", tab: "validation" }
        ]
    },
    matrixdropdown: {
        properties: [
            "totalText",
            "placeholder",
            { name: "hideIfRowsEmpty", tab: "rows" },
            { name: "rowTitleWidth", tab: "layout" },
            { name: "keyDuplicationError", tab: "validation" }
        ]
    },
    matrix: {
        properties: [
            { name: "isAllRowRequired", tab: "validation" },
            { name: "eachRowUnique", tab: "validation" },
            { name: "showHeader", tab: "layout" },
            { name: "showColumnHeader", tab: "layout" },
            { name: "verticalAlign", tab: "layout" },
            { name: "alternateRows", tab: "layout" },
            { name: "rowsOrder", tab: "rows" },
            { name: "hideIfRowsEmpty", tab: "rows" },
            { name: "columnsVisibleIf", tab: "logic" },
            { name: "rowsVisibleIf", tab: "logic" },
            { name: "columnMinWidth", tab: "layout" },
            { name: "rowTitleWidth", tab: "layout" }
        ],
        tabs: [
            { name: "columns", index: 10 },
            { name: "rows", index: 11 },
            { name: "cells", index: 500 }
        ]
    },
    multipletext: {
        properties: [
            { name: "colCount", tab: "layout" },
            { name: "itemSize", tab: "layout" },
            { name: "itemErrorLocation", tab: "layout" }
        ],
        tabs: [{ name: "items", index: 10 }]
    },
    rating: {
        properties: [
            { name: "displayMode", tab: "rateValues" },
            { name: "rateCount", tab: "rateValues" },
            { name: "rateMin", tab: "rateValues" },
            { name: "rateMax", tab: "rateValues" },
            { name: "rateStep", tab: "rateValues" },
            { name: "minRateDescription", tab: "rateValues" },
            { name: "maxRateDescription", tab: "rateValues" },
            { name: "rateDescriptionLocation", tab: "rateValues" },
            { name: "displayRateDescriptionsAsExtremeItems", tab: "rateValues" },
        ],
        tabs: [{ name: "rateValues", index: 10 }]
    },
    selectbase: {
        properties: [
            { name: "choicesFromQuestion", tab: "choices" },
            { name: "choicesFromQuestionMode", tab: "choices" },
            { name: "choiceValuesFromQuestion", tab: "choices" },
            { name: "choiceTextsFromQuestion", tab: "choices" },
            { name: "choicesOrder", tab: "choices" },
            { name: "colCount", tab: "layout" },
            { name: "textWrapEnabled", tab: "choices" },
            { name: "showOtherItem", tab: "choices" },
            { name: "otherText", tab: "choices" },
            { name: "otherPlaceholder", tab: "choices" },
            { name: "showNoneItem", tab: "choices" },
            { name: "noneText", tab: "choices" },
            { name: "showRefuseItem", tab: "choices" },
            { name: "refuseText", tab: "choices" },
            { name: "showDontKnowItem", tab: "choices" },
            { name: "dontKnowText", tab: "choices" },
            { name: "hideIfChoicesEmpty", tab: "logic" },
            { name: "choicesVisibleIf", tab: "logic" },
            { name: "choicesEnableIf", tab: "logic" },
            { name: "otherErrorText", tab: "validation" },
            { name: "separateSpecialChoices", tab: "choices" },
        ],
        tabs: [
            { name: "choices", index: 10 },
            { name: "choicesByUrl", index: 11 }
        ]
    },
    checkbox: {
        properties: [
            { name: "showSelectAllItem", tab: "choices" },
            { name: "selectAllText", tab: "choices" },
            { name: "minSelectedChoices", tab: "choices" },
            { name: "maxSelectedChoices", tab: "choices" },
            { name: "separateSpecialChoices", tab: "choices" },
        ]
    },
    ranking: {
        properties: [
            { name: "selectToRankEnabled" },
            { name: "selectToRankAreasLayout" },
            { name: "minSelectedChoices", tab: "choices" },
            { name: "maxSelectedChoices", tab: "choices" }
        ]
    },
    radiogroup: {
        properties: [
            { name: "showClearButton", tab: "choices" },
            { name: "separateSpecialChoices", tab: "choices" },
        ]
    },
    dropdown: {
        properties: [
            "placeholder",
            "autocomplete",
            { name: "choicesMin", tab: "choices" },
            { name: "choicesMax", tab: "choices" },
            { name: "choicesStep", tab: "choices" },
            { name: "allowClear", tab: "choices" },
            { name: "searchMode", tab: "choices" },
        ]
    },
    tagbox: {
        properties: [
            "closeOnSelect",
            "placeholder",
            { name: "searchEnabled", tab: "choices" },
            { name: "searchMode", tab: "choices" },
            { name: "hideSelectedItems", tab: "choices" },
            { name: "allowClear", tab: "choices" },
        ]
    },
    imagepicker: {
        properties: [
            "contentMode",
            "imageFit",
            "isResponsive",
            "minImageWidth",
            "maxImageWidth",
            "minImageHeight",
            "maxImageHeight",
            "imageHeight",
            "imageWidth",
            "multiSelect",
            "showLabel",
        ]
    },
    image: {
        properties: [
            "imageLink",
            "contentMode",
            "imageFit",
            "imageHeight",
            "imageWidth",
            "text"
        ]
    },
    "itemvalue[]@choices": {
        properties: [{ name: "visibleIf" }, { name: "enableIf" }],
        tabs: [{ name: "general" }]
    },
    "itemvalue[]@rows": {
        properties: [{ name: "visibleIf" }, { name: "enableIf" }],
        tabs: [{ name: "general" }]
    },
    "itemvalue[]@columns": {
        properties: [{ name: "visibleIf" }, { name: "enableIf" }],
        tabs: [{ name: "general" }]
    },
    text: {
        properties: [
            "inputType",
            "min",
            "max",
            "step",
            "placeholder",
            "autocomplete",
            "dataList",
            { name: "minValueExpression", tab: "logic" },
            { name: "maxValueExpression", tab: "logic" },
            { name: "size", tab: "layout" },
            { name: "inputTextAlignment", tab: "layout" },
            { name: "maxLength", tab: "validation" },
            { name: "minErrorText", tab: "validation" },
            { name: "maxErrorText", tab: "validation" },
            { name: "textUpdateMode", tab: "data" },
            { name: "maskType", tab: "mask" },
            { name: "maskSettings", tab: "mask" },
        ],
        tabs: [
            { name: "mask", index: 250 }
        ]
    },
    boolean: {
        properties: [
            "label",
            "labelTrue",
            "labelFalse",
            "showTitle",
            { name: "valueTrue", tab: "data" },
            { name: "valueFalse", tab: "data" }
        ]
    },
    expression: {
        properties: [
            "expression",
            "displayStyle",
            "currency",
            "format",
            "maximumFractionDigits",
            "minimumFractionDigits",
            "useGrouping"
        ]
    },
    "panellayoutcolumn": {
        properties: ["effectiveWidth", "questionTitleWidth"]
    },
    matrixdropdowncolumn: {
        properties: ["name", "title"]
    },
    "matrixdropdowncolumn@default": {
        properties: [
            "name",
            "title",
            "cellType",
            "visible",
            "readOnly",
            "isRequired",
            "isUnique",
            "showInMultipleColumns",
            "width",
            "minWidth",
            { name: "visibleIf", tab: "logic" },
            { name: "enableIf", tab: "logic" },
            { name: "requiredIf", tab: "logic" },
            { name: "defaultValueExpression", tab: "logic" },
            { name: "resetValueIf", tab: "logic" },
            { name: "setValueIf", tab: "logic" },
            { name: "setValueExpression", tab: "logic" },
            { name: "totalType", tab: "totals" },
            { name: "totalDisplayStyle", tab: "totals" },
            { name: "totalCurrency", tab: "totals" },
            { name: "totalFormat", tab: "totals" },
            { name: "totalExpression", tab: "totals" },
            { name: "validators", tab: "validation" },
            { name: "requiredErrorText", tab: "validation" }
        ],
        tabs: [
            { name: "general", index: 5 },
            { name: "logic", index: 20 },
            { name: "totals", index: 40 },
            { name: "validation", index: 60 }
        ]
    },
    "matrixdropdowncolumn@checkbox": {
        properties: [
            { name: "choicesFromQuestion", tab: "choices" },
            { name: "choicesFromQuestionMode", tab: "choices" },
            { name: "choiceValuesFromQuestion", tab: "choices" },
            { name: "choiceTextsFromQuestion", tab: "choices" },
            { name: "showOtherItem", tab: "choices" },
            { name: "otherText", tab: "choices" },
            { name: "otherPlaceholder", tab: "choices" },
            { name: "choicesOrder", tab: "choices" },
            { name: "colCount", tab: "choices" },
            { name: "showSelectAllItem", tab: "choices" },
            { name: "showNoneItem", tab: "choices" },
            { name: "noneText", tab: "choices" },
            { name: "showRefuseItem", tab: "choices" },
            { name: "refuseText", tab: "choices" },
            { name: "showDontKnowItem", tab: "choices" },
            { name: "dontKnowText", tab: "choices" },
            { name: "minSelectedChoices", tab: "choices" },
            { name: "maxSelectedChoices", tab: "choices" },
            { name: "selectAllText", tab: "choices" },
            { name: "choicesVisibleIf", tab: "logic" },
            { name: "choicesEnableIf", tab: "logic" },
        ],
        tabs: [
            { name: "choices", index: 10 },
            { name: "choicesByUrl", index: 11 }
        ]
    },
    "matrixdropdowncolumn@radiogroup": {
        properties: [
            { name: "choicesFromQuestion", tab: "choices" },
            { name: "choicesFromQuestionMode", tab: "choices" },
            { name: "choiceValuesFromQuestion", tab: "choices" },
            { name: "choiceTextsFromQuestion", tab: "choices" },
            { name: "showOtherItem", tab: "choices" },
            { name: "otherText", tab: "choices" },
            { name: "otherPlaceholder", tab: "choices" },
            { name: "choicesOrder", tab: "choices" },
            { name: "colCount", tab: "choices" },
            { name: "showNoneItem", tab: "choices" },
            { name: "noneText", tab: "choices" },
            { name: "showRefuseItem", tab: "choices" },
            { name: "refuseText", tab: "choices" },
            { name: "showDontKnowItem", tab: "choices" },
            { name: "dontKnowText", tab: "choices" },
            { name: "choicesVisibleIf", tab: "logic" },
            { name: "choicesEnableIf", tab: "logic" },
        ],
        tabs: [
            { name: "choices", index: 10 },
            { name: "choicesByUrl", index: 11 }
        ]
    },
    "matrixdropdowncolumn@dropdown": {
        properties: [
            "placeholder",
            { name: "choicesFromQuestion", tab: "choices" },
            { name: "choicesFromQuestionMode", tab: "choices" },
            { name: "choiceValuesFromQuestion", tab: "choices" },
            { name: "choiceTextsFromQuestion", tab: "choices" },
            { name: "showOtherItem", tab: "choices" },
            { name: "otherText", tab: "choices" },
            { name: "otherPlaceholder", tab: "choices" },
            { name: "choicesOrder", tab: "choices" },
            { name: "optionsCaption", tab: "choices" },
            { name: "showNoneItem", tab: "choices" },
            { name: "noneText", tab: "choices" },
            { name: "showRefuseItem", tab: "choices" },
            { name: "refuseText", tab: "choices" },
            { name: "showDontKnowItem", tab: "choices" },
            { name: "dontKnowText", tab: "choices" },
            { name: "choicesMin", tab: "choices" },
            { name: "choicesMax", tab: "choices" },
            { name: "choicesStep", tab: "choices" },
            { name: "allowClear", tab: "choices" },
            { name: "choicesVisibleIf", tab: "logic" },
            { name: "choicesEnableIf", tab: "logic" },
        ],
        tabs: [
            { name: "choices", index: 10 },
            { name: "choicesByUrl", index: 11 }
        ]
    },
    "matrixdropdowncolumn@tagbox": {
        properties: [
            "placeholder",
            { name: "choicesFromQuestion", tab: "choices" },
            { name: "choicesFromQuestionMode", tab: "choices" },
            { name: "choiceValuesFromQuestion", tab: "choices" },
            { name: "choiceTextsFromQuestion", tab: "choices" },
            { name: "showOtherItem", tab: "choices" },
            { name: "otherText", tab: "choices" },
            { name: "otherPlaceholder", tab: "choices" },
            { name: "choicesOrder", tab: "choices" },
            { name: "optionsCaption", tab: "choices" },
            { name: "showNoneItem", tab: "choices" },
            { name: "noneText", tab: "choices" },
            { name: "showRefuseItem", tab: "choices" },
            { name: "refuseText", tab: "choices" },
            { name: "showDontKnowItem", tab: "choices" },
            { name: "dontKnowText", tab: "choices" },
            { name: "choicesMin", tab: "choices" },
            { name: "choicesMax", tab: "choices" },
            { name: "choicesStep", tab: "choices" },
            { name: "allowClear", tab: "choices" },
            { name: "choicesVisibleIf", tab: "logic" },
            { name: "choicesEnableIf", tab: "logic" },
        ],
        tabs: [
            { name: "choices", index: 10 },
            { name: "choicesByUrl", index: 11 }
        ]
    },
    "matrixdropdowncolumn@text": {
        properties: [
            "inputType",
            "min",
            "max",
            "step",
            "placeholder",
            "dataList",
            "maxLength",
            { name: "maskType", tab: "mask" },
            { name: "maskSettings", tab: "mask" },
        ],
        tabs: [
            { name: "mask", index: 20 },
            { name: "validators", index: 25 }
        ]
    },
    "matrixdropdowncolumn@comment": {
        properties: ["rows", "placeholder", "maxLength"],
        tabs: [{ name: "validators", index: 25 }]
    },
    "matrixdropdowncolumn@boolean": {
        properties: [
            { name: "labelTrue", tab: "data" },
            { name: "labelFalse", tab: "data" },
            { name: "valueTrue", tab: "data" },
            { name: "valueFalse", tab: "data" },
            { name: "defaultValue", tab: "data" }
        ],
        tabs: [{ name: "data", index: 25 }]
    },
    "matrixdropdowncolumn@expression": {
        properties: [
            "expression",
            "displayStyle",
            "currency"
        ]
    },
    "matrixdropdowncolumn@rating": {
        properties: [
            { name: "displayMode", tab: "rateValues" },
            { name: "rateType", tab: "rateValues" },
            { name: "rateCount", tab: "rateValues" },
            { name: "rateColorMode", tab: "rateValues" },
            { name: "scaleColorMode", tab: "rateValues" },
            { name: "autoGenerate", tab: "rateValues" },
            { name: "rateMin", tab: "rateValues" },
            { name: "rateMax", tab: "rateValues" },
            { name: "rateStep", tab: "rateValues" },
            { name: "rateValues", tab: "rateValues" },
            { name: "minRateDescription", tab: "rateValues" },
            { name: "maxRateDescription", tab: "rateValues" },
            { name: "rateDescriptionLocation", tab: "rateValues" },
            { name: "displayRateDescriptionsAsExtremeItems", tab: "rateValues" },
        ],
        tabs: [{ name: "rateValues", index: 5 }]
    },
    multipletextitem: {
        properties: [
            "name",
            "title",
            "inputType",
            "isRequired",
            "size",
            "placeholder",
            "inputTextAlignment",
            { name: "maxLength", tab: "validation" },
            { name: "requiredErrorText", tab: "validation" },
            { name: "validators", tab: "validation" },
            { name: "defaultValueExpression", tab: "logic" },
            { name: "minValueExpression", tab: "logic" },
            { name: "maxValueExpression", tab: "logic" },
            { name: "maskType", tab: "mask" },
            { name: "maskSettings", tab: "mask" },
        ],
        tabs: [
            { name: "logic", index: 200 },
            { name: "mask", index: 250 },
            { name: "validation", index: 300 }
        ]
    },
    "multipletext@items": {
        properties: ["name", "title"]
    },
    calculatedvalue: {
        properties: ["name", "expression", "includeIntoResult"]
    },
    "calculatedvalue@items": {
        properties: ["name", "expression"]
    },
    paneldynamic: {
        properties: [
            "renderMode",
            "displayMode",
            "templateTabTitle",
            "tabTitlePlaceholder",
            "tabAlign",
            "panelCount",
            "minPanelCount",
            "maxPanelCount",
            "panelsState",
            { name: "allowAddPanel" },
            { name: "allowRemovePanel" },
            "panelAddText",
            "panelRemoveText",
            "templateTitle",
            "templateDescription",
            "noEntriesText",
            "confirmDelete",
            "confirmDeleteText",
            "panelPrevText",
            "panelNextText",
            "showQuestionNumbers",
            "showRangeInProgress",
            "showProgressBar",
            "progressBarLocation",
            { name: "defaultPanelValue", tab: "data" },
            { name: "defaultValueFromLastPanel", tab: "data" },
            { name: "templateTitleLocation", tab: "questionSettings" },
            { name: "templateErrorLocation", tab: "questionSettings" },
            { name: "panelRemoveButtonLocation", tab: "layout" },
            { name: "keyName", tab: "validation" },
            { name: "keyDuplicationError", tab: "validation" }
        ]
    },
    panelbase: {
        properties: [
            "name",
            "title",
            "description",
            "visible",
            "readOnly",
            { name: "visibleIf", tab: "logic" },
            { name: "enableIf", tab: "logic" },
            { name: "requiredIf", tab: "logic" },
            { name: "questionTitleLocation", tab: "questionSettings" },
            { name: "questionTitleWidth", tab: "questionSettings" },
            { name: "questionErrorLocation", tab: "questionSettings" },
            { name: "layoutColumns", tab: "questionSettings" },
        ],
        tabs: [
            { name: "questionSettings", index: 100 },
            { name: "logic", index: 200 },
            { name: "data", index: 300 },
            { name: "validation", index: 400 }
        ]
    },
    panel: {
        properties: [
            "isRequired",
            { name: "questionsOrder", tab: "questionSettings" },
            { name: "innerIndent", tab: "questionSettings" },
            { name: "requiredErrorText", tab: "validation" },
            { name: "page", tab: "layout" },
            { name: "startWithNewLine", tab: "layout" },
            { name: "state", tab: "layout" },
            { name: "width", tab: "layout" },
            { name: "minWidth", tab: "layout" },
            { name: "maxWidth", tab: "layout" },
            { name: "effectiveColSpan", tab: "layout" },
            { name: "showNumber", tab: "numbering" },
            { name: "showQuestionNumbers", tab: "numbering" },
            { name: "questionStartIndex", tab: "numbering" }
        ],
        tabs: [
            { name: "layout", index: 150 },
            { name: "numbering", index: 350 }
        ]
    },
    page: {
        properties: [
            "navigationTitle",
            "navigationDescription",
            "timeLimit",
            "maxTimeToFinish",
            { name: "questionsOrder", tab: "questionSettings" },
            { name: "navigationButtonsVisibility", tab: "navigation" }
        ],
        tabs: [{ name: "navigation", index: 350 }]
    },
    survey: {
        properties: [
            "title",
            "description",
            "showTitle",
            "locale",
            "mode",
            "cookieName",
            "widthMode",
            "width",
            "fitToContainer",
            { name: "questionsOnPageMode", tab: "navigation" },
            { name: "firstPageIsStarted", tab: "navigation" },
            { name: "goNextPageAutomatic", tab: "navigation" },
            { name: "allowCompleteSurveyAutomatic", tab: "navigation" },
            { name: "showNavigationButtons", tab: "navigation" },
            { name: "showPrevButton", tab: "navigation" },
            { name: "showProgressBar", tab: "navigation" },
            { name: "progressBarType", tab: "navigation" },
            { name: "progressBarShowPageTitles", tab: "navigation" },
            { name: "progressBarShowPageNumbers", tab: "navigation" },
            { name: "showTOC", tab: "navigation" },
            { name: "tocLocation", tab: "navigation" },
            { name: "showPreviewBeforeComplete", tab: "navigation" },
            { name: "previewText", tab: "navigation" },
            { name: "editText", tab: "navigation" },
            { name: "startSurveyText", tab: "navigation" },
            { name: "pagePrevText", tab: "navigation" },
            { name: "pageNextText", tab: "navigation" },
            { name: "completeText", tab: "navigation" },
            { name: "questionsOrder", tab: "question" },
            { name: "questionTitleLocation", tab: "question" },
            { name: "questionDescriptionLocation", tab: "question" },
            { name: "showQuestionNumbers", tab: "question" },
            { name: "questionTitlePattern", tab: "question" },
            { name: "requiredText", tab: "question" },
            { name: "questionStartIndex", tab: "question" },
            { name: "questionErrorLocation", tab: "question" },
            {
                name: "focusFirstQuestionAutomatic",
                tab: "question"
            },
            { name: "maxTextLength", tab: "question" },
            { name: "maxOthersLength", tab: "question" },
            { name: "commentAreaRows", tab: "question" },
            { name: "autoGrowComment", tab: "question" },
            { name: "allowResizeComment", tab: "question" },
            { name: "gridLayoutEnabled", tab: "question" },
            { name: "showPageTitles", tab: "pages" },
            { name: "showPageNumbers", tab: "pages" },
            { name: "calculatedValues", tab: "logic" },
            { name: "triggers", tab: "logic" },
            { name: "clearInvisibleValues", tab: "data" },
            { name: "textUpdateMode", tab: "data" },
            { name: "sendResultOnPageNext", tab: "data" },
            { name: "storeOthersAsComment", tab: "data" },
            { name: "focusOnFirstError", tab: "validation" },
            { name: "checkErrorsMode", tab: "validation" },
            { name: "validateVisitedEmptyFields", tab: "validation" },
            { name: "navigateToUrl", tab: "showOnCompleted" },
            { name: "navigateToUrlOnCondition", tab: "showOnCompleted" },
            { name: "showCompletedPage", tab: "showOnCompleted" },
            { name: "completedHtml", tab: "showOnCompleted" },
            { name: "completedHtmlOnCondition", tab: "showOnCompleted" },
            { name: "loadingHtml", tab: "showOnCompleted" },
            { name: "completedBeforeHtml", tab: "showOnCompleted" },
            { name: "showTimer", tab: "timer" },
            { name: "timerLocation", tab: "timer" },
            { name: "timeLimit", tab: "timer" },
            { name: "timeLimitPerPage", tab: "timer" },
            { name: "timerInfoMode", tab: "timer" },
            { name: "maxTimeToFinish", tab: "timer" },
            { name: "maxTimeToFinishPage", tab: "timer" },
            { name: "showTimerPanel", tab: "timer" },
            { name: "showTimerPanelMode", tab: "timer" },
            { name: "logo", tab: "logo" },
            { name: "logoPosition", tab: "logo" },
            { name: "logoWidth", tab: "logo" },
            { name: "logoHeight", tab: "logo" },
            { name: "logoFit", tab: "logo" }
        ],
        tabs: [
            { name: "logo", index: 50 },
            { name: "navigation", index: 100 },
            { name: "question", index: 200 },
            { name: "pages", index: 250 },
            { name: "logic", index: 300 },
            { name: "data", index: 400 },
            { name: "validation", index: 500 },
            { name: "showOnCompleted", index: 600 },
            { name: "timer", index: 700 }
        ]
    },
    "page@survey": {
        properties: ["name", "title"]
    },
    choicesByUrl: {
        properties: [
            "url",
            "path",
            "valueName",
            "titleName",
            "allowEmptyResponse"
        ]
    },
    "patternmask@maskSettings": {
        properties: [
            "pattern",
            "saveMaskedValue",
        ]
    },
    "datetimemask@maskSettings": {
        properties: [
            "pattern",
            "min",
            "max",
            "saveMaskedValue",
        ]
    },
    "numericmask@maskSettings": {
        properties: [
            "min",
            "max",
            "precision",
            "decimalSeparator",
            "thousandsSeparator",
            "allowNegativeValues",
            "saveMaskedValue",
        ]
    },
    "currencymask@maskSettings": {
        properties: [
            "prefix",
            "suffix",
            "min",
            "max",
            "precision",
            "decimalSeparator",
            "thousandsSeparator",
            "allowNegativeValues",
            "saveMaskedValue",
        ]
    },
    "patternmask": {
        properties: ["pattern"]
    },
    "datetimemask": {
        properties: ["pattern"]
    },
    "currencymask": {
        properties: ["prefix", "suffix"]
    }
};
var defaultPropertyGridDefinition = {
    autoGenerateProperties: true,
    classes: defaultProperties
};
var SurveyQuestionEditorDefinition = /** @class */ (function () {
    function SurveyQuestionEditorDefinition() {
    }
    SurveyQuestionEditorDefinition.definition = defaultProperties;
    return SurveyQuestionEditorDefinition;
}());



/***/ }),

/***/ "./src/question-editor/properties.ts":
/*!*******************************************!*\
  !*** ./src/question-editor/properties.ts ***!
  \*******************************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SurveyQuestionEditorPropertyDefinition: () => (/* binding */ SurveyQuestionEditorPropertyDefinition),
/* harmony export */   SurveyQuestionEditorTabDefinition: () => (/* binding */ SurveyQuestionEditorTabDefinition),
/* harmony export */   SurveyQuestionProperties: () => (/* binding */ SurveyQuestionProperties)
/* harmony export */ });
/* harmony import */ var _definition__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./definition */ "./src/question-editor/definition.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../creator-settings */ "./src/creator-settings.ts");




var SurveyQuestionEditorPropertyDefinition = /** @class */ (function () {
    function SurveyQuestionEditorPropertyDefinition() {
    }
    Object.defineProperty(SurveyQuestionEditorPropertyDefinition.prototype, "name", {
        get: function () {
            return !!this.property ? this.property.name : "";
        },
        enumerable: false,
        configurable: true
    });
    return SurveyQuestionEditorPropertyDefinition;
}());

var SurveyQuestionEditorTabDefinition = /** @class */ (function () {
    function SurveyQuestionEditorTabDefinition() {
        this.visible = true;
        this.index = 0;
        this.properties = [];
    }
    return SurveyQuestionEditorTabDefinition;
}());

var otherTabName = "others";
var SurveyQuestionProperties = /** @class */ (function () {
    function SurveyQuestionProperties(obj, options, className, showMode, parentObj, parentProperty, propertyGridDefinition) {
        if (options === void 0) { options = null; }
        if (className === void 0) { className = null; }
        if (showMode === void 0) { showMode = null; }
        if (parentObj === void 0) { parentObj = null; }
        if (parentProperty === void 0) { parentProperty = null; }
        if (propertyGridDefinition === void 0) { propertyGridDefinition = null; }
        this.obj = obj;
        this.options = options;
        this.parentObj = parentObj;
        this.parentProperty = parentProperty;
        this.propertyGridDefinition = propertyGridDefinition;
        this.tabs = [];
        this.unusedProperties = [];
        if (!this.propertyGridDefinition) {
            this.propertyGridDefinition = _definition__WEBPACK_IMPORTED_MODULE_0__.defaultPropertyGridDefinition;
        }
        this.showModeValue = showMode;
        this.properties = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.getPropertiesByObj(this.obj);
        this.fillPropertiesHash();
        this.buildTabs(className);
    }
    SurveyQuestionProperties.prototype.getAllVisiblePropertiesNames = function (includeUnused) {
        var res = [];
        this.tabs.forEach(function (tab) {
            tab.properties.forEach(function (prop) { return res.push(prop.name); });
        });
        if (includeUnused) {
            this.unusedProperties.forEach(function (prop) { return res.push(prop.name); });
        }
        return res;
    };
    SurveyQuestionProperties.prototype.getIsPropertyVisible = function (prop) {
        return _survey_helper__WEBPACK_IMPORTED_MODULE_2__.SurveyHelper.isPropertyVisible(this.obj, prop, this.options, this.showMode, this.parentObj, this.parentProperty);
    };
    SurveyQuestionProperties.prototype.getDynamicClassName = function () {
        return !!this.obj && this.obj.isQuestion && !!this.obj.getDynamicType ? this.obj.getDynamicType() : "";
    };
    SurveyQuestionProperties.prototype.getProperty = function (propertyName) {
        var res = this.propertiesHash[propertyName];
        return !!res && res.visible ? res.property : null;
    };
    SurveyQuestionProperties.prototype.getPropertyAsCategory = function (propertyName) {
        var prop = this.getProperty(propertyName);
        return prop && (!prop.category || prop.category === propertyName) ? prop : null;
    };
    Object.defineProperty(SurveyQuestionProperties.prototype, "showMode", {
        get: function () {
            return !!this.showModeValue ? this.showModeValue : "form";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyQuestionProperties.prototype, "isEmpty", {
        get: function () {
            for (var i = 0; i < this.tabs.length; i++) {
                if (this.tabs[i].visible && this.tabs[i].properties.length > 0)
                    return false;
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionProperties.prototype.getClassDefintion = function (name) {
        if (!this.propertyGridDefinition || !this.propertyGridDefinition.classes)
            return undefined;
        return this.propertyGridDefinition.classes[name];
    };
    SurveyQuestionProperties.prototype.fillPropertiesHash = function () {
        this.propertiesHash = {};
        for (var i = 0; i < this.properties.length; i++) {
            var prop = this.properties[i];
            this.propertiesHash[prop.name] = {
                property: prop,
                visible: this.getIsPropertyVisible(prop),
            };
        }
    };
    SurveyQuestionProperties.prototype.isJSONPropertyVisible = function (property) {
        var res = this.propertiesHash[property.name];
        return !!res && res.visible;
    };
    SurveyQuestionProperties.prototype.getTabByName = function (tabName) {
        for (var i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].name == tabName)
                return this.tabs[i];
        }
        return null;
    };
    SurveyQuestionProperties.prototype.getTabs = function () {
        return this.tabs;
    };
    SurveyQuestionProperties.prototype.getProperties = function (tab) {
        var res = [];
        for (var i = 0; i < tab.properties.length; i++) {
            res.push(tab.properties[i].property);
        }
        return res;
    };
    SurveyQuestionProperties.prototype.buildTabs = function (className) {
        if (!className && !!this.obj) {
            className = this.obj.getType();
        }
        var definitions = this.getAllDefinitionsByClass(className);
        var addedProperties = [];
        for (var i = definitions.length - 1; i >= 0; i--) {
            var defItem = definitions[i];
            for (var j = !!defItem.tabs ? defItem.tabs.length - 1 : -1; j >= 0; j--) {
                var defTab = defItem.tabs[j];
                if (addedProperties.indexOf(defTab.name) > -1) {
                    this.setTabProperties(defTab);
                }
                else {
                    if (this.addPropertyIntoTab(defTab, true)) {
                        addedProperties.push(defTab.name);
                    }
                }
            }
            for (var j = !!defItem.properties ? defItem.properties.length - 1 : -1; j >= 0; j--) {
                var propertyName = defItem.properties[j]["name"] || defItem.properties[j];
                if (addedProperties.indexOf(propertyName) === -1) {
                    addedProperties.push(propertyName);
                    this.addPropertyIntoTab(defItem.properties[j]);
                }
            }
        }
        for (var i = this.tabs.length - 1; i >= 0; i--) {
            this.movePropertiesToNextProperties(this.tabs[i].properties);
            if (!this.tabs[i].visible) {
                this.tabs.splice(i, 1);
            }
            else {
                this.sortProperties(this.tabs[i].properties);
            }
        }
        this.tabs.sort(function (a, b) {
            return a.index < b.index ? -1 : a.index > b.index ? 1 : 0;
        });
        this.setParentTabs();
        this.tabs.forEach(function (tab) {
            var _a;
            (_a = tab.tabs) === null || _a === void 0 ? void 0 : _a.sort(function (a, b) { return a.index - b.index; });
        });
    };
    SurveyQuestionProperties.prototype.setParentTabs = function () {
        for (var i = this.tabs.length - 1; i >= 0; i--) {
            var tab = this.tabs[i];
            if (tab.parentName) {
                var parent_1 = this.getTabByName(tab.parentName);
                if (parent_1) {
                    tab.parent = parent_1;
                    if (!Array.isArray(parent_1.tabs)) {
                        parent_1.tabs = [];
                    }
                    parent_1.tabs.push(tab);
                    this.tabs.splice(i, 1);
                }
            }
        }
    };
    SurveyQuestionProperties.prototype.addPropertyIntoTab = function (defProperty, isTab) {
        if (isTab === void 0) { isTab = false; }
        if (isTab) {
            this.setTabProperties(defProperty);
        }
        var isString = typeof defProperty == "string";
        var name = !isString ? defProperty.name : defProperty;
        var propRes = this.propertiesHash[name];
        if (!propRes || isTab && !this.getPropertyAsCategory(name))
            return false;
        if (!isString && defProperty.visible === false)
            return false;
        if (!propRes.visible &&
            (isString || (!isString && defProperty.visible !== true)))
            return false;
        var tabName = isTab ? defProperty.name : _creator_settings__WEBPACK_IMPORTED_MODULE_3__.settings.propertyGrid.generalTabName;
        if (!isTab && !isString && !!defProperty.tab) {
            tabName = defProperty.tab;
        }
        var propertyDefinition = new SurveyQuestionEditorPropertyDefinition();
        propertyDefinition.property = propRes.property;
        propertyDefinition.category =
            !isString && !!defProperty.category ? defProperty.category : "";
        propertyDefinition.title =
            !isString && !!defProperty.title ? defProperty.title : "";
        if (!isTab && defProperty.index !== undefined) {
            propertyDefinition.definedIndex = defProperty.index;
        }
        propertyDefinition.onSameLine = this.isPropertyOnSameLine(propRes.property.nextToProperty);
        propertyDefinition.createdFromTabName = isTab;
        var tab = this.getTabOrCreate(tabName);
        tab.properties.unshift(propertyDefinition);
        return true;
    };
    SurveyQuestionProperties.prototype.setTabProperties = function (defProperty) {
        var tab = this.getTabOrCreate(defProperty.name);
        if (defProperty.index > 0) {
            tab.index = defProperty.index;
        }
        tab.parentName = defProperty.parent;
        if (defProperty.visible === false) {
            tab.visible = false;
        }
        if (!!defProperty.title) {
            tab.title = defProperty.title;
        }
    };
    SurveyQuestionProperties.prototype.movePropertiesToNextProperties = function (properties) {
        var props = [].concat(properties);
        for (var i = 0; i < props.length; i++) {
            var nextToProperty = this.getNextToNameProperty(props[i].property);
            var newTab = this.getTabByPropertyName(nextToProperty);
            if (!!newTab) {
                var prop = this.getPropertyByNameInTab(newTab, nextToProperty);
                var index = newTab.properties.indexOf(prop);
                newTab.properties.splice(index + 1, 0, props[i]);
                properties.splice(properties.indexOf(props[i]), 1);
            }
        }
    };
    SurveyQuestionProperties.prototype.getTabByPropertyName = function (propName) {
        if (!propName)
            return null;
        if (this.isPropertyOnSameLine(propName))
            propName = propName.substring(1);
        for (var i = 0; i < this.tabs.length; i++) {
            if (!!this.getPropertyByNameInTab(this.tabs[i], propName))
                return this.tabs[i];
        }
        return null;
    };
    SurveyQuestionProperties.prototype.getNextToNameProperty = function (property) {
        if (!property.nextToProperty)
            return "";
        if (this.isPropertyOnSameLine(property.nextToProperty))
            return property.nextToProperty.substring(1);
        return property.nextToProperty;
    };
    SurveyQuestionProperties.prototype.isPropertyOnSameLine = function (nextToProperty) {
        return !!nextToProperty && nextToProperty[0] === "*";
    };
    SurveyQuestionProperties.prototype.getPropertyByNameInTab = function (tab, propName) {
        var props = tab.properties;
        for (var i = 0; i < props.length; i++) {
            if (props[i].name == propName)
                return props[i];
        }
        return null;
    };
    SurveyQuestionProperties.prototype.getTabOrCreate = function (tabName) {
        for (var i = 0; i < this.tabs.length; i++) {
            if (this.tabs[i].name == tabName)
                return this.tabs[i];
        }
        var res = new SurveyQuestionEditorTabDefinition();
        res.name = tabName;
        if (tabName == _creator_settings__WEBPACK_IMPORTED_MODULE_3__.settings.propertyGrid.generalTabName) {
            res.index = -1;
        }
        this.tabs.unshift(res);
        return res;
    };
    SurveyQuestionProperties.prototype.setUsedProperties = function (res, usedProperties) {
        for (var i = 0; i < res.length; i++) {
            var props = res[i].properties;
            if (!Array.isArray(props))
                continue;
            for (var j = 0; j < props.length; j++) {
                var propName = !!props[j]["name"] ? props[j]["name"] : props[j];
                usedProperties[propName] = true;
            }
        }
    };
    SurveyQuestionProperties.prototype.getAllDefinitionsByClass = function (className) {
        var _this = this;
        var result = [];
        var usedProperties = {};
        if (className.indexOf("@") > -1 && this.getClassDefintion(className)) {
            var prefix = className.substring(0, className.indexOf("@") + 1);
            var clName = className.substring(prefix.length);
            var classes = [];
            var classInfo = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findClass(clName);
            while (!!classInfo && classInfo.name !== "question") {
                classes.unshift(prefix + classInfo.name);
                classInfo = !!classInfo.parentName ? survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findClass(classInfo.parentName) : undefined;
            }
            if (classes.indexOf(className) < 0) {
                classes.unshift(className);
            }
            if (classes.indexOf(prefix + "default") < 0) {
                classes.unshift(prefix + "default");
            }
            classes.forEach(function (cl) {
                var def = _this.getClassDefintion(cl);
                if (def) {
                    result.push(def);
                }
            });
            this.setUsedProperties(result, usedProperties);
            if (this.isColumnObj) {
                this.getAllDefinitionsByClassCore(this.obj.templateQuestion.getType(), usedProperties, result, undefined, true);
            }
            this.addNonTabProperties(result, usedProperties, true);
            return result;
        }
        var hasNonTabDynamicProperties = false;
        var dynamicClass = this.getDynamicClassName();
        if (dynamicClass) {
            hasNonTabDynamicProperties = this.getAllDefinitionsByClassCore(dynamicClass, usedProperties, result, className);
        }
        var hasNonTabProperties = this.getAllDefinitionsByClassCore(className, usedProperties, result, undefined);
        if (!hasNonTabProperties || !hasNonTabDynamicProperties) {
            this.addNonTabProperties(result, usedProperties);
        }
        return result;
    };
    SurveyQuestionProperties.prototype.getAllDefinitionsByClassCore = function (className, usedProperties, result, baseClass, isColumn) {
        var res = false;
        var curClassName = className;
        while (curClassName && (!baseClass || !survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.isDescendantOf(baseClass, curClassName))) {
            var metaClass = (survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findClass(curClassName));
            if (!metaClass)
                break;
            res = this.getAllDefinitionsByClassSingleCore(metaClass.name, usedProperties, result, isColumn);
            curClassName = metaClass.parentName;
        }
        return res;
    };
    SurveyQuestionProperties.prototype.getAllDefinitionsByClassSingleCore = function (className, usedProperties, result, isColumn) {
        var classRes = this.getClassDefintion(className);
        var res = false;
        if (!classRes)
            return res;
        var columnDef = undefined;
        if (classRes.properties) {
            var i = 0;
            while (i < classRes.properties.length) {
                var prop = classRes.properties[i];
                var propName = typeof prop == "string" ? prop : prop.name;
                var tabName = _creator_settings__WEBPACK_IMPORTED_MODULE_3__.settings.propertyGrid.generalTabName;
                if (typeof prop !== "string" && !!prop.tab) {
                    tabName = prop.tab;
                }
                var jsonProp = !!this.propertiesHash[propName]
                    ? this.propertiesHash[propName].property
                    : null;
                if (!isColumn || (jsonProp === null || jsonProp === void 0 ? void 0 : jsonProp.availableInMatrixColumn)) {
                    var jsonPropertyCategory = this.getJsonPropertyCategory(jsonProp);
                    if (!!jsonPropertyCategory && jsonPropertyCategory !== tabName) {
                        classRes.properties.splice(i, 1);
                    }
                    else {
                        usedProperties[propName] = true;
                    }
                    if (isColumn) {
                        if (!columnDef) {
                            columnDef = { properties: [], tabs: [] };
                        }
                        columnDef.properties.push(prop);
                    }
                }
                i++;
            }
        }
        if (isColumn) {
            if (!!columnDef) {
                result.unshift(columnDef);
            }
            return res;
        }
        if (classRes.tabs) {
            for (var i_1 = 0; i_1 < classRes.tabs.length; i_1++) {
                var tabName = classRes.tabs[i_1].name;
                res = res || tabName === otherTabName;
                if (!!this.getPropertyAsCategory(tabName)) {
                    usedProperties[tabName] = true;
                }
            }
        }
        result.unshift(classRes);
        return res;
    };
    SurveyQuestionProperties.prototype.getJsonPropertyCategory = function (jsonProperty) {
        if (!jsonProperty)
            return null;
        if (!!jsonProperty.category)
            return jsonProperty.category;
        return null;
    };
    Object.defineProperty(SurveyQuestionProperties.prototype, "isColumnObj", {
        get: function () { return this.obj.getType() === "matrixdropdowncolumn"; },
        enumerable: false,
        configurable: true
    });
    SurveyQuestionProperties.prototype.getUnusedProperties = function (usedProperties, isFormMode) {
        if (isFormMode === void 0) { isFormMode = false; }
        var res = [];
        var isColumn = this.isColumnObj;
        for (var i = 0; i < this.properties.length; i++) {
            var prop = this.properties[i];
            if (this.isJSONPropertyVisible(prop) && !usedProperties[prop.name] && (!isFormMode || prop.showMode === "form" || isColumn && prop.availableInMatrixColumn)) {
                res.push(prop);
            }
        }
        return res;
    };
    SurveyQuestionProperties.prototype.addNonTabProperties = function (tabs, usedProperties, isFormMode) {
        if (isFormMode === void 0) { isFormMode = false; }
        var unusedProperties = this.getUnusedProperties(usedProperties, isFormMode);
        if (!this.propertyGridDefinition.autoGenerateProperties) {
            this.unusedProperties = unusedProperties;
            return;
        }
        var classRes = { properties: [], tabs: [] };
        var tabNames = [];
        for (var i = 0; i < unusedProperties.length; i++) {
            var prop = unusedProperties[i];
            var propCategory = this.getJsonPropertyCategory(prop);
            var tabName = !!propCategory
                ? propCategory
                : tabs.length == 0 || (!!this.parentObj && this.showMode === "form")
                    ? _creator_settings__WEBPACK_IMPORTED_MODULE_3__.settings.propertyGrid.generalTabName
                    : otherTabName;
            if (tabNames.indexOf(tabName) < 0 && tabName != _creator_settings__WEBPACK_IMPORTED_MODULE_3__.settings.propertyGrid.generalTabName) {
                tabNames.push(tabName);
                classRes.tabs.push({
                    name: tabName,
                    index: tabName === otherTabName ? 1000 : tabNames.length * 10,
                });
            }
            if (prop.categoryIndex > -1 && tabNames.indexOf(tabName) > -1) {
                for (var j = 0; j < classRes.tabs.length; j++) {
                    if (classRes.tabs[j].name == tabName) {
                        classRes.tabs[j].index = prop.categoryIndex;
                    }
                }
            }
            classRes.properties.push({
                name: prop.name,
                tab: tabName,
            });
        }
        if (classRes.properties.length > 0) {
            tabs.push(classRes);
        }
    };
    SurveyQuestionProperties.prototype.sortProperties = function (properties) {
        if (!Array.isArray(properties))
            return;
        var index = 0;
        properties.forEach(function (prop) {
            prop.index = prop.definedIndex !== undefined ? prop.definedIndex : index;
            index++;
        });
        properties.sort(function (prop1, prop2) {
            if (prop1.index === prop2.index)
                return 0;
            return prop1.index < prop2.index ? -1 : 1;
        });
        this.insertProperteisWithVisibleIndex(properties);
    };
    SurveyQuestionProperties.prototype.insertProperteisWithVisibleIndex = function (properties) {
        var props = [].concat(properties);
        for (var i = 0; i < props.length; i++) {
            var index = props[i].property.visibleIndex;
            if (props[i].createdFromTabName && index < 0) {
                index = 0;
            }
            if (index < 0 || props[i].definedIndex !== undefined)
                continue;
            var curIndex = properties.indexOf(props[i]);
            if (curIndex > -1) {
                properties.splice(curIndex, 1);
            }
            if (index < properties.length) {
                properties.splice(index, 0, props[i]);
            }
            else {
                properties.push(props[i]);
            }
        }
    };
    return SurveyQuestionProperties;
}());



/***/ }),

/***/ "./src/questionconverter.ts":
/*!**********************************!*\
  !*** ./src/questionconverter.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionConverter: () => (/* binding */ QuestionConverter)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./creator-settings */ "./src/creator-settings.ts");


var QuestionConverter = /** @class */ (function () {
    function QuestionConverter() {
    }
    Object.defineProperty(QuestionConverter, "convertInfo", {
        get: function () {
            if (!QuestionConverter.convertInfoValue) {
                QuestionConverter.convertInfoValue = {};
                QuestionConverter.createDefaultQuestionConverterItems();
            }
            return QuestionConverter.convertInfoValue;
        },
        enumerable: false,
        configurable: true
    });
    QuestionConverter.createDefaultQuestionConverterItems = function () {
        var classes = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.getChildrenClasses("selectbase", true);
        for (var i = 0; i < classes.length; i++) {
            for (var j = 0; j < classes.length; j++) {
                if (i == j)
                    continue;
                QuestionConverter.addConvertInfo(classes[i].name, classes[j].name);
            }
        }
        QuestionConverter.addConvertInfo("text", "comment");
        QuestionConverter.addConvertInfo("comment", "text");
    };
    QuestionConverter.addConvertInfo = function (className, convertToClassName) {
        if (!QuestionConverter.convertInfo[className]) {
            QuestionConverter.convertInfo[className] = [];
        }
        QuestionConverter.convertInfo[className].push(convertToClassName);
    };
    QuestionConverter.getConvertableClasses = function (className) {
        var res = QuestionConverter.convertInfo[className];
        if (!!Array.isArray(res) && res.indexOf(className) < 0) {
            res.unshift(className);
        }
        return res;
    };
    QuestionConverter.getConvertToClasses = function (className, availableTypes, includeCurrent) {
        if (availableTypes === void 0) { availableTypes = null; }
        if (includeCurrent === void 0) { includeCurrent = false; }
        var res = _creator_settings__WEBPACK_IMPORTED_MODULE_1__.settings.questionConvertMode == _creator_settings__WEBPACK_IMPORTED_MODULE_1__.QuestionConvertMode.AllTypes
            ? getAllQuestionTypes(className, includeCurrent)
            : QuestionConverter.getConvertableClasses(className);
        if (!res)
            return [];
        if (Array.isArray(availableTypes) && availableTypes.length > 0) {
            var types_1 = [];
            res.forEach(function (item) { return types_1.push(item); });
            res = availableTypes
                .filter(function (item) { return types_1.indexOf(item) >= 0; });
        }
        return !!res ? res : [];
    };
    QuestionConverter.getObjJSON = function (obj, defaultObjJSON) {
        var res = obj.toJSON();
        if (defaultObjJSON) {
            for (var key in defaultObjJSON) {
                if (res[key] && survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.isTwoValueEquals(res[key], defaultObjJSON[key])) {
                    delete res[key];
                }
            }
        }
        return res;
    };
    QuestionConverter.convertObject = function (obj, convertToClass, objJSON, defaultJSON, jsonToSetAfter) {
        if (defaultJSON === void 0) { defaultJSON = null; }
        if (jsonToSetAfter === void 0) { jsonToSetAfter = null; }
        if (!obj || !obj.parent || convertToClass == obj.getType() && !defaultJSON)
            return null;
        var newQuestion = !defaultJSON ? survey_core__WEBPACK_IMPORTED_MODULE_0__.QuestionFactory.Instance.createQuestion(convertToClass, obj.name) : undefined;
        if (!newQuestion) {
            newQuestion = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.createClass(convertToClass, {});
        }
        newQuestion.name = obj.name;
        var sourceJSON = defaultJSON;
        var json = sourceJSON ? survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.createCopy(sourceJSON) : newQuestion.toJSON();
        //const qJson = QuestionConverter.getObjJSON(obj, objJSON);
        var qJson = objJSON || {};
        for (var key in qJson) {
            json[key] = qJson[key];
        }
        if (jsonToSetAfter) {
            for (var key in jsonToSetAfter) {
                json[key] = jsonToSetAfter[key];
            }
        }
        QuestionConverter.updateJSON(json, convertToClass, obj.getType());
        newQuestion.fromJSON(json);
        QuestionConverter.removeValidators(newQuestion);
        var panel = obj.parent;
        var index = panel.elements.indexOf(obj);
        panel.isConverting = true;
        var isSameLine = index + 1 < panel.elements.length ? panel.elements[index + 1].startWithNewLine === false : false;
        panel.removeElement(obj);
        panel.addElement(newQuestion, index);
        if (isSameLine) {
            panel.elements[index + 1].startWithNewLine = false;
        }
        delete panel.isConverting;
        newQuestion.onSurveyLoad();
        return newQuestion;
    };
    QuestionConverter.updateJSON = function (json, convertToClass, convertFromClass) {
        QuestionConverter.updateJSONForRating(json, convertToClass);
        QuestionConverter.updateJSONForMatrices(json, convertToClass, convertFromClass);
        QuestionConverter.updateJSONForPanels(json, convertToClass, convertFromClass);
        QuestionConverter.updateJSONForBarrating(json, convertToClass);
    };
    QuestionConverter.updateJSONForMatrices = function (json, convertToClass, convertFromClass) {
        if (survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.isDescendantOf(convertToClass, "matrix") &&
            survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.isDescendantOf(convertFromClass, "matrixdropdownbase") &&
            json.columns) {
            var num_1 = 0;
            json.columns = json.columns.map(function (col) {
                var name = col.name ? col.name : (typeof col === "string" ? col : "col" + (num_1++));
                return col.title ? { value: name, text: col.title } : name;
            });
        }
        if (survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.isDescendantOf(convertToClass, "matrixdropdownbase") &&
            survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.isDescendantOf(convertFromClass, "matrix") &&
            json.columns) {
            json.columns = json.columns.map(function (col) { return ({
                name: QuestionConverter.getColumnName(col.name || col.value || col), title: col.text
            }); });
        }
    };
    QuestionConverter.getColumnName = function (val) {
        if (survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.isNumber(val))
            return "col" + val;
        return val;
    };
    QuestionConverter.updateJSONForRating = function (json, convertToClass) {
        if (convertToClass === "rating" && json.choices) {
            json.rateValues = json.choices;
        }
        if (!!json.rateValues && !survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.isDescendantOf(convertToClass, "matrixdropdownbase")) {
            json.choices = json.rateValues;
        }
    };
    QuestionConverter.updateJSONForBarrating = function (json, convertToClass) {
        if (convertToClass === "barrating") {
            json.choices = [1, 2, 3, 4, 5];
        }
    };
    QuestionConverter.updateJSONForPanels = function (json, convertToClass, convertFromClass) {
        if (survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.isDescendantOf(convertToClass, "paneldynamic") &&
            survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.isDescendantOf(convertFromClass, "panel") &&
            json.elements) {
            json.templateElements = json.elements;
            delete json.elements;
        }
        if (survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.isDescendantOf(convertToClass, "panel") &&
            survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.isDescendantOf(convertFromClass, "paneldynamic") &&
            json.templateElements) {
            json.elements = json.templateElements;
            delete json.templateElements;
        }
    };
    QuestionConverter.removeValidators = function (question) {
        var validators = question.validators;
        if (!Array.isArray(validators) || validators.length === 0)
            return;
        var supported = question.getSupportedValidators();
        for (var i = validators.length - 1; i >= 0; i--) {
            var valType = validators[i].getType().replace("validator", "");
            if (supported.indexOf(valType) < 0) {
                validators.splice(i, 1);
            }
        }
    };
    return QuestionConverter;
}());

function getAllQuestionTypes(className, includeCurrent) {
    if (includeCurrent === void 0) { includeCurrent = false; }
    var classes = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.getChildrenClasses("question", true);
    var res = [];
    for (var i = 0; i < classes.length; i++) {
        if (includeCurrent || classes[i].name !== className) {
            res.push(classes[i].name);
        }
    }
    if (includeCurrent || className !== "panel") {
        res.push("panel");
    }
    var widgets = survey_core__WEBPACK_IMPORTED_MODULE_0__.CustomWidgetCollection.Instance.widgets;
    for (var i = 0; i < widgets.length; i++) {
        if (includeCurrent || widgets[i].name !== className) {
            res.push(widgets[i].name);
        }
    }
    return res;
}


/***/ }),

/***/ "./src/selection-history.ts":
/*!**********************************!*\
  !*** ./src/selection-history.ts ***!
  \**********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   SelectionHistory: () => (/* binding */ SelectionHistory)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


var SelectionHistory = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SelectionHistory, _super);
    function SelectionHistory(creator) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.items = [];
        return _this;
    }
    Object.defineProperty(SelectionHistory.prototype, "hasPrev", {
        get: function () {
            return this.currentIndex > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SelectionHistory.prototype, "hasNext", {
        get: function () {
            var index = this.currentIndex;
            return index > -1 && index < this.items.length - 1;
        },
        enumerable: false,
        configurable: true
    });
    SelectionHistory.prototype.hasInHistory = function (obj) {
        return this.getIndex(obj) > -1;
    };
    SelectionHistory.prototype.prev = function () {
        this.selectElement(this.currentIndex - 1);
    };
    SelectionHistory.prototype.next = function () {
        this.selectElement(this.currentIndex + 1);
    };
    SelectionHistory.prototype.reset = function () {
        this.items = [];
        if (!!this.creator.selectedElement) {
            this.onObjSelected(this.creator.selectedElement);
        }
    };
    SelectionHistory.prototype.selectFromAction = function (obj, propertyName) {
        var index = this.currentIndex;
        if (index > -1 && index < this.items.length) {
            this.items[index].propertyName = propertyName;
        }
        this.creator.selectElement(obj);
    };
    SelectionHistory.prototype.onObjSelected = function (obj) {
        if (this.isChangingInternally)
            return;
        var index = this.currentIndex;
        if (index > -1) {
            this.items.splice(index, 1);
        }
        this.items.push({
            obj: obj,
        });
    };
    Object.defineProperty(SelectionHistory.prototype, "currentIndex", {
        get: function () {
            return this.getIndex(this.creator.selectedElement);
        },
        enumerable: false,
        configurable: true
    });
    SelectionHistory.prototype.getIndex = function (obj) {
        if (!obj)
            return -1;
        this.updateItems();
        for (var i = 0; i < this.items.length; i++) {
            if (this.items[i].obj == obj)
                return i;
        }
        return -1;
    };
    SelectionHistory.prototype.selectElement = function (index) {
        if (index < 0 || index >= this.items.length)
            return;
        this.isChangingInternally = true;
        var item = this.items[index];
        this.creator.selectElement(item.obj, item.propertyName);
        this.isChangingInternally = false;
    };
    SelectionHistory.prototype.updateItems = function () {
        for (var i = this.items.length - 1; i >= 0; i--) {
            var obj = this.items[i].obj;
            if (!!obj && (obj.isDisposed || !obj.inSurvey)) {
                this.items.splice(i, 1);
            }
        }
    };
    return SelectionHistory;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));



/***/ }),

/***/ "./src/survey-elements.ts":
/*!********************************!*\
  !*** ./src/survey-elements.ts ***!
  \********************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   DragDropSurveyElements: () => (/* binding */ DragDropSurveyElements),
/* harmony export */   calculateDragOverLocation: () => (/* binding */ calculateDragOverLocation),
/* harmony export */   calculateIsEdge: () => (/* binding */ calculateIsEdge),
/* harmony export */   calculateIsSide: () => (/* binding */ calculateIsSide),
/* harmony export */   isPanelDynamic: () => (/* binding */ isPanelDynamic)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./survey-helper */ "./src/survey-helper.ts");




function calculateIsEdge(dropTargetNode, clientY) {
    var rect = dropTargetNode.getBoundingClientRect();
    return clientY - rect.top <= DragDropSurveyElements.edgeHeight || rect.bottom - clientY <= DragDropSurveyElements.edgeHeight;
}
function calculateIsSide(dropTargetNode, clientX) {
    var rect = dropTargetNode.getBoundingClientRect();
    return clientX - rect.left <= DragDropSurveyElements.edgeHeight || rect.right - clientX <= DragDropSurveyElements.edgeHeight;
}
function calculateDragOverLocation(clientX, clientY, rect, direction) {
    if (direction === void 0) { direction = null; }
    var tg = rect.height / rect.width;
    var dx = clientX - rect.x;
    var dy = clientY - rect.y;
    if (direction == "top-bottom") {
        if (dy >= rect.height / 2) {
            return survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Bottom;
        }
        else {
            return survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Top;
        }
    }
    if (direction == "left-right") {
        if (dx >= rect.width / 2) {
            return survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Right;
        }
        else {
            return survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Left;
        }
    }
    if (dy >= tg * dx) {
        if (dy >= -tg * dx + rect.height) {
            return survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Bottom;
        }
        else {
            return survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Left;
        }
    }
    else {
        if (dy >= -tg * dx + rect.height) {
            return survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Right;
        }
        else {
            return survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Top;
        }
    }
}
function isPanelDynamic(element) {
    return element instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.QuestionPanelDynamicModel;
}
var DragDropSurveyElements = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(DragDropSurveyElements, _super);
    function DragDropSurveyElements() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.insideContainer = null;
        _this.prevIsEdge = null;
        // protected ghostSurveyElement: IElement = null;
        _this.dragOverIndicatorElement = null;
        _this.isDraggedElementSelected = false;
        _this.doBanDropHere = function () {
            _this.removeDragOverMarker(_this.dragOverIndicatorElement);
            _this.removeDragOverMarker(_this.dropTarget);
        };
        _this.doDrop = function () {
            var _a;
            if (!_this.dropTarget)
                return;
            var page = _this.parentElement;
            var dragged = _this.draggedElement;
            var src = _this.draggedElement;
            if (dragged.isPage && dragged instanceof survey_core__WEBPACK_IMPORTED_MODULE_1__.PageModel) {
                var survey = dragged.survey;
                var indexOfDraggedPage = survey.pages.indexOf(dragged);
                survey.pages.splice(indexOfDraggedPage, 1);
                var indexOfDropTarget = survey.pages.indexOf(_this.dropTarget) + (_this.dragOverLocation === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Top ? 0 : 1);
                survey.pages.splice(indexOfDropTarget, 0, dragged);
                if (indexOfDraggedPage !== indexOfDropTarget) {
                    dragged["draggedFrom"] = indexOfDraggedPage < indexOfDropTarget ? indexOfDraggedPage : indexOfDraggedPage + 1;
                }
                return dragged;
            }
            var convertLocation = function () {
                switch (_this.dragOverLocation) {
                    case 4: return "top";
                    case 5: return "right";
                    case 6: return "bottom";
                    case 7: return "left";
                    default: return "bottom";
                }
            };
            var srcContainer = src.parent || src.page;
            if (!!srcContainer) {
                page.survey.startMovingQuestion();
                srcContainer.removeElement(src);
            }
            var dest = ((_a = _this.dragOverIndicatorElement) === null || _a === void 0 ? void 0 : _a.isPanel) ? _this.dragOverIndicatorElement : _this.dropTarget;
            if (isPanelDynamic(dest) && _this.insideContainer)
                dest = dest.template;
            if (dest.isPage && dest.elements.length > 0 && !_this.insideContainer)
                return;
            var isTargetIsContainer = dest.isPanel || dest.isPage;
            if (isTargetIsContainer && _this.insideContainer) {
                dest.insertElement(src);
            }
            else {
                var destParent = dest.parent || dest.page;
                if (destParent)
                    destParent.insertElement(src, dest, convertLocation());
            }
            page.survey.stopMovingQuestion();
            return dragged;
        };
        return _this;
    }
    Object.defineProperty(DragDropSurveyElements.prototype, "draggedElementType", {
        get: function () {
            if (!!this.draggedElement && this.draggedElement.isPage) {
                return "survey-page";
            }
            return "survey-element";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DragDropSurveyElements.prototype, "maxNestedPanels", {
        get: function () { return this.onGetMaxNestedPanels ? this.onGetMaxNestedPanels() : -1; },
        enumerable: false,
        configurable: true
    });
    // private isRight: boolean;
    // protected prevIsRight: boolean;
    DragDropSurveyElements.prototype.startDragToolboxItem = function (event, draggedElementJson, toolboxItemModel) {
        var draggedElement = this.createElementFromJson(draggedElementJson);
        draggedElement.toolboxItemTitle = toolboxItemModel.title;
        draggedElement.toolboxItemIconName = toolboxItemModel.iconName;
        this.startDrag(event, draggedElement);
    };
    DragDropSurveyElements.prototype.startDragSurveyElement = function (event, draggedElement, isElementSelected) {
        this.isDraggedElementSelected = isElementSelected;
        this.startDrag(event, draggedElement);
    };
    DragDropSurveyElements.prototype.getShortcutText = function (draggedElement) {
        return draggedElement.toolboxItemTitle || _super.prototype.getShortcutText.call(this, draggedElement);
    };
    DragDropSurveyElements.prototype.createDraggedElementShortcut = function (text, draggedElementNode, event) {
        var draggedElementShortcut = document.createElement("div");
        var textSpan = document.createElement("span");
        textSpan.className = "svc-dragged-element-shortcut__text";
        textSpan.innerText = text;
        if (this.draggedElement.toolboxItemIconName) {
            draggedElementShortcut.appendChild(this.createDraggedElementIcon());
        }
        draggedElementShortcut.appendChild(textSpan);
        draggedElementShortcut.className = this.getDraggedElementClass();
        return draggedElementShortcut;
    };
    DragDropSurveyElements.prototype.createDraggedElementIcon = function () {
        var span = document.createElement("span");
        span.className = "svc-dragged-element-shortcut__icon";
        var iconName = (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.getIconNameFromProxy)(this.draggedElement.toolboxItemIconName);
        var svgString = "<svg class=\"sv-svg-icon\" role=\"img\" style=\"width: 24px; height: 24px;\"><use xlink:href=\"#".concat(iconName, "\"></use></svg>");
        span.innerHTML = svgString;
        return span;
    };
    DragDropSurveyElements.prototype.getDraggedElementClass = function () {
        var result = "svc-dragged-element-shortcut";
        if (!!this.draggedElement.toolboxItemIconName)
            result += " svc-dragged-element-shortcut--has-icon";
        if (this.isDraggedElementSelected)
            result += " svc-dragged-element-shortcut--selected";
        return result;
    };
    DragDropSurveyElements.prototype.createElementFromJson = function (json) {
        var element = this.createNewElement(json);
        if (element["setSurveyImpl"]) {
            element["setSurveyImpl"](this.survey);
        }
        else {
            element["setData"](this.survey);
        }
        element.renderWidth = "100%";
        return element;
    };
    DragDropSurveyElements.prototype.createNewElement = function (json) {
        var newElement = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass(json["type"]);
        new survey_core__WEBPACK_IMPORTED_MODULE_1__.JsonObject().toObject(json, newElement);
        return newElement;
    };
    DragDropSurveyElements.prototype.findDropTargetNodeByDragOverNode = function (dragOverNode) {
        var ghostRow = dragOverNode.closest(".svc-row--ghost");
        if (!!ghostRow) {
            var ghostDataAttrSelector = "[data-sv-drop-target-survey-element='sv-drag-drop-ghost-survey-element-name']";
            var ghostNode = dragOverNode.closest(ghostDataAttrSelector) || dragOverNode.querySelector(ghostDataAttrSelector);
            if (!!ghostNode) {
                return ghostNode;
            }
        }
        var dropTargetNode = dragOverNode.closest(this.dropTargetDataAttributeName);
        return dropTargetNode;
    };
    DragDropSurveyElements.prototype.getDropTargetByDataAttributeValue = function (dataAttributeValue, dropTargetNode, event) {
        var oldDragOverIndicatorElement = this.dragOverIndicatorElement;
        if (!dataAttributeValue) {
            // panel dynamic
            var nearestDropTargetElement = dropTargetNode.parentElement.closest(this.dropTargetDataAttributeName);
            dataAttributeValue = this.getDataAttributeValueByNode(nearestDropTargetElement);
        }
        if (!dataAttributeValue) {
            throw new Error("Can't find drop target survey element name");
        }
        if (dataAttributeValue === DragDropSurveyElements.ghostSurveyElementName) {
            return this.prevDropTarget;
        }
        // drop to new page
        if (dataAttributeValue === "newGhostPage") {
            return DragDropSurveyElements.newGhostPage;
        }
        // drop to page
        var page = this.survey.getPageByName(dataAttributeValue);
        if (page) {
            return page;
        }
        // drop to question or panel
        var dropTarget;
        var dragOverElement;
        this.survey.pages.forEach(function (page) {
            var question = page.getElementByName(dataAttributeValue);
            if (question) {
                dropTarget = question;
                dragOverElement = question;
            }
        });
        // drop to matrix detail panel
        if ((dropTarget.getType() === "matrixdropdown" || dropTarget.getType() === "matrixdynamic") && dropTarget.detailPanelMode !== "none" && this.insideContainer) {
            dropTarget = dropTarget.detailPanel;
        }
        // drop to question
        //question inside paneldymanic
        if (!dropTarget.page) {
            var nearestDropTargetPageElement = dropTargetNode.parentElement.closest("[data-sv-drop-target-page]");
            dataAttributeValue = nearestDropTargetPageElement.dataset.svDropTargetPage;
            var page_1 = this.survey.getPageByName(dataAttributeValue);
            dropTarget.__page = page_1;
        }
        this.dragOverIndicatorElement = dragOverElement;
        if (this.dragOverIndicatorElement != oldDragOverIndicatorElement) {
            this.removeDragOverMarker(oldDragOverIndicatorElement);
        }
        return dropTarget;
        // EO drop to question or panel
    };
    DragDropSurveyElements.prototype.isDropTargetValid = function (dropTarget, dropTargetNode, dragOverLocation) {
        if (dragOverLocation === void 0) { dragOverLocation = survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Top; }
        if (!dropTarget)
            return false;
        if (dropTarget === this.draggedElement)
            return false;
        if (this.draggedElement.getType() === "paneldynamic" && dropTarget === this.draggedElement.template) {
            return false;
        }
        if (this.maxNestedPanels >= 0 && this.draggedElement.isPanel) {
            var pnl = this.draggedElement;
            if (pnl.deepNested === undefined) {
                pnl.deepNested = this.getMaximumNestedPanelCount(pnl, 0);
            }
            var len = _survey_helper__WEBPACK_IMPORTED_MODULE_3__.SurveyHelper.getElementDeepLength(dropTarget);
            if (dragOverLocation !== survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.InsideEmptyPanel && dropTarget.isPanel)
                len--;
            if (this.maxNestedPanels < len + pnl.deepNested)
                return false;
        }
        if (DragDropSurveyElements.restrictDragQuestionBetweenPages &&
            this.shouldRestricDragQuestionBetweenPages(dropTarget)) {
            return false;
        }
        return true;
    };
    DragDropSurveyElements.prototype.getMaximumNestedPanelCount = function (panel, deep) {
        var _this = this;
        var max = deep;
        panel.elements.forEach(function (el) {
            if (el.isPanel) {
                var pDeep = _this.getMaximumNestedPanelCount(el, deep + 1);
                if (pDeep > max) {
                    max = pDeep;
                }
            }
        });
        return max;
    };
    DragDropSurveyElements.prototype.shouldRestricDragQuestionBetweenPages = function (dropTarget) {
        var oldPage = this.draggedElement["page"];
        var newPage = dropTarget.isPage ? dropTarget : dropTarget["page"];
        // if oldPage === null then it is drop from the toolbox
        return oldPage && oldPage !== newPage;
    };
    DragDropSurveyElements.prototype.findDeepestDropTargetChild = function (parent) {
        var selector = this.dropTargetDataAttributeName;
        var result = parent;
        while (!!parent) {
            result = parent;
            parent = parent.querySelector(selector);
        }
        return result;
    };
    DragDropSurveyElements.prototype.isAllowDragOver = function (dropTarget, dragOverLocation) {
        if (!this.survey || this.survey.onDragDropAllow.isEmpty)
            return true;
        var allowOptions = {
            allow: true,
            parent: this.parentElement,
            source: this.draggedElement,
            toElement: dropTarget,
            draggedElement: this.draggedElement,
            fromElement: this.draggedElement.parent,
            target: dropTarget,
            insertAfter: undefined,
            insertBefore: undefined,
            allowDropNextToAnother: true
        };
        if (dragOverLocation === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Bottom || dragOverLocation === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Right) {
            allowOptions.insertAfter = dropTarget;
        }
        if (dragOverLocation === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Top || dragOverLocation === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Left) {
            allowOptions.insertBefore = dropTarget;
        }
        this.survey.onDragDropAllow.fire(this.survey, allowOptions);
        if (!allowOptions.allowDropNextToAnother) {
            if (dragOverLocation === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Left) {
                this.dragOverLocation = survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Top;
            }
            if (dragOverLocation === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Right) {
                this.dragOverLocation = survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Bottom;
            }
        }
        return allowOptions.allow;
    };
    DragDropSurveyElements.prototype.dragOverCore = function (dropTarget, dragOverLocation) {
        var oldDragOverIndicatorElement = this.dragOverIndicatorElement;
        var oldDropTarget = this.dropTarget;
        if (this.isSameElement(dropTarget)) {
            this.allowDropHere = false;
            return;
        }
        this.dropTarget = dropTarget;
        this.dragOverLocation = dragOverLocation;
        this.parentElement = this.dropTarget.isPage
            ? this.dropTarget
            : (this.dropTarget.page || this.dropTarget.__page);
        if (!this.isAllowDragOver(dropTarget, dragOverLocation)) {
            this.allowDropHere = false;
            return;
        }
        if (dragOverLocation == survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.InsideEmptyPanel) {
            this.dragOverIndicatorElement = this.dropTarget;
            this.dragOverIndicatorElement.dragTypeOverMe = survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.InsideEmptyPanel;
        }
        else {
            var row = this.parentElement.dragDropFindRow(this.dropTarget);
            if (!!row && row.elements.length > 1 && (this.dragOverLocation === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Top || this.dragOverLocation === survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.Bottom)) {
                row.dragTypeOverMe = this.dragOverLocation;
                this.dragOverIndicatorElement = row;
            }
            else {
                this.dropTarget.dragTypeOverMe = this.dragOverLocation;
                this.dragOverIndicatorElement = this.dropTarget;
            }
        }
        if (this.dragOverIndicatorElement != oldDragOverIndicatorElement)
            this.removeDragOverMarker(oldDragOverIndicatorElement);
        if (this.dropTarget != oldDropTarget)
            this.removeDragOverMarker(oldDropTarget);
    };
    DragDropSurveyElements.prototype.isSameElement = function (target) {
        while (!!target) {
            if (target === this.draggedElement)
                return true;
            target = target.parent;
        }
        return false;
    };
    DragDropSurveyElements.prototype.dragOver = function (event) {
        var dropTargetNode = this.findDropTargetNodeFromPoint(event.clientX, event.clientY);
        if (!dropTargetNode) {
            this.banDropHere();
            return;
        }
        var oldInsideContainer = this.insideContainer;
        this.insideContainer = !calculateIsEdge(dropTargetNode, event.clientY) && !calculateIsSide(dropTargetNode, event.clientX);
        var dropTarget = this.getDropTargetByNode(dropTargetNode, event);
        if (!!oldInsideContainer != !!this.insideContainer)
            dropTarget.dragTypeOverMe = null;
        var dropTargetRect = dropTargetNode.getBoundingClientRect();
        var calcDirection = !_creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings.dragDrop.allowDragToTheSameLine || (!!this.draggedElement && this.draggedElement.isPage) ? "top-bottom" : null;
        var dragOverLocation = calculateDragOverLocation(event.clientX, event.clientY, dropTargetRect, calcDirection);
        if (dropTarget && ((dropTarget.isPanel || dropTarget.isPage) && dropTarget.elements.length === 0 || isPanelDynamic(dropTarget) && dropTarget.template.elements.length == 0)) {
            if (dropTarget.isPage || this.insideContainer) {
                dragOverLocation = survey_core__WEBPACK_IMPORTED_MODULE_1__.DragTypeOverMeEnum.InsideEmptyPanel;
            }
        }
        var options = {
            survey: this.survey,
            draggedSurveyElement: this.draggedElement,
            dragOverSurveyElement: dropTarget,
            clientX: event.clientX,
            clientY: event.clientY,
            dragOverRect: dropTargetRect,
            insideContainer: this.insideContainer,
            dragOverLocation: dragOverLocation
        };
        if (this.onDragOverLocationCalculating) {
            this.onDragOverLocationCalculating(options);
            dragOverLocation = options.dragOverLocation;
            this.insideContainer = options.insideContainer;
        }
        var isDropTargetValid = this.isDropTargetValid(dropTarget, dropTargetNode, dragOverLocation);
        if (!isDropTargetValid) {
            this.banDropHere();
            return;
        }
        this.allowDropHere = true;
        this.dragOverCore(dropTarget, dragOverLocation);
    };
    DragDropSurveyElements.prototype.onStartDrag = function () {
        // this.ghostSurveyElement = this.createGhostSurveyElement();
        this.draggedElement.isDragMe = true;
    };
    DragDropSurveyElements.prototype.moveElementInPanel = function (panel, src, target, targetIndex) {
        var srcIndex = src.parent.elements.indexOf(src);
        if (targetIndex > srcIndex) {
            targetIndex--;
        }
        if (src === target && srcIndex === targetIndex) {
            return;
        }
        panel.removeElement(src);
        panel.addElement(target, targetIndex);
    };
    DragDropSurveyElements.prototype.removeDragOverMarker = function (dropTarget) {
        if (!!dropTarget) {
            dropTarget.dragTypeOverMe = null;
        }
    };
    DragDropSurveyElements.prototype.clear = function () {
        this.insideContainer = null;
        this.removeDragOverMarker(this.prevDropTarget);
        this.removeDragOverMarker(this.dropTarget);
        this.removeDragOverMarker(this.dragOverIndicatorElement);
        if (!!this.draggedElement) {
            this.draggedElement.isDragMe = false;
        }
        _super.prototype.clear.call(this);
    };
    DragDropSurveyElements.prototype.getTargetParent = function (dropTarget) {
        var targetParent = dropTarget.isPage || dropTarget.isPanel ? dropTarget : dropTarget.parent;
        if (dropTarget.getType() === "paneldynamic") {
            targetParent = dropTarget.templateValue;
        }
        return targetParent;
    };
    DragDropSurveyElements.prototype.getTargetRow = function (dropTarget) {
        var targetParent = this.getTargetParent(dropTarget);
        var targetRow;
        targetParent.rows.forEach(function (row) {
            if (row.elements.indexOf(dropTarget) !== -1) {
                targetRow = row;
            }
        });
        return targetRow;
    };
    DragDropSurveyElements.newGhostPage = null;
    DragDropSurveyElements.restrictDragQuestionBetweenPages = false;
    DragDropSurveyElements.edgeHeight = 30;
    DragDropSurveyElements.nestedPanelDepth = -1;
    DragDropSurveyElements.ghostSurveyElementName = "sv-drag-drop-ghost-survey-element-name"; // before renaming use globa search (we have also css selectors)
    return DragDropSurveyElements;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.DragDropCore));



/***/ }),

/***/ "./src/survey-helper.ts":
/*!******************************!*\
  !*** ./src/survey-helper.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ObjType: () => (/* binding */ ObjType),
/* harmony export */   SurveyHelper: () => (/* binding */ SurveyHelper)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./utils/utils */ "./src/utils/utils.ts");



var ObjType;
(function (ObjType) {
    ObjType["Unknown"] = "unknown";
    ObjType["Survey"] = "survey";
    ObjType["Page"] = "page";
    ObjType["Panel"] = "panel";
    ObjType["Question"] = "question";
    ObjType["Column"] = "column";
})(ObjType || (ObjType = {}));
var SurveyHelper = /** @class */ (function () {
    function SurveyHelper() {
    }
    SurveyHelper.getNewElementName = function (el) {
        var survey = el.getSurvey();
        if (!survey)
            return el.name;
        if (el.isPage)
            return this.getNewPageName(survey.pages);
        if (el.isPanel)
            return this.getNewPanelName(survey.getAllPanels());
        return this.getNewQuestionName(survey.getAllQuestions(false, false, true));
    };
    SurveyHelper.getNewPageName = function (objs) {
        return SurveyHelper.getNewName(objs, _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.newPageName"));
    };
    SurveyHelper.isPageNameAutoGenerated = function (name) {
        return SurveyHelper.isNameAutoGenerated(name, _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.newPageName"));
    };
    SurveyHelper.isPagePropertiesAreModified = function (page) {
        if (!SurveyHelper.isPageNameAutoGenerated(page.name))
            return true;
        var json = page.toJSON();
        delete json["name"];
        delete json["elements"];
        //If there is at least one property in page is set, then return true
        for (var key in json)
            return true;
        return false;
    };
    SurveyHelper.getNewQuestionName = function (objs) {
        return SurveyHelper.getNewName(objs, _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.newQuestionName"));
    };
    SurveyHelper.getNewPanelName = function (objs) {
        return SurveyHelper.getNewName(objs, _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.newPanelName"));
    };
    SurveyHelper.generateNewName = function (name) {
        var pos = name.length;
        while (pos > 0 && name[pos - 1] >= "0" && name[pos - 1] <= "9") {
            pos--;
        }
        var base = name.substring(0, pos);
        var num = 0;
        if (pos < name.length) {
            num = parseInt(name.substring(pos));
        }
        num++;
        return base + num;
    };
    SurveyHelper.getNewName = function (objs, baseName) {
        var hash = {};
        for (var i = 0; i < objs.length; i++) {
            hash[objs[i].name] = true;
        }
        var num = 1;
        while (true) {
            if (!hash[baseName + num.toString()])
                break;
            num++;
        }
        return baseName + num.toString();
    };
    SurveyHelper.isNameAutoGenerated = function (name, baseName) {
        if (!name || name.length < baseName.length)
            return false;
        var digits = name.substring(baseName.length);
        return survey_core__WEBPACK_IMPORTED_MODULE_0__.Helpers.isNumber(digits);
    };
    SurveyHelper.getObjectType = function (obj) {
        if (!obj || !obj["getType"])
            return ObjType.Unknown;
        if (obj.isPage)
            return ObjType.Page;
        if (obj.isPanel)
            return ObjType.Panel;
        if (obj.getType() == "survey")
            return ObjType.Survey;
        if (obj.getType() == "matrixdropdowncolumn")
            return ObjType.Column;
        if (obj.isQuestion)
            return ObjType.Question;
        return ObjType.Unknown;
    };
    SurveyHelper.getObjectTypeStr = function (obj) {
        var objType = SurveyHelper.getObjectType(obj);
        if (objType === ObjType.Survey)
            return "survey";
        if (objType === ObjType.Page)
            return "page";
        if (objType === ObjType.Panel)
            return "panel";
        if (objType === ObjType.Question)
            return "question";
        if (objType === ObjType.Column)
            return "column";
        return "unknown";
    };
    SurveyHelper.getObjectName = function (obj, showObjectTitle) {
        if (showObjectTitle === void 0) { showObjectTitle = false; }
        var objType = SurveyHelper.getObjectType(obj);
        if (objType === ObjType.Survey)
            return _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization.getString("ed.surveyTypeName");
        if (showObjectTitle && obj["title"])
            return obj["title"];
        if (showObjectTitle && obj["text"])
            return obj["text"];
        if (obj["name"])
            return obj["name"];
        return "";
    };
    SurveyHelper.getElements = function (element, includeHidden) {
        if (includeHidden === void 0) { includeHidden = false; }
        if (!element)
            return [];
        if (element.getElementsInDesign)
            return element.getElementsInDesign(includeHidden);
        if (element.elements)
            return element.elements;
        return [];
    };
    SurveyHelper.addElements = function (elements, isPanel, result) {
        for (var i = 0; i < elements.length; i++) {
            if (elements[i].isPanel === isPanel) {
                result.push(elements[i]);
            }
            SurveyHelper.addElements(SurveyHelper.getElements(elements[i]), isPanel, result);
        }
    };
    SurveyHelper.getAllElements = function (survey, isPanel) {
        var result = [];
        for (var i = 0; i < survey.pages.length; i++) {
            SurveyHelper.addElements(survey.pages[i].elements, isPanel, result);
        }
        return result;
    };
    SurveyHelper.isPropertyVisible = function (obj, property, options, showMode, parentObj, parentProperty) {
        if (options === void 0) { options = null; }
        if (showMode === void 0) { showMode = null; }
        if (parentObj === void 0) { parentObj = null; }
        if (parentProperty === void 0) { parentProperty = null; }
        if (!property || !property.visible)
            return false;
        if (!!showMode && !!property.showMode && showMode !== property.showMode)
            return false;
        if (!!property.isVisible &&
            !!obj.getLayoutType &&
            !property["isVisible"](obj.getLayoutType(), null))
            return false;
        var canShow = !!options
            ? function (object, property) {
                return options.onCanShowPropertyCallback(object, property, showMode, parentObj, parentProperty);
            }
            : null;
        if (!!canShow && !canShow(obj, property))
            return false;
        return true;
    };
    SurveyHelper.isNeedScrollIntoView = function (el, scrollIfElementBiggerThanContainer) {
        if (scrollIfElementBiggerThanContainer === void 0) { scrollIfElementBiggerThanContainer = false; }
        if (!el || !el.scrollIntoView)
            return;
        var rect = el.getBoundingClientRect();
        var scrollableDiv = SurveyHelper.getScrollableDiv(el);
        if (!scrollableDiv)
            return;
        var height = scrollableDiv.clientHeight;
        if (rect.top < scrollableDiv.offsetTop) {
            return "top";
        }
        else {
            var offsetTop = height + scrollableDiv.offsetTop;
            if (rect.bottom > offsetTop && (rect.height < height || scrollIfElementBiggerThanContainer)) {
                return "bottom";
            }
        }
    };
    SurveyHelper.scrollIntoViewIfNeeded = function (el, getOptions, scrollIfElementBiggerThanContainer) {
        if (scrollIfElementBiggerThanContainer === void 0) { scrollIfElementBiggerThanContainer = false; }
        var isNeedScroll = SurveyHelper.isNeedScrollIntoView(el, scrollIfElementBiggerThanContainer);
        if (!isNeedScroll)
            return;
        var isNeedScrollToTop = isNeedScroll === "top";
        el.scrollIntoView(getOptions ? getOptions(isNeedScrollToTop) : isNeedScrollToTop);
    };
    SurveyHelper.getScrollableDiv = function (el) {
        while (!!el) {
            if (!!el.id && el.id.indexOf("scrollableDiv") > -1)
                return el;
            if (!el.offsetParent)
                return null;
            el = el.offsetParent;
        }
        return null;
    };
    SurveyHelper.moveItemInArray = function (list, obj, newIndex) {
        if (!list || list.length < 2)
            return false;
        if (newIndex < 0 || newIndex >= list.length)
            return false;
        var oldIndex = list.indexOf(obj);
        if (oldIndex < 0 || oldIndex == newIndex)
            return false;
        for (var i = 0; i < list.length; i++) {
            SurveyHelper.disableSelectingObj(list[i]);
        }
        list.splice(oldIndex, 1);
        list.splice(newIndex, 0, obj);
        for (var i = 0; i < list.length; i++) {
            SurveyHelper.enableSelectingObj(list[i]);
        }
        return true;
    };
    SurveyHelper.applyItemValueArray = function (dest, src) {
        if (!src || src.length == 0) {
            dest.splice(0, dest.length);
            return;
        }
        if (dest.length > src.length) {
            dest.splice(src.length, dest.length - src.length);
        }
        if (dest.length < src.length) {
            var insertedArray = [];
            for (var i = dest.length; i < src.length; i++) {
                insertedArray.push(src[i]);
            }
            dest.splice.apply(dest, [dest.length, 0].concat(insertedArray));
        }
        for (var i = 0; i < dest.length; i++) {
            if (dest[i].value != src[i].value) {
                dest[i].value = src[i].value;
            }
            dest[i].text = src[i].hasText ? src[i].text : "";
        }
    };
    SurveyHelper.disableSelectingObj = function (obj) {
        obj["disableSelecting"] = true;
    };
    SurveyHelper.enableSelectingObj = function (obj) {
        delete obj["disableSelecting"];
    };
    SurveyHelper.canSelectObj = function (obj) {
        return !obj || obj["disableSelecting"] !== true;
    };
    SurveyHelper.warnNonSupported = function (name, newPropertyName) {
        var outputText = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_2__.wrapTextByCurlyBraces)(name) + " is not supported in V2.";
        if (!!newPropertyName) {
            outputText += " Use the '" + newPropertyName + "' property instead";
        }
        SurveyHelper.warnText(outputText);
    };
    SurveyHelper.warnText = function (text) {
        // eslint-disable-next-line no-console
        console.warn(text);
    };
    SurveyHelper.deleteConditionProperties = function (json) {
        delete json["visible"];
        delete json["visibleIf"];
        delete json["readOnly"];
        delete json["enableIf"];
        delete json["valueName"];
        delete json["choicesVisibleIf"];
        delete json["choicesEnableIf"];
        delete json["width"];
        delete json["minWidth"];
        delete json["maxWidth"];
    };
    SurveyHelper.deleteRandomProperties = function (json) {
        ["choicesOrder", "rowsOrder"].forEach(function (prop) {
            if (json[prop] === "random") {
                delete json[prop];
            }
        });
    };
    SurveyHelper.updateQuestionJson = function (questionJson) {
        questionJson.storeOthersAsComment = false;
        delete questionJson.valuePropertyName;
        SurveyHelper.deleteConditionProperties(questionJson);
        SurveyHelper.deleteRandomProperties(questionJson);
        SurveyHelper.deleteConditionPropertiesFromArray(questionJson.choices);
        SurveyHelper.deleteConditionPropertiesFromArray(questionJson.rows);
        SurveyHelper.deleteConditionPropertiesFromArray(questionJson.columns);
        SurveyHelper.deleteConditionPropertiesFromArray(questionJson.rates);
    };
    SurveyHelper.deleteConditionPropertiesFromArray = function (jsonArray) {
        if (!Array.isArray(jsonArray))
            return;
        jsonArray.forEach(function (item) {
            SurveyHelper.deleteConditionProperties(item);
        });
    };
    SurveyHelper.convertMatrixRowsToText = function (rows) {
        var result = rows
            .filter(function (row) { return !row.cells[0].hasError; })
            .map(function (row) {
            return row.cells
                .map(function (cell) { return cell.value || ""; })
                .join(survey_core__WEBPACK_IMPORTED_MODULE_0__.ItemValue.Separator)
                .replace(/\|$/, "");
        })
            .join("\n");
        return result;
    };
    SurveyHelper.convertItemValuesToText = function (items) {
        var text = "";
        items.forEach(function (item) {
            if (text)
                text += "\n";
            text += item.value;
            if (item.pureText)
                text += survey_core__WEBPACK_IMPORTED_MODULE_0__.ItemValue.Separator + item.pureText;
        });
        return text;
    };
    SurveyHelper.convertTextToItemValues = function (text, properties, className) {
        var items = [];
        if (!text)
            return items;
        var texts = text.split("\n");
        for (var i = 0; i < texts.length; i++) {
            if (!texts[i])
                continue;
            var elements = texts[i].split(survey_core__WEBPACK_IMPORTED_MODULE_0__.ItemValue.Separator);
            var valueItem = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.createClass(className);
            properties.forEach(function (p, i) {
                valueItem[p.name] = elements[i];
            });
            items.push(valueItem);
        }
        return items;
    };
    SurveyHelper.sortItems = function (items, propertyName) {
        if (propertyName === void 0) { propertyName = "text"; }
        var getNumber = function (str, index) {
            var strNum = "";
            while (index < str.length && str[index] >= "0" && str[index] <= "9") {
                strNum += str[index];
                index++;
            }
            return parseFloat(strNum);
        };
        items.sort(function (a, b) {
            var aVal = !!a[propertyName] ? a[propertyName] : "";
            var bVal = !!b[propertyName] ? b[propertyName] : "";
            var index = 0;
            while (index < aVal.length && index < bVal.length && aVal[index] === bVal[index])
                index++;
            if (index < aVal.length && index < bVal.length) {
                while (index > 0 && (aVal[index - 1] >= "0" && aVal[index - 1] <= "9"))
                    index--;
                var aNum = getNumber(aVal, index);
                var bNum = getNumber(bVal, index);
                if (aNum < bNum)
                    return -1;
                if (aNum > bNum)
                    return 1;
            }
            return aVal.localeCompare(bVal);
        });
    };
    SurveyHelper.getQuestionContextIndexInfo = function (name, prefix) {
        if (prefix === void 0) { prefix = ""; }
        var contextStrings = ["row", "panel"];
        for (var i = 0; i < contextStrings.length; i++) {
            var subStr = prefix + contextStrings[i] + ".";
            var index = name.indexOf(subStr);
            if (index > -1)
                return { index: index, name: subStr };
        }
        return undefined;
    };
    SurveyHelper.isSupportCellEditor = function (type) {
        var supportedTypes = ["selectbase", "boolean", "rating"];
        for (var i = 0; i < supportedTypes.length; i++) {
            if (survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.isDescendantOf(type, supportedTypes[i]))
                return true;
        }
        return false;
    };
    SurveyHelper.getElementDeepLength = function (element) {
        var res = 0;
        while (!!element) {
            if (element.isPanel)
                res++;
            element = element.parent;
        }
        return res;
    };
    return SurveyHelper;
}());



/***/ }),

/***/ "./src/svgbundle.ts":
/*!**************************!*\
  !*** ./src/svgbundle.ts ***!
  \**************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   iconsV1: () => (/* binding */ iconsV1),
/* harmony export */   iconsV2: () => (/* binding */ iconsV2),
/* harmony export */   svgBundle: () => (/* binding */ svgBundle)
/* harmony export */ });
var svgBundle = {};
function getIconsData(path) {
    var icons = {};
    path.keys().forEach(function (key) {
        icons[key.substring(2, key.length - 4).toLowerCase()] = path(key);
    });
    return icons;
}
var iconsV1 = getIconsData(__webpack_require__("./src/images-v1 sync recursive \\.svg$"));
var iconsV2 = getIconsData(__webpack_require__("./src/images-v2 sync recursive \\.svg$"));


/***/ }),

/***/ "./src/tabbed-menu.ts":
/*!****************************!*\
  !*** ./src/tabbed-menu.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   TabbedMenuContainer: () => (/* binding */ TabbedMenuContainer),
/* harmony export */   TabbedMenuItem: () => (/* binding */ TabbedMenuItem)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


var tabsIcons = {
    designer: "icon-config",
    theme: "icon-theme",
    editor: "icon-codeeditor-24x24",
    translation: "icon-language",
    preview: "icon-preview",
    logic: "icon-logic-24x24",
    customembeded: "icon-embedsurvey-24x24",
    default: "icon-undefined-24x24"
};
var TabbedMenuItem = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TabbedMenuItem, _super);
    function TabbedMenuItem(item) {
        return _super.call(this, item) || this;
    }
    TabbedMenuItem.prototype.getRootCss = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append("svc-tabbed-menu-item")
            .append("svc-tabbed-menu-item--selected", this.active)
            .append("svc-tabbed-menu-item--disabled", this.enabled !== undefined && !this.enabled)
            .append("svc-tabbed-menu-item--icon", this.hasIcon)
            .toString();
    };
    TabbedMenuItem.prototype.getTitleCss = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append("svc-tabbed-menu-item__text")
            .toString();
    };
    TabbedMenuItem.prototype.getIconCss = function () {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder().append("svc-tabbed-menu-item__icon").toString();
    };
    Object.defineProperty(TabbedMenuItem.prototype, "hasTitle", {
        get: function () {
            return !this.hasIcon;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TabbedMenuItem.prototype, "hasIcon", {
        get: function () {
            return !this.disableShrink && this.iconName && this.mode == "small";
        },
        enumerable: false,
        configurable: true
    });
    return TabbedMenuItem;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Action));

var TabbedMenuContainer = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(TabbedMenuContainer, _super);
    function TabbedMenuContainer(creator) {
        var _this = _super.call(this) || this;
        _this.creator = creator;
        _this.dotsItem.popupModel.horizontalPosition = "center";
        _this.dotsItem.popupModel.cssClass += " svc-tabbed-menu-item__popup svc-creator-popup";
        _this.minVisibleItemsCount = 1;
        return _this;
    }
    TabbedMenuContainer.prototype.addTab = function (name, plugin, title, componentName, index) {
        var _this = this;
        var tabName = name === "test" ? "preview" : name;
        var locStrName = !title ? "tabs." + tabName : (title.indexOf("ed.") == 0 ? title : "");
        var tab = new TabbedMenuItem({
            id: name,
            locTitleName: locStrName,
            title: title,
            componentContent: componentName ? componentName : "svc-tab-" + name,
            data: plugin,
            iconName: tabsIcons[tabName] || tabsIcons["default"],
            action: function () { _this.creator.makeNewViewActive(name); },
            active: this.creator.viewType === name,
            disableHide: this.creator.viewType === name
        });
        tab.disableShrink = this.creator.tabResponsivenessMode == "menu";
        if (index !== undefined && index >= 0 && index < this.actions.length) {
            this.actions.splice(index, 0, tab);
        }
        else {
            this.actions.push(tab);
        }
    };
    TabbedMenuContainer.prototype.updateResponsivenessMode = function () {
        var _this = this;
        this.actions.forEach(function (tab) {
            tab.disableShrink = _this.creator.tabResponsivenessMode == "menu";
        });
        this.raiseUpdate(true);
    };
    return TabbedMenuContainer;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.AdaptiveActionContainer));



/***/ }),

/***/ "./src/textWorker.ts":
/*!***************************!*\
  !*** ./src/textWorker.ts ***!
  \***************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   JsonDuplicateNameError: () => (/* binding */ JsonDuplicateNameError),
/* harmony export */   SurveyTextWorker: () => (/* binding */ SurveyTextWorker),
/* harmony export */   SurveyTextWorkerError: () => (/* binding */ SurveyTextWorkerError),
/* harmony export */   SurveyTextWorkerJsonError: () => (/* binding */ SurveyTextWorkerJsonError),
/* harmony export */   SurveyTextWorkerParserError: () => (/* binding */ SurveyTextWorkerParserError)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _json5__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./json5 */ "./src/json5.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./creator-settings */ "./src/creator-settings.ts");





var SurveyForTextWorker = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyForTextWorker, _super);
    function SurveyForTextWorker(jsonObj) {
        var _this = _super.call(this) || this;
        _this.setDesignMode(true);
        _this.fromJSON(jsonObj);
        return _this;
    }
    //Run endLoading before fixing issues with unique names
    SurveyForTextWorker.prototype.runEndLoadingFromJson = function () {
        if (this.isRunEndLoadingFromJson)
            return;
        this.isRunEndLoadingFromJson = true;
        _super.prototype.endLoadingFromJson.call(this);
    };
    //Do nothing on end loading
    SurveyForTextWorker.prototype.endLoadingFromJson = function () { };
    SurveyForTextWorker.prototype.getSurveyData = function () { return null; };
    return SurveyForTextWorker;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.SurveyModel));
var SurveyTextWorkerJsonErrorFixerBase = /** @class */ (function () {
    function SurveyTextWorkerJsonErrorFixerBase() {
    }
    SurveyTextWorkerJsonErrorFixerBase.prototype.getCorrectAt = function (text, at, end) {
        return at;
    };
    Object.defineProperty(SurveyTextWorkerJsonErrorFixerBase.prototype, "isFixable", {
        get: function () { return false; },
        enumerable: false,
        configurable: true
    });
    SurveyTextWorkerJsonErrorFixerBase.prototype.fixError = function (text, start, end) { return text; };
    return SurveyTextWorkerJsonErrorFixerBase;
}());
var SurveyTextWorkerError = /** @class */ (function () {
    function SurveyTextWorkerError(at, text) {
        this.at = at;
        this.text = text;
        this.rowAt = -1;
        this.columnAt = -1;
    }
    Object.defineProperty(SurveyTextWorkerError.prototype, "isFixable", {
        get: function () { return this.fixer.isFixable; },
        enumerable: false,
        configurable: true
    });
    SurveyTextWorkerError.prototype.fixError = function (text) { return text; };
    Object.defineProperty(SurveyTextWorkerError.prototype, "fixer", {
        get: function () {
            if (!this.fixerValue) {
                this.fixerValue = this.createFixer();
            }
            return this.fixerValue;
        },
        enumerable: false,
        configurable: true
    });
    SurveyTextWorkerError.prototype.createFixer = function () {
        return new SurveyTextWorkerJsonErrorFixerBase();
    };
    return SurveyTextWorkerError;
}());

var SurveyTextWorkerParserError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyTextWorkerParserError, _super);
    function SurveyTextWorkerParserError() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SurveyTextWorkerParserError.prototype.getErrorType = function () { return "parseerror"; };
    return SurveyTextWorkerParserError;
}(SurveyTextWorkerError));

var SurveyTextWorkerJsonErrorFixer = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyTextWorkerJsonErrorFixer, _super);
    function SurveyTextWorkerJsonErrorFixer(element, jsonObj) {
        var _this = _super.call(this) || this;
        _this.element = element;
        _this.jsonObj = jsonObj;
        return _this;
    }
    SurveyTextWorkerJsonErrorFixer.prototype.getNewIndex = function (text, findText, at, end) {
        var index = text.indexOf(findText, at);
        if (index > -1 && (end < 0 || index < end)) {
            return index;
        }
        return -1;
    };
    SurveyTextWorkerJsonErrorFixer.prototype.fixError = function (text, start, end) {
        var content = text.substring(start, end + 1);
        var json = JSON.parse(content);
        this.updatedJsonObjOnFix(json);
        return this.replaceJson(text, start, end, json);
    };
    SurveyTextWorkerJsonErrorFixer.prototype.updatedJsonObjOnFix = function (json) {
    };
    SurveyTextWorkerJsonErrorFixer.prototype.replaceJson = function (text, start, end, json) {
        var newContent = JSON.stringify(json, null, _creator_settings__WEBPACK_IMPORTED_MODULE_4__.settings.jsonEditor.indentation);
        newContent = this.addLeftIndentIntoContent(text, newContent, start - 1);
        return text.substring(0, start) + newContent + text.substring(end + 1);
    };
    SurveyTextWorkerJsonErrorFixer.prototype.addLeftIndentIntoContent = function (text, content, index) {
        if (index <= 0)
            return content;
        var indent = "";
        while (index > 0 && (text[index] === " " || text[index] === "\t")) {
            indent += text[index];
            index--;
        }
        if (!indent)
            return content;
        var lines = content.split("\n");
        for (var i = 1; i < lines.length; i++) {
            lines[i] = indent + lines[i];
        }
        return lines.join("\n");
    };
    return SurveyTextWorkerJsonErrorFixer;
}(SurveyTextWorkerJsonErrorFixerBase));
var SurveyTextWorkerJsonUnknownPropertyErrorFixer = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyTextWorkerJsonUnknownPropertyErrorFixer, _super);
    function SurveyTextWorkerJsonUnknownPropertyErrorFixer(element, jsonObj, propertyName) {
        var _this = _super.call(this, element, jsonObj) || this;
        _this.element = element;
        _this.jsonObj = jsonObj;
        _this.propertyName = propertyName;
        return _this;
    }
    SurveyTextWorkerJsonUnknownPropertyErrorFixer.prototype.getCorrectAt = function (text, at, end) {
        var propName = this.propertyName;
        if (!propName)
            return at;
        return this.getNewIndex(text, this.propertyName, at, end);
    };
    return SurveyTextWorkerJsonUnknownPropertyErrorFixer;
}(SurveyTextWorkerJsonErrorFixer));
var SurveyTextWorkerJsonArrayPropertyErrorFixer = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyTextWorkerJsonArrayPropertyErrorFixer, _super);
    function SurveyTextWorkerJsonArrayPropertyErrorFixer(element, jsonObj, propertyName) {
        var _this = _super.call(this, element, jsonObj, propertyName) || this;
        _this.element = element;
        _this.jsonObj = jsonObj;
        _this.propertyName = propertyName;
        return _this;
    }
    Object.defineProperty(SurveyTextWorkerJsonArrayPropertyErrorFixer.prototype, "isFixable", {
        get: function () { return true; },
        enumerable: false,
        configurable: true
    });
    SurveyTextWorkerJsonArrayPropertyErrorFixer.prototype.updatedJsonObjOnFix = function (json) {
        var obj = json[this.propertyName];
        if (obj && !Array.isArray(obj)) {
            json[this.propertyName] = [obj];
        }
    };
    return SurveyTextWorkerJsonArrayPropertyErrorFixer;
}(SurveyTextWorkerJsonUnknownPropertyErrorFixer));
var SurveyTextWorkerJsonDuplicateNameErrorFixer = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyTextWorkerJsonDuplicateNameErrorFixer, _super);
    function SurveyTextWorkerJsonDuplicateNameErrorFixer() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(SurveyTextWorkerJsonDuplicateNameErrorFixer.prototype, "isFixable", {
        get: function () { return true; },
        enumerable: false,
        configurable: true
    });
    SurveyTextWorkerJsonDuplicateNameErrorFixer.prototype.getCorrectAt = function (text, at, end) {
        var newAt = this.getNewIndex(text, "name:", at, end);
        if (newAt > at)
            return newAt;
        return this.getNewIndex(text, "\"name\":", at, end);
    };
    SurveyTextWorkerJsonDuplicateNameErrorFixer.prototype.updatedJsonObjOnFix = function (json) {
        var _a;
        var el = this.element;
        if ((_a = el.survey) === null || _a === void 0 ? void 0 : _a.runEndLoadingFromJson) {
            el.survey.runEndLoadingFromJson();
        }
        json["name"] = _survey_helper__WEBPACK_IMPORTED_MODULE_2__.SurveyHelper.getNewElementName(el);
    };
    return SurveyTextWorkerJsonDuplicateNameErrorFixer;
}(SurveyTextWorkerJsonErrorFixer));
var SurveyTextWorkerJsonRequiredPropertyErrorFixer = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyTextWorkerJsonRequiredPropertyErrorFixer, _super);
    function SurveyTextWorkerJsonRequiredPropertyErrorFixer(element, jsonObj, propertyName) {
        var _this = _super.call(this, element, jsonObj) || this;
        _this.element = element;
        _this.jsonObj = jsonObj;
        _this.propertyName = propertyName;
        return _this;
    }
    Object.defineProperty(SurveyTextWorkerJsonRequiredPropertyErrorFixer.prototype, "isFixable", {
        get: function () { return this.propertyName === "name"; },
        enumerable: false,
        configurable: true
    });
    SurveyTextWorkerJsonRequiredPropertyErrorFixer.prototype.updatedJsonObjOnFix = function (json) {
        var name = this.element["name"];
        if (!name)
            name = _survey_helper__WEBPACK_IMPORTED_MODULE_2__.SurveyHelper.getNewElementName(this.element);
        json["name"] = name;
    };
    return SurveyTextWorkerJsonRequiredPropertyErrorFixer;
}(SurveyTextWorkerJsonErrorFixer));
var SurveyTextWorkerJsonError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(SurveyTextWorkerJsonError, _super);
    function SurveyTextWorkerJsonError(jsonError) {
        var _this = _super.call(this, jsonError.at, jsonError.getFullDescription()) || this;
        _this.elementStart = jsonError.at;
        _this.elementEnd = jsonError.end;
        _this.element = jsonError.element;
        _this.errorType = jsonError.type;
        _this.propertyName = jsonError["propertyName"];
        _this.jsonObj = jsonError.jsonObj;
        return _this;
    }
    SurveyTextWorkerJsonError.prototype.createFixer = function () {
        if (this.errorType === "unknownproperty")
            return new SurveyTextWorkerJsonUnknownPropertyErrorFixer(this.element, this.jsonObj, this.propertyName);
        if (this.errorType === "arrayproperty")
            return new SurveyTextWorkerJsonArrayPropertyErrorFixer(this.element, this.jsonObj, this.propertyName);
        if (this.errorType === "duplicatename")
            return new SurveyTextWorkerJsonDuplicateNameErrorFixer(this.element, this.jsonObj);
        if (this.errorType === "requiredproperty")
            return new SurveyTextWorkerJsonRequiredPropertyErrorFixer(this.element, this.jsonObj, this.propertyName);
        return _super.prototype.createFixer.call(this);
    };
    SurveyTextWorkerJsonError.prototype.getErrorType = function () { return this.errorType; };
    Object.defineProperty(SurveyTextWorkerJsonError.prototype, "isFixable", {
        get: function () { return this.fixer.isFixable && this.elementStart > -1 && this.elementEnd > this.elementStart; },
        enumerable: false,
        configurable: true
    });
    SurveyTextWorkerJsonError.prototype.correctAt = function (text) {
        var newAt = this.fixer.getCorrectAt(text, this.at, this.elementEnd);
        if (newAt > -1) {
            this.at = newAt;
        }
    };
    SurveyTextWorkerJsonError.prototype.fixError = function (text) {
        return this.fixer.fixError(text, this.elementStart, this.elementEnd);
    };
    return SurveyTextWorkerJsonError;
}(SurveyTextWorkerError));

var SurveyTextWorker = /** @class */ (function () {
    function SurveyTextWorker(text) {
        this.text = text;
        if (!this.text || this.text.trim() == "") {
            this.text = "{}";
        }
        this.errors = [];
        this.process();
    }
    Object.defineProperty(SurveyTextWorker.prototype, "survey", {
        get: function () {
            return this.surveyValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyTextWorker.prototype, "isJsonCorrect", {
        get: function () {
            return !!this.surveyValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SurveyTextWorker.prototype, "isJsonHasErrors", {
        get: function () {
            return this.errors.length > 0 || !this.isJsonCorrect;
        },
        enumerable: false,
        configurable: true
    });
    SurveyTextWorker.prototype.process = function () {
        var _this = this;
        try {
            this.jsonValue = new _json5__WEBPACK_IMPORTED_MODULE_3__.SurveyJSON5(1).parse(this.text);
        }
        catch (error) {
            this.errors.push(new SurveyTextWorkerParserError(error.at, error.message));
        }
        if (this.jsonValue != null) {
            this.updateJsonPositions(this.jsonValue);
            if (!!SurveyTextWorker.onProcessJson) {
                SurveyTextWorker.onProcessJson(this.jsonValue);
            }
            this.surveyValue = new SurveyForTextWorker(this.jsonValue);
            var jsonErrors = this.surveyValue.jsonErrors;
            if (Array.isArray(jsonErrors)) {
                for (var i = 0; i < jsonErrors.length; i++) {
                    var error = new SurveyTextWorkerJsonError(jsonErrors[i]);
                    error.correctAt(this.text);
                    this.errors.push(error);
                }
            }
            this.getDuplicatedNamesErrors().forEach(function (error) { return _this.errors.push(error); });
        }
        this.setErrorsPositionByChartAt();
    };
    SurveyTextWorker.prototype.updateJsonPositions = function (jsonObj) {
        jsonObj["pos"]["self"] = jsonObj;
        for (var key in jsonObj) {
            var obj = jsonObj[key];
            if (obj && obj["pos"]) {
                jsonObj["pos"][key] = obj["pos"];
                this.updateJsonPositions(obj);
            }
        }
    };
    SurveyTextWorker.prototype.setErrorsPositionByChartAt = function () {
        if (this.errors.length === 0)
            return;
        this.errors.sort(function (el1, el2) {
            if (el1.at > el2.at)
                return 1;
            if (el1.at < el2.at)
                return -1;
            return 0;
        });
        var position = { row: 0, column: 0 };
        var startAt = 0;
        for (var i = 0; i < this.errors.length; i++) {
            var at = this.errors[i].at;
            position = this.getPostionByChartAt(position, startAt, at);
            var error = this.errors[i];
            if (at == error.at) {
                error.columnAt = position.column;
                error.rowAt = position.row;
            }
            startAt = at;
        }
    };
    SurveyTextWorker.prototype.getPostionByChartAt = function (startPosition, startAt, at) {
        var result = { row: startPosition.row, column: startPosition.column };
        var curChar = startAt;
        while (curChar < at) {
            if (this.text.charAt(curChar) == SurveyTextWorker.newLineChar) {
                result.row++;
                result.column = 0;
            }
            else {
                result.column++;
            }
            curChar++;
        }
        return result;
    };
    SurveyTextWorker.prototype.getDuplicatedNamesErrors = function () {
        var _this = this;
        var res = [];
        this.getDuplicatedElements().forEach(function (el) {
            var error = new SurveyTextWorkerJsonError(_this.createDuplicatedError(el));
            error.correctAt(_this.text);
            if (error)
                res.push(error);
        });
        return res;
    };
    SurveyTextWorker.prototype.getDuplicatedElements = function () {
        var _this = this;
        var res = [];
        var names = {};
        this.survey.pages.forEach(function (p) { return _this.checkDuplicatedElement(p, names, res); });
        _survey_helper__WEBPACK_IMPORTED_MODULE_2__.SurveyHelper.getAllElements(this.survey, true).forEach(function (p) { return _this.checkDuplicatedElement(p, names, res); });
        _survey_helper__WEBPACK_IMPORTED_MODULE_2__.SurveyHelper.getAllElements(this.survey, false).forEach(function (q) { return _this.checkDuplicatedElement(q, names, res); });
        return res;
    };
    SurveyTextWorker.prototype.checkDuplicatedElement = function (el, names, duplicates) {
        var name = el["name"];
        if (names[name]) {
            duplicates.push(el);
        }
        else {
            names[name] = true;
        }
    };
    SurveyTextWorker.prototype.createDuplicatedError = function (el) {
        var pos = el["pos"];
        if (!pos)
            return undefined;
        var error = new survey_core__WEBPACK_IMPORTED_MODULE_1__.JsonError("duplicatename", "The name: '" + el["name"] + "' is duplicated.");
        error.at = pos.start;
        error.end = pos.end;
        error.element = el;
        return error;
    };
    SurveyTextWorker.newLineChar = "\n";
    return SurveyTextWorker;
}());

var JsonDuplicateNameError = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(JsonDuplicateNameError, _super);
    function JsonDuplicateNameError(el) {
        var _this = _super.call(this, "duplicatename", "The name: '" + el["name"] + "' is duplicated.") || this;
        _this.element = el;
        return _this;
    }
    return JsonDuplicateNameError;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.JsonError));



/***/ }),

/***/ "./src/toolbox.ts":
/*!************************!*\
  !*** ./src/toolbox.ts ***!
  \************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   QuestionToolbox: () => (/* binding */ QuestionToolbox),
/* harmony export */   QuestionToolboxCategory: () => (/* binding */ QuestionToolboxCategory),
/* harmony export */   QuestionToolboxItem: () => (/* binding */ QuestionToolboxItem)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ./editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ./creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _components_toolbox_toolbox_search_manager__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ./components/toolbox/toolbox-search-manager */ "./src/components/toolbox/toolbox-search-manager.ts");





var QuestionToolboxCategory = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionToolboxCategory, _super);
    function QuestionToolboxCategory(toolbox) {
        var _this = _super.call(this) || this;
        _this.toolbox = toolbox;
        return _this;
    }
    Object.defineProperty(QuestionToolboxCategory.prototype, "collapsed", {
        get: function () {
            return !this.forceExpand && this.collapsedValue;
        },
        set: function (val) {
            this.collapsedValue = val;
        },
        enumerable: false,
        configurable: true
    });
    QuestionToolboxCategory.prototype.toggleState = function () {
        if (this.toolbox) {
            this.toolbox.toggleCategoryState(this.name);
        }
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionToolboxCategory.prototype, "name", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionToolboxCategory.prototype, "title", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.propertyArray)()
    ], QuestionToolboxCategory.prototype, "items", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], QuestionToolboxCategory.prototype, "collapsedValue", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], QuestionToolboxCategory.prototype, "forceExpand", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionToolboxCategory.prototype, "empty", void 0);
    return QuestionToolboxCategory;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Base));

/**
 * A toolbox item instance.
 *
 * An object of this class is returned by the `QuestionToolbox`'s [`getItemByName(name)`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#getItemByName) method.
 */
var QuestionToolboxItem = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionToolboxItem, _super);
    function QuestionToolboxItem(item) {
        var _this = _super.call(this, item) || this;
        _this.item = item;
        if (!_this.id) {
            _this.id = _this.name;
        }
        var originalCss = _this.css;
        _this.css = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
            var _a;
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("svc-toolbox__tool")
                .append("svc-toolbox__tool--action")
                .append(originalCss)
                .append("svc-toolbox__tool--pressed", _this.isPressed)
                .append("svc-toolbox__tool--has-icon", !!_this.iconName)
                .append("svc-toolbox__tool--has-subitems", !!(((_a = _this.items) === null || _a === void 0 ? void 0 : _a.length) > 0))
                .append("svc-toolbox__tool--disabled", _this.enabled === false)
                .append("sv-action--hidden", !_this.isVisible)
                .toString();
        });
        return _this;
    }
    QuestionToolboxItem.getItemClassNames = function (iconName) {
        return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
            .append("svc-toolbox__item")
            .append("svc-toolbox__item--has-icon", !!iconName)
            .append("svc-toolbox__item--" + iconName, !!iconName)
            .toString();
    };
    Object.defineProperty(QuestionToolboxItem.prototype, "title", {
        /**
         * A user-friendly toolbox item title.
         */
        get: function () {
            return this.getTitle();
        },
        set: function (val) {
            this.setTitle(val);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolboxItem.prototype, "enabled", {
        /**
         * Specifies whether users can interact with the toolbox item.
         *
         * Default value: `true`
         */
        get: function () {
            return this.getEnabled();
        },
        set: function (val) {
            this.setEnabled(val);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolboxItem.prototype, "renderedCss", {
        get: function () {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("svc-toolbox__item")
                .append(this.className)
                .append("svc-toolbox__item--has-subitems", this.hasSubItems).toString();
        },
        enumerable: false,
        configurable: true
    });
    QuestionToolboxItem.prototype.toJSON = function () {
        return this.item;
    };
    Object.defineProperty(QuestionToolboxItem.prototype, "typeName", {
        get: function () {
            if (!!this.json && !!this.json.type)
                return this.json.type;
            return this.name;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolboxItem.prototype, "isPanel", {
        get: function () {
            var type = this.typeName;
            return !!type && survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.isDescendantOf(type, "panelbase");
        },
        enumerable: false,
        configurable: true
    });
    QuestionToolboxItem.prototype.getArea = function (target) {
        return target.closest("#scrollableDiv-designer");
    };
    QuestionToolboxItem.prototype.hasText = function (text) {
        if (!text)
            return;
        var textLowerCase = text.toLowerCase();
        return this.title.toLowerCase().indexOf(textLowerCase) >= 0 || this.name.toLowerCase().indexOf(textLowerCase) >= 0;
    };
    /**
     * Finds a subitem with a specified name in the collection of subitems belonging to this toolbox item.
     *
     * [Manage Toolbox Subitems](https://surveyjs.io/survey-creator/documentation/toolbox-customization#manage-toolbox-subitems (linkStyle))
     * @param name A subitem [`name`](https://surveyjs.io/survey-creator/documentation/api-reference/iquestiontoolboxitem#name).
     * @returns A [`QuestionToolboxItem`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolboxitem) object that represents the subitem instance.
     */
    QuestionToolboxItem.prototype.getSubitem = function (name) {
        var _a;
        return (_a = this.items) === null || _a === void 0 ? void 0 : _a.filter(function (i) { return i.id === name; })[0];
    };
    QuestionToolboxItem.prototype.addSubitems = function (items) {
        if (!items || items.length < 1)
            return;
        this.setSubItems({ items: items });
        this.popupModel.getAreaCallback = this.getArea;
        this.component = QuestionToolbox.defaultItemGroupComponent;
    };
    /**
     * Removes all subitems from this toolbox item.
     *
     * [Manage Toolbox Subitems](https://surveyjs.io/survey-creator/documentation/toolbox-customization#manage-toolbox-subitems (linkStyle))
     * @see removeSubitem
     * @see addSubitem
     */
    QuestionToolboxItem.prototype.clearSubitems = function () {
        if (this.hasSubItems) {
            this.items = [];
            this.component = "";
            this.popupModel.dispose();
        }
    };
    /**
     * Adds a subitem to this toolbox item.
     *
     * [Manage Toolbox Subitems](https://surveyjs.io/survey-creator/documentation/toolbox-customization#manage-toolbox-subitems (linkStyle))
     * @param subitem An [`IQuestionToolboxItem`](https://surveyjs.io/survey-creator/documentation/api-reference/iquestiontoolboxitem) object that represents a subitem configuration.
     * @param index *(Optional)* A zero-based index at which to insert the subitem. If you do not specify this parameter, the subitem is added to the end.
     * @see removeSubitem
     * @see clearSubitems
     */
    QuestionToolboxItem.prototype.addSubitem = function (subitem, index) {
        if (index === void 0) { index = -1; }
        if (!subitem)
            return;
        var newItem = new QuestionToolboxItem(subitem);
        newItem.iconName = "";
        if (!newItem.className)
            newItem.className = QuestionToolboxItem.getItemClassNames(newItem.iconName);
        newItem.className = new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder().append(newItem.className).append("svc-toolbox__item-subtype").toString();
        var array = (this.items || []).slice();
        if (index === -1) {
            array.push(newItem);
        }
        else {
            array.splice(index, 0, newItem);
        }
        this.addSubitems(array);
    };
    /**
     * Removes a specific subitem from this toolbox item.
     *
     * [Manage Toolbox Subitems](https://surveyjs.io/survey-creator/documentation/toolbox-customization#manage-toolbox-subitems (linkStyle))
     * @param subitem A subitem [`name`](https://surveyjs.io/survey-creator/documentation/api-reference/iquestiontoolboxitem#name) or an [`IQuestionToolboxItem`](https://surveyjs.io/survey-creator/documentation/api-reference/iquestiontoolboxitem) object that represents a subitem configuration.
     * @see clearSubitems
     * @see addSubitem
     */
    QuestionToolboxItem.prototype.removeSubitem = function (subitem) {
        if (!this.hasSubItems || !subitem)
            return;
        var id = (subitem === null || subitem === void 0 ? void 0 : subitem.id) || subitem;
        if (!id)
            return;
        var removedItem = this.getSubitem(id);
        var array = (this.items || []).slice();
        var removedIndex = array.indexOf(removedItem);
        if (removedIndex > -1) {
            array.splice(removedIndex, 1);
        }
        if (array.length == 0) {
            this.clearSubitems();
        }
        else {
            this.addSubitems(array);
        }
    };
    Object.defineProperty(QuestionToolboxItem.prototype, "subitemsButtonIcon", {
        get: function () {
            return "icon-next_16x16";
        },
        enumerable: false,
        configurable: true
    });
    return QuestionToolboxItem;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Action));

/**
 * An object that enables you to modify Survey Creator's Toolbox. To access this object, use the [`toolbox`](https://surveyjs.io/survey-creator/documentation/api-reference/survey-creator#toolbox) property on a Survey Creator instance:
 *
 * ```js
 * const creatorOptions = { ... };
 * const creator = new SurveyCreator.SurveyCreator(creatorOptions);
 * creator.toolbox.settingName = "value";
 *
 * // In modular applications:
 * import { SurveyCreatorModel } from "survey-creator-core";
 *
 * const creatorOptions = { ... };
 * const creator = new SurveyCreatorModel(creatorOptions);
 * creator.toolbox.settingName = "value";
 * ```
 *
 * [Toolbox Customization](https://surveyjs.io/survey-creator/documentation/toolbox-customization (linkStyle))
 */
var QuestionToolbox = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(QuestionToolbox, _super);
    function QuestionToolbox(supportedQuestions, creator, useDefaultCategories) {
        if (supportedQuestions === void 0) { supportedQuestions = null; }
        if (creator === void 0) { creator = null; }
        if (useDefaultCategories === void 0) { useDefaultCategories = false; }
        var _this = _super.call(this) || this;
        _this.supportedQuestions = supportedQuestions;
        _this.creator = creator;
        _this._orderedQuestions = [
            "radiogroup", "rating", "checkbox", "dropdown", "tagbox", "boolean", "file", "imagepicker", "ranking",
            "text", "comment", "multipletext",
            "panel", "paneldynamic",
            "matrix", "matrixdropdown", "matrixdynamic",
            "html", "expression", "image", "signaturepad"
        ];
        _this.copiedItemMaxCount = 3;
        _this.allowExpandMultipleCategoriesValue = false;
        _this.keepAllCategoriesExpandedValue = false;
        _this.compactAnimation = new survey_core__WEBPACK_IMPORTED_MODULE_1__.AnimationBoolean(_this.getAnimationOptions(), function (val) {
            _this.isCompactRendered = !val;
        }, function () { return !_this.isCompactRendered; });
        _this.categoriesTitles = {};
        _this.searchManager = new _components_toolbox_toolbox_search_manager__WEBPACK_IMPORTED_MODULE_4__.SearchManagerToolbox();
        _this.subItemsShowDelay = 0;
        _this.searchManager.isVisible = _this.searchEnabled;
        _this.searchManager.toolbox = _this;
        _this.searchItem = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: "searchItem-id",
            css: "svc-toolbox__tool svc-toolbox__search-button",
            innerCss: "svc-toolbox__item sv-dots__item",
            iconName: "icon-search",
            iconSize: "auto",
            component: "sv-action-bar-item",
            tooltip: survey_core__WEBPACK_IMPORTED_MODULE_1__.surveyLocalization.getString("search"),
            action: function () {
                _this.rootElement.querySelector("input").focus();
                _this.isFocused = true;
            }
        });
        _this.updateResponsiveness(_this.isCompact, _this.overflowBehavior);
        _this.createDefaultItems(supportedQuestions, useDefaultCategories);
        _this.initDotsItem();
        return _this;
    }
    Object.defineProperty(QuestionToolbox.prototype, "itemSelector", {
        get: function () {
            return ".svc-toolbox__category>.svc-toolbox__tool--action";
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "containerSelector", {
        get: function () {
            return ".svc-scroll__scroller";
        },
        enumerable: false,
        configurable: true
    });
    QuestionToolbox.getQuestionDefaultSettings = function (questionType) {
        if (!_creator_settings__WEBPACK_IMPORTED_MODULE_3__.settings.toolbox || !_creator_settings__WEBPACK_IMPORTED_MODULE_3__.settings.toolbox.defaultJSON)
            return undefined;
        return _creator_settings__WEBPACK_IMPORTED_MODULE_3__.settings.toolbox.defaultJSON[questionType];
    };
    QuestionToolbox.getSubTypePropertyName = function (questionType) {
        var propertyName = "";
        if (questionType === "text")
            propertyName = "inputType";
        if (questionType === "rating")
            propertyName = "rateType";
        return propertyName;
    };
    Object.defineProperty(QuestionToolbox.prototype, "orderedQuestions", {
        get: function () {
            return this._orderedQuestions;
        },
        set: function (questions) {
            this._orderedQuestions = questions;
            this.reorderItems();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "toolboxNoResultsFound", {
        get: function () { return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("ed.toolboxNoResultsFound"); },
        enumerable: false,
        configurable: true
    });
    QuestionToolbox.prototype.updateResponsiveness = function (isCompact, overflowBehavior) {
        if (overflowBehavior == "scroll" && this.creator && !this.creator.isTouch ||
            this.creator && this.creator.toolboxLocation === "sidebar") {
            this.isResponsivenessDisabled = true;
            this.updateCallback && this.updateCallback(true);
            return;
        }
        if (this.hasCategories && this.showCategoryTitles) {
            if (isCompact) {
                this.isResponsivenessDisabled = false;
                this.raiseUpdate(true);
            }
            else {
                this.isResponsivenessDisabled = true;
                this.setActionsMode("large");
            }
            return;
        }
        this.isResponsivenessDisabled = false;
        this.raiseUpdate(true);
    };
    QuestionToolbox.prototype.getAnimationOptions = function () {
        var _this = this;
        var onBeforeRunAnimation = function (el) {
            el.style.setProperty("--animation-width", getComputedStyle(el).width);
        };
        return {
            getAnimatedElement: function () {
                var _a;
                return (_a = _this.rootElement) === null || _a === void 0 ? void 0 : _a.querySelector(".svc-toolbox__panel");
            },
            isAnimationEnabled: function () { return _this.animationAllowed; },
            getRerenderEvent: function () { return _this.onElementRerendered; },
            getLeaveOptions: function () {
                return {
                    cssClass: "svc-toolbox__panel--leave",
                    onAfterRunAnimation: function () { _this.isFlyoutToCompactRunning = false; },
                    onBeforeRunAnimation: onBeforeRunAnimation
                };
            },
            getEnterOptions: function () {
                return {
                    cssClass: "svc-toolbox__panel--enter",
                    onBeforeRunAnimation: onBeforeRunAnimation
                };
            }
        };
    };
    QuestionToolbox.prototype.initDotsItem = function () {
        var _this = this;
        this.dotsItem.innerCss = "svc-toolbox__item svc-toolbox__item--dots sv-dots__item";
        this.dotsItem.css = new survey_core__WEBPACK_IMPORTED_MODULE_1__.ComputedUpdater(function () {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("svc-toolbox__tool svc-toolbox__tool--dots")
                .append("sv-action--hidden", !_this.dotsItem.isVisible)
                .toString();
        });
        this.dotsItem.popupModel.horizontalPosition = "right";
        this.dotsItem.popupModel.verticalPosition = "top";
        this.dragOrClickHelper = new survey_core__WEBPACK_IMPORTED_MODULE_1__.DragOrClickHelper(function (pointerDownEvent, currentTarget, itemModel) {
            var _a;
            var json = _this.creator.getJSONForNewElement(itemModel.json);
            _this.dotsItem.popupModel.hide();
            (_a = _this.creator) === null || _a === void 0 ? void 0 : _a.onDragDropItemStart();
            _this.dragDropHelper.startDragToolboxItem(pointerDownEvent, json, itemModel);
        });
        this.hiddenItemsListModel.onPointerDown = function (pointerDownEvent, item) {
            if (!_this.creator.readOnly) {
                _this.dragOrClickHelper.onPointerDown(pointerDownEvent, item);
            }
        };
        this.dotsItem.popupModel.cssClass += " svc-toolbox-popup svc-creator-popup";
    };
    QuestionToolbox.prototype.getDefaultQuestionCategories = function () {
        var _this = this;
        var questionCategoryMap = {};
        Object.keys(QuestionToolbox.defaultCategories).forEach(function (key) {
            var cat = QuestionToolbox.defaultCategories[key];
            cat.forEach(function (name) {
                if (!_this.supportedQuestions || _this.supportedQuestions.indexOf(name) != -1) {
                    questionCategoryMap[name] = key;
                }
            });
        });
        return questionCategoryMap;
    };
    QuestionToolbox.prototype.getCategoryTitle = function (name) {
        if (this.categoriesTitles[name])
            return this.categoriesTitles[name];
        return (0,_editorLocalization__WEBPACK_IMPORTED_MODULE_2__.getLocString)("toolboxCategories." + name);
    };
    QuestionToolbox.prototype.onActiveCategoryChanged = function (newValue) {
        var categories = this.categories;
        //if(!this.allowExpandMultipleCategories) {
        for (var i = 0; i < categories.length; i++) {
            var category = categories[i];
            category.collapsed = category.name !== newValue;
        }
        //}
    };
    Object.defineProperty(QuestionToolbox.prototype, "showSearch", {
        get: function () {
            return this.searchEnabled && this.items.length > QuestionToolbox.MINELEMENTCOUNT;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "showInSingleCategory", {
        get: function () {
            return this.isCompactRendered || this.categories.length == 1 || !this.showCategoryTitles;
        },
        enumerable: false,
        configurable: true
    });
    QuestionToolbox.prototype.setRootElement = function (element) {
        this._rootElementValue = element;
        this._containerElementValue = element === null || element === void 0 ? void 0 : element.querySelector(this.containerSelector);
    };
    Object.defineProperty(QuestionToolbox.prototype, "containerElement", {
        get: function () {
            return this._containerElementValue;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "rootElement", {
        get: function () {
            return this._rootElementValue;
        },
        enumerable: false,
        configurable: true
    });
    QuestionToolbox.prototype.focusOut = function (e) {
        if (e.relatedTarget !== e.currentTarget &&
            !e.currentTarget.contains(e.relatedTarget)) {
            this.isFocused = false;
            this.searchManager.filterString = "";
        }
    };
    Object.defineProperty(QuestionToolbox.prototype, "classNames", {
        get: function () {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("svc-toolbox")
                .append("svc-toolbox--searchable", this.searchEnabled)
                .append("svc-toolbox--no-separators", !this.showSeparators)
                .append("svc-toolbox--flyout-to-compact-running", this.isFlyoutToCompactRunning)
                .append("svc-toolbox--compact", this.isCompactRendered)
                .append("svc-toolbox--flyout", this.isCompact && this.isFocused)
                .append("svc-toolbox--scrollable", this.overflowBehavior == "scroll").toString();
        },
        enumerable: false,
        configurable: true
    });
    QuestionToolbox.prototype.setLocation = function (toolboxLocation) {
        if (toolboxLocation === "sidebar") {
            this.visibleActions.forEach(function (item) { return (item.mode = "small"); });
        }
        else {
            this.dotsItem.popupModel.horizontalPosition = this.creator.toolboxLocation == "right" ? "left" : "right";
        }
        this.updateResponsiveness(this.isCompact, this.overflowBehavior);
    };
    Object.defineProperty(QuestionToolbox.prototype, "jsonText", {
        get: function () {
            return JSON.stringify(this.actions);
        },
        set: function (value) {
            this.actions = (value ? JSON.parse(value) : []).map(function (action) { return new QuestionToolboxItem(action); });
            this.onItemsChanged();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "copiedJsonText", {
        get: function () {
            return JSON.stringify(this.copiedItems);
        },
        set: function (value) {
            var newItems = value ? JSON.parse(value) : [];
            this.clearCopiedItems();
            for (var i = 0; i < newItems.length; i++) {
                newItems[i].isCopied = true;
                this.addItem(newItems[i]);
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "items", {
        /**
         * An array of toolbox items.
         * @see getItemByName
         * @see addItem
         * @see removeItem
         */
        get: function () {
            return this.actions;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "itemNames", {
        get: function () {
            var res = [];
            for (var i = 0; i < this.items.length; i++) {
                res.push(this.items[i].typeName);
            }
            return res;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "copiedItems", {
        get: function () {
            var result = [];
            for (var i = 0; i < this.actions.length; i++) {
                if (this.actions[i].isCopied)
                    result.push(this.actions[i]);
            }
            return result;
        },
        enumerable: false,
        configurable: true
    });
    QuestionToolbox.prototype.addItems = function (items, clearAll) {
        if (clearAll === void 0) { clearAll = false; }
        if (clearAll) {
            this.clearItems();
        }
        for (var i = 0; i < items.length; i++) {
            this.actions.push(this.getOrCreateToolboxItem(items[i]));
        }
        this.onItemsChanged();
    };
    QuestionToolbox.prototype.addCopiedItem = function (question, options) {
        if (options === void 0) { options = null; }
        if (!options)
            options = {};
        var name = !!options.name ? options.name : question.name;
        var title = !!options.title ? options.title : name;
        var tooltip = !!options.tooltip ? options.tooltip : title;
        var iconName = !!options.iconName ? options.iconName : QuestionToolbox.defaultIconName;
        var item = {
            id: name,
            name: name,
            title: title,
            tooltip: tooltip,
            className: QuestionToolboxItem.getItemClassNames(iconName),
            isCopied: options.isCopied !== false,
            iconName: iconName,
            json: !!options.json ? options.json : this.getQuestionJSON(question),
            category: !!options.category ? options.category : ""
        };
        if (this.replaceItem(item))
            return;
        var copied = this.copiedItems;
        if (this.copiedItemMaxCount > 0 && copied.length == this.copiedItemMaxCount)
            this.removeItem(copied[this.copiedItemMaxCount - 1].name);
        this.addItem(item);
    };
    QuestionToolbox.prototype.getOrCreateToolboxItem = function (item) {
        if (item instanceof QuestionToolboxItem) {
            return item;
        }
        else {
            item.iconName = item.iconName ? item.iconName : QuestionToolbox.defaultIconName;
            var newItem = new QuestionToolboxItem(item);
            var newItems = this.createSubTypes(newItem);
            if (newItems) {
                newItem.addSubitems(newItems);
            }
            return newItem;
        }
    };
    QuestionToolbox.prototype.createSubTypes = function (parentItem) {
        var property = null;
        var propName = QuestionToolbox.getSubTypePropertyName(parentItem.id);
        if (propName)
            property = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.findProperty(parentItem.id, propName);
        if (!property || !property.visible)
            return;
        var newItems = property.choices.map(function (ch) {
            var newJson = (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__assign)({}, parentItem.json);
            newJson[propName] = ch;
            var newId = parentItem.id != ch ? ch : parentItem.id + "-default";
            var innerItem = new QuestionToolboxItem({
                id: newId,
                name: newId,
                title: _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getPropertyValueInEditor(propName, ch),
                className: QuestionToolboxItem.getItemClassNames() + " svc-toolbox__item-subtype",
                json: newJson,
                iconName: null,
                category: null,
                isCopied: false,
                component: QuestionToolbox.defaultItemComponent
            });
            innerItem.propName = propName;
            innerItem.propValue = ch;
            return innerItem;
        });
        return newItems;
    };
    /**
     * Adds a new item to the Toolbox.
     * @param item A [toolbox item configuration](https://surveyjs.io/survey-creator/documentation/api-reference/iquestiontoolboxitem).
     * @param index *(Optional)* A zero-based index at which to insert the item. If you do not specify this parameter, the item is added to the end.
     * @see removeItem
     * @see replaceItem
     * @see items
     */
    QuestionToolbox.prototype.addItem = function (item, index) {
        this.correctItem(item);
        var action = this.getOrCreateToolboxItem(item);
        if (index === undefined) {
            this.actions.push(action);
        }
        else {
            this.actions.splice(index, 0, action);
        }
        this.onItemsChanged();
    };
    QuestionToolbox.prototype.correctItem = function (item) {
        if (!item.title)
            item.title = item.name;
        if (!item.tooltip)
            item.tooltip = item.title;
    };
    Object.defineProperty(QuestionToolbox.prototype, "dragDropHelper", {
        get: function () {
            return this.creator.dragDropSurveyElements;
        },
        enumerable: false,
        configurable: true
    });
    /**
     * Adds a new toolbox item and deletes an existing item with the same name (if there is any).
     * @param item A [toolbox item configuration](https://surveyjs.io/survey-creator/documentation/api-reference/iquestiontoolboxitem).
     * @see addItem
     */
    QuestionToolbox.prototype.replaceItem = function (item) {
        this.correctItem(item);
        var index = this.indexOf(item.name);
        if (index < 0)
            return;
        this.actions[index] = this.getOrCreateToolboxItem(item);
        this.onItemsChanged();
        return true;
    };
    /**
     * Removes a [toolbox item](https://surveyjs.io/survey-creator/documentation/api-reference/iquestiontoolboxitem) with a specified name.
     * @param name A toolbox item's [`name`](https://surveyjs.io/survey-creator/documentation/api-reference/iquestiontoolboxitem#name).
     * @returns `true` if the item is successfully deleted or `false` otherwise.
     * @see clearItems
     * @see addItem
     * @see items
     */
    QuestionToolbox.prototype.removeItem = function (name) {
        var index = this.indexOf(name);
        if (index < 0)
            return false;
        this.actions.splice(index, 1);
        this.onItemsChanged();
        return true;
    };
    /**
     * Removes all items from the Toolbox.
     * @see removeItem
     * @see addItem
     * @see items
     */
    QuestionToolbox.prototype.clearItems = function () {
        this.actions = [];
        this.onItemsChanged();
    };
    QuestionToolbox.prototype.clearCopiedItems = function () {
        var removedItems = this.copiedItems;
        for (var i = 0; i < removedItems.length; i++) {
            this.removeItem(removedItems[i].name);
        }
    };
    /**
     * Returns a [toolbox item](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolboxitem) with a specified name.
     * @param name A toolbox item's [`name`](https://surveyjs.io/survey-creator/documentation/api-reference/iquestiontoolboxitem#name).
     * @returns A toolbox item or `null` if a toolbox item with the specified name isn't found.
     */
    QuestionToolbox.prototype.getItemByName = function (name) {
        if (!name)
            return null;
        var index = this.indexOf(name);
        return index > -1 ? this.actions[index] : null;
    };
    Object.defineProperty(QuestionToolbox.prototype, "allowExpandMultipleCategories", {
        /**
         * Specifies whether more than one category can be in the expanded state at a time. Applies only if [`showCategoryTitles`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#showCategoryTitles) is `true`.
         *
         * If this property is `false`, the currently expanded category collapses when a user expands another category.
         *
         * Default value: `false`
         * @see keepAllCategoriesExpanded
         */
        get: function () {
            return this.allowExpandMultipleCategoriesValue;
        },
        set: function (val) {
            this.allowExpandMultipleCategoriesValue = val;
            this.updateCategoriesState();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "keepAllCategoriesExpanded", {
        /**
         * Specifies whether to expand all categories without the capability to collapse any of them. Applies only if [`showCategoryTitles`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#showCategoryTitles) is `true`.
         * @see allowExpandMultipleCategories
         */
        get: function () {
            return this.keepAllCategoriesExpandedValue || !this.showCategoryTitlesValue;
        },
        set: function (val) {
            this.keepAllCategoriesExpandedValue = val;
            this.canCollapseCategories = !this.keepAllCategoriesExpanded;
            this.updateCategoriesState();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(QuestionToolbox.prototype, "showCategoryTitles", {
        /**
         * Specifies whether to display category titles in the Toolbox.
         *
         * Default value: `false`
         *
         * If this property is disabled, the Toolbox hides the titles but continues to display horizontal lines that divide categories. To remove these lines as well, call the [`removeCategories()`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#removeCategories) method.
         * @see allowExpandMultipleCategories
         * @see keepAllCategoriesExpanded
         */
        get: function () {
            return this.showCategoryTitlesValue;
        },
        set: function (val) {
            this.showCategoryTitlesValue = val;
            this.updateCategoriesState();
        },
        enumerable: false,
        configurable: true
    });
    QuestionToolbox.prototype.updateTitles = function () {
        var _this = this;
        this.actions.forEach(function (action) {
            _this.updateToolboxItemTitle(action);
        });
        if (Array.isArray(this.categories)) {
            this.categories.forEach(function (category) {
                category.title = _this.getCategoryTitle(category.name);
            });
        }
    };
    QuestionToolbox.prototype.updateToolboxItemTitle = function (item) {
        this.updateActionTitle(item);
        this.updateActionTitle(item.innerItem);
        if (!Array.isArray(item.items))
            return;
        item.items.forEach(function (subItem) {
            var propName = subItem.propName;
            var propValue = subItem.propValue;
            if (!!propName && !!propValue) {
                subItem.title = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getPropertyValueInEditor(propName, propValue);
            }
        });
    };
    QuestionToolbox.prototype.updateActionTitle = function (action) {
        var newTitle = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("qt." + action.id);
        if (!!newTitle && newTitle !== action.id) {
            action.title = newTitle;
            action.tooltip = newTitle;
        }
    };
    QuestionToolbox.prototype.updateCategoriesState = function () {
        var noActive = this.allowExpandMultipleCategories || this.keepAllCategoriesExpanded;
        if (noActive) {
            this.activeCategory = "";
            if (this.keepAllCategoriesExpandedValue) {
                this.expandAllCategories();
            }
        }
        else {
            if (this.categories.length > 0) {
                this.activeCategory = this.categories[0].name;
            }
        }
    };
    /**
     * Changes the category of a toolbox item.
     * @param itemName A toolbox item's [`name`](https://surveyjs.io/survey-creator/documentation/api-reference/iquestiontoolboxitem#name).
     * @param categoryName A new category name. Out-of-the-box category names include `"general"`, `"choice"`, `"text"`, `"containers"`, `"matrix"`, and `"misc"`.
     * @see defineCategories
     */
    QuestionToolbox.prototype.changeCategory = function (itemName, categoryName) {
        this.changeCategories([{ name: itemName, category: categoryName }]);
    };
    /**
     * Changes the categories of multiple toolbox items.
     * @param items An array of objects with the following structure: `{ name: "toolboxItemName", category: "newCategoryName" }`.
     * @see defineCategories
     */
    QuestionToolbox.prototype.changeCategories = function (items) {
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            var toolboxItem = this.getItemByName(item.name);
            if (toolboxItem) {
                toolboxItem.category = item.category;
            }
        }
        this.onItemsChanged();
    };
    /**
     * Defines toolbox categories from scratch.
     *
     * This method accepts an array of objects as the `categories` parameter. Each object defines a single category and lists items included into it. Unlisted items can be collected in the Misc category if you pass `true` as the `displayMisc` parameter. Optionally, you can override display titles for individual items.
     *
     * The following code defines two toolbox categories: Dropdowns and Text Input. Items that do not fall into either category are collected in Misc. The `"comment"` item has a custom display title.
     *
     * ```
     * creator.toolbox.defineCategories([{
     *   category: "Dropdowns",
     *   items: [
     *     "dropdown",
     *     "tagbox"
     *   ]
     * }, {
     *   category: "Text Input",
     *   items: [
     *     "text",
     *     // Override the display title
     *     { name: "comment", title: "Multi-Line Input" }
     *   ]
     * }], true);
     * ```
     *
     * [View Demo](https://surveyjs.io/survey-creator/examples/survey-toolbox-categories/ (linkStyle))
     * @param categories An array of new categories.
     * @param displayMisc Pass `true` if you want to collect unlisted toolbox items in the Misc category. Default value: `false`.
     */
    QuestionToolbox.prototype.defineCategories = function (categories, displayMisc) {
        var _this = this;
        if (displayMisc === void 0) { displayMisc = false; }
        if (!Array.isArray(categories))
            return;
        var items = this.getDefaultItems(this.supportedQuestions, false, true, true);
        var itemsHash = {};
        items.forEach(function (item) {
            item.visible = false;
            itemsHash[item.id] = item;
        });
        if (Array.isArray(this.presetDefaultItems)) {
            this.presetDefaultItems.forEach(function (item) {
                var action = itemsHash[item.name];
                if (action) {
                    for (var key in item) {
                        action[key] = item[key];
                    }
                }
                else {
                    if (!!item.json) {
                        var tItem = new QuestionToolboxItem(item);
                        itemsHash[tItem.id] = tItem;
                        items.push(tItem);
                    }
                }
            });
        }
        this.categoriesTitles = {};
        var actionList = new Array();
        categories.forEach(function (category) {
            if (!!category.category && !!category.title) {
                _this.categoriesTitles[category.category] = category.title;
            }
            if (!Array.isArray(category.items))
                return;
            category.items.forEach(function (obj) {
                var name = undefined;
                var title = undefined;
                if (typeof obj === "string") {
                    name = obj;
                }
                else {
                    name = obj.name;
                    title = obj.title;
                }
                var item = itemsHash[name];
                if (item) {
                    item.category = category.category;
                    item.visible = true;
                    if (!!title) {
                        item.title = title;
                    }
                    actionList.push(item);
                }
            });
        });
        if (displayMisc) {
            items.forEach(function (item) {
                if (!item.visible) {
                    item.visible = true;
                    item.category = "misc";
                    actionList.push(item);
                }
            });
        }
        this.setItems(actionList);
        this.onItemsChanged(false);
    };
    /**
     * Removes all categories from the Toolbox.
     */
    QuestionToolbox.prototype.removeCategories = function () {
        var allTypes = survey_core__WEBPACK_IMPORTED_MODULE_1__.ElementFactory.Instance.getAllToolboxTypes();
        this.changeCategories(allTypes.map(function (t) { return ({ name: t, category: null }); }));
        this.onItemsChanged();
    };
    QuestionToolbox.prototype.toggleCategoryState = function (categoryName) {
        if (this.keepAllCategoriesExpanded)
            return;
        if (this.allowExpandMultipleCategories) {
            var category = this.getCategoryByName(categoryName);
            if (category) {
                category.collapsed = !category.collapsed;
            }
        }
        else {
            this.activeCategory = categoryName;
        }
    };
    /**
     * Expands a category with a specified name. Applies only if [`showCategoryTitles`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#showCategoryTitles) is `true`.
     *
     * If [`allowExpandMultipleCategories`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#allowExpandMultipleCategories) is `false`, all other categories become collapsed.
     * @param categoryName A category name. Out-of-the-box category names include `"general"`, `"choice"`, `"text"`, `"containers"`, `"matrix"`, and `"misc"`.
     * @see collapseCategory
     */
    QuestionToolbox.prototype.expandCategory = function (categoryName) {
        if (this.allowExpandMultipleCategories) {
            var category = this.getCategoryByName(categoryName);
            if (category) {
                category.collapsed = false;
            }
        }
        else {
            if (this.canCollapseCategories) {
                this.activeCategory = categoryName;
            }
        }
    };
    /**
     * Collapses a category with a specified name. Applies only if [`showCategoryTitles`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#showCategoryTitles) and [`allowExpandMultipleCategories`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#allowExpandMultipleCategories) are `true`.
     * @param categoryName A category name. Out-of-the-box category names include `"general"`, `"choice"`, `"text"`, `"containers"`, `"matrix"`, and `"misc"`.
     * @see expandCategory
     */
    QuestionToolbox.prototype.collapseCategory = function (categoryName) {
        if (!this.allowExpandMultipleCategories)
            return;
        var category = this.getCategoryByName(categoryName);
        if (category) {
            category.collapsed = true;
        }
    };
    /**
     * Expands all categories. Applies only if [`showCategoryTitles`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#showCategoryTitles) and [`allowExpandMultipleCategories`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#allowExpandMultipleCategories) are `true`.
     * @see collapseAllCategories
     */
    QuestionToolbox.prototype.expandAllCategories = function () {
        this.expandCollapseAllCategories(false);
    };
    /**
     * Collapses all categories. Applies only if [`showCategoryTitles`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#showCategoryTitles) and [`allowExpandMultipleCategories`](https://surveyjs.io/survey-creator/documentation/api-reference/questiontoolbox#allowExpandMultipleCategories) are `true`.
     * @see expandAllCategories
     */
    QuestionToolbox.prototype.collapseAllCategories = function () {
        this.expandCollapseAllCategories(true);
    };
    QuestionToolbox.prototype.expandCollapseAllCategories = function (isCollapsed) {
        var categories = this.categories;
        for (var i = 0; i < categories.length; i++) {
            categories[i].collapsed = isCollapsed;
        }
    };
    QuestionToolbox.prototype.getCategoryByName = function (categoryName) {
        var categories = this.categories;
        for (var i = 0; i < categories.length; i++) {
            var category = categories[i];
            if (category.name === categoryName)
                return category;
        }
        return null;
    };
    QuestionToolbox.prototype.onItemsChanged = function (changeActions) {
        var _this = this;
        if (changeActions === void 0) { changeActions = true; }
        var categories = new Array();
        var categoriesHash = {};
        var prevActiveCategory = this.activeCategory;
        var _loop_1 = function (i) {
            var item = this_1.actions[i];
            item.innerItem.action = function () {
                _this.creator.clickToolboxItem(item.json);
            };
            if (item.visible === false)
                return "continue";
            var categoryName = item.category ? item.category : "general";
            if (!categoriesHash[categoryName]) {
                var category = this_1.createCategory();
                category.name = categoryName;
                category.title = this_1.getCategoryTitle(categoryName);
                category.collapsed = categoryName !== prevActiveCategory && !this_1.keepAllCategoriesExpanded;
                categoriesHash[categoryName] = category;
                categories.push(category);
            }
            categoriesHash[categoryName].items.push(item);
        };
        var this_1 = this;
        for (var i = 0; i < this.actions.length; i++) {
            _loop_1(i);
        }
        this.categories = categories;
        if (!this.keepAllCategoriesExpanded) {
            if (!this.allowExpandMultipleCategories) {
                if (prevActiveCategory && categoriesHash[prevActiveCategory]) {
                    this.activeCategory = prevActiveCategory;
                }
                else {
                    this.activeCategory = categories.length > 0 ? categories[0].name : "";
                }
            }
            else {
                if (categories.length > 0) {
                    categories[0].collapsed = false;
                }
            }
        }
        if (changeActions) {
            var newItems_1 = [];
            this.categories.forEach(function (cat) {
                newItems_1 = newItems_1.concat(cat.items);
            });
            this.actions = newItems_1;
        }
        this.hasCategories = categories.length > 1;
        //this.updateCategoriesState();
        this.updateItemSeparators();
        this.updateResponsiveness(this.isCompact, this.overflowBehavior);
    };
    QuestionToolbox.prototype.createCategory = function () {
        return new QuestionToolboxCategory(this);
    };
    QuestionToolbox.prototype.indexOf = function (name) {
        for (var i = 0; i < this.actions.length; i++) {
            if (this.actions[i].name == name)
                return i;
        }
        return -1;
    };
    QuestionToolbox.prototype.updateItemSeparators = function () {
        var categories = this.hasCategories ? this.categories : [{ items: this.actions }];
        categories.forEach(function (category, categoryIndex) {
            (category.items || []).forEach(function (item, index) {
                item.needSeparator = categoryIndex !== 0 && index == 0;
                if (item.innerItem)
                    item.innerItem.needSeparator = item.needSeparator;
            });
        });
    };
    QuestionToolbox.prototype.reorderItems = function () {
        var _this = this;
        this.actions.sort(function (i1, i2) {
            var index1 = _this._orderedQuestions.indexOf(i1.name);
            if (index1 === -1)
                index1 = Number.MAX_VALUE;
            var index2 = _this._orderedQuestions.indexOf(i2.name);
            if (index2 === -1)
                index2 = Number.MAX_VALUE;
            return index1 - index2;
        });
        this.onItemsChanged();
    };
    /**
     * Adds default items to the Toolbox. If the Toolbox contains any items before you call this method, they will be removed.
     * @param supportedQuestions Specifies which question and panel types to include in the Toolbox.
     * @param useDefaultCategories Pass `true` if you want to create default categories.
     */
    QuestionToolbox.prototype.createDefaultItems = function (supportedQuestions, useDefaultCategories) {
        var _this = this;
        supportedQuestions = supportedQuestions || this.supportedQuestions;
        this.clearItems();
        this.getDefaultItems(supportedQuestions, useDefaultCategories, true, true).forEach(function (item) { return _this.addToolBoxItem(item, _this.actions); });
        this.onItemsChanged();
    };
    QuestionToolbox.prototype.getDefaultItems = function (supportedQuestions, useDefaultCategories, includeCustomWidgets, includeComponents) {
        var res = this.getDefaultQuestionItems(supportedQuestions, useDefaultCategories);
        if (includeCustomWidgets) {
            res = res.concat(this.getRegisterCustomWidgets());
        }
        if (includeComponents) {
            res = res.concat(this.getRegisterComponentQuestions());
        }
        return res;
    };
    QuestionToolbox.prototype.getDefaultQuestionItems = function (supportedQuestions, useDefaultCategories) {
        var res = [];
        var questions = this.getQuestionTypes(supportedQuestions);
        var defaultCategories = useDefaultCategories ? this.getDefaultQuestionCategories() : {};
        for (var i = 0; i < questions.length; i++) {
            var name_1 = questions[i];
            var question = survey_core__WEBPACK_IMPORTED_MODULE_1__.ElementFactory.Instance.createElement(name_1, "q1");
            if (!question) {
                question = survey_core__WEBPACK_IMPORTED_MODULE_1__.Serializer.createClass(name_1);
            }
            var json = this.getQuestionJSON(question);
            delete json.name;
            var title = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("qt." + name_1);
            var iconName = "icon-" + name_1;
            var item = {
                id: name_1,
                name: name_1,
                iconName: iconName,
                title: title,
                tooltip: title,
                className: QuestionToolboxItem.getItemClassNames(iconName),
                json: json,
                isCopied: false,
                category: (defaultCategories[name_1] || "")
            };
            res.push(this.getOrCreateToolboxItem(item));
        }
        return res;
    };
    QuestionToolbox.prototype.getRegisterComponentQuestions = function () {
        var _this = this;
        var res = [];
        survey_core__WEBPACK_IMPORTED_MODULE_1__.ComponentCollection.Instance.items.forEach(function (item) {
            var action = _this.createToolboxItemFromJSON(item.json);
            if (!!action) {
                res.push(action);
            }
        });
        return res;
    };
    QuestionToolbox.prototype.getRegisterCustomWidgets = function () {
        var _this = this;
        var res = [];
        survey_core__WEBPACK_IMPORTED_MODULE_1__.CustomWidgetCollection.Instance.widgets.forEach(function (widget) {
            if (widget.canShowInToolbox) {
                var action = _this.createToolboxItemFromJSON(widget.widgetJson);
                if (!!action) {
                    res.push(action);
                }
            }
        });
        return res;
    };
    QuestionToolbox.prototype.addToolBoxItem = function (action, actions) {
        if (!action)
            return;
        var existingAction = this.getActionByIdFromArray(action.id, actions);
        if (!!existingAction) {
            actions.splice(actions.indexOf(existingAction), 1, action);
        }
        else {
            var index = Array.isArray(this.supportedQuestions) ? this.supportedQuestions.indexOf(action.id) : -1;
            if (index > -1) {
                actions.splice(index, 0, action);
            }
            else {
                actions.push(action);
            }
        }
    };
    QuestionToolbox.prototype.getActionByIdFromArray = function (id, actions) {
        for (var i = 0; i < actions.length; i++) {
            if (actions[i].id === id)
                return actions[i];
        }
        return undefined;
    };
    QuestionToolbox.prototype.createToolboxItemFromJSON = function (json) {
        if (json.showInToolbox === false || json.internal === true || !json.name)
            return undefined;
        var iconName = json.iconName ? json.iconName : QuestionToolbox.defaultIconName;
        var title = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("qt." + json.name);
        if (!title || title == json.name) {
            title = this.getTitleFromJsonTitle(json.title, json.name);
        }
        if (!title) {
            title = json.name;
        }
        var elementJson = json.defaultJSON ? JSON.parse(JSON.stringify(json.defaultJSON)) : {};
        if (!elementJson.type) {
            elementJson.type = json.name;
        }
        delete elementJson.name;
        var category = json.category ? json.category : "";
        var item = new survey_core__WEBPACK_IMPORTED_MODULE_1__.Action({
            id: json.name,
            name: json.name,
            iconName: iconName,
            title: title,
            tooltip: title,
            className: QuestionToolboxItem.getItemClassNames(iconName),
            json: elementJson,
            isCopied: false,
            category: category
        });
        return this.getOrCreateToolboxItem(item);
    };
    QuestionToolbox.prototype.getTitleFromJsonTitle = function (title, name) {
        if (!title)
            return title;
        if (typeof title === "string")
            return title;
        if (typeof title !== "object")
            return title;
        for (var key in title) {
            var loc = _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.locales[key];
            if (title[key] && loc && loc.qt) {
                loc.qt[name] = title[key];
            }
        }
        return _editorLocalization__WEBPACK_IMPORTED_MODULE_2__.editorLocalization.getString("qt." + name);
    };
    QuestionToolbox.prototype.getQuestionJSON = function (question) {
        var json = new survey_core__WEBPACK_IMPORTED_MODULE_1__.JsonObject().toJsonObject(question);
        json.type = question.getType();
        var defaultSettings = QuestionToolbox.getQuestionDefaultSettings(json.type);
        if (defaultSettings) {
            for (var key in defaultSettings) {
                json[key] = defaultSettings[key];
            }
        }
        return json;
    };
    QuestionToolbox.prototype.isHiddenCustomWidget = function (name) {
        var widget = survey_core__WEBPACK_IMPORTED_MODULE_1__.CustomWidgetCollection.Instance.getCustomWidgetByName(name);
        return !!widget && !widget.showInToolbox;
    };
    QuestionToolbox.prototype.getQuestionTypes = function (supportedQuestions) {
        var allTypes = survey_core__WEBPACK_IMPORTED_MODULE_1__.ElementFactory.Instance.getAllToolboxTypes();
        if (!supportedQuestions || supportedQuestions.length == 0)
            supportedQuestions = allTypes;
        var questions = [];
        for (var i = 0; i < this.orderedQuestions.length; i++) {
            var name_2 = this.orderedQuestions[i];
            if (supportedQuestions.indexOf(name_2) > -1 && allTypes.indexOf(name_2) > -1)
                questions.push(name_2);
        }
        for (var i = 0; i < supportedQuestions.length; i++) {
            var name = supportedQuestions[i];
            if (questions.indexOf(name) < 0 &&
                allTypes.indexOf(name) > -1 &&
                !this.isHiddenCustomWidget(name))
                questions.push(name);
        }
        return questions;
    };
    QuestionToolbox.MINELEMENTCOUNT = 10;
    QuestionToolbox.defaultIconName = "icon-default";
    QuestionToolbox.defaultItemComponent = "svc-toolbox-item";
    QuestionToolbox.defaultItemGroupComponent = "svc-toolbox-item-group";
    QuestionToolbox.defaultCategories = {
        choice: ["radiogroup", "rating", "checkbox", "dropdown", "tagbox", "boolean", "file", "imagepicker", "ranking"],
        text: ["text", "comment", "multipletext"],
        containers: ["panel", "paneldynamic"],
        matrix: ["matrix", "matrixdropdown", "matrixdynamic"],
        misc: ["html", "expression", "image", "signaturepad"]
    };
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], QuestionToolbox.prototype, "showCategoryTitlesValue", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.propertyArray)()
    ], QuestionToolbox.prototype, "categories", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            defaultValue: "",
            onSet: function (val, target) {
                target.onActiveCategoryChanged(val);
            }
        })
    ], QuestionToolbox.prototype, "activeCategory", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], QuestionToolbox.prototype, "hasCategories", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], QuestionToolbox.prototype, "canCollapseCategories", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            defaultValue: false,
            onSet: function (val, target) {
                target.updateResponsiveness(val, target.overflowBehavior);
                target.compactAnimation.sync(!(val && !target.isFocused));
            }
        })
    ], QuestionToolbox.prototype, "isCompact", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], QuestionToolbox.prototype, "isCompactRendered", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: false })
    ], QuestionToolbox.prototype, "isFlyoutToCompactRunning", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            defaultValue: false,
            onSet: function (val, target) {
                if (target.animationAllowed)
                    target.isFlyoutToCompactRunning = target.isCompact && !val;
                target.compactAnimation.sync(!(target.isCompact && !val));
            }
        })
    ], QuestionToolbox.prototype, "isFocused", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            defaultValue: "scroll",
            onSet: function (val, target) {
                target.updateResponsiveness(target.isCompact, val);
            }
        })
    ], QuestionToolbox.prototype, "overflowBehavior", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionToolbox.prototype, "forceCompact", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({
            defaultValue: true,
            onSet: function (val, target) {
                target.searchManager.isVisible = val;
            }
        })
    ], QuestionToolbox.prototype, "searchEnabled", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], QuestionToolbox.prototype, "showSubitems", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)()
    ], QuestionToolbox.prototype, "showPlaceholder", void 0);
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: true })
    ], QuestionToolbox.prototype, "showSeparators", void 0);
    return QuestionToolbox;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.AdaptiveActionContainer));



/***/ }),

/***/ "./src/utils/actions.ts":
/*!******************************!*\
  !*** ./src/utils/actions.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   MenuButton: () => (/* binding */ MenuButton),
/* harmony export */   findAction: () => (/* binding */ findAction),
/* harmony export */   updateMatixActionsClasses: () => (/* binding */ updateMatixActionsClasses),
/* harmony export */   updateMatrixLogicExpandAction: () => (/* binding */ updateMatrixLogicExpandAction),
/* harmony export */   updateMatrixLogicRemoveAction: () => (/* binding */ updateMatrixLogicRemoveAction),
/* harmony export */   updateMatrixRemoveAction: () => (/* binding */ updateMatrixRemoveAction)
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! tslib */ "./src/entries/helpers.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_1__);


function findAction(actions, id) {
    if (!Array.isArray(actions))
        return null;
    for (var i = 0; i < actions.length; i++) {
        if (actions[i].id === id)
            return actions[i];
    }
    return null;
}
function updateMatrixLogicExpandAction(question, actions, row) {
    var action = findAction(actions, "show-detail");
    if (!action)
        return;
    action.component = "sv-action-bar-item";
    action.iconName = "icon-logic-expand";
    action.innerCss = "sl-table__action-button sl-table__detail-button";
    action.iconSize = "auto";
    action.showTitle = false;
    action.action = function () {
        row.showHideDetailPanelClick();
    };
    var updateIcon = function () { action.iconName = row.isDetailPanelShowing ? "icon-logic-collapse" : "icon-logic-expand"; };
    question.registerFunctionOnPropertyValueChanged("isRowShowing" + row.id, updateIcon);
    updateIcon();
}
function updateMatrixLogicRemoveAction(question, actions, row) {
    updateMatrixRemoveAction(question, actions, row);
    var action = findAction(actions, "remove-row");
    if (!action)
        return;
    action.iconSize = "auto";
    action.css = "sl-table__action-button sl-table__remove-button";
}
function updateMatrixRemoveAction(question, actions, row) {
    var action = findAction(actions, "remove-row");
    if (!action)
        return;
    action.component = "sv-action-bar-item";
    action.iconName = "icon-delete";
    action.iconSize = "auto";
    action.innerCss = "spg-action-button spg-action-button--danger";
    action.title = question.removeRowText;
    action.showTitle = false;
    action.visibleIndex = 10;
    action.action = function () {
        question.removeRowUI(row);
    };
}
function updateMatixActionsClasses(actions) {
    actions.forEach(function (action) {
        action.innerCss = "".concat(action.innerCss || "", " spg-action-button--muted");
    });
}
var MenuButton = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__extends)(MenuButton, _super);
    function MenuButton() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(MenuButton.prototype, "buttonClassName", {
        get: function () {
            return new survey_core__WEBPACK_IMPORTED_MODULE_1__.CssClassBuilder()
                .append("svc-menu-action__button")
                .append("svc-menu-action__button--with-subtitle", this.contentType === "text-description-vertical")
                .append("svc-menu-action__button--pressed", this.pressed)
                .append("svc-menu-action__button--selected", !!this.active)
                .toString();
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib__WEBPACK_IMPORTED_MODULE_0__.__decorate)([
        (0,survey_core__WEBPACK_IMPORTED_MODULE_1__.property)({ defaultValue: "icon" })
    ], MenuButton.prototype, "contentType", void 0);
    return MenuButton;
}(survey_core__WEBPACK_IMPORTED_MODULE_1__.Action));



/***/ }),

/***/ "./src/utils/events.ts":
/*!*****************************!*\
  !*** ./src/utils/events.ts ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);



/***/ }),

/***/ "./src/utils/resizer.ts":
/*!******************************!*\
  !*** ./src/utils/resizer.ts ***!
  \******************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ResizeManager: () => (/* binding */ ResizeManager)
/* harmony export */ });
var ResizeManager = /** @class */ (function () {
    function ResizeManager(container, handles) {
        var _this = this;
        this.container = container;
        this.events = {
            "mousedown": { "touch": "touchend", "mouse": "mousedown", "pointer": "pointerdown" },
            "mouseup": { "touch": "touchstart", "mouse": "mouseup", "pointer": "pointerup" },
            "mousemove": { "touch": "touchmove", "mouse": "mousemove", "pointer": "pointermove" },
        };
        this.onMouseDownListener = function (e) {
            if (!window)
                return;
            e.preventDefault();
            _this.originalWidth = _this.getStyleValue(_this.container, "width");
            _this.originalMouseX = e.pageX;
            _this.currentResizer = e.target;
            window.addEventListener(_this.getMouseEvent("mousemove"), _this.resize);
            window.addEventListener(_this.getMouseEvent("mouseup"), _this.stopResize);
        };
        this.resize = function (e) {
            var width = _this.originalWidth;
            var horizontalDistinction = e.pageX - _this.originalMouseX;
            if (_this.currentResizer == _this.westResizer) {
                width -= horizontalDistinction;
            }
            else {
                width += horizontalDistinction;
            }
            if (width > _this.maxWidth) {
                width = _this.maxWidth;
            }
            else if (width < _this.minWidth) {
                width = _this.minWidth;
            }
            _this.container.style.width = width + "px";
        };
        this.stopResize = function (e) {
            if (!window)
                return;
            window.removeEventListener(_this.getMouseEvent("mousemove"), _this.resize);
            window.removeEventListener(_this.getMouseEvent("mouseup"), _this.stopResize);
        };
        this.init(container);
        this.setHandles(handles);
    }
    ResizeManager.prototype.setHandles = function (newVal) {
        var isThereWestResizer = false;
        var isThereEastResizer = false;
        var inputVal = newVal.split(",");
        inputVal.forEach(function (str) { return str.trim(); });
        inputVal = inputVal.filter(function (str) { return !!str; });
        (inputVal || []).forEach(function (handrail) {
            if (handrail == "w")
                isThereWestResizer = true;
            if (handrail == "e")
                isThereEastResizer = true;
        });
        this.westResizer.style["display"] = isThereWestResizer ? "block" : "none";
        this.eastResizer.style["display"] = isThereEastResizer ? "block" : "none";
    };
    ResizeManager.prototype.getStyleValue = function (element, style) {
        if (!window)
            return 0;
        return parseFloat(window.getComputedStyle(element).getPropertyValue(style).replace("px", ""));
    };
    ResizeManager.prototype.isEventSupported = function (eventName) {
        var el = document.createElement("div");
        eventName = "on" + eventName;
        var isSupported = (eventName in el);
        if (!isSupported) {
            el.setAttribute(eventName, "return;");
            isSupported = typeof el[eventName] == "function";
        }
        el = null;
        return isSupported;
    };
    ResizeManager.prototype.getEventPrefix = function () {
        if (this.mouseDevice === undefined) {
            if (this.isEventSupported("pointerdown")) {
                this.mouseDevice = "pointer";
            }
            else if (this.isEventSupported("touchstart")) {
                this.mouseDevice = "touch";
            }
            else if (this.isEventSupported("mousedown")) {
                this.mouseDevice = "mouse";
            }
        }
        return this.mouseDevice;
    };
    ResizeManager.prototype.getMouseEvent = function (eventName) {
        return this.events[eventName][this.getEventPrefix()];
    };
    ResizeManager.prototype.init = function (container) {
        this.westResizer = this.createrResizerElement("svc-resizer svc-resizer-west");
        this.eastResizer = this.createrResizerElement("svc-resizer svc-resizer-east");
        this.minWidth = this.getStyleValue(container, "min-width");
        this.maxWidth = this.getStyleValue(container, "max-width");
        container.insertBefore(this.westResizer, container.children[0]);
        container.appendChild(this.eastResizer);
    };
    ResizeManager.prototype.createrResizerElement = function (className) {
        var resizer = document.createElement("div");
        resizer.className = className;
        resizer.addEventListener(this.getMouseEvent("mousedown"), this.onMouseDownListener);
        return resizer;
    };
    ResizeManager.prototype.dispose = function () {
        this.eastResizer.removeEventListener(this.getMouseEvent("mousedown"), this.onMouseDownListener);
        this.eastResizer.remove();
        this.eastResizer = undefined;
        this.westResizer.removeEventListener(this.getMouseEvent("mousedown"), this.onMouseDownListener);
        this.westResizer.remove();
        this.westResizer = undefined;
    };
    return ResizeManager;
}());



/***/ }),

/***/ "./src/utils/utils.ts":
/*!****************************!*\
  !*** ./src/utils/utils.ts ***!
  \****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   ColorCalculator: () => (/* binding */ ColorCalculator),
/* harmony export */   HEXToRGB: () => (/* binding */ HEXToRGB),
/* harmony export */   HSBToRGB: () => (/* binding */ HSBToRGB),
/* harmony export */   RGBToHSB: () => (/* binding */ RGBToHSB),
/* harmony export */   assign: () => (/* binding */ assign),
/* harmony export */   assignDefaultV2Classes: () => (/* binding */ assignDefaultV2Classes),
/* harmony export */   capitalize: () => (/* binding */ capitalize),
/* harmony export */   clearNewLines: () => (/* binding */ clearNewLines),
/* harmony export */   colorsAreEqual: () => (/* binding */ colorsAreEqual),
/* harmony export */   convertRgbaToString: () => (/* binding */ convertRgbaToString),
/* harmony export */   copyCssClasses: () => (/* binding */ copyCssClasses),
/* harmony export */   copyObject: () => (/* binding */ copyObject),
/* harmony export */   findParentNode: () => (/* binding */ findParentNode),
/* harmony export */   focusFirstControl: () => (/* binding */ focusFirstControl),
/* harmony export */   getAcceptedTypesByContentMode: () => (/* binding */ getAcceptedTypesByContentMode),
/* harmony export */   getFirstNonTextElement: () => (/* binding */ getFirstNonTextElement),
/* harmony export */   getNextItemText: () => (/* binding */ getNextItemText),
/* harmony export */   getNextItemValue: () => (/* binding */ getNextItemValue),
/* harmony export */   getNextValue: () => (/* binding */ getNextValue),
/* harmony export */   getNodesFromKoComponentInfo: () => (/* binding */ getNodesFromKoComponentInfo),
/* harmony export */   getQuestionFromObj: () => (/* binding */ getQuestionFromObj),
/* harmony export */   imageMimeTypes: () => (/* binding */ imageMimeTypes),
/* harmony export */   ingectAlpha: () => (/* binding */ ingectAlpha),
/* harmony export */   isPropertyVisible: () => (/* binding */ isPropertyVisible),
/* harmony export */   notShortCircuitAnd: () => (/* binding */ notShortCircuitAnd),
/* harmony export */   parseColor: () => (/* binding */ parseColor),
/* harmony export */   parseRgbaFromString: () => (/* binding */ parseRgbaFromString),
/* harmony export */   propertyExists: () => (/* binding */ propertyExists),
/* harmony export */   roundTo2Decimals: () => (/* binding */ roundTo2Decimals),
/* harmony export */   saveToFileHandler: () => (/* binding */ saveToFileHandler),
/* harmony export */   scrollElementIntoView: () => (/* binding */ scrollElementIntoView),
/* harmony export */   select: () => (/* binding */ select),
/* harmony export */   toggleHovered: () => (/* binding */ toggleHovered),
/* harmony export */   trimEmptyFields: () => (/* binding */ trimEmptyFields),
/* harmony export */   wrapTextByCurlyBraces: () => (/* binding */ wrapTextByCurlyBraces)
/* harmony export */ });
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../creator-settings */ "./src/creator-settings.ts");


function getNumericFromString(str) {
    if (!str)
        return "";
    var num = "";
    for (var i = str.length - 1; i >= 0; i--) {
        if (str[i] >= "0" && str[i] <= "9") {
            num = str[i] + num;
        }
        else {
            if (!!num)
                return num;
        }
        if (num.length == 10)
            break;
    }
    return num;
}
function roundTo2Decimals(number) {
    return Math.round(number * 100) / 100;
}
var opositeValues = {
    true: "false",
    True: "False",
    TRUE: "FALSE",
    false: "true",
    False: "True",
    FALSE: "TRUE",
    yes: "no",
    Yes: "No",
    YES: "NO",
    no: "yes",
    No: "Yes",
    NO: "YES"
};
function getOpositValue(str) {
    if (!!opositeValues[str])
        return opositeValues[str];
    return null;
}
function hasValueInArray(values, search) {
    search = search.toString();
    for (var i = 0; i < values.length; i++) {
        if (!values[i])
            continue;
        if (values[i].toString() === search)
            return true;
    }
    return false;
}
function getNextItemValue(prefix, choices) {
    var values = choices.map(function (item) { return item.value; });
    return getNextValue(prefix, values);
}
function getNextItemText(choices) {
    var ln = choices.length;
    if (ln === 0)
        return "";
    if (!choices[ln - 1].text || choices[ln - 1].text === choices[ln - 1].value)
        return "";
    var values = [];
    choices.forEach(function (item) { if (item.hasText)
        values.push(item.text); });
    choices.map(function (item) { return item.text; });
    var nextValue = getNextValue("", values);
    return !!nextValue ? nextValue.toString() : "";
}
function getNextValue(prefix, values) {
    if (values.length > 0)
        var oposite = getOpositValue(values[values.length - 1]);
    if (oposite && values.indexOf(oposite) < 0)
        return oposite;
    var numStr = "";
    var baseValue;
    var numStrIndex = -1;
    for (var i = values.length - 1; i >= 0; i--) {
        if (!values[i])
            continue;
        var str = values[i].toString();
        numStr = getNumericFromString(str);
        if (!!numStr) {
            numStrIndex = str.lastIndexOf(numStr);
            baseValue = values[i];
            break;
        }
    }
    if (numStrIndex > -1) {
        var num = parseInt(numStr);
        var isNumber = baseValue === num;
        var newValue;
        do {
            if (isNumber) {
                newValue = ++num;
            }
            else {
                var newNum = (num++).toString();
                while (numStr.length > newNum.length) {
                    newNum = "0" + newNum;
                }
                newValue = str.substring(0, numStrIndex) + newNum + str.substring(numStrIndex + numStr.length);
            }
        } while (hasValueInArray(values, newValue));
        return newValue;
    }
    if (!prefix) {
        prefix = values[values.length - 1];
    }
    return prefix + 1;
}
function findParentNode(className, sourceNode) {
    var parent = sourceNode;
    while (!!parent && !parent.classList.contains(className)) {
        parent = parent.parentElement;
    }
    return parent;
}
function focusFirstControl(renderedElements) {
    for (var i = 0; i < renderedElements.length; i++) {
        if (typeof renderedElements[i].getElementsByClassName === "function") {
            var elements = (renderedElements[i].getElementsByClassName("svd-focusable"));
            if (elements.length === 0 &&
                renderedElements[i].className.indexOf("svd-focusable") !== -1) {
                elements = [renderedElements[i]];
            }
            if (elements.length > 0) {
                var element = elements[0];
                if (element.tagName.toLowerCase() !== "a") {
                    element.focus({ preventScroll: true });
                    break;
                }
            }
        }
    }
}
function getFirstNonTextElement(elements) {
    if (!elements || !elements.length)
        return;
    for (var i = 0; i < elements.length; i++) {
        if (elements[i].nodeName != "#text" && elements[i].nodeName != "#comment")
            return elements[i];
    }
    return null;
}
// about compoentInfo: https://knockoutjs.com/documentation/component-registration.html
function getNodesFromKoComponentInfo(componentInfo) {
    // elem.nodeType === 3 // text node
    // elem.nodeType === 8 // comment node
    var element = componentInfo.element;
    var siblings = [];
    if (element.nodeType !== 8) {
        return element.childNodes;
    }
    while ((element = element.nextSibling)) {
        if (element.nodeType === 3)
            continue;
        siblings.push(element);
    }
    return siblings;
}
// ko.bindingHandlers["trueclick"] = {
//   init: function (element, valueAccessor, allBindingsAccessor) {
//     element.onclick = () => true;
//   },
// };
// export function createKey2click(element: HTMLElement) {
//   return (ev: KeyboardEvent) => {
//     var char = ev.which || ev.keyCode;
//     if (char === 13 || char === 32) {
//       element.click();
//     } else if (char === 27) {
//       element.blur();
//     }
//   };
// }
// ko.bindingHandlers["key2click"] = {
//   init: function (element, valueAccessor, allBindingsAccessor) {
//     element.onkeyup = createKey2click(element);
//   },
// };
// ko.bindingHandlers["clickNoFocus"] = {
//   init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
//     element.onclick = (ev) => {
//       valueAccessor().call(viewModel, viewModel, ev);
//     };
//   },
// };
// ko.bindingHandlers["afterRenderParent"] = {
//   init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
//     element.style.display = "none";
//     valueAccessor() && valueAccessor()([element.parentElement]);
//   },
// };
function propertyExists(obj, propertyName) {
    var result = true;
    if (!!obj && typeof obj.getType === "function") {
        var property = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.findProperty(obj.getType(), propertyName);
        result = !!property;
    }
    return result;
}
function isPropertyVisible(obj, propertyName) {
    var result = true;
    if (!!obj && typeof obj.getType === "function") {
        var property = survey_core__WEBPACK_IMPORTED_MODULE_0__.Serializer.findProperty(obj.getType(), propertyName);
        result = !property || property.visible;
    }
    return result;
}
function toggleHovered(e, element, timeout) {
    if (timeout === void 0) { timeout = 0; }
    var processedFlagName = "__svc_question_processed";
    var name = "svc-hovered";
    var nameReady = "svc-hovered-ready";
    function setClass(className, checkReady) {
        if (checkReady === void 0) { checkReady = null; }
        var arr = (element.className || "").split(" ");
        if (checkReady) {
            if (arr.indexOf(checkReady) == -1) {
                return;
            }
        }
        if (arr.indexOf(className) == -1) {
            element.className += " " + className;
        }
    }
    if (!e[processedFlagName] && e.type === "mouseover") {
        if (timeout) {
            setClass(nameReady);
            setTimeout(function () {
                setClass(name, nameReady);
            }, timeout);
        }
        else {
            setClass(name);
        }
        e[processedFlagName] = true;
    }
    else {
        element.className = (element.className || "").replace(" svc-hovered-ready", "");
        element.className = (element.className || "").replace(" svc-hovered", "");
    }
}
function clearNewLines(text) {
    return text.replace(new RegExp("(\\r\\n|\\n|\\r)", "gm"), "");
}
function select(element) {
    if (!window)
        return;
    var range, selection;
    if (window.getSelection && document.createRange) {
        selection = window.getSelection();
        range = document.createRange();
        range.selectNodeContents(element);
        selection.removeAllRanges();
        selection.addRange(range);
    }
    else if (document["selection"] && document.body["createTextRange"]) {
        range = document.body["createTextRange"]();
        range.moveToElementText(element);
        range.select();
    }
}
function copyObject(dst, src) {
    for (var key in src) {
        var source = src[key];
        if (typeof source === "object") {
            source = {};
            copyObject(source, src[key]);
        }
        dst[key] = source;
    }
}
function copyCssClasses(dest, source) {
    if (!source)
        return;
    if (typeof source === "string" || source instanceof String) {
        dest["root"] = source;
    }
    else {
        copyObject(dest, source);
    }
}
function assignDefaultV2Classes(destination, questionType) {
    copyCssClasses(destination, survey_core__WEBPACK_IMPORTED_MODULE_0__.defaultV2Css.question);
    copyCssClasses(destination, survey_core__WEBPACK_IMPORTED_MODULE_0__.defaultV2Css[questionType]);
    destination.hasErrorTop = "";
    destination.hasErrorBottom = "";
}
function wrapTextByCurlyBraces(text) {
    return _creator_settings__WEBPACK_IMPORTED_MODULE_1__.settings.logic.openBracket + text + _creator_settings__WEBPACK_IMPORTED_MODULE_1__.settings.logic.closeBracket;
}
function capitalize(str) {
    if (!str)
        return str;
    str = str.replace(/[\s]+/g, " ");
    str = str.replace(/([\s]|^)(\S)/g, function (_, p1, p2) {
        return p1 + p2.toUpperCase();
    });
    return str;
}
function notShortCircuitAnd() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    return args.every(function (val) { return val === true; });
}
var imageMimeTypes = "image/png, image/gif, image/jpeg, image/apng, image/avif, image/svg+xml, image/webp";
function getAcceptedTypesByContentMode(contentMode) {
    if (["auto", "image"].indexOf(contentMode) > -1) {
        return imageMimeTypes;
    }
    else if (contentMode == "video") {
        return "video/*";
    }
    else {
        return "";
    }
}
function getQuestionFromObj(obj) {
    return (obj instanceof survey_core__WEBPACK_IMPORTED_MODULE_0__.MatrixDropdownColumn) ? obj.templateQuestion : obj;
}
function scrollElementIntoView(elementId) {
    if (!elementId || typeof survey_core__WEBPACK_IMPORTED_MODULE_0__.settings.environment.root === "undefined")
        return;
    var el = survey_core__WEBPACK_IMPORTED_MODULE_0__.settings.environment.root.getElementById(elementId);
    if (!el)
        return;
    el.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
}
function ingectAlpha(baseColor, alpha) {
    if (!!baseColor && alpha !== undefined) {
        var rgbValue = HEXToRGB(baseColor);
        return "rgba(".concat(rgbValue[0], ", ").concat(rgbValue[1], ", ").concat(rgbValue[2], ", ").concat(rgbValue[3] || alpha, ")");
    }
}
function convertRgbaToString(rgbValues, alpha) {
    return "rgba(".concat(rgbValues[0], ", ").concat(rgbValues[1], ", ").concat(rgbValues[2], ", ").concat(alpha, ")");
}
function parseRgbaFromString(value) {
    if (value === void 0) { value = ""; }
    var matchRgb = value.match(/\((.*)\)/);
    if (matchRgb) {
        return matchRgb[1].split(",").map(function (i) { return parseFloat(i); });
    }
    else {
        return [];
    }
}
function parseColor(value) {
    if (value === void 0) { value = ""; }
    var rgbValues = parseRgbaFromString(value);
    if (rgbValues.length !== 0) {
        var opacity = 1;
        if (rgbValues.length == 4) {
            opacity = rgbValues.pop();
        }
        var color = rgbValues.reduce(function (res, color) {
            var hex = color.toString(16);
            return res + (hex.length == 1 ? "0" + hex : hex);
        }, "#");
        return { color: color, opacity: roundTo2Decimals(opacity * 100) };
    }
    else {
        return { color: value, opacity: 100 };
    }
}
function HEXToRGB(baseColor) {
    if (!!baseColor) {
        var r = parseInt(baseColor.slice(1, 3), 16);
        var g = parseInt(baseColor.slice(3, 5), 16);
        var b = parseInt(baseColor.slice(5, 7), 16);
        var alpha = roundTo2Decimals(parseInt(baseColor.slice(7, 9), 16) / 255);
        return [r, g, b, alpha];
    }
    return [];
}
function HSBToRGB(h, s, b) {
    s /= 100;
    b /= 100;
    var k = function (n) { return (n + h / 60) % 6; };
    var f = function (n) { return b * (1 - s * Math.max(0, Math.min(k(n), 4 - k(n), 1))); };
    return [Math.round(255 * f(5)), Math.round(255 * f(3)), Math.round(255 * f(1))];
}
function RGBToHSB(r, g, b) {
    r /= 255;
    g /= 255;
    b /= 255;
    var v = Math.max(r, g, b), n = v - Math.min(r, g, b);
    var h = n === 0 ? 0 : n && v === r ? (g - b) / n : v === g ? 2 + (b - r) / n : 4 + (r - g) / n;
    return [60 * (h < 0 ? h + 6 : h), v && (n / v) * 100, v * 100];
}
function trimEmptyFields(object) {
    Object.keys(object).forEach(function (key) {
        if (object[key] === undefined || object[key] === null) {
            delete object[key];
        }
    });
}
function assign() {
    var inputs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        inputs[_i] = arguments[_i];
    }
    var objects = (inputs || []).filter(function (obj) { return !!obj; });
    if (objects.length <= 1) {
        return;
    }
    if (objects.length == 2) {
        Object.keys(objects[1]).forEach(function (key) { return objects[0][key] = objects[1][key]; });
        trimEmptyFields(inputs[0]);
        return;
    }
    for (var i = 1; i < objects.length; i++) {
        assign(objects[0], objects[i]);
    }
}
var ColorCalculator = /** @class */ (function () {
    function ColorCalculator() {
        this.colorSettings = { baseColorAlpha: 1, darkColorAlpha: 1, lightColorAlpha: 1, deltaDarkColor: 0, deltaLightColor: 0, newColorLight: "", newColorDark: "" };
    }
    ColorCalculator.prototype.initialize = function (baseColor, lightColor, darkColor) {
        var primaryColorRgba = parseRgbaFromString(baseColor);
        if (primaryColorRgba.length === 0) {
            primaryColorRgba = parseRgbaFromString(ingectAlpha(baseColor, 1));
        }
        var primaryColorDarkRgba = parseRgbaFromString(darkColor);
        if (primaryColorDarkRgba.length === 0) {
            primaryColorDarkRgba = parseRgbaFromString(ingectAlpha(darkColor, 1));
        }
        var primaryColorLightRgba = parseRgbaFromString(lightColor);
        if (primaryColorLightRgba.length === 0) {
            primaryColorLightRgba = parseRgbaFromString(ingectAlpha(lightColor, 1));
        }
        this.colorSettings.baseColorAlpha = primaryColorRgba[3];
        this.colorSettings.darkColorAlpha = primaryColorDarkRgba[3];
        this.colorSettings.lightColorAlpha = primaryColorLightRgba[3];
        var primaryColorHSB = RGBToHSB(primaryColorRgba[0], primaryColorRgba[1], primaryColorRgba[2]);
        var primaryColorDarkHSB = RGBToHSB(primaryColorDarkRgba[0], primaryColorDarkRgba[1], primaryColorDarkRgba[2]);
        var primaryColorLightHSB = RGBToHSB(primaryColorLightRgba[0], primaryColorLightRgba[1], primaryColorLightRgba[2]);
        this.colorSettings.deltaDarkColor = primaryColorHSB[2] - primaryColorDarkHSB[2];
        this.colorSettings.deltaLightColor = primaryColorHSB[2] - primaryColorLightHSB[2];
    };
    ColorCalculator.prototype.calculateColors = function (newColor) {
        var newColorRbg = parseRgbaFromString(newColor);
        if (newColorRbg.length === 0) {
            newColorRbg = parseRgbaFromString(ingectAlpha(newColor, 1));
        }
        var newColorHsb = RGBToHSB(newColorRbg[0], newColorRbg[1], newColorRbg[2]);
        var newPrimaryColorDarkRGB = HSBToRGB(newColorHsb[0], newColorHsb[1], newColorHsb[2] - this.colorSettings.deltaDarkColor);
        var newPrimaryColorLightRGB = HSBToRGB(newColorHsb[0], newColorHsb[1], newColorHsb[2] - this.colorSettings.deltaLightColor);
        this.colorSettings.newColorLight = convertRgbaToString(newPrimaryColorLightRGB, this.colorSettings.lightColorAlpha);
        this.colorSettings.newColorDark = convertRgbaToString(newPrimaryColorDarkRGB, this.colorSettings.darkColorAlpha);
    };
    return ColorCalculator;
}());

function saveToFileHandler(fileName, blob) {
    if (!window)
        return;
    if (window.navigator["msSaveOrOpenBlob"]) {
        window.navigator["msSaveBlob"](blob, fileName);
    }
    else {
        var elem = window.document.createElement("a");
        elem.href = window.URL.createObjectURL(blob);
        elem.download = fileName;
        document.body.appendChild(elem);
        elem.click();
        document.body.removeChild(elem);
    }
}
function colorsAreEqual(color1, color2) {
    var color1Value = parseColor(color1);
    color1Value.color = color1Value.color.substring(0, 7).toUpperCase();
    var color2Value = parseColor(color2);
    color2Value.color = color2Value.color.substring(0, 7).toUpperCase();
    return color1Value.color === color2Value.color && color1Value.opacity === color2Value.opacity;
}


/***/ }),

/***/ "./src/images-v1 sync recursive \\.svg$":
/*!************************************!*\
  !*** ./src/images-v1/ sync \.svg$ ***!
  \************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./add-16x16.svg": "./src/images-v1/add-16x16.svg",
	"./add-24x24.svg": "./src/images-v1/add-24x24.svg",
	"./apply-24x24.svg": "./src/images-v1/apply-24x24.svg",
	"./arrowdown-24x24.svg": "./src/images-v1/arrowdown-24x24.svg",
	"./arrowleft-16x16.svg": "./src/images-v1/arrowleft-16x16.svg",
	"./arrowleft-24x24.svg": "./src/images-v1/arrowleft-24x24.svg",
	"./arrowright-16x16.svg": "./src/images-v1/arrowright-16x16.svg",
	"./arrowright-24x24.svg": "./src/images-v1/arrowright-24x24.svg",
	"./arrowup-24x24.svg": "./src/images-v1/arrowup-24x24.svg",
	"./camera-24x24.svg": "./src/images-v1/camera-24x24.svg",
	"./camera-32x32.svg": "./src/images-v1/camera-32x32.svg",
	"./cancel-24x24.svg": "./src/images-v1/cancel-24x24.svg",
	"./check-16x16.svg": "./src/images-v1/check-16x16.svg",
	"./check-24x24.svg": "./src/images-v1/check-24x24.svg",
	"./chevrondown-16x16.svg": "./src/images-v1/chevrondown-16x16.svg",
	"./chevrondown-24x24.svg": "./src/images-v1/chevrondown-24x24.svg",
	"./chevronleft-16x16.svg": "./src/images-v1/chevronleft-16x16.svg",
	"./clear-16x16.svg": "./src/images-v1/clear-16x16.svg",
	"./clear-24x24.svg": "./src/images-v1/clear-24x24.svg",
	"./close-16x16.svg": "./src/images-v1/close-16x16.svg",
	"./close-24x24.svg": "./src/images-v1/close-24x24.svg",
	"./codeeditor-24x24.svg": "./src/images-v1/codeeditor-24x24.svg",
	"./collapse-16x16.svg": "./src/images-v1/collapse-16x16.svg",
	"./collapse-24x24.svg": "./src/images-v1/collapse-24x24.svg",
	"./collapse-pg-24x24.svg": "./src/images-v1/collapse-pg-24x24.svg",
	"./collapseall-24x24.svg": "./src/images-v1/collapseall-24x24.svg",
	"./collapsedetails-16x16.svg": "./src/images-v1/collapsedetails-16x16.svg",
	"./collapsefocused-16x16.svg": "./src/images-v1/collapsefocused-16x16.svg",
	"./collapsepage-16x16.svg": "./src/images-v1/collapsepage-16x16.svg",
	"./collapsepanel-16x16.svg": "./src/images-v1/collapsepanel-16x16.svg",
	"./copy-16x16.svg": "./src/images-v1/copy-16x16.svg",
	"./copy-24x24.svg": "./src/images-v1/copy-24x24.svg",
	"./cross-24x24.svg": "./src/images-v1/cross-24x24.svg",
	"./delete-16x16.svg": "./src/images-v1/delete-16x16.svg",
	"./delete-24x24.svg": "./src/images-v1/delete-24x24.svg",
	"./desktop-24x24.svg": "./src/images-v1/desktop-24x24.svg",
	"./download-24x24.svg": "./src/images-v1/download-24x24.svg",
	"./drag-24x24.svg": "./src/images-v1/drag-24x24.svg",
	"./draghorizontal-24x16.svg": "./src/images-v1/draghorizontal-24x16.svg",
	"./draghorizontalsmall-24x16.svg": "./src/images-v1/draghorizontalsmall-24x16.svg",
	"./dropper-16x16.svg": "./src/images-v1/dropper-16x16.svg",
	"./edit-16x16.svg": "./src/images-v1/edit-16x16.svg",
	"./edit-24x24.svg": "./src/images-v1/edit-24x24.svg",
	"./editsmall-16x16.svg": "./src/images-v1/editsmall-16x16.svg",
	"./embedsurvey-24x24.svg": "./src/images-v1/embedsurvey-24x24.svg",
	"./error-16x16.svg": "./src/images-v1/error-16x16.svg",
	"./error-24x24.svg": "./src/images-v1/error-24x24.svg",
	"./expand-16x16.svg": "./src/images-v1/expand-16x16.svg",
	"./expand-24x24.svg": "./src/images-v1/expand-24x24.svg",
	"./expand-pg-24x24.svg": "./src/images-v1/expand-pg-24x24.svg",
	"./expandall-24x24.svg": "./src/images-v1/expandall-24x24.svg",
	"./expanddetails-16x16.svg": "./src/images-v1/expanddetails-16x16.svg",
	"./expandfocused-16x16.svg": "./src/images-v1/expandfocused-16x16.svg",
	"./expandpage-16x16.svg": "./src/images-v1/expandpage-16x16.svg",
	"./expandpanel-16x16.svg": "./src/images-v1/expandpanel-16x16.svg",
	"./file-72x72.svg": "./src/images-v1/file-72x72.svg",
	"./finishedit-24x24.svg": "./src/images-v1/finishedit-24x24.svg",
	"./fix-24x24.svg": "./src/images-v1/fix-24x24.svg",
	"./flip-24x24.svg": "./src/images-v1/flip-24x24.svg",
	"./folder-24x24.svg": "./src/images-v1/folder-24x24.svg",
	"./fullsize-16x16.svg": "./src/images-v1/fullsize-16x16.svg",
	"./gear-24x24.svg": "./src/images-v1/gear-24x24.svg",
	"./help-24x24.svg": "./src/images-v1/help-24x24.svg",
	"./hidehint-16x16.svg": "./src/images-v1/hidehint-16x16.svg",
	"./hidehint-24x24.svg": "./src/images-v1/hidehint-24x24.svg",
	"./hint-16x16.svg": "./src/images-v1/hint-16x16.svg",
	"./hint-24x24.svg": "./src/images-v1/hint-24x24.svg",
	"./image-48x48.svg": "./src/images-v1/image-48x48.svg",
	"./import-24x24.svg": "./src/images-v1/import-24x24.svg",
	"./invisible-24x24.svg": "./src/images-v1/invisible-24x24.svg",
	"./language-24x24.svg": "./src/images-v1/language-24x24.svg",
	"./loading-48x48.svg": "./src/images-v1/loading-48x48.svg",
	"./logic-24x24.svg": "./src/images-v1/logic-24x24.svg",
	"./logo-angular-24x24.svg": "./src/images-v1/logo-angular-24x24.svg",
	"./logo-jquery-24x24.svg": "./src/images-v1/logo-jquery-24x24.svg",
	"./logo-knockout-24x24.svg": "./src/images-v1/logo-knockout-24x24.svg",
	"./logo-react-24x24.svg": "./src/images-v1/logo-react-24x24.svg",
	"./logo-surveycreator-48x48.svg": "./src/images-v1/logo-surveycreator-48x48.svg",
	"./logo-vue-24x24.svg": "./src/images-v1/logo-vue-24x24.svg",
	"./maximize-16x16.svg": "./src/images-v1/maximize-16x16.svg",
	"./minimize-16x16.svg": "./src/images-v1/minimize-16x16.svg",
	"./minus-32x32.svg": "./src/images-v1/minus-32x32.svg",
	"./minusbox-16x16.svg": "./src/images-v1/minusbox-16x16.svg",
	"./more-16x16.svg": "./src/images-v1/more-16x16.svg",
	"./more-24x24.svg": "./src/images-v1/more-24x24.svg",
	"./navmenu-24x24.svg": "./src/images-v1/navmenu-24x24.svg",
	"./noimage-48x48.svg": "./src/images-v1/noimage-48x48.svg",
	"./pg-appearance-24x24.svg": "./src/images-v1/pg-appearance-24x24.svg",
	"./pg-background-24x24.svg": "./src/images-v1/pg-background-24x24.svg",
	"./pg-columns-24x24.svg": "./src/images-v1/pg-columns-24x24.svg",
	"./pg-conditions-24x24.svg": "./src/images-v1/pg-conditions-24x24.svg",
	"./pg-data-24x24.svg": "./src/images-v1/pg-data-24x24.svg",
	"./pg-design-24x24.svg": "./src/images-v1/pg-design-24x24.svg",
	"./pg-general-24x24.svg": "./src/images-v1/pg-general-24x24.svg",
	"./pg-header-24x24.svg": "./src/images-v1/pg-header-24x24.svg",
	"./pg-language-24x24.svg": "./src/images-v1/pg-language-24x24.svg",
	"./pg-layout-24x24.svg": "./src/images-v1/pg-layout-24x24.svg",
	"./pg-logo-24x24.svg": "./src/images-v1/pg-logo-24x24.svg",
	"./pg-navigation-24x24.svg": "./src/images-v1/pg-navigation-24x24.svg",
	"./pg-pages-24x24.svg": "./src/images-v1/pg-pages-24x24.svg",
	"./pg-questiondesign-24x24.svg": "./src/images-v1/pg-questiondesign-24x24.svg",
	"./pg-quiz-24x24.svg": "./src/images-v1/pg-quiz-24x24.svg",
	"./pg-rows-24x24.svg": "./src/images-v1/pg-rows-24x24.svg",
	"./pg-specific-24x24.svg": "./src/images-v1/pg-specific-24x24.svg",
	"./pg-thankyyoupage-24x24.svg": "./src/images-v1/pg-thankyyoupage-24x24.svg",
	"./pg-themes-24x24.svg": "./src/images-v1/pg-themes-24x24.svg",
	"./pg-totals-24x24.svg": "./src/images-v1/pg-totals-24x24.svg",
	"./pg-undefined-24x24.svg": "./src/images-v1/pg-undefined-24x24.svg",
	"./pg-validation-24x24.svg": "./src/images-v1/pg-validation-24x24.svg",
	"./phone-24x24.svg": "./src/images-v1/phone-24x24.svg",
	"./plus-32x32.svg": "./src/images-v1/plus-32x32.svg",
	"./plusbox-16x16.svg": "./src/images-v1/plusbox-16x16.svg",
	"./preview-24x24.svg": "./src/images-v1/preview-24x24.svg",
	"./publish-24x24.svg": "./src/images-v1/publish-24x24.svg",
	"./questionlock-24x24.svg": "./src/images-v1/questionlock-24x24.svg",
	"./ranking-arrows.svg": "./src/images-v1/ranking-arrows.svg",
	"./rankingundefined-16x16.svg": "./src/images-v1/rankingundefined-16x16.svg",
	"./redo-24x24.svg": "./src/images-v1/redo-24x24.svg",
	"./refresh-16x16.svg": "./src/images-v1/refresh-16x16.svg",
	"./remove-16x16.svg": "./src/images-v1/remove-16x16.svg",
	"./reorder-24x24.svg": "./src/images-v1/reorder-24x24.svg",
	"./required-16x16.svg": "./src/images-v1/required-16x16.svg",
	"./restore-24x24.svg": "./src/images-v1/restore-24x24.svg",
	"./restoredown-16x16.svg": "./src/images-v1/restoredown-16x16.svg",
	"./rotate-24x24.svg": "./src/images-v1/rotate-24x24.svg",
	"./save-24x24.svg": "./src/images-v1/save-24x24.svg",
	"./saveas-24x24.svg": "./src/images-v1/saveas-24x24.svg",
	"./search-24x24.svg": "./src/images-v1/search-24x24.svg",
	"./selectpage-24x24.svg": "./src/images-v1/selectpage-24x24.svg",
	"./settings-16x16.svg": "./src/images-v1/settings-16x16.svg",
	"./settings-24x24.svg": "./src/images-v1/settings-24x24.svg",
	"./smile-24x24.svg": "./src/images-v1/smile-24x24.svg",
	"./smiley-rate0-24x24.svg": "./src/images-v1/smiley-rate0-24x24.svg",
	"./smiley-rate1-24x24.svg": "./src/images-v1/smiley-rate1-24x24.svg",
	"./smiley-rate10-24x24.svg": "./src/images-v1/smiley-rate10-24x24.svg",
	"./smiley-rate2-24x24.svg": "./src/images-v1/smiley-rate2-24x24.svg",
	"./smiley-rate3-24x24.svg": "./src/images-v1/smiley-rate3-24x24.svg",
	"./smiley-rate4-24x24.svg": "./src/images-v1/smiley-rate4-24x24.svg",
	"./smiley-rate5-24x24.svg": "./src/images-v1/smiley-rate5-24x24.svg",
	"./smiley-rate6-24x24.svg": "./src/images-v1/smiley-rate6-24x24.svg",
	"./smiley-rate7-24x24.svg": "./src/images-v1/smiley-rate7-24x24.svg",
	"./smiley-rate8-24x24.svg": "./src/images-v1/smiley-rate8-24x24.svg",
	"./smiley-rate9-24x24.svg": "./src/images-v1/smiley-rate9-24x24.svg",
	"./speechbubble-16x16.svg": "./src/images-v1/speechbubble-16x16.svg",
	"./switchoff-16x16.svg": "./src/images-v1/switchoff-16x16.svg",
	"./switchon-16x16.svg": "./src/images-v1/switchon-16x16.svg",
	"./tablet-24x24.svg": "./src/images-v1/tablet-24x24.svg",
	"./textedit-24x24.svg": "./src/images-v1/textedit-24x24.svg",
	"./theme-24x24.svg": "./src/images-v1/theme-24x24.svg",
	"./toolbox-24x24.svg": "./src/images-v1/toolbox-24x24.svg",
	"./toolbox-boolean-16x16.svg": "./src/images-v1/toolbox-boolean-16x16.svg",
	"./toolbox-boolean-24x24.svg": "./src/images-v1/toolbox-boolean-24x24.svg",
	"./toolbox-checkbox-16x16.svg": "./src/images-v1/toolbox-checkbox-16x16.svg",
	"./toolbox-checkbox-24x24.svg": "./src/images-v1/toolbox-checkbox-24x24.svg",
	"./toolbox-customquestion-16x16.svg": "./src/images-v1/toolbox-customquestion-16x16.svg",
	"./toolbox-customquestion-24x24.svg": "./src/images-v1/toolbox-customquestion-24x24.svg",
	"./toolbox-dropdown-16x16.svg": "./src/images-v1/toolbox-dropdown-16x16.svg",
	"./toolbox-dropdown-24x24.svg": "./src/images-v1/toolbox-dropdown-24x24.svg",
	"./toolbox-dynamicmatrix-16x16.svg": "./src/images-v1/toolbox-dynamicmatrix-16x16.svg",
	"./toolbox-dynamicmatrix-24x24.svg": "./src/images-v1/toolbox-dynamicmatrix-24x24.svg",
	"./toolbox-dynamicpanel-16x16.svg": "./src/images-v1/toolbox-dynamicpanel-16x16.svg",
	"./toolbox-dynamicpanel-24x24.svg": "./src/images-v1/toolbox-dynamicpanel-24x24.svg",
	"./toolbox-expression-16x16.svg": "./src/images-v1/toolbox-expression-16x16.svg",
	"./toolbox-expression-24x24.svg": "./src/images-v1/toolbox-expression-24x24.svg",
	"./toolbox-file-16x16.svg": "./src/images-v1/toolbox-file-16x16.svg",
	"./toolbox-file-24x24.svg": "./src/images-v1/toolbox-file-24x24.svg",
	"./toolbox-html-16x16.svg": "./src/images-v1/toolbox-html-16x16.svg",
	"./toolbox-html-24x24.svg": "./src/images-v1/toolbox-html-24x24.svg",
	"./toolbox-image-16x16.svg": "./src/images-v1/toolbox-image-16x16.svg",
	"./toolbox-image-24x24.svg": "./src/images-v1/toolbox-image-24x24.svg",
	"./toolbox-imagepicker-16x16.svg": "./src/images-v1/toolbox-imagepicker-16x16.svg",
	"./toolbox-imagepicker-24x24.svg": "./src/images-v1/toolbox-imagepicker-24x24.svg",
	"./toolbox-longtext-16x16.svg": "./src/images-v1/toolbox-longtext-16x16.svg",
	"./toolbox-longtext-24x24.svg": "./src/images-v1/toolbox-longtext-24x24.svg",
	"./toolbox-matrix-16x16.svg": "./src/images-v1/toolbox-matrix-16x16.svg",
	"./toolbox-matrix-24x24.svg": "./src/images-v1/toolbox-matrix-24x24.svg",
	"./toolbox-multimatrix-16x16.svg": "./src/images-v1/toolbox-multimatrix-16x16.svg",
	"./toolbox-multimatrix-24x24.svg": "./src/images-v1/toolbox-multimatrix-24x24.svg",
	"./toolbox-multipletext-16x16.svg": "./src/images-v1/toolbox-multipletext-16x16.svg",
	"./toolbox-multipletext-24x24.svg": "./src/images-v1/toolbox-multipletext-24x24.svg",
	"./toolbox-panel-16x16.svg": "./src/images-v1/toolbox-panel-16x16.svg",
	"./toolbox-panel-24x24.svg": "./src/images-v1/toolbox-panel-24x24.svg",
	"./toolbox-radiogroup-16x16.svg": "./src/images-v1/toolbox-radiogroup-16x16.svg",
	"./toolbox-radiogroup-24x24.svg": "./src/images-v1/toolbox-radiogroup-24x24.svg",
	"./toolbox-ranking-16x16.svg": "./src/images-v1/toolbox-ranking-16x16.svg",
	"./toolbox-ranking-24x24.svg": "./src/images-v1/toolbox-ranking-24x24.svg",
	"./toolbox-rating-16x16.svg": "./src/images-v1/toolbox-rating-16x16.svg",
	"./toolbox-rating-24x24.svg": "./src/images-v1/toolbox-rating-24x24.svg",
	"./toolbox-signature-16x16.svg": "./src/images-v1/toolbox-signature-16x16.svg",
	"./toolbox-signature-24x24.svg": "./src/images-v1/toolbox-signature-24x24.svg",
	"./toolbox-singleline-16x16.svg": "./src/images-v1/toolbox-singleline-16x16.svg",
	"./toolbox-singleline-24x24.svg": "./src/images-v1/toolbox-singleline-24x24.svg",
	"./toolbox-tagbox-16x16.svg": "./src/images-v1/toolbox-tagbox-16x16.svg",
	"./toolbox-tagbox-24x24.svg": "./src/images-v1/toolbox-tagbox-24x24.svg",
	"./undo-24x24.svg": "./src/images-v1/undo-24x24.svg",
	"./visible-24x24.svg": "./src/images-v1/visible-24x24.svg",
	"./wand-24x24.svg": "./src/images-v1/wand-24x24.svg",
	"./warning-24x24.svg": "./src/images-v1/warning-24x24.svg",
	"./wrench-24x24.svg": "./src/images-v1/wrench-24x24.svg",
	"./zoomin-24x24.svg": "./src/images-v1/zoomin-24x24.svg",
	"./zoomout-24x24.svg": "./src/images-v1/zoomout-24x24.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images-v1 sync recursive \\.svg$";

/***/ }),

/***/ "./src/images-v2 sync recursive \\.svg$":
/*!************************************!*\
  !*** ./src/images-v2/ sync \.svg$ ***!
  \************************************/
/***/ ((module, __unused_webpack_exports, __webpack_require__) => {

var map = {
	"./add-16x16.svg": "./src/images-v2/add-16x16.svg",
	"./add-24x24.svg": "./src/images-v2/add-24x24.svg",
	"./apply-24x24.svg": "./src/images-v2/apply-24x24.svg",
	"./arrowdown-24x24.svg": "./src/images-v2/arrowdown-24x24.svg",
	"./arrowleft-16x16.svg": "./src/images-v2/arrowleft-16x16.svg",
	"./arrowleft-24x24.svg": "./src/images-v2/arrowleft-24x24.svg",
	"./arrowright-16x16.svg": "./src/images-v2/arrowright-16x16.svg",
	"./arrowright-24x24.svg": "./src/images-v2/arrowright-24x24.svg",
	"./arrowup-24x24.svg": "./src/images-v2/arrowup-24x24.svg",
	"./camera-24x24.svg": "./src/images-v2/camera-24x24.svg",
	"./camera-32x32.svg": "./src/images-v2/camera-32x32.svg",
	"./cancel-24x24.svg": "./src/images-v2/cancel-24x24.svg",
	"./check-16x16.svg": "./src/images-v2/check-16x16.svg",
	"./check-24x24.svg": "./src/images-v2/check-24x24.svg",
	"./chevrondown-16x16.svg": "./src/images-v2/chevrondown-16x16.svg",
	"./chevrondown-24x24.svg": "./src/images-v2/chevrondown-24x24.svg",
	"./chevronleft-16x16.svg": "./src/images-v2/chevronleft-16x16.svg",
	"./chevronright-16x16.svg": "./src/images-v2/chevronright-16x16.svg",
	"./clear-16x16.svg": "./src/images-v2/clear-16x16.svg",
	"./clear-24x24.svg": "./src/images-v2/clear-24x24.svg",
	"./close-16x16.svg": "./src/images-v2/close-16x16.svg",
	"./close-24x24.svg": "./src/images-v2/close-24x24.svg",
	"./codeeditor-24x24.svg": "./src/images-v2/codeeditor-24x24.svg",
	"./collapse-16x16.svg": "./src/images-v2/collapse-16x16.svg",
	"./collapse-24x24.svg": "./src/images-v2/collapse-24x24.svg",
	"./collapse-pg-24x24.svg": "./src/images-v2/collapse-pg-24x24.svg",
	"./collapseall-24x24.svg": "./src/images-v2/collapseall-24x24.svg",
	"./collapsedetails-16x16.svg": "./src/images-v2/collapsedetails-16x16.svg",
	"./collapsefocused-16x16.svg": "./src/images-v2/collapsefocused-16x16.svg",
	"./collapsepage-16x16.svg": "./src/images-v2/collapsepage-16x16.svg",
	"./collapsepanel-16x16.svg": "./src/images-v2/collapsepanel-16x16.svg",
	"./copy-16x16.svg": "./src/images-v2/copy-16x16.svg",
	"./copy-24x24.svg": "./src/images-v2/copy-24x24.svg",
	"./cross-24x24.svg": "./src/images-v2/cross-24x24.svg",
	"./delete-16x16.svg": "./src/images-v2/delete-16x16.svg",
	"./delete-24x24.svg": "./src/images-v2/delete-24x24.svg",
	"./desktop-24x24.svg": "./src/images-v2/desktop-24x24.svg",
	"./download-24x24.svg": "./src/images-v2/download-24x24.svg",
	"./drag-24x24.svg": "./src/images-v2/drag-24x24.svg",
	"./draghorizontal-24x16.svg": "./src/images-v2/draghorizontal-24x16.svg",
	"./draghorizontalsmall-24x16.svg": "./src/images-v2/draghorizontalsmall-24x16.svg",
	"./dropper-16x16.svg": "./src/images-v2/dropper-16x16.svg",
	"./edit-16x16.svg": "./src/images-v2/edit-16x16.svg",
	"./edit-24x24.svg": "./src/images-v2/edit-24x24.svg",
	"./editsmall-16x16.svg": "./src/images-v2/editsmall-16x16.svg",
	"./embedsurvey-24x24.svg": "./src/images-v2/embedsurvey-24x24.svg",
	"./error-16x16.svg": "./src/images-v2/error-16x16.svg",
	"./error-24x24.svg": "./src/images-v2/error-24x24.svg",
	"./expand-16x16.svg": "./src/images-v2/expand-16x16.svg",
	"./expand-24x24.svg": "./src/images-v2/expand-24x24.svg",
	"./expand-pg-24x24.svg": "./src/images-v2/expand-pg-24x24.svg",
	"./expandall-24x24.svg": "./src/images-v2/expandall-24x24.svg",
	"./expanddetails-16x16.svg": "./src/images-v2/expanddetails-16x16.svg",
	"./expandfocused-16x16.svg": "./src/images-v2/expandfocused-16x16.svg",
	"./expandpage-16x16.svg": "./src/images-v2/expandpage-16x16.svg",
	"./expandpanel-16x16.svg": "./src/images-v2/expandpanel-16x16.svg",
	"./file-72x72.svg": "./src/images-v2/file-72x72.svg",
	"./finishedit-24x24.svg": "./src/images-v2/finishedit-24x24.svg",
	"./fix-24x24.svg": "./src/images-v2/fix-24x24.svg",
	"./flip-24x24.svg": "./src/images-v2/flip-24x24.svg",
	"./folder-24x24.svg": "./src/images-v2/folder-24x24.svg",
	"./fullsize-16x16.svg": "./src/images-v2/fullsize-16x16.svg",
	"./gear-24x24.svg": "./src/images-v2/gear-24x24.svg",
	"./help-24x24.svg": "./src/images-v2/help-24x24.svg",
	"./hidehint-16x16.svg": "./src/images-v2/hidehint-16x16.svg",
	"./hidehint-24x24.svg": "./src/images-v2/hidehint-24x24.svg",
	"./hint-16x16.svg": "./src/images-v2/hint-16x16.svg",
	"./hint-24x24.svg": "./src/images-v2/hint-24x24.svg",
	"./image-48x48.svg": "./src/images-v2/image-48x48.svg",
	"./import-24x24.svg": "./src/images-v2/import-24x24.svg",
	"./invisible-24x24.svg": "./src/images-v2/invisible-24x24.svg",
	"./language-24x24.svg": "./src/images-v2/language-24x24.svg",
	"./loading-48x48.svg": "./src/images-v2/loading-48x48.svg",
	"./logic-24x24.svg": "./src/images-v2/logic-24x24.svg",
	"./logo-angular-24x24.svg": "./src/images-v2/logo-angular-24x24.svg",
	"./logo-jquery-24x24.svg": "./src/images-v2/logo-jquery-24x24.svg",
	"./logo-knockout-24x24.svg": "./src/images-v2/logo-knockout-24x24.svg",
	"./logo-react-24x24.svg": "./src/images-v2/logo-react-24x24.svg",
	"./logo-surveycreator-48x48.svg": "./src/images-v2/logo-surveycreator-48x48.svg",
	"./logo-vue-24x24.svg": "./src/images-v2/logo-vue-24x24.svg",
	"./maximize-16x16.svg": "./src/images-v2/maximize-16x16.svg",
	"./minimize-16x16.svg": "./src/images-v2/minimize-16x16.svg",
	"./minus-32x32.svg": "./src/images-v2/minus-32x32.svg",
	"./minusbox-16x16.svg": "./src/images-v2/minusbox-16x16.svg",
	"./more-16x16.svg": "./src/images-v2/more-16x16.svg",
	"./more-24x24.svg": "./src/images-v2/more-24x24.svg",
	"./navmenu-24x24.svg": "./src/images-v2/navmenu-24x24.svg",
	"./noimage-48x48.svg": "./src/images-v2/noimage-48x48.svg",
	"./pg-appearance-24x24.svg": "./src/images-v2/pg-appearance-24x24.svg",
	"./pg-background-24x24.svg": "./src/images-v2/pg-background-24x24.svg",
	"./pg-columns-24x24.svg": "./src/images-v2/pg-columns-24x24.svg",
	"./pg-conditions-24x24.svg": "./src/images-v2/pg-conditions-24x24.svg",
	"./pg-data-24x24.svg": "./src/images-v2/pg-data-24x24.svg",
	"./pg-design-24x24.svg": "./src/images-v2/pg-design-24x24.svg",
	"./pg-general-24x24.svg": "./src/images-v2/pg-general-24x24.svg",
	"./pg-header-24x24.svg": "./src/images-v2/pg-header-24x24.svg",
	"./pg-language-24x24.svg": "./src/images-v2/pg-language-24x24.svg",
	"./pg-layout-24x24.svg": "./src/images-v2/pg-layout-24x24.svg",
	"./pg-logo-24x24.svg": "./src/images-v2/pg-logo-24x24.svg",
	"./pg-navigation-24x24.svg": "./src/images-v2/pg-navigation-24x24.svg",
	"./pg-pages-24x24.svg": "./src/images-v2/pg-pages-24x24.svg",
	"./pg-questiondesign-24x24.svg": "./src/images-v2/pg-questiondesign-24x24.svg",
	"./pg-quiz-24x24.svg": "./src/images-v2/pg-quiz-24x24.svg",
	"./pg-rows-24x24.svg": "./src/images-v2/pg-rows-24x24.svg",
	"./pg-specific-24x24.svg": "./src/images-v2/pg-specific-24x24.svg",
	"./pg-thankyyoupage-24x24.svg": "./src/images-v2/pg-thankyyoupage-24x24.svg",
	"./pg-themes-24x24.svg": "./src/images-v2/pg-themes-24x24.svg",
	"./pg-totals-24x24.svg": "./src/images-v2/pg-totals-24x24.svg",
	"./pg-undefined-24x24.svg": "./src/images-v2/pg-undefined-24x24.svg",
	"./pg-validation-24x24.svg": "./src/images-v2/pg-validation-24x24.svg",
	"./phone-24x24.svg": "./src/images-v2/phone-24x24.svg",
	"./plus-32x32.svg": "./src/images-v2/plus-32x32.svg",
	"./plusbox-16x16.svg": "./src/images-v2/plusbox-16x16.svg",
	"./preview-24x24.svg": "./src/images-v2/preview-24x24.svg",
	"./publish-24x24.svg": "./src/images-v2/publish-24x24.svg",
	"./questionlock-24x24.svg": "./src/images-v2/questionlock-24x24.svg",
	"./ranking-arrows.svg": "./src/images-v2/ranking-arrows.svg",
	"./rankingundefined-16x16.svg": "./src/images-v2/rankingundefined-16x16.svg",
	"./redo-24x24.svg": "./src/images-v2/redo-24x24.svg",
	"./refresh-16x16.svg": "./src/images-v2/refresh-16x16.svg",
	"./remove-16x16.svg": "./src/images-v2/remove-16x16.svg",
	"./reorder-24x24.svg": "./src/images-v2/reorder-24x24.svg",
	"./required-16x16.svg": "./src/images-v2/required-16x16.svg",
	"./restore-24x24.svg": "./src/images-v2/restore-24x24.svg",
	"./restoredown-16x16.svg": "./src/images-v2/restoredown-16x16.svg",
	"./rotate-24x24.svg": "./src/images-v2/rotate-24x24.svg",
	"./save-24x24.svg": "./src/images-v2/save-24x24.svg",
	"./saveas-24x24.svg": "./src/images-v2/saveas-24x24.svg",
	"./search-24x24.svg": "./src/images-v2/search-24x24.svg",
	"./selectpage-24x24.svg": "./src/images-v2/selectpage-24x24.svg",
	"./settings-16x16.svg": "./src/images-v2/settings-16x16.svg",
	"./settings-24x24.svg": "./src/images-v2/settings-24x24.svg",
	"./smile-24x24.svg": "./src/images-v2/smile-24x24.svg",
	"./smiley-rate0-24x24.svg": "./src/images-v2/smiley-rate0-24x24.svg",
	"./smiley-rate1-24x24.svg": "./src/images-v2/smiley-rate1-24x24.svg",
	"./smiley-rate10-24x24.svg": "./src/images-v2/smiley-rate10-24x24.svg",
	"./smiley-rate2-24x24.svg": "./src/images-v2/smiley-rate2-24x24.svg",
	"./smiley-rate3-24x24.svg": "./src/images-v2/smiley-rate3-24x24.svg",
	"./smiley-rate4-24x24.svg": "./src/images-v2/smiley-rate4-24x24.svg",
	"./smiley-rate5-24x24.svg": "./src/images-v2/smiley-rate5-24x24.svg",
	"./smiley-rate6-24x24.svg": "./src/images-v2/smiley-rate6-24x24.svg",
	"./smiley-rate7-24x24.svg": "./src/images-v2/smiley-rate7-24x24.svg",
	"./smiley-rate8-24x24.svg": "./src/images-v2/smiley-rate8-24x24.svg",
	"./smiley-rate9-24x24.svg": "./src/images-v2/smiley-rate9-24x24.svg",
	"./speechbubble-16x16.svg": "./src/images-v2/speechbubble-16x16.svg",
	"./switchoff-16x16.svg": "./src/images-v2/switchoff-16x16.svg",
	"./switchon-16x16.svg": "./src/images-v2/switchon-16x16.svg",
	"./tablet-24x24.svg": "./src/images-v2/tablet-24x24.svg",
	"./textedit-24x24.svg": "./src/images-v2/textedit-24x24.svg",
	"./theme-24x24.svg": "./src/images-v2/theme-24x24.svg",
	"./toolbox-24x24.svg": "./src/images-v2/toolbox-24x24.svg",
	"./toolbox-boolean-16x16.svg": "./src/images-v2/toolbox-boolean-16x16.svg",
	"./toolbox-boolean-24x24.svg": "./src/images-v2/toolbox-boolean-24x24.svg",
	"./toolbox-checkbox-16x16.svg": "./src/images-v2/toolbox-checkbox-16x16.svg",
	"./toolbox-checkbox-24x24.svg": "./src/images-v2/toolbox-checkbox-24x24.svg",
	"./toolbox-customquestion-16x16.svg": "./src/images-v2/toolbox-customquestion-16x16.svg",
	"./toolbox-customquestion-24x24.svg": "./src/images-v2/toolbox-customquestion-24x24.svg",
	"./toolbox-dropdown-16x16.svg": "./src/images-v2/toolbox-dropdown-16x16.svg",
	"./toolbox-dropdown-24x24.svg": "./src/images-v2/toolbox-dropdown-24x24.svg",
	"./toolbox-dynamicmatrix-16x16.svg": "./src/images-v2/toolbox-dynamicmatrix-16x16.svg",
	"./toolbox-dynamicmatrix-24x24.svg": "./src/images-v2/toolbox-dynamicmatrix-24x24.svg",
	"./toolbox-dynamicpanel-16x16.svg": "./src/images-v2/toolbox-dynamicpanel-16x16.svg",
	"./toolbox-dynamicpanel-24x24.svg": "./src/images-v2/toolbox-dynamicpanel-24x24.svg",
	"./toolbox-expression-16x16.svg": "./src/images-v2/toolbox-expression-16x16.svg",
	"./toolbox-expression-24x24.svg": "./src/images-v2/toolbox-expression-24x24.svg",
	"./toolbox-file-16x16.svg": "./src/images-v2/toolbox-file-16x16.svg",
	"./toolbox-file-24x24.svg": "./src/images-v2/toolbox-file-24x24.svg",
	"./toolbox-html-16x16.svg": "./src/images-v2/toolbox-html-16x16.svg",
	"./toolbox-html-24x24.svg": "./src/images-v2/toolbox-html-24x24.svg",
	"./toolbox-image-16x16.svg": "./src/images-v2/toolbox-image-16x16.svg",
	"./toolbox-image-24x24.svg": "./src/images-v2/toolbox-image-24x24.svg",
	"./toolbox-imagepicker-16x16.svg": "./src/images-v2/toolbox-imagepicker-16x16.svg",
	"./toolbox-imagepicker-24x24.svg": "./src/images-v2/toolbox-imagepicker-24x24.svg",
	"./toolbox-longtext-16x16.svg": "./src/images-v2/toolbox-longtext-16x16.svg",
	"./toolbox-longtext-24x24.svg": "./src/images-v2/toolbox-longtext-24x24.svg",
	"./toolbox-matrix-16x16.svg": "./src/images-v2/toolbox-matrix-16x16.svg",
	"./toolbox-matrix-24x24.svg": "./src/images-v2/toolbox-matrix-24x24.svg",
	"./toolbox-multimatrix-16x16.svg": "./src/images-v2/toolbox-multimatrix-16x16.svg",
	"./toolbox-multimatrix-24x24.svg": "./src/images-v2/toolbox-multimatrix-24x24.svg",
	"./toolbox-multipletext-16x16.svg": "./src/images-v2/toolbox-multipletext-16x16.svg",
	"./toolbox-multipletext-24x24.svg": "./src/images-v2/toolbox-multipletext-24x24.svg",
	"./toolbox-panel-16x16.svg": "./src/images-v2/toolbox-panel-16x16.svg",
	"./toolbox-panel-24x24.svg": "./src/images-v2/toolbox-panel-24x24.svg",
	"./toolbox-radiogroup-16x16.svg": "./src/images-v2/toolbox-radiogroup-16x16.svg",
	"./toolbox-radiogroup-24x24.svg": "./src/images-v2/toolbox-radiogroup-24x24.svg",
	"./toolbox-ranking-16x16.svg": "./src/images-v2/toolbox-ranking-16x16.svg",
	"./toolbox-ranking-24x24.svg": "./src/images-v2/toolbox-ranking-24x24.svg",
	"./toolbox-rating-16x16.svg": "./src/images-v2/toolbox-rating-16x16.svg",
	"./toolbox-rating-24x24.svg": "./src/images-v2/toolbox-rating-24x24.svg",
	"./toolbox-signature-16x16.svg": "./src/images-v2/toolbox-signature-16x16.svg",
	"./toolbox-signature-24x24.svg": "./src/images-v2/toolbox-signature-24x24.svg",
	"./toolbox-singleline-16x16.svg": "./src/images-v2/toolbox-singleline-16x16.svg",
	"./toolbox-singleline-24x24.svg": "./src/images-v2/toolbox-singleline-24x24.svg",
	"./toolbox-tagbox-16x16.svg": "./src/images-v2/toolbox-tagbox-16x16.svg",
	"./toolbox-tagbox-24x24.svg": "./src/images-v2/toolbox-tagbox-24x24.svg",
	"./undo-24x24.svg": "./src/images-v2/undo-24x24.svg",
	"./visible-24x24.svg": "./src/images-v2/visible-24x24.svg",
	"./wand-24x24.svg": "./src/images-v2/wand-24x24.svg",
	"./warning-24x24.svg": "./src/images-v2/warning-24x24.svg",
	"./wrench-24x24.svg": "./src/images-v2/wrench-24x24.svg",
	"./zoomin-24x24.svg": "./src/images-v2/zoomin-24x24.svg",
	"./zoomout-24x24.svg": "./src/images-v2/zoomout-24x24.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/images-v2 sync recursive \\.svg$";

/***/ }),

/***/ "survey-core":
/*!*********************************************************************************************************!*\
  !*** external {"root":"Survey","commonjs2":"survey-core","commonjs":"survey-core","amd":"survey-core"} ***!
  \*********************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_survey_core__;

/***/ }),

/***/ "survey-creator-core/themes":
/*!******************************************************************************************************************************************************************!*\
  !*** external {"root":"SurveyCreatorTheme","commonjs2":"survey-creator-core/themes","commonjs":"survey-creator-core/themes","amd":"survey-creator-core/themes"} ***!
  \******************************************************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_survey_creator_core_themes__;

/***/ }),

/***/ "survey-core/themes":
/*!***********************************************************************************************************************************!*\
  !*** external {"root":"SurveyTheme","commonjs2":"survey-core/themes","commonjs":"survey-core/themes","amd":"survey-core/themes"} ***!
  \***********************************************************************************************************************************/
/***/ ((module) => {

"use strict";
module.exports = __WEBPACK_EXTERNAL_MODULE_survey_core_themes__;

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
(() => {
"use strict";
/*!******************************!*\
  !*** ./src/entries/index.ts ***!
  \******************************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   AceJsonEditorModel: () => (/* reexport safe */ _components_tabs_json_editor_ace__WEBPACK_IMPORTED_MODULE_7__.AceJsonEditorModel),
/* harmony export */   ColorCalculator: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.ColorCalculator),
/* harmony export */   CreatorAction: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.CreatorAction),
/* harmony export */   CreatorBase: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.CreatorBase),
/* harmony export */   CreatorEvent: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.CreatorEvent),
/* harmony export */   CreatorPreset: () => (/* reexport safe */ _presets_presets__WEBPACK_IMPORTED_MODULE_89__.CreatorPreset),
/* harmony export */   CreatorPresetBase: () => (/* reexport safe */ _presets_presets_base__WEBPACK_IMPORTED_MODULE_88__.CreatorPresetBase),
/* harmony export */   CreatorPresetPropertyGrid: () => (/* reexport safe */ _presets_presets_properties__WEBPACK_IMPORTED_MODULE_90__.CreatorPresetPropertyGrid),
/* harmony export */   CreatorPresetPropertyGridDefinition: () => (/* reexport safe */ _presets_presets_properties__WEBPACK_IMPORTED_MODULE_90__.CreatorPresetPropertyGridDefinition),
/* harmony export */   CreatorPresetTabs: () => (/* reexport safe */ _presets_presets_tabs__WEBPACK_IMPORTED_MODULE_91__.CreatorPresetTabs),
/* harmony export */   CreatorPresetToolbox: () => (/* reexport safe */ _presets_presets_toolbox__WEBPACK_IMPORTED_MODULE_92__.CreatorPresetToolbox),
/* harmony export */   CreatorPresetToolboxConfigurator: () => (/* reexport safe */ _presets_presets_toolbox__WEBPACK_IMPORTED_MODULE_92__.CreatorPresetToolboxConfigurator),
/* harmony export */   CreatorPresetToolboxDefinition: () => (/* reexport safe */ _presets_presets_toolbox__WEBPACK_IMPORTED_MODULE_92__.CreatorPresetToolboxDefinition),
/* harmony export */   CreatorResponsivityManager: () => (/* reexport safe */ _creator_responsivity_manager__WEBPACK_IMPORTED_MODULE_6__.CreatorResponsivityManager),
/* harmony export */   CreatorThemeModel: () => (/* reexport safe */ _creator_theme_creator_theme_model__WEBPACK_IMPORTED_MODULE_87__.CreatorThemeModel),
/* harmony export */   DEFAULT_MONITOR_DPI: () => (/* reexport safe */ _components_simulator__WEBPACK_IMPORTED_MODULE_41__.DEFAULT_MONITOR_DPI),
/* harmony export */   DefaultFonts: () => (/* reexport safe */ _components_tabs_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_14__.DefaultFonts),
/* harmony export */   DragDropSurveyElements: () => (/* reexport safe */ _survey_elements__WEBPACK_IMPORTED_MODULE_93__.DragDropSurveyElements),
/* harmony export */   EditorLocalization: () => (/* reexport safe */ _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.EditorLocalization),
/* harmony export */   EmptySurveyCreatorOptions: () => (/* reexport safe */ _creator_settings__WEBPACK_IMPORTED_MODULE_2__.EmptySurveyCreatorOptions),
/* harmony export */   HEXToRGB: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.HEXToRGB),
/* harmony export */   HSBToRGB: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.HSBToRGB),
/* harmony export */   ImageItemValueWrapperViewModel: () => (/* reexport safe */ _components_image_item_value__WEBPACK_IMPORTED_MODULE_39__.ImageItemValueWrapperViewModel),
/* harmony export */   ItemValueWrapperViewModel: () => (/* reexport safe */ _components_item_value__WEBPACK_IMPORTED_MODULE_38__.ItemValueWrapperViewModel),
/* harmony export */   JsonDuplicateNameError: () => (/* reexport safe */ _textWorker__WEBPACK_IMPORTED_MODULE_69__.JsonDuplicateNameError),
/* harmony export */   JsonEditorBaseModel: () => (/* reexport safe */ _components_tabs_json_editor_plugin__WEBPACK_IMPORTED_MODULE_8__.JsonEditorBaseModel),
/* harmony export */   LogicEvent: () => (/* reexport safe */ _components_tabs_logic__WEBPACK_IMPORTED_MODULE_20__.LogicEvent),
/* harmony export */   LogoImageViewModel: () => (/* reexport safe */ _components_header_logo_image__WEBPACK_IMPORTED_MODULE_43__.LogoImageViewModel),
/* harmony export */   MatrixCellWrapperEditSurvey: () => (/* reexport safe */ _components_matrix_cell__WEBPACK_IMPORTED_MODULE_40__.MatrixCellWrapperEditSurvey),
/* harmony export */   MatrixCellWrapperViewModel: () => (/* reexport safe */ _components_matrix_cell__WEBPACK_IMPORTED_MODULE_40__.MatrixCellWrapperViewModel),
/* harmony export */   MenuButton: () => (/* reexport safe */ _utils_actions__WEBPACK_IMPORTED_MODULE_78__.MenuButton),
/* harmony export */   ObjType: () => (/* reexport safe */ _survey_helper__WEBPACK_IMPORTED_MODULE_81__.ObjType),
/* harmony export */   ObjectSelector: () => (/* reexport safe */ _property_grid_object_selector__WEBPACK_IMPORTED_MODULE_59__.ObjectSelector),
/* harmony export */   ObjectSelectorItem: () => (/* reexport safe */ _property_grid_object_selector__WEBPACK_IMPORTED_MODULE_59__.ObjectSelectorItem),
/* harmony export */   ObjectSelectorModel: () => (/* reexport safe */ _property_grid_object_selector__WEBPACK_IMPORTED_MODULE_59__.ObjectSelectorModel),
/* harmony export */   PageAdorner: () => (/* reexport safe */ _components_page__WEBPACK_IMPORTED_MODULE_32__.PageAdorner),
/* harmony export */   PageNavigatorViewModel: () => (/* reexport safe */ _components_page_navigator_page_navigator__WEBPACK_IMPORTED_MODULE_31__.PageNavigatorViewModel),
/* harmony export */   PagesController: () => (/* reexport safe */ _pages_controller__WEBPACK_IMPORTED_MODULE_85__.PagesController),
/* harmony export */   PredefinedBackgroundColors: () => (/* reexport safe */ _components_tabs_themes__WEBPACK_IMPORTED_MODULE_16__.PredefinedBackgroundColors),
/* harmony export */   PredefinedColors: () => (/* reexport safe */ _components_tabs_themes__WEBPACK_IMPORTED_MODULE_16__.PredefinedColors),
/* harmony export */   PredefinedThemes: () => (/* reexport safe */ _components_tabs_themes__WEBPACK_IMPORTED_MODULE_16__.PredefinedThemes),
/* harmony export */   PropertyEditorSetupValue: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyEditorSetupValue),
/* harmony export */   PropertyGridCellsEditor: () => (/* reexport safe */ _property_grid_values__WEBPACK_IMPORTED_MODULE_62__.PropertyGridCellsEditor),
/* harmony export */   PropertyGridEditor: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditor),
/* harmony export */   PropertyGridEditorBackgroundCornerRadius: () => (/* reexport safe */ _property_grid_theme_settings__WEBPACK_IMPORTED_MODULE_61__.PropertyGridEditorBackgroundCornerRadius),
/* harmony export */   PropertyGridEditorBindings: () => (/* reexport safe */ _property_grid_bindings__WEBPACK_IMPORTED_MODULE_57__.PropertyGridEditorBindings),
/* harmony export */   PropertyGridEditorBoolean: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorBoolean),
/* harmony export */   PropertyGridEditorCollection: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorCollection),
/* harmony export */   PropertyGridEditorColor: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorColor),
/* harmony export */   PropertyGridEditorColorWithAlpha: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorColorWithAlpha),
/* harmony export */   PropertyGridEditorCondition: () => (/* reexport safe */ _property_grid_condition__WEBPACK_IMPORTED_MODULE_55__.PropertyGridEditorCondition),
/* harmony export */   PropertyGridEditorDateTime: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorDateTime),
/* harmony export */   PropertyGridEditorDropdown: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorDropdown),
/* harmony export */   PropertyGridEditorExpression: () => (/* reexport safe */ _property_grid_condition__WEBPACK_IMPORTED_MODULE_55__.PropertyGridEditorExpression),
/* harmony export */   PropertyGridEditorFontSettings: () => (/* reexport safe */ _property_grid_theme_settings__WEBPACK_IMPORTED_MODULE_61__.PropertyGridEditorFontSettings),
/* harmony export */   PropertyGridEditorHtml: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorHtml),
/* harmony export */   PropertyGridEditorImageSize: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorImageSize),
/* harmony export */   PropertyGridEditorMatrix: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrix),
/* harmony export */   PropertyGridEditorMatrixCalculatedValues: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixCalculatedValues),
/* harmony export */   PropertyGridEditorMatrixColumns: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixColumns),
/* harmony export */   PropertyGridEditorMatrixHtmlConditions: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixHtmlConditions),
/* harmony export */   PropertyGridEditorMatrixItemValues: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixItemValues),
/* harmony export */   PropertyGridEditorMatrixLayoutColumns: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixLayoutColumns),
/* harmony export */   PropertyGridEditorMatrixMultipleTypes: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixMultipleTypes),
/* harmony export */   PropertyGridEditorMatrixMutlipleTextItems: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixMutlipleTextItems),
/* harmony export */   PropertyGridEditorMatrixPages: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixPages),
/* harmony export */   PropertyGridEditorMatrixRateValues: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixRateValues),
/* harmony export */   PropertyGridEditorMatrixTriggers: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixTriggers),
/* harmony export */   PropertyGridEditorMatrixUrlConditions: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixUrlConditions),
/* harmony export */   PropertyGridEditorMatrixValidators: () => (/* reexport safe */ _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__.PropertyGridEditorMatrixValidators),
/* harmony export */   PropertyGridEditorNumber: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorNumber),
/* harmony export */   PropertyGridEditorPage: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorPage),
/* harmony export */   PropertyGridEditorQuestion: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorQuestion),
/* harmony export */   PropertyGridEditorQuestionCarryForward: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorQuestionCarryForward),
/* harmony export */   PropertyGridEditorQuestionHeader: () => (/* reexport safe */ _property_grid_header_settings__WEBPACK_IMPORTED_MODULE_65__.PropertyGridEditorQuestionHeader),
/* harmony export */   PropertyGridEditorQuestionMaskSettings: () => (/* reexport safe */ _property_grid_maskSettings__WEBPACK_IMPORTED_MODULE_64__.PropertyGridEditorQuestionMaskSettings),
/* harmony export */   PropertyGridEditorQuestionRestfull: () => (/* reexport safe */ _property_grid_restfull__WEBPACK_IMPORTED_MODULE_60__.PropertyGridEditorQuestionRestfull),
/* harmony export */   PropertyGridEditorQuestionSelectBase: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorQuestionSelectBase),
/* harmony export */   PropertyGridEditorQuestionValue: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorQuestionValue),
/* harmony export */   PropertyGridEditorSet: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorSet),
/* harmony export */   PropertyGridEditorShadowEffects: () => (/* reexport safe */ _property_grid_theme_settings__WEBPACK_IMPORTED_MODULE_61__.PropertyGridEditorShadowEffects),
/* harmony export */   PropertyGridEditorSpinEdit: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorSpinEdit),
/* harmony export */   PropertyGridEditorString: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorString),
/* harmony export */   PropertyGridEditorStringArray: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorStringArray),
/* harmony export */   PropertyGridEditorStringBase: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorStringBase),
/* harmony export */   PropertyGridEditorSwitchToggle: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorSwitchToggle),
/* harmony export */   PropertyGridEditorText: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorText),
/* harmony export */   PropertyGridEditorUndefinedBoolean: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridEditorUndefinedBoolean),
/* harmony export */   PropertyGridLinkEditor: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridLinkEditor),
/* harmony export */   PropertyGridModel: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridModel),
/* harmony export */   PropertyGridPanelValueEditor: () => (/* reexport safe */ _property_grid_values__WEBPACK_IMPORTED_MODULE_62__.PropertyGridPanelValueEditor),
/* harmony export */   PropertyGridRowValueEditor: () => (/* reexport safe */ _property_grid_values__WEBPACK_IMPORTED_MODULE_62__.PropertyGridRowValueEditor),
/* harmony export */   PropertyGridTitleActionsCreator: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyGridTitleActionsCreator),
/* harmony export */   PropertyGridTriggerValueEditor: () => (/* reexport safe */ _property_grid_values__WEBPACK_IMPORTED_MODULE_62__.PropertyGridTriggerValueEditor),
/* harmony export */   PropertyGridTriggerValueInLogicEditor: () => (/* reexport safe */ _property_grid_values__WEBPACK_IMPORTED_MODULE_62__.PropertyGridTriggerValueInLogicEditor),
/* harmony export */   PropertyGridValueEditor: () => (/* reexport safe */ _property_grid_values__WEBPACK_IMPORTED_MODULE_62__.PropertyGridValueEditor),
/* harmony export */   PropertyGridValueEditorBase: () => (/* reexport safe */ _property_grid_values__WEBPACK_IMPORTED_MODULE_62__.PropertyGridValueEditorBase),
/* harmony export */   PropertyGridViewModel: () => (/* reexport safe */ _property_grid_property_grid_view_model__WEBPACK_IMPORTED_MODULE_58__.PropertyGridViewModel),
/* harmony export */   PropertyJSONGenerator: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.PropertyJSONGenerator),
/* harmony export */   QuestionAdornerViewModel: () => (/* reexport safe */ _components_question__WEBPACK_IMPORTED_MODULE_34__.QuestionAdornerViewModel),
/* harmony export */   QuestionColorModel: () => (/* reexport safe */ _custom_questions_question_color__WEBPACK_IMPORTED_MODULE_51__.QuestionColorModel),
/* harmony export */   QuestionCommentWithResetModel: () => (/* reexport safe */ _custom_questions_question_text_with_reset__WEBPACK_IMPORTED_MODULE_53__.QuestionCommentWithResetModel),
/* harmony export */   QuestionConvertMode: () => (/* reexport safe */ _creator_settings__WEBPACK_IMPORTED_MODULE_2__.QuestionConvertMode),
/* harmony export */   QuestionConverter: () => (/* reexport safe */ _questionconverter__WEBPACK_IMPORTED_MODULE_67__.QuestionConverter),
/* harmony export */   QuestionDropdownAdornerViewModel: () => (/* reexport safe */ _components_question_dropdown__WEBPACK_IMPORTED_MODULE_35__.QuestionDropdownAdornerViewModel),
/* harmony export */   QuestionEmbeddedSurveyModel: () => (/* reexport safe */ _components_embedded_survey__WEBPACK_IMPORTED_MODULE_45__.QuestionEmbeddedSurveyModel),
/* harmony export */   QuestionFileEditorModel: () => (/* reexport safe */ _custom_questions_question_file__WEBPACK_IMPORTED_MODULE_52__.QuestionFileEditorModel),
/* harmony export */   QuestionImageAdornerViewModel: () => (/* reexport safe */ _components_question_image__WEBPACK_IMPORTED_MODULE_36__.QuestionImageAdornerViewModel),
/* harmony export */   QuestionLinkValueModel: () => (/* reexport safe */ _components_link_value__WEBPACK_IMPORTED_MODULE_46__.QuestionLinkValueModel),
/* harmony export */   QuestionRatingAdornerViewModel: () => (/* reexport safe */ _components_question_rating__WEBPACK_IMPORTED_MODULE_37__.QuestionRatingAdornerViewModel),
/* harmony export */   QuestionSpinEditorModel: () => (/* reexport safe */ _custom_questions_question_spin_editor__WEBPACK_IMPORTED_MODULE_50__.QuestionSpinEditorModel),
/* harmony export */   QuestionTextWithResetModel: () => (/* reexport safe */ _custom_questions_question_text_with_reset__WEBPACK_IMPORTED_MODULE_53__.QuestionTextWithResetModel),
/* harmony export */   QuestionToolbox: () => (/* reexport safe */ _toolbox__WEBPACK_IMPORTED_MODULE_70__.QuestionToolbox),
/* harmony export */   QuestionToolboxCategory: () => (/* reexport safe */ _toolbox__WEBPACK_IMPORTED_MODULE_70__.QuestionToolboxCategory),
/* harmony export */   QuestionToolboxItem: () => (/* reexport safe */ _toolbox__WEBPACK_IMPORTED_MODULE_70__.QuestionToolboxItem),
/* harmony export */   RGBToHSB: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.RGBToHSB),
/* harmony export */   ResetValueAdorner: () => (/* reexport safe */ _custom_questions_question_text_with_reset__WEBPACK_IMPORTED_MODULE_53__.ResetValueAdorner),
/* harmony export */   ResizeManager: () => (/* reexport safe */ _utils_resizer__WEBPACK_IMPORTED_MODULE_82__.ResizeManager),
/* harmony export */   RowViewModel: () => (/* reexport safe */ _components_row__WEBPACK_IMPORTED_MODULE_33__.RowViewModel),
/* harmony export */   ScrollViewModel: () => (/* reexport safe */ _components_scroll__WEBPACK_IMPORTED_MODULE_48__.ScrollViewModel),
/* harmony export */   SearchManager: () => (/* reexport safe */ _components_search_manager__WEBPACK_IMPORTED_MODULE_47__.SearchManager),
/* harmony export */   SearchManagerPropertyGrid: () => (/* reexport safe */ _property_grid_search_manager__WEBPACK_IMPORTED_MODULE_63__.SearchManagerPropertyGrid),
/* harmony export */   SearchManagerToolbox: () => (/* reexport safe */ _components_toolbox_toolbox_search_manager__WEBPACK_IMPORTED_MODULE_30__.SearchManagerToolbox),
/* harmony export */   SidebarHeaderModel: () => (/* reexport safe */ _components_side_bar_side_bar_header_model__WEBPACK_IMPORTED_MODULE_72__.SidebarHeaderModel),
/* harmony export */   SidebarModel: () => (/* reexport safe */ _components_side_bar_side_bar_model__WEBPACK_IMPORTED_MODULE_71__.SidebarModel),
/* harmony export */   SidebarPageModel: () => (/* reexport safe */ _components_side_bar_side_bar_page_model__WEBPACK_IMPORTED_MODULE_73__.SidebarPageModel),
/* harmony export */   StringEditorConnector: () => (/* reexport safe */ _components_string_editor__WEBPACK_IMPORTED_MODULE_44__.StringEditorConnector),
/* harmony export */   StringEditorViewModelBase: () => (/* reexport safe */ _components_string_editor__WEBPACK_IMPORTED_MODULE_44__.StringEditorViewModelBase),
/* harmony export */   StringItemsNavigatorBase: () => (/* reexport safe */ _components_string_editor__WEBPACK_IMPORTED_MODULE_44__.StringItemsNavigatorBase),
/* harmony export */   StylesManager: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.StylesManager),
/* harmony export */   SurveyCreatorModel: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.SurveyCreatorModel),
/* harmony export */   SurveyHelper: () => (/* reexport safe */ _survey_helper__WEBPACK_IMPORTED_MODULE_81__.SurveyHelper),
/* harmony export */   SurveyJSON5: () => (/* reexport safe */ _json5__WEBPACK_IMPORTED_MODULE_49__.SurveyJSON5),
/* harmony export */   SurveyLogic: () => (/* reexport safe */ _components_tabs_logic__WEBPACK_IMPORTED_MODULE_20__.SurveyLogic),
/* harmony export */   SurveyLogicUI: () => (/* reexport safe */ _components_tabs_logic_ui__WEBPACK_IMPORTED_MODULE_26__.SurveyLogicUI),
/* harmony export */   SurveyQuestionEditorDefinition: () => (/* reexport safe */ _question_editor_definition__WEBPACK_IMPORTED_MODULE_79__.SurveyQuestionEditorDefinition),
/* harmony export */   SurveyQuestionEditorPropertyDefinition: () => (/* reexport safe */ _question_editor_properties__WEBPACK_IMPORTED_MODULE_80__.SurveyQuestionEditorPropertyDefinition),
/* harmony export */   SurveyQuestionEditorTabDefinition: () => (/* reexport safe */ _question_editor_properties__WEBPACK_IMPORTED_MODULE_80__.SurveyQuestionEditorTabDefinition),
/* harmony export */   SurveyQuestionProperties: () => (/* reexport safe */ _question_editor_properties__WEBPACK_IMPORTED_MODULE_80__.SurveyQuestionProperties),
/* harmony export */   SurveyResultsItemModel: () => (/* reexport safe */ _components_results__WEBPACK_IMPORTED_MODULE_42__.SurveyResultsItemModel),
/* harmony export */   SurveyResultsModel: () => (/* reexport safe */ _components_results__WEBPACK_IMPORTED_MODULE_42__.SurveyResultsModel),
/* harmony export */   SurveySimulatorModel: () => (/* reexport safe */ _components_simulator__WEBPACK_IMPORTED_MODULE_41__.SurveySimulatorModel),
/* harmony export */   SurveyTextWorker: () => (/* reexport safe */ _textWorker__WEBPACK_IMPORTED_MODULE_69__.SurveyTextWorker),
/* harmony export */   SurveyTextWorkerError: () => (/* reexport safe */ _textWorker__WEBPACK_IMPORTED_MODULE_69__.SurveyTextWorkerError),
/* harmony export */   SurveyTextWorkerJsonError: () => (/* reexport safe */ _textWorker__WEBPACK_IMPORTED_MODULE_69__.SurveyTextWorkerJsonError),
/* harmony export */   SurveyTextWorkerParserError: () => (/* reexport safe */ _textWorker__WEBPACK_IMPORTED_MODULE_69__.SurveyTextWorkerParserError),
/* harmony export */   Switcher: () => (/* reexport safe */ _components_switcher_switcher__WEBPACK_IMPORTED_MODULE_75__.Switcher),
/* harmony export */   TabControlModel: () => (/* reexport safe */ _components_side_bar_tab_control_model__WEBPACK_IMPORTED_MODULE_74__.TabControlModel),
/* harmony export */   TabDesignerPlugin: () => (/* reexport safe */ _components_tabs_designer_plugin__WEBPACK_IMPORTED_MODULE_25__.TabDesignerPlugin),
/* harmony export */   TabDesignerViewModel: () => (/* reexport safe */ _components_tabs_designer__WEBPACK_IMPORTED_MODULE_24__.TabDesignerViewModel),
/* harmony export */   TabJsonEditorAcePlugin: () => (/* reexport safe */ _components_tabs_json_editor_ace__WEBPACK_IMPORTED_MODULE_7__.TabJsonEditorAcePlugin),
/* harmony export */   TabJsonEditorBasePlugin: () => (/* reexport safe */ _components_tabs_json_editor_plugin__WEBPACK_IMPORTED_MODULE_8__.TabJsonEditorBasePlugin),
/* harmony export */   TabJsonEditorTextareaPlugin: () => (/* reexport safe */ _components_tabs_json_editor_textarea__WEBPACK_IMPORTED_MODULE_9__.TabJsonEditorTextareaPlugin),
/* harmony export */   TabLogicPlugin: () => (/* reexport safe */ _components_tabs_logic_plugin__WEBPACK_IMPORTED_MODULE_27__.TabLogicPlugin),
/* harmony export */   TabTestPlugin: () => (/* reexport safe */ _components_tabs_test_plugin__WEBPACK_IMPORTED_MODULE_11__.TabTestPlugin),
/* harmony export */   TabTranslationPlugin: () => (/* reexport safe */ _components_tabs_translation_plugin__WEBPACK_IMPORTED_MODULE_23__.TabTranslationPlugin),
/* harmony export */   TabbedMenuContainer: () => (/* reexport safe */ _tabbed_menu__WEBPACK_IMPORTED_MODULE_5__.TabbedMenuContainer),
/* harmony export */   TabbedMenuItem: () => (/* reexport safe */ _tabbed_menu__WEBPACK_IMPORTED_MODULE_5__.TabbedMenuItem),
/* harmony export */   TestSurveyTabViewModel: () => (/* reexport safe */ _components_tabs_test__WEBPACK_IMPORTED_MODULE_10__.TestSurveyTabViewModel),
/* harmony export */   TextareaJsonEditorModel: () => (/* reexport safe */ _components_tabs_json_editor_textarea__WEBPACK_IMPORTED_MODULE_9__.TextareaJsonEditorModel),
/* harmony export */   ThemeModelEditorDefinition: () => (/* reexport safe */ _components_tabs_theme_model_definition__WEBPACK_IMPORTED_MODULE_19__.ThemeModelEditorDefinition),
/* harmony export */   ThemeTabPlugin: () => (/* reexport safe */ _components_tabs_theme_plugin__WEBPACK_IMPORTED_MODULE_18__.ThemeTabPlugin),
/* harmony export */   ThemeTabViewModel: () => (/* reexport safe */ _components_tabs_theme_builder__WEBPACK_IMPORTED_MODULE_17__.ThemeTabViewModel),
/* harmony export */   Themes: () => (/* reexport safe */ _components_tabs_themes__WEBPACK_IMPORTED_MODULE_16__.Themes),
/* harmony export */   ToolbarActionContainer: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.ToolbarActionContainer),
/* harmony export */   ToolboxToolViewModel: () => (/* reexport safe */ _components_toolbox_toolbox_tool__WEBPACK_IMPORTED_MODULE_29__.ToolboxToolViewModel),
/* harmony export */   Transaction: () => (/* reexport safe */ _plugins_undo_redo_undo_redo_manager__WEBPACK_IMPORTED_MODULE_84__.Transaction),
/* harmony export */   Translation: () => (/* reexport safe */ _components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__.Translation),
/* harmony export */   TranslationEditor: () => (/* reexport safe */ _components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__.TranslationEditor),
/* harmony export */   TranslationForEditor: () => (/* reexport safe */ _components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__.TranslationForEditor),
/* harmony export */   TranslationGroup: () => (/* reexport safe */ _components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__.TranslationGroup),
/* harmony export */   TranslationItem: () => (/* reexport safe */ _components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__.TranslationItem),
/* harmony export */   TranslationItemBase: () => (/* reexport safe */ _components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__.TranslationItemBase),
/* harmony export */   TranslationItemString: () => (/* reexport safe */ _components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__.TranslationItemString),
/* harmony export */   UndoRedoAction: () => (/* reexport safe */ _plugins_undo_redo_undo_redo_manager__WEBPACK_IMPORTED_MODULE_84__.UndoRedoAction),
/* harmony export */   UndoRedoArrayAction: () => (/* reexport safe */ _plugins_undo_redo_undo_redo_manager__WEBPACK_IMPORTED_MODULE_84__.UndoRedoArrayAction),
/* harmony export */   UndoRedoManager: () => (/* reexport safe */ _plugins_undo_redo_undo_redo_manager__WEBPACK_IMPORTED_MODULE_84__.UndoRedoManager),
/* harmony export */   UndoRedoPlugin: () => (/* reexport safe */ _plugins_undo_redo__WEBPACK_IMPORTED_MODULE_83__.UndoRedoPlugin),
/* harmony export */   Version: () => (/* binding */ Version),
/* harmony export */   assign: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.assign),
/* harmony export */   assignDefaultV2Classes: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.assignDefaultV2Classes),
/* harmony export */   backgroundCornerRadiusFromCssVariable: () => (/* reexport safe */ _components_tabs_theme_custom_questions_background_corner_radius__WEBPACK_IMPORTED_MODULE_15__.backgroundCornerRadiusFromCssVariable),
/* harmony export */   backgroundCornerRadiusToCssVariable: () => (/* reexport safe */ _components_tabs_theme_custom_questions_background_corner_radius__WEBPACK_IMPORTED_MODULE_15__.backgroundCornerRadiusToCssVariable),
/* harmony export */   calculateDragOverLocation: () => (/* reexport safe */ _survey_elements__WEBPACK_IMPORTED_MODULE_93__.calculateDragOverLocation),
/* harmony export */   calculateIsEdge: () => (/* reexport safe */ _survey_elements__WEBPACK_IMPORTED_MODULE_93__.calculateIsEdge),
/* harmony export */   calculateIsSide: () => (/* reexport safe */ _survey_elements__WEBPACK_IMPORTED_MODULE_93__.calculateIsSide),
/* harmony export */   capitalize: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.capitalize),
/* harmony export */   clearNewLines: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.clearNewLines),
/* harmony export */   colorsAreEqual: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.colorsAreEqual),
/* harmony export */   convertRgbaToString: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.convertRgbaToString),
/* harmony export */   copyCssClasses: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.copyCssClasses),
/* harmony export */   copyObject: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.copyObject),
/* harmony export */   createBoxShadow: () => (/* reexport safe */ _components_tabs_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_13__.createBoxShadow),
/* harmony export */   createBoxShadowReset: () => (/* reexport safe */ _components_tabs_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_13__.createBoxShadowReset),
/* harmony export */   createColor: () => (/* reexport safe */ _components_tabs_theme_custom_questions_color_alpha__WEBPACK_IMPORTED_MODULE_12__.createColor),
/* harmony export */   createExportCSVAction: () => (/* reexport safe */ _components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__.createExportCSVAction),
/* harmony export */   createImportCSVAction: () => (/* reexport safe */ _components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__.createImportCSVAction),
/* harmony export */   creatorThemeModelEditorDefinition: () => (/* reexport safe */ _creator_theme_creator_theme_model_definition__WEBPACK_IMPORTED_MODULE_86__.creatorThemeModelEditorDefinition),
/* harmony export */   creatorThemeModelPropertyGridDefinition: () => (/* reexport safe */ _creator_theme_creator_theme_model_definition__WEBPACK_IMPORTED_MODULE_86__.creatorThemeModelPropertyGridDefinition),
/* harmony export */   defaultPropertyGridDefinition: () => (/* reexport safe */ _question_editor_definition__WEBPACK_IMPORTED_MODULE_79__.defaultPropertyGridDefinition),
/* harmony export */   defaultStrings: () => (/* reexport safe */ _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.defaultStrings),
/* harmony export */   editableStringRendererName: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.editableStringRendererName),
/* harmony export */   editorLocalization: () => (/* reexport safe */ _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization),
/* harmony export */   enStrings: () => (/* reexport safe */ _localization_english__WEBPACK_IMPORTED_MODULE_0__.enStrings),
/* harmony export */   findParentNode: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.findParentNode),
/* harmony export */   focusFirstControl: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.focusFirstControl),
/* harmony export */   fontsettingsFromCssVariable: () => (/* reexport safe */ _components_tabs_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_14__.fontsettingsFromCssVariable),
/* harmony export */   fontsettingsToCssVariable: () => (/* reexport safe */ _components_tabs_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_14__.fontsettingsToCssVariable),
/* harmony export */   getAcceptedTypesByContentMode: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.getAcceptedTypesByContentMode),
/* harmony export */   getElementWrapperComponentData: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.getElementWrapperComponentData),
/* harmony export */   getElementWrapperComponentName: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.getElementWrapperComponentName),
/* harmony export */   getFirstNonTextElement: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.getFirstNonTextElement),
/* harmony export */   getItemValueWrapperComponentData: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.getItemValueWrapperComponentData),
/* harmony export */   getItemValueWrapperComponentName: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.getItemValueWrapperComponentName),
/* harmony export */   getLocString: () => (/* reexport safe */ _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.getLocString),
/* harmony export */   getNextItemText: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.getNextItemText),
/* harmony export */   getNextItemValue: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.getNextItemValue),
/* harmony export */   getNextValue: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.getNextValue),
/* harmony export */   getNodesFromKoComponentInfo: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.getNodesFromKoComponentInfo),
/* harmony export */   getPredefinedBackgoundColorsChoices: () => (/* reexport safe */ _components_tabs_themes__WEBPACK_IMPORTED_MODULE_16__.getPredefinedBackgoundColorsChoices),
/* harmony export */   getPredefinedColorsItemValues: () => (/* reexport safe */ _components_tabs_themes__WEBPACK_IMPORTED_MODULE_16__.getPredefinedColorsItemValues),
/* harmony export */   getQuestionContentWrapperComponentName: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.getQuestionContentWrapperComponentName),
/* harmony export */   getQuestionFromObj: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.getQuestionFromObj),
/* harmony export */   iconsV1: () => (/* reexport safe */ _svgbundle__WEBPACK_IMPORTED_MODULE_68__.iconsV1),
/* harmony export */   iconsV2: () => (/* reexport safe */ _svgbundle__WEBPACK_IMPORTED_MODULE_68__.iconsV2),
/* harmony export */   ignoreUndoRedo: () => (/* reexport safe */ _plugins_undo_redo__WEBPACK_IMPORTED_MODULE_83__.ignoreUndoRedo),
/* harmony export */   imageMimeTypes: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.imageMimeTypes),
/* harmony export */   ingectAlpha: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.ingectAlpha),
/* harmony export */   initLogicOperator: () => (/* reexport safe */ _components_tabs_logic__WEBPACK_IMPORTED_MODULE_20__.initLogicOperator),
/* harmony export */   initialSettingsAllowShowEmptyTitleInDesignMode: () => (/* reexport safe */ _components_tabs_designer__WEBPACK_IMPORTED_MODULE_24__.initialSettingsAllowShowEmptyTitleInDesignMode),
/* harmony export */   initializeDesignTimeSurveyModel: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.initializeDesignTimeSurveyModel),
/* harmony export */   isPanelDynamic: () => (/* reexport safe */ _survey_elements__WEBPACK_IMPORTED_MODULE_93__.isPanelDynamic),
/* harmony export */   isPropertyVisible: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.isPropertyVisible),
/* harmony export */   isStringEditable: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.isStringEditable),
/* harmony export */   isTextInput: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.isTextInput),
/* harmony export */   localization: () => (/* reexport safe */ _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.editorLocalization),
/* harmony export */   logicCss: () => (/* reexport safe */ _components_tabs_logic_theme__WEBPACK_IMPORTED_MODULE_28__.logicCss),
/* harmony export */   notShortCircuitAnd: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.notShortCircuitAnd),
/* harmony export */   parseBoxShadow: () => (/* reexport safe */ _components_tabs_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_13__.parseBoxShadow),
/* harmony export */   parseColor: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.parseColor),
/* harmony export */   parseRgbaFromString: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.parseRgbaFromString),
/* harmony export */   propertyExists: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.propertyExists),
/* harmony export */   propertyGridCss: () => (/* reexport safe */ _property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_66__.propertyGridCss),
/* harmony export */   registerAdorner: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.registerAdorner),
/* harmony export */   removeAdorners: () => (/* reexport safe */ _creator_base__WEBPACK_IMPORTED_MODULE_4__.removeAdorners),
/* harmony export */   roundTo2Decimals: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.roundTo2Decimals),
/* harmony export */   saveToFileHandler: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.saveToFileHandler),
/* harmony export */   scrollElementIntoView: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.scrollElementIntoView),
/* harmony export */   select: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.select),
/* harmony export */   setSurveyJSONForPropertyGrid: () => (/* reexport safe */ _property_grid__WEBPACK_IMPORTED_MODULE_54__.setSurveyJSONForPropertyGrid),
/* harmony export */   settings: () => (/* reexport safe */ _creator_settings__WEBPACK_IMPORTED_MODULE_2__.settings),
/* harmony export */   setupLocale: () => (/* reexport safe */ _editorLocalization__WEBPACK_IMPORTED_MODULE_1__.setupLocale),
/* harmony export */   simulatorDevices: () => (/* reexport safe */ _components_simulator__WEBPACK_IMPORTED_MODULE_41__.simulatorDevices),
/* harmony export */   svgBundle: () => (/* reexport safe */ _svgbundle__WEBPACK_IMPORTED_MODULE_68__.svgBundle),
/* harmony export */   themeModelPropertyGridDefinition: () => (/* reexport safe */ _components_tabs_theme_model_definition__WEBPACK_IMPORTED_MODULE_19__.themeModelPropertyGridDefinition),
/* harmony export */   toggleHovered: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.toggleHovered),
/* harmony export */   translationCss: () => (/* reexport safe */ _components_tabs_translation_theme__WEBPACK_IMPORTED_MODULE_22__.translationCss),
/* harmony export */   trimBoxShadowValue: () => (/* reexport safe */ _components_tabs_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_13__.trimBoxShadowValue),
/* harmony export */   trimEmptyFields: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.trimEmptyFields),
/* harmony export */   undoRedoTransaction: () => (/* reexport safe */ _plugins_undo_redo__WEBPACK_IMPORTED_MODULE_83__.undoRedoTransaction),
/* harmony export */   updateBackgroundCornerRadiusJSON: () => (/* reexport safe */ _components_tabs_theme_custom_questions_background_corner_radius__WEBPACK_IMPORTED_MODULE_15__.updateBackgroundCornerRadiusJSON),
/* harmony export */   updateFontSettingsJSON: () => (/* reexport safe */ _components_tabs_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_14__.updateFontSettingsJSON),
/* harmony export */   updateShadowEffectsJSON: () => (/* reexport safe */ _components_tabs_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_13__.updateShadowEffectsJSON),
/* harmony export */   updatecoloralphaJSON: () => (/* reexport safe */ _components_tabs_theme_custom_questions_color_alpha__WEBPACK_IMPORTED_MODULE_12__.updatecoloralphaJSON),
/* harmony export */   wrapTextByCurlyBraces: () => (/* reexport safe */ _utils_utils__WEBPACK_IMPORTED_MODULE_77__.wrapTextByCurlyBraces)
/* harmony export */ });
/* harmony import */ var _localization_english__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ../localization/english */ "./src/localization/english.ts");
/* harmony import */ var _editorLocalization__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ../editorLocalization */ "./src/editorLocalization.ts");
/* harmony import */ var _creator_settings__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! ../creator-settings */ "./src/creator-settings.ts");
/* harmony import */ var _creator_events_api__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! ../creator-events-api */ "./src/creator-events-api.ts");
/* harmony import */ var _creator_base__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! ../creator-base */ "./src/creator-base.ts");
/* harmony import */ var _tabbed_menu__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! ../tabbed-menu */ "./src/tabbed-menu.ts");
/* harmony import */ var _creator_responsivity_manager__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(/*! ../creator-responsivity-manager */ "./src/creator-responsivity-manager.ts");
/* harmony import */ var _components_tabs_json_editor_ace__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(/*! ../components/tabs/json-editor-ace */ "./src/components/tabs/json-editor-ace.ts");
/* harmony import */ var _components_tabs_json_editor_plugin__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(/*! ../components/tabs/json-editor-plugin */ "./src/components/tabs/json-editor-plugin.ts");
/* harmony import */ var _components_tabs_json_editor_textarea__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(/*! ../components/tabs/json-editor-textarea */ "./src/components/tabs/json-editor-textarea.ts");
/* harmony import */ var _components_tabs_test__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(/*! ../components/tabs/test */ "./src/components/tabs/test.ts");
/* harmony import */ var _components_tabs_test_plugin__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(/*! ../components/tabs/test-plugin */ "./src/components/tabs/test-plugin.ts");
/* harmony import */ var _components_tabs_theme_custom_questions_color_alpha__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(/*! ../components/tabs/theme-custom-questions/color-alpha */ "./src/components/tabs/theme-custom-questions/color-alpha.ts");
/* harmony import */ var _components_tabs_theme_custom_questions_shadow_effects__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(/*! ../components/tabs/theme-custom-questions/shadow-effects */ "./src/components/tabs/theme-custom-questions/shadow-effects.ts");
/* harmony import */ var _components_tabs_theme_custom_questions_font_settings__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(/*! ../components/tabs/theme-custom-questions/font-settings */ "./src/components/tabs/theme-custom-questions/font-settings.ts");
/* harmony import */ var _components_tabs_theme_custom_questions_background_corner_radius__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(/*! ../components/tabs/theme-custom-questions/background-corner-radius */ "./src/components/tabs/theme-custom-questions/background-corner-radius.ts");
/* harmony import */ var _components_tabs_themes__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(/*! ../components/tabs/themes */ "./src/components/tabs/themes.ts");
/* harmony import */ var _components_tabs_theme_builder__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(/*! ../components/tabs/theme-builder */ "./src/components/tabs/theme-builder.ts");
/* harmony import */ var _components_tabs_theme_plugin__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(/*! ../components/tabs/theme-plugin */ "./src/components/tabs/theme-plugin.ts");
/* harmony import */ var _components_tabs_theme_model_definition__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(/*! ../components/tabs/theme-model-definition */ "./src/components/tabs/theme-model-definition.ts");
/* harmony import */ var _components_tabs_logic__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(/*! ../components/tabs/logic */ "./src/components/tabs/logic.ts");
/* harmony import */ var _components_tabs_translation__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(/*! ../components/tabs/translation */ "./src/components/tabs/translation.ts");
/* harmony import */ var _components_tabs_translation_theme__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(/*! ../components/tabs/translation-theme */ "./src/components/tabs/translation-theme.ts");
/* harmony import */ var _components_tabs_translation_plugin__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(/*! ../components/tabs/translation-plugin */ "./src/components/tabs/translation-plugin.ts");
/* harmony import */ var _components_tabs_designer__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(/*! ../components/tabs/designer */ "./src/components/tabs/designer.ts");
/* harmony import */ var _components_tabs_designer_plugin__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(/*! ../components/tabs/designer-plugin */ "./src/components/tabs/designer-plugin.ts");
/* harmony import */ var _components_tabs_logic_ui__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(/*! ../components/tabs/logic-ui */ "./src/components/tabs/logic-ui.ts");
/* harmony import */ var _components_tabs_logic_plugin__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(/*! ../components/tabs/logic-plugin */ "./src/components/tabs/logic-plugin.ts");
/* harmony import */ var _components_tabs_logic_theme__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(/*! ../components/tabs/logic-theme */ "./src/components/tabs/logic-theme.ts");
/* harmony import */ var _components_toolbox_toolbox_tool__WEBPACK_IMPORTED_MODULE_29__ = __webpack_require__(/*! ../components/toolbox/toolbox-tool */ "./src/components/toolbox/toolbox-tool.ts");
/* harmony import */ var _components_toolbox_toolbox_search_manager__WEBPACK_IMPORTED_MODULE_30__ = __webpack_require__(/*! ../components/toolbox/toolbox-search-manager */ "./src/components/toolbox/toolbox-search-manager.ts");
/* harmony import */ var _components_page_navigator_page_navigator__WEBPACK_IMPORTED_MODULE_31__ = __webpack_require__(/*! ../components/page-navigator/page-navigator */ "./src/components/page-navigator/page-navigator.ts");
/* harmony import */ var _components_page__WEBPACK_IMPORTED_MODULE_32__ = __webpack_require__(/*! ../components/page */ "./src/components/page.ts");
/* harmony import */ var _components_row__WEBPACK_IMPORTED_MODULE_33__ = __webpack_require__(/*! ../components/row */ "./src/components/row.ts");
/* harmony import */ var _components_question__WEBPACK_IMPORTED_MODULE_34__ = __webpack_require__(/*! ../components/question */ "./src/components/question.ts");
/* harmony import */ var _components_question_dropdown__WEBPACK_IMPORTED_MODULE_35__ = __webpack_require__(/*! ../components/question-dropdown */ "./src/components/question-dropdown.ts");
/* harmony import */ var _components_question_image__WEBPACK_IMPORTED_MODULE_36__ = __webpack_require__(/*! ../components/question-image */ "./src/components/question-image.ts");
/* harmony import */ var _components_question_rating__WEBPACK_IMPORTED_MODULE_37__ = __webpack_require__(/*! ../components/question-rating */ "./src/components/question-rating.ts");
/* harmony import */ var _components_item_value__WEBPACK_IMPORTED_MODULE_38__ = __webpack_require__(/*! ../components/item-value */ "./src/components/item-value.ts");
/* harmony import */ var _components_image_item_value__WEBPACK_IMPORTED_MODULE_39__ = __webpack_require__(/*! ../components/image-item-value */ "./src/components/image-item-value.ts");
/* harmony import */ var _components_matrix_cell__WEBPACK_IMPORTED_MODULE_40__ = __webpack_require__(/*! ../components/matrix-cell */ "./src/components/matrix-cell.ts");
/* harmony import */ var _components_simulator__WEBPACK_IMPORTED_MODULE_41__ = __webpack_require__(/*! ../components/simulator */ "./src/components/simulator.ts");
/* harmony import */ var _components_results__WEBPACK_IMPORTED_MODULE_42__ = __webpack_require__(/*! ../components/results */ "./src/components/results.ts");
/* harmony import */ var _components_header_logo_image__WEBPACK_IMPORTED_MODULE_43__ = __webpack_require__(/*! ../components/header/logo-image */ "./src/components/header/logo-image.ts");
/* harmony import */ var _components_string_editor__WEBPACK_IMPORTED_MODULE_44__ = __webpack_require__(/*! ../components/string-editor */ "./src/components/string-editor.ts");
/* harmony import */ var _components_embedded_survey__WEBPACK_IMPORTED_MODULE_45__ = __webpack_require__(/*! ../components/embedded-survey */ "./src/components/embedded-survey.ts");
/* harmony import */ var _components_link_value__WEBPACK_IMPORTED_MODULE_46__ = __webpack_require__(/*! ../components/link-value */ "./src/components/link-value.ts");
/* harmony import */ var _components_search_manager__WEBPACK_IMPORTED_MODULE_47__ = __webpack_require__(/*! ../components/search-manager */ "./src/components/search-manager.ts");
/* harmony import */ var _components_scroll__WEBPACK_IMPORTED_MODULE_48__ = __webpack_require__(/*! ../components/scroll */ "./src/components/scroll.ts");
/* harmony import */ var _json5__WEBPACK_IMPORTED_MODULE_49__ = __webpack_require__(/*! ../json5 */ "./src/json5.ts");
/* harmony import */ var _custom_questions_question_spin_editor__WEBPACK_IMPORTED_MODULE_50__ = __webpack_require__(/*! ../custom-questions/question-spin-editor */ "./src/custom-questions/question-spin-editor.ts");
/* harmony import */ var _custom_questions_question_color__WEBPACK_IMPORTED_MODULE_51__ = __webpack_require__(/*! ../custom-questions/question-color */ "./src/custom-questions/question-color.ts");
/* harmony import */ var _custom_questions_question_file__WEBPACK_IMPORTED_MODULE_52__ = __webpack_require__(/*! ../custom-questions/question-file */ "./src/custom-questions/question-file.ts");
/* harmony import */ var _custom_questions_question_text_with_reset__WEBPACK_IMPORTED_MODULE_53__ = __webpack_require__(/*! ../custom-questions/question-text-with-reset */ "./src/custom-questions/question-text-with-reset.ts");
/* harmony import */ var _property_grid__WEBPACK_IMPORTED_MODULE_54__ = __webpack_require__(/*! ../property-grid */ "./src/property-grid/index.ts");
/* harmony import */ var _property_grid_condition__WEBPACK_IMPORTED_MODULE_55__ = __webpack_require__(/*! ../property-grid/condition */ "./src/property-grid/condition.ts");
/* harmony import */ var _property_grid_matrices__WEBPACK_IMPORTED_MODULE_56__ = __webpack_require__(/*! ../property-grid/matrices */ "./src/property-grid/matrices.ts");
/* harmony import */ var _property_grid_bindings__WEBPACK_IMPORTED_MODULE_57__ = __webpack_require__(/*! ../property-grid/bindings */ "./src/property-grid/bindings.ts");
/* harmony import */ var _property_grid_property_grid_view_model__WEBPACK_IMPORTED_MODULE_58__ = __webpack_require__(/*! ../property-grid/property-grid-view-model */ "./src/property-grid/property-grid-view-model.ts");
/* harmony import */ var _property_grid_object_selector__WEBPACK_IMPORTED_MODULE_59__ = __webpack_require__(/*! ../property-grid/object-selector */ "./src/property-grid/object-selector.ts");
/* harmony import */ var _property_grid_restfull__WEBPACK_IMPORTED_MODULE_60__ = __webpack_require__(/*! ../property-grid/restfull */ "./src/property-grid/restfull.ts");
/* harmony import */ var _property_grid_theme_settings__WEBPACK_IMPORTED_MODULE_61__ = __webpack_require__(/*! ../property-grid/theme-settings */ "./src/property-grid/theme-settings.ts");
/* harmony import */ var _property_grid_values__WEBPACK_IMPORTED_MODULE_62__ = __webpack_require__(/*! ../property-grid/values */ "./src/property-grid/values.ts");
/* harmony import */ var _property_grid_search_manager__WEBPACK_IMPORTED_MODULE_63__ = __webpack_require__(/*! ../property-grid/search-manager */ "./src/property-grid/search-manager.ts");
/* harmony import */ var _property_grid_maskSettings__WEBPACK_IMPORTED_MODULE_64__ = __webpack_require__(/*! ../property-grid/maskSettings */ "./src/property-grid/maskSettings.ts");
/* harmony import */ var _property_grid_header_settings__WEBPACK_IMPORTED_MODULE_65__ = __webpack_require__(/*! ../property-grid/header-settings */ "./src/property-grid/header-settings.ts");
/* harmony import */ var _property_grid_theme_property_grid__WEBPACK_IMPORTED_MODULE_66__ = __webpack_require__(/*! ../property-grid-theme/property-grid */ "./src/property-grid-theme/property-grid.ts");
/* harmony import */ var _questionconverter__WEBPACK_IMPORTED_MODULE_67__ = __webpack_require__(/*! ../questionconverter */ "./src/questionconverter.ts");
/* harmony import */ var _svgbundle__WEBPACK_IMPORTED_MODULE_68__ = __webpack_require__(/*! ../svgbundle */ "./src/svgbundle.ts");
/* harmony import */ var _textWorker__WEBPACK_IMPORTED_MODULE_69__ = __webpack_require__(/*! ../textWorker */ "./src/textWorker.ts");
/* harmony import */ var _toolbox__WEBPACK_IMPORTED_MODULE_70__ = __webpack_require__(/*! ../toolbox */ "./src/toolbox.ts");
/* harmony import */ var _components_side_bar_side_bar_model__WEBPACK_IMPORTED_MODULE_71__ = __webpack_require__(/*! ../components/side-bar/side-bar-model */ "./src/components/side-bar/side-bar-model.ts");
/* harmony import */ var _components_side_bar_side_bar_header_model__WEBPACK_IMPORTED_MODULE_72__ = __webpack_require__(/*! ../components/side-bar/side-bar-header-model */ "./src/components/side-bar/side-bar-header-model.ts");
/* harmony import */ var _components_side_bar_side_bar_page_model__WEBPACK_IMPORTED_MODULE_73__ = __webpack_require__(/*! ../components/side-bar/side-bar-page-model */ "./src/components/side-bar/side-bar-page-model.ts");
/* harmony import */ var _components_side_bar_tab_control_model__WEBPACK_IMPORTED_MODULE_74__ = __webpack_require__(/*! ../components/side-bar/tab-control-model */ "./src/components/side-bar/tab-control-model.ts");
/* harmony import */ var _components_switcher_switcher__WEBPACK_IMPORTED_MODULE_75__ = __webpack_require__(/*! ../components/switcher/switcher */ "./src/components/switcher/switcher.ts");
/* harmony import */ var _utils_events__WEBPACK_IMPORTED_MODULE_76__ = __webpack_require__(/*! ../utils/events */ "./src/utils/events.ts");
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_77__ = __webpack_require__(/*! ../utils/utils */ "./src/utils/utils.ts");
/* harmony import */ var _utils_actions__WEBPACK_IMPORTED_MODULE_78__ = __webpack_require__(/*! ../utils/actions */ "./src/utils/actions.ts");
/* harmony import */ var _question_editor_definition__WEBPACK_IMPORTED_MODULE_79__ = __webpack_require__(/*! ../question-editor/definition */ "./src/question-editor/definition.ts");
/* harmony import */ var _question_editor_properties__WEBPACK_IMPORTED_MODULE_80__ = __webpack_require__(/*! ../question-editor/properties */ "./src/question-editor/properties.ts");
/* harmony import */ var _survey_helper__WEBPACK_IMPORTED_MODULE_81__ = __webpack_require__(/*! ../survey-helper */ "./src/survey-helper.ts");
/* harmony import */ var _utils_resizer__WEBPACK_IMPORTED_MODULE_82__ = __webpack_require__(/*! ../utils/resizer */ "./src/utils/resizer.ts");
/* harmony import */ var _plugins_undo_redo__WEBPACK_IMPORTED_MODULE_83__ = __webpack_require__(/*! ../plugins/undo-redo */ "./src/plugins/undo-redo/index.ts");
/* harmony import */ var _plugins_undo_redo_undo_redo_manager__WEBPACK_IMPORTED_MODULE_84__ = __webpack_require__(/*! ../plugins/undo-redo/undo-redo-manager */ "./src/plugins/undo-redo/undo-redo-manager.ts");
/* harmony import */ var _pages_controller__WEBPACK_IMPORTED_MODULE_85__ = __webpack_require__(/*! ../pages-controller */ "./src/pages-controller.ts");
/* harmony import */ var _creator_theme_creator_theme_model_definition__WEBPACK_IMPORTED_MODULE_86__ = __webpack_require__(/*! ../creator-theme/creator-theme-model-definition */ "./src/creator-theme/creator-theme-model-definition.ts");
/* harmony import */ var _creator_theme_creator_theme_model__WEBPACK_IMPORTED_MODULE_87__ = __webpack_require__(/*! ../creator-theme/creator-theme-model */ "./src/creator-theme/creator-theme-model.ts");
/* harmony import */ var _presets_presets_base__WEBPACK_IMPORTED_MODULE_88__ = __webpack_require__(/*! ../presets/presets-base */ "./src/presets/presets-base.ts");
/* harmony import */ var _presets_presets__WEBPACK_IMPORTED_MODULE_89__ = __webpack_require__(/*! ../presets/presets */ "./src/presets/presets.ts");
/* harmony import */ var _presets_presets_properties__WEBPACK_IMPORTED_MODULE_90__ = __webpack_require__(/*! ../presets/presets-properties */ "./src/presets/presets-properties.ts");
/* harmony import */ var _presets_presets_tabs__WEBPACK_IMPORTED_MODULE_91__ = __webpack_require__(/*! ../presets/presets-tabs */ "./src/presets/presets-tabs.ts");
/* harmony import */ var _presets_presets_toolbox__WEBPACK_IMPORTED_MODULE_92__ = __webpack_require__(/*! ../presets/presets-toolbox */ "./src/presets/presets-toolbox.ts");
/* harmony import */ var _survey_elements__WEBPACK_IMPORTED_MODULE_93__ = __webpack_require__(/*! ../survey-elements */ "./src/survey-elements.ts");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_94__ = __webpack_require__(/*! survey-core */ "survey-core");
/* harmony import */ var survey_core__WEBPACK_IMPORTED_MODULE_94___default = /*#__PURE__*/__webpack_require__.n(survey_core__WEBPACK_IMPORTED_MODULE_94__);
var Version;
Version = "".concat("1.12.14");
//should be loaded before other styles for easier override 
__webpack_require__(/*! ../utils/context-button.scss */ "./src/utils/context-button.scss");




















































//custom questions for property grid












































__webpack_require__(/*! ../components/search.scss */ "./src/components/search.scss");
__webpack_require__(/*! ../components/scroll.scss */ "./src/components/scroll.scss");
__webpack_require__(/*! ../components/property-panel/property-panel-item.scss */ "./src/components/property-panel/property-panel-item.scss");
__webpack_require__(/*! ../components/property-panel/property-panel.scss */ "./src/components/property-panel/property-panel.scss");
__webpack_require__(/*! ../components/tabbed-menu/tabbed-menu-item.scss */ "./src/components/tabbed-menu/tabbed-menu-item.scss");
__webpack_require__(/*! ../components/tabbed-menu/tabbed-menu.scss */ "./src/components/tabbed-menu/tabbed-menu.scss");
__webpack_require__(/*! ../components/toolbox/toolbox-tool.scss */ "./src/components/toolbox/toolbox-tool.scss");
__webpack_require__(/*! ../components/question-dropdown.scss */ "./src/components/question-dropdown.scss");
__webpack_require__(/*! ../components/toolbox/toolbox.scss */ "./src/components/toolbox/toolbox.scss");
__webpack_require__(/*! ../components/toolbox/toolbox-search.scss */ "./src/components/toolbox/toolbox-search.scss");
__webpack_require__(/*! ../components/toolbox/toolbox-right.scss */ "./src/components/toolbox/toolbox-right.scss");
__webpack_require__(/*! ../components/toolbox/toolbox-animation.scss */ "./src/components/toolbox/toolbox-animation.scss");
__webpack_require__(/*! ../components/side-bar/side-bar.scss */ "./src/components/side-bar/side-bar.scss");
__webpack_require__(/*! ../components/side-bar/tab-control.scss */ "./src/components/side-bar/tab-control.scss");
__webpack_require__(/*! ../property-grid-theme/property-grid.scss */ "./src/property-grid-theme/property-grid.scss");
__webpack_require__(/*! ../utils/design.scss */ "./src/utils/design.scss");
__webpack_require__(/*! ../utils/layout.scss */ "./src/utils/layout.scss");
__webpack_require__(/*! ../custom-questions/boolean-switch.scss */ "./src/custom-questions/boolean-switch.scss");

survey_core__WEBPACK_IMPORTED_MODULE_94__.settings.supportCreatorV2 = true;
(0,survey_core__WEBPACK_IMPORTED_MODULE_94__.checkLibraryVersion)("".concat("1.12.14"), "survey-creator-core");

})();

/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=survey-creator-core.js.map